webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1674),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return endpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToServer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_calculators__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_calculatorModals__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_api_claims__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_api_generatedDocuments__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_api_resources__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_api_miniCalculators__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_api_dashboards__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_api_users__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_api_support__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_api_personalInjury__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_api_exceptions__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_api_contacts__ = __webpack_require__(863);

















var API_VERSION = 'v1';
var token = document.head.querySelector('meta[name="csrf-token"]');

var config = function config() {
    var auth = { 'Authorization': "Bearer " + __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].getters['user/getToken'] };
    var csrf = {};
    if (true) {
        csrf['X-CSRF-TOKEN'] = token.content;
    }
    return {
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, auth, csrf)
    };
};

var onError = function onError(error) {
    __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('http/error', error);
    throw error;
};

var onSuccess = function onSuccess(response, showRunning) {
    __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('http/stop', { response: response, showRunning: showRunning });
    return response.data;
};

var apiUrl = function apiUrl(path) {
    return '/api/' + API_VERSION + '/' + path;
};

var makeCall = function makeCall(url, payload) {
    var showRunning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('http/start', { url: url, showRunning: showRunning });
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, payload, config()).then(onSuccess).catch(onError);
};

var endpoint = function endpoint(resource, action, payload) {
    var showRunning = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return makeCall(apiUrl(resource + '/' + action), payload, showRunning);
};

var dateToServer = function dateToServer(date) {
    return date ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    calculators: __WEBPACK_IMPORTED_MODULE_4_services_api_calculators__["a" /* default */],
    calculatorModals: __WEBPACK_IMPORTED_MODULE_5_services_api_calculatorModals__["a" /* default */],
    claims: __WEBPACK_IMPORTED_MODULE_6_services_api_claims__["a" /* default */],
    generatedDocuments: __WEBPACK_IMPORTED_MODULE_7_services_api_generatedDocuments__["a" /* default */],
    miniCalculators: __WEBPACK_IMPORTED_MODULE_9_services_api_miniCalculators__["a" /* default */],
    resources: __WEBPACK_IMPORTED_MODULE_8_services_api_resources__["a" /* default */],
    dashboards: __WEBPACK_IMPORTED_MODULE_10_services_api_dashboards__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_11_services_api_users__["a" /* default */],
    support: __WEBPACK_IMPORTED_MODULE_12_services_api_support__["a" /* default */],
    personalInjury: __WEBPACK_IMPORTED_MODULE_13_services_api_personalInjury__["a" /* default */],
    exceptions: __WEBPACK_IMPORTED_MODULE_14_services_api_exceptions__["a" /* default */],
    contacts: __WEBPACK_IMPORTED_MODULE_15_services_api_contacts__["a" /* default */]
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        currencyFormat: function currencyFormat(value) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '£';
            var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

            if (!value) {
                return symbol + '0.00';
            }
            var n = value,
                c = precision,
                d = '.',
                t = ',',
                s = n < 0 ? '-' : '',
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;

            return symbol + (s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')).toString();
        }
    }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1581),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_validator_controls_FormControl__ = __webpack_require__(826);



/* harmony default export */ __webpack_exports__["a"] = ({
    beforeCreate: function beforeCreate() {
        this.$formCtrl = new __WEBPACK_IMPORTED_MODULE_1_components_form_validator_controls_FormControl__["a" /* default */](this);

        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.defineReactive(this.$formCtrl, 'state', this.$formCtrl.state);
    },
    destroyed: function destroyed() {
        this.$formCtrl.remove();
    },

    computed: {
        $form: function $form() {
            return this.$formCtrl.state;
        }
    },
    methods: {
        $valid: function $valid(field) {
            return this.$formCtrl.determine('$valid', field);
        },
        $invalid: function $invalid(field) {
            return this.$formCtrl.determine('$invalid', field);
        },
        $dirty: function $dirty(field) {
            return this.$formCtrl.determine('$dirty', field);
        },
        $clean: function $clean(field) {
            return this.$formCtrl.determine('$clean', field);
        },
        $touched: function $touched(field) {
            return this.$formCtrl.determine('$touched', field);
        },
        $untouched: function $untouched(field) {
            return this.$formCtrl.determine('$untouched', field);
        },
        $error: function $error(field) {
            return this.$formCtrl.determine('$error', field);
        }
    }
});

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var inputEvent = function inputEvent(el) {
    return function (e) {
        format(el, e.target.value);
    };
};

var format = function format(el, value) {
    var userValue = parseFloat(value);
    if (isNaN(userValue)) {
        return;
    }
    el.value = (Math.round(userValue * 100) / 100).toFixed(2);
};

var updateIfNotActive = function updateIfNotActive(el) {
    if (el !== document.activeElement) {
        format(el, el.value);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    bind: function bind(el) {
        updateIfNotActive(el);
        el.addEventListener('blur', inputEvent(el));
        el.step = 0.01;
    },

    update: updateIfNotActive
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStepByNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return nextStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return prevStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStepValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setStepValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStepTransitionAllowed; });
/* unused harmony export saveStep */
/* unused harmony export isStepRoute */
/* unused harmony export stepError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beforeEnter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_modules_claim__ = __webpack_require__(29);



var getStepByNumber = function getStepByNumber(index) {
    var steps = __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].getters[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["a" /* currentClaimType */])() + '/step/allSteps'];
    var id = __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].getters['claim/id'];

    if (steps[index]) {
        steps[index]['route']['params']['id'] = id;
        return steps[index];
    }
};

var nextStep = function nextStep() {
    return getStepByNumber(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["b" /* currentClaimStepIndex */])() + 1);
};

var prevStep = function prevStep() {
    return getStepByNumber(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["b" /* currentClaimStepIndex */])() - 1);
};

var isStepValid = function isStepValid(stepNo) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["a" /* currentClaimType */])()) {
        return;
    }

    return __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].getters[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["a" /* currentClaimType */])() + '/step/valid'](stepNo - 1);
};

var setStepValid = function setStepValid(isValid) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["a" /* currentClaimType */])()) {
        return;
    }

    var index = __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].getters[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["a" /* currentClaimType */])() + '/step/currentStepIndex'];

    return __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["a" /* currentClaimType */])() + '/step/setValid', {
        valid: isValid,
        index: index
    });
};

var isStepTransitionAllowed = function isStepTransitionAllowed(fromStep, toStep) {
    if (toStep < fromStep) {
        return true;
    }

    if (toStep === 9) {
        return isStepValid(8);
    }

    if (fromStep + 1 !== toStep) {
        return isStepValid(fromStep) && isStepValid(toStep - 1);
    }

    return isStepValid(fromStep);
};

var saveStep = function saveStep(stepNo) {
    return __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].dispatch('claim/save', stepNo - 1);
};

var isStepRoute = function isStepRoute(route) {
    return !!(route.meta && route.meta.step);
};

var stepError = function stepError(error) {
    console.log(error);
};

var beforeEnter = function beforeEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].getters['user/getToken'] === null) {
        next({ name: 'homepage' });
    }

    if (!~from.path.indexOf(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["a" /* currentClaimType */]) && to.meta.step === 1) {
        return next();
    }

    if (isStepRoute(from) && isStepRoute(to) && !isStepTransitionAllowed(from.meta.step, to.meta.step)) {
        return;
    }

    if (!isStepRoute(from) && isStepRoute(to) && to.meta.step !== 1) {
        next({ name: 'homepage' });
    }

    if (isStepRoute(from) && isStepValid(from.meta.step)) {
        return saveStep(from.meta.step).then(function () {
            return next();
        }, stepError);
    }

    return next();
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1761),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_actions__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_getters__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_mutations__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_modules_fatal__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_accordion__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_menu__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_modules_timeline__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_http__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_modules_resources__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_modules_modal__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_store_modules_documents__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store_modules_dropdown__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_store_modules_lost__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_store_modules_mini__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_store_modules_personal__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_store_modules_dashboards__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_store_modules_user__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_store_modules_psla__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_store_modules_reserves__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_store_modules_support__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_store_modules_discountRateComparison__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_store_modules_windowWidth__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_store_modules_headerWidth__ = __webpack_require__(911);




























__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
    strict: false,
    actions: __WEBPACK_IMPORTED_MODULE_3_store_actions__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_4_store_getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_5_store_mutations__["a" /* default */],
    modules: {
        documents: __WEBPACK_IMPORTED_MODULE_13_store_modules_documents__["a" /* default */],
        fatal: __WEBPACK_IMPORTED_MODULE_6_store_modules_fatal__["a" /* default */],
        accordion: __WEBPACK_IMPORTED_MODULE_7_store_modules_accordion__["a" /* default */],
        menu: __WEBPACK_IMPORTED_MODULE_8_store_modules_menu__["a" /* default */],
        timeline: __WEBPACK_IMPORTED_MODULE_9_store_modules_timeline__["a" /* default */],
        http: __WEBPACK_IMPORTED_MODULE_10_store_modules_http__["a" /* default */],
        resources: __WEBPACK_IMPORTED_MODULE_11_store_modules_resources__["a" /* default */],
        modal: __WEBPACK_IMPORTED_MODULE_12_store_modules_modal__["a" /* default */],
        dropdown: __WEBPACK_IMPORTED_MODULE_14_store_modules_dropdown__["a" /* default */],
        lost: __WEBPACK_IMPORTED_MODULE_15_store_modules_lost__["a" /* default */],
        mini: __WEBPACK_IMPORTED_MODULE_16_store_modules_mini__["a" /* default */],
        claim: __WEBPACK_IMPORTED_MODULE_17_store_modules_claim__["g" /* default */],
        personal: __WEBPACK_IMPORTED_MODULE_18_store_modules_personal__["a" /* default */],
        dashboards: __WEBPACK_IMPORTED_MODULE_19_store_modules_dashboards__["a" /* default */],
        user: __WEBPACK_IMPORTED_MODULE_20_store_modules_user__["a" /* default */],
        psla: __WEBPACK_IMPORTED_MODULE_21_store_modules_psla__["a" /* default */],
        reserves: __WEBPACK_IMPORTED_MODULE_22_store_modules_reserves__["a" /* default */],
        support: __WEBPACK_IMPORTED_MODULE_23_store_modules_support__["a" /* default */],
        discountRateComparison: __WEBPACK_IMPORTED_MODULE_24_store_modules_discountRateComparison__["a" /* default */],
        windowWidth: __WEBPACK_IMPORTED_MODULE_25_store_modules_windowWidth__["a" /* default */],
        headerWidth: __WEBPACK_IMPORTED_MODULE_26_store_modules_headerWidth__["a" /* default */]
    },
    plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
        paths: ['menu', 'user']
    })]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

if (false) {
    module.hot.accept(['store/mutations', './modules/fatal', './modules/lost', './modules/mini', './modules/accordion', './modules/menu', './modules/timeline', './modules/http', './modules/claim', './modules/personal', './modules/dashboards', './modules/user', './modules/reserves', './modules/support', './modules/discountRateComparison'], function () {
        var newMutations = require('./mutations').default;
        var newFatal = require('./modules/fatal/index').default;
        var newMini = require('./modules/mini/index').default;
        var newLost = require('./modules/lost/index').default;
        var newAccordion = require('./modules/accordion').default;
        var newMenu = require('./modules/menu').default;
        var newTimeline = require('./modules/timeline').default;
        var newHttp = require('./modules/http').default;
        var newClaim = require('./modules/claim').default;
        var newPersonal = require('./modules/personal').default;
        var newDashboards = require('./modules/dashboards').default;
        var newUser = require('./modules/user').default;
        var newPsla = require('./modules/psla').default;
        var newReserve = require('./modules/reserves').default;
        var newSupport = require('./modules/support').default;
        var newDiscountRateComparison = require('./modules/discountRateComparison').default;

        store.hotUpdate({
            mutations: newMutations,
            modules: {
                fatal: newFatal,
                accordion: newAccordion,
                menu: newMenu,
                timeline: newTimeline,
                http: newHttp,
                lost: newLost,
                mini: newMini,
                claim: newClaim,
                personal: newPersonal,
                dashboards: newDashboards,
                user: newUser,
                psla: newPsla,
                reserves: newReserve,
                support: newSupport,
                discountRateComparison: newDiscountRateComparison
            }
        });
    });
}

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1730),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        roundValue: function roundValue(value, decimals) {
            if (!value) {
                value = 0;
            }

            if (!decimals) {
                decimals = 0;
            }

            value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
            return value;
        }
    }
});

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildFromRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return previousValid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_modules_claim__ = __webpack_require__(29);


var _mutations;



var types = {
    INCREMENT_STEP: 'INCREMENT_STEP',
    DECREMENT_STEP: 'DECREMENT_STEP',
    SET_STEP_VALID: 'SET_STEP_VALID',
    RESET: 'RESET'
};

var state = function state(steps) {
    return {
        currentStepIndex: 0,
        steps: steps,
        currentStep: null
    };
};

var getters = {
    currentStep: function currentStep(state) {
        return state.currentStep;
    },
    currentStepIndex: function currentStepIndex(state) {
        return state.currentStepIndex;
    },
    valid: function valid(state) {
        return function (index) {
            return state.steps[index] && state.steps[index].valid;
        };
    },
    next: function next(state) {
        if (state.currentStepIndex.index + 1 < state.currentStepIndex) {
            return state.steps[state.currentStepIndex + 1];
        }
        return null;
    },
    prev: function prev(state) {
        if (state.currentStepIndex.index - 1 >= 0) {
            return state.steps[state.currentStepIndex - 1];
        }
        return null;
    },
    allSteps: function allSteps(state) {
        return state.steps;
    }

};

var actions = {
    setValid: function setValid(_ref, valid) {
        var commit = _ref.commit;

        commit(types.SET_STEP_VALID, { valid: valid });
    },
    setStepNumberValid: function setStepNumberValid(_ref2, _ref3) {
        var commit = _ref2.commit;
        var stepNo = _ref3.stepNo,
            valid = _ref3.valid;

        commit(types.SET_STEP_VALID, { valid: { index: stepNo, valid: !!valid } });
    },
    reset: function reset(_ref4) {
        var commit = _ref4.commit;

        commit(types.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.SET_STEP_VALID, function (state, _ref5) {
    var valid = _ref5.valid;

    if (!state.steps[valid.index]) {
        return;
    }

    state.steps[valid.index].valid = valid.valid;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.RESET, function (state) {
    state.steps.forEach(function (step) {
        return step.valid = false;
    });
    state.currentStepIndex = 0;
    state.currentStep = state.steps[0];
}), _mutations);

var buildFromRoute = function buildFromRoute(_ref6) {
    var route = _ref6.route,
        prefix = _ref6.prefix;
    return {
        route: route,
        name: route.meta.name,
        store: route.meta.store,
        step: route.meta.step,
        valid: false
    };
};

var previousValid = function previousValid(rootState, current) {
    var step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_claim__["c" /* claimSteps */])(rootState, rootState['claim']['type'])[current ? current - 1 : 0];

    return !step ? false : step.valid;
};

/* harmony default export */ __webpack_exports__["c"] = (function (steps) {
    var currentState = state(steps);
    currentState.steps = steps;
    currentState.currentStep = steps[0];
    return {
        namespaced: true,
        state: currentState,
        getters: getters,
        actions: actions,
        mutations: mutations
    };
});

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return stringRequired; });
/* unused harmony export isScalar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var stringRequired = function stringRequired(value) {
    return !!(isScalar(value) && value !== '' && (value && value.trim ? value.trim() : value) !== '');
};

var isScalar = function isScalar(value) {
    return !!(value !== null && typeof value !== 'undefined');
};

var mDate = function mDate(value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, 'DD/MM/YYYY');
};

var validDate = function validDate(value) {
    return stringRequired(value) && /^[0123][0-9]\/[01][0-9]\/[12][09][0-9]{2}$/.test(value) && mDate(value).isValid();
};

/* harmony default export */ __webpack_exports__["b"] = ({
    text: {
        required: stringRequired,

        min: function min(value, opt) {
            return !stringRequired(value) ? true : value.length >= parseInt(opt, 10);
        },

        max: function max(value, opt) {
            return !stringRequired(value) ? true : value.length <= parseInt(opt, 10);
        },

        name: function name(value) {
            return !stringRequired(value) || /^(?=.*)[\x20-\xFE]+$/g.test(value);
        }
    },
    number: {
        valid: function valid(value) {
            return !isNaN(value);
        },

        required: function required(value) {
            return isScalar(value) && stringRequired(value.toString()) && !isNaN(value);
        },

        min: function min(value, opt) {
            return isScalar(value) && !stringRequired(value.toString()) ? true : parseFloat(value) >= parseFloat(opt);
        },

        max: function max(value, opt) {
            return isScalar(value) && !stringRequired(value.toString()) ? true : parseFloat(value) <= parseFloat(opt);
        }
    },
    date: {
        required: function required(value) {
            return validDate(value);
        },

        min: function min(value, opt) {
            return !validDate(value) || !validDate(opt) ? true : mDate(value).isSameOrAfter(mDate(opt));
        },

        max: function max(value, opt) {
            return !validDate(value) || !validDate(opt) ? true : mDate(value).isSameOrBefore(mDate(opt));
        }
    },
    'select-one': {
        required: stringRequired,

        min: true,

        max: true
    },
    array: {
        required: function required(value) {
            return !!value.length;
        }
    }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_validations__ = __webpack_require__(23);






var Validator = function () {
    function Validator(data, rules) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Validator);

        this._data = data;
        this._rules = rules;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Validator, [{
        key: 'validate',
        value: function validate() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (this._data || this._rules) {
                return this.validateAll();
            }

            if (!rules) {
                return true;
            }

            if (!value) {
                return false;
            }

            return false;
        }
    }, {
        key: 'validateAll',
        value: function validateAll() {
            var _this = this;

            if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this._rules).length) {
                return true;
            }

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this._rules).reduce(function (valid, field) {
                var value = field.split('.').reduce(function (o, i) {
                    return o[i];
                }, _this._data);

                return !valid ? valid : _this._validate(value, _this._rules[field]);
            }, true);
        }
    }, {
        key: '_validate',
        value: function _validate(value, field) {
            var _this2 = this;

            return this._rulesFrom(field.rules).reduce(function (valid, rule) {
                return !valid ? valid : _this2._runRule(field.type, rule, value);
            }, true);
        }
    }, {
        key: '_runRule',
        value: function _runRule(type, rule, value) {
            var _validators$type;

            var ruleParts = rule.split(':');
            return (_validators$type = __WEBPACK_IMPORTED_MODULE_4_components_form_validator_validations__["b" /* default */][type])[ruleParts.shift()].apply(_validators$type, [value].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ruleParts)));
        }
    }, {
        key: '_rulesFrom',
        value: function _rulesFrom(rules) {
            return rules.split('|');
        }
    }]);

    return Validator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Validator);

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1753),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1815),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1306)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return claimTypes; });
/* unused harmony export humanClaimTypes */
/* unused harmony export claimTypeRouting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentClaimType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return currentHumanClaimType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentClaimStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return claimSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestPayload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_modules_fatal__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_modules_lost__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);


var _mutations;








var mutationTypes = {
    INITIALISE_CLAIM: 'INITIALISE_CLAIM',
    RESET_CLAIM: 'RESET_CLAIM',
    SET_CLAIM_ID: 'SET_CLAIM_ID',
    LOAD_CLAIM: 'LOAD_CLAIM',
    LOADING_CLAIM: 'LOADING_CLAIM',
    LOADED_CLAIM: 'LOADED_CLAIM',
    DELETED_CLAIM: 'DELETED_CLAIM',
    SET_CURRENT: 'SET_CURRENT',
    SET_COSTS: 'SET_COSTS'
};

var claimTypes = {
    'day_one_only_lost_years': 'reserves/dayOneLost',
    'day_one_only_fatal_accident': 'reserves/dayOneFatal',
    'fatal_accident_dependency': 'fatal/dependency',
    'fatal_accident_estate': 'fatal/estate',
    'lost_years': 'lost',
    'personal_injury': 'personal'
};

var humanClaimTypes = {
    'day_one_only_lost_years': 'Day One Assessment Only Lost Years',
    'day_one_only_fatal_accident': 'Day One Assessment Only Fatal Accident',
    'fatal_accident_dependency': 'Fatal Accident Dependency Claim',
    'fatal_accident_estate': 'Fatal Accident Estate Claim',
    'lost_years': 'Lost Years Claim',
    'personal_injury': 'Personal Injury Claim'
};

var claimTypeRouting = {
    'fatal_accident_dependency': 'fatal::dependency.step-',
    'fatal_accident_estate': 'fatal::estate.step-',
    'lost_years': 'lost::step-',
    'personal_injury': 'personal::step-'
};

var currentClaimType = function currentClaimType() {
    return claimTypes[__WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].getters['claim/type']];
};

var currentHumanClaimType = function currentHumanClaimType() {
    return humanClaimTypes[__WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].getters['claim/type']];
};

var currentClaimStepIndex = function currentClaimStepIndex() {
    return __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].getters[currentClaimType() + '/step/currentStepIndex'];
};

var claimSteps = function claimSteps(rootState, type) {
    if (type === 'day_one_only_lost_years' || type === 'day_one_only_fatal_accident') {
        return {};
    }

    if (type === 'fatal_accident_dependency') {
        return rootState['fatal']['dependency'].step.steps;
    }

    if (type === 'fatal_accident_estate') {
        return rootState['fatal']['estate'].step.steps;
    }

    return rootState[claimTypes[type]].step.steps;
};

var onClaimType = function onClaimType(type, action) {
    return claimTypes[type] + '/' + action;
};

var requestPayload = function requestPayload(stepNo) {
    return {
        claim_type: state.type,
        claim_id: state.id,
        step_number: stepNo,

        data: {}
    };
};

var loadingTemplate = {
    id: null,
    type: null
};

var state = {
    id: null,
    type: null,
    current: null,

    loading: loadingTemplate
};

var getters = {
    id: function id(state) {
        return state.id;
    },
    type: function type(state) {
        return state.type;
    },
    loading: function loading(state) {
        return state.loading;
    },
    current: function current(state) {
        return state.current;
    }
};

var actions = {
    initialise: function initialise(_ref, type) {
        var commit = _ref.commit;

        commit(mutationTypes.INITIALISE_CLAIM, type);
    },
    save: function save(_ref2, stepNo) {
        var rootGetters = _ref2.rootGetters,
            dispatch = _ref2.dispatch;

        __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].dispatch(onClaimType(state.type, 'save'), requestPayload(stepNo)).then(function (response) {
            if (!rootGetters['claim/id'] && typeof response !== 'undefined') {
                dispatch('claim/setClaimId', response.step.claim_id, { root: true });
            }
        });
    },
    setClaimId: function setClaimId(_ref3, id) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        commit(mutationTypes.SET_CLAIM_ID, { id: id });
        if (id != null && !state.current) {
            return dispatch('loadById', id);
        }
    },
    load: function load(_ref4, _ref5) {
        var state = _ref4.state,
            dispatch = _ref4.dispatch,
            commit = _ref4.commit,
            rootState = _ref4.rootState;
        var claim = _ref5.claim,
            router = _ref5.router,
            type = _ref5.type;

        var processSteppedClaim = function processSteppedClaim(response) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_helper__["a" /* promiseQueue */])(response.steps, function (step) {
                return dispatch('loadStep', step);
            }).then(function () {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_helper__["a" /* promiseQueue */])(claimSteps(rootState, state.type), function (step) {
                    return dispatch('processStep', step);
                });
            }).then(function () {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_helper__["a" /* promiseQueue */])(claimSteps(rootState, state.type), function (step) {
                    return dispatch('validateStep', step);
                });
            }).then(function () {
                var goTo = claimTypeRouting[state.type] + '1';

                if (router.app.$route.params.id == state.id && router.app.$route.name == goTo) {
                    return;
                }

                router.push({ name: goTo, params: state });
            }).then(function () {
                dispatch('documents/resetDocuments', null, { root: true });
                dispatch('menu/updateMenu', true, { root: true });
                dispatch('menu/updateSubMenu', claimTypes[state.type], { root: true });
            });
        };

        var processDayOneFatalClaim = function processDayOneFatalClaim(response) {
            return dispatch('reserves/dayOneFatal/reset', null, { root: true }).then(function () {
                return router.push('/reserving/day-one-assessment/fatal');
            }).then(function () {
                return dispatch('reserves/dayOneFatal/load', response, { root: true });
            });
        };

        var processDayOneLostClaim = function processDayOneLostClaim(response) {
            return dispatch('reserves/dayOneLost/reset', null, { root: true }).then(function () {
                return router.push('/reserving/day-one-assessment/lost');
            }).then(function () {
                return dispatch('reserves/dayOneLost/load', response, { root: true });
            });
        };

        dispatch('reset').then(function () {
            return commit(mutationTypes.LOADING_CLAIM, claim);
        }).then(function () {
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.load(claim.id);
        }).then(function (response) {
            commit(mutationTypes.LOAD_CLAIM);
            return response;
        }).then(function (response) {
            claim = { id: response.id, type: response.type };
            dispatch('setCurrent', response);
            commit(mutationTypes.INITIALISE_CLAIM, type ? type : response.type);

            var prom = null;
            switch (type ? type : response.type) {
                case "day_one_only_lost_years":
                    prom = processDayOneLostClaim(response);
                    break;
                case "day_one_only_fatal_accident":
                    prom = processDayOneFatalClaim(response);
                    break;
                default:
                    prom = processSteppedClaim(response);
            }

            return prom.then(function () {
                return commit(mutationTypes.LOADED_CLAIM, claim);
            });
        });
    },
    reset: function reset(_ref6) {
        var state = _ref6.state,
            commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            rootState = _ref6.rootState;

        if (!state.type || !state.id) {
            dispatch('dropdown/close', null, { root: true });
            return;
        }

        if (state.type === "day_one_only_lost_years" || state.type === "day_one_only_fatal_accident") {
            return commit(mutationTypes.RESET_CLAIM, null);
        }

        var allTheSteps = _.map(claimTypes, function (key, type) {
            return _.map(claimSteps(rootState, type), function (step) {
                return { type: type, step: step };
            });
        });

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_helper__["a" /* promiseQueue */])(_.flatten(allTheSteps), function (_ref7) {
            var type = _ref7.type,
                step = _ref7.step;
            return dispatch('resetServerStep', { type: type, step: step });
        }).then(function () {
            commit(mutationTypes.RESET_CLAIM, null);
            dispatch('documents/resetDocuments', null, { root: true });
        });
    },
    loadStep: function loadStep(_ref8, step) {
        var state = _ref8.state,
            dispatch = _ref8.dispatch,
            getters = _ref8.getters;

        dispatch(onClaimType(state.loading.type || state.type, 'load'), step, { root: true });
    },
    processStep: function processStep(_ref9, step) {
        var state = _ref9.state,
            dispatch = _ref9.dispatch,
            getters = _ref9.getters;

        dispatch(onClaimType(state.type, 'process'), step, { root: true });
    },
    validateStep: function validateStep(_ref10, step) {
        var state = _ref10.state,
            dispatch = _ref10.dispatch,
            getters = _ref10.getters;

        dispatch(onClaimType(state.type, 'validate'), step, { root: true });
    },
    resetServerStep: function resetServerStep(_ref11, _ref12) {
        var state = _ref11.state,
            dispatch = _ref11.dispatch,
            getters = _ref11.getters;
        var type = _ref12.type,
            step = _ref12.step;

        dispatch(onClaimType(type, 'reset'), step, { root: true });
    },
    delete: function _delete(_ref13, _ref14) {
        var state = _ref13.state,
            commit = _ref13.commit,
            dispatch = _ref13.dispatch,
            rootState = _ref13.rootState;
        var claim = _ref14.claim;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.delete(claim.id);
    },
    setCurrent: function setCurrent(_ref15, claim) {
        var commit = _ref15.commit;

        commit(mutationTypes.SET_CURRENT, claim);
    },
    updateClaim: function updateClaim(_ref16, data) {
        var dispatch = _ref16.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.update(data);
    },
    updateCosts: function updateCosts(_ref17, data) {
        var commit = _ref17.commit;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.updateCosts(data).then(function (response) {
            commit(mutationTypes.SET_COSTS, response.cost);
        });
    },
    loadById: function loadById(_ref18, claimId) {
        var dispatch = _ref18.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.load(claimId).then(function (claim) {
            return dispatch('setCurrent', claim);
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.INITIALISE_CLAIM, function (state, payload) {
    state.type = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_CLAIM, function (state) {
    state.id = null;
    state.type = null;
    state.current = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_CLAIM_ID, function (state, payload) {
    state.id = payload.id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOAD_CLAIM, function (state, payload) {
    if (!payload) {
        state.id = state.loading.id;
        state.type = state.loading.type;
        return;
    }

    state.id = payload.id;
    state.type = payload.type || state.type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOADING_CLAIM, function (state, payload) {
    state.loading = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOADED_CLAIM, function (state, payload) {
    state.id = payload.id;
    state.type = payload.type;

    state.loading.id = null;
    state.loading.type = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_CURRENT, function (state, claim) {
    state.current = claim;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_COSTS, function (state, cost) {
    state.current.cost = cost;
}), _mutations);

/* harmony default export */ __webpack_exports__["g"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {}
});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1321)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1778),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_components_MiniCalculatorPage__);





/* harmony default export */ __webpack_exports__["a"] = ({
    extends: {
        methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_components_MiniCalculatorPage___default.a.methods),
        computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_components_MiniCalculatorPage___default.a.computed)
    },
    methods: {
        hidePrompt: function hidePrompt() {
            var summary = document.querySelector('.p-animated-calc__summary-panel');
            var results = document.querySelector('.p-animated-calc__results-panel');
            var share = document.querySelector('.p-animated-calc__share');

            summary.style.display = 'none';
            results.style.opacity = '1';
            share.style.display = 'block';
        },
        showPrompt: function showPrompt() {
            var summary = document.querySelector('.p-animated-calc__summary-panel');
            var results = document.querySelector('.p-animated-calc__results-panel');
            var share = document.querySelector('.p-animated-calc__share');

            summary.style.display = 'block';
            results.style.opacity = '0';
            share.style.display = 'none';
        }
    }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = personTemplate;
/* harmony export (immutable) */ __webpack_exports__["l"] = lifeExpectancyTemplate;
/* unused harmony export assumedLifeExpectancyTemplate */
/* unused harmony export incomeTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultIncomePeriodTemplate; });
/* harmony export (immutable) */ __webpack_exports__["d"] = customHeadsOfLossTemplate;
/* harmony export (immutable) */ __webpack_exports__["c"] = careTemplate;
/* harmony export (immutable) */ __webpack_exports__["e"] = carePeriodTemplate;
/* harmony export (immutable) */ __webpack_exports__["j"] = lossOfEarningsPeriodTemplate;
/* harmony export (immutable) */ __webpack_exports__["b"] = paymentsTemplate;
/* harmony export (immutable) */ __webpack_exports__["k"] = serviceTemplate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return headOfLossTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return dependantsHeadsOfLossTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return dependantsCustomHeadsOfLossTemplate; });
/* harmony export (immutable) */ __webpack_exports__["r"] = earningsAtInjuryTemplate;
/* harmony export (immutable) */ __webpack_exports__["q"] = postInjuryIncomeTemplate;
/* harmony export (immutable) */ __webpack_exports__["s"] = paymentsReceivedTemplate;
/* harmony export (immutable) */ __webpack_exports__["t"] = absenceTemplate;
/* harmony export (immutable) */ __webpack_exports__["m"] = purchaseTemplate;
/* harmony export (immutable) */ __webpack_exports__["n"] = otherFutureLossesCareTemplate;
/* harmony export (immutable) */ __webpack_exports__["o"] = otherFutureLossesServicesTemplate;
/* harmony export (immutable) */ __webpack_exports__["p"] = generalDamagesTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var m = function m(d) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(d, 'DD/MM/YYYY');
};

function personTemplate() {
    return {
        id: null,
        name: null,
        dateOfBirth: null,
        dateOfDeath: null,
        onsetOfSymptoms: null,
        ageAtDeath: null,
        currentAge: null,
        gender: null,
        predictedDeath: null,
        income: incomeTemplate(),
        lifeExpectancy: lifeExpectancyTemplate(),
        assumedLifeExpectancy: assumedLifeExpectancyTemplate(),
        levelOfEducation: null,
        employedAtDateOfDeath: null,
        disabledAtAccident: null,
        employedAtAccident: null,
        disabledAtTrial: null,
        employedAtTrial: null,
        employedButFor: null,
        ageAtOnset: null
    };
}

function lifeExpectancyTemplate() {
    return {
        method: 'ogden_table',
        yearsAndMonths: {
            months: 0,
            years: 0
        },
        dateOfDeathIsAssumed: null,
        ageAtDeath: null,
        dateOfDeath: null,
        percentageOfNormalLifeExpectancy: 100,
        percentageReductionInNormalLifeExpectancy: 0,
        child: {
            youthCutOffAge: null,
            youthYearsLeft: null,
            youthCutOffDate: null
        }
    };
}

function assumedLifeExpectancyTemplate() {
    return {
        method: null,
        yearsLeft: 0,
        monthsLeft: 0,
        ageAtDeath: '',
        dateOfDeath: ''
    };
}

function incomeTemplate() {
    return {
        pastLossOfEarnings: null,
        futureLossOfEarnings: null,
        absences: null,
        retired: false,
        retirementAgeCalc: 'auto',
        retirementAge: 65,
        retirementDate: '',
        periods: [],
        futurePeriods: [],
        pastPeriods: [],
        preAccident: earningsAtInjuryTemplate(),
        postInjuryPeriods: [],
        futureEarningsPreAccident: earningsAtInjuryTemplate(),
        futureEarningsPostAccident: earningsAtInjuryTemplate(),
        absencePeriods: [absenceTemplate()],
        otherPayments: 0,
        contingencyMultiplier: false,
        multiplier: 1,
        ownPastLosses: false,
        ownFutureLosses: false,
        pastLossOfEarningsNetTotal: 0
    };
}

var defaultIncomePeriodTemplate = function defaultIncomePeriodTemplate(_ref) {
    var start = _ref.start,
        end = _ref.end,
        _ref$employmentNetGro = _ref.employmentNetGross,
        employmentNetGross = _ref$employmentNetGro === undefined ? 'net' : _ref$employmentNetGro,
        _ref$employmentType = _ref.employmentType,
        employmentType = _ref$employmentType === undefined ? 'employed' : _ref$employmentType,
        _ref$employmentIncome = _ref.employmentIncome,
        employmentIncome = _ref$employmentIncome === undefined ? 0 : _ref$employmentIncome,
        _ref$totalGross = _ref.totalGross,
        totalGross = _ref$totalGross === undefined ? 0 : _ref$totalGross,
        _ref$totalNetIncome = _ref.totalNetIncome,
        totalNetIncome = _ref$totalNetIncome === undefined ? 0 : _ref$totalNetIncome;

    return {
        startOfPeriod: start,
        endOfPeriod: end,
        employmentType: employmentType,
        employmentIncome: employmentIncome,
        employmentNetGross: employmentNetGross,
        pensionIncome: 0,
        pensionNetGross: 'net',
        totalGrossIncome: totalGross,
        totalNetIncome: totalNetIncome,
        duration: Math.round(m(end).diff(m(start), 'years', true) * 100) / 100
    };
};

function customHeadsOfLossTemplate() {
    return {
        name: '',
        value: 0,
        interest: 0.5,
        interestAccrued: 0
    };
}

function careTemplate() {
    return {
        type: null,
        past: {
            type: 'own',
            totalValue: 0,
            periods: [carePeriodTemplate()]
        },
        future: {
            type: 'own',
            totalValue: 0,
            periods: [carePeriodTemplate()]
        }
    };
}

function carePeriodTemplate() {
    return {
        periodStart: '',
        periodEnd: '',
        hoursPerDay: 0,
        numberOfDays: 0,
        rate: 'basic',
        total: 0,
        gratuitousCare: false,
        includeLastDay: true,
        includeFirstDay: true
    };
}

function lossOfEarningsPeriodTemplate() {
    return {
        periodStart: '',
        periodEnd: '',
        periodTotal: 0,
        includeLastDay: true,
        includeFirstDay: true,
        periodNetGross: 'gross',
        periodEmploymentType: 'employed',
        periodValue: 0,
        duration: 0
    };
}

function paymentsTemplate() {
    return {
        date: '',
        value: 0
    };
}

function serviceTemplate() {
    return {
        descriptionOfService: null,
        calculatedDependency: null,
        ogdenTableF: null,
        ogdenTableE: null,
        ogdenTableTwentyEight: null,
        selectedOgdenDiscount: 28,
        duration: 0,
        multiplicand: 0,
        toDate: '',
        durationType: 'life',
        valid: false,
        years: 0,
        months: 0,
        age: 0
    };
}

var headOfLossTemplate = function headOfLossTemplate() {
    return {
        name: '',
        value: 0,
        interest: 0.5,
        interestAccrued: 0
    };
};

var dependantsHeadsOfLossTemplate = function dependantsHeadsOfLossTemplate() {
    return {
        generalDamages: 0,
        bereavementAward: 0,
        funeralExpenses: 0,
        lossOfSpouse: 0,
        pastLossOfEarnings: 0,
        pastCostOfCare: 0,
        pastCostOfTravel: 0,
        misc: 0,
        interest: 0,
        dependantsCustomHeadsOfLoss: []
    };
};

var dependantsCustomHeadsOfLossTemplate = function dependantsCustomHeadsOfLossTemplate() {
    return {
        name: '',
        value: 0
    };
};

function earningsAtInjuryTemplate() {
    return {
        employmentType: 'employed',
        employmentIncome: 0,
        employmentNetGross: 'gross',
        totalNetIncome: 0
    };
}

function postInjuryIncomeTemplate(_ref2) {
    var start = _ref2.start,
        end = _ref2.end;

    return {
        startOfPeriod: start,
        endOfPeriod: end,
        employmentType: '',
        employmentIncome: 0,
        employmentNetGross: 'gross',
        totalNetIncome: 0,
        totalNetLoss: 0,
        paymentsReceived: []
    };
};

function paymentsReceivedTemplate() {
    return {
        date: '',
        total: 0
    };
}

function absenceTemplate() {
    return {
        startOfPeriod: '',
        endOfPeriod: '',
        duration: 0
    };
}

function purchaseTemplate() {
    return {
        description: null,
        purchaseDate: null,
        purchaseUntil: 'own',
        purchaseEnd: null,
        resaleOption: false,
        type: null,
        mortalityMultiplier: null,
        frequency: 0,
        frequencyType: 'years',
        resaleValue: 0,
        resaleTotal: 0,
        ageAtPurchase: null,
        multiplier: 0,
        multiplicand: 0,
        discount: 0,
        total: 0
    };
}

function otherFutureLossesCareTemplate() {
    return {
        description: null,
        careStartDate: null,
        careEndDate: null,
        duration: 0,
        multiplier: 0,
        multiplicand: 0,
        lossesForLife: null,
        futureCareTotal: 0,
        mortalityMultiplier: null,
        ageAtEndDate: 0
    };
}

function otherFutureLossesServicesTemplate() {
    return {
        description: null,
        servicesStartDate: null,
        servicesEndDate: null,
        duration: 0,
        multiplier: 0,
        multiplicand: 0,
        lossesForLife: null,
        futureServicesTotal: 0,
        mortalityMultiplier: null,
        ageAtEndDate: 0
    };
}

function generalDamagesTemplate() {
    return {
        generalDamages: null,
        uplift: true,
        path: [],
        discount: 0,
        total: null
    };
}

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(1770),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(1758),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(747),
  /* template */
  __webpack_require__(1834),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return userSettable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dynamicUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return findNextPeriodStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return findNextPeriodEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return doesIncomePeriodNeedToUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return zeroCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isValidIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return throttledIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return unthrottledIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return financeValues; });
/* unused harmony export incomeUpdates */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return determineLife; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return calcAgeDeath; });
/* unused harmony export sumPeriodValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extractIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return incomeValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return splitPeriodsForRetirement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removePeriodsSplitForTheRetired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateIncomePeriodsForRetirement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__ = __webpack_require__(33);












function clone(life) {
    var cloned = {};
    __WEBPACK_IMPORTED_MODULE_5_vue___default.a.util.extend(cloned, life);

    return life;
}

function roundYears(years) {
    return Math.round(years * 100) / 100;
}

var updateObject = function updateObject(dispatch, action, obj) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var proms = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return dispatch(action, { key: key, value: obj[key], index: index });
    });
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
};

var userSettable = function userSettable(key) {
    return key !== 'lifeExpectancy' && key !== 'income' && key !== 'ageAtDeath';
};

var dynamicUpdates = function dynamicUpdates(actions) {
    return function (key, dispatch, person, index) {
        var proms = [];
        switch (key) {
            case 'dateOfDeath':
            case 'dateOfBirth':
                if (actions.ageAtDeath) {
                    proms.push(dispatch(actions.ageAtDeath, {
                        key: 'ageAtDeath',
                        value: calcAgeDeath(person),
                        index: index,
                        force: true
                    }));
                }

                proms.push(dispatch(actions.lifeExpectancy, { lifeExpectancy: person.lifeExpectancy, index: index }));
                if (key == 'dateOfDeath') {
                    break;
                }
        }
        return proms;
    };
};

var findNextPeriodStart = function findNextPeriodStart(periods, worseCase) {
    return periods.reduce(function (min, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(min) ? periodDate : min;
    }, __WEBPACK_IMPORTED_MODULE_6_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var findNextPeriodEnd = function findNextPeriodEnd(periods, worseCase) {
    return periods.reduce(function (max, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(max) ? periodDate : max;
    }, __WEBPACK_IMPORTED_MODULE_6_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var doesIncomePeriodNeedToUpdate = function doesIncomePeriodNeedToUpdate(updatedKeys) {
    var triggerKeys = ['startOfPeriod', 'endOfPeriod', 'employmentType', 'employmentIncome', 'employmentNetGross', 'pensionIncome', 'pensionNetGross', 'grossIncome', 'netIncome', 'netPensionIncome', 'grossPensionIncome'];
    var keys = updatedKeys.filter(function (key) {
        return key && ~triggerKeys.indexOf(key);
    });
    return !!keys.length;
};

var zeroCheck = function zeroCheck(dispatch, index, period, person, action, type) {
    var proms = [];
    if (type === 'deceased') {
        if (person.income.retired === true && period.pensionIncome === 0) {
            proms.push(dispatch(action, { key: 'totalNetIncome', value: 0, index: index }));
        }
        if (person.income.retired === false && period.pensionIncome === 0 && period.employmentIncome === 0) {
            proms.push(dispatch(action, { key: 'totalNetIncome', value: 0, index: index }));
            proms.push(dispatch(action, { key: 'totalGrossIncome', value: 0, index: index }));
        }
    } else {
        if (person.income.retired === true && period.pensionIncome === 0) {
            proms.push(dispatch(action, { key: 'totalNetIncome', value: 0, index: index, dependant: person }));
        }
        if (person.income.retired === false && period.pensionIncome === 0 && period.employmentIncome === 0) {
            proms.push(dispatch(action, { key: 'totalNetIncome', value: 0, index: index, dependant: person }));
            proms.push(dispatch(action, { key: 'totalGrossIncome', value: 0, index: index, dependant: person }));
        }
    }
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
};

var isValidIncome = function isValidIncome(period) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(period.startOfPeriod) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(period.endOfPeriod) && !isNaN(period.employmentIncome) && !isNaN(period.pensionIncome) && __WEBPACK_IMPORTED_MODULE_6_moment___default()(period.startOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(period.endOfPeriod, 'DD/MM/YYYY'));
};

var throttledIncome = function throttledIncome(period, dispatch, action, args, person) {
    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.income(period, person).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {
                dispatch(action, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key, value: updated[key] }, args));
            }
        });
    }).then(function () {
        return dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
    });
};

var unthrottledIncome = function unthrottledIncome(period, dispatch, action, args, person) {
    __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.income(period, person).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {

                __WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].dispatch(action, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    key: key,
                    value: updated[key] }, args));
            }
        });
    });
};

var financeValues = function financeValues(person, duration) {
    var _ref;

    var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var income = person.income;
    var life = lifeExpectancyValues(person);
    return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "retired_at_death", income.employmentType ? 'yes' : 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "pension_type", income.pensionIncomeType + "_income"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "pension_value", income[income.pensionIncomeType + "PensionIncome"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "pension_unchanged", income.unchangedPension), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "employment_type", income.employmentType), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "retired", income.retired), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "retirement_age_calc", income.retirementAgeCalc), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "retirement_age", income.retirementAge), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "retirement_date", income.retirementDate), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "net_income", income.netIncome || 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "gross_income", income.grossIncome || 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "net_pension_income", income.netPensionIncome || 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "gross_pension_income", income.grossPensionIncome || 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "date_of_birth", person.dateOfBirth), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "date_of_death", person.lifeExpectancy.dateOfDeath), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "type", life.type), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "value", life.value), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "period_of_dependency", duration), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "periods", person.income.periods), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "employed_at_date_of_death", person.employedAtDateOfDeath), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "contingency_multiplier", income.contingencyMultiplier), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "multiplier", income.multiplier), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "level_of_education", person.levelOfEducation), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefix + "disabled_at_accident", person.disabledAtAccident), _ref;
};

var lifeExpectancyValues = function lifeExpectancyValues(person) {
    var leValue = null;
    var life = person.lifeExpectancy;
    switch (life.method) {
        case 'years_and_months':
            leValue = [life.yearsAndMonths.years, life.yearsAndMonths.months];
            break;
        case 'enter_date':
            leValue = life.dateOfDeathIsAssumed;
            break;
        case 'age_at_death':
            leValue = life.ageAtDeath;
            break;
        case 'percentage_of_normal_life_expectancy':
            leValue = life.percentageOfNormalLifeExpectancy;
            break;
        case 'percentage_reduction_in_normal_life_expectancy':
            leValue = life.percentageReductionInNormalLifeExpectancy;
            break;
        case 'dependent_until_16':
            leValue = [life.child.youthCutOffDate, life.child.youthCutOffAge, life.child.youthYearsLeft];
            break;
        case 'dependent_until_18':
            leValue = [life.child.youthCutOffDate, life.child.youthCutOffAge, life.child.youthYearsLeft];
            break;
        case 'dependent_until_21':
            leValue = [life.child.youthCutOffDate, life.child.youthCutOffAge, life.child.youthYearsLeft];
            break;
        case 'dependent_until_custom':
            leValue = [life.child.youthCutOffDate, life.child.youthCutOffAge, life.child.youthYearsLeft];
            break;
    }
    return { type: life.method, value: leValue };
};

var incomeUpdates = function incomeUpdates(actions, dispatch, income, dateOfDeath, index) {
    return function (updatedKeys) {
        var proms = [];

        if (~updatedKeys.indexOf('retirementDate')) {
            proms.push(dispatch(actions.updateRetirementAge, { index: index }));
        }

        if (~updatedKeys.indexOf('retirementAge')) {
            proms.push(dispatch(actions.updateRetirementDate, { index: index }));
        }

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
    };
};

function calcYearsAndMonths(person, lifeExpectancy) {
    var dob = __WEBPACK_IMPORTED_MODULE_6_moment___default()(person.dateOfBirth, 'DD/MM/YYYY');
    var end = person.dateOfDeath ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(person.dateOfDeath, 'DD/MM/YYYY') : __WEBPACK_IMPORTED_MODULE_6_moment___default()();
    end.add(lifeExpectancy.yearsAndMonths.years, 'years').add(lifeExpectancy.yearsAndMonths.months, 'months');

    return {
        dateOfDeath: end.format('DD/MM/YYYY'),
        ageAtDeath: roundYears(end.diff(dob, 'years', true))
    };
}

function calcEnterDate(person, lifeExpectancy) {
    var dob = __WEBPACK_IMPORTED_MODULE_6_moment___default()(person.dateOfBirth, 'DD/MM/YYYY');
    var end = __WEBPACK_IMPORTED_MODULE_6_moment___default()(lifeExpectancy.dateOfDeathIsAssumed, 'DD/MM/YYYY');

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(lifeExpectancy.dateOfDeathIsAssumed)) {
        return {
            dateOfDeath: '',
            ageAtDeath: 0
        };
    }

    return {
        dateOfDeath: end.format('DD/MM/YYYY'),
        ageAtDeath: roundYears(end.diff(dob, 'years', true))
    };
}

function ogdenValue(assumedSettlement, person, lifeExpectancy) {
    var clonePerson = clone(person);

    lifeExpectancy.dateOfDeath = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('DD/MM/YYYY');
    clonePerson.dateOfDeathAssumed = lifeExpectancy.dateOfDeathIsAssumed;

    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.dates.lifeExpectancy('ogden_table', clonePerson, assumedSettlement).then(function (result) {
        var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_6_moment___default()(result.dateOfDeath, 'DD/MM/YYYY');

        return {
            dateOfDeath: mDateOfDeath.format('DD/MM/YYYY'),
            ageAtDeath: result.ageAtDeath
        };
    });
}

function enterAgeAtDeath(person, lifeExpectancy) {
    if (lifeExpectancy.ageAtDeath > 0) {
        var dateOfDeath = __WEBPACK_IMPORTED_MODULE_6_moment___default()(person.dateOfBirth, 'DD/MM/YYYY').add(lifeExpectancy.ageAtDeath, 'years').format('DD/MM/YYYY');
        return {
            dateOfDeath: dateOfDeath
        };
    }
    return {
        dateOfDeath: ''
    };
}

var percentageOfNormalLifeExpectancy = function percentageOfNormalLifeExpectancy(assumedSettlement, person, lifeExpectancy) {
    if (lifeExpectancy.percentageOfNormalLifeExpectancy < 0 || lifeExpectancy.percentageOfNormalLifeExpectancy > 100) {
        throw { 'error': 'Percentage of normal life expectancy must be between = and 100' };
    }

    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.dates.lifeExpectancy('percentage_of_normal_life_expectancy', person, {
        percentage: lifeExpectancy.percentageOfNormalLifeExpectancy,
        date_of_trial: assumedSettlement
    }).then(function (data) {
        return {
            dateOfDeath: data.dateOfDeath,
            ageAtDeath: data.ageAtDeath
        };
    });
};

function percentageReductionInNormalLifeExpectancy(assumedSettlement, person, lifeExpectancy) {
    if (lifeExpectancy.percentageReductionInNormalLifeExpectancy < 0 || lifeExpectancy.percentageReductionInNormalLifeExpectancy > 100) {
        throw { 'error': 'Percentage reduction in normal life expectancy must be between 0 and 100' };
    }

    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.dates.lifeExpectancy('percentage_reduction_in_normal_life_expectancy', person, {
        percentage: lifeExpectancy.percentageReductionInNormalLifeExpectancy,
        date_of_trial: assumedSettlement
    }).then(function (data) {
        return {
            dateOfDeath: data.dateOfDeath,
            ageAtDeath: data.ageAtDeath
        };
    });
}

function childDependent(person, lifeExpectancy) {
    if (!lifeExpectancy.child.youthCutOffAge || !lifeExpectancy.child.youthCutOffDate) {
        return;
    }

    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.dates.lifeExpectancy(lifeExpectancy.method, person, lifeExpectancy.child.youthCutOffAge).then(function (childDependency) {
        var mEndOfChildDependency = __WEBPACK_IMPORTED_MODULE_6_moment___default()(childDependency.dateOfDeath, 'DD/MM/YYYY');

        return {
            dateOfDeath: mEndOfChildDependency.format('DD/MM/YYYY'),
            child: {
                youthCutOffDate: mEndOfChildDependency.format('DD/MM/YYYY'),
                youthCutOffAge: roundYears(mEndOfChildDependency.diff(__WEBPACK_IMPORTED_MODULE_6_moment___default()(person.dateOfBirth, 'DD/MM/YYYY'), 'years', true)),
                youthYearsLeft: roundYears(mEndOfChildDependency.diff(__WEBPACK_IMPORTED_MODULE_6_moment___default()(), 'years', true))
            }
        };
    });
}

var determineLife = function determineLife(assumedSettlement, person, lifeExpectancy) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        switch (lifeExpectancy.method) {
            case 'years_and_months':
                resolve(calcYearsAndMonths(person, lifeExpectancy));
                break;
            case 'enter_date':
                resolve(calcEnterDate(person, lifeExpectancy));
                break;
            case 'age_at_death':
                resolve(enterAgeAtDeath(person, lifeExpectancy));
                break;

            case 'ogden_table':
                ogdenValue(assumedSettlement, person, lifeExpectancy).then(resolve);
                break;
            case 'percentage_of_normal_life_expectancy':
                percentageOfNormalLifeExpectancy(assumedSettlement, person, lifeExpectancy).then(resolve);
                break;
            case 'percentage_reduction_in_normal_life_expectancy':
                percentageReductionInNormalLifeExpectancy(assumedSettlement, person, lifeExpectancy).then(resolve);
                break;
            case 'dependent_until_adult':
                ogdenValue(assumedSettlement, person, lifeExpectancy).then(resolve);
                break;
            case 'dependent_until_date':
                ogdenValue(assumedSettlement, person, lifeExpectancy).then(resolve);
                break;
            case 'dependent_until_16':
                childDependent(person, lifeExpectancy).then(resolve);
                break;
            case 'dependent_until_18':
                childDependent(person, lifeExpectancy).then(resolve);
                break;
            case 'dependent_until_21':
                childDependent(person, lifeExpectancy).then(resolve);
                break;
            case 'dependent_until_custom':
                childDependent(person, lifeExpectancy).then(resolve);
                break;
            default:
                resolve(true);
        }
    });
};

var calcAgeDeath = function calcAgeDeath(person) {
    var mDob = __WEBPACK_IMPORTED_MODULE_6_moment___default()(person.dateOfBirth, 'DD/MM/YYYY');
    var mDod = __WEBPACK_IMPORTED_MODULE_6_moment___default()(person.dateOfDeath, 'DD/MM/YYYY');
    if (mDob.isValid() && mDod.isValid()) {
        return roundYears(mDod.diff(mDob, 'years', true));
    }
    return null;
};

var sumPeriodValue = function sumPeriodValue(periods, key) {
    return periods.reduce(function (total, period) {
        return total + (period[key] || 0);
    }, 0);
};

var extractIncome = function extractIncome(person, type) {
    return (person.income.retired ? sumPeriodValue(person.income.periods, type + "PensionIncome") : 0) + (person.income.employmentType !== 'retired' ? sumPeriodValue(person.income.periods, type + "Income") : 0);
};

var incomeValid = function incomeValid(assumedSettlement, person) {
    var dob = __WEBPACK_IMPORTED_MODULE_6_moment___default()(person.dateOfBirth, 'DD/MM/YYYY');
    if (assumedSettlement.diff(dob, 'years') < 21 || isChild(person)) {
        return true;
    }
    return person.income.periods.reduce(function (valid, period) {
        return valid ? period.pensionIncome > 0 || period.employmentIncome > 0 && !!period.endOfPeriod : valid;
    }, true);
};

var isChild = function isChild(dependant) {
    return __WEBPACK_IMPORTED_MODULE_6_moment___default()(dependant.dateOfBirth, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(18, 'y'));
};

var splitPeriodsForRetirement = function splitPeriodsForRetirement(commit, updateMutation, addMutation, previousRetirementDate, retirementDate, periods, end) {
    var dependant = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    var dependantIndex = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    var type = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;


    if (previousRetirementDate === "") {
        previousRetirementDate = retirementDate;
    }

    if (previousRetirementDate === "") {
        return;
    }
    previousRetirementDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(previousRetirementDate, 'DD/MM/YYYY');

    if (retirementDate === null) {
        return;
    }
    var mRetirementDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(retirementDate, 'DD/MM/YYYY');

    if (periods.length === 1 && retirementDate !== "") {
        var periodStart = __WEBPACK_IMPORTED_MODULE_6_moment___default()(periods[0].startOfPeriod, 'DD/MM/YYYY');
        var periodEnd = __WEBPACK_IMPORTED_MODULE_6_moment___default()(periods[0].endOfPeriod, 'DD/MM/YYYY');
        if (!__WEBPACK_IMPORTED_MODULE_6_moment___default()(retirementDate, 'DD/MM/YYYY').isBetween(periodStart, periodEnd)) {
            return;
        }

        commit(updateMutation, {
            index: 0,
            key: "endOfPeriod",
            value: retirementDate,
            dependant: dependant,
            type: type
        });
        var period = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["a" /* defaultIncomePeriodTemplate */])({
            start: retirementDate,
            end: end
        });
        if (addMutation === "ADD_DEPENDANT_INCOME_PERIOD") {
            commit(addMutation, { dependant: dependantIndex, period: period });
        } else if (addMutation === "ADD_INCOME_PERIOD") {
            commit(addMutation, { type: type, period: period });
        } else {
            commit(addMutation, period);
        }
        return;
    }
    var min = __WEBPACK_IMPORTED_MODULE_6_moment___default()(periods[0].startOfPeriod, 'DD/MM/YYYY');
    var max = __WEBPACK_IMPORTED_MODULE_6_moment___default()(periods[periods.length - 1].endOfPeriod, 'DD/MM/YYYY');

    periods.forEach(function (period, index) {
        var start = __WEBPACK_IMPORTED_MODULE_6_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
        var end = __WEBPACK_IMPORTED_MODULE_6_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');
        if (index === 0 && mRetirementDate.isBefore(start)) {
            return;
        }
        if (index === periods.length - 1 && mRetirementDate.isAfter(end)) {
            return;
        }
        if (end.isSame(previousRetirementDate) && mRetirementDate.isAfter(start) && mRetirementDate.isBefore(max)) {
            commit(updateMutation, {
                index: index,
                key: "endOfPeriod",
                value: retirementDate,
                dependant: dependant,
                type: type
            });
        }
        if (start.isSame(previousRetirementDate) && mRetirementDate.isBefore(end) && mRetirementDate.isAfter(min)) {
            commit(updateMutation, {
                index: index,
                key: "startOfPeriod",
                value: retirementDate,
                dependant: dependant,
                type: type
            });
        }
    });
};

var removePeriodsSplitForTheRetired = function removePeriodsSplitForTheRetired(dispatch, action, periods, previousDate, currentDate) {
    var args = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (periods.length <= 1) {
        return;
    }
    var proms = periods.map(function (period, index) {
        if (period.startOfPeriod === previousDate || period.startOfPeriod === currentDate) {
            return dispatch(action, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ index: index }, args));
        }
    });
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
};

var updateIncomePeriodsForRetirement = function updateIncomePeriodsForRetirement(dispatch, action, periods, retired) {
    var args = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var proms = periods.map(function (period, index) {
        if (retired && period.employmentIncome > 0) {
            return dispatch(action, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                key: 'employmentIncome',
                value: 0,
                index: index
            }, args)).then(function () {
                return true;
            });
        }
        return false;
    });
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
};

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1689),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return areAllTrue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return promiseQueue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dateFromServer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



Array.prototype.filterAssoc = function (callback) {
    var a = this.slice();
    a.map(function (v, k, a) {
        if (!callback(v, k, a)) delete a[k];
    });
    return a;
};

var areAllTrue = function areAllTrue(arr, expression) {
    return arr.reduce(function (valid, value) {
        return !valid ? valid : expression(value);
    }, true);
};

var promiseQueue = function promiseQueue(items, cb) {
    var itemList = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(items);

    return cb(itemList.shift()).then(function () {
        if (itemList.length) {
            return promiseQueue(itemList, cb);
        }
        return true;
    });
};

var dateFromServer = function dateFromServer(dateObj) {
    var mDate = void 0;
    if (!dateObj) {
        return null;
    }
    if (typeof dateObj === 'string') {
        mDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateObj, 'YYYY-MM-DD');
    }
    if (dateObj.date) {
        mDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateObj.date, 'YYYY-MM-DD');
    }
    if (!mDate || !mDate.isValid()) {
        return null;
    }
    return mDate.format('DD/MM/YYYY');
};

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESOURCE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_calculatorModals_age__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals_care__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_calculatorModals_services__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_calculatorModals_pension__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_calculatorModals_dayOne__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_calculatorModals_education__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_api_calculatorModals_headsOfLoss__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_api_calculatorModals_interest__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_api_calculatorModals_lifeExpectancy__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_api_calculatorModals_multipliers__ = __webpack_require__(858);











var RESOURCE = 'calculator-modals';

/* harmony default export */ __webpack_exports__["a"] = ({
  age: __WEBPACK_IMPORTED_MODULE_0_services_api_calculatorModals_age__["a" /* default */],

  care: __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals_care__["a" /* default */],

  services: __WEBPACK_IMPORTED_MODULE_2_services_api_calculatorModals_services__["a" /* default */],

  pension: __WEBPACK_IMPORTED_MODULE_3_services_api_calculatorModals_pension__["a" /* default */],

  dayOne: __WEBPACK_IMPORTED_MODULE_4_services_api_calculatorModals_dayOne__["a" /* default */],

  education: __WEBPACK_IMPORTED_MODULE_5_services_api_calculatorModals_education__["a" /* default */],

  headsOfLoss: __WEBPACK_IMPORTED_MODULE_6_services_api_calculatorModals_headsOfLoss__["a" /* default */],

  interest: __WEBPACK_IMPORTED_MODULE_7_services_api_calculatorModals_interest__["a" /* default */],

  lifeExpectancy: __WEBPACK_IMPORTED_MODULE_8_services_api_calculatorModals_lifeExpectancy__["a" /* default */],

  multipliers: __WEBPACK_IMPORTED_MODULE_9_services_api_calculatorModals_multipliers__["a" /* default */]
});

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1741),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        dateFormat: function dateFormat(value, format) {
            return value ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format(format) : '';
        }
    }
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1790),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        percentageDifference: function percentageDifference(num1, num2) {
            if (num2 === num1) {
                return 0;
            }

            if (num2 === 0 || num1 === 0) {
                return 100;
            }

            return Math.abs((1 - num2 / num1) * 100);
        }
    }
});

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
    mixins: [reactiveProp],
    props: ["options"],
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
}));

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1603),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESOURCE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_mini_calculators_monetary__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_mini_calculators_multipliers__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_mini_calculators_grossNetPension__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_api_mini_calculators_care__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_api_mini_calculators_lifeExpectancy__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_api_mini_calculators_dates__ = __webpack_require__(870);







var RESOURCE = 'mini-calculators';

/* harmony default export */ __webpack_exports__["a"] = ({
  monetary: __WEBPACK_IMPORTED_MODULE_0_services_api_mini_calculators_monetary__["a" /* default */],

  multipliers: __WEBPACK_IMPORTED_MODULE_1_services_api_mini_calculators_multipliers__["a" /* default */],

  grossNetPension: __WEBPACK_IMPORTED_MODULE_2_services_api_mini_calculators_grossNetPension__["a" /* default */],

  care: __WEBPACK_IMPORTED_MODULE_3_services_api_mini_calculators_care__["a" /* default */],

  lifeExpectancy: __WEBPACK_IMPORTED_MODULE_4_services_api_mini_calculators_lifeExpectancy__["a" /* default */],

  dates: __WEBPACK_IMPORTED_MODULE_5_services_api_mini_calculators_dates__["a" /* default */]

});

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1777),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1304)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1566),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1314)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1694),
  /* scopeId */
  "data-v-54317516",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1673),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1836),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1313)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1804),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1767),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1577),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
    mixins: [reactiveProp],
    props: ['options'],
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
}));

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
    mixins: [reactiveProp],
    props: ['options'],
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
}));

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESOURCE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_calculators_dates__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculators_monetary__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_calculators_ons__ = __webpack_require__(861);




var RESOURCE = 'calculators';

/* harmony default export */ __webpack_exports__["a"] = ({
  dates: __WEBPACK_IMPORTED_MODULE_0_services_api_calculators_dates__["a" /* default */],

  monetary: __WEBPACK_IMPORTED_MODULE_1_services_api_calculators_monetary__["a" /* default */],

  ons: __WEBPACK_IMPORTED_MODULE_2_services_api_calculators_ons__["a" /* default */]
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculators__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_personFunctions__ = __webpack_require__(38);




var RESOURCE = 'monetary';

function extractNetIncomeForServer(person) {
    var net_income = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_services_personFunctions__["a" /* extractIncome */])(person, 'net');
    return {
        net_income: net_income
    };
}

var extractSinglePeriod = function extractSinglePeriod(income, period) {
    if (income.retired) {
        return [{
            is_pension: true,
            employment_type: 'retired',
            start_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(period.startOfPeriod),
            end_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(period.endOfPeriod),
            net_income: period.netPensionIncome
        }];
    }
    return [{
        employment_type: period.employmentType,
        start_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(period.startOfPeriod),
        end_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(income.retirementDate),
        net_income: period.netIncome
    }, {
        is_pension: true,
        employment_type: 'retired',
        start_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(income.retirementDate),
        end_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(period.endOfPeriod),
        net_income: period.netPensionIncome
    }];
};

var extractMultiplePeriods = function extractMultiplePeriods(income, periods) {
    var ret = [];
    periods.forEach(function (period) {
        if (period.netPensionIncome > 0) {
            ret.push({
                is_pension: true,
                employment_type: 'retired',
                start_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(period.startOfPeriod),
                end_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(period.endOfPeriod),
                net_income: period.netPensionIncome
            });
        }

        if (period.netIncome > 0) {
            ret.push({
                employment_type: period.employmentType,
                start_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(period.startOfPeriod),
                end_of_period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(period.endOfPeriod),
                net_income: period.netIncome
            });
        }
    });

    return ret;
};

var extractForIncomeTable = function extractForIncomeTable(start) {
    return function (person) {
        var income = person.income;
        var periods = income.periods;
        if (!periods[0]) {
            return null;
        }
        var serverPeriods = income.unchangedPension ? extractSinglePeriod(income, periods[0]) : extractMultiplePeriods(income, periods);

        return {
            name: person.name,
            gender: person.gender,
            date_of_birth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(person.dateOfBirth),
            date_of_death: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(person.dateOfDeath),
            date_of_death_assumed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(person.lifeExpectancy.dateOfDeath),
            income: serverPeriods
        };
    };
};

/* harmony default export */ __webpack_exports__["a"] = ({
    pensionLoss: function pensionLoss(claimant, pension) {
        var data = {
            claimant: claimant,
            pension: pension
        };

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'pension-loss', data);
    },
    futureLoss: function futureLoss(duration, discountRate) {
        var data = {
            duration: duration,
            discountRate: discountRate
        };

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'future-loss', data).then(function (data) {
            return parseFloat(data.value);
        });
    },
    income: function income(_income, person) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'income', {
            employment_income: _income.employmentIncome,
            employment_net_gross: _income.employmentNetGross,
            employment_type: _income.employmentType,
            end_of_period: _income.endOfPeriod,
            pension_income: _income.pensionIncome,
            pension_net_gross: _income.pensionNetGross,
            start_of_period: _income.startOfPeriod,
            retirement_date: person.income.retirementDate
        }).then(function (data) {
            return {
                totalGrossIncome: data.total_gross_income,
                totalNetIncome: data.total_net_income
            };
        });
    },
    multiplicand: function multiplicand(deceasedIncome, dependantsIncome, percentage) {
        var data = {
            deceased: deceasedIncome,
            dependants: dependantsIncome,
            percentage: percentage
        };
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'multiplicand', data).then(function (data) {
            return parseFloat(data.value);
        });
    },
    multiplier: function multiplier(person, dependants, claimantName, dateOfassumedSettlement, type, discountRate, discountTable, multiplicandTotal) {
        dependants.map(function (dependant) {
            return dependant.dateOfDeathAssumed = dependant.lifeExpectancy.dateOfDeath;
        });

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'financial/multiplier', {
            person: {
                name: person.name,
                gender: person.gender,
                date_of_birth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(person.dateOfBirth),
                date_of_death: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(person.dateOfDeath),
                date_of_death_assumed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(person.lifeExpectancy.dateOfDeath)
            },
            claim: {
                claimant_name: claimantName,
                assumed_settlement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(dateOfassumedSettlement)
            },
            discount_rate: discountRate,
            discount_table: discountTable,
            multiplier: {
                dependency_type: type,
                value: multiplicandTotal
            },
            loss_of_earnings: person.income.multiplier,
            dependants: dependants ? dependants : []
        });
    },
    multiplierTable: function multiplierTable(theDeceased, dependants, claimantName, assumedSettlement, discountRate, discountTable, multiTotal) {
        var action = discountTable === 1 ? 'financial/table-1-and-2' : 'financial/table-28';

        theDeceased.dateOfDeathAssumed = theDeceased.lifeExpectancy.dateOfDeath;
        dependants.map(function (dependant) {
            return dependant.dateOfDeathAssumed = dependant.lifeExpectancy.dateOfDeath;
        });

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, action, {
            deceased: theDeceased,
            dependants: dependants,
            claim: {
                claimant_name: claimantName,
                assumed_settlement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(assumedSettlement)
            },
            discount_rate: discountRate,
            discount_table: discountTable,
            multiplier: {
                value: multiTotal
            },
            loss_of_earnings: theDeceased.income.multiplier
        });
    },
    rpiTable: function rpiTable() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'rpi/load-all');
    },
    rpiCurrent: function rpiCurrent() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'rpi/current');
    },
    pslaTable: function pslaTable() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'psla/table', null, false);
    },
    pslaAwards: function pslaAwards() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'psla/awards');
    },
    servicesMultiplier: function servicesMultiplier(theDeceased, claimantName, issueOfProceedings, services, preTrial, discountRate) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'services/multiplier', {
            person: {
                name: theDeceased.name,
                gender: theDeceased.gender.toLowerCase(),
                date_of_birth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(theDeceased.dateOfBirth),
                date_of_death: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(theDeceased.dateOfDeath)
            },
            claim: {
                claimant_name: claimantName,
                assumed_settlement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(issueOfProceedings)
            },
            discount_rate: discountRate,
            multipliers: services.map(function (service) {
                return {
                    discount_table: service.discountTable,
                    value: service.multiplicand || 0,
                    period_of_dependency: parseFloat(service.duration) - parseFloat(preTrial)
                };
            }),
            loss_of_earnings: theDeceased.income.multiplier
        });
    },
    servicesTable: function servicesTable(theDeceased, claimantName, issueOfProceedings, services, preTrial, discountRate, discountTable) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'services/table', {
            person: {
                name: theDeceased.name,
                gender: theDeceased.gender.toLowerCase(),
                date_of_birth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(theDeceased.dateOfBirth),
                date_of_death: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(theDeceased.dateOfDeath)
            },
            claim: {
                claimant_name: claimantName,
                assumed_settlement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(issueOfProceedings)
            },
            discount_rate: discountRate,
            discount_table: discountTable,
            multipliers: services.map(function (service) {
                return {
                    discount_table: service.discountTable,
                    value: service.multiplicand || 0,
                    period_of_dependency: parseFloat(service.duration)
                };
            })
        });
    },
    interest: function interest(preLitOrLit, assumedSettlement, serviceOfProceedings, onsetOfSymptoms, lifeExpectancy, deductibles, headsOfLoss, interim) {

        var interest = {
            pastDependencyOnIncomeInterest: headsOfLoss.pastDependencyOnIncomeInterest,
            pastDependencyOnServicesInterest: headsOfLoss.pastDependencyOnServicesInterest,
            generalDamagesInterest: headsOfLoss.generalDamagesInterest,
            bereavementAwardInterest: headsOfLoss.bereavementAwardInterest,
            funeralExpensesInterest: headsOfLoss.funeralExpensesInterest,
            lossOfSpouseInterest: headsOfLoss.lossOfSpouseInterest,
            pastCostOfCareInterest: headsOfLoss.pastCostOfCareInterest,
            futureCostOfCareInterest: headsOfLoss.futureCostOfCareInterest,
            pastCostOfTravelInterest: headsOfLoss.pastCostOfTravelInterest,
            pastLossOfEarningsInterest: headsOfLoss.pastLossOfEarningsInterest,
            miscInterest: headsOfLoss.miscInterest,
            pastCostOfServicesInterest: headsOfLoss.pastCostOfServicesInterest,
            pastReducedEarningsInterest: headsOfLoss.pastReducedEarningsInterest
        };

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'interest', {
            claim: {
                assumed_settlement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(assumedSettlement),
                service_of_proceedings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(serviceOfProceedings),
                type: preLitOrLit
            },
            deceased: {
                onset_of_symptoms: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(onsetOfSymptoms)
            },
            deductibles: deductibles,
            heads_of_loss: {
                generalDamages: headsOfLoss.generalDamages,
                pastDependencyOnIncome: headsOfLoss.pastDependencyOnIncome,
                pastDependencyOnServices: headsOfLoss.pastDependencyOnServices,
                bereavementAward: headsOfLoss.bereavementAward,
                funeralExpenses: headsOfLoss.funeralExpenses,
                lossOfSpouse: headsOfLoss.lossOfSpouse,
                pastLossOfEarnings: headsOfLoss.pastLossOfEarnings,
                pastCostOfCare: headsOfLoss.pastCostOfCare,
                futureCostOfCare: headsOfLoss.futureCostOfCare,
                pastCostOfTravel: headsOfLoss.pastCostOfTravel,
                misc: headsOfLoss.misc,
                pastCostOfServices: headsOfLoss.pastCostOfServices,
                pastReducedEarnings: headsOfLoss.pastReducedEarnings
            },
            interest: interest,
            interestPeriod: {
                type: headsOfLoss.interestType,
                value: headsOfLoss.customInterestDate
            },
            interimPayments: interim,
            custom_heads_of_loss: headsOfLoss.customHeadsOfLoss ? headsOfLoss.customHeadsOfLoss : headsOfLoss.headsOfLoss
        });
    },
    customInterest: function customInterest(assumedSettlement, onsetOfSymptoms, assumedDateOfDeath, customHeadsOfLoss) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'custom-interest', {
            claim: {
                assumed_settlement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(assumedSettlement)
            },
            deceased: {
                date_of_death: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(assumedDateOfDeath),
                onset_of_symptoms: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(onsetOfSymptoms)
            },
            custom: customHeadsOfLoss.headsOfLoss ? customHeadsOfLoss.headsOfLoss : customHeadsOfLoss.customHeadsOfLoss
        });
    },
    detailedCare: function detailedCare(care) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'care/detailed', {
            care: care
        });
    },
    autoCalculateCare: function autoCalculateCare(gratuitousCare) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'care/auto-calculate', {});
    },
    otherFutureLosses: function otherFutureLosses(period) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'calculateFutureLosses', {
            multiplicand: period.multiplicand,
            start_date: period.startDate,
            gender: period.gender,
            discount_rate: period.discountRate,
            end_date: period.endDate,
            mortality_multiplier: period.mortalityMultiplier,
            date_of_birth: period.dateOfBirth,
            assumed_settlement: period.assumedSettlement
        });
    },
    lossOfIncomeTables: function lossOfIncomeTables(claimant, assumedSettlement, discountRate) {
        var action = 'lost-years/loss-of-income';

        claimant.dateOfDeath = claimant.lifeExpectancy.dateOfDeath;
        claimant.dateOfDeathAssumed = claimant.assumedLifeExpectancy.dateOfDeath;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, action, {
            claimant: claimant,
            claim: {
                claimant_name: claimant.name,
                assumed_settlement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(assumedSettlement)
            },
            discount_rate: discountRate,
            loss_of_earnings: claimant.income.multiplier
        });
    },
    postInjuryLossOfIncomeTables: function postInjuryLossOfIncomeTables(claimant, claimInfo) {
        var action = 'personal-injury/loss-of-income';

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, action, {
            claimant: claimant,
            claim: {
                claimant_name: claimant.name,
                assumed_settlement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["d" /* dateToServer */])(claimInfo.dateOfAssumedSettlement)
            },
            claim_info: {
                discount_rate: claimInfo.discountRate,
                procedural_status: claimInfo.proceduralStatus,
                date_of_injury: claimInfo.dateOfInjury,
                date_of_assumed_settlement: claimInfo.dateOfAssumedSettlement,
                level_of_education: claimant.levelOfEducation,
                disabled_at_accident: claimant.disabledAtAccident,
                employed_at_accident: claimant.employedAtAccident,
                disabled_at_trial: claimant.disabledAtTrial,
                employed_at_trial: claimant.employedAtTrial
            }
        });
    },
    employmentContingencyDiscount: function employmentContingencyDiscount(payload) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'employment-contingency-discount', payload);
    },
    pastLossOfEarnings: function pastLossOfEarnings(payload) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'past-loss-of-earnings', payload);
    },
    miniIncome: function miniIncome(income) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'income', {
            employment_income: income.employmentIncome,
            employment_net_gross: income.employmentNetGross,
            employment_type: income.employmentType,
            end_of_period: income.endOfPeriod,
            pension_income: income.pensionIncome,
            pension_net_gross: income.pensionNetGross,
            start_of_period: income.startOfPeriod,
            retirement_date: income.retirementDate
        }).then(function (data) {
            return {
                totalGrossIncome: data.total_gross_income,
                totalNetIncome: data.total_net_income
            };
        });
    },
    postInjuryIncome: function postInjuryIncome(income, person, dateOfInjury) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'postInjuryIncome', {
            pastPeriod: {
                end_of_period: dateOfInjury,
                employment_income: income.employmentIncome,
                employment_type: income.employmentType
            },
            retirement_date: person.income.retirementDate,
            employment_income: income.employmentIncome,
            employment_type: income.employmentType,
            end_of_period: income.endOfPeriod,
            start_of_period: income.startOfPeriod,
            employment_net_gross: income.employmentNetGross
        }).then(function (data) {
            return {
                periodLoss: data.period_loss,
                totalNetIncome: data.total_net_income
            };
        });

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'income', {
            employment_income: income.employmentIncome,
            employment_net_gross: income.employmentNetGross,
            employment_type: income.employmentType,
            end_of_period: income.endOfPeriod,
            pension_income: income.pensionIncome,
            pension_net_gross: income.pensionNetGross,
            start_of_period: income.startOfPeriod,
            retirement_date: person.income.retirementDate
        }).then(function (data) {
            return {
                totalGrossIncome: data.total_gross_income,
                totalNetIncome: data.total_net_income
            };
        });
    },
    futureLossMultiplier: function futureLossMultiplier(payload) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'multipliers/future-loss', payload);
    },
    futurePurchase: function futurePurchase(purchase) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'purchase/future-purchase', {
            multiplicand: purchase.multiplicand,
            purchase_date: purchase.dateOfPurchase,
            discount_rate: purchase.discountRate,
            date_of_birth: purchase.dateOfBirth,
            assumed_settlement: purchase.assumedSettlement,
            resale_value: purchase.resaleValue,
            type: purchase.type,
            purchase_end_date: purchase.purchaseEnd,
            frequency: purchase.frequency,
            gender: purchase.gender,
            mortality_multiplier: purchase.mortalityMultiplier
        });
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESOURCE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_dashboards_discountComparison__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_dashboards_executive__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_dashboards_reserving__ = __webpack_require__(866);




var RESOURCE = 'dashboards';

/* harmony default export */ __webpack_exports__["a"] = ({
  discountComparison: __WEBPACK_IMPORTED_MODULE_0_services_api_dashboards_discountComparison__["a" /* default */],

  executive: __WEBPACK_IMPORTED_MODULE_1_services_api_dashboards_executive__["a" /* default */],

  reserving: __WEBPACK_IMPORTED_MODULE_2_services_api_dashboards_reserving__["a" /* default */]
});

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1784),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1822),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1318)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1719),
  /* scopeId */
  "data-v-64d09fe4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1830),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1707),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(1795),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(763),
  /* template */
  __webpack_require__(1743),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calculators__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(43);




var RESOURCE = 'dates';

/* harmony default export */ __webpack_exports__["a"] = ({
    lifeExpectancy: function lifeExpectancy(type, person) {
        var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1__calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'life-expectancy', {
            type: type,
            person: person,
            value: value
        }).then(function (data) {
            return {
                dateOfDeath: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* dateFromServer */])(data.date_of_death),
                ageAtDeath: data.age_at_death
            };
        });
    },

    statePensionAge: function statePensionAge(person) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1__calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'state-pension-age', {
            person: {
                date_of_birth: person.dateOfBirth,
                gender: person.gender
            }
        });
    }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);



var mutationTypes = {};

var state = {};

var getters = {};

var actions = {
  save: function save(_ref, payload) {
    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;
  },
  load: function load(_ref2, step) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootGetters = _ref2.rootGetters;
  },
  validate: function validate(_ref3, step) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootGetters = _ref3.rootGetters;
  },
  process: function process(_ref4, step) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        rootState = _ref4.rootState;
  },
  reset: function reset(_ref5, step) {
    var dispatch = _ref5.dispatch,
        rootState = _ref5.rootState;
  }
};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);




var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE'
};

var state = {
    table: [],
    awards: [],
    currentRpi: []
};

var getters = {
    getAll: function getAll(state) {
        return state;
    },
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    }
};

var actions = {
    loadTable: function loadTable(_ref) {
        var state = _ref.state,
            commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].calculators.monetary.pslaTable().then(function (returnData) {
            commit(mutationTypes.UPDATE_VALUE, { key: 'table', value: returnData });
            return returnData;
        });
    },
    loadAwards: function loadAwards(_ref2) {
        var state = _ref2.state,
            commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].calculators.monetary.pslaAwards().then(function (returnData) {
            commit(mutationTypes.UPDATE_VALUE, { key: 'awards', value: returnData });
            return returnData;
        });
    },
    loadCurrentRpi: function loadCurrentRpi(_ref3) {
        var state = _ref3.state,
            commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].calculators.monetary.rpiCurrent().then(function (returnData) {
            commit(mutationTypes.UPDATE_VALUE, { key: 'currentRpi', value: returnData });
            return returnData;
        });
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.UPDATE_VALUE, function (state, _ref4) {
    var key = _ref4.key,
        value = _ref4.value;

    __WEBPACK_IMPORTED_MODULE_2_vue___default.a.set(state, key, value);
});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1663),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1585),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1598),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1714),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(751),
  /* template */
  __webpack_require__(1785),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1305)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(789),
  /* template */
  __webpack_require__(1586),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);




var FormEvent = function FormEvent(name) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormEvent);

    this.name = name;

    for (var _len = arguments.length, payload = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        payload[_key - 1] = arguments[_key];
    }

    this.payload = payload;
};

var Listener = function Listener(name, callback) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Listener);

    this.name = name;
    this.callback = callback;
};

var Bus = function () {
    function Bus() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Bus);

        this.listeners = {};
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Bus, [{
        key: "on",
        value: function on(listener) {
            if (!this.listeners[listener.name]) {
                this.listeners[listener.name] = [];
            }
            this.listeners[listener.name].unshift(listener);
        }
    }, {
        key: "off",
        value: function off(listener) {
            var eventStack = this.listeners[listener.name];
            if (eventStack && eventStack.length) {
                eventStack.splice(eventStack.indexOf(listener), 1);
            }
        }
    }, {
        key: "trigger",
        value: function trigger(event) {
            var _this = this;

            if (!this.listeners[event.name]) {
                return;
            }
            return this.listeners[event.name].reduce(function (runNext, listener) {
                return runNext ? _this._fire(event, listener) : runNext;
            }, true);
        }
    }, {
        key: "_fire",
        value: function _fire(event, listener) {
            return listener.callback.apply(listener, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(event.payload));
        }
    }]);

    return Bus;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    bus: new Bus(),
    on: function on(eventName, callback) {
        var listener = new Listener(eventName, callback);
        this.bus.on(listener);
        return listener;
    },
    off: function off(listener) {
        return this.bus.off(listener);
    },
    trigger: function trigger(eventName) {
        for (var _len2 = arguments.length, payload = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            payload[_key2 - 1] = arguments[_key2];
        }

        return this.bus.trigger(new (Function.prototype.bind.apply(FormEvent, [null].concat([eventName], payload)))());
    }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_dependency_steps_CalculateLossAndGenerateSchedule_vue__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_dependency_steps_CalculateLossAndGenerateSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_dependency_steps_CalculateLossAndGenerateSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_dependency_steps_ClaimDetails_vue__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_dependency_steps_ClaimDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_dependency_steps_ClaimDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_dependency_steps_CruBenefits_vue__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_dependency_steps_CruBenefits_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_dependency_steps_CruBenefits_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_dependency_steps_TheDependants_vue__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_dependency_steps_TheDependants_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_dependency_steps_TheDependants_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_DependencyOnIncome_vue__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_DependencyOnIncome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_DependencyOnIncome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_dependency_steps_DependencyOnServices_vue__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_dependency_steps_DependencyOnServices_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_dependency_steps_DependencyOnServices_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_FatalAccidentClaims_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_FatalAccidentClaims_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_FatalAccidentClaims_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_dependency_DependencyClaim_vue__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_dependency_DependencyClaim_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_dependency_DependencyClaim_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_HeadsOfLossAndDependency_vue__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_HeadsOfLossAndDependency_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_HeadsOfLossAndDependency_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_dependency_steps_InterimPaymentsAndInterest_vue__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_dependency_steps_InterimPaymentsAndInterest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_dependency_steps_InterimPaymentsAndInterest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_fatal_accident_claims_dependency_steps_TheDeceased_vue__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_fatal_accident_claims_dependency_steps_TheDeceased_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_fatal_accident_claims_dependency_steps_TheDeceased_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_documents_Documents_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_documents_Documents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_documents_Documents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_documents_DocumentEditor_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_documents_DocumentEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_documents_DocumentEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_documents_DocumentList_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_documents_DocumentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_documents_DocumentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_routingMethods__ = __webpack_require__(13);

















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'fatal::dependency',
    path: 'dependency',
    component: __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_dependency_DependencyClaim_vue___default.a,
    meta: {
        claimStore: 'fatal/dependency'
    },
    beforeEnter: function beforeEnter(to, from, next) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
    },
    children: [{
        name: 'fatal::dependency.step-1',
        path: 'claim-data',
        component: __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_dependency_steps_ClaimDetails_vue___default.a,
        meta: {
            step: 1,
            name: 'Claim Data',
            store: 'claimDetails'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.step-2',
        path: 'the-deceased',
        component: __WEBPACK_IMPORTED_MODULE_11_pages_fatal_accident_claims_dependency_steps_TheDeceased_vue___default.a,
        meta: {
            step: 2,
            name: 'The Deceased',
            store: 'deceased'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.step-3',
        path: 'the-dependent',
        component: __WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_dependency_steps_TheDependants_vue___default.a,
        meta: {
            step: 3,
            name: 'The Dependants',
            store: 'dependants'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.step-4',
        path: 'dependency-on-income',
        component: __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_DependencyOnIncome_vue___default.a,
        meta: {
            step: 4,
            name: 'Dependency on Income',
            store: 'dependencyOnIncome'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.step-5',
        path: 'dependency-on-services',
        component: __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_dependency_steps_DependencyOnServices_vue___default.a,
        meta: {
            step: 5,
            name: 'Dependency on Services',
            store: 'dependencyOnServices'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.step-6',
        path: 'heads-of-loss',
        component: __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_HeadsOfLossAndDependency_vue___default.a,
        meta: {
            step: 6,
            name: 'General Damages and Past Heads of Loss',
            store: 'headsOfLoss'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.step-7',
        path: 'cru',
        component: __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_dependency_steps_CruBenefits_vue___default.a,
        meta: {
            step: 7,
            name: 'CRU Benefits',
            store: 'cru'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.step-8',
        path: 'interim-payments-and-interest',
        component: __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_dependency_steps_InterimPaymentsAndInterest_vue___default.a,
        meta: {
            step: 8,
            name: 'Interim Payments and Interest',
            store: 'interimPayments'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.step-9',
        path: 'calculate',
        component: __WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_dependency_steps_CalculateLossAndGenerateSchedule_vue___default.a,
        meta: {
            step: 9,
            name: 'Calculate Loss and Generate Schedule',
            store: 'calculateLoss'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::dependency.documents',
        path: 'documents',
        component: __WEBPACK_IMPORTED_MODULE_12_components_documents_Documents_vue___default.a,
        meta: {
            step: 10,
            name: 'Documents',
            store: 'documents'
        },
        children: [{
            name: 'fatal::dependency.documents.list',
            path: 'list',
            component: __WEBPACK_IMPORTED_MODULE_14_components_documents_DocumentList_vue___default.a,
            meta: {
                step: 10,
                name: 'List'
            }
        }, {
            name: 'fatal::dependency.documents.editor',
            path: 'editor/:document_id(\\d+)',

            component: __WEBPACK_IMPORTED_MODULE_13_components_documents_DocumentEditor_vue___default.a,
            meta: {
                step: 10,
                name: 'Editor'
            }
        }]
    }]
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_estate_steps_CalculateLossAndGenerateSchedule_vue__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_estate_steps_CalculateLossAndGenerateSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_estate_steps_CalculateLossAndGenerateSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_estate_steps_ClaimDetails_vue__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_estate_steps_ClaimDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_estate_steps_ClaimDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_estate_steps_CruBenefits_vue__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_estate_steps_CruBenefits_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_estate_steps_CruBenefits_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_FatalAccidentClaims_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_FatalAccidentClaims_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_FatalAccidentClaims_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_estate_EstateClaim_vue__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_estate_EstateClaim_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_estate_EstateClaim_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_estate_steps_HeadsOfLossAndPastLossOfEarnings_vue__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_estate_steps_HeadsOfLossAndPastLossOfEarnings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_estate_steps_HeadsOfLossAndPastLossOfEarnings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_estate_steps_InterimPaymentsAndInterest_vue__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_estate_steps_InterimPaymentsAndInterest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_estate_steps_InterimPaymentsAndInterest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_estate_steps_TheDeceased_vue__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_estate_steps_TheDeceased_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_estate_steps_TheDeceased_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_documents_Documents_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_documents_Documents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_documents_Documents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_documents_DocumentEditor_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_documents_DocumentEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_documents_DocumentEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentList_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_routingMethods__ = __webpack_require__(13);














/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'fatal::estate',
    path: 'estate',
    component: __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_estate_EstateClaim_vue___default.a,
    meta: {
        claimStore: 'fatal/estate'
    },
    beforeEnter: function beforeEnter(to, from, next) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
    },
    children: [{
        name: 'fatal::estate.step-1',
        path: 'claim-data',
        component: __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_estate_steps_ClaimDetails_vue___default.a,
        meta: {
            step: 1,
            name: 'Claim Data',
            store: 'claimDetails'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::estate.step-2',
        path: 'the-deceased',
        component: __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_estate_steps_TheDeceased_vue___default.a,
        meta: {
            step: 2,
            name: 'The Deceased',
            store: 'deceased'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::estate.step-3',
        path: 'heads-of-loss',
        component: __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_estate_steps_HeadsOfLossAndPastLossOfEarnings_vue___default.a,
        meta: {
            step: 3,
            name: 'Heads of Loss',
            store: 'headsOfLoss'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::estate.step-4',
        path: 'cru',
        component: __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_estate_steps_CruBenefits_vue___default.a,
        meta: {
            step: 4,
            name: 'CRU Benefits',
            store: 'cru'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::estate.step-5',
        path: 'interim-payments-and-interest',
        component: __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_estate_steps_InterimPaymentsAndInterest_vue___default.a,
        meta: {
            step: 5,
            name: 'Interim Payments and Interest',
            store: 'interimPayments'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::estate.step-6',
        path: 'calculate',
        component: __WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_estate_steps_CalculateLossAndGenerateSchedule_vue___default.a,
        meta: {
            step: 6,
            name: 'Calculate Loss and Generate Schedule',
            store: 'calculateLoss'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'fatal::estate.documents',
        path: 'documents',
        component: __WEBPACK_IMPORTED_MODULE_9_components_documents_Documents_vue___default.a,
        meta: {
            step: 10,
            name: 'Documents',
            store: 'documents'
        },
        children: [{
            name: 'fatal::estate.documents.list',
            path: 'list',
            component: __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentList_vue___default.a,
            meta: {
                step: 10,
                name: 'List'
            }
        }, {
            name: 'fatal::estate.documents.editor',
            path: 'editor/:document_id(\\d+)',

            component: __WEBPACK_IMPORTED_MODULE_10_components_documents_DocumentEditor_vue___default.a,
            meta: {
                step: 10,
                name: 'Editor'
            }
        }]
    }]
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_lost_years_claims_LostYearsClaims_vue__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_lost_years_claims_LostYearsClaims_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_lost_years_claims_LostYearsClaims_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_lost_years_claims_steps_ClaimantDetails_vue__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_lost_years_claims_steps_ClaimantDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_lost_years_claims_steps_ClaimantDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_lost_years_claims_steps_ClaimInfo_vue__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_lost_years_claims_steps_ClaimInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_lost_years_claims_steps_ClaimInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_lost_years_claims_steps_IncomeInformation_vue__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_lost_years_claims_steps_IncomeInformation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_lost_years_claims_steps_IncomeInformation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_lost_years_claims_steps_LossOfIncome_vue__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_lost_years_claims_steps_LossOfIncome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_lost_years_claims_steps_LossOfIncome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_lost_years_claims_steps_HeadsOfLoss_vue__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_lost_years_claims_steps_HeadsOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_lost_years_claims_steps_HeadsOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_lost_years_claims_steps_CruBenefits_vue__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_lost_years_claims_steps_CruBenefits_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_lost_years_claims_steps_CruBenefits_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_lost_years_claims_steps_InterimPayments_vue__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_lost_years_claims_steps_InterimPayments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_lost_years_claims_steps_InterimPayments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_lost_years_claims_steps_CalculateLoss_vue__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_lost_years_claims_steps_CalculateLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_lost_years_claims_steps_CalculateLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_documents_Documents_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_documents_Documents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_documents_Documents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_documents_DocumentEditor_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_documents_DocumentEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_documents_DocumentEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentList_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_routingMethods__ = __webpack_require__(13);














/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'lost',
    path: '/lost-years/:id(\\d+)?',
    beforeEnter: function beforeEnter(to, from, next) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
    },
    component: __WEBPACK_IMPORTED_MODULE_0_pages_lost_years_claims_LostYearsClaims_vue___default.a,
    meta: {
        claimStore: 'lost'
    },
    children: [{
        name: 'lost::step-1',
        path: 'claimant-details',
        component: __WEBPACK_IMPORTED_MODULE_1_pages_lost_years_claims_steps_ClaimantDetails_vue___default.a,
        meta: {
            step: 1,
            name: 'Claimant Details',
            store: 'claimant'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'lost::step-2',
        path: 'claim-info',
        component: __WEBPACK_IMPORTED_MODULE_2_pages_lost_years_claims_steps_ClaimInfo_vue___default.a,
        meta: {
            step: 2,
            name: 'Claim Info',
            store: 'claimInfo'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'lost::step-3',
        path: 'income-information',
        component: __WEBPACK_IMPORTED_MODULE_3_pages_lost_years_claims_steps_IncomeInformation_vue___default.a,
        meta: {
            step: 3,
            name: 'Income Information',
            store: 'incomeInformation'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'lost::step-4',
        path: 'loss-of-income',
        component: __WEBPACK_IMPORTED_MODULE_4_pages_lost_years_claims_steps_LossOfIncome_vue___default.a,
        meta: {
            step: 4,
            name: 'Loss of Income',
            store: 'lossOfIncome'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'lost::step-5',
        path: 'other-heads-of-loss',
        component: __WEBPACK_IMPORTED_MODULE_5_pages_lost_years_claims_steps_HeadsOfLoss_vue___default.a,
        meta: {
            step: 5,
            name: 'Other Heads of Loss',
            store: 'headsOfLoss'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'lost::step-6',
        path: 'cru-benefits',
        component: __WEBPACK_IMPORTED_MODULE_6_pages_lost_years_claims_steps_CruBenefits_vue___default.a,
        meta: {
            step: 6,
            name: 'CRU Benefits',
            store: 'cruBenefits'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'lost::step-7',
        path: 'interim-payments',
        component: __WEBPACK_IMPORTED_MODULE_7_pages_lost_years_claims_steps_InterimPayments_vue___default.a,
        meta: {
            step: 7,
            name: 'Interim Payments and Interest',
            store: 'interimPayments'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'lost::step-8',
        path: 'calculate-loss',
        component: __WEBPACK_IMPORTED_MODULE_8_pages_lost_years_claims_steps_CalculateLoss_vue___default.a,
        meta: {
            step: 8,
            name: 'Calculate Loss and Generate Schedule',
            store: 'calculateLoss'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'lost::documents',
        path: 'documents',
        component: __WEBPACK_IMPORTED_MODULE_9_components_documents_Documents_vue___default.a,
        meta: {
            step: 10,
            name: 'Documents',
            store: 'documents'
        },
        children: [{
            name: 'lost::documents.list',
            path: 'list',
            component: __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentList_vue___default.a,
            meta: {
                step: 10,
                name: 'List'
            }
        }, {
            name: 'lost::documents.editor',
            path: 'editor/:document_id(\\d+)',
            component: __WEBPACK_IMPORTED_MODULE_10_components_documents_DocumentEditor_vue___default.a,
            meta: {
                step: 10,
                name: 'Editor'
            }
        }]
    }]
}]);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        period: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        dependant: {
            type: Number,
            default: null
        }
    },
    data: function data() {
        return {
            incomeType: 'net'
        };
    },

    computed: {
        innerPeriod: function innerPeriod() {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.period);
        },

        userValue: {
            get: function get() {
                return this.innerPeriod[this.innerPeriod.pensionIncomeType + 'PensionIncome'];
            },
            set: function set(value) {
                this.innerPeriod[this.innerPeriod.pensionIncomeType + 'PensionIncome'] = value;
                this.update();
            }
        },
        pensionType: {
            get: function get() {
                return this.innerPeriod.pensionIncomeType;
            },
            set: function set(value) {
                this.innerPeriod[value + 'PensionIncome'] = this.userValue;
                this.innerPeriod.pensionIncomeType = value;
                this.update();
            }
        },
        userIncomeType: {
            get: function get() {
                return this.incomeType;
            },
            set: function set(value) {
                this.incomeType = value;
                this.userIncomeValue = this.innerPeriod[this.incomeType + 'Income'];
            }
        },
        userIncomeValue: {
            get: function get() {
                return this.innerPeriod[this.incomeType + 'Income'];
            },
            set: function set(value) {
                this.innerPeriod[this.incomeType + 'Income'] = value;
                this.update();
            }
        }
    },
    methods: {
        update: function update() {
            this.$emit('update', {
                index: this.index,
                period: this.innerPeriod,
                dependant: this.dependant
            });
        }
    }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_calculators_ageCalculator_vue__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_calculators_ageCalculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_calculators_ageCalculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_calculators_careCalculator_vue__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_calculators_careCalculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_calculators_careCalculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_mini_calculators_calculators_dependencyMultiplicand_vue__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_mini_calculators_calculators_dependencyMultiplicand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_mini_calculators_calculators_dependencyMultiplicand_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_calculators_earnings_vue__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_calculators_earnings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_calculators_earnings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_calculators_lossOfEarnings_vue__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_calculators_lossOfEarnings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_calculators_lossOfEarnings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_calculators_inflationCalculator_vue__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_calculators_inflationCalculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_calculators_inflationCalculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_Interest_vue__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_Interest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_Interest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_mini_calculators_calculators_InterpolatedMultipliers_vue__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_mini_calculators_calculators_InterpolatedMultipliers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_mini_calculators_calculators_InterpolatedMultipliers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_lifeExpectancy_vue__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_lifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_lifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_calculators_lossOfPension_vue__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_calculators_lossOfPension_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_calculators_lossOfPension_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_MiniCalculators_vue__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_MiniCalculators_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_MiniCalculators_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mesoCalculator_vue__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mesoCalculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mesoCalculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_calculators_pension_vue__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_calculators_pension_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_calculators_pension_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_calculators_periodBetweenTwoDates_vue__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_calculators_periodBetweenTwoDates_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_calculators_periodBetweenTwoDates_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_tableDiscounts_vue__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_tableDiscounts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_tableDiscounts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_calculators_retirementAge_vue__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_calculators_retirementAge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_calculators_retirementAge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_routingMethods__ = __webpack_require__(13);


















/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'mini-calculators',
    path: '/mini-calculators',
    beforeEnter: function beforeEnter(to, from, next) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
    },
    component: __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_MiniCalculators_vue___default.a,
    meta: {
        calculatorName: 'dashboard'
    },
    children: [{
        name: 'mini-calculators::age-calculator',
        path: 'age-calculator',
        component: __WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_calculators_ageCalculator_vue___default.a,
        meta: {
            step: 1,
            name: 'Age Calculator',
            calculatorName: 'ageCalculator'
        }
    }, {
        name: 'mini-calculators::care-calculator',
        path: 'care-calculator',
        component: __WEBPACK_IMPORTED_MODULE_1_pages_mini_calculators_calculators_careCalculator_vue___default.a,
        meta: {
            step: 1,
            name: 'Care Calculator',
            calculatorName: 'careCalculator'
        }
    }, {
        name: 'mini-calculators::dependency-multiplicand',
        path: 'dependency-multiplicand',
        component: __WEBPACK_IMPORTED_MODULE_2_pages_mini_calculators_calculators_dependencyMultiplicand_vue___default.a,
        meta: {
            step: 1,
            name: 'Dependency Multiplicand',
            calculatorName: 'dependencyMultiplicand'
        }
    }, {
        name: 'mini-calculators::gross-net-earnings',
        path: 'gross-net-earnings',
        component: __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_calculators_earnings_vue___default.a,
        meta: {
            step: 1,
            name: 'Gross/Net Earnings',
            calculatorName: 'grossNetEarnings'
        }
    }, {
        name: 'mini-calculators::gross-net-pension',
        path: 'gross-net-pension',
        component: __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_calculators_pension_vue___default.a,
        meta: {
            step: 1,
            name: 'Gross/Net Pension',
            calculatorName: 'grossNetPension'
        }
    }, {
        name: 'mini-calculators::inflation-calculator',
        path: 'inflation-calculator',
        component: __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_calculators_inflationCalculator_vue___default.a,
        meta: {
            step: 1,
            name: 'Inflation Calculator',
            calculatorName: 'inflationCalculator'
        }
    }, {
        name: 'mini-calculators::interest',
        path: 'interest',
        component: __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_Interest_vue___default.a,
        meta: {
            step: 1,
            name: 'Interest Calculator',
            calculatorName: 'interest'
        }
    }, {
        name: 'mini-calculators::interpolated-multipliers',
        path: 'interpolated-multipliers',
        component: __WEBPACK_IMPORTED_MODULE_7_pages_mini_calculators_calculators_InterpolatedMultipliers_vue___default.a,
        meta: {
            step: 1,
            name: 'Interpolated Multipliers',
            calculatorName: 'interpolatedMultipliers'
        }
    }, {
        name: 'mini-calculators::life-expectancy',
        path: 'life-expectancy',
        component: __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_lifeExpectancy_vue___default.a,
        meta: {
            step: 1,
            name: 'Life Expectancy',
            calculatorName: 'lifeExpectancy'
        }
    }, {
        name: 'mini-calculators::loss-of-earnings',
        path: 'loss-of-earnings',
        component: __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_calculators_lossOfEarnings_vue___default.a,
        meta: {
            step: 1,
            name: 'Loss of Earnings',
            calculatorName: 'LossOfEarnings'
        }
    }, {
        name: 'mini-calculators::loss-of-pension',
        path: 'loss-of-pension',
        component: __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_calculators_lossOfPension_vue___default.a,
        meta: {
            step: 1,
            name: 'Loss of Pension',
            calculatorName: 'lossOfPension'
        }
    }, {
        name: 'mini-calculators::mesothelioma-psla-calculator',
        path: 'mesothelioma-psla-calculator',
        component: __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mesoCalculator_vue___default.a,
        meta: {
            step: 1,
            name: 'Mesothelioma PSLA Calculator',
            calculatorName: 'mesotheliomaPslaCalculator'
        }
    }, {
        name: 'mini-calculators::period-between-two-dates',
        path: 'period-between-two-dates',
        component: __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_calculators_periodBetweenTwoDates_vue___default.a,
        meta: {
            step: 1,
            name: 'Period Between Dates',
            calculatorName: 'periodBetweenTwoDates'
        }
    }, {
        name: 'mini-calculators::pre-and-post-assessment-discounts',
        path: 'pre-and-post-assessment-discounts',
        component: __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_tableDiscounts_vue___default.a,
        meta: {
            step: 1,
            name: 'Pre and Post Assessment Discounts',
            calculatorName: 'preAndPostAssessmentDiscounts'
        }
    }, {
        path: 'retirement-age',
        component: __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_calculators_retirementAge_vue___default.a,
        meta: {
            step: 1,
            name: 'Retirement Age Calculator',
            calculatorName: 'retirementAge'
        }
    }]
}]);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_personal_injury_claims_PersonalInjuryClaims_vue__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_personal_injury_claims_PersonalInjuryClaims_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_personal_injury_claims_PersonalInjuryClaims_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_personal_injury_claims_steps_ClaimInfo_vue__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_personal_injury_claims_steps_ClaimInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_personal_injury_claims_steps_ClaimInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_personal_injury_claims_steps_PastLossOfEarnings_vue__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_personal_injury_claims_steps_PastLossOfEarnings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_personal_injury_claims_steps_PastLossOfEarnings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_personal_injury_claims_steps_GeneralDamages_vue__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_personal_injury_claims_steps_GeneralDamages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_personal_injury_claims_steps_GeneralDamages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_personal_injury_claims_steps_CruBenefits_vue__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_personal_injury_claims_steps_CruBenefits_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_personal_injury_claims_steps_CruBenefits_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_personal_injury_claims_steps_InterimPayments_vue__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_personal_injury_claims_steps_InterimPayments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_personal_injury_claims_steps_InterimPayments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_steps_CalculateLoss_vue__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_steps_CalculateLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_steps_CalculateLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_personal_injury_claims_steps_OtherPastLosses_vue__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_personal_injury_claims_steps_OtherPastLosses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_personal_injury_claims_steps_OtherPastLosses_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_steps_OtherFutureLosses_vue__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_steps_OtherFutureLosses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_steps_OtherFutureLosses_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_FutureLosses_vue__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_FutureLosses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_FutureLosses_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_documents_Documents_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_documents_Documents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_documents_Documents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentEditor_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_documents_DocumentList_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_documents_DocumentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_documents_DocumentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_routingMethods__ = __webpack_require__(13);















/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'personal',
    path: '/personal-injury/:id(\\d+)?',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_personal_injury_claims_PersonalInjuryClaims_vue___default.a,
    meta: {
        claimStore: 'personal'
    },
    children: [{
        name: 'personal::step-1',
        path: 'claim-info',
        component: __WEBPACK_IMPORTED_MODULE_1_pages_personal_injury_claims_steps_ClaimInfo_vue___default.a,
        meta: {
            step: 1,
            name: 'Claim Info',
            store: 'claimant'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::step-2',
        path: 'general-damages',
        component: __WEBPACK_IMPORTED_MODULE_3_pages_personal_injury_claims_steps_GeneralDamages_vue___default.a,
        meta: {
            step: 2,
            name: 'General Damages (PSLA)',
            store: 'generalDamages'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::step-3',
        path: 'past-loss-of-earnings',
        component: __WEBPACK_IMPORTED_MODULE_2_pages_personal_injury_claims_steps_PastLossOfEarnings_vue___default.a,
        meta: {
            step: 3,
            name: 'Past Loss of Earnings',
            store: 'pastLossOfEarnings'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::step-4',
        path: 'other-past-losses',
        component: __WEBPACK_IMPORTED_MODULE_7_pages_personal_injury_claims_steps_OtherPastLosses_vue___default.a,
        meta: {
            step: 4,
            name: 'Other Past Losses',
            store: 'otherPastLosses'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::step-5',
        path: 'future-losses',
        component: __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_FutureLosses_vue___default.a,
        meta: {
            step: 5,
            name: 'Future Loss of Earnings',
            store: 'futureLosses'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::step-6',
        path: 'other-future-losses',
        component: __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_steps_OtherFutureLosses_vue___default.a,
        meta: {
            step: 6,
            name: 'Other Future Losses',
            store: 'otherFutureLosses'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::step-7',
        path: 'cru-benefits',
        component: __WEBPACK_IMPORTED_MODULE_4_pages_personal_injury_claims_steps_CruBenefits_vue___default.a,
        meta: {
            step: 7,
            name: 'CRU Benefits',
            store: 'cruBenefits'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::step-8',
        path: 'interim-payments',
        component: __WEBPACK_IMPORTED_MODULE_5_pages_personal_injury_claims_steps_InterimPayments_vue___default.a,
        meta: {
            step: 8,
            name: 'Interim Payments and Interest',
            store: 'interimPayments'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::step-9',
        path: 'calculate-loss',
        component: __WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_steps_CalculateLoss_vue___default.a,
        meta: {
            step: 9,
            name: 'Calculate Loss and Generate Schedule',
            store: 'calculateLoss'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
        }
    }, {
        name: 'personal::documents',
        path: 'documents',
        component: __WEBPACK_IMPORTED_MODULE_10_components_documents_Documents_vue___default.a,
        meta: {
            step: 10,
            name: 'Documents',
            store: 'documents'
        },
        children: [{
            name: 'personal::documents.list',
            path: 'list',
            component: __WEBPACK_IMPORTED_MODULE_12_components_documents_DocumentList_vue___default.a,
            meta: {
                step: 10,
                name: 'List'
            }
        }, {
            name: 'personal::documents.editor',
            path: 'editor/:document_id(\\d+)',
            component: __WEBPACK_IMPORTED_MODULE_11_components_documents_DocumentEditor_vue___default.a,
            meta: {
                step: 10,
                name: 'Editor'
            }
        }]
    }]
}]);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            selectedColumn: null,
            selectedRow: null,
            hoveredRow: null,
            hoveredColumn: null
        };
    },

    methods: {
        highlightColumn: function highlightColumn(row, column) {
            switch (true) {
                case this.selectedColumn == column && this.selectedRow == row:
                    return 'both-selected';
                    break;
                case this.selectedRow == row:
                    return 'selected--row';
                    break;
                case this.selectedColumn == column:
                    return 'selected--column';
                    break;
            }
        },
        lightHighlightColumn: function lightHighlightColumn(row, column) {
            switch (true) {
                case this.hoveredColumn == column && this.hoveredRow == row:
                    return 'both-hovered';
                    break;
                case this.hoveredRow == row:
                    return 'hovered--row';
                    break;
                case this.hoveredColumn == column:
                    return 'hovered--column';
                    break;
            }
        },
        hoverColumn: function hoverColumn(column) {
            this.hoveredColumn = column - 1;
        },
        hoverRow: function hoverRow(row) {
            this.hoveredRow = row;
        },
        selectColumn: function selectColumn(column) {
            return this.selectedColumn == column - 1 ? this.selectedColumn = null : this.selectedColumn = column - 1;
        },
        selectRow: function selectRow(row) {
            return this.selectedRow == row ? this.selectedRow = null : this.selectedRow = row;
        }
    }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__ = __webpack_require__(71);



var RESOURCE = 'multipliers';

/* harmony default export */ __webpack_exports__["a"] = ({
  tableEandF: function tableEandF(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'table-e-and-f', {
      gender: state.gender,
      pre_or_post: state.preOrPost,
      age: state.ageOfDeceased,
      date_of_death: state.dateOfDeath,
      date_of_trial: state.dateOfTrialOrCessation
    });
  },
  ogdenTableInfo: function ogdenTableInfo() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'table-info');
  },
  lookupOgdenMultiplier: function lookupOgdenMultiplier(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'lookup', data);
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESOURCE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_personalInjury_generalDamages__ = __webpack_require__(874);


var RESOURCE = 'personal-injury';

/* harmony default export */ __webpack_exports__["a"] = ({
  generalDamages: __WEBPACK_IMPORTED_MODULE_0_services_api_personalInjury_generalDamages__["a" /* default */]
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESOURCE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_resources_documents__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_resources_ogden_tables__ = __webpack_require__(876);



var RESOURCE = 'resources-and-tools';

/* harmony default export */ __webpack_exports__["a"] = ({
  documents: __WEBPACK_IMPORTED_MODULE_0_services_api_resources_documents__["a" /* default */],

  ogden: __WEBPACK_IMPORTED_MODULE_1_services_api_resources_ogden_tables__["a" /* default */]
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_modules_fatal_dependency_index__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_modules_fatal_estate_index__ = __webpack_require__(906);







var mutationTypes = {
    LOADING_CLAIM: 'LOADING_CLAIM',
    UPDATING_TABLE: 'UPDATING_TABLE',
    CHANGE_CLAIM_ID: 'CHANGE_CLAIM_ID',
    FINISHED_LOADING_CLAIM: 'FINISHED_LOADING_CLAIM'
};

var state = {
    claimId: null
};

var getters = {};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {
        dependency: __WEBPACK_IMPORTED_MODULE_4_store_modules_fatal_dependency_index__["a" /* default */],
        estate: __WEBPACK_IMPORTED_MODULE_5_store_modules_fatal_estate_index__["a" /* default */]
    }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_modules_lost_step__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_modules_lost_claimant__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_modules_lost_claimInfo__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_modules_lost_incomeInformation__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_modules_lost_lossOfIncome__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_modules_lost_headsOfLoss__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_lost_cruBenefits__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_lost_interimPayments__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_modules_lost_calculateLoss__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_lost_documents__ = __webpack_require__(158);












var claimType = 'lost_years';

var mutationTypes = {};

var state = {};

var getters = {};

var actions = {
  save: function save(_ref, payload) {
    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;

    var individualStep = rootGetters['lost/step/allSteps'][payload.step_number];

    return __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].dispatch('lost/' + individualStep.store + '/save', payload);
  },
  load: function load(_ref2, step) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootGetters = _ref2.rootGetters;

    var individualStep = rootGetters['lost/step/allSteps'][parseInt(step.step_number, 10)];

    dispatch('checkForStepStore', individualStep).then(function () {
      return __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].dispatch('lost/' + individualStep.store + '/load', step);
    });
  },
  process: function process(_ref3, step) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootState = _ref3.rootState;

    dispatch('checkForStepStore', step).then(function () {
      return __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].dispatch('lost/' + step.store + '/process', step);
    });
  },
  validate: function validate(_ref4, step) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        rootState = _ref4.rootState;

    dispatch('checkForStepStore', step).then(function () {
      return __WEBPACK_IMPORTED_MODULE_0_store_index__["a" /* default */].dispatch('lost/' + step.store + '/validate', step);
    });
  },
  reset: function reset(_ref5, step) {
    var dispatch = _ref5.dispatch,
        rootState = _ref5.rootState;

    return dispatch('checkForStepStore', step).then(function () {
      if (rootState['lost'][step.store]) {
        return dispatch('lost/' + step.store + '/reset', step, { root: true });
      }
    });
  },
  checkForStepStore: function checkForStepStore(noop, individualStep) {
    if (!individualStep.store) {
      throw { 'error': 'Step #' + individualStep.step + ' (' + individualStep.name + ') does not have a store defined in the routes meta' };
    }
  }
};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  modules: {
    step: __WEBPACK_IMPORTED_MODULE_1_store_modules_lost_step__["a" /* default */],
    claimant: __WEBPACK_IMPORTED_MODULE_2_store_modules_lost_claimant__["a" /* default */],
    claimInfo: __WEBPACK_IMPORTED_MODULE_3_store_modules_lost_claimInfo__["a" /* default */],
    incomeInformation: __WEBPACK_IMPORTED_MODULE_4_store_modules_lost_incomeInformation__["a" /* default */],
    lossOfIncome: __WEBPACK_IMPORTED_MODULE_5_store_modules_lost_lossOfIncome__["a" /* default */],
    headsOfLoss: __WEBPACK_IMPORTED_MODULE_6_store_modules_lost_headsOfLoss__["a" /* default */],
    cruBenefits: __WEBPACK_IMPORTED_MODULE_7_store_modules_lost_cruBenefits__["a" /* default */],
    interimPayments: __WEBPACK_IMPORTED_MODULE_8_store_modules_lost_interimPayments__["a" /* default */],
    calculateLoss: __WEBPACK_IMPORTED_MODULE_9_store_modules_lost_calculateLoss__["a" /* default */],
    documents: __WEBPACK_IMPORTED_MODULE_10_store_modules_lost_documents__["a" /* default */]
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);


var _mutations;





var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET'
};

var defaultPeriodTemplate = {
    periodStart: null,
    periodEnd: null,
    hoursPerDay: 1,
    rate: '',
    gratuitousCare: false,
    total: 0,
    table: [[]],
    includeLastDay: true,
    includeFirstDay: true
};

var state = {
    periods: [defaultPeriodTemplate],
    rates: {}
};

function validRequest(period) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_components_form_validator_validations__["a" /* validDate */])(period.periodStart) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_components_form_validator_validations__["a" /* validDate */])(period.periodEnd) && period.hoursPerDay > 0 && period.rate !== '' && period.periodStart < period.periodEnd && period.periodEnd > period.periodStart;
}

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    periods: function periods(state) {
        return state.periods;
    }
};

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    },

    calculatePeriodTotal: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref3, index) {
        var state = _ref3.state,
            dispatch = _ref3.dispatch;

        var period = state.periods[index];
        if (validRequest(period)) {
            __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].miniCalculators.care.findPeriods([period]).then(function (data) {
                dispatch('update', { key: 'table', value: data });
                period.table = data;
                period.total = __WEBPACK_IMPORTED_MODULE_3_lodash___default()(data[0]).reduce(function (total, item) {
                    return total + item.total;
                }, 0);
            });
        }
    }, 500),
    loadCareRates: function loadCareRates(_ref4) {
        var dispatch = _ref4.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].miniCalculators.care.careRates().then(function (data) {
            return dispatch('update', { key: 'rates', value: data });
        });
    },
    addPeriod: function addPeriod(_ref5) {
        var state = _ref5.state;

        state.periods.push({
            periodStart: null,
            periodEnd: null,
            hoursPerDay: 1,
            rate: '',
            gratuitousCare: false,
            total: 0,
            table: [[]],
            includeLastDay: true,
            includeFirstDay: true
        });
    },
    deletePeriod: function deletePeriod(_ref6, index) {
        var state = _ref6.state;

        state.periods.splice(index, 1);
    },
    updatePeriod: function updatePeriod(_ref7, _ref8) {
        var state = _ref7.state;
        var index = _ref8.index,
            value = _ref8.value;

        state.periods[index] = value;
    },
    reset: function reset(_ref9) {
        var commit = _ref9.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.periods = [];
    state.periods.push({
        periodStart: null,
        periodEnd: null,
        hoursPerDay: 1,
        rate: '',
        gratuitousCare: false,
        total: 0,
        table: [[]],
        includeLastDay: true,
        includeFirstDay: true
    });
    state.rates = {};
}), _mutations);

/* harmony default export */ __webpack_exports__["b"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1303)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1557),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1309)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1639),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1678),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1592),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1787),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1671),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1801),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1799),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1562),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1711),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1748),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1582),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1607),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1584),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1568),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1763),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1315)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1700),
  /* scopeId */
  "data-v-5714e924",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1579),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(1756),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(1644),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(1655),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(1665),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1572),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(1699),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(1733),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(788),
  /* template */
  __webpack_require__(1561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(1766),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1669),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1782),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(1629),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1697),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__myValidate__ = __webpack_require__(831);



/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_routes__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isAuthenticated__ = __webpack_require__(850);







__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var Router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_0_pages_routes__["a" /* default */]
});

Router.beforeResolve(__WEBPACK_IMPORTED_MODULE_5__isAuthenticated__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4_store__["a" /* default */], Router);

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1323)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1798),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, exports) {

module.exports = {"_args":[["axios@0.21.4","/app"]],"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_spec":"0.21.4","_where":"/app","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Navigation_vue__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Navigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RightCol_vue__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RightCol_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_RightCol_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Passport_vue__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Passport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Passport_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: { Navigation: __WEBPACK_IMPORTED_MODULE_1_components_Navigation_vue___default.a, RightCol: __WEBPACK_IMPORTED_MODULE_2_components_RightCol_vue___default.a, Modal: __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue___default.a, Passport: __WEBPACK_IMPORTED_MODULE_5_components_Passport_vue___default.a },
    data: function data() {
        return {
            heartbeatLoggedOut: false,
            ie: false,
            ieVersion: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('http', ['errorToDisplay', 'apiRouteRequestRunning', 'getMaintenanceStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('dropdown', ['dropdowns']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('user', ['getUserId', 'getStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('headerWidth', ['theCurrentHeaderWidth', 'theCurrentHeaderPosition'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('dropdown', ['close']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['heartbeat']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('windowWidth', ['updateWidth']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('headerWidth', ['updateHeaderWidth', 'updateHeaderPosition']), {
        closeClaimDropdown: function closeClaimDropdown() {
            if (this.dropdowns.name !== false) {
                this.close('Create a new claim');
            }
        },
        hideWarningIE: function hideWarningIE() {
            this.ie = false;
        }
    }),
    watch: {
        getMaintenanceStatus: function getMaintenanceStatus(value) {
            if (value === true) {
                this.$router.push({ name: 'fiveOThree' });
            }
            this.$router.push({ name: 'homepage' });
        }
    },
    mounted: function mounted() {
        var _this = this;

        var version = detectIE();

        if (version === false) {} else if (version >= 12) {} else {
            this.ie = true;
            this.ieVersion = version;
        }

        function detectIE() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            return false;
        }


        setInterval(function () {}, 15000);

        this.updateWidth(window.innerWidth);

        if (window.location.hostname === "localhost" || window.location.hostname === "quantum.bclegal") {
            return;
        }

        window.onresize = function () {
            _this.updateWidth(window.innerWidth);
            _this.updateHeaderWidth({ windowWidth: _this.theCurrentWidth });
            _this.updateHeaderPosition({ windowWidth: _this.theCurrentWidth });
        };
    }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_routingMethods__ = __webpack_require__(13);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'benefit',
    props: {
        label: String,
        cruKey: {
            type: String,
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */]],
    components: {
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/cru', {
        findValue: 'value',
        findInclude: 'include',
        allValid: 'allValid'
    }), {
        value: {
            get: function get() {
                return this.findValue(this.cruKey);
            },
            set: function set(value) {
                var _this = this;

                this.updateValue({ key: this.cruKey, value: value }).then(function () {
                    _this.include = !!value;
                    _this.updateValid();
                    _this.calcAllInterest();
                });
            }
        },
        include: {
            get: function get() {
                return this.findInclude(this.cruKey);
            },
            set: function set(value) {
                this.updateInclude({ key: this.cruKey, value: value }).then(this.updateValid(), this.calcAllInterest());
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/cru', ['updateValue', 'updateInclude']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/headsOfLoss', ['calcAllInterest']), {
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_services_routingMethods__["b" /* setStepValid */])(this.allValid);
        },
        calcValue: function calcValue() {
            this.calcAllInterest;
        }
    })
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_dropdown_CreateANewClaim_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_dropdown_CreateANewClaim_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_dropdown_CreateANewClaim_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'header-section',
    components: { dropdown: __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue___default.a, Icons: __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default.a, CreateANewClaim: __WEBPACK_IMPORTED_MODULE_4_components_dropdown_CreateANewClaim_vue___default.a },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('menu', ['isMenuOpen', 'isMobileMenuOpen', 'isMenuCollapsed']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('headerWidth', ['theCurrentHeaderWidth', 'theCurrentHeaderPosition']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('http', ['running'])),
    props: {
        title: {
            type: String,
            default: ''
        },
        loadButton: {
            type: Boolean,
            default: false
        },
        saveButton: {
            type: Boolean,
            default: false
        },
        createButton: {
            type: Boolean,
            default: false
        },
        setBorder: {
            type: Boolean,
            default: false
        },
        setPosition: {
            type: String,
            default: 'relative'
        },
        setWidth: {
            type: String,
            default: '80'
        },
        current: {
            type: Object,
            default: function _default() {}
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('dropdown', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('menu', ['updateMenu', 'updateMobileMenu', 'updateSubMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal', { resetFatal: 'reset' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('claim', ['reset', 'initialise', 'save']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/interimPayments', { resetInterimPayments: 'reset' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('windowWidth', ['updateWidth']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('headerWidth', ['updateHeaderWidth', 'updateHeaderPosition', 'setInitialHeaderWidth', 'setInitialHeaderPosition']), {
        isRoute: function isRoute(route) {
            return !!this.$route.matched.filter(function (matched) {
                return matched && (matched.path.indexOf(route) !== -1 || matched.name === route);
            }).length;
        },
        isInRoutePath: function isInRoutePath(routeName) {
            return ~this.$route.path.indexOf(routeName);
        },
        force: function force() {
            this.updateMenu(false);
            this.updateSubMenu(null);
            this.forceMenu = true;
            this.$router.push({ name: 'claims' });
        },
        saveForm: function saveForm() {
            if (!this.current || !this.current.valid) {
                return;
            }

            this.save(this.current.step - 1);
        },
        saving: function saving() {
            return this.running;
        }
    }),
    mounted: function mounted() {
        this.updateWidth(window.innerWidth);
        this.setInitialHeaderWidth({ initialWidthValue: this.setWidth });
        this.setInitialHeaderPosition({ initialPositionValue: this.setPosition });
        this.updateHeaderWidth({ windowWidth: this.theCurrentWidth });
        this.updateHeaderPosition({ windowWidth: this.theCurrentWidth });
    }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'icon-tooltip',
    props: {
        tooltipName: {
            type: String,
            default: null
        },
        tooltipText: {
            type: String,
            default: null
        },
        side: {
            type: String,
            default: null
        },
        containerWidth: {
            type: String,
            default: '26'
        },
        textWidth: {
            type: String,
            default: '200'
        },
        iconType: {
            type: String,
            default: null
        },
        noIcon: {
            type: Boolean,
            default: false
        },
        pixelOrPercent: {
            type: String,
            default: 'px'
        },
        iconColour: {
            type: String,
            default: 'm-icon--dark'
        }
    },
    data: function data() {
        return {
            tooltipVisible: false,
            hoverStyle: {}
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('windowWidth', ['updateWidth']), {
        iconEnter: function iconEnter(e) {
            if (this.tooltipText && this.theCurrentWidth > 1024 && !e.currentTarget.classList.contains('default')) {
                this.hoverStyle = {
                    cursor: 'pointer'
                };
                this.tooltipVisible = true;
            }
        },
        iconLeave: function iconLeave() {
            document.body.style.cursor = "auto";
            this.tooltipVisible = false;
        },
        isRouteByName: function isRouteByName(routeName) {
            return this.$route.name == routeName;
        }
    }),
    mounted: function mounted() {
        this.updateWidth(window.innerWidth);
    }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'quantum-icons'
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'interest-item',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_1_directives_TwoDecimalPlaces__["a" /* default */]
    },
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            required: true
        },
        uniqueId: {
            required: true
        },
        interest: {
            type: Number,
            required: true
        },
        tipName: {
            type: String,
            required: true
        },
        updates: {
            required: true
        },
        endpoint: {
            type: String,
            default: 'interest'
        },
        index: {
            default: null
        },
        payload: {
            default: null
        },
        option: {
            type: Object,
            default: null
        },
        name: {
            default: null
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        userInterest: {
            get: function get() {
                return this.interest;
            },
            set: function set(value) {
                return this.$emit('update', {
                    updates: this.updates,
                    value: value
                });
            }
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']))
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_routingMethods__ = __webpack_require__(13);



var _watch;














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'life-expectancy',
    props: ['label', 'person', 'type', 'index', 'date', 'assumed-settlement', 'dayOne', 'stepValid'],
    computed: {
        innerLifeExpectancy: function innerLifeExpectancy() {
            return this.person.lifeExpectancy;
        },
        minDateOfDeath: function minDateOfDeath() {
            if (this.person.dateOfDeath) {
                return this.person.dateOfDeath;
            }

            return this.date;
        },

        ageAtDeath: {
            get: function get() {
                return this.person.lifeExpectancy.ageAtDeath > 0 ? this.person.lifeExpectancy.ageAtDeath : null;
            },
            set: function set(value) {
                this.innerLifeExpectancy.ageAtDeath = value;
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.person.lifeExpectancy.ageAtDeath > 0 ? this.person.lifeExpectancy.dateOfDeath : null;
            }
        },
        child: {
            get: function get() {
                if (this.person.dateOfDeath || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["e" /* isStepValid */])(2)) {
                    return false;
                }
                if (__WEBPACK_IMPORTED_MODULE_8_moment___default()(this.person.dateOfBirth, "DD/MM/YYYY") > __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(21, 'years') && this.innerLifeExpectancy.method === 'years_and_months') {
                    this.innerLifeExpectancy.method = '';
                    return true;
                }
                return __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.person.dateOfBirth, "DD/MM/YYYY") > __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(21, 'years');
            }
        },
        lifeDateOfDeathOptions: function lifeDateOfDeathOptions() {
            return { type: 'date', rules: 'min:' + this.minDateOfDeath };
        },

        percentageOfNormalLifeExpectancy: {
            get: function get() {
                return this.person.lifeExpectancy.percentageOfNormalLifeExpectancy >= 0 ? this.person.lifeExpectancy.percentageOfNormalLifeExpectancy : null;
            },
            set: function set(value) {
                this.innerLifeExpectancy.percentageOfNormalLifeExpectancy = value;
            }
        },
        percentageReductionInNormalLifeExpectancy: {
            get: function get() {
                return this.person.lifeExpectancy.percentageReductionInNormalLifeExpectancy >= 0 ? this.person.lifeExpectancy.percentageReductionInNormalLifeExpectancy : null;
            },
            set: function set(value) {
                this.innerLifeExpectancy.percentageReductionInNormalLifeExpectancy = value;
            }
        },
        lifeAgeAtDeathIcon: {
            get: function get() {
                return this.innerLifeExpectancy.method === 'ogden_table' || this.innerLifeExpectancy.method === 'percentage_of_normal_life_expectancy' || this.innerLifeExpectancy.method === 'percentage_reduction_in_normal_life_expectancy' ? 'formula' : 'default';
            }
        },
        lifeExpectancyValue: {
            get: function get() {
                if (this.innerLifeExpectancy.method === 'percentage_of_normal_life_expectancy') {
                    return this.person.lifeExpectancy.percentageOfNormalLifeExpectancy;
                }

                if (this.innerLifeExpectancy.method === 'percentage_reduction_in_normal_life_expectancy') {
                    return this.person.lifeExpectancy.percentageReductionInNormalLifeExpectancy;
                }
            }
        },
        lifeExpectancyModal: {
            get: function get() {
                return {
                    type: this.type,
                    assumedSettlement: this.assumedSettlement,
                    person: this.person,
                    value: this.lifeExpectancyValue
                };
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    watch: (_watch = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'person.dateOfBirth', function personDateOfBirth() {
        this.calcAgeAtDeath();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'person.dateOfDeath', function personDateOfDeath() {
        this.calcAgeAtDeath();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'person.gender', function personGender() {
        this.calcAgeAtDeath();
    }), _watch),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        calcAgeAtDeath: function calcAgeAtDeath() {
            if (this.child && this.innerLifeExpectancy.method === 'ogden_table') {
                this.innerLifeExpectancy.method = '';
            }

            if (!this.child && (this.innerLifeExpectancy.method === 'dependent_until' || this.innerLifeExpectancy.method === '')) {
                this.innerLifeExpectancy.method = 'ogden_table';
            }

            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_components_form_validator_validations__["a" /* validDate */])(this.person.dateOfBirth)) {
                this.$emit('update', this.innerLifeExpectancy);
            }
        },
        calcChildDependentAge: function calcChildDependentAge(age) {
            switch (this.innerLifeExpectancy.method) {
                case 'dependent_until_16':
                    this.innerLifeExpectancy.child.youthCutOffAge = 16;
                    break;
                case 'dependent_until_18':
                    this.innerLifeExpectancy.child.youthCutOffAge = 18;
                    break;
                case 'dependent_until_21':
                    this.innerLifeExpectancy.child.youthCutOffAge = 21;
                    break;
                case 'dependent_until_custom':
                    this.innerLifeExpectancy.child.youthCutOffAge = this.youthCutOffAge;
                    break;
            }

            this.innerLifeExpectancy.child.youthCutOffDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.person.dateOfBirth, 'DD/MM/YYYY').add(this.innerLifeExpectancy.child.youthCutOffAge, 'years').format('DD/MM/YYYY');

            this.$emit('update', this.innerLifeExpectancy);
        },
        calcChildDependentDate: function calcChildDependentDate() {
            this.$emit('update', this.innerLifeExpectancy);
        }
    })
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_passport__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icons__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'navigation',
    components: { Icons: __WEBPACK_IMPORTED_MODULE_3_components_Icons___default.a },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_passport__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('menu', ['isMenuOpen', 'isMobileMenuOpen', 'isMenuCollapsed', 'getSubMenu', 'subMenuStatus', 'isPassportOpen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('user', ['getUserId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('http', ['running', 'apiRouteRequestRunning'])),
    data: function data() {
        return {
            forceMenu: false,
            topMenuSubMenuOpen: false,
            currentSubMenu: ''
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('menu', ['reset', 'updateMenu', 'updateMobileMenu', 'collapseMenu', 'updateSubMenu', 'updatePassportMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['logoutUser']), {
        isRoute: function isRoute(route) {
            return !!this.$route.matched.filter(function (matched) {
                return matched.path.indexOf(route) !== -1 || matched.name === route;
            }).length;
        },
        isRouteByName: function isRouteByName(routeName) {
            return this.$route.name == routeName;
        },
        force: function force() {
            this.forceMenu = true;
        },
        unforce: function unforce() {
            this.forceMenu = false;
        },
        fetchSubMenu: function fetchSubMenu(menu) {
            this.updateMenu(true);
            this.updateSubMenu(menu);
        },
        loggingOut: function loggingOut() {
            return this.apiRouteRequestRunning('/api/v1/auth/logout');
        },
        addSubClicks: function addSubClicks() {
            var _this = this;

            var clickListener = function clickListener(e) {
                if (e.currentTarget.id && _this.currentSubMenu != e.currentTarget.id + '-sub') {
                    _this.currentSubMenu = e.currentTarget.id + '-sub';
                } else {
                    _this.currentSubMenu = '';
                }
            };

            var listItems = document.querySelectorAll('.top-nav-links li');

            listItems.forEach(function (clickElement) {
                return clickElement.addEventListener('click', clickListener);
            });
        },
        goHome: function goHome() {
            this.$router.push({ name: 'homepage' });
        }
    }),
    watch: {
        getUserId: function getUserId(newId, oldId) {
            var self = this;

            setTimeout(function () {
                self.addSubClicks();
            }, 1000);

            if (!newId) {
                self.goHome();
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.reset();
        setTimeout(function () {
            _this2.addSubClicks();
        }, 1000);
    }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'number-counter',
    props: {
        values: {
            type: Array,
            default: []
        },
        speed: {
            type: Array,
            default: []
        }
    },
    watch: {
        values: function values(oldValues, newValues) {
            if (oldValues !== newValues) this.counter();
        }
    },
    methods: {
        counter: function counter() {

            var CountUp = function CountUp(target, startVal, endVal, decimals, duration, options) {

                var self = this;
                self.version = function () {
                    return '1.9.1';
                };

                self.options = {
                    useEasing: true,
                    useGrouping: true,
                    separator: ',',
                    decimal: '.',
                    easingFn: easeOutExpo,
                    formattingFn: formatNumber,
                    prefix: '',
                    suffix: '',
                    numerals: [] };

                if (options && (typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) === 'object') {
                    for (var key in self.options) {
                        if (options.hasOwnProperty(key) && options[key] !== null) {
                            self.options[key] = options[key];
                        }
                    }
                }

                if (self.options.separator === '') self.options.useGrouping = false;

                var lastTime = 0;
                var vendors = ['webkit', 'moz', 'ms', 'o'];
                for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
                    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
                    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
                }
                if (!window.requestAnimationFrame) {
                    window.requestAnimationFrame = function (callback, element) {
                        var currTime = new Date().getTime();
                        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                        var id = window.setTimeout(function () {
                            callback(currTime + timeToCall);
                        }, timeToCall);
                        lastTime = currTime + timeToCall;
                        return id;
                    };
                }
                if (!window.cancelAnimationFrame) {
                    window.cancelAnimationFrame = function (id) {
                        clearTimeout(id);
                    };
                }

                function formatNumber(num) {
                    num = num.toFixed(self.decimals);
                    num += '';
                    var x, x1, x2, rgx;
                    x = num.split('.');
                    x1 = x[0];
                    x2 = x.length > 1 ? self.options.decimal + x[1] : '';
                    rgx = /(\d+)(\d{3})/;
                    if (self.options.useGrouping) {
                        while (rgx.test(x1)) {
                            x1 = x1.replace(rgx, '$1' + self.options.separator + '$2');
                        }
                    }

                    if (self.options.numerals.length) {
                        x1 = x1.replace(/[0-9]/g, function (w) {
                            return self.options.numerals[+w];
                        });
                        x2 = x2.replace(/[0-9]/g, function (w) {
                            return self.options.numerals[+w];
                        });
                    }
                    return self.options.prefix + x1 + x2 + self.options.suffix;
                }

                function easeOutExpo(t, b, c, d) {
                    return c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b;
                }
                function ensureNumber(n) {
                    return typeof n === 'number' && !isNaN(n);
                }

                self.initialize = function () {
                    if (self.initialized) return true;

                    self.error = '';
                    self.d = typeof target === 'string' ? document.getElementById(target) : target;
                    if (!self.d) {
                        self.error = '[CountUp] target is null or undefined';
                        return false;
                    }
                    self.startVal = Number(startVal);
                    self.endVal = Number(endVal);

                    if (ensureNumber(self.startVal) && ensureNumber(self.endVal)) {
                        self.decimals = Math.max(0, decimals || 0);
                        self.dec = Math.pow(10, self.decimals);
                        self.duration = Number(duration) * 1000 || 2000;
                        self.countDown = self.startVal > self.endVal;
                        self.frameVal = self.startVal;
                        self.initialized = true;
                        return true;
                    } else {
                        self.error = '[CountUp] startVal (' + startVal + ') or endVal (' + endVal + ') is not a number';
                        return false;
                    }
                };

                self.printValue = function (value) {
                    var result = self.options.formattingFn(value);

                    if (self.d.tagName === 'INPUT') {
                        this.d.value = result;
                    } else if (self.d.tagName === 'text' || self.d.tagName === 'tspan') {
                        this.d.textContent = result;
                    } else {
                        this.d.innerHTML = result;
                    }
                };

                self.count = function (timestamp) {

                    if (!self.startTime) {
                        self.startTime = timestamp;
                    }

                    self.timestamp = timestamp;
                    var progress = timestamp - self.startTime;
                    self.remaining = self.duration - progress;

                    if (self.options.useEasing) {
                        if (self.countDown) {
                            self.frameVal = self.startVal - self.options.easingFn(progress, 0, self.startVal - self.endVal, self.duration);
                        } else {
                            self.frameVal = self.options.easingFn(progress, self.startVal, self.endVal - self.startVal, self.duration);
                        }
                    } else {
                        if (self.countDown) {
                            self.frameVal = self.startVal - (self.startVal - self.endVal) * (progress / self.duration);
                        } else {
                            self.frameVal = self.startVal + (self.endVal - self.startVal) * (progress / self.duration);
                        }
                    }

                    if (self.countDown) {
                        self.frameVal = self.frameVal < self.endVal ? self.endVal : self.frameVal;
                    } else {
                        self.frameVal = self.frameVal > self.endVal ? self.endVal : self.frameVal;
                    }

                    self.frameVal = Math.round(self.frameVal * self.dec) / self.dec;

                    self.printValue(self.frameVal);

                    if (progress < self.duration) {
                        self.rAF = requestAnimationFrame(self.count);
                    } else {
                        if (self.callback) self.callback();
                    }
                };

                self.start = function (callback) {
                    if (!self.initialize()) return;
                    self.callback = callback;
                    self.rAF = requestAnimationFrame(self.count);
                };

                self.pauseResume = function () {
                    if (!self.paused) {
                        self.paused = true;
                        cancelAnimationFrame(self.rAF);
                    } else {
                        self.paused = false;
                        delete self.startTime;
                        self.duration = self.remaining;
                        self.startVal = self.frameVal;
                        requestAnimationFrame(self.count);
                    }
                };

                self.reset = function () {
                    self.paused = false;
                    delete self.startTime;
                    self.initialized = false;
                    if (self.initialize()) {
                        cancelAnimationFrame(self.rAF);
                        self.printValue(self.startVal);
                    }
                };

                self.update = function (newEndVal) {
                    if (!self.initialize()) return;
                    newEndVal = Number(newEndVal);
                    if (!ensureNumber(newEndVal)) {
                        self.error = '[CountUp] update() - new endVal is not a number: ' + newEndVal;
                        return;
                    }
                    self.error = '';
                    if (newEndVal === self.frameVal) return;
                    cancelAnimationFrame(self.rAF);
                    self.paused = false;
                    delete self.startTime;
                    self.startVal = self.frameVal;
                    self.endVal = newEndVal;
                    self.countDown = self.startVal > self.endVal;
                    self.rAF = requestAnimationFrame(self.count);
                };

                if (self.initialize()) self.printValue(self.startVal);
            };

            for (var i = 1; i < this.values.length + 1; i++) {
                var numAnim = new CountUp("counter" + i, 0, this.values[i - 1], 0, this.speed[i - 1]);
                if (!numAnim.error) {
                    numAnim.start();
                } else {
                    console.error(numAnim.error);
                }
            }
        }
    },
    mounted: function mounted() {
        this.counter();
    }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'option-filters',
    mounted: function mounted() {
        this.init();
    },
    methods: {
        init: function init() {
            var buttonList = this.$refs.list.querySelectorAll("li");
            var buttonListATag = this.$refs.list.querySelectorAll("li a");

            buttonList.forEach(function (clickElement) {
                return clickElement.addEventListener('click', selectButton);
            });
            buttonListATag.forEach(function (clickElement) {
                return clickElement.addEventListener('click', selectButton);
            });

            function selectButton(e) {
                buttonList.forEach(function (element) {
                    element.classList.remove("m-option-filters--active");
                });
                e.currentTarget.classList.add('m-option-filters--active');
            }
        }
    }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'option-list',
    data: function data() {
        return {
            filterSelected: false
        };
    },
    props: {
        heading: {
            type: String,
            default: 'Please select'
        },
        defaultHeading: {
            type: String,
            default: ''
        },
        selectStyle: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        }
    },
    methods: {
        resetDefaultHeading: function resetDefaultHeading() {
            this.filterSelected = false;
            var currentHeading = document.querySelector(".c-option-list__heading." + this.name);
            currentHeading.innerHTML = this.defaultHeading;
        },
        updateListOptions: function updateListOptions() {
            var listOptions = document.querySelector("div.c-option-list." + this.name);
            var listOptionsAll = document.querySelectorAll("div.c-option-list");
            for (var i = 0; i < listOptionsAll.length; i++) {
                listOptionsAll[i].style.display = listOptionsAll[i].style.display === 'block' ? '' : '';
            }

            listOptions.style.display = listOptions.style.display === 'block' ? '' : 'block';

            var body = document.querySelector('body');

            body.addEventListener('click', bodyFunction);

            var currentHeadingString = 'c-option-list__heading ' + this.name;
            var currentHeading = document.querySelector(".c-option-list__heading." + this.name);

            function bodyFunction(e) {
                if (e.target.id !== 'c-option-list' && e.target.id !== 'c-option-list__parent-heading' && !e.target.classList.contains('c-option-list--select-style') && e.target.id !== 'c-option-list__arrow' && e.target.className !== undefined && e.target.className !== currentHeadingString) {
                    listOptions.style.display = "none";

                    body.removeEventListener('click', bodyFunction);
                }
            }

            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    for (var i = 0; i < listOptionsAll.length; i++) {
                        listOptionsAll[i].style.display = listOptionsAll[i].style.display === 'block' ? '' : '';
                    }
                }
            });

            var listItems = document.querySelectorAll('.c-option-list.' + this.name + ' ul li');
            var listItemsNonClick = document.querySelectorAll('.c-option-list.' + this.name + ' ul li.c-option-list__non-click');

            listItems.forEach(function (clickElement) {
                return clickElement.addEventListener('click', updateHeader);
            });

            listItemsNonClick.forEach(function (clickElement) {
                return clickElement.removeEventListener('click', updateHeader);
            });

            var thisScope = this;

            function updateHeader(e) {
                currentHeading.innerHTML = e.target.innerHTML;
                thisScope.filterSelected = true;
            }
        }
    }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'overview-box'
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'paginator',
    props: {
        pageNumbers: {
            required: true
        },
        pageNo: {
            type: Number,
            required: true
        }
    },
    methods: {
        changePage: function changePage(page) {
            this.$emit('change', page);
        }
    }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PassportIcons_vue__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_PassportIcons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_PassportIcons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_env__ = __webpack_require__(879);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'passport',
    components: { PassportIcons: __WEBPACK_IMPORTED_MODULE_1_components_PassportIcons_vue___default.a },
    data: function data() {
        return {
            initialLoad: true,
            username: '',
            password: '',
            menuOpen: false,
            timeout: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', {
        getUserId: 'getUserId',
        getUserFullName: 'getUserFullName',
        hasError: 'hasError',
        getToken: 'getLoginToken',
        isLocked: 'isLocked',
        getUserEmail: 'getUserEmail',
        hasLockedErrors: 'hasLockedErrors'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('http', ['running', 'apiRouteRequestRunning']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('menu', ['isMenuOpen', 'isMobileMenuOpen', 'isMenuCollapsed', 'getSubMenu', 'subMenuStatus', 'isPassportOpen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        passportText: function passportText() {
            return this.theCurrentWidth <= 500 ? 'login to ABC Passport' : 'login to ABC Passport to see your apps here';
        },

        passportUrl: function passportUrl() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_env__["a" /* default */])('PASSPORT_URL', 'https://passport.bc-legal.co.uk');
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('user', {
        resetErrors: 'resetErrors',
        loginTheUser: 'loginUser',
        authenticateTheUser: 'authenticateUser',
        logout: 'logoutUser',
        continueTheUser: 'continueUser',
        lockUser: 'lock'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('menu', ['updateMenu', 'updateMobileMenu', 'collapseMenu', 'updateSubMenu', 'updatePassportMenu']), {
        login: function login() {
            this.loginTheUser({ email: this.username, password: this.password });
        },
        authenticate: function authenticate() {
            if (this.getUrlParameter('authenticate')) {
                this.authenticateTheUser(this.getUrlParameter('authenticate'));
            }
        },
        continueUser: function continueUser() {
            this.continueTheUser({ email: this.getUserEmail, password: this.password });
        },
        getUrlParameter: function getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        close: function close() {
            var passportContent = document.querySelector('.p-passport__content');

            var valueArray = [{ elem: passportContent, disp: 'flex' }];

            valueArray[0].elem.style.display = valueArray[0].elem.style.display === valueArray[0].disp ? '' : valueArray[0].disp;

            this.updatePassportMenu();
        },
        passport: function passport() {
            var passportContent = document.querySelector('.p-passport__content');
            var closeIconLoggedIn = document.querySelector('.p-passport__loggedin .p-passport__icon--close');
            var closeIconLoggedOut = document.querySelector('.p-passport__loggedout .p-passport__icon--close');
            var loginTopBar = document.querySelector('.p-passport__loggedin');
            var logoutTopBar = document.querySelector('.p-passport__loggedout');
            var loginContent = document.querySelector('.p-passport__content-loggedin');
            var logoutContent = document.querySelector('.p-passport__content-loggedout');

            var buttonList = document.querySelectorAll(".p-passport__login-button, .p-passport__logout-button");
            var topbarList = document.querySelectorAll(".p-passport__logo, .p-passport__loggedin .p-passport__icon--close, .p-passport__loggedout .p-passport__icon--close");

            buttonList.forEach(function (clickElement) {
                return clickElement.addEventListener('click', loginlogout);
            });
            topbarList.forEach(function (clickElement) {
                return clickElement.addEventListener('click', topbar);
            });

            var hoverIcon = document.querySelectorAll('.p-passport__icon--app-quantum, .p-passport__icon--app-asbestos, .p-passport__icon--app-noise, .p-passport__icon--close');

            hoverIcon.forEach(function (hoverElement) {
                return hoverElement.addEventListener('mouseenter', iconEnter);
            });

            function iconEnter(event) {
                if (thisScope.theCurrentWidth >= 500) {
                    document.querySelector('.p-passport__topbar-right-label').innerHTML = event.currentTarget.id;
                }
            }

            hoverIcon.forEach(function (hoverElement) {
                return hoverElement.addEventListener('mouseleave', iconLeave);
            });

            function iconLeave(event) {
                document.querySelector('.p-passport__topbar-right-label').innerHTML = "";
            }

            var valueArray = void 0;

            var thisScope = this;

            function loginlogout() {
                valueArray = [{ elem: loginTopBar, disp: 'flex' }, { elem: logoutTopBar, disp: 'flex' }, { elem: loginContent, disp: 'flex' }, { elem: logoutContent, disp: 'none' }];
                setShowHide(valueArray);
            }

            function topbar() {
                valueArray = [{ elem: passportContent, disp: 'flex' }, { elem: closeIconLoggedIn, disp: 'flex' }, { elem: closeIconLoggedOut, disp: 'flex' }];
                setShowHide(valueArray);
                thisScope.updatePassportMenu();
            }

            function setShowHide(va) {
                for (var i = 0; i < va.length; i++) {
                    va[i].elem.style.display = va[i].elem.style.display === va[i].disp ? '' : va[i].disp;
                }
            }
        },
        loggingIn: function loggingIn() {
            return this.apiRouteRequestRunning('/api/passport/login');
        },
        loggingOut: function loggingOut() {
            return this.apiRouteRequestRunning('/api/passport/logout');
        },
        checkAuthStatus: function checkAuthStatus() {
            return this.apiRouteRequestRunning('/api/passport/authenticate');
        },
        refreshTimeout: function refreshTimeout() {
            var _this = this;

            clearTimeout(this.timeout);

            this.timeout = setTimeout(function () {
                _this.lockUser();
                _this.close();
            }, 5 * 60 * 1000);
        }
    }),
    mounted: function mounted() {
        var _this2 = this;

        this.resetErrors();
        this.passport();
        this.authenticate();

        window.addEventListener('click', function (event) {
            _this2.refreshTimeout();
        });
    }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'passport-icons'
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'progress-bar',
    props: {
        value: {
            type: Number,
            default: 0
        },
        totalValue: {
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {
            theWidth: this.value
        };
    },

    methods: {
        calculateWidth: function calculateWidth() {
            return this.value / this.totalValue * 100;
        },
        completeColor: function completeColor() {
            return this.value / this.totalValue * 100 == 100 ? '#67CFB6' : '#4A89E5';
        }
    }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_dropdown_CreateANewClaim__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_dropdown_CreateANewClaim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_dropdown_CreateANewClaim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Header_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'right-col',
    components: {
        dropdown: __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue___default.a,
        Icons: __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default.a,
        CreateANewClaim: __WEBPACK_IMPORTED_MODULE_4_components_dropdown_CreateANewClaim___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_5_components_Header_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('menu', ['isMenuOpen', 'isMobileMenuOpen', 'isMenuCollapsed']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        isHomePage: function isHomePage() {
            return this.$route.fullPath === '/';
        },
        showHeader: function showHeader() {
            var allowForPath = ['mini-calculators', 'executive-dashboard', 'reserving', 'support', 'discount-rate-comparison', 'compare'].map(this.isInRoutePath.bind(this)).every(function (isRoute) {
                return !isRoute;
            });

            return this.theCurrentWidth < 1024 || allowForPath;
        }
    }),
    watch: {
        '$route': function $route() {
            window.scrollTo(0, 0);
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('dropdown', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('menu', ['updateMenu', 'updateMobileMenu', 'updateSubMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal', { resetFatal: 'reset' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('claim', ['reset', 'initialise']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/interimPayments', { resetInterimPayments: 'reset' }), {
        isRoute: function isRoute(route) {
            return !!this.$route.matched.filter(function (matched) {
                return matched && (matched.path.indexOf(route) !== -1 || matched.name === route);
            }).length;
        },
        isInRoutePath: function isInRoutePath(routeName) {
            return ~this.$route.path.indexOf(routeName);
        },
        force: function force() {
            this.forceMenu = true;
        }
    })
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_routingMethods__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'step-button',
    props: {
        prevValid: {
            type: Boolean,
            default: true
        },
        nextValid: {
            type: Boolean,
            default: false
        }
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])('http', ['running']),
    methods: {
        next: function next() {
            if (this.nextValid) {
                this.$router.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_routingMethods__["c" /* nextStep */])().route);
            }
        },
        back: function back() {
            if (this.prevValid) {
                this.$router.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_routingMethods__["d" /* prevStep */])().route);
            }
        }
    }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'timeline',
    props: ['steps', 'current', 'stepNo', 'timelineSteps'],
    data: function data() {
        return {
            tooltipVisible: false
        };
    },
    components: {
        quantumIcons: __WEBPACK_IMPORTED_MODULE_4__Icons_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_5__IconTooltip_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        timelineText: function timelineText() {
            return this.isTimelineOpen ? 'Hide Timeline Menu' : 'Show Timeline Menu';
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('timeline', ['isTimelineOpen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('claim', { claimId: 'id' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('http', ['running']), {
        humanClaimType: {
            get: function get() {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_modules_claim__["e" /* currentHumanClaimType */])();
            }
        },
        pageTitle: {
            get: function get() {
                return 'Step ' + (this.stepNo + 1) + ' - ' + this.current.name;
            }
        },
        isDocumentView: function isDocumentView() {
            var string = this.$route.fullPath.toString();
            var substring = "list";
            return string.includes(substring);
        },
        isFinalStep: function isFinalStep() {
            var string = this.$route.fullPath.toString();
            var substring = "calculate";
            return string.includes(substring);
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('timeline', ['updateTimeline']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('claim', ['save']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('windowWidth', ['updateWidth']), {
        progressAllowed: function progressAllowed(index, step) {
            if (index <= this.stepNo) {
                return true;
            }

            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.range(index).reduce(function (allValid, index) {
                return allValid ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["e" /* isStepValid */])(index + 1) : false;
            }, true);
        },
        progressInvalid: function progressInvalid(index, step) {
            return !step.valid && index === this.stepNo && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["e" /* isStepValid */])(this.stepNo + 2);
        },
        route: function route(step) {
            var route = step.route;

            if (this.claimId) {
                route.params = { id: this.claimId };
            }

            return route;
        },
        saveForm: function saveForm() {
            if (!this.current.valid) {
                return;
            }

            this.save(this.current.step - 1);
        },
        saving: function saving() {
            return this.running;
        },
        transitionAllowed: function transitionAllowed(step) {
            if (step == this.current) {
                return true;
            }

            return step.valid || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["f" /* isStepTransitionAllowed */])(this.current.route.meta.step, step.route.meta.step);
        }
    }),
    mounted: function mounted() {
        this.updateWidth(window.innerWidth);

        var icon = document.querySelector('.c-icon-tooltip');

        icon.addEventListener('mouseenter', iconEnter);

        var thisScope = this;

        function iconEnter(event) {
            return thisScope.tooltipVisible = true;
        }

        icon.addEventListener('mouseleave', iconLeave);

        function iconLeave(event) {
            return thisScope.tooltipVisible = false;
        }
    }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'typeahead',

    props: {
        label: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            required: true
        },
        errorMessage: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        value: {
            type: Object
        }
    },

    watch: {
        value: {
            handler: function handler(val) {
                if (val === null) {
                    this.reset();
                    this.query = '';
                }
            }
        }
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */]],

    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a
    },

    data: function data() {
        return {
            src: '/api/v1/contacts/search',
            items: [],
            query: (this.value || {}).name,
            current: -1,
            loading: false,
            limit: 5,
            minChars: 1,
            selectFirst: false,
            inFocus: true
        };
    },


    computed: {
        hasItems: function hasItems() {
            if (this.inFocus == true) {
                return this.items.length > 0;
            }
        },
        isEmpty: function isEmpty() {
            return !this.query;
        },
        isDirty: function isDirty() {
            return !!this.query;
        }
    },

    created: function created() {},


    methods: {
        update: function update() {
            var _this = this;

            this.inFocus = true;

            if (!this.query) {
                this.$emit('update', { id: null, name: null, type: null });
                return this.reset();
            }

            if (this.minChars && this.query.length < this.minChars) {
                return;
            }

            this.loading = true;

            this.fetch().then(function (response) {
                if (response && _this.query) {
                    var removeDuplicates = function removeDuplicates(myArr, prop) {
                        return myArr.filter(function (obj, pos, arr) {
                            return arr.map(function (mapObj) {
                                return mapObj[prop];
                            }).indexOf(obj[prop]) === pos;
                        });
                    };

                    var data = response.data;
                    data = _this.prepareResponseData ? _this.prepareResponseData(data) : data;

                    var newData = removeDuplicates(data, 'name');

                    _this.items = _this.limit ? newData.slice(0, _this.limit) : newData;
                    _this.current = -1;
                    _this.loading = false;

                    if (_this.selectFirst) {
                        _this.down();
                    }
                }

                _this.$emit('update', { id: null, name: _this.query, type: _this.type });
            });
        },
        fetch: function fetch() {
            var _this2 = this;

            var cancel = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                return _this2.cancel = resolve;
            });
            var request = __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].contacts.search({ search: this.query, type: this.type });

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.race([cancel, request]);
        },
        reset: function reset() {
            this.inFocus = false;
            this.items = [];
            this.loading = false;

            if (this.query !== null && this.query.length > 0) {
                this.query = this.query.trim();
                this.$emit('update', { id: null, name: this.query, type: this.type });
            }
        },
        setActive: function setActive(index) {
            this.current = index;
        },
        activeClass: function activeClass(index) {
            return {
                active: this.current === index
            };
        },
        hit: function hit() {
            this.inFocus = false;
            if (this.current !== -1) {
                this.onHit(this.items[this.current]);
            }
        },
        up: function up() {
            if (this.current > 0) {
                this.current--;
            } else if (this.current === -1) {
                this.current = this.items.length - 1;
            } else {
                this.current = -1;
            }
        },
        down: function down() {
            this.inFocus = true;
            if (this.current < this.items.length - 1) {
                this.current++;
            } else {
                this.current = -1;
            }
        },
        onHit: function onHit(item) {
            this.query = item.name;
            this.$emit('update', item);
        }
    }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'accordion',
    props: {
        bodyMap: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'accordion-item',
    props: {
        hasError: {
            type: Boolean,
            default: false
        },
        keepClosed: {
            type: Boolean,
            default: false
        },
        contentPull: {
            type: Boolean,
            default: false
        },
        showOpen: {
            type: Boolean,
            default: false
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('accordion', {
        findIsOpen: 'isOpen'
    }), {
        isOpen: function isOpen() {
            return this.findIsOpen(this.index);
        }
    }),
    data: function data() {
        return {
            index: null
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('accordion', ['setOpen', 'openNext']), {
        triggerOpenNext: function triggerOpenNext() {
            if (this.showOpen && this.isOpen) {
                return this.openNext(this.index);
            }
            if (!this.isOpen) {
                return this.setOpen(this.index);
            }
        }
    }),
    created: function created() {
        var _this = this;

        this.$store.dispatch('accordion/register', this.keepClosed).then(function (index) {
            _this.index = index;
        });
    },
    destroyed: function destroyed() {
        return this.$store.dispatch('accordion/deregister', this.index);
    }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'chart-legend',
    props: {
        columns: {
            type: Number,
            default: 2
        },
        legendWidth: {
            type: Number,
            default: 70
        },
        marginTop: {
            type: String,
            default: ''
        },
        marginBottom: {
            type: String,
            default: ''
        },
        values: {},
        colours: {
            type: Array,
            default: function _default() {
                return ['#45BFFC', '#3DF2C3', '#CD5CD8', '#EB1458', '#7DD3F4', '#94F7DB', '#E18FEF', '#F94B8A', '#4A89E5', '#EA7A68', '#9A4CD9', '#BF104F', '#422960', '#007180', '#2ECE9D'];
            }
        }
    },
    watch: {
        values: function values() {
            this.render();
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth'])),
    data: function data() {
        return {
            columnOne: [],
            columnTwo: [],
            columnThree: [],
            columnOneColours: [],
            columnTwoColours: [],
            columnThreeColours: []
        };
    },
    methods: {
        render: function render() {
            this.columnOne = [];
            this.columnTwo = [];
            this.columnThree = [];
            this.columnOneColours = [];
            this.columnTwoColours = [];
            this.columnThreeColours = [];

            if (this.columns === 1) {
                for (var i = 0; i < this.values.length; i++) {
                    this.columnOne.push(this.values[i]);
                    this.columnOneColours.push(this.colours[i]);
                }
            } else if (this.columns === 3) {
                for (var i = 0; i < this.values.length; i += 3) {
                    this.columnOne.push(this.values[i]);
                    this.columnOneColours.push(this.colours[i]);
                }
                for (var i = 1; i < this.values.length; i += 3) {
                    this.columnTwo.push(this.values[i]);
                    this.columnTwoColours.push(this.colours[i]);
                }
                for (var i = 2; i < this.values.length; i += 3) {
                    this.columnThree.push(this.values[i]);
                    this.columnThreeColours.push(this.colours[i]);
                }
            } else {
                for (var i = 0; i < this.values.length; i += 2) {
                    this.columnOne.push(this.values[i]);
                    this.columnOneColours.push(this.colours[i]);
                }
                for (var i = 1; i < this.values.length; i += 2) {
                    this.columnTwo.push(this.values[i]);
                    this.columnTwoColours.push(this.colours[i]);
                }
            }
        }
    },
    mounted: function mounted() {
        this.render();
    }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_directives_TwoDecimalPlaces__ = __webpack_require__(11);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'custom-head-of-loss',
    props: ['index', 'headOfLoss', 'showInterest'],
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_mixins_percentageDifference__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_7_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('documents', {
        getDocumentDataByKey: 'getDocumentDataByKey'
    }), {
        name: {
            get: function get() {
                return this.headOfLoss.name;
            }
        },
        value: {
            get: function get() {
                return this.headOfLoss.value;
            }
        },
        interestAccrued: {
            get: function get() {
                return this.headOfLoss.interestAccrued;
            }
        },
        dependantsValue: {
            get: function get() {
                return this.getDocumentDataByKey({ key: this.headOfLoss.name, index: this.index }) || 0;
            },
            set: function set(value) {
                this.updateDataByKey({ key: this.name, value: value, index: this.index });
            }
        },
        dependantsInterestValue: {
            get: function get() {
                return this.getDocumentDataByKey({ key: this.headOfLoss.name + 'WithInterest', index: this.index }) || 0;
            },
            set: function set(value) {
                this.updateDataByKey({ key: this.name + 'WithInterest', value: value, index: this.index });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('documents', {
        updateDataByKey: 'updateDataByKey'
    }), {
        roundAndPercent: function roundAndPercent(val1, val2) {
            return this.roundValue(this.percentageDifference(val1, val2), 2);
        },
        updateTotals: function updateTotals() {
            this.$emit('update');
        }
    })
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_html5_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_documents_FatalDependencyComparisonSchedule_vue__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_documents_FatalDependencyComparisonSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_documents_FatalDependencyComparisonSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_documents_FatalEstateComparisonSchedule_vue__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_documents_FatalEstateComparisonSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_documents_FatalEstateComparisonSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_documents_LostComparisonSchedule_vue__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_documents_LostComparisonSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_documents_LostComparisonSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_documents_PersonalComparisonSchedule_vue__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_documents_PersonalComparisonSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_documents_PersonalComparisonSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_form_validator_mixin__ = __webpack_require__(9);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'editor',
    mixins: [__WEBPACK_IMPORTED_MODULE_12_components_form_validator_mixin__["a" /* default */]],
    components: {
        HtmlEditor: new __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor___default.a({
            name: "html-editor",
            hiddenModules: ['full-screen'],
            visibleModules: ["text", "color", "font", "align", "list", "tabulation", "hr", "eraser", "undo"]
        }),
        FatalDependencyComparisonSchedule: __WEBPACK_IMPORTED_MODULE_8_components_documents_FatalDependencyComparisonSchedule_vue___default.a,
        FatalEstateComparisonSchedule: __WEBPACK_IMPORTED_MODULE_9_components_documents_FatalEstateComparisonSchedule_vue___default.a,
        lostComparisonSchedule: __WEBPACK_IMPORTED_MODULE_10_components_documents_LostComparisonSchedule_vue___default.a,
        personalComparisonSchedule: __WEBPACK_IMPORTED_MODULE_11_components_documents_PersonalComparisonSchedule_vue___default.a,
        fatalIcons: __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('documents', {
        findDocument: 'getGeneratedDocument',
        getExitAllowed: 'getExitAllowed',
        showingExitNotification: 'showingExitNotification'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id',
        claimType: 'type'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('http', ['running', 'apiRouteRequestRunning']), {
        theDocument: function theDocument() {
            var theDocument = {};
            __WEBPACK_IMPORTED_MODULE_3_vue___default.a.util.extend(theDocument, this.findDocument(this.$route.params.document_id));
            return theDocument;
        },
        exitRoute: function exitRoute() {
            var params = { id: this.claimId };

            switch (this.claimType) {
                case 'fatal_accident_dependency':
                    return { name: 'fatal::dependency.documents.list', params: params };
                case 'fatal_accident_estate':
                    return { name: 'fatal::estate.documents.list', params: params };
                case 'lost_years':
                    return { name: 'lost::documents.list', params: params };
                case 'personal_injury':
                    return { name: 'personal::documents.list', params: params };
            };
        },

        documentName: {
            get: function get() {
                return this.theDocument.name;
            },
            set: function set(value) {
                this.theDocument.name = value;
                this.updateDocumentName({ value: value, index: this.$route.params.document_id });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('documents', {
        saveGeneratedDocument: 'saveGeneratedDocument',
        toggleContent: 'toggleEditingDocument',
        quitEditingDocument: 'quitEditingDocument',
        exitClosed: 'exitClosed',
        exitAttempted: 'exitAttempted',
        updateDocumentName: 'updateDocumentName'
    }), {
        updateState: function updateState() {
            this.updateDocument(this.index, this.theDocument);
        },
        updateContent: function updateContent(content) {
            this.theDocument.html = content;
        },
        saveDocument: function saveDocument() {
            this.theDocument.updated_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss');
            this.saveGeneratedDocument({ index: this.index, document: this.theDocument });
        },
        saveAndClose: function saveAndClose() {
            var _this = this;

            this.theDocument.updated_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss');
            this.saveGeneratedDocument({ index: this.index, document: this.theDocument }).then(function () {
                return _this.$router.push(_this.exitRoute);
            });
        },
        savingData: function savingData() {
            return this.apiRouteRequestRunning('/api/v1/generated-documents/save');
        }
    })
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_documents_Icons_vue__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_documents_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_documents_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_documents_DocumentEditor_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_documents_DocumentEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_documents_DocumentEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'documents',
    data: function data() {
        return {
            discountRate: null,
            documentType: '',
            filter: false,
            filterOptions: {
                comparison_schedule: true,
                schedule_of_loss: true,
                offer_letter: true
            },
            pagination: {},
            offset: 4,
            documents: []
        };
    },
    created: function created() {
        this.getGeneratedDocumentsFromServer({
            claimId: this.claimId,
            page: 1,
            filter: this.filterOptions
        });
    },
    mounted: function mounted() {
        this.pagination = this.getPagination;
        this.discountRate = this.discountRateForDocument();
    },

    components: {
        fatalIcons: __WEBPACK_IMPORTED_MODULE_2_components_documents_Icons_vue___default.a,
        DocumentEditor: __WEBPACK_IMPORTED_MODULE_3_components_documents_DocumentEditor_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_6_components_IconTooltip_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id',
        claimType: 'type'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('documents', {
        getGeneratedDocuments: 'getGeneratedDocuments',
        getEditingDocument: 'getEditingDocument',
        requesting: 'getRequestStatus',
        findDocument: 'getGeneratedDocument',
        getPagination: 'getPagination'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('http', ['running', 'apiRouteRequestRunning']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('lost/claimant', {
        getLostYearsDiscountRate: 'getClaimantInfoValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/claimant', {
        getPersonalInjuryDiscountRate: 'getClaimInfo'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', {
        getDependencyDiscountRate: 'discountRate'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/estate/claimDetails', {
        getEstateDiscountRate: 'discountRate'
    }), {
        isActive: function isActive() {
            return this.pagination.current_page;
        },
        pageNumbers: function pageNumbers() {
            if (!this.pagination.to) {
                return [];
            }
            var from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            var to = from + this.offset * 2;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            var pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('documents', {
        toggleContent: 'toggleEditingDocument',
        createGeneratedDocument: 'createGeneratedDocument',
        deleteGeneratedDocument: 'deleteGeneratedDocument',
        getGeneratedDocumentsFromServer: 'getGeneratedDocumentsFromServer'
    }), {
        changePage: function changePage(page) {
            this.pagination.current_page = page;
            this.getGeneratedDocumentsFromServer({
                claimId: this.claimId,
                page: this.pagination.current_page,
                filter: this.filterOptions
            });
        },
        filterDocuments: function filterDocuments() {
            this.pagination.current_page = 1;
            this.getGeneratedDocumentsFromServer({
                claimId: this.claimId,
                page: this.pagination.current_page,
                filter: this.filterOptions
            });
        },
        toggleFilter: function toggleFilter() {
            this.filter = !this.filter;
        },

        createDocument: _.debounce(function (e) {
            this.createGeneratedDocument({
                claimId: this.claimId,
                claimType: __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['claim/type'],
                type: this.documentType,
                discountRate: this.discountRate
            });
        }, 500),
        deleteDocument: function deleteDocument(document) {
            if (this.requesting) {
                return;
            }
            this.deleteGeneratedDocument(document);
        },
        discountRateForDocument: function discountRateForDocument() {
            switch (this.claimType) {
                case 'fatal_accident_dependency':
                    return this.getDependencyDiscountRate;
                case 'fatal_accident_estate':
                    return this.getEstateDiscountRate;
                case 'lost_years':
                    return this.getLostYearsDiscountRate('discountRate');
                case 'personal_injury':
                    return this.getPersonalInjuryDiscountRate('discountRate');
            }
        },
        updateDiscountRate: function updateDiscountRate(event) {
            this.discountRate = event.target.value;
        },
        formatDate: function formatDate(dateStr) {
            return __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateStr).format('DD/MM/YYYY HH:mm');
        }
    })
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_documents_DocumentEditor_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_documents_DocumentEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_documents_DocumentEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_index__ = __webpack_require__(15);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'documents',
    components: {
        DocumentEditor: __WEBPACK_IMPORTED_MODULE_2_components_documents_DocumentEditor_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id',
        claimType: 'type'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('http', ['running', 'apiRouteRequestRunning'])),
    methods: {}
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);













var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'fatal-dependency-comparison-schedule',
    mounted: function mounted() {
        this.getMoveableHeadsOfLoss({
            claimId: this.claimId,
            discountRate: this.findDocument(this.index).discount_rate
        });
    },

    props: ['document', 'index'],
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_dateFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_percentageDifference__["a" /* default */]],
    components: {
        customHeadOfLoss: __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id',
        claimType: 'type'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', {
        headOfLoss: 'value',
        totalInterest: 'totalInterest',
        customHeadsOfLoss: 'headsOfLoss'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnIncome', {
        incomePre: 'preDependencyValue',
        incomePost: 'postDependencyValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnServices', {
        servicePre: 'preDependencyValue',
        servicePost: 'postDependencyValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('documents', {
        getDocumentDataByKey: 'getDocumentDataByKey',
        findDocument: 'getGeneratedDocument',
        getEditingDocument: 'getEditingDocument',
        getShowInterest: 'getShowInterest',
        getHeadsOfLoss: 'getHeadsOfLoss'
    }), {
        pastDependencyOnIncome: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnIncome', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnIncome', value: value, index: this.index });
            }
        },
        pastDependencyOnIncomeInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnIncomeWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnIncomeWithInterest', value: value, index: this.index });
            }
        },
        futureDependencyOnIncome: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureDependencyOnIncome', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureDependencyOnIncome', value: value, index: this.index });
            }
        },
        pastDependencyOnServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServices', value: value, index: this.index });
            }
        },
        pastDependencyOnServicesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServicesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServicesWithInterest', value: value, index: this.index });
            }
        },
        futureDependencyOnServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureDependencyOnServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureDependencyOnServices', value: value, index: this.index });
            }
        },
        generalDamages: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'generalDamages', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'generalDamages', value: value, index: this.index });
            }
        },
        generalDamagesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'generalDamagesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'generalDamagesWithInterest', value: value, index: this.index });
            }
        },
        bereavementAward: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'bereavementAward', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'bereavementAward', value: value, index: this.index });
            }
        },
        bereavementAwardInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'bereavementAwardWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'bereavementAwardWithInterest', value: value, index: this.index });
            }
        },
        funeralExpenses: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'funeralExpenses', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'funeralExpenses', value: value, index: this.index });
            }
        },
        funeralExpensesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'funeralExpensesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'funeralExpensesWithInterest', value: value, index: this.index });
            }
        },
        lossOfSpouse: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'lossOfSpouse', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'lossOfSpouse', value: value, index: this.index });
            }
        },
        lossOfSpouseInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'lossOfSpouseWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'lossOfSpouseWithInterest', value: value, index: this.index });
            }
        },
        pastLossOfEarnings: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastLossOfEarnings', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastLossOfEarnings', value: value, index: this.index });
            }
        },
        pastLossOfEarningsInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastLossOfEarningsWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastLossOfEarningsWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfTravel: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfTravel', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfTravel', value: value, index: this.index });
            }
        },
        pastCostOfTravelInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfTravelWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfTravelWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfCare: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfCare', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfCare', value: value, index: this.index });
            }
        },
        pastCostOfCareInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfCareWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfCareWithInterest', value: value, index: this.index });
            }
        },
        misc: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'misc', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'misc', value: value, index: this.index });
            }
        },
        miscInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'miscWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'miscWithInterest', value: value, index: this.index });
            }
        },
        interest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'interest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'interest', value: value, index: this.index });
            }
        },
        showInterest: {
            get: function get() {
                return this.getShowInterest(this.index);
            },
            set: function set(value) {
                this.updateShowInterest({ index: this.index });
            }
        },
        headsOfLossTotal: function headsOfLossTotal() {
            return numberVal(this.headOfLoss('pastDependencyOnIncome')) + numberVal(this.headOfLoss('pastDependencyOnServices')) + numberVal(this.headOfLoss('generalDamages')) + numberVal(this.headOfLoss('bereavementAward')) + numberVal(this.headOfLoss('lossOfSpouse')) + numberVal(this.headOfLoss('pastLossOfEarnings')) + numberVal(this.headOfLoss('pastCostOfTravel')) + numberVal(this.headOfLoss('funeralExpenses')) + numberVal(this.headOfLoss('pastCostOfCare')) + numberVal(this.headOfLoss('misc')) + numberVal(this.servicePost) + numberVal(this.incomePost) + numberVal(this.calcCustomHeadsOfLoss) + numberVal(this.calcInterest);
        },
        calcCustomHeadsOfLoss: function calcCustomHeadsOfLoss() {
            var total = 0;
            if (this.customHeadsOfLoss) {
                this.customHeadsOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.value);
                });
            }
            return total;
        },
        calcInterest: function calcInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return numberVal(this.headOfLoss('pastDependencyOnIncomeWithInterest')) + numberVal(this.headOfLoss('pastDependencyOnServicesWithInterest')) + numberVal(this.headOfLoss('generalDamagesWithInterest')) + numberVal(this.headOfLoss('bereavementAwardWithInterest')) + numberVal(this.headOfLoss('lossOfSpouseWithInterest')) + numberVal(this.headOfLoss('pastLossOfEarningsWithInterest')) + numberVal(this.headOfLoss('pastCostOfTravelWithInterest')) + numberVal(this.headOfLoss('funeralExpensesWithInterest')) + numberVal(this.headOfLoss('pastCostOfCareWithInterest')) + numberVal(this.headOfLoss('miscWithInterest')) + numberVal(this.calcCustomHeadsOfLossInterest);
        },
        calcCustomHeadsOfLossInterest: function calcCustomHeadsOfLossInterest() {
            var total = 0;
            if (this.customHeadsOfLoss) {
                this.customHeadsOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.interestAccrued);
                });
            }
            return total;
        },
        dependantsHeadsOfLossTotal: function dependantsHeadsOfLossTotal() {
            return numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnIncome', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnServices', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'generalDamages', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'bereavementAward', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'lossOfSpouse', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastLossOfEarnings', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfTravel', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'funeralExpenses', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfCare', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'misc', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureDependencyOnServices', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureDependencyOnIncome', index: this.index })) + numberVal(this.dependantsHeadsOfLossInterest) + numberVal(this.calcCustomDependantsHeadsOfLoss);
        },
        dependantsHeadsOfLossInterest: function dependantsHeadsOfLossInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnIncomeInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnServicesInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'generalDamagesWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'bereavementAwardWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'lossOfSpouseWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastLossOfEarningsWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfTravelWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnServicesWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnIncomeWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'funeralExpensesWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfCareWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'miscWithInterest', index: this.index })) + numberVal(this.calcCustomDependantsHeadsOfLossInterest);
        },
        calcCustomDependantsHeadsOfLoss: function calcCustomDependantsHeadsOfLoss() {
            var _this = this;

            var total = 0;
            if (this.customHeadsOfLoss) {
                var index = this.index;
                this.customHeadsOfLoss.forEach(function (customHead) {
                    total = total + numberVal(_this.getDocumentDataByKey({ key: customHead.name, index: index }));
                });
            }
            return total;
        },
        calcCustomDependantsHeadsOfLossInterest: function calcCustomDependantsHeadsOfLossInterest() {
            var _this2 = this;

            var total = 0;
            if (this.customHeadsOfLoss) {
                var index = this.index;
                this.customHeadsOfLoss.forEach(function (customHead) {
                    total = total + numberVal(_this2.getDocumentDataByKey({
                        key: customHead.name + 'WithInterest',
                        index: index
                    }));
                });
            }
            return total;
        },
        differenceTotal: function differenceTotal() {
            return this.headsOfLossTotal - this.dependantsHeadsOfLossTotal;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('documents', {
        saveGeneratedDocument: 'saveGeneratedDocument',
        toggleContent: 'toggleEditingDocument',
        updateDataByKey: 'updateDataByKey',
        updateDocument: 'updateDocument',
        updateShowInterest: 'updateShowInterest',
        getMoveableHeadsOfLoss: 'getMoveableHeadsOfLoss'
    }), {
        saveDocument: function saveDocument() {
            this.document.updated_at = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD HH:mm:ss');
            this.saveGeneratedDocument({ index: this.index, document: this.document });
            this.toggleContent(-1);
        },
        roundAndPercent: function roundAndPercent(val1, val2) {
            return this.roundValue(this.percentageDifference(val1, val2), 2);
        },
        updateTotals: function updateTotals() {
            this.headsOfLossTotal;
            this.dependantsHeadsOfLossTotal;
            this.differenceTotal;
        }
    })
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_documents_CustomHeadOfLoss_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_documents_CustomHeadOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_documents_CustomHeadOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);














var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'fatal-estate-comparison-schedule',
    props: ['document', 'index'],
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_dateFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_percentageDifference__["a" /* default */]],
    components: {
        customHeadOfLoss: __WEBPACK_IMPORTED_MODULE_9_components_documents_CustomHeadOfLoss_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', {
        headOfLoss: 'value',
        totalInterest: 'totalInterest',
        customHeadsOfLoss: 'headsOfLoss'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('documents', {
        getDocumentDataByKey: 'getDocumentDataByKey',
        getGeneratedDocument: 'getGeneratedDocument',
        getEditingDocument: 'getEditingDocument',
        getShowInterest: 'getShowInterest'
    }), {
        comparisonSchedule: {
            get: function get() {
                return this.document;
            }
        },
        pastDependencyOnIncome: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnIncome', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnIncome', value: value, index: this.index });
            }
        },
        pastDependencyOnIncomeInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnIncomeWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnIncomeWithInterest', value: value, index: this.index });
            }
        },
        futureDependencyOnIncome: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureDependencyOnIncome', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureDependencyOnIncome', value: value, index: this.index });
            }
        },
        pastDependencyOnServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServices', value: value, index: this.index });
            }
        },
        pastDependencyOnServicesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServicesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServicesWithInterest', value: value, index: this.index });
            }
        },
        futureDependencyOnServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureDependencyOnServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureDependencyOnServices', value: value, index: this.index });
            }
        },
        generalDamages: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'generalDamages', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'generalDamages', value: value, index: this.index });
            }
        },
        generalDamagesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'generalDamagesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'generalDamagesWithInterest', value: value, index: this.index });
            }
        },
        bereavementAward: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'bereavementAward', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'bereavementAward', value: value, index: this.index });
            }
        },
        bereavementAwardInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'bereavementAwardWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'bereavementAwardWithInterest', value: value, index: this.index });
            }
        },
        funeralExpenses: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'funeralExpenses', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'funeralExpenses', value: value, index: this.index });
            }
        },
        funeralExpensesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'funeralExpensesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'funeralExpensesWithInterest', value: value, index: this.index });
            }
        },
        lossOfSpouse: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'lossOfSpouse', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'lossOfSpouse', value: value, index: this.index });
            }
        },
        lossOfSpouseInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'lossOfSpouseWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'lossOfSpouseWithInterest', value: value, index: this.index });
            }
        },
        pastLossOfEarnings: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastLossOfEarnings', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastLossOfEarnings', value: value, index: this.index });
            }
        },
        pastLossOfEarningsInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastLossOfEarningsWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastLossOfEarningsWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfTravel: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfTravel', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfTravel', value: value, index: this.index });
            }
        },
        pastCostOfTravelInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfTravelWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfTravelWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfCare: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfCare', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfCare', value: value, index: this.index });
            }
        },
        pastCostOfCareInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfCareWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfCareWithInterest', value: value, index: this.index });
            }
        },
        misc: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'misc', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'misc', value: value, index: this.index });
            }
        },
        miscInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'miscWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'miscWithInterest', value: value, index: this.index });
            }
        },
        interest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'interest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'interest', value: value, index: this.index });
            }
        },
        showInterest: {
            get: function get() {
                return this.getShowInterest(this.index);
            },
            set: function set(value) {
                this.updateShowInterest({ index: this.index });
            }
        },
        headsOfLossTotal: function headsOfLossTotal() {
            return numberVal(this.headOfLoss('generalDamages')) + numberVal(this.headOfLoss('bereavementAward')) + numberVal(this.headOfLoss('lossOfSpouse')) + numberVal(this.headOfLoss('pastLossOfEarnings')) + numberVal(this.headOfLoss('pastCostOfTravel')) + numberVal(this.headOfLoss('funeralExpenses')) + numberVal(this.headOfLoss('pastCostOfCare')) + numberVal(this.headOfLoss('misc')) + numberVal(this.calcCustomHeadsOfLoss) + numberVal(this.calcInterest);
        },
        calcCustomHeadsOfLoss: function calcCustomHeadsOfLoss() {
            var total = 0;
            if (this.customHeadsOfLoss) {
                this.customHeadsOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.value);
                });
            }
            return total;
        },
        calcInterest: function calcInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return numberVal(this.headOfLoss('generalDamagesWithInterest')) + numberVal(this.headOfLoss('lossOfSpouseWithInterest')) + numberVal(this.headOfLoss('pastLossOfEarningsWithInterest')) + numberVal(this.headOfLoss('pastCostOfTravelWithInterest')) + numberVal(this.headOfLoss('funeralExpensesWithInterest')) + numberVal(this.headOfLoss('pastCostOfCareWithInterest')) + numberVal(this.headOfLoss('miscWithInterest')) + numberVal(this.calcCustomHeadsOfLossInterest);
        },
        calcCustomHeadsOfLossInterest: function calcCustomHeadsOfLossInterest() {
            var total = 0;
            if (this.customHeadsOfLoss) {
                this.customHeadsOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.interestAccrued);
                });
            }
            return total;
        },
        dependantsHeadsOfLossTotal: function dependantsHeadsOfLossTotal() {
            return numberVal(this.getDocumentDataByKey({ key: 'generalDamages', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'lossOfSpouse', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastLossOfEarnings', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfTravel', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'funeralExpenses', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfCare', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'misc', index: this.index })) + numberVal(this.dependantsHeadsOfLossInterest) + numberVal(this.calcCustomDependantsHeadsOfLoss);
        },
        dependantsHeadsOfLossInterest: function dependantsHeadsOfLossInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return numberVal(this.getDocumentDataByKey({ key: 'generalDamagesWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'lossOfSpouseWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastLossOfEarningsWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfTravelWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'funeralExpensesWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfCareWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'miscWithInterest', index: this.index })) + numberVal(this.calcCustomDependantsHeadsOfLossInterest);
        },
        calcCustomDependantsHeadsOfLoss: function calcCustomDependantsHeadsOfLoss() {
            var _this = this;

            var total = 0;
            if (this.customHeadsOfLoss) {
                var index = this.index;
                this.customHeadsOfLoss.forEach(function (customHead) {
                    total = total + numberVal(_this.getDocumentDataByKey({ key: customHead.name, index: index }));
                });
            }
            return total;
        },
        calcCustomDependantsHeadsOfLossInterest: function calcCustomDependantsHeadsOfLossInterest() {
            var _this2 = this;

            var total = 0;
            if (this.customHeadsOfLoss) {
                var index = this.index;
                this.customHeadsOfLoss.forEach(function (customHead) {
                    total = total + numberVal(_this2.getDocumentDataByKey({
                        key: customHead.name + 'WithInterest',
                        index: index
                    }));
                });
            }
        },
        differenceTotal: function differenceTotal() {
            return this.headsOfLossTotal - this.dependantsHeadsOfLossTotal;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('documents', {
        saveGeneratedDocument: 'saveGeneratedDocument',
        toggleContent: 'toggleEditingDocument',
        updateDataByKey: 'updateDataByKey',
        updateDocument: 'updateDocument',
        updateShowInterest: 'updateShowInterest'
    }), {
        saveDocument: function saveDocument() {
            this.document.updated_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss');
            this.saveGeneratedDocument({ index: this.index, document: this.document });
            this.toggleContent(-1);
        },
        roundAndPercent: function roundAndPercent(val1, val2) {
            return this.roundValue(this.percentageDifference(val1, val2), 2);
        },
        updateTotals: function updateTotals() {
            this.headsOfLossTotal;
            this.dependantsHeadsOfLossTotal;
            this.differenceTotal;
        }
    })
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'fatal-icons'
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);













var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'lost-comparison-schedule',
    mounted: function mounted() {
        this.getMoveableHeadsOfLoss({
            claimId: this.claimId,
            discountRate: this.findDocument(this.index).discount_rate
        });
    },

    props: ['document', 'index'],
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_dateFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_percentageDifference__["a" /* default */]],
    components: {
        customHeadOfLoss: __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id',
        claimType: 'type'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('lost/headsOfLoss', {
        getHeadsOfLossValue: 'getHeadsOfLossValue',
        customHeadOfLoss: 'getAllCustomHeadOfLoss'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('lost/lossOfIncome', ['futureLossTotal', 'pastLossTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('documents', {
        getDocumentDataByKey: 'getDocumentDataByKey',
        getGeneratedDocument: 'getGeneratedDocument',
        getEditingDocument: 'getEditingDocument',
        getShowInterest: 'getShowInterest',
        getHeadsOfLoss: 'getHeadsOfLoss',
        findDocument: 'getGeneratedDocument'
    }), {
        comparisonSchedule: {
            get: function get() {
                return this.document;
            }
        },
        generalDamages: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'generalDamages', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'generalDamages', value: value, index: this.index });
            }
        },
        generalDamagesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'generalDamagesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'generalDamagesWithInterest', value: value, index: this.index });
            }
        },
        pastDependencyOnServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServices', value: value, index: this.index });
            }
        },
        pastDependencyOnServicesWithInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServicesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServicesWithInterest', value: value, index: this.index });
            }
        },
        pastLossOfEarnings: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastLossOfEarnings', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastLossOfEarnings', value: value, index: this.index });
            }
        },
        pastLossOfEarningsInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastLossOfEarningsWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastLossOfEarningsWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfTravel: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfTravel', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfTravel', value: value, index: this.index });
            }
        },
        pastCostOfTravelInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfTravelWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfTravelWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfCare: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfCare', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfCare', value: value, index: this.index });
            }
        },
        pastCostOfCareInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfCareWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfCareWithInterest', value: value, index: this.index });
            }
        },
        misc: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'misc', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'misc', value: value, index: this.index });
            }
        },
        miscInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'miscWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'miscWithInterest', value: value, index: this.index });
            }
        },
        futureDependencyOnServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureDependencyOnServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureDependencyOnServices', value: value, index: this.index });
            }
        },
        futureLossOfEarnings: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureLossOfEarnings', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureLossOfEarnings', value: value, index: this.index });
            }
        },
        futureCostOfCare: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureCostOfCare', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureCostOfCare', value: value, index: this.index });
            }
        },
        interest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'interest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'interest', value: value, index: this.index });
            }
        },
        showInterest: {
            get: function get() {
                return this.getShowInterest(this.index);
            },
            set: function set(value) {
                this.updateShowInterest({ index: this.index });
            }
        },
        headsOfLossTotal: function headsOfLossTotal() {
            return numberVal(this.getHeadsOfLossValue('generalDamages')) + numberVal(this.pastLossTotal) + numberVal(this.getHeadsOfLossValue('pastCostOfTravel')) + numberVal(this.getHeadsOfLossValue('pastDependencyOnServices')) + numberVal(this.getHeadsOfLossValue('pastCostOfCare')) + numberVal(this.getHeadsOfLossValue('misc')) + numberVal(this.getHeadsOfLossValue('futureDependencyOnServices')) + numberVal(this.getHeadsOfLossValue('futureCostOfCare')) + numberVal(this.futureLossTotal) + numberVal(this.calcCustomHeadsOfLoss) + numberVal(this.calcInterest);
        },
        calcCustomHeadsOfLoss: function calcCustomHeadsOfLoss() {
            var total = 0;
            if (this.customHeadOfLoss) {
                this.customHeadOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.value);
                });
            }
            return total;
        },
        calcInterest: function calcInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return numberVal(this.getHeadsOfLossValue('pastDependencyOnServicesWithInterest')) + numberVal(this.getHeadsOfLossValue('pastCostOfCareWithInterest')) + numberVal(this.getHeadsOfLossValue('pastCostOfTravelWithInterest')) + numberVal(this.getHeadsOfLossValue('pastLossOfEarningsWithInterest')) + numberVal(this.getHeadsOfLossValue('miscWithInterest')) + numberVal(this.calcCustomHeadsOfLossInterest);
        },
        calcCustomHeadsOfLossInterest: function calcCustomHeadsOfLossInterest() {
            var total = 0;
            if (this.customHeadOfLoss) {
                this.customHeadOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.interestAccrued);
                });
            }
            return total;
        },
        dependantsHeadsOfLossTotal: function dependantsHeadsOfLossTotal() {
            return numberVal(this.getDocumentDataByKey({ key: 'generalDamages', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastLossOfEarnings', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnServices', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfTravel', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfCare', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'misc', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureDependencyOnServices', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureLossOfEarnings', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureCostOfCare', index: this.index })) + numberVal(this.dependantsHeadsOfLossInterest) + numberVal(this.calcCustomDependantsHeadsOfLoss);
        },
        dependantsHeadsOfLossInterest: function dependantsHeadsOfLossInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return numberVal(this.getDocumentDataByKey({
                key: 'pastDependencyOnIncomeWithInterest',
                index: this.index
            })) + numberVal(this.getDocumentDataByKey({
                key: 'pastDependencyOnServicesWithInterest',
                index: this.index
            })) + numberVal(this.getDocumentDataByKey({ key: 'generalDamagesWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastLossOfEarningsWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfTravelWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfCareWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'miscWithInterest', index: this.index })) + numberVal(this.calcCustomDependantsHeadsOfLossInterest);
        },
        calcCustomDependantsHeadsOfLoss: function calcCustomDependantsHeadsOfLoss() {
            var _this = this;

            var total = 0;
            if (this.customHeadOfLoss) {
                var index = this.index;
                this.customHeadOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(_this.getDocumentDataByKey({ key: customHead.name, index: index }));
                });
            }
            return total;
        },
        calcCustomDependantsHeadsOfLossInterest: function calcCustomDependantsHeadsOfLossInterest() {
            var _this2 = this;

            var total = 0;
            if (this.customHeadOfLoss) {
                var index = this.index;
                this.customHeadOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(_this2.getDocumentDataByKey({
                        key: customHead.name + 'WithInterest',
                        index: index
                    }));
                });
            }
            return total;
        },
        differenceTotal: function differenceTotal() {
            return this.headsOfLossTotal - this.dependantsHeadsOfLossTotal;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('documents', {
        saveGeneratedDocument: 'saveGeneratedDocument',
        toggleContent: 'toggleEditingDocument',
        updateDataByKey: 'updateDataByKey',
        updateDocument: 'updateDocument',
        updateShowInterest: 'updateShowInterest',
        getMoveableHeadsOfLoss: 'getMoveableHeadsOfLoss'
    }), {
        saveDocument: function saveDocument() {
            this.document.updated_at = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD HH:mm:ss');
            this.saveGeneratedDocument({ index: this.index, document: this.document });
            this.toggleContent(-1);
        },
        roundAndPercent: function roundAndPercent(val1, val2) {
            return this.roundValue(this.percentageDifference(val1, val2), 2);
        },
        updateTotals: function updateTotals() {
            this.headsOfLossTotal;
            this.dependantsHeadsOfLossTotal;
            this.differenceTotal;
        }
    })
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);













var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'lost-comparison-schedule',
    props: ['document', 'index'],
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_dateFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_percentageDifference__["a" /* default */]],
    components: {
        customHeadOfLoss: __WEBPACK_IMPORTED_MODULE_8_components_documents_CustomHeadOfLoss_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/generalDamages', { getGeneralDamages: 'getSubTotal' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/claimant', ['pastIncomeTotal', 'getIncomeValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/otherPastLosses', {
        getLossValue: 'value',
        getAllCustomHeadOfLoss: 'getAllCustomHeadOfLoss'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', {
        getFutureLossValue: 'value',
        getAllFutureCustomHeadOfLoss: 'getAllCustomHeadOfLoss',
        careTotal: 'careTotal',
        servicesTotal: 'servicesTotal',
        purchasesTotal: 'purchasesTotal',
        pensionValue: 'pensionValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/futureLosses', ['getLoss']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('documents', {
        getDocumentDataByKey: 'getDocumentDataByKey',
        getGeneratedDocument: 'getGeneratedDocument',
        getEditingDocument: 'getEditingDocument',
        getShowInterest: 'getShowInterest'
    }), {
        comparisonSchedule: {
            get: function get() {
                return this.document;
            }
        },
        generalDamages: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'generalDamages', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'generalDamages', value: value, index: this.index });
            }
        },
        generalDamagesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'generalDamagesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'generalDamagesWithInterest', value: value, index: this.index });
            }
        },
        pastDependencyOnServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServices', value: value, index: this.index });
            }
        },
        pastLossOfEarnings: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastLossOfEarnings', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastLossOfEarnings', value: value, index: this.index });
            }
        },
        pastLossOfEarningsInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastLossOfEarningsWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastLossOfEarningsWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfTravel: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfTravel', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfTravel', value: value, index: this.index });
            }
        },
        pastCostOfTravelInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfTravelWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfTravelWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfCare: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfCare', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfCare', value: value, index: this.index });
            }
        },
        pastCostOfServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServices', value: value, index: this.index });
            }
        },
        pastCostOfCareInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastCostOfCareWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastCostOfCareWithInterest', value: value, index: this.index });
            }
        },
        pastCostOfServicesInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'pastDependencyOnServicesWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'pastDependencyOnServicesWithInterest', value: value, index: this.index });
            }
        },
        misc: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'misc', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'misc', value: value, index: this.index });
            }
        },
        miscInterest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'miscWithInterest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'miscWithInterest', value: value, index: this.index });
            }
        },
        futureLossOfEarnings: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureLossOfEarnings', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureLossOfEarnings', value: value, index: this.index });
            }
        },
        futureCostOfCare: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureCostOfCare', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureCostOfCare', value: value, index: this.index });
            }
        },
        futureLossOfPension: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureLossOfPension', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureLossOfPension', value: value, index: this.index });
            }
        },
        futureCareTotal: {
            get: function get() {
                return this.careTotal;
            }
        },
        futureServicesTotal: {
            get: function get() {
                return this.servicesTotal;
            }
        },
        futurePensionTotal: {
            get: function get() {
                return this.pensionValue('totalLoss');
            }
        },
        futureCostOfServices: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futureCostOfServices', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futureCostOfServices', value: value, index: this.index });
            }
        },
        futurePurchases: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'futurePurchases', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'futurePurchases', value: value, index: this.index });
            }
        },
        interest: {
            get: function get() {
                return this.getDocumentDataByKey({ key: 'interest', index: this.index });
            },
            set: function set(value) {
                this.updateDataByKey({ key: 'interest', value: value, index: this.index });
            }
        },
        showInterest: {
            get: function get() {
                return this.getShowInterest(this.index);
            },
            set: function set(value) {
                this.updateShowInterest({ index: this.index });
            }
        },
        multiplier: {
            get: function get() {
                return this.getLoss('multiplier');
            }
        },
        preInjuryDiscountFactor: {
            get: function get() {
                return this.getLoss('preInjuryDiscountFactor');
            }
        },
        assessmentDiscountFactor: {
            get: function get() {
                return this.getLoss('assessmentDiscountFactor');
            }
        },
        lossResult: {
            get: function get() {
                return this.getIncomeValue('preAccidentFutureLossOfEarningsNetTotal') - this.getIncomeValue('futureLossOfEarningsNetTotal');
            }
        },
        headsOfLossTotal: function headsOfLossTotal() {
            return numberVal(this.getGeneralDamages) + numberVal(this.getIncomeValue('pastLossOfEarningsNetTotal')) + numberVal(this.getLossValue('pastCostOfTravel')) + this.calcCustomHeadsOfLoss + numberVal(this.getLossValue('pastCostOfCare')) + numberVal(this.getLossValue('pastCostOfServices')) + numberVal(this.getLossValue('misc')) + numberVal(this.futurePensionTotal) + numberVal(this.futureCareTotal) + numberVal(this.futureServicesTotal) + numberVal(this.purchasesTotal) + numberVal(this.lossResult) + this.headsOfLossInterest;
        },
        headsOfLossInterest: function headsOfLossInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return numberVal(this.getLossValue('pastLossOfEarningsWithInterest')) + numberVal(this.getLossValue('pastCostOfTravelWithInterest')) + this.calcCustomHeadsOfLossInterest + numberVal(this.getLossValue('pastCostOfCareWithInterest')) + numberVal(this.getLossValue('pastCostOfServicesWithInterest')) + numberVal(this.getLossValue('miscWithInterest'));
        },
        calcCustomHeadsOfLoss: function calcCustomHeadsOfLoss() {
            var total = 0;
            if (this.getAllCustomHeadOfLoss) {
                this.getAllCustomHeadOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.value);
                });
            }
            return total;
        },
        calcInterest: function calcInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return;
        },
        calcCustomHeadsOfLossInterest: function calcCustomHeadsOfLossInterest() {
            var total = 0;
            if (this.getAllCustomHeadOfLoss) {
                this.getAllCustomHeadOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.interestAccrued);
                });
            }
            return total;
        },
        dependantsHeadsOfLossTotal: function dependantsHeadsOfLossTotal() {
            return numberVal(this.getDocumentDataByKey({ key: 'generalDamages', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastLossOfEarnings', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfTravel', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfCare', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnServices', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'misc', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureLossOfEarnings', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureLossOfPension', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureCostOfCare', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futureCostOfServices', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'futurePurchases', index: this.index })) + numberVal(this.dependantsHeadsOfLossInterest) + numberVal(this.calcCustomDependantsHeadsOfLoss);
        },
        dependantsHeadsOfLossInterest: function dependantsHeadsOfLossInterest() {
            if (!this.showInterest) {
                return 0;
            }

            return numberVal(this.getDocumentDataByKey({ key: 'pastDependencyOnServicesWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastLossOfEarningsWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfTravelWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'pastCostOfCareWithInterest', index: this.index })) + numberVal(this.getDocumentDataByKey({ key: 'miscWithInterest', index: this.index })) + numberVal(this.calcCustomDependantsHeadsOfLossInterest);
        },
        calcCustomDependantsHeadsOfLoss: function calcCustomDependantsHeadsOfLoss() {
            var _this = this;

            var total = 0;
            if (this.getAllCustomHeadOfLoss) {
                var index = this.index;
                this.getAllCustomHeadOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(_this.getDocumentDataByKey({ key: customHead.name, index: index }));
                });
            }
            return total;
        },
        calcCustomDependantsHeadsOfLossInterest: function calcCustomDependantsHeadsOfLossInterest() {
            var _this2 = this;

            var total = 0;
            if (this.getAllCustomHeadOfLoss) {
                var index = this.index;
                this.getAllCustomHeadOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(_this2.getDocumentDataByKey({
                        key: customHead.name + 'WithInterest',
                        index: index
                    }));
                });
            }
            return total;
        },
        differenceTotal: function differenceTotal() {
            return this.headsOfLossTotal - this.dependantsHeadsOfLossTotal;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('documents', {
        saveGeneratedDocument: 'saveGeneratedDocument',
        toggleContent: 'toggleEditingDocument',
        updateDataByKey: 'updateDataByKey',
        updateDocument: 'updateDocument',
        updateShowInterest: 'updateShowInterest'
    }), {
        saveDocument: function saveDocument() {
            this.document.updated_at = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD HH:mm:ss');
            this.saveGeneratedDocument({ index: this.index, document: this.document });
            this.toggleContent(-1);
        },
        roundAndPercent: function roundAndPercent(val1, val2) {
            return this.roundValue(this.percentageDifference(val1, val2), 2);
        },
        updateTotals: function updateTotals() {
            this.headsOfLossTotal;
            this.dependantsHeadsOfLossTotal;
            this.differenceTotal;
        }
    })
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'right-col',
    components: {
        dropdown: __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue___default.a
    },
    computed: {},
    watch: {
        '$route': function $route() {
            window.scrollTo(0, 0);
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('dropdown', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('menu', ['updateMenu', 'updateMobileMenu', 'updateSubMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/dependency/claimDetails', { resetFatalDependency: 'reset' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/estate/claimDetails', { resetFatalEstate: 'reset' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('lost/claimant', { resetLost: 'reset' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('personal/claimant', { resetPersonal: 'reset' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('claim', ['reset', 'initialise']), {
        newFatalDependencyClaim: function newFatalDependencyClaim() {
            var _this = this;

            this.reset().then(function () {
                _this.resetFatalDependency();
                _this.updateMenu(true);
                _this.updateSubMenu('fatal/dependency');
            }).then(function () {
                _this.$router.push({ name: 'fatal::dependency.step-1' });
            });
        },
        newFatalEstateClaim: function newFatalEstateClaim() {
            var _this2 = this;

            this.reset().then(function () {
                _this2.resetFatalEstate();
                _this2.updateMenu(true);
                _this2.updateSubMenu('fatal/estate');
            }).then(function () {
                _this2.$router.push({ name: 'fatal::estate.step-1' });
            });
        },
        newLostClaim: function newLostClaim() {
            var _this3 = this;

            this.reset().then(function () {
                _this3.resetLost();
                _this3.updateMenu(true);
                _this3.updateSubMenu('lost');
            }).then(function () {
                _this3.initialise('lost_years');
                _this3.$router.push({ name: 'lost::step-1' });
            });
        },
        newPersonalClaim: function newPersonalClaim() {
            var _this4 = this;

            this.reset().then(function () {
                _this4.resetPersonal();
                _this4.updateMenu(true);
                _this4.updateSubMenu('personal');
            }).then(function () {
                _this4.initialise('personal_injury');
                _this4.$router.push({ name: 'personal::step-1' });
            });
        }
    })
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'dropdown',
    props: {
        dropdownName: {
            type: String,
            default: ''
        },
        isADropdown: {
            type: Boolean,
            default: false
        },
        buttonName: {
            type: String,
            default: ''
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('dropdown', ['dropdowns']), {
        isThisDropdownOpen: {
            get: function get() {
                return this.dropdowns[this.name];
            }
        }
    }),
    created: function created() {
        this.register(this.name);
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('dropdown', ['toggle', 'register', 'unregister', 'close']), {
        toggleThisDropdown: function toggleThisDropdown(message, event) {
            var _this = this;

            this.toggle(this.name);
            if (event) {
                event.preventDefault();
            }
            if (this.isThisDropdownOpen == true) {
                document.body.addEventListener('click', this.closeDropdown);
            }
            window.addEventListener('keyup', function (event) {
                document.body.removeEventListener('click', _this.closeDropdown);
                if (event.keyCode === 27 && _this.isThisDropdownOpen == true) {
                    _this.close(_this.name);
                }
            });
        },
        menuContentClicked: function menuContentClicked() {
            this.close(this.name);
        },
        closeDropdown: function closeDropdown() {
            document.body.removeEventListener('click', this.closeDropdown);
            this.close(this.name);
        }
    })
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_filter_filterTypes_InputFilter_vue__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_filter_filterTypes_InputFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_filter_filterTypes_InputFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_filter_filterTypes_MonetaryRangeFilter_vue__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_filter_filterTypes_MonetaryRangeFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_filter_filterTypes_MonetaryRangeFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_filter_filterTypes_RangeFilter_vue__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_filter_filterTypes_RangeFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_filter_filterTypes_RangeFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_filter_filterTypes_SelectFilter_vue__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_filter_filterTypes_SelectFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_filter_filterTypes_SelectFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_OptionList_vue__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_OptionList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_OptionList_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'filter-options',
    components: {
        InputFilter: __WEBPACK_IMPORTED_MODULE_0_components_filter_filterTypes_InputFilter_vue___default.a,
        MonetaryRangeFilter: __WEBPACK_IMPORTED_MODULE_1_components_filter_filterTypes_MonetaryRangeFilter_vue___default.a,
        RangeFilter: __WEBPACK_IMPORTED_MODULE_2_components_filter_filterTypes_RangeFilter_vue___default.a,
        SelectFilter: __WEBPACK_IMPORTED_MODULE_3_components_filter_filterTypes_SelectFilter_vue___default.a,
        OptionList: __WEBPACK_IMPORTED_MODULE_4_components_OptionList_vue___default.a
    },
    props: {
        title: {
            type: String,
            default: "Claim Filter"
        },
        buttonTitle: {
            type: String,
            default: "Search"
        },
        running: {
            type: Boolean,
            default: false
        },
        justAdvanced: {
            type: Boolean,
            default: false
        },

        action: {},
        reset: {},
        filter: {}
    },
    data: function data() {
        return {
            advancedSearchVisible: false,
            selectedListItem: 'hi',
            defaultFilterHeading: 'Please select a claim filter and click the add button',
            deleteBox: '',
            currentMenu: '',
            filterBoxes: [],
            show: true,
            filterCounter: 0,
            filters: {
                filterTypes: [{
                    component: 'SelectFilter',
                    name: 'claimStatus',
                    filterHeading: 'Claim Status',
                    values: {
                        'All Claims': null,
                        'Live Claims': true,
                        'Concluded Claims': false
                    }
                }, {
                    component: 'SelectFilter',
                    name: 'claimType',
                    filterHeading: 'Claim Type',
                    values: {
                        'Fatal Accident Dependency': 'fatal_accident_dependency',
                        'Fatal Accident Estate': 'fatal_accident_estate',
                        'Lost Years': 'lost_years',
                        'Personal Injury': 'personal_injury'
                    }
                }, {
                    component: 'SelectFilter',
                    filterHeading: 'Discount Rate',
                    name: 'discountRate',
                    values: {
                        '-2.00%': '-2',
                        '-1.50%': '-1.5',
                        '-1.00%': '-1',
                        '-0.75%': '-0.75',
                        '-0.50%': '-0.5',
                        '-0.25%': '-0.25',
                        '0.00%': '0',
                        '0.50%': '0.5',
                        '1.00%': '1',
                        '1.50%': '1.5',
                        '2.00%': '2',
                        '2.50%': '2.5',
                        '3.00%': '3'
                    }
                }, {
                    component: 'SelectFilter',
                    filterHeading: 'Deceased/Injured Gender',
                    name: 'gender',
                    values: {
                        'Male': 'male',
                        'Female': 'female'
                    }
                }, {
                    component: 'RangeFilter',
                    filterHeading: 'Age at Death',
                    name: 'ageAtDeath',
                    from: '',
                    to: ''
                }, {
                    component: 'SelectFilter',
                    filterHeading: 'Number of Dependants',
                    name: 'numberOfDependants',
                    values: {
                        '1': 1,
                        '2': 2,
                        '3': 3,
                        '4': 4,
                        '5': 5
                    }
                }, {
                    component: 'SelectFilter',
                    filterHeading: 'Child Dependants',
                    name: 'numberOfChildDependants',
                    values: {
                        '1': 1,
                        '2': 2,
                        '3': 3,
                        '4': 4,
                        '5': 5
                    }
                }, {
                    component: 'SelectFilter',
                    filterHeading: 'Employed at Death',
                    name: 'employedAtDeath',
                    values: {
                        'Yes': true,
                        'No': false
                    }
                }]
            }
        };
    },
    methods: {
        submit: function submit() {
            this.action(this);
        },
        doReset: function doReset() {
            this.$refs.filterInputs.forEach(function (component) {
                component.reset();
            });

            this.reset();
        },
        toggle: function toggle() {
            this.show = !this.show;
        },
        updateFilter: function updateFilter(e) {
            this.currentMenu = e.target;
        },
        advancedSearch: function advancedSearch() {
            this.reset();
            return this.advancedSearchVisible = !this.advancedSearchVisible;
        }
    },
    mounted: function mounted() {
        if (!this.action) {
            throw { 'error': 'No action prop defined for FilterOptions. Unable to handle request.' };
        }

        if (!this.reset) {
            throw { 'error': 'No reset prop defined for FilterOptions. Unable to reset for subsequent requests.' };
        }

        if (!this.filter) {
            throw { 'error': 'No filter prop defined for FilterOptions. Unable to apply filters.' };
        }

        this.filterBoxes = document.querySelectorAll('.o-filter-options__box .filterInputs');
    }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'InputFilter',
    components: { DateInput: __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput_vue___default.a },
    props: {
        filterHeading: {
            type: String,
            default: ''
        },
        pound: {
            type: Boolean,
            default: false
        },
        date: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: ''
        },

        update: {}
    },
    methods: {
        updateValue: function updateValue(event) {
            this.update({ key: this.name, value: event.target.value });
        },
        reset: function reset() {
            this.update({ key: this.name, value: null });
            this.$refs.input.value = null;
        }
    }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MonetaryRangeFilter',
    props: {
        filterHeading: {
            type: String,
            default: ''
        },
        id: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: ''
        },
        pound: {
            type: Boolean,
            default: false
        },

        update: {}
    },
    data: function data() {
        return {
            from: '',
            to: ''
        };
    },

    methods: {
        updateValue: function updateValue() {
            this.update({ key: this.name, value: [this.from, this.to] });
        },
        reset: function reset() {
            this.update({ key: this.name, value: [null, null] });
            this.$refs.inputFrom.value = null;
            this.$refs.inputTo.value = null;
        }
    }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RangeFilter',
    props: {
        filterHeading: {
            type: String,
            default: ''
        },
        id: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: ''
        },

        update: {}
    },
    data: function data() {
        return {
            from: '',
            to: ''
        };
    },

    methods: {
        updateValue: function updateValue() {
            this.update({ key: this.name, value: [this.from, this.to] });
        },
        reset: function reset() {
            this.update({ key: this.name, value: [null, null] });
            this.$refs.inputFrom.value = null;
            this.$refs.inputTo.value = null;
        }
    }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SelectFilter',
    props: {
        filterHeading: {
            type: String,
            default: ''
        },
        id: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: ''
        },
        optionValues: {
            type: Object,
            default: {}
        },

        update: {}
    },
    methods: {
        updateValue: function updateValue(event) {
            this.update({ key: this.name, value: event.target.value });
        },
        reset: function reset() {
            this.update({ key: this.name, value: null });
            this.$refs.input.value = '';
        }
    }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_claims_dashboard_components_Icons_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_claims_dashboard_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_claims_dashboard_components_Icons_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'control',
    props: {
        name: {
            type: String,
            default: ''
        },
        label: String,
        beforeAfter: {
            type: String,
            default: 'default'
        },
        tipName: {
            type: String,
            default: 'default'
        },
        tipText: String,
        tipIcon: {
            type: String,
            default: 'default'
        },
        tipIconTwo: {
            type: String,
            default: ''
        },
        tipIconThree: {
            type: String,
            default: ''
        },
        tipSide: {
            type: String,
            default: 'right'
        },
        tipShow: {
            type: Boolean,
            default: true
        },
        tipWidth: {
            type: String,
            default: ''
        },
        modalName: {
            type: String,
            default: ''
        },
        iconSpace: {
            default: true
        },
        hideTip: {
            type: Boolean,
            default: false
        },
        noFlexMargin: {
            type: Boolean,
            default: false
        },
        tableControl: {
            type: Boolean,
            default: false
        },
        verticalCentre: {
            type: Boolean,
            default: false
        },
        isRequired: {
            type: Boolean,
            default: false
        },

        endpoint: {
            type: String,
            default: null
        },

        payload: {
            default: null
        },

        option: {
            type: Object,
            default: null
        }
    },
    data: function data() {
        return {
            headsOfLossPath: null,
            customHeadsOfLossPath: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('claim', {
        claimType: 'type'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('lost/headsOfLoss', {
        getLostHeadsOfLossValue: 'getHeadsOfLossValue',
        getLostCustomHeadOfLoss: 'getCustomHeadOfLoss'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', {
        getDependencyHeadsOfLossValue: 'value',
        getDependencyCustomHeadOfLoss: 'findHeadOfLoss'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', {
        getEstateHeadsOfLossValue: 'value',
        getEstateCustomHeadOfLoss: 'findHeadOfLoss'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/otherPastLosses', {
        getPersonalHeadsOfLossValue: 'value',
        getPersonalCustomHeadOfLoss: 'getCustomHeadOfLoss'
    })),
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_3_components_IconTooltip_vue___default.a,
        claimsDashboardIcons: __WEBPACK_IMPORTED_MODULE_4_pages_claims_dashboard_components_Icons_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        toggleModal: function toggleModal() {
            this.toggle(this.modalName);

            this.setHeadsOfLossPath();
            if (this.endpoint && this.option && this.option.key !== null) {
                this.getModalContent({
                    endpoint: this.endpoint,
                    payload: this.payloadForInterest()
                });
            }

            if (this.endpoint) {
                this.getModalContent({
                    endpoint: this.endpoint,
                    payload: this.payload
                });
            }
        },
        setHeadsOfLossPath: function setHeadsOfLossPath() {
            switch (this.claimType) {
                case 'lost_years':
                    this.headsOfLossPath = 'getLostHeadsOfLossValue';
                    this.customHeadsOfLossPath = 'getLostCustomHeadOfLoss';
                    break;
                case 'fatal_accident_dependency':
                    this.headsOfLossPath = 'getDependencyHeadsOfLossValue';
                    this.customHeadsOfLossPath = 'getDependencyCustomHeadOfLoss';
                    break;
                case 'fatal_accident_estate':
                    this.headsOfLossPath = 'getEstateHeadsOfLossValue';
                    this.customHeadsOfLossPath = 'getEstateCustomHeadOfLoss';
                    break;
                case 'personal_injury':
                    this.headsOfLossPath = 'getPersonalHeadsOfLossValue';
                    this.customHeadsOfLossPath = 'getPersonalCustomHeadOfLoss';
                    break;
            }
        },
        payloadForInterest: function payloadForInterest() {
            var payload = this.payload;

            if (typeof this.option.key !== "undefined") {
                payload.headOfLoss = {
                    'type': this.option.name,
                    'value': this[this.customHeadsOfLossPath](this.option.key)['value'],
                    'interest': this[this.customHeadsOfLossPath](this.option.key)['interest']
                };
                return payload;
            }

            payload.headOfLoss = {
                'type': this.option.name,
                'value': this[this.headsOfLossPath](this.option.name),
                'interest': this[this.headsOfLossPath](this.option.name + 'Interest')
            };
            return payload;
        }
    })
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'switch-button',
    props: {
        labels: {
            type: Array
        },
        id: {
            type: Array
        },
        onDark: {
            type: Boolean
        }
    }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'value-bars',
    props: {
        button: {
            type: Boolean,
            default: false
        },
        values: {
            type: Array
        },
        onDark: {
            type: Boolean
        }
    },
    watch: {
        values: function values() {
            this.bars();
        }
    },
    methods: {
        bars: function bars() {
            var bars = this.values;
            var largest = Math.max.apply(Math, bars);
            var headings = document.querySelectorAll('.m-bars h3');

            for (var i = 1; i <= bars.length; i++) {
                var currentBar = document.querySelector(".bar" + i);
                var multiplier = i / bars.length;
                var currentBarText = document.querySelector(".bar" + i + " span");

                if (bars[0] > 0) {
                    document.querySelector('.bar' + i).style.width = bars[i - 1] / largest * 100 + '%';
                    currentBarText.style.opacity = "1";
                }

                headings[i - 1].style.display = 'block';
                currentBar.style.display = "block";
                currentBar.style.background = this.onDark == true ? "rgba(74, 137, 229, 1)" : "rgba(74, 137, 229, " + multiplier + ")";
                currentBarText.innerHTML = bars[i - 1];
            }
        }
    }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__ = __webpack_require__(23);





var DATE_CUT_OFF_YEAR = 30;

var padDate = function padDate(datePart) {
    return datePart.length === 1 ? '0' + datePart : datePart;
};

var dateParts = function dateParts(value) {
    if (~value.indexOf('/')) {
        var parts = value.split("/");
        value = parts.map(function (part, i) {
            return i < parts.length - 1 ? padDate(part) : part;
        }).join("/");
    }

    var numberValue = value.replace(/[^0-9]/g, '');

    var day = numberValue.substr(0, 2);
    var month = numberValue.substr(2, 2);
    var year = numberValue.substr(4, 4);
    return { day: day, month: month, year: year };
};

var validDateRange = function validDateRange(value, min, max) {
    var validMin = min === '' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__["a" /* validDate */])(min) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__["c" /* mDate */])(value).isSameOrBefore(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__["c" /* mDate */])(min));
    var validMax = max === '' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__["a" /* validDate */])(max) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__["c" /* mDate */])(value).isSameOrAfter(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__["c" /* mDate */])(max));

    return validMin && validMax;
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'date-input',
    props: {
        value: {
            type: String,
            default: ''
        },
        min: {
            type: String,
            default: ''
        },
        max: {
            type: String,
            default: ''
        },
        emit: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        updateValue: function updateValue(value) {
            var parts = dateParts(value);

            if (parts.year.length === 2) {
                var yearPreFix = parseInt(parts.year, 10) < DATE_CUT_OFF_YEAR ? "20" : "19";
                parts.year = yearPreFix + parts.year;
            }

            var dateStr = [parts.day.length === 2 && parts.month ? parts.day + '/' : parts.day, parts.month.length === 2 && parts.year ? parts.month + '/' : parts.month, parts.year].join('');

            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__["a" /* validDate */])(dateStr) || !validDateRange(dateStr, this.min, this.max)) {
                this.$emit('input', '');

                this.$refs.input.value = value;
                return;
            }

            this.$refs.input.value = dateStr;
            this.$emit('input', dateStr);
        }
    }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'control-error',
    props: {
        show: {
            type: Boolean,
            default: true
        }
    }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__ = __webpack_require__(23);





var DATE_CUT_OFF_YEAR = 30;

var padDate = function padDate(datePart) {
    return datePart.length === 1 ? '0' + datePart : datePart;
};

var dateParts = function dateParts(value) {
    if (~value.indexOf('/')) {
        var parts = value.split("/");
        value = parts.map(function (part, i) {
            return i < parts.length - 1 ? padDate(part) : part;
        }).join("/");
    }

    var numberValue = value.replace(/[^0-9]/g, '');

    var day = numberValue.substr(0, 2);
    var month = numberValue.substr(2, 2);
    var year = numberValue.substr(4, 4);
    return { day: day, month: month, year: year };
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'date-input',
    props: {
        value: {
            type: String,
            default: ''
        },
        emit: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        updateValue: function updateValue(value) {
            var parts = dateParts(value);

            if (parts.year.length === 2) {
                var yearPreFix = parseInt(parts.year, 10) < DATE_CUT_OFF_YEAR ? "20" : "19";
                parts.year = yearPreFix + parts.year;
            }

            var dateStr = [parts.day.length === 2 && parts.month ? parts.day + '/' : parts.day, parts.month.length === 2 && parts.year ? parts.month + '/' : parts.month, parts.year].join('');

            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_components_form_validator_validations__["a" /* validDate */])(dateStr)) {
                this.$emit('input', dateStr);

                this.$refs.input.value = value;
                return;
            }

            this.$refs.input.value = dateStr;
            this.$emit('input', dateStr);
        }
    }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'control-warning',
    props: {
        show: {
            type: Boolean,
            default: true
        }
    }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'formula',
    props: ['data']
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'heading',
    props: ['data']
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'html-string',
    props: ['data']
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'modal',
    props: {
        name: {
            type: String,
            default: '',
            required: true
        },
        noDefaultButton: {
            default: false
        },
        buttonName: {
            type: String,
            default: ''
        },
        wide: {
            type: Boolean,
            default: false
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('modal', ['modals']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('documents', ['getEditingDocument', 'getExitAllowed', 'showingExitNotification']), {
        isThisModalOpen: function isThisModalOpen() {
            return this.modals[this.name];
        }
    }),
    created: function created() {
        this.register(this.name);
    },
    mounted: function mounted() {
        var _this = this;

        window.addEventListener('keyup', function (event) {
            if (event.keyCode === 27) {
                _this.closeModal(_this.name);
            }
        });
    },
    destroyed: function destroyed() {
        this.unregister(this.name);
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle', 'register', 'unregister', 'resetModal', 'closeModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('documents', ['quitEditingDocument', 'exitAttempted', 'exitClosed']), {
        toggleThisModal: function toggleThisModal() {
            this.quitEditingDocument();
            this.toggle(this.name);
            this.resetModal();
        }
    })
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_modal_Heading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_TableData_vue__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_TableData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_TableData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Formula_vue__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Formula_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_Formula_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_HtmlString_vue__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_HtmlString_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_HtmlString_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'modal-content',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('modal', ['modalContent'])),
    components: {
        Heading: __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading_vue___default.a,
        Paragraph: __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph_vue___default.a,
        TableData: __WEBPACK_IMPORTED_MODULE_4_components_modal_TableData_vue___default.a,
        Formula: __WEBPACK_IMPORTED_MODULE_5_components_modal_Formula_vue___default.a,
        HtmlString: __WEBPACK_IMPORTED_MODULE_6_components_modal_HtmlString_vue___default.a
    }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'modal-in-the-wild',
    props: {
        modalName: {
            type: String,
            default: ''
        }
    },
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue___default.a,
        Icons: __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        toggleModal: function toggleModal() {
            this.toggle(this.modalName);
        }
    })
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'paragraph',
    props: ['data']
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'table-data',
    props: ['data']
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'warning-box',
    props: {
        modalName: {
            type: String,
            default: ''
        }
    },
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal_vue___default.a,
        Icons: __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        toggleModal: function toggleModal() {
            this.toggle(this.modalName);
        }
    })
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'cookie-policy'
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'disclaimer'
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'privacy-policy'
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'fourOFour'
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'fiveOThree'
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_policies_CookiePolicy_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_policies_CookiePolicy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_policies_CookiePolicy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_policies_Disclaimer_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_policies_Disclaimer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_policies_Disclaimer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_dropdown_Dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'homepage',
    components: {
        CookiePolicy: __WEBPACK_IMPORTED_MODULE_0_components_policies_CookiePolicy_vue___default.a,
        Disclaimer: __WEBPACK_IMPORTED_MODULE_1_components_policies_Disclaimer_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalContent_vue___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild_vue___default.a,

        HeaderSection: __WEBPACK_IMPORTED_MODULE_6_components_Header_vue___default.a
    },
    mounted: function mounted() {
        var video = document.querySelector('.v-video');
        video.style.display = 'none';
        document.querySelector('.v-image').addEventListener('click', playVideo);

        function playVideo() {
            this.style.display = 'none';
            video.style.display = 'block';
            document.querySelector('#video').play();
        }
    }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_claims_dashboard_components_Icons__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_claims_dashboard_components_Icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_claims_dashboard_components_Icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_claims_dashboard_components_Table__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_claims_dashboard_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_claims_dashboard_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modal_Modal__);










/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_6__components_modal_Modal___default.a,
        ClaimsDashboardIcons: __WEBPACK_IMPORTED_MODULE_2_pages_claims_dashboard_components_Icons___default.a,
        ClaimTable: __WEBPACK_IMPORTED_MODULE_3_pages_claims_dashboard_components_Table___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_4_components_Header_vue___default.a
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('menu', ['isMenuOpen']),
    data: function data() {
        return {
            claimToDelete: null
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('menu', ['updateMenu', 'collapseMenu', 'updateSubMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('claim', ['load', 'delete']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        loadClaimAndView: function loadClaimAndView(claim) {
            this.openSubMenu(claim.type);
            this.load({ claim: claim, router: this.$router });
        },
        deleteClaim: function deleteClaim(claim) {
            this.claimToDelete = claim;
            this.toggle('confirm_delete');
        },
        openSubMenu: function openSubMenu(type) {
            this.updateSubMenu(__WEBPACK_IMPORTED_MODULE_5_store_modules_claim__["f" /* claimTypes */][type]);
        },
        subMenu: function subMenu() {
            if (this.isMenuOpen) {
                this.updateMenu(false);
            }
        },
        performDelete: function performDelete() {
            var _this = this;

            this.delete({ claim: this.claimToDelete }).then(function () {
                _this.dismissClose();
                _this.$refs.claims.search();
            });
        },
        dismissClose: function dismissClose() {
            this.claimToDelete = null;
            this.toggle('confirm_delete');
        }
    })
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_validator_mixin__ = __webpack_require__(9);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-info',
    props: {
        claim: {
            type: Object,
            required: true
        },
        showBack: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: "Claim Info (editing)"
        }
    },
    data: function data() {
        return {
            active: !!this.claim.active,
            openDate: this.claim.open_date ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.claim.open_date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY') : __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.claim.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY'),
            closeDate: this.claim.close_date ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.claim.close_date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY') : __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('DD/MM/YYYY'),
            outcome: this.claim.outcome
        };
    },

    components: {
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_6__components_form_control_Error_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7__components_form_validator_mixin__["a" /* default */]],
    computed: {
        closedDateRules: function closedDateRules() {
            if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.closeDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.openDate, 'DD/MM/YYYY'))) {
                return true;
            }
            return false;
        }
    },
    methods: {
        close: function close(value) {
            this.$emit('close', value);
        },
        save: function save() {
            this.$emit('save', {
                claim_id: this.claim.id,
                open_date: this.openDate,
                active: this.active,
                outcome: this.active ? null : this.outcome,
                close_date: this.active ? null : this.closeDate
            });
        }
    }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claims-dashboard-icons'
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'initial-reserves-costs',
    props: {
        claim: {
            type: Object,
            required: true
        },
        modal: {
            type: Boolean,
            default: false
        },
        isSaving: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "Reserves & Costs (editing)"
        },
        showBackBtn: {
            type: Boolean,
            default: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_2_directives_TwoDecimalPlaces__["a" /* default */]
    },
    data: function data() {
        var _this = this;

        var getValue = function getValue(costKey) {
            return _this.claim.cost ? _this.claim.cost[costKey] || 0 : 0;
        };
        return {
            damagesReserve: getValue('current_damages_reserve'),
            thirdPartyReserve: getValue('current_third_party_reserve'),
            defenceCostsReserve: getValue('current_defence_costs_reserve'),
            paidDamages: getValue('paid_damages'),
            paidThirdPartyCosts: getValue('paid_third_party_costs'),
            paidDefenceCosts: getValue('paid_defence_costs'),
            recoveredCosts: getValue('recovered_costs')
        };
    },

    computed: {
        totalReserve: function totalReserve() {
            return parseFloat(this.damagesReserve) + parseFloat(this.thirdPartyReserve) + parseFloat(this.defenceCostsReserve);
        },
        totalPaid: function totalPaid() {
            return parseFloat(this.paidDamages) + parseFloat(this.paidThirdPartyCosts) + parseFloat(this.paidDefenceCosts);
        },
        netPaid: function netPaid() {
            return parseFloat(this.totalPaid) - parseFloat(this.recoveredCosts);
        }
    },
    methods: {
        close: function close(value) {
            this.$emit('close', value);
        },
        save: function save() {
            this.$emit('save', {
                claim_id: this.claim.id,
                currentDamagesReserve: this.damagesReserve,
                currentThirdPartyReserve: this.thirdPartyReserve,
                currentDefenceCostsReserve: this.defenceCostsReserve,
                paidDamages: this.paidDamages,
                paidThirdPartyCosts: this.paidThirdPartyCosts,
                paidDefenceCosts: this.paidDefenceCosts,
                recoveredCosts: this.recoveredCosts
            });
        }
    }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClaimInfo__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClaimInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ClaimInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InitialReservesCosts__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InitialReservesCosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InitialReservesCosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "reserves-for-claim",
    components: {
        ClaimInfo: __WEBPACK_IMPORTED_MODULE_1__ClaimInfo___default.a,
        InitialReservesCosts: __WEBPACK_IMPORTED_MODULE_2__InitialReservesCosts___default.a
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('claim', { claim: 'current' }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('claim', ['updateClaim', 'setCurrent', 'updateCosts']), {
        saveReserveChanges: function saveReserveChanges(data) {
            var _this = this;

            this.isSaving = true;
            this.updateCosts(data).then(function () {
                _this.isSaving = false;
            });
        },
        saveClaimData: function saveClaimData(claimData) {
            var _this2 = this;

            this.updateClaim(claimData).then(function (data) {
                return _this2.setCurrent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.theClaim, {
                    id: data.id,
                    open_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(claimData.open_date, 'DD/MM/YYYY'),
                    active: claimData.active,
                    outcome: claimData.outcome,
                    close_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(claimData.close_date, 'DD/MM/YYYY')
                }));
            });
        }
    })
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_claims_dashboard_components_Icons__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_claims_dashboard_components_Icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_claims_dashboard_components_Icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_filter_FilterOptions__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_filter_FilterOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_filter_FilterOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_claims_dashboard_components_ClaimInfo__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_claims_dashboard_components_ClaimInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_claims_dashboard_components_ClaimInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_InitialReservesCosts__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_InitialReservesCosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_InitialReservesCosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-table',
    props: {
        showDelete: {
            type: Boolean,
            default: false
        }
    },
    components: {
        claimsDashboardIcons: __WEBPACK_IMPORTED_MODULE_5_pages_claims_dashboard_components_Icons___default.a,
        FilterOptions: __WEBPACK_IMPORTED_MODULE_6_components_filter_FilterOptions___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_9_components_IconTooltip___default.a,
        ClaimInfo: __WEBPACK_IMPORTED_MODULE_7_pages_claims_dashboard_components_ClaimInfo___default.a,
        InitialReservesCosts: __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_InitialReservesCosts___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_10_mixins_dateFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_mixins_currencyFormat__["a" /* default */]],
    created: function created() {
        this.search();
    },
    mounted: function mounted() {
        var _this = this;

        this.availableColumns.forEach(function (columnData) {
            if (columnData.default === true) {
                _this.showColumns.push(columnData.value);
            }
        });
    },
    data: function data() {
        var availableColumns = [{
            name: 'Claim Type',
            value: 'human_claim_type',
            default: true
        }, {
            name: 'Defendant Name',
            value: 'defendant_name',
            default: true
        }, {
            name: 'Claimant Solicitor',
            value: 'claimant_solicitor',
            default: true
        }, {
            name: 'Claimant Reference',
            value: 'claimant_reference',
            default: false
        }, {
            name: 'Procedural Status',
            value: 'procedural_status',
            default: false
        }, {
            name: 'Service of Proceedings',
            value: 'service_of_proceedings',
            default: false
        }, {
            name: 'Assumed Settlement',
            value: 'assumed_settlement',
            default: false
        }, {
            name: 'Claims Handler',
            value: 'claims_handler',
            default: false
        }, {
            name: 'Team/Branch',
            value: 'team_branch',
            default: false
        }, {
            name: 'Claim Status',
            value: 'claim_status',
            default: false
        }, {
            name: 'Gender',
            value: 'gender',
            default: false
        }, {
            name: 'Created At',
            value: 'created_at',
            default: false
        }, {
            name: 'Updated At',
            value: 'updated_at',
            default: true
        }];
        if (this.showNames) {
            availableColumns.unshift({
                name: 'Claimant Name',
                value: 'claimant_name',
                default: true
            });
        }
        return {
            loading: true,
            action: null,
            showSummaries: null,
            advancedSearchVisible: false,
            availableColumns: availableColumns,
            showColumns: [],
            pagination: {
                total: 0,
                per_page: 10,
                from: 1,
                to: 0,
                current_page: 1,
                last_page: 2
            },
            offset: 4,
            claims: [],
            filters: false,
            filter: {},
            order: 'updated_at',
            sort: 'desc',
            showAllSummary: true,
            showClaimInfo: false,
            showReservesCosts: false,
            summaryDefault: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('http', ['running', 'apiRouteRequestRunning']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        isActive: function isActive() {
            return this.pagination.current_page;
        },
        pageNumbers: function pageNumbers() {
            if (!this.pagination.to) {
                return [];
            }
            var from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            var to = from + this.offset * 2;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            var pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('claim', ['load', 'delete', 'update']), {
        showHideFilters: function showHideFilters() {
            return this.filters = !this.filters;
        },
        toggleSummary: function toggleSummary(claimId) {
            this.showSummaries = this.showSummaries !== claimId ? claimId : null;
            this.showClaimInfo = this.showReservesCosts = false;
            this.showAllSummary = true;
        },
        showSummary: function showSummary(claimId) {
            return this.showSummaries === claimId;
        },
        updateEditing: function updateEditing(value) {
            this.showAllSummary = this.showClaimInfo = this.showReservesCosts = false;
            switch (value) {
                case 'showAllSummary':
                    this.showAllSummary = true;
                    break;
                case 'showClaimInfo':
                    this.showClaimInfo = true;
                    break;
                case 'showReservesCosts':
                    this.showReservesCosts = true;
                    break;
                default:
            }
        },
        search: function search() {
            this.pagination.current_page = 0;
            return this.request();
        },
        changePage: function changePage(page) {
            this.pagination.current_page = page;
            this.request();
        },
        changeOrder: function changeOrder(column) {
            this.sort = this.order != column ? 'asc' : this.sort == 'desc' ? 'asc' : 'desc';
            this.order = column;
            this.search();
        },
        reset: function reset() {
            this.order = 'updated_at';
            this.sort = 'desc';
            this.filter = {};
            this.search();
        },
        columnTitle: function columnTitle(column) {
            return this.availableColumns.filter(function (columnData) {
                return columnData.value === column;
            })[0].name;
        },
        request: function request() {
            var _this2 = this;

            this.loading = true;

            return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.search(this.cleanFilter(), this.pagination.current_page, this.order, this.sort).then(function (claims) {
                _this2.claims = claims.data;
                _this2.pagination.total = claims.total;
                _this2.pagination.per_page = claims.per_page;
                _this2.pagination.from = claims.from;
                _this2.pagination.to = claims.to;
                _this2.pagination.current_page = claims.current_page;
                _this2.pagination.last_page = claims.last_page;
                _this2.loading = false;
            });
        },
        updateFilter: function updateFilter(_ref) {
            var key = _ref.key,
                value = _ref.value;

            this.filter[key] = value;
        },
        cleanFilter: function cleanFilter() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
                if (_this3.filter[k] === null || _this3.filter[k] === "null" || _this3.filter[k] === "") {
                    delete _this3.filter[k];
                }
            });

            return this.filter;
        },
        saveClaimChanges: function saveClaimChanges(data) {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.update(data).then(function (response) {
                var claimIndex = _this4.claims.findIndex(function (claim) {
                    return claim.id === response.id;
                });

                _this4.claims[claimIndex]['open_date'] = __WEBPACK_IMPORTED_MODULE_3_moment___default()(data.open_date, 'DD/MM/YYYY');
                _this4.claims[claimIndex]['active'] = data.active;
                _this4.claims[claimIndex]['outcome'] = data.outcome;
                _this4.claims[claimIndex]['close_date'] = __WEBPACK_IMPORTED_MODULE_3_moment___default()(data.close_date, 'DD/MM/YYYY');
            });
            this.updateEditing('showAllSummary');
        },
        saveReserveChanges: function saveReserveChanges(data) {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.updateCosts(data).then(function (response) {
                var claimIndex = _this5.claims.map(function (claim) {
                    return claim.id;
                }).indexOf(response.id);

                _this5.claims[claimIndex].cost = response.cost;
            });
            this.updateEditing('showAllSummary');
        },
        sendLoad: function sendLoad(claim) {
            this.action = 'loading';
            this.$emit('select', claim);
        },
        sendDelete: function sendDelete(claim) {
            this.$emit('delete', claim);
        },
        formatCost: function formatCost(claim, key) {
            if (claim && claim.cost && claim.cost[key]) {
                return this.currencyFormat(claim.cost[key]);
            }
            return '-';
        },
        userFrom: function userFrom(claim) {
            if (!claim.user) {
                return;
            }

            return claim.user.name;
        },
        teamFrom: function teamFrom(claim) {
            if (!claim.user || !claim.user.team) {
                return;
            }

            return claim.user.team.name;
        },
        formatDate: function formatDate(date) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('DD/MM/YYYY');
        },
        output: function output(claim, column) {
            if (column === 'claims_handler') {
                return this.userFrom(claim);
            }

            if (column === 'team_branch') {
                return this.teamFrom(claim);
            }

            if (column === 'claim_status') {
                return claim['active'] ? 'Open' : 'Closed';
            }

            if (column === 'service_of_proceedings') {
                return claim[column] !== null ? this.formatDate(claim[column]) : 'n/a';
            }

            if (column === 'assumed_settlement') {
                return claim[column] !== null ? this.formatDate(claim[column]) : 'n/a';
            }

            if (column === 'procedural_status') {
                return claim[column] === 'pre-lit' ? 'Pre-Litigation' : 'Litigated';
            }

            if (column === 'gender') {
                return __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.upperFirst(claim[column]);
            }

            if (column === "updated_at") {
                return this.dateFormat(claim[column], "DD/MM/YYYY H:mm");
            }

            return claim[column];
        }
    })
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Form__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClaimTable__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClaimTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ClaimTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FromTo__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FromTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FromTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Search__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DifferenceChart__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DifferenceChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DifferenceChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_claims_dashboard_components_Icons__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_claims_dashboard_components_Icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_claims_dashboard_components_Icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FeeEarnerChart__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FeeEarnerChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_FeeEarnerChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RangeChartContainer__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RangeChartContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_RangeChartContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Slider__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ResultsTable__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ResultsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ResultsTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_Header_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'compare-values',
    components: {
        ResultsTable: __WEBPACK_IMPORTED_MODULE_11__components_ResultsTable___default.a,
        Slider: __WEBPACK_IMPORTED_MODULE_10__components_Slider___default.a,
        RangeChartContainer: __WEBPACK_IMPORTED_MODULE_9__components_RangeChartContainer___default.a,
        FeeEarnerChart: __WEBPACK_IMPORTED_MODULE_8__components_FeeEarnerChart___default.a,
        DifferenceChart: __WEBPACK_IMPORTED_MODULE_5__components_DifferenceChart___default.a,
        Search: __WEBPACK_IMPORTED_MODULE_4__components_Search___default.a,
        FromTo: __WEBPACK_IMPORTED_MODULE_3__components_FromTo___default.a,
        ClaimTable: __WEBPACK_IMPORTED_MODULE_2__components_ClaimTable___default.a,
        CompareForm: __WEBPACK_IMPORTED_MODULE_1__components_Form___default.a,
        ClaimsDashboardIcons: __WEBPACK_IMPORTED_MODULE_6_pages_claims_dashboard_components_Icons___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_12_components_Header_vue___default.a
    },
    data: function data() {
        return {
            showClaimTable: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('reserves/compare', ['claims', 'calculating', 'hasClaims']))
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Paginator__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Paginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Paginator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_form_Control__);










var labels = {
    "dayOne": 'Day One',
    "paid": 'Paid',
    "final": 'Final Reserve',
    "initial": 'Initial Reserve'
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-table',
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_6__components_form_Control___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_5_components_Paginator___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_4_components_IconTooltip___default.a
    },
    data: function data() {
        return { pageNo: 0, perPage: 10 };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('reserves/compare', ['tableClaims', 'from', 'to', 'totalClaims', 'includeInTable']), {
        fromLabel: function fromLabel() {
            return labels[this.from];
        },
        toLabel: function toLabel() {
            return labels[this.to];
        },
        claims: function claims() {
            return this.tableClaims.slice(this.pageNo * this.perPage, (this.pageNo + 1) * this.perPage);
        },
        pageNumbers: function pageNumbers() {
            return Math.ceil(this.tableClaims.length / this.perPage);
        },

        tableFilter: {
            get: function get() {
                return this.includeInTable;
            },
            set: function set(value) {
                this.update({ key: 'includeInTable', value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('claim', ['load']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('reserves/compare', ['update']), {
        doLoad: function doLoad(claim) {
            this.load({ claim: claim, router: this.$router });
        },
        displayPercent: function displayPercent(value) {
            if (value === Infinity) {
                return "-";
            }
            return this.roundValue(value * 100, 2) + '%';
        },
        changePage: function changePage(page) {
            this.pageNo = page;
        },
        percentDisplay: function percentDisplay(value) {
            if (!value) {
                return "-";
            }
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mixins_roundValue__["a" /* default */])(value * 100, 2) + '%';
        }
    })
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_graphs_BarChart__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DifferenceTable__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DifferenceTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DifferenceTable__);








var labels = {
    "dayOne": 'Day One Reserve ',
    "paid": 'Paid',
    "final": 'Final Reserve',
    "initial": 'Initial Reserve'
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'difference-chart',
    components: {
        DifferenceTable: __WEBPACK_IMPORTED_MODULE_4__DifferenceTable___default.a,
        BarChart: __WEBPACK_IMPORTED_MODULE_1_components_graphs_BarChart__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */]],
    data: function data() {
        return {
            colours: ['#45BFFC', '#3DF2C3', '#CD5CD8']
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('reserves/compare', ['from', 'to', 'claims', 'averageFrom', 'averageTo', 'averageDifference']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        fromLabel: function fromLabel() {
            return labels[this.from];
        },
        toLabel: function toLabel() {
            return labels[this.to];
        },
        defaultOptions: function defaultOptions() {
            var _this = this;

            return {
                legend: { display: false },
                scales: {
                    yAxes: [{
                        ticks: {
                            callback: function callback(label) {
                                return _this.currencyFormat(label, '£', 0);
                            },
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000"
                        },
                        gridLines: {
                            display: true,
                            drawTicks: false,
                            color: 'rgba(255, 255, 255, 0)',
                            zeroLineWidth: 1,
                            zeroLineColor: 'rgba(0, 0, 0, 0.20)',
                            drawBorder: false
                        }
                    }],
                    xAxes: [{
                        categoryPercentage: 1,
                        barPercentage: 0.75,
                        ticks: {
                            fontSize: 14,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000"
                        }
                    }]
                },
                tooltips: {
                    mode: 'single',
                    callbacks: {
                        label: function label(tooltipItems) {
                            return _this.currencyFormat(tooltipItems.yLabel);
                        }
                    }
                }
            };
        },
        currentChartData: function currentChartData() {
            return {
                type: 'bar',
                labels: [this.fromLabel, this.toLabel, "Difference"],
                datasets: [{
                    backgroundColor: this.colours,
                    data: [this.averageFrom, this.averageTo, Math.abs(this.averageDifference)]
                }]
            };
        }
    })
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_roundValue__ = __webpack_require__(19);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: "difference-table",
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_roundValue__["a" /* default */]],
    props: {
        colours: {
            type: Array,
            required: true
        },
        fromLabel: {
            type: String,
            required: true
        },
        toLabel: {
            type: String,
            required: true
        },
        difference: {
            type: Number,
            required: true
        },
        averageFrom: {
            type: Number,
            required: true
        },
        averageTo: {
            type: Number,
            required: true
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('reserves/compare', ['from', 'to']), {
        headingLabels: function headingLabels() {
            var from = 'Reserve';
            var to = 'Paid';
            if (this.from === 'paid') {
                from = 'Paid';
            }
            if (this.to !== 'paid') {
                to = 'Reserve';
            }
            return { from: from, to: to };
        },
        differencePercent: function differencePercent() {
            return (1 - Math.min(this.averageTo, this.averageFrom) / Math.max(this.averageTo, this.averageFrom)) * 100;
        }
    })
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_graphs_BarChart__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Paginator__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Paginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Paginator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mixins_roundValue__ = __webpack_require__(19);















var labels = {
    "dayOne": 'Day One Reserve ',
    "paid": 'Paid',
    "final": 'Final Reserve',
    "initial": 'Initial Reserve'
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'fee-earner-chart',
    components: {
        Paginator: __WEBPACK_IMPORTED_MODULE_6_components_Paginator___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a,
        BarChart: __WEBPACK_IMPORTED_MODULE_4_components_graphs_BarChart__["a" /* default */],
        IconTooltip: __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalInTheWild___default.a,
        roundValue: __WEBPACK_IMPORTED_MODULE_11_mixins_roundValue__["a" /* default */],
        currencyFormat: __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */]],
    data: function data() {
        return {
            compareType: 'Total Difference',
            pageNo: 0,
            show: true
        };
    },

    watch: {
        compareType: function compareType() {
            var _this = this;

            this.show = false;
            setTimeout(function () {
                return _this.show = true;
            }, 1);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('reserves/compare', ['claims', 'from', 'to']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        feeEarnerAggregate: function feeEarnerAggregate() {
            var _this2 = this;

            var total = this.claims.length;
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(this.claims).reduce(function (list, claim) {
                if (!list[claim.claimHandler] && list[claim.claimHandler] !== 0) {
                    list[claim.claimHandler] = 0;
                }
                switch (_this2.compareType) {
                    case "Total Difference":
                    case "Average Difference":
                        list[claim.claimHandler] += Math.abs(claim.difference);
                        break;
                    case "Maximum Difference":
                        if (list[claim.claimHandler] < claim.difference) {
                            list[claim.claimHandler] = claim.difference;
                        }
                        break;
                    case "Number of Claims":
                        list[claim.claimHandler]++;
                }
                return list;
            }, {}).toPairs().sortBy(function (value) {
                return -Math.abs(value[1]);
            }).map(function (value) {
                if (_this2.compareType === 'Average Difference') {
                    value[1] = value[1] / total;
                }
                return value;
            }).fromPairs().value();
        },
        feeEarnersSliced: function feeEarnersSliced() {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(this.feeEarnerAggregate).toPairs().slice(this.pageNo * 5, (this.pageNo + 1) * 5).fromPairs().value();
        },
        fromLabel: function fromLabel() {
            return labels[this.from];
        },
        toLabel: function toLabel() {
            return labels[this.to];
        },
        currentChartData: function currentChartData() {
            return {
                type: 'bar',
                labels: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.feeEarnersSliced),
                datasets: [{
                    backgroundColor: ['#45BFFC', '#3DF2C3', '#CD5CD8', '#EB1458', '#7DD3F4', '#94F7DB'],
                    data: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(this.feeEarnersSliced)
                }]
            };
        },
        chartOptions: function chartOptions() {
            var _this3 = this;

            return {
                legend: { display: false },
                scales: {
                    xAxes: [{
                        categoryPercentage: 0.8,
                        barPercentage: 0.8,
                        ticks: {
                            fontSize: 14,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000"
                        }
                    }],
                    yAxes: [{
                        type: 'linear',
                        ticks: {
                            callback: function callback(label) {
                                if (_this3.compareType !== 'Number of Claims') {
                                    return _this3.currencyFormat(label, '£', 0);
                                }

                                if (Math.floor(label) === label) {
                                    return label;
                                }
                            },
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000",
                            stepSize: this.compareType !== 'Number of Claims' ? null : this.claims.length / 10
                        },
                        gridLines: {
                            display: true,
                            drawTicks: false,
                            color: 'rgba(255, 255, 255, 0)',
                            zeroLineWidth: 1,
                            zeroLineColor: 'rgba(0, 0, 0, 0.20)',
                            drawBorder: false
                        }
                    }]
                },
                tooltips: {
                    mode: 'single',
                    callbacks: {
                        label: function label(tooltipItems) {
                            return _this3.compareType !== 'Number of Claims' ? _this3.currencyFormat(tooltipItems.yLabel) : tooltipItems.yLabel;
                        }
                    }
                }
            };
        },
        pageNumbers: function pageNumbers() {
            return Math.ceil(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.feeEarnerAggregate).length / 5);
        }
    }),
    methods: {
        changePage: function changePage(page) {
            this.pageNo = page;
        },
        openModal: function openModal() {
            this.$store.dispatch('modal/toggle', 'feinfo');
        }
    }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FromTo__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FromTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FromTo__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'compare-form',
    components: {
        FromTo: __WEBPACK_IMPORTED_MODULE_3__FromTo___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control___default.a
    },
    computed: {
        claimType: {
            get: function get() {
                return this.getValue('claimType');
            },
            set: function set(value) {
                this.diseaseOrAccident = null;
                this.update({ key: 'claimType', value: value });
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.getValue('diseaseOrAccident');
            },
            set: function set(value) {
                this.diseaseType = null;
                this.acceleration = null;

                switch (true) {
                    case this.claimType === 'personal_injury':
                        value = 'accident';
                        break;
                    case !['accident', 'disease'].includes(value):
                        value = null;
                        break;
                }

                this.update({ key: 'diseaseOrAccident', value: value });
            }
        },
        diseaseType: {
            get: function get() {
                return this.getValue('diseaseType');
            },
            set: function set(value) {
                this.resetType({ key: 'accidentType' });

                value = this.diseaseOrAccident === 'disease' ? value : null;
                this.update({ key: 'diseaseType', value: value });
            }
        },
        accidentType: {
            get: function get() {
                return this.getValue('accidentType');
            },
            set: function set(value) {
                this.resetType({ key: 'diseaseType' });

                value = this.diseaseOrAccident === 'accident' ? value : null;
                this.update({ key: 'accidentType', value: value });
            }
        },
        discountRate: {
            get: function get() {
                return this.getValue('discountRate');
            },
            set: function set(value) {
                this.update({ key: 'discountRate', value: value });
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('reserves/compare', ['update', 'calculate', 'resetType']), {
        getValue: function getValue(key) {
            return this.$store.getters['reserves/compare/' + key];
        }
    })
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'from-to',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('reserves/compare', ['from', 'to', 'totalClaims', 'hasPaidClaims', 'numberOfPaid', 'hasClaims', 'hasNoClaims']), {
        from: {
            get: function get() {
                return this.$store.getters['reserves/compare/from'];
            },
            set: function set(value) {
                return this.$store.dispatch('reserves/compare/update', {
                    key: 'from',
                    value: value
                });
            }
        },
        to: {
            get: function get() {
                return this.$store.getters['reserves/compare/to'];
            },
            set: function set(value) {
                return this.$store.dispatch('reserves/compare/update', {
                    key: 'to',
                    value: value
                });
            }
        },
        toOptions: function toOptions() {
            var _this = this;

            var labels = {
                dayOne: 'Day One',
                final: 'Final Reserve',
                paid: 'Paid'
            };
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pickBy(labels, function (label, key) {
                return key !== _this.from;
            });
        },
        isComparingPaid: function isComparingPaid() {
            return this.to === 'paid' || this.from === 'paid';
        },
        showPaidAlert: function showPaidAlert() {
            return this.isComparingPaid && !this.hasPaidClaims && this.hasClaims;
        }
    })
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(349);




var MIN_HEIGHT = 400;
var MAX_WIDTH = 3000;
var DURATION = 500;

var BAR_PADDING = 0.1;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'range-chart',
    props: {
        claims: {
            type: Array,
            required: true
        },
        range: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            width: 0,
            height: 0,
            margin: { top: 20, right: 20, bottom: 50, left: 65 },
            xScaleLinear: null,
            xScaleBand: null,
            yScale: null,
            svg: null,
            tooltip: null,
            drawType: 'bar',
            groups: {
                axis: {
                    x: null,
                    y: null
                },
                marks: null,
                rangeMarks: null,
                boundBox: null
            }
        };
    },

    computed: {
        cleanClaims: function cleanClaims() {
            return this.claims.filter(function (claim) {
                return claim.percent !== Infinity && !isNaN(claim.percent);
            });
        },
        min: function min() {
            return this.cleanClaims.reduce(function (currMin, claim) {
                return claim.percent < currMin ? claim.percent : currMin;
            }, 1);
        },
        max: function max() {
            return this.cleanClaims.reduce(function (currMax, claim) {
                return claim.percent > currMax ? claim.percent : currMax;
            }, -1);
        },
        results: function results() {
            var results = Array.apply(null, Array(20)).map(function (val, index) {
                return { percent: (index * 10 - 100) / 100, count: 0 };
            });

            this.cleanClaims.forEach(function (claim) {
                var index = Math.floor((claim.percent + 1) * 10);
                if (index < 0) {
                    index = 0;
                }
                if (index > 19) {
                    index = 19;
                }
                results[index].count++;
            });
            return results;
        },
        maxClaims: function maxClaims() {
            return this.results.reduce(function (count, d) {
                return count + d.count;
            }, 0);
        }
    },
    mounted: function mounted() {
        this.svg = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* select */](this.$refs.svg);

        this.tooltip = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* select */](this.$refs.tooltip);

        this.init();

        window.addEventListener('resize', this.reset);
    },
    destroyed: function destroyed() {
        window.removeEventListener('resize', this.reset);
    },

    watch: {
        min: function min() {
            this.draw();
        },
        max: function max() {
            this.draw();
        },
        range: function range() {
            this.draw();
        }
    },
    methods: {
        init: function init() {
            this.determineHeightAndWidth();
            this.setupScales();
            this.setupGroups();
            this.setupAxisLabels();
            this.draw();
        },
        determineHeightAndWidth: function determineHeightAndWidth() {
            var container = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* select */](this.$refs.container);
            var containerWidth = parseFloat(container.style('width').replace('px', ''));
            var containerHeight = parseFloat(container.style('height').replace('px', ''));

            this.width = Math.min(MAX_WIDTH, containerWidth);
            this.height = Math.max(MIN_HEIGHT, containerHeight);
        },
        setupScales: function setupScales() {

            this.xScaleLinear = __WEBPACK_IMPORTED_MODULE_0_d3__["b" /* scaleLinear */]().range([0, this.width - this.margin.left - this.margin.right - this.results.length * BAR_PADDING]);

            this.xScaleBand = __WEBPACK_IMPORTED_MODULE_0_d3__["c" /* scaleBand */]().range([0, this.width - this.margin.left - this.margin.right - 2]).padding(BAR_PADDING);
            this.yScale = __WEBPACK_IMPORTED_MODULE_0_d3__["b" /* scaleLinear */]().range([this.height - this.margin.top - this.margin.bottom, 0]);
            this.applyDomainToScale();
        },
        setupGroups: function setupGroups() {
            this.svg.selectAll('g').remove();
            this.groups.axis.x = this.svg.append('g').attr("transform", "translate(" + this.margin.left + "," + (this.height - this.margin.bottom) + ")").attr('class', 'x axis');
            this.groups.axis.y = this.svg.append('g').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")").attr('class', 'y axis');
            this.groups.boundBox = this.svg.append('g').attr('class', 'bound-box').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
            this.groups.rangeMarks = this.svg.append('g').attr('class', 'range-marks').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
            this.groups.marks = this.svg.append('g').attr('class', 'marks').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
        },

        applyDomainToScale: function applyDomainToScale() {
            this.xScaleLinear.domain([-1, 1]);
            this.xScaleBand.domain(this.results.map(function (result) {
                return result.percent;
            }));
            this.yScale.domain([0, this.maxClaims + 1]);
        },
        setupAxisLabels: function setupAxisLabels() {
            this.svg.append('g').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")").attr('class', 'y axis-label').append('text').attr("transform", "rotate(-90)").attr("y", 0 - this.margin.left / 2).attr("x", 0 - this.height / 2).text("Number of Claims");
            this.svg.append('g').attr("transform", "translate(0," + (this.height - this.margin.bottom) + ")").attr('class', 'x axis-label').append('text').style("text-anchor", "middle").attr("y", this.margin.bottom).attr("x", this.width / 2).text("Percentile");
        },
        draw: function draw() {
            this.drawAxis();
            switch (this.drawType) {
                case 'mark':
                    this.drawMarks();
                    break;
                case 'line':
                    this.drawLine();
                    break;
                case 'bar':
                    this.drawBars();
                    break;
            }
            this.drawRangeMarkers();
        },
        drawAxis: function drawAxis() {
            var xGroup = this.groups.axis.x;
            var yGroup = this.groups.axis.y;
            this.applyDomainToScale();
            var percentFormat = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* format */](".0%");
            xGroup.transition().duration(DURATION).call(__WEBPACK_IMPORTED_MODULE_0_d3__["e" /* axisBottom */](this.drawType === 'bar' ? this.xScaleBand : this.xScaleLinear).tickFormat(function (d) {
                return percentFormat(d) + ' to ' + percentFormat(d + 0.1);
            }));
            yGroup.transition().duration(DURATION).call(__WEBPACK_IMPORTED_MODULE_0_d3__["f" /* axisLeft */](this.yScale).tickFormat(function (d) {
                return Math.floor(d) !== d ? null : d;
            }));
        },
        drawMarks: function drawMarks() {
            var _this = this;

            this.applyDomainToScale();

            var marks = this.groups.marks.selectAll('.mark').data(this.results);
            var determineClass = function determineClass(prefix) {
                return function (d) {
                    if (d.percent < _this.range[0]) {
                        return prefix + ' under';
                    }
                    if (d.percent > _this.range[1]) {
                        return prefix + ' over';
                    }
                    return prefix + ' centre';
                };
            };
            marks.enter().append('circle').attr('class', determineClass('mark')).attr('r', 2).attr("cx", function (d) {
                return _this.xScaleLinear(d.percent);
            }).attr("cy", function () {
                return _this.yScale(0);
            }).transition().duration(DURATION).attr("cy", function (d) {
                return _this.yScale(d.count);
            });
            marks.attr('class', determineClass('mark')).transition().duration(DURATION).attr("cx", function (d) {
                return _this.xScaleLinear(d.percent);
            }).attr("cy", function (d) {
                return _this.yScale(d.count);
            });
            marks.exit().remove();
        },
        drawBars: function drawBars() {
            var _this2 = this;

            this.applyDomainToScale();

            var bars = this.groups.marks.selectAll('.bar').data(this.results);
            var determineClass = function determineClass(prefix) {
                return function (d) {
                    if (d.percent < _this2.range[0]) {
                        return prefix + ' under';
                    }
                    if (d.percent >= _this2.range[1]) {
                        return prefix + ' over';
                    }
                    return prefix + ' centre';
                };
            };
            var innerHeight = this.height - this.margin.top - this.margin.bottom;
            bars.enter().append('rect').attr('class', determineClass('bar')).attr('x', function (d) {
                return _this2.xScaleBand(d.percent);
            }).attr("width", this.xScaleBand.bandwidth()).attr("height", innerHeight - this.yScale(0)).attr("y", this.yScale(0)).on("mouseover", this.showTooltip.bind(this)).on("mouseout", this.hideTooltip.bind(this)).transition().duration(DURATION).attr("height", function (d) {
                return innerHeight - _this2.yScale(d.count);
            }).attr("y", function (d) {
                return _this2.yScale(d.count);
            });

            bars.attr('class', determineClass('bar')).transition().duration(DURATION).attr("height", function (d) {
                return innerHeight - _this2.yScale(d.count);
            }).attr("y", function (d) {
                return _this2.yScale(d.count);
            });

            bars.exit().remove();
        },
        drawLine: function drawLine() {
            var _this3 = this;

            var lineValue = __WEBPACK_IMPORTED_MODULE_0_d3__["g" /* line */]().x(function (d) {
                return _this3.xScaleLinear(d.percent);
            }).y(function (d) {
                return _this3.yScale(d.count);
            });
            var lineZero = __WEBPACK_IMPORTED_MODULE_0_d3__["g" /* line */]().x(function (d) {
                return _this3.xScaleLinear(d.percent);
            }).y(function () {
                return _this3.yScale(0);
            });

            var line = this.groups.marks.selectAll('.line').data([this.results]);

            line.enter().append('path').attr('class', 'line').attr('d', lineZero).transition().duration(DURATION).attr("d", lineValue);

            line.transition().duration(DURATION).attr("d", lineValue);

            line.exit().remove();
        },
        drawRangeMarkers: function drawRangeMarkers() {
            var _this4 = this;

            var applyToMakers = function applyToMakers(lower, upper) {
                return function (d, index) {
                    return index === 0 ? lower(d) : upper(d);
                };
            };

            var markerLines = this.groups.rangeMarks.selectAll('line').data(this.range);

            markerLines.enter().append('line').attr('class', applyToMakers(function () {
                return 'under';
            }, function () {
                return 'over';
            })).attr('x1', this.xScaleLinear).attr('y1', this.yScale(0)).attr('x2', this.xScaleLinear).attr('y2', this.yScale(this.maxClaims + 1));

            markerLines.attr('x1', this.xScaleLinear).attr('x2', this.xScaleLinear);

            var boundBox = this.groups.boundBox.selectAll('rect').data([{ start: -1, end: this.range[0], name: 'under' }, { start: this.range[0], end: this.range[1], name: 'centre' }, { start: this.range[1], end: 1, name: 'over' }]);
            boundBox.enter().append('rect').attr('class', function (d) {
                return 'range-bound ' + d.name;
            }).attr('x', function (d) {
                return _this4.xScaleLinear(d.start);
            }).attr("width", function (d) {
                return _this4.xScaleLinear(d.end) - _this4.xScaleLinear(d.start);
            }).attr("height", this.yScale(0) - this.yScale(this.maxClaims + 1)).attr("y", this.yScale(this.maxClaims + 1));
            boundBox.attr('x', function (d) {
                return _this4.xScaleLinear(d.start);
            }).attr("width", function (d) {
                return _this4.xScaleLinear(d.end) - _this4.xScaleLinear(d.start);
            });
        },
        showTooltip: function showTooltip(item) {
            var percentFormat = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* format */](".2%");
            this.tooltip.html('<strong>' + percentFormat(item.percent) + ' to ' + percentFormat(item.percent + 0.1) + '</strong>\n                        <br>\n                        <strong>' + item.count + '</strong> claims');
            var evt = __WEBPACK_IMPORTED_MODULE_0_d3__["h" /* event */];
            var left = this.margin.left + parseFloat(__WEBPACK_IMPORTED_MODULE_0_d3__["a" /* select */](evt.currentTarget).attr("x")) + this.xScaleBand.step() / 2;
            left -= parseFloat(this.tooltip.style('width').replace("px", '') / 2);

            this.tooltip.style("visibility", "visible").style("left", left + "px").style("top", this.yScale(item.count) - 70 + "px").transition().duration(DURATION / 2).style("opacity", 1);
        },
        hideTooltip: function hideTooltip() {
            this.tooltip.transition().duration(DURATION / 2).style("opacity", 0);
        },
        reset: function reset() {
            this.groups.axis.x.remove();
            this.groups.axis.y.remove();
            this.groups.marks.remove();
            this.groups.rangeMarks.remove();
            this.groups.boundBox.remove();
            if (this.$refs && this.$refs.container) {
                this.init();
            }
        }
    }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RangeChart__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RangeChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RangeChart__);






var labels = {
    "dayOne": 'Day One Reserve ',
    "paid": 'Paid',
    "final": 'Final Reserve',
    "initial": 'Initial Reserve'
};

/* harmony default export */ __webpack_exports__["default"] = ({
    components: { RangeChart: __WEBPACK_IMPORTED_MODULE_2__RangeChart___default.a },
    name: 'range-chart-container',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('reserves/compare', ['claims', 'from', 'to', 'range']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        fromLabel: function fromLabel() {
            return labels[this.from];
        },
        toLabel: function toLabel() {
            return labels[this.to];
        }
    })
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_roundValue__ = __webpack_require__(19);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: "results-table",
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_roundValue__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('reserves/compare', ['claims', 'from', 'to', 'range']), {
        total: function total() {
            return this.cleanClaims.length;
        },
        cleanClaims: function cleanClaims() {
            return this.claims.filter(function (claim) {
                return claim.percent !== Infinity && !isNaN(claim.percent);
            });
        },
        underLimit: function underLimit() {
            var _this = this;

            var totalUnder = this.cleanClaims.reduce(function (total, claim) {
                return claim.percent < _this.range[0] ? ++total : total;
            }, 0);
            return {
                total: totalUnder,
                percent: totalUnder / this.total
            };
        },
        overLimit: function overLimit() {
            var _this2 = this;

            var totalOver = this.cleanClaims.reduce(function (total, claim) {
                return claim.percent > _this2.range[1] ? ++total : total;
            }, 0);
            return {
                total: totalOver,
                percent: totalOver / this.total
            };
        },
        withinLimit: function withinLimit() {
            var total = this.total - this.underLimit.total - this.overLimit.total;
            return {
                total: total,
                percent: total / this.total
            };
        }
    })
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'search',
    data: function data() {
        return {
            searchTerm: ''
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('reserves/compare', ['search', 'resetSearch']), {
        doSearch: function doSearch() {
            this.search(this.searchTerm);
        },
        doReset: function doReset() {
            var _this = this;

            this.resetSearch().then(function () {
                return _this.searchTerm = '';
            });
        }
    })
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "slider",
    components: {
        VueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
    },
    computed: {
        backgroundStyle: function backgroundStyle() {
            var min = (100 + Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.getters['reserves/compare/range'])) * 100) / 2;
            var max = (100 + Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.getters['reserves/compare/range'])) * 100) / 2;

            return {
                'background': 'linear-gradient(to right, #85f7d9 ' + min + '%, #a6a6a6 ' + min + '%, #a6a6a6 ' + max + '%, #e68bb4 ' + max + '%)'
            };
        },

        range: {
            get: function get() {
                return this.$store.getters['reserves/compare/range'];
            },
            set: function set(value) {
                return this.$store.dispatch('reserves/compare/update', { key: 'range', value: value });
            }
        },
        rangeDisplay: function rangeDisplay() {
            return function (value) {
                return Math.round(value * 100) + '%';
            };
        }
    }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_Accordion_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_Accordion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_accordion_Accordion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_PageForm_vue__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_PageForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_PageForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_sections_AllHeadsOfLoss_vue__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_sections_AllHeadsOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_sections_AllHeadsOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_sections_AssessmentsByAge_vue__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_sections_AssessmentsByAge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_sections_AssessmentsByAge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_sections_AveragePastFutureLosses_vue__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_sections_AveragePastFutureLosses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_sections_AveragePastFutureLosses_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_sections_TotalPastFutureLosses_vue__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_sections_TotalPastFutureLosses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_sections_TotalPastFutureLosses_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Header_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'discount-rate-comparison',
    components: {
        Accordion: __WEBPACK_IMPORTED_MODULE_2_components_accordion_Accordion_vue___default.a,
        PageForm: __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_PageForm_vue___default.a,
        AllHeadsOfLoss: __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_sections_AllHeadsOfLoss_vue___default.a,
        AssessmentsByAge: __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_sections_AssessmentsByAge_vue___default.a,
        AveragePastFutureLosses: __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_sections_AveragePastFutureLosses_vue___default.a,
        TotalPastFutureLosses: __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_sections_TotalPastFutureLosses_vue___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_8_components_Header_vue___default.a
    },
    mounted: function mounted() {
        this.reset();
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['results', 'claimType'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['reset']))
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_update_PageForm__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_update_PageForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_update_PageForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_update_ClaimsPreview__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_update_ClaimsPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_update_ClaimsPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ProgressBar__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_ProgressBar__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'update-discount-rate',
    components: {
        PageForm: __WEBPACK_IMPORTED_MODULE_1__components_update_PageForm___default.a,
        ClaimsPreview: __WEBPACK_IMPORTED_MODULE_2__components_update_ClaimsPreview___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_3_components_Header_vue___default.a,
        ProgressBar: __WEBPACK_IMPORTED_MODULE_4_components_ProgressBar___default.a
    },
    mounted: function mounted() {
        this.reset();
        this.checkProgress();
    },
    beforeDestroy: function beforeDestroy() {
        this.cancelChecking();
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])('discountRateComparison', ['preview', 'processing', 'progress']),
    methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('discountRateComparison', ['reset', 'clearError', 'checkProgress', 'cancelChecking'])
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_BookOfBusinessSearch_vue__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_BookOfBusinessSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_BookOfBusinessSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_DiscountRates_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_DiscountRates_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_DiscountRates_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_IndividualSearch_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_IndividualSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_IndividualSearch_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'page-form',
    components: {
        BookOfBusinessSearch: __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_BookOfBusinessSearch_vue___default.a,
        DiscountRates: __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_DiscountRates_vue___default.a,
        IndividualSearch: __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_IndividualSearch_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['chosenRates', 'results', 'loading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('discountRateComparison', ['individualClaim']), {
        disableCompare: {
            get: function get() {
                return !this.chosenRates.length;
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['compare', 'reset']))
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_graphs_BarChart_js__ = __webpack_require__(64);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'bar',
    components: {
        BarChart: __WEBPACK_IMPORTED_MODULE_1_components_graphs_BarChart_js__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_0_mixins_currencyFormat__["a" /* default */]],
    props: {
        title: {
            type: String,
            default: null
        },
        legend: {
            type: Boolean,
            default: true
        },
        dataset: {
            type: Array,
            default: null
        },
        labels: {
            type: Array,
            default: null
        }
    },
    computed: {
        chartData: {
            get: function get() {
                return {
                    labels: this.labels,
                    datasets: this.dataset
                };
            }
        },
        chartOptions: {
            get: function get() {
                var _this = this;

                return {
                    scales: {
                        xAxes: [{
                            id: 'xAxisLabels',
                            categoryPercentage: 0.7,
                            barPercentage: 1,
                            ticks: {
                                fontSize: 16,
                                fontFamily: "'Nunito', sans-serif",
                                fontColor: "#000"
                            }
                        }],
                        yAxes: [{
                            id: 'yAxisMain',
                            scaleLabel: {
                                display: true,
                                labelString: 'Amount (£)'
                            },
                            ticks: {
                                fontSize: 16,
                                fontFamily: "'Nunito', sans-serif",
                                fontColor: "#000",
                                callback: function callback(label) {
                                    return _this.currencyFormat(label, '£', 0);
                                }
                            }
                        }]
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    legend: {
                        display: this.legend,
                        position: 'top',
                        labels: {
                            boxWidth: 60,
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000",
                            padding: 40
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function label(tooltipItem, data) {
                                return _this.currencyFormat(data.datasets[tooltipItem.datasetIndex]['data'][tooltipItem.index]);
                            }
                        }
                    },
                    title: {
                        display: true,
                        text: ''
                    }
                };
            }
        }
    }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_graphs_LineChart_js__ = __webpack_require__(116);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'linegraph',
    components: {
        LineChart: __WEBPACK_IMPORTED_MODULE_2_components_graphs_LineChart_js__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        title: {
            type: String,
            default: null
        },
        legend: {
            type: Boolean,
            default: true
        },
        dataset: {
            type: Array,
            default: null
        },
        labels: {
            type: Array,
            default: null
        }
    },
    computed: {
        chartData: {
            get: function get() {
                return {
                    labels: this.labels,
                    datasets: this.dataset
                };
            }
        },
        chartOptions: {
            get: function get() {
                var _this = this;

                return {
                    scales: {
                        xAxes: [{
                            id: 'xAxisLabels',
                            categoryPercentage: 0.7,
                            barPercentage: 0.7
                        }, {
                            id: 'xAxisLinear',
                            type: "linear",
                            display: false,
                            ticks: {
                                min: 0,
                                max: 100,
                                suggestedMin: 0,
                                suggestedMax: 100
                            }
                        }],
                        yAxes: [{
                            id: 'yAxisMain',
                            scaleLabel: {
                                display: true,
                                labelString: 'Amount (£)'
                            }
                        }, {
                            id: 'yAxisSimple',
                            display: false,
                            type: 'linear',
                            min: 0,
                            max: 1
                        }]
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    legend: {
                        display: this.legend,
                        position: 'top',
                        labels: {
                            boxWidth: 60,
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000",
                            padding: 40
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function label(tooltipItem, data) {
                                return _this.currencyFormat(data.datasets[tooltipItem.datasetIndex]['data'][tooltipItem.index]);
                            }
                        }
                    },
                    title: {
                        display: true,
                        text: ''
                    }
                };
            }
        }
    }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_graphs_PieChart_js__ = __webpack_require__(117);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pie',
    components: {
        PieChart: __WEBPACK_IMPORTED_MODULE_2_components_graphs_PieChart_js__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        title: {
            type: String,
            default: null
        },
        legend: {
            type: Boolean,
            default: true
        },
        rate: {
            type: String
        },
        total: {
            type: Number,
            default: null
        },
        totalText: {
            type: String,
            default: 'Total'
        },
        dataset: {
            type: Array,
            default: null
        },
        labels: {
            type: Array,
            default: null
        }
    },
    computed: {
        chartData: {
            get: function get() {
                return {
                    labels: this.labels,
                    datasets: this.dataset
                };
            }
        },
        chartOptions: {
            get: function get() {
                var _this = this;

                return {
                    cutoutPercentage: 70,
                    legend: {
                        display: false,
                        position: 'bottom',
                        labels: {
                            boxWidth: 60,
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000",
                            padding: 20
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function label(tooltipItem, data) {
                                return data.labels[tooltipItem.index] + ' - ' + _this.currencyFormat(data.datasets[tooltipItem.datasetIndex]['data'][tooltipItem.index]);
                            }
                        }
                    },
                    title: {
                        display: true,
                        text: ''
                    }
                };
            }
        }
    }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'accident-type',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        getDiseaseType: 'accidentType'
    }), {
        accidentType: {
            get: function get() {
                return this.getDiseaseType;
            },
            set: function set(value) {
                this.update({ key: 'accidentType', value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['update']))
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_ClaimStatus_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_ClaimStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_ClaimStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_ClaimType_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_ClaimType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_ClaimType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_DiseaseType_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_DiseaseType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_DiseaseType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_form_AccidentType_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_form_AccidentType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_form_AccidentType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_form_DiseaseOrAccident_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_form_DiseaseOrAccident_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_form_DiseaseOrAccident_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_form_Gender_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_form_Gender_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_form_Gender_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'book-of-business-search',
    components: {
        ClaimStatus: __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_ClaimStatus_vue___default.a,
        ClaimType: __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_ClaimType_vue___default.a,
        DiseaseType: __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_DiseaseType_vue___default.a,
        AccidentType: __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_form_AccidentType_vue___default.a,
        Gender: __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_form_Gender_vue___default.a,
        DiseaseOrAccident: __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_form_DiseaseOrAccident_vue___default.a
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        getDiscountOrAccident: 'diseaseOrAccident',
        getClaimType: 'claimType'
    }), {
        claimType: {
            get: function get() {
                return this.getClaimType;
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.getDiscountOrAccident;
            }
        }
    })
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-status',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        getClaimStatus: 'claimStatus'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('discountRateComparison', {
        individualClaim: 'individualClaim'
    }), {
        claimStatus: {
            get: function get() {
                return this.getClaimStatus;
            },
            set: function set(value) {
                this.update({ key: 'claimStatus', value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['update']))
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-type',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        getClaimType: 'claimType'
    }), {
        claimType: {
            get: function get() {
                return this.getClaimType;
            },
            set: function set(value) {
                this.update({ key: 'claimType', value: value });
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.$store.getters['dashboards/diseaseOrAccident'];
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['update']))
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'discount-rate-options',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['discountRatesOptions']), {
        DiscountRatesOptions: {
            get: function get() {
                return this.discountRatesOptions;
            },
            set: function set(value) {
                this.update({ key: 'discountRatesOptions', value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['update']))
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'discount-rates',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['discountRates', 'chosenRates'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['toggleDiscountRate']), {
        toggle: function toggle(event) {
            this.toggleDiscountRate(event.target.value);
        },
        checkedRate: function checkedRate(rate) {
            return !!this.chosenRates.find(function (chosen) {
                return chosen === rate;
            });
        },
        disableRate: function disableRate(rate) {
            if (this.checkedRate(rate)) {
                return false;
            }

            return this.chosenRates.length >= 2;
        }
    })
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'disease-or-accident',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        getDiscountOrAccident: 'diseaseOrAccident',
        getClaimType: 'claimType'
    }), {
        claimType: {
            get: function get() {
                return this.getClaimType;
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.getDiscountOrAccident;
            },
            set: function set(value) {
                this.update({ key: 'diseaseOrAccident', value: value });
                this.update({ key: 'accidentType', value: null });
                this.update({ key: 'diseaseType', value: null });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['update']))
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'disease-type',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        getDiseaseType: 'diseaseType'
    }), {
        diseaseType: {
            get: function get() {
                return this.getDiseaseType;
            },
            set: function set(value) {
                this.update({ key: 'diseaseType', value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['update']))
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'gender',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        getGender: 'gender'
    }), {
        gender: {
            get: function get() {
                return this.getGender;
            },
            set: function set(value) {
                this.update({ key: 'gender', value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['update']))
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_discount_rate_comparison_components_form_ClaimStatus_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_discount_rate_comparison_components_form_ClaimStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_discount_rate_comparison_components_form_ClaimStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_modal_IndividualSearchModal_vue__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_modal_IndividualSearchModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_modal_IndividualSearchModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalInTheWild_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalInTheWild_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_ModalInTheWild_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'individual-search',
    components: {
        ClaimStatus: __WEBPACK_IMPORTED_MODULE_1_pages_discount_rate_comparison_components_form_ClaimStatus_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        IndividualSearchModal: __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_modal_IndividualSearchModal_vue___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalInTheWild_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])('discountRateComparison', {})),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('discountRateComparison', []))
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'update-discount-rate',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        discountRates: 'discountRates',
        updateTheDiscountRate: 'updateDiscountRate'
    }), {
        Rates: {
            get: function get() {
                return this.updateTheDiscountRate;
            },
            set: function set(value) {
                this.update({ key: 'updateDiscountRate', value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['update']))
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'individual-search-modal',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])('discountRateComparison', {})),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('discountRateComparison', []))
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_accordion_AccordionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_charts_Pie_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_charts_Pie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_charts_Pie_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_discount_rate_comparison_components_tables_HeadOfLossRow_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_discount_rate_comparison_components_tables_HeadOfLossRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_discount_rate_comparison_components_tables_HeadOfLossRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_OptionFilters_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_OptionFilters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_OptionFilters_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_chart_Legend_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_chart_Legend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_chart_Legend_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'all-heads-of-loss',
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_4_components_accordion_AccordionItem_vue___default.a,
        HeadOfLossRow: __WEBPACK_IMPORTED_MODULE_9_pages_discount_rate_comparison_components_tables_HeadOfLossRow_vue___default.a,
        Pie: __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_charts_Pie_vue___default.a,
        OptionFilters: __WEBPACK_IMPORTED_MODULE_10_components_OptionFilters_vue___default.a,
        ChartLegend: __WEBPACK_IMPORTED_MODULE_11_components_chart_Legend_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_percentageDifference__["a" /* default */]],
    data: function data() {
        return {
            tableType: "average"
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])('discountRateComparison', ['chosenRates', 'claimType']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('discountRateComparison', ['averageHeadsOfLossGraph', 'averageHeadsOfLossTable', 'totalHeadsOfLossGraph', 'totalHeadsOfLossTable']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        chartLegendWidth: function chartLegendWidth() {
            switch (true) {
                case this.theCurrentWidth <= 700:
                    return 100;
                    break;
                case this.theCurrentWidth <= 900:
                    return 90;
                    break;
                case this.theCurrentWidth <= 1024:
                    return 70;
                    break;
                default:
                    return 80;
            }
        },
        colours: function colours() {
            return ['#45BFFC', '#3DF2C3', '#CD5CD8', '#EB1458', '#7DD3F4', '#94F7DB', '#E18FEF', '#F94B8A', '#4A89E5', '#EA7A68', '#9A4CD9', '#BF104F', '#422960', '#007180', '#2ECE9D'];
        },
        headOfLossOrder: function headOfLossOrder() {
            var fatalAccidentDependency = ['generalDamages', 'bereavementAward', 'funeralExpenses', 'lossOfSpouse', 'pastLossOfEarnings', 'pastCostOfTravel', 'miscellaneous', 'pastCostOfCare', 'customHeadsOfLoss', 'pastDependencyOnIncome', 'futureDependencyOnIncome', 'pastDependencyOnServices', 'futureDependencyOnServices'];

            var fatalAccidentEstate = ['generalDamages', 'funeralExpenses', 'lossOfSpouse', 'pastLossOfEarnings', 'pastCostOfTravel', 'miscellaneous', 'pastCostOfCare', 'customHeadsOfLoss'];

            var lostYears = ['generalDamages', 'futureLossTotal', 'miscellaneous', 'pastCostOfCare', 'pastLossOfEarnings', 'pastCostOfTravel', 'futureCostOfCare', 'customHeadsOfLoss'];

            var all = ['generalDamages', 'bereavementAward', 'funeralExpenses', 'lossOfSpouse', 'pastLossOfEarnings', 'pastCostOfTravel', 'miscellaneous', 'pastCostOfCare', 'futureCostOfCare', 'customHeadsOfLoss', 'pastDependencyOnIncome', 'futureDependencyOnIncome', 'pastDependencyOnServices', 'futureDependencyOnServices', 'futureLossTotal', 'futureCostOfServices', 'futurePurchases', 'futureLossOfPension'];

            var personalInjury = ['generalDamages', 'pastLossOfEarnings', 'pastCostOfTravel', 'miscellaneous', 'pastCostOfCare', 'customHeadsOfLoss', 'futureCostOfServices', 'futureCostOfCare', 'futureLossOfEarnings', 'futurePurchases', 'futureLossOfPension'];

            switch (this.claimType) {
                case 'fatal_accident_dependency':
                    return fatalAccidentDependency;
                case 'fatal_accident_estate':
                    return fatalAccidentEstate;
                case 'lost_years':
                    return lostYears;
                case 'personal_injury':
                    return personalInjury;
                default:
                    return all;
            }
        },

        numberOfRates: {
            get: function get() {
                return this.chosenRates.length;
            }
        },
        gapClass: {
            get: function get() {
                return this.chosenRates.length >= 2 ? 'flex-grid__g-1' : 'flex-grid__g-3';
            }
        },
        labels: {
            get: function get() {
                var graphData = this.graphData(this.chosenRates[0]);

                var data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(this.headOfLossOrder, function (data, name) {
                    data.push(name);
                    return data;
                }, []);

                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data, function (value) {
                    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startCase(value).replace('Diy', 'DIY');
                });
            }
        }
    }),
    methods: {
        updateTable: function updateTable(type) {
            this.tableType = type;
        },
        graphData: function graphData(rate) {
            if (this.tableType === 'total') {
                return this.totalHeadsOfLossGraph(rate);
            }

            return this.averageHeadsOfLossGraph(rate);
        },
        tableData: function tableData() {
            if (this.tableType === 'total') {
                return this.totalHeadsOfLossTable;
            }

            return this.averageHeadsOfLossTable;
        },
        table: function table() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(this.headOfLossOrder, function (table, name) {
                table[name] = _this.tableData()[name];
                return table;
            }, {});
        },
        dataset: function dataset(rate) {
            var graphData = this.graphData(rate);

            var data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(this.headOfLossOrder, function (data, name) {
                data.push(graphData[name]);
                return data;
            }, []);

            return [{
                data: data,
                backgroundColor: this.colours,
                borderWidth: 0
            }];
        },
        sumOf: function sumOf(rate) {
            var data = this.graphData(rate);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).reduce(function (total, key) {
                return total + parseFloat(data[key]);
            }, 0);
        },
        roundAndPercent: function roundAndPercent(val1, val2) {
            return this.roundValue(this.percentageDifference(val1, val2), 2);
        },
        chartLegend: function chartLegend() {
            var fatalAccidentDependency = ['General Damages', 'Bereavement Award', 'Funeral Expenses', 'Loss Of Spouse', 'Past Loss Of Earnings', 'Past Cost Of Travel', 'Misc', 'Past Cost Of Care', 'Custom Heads Of Loss', 'Past Dependency On Income', 'Future Dependency On Income', 'Past Dependency On Services', 'Future Dependency On Services'];

            var fatalAccidentEstate = ['General Damages', 'Funeral Expenses', 'Loss Of Spouse', 'Past Loss Of Earnings', 'Past Cost Of Travel', 'Misc', 'Past Cost Of Care', 'Custom Heads Of Loss'];

            var lostYears = ['General Damages', 'Future Loss Total', 'Misc', 'Past Cost Of Care', 'Past Loss Of Earnings', 'Past Cost Of Travel', 'Future Cost Of Care', 'Custom Heads Of Loss'];

            var all = ['General Damages', 'Bereavement Award', 'Funeral Expenses', 'Loss Of Spouse', 'Past Loss Of Earnings', 'Past Cost Of Travel', 'Misc', 'Past Cost Of Care', 'Future Cost Of Care', 'Custom Heads Of Loss', 'Past Dependency On Income', 'Future Dependency On Income', 'Past Dependency On Services', 'Future Dependency On Services', 'Future Loss Total'];

            var personalInjury = ['General Damages', 'Past Loss Of Earnings', 'Past Cost Of Travel', 'Past Cost Of Care', 'Miscellaneous', 'Custom Heads Of Loss', 'Future Cost of Services', 'Future Cost of Care', 'Future Loss of Income', 'Future Cost of Purchases', 'Future Loss of Pension'];

            switch (this.claimType) {
                case 'fatal_accident_dependency':
                    return fatalAccidentDependency;
                case 'fatal_accident_estate':
                    return fatalAccidentEstate;
                case 'lost_years':
                    return lostYears;
                case 'personal_injury':
                    return personalInjury;
                default:
                    return all;
            }
        }
    }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_tables_AgeGroupRow_vue__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_tables_AgeGroupRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_tables_AgeGroupRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_charts_Bar_vue__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_charts_Bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_charts_Bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_charts_Linegraph_vue__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_charts_Linegraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_charts_Linegraph_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_OptionFilters_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_OptionFilters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_OptionFilters_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_chart_Legend_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_chart_Legend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_chart_Legend_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'assessments-by-age',
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem_vue___default.a,
        AgeGroupRow: __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_tables_AgeGroupRow_vue___default.a,
        Bar: __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_charts_Bar_vue___default.a,
        Linegraph: __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_charts_Linegraph_vue___default.a,
        OptionFilters: __WEBPACK_IMPORTED_MODULE_7_components_OptionFilters_vue___default.a,
        ChartLegend: __WEBPACK_IMPORTED_MODULE_8_components_chart_Legend_vue___default.a
    },
    data: function data() {
        return {
            ageGroupChartType: "bar",
            rateGroupChartType: "bar"
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['chosenRates']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('discountRateComparison', ['ageGroupGraph', 'rateGroupGraph']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        chartLegendWidthTwo: function chartLegendWidthTwo() {
            switch (true) {
                case this.theCurrentWidth <= 700:
                    return 100;
                    break;
                case this.theCurrentWidth <= 900:
                    return 100;
                    break;
                case this.theCurrentWidth <= 1024:
                    return 50;
                    break;
                default:
                    return 40;
            }
        },
        chartLegendWidthThree: function chartLegendWidthThree() {
            switch (true) {
                case this.theCurrentWidth <= 700:
                    return 100;
                    break;
                case this.theCurrentWidth <= 900:
                    return 90;
                    break;
                case this.theCurrentWidth <= 1024:
                    return 70;
                    break;
                default:
                    return 60;
            }
        },

        ageGroupBarLabels: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keys(this.ageGroupGraph(this.chosenRates[0]));
            }
        },
        ageGroupBarDataset: {
            get: function get() {
                var _this = this;

                var groups = this.chosenRates;
                var bars = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.zip.apply(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a, [groups, ["#45BFFC", "#3DF2C3"]]);
                var result = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(bars, function (bar) {
                    if (!bar[0]) {
                        return;
                    }

                    var data = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(_this.ageGroupGraph(bar[0]));
                    if (data.length !== 2) {
                        data.push(0);
                    }
                    return {
                        label: bar[0],
                        xAxisID: 'xAxisLabels',
                        backgroundColor: bar[1],
                        borderWidth: 0,
                        data: data
                    };
                });

                return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.compact(result);
            }
        },
        ageGroupLineDataset: {
            get: function get() {
                var _this2 = this;

                var groups = this.chosenRates;
                var lines = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.zip.apply(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a, [groups, ["#45BFFC", "#3DF2C3"]]);
                var result = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(lines, function (line) {
                    if (!line[0]) {
                        return;
                    }

                    return {
                        label: line[0],
                        backgroundColor: "transparent",
                        borderColor: line[1],
                        pointBorderColor: line[1],
                        pointBackgroundColor: line[1],
                        borderWidth: 0,
                        data: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(_this2.ageGroupGraph(line[0]))
                    };
                });

                return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.compact(result);
            }
        },
        rateGroupBarDataset: {
            get: function get() {
                var groups = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(this.rateGroupGraph, function (value, key) {
                    return [key, value];
                });
                var rates = this.chosenRates;
                var bars = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.zip.apply(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a, [groups, ['#45BFFC', '#3DF2C3', '#CD5CD8', '#EB1458', '#7DD3F4', '#94F7DB', '#E18FEF', '#F94B8A', '#4A89E5', '#EA7A68', '#9A4CD9', '#BF104F', '#422960', '#007180', '#2ECE9D']]).map(function (bar) {
                    if (!bar[0]) {
                        return bar;
                    }
                    rates.forEach(function (rate) {
                        if (!bar[0][1][rate]) {
                            bar[0][1][rate] = 0;
                        }
                    });
                    return bar;
                });

                var result = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(bars, function (bar) {
                    if (!bar[0]) {
                        return;
                    }

                    return {
                        label: bar[0][0],
                        backgroundColor: bar[1],
                        borderWidth: 0,
                        data: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(bar[0][1])
                    };
                });

                return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.compact(result);
            }
        },
        rateGroupLineDataset: {
            get: function get() {
                var groups = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(this.rateGroupGraph, function (value, key) {
                    return [key, value];
                });
                var bars = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.zip.apply(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a, [groups, ['#45BFFC', '#3DF2C3', '#CD5CD8', '#EB1458', '#7DD3F4', '#94F7DB', '#E18FEF', '#F94B8A', '#4A89E5', '#2ECE9D', '#9A4CD9', '#BF104F', '#422960']]);

                var result = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(bars, function (bar) {
                    if (!bar[0]) {
                        return;
                    }

                    return {
                        label: bar[0][0],
                        backgroundColor: "transparent",
                        pointBackgroundColor: bar[1],
                        borderColor: bar[1],
                        pointBorderColor: bar[1],
                        data: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(bar[0][1]),
                        borderWidth: 0
                    };
                });

                return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.compact(result);
            }
        },
        ageLabels: function ageLabels() {
            return this.rateGroupBarDataset.map(function (row) {
                return row.label + " - " + (parseInt(row.label, 10) + 5);
            });
        }
    }),
    methods: {
        updateAgeGroupChartType: function updateAgeGroupChartType(type) {
            this.ageGroupChartType = type;
        },
        updateRateGroupChartType: function updateRateGroupChartType(type) {
            this.rateGroupChartType = type;
        }
    }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_charts_Pie__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_charts_Pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_charts_Pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_chart_Legend__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_chart_Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_chart_Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tables_PieSummary__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tables_PieSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tables_PieSummary__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'average-past-future',
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem___default.a,
        Pie: __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_charts_Pie___default.a,
        ChartLegend: __WEBPACK_IMPORTED_MODULE_4_components_chart_Legend___default.a,
        PieSummary: __WEBPACK_IMPORTED_MODULE_5__tables_PieSummary___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['chosenRates']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('discountRateComparison', ['averageDataset', 'averageTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        chartLegendWidth: function chartLegendWidth() {
            switch (true) {
                case this.theCurrentWidth <= 700:
                    return 100;
                    break;
                case this.theCurrentWidth <= 1024:
                    return 70;
                    break;
                default:
                    return 50;
            }
        },

        gapClass: {
            get: function get() {
                return this.chosenRates.length >= 2 ? 'flex-grid__g-1' : 'flex-grid__g-3';
            }
        }
    }),
    methods: {
        dataset: function dataset(rate) {
            return [{
                data: this.averageDataset(rate),
                backgroundColor: ['#45BFFC', '#3DF2C3'],
                borderWidth: 0
            }];
        }
    }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_charts_Pie__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_charts_Pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_charts_Pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_chart_Legend__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_chart_Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_chart_Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tables_PieSummary__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tables_PieSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tables_PieSummary__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'total-past-future',
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem___default.a,
        Pie: __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_charts_Pie___default.a,
        ChartLegend: __WEBPACK_IMPORTED_MODULE_4_components_chart_Legend___default.a,
        PieSummary: __WEBPACK_IMPORTED_MODULE_5__tables_PieSummary___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['chosenRates']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('discountRateComparison', ['totalDataset', 'totalTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        chartLegendWidth: function chartLegendWidth() {
            switch (true) {
                case this.theCurrentWidth <= 700:
                    return 100;
                    break;
                case this.theCurrentWidth <= 1024:
                    return 70;
                    break;
                default:
                    return 50;
            }
        },

        gapClass: {
            get: function get() {
                return this.chosenRates.length >= 2 ? 'flex-grid__g-1' : 'flex-grid__g-3';
            }
        }
    }),
    methods: {
        dataset: function dataset(rate) {
            return [{
                data: this.totalDataset(rate),
                backgroundColor: ['#45BFFC', '#3DF2C3'],
                borderWidth: 0
            }];
        }
    }
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_roundValue__ = __webpack_require__(19);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'age-group-row',
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_roundValue__["a" /* default */]],
    props: {
        row: {
            type: Object,
            default: null
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['chosenRates']), {
        difference: function difference() {
            return this.row.data[0] - this.row.data[1];
        },
        percent: function percent() {
            return (1 - this.row.data[0] / this.row.data[1]) * 100;
        }
    })
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_roundValue__ = __webpack_require__(19);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'head-of-loss-row',
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_mixins_percentageDifference__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_mixins_roundValue__["a" /* default */]],
    props: {
        name: {
            type: String,
            default: null
        },
        row: {
            type: Object,
            default: null
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])('discountRateComparison', ['chosenRates'])),
    methods: {
        format: function format(name) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startCase(name).replace('Diy', 'DIY');
        },
        currency: function currency(val1, val2) {
            return this.currencyFormat(val1 - val2);
        },
        roundAndPercent: function roundAndPercent(val1, val2) {
            return this.roundValue(this.percentageDifference(this.roundValue(val1, 2), this.roundValue(val2, 2)), 2);
        }
    }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mixins_currencyFormat__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "pie-summary",
    mixins: [__WEBPACK_IMPORTED_MODULE_0_mixins_currencyFormat__["a" /* default */]],
    props: {
        rates: {
            type: Array,
            required: true
        },
        data: {
            type: Array,
            required: true
        }
    }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_ClaimStatus_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_ClaimStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_ClaimStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_ClaimType_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_ClaimType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_ClaimType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_DiseaseType_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_DiseaseType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_DiseaseType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_form_AccidentType_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_form_AccidentType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_form_AccidentType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_form_DiseaseOrAccident_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_form_DiseaseOrAccident_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_form_DiseaseOrAccident_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_form_Gender_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_form_Gender_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_form_Gender_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_form_UpdateDiscountRate_vue__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_form_UpdateDiscountRate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_form_UpdateDiscountRate_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'book-of-business-search',
    components: {
        ClaimStatus: __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_form_ClaimStatus_vue___default.a,
        ClaimType: __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_ClaimType_vue___default.a,
        DiseaseType: __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_DiseaseType_vue___default.a,
        AccidentType: __WEBPACK_IMPORTED_MODULE_5_pages_discount_rate_comparison_components_form_AccidentType_vue___default.a,
        Gender: __WEBPACK_IMPORTED_MODULE_7_pages_discount_rate_comparison_components_form_Gender_vue___default.a,
        DiseaseOrAccident: __WEBPACK_IMPORTED_MODULE_6_pages_discount_rate_comparison_components_form_DiseaseOrAccident_vue___default.a,
        UpdateDiscountRate: __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_form_UpdateDiscountRate_vue___default.a
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', {
        getDiscountOrAccident: 'diseaseOrAccident',
        getClaimType: 'claimType'
    }), {
        claimType: {
            get: function get() {
                return this.getClaimType;
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.getDiscountOrAccident;
            }
        }
    })
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_graphs_HorizontalBarChart__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_tables_HeadOfLossRow_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_tables_HeadOfLossRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_tables_HeadOfLossRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_OptionFilters_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_OptionFilters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_OptionFilters_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_chart_Legend_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_chart_Legend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_chart_Legend_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_discount_rate_comparison_components_form_DiscountRateOptions_vue__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_discount_rate_comparison_components_form_DiscountRateOptions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_discount_rate_comparison_components_form_DiscountRateOptions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalInTheWild_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalInTheWild_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_modal_ModalInTheWild_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_discount_rate_comparison_components_charts_Pie__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_discount_rate_comparison_components_charts_Pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pages_discount_rate_comparison_components_charts_Pie__);



















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Claims-Preview',
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem_vue___default.a,
        HeadOfLossRow: __WEBPACK_IMPORTED_MODULE_8_pages_discount_rate_comparison_components_tables_HeadOfLossRow_vue___default.a,
        BarChart: __WEBPACK_IMPORTED_MODULE_7_components_graphs_HorizontalBarChart__["a" /* default */],
        OptionFilters: __WEBPACK_IMPORTED_MODULE_9_components_OptionFilters_vue___default.a,
        ChartLegend: __WEBPACK_IMPORTED_MODULE_10_components_chart_Legend_vue___default.a,
        DiscountRateOptions: __WEBPACK_IMPORTED_MODULE_11_pages_discount_rate_comparison_components_form_DiscountRateOptions_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalInTheWild_vue___default.a,
        Pie: __WEBPACK_IMPORTED_MODULE_15_pages_discount_rate_comparison_components_charts_Pie___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_mixins_percentageDifference__["a" /* default */]],
    data: function data() {
        return {
            tableType: "average",
            offset: 4
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])('discountRateComparison', ['preview', 'discountRates', 'updateDiscountRate', 'discountRatesOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('discountRateComparison', ['averageHeadsOfLossGraph', 'averageHeadsOfLossTable', 'totalHeadsOfLossGraph', 'totalHeadsOfLossTable', 'claimsToBeUpdatedTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        isActive: function isActive() {
            return this.preview.currentPage;
        },
        pageNumbers: function pageNumbers() {
            if (!this.preview.to) {
                return [];
            }
            var from = this.preview.currentPage - this.offset;
            if (from < 1) {
                from = 1;
            }
            var to = from + this.offset * 2;
            if (to >= this.preview.lastPage) {
                to = this.preview.lastPage;
            }
            var pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
        chartLegendWidth: function chartLegendWidth() {
            switch (true) {
                case this.theCurrentWidth <= 700:
                    return 100;
                    break;
                case this.theCurrentWidth <= 900:
                    return 90;
                    break;
                case this.theCurrentWidth <= 1024:
                    return 70;
                    break;
                default:
                    return 80;
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('discountRateComparison', ['apply', 'updateClaimSelect', 'loadPreview']), {
        changePage: function changePage(page) {
            this.preview.currentPage = page;
            this.loadPreview();
        },
        showDifference: function showDifference(val1, val2) {
            if (val1 > val2) {
                return val1 - val2;
            }
            return val2 - val1;
        },
        updateSelected: function updateSelected(claimId) {
            this.updateClaimSelect(claimId);
        },
        close: function close() {
            this.toggle('discount-rate-warning');
        },
        startUpdateDiscountRate: function startUpdateDiscountRate() {
            this.toggle('discount-rate-warning');
            this.apply();
        },
        headsOfLossTotal: function headsOfLossTotal() {
            return this.preview.data.reduce(function (total, claim) {
                return total + claim.headsOfLossTotal;
            }, 0);
        },
        headsOfLossPreview: function headsOfLossPreview() {
            return this.preview.data.reduce(function (total, claim) {
                return total + claim.headsOfLossPreview;
            }, 0);
        },
        totalDifference: function totalDifference() {
            return this.headsOfLossTotal() - this.headsOfLossPreview();
        },
        dataset: function dataset(rate) {
            return [{
                data: [this.headsOfLossTotal(), this.headsOfLossPreview()],
                backgroundColor: ["#45BFFC", "#3DF2C3"],
                borderWidth: 0
            }];
        },
        selectAll: function selectAll() {
            this.preview.data.forEach(function (claim) {
                this.updateSelected(claim.id);
            }, this);
        }
    })
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_update_BookOfBusinessSearch_vue__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_update_BookOfBusinessSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_update_BookOfBusinessSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_DiscountRates_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_DiscountRates_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_DiscountRates_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_IndividualSearch_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_IndividualSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_IndividualSearch_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'page-form',
    components: {
        BookOfBusinessSearch: __WEBPACK_IMPORTED_MODULE_2_pages_discount_rate_comparison_components_update_BookOfBusinessSearch_vue___default.a,
        DiscountRates: __WEBPACK_IMPORTED_MODULE_3_pages_discount_rate_comparison_components_form_DiscountRates_vue___default.a,
        IndividualSearch: __WEBPACK_IMPORTED_MODULE_4_pages_discount_rate_comparison_components_form_IndividualSearch_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('discountRateComparison', ['chosenRates', 'results', 'loading', 'preview', 'updateDiscountRate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('discountRateComparison', ['individualClaim'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('discountRateComparison', ['loadPreview', 'reset']))
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_filter_FilterOptions_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_filter_FilterOptions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_filter_FilterOptions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_NumberCounter__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_NumberCounter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_NumberCounter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_OptionFilters__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_OptionFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_OptionFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_OptionList__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_OptionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_OptionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_OverviewBox__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_OverviewBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_OverviewBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_executive_dashboard_components_PageForm__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_executive_dashboard_components_PageForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_executive_dashboard_components_PageForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_executive_dashboard_components_PageHeader__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_executive_dashboard_components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_executive_dashboard_components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_executive_dashboard_components_charts_SummaryCharts__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_executive_dashboard_components_charts_SummaryCharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_executive_dashboard_components_charts_SummaryCharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_form_SwitchButton__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_form_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_form_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ReserveSection__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ReserveSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_ReserveSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_NumbersSection__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_NumbersSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_NumbersSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_Header_vue__);




















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'executive-dashboards',
    data: function data() {
        return {
            chartView: 'all'
        };
    },

    components: {
        NumbersSection: __WEBPACK_IMPORTED_MODULE_15__components_NumbersSection___default.a,
        ReserveSection: __WEBPACK_IMPORTED_MODULE_14__components_ReserveSection___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        FilterOptions: __WEBPACK_IMPORTED_MODULE_2_components_filter_FilterOptions_vue___default.a,
        Icons: __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_4_components_IconTooltip_vue___default.a,
        NumberCounter: __WEBPACK_IMPORTED_MODULE_5_components_NumberCounter___default.a,
        OptionFilters: __WEBPACK_IMPORTED_MODULE_6_components_OptionFilters___default.a,
        OptionList: __WEBPACK_IMPORTED_MODULE_7_components_OptionList___default.a,
        OverviewBox: __WEBPACK_IMPORTED_MODULE_8_components_OverviewBox___default.a,
        PageForm: __WEBPACK_IMPORTED_MODULE_9_pages_executive_dashboard_components_PageForm___default.a,
        PageHeader: __WEBPACK_IMPORTED_MODULE_10_pages_executive_dashboard_components_PageHeader___default.a,
        ReservesCharts: __WEBPACK_IMPORTED_MODULE_11_pages_executive_dashboard_components_charts_SummaryCharts___default.a,
        SwitchButton: __WEBPACK_IMPORTED_MODULE_12_components_form_SwitchButton___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_16_components_Header_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["a" /* mapGetters */])('http', ['running', 'apiRouteRequestRunning']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["a" /* mapGetters */])('dashboards', ['averageReservesChartData', 'totalReservesChartData', 'diseaseType'])),
    mounted: function mounted() {
        this.updateAll();
    },

    methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["b" /* mapActions */])('dashboards', ['executiveDashboard', 'updatePeriod', 'updateAll', 'updateAverageReservesType', 'updateTotalReservesType'])
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_OptionFilters__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_OptionFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_OptionFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_SummaryCharts__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_SummaryCharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_SummaryCharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_TrendsChart__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_TrendsChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__charts_TrendsChart__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: "numbers-section",
    components: {
        TrendsChart: __WEBPACK_IMPORTED_MODULE_3__charts_TrendsChart___default.a,
        SummaryCharts: __WEBPACK_IMPORTED_MODULE_1__charts_SummaryCharts___default.a,
        OptionFilters: __WEBPACK_IMPORTED_MODULE_0_components_OptionFilters___default.a
    },
    data: function data() {
        return { chartType: 'total' };
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('dashboards', ['caseNumbersChartData', 'caseNumbersTrendChartData', 'diseaseTypeSelected'])
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_ClaimStatus__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_ClaimStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_ClaimStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_ClaimType__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_ClaimType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__form_ClaimType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_ClaimCosts__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_ClaimCosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__form_ClaimCosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_DiseaseOrAccident__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_DiseaseOrAccident___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__form_DiseaseOrAccident__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_DiseaseType__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_DiseaseType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__form_DiseaseType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_AccidentType__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_AccidentType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__form_AccidentType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_ReserveValue__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_ReserveValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__form_ReserveValue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_ReserveRange__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_ReserveRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__form_ReserveRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_Dates__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_Dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__form_Dates__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'page-form',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_0_components_form_Control___default.a,
        ClaimStatus: __WEBPACK_IMPORTED_MODULE_1__form_ClaimStatus___default.a,
        ClaimCosts: __WEBPACK_IMPORTED_MODULE_3__form_ClaimCosts___default.a,
        ClaimType: __WEBPACK_IMPORTED_MODULE_2__form_ClaimType___default.a,
        DiseaseOrAccident: __WEBPACK_IMPORTED_MODULE_4__form_DiseaseOrAccident___default.a,
        DiseaseType: __WEBPACK_IMPORTED_MODULE_5__form_DiseaseType___default.a,
        AccidentType: __WEBPACK_IMPORTED_MODULE_6__form_AccidentType___default.a,
        ReserveValue: __WEBPACK_IMPORTED_MODULE_7__form_ReserveValue___default.a,
        ReserveRange: __WEBPACK_IMPORTED_MODULE_8__form_ReserveRange___default.a,
        Dates: __WEBPACK_IMPORTED_MODULE_9__form_Dates___default.a
    },
    computed: {
        claimType: {
            get: function get() {
                return this.$store.getters['dashboards/claimType'];
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.$store.getters['dashboards/diseaseOrAccident'];
            }
        },
        reserveValue: {
            get: function get() {
                return this.$store.getters['dashboards/reserveValue'];
            }
        }
    }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'page-header',
    components: {},
    computed: {},
    methods: {}
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_OptionFilters__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_OptionFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_OptionFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_SummaryCharts__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_SummaryCharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_SummaryCharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_TrendsChart__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_TrendsChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__charts_TrendsChart__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: "reserve-section",
    components: {
        TrendsChart: __WEBPACK_IMPORTED_MODULE_3__charts_TrendsChart___default.a,
        SummaryCharts: __WEBPACK_IMPORTED_MODULE_1__charts_SummaryCharts___default.a,
        OptionFilters: __WEBPACK_IMPORTED_MODULE_0_components_OptionFilters___default.a
    },
    data: function data() {
        return { chartType: 'average', show: true };
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('dashboards', ['averageReservesChartData', 'totalReservesChartData', 'trendsInReservesChartData', 'trendsInAverageReservesChartData', 'trendsInTotalReservesChartData', 'diseaseOrAccident', 'claimType']),
    methods: {
        changeType: function changeType(type) {
            var _this = this;

            this.chartType = type;
            this.show = false;
            setTimeout(function () {
                return _this.show = true;
            }, 1);
        }
    }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_graphs_BarChart__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_graphs_PieChart__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_OverviewBox__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_OverviewBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_OverviewBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_chart_Legend_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_chart_Legend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_chart_Legend_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'summary-charts',
    props: {
        chartData: {
            required: true,
            type: Object
        },
        type: {
            required: true,
            type: String
        },
        runType: {
            required: true,
            type: String
        }
    },
    data: function data() {
        return {
            hide: false
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__["a" /* default */]],
    components: {
        BarChart: __WEBPACK_IMPORTED_MODULE_2_components_graphs_BarChart__["a" /* default */],
        PieChart: __WEBPACK_IMPORTED_MODULE_3_components_graphs_PieChart__["a" /* default */],
        OverviewBox: __WEBPACK_IMPORTED_MODULE_4_components_OverviewBox___default.a,
        ChartLegend: __WEBPACK_IMPORTED_MODULE_6_components_chart_Legend_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('dashboards', ['getRunning', 'diseaseTypeSelected', 'claimCost', 'diseaseType']), {
        reserveType: function reserveType() {
            switch (this.claimCost) {
                case 'damages':
                    return 'Damages';
                case 'claimantCosts':
                    return 'Claimant Costs';
                case 'defenceCosts':
                    return 'Defence Costs';
                default:
                    return 'Reserve';
            }
        },
        diseaseSpecificData: function diseaseSpecificData() {
            return _.map(this.barChartData.datasets, function (value) {
                return value.data[0];
            });
        },
        diseaseSpecificColors: function diseaseSpecificColors() {
            return _.map(this.barChartData.datasets, function (value) {
                return value.backgroundColor;
            });
        },
        diseaseData: function diseaseData() {
            return this.diseaseType ? this.diseaseSpecificData : this.barChartData.datasets[0].data;
        },
        table: function table() {
            var colors = this.diseaseType ? this.diseaseSpecificColors : this.barChartData.datasets[0].backgroundColor;

            return _.zip(this.barChartData.labels, this.diseaseData, colors);
        },
        hasResults: function hasResults() {
            return this.chartData.hasData;
        },
        barChartOptions: function barChartOptions() {
            var _this = this;

            return {
                legend: { display: false },
                title: {
                    display: true,
                    text: ''
                },
                scales: {
                    xAxes: [{
                        stacked: this.diseaseTypeSelected,
                        display: true,
                        barPercentage: 1,
                        categoryPercentage: 0.7,
                        ticks: {
                            autoSkip: false,
                            callback: function callback() {
                                return '';
                            },
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000"
                        }
                    }],
                    yAxes: [{
                        stacked: this.diseaseTypeSelected,
                        ticks: {
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000",
                            beginAtZero: true,
                            callback: function callback(label) {
                                if (_this.type !== 'number') {
                                    return _this.currencyFormat(label, '£', 0);
                                }

                                if (Math.floor(label) === label) {
                                    return label;
                                }
                            }
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.type === 'number' ? 'Number of Claims' : ' ',
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000"
                        }
                    }]
                },
                tooltips: {
                    mode: 'single',
                    callbacks: {
                        title: function title(item, items) {
                            if (_this.diseaseTypeSelected) {
                                return items.labels[item[0].datasetIndex];
                            }
                            return items.labels[item[0].index];
                        },
                        label: function label(tooltipItems) {
                            if (_this.type === 'value') {
                                if (_this.diseaseTypeSelected) {
                                    return _this.currencyFormat(tooltipItems.yLabel, '£', 0);
                                }
                                return _this.currencyFormat(tooltipItems.yLabel, '£', 0);
                            } else {
                                return tooltipItems.yLabel;
                            }
                        }
                    }
                }
            };
        },
        barChartData: function barChartData() {
            return {
                labels: this.chartData.labels,
                datasets: this.chartData.dataSets
            };
        },
        pieChartOptions: function pieChartOptions() {
            var _this2 = this;

            return {
                cutoutPercentage: 70,
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        boxWidth: 60,
                        fontSize: 16,
                        fontFamily: "'Nunito', sans-serif",
                        fontColor: "#000",
                        padding: 20
                    }
                },
                title: {
                    display: false,
                    text: ''
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItems, other) {
                            if (!_this2.diseaseTypeSelected) {
                                return other.labels[tooltipItems.index] + ' ' + (_this2.type === 'value' ? _this2.currencyFormat(other.datasets[0].data[tooltipItems.index], '£', 0) : other.datasets[0].data[tooltipItems.index]);
                            } else {
                                return other.labels[tooltipItems.index] + ' ' + _this2.currencyFormat(other.datasets[0].data[tooltipItems.index], '£', 0);
                            }
                        }
                    }
                }
            };
        },
        pieChartData: function pieChartData() {
            return {
                labels: this.chartData.labels,
                datasets: this.chartData.pieDataSets
            };
        },
        loadingContent: function loadingContent() {
            return this.getRunning(this.runType) || this.hide;
        },
        sum: function sum() {
            return _.sum(this.diseaseData);
        },
        avg: function avg() {
            return _.sum(this.diseaseData);
        }
    }),
    methods: {
        percentage: function percentage(value) {
            return (100 / this.sum * value).toFixed(2);
        }
    }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_graphs_LineChart__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_OptionFilters__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_OptionFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_OptionFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_chart_Legend_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_chart_Legend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_chart_Legend_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'trends-chart',
    props: {
        chartData: {
            required: true,
            type: Object
        },
        type: {
            required: true,
            type: String
        },
        showing: {
            required: true,
            type: String
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */]],
    components: {
        LineChart: __WEBPACK_IMPORTED_MODULE_2_components_graphs_LineChart__["a" /* default */],
        OptionFilters: __WEBPACK_IMPORTED_MODULE_3_components_OptionFilters___default.a,
        ChartLegend: __WEBPACK_IMPORTED_MODULE_5_components_chart_Legend_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('dashboards', ['getPeriod', 'getRunning', 'diseaseTypeSelected']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        chartLegendWidth: function chartLegendWidth() {
            switch (true) {
                case this.theCurrentWidth <= 700:
                    return 100;
                    break;
                case this.theCurrentWidth <= 900:
                    return 90;
                    break;
                case this.theCurrentWidth <= 1024:
                    return 70;
                    break;
                default:
                    return 80;
            }
        },
        hasResults: function hasResults() {
            return !!this.chartData.data.length;
        },

        period: {
            get: function get() {
                return this.getPeriod('trendReserve');
            }
        },
        lineChartLabels: function lineChartLabels() {
            return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(this.chartData.data, function (value) {
                return value.label;
            });
        },
        lineChartData: function lineChartData() {
            return {
                labels: this.chartData.labels,
                datasets: this.chartData.data
            };
        },
        lineChartOptions: function lineChartOptions() {
            var _this = this;

            return {
                legend: {
                    display: false,
                    position: 'bottom',
                    labels: {
                        boxWidth: 60,
                        fontSize: 16,
                        fontFamily: "'Nunito', sans-serif",
                        fontColor: "#000",
                        padding: 20
                    }
                },
                title: {
                    display: true,
                    text: ''
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000"
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000",
                            callback: function callback(label) {
                                if (_this.type !== 'number') {
                                    return _this.currencyFormat(label, '£', 0);
                                }

                                if (Math.floor(label) === label) {
                                    return label;
                                }
                            }
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.type === 'number' ? 'Number of Claims' : ''
                        }
                    }]
                },
                tooltips: {
                    mode: 'single',
                    callbacks: {
                        title: function title(item, items) {
                            if (_this.diseaseTypeSelected) {
                                return items.labels[item[0].datasetIndex];
                            }
                            return items.labels[item[0].index];
                        },
                        labelColor: function labelColor(item, items) {
                            var datasetItem = _this.lineChartData.datasets[item.datasetIndex];
                            return {
                                borderColor: datasetItem.borderColor[0],
                                backgroundColor: datasetItem.backgroundColor[0]
                            };
                        },
                        label: function label(tooltipItems) {
                            if (_this.type === 'value') {
                                if (_this.diseaseTypeSelected) {
                                    return _this.currencyFormat(tooltipItems.yLabel, '£', 0);
                                }
                                return _this.currencyFormat(tooltipItems.yLabel, '£', 0);
                            } else {
                                return tooltipItems.yLabel;
                            }
                        }
                    }
                },
                hover: { mode: null }
            };
        },
        loadingContent: function loadingContent() {
            return this.getRunning('trendReserve');
        }
    }),
    methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('dashboards', ['updateTrendsInReservesPeriod'])
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'accident-type',
    computed: {
        accidentType: {
            get: function get() {
                return this.$store.getters['dashboards/accidentType'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'accidentType', value: value });
            }
        }
    }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-costs',
    computed: {
        claimCosts: {
            get: function get() {
                return this.$store.getters['dashboards/claimCost'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'claimCost', value: value });
            }
        }
    }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-status',
    computed: {
        claimStatus: {
            get: function get() {
                return this.$store.getters['dashboards/claimStatus'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'claimStatus', value: value });
            }
        }
    }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-type',
    computed: {
        claimType: {
            get: function get() {
                return this.$store.getters['dashboards/claimType'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'claimType', value: value });
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.$store.getters['dashboards/diseaseOrAccident'];
            }
        }
    }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "dates",
    components: {
        DateInput: __WEBPACK_IMPORTED_MODULE_0_components_form_control_DateInput___default.a
    },
    computed: {
        fromDate: {
            get: function get() {
                return this.$store.getters['dashboards/fromDate'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'fromDate', value: value });
            }
        },
        toDate: {
            get: function get() {
                return this.$store.getters['dashboards/toDate'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'toDate', value: value });
            }
        }
    }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'disease-or-accident',
    computed: {
        claimType: {
            get: function get() {
                return this.$store.getters['dashboards/claimType'];
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.$store.getters['dashboards/diseaseOrAccident'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'diseaseOrAccident', value: value });
                this.$store.dispatch('dashboards/updateFilter', { filter: 'accidentType', value: null });
                this.$store.dispatch('dashboards/updateFilter', { filter: 'diseaseType', value: null });
            }
        }
    }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'disease-type',
    computed: {
        diseaseType: {
            get: function get() {
                return this.$store.getters['dashboards/diseaseType'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'diseaseType', value: value });
            }
        }
    }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "dates",
    components: {},
    computed: {
        fromReserve: {
            get: function get() {
                return this.$store.getters['dashboards/fromReserve'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'fromReserve', value: value });
            }
        },
        toReserve: {
            get: function get() {
                return this.$store.getters['dashboards/toReserve'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'toReserve', value: value });
            }
        }
    }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'reserve-value',
    computed: {
        reserveValue: {
            get: function get() {
                return this.$store.getters['dashboards/reserveValue'];
            },
            set: function set(value) {
                this.$store.dispatch('dashboards/updateFilter', { filter: 'reserveValue', value: value });
            }
        }
    }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_modules_claim__ = __webpack_require__(29);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FatalAccidentClaims',
    components: {
        HeaderSection: __WEBPACK_IMPORTED_MODULE_2_components_Header_vue___default.a
    },
    mounted: function mounted() {},

    watch: {
        '$route': function $route(to, from) {
            this.resetOrLoad(to);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id',
        claimType: 'type'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/step', {
        dependencySteps: 'allSteps',
        dependencyCurrent: 'currentStep',
        dependencyStepNo: 'currentStepIndex'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/estate/step', {
        estateSteps: 'allSteps',
        estateCurrent: 'currentStep',
        estateStepNo: 'currentStepIndex'
    }), {
        current: function current() {
            if (this.claimType === 'fatal_accident_dependency') {
                return this.dependencyCurrent;
            }
            return this.estateCurrent;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('claim', ['load', 'reset', 'initialise']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('menu', ['updateMenu']), {
        isVisible: function isVisible() {

            return false;
        },
        resetOrLoad: function resetOrLoad(route) {
            var id = route.params.id;

            if (!id) {
                this.reset();
            }
        }
    })
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__ = __webpack_require__(11);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: "benefit",
    mixins: [__WEBPACK_IMPORTED_MODULE_0_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default.a
    },
    props: {
        title: {
            type: String,
            required: true
        },
        storeKey: {
            type: String,
            required: true
        },
        estateType: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        },
        showHeader: {
            type: Boolean,
            default: false
        },
        isLast: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        fieldName: function fieldName() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.snakeCase(this.title);
        },
        benefit: function benefit() {
            return this.$store.getters['fatal/' + this.estateType + '/cru/' + this.storeKey];
        },

        amount: {
            get: function get() {
                return this.benefit.value;
            },
            set: function set(value) {
                this.updateValue({ key: this.storeKey, value: value }).then(this.calcInterest);
            }
        },
        include: {
            get: function get() {
                return this.benefit.include;
            },
            set: function set(value) {
                this.updateInclude({ key: this.storeKey, value: value }).then(this.calcInterest);
            }
        }
    },
    methods: {
        calcInterest: function calcInterest() {
            return this.$store.dispatch('fatal/' + this.estateType + '/headsOfLoss/calcAllInterest');
        },
        updateValue: function updateValue(arg) {
            return this.$store.dispatch('fatal/' + this.estateType + '/cru/updateValue', arg);
        },
        updateInclude: function updateInclude(arg) {
            return this.$store.dispatch('fatal/' + this.estateType + '/cru/updateInclude', arg);
        }
    }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    props: {
        estateType: {
            type: String,
            required: true
        }
    }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    props: {
        estateType: {
            type: String,
            required: true
        }
    }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    props: {
        estateType: {
            type: String,
            required: true
        }
    }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    props: {
        estateType: {
            type: String,
            required: true
        }
    }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DependencyClaim',
    components: {
        Timeline: __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default.a
    },
    mounted: function mounted() {
        this.resetOrLoad(this.$route);
    },

    watch: {
        '$route': function $route(to, from) {
            this.resetOrLoad(to);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/step', {
        steps: 'allSteps',
        current: 'currentStep',
        stepNo: 'currentStepIndex'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('claim', { claimId: 'id' })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('claim', ['load', 'reset', 'initialise']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('menu', ['updateMenu']), {
        isVisible: function isVisible() {
            if (this.$route.params.id == this.claimId) {
                return true;
            }

            if (!this.$route.params.id && this.claimId) {
                return true;
            }

            return false;
        },
        resetOrLoad: function resetOrLoad(route) {
            var _this = this;

            var id = route.params.id;

            if (!id) {
                return this.reset().then(function () {
                    _this.initialise('fatal_accident_dependency');
                });
            }

            if (this.claimId === parseInt(id)) {
                return;
            }

            this.load({ claim: { id: id }, router: this.$router });
        }
    })
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_html5_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_dropdown_Dropdown_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_dropdown_Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_dropdown_Dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_claims_dashboard_components_ReservesForClaim__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_claims_dashboard_components_ReservesForClaim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_claims_dashboard_components_ReservesForClaim__);




var HtmlEditor = new __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor___default.a();









var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        ReservesForClaim: __WEBPACK_IMPORTED_MODULE_9_pages_claims_dashboard_components_ReservesForClaim___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        HtmlEditor: HtmlEditor,
        dropdown: __WEBPACK_IMPORTED_MODULE_8_components_dropdown_Dropdown_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_dateFormat__["a" /* default */]],
    data: function data() {
        return {
            editingContent: null,
            showComparisonSchedule: false,
            loading: false,
            isSaving: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', {
        headOfLoss: 'value',
        totalInterest: 'totalInterest',
        customHeadsOfLoss: 'headsOfLoss',
        periods: 'periods'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnServices', {
        servicePre: 'preDependencyValue',
        servicePost: 'postDependencyValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnIncome', {
        incomePre: 'preDependencyValue',
        incomePost: 'postDependencyValue',
        table28: 'table28'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/interimPayments', {
        interimPayments: 'interimPayments'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/cru', ['getGeneralDamagesOffset', 'getPastLossOfEarningsOffset', 'getPastCostOfCareOffset', 'getPastCostOfTravelOffset']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), {
        subTotal: function subTotal() {
            return numberVal(this.headOfLoss('generalDamages')) + numberVal(this.headOfLoss('bereavementAward')) + numberVal(this.headOfLoss('funeralExpenses')) + numberVal(this.headOfLoss('lossOfSpouse')) + numberVal(this.headOfLoss('pastLossOfEarnings')) + numberVal(this.headOfLoss('pastCostOfTravel')) + numberVal(this.headOfLoss('pastCostOfCare')) + numberVal(this.headOfLoss('misc')) + numberVal(this.calcCustomHeadsOfLoss) + numberVal(this.headOfLoss('pastDependencyOnServices')) + numberVal(this.servicePost) + numberVal(this.headOfLoss('pastDependencyOnIncome')) + numberVal(this.incomePost) - numberVal(this.cruTotalDeductions);
        },
        interestTotal: function interestTotal() {
            return numberVal(this.headOfLoss('generalDamagesWithInterest')) + numberVal(this.headOfLoss('bereavementAwardWithInterest')) + numberVal(this.headOfLoss('funeralExpensesWithInterest')) + numberVal(this.headOfLoss('lossOfSpouseWithInterest')) + numberVal(this.headOfLoss('pastLossOfEarningsWithInterest')) + numberVal(this.headOfLoss('pastCostOfCareWithInterest')) + numberVal(this.headOfLoss('pastCostOfTravelWithInterest')) + numberVal(this.headOfLoss('miscWithInterest')) + numberVal(this.calcCustomHeadsOfLossInterest) + numberVal(this.headOfLoss('pastDependencyOnIncomeWithInterest')) + numberVal(this.headOfLoss('pastDependencyOnServicesWithInterest'));
        },
        total: function total() {
            return numberVal(this.subTotal.toFixed(2)) + numberVal(this.interestTotal.toFixed(2));
        },
        totalLessInterimPayments: function totalLessInterimPayments() {
            return this.total - numberVal(this.calcInterimPayments);
        },
        downloadUrl: function downloadUrl() {
            return '/api/v1/download/' + this.claimId + '?access_token=' + this.getToken;
        },
        calcCustomHeadsOfLoss: function calcCustomHeadsOfLoss() {
            var total = 0;
            if (this.customHeadsOfLoss) {
                this.customHeadsOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.value);
                });
            }
            return total;
        },
        calcCustomHeadsOfLossInterest: function calcCustomHeadsOfLossInterest() {
            var total = 0;
            if (this.customHeadsOfLoss) {
                this.customHeadsOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.interestAccrued);
                });
            }
            return total;
        },
        calcInterimPayments: function calcInterimPayments() {
            return this.interimPayments.reduce(function (total, interimPayment) {
                return total + numberVal(interimPayment.value);
            }, 0);
        },
        cruTotalDeductions: function cruTotalDeductions() {
            return this.getGeneralDamagesOffset + this.getPastLossOfEarningsOffset + this.getPastCostOfCareOffset + this.getPastCostOfTravelOffset;
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('modal', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', {
        addDependantHeadOfLoss: 'addDependantHeadOfLoss'
    }), {
        createDocument: function createDocument(type) {
            this.createGeneratedDocument({ claimId: this.claimId, type: type });
        },
        deleteDocument: function deleteDocument(document) {
            if (this.requesting) {
                return;
            }
            this.deleteGeneratedDocument(document);
        },
        createComparisonSchedule: function createComparisonSchedule() {
            this.addDependantHeadOfLoss();
            this.showComparisonSchedule = true;
        },
        theDocument: function theDocument(index) {
            return this.findDocument(index);
        },
        requestInProgress: function requestInProgress() {
            return this.apiRouteRequestRunning('/api/v1/generated-documents/load');
        }
    })
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_WarningBox_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_WarningBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_WarningBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Typeahead__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Typeahead__);















/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])("fatal/dependency/claimDetails", {
    detailValue: "value"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])("fatal/dependency/dependencyOnIncome", {
    dependencyOnIncome: "getAll"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])("user", ["hideNames", "showNames"]), {
    claimantName: {
      get: function get() {
        return this.detailValue("claimantName");
      },
      set: function set(value) {
        this.updateDetail({ key: "claimantName", value: value }).then(this.updateValid.bind(this));
      }
    },
    claimantSolicitor: {
      get: function get() {
        return this.detailValue("claimantSolicitor");
      }
    },
    claimantReference: {
      get: function get() {
        return this.detailValue("claimantReference");
      },
      set: function set(value) {
        this.updateDetail({ key: "claimantReference", value: value }).then(this.updateValid.bind(this));
      }
    },
    yourReference: {
      get: function get() {
        return this.detailValue("yourReference");
      },
      set: function set(value) {
        this.updateDetail({ key: "yourReference", value: value }).then(this.updateValid.bind(this));
      }
    },
    defendantName: {
      get: function get() {
        return this.detailValue("defendantName");
      }
    },
    narrative: {
      get: function get() {
        return this.detailValue("claimNarrative");
      },
      set: function set(value) {
        this.updateDetail({ key: "claimNarrative", value: value }).then(this.updateValid.bind(this));
      }
    },
    diseaseOrAccident: {
      get: function get() {
        return this.detailValue("diseaseOrAccident");
      },
      set: function set(value) {
        var _this = this;

        this.updateDetail({ key: "diseaseOrAccident", value: value }).then(function () {
          if (_this.diseaseOrAccident === "disease") {
            _this.accidentType = null;
            _this.otherAccidentType = null;
          } else if (_this.diseaseOrAccident === "accident") {
            _this.diseaseType = null;
            _this.otherDiseaseType = null;
          }
        }).then(this.updateValid.bind(this));
      }
    },
    accidentType: {
      get: function get() {
        return this.detailValue("accidentType");
      },
      set: function set(value) {
        this.updateDetail({ key: "accidentType", value: value }).then(this.updateValid.bind(this));
      }
    },
    otherAccidentType: {
      get: function get() {
        return this.detailValue("otherAccidentType");
      },
      set: function set(value) {
        this.updateDetail({ key: "otherAccidentType", value: value }).then(this.updateValid.bind(this));
      }
    },
    diseaseType: {
      get: function get() {
        return this.detailValue("diseaseType");
      },
      set: function set(value) {
        this.updateDetail({ key: "diseaseType", value: value }).then(this.updateValid.bind(this));
      }
    },
    otherDiseaseType: {
      get: function get() {
        return this.detailValue("otherDiseaseType");
      },
      set: function set(value) {
        this.updateDetail({ key: "otherDiseaseType", value: value }).then(this.updateValid.bind(this));
      }
    },
    dateOfServiceProceedings: {
      get: function get() {
        return this.detailValue("serviceOfProceedings");
      },
      set: function set(value) {
        this.updateDetail({ key: "serviceOfProceedings", value: value }).then(this.updateValid.bind(this));
      }
    },
    dateOfAssumedSettlement: {
      get: function get() {
        return this.detailValue("assumedSettlement");
      },
      set: function set(value) {
        this.updateDetail({ key: "assumedSettlement", value: value }).then(this.updateValid.bind(this));
      }
    },
    preLitOrLit: {
      get: function get() {
        return this.detailValue("proceduralStatus");
      },
      set: function set(value) {
        this.updateDetail({ key: "proceduralStatus", value: value }).then(this.updateValid.bind(this));
      }
    },
    discountRate: {
      get: function get() {
        return this.detailValue("discountRate");
      },
      set: function set(value) {
        this.updateDetail({ key: "discountRate", value: value }).then(this.updateValid.bind(this));
      }
    },
    showServiceOfProceedingsValidationMessage_required: {
      get: function get() {
        if (!this.dateOfServiceProceedings || !this.dateOfAssumedSettlement) {
          return false;
        }

        return !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, "DD/MM/YYYY").isValid() || !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, "DD/MM/YYYY").isValid();
      }
    },
    showServiceOfProceedingsValidationMessage_9years: {
      get: function get() {
        if (this.showServiceOfProceedingsValidationMessage_required) {
          return false;
        }

        var mServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, "DD/MM/YYYY");
        var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, "DD/MM/YYYY");

        if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
          return false;
        }

        return mServiceOfProceedings.diff(mAssumedSettlement, "years") < -9;
      }
    },
    showServiceOfProceedingsValidationMessage_before: {
      get: function get() {
        if (this.showServiceOfProceedingsValidationMessage_required) {
          return false;
        }

        var mServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, "DD/MM/YYYY");
        var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, "DD/MM/YYYY");

        if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
          return false;
        }

        return !mServiceOfProceedings.isBefore(mAssumedSettlement);
      }
    },
    dateOfAssumedSettlementInPast: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_10_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, "DD/MM/YYYY"), "days") > 0;
      }
    },
    isValid: function isValid() {
      return this.$valid() && this.validServiceOfProceedings() && this.isValidAccidentOrDisease() && this.isValidClaimantSolicitor() && this.isValidDefendant();
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__["a" /* default */]],
  components: {
    Typeahead: __WEBPACK_IMPORTED_MODULE_11_components_Typeahead___default.a,
    StepButton: __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default.a,
    Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
    ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
    ControlWarning: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue___default.a,
    WarningBox: __WEBPACK_IMPORTED_MODULE_6_components_modal_WarningBox_vue___default.a,
    DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a
  },
  watch: {
    isValid: function isValid() {
      this.updateValid();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])("fatal/dependency/claimDetails", {
    updateDetail: "update"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])("fatal/dependency/proceduralDates", ["setIssueProceedings", "setServiceProceedings", "setAssumedSettlement", "setPreLitOrLit"]), {
    updateValid: function updateValid() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["b" /* setStepValid */])(this.isValid);
    },
    validServiceOfProceedings: function validServiceOfProceedings() {
      var mServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, "DD/MM/YYYY");
      var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, "DD/MM/YYYY");

      if (this.preLitOrLit === "pre-lit") {
        return true;
      }

      if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
        return false;
      }

      if (!mServiceOfProceedings.isBefore(mAssumedSettlement)) {
        return false;
      }

      return mServiceOfProceedings.diff(mAssumedSettlement, "years") >= -9;
    },
    isValidAccidentOrDisease: function isValidAccidentOrDisease() {
      if (this.diseaseOrAccident === "disease") {
        return this.diseaseType !== null && (this.diseaseType.substr(0, 5) === "Other" && this.otherDiseaseType !== null && this.otherDiseaseType.length >= 1 || this.diseaseType.substr(0, 5) !== "Other");
      }

      if (this.diseaseOrAccident === "accident") {
        return this.accidentType !== null && (this.accidentType.substr(0, 5) === "Other" && this.otherAccidentType !== null && this.otherAccidentType.length >= 1 || this.accidentType.substr(0, 5) !== "Other");
      }

      return false;
    },
    isValidClaimantSolicitor: function isValidClaimantSolicitor() {
      return this.claimantSolicitor && this.claimantSolicitor.name !== null && this.claimantSolicitor.name !== "";
    },
    isValidDefendant: function isValidDefendant() {
      return this.defendantName && this.defendantName.name !== null && this.defendantName.name !== "";
    },
    updateClaimantSolicitors: function updateClaimantSolicitors(value) {
      this.updateDetail({ key: "claimantSolicitor", value: value }).then(this.updateValid.bind(this));
    },
    updateDefendant: function updateDefendant(value) {
      this.updateDetail({ key: "defendantName", value: value }).then(this.updateValid.bind(this));
    }
  })
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_cru_benefits_GeneralDamages__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_cru_benefits_GeneralDamages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_cru_benefits_GeneralDamages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_cru_benefits_PastCostOfCare__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_cru_benefits_PastCostOfCare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_cru_benefits_PastCostOfCare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_cru_benefits_PastCostOfTravel__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_cru_benefits_PastCostOfTravel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_cru_benefits_PastCostOfTravel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_cru_benefits_PastLossOfEarnings__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_cru_benefits_PastLossOfEarnings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_cru_benefits_PastLossOfEarnings__);












/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Accordion: __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default.a,
        GeneralDamages: __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_cru_benefits_GeneralDamages___default.a,
        PastCostOfCare: __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_cru_benefits_PastCostOfCare___default.a,
        PastCostOfTravel: __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_cru_benefits_PastCostOfTravel___default.a,
        PastLossOfEarnings: __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_cru_benefits_PastLossOfEarnings___default.a
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('fatal/dependency/cru', ['allValid']),
    mounted: function mounted() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_routingMethods__["b" /* setStepValid */])(this.allValid);
    },

    watch: {
        allValid: function allValid() {
            this.update();
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', ['calcAllInterest']), {
        update: function update() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_routingMethods__["b" /* setStepValid */])(this.allValid);
            if (this.allValid) {
                this.calcAllInterest();
            }
        }
    })
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_Accordion_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_Accordion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_accordion_Accordion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Multipliers_vue__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Multipliers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Multipliers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Mutiplicand_vue__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Mutiplicand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Mutiplicand_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Income_vue__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Income_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Income_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);













/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Accordion: __WEBPACK_IMPORTED_MODULE_2_components_accordion_Accordion_vue___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem_vue___default.a,
        Income: __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Income_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue___default.a,
        Multiplicand: __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Mutiplicand_vue___default.a,
        Multipliers: __WEBPACK_IMPORTED_MODULE_4_pages_fatal_accident_claims_dependency_steps_dependency_on_income_Multipliers_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', {
        theDeceased: 'theDeceased',
        deceasedIncomeValid: 'theDeceasedIncomeValid'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/dependants', {
        dependants: 'dependants',
        dependantsIncomeValid: 'allDependantsIncomeValid',
        dependantIncomeValid: 'dependantIncomeValid',
        dependencyOnIncomeValid: 'getDependencyOnIncomeValid',
        hasSplitPeriods: 'hasSplitPeriods'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', ['value'])),
    data: function data() {
        return { valid: false };
    },
    mounted: function mounted() {
        this.updateValid();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/dependency/deceased', {
        updateDeceasedIncome: 'updateDeceasedIncome'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/dependency/dependants', {
        updateDependantIncome: 'updateDependantIncome'
    }), {
        updateTheDeceasedIncome: function updateTheDeceasedIncome(val) {
            this.updateDeceasedIncome(val).then(this.updateValid);
        },
        updateTheDependantIncome: function updateTheDependantIncome(val) {
            this.updateDependantIncome(val).then(this.updateValid);
        },
        updateValid: function updateValid() {
            if (typeof this.dependencyOnIncomeValid !== 'undefined') {
                this.valid = this.dependencyOnIncomeValid;
            } else {
                this.valid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["e" /* isStepValid */])(3);
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["b" /* setStepValid */])(this.valid);
            return this.valid;
        },
        determineAge: function determineAge(person) {
            return __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.value('assumedSettlement'), 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(person.dateOfBirth, 'DD/MM/YYYY'), 'years');
        }
    })
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_dependency_steps_dependency_on_services_Service_vue__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_dependency_steps_dependency_on_services_Service_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_dependency_steps_dependency_on_services_Service_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_Accordion_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_Accordion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_accordion_Accordion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_accordion_AccordionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);











/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin_js__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnServices', {
        services: 'all',
        allServicesProcessed: 'allServicesProcessed'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/dependency/step', {
        step: 'currentStep'
    }), {
        stepValid: {
            get: function get() {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_services_routingMethods__["b" /* setStepValid */])(this.allServicesProcessed && this.$valid());
                return this.allServicesProcessed && this.$valid();
            }
        }
    }),
    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_1_components_StepButton_vue___default.a,
        Service: __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_dependency_steps_dependency_on_services_Service_vue___default.a,
        Accordion: __WEBPACK_IMPORTED_MODULE_3_components_accordion_Accordion_vue___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_4_components_accordion_AccordionItem_vue___default.a
    },
    created: function created() {
        if (!this.services.length) {
            this.addService();
        } else {
            this.updateTheMultiplicand().then(this.reCalcServices.bind(this));
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('fatal/dependency/dependencyOnServices', {
        addService: 'add',
        reCalcServices: 'reCalcServices',
        updateTheMultiplicand: 'updateTheMultiplicand'
    }), {
        updateValid: function updateValid() {
            this.updateTheMultiplicand();

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_services_routingMethods__["b" /* setStepValid */])(this.allServicesProcessed && this.$valid());
        }
    })

});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_dependency_steps_heads_of_loss_HeadOfLoss_vue__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_dependency_steps_heads_of_loss_HeadOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_dependency_steps_heads_of_loss_HeadOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_heads_of_loss_CarePeriod_vue__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_heads_of_loss_CarePeriod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_heads_of_loss_CarePeriod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_dependency_steps_heads_of_loss_EarningsPeriod_vue__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_dependency_steps_heads_of_loss_EarningsPeriod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_dependency_steps_heads_of_loss_EarningsPeriod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_dependency_steps_general_damages_GeneralDamagesPslaCalculator__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_dependency_steps_general_damages_GeneralDamagesPslaCalculator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_dependency_steps_general_damages_GeneralDamagesPslaCalculator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_directives_TwoDecimalPlaces__ = __webpack_require__(11);




















/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue___default.a,
        HeadOfLoss: __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_dependency_steps_heads_of_loss_HeadOfLoss_vue___default.a,
        CarePeriod: __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_heads_of_loss_CarePeriod_vue___default.a,
        EarningsPeriod: __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_dependency_steps_heads_of_loss_EarningsPeriod_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default.a,
        GeneralDamagesPslaCalculator: __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_dependency_steps_general_damages_GeneralDamagesPslaCalculator___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_15_directives_TwoDecimalPlaces__["a" /* default */]
    },
    watch: {
        'generalDamages': function generalDamages(newVal, oldValue) {
            var _this = this;

            this.$nextTick(function () {
                _this.updateValid();
            });
        }
    },
    data: function data() {
        return {
            loading: false
        };
    },
    created: function created() {
        this.updateValid();
        this.determineBereavementAward();
    },
    mounted: function mounted() {
        this.updatePastDependencyOnServices();
        this.updateValid();
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', {
        findValue: 'value',
        headsOfLoss: 'headsOfLoss',
        allHeadsOfLossValid: 'allHeadsOfLossValid',
        periods: 'periods',
        pastLossOfEarningsPeriods: 'pastLossOfEarningsPeriods',
        allPeriodsValid: 'allPeriodsValid',
        pastLossOfEarningsPeriodsValid: 'pastLossOfEarningsPeriodsValid'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', {
        claimValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('modal', ['modals']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', ['theDeceased']), {
        diseaseType: {
            get: function get() {
                return this.claimValue('diseaseType');
            }
        },
        generalDamages: {
            get: function get() {
                return this.findValue('generalDamages');
            },
            set: function set(value) {
                this.updateValue({ key: 'generalDamages', value: value }).then(this.updateValid);
            }
        },
        funeralExpenses: {
            get: function get() {
                return this.findValue('funeralExpenses');
            },
            set: function set(value) {
                this.updateValue({ key: 'funeralExpenses', value: value }).then(this.updateValid);
            }
        },
        lossOfSpouse: {
            get: function get() {
                return this.findValue('lossOfSpouse');
            },
            set: function set(value) {
                this.updateValue({ key: 'lossOfSpouse', value: value }).then(this.updateValid);
            }
        },
        pastLossOfEarnings: {
            get: function get() {
                return this.findValue('pastLossOfEarnings');
            },
            set: function set(value) {
                this.updateValue({ key: 'pastLossOfEarnings', value: value }).then(this.updateValid);
            }
        },
        pastCostOfTravel: {
            get: function get() {
                return this.findValue('pastCostOfTravel');
            },
            set: function set(value) {
                this.updateValue({ key: 'pastCostOfTravel', value: value }).then(this.updateValid);
            }
        },
        misc: {
            get: function get() {
                return this.findValue('misc');
            },
            set: function set(value) {
                this.updateValue({ key: 'misc', value: value }).then(this.updateValid);
            }
        },
        careCalcType: {
            get: function get() {
                return this.findValue('careCalcType');
            },
            set: function set(value) {
                var _this2 = this;

                this.updateValue({ key: 'careCalcType', value: value }).then(this.updateValid);

                if (value !== 'own') {
                    this.updateValue({
                        key: 'ownCareFigure',
                        value: this.ownCareFigure || 0
                    });

                    if (!this.periods.length) {
                        this.addCarePeriod();
                    }
                }

                if (value === 'auto') {
                    this.loading = true;

                    return this.autoCalculateCare(this.findValue('gratuitousCare')).then(function () {
                        _this2.loading = false;
                    });
                }

                return this.updateValue({
                    key: 'pastCostOfCare',
                    value: 0
                });
            }
        },
        pastLossOfEarningsType: {
            get: function get() {
                return this.findValue('pastLossOfEarningsType');
            },
            set: function set(value) {
                this.updateValue({ key: 'pastLossOfEarningsType', value: value }).then(this.updateValid);
                if (value !== 'own') {
                    this.updateValue({
                        key: 'pastLossOfEarningsType',
                        value: this.pastLossOfEarningsType || 0
                    });

                    if (!this.pastLossOfEarningsPeriods.length) {
                        this.addLossOfEarningsPeriod();
                    }
                }
                return this.updateValue({
                    key: 'pastLossOfEarnings',
                    value: 0
                });
            }
        },
        gratuitousCare: {
            get: function get() {
                return this.findValue('gratuitousCare');
            },
            set: function set(value) {
                this.updateValue({ key: 'gratuitousCare', value: value }).then(this.updateValid);
                this.determineCalculateCare(value);
            }
        },
        ownCareFigure: {
            get: function get() {
                return this.findValue('ownCareFigure');
            },
            set: function set(value) {
                if (isNaN(value)) {
                    value = 0;
                }
                this.updateValue({ key: 'ownCareFigure', value: value }).then(this.updateValid);
                this.ownCalculateCare(this.findValue('gratuitousCare'));
            }
        },
        ownPastLossOfEarningsFigure: {
            get: function get() {
                return this.findValue('ownPastLossOfEarningsFigure');
            },
            set: function set(value) {
                if (isNaN(value)) {
                    value = 0;
                }
                this.updateValue({ key: 'ownPastLossOfEarningsFigure', value: value });
                this.updateValue({ key: 'pastLossOfEarnings', value: value }).then(this.updateValid);
            }
        },
        careIcon: {
            get: function get() {
                return this.findValue('careCalcType') === 'auto' ? 'formula' : 'default';
            }
        },
        bereavementModalPayload: function bereavementModalPayload() {
            return {
                person: this.theDeceased
            };
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', {
        updateValue: 'updateValue',
        calcInterest: 'calcAllInterest',
        addHeadOfLoss: 'addHeadOfLoss',
        addCarePeriod: 'addCarePeriod',
        addLossOfEarningsPeriod: 'addLossOfEarningsPeriod',
        autoCalculateCare: 'autoCalculateCare',
        ownCalculateCare: 'ownCalculateCare',
        determineBereavementAward: 'determineBereavementAward',
        updatePastDependencyOnServices: 'updatePastDependencyOnServices'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        calcInterestValue: function calcInterestValue() {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["e" /* isStepValid */])(6)) {
                this.calcInterest();
            }
        },
        determineCalculateCare: function determineCalculateCare(value) {
            if (this.findValue('careCalcType') === 'auto') {
                this.autoCalculateCare(value);
            } else if (this.findValue('careCalcType') === 'own') {
                this.ownCalculateCare(value);
            }
        },
        updateValid: function updateValid() {
            if (this.careCalcType === 'auto' || this.careCalcType === 'own') {
                this.validCare = this.allHeadsOfLossValid;
            }

            if (this.careCalcType === 'manual') {
                this.validCare = this.allHeadsOfLossValid && this.allPeriodsValid;
            }

            if (this.pastLossOfEarningsType === 'manual') {
                this.validPassLossOfEarnings = this.pastLossOfEarningsPeriodsValid;
            }

            if (this.pastLossOfEarningsType === 'own') {
                this.validPassLossOfEarnings = this.ownPastLossOfEarningsFigure !== null && this.ownPastLossOfEarningsFigure !== "";
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["b" /* setStepValid */])(this.$valid() && this.validCare && this.validPassLossOfEarnings);
        },
        isValid: function isValid() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["e" /* isStepValid */])(6);
        },
        toggleGeneralDamagesPslaModal: function toggleGeneralDamagesPslaModal() {
            this.toggle('generalDamagesPslaModal');
        },
        addNewHeadOfLoss: function addNewHeadOfLoss() {
            this.addHeadOfLoss();
            this.updateValid();
        }
    })
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_fatal_accident_claims_dependency_steps_interim_Payment_vue__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_fatal_accident_claims_dependency_steps_interim_Payment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pages_fatal_accident_claims_dependency_steps_interim_Payment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_InterestItem_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_InterestItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_InterestItem_vue__);



















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'InterimPaymentsAndInterest',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', ['value', 'headsOfLoss', 'getModalPayload']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/interimPayments', ['interimPayments', 'allInterimPaymentsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnIncome', {
        incomePre: 'preDependencyValue',
        incomePost: 'postDependencyValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', {
        deceasedValue: 'theDeceased'
    }), {
        deceasedDod: {
            get: function get() {
                return this.deceasedValue['dateOfDeath'];
            }
        },
        interestType: {
            get: function get() {
                return this.value('interestType');
            },
            set: function set(value) {
                this.setValue({ key: 'interestType', value: value });
            }
        },
        customInterestDate: {
            get: function get() {
                return this.value('customInterestDate');
            },
            set: function set(value) {
                this.setValue({ key: 'customInterestDate', value: value });
            }
        },
        payload: {
            get: function get() {
                return this.getModalPayload;
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    created: function created() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(true);
        this.calcInterestValue();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default.a,
        Payment: __WEBPACK_IMPORTED_MODULE_12_pages_fatal_accident_claims_dependency_steps_interim_Payment_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent_vue___default.a,
        InterestItem: __WEBPACK_IMPORTED_MODULE_15_components_InterestItem_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', {
        setValue: 'updateValue',
        updateInterest: 'calcNewValue',
        calcAllInterest: 'calcAllInterest',
        updateHeadOfLossValue: 'updateHeadOfLossValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/interimPayments', ['addPayment']), {
        calcInterestValue: function calcInterestValue() {
            this.calcAllInterest();
        },
        onUpdate: function onUpdate(info) {
            this.setValue({ key: info.updates, value: info.value }).then(this.calcAllInterest.bind(this));
        },
        onUpdateCustom: function onUpdateCustom(info) {
            this.updateHeadOfLossValue({ index: info.updates, value: info.value, key: 'interest' }).then(this.calcAllInterest.bind(this));
        },
        isValidDate: function isValidDate() {
            var mDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.customInterestDate, 'DD/MM/YYYY');
            return mDate.isValid() && mDate.isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.deceasedDod, 'DD/MM/YYYY'));
        }
    })
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TheDeceased',
    created: function created() {
        this.validDateOfProceedings();
        this.validOnsetOfSymptoms();
        this.validateDateOfDeath();
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', {
        claimDetailsValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', {
        deceasedValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/proceduralDates', ['date']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        theDeceased: function theDeceased() {
            var theDeceased = {};
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.util.extend(theDeceased, this.$store.getters['fatal/dependency/deceased/theDeceased']);
            return theDeceased;
        },

        levelOfEducation: {
            get: function get() {
                return this.claimDetailsValue('levelOfEducation');
            },
            set: function set(value) {
                this.updateTheClaim({ key: 'levelOfEducation', value: value });
            }
        },
        disabledAtAccident: {
            get: function get() {
                return this.claimDetailsValue('disabled');
            },
            set: function set(value) {
                this.updateTheClaim({ key: 'disabled', value: value });
            }
        },
        periodDeathToSettlement: function periodDeathToSettlement() {
            return this.deceasedValue('periodDeathToSettlement');
        },
        ageAtSettlement: function ageAtSettlement() {
            return this.deceasedValue('ageAtSettlement');
        },
        reductionInLifeExpectancy: function reductionInLifeExpectancy() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(this.theDeceased.lifeExpectancy.ageAtDeath - this.theDeceased.ageAtDeath > 0);
            return this.theDeceased.lifeExpectancy.ageAtDeath - this.theDeceased.ageAtDeath;
        },
        assumedSettlement: function assumedSettlement() {
            return this.claimDetailsValue('assumedSettlement');
        },
        dateOfServiceProceedings: function dateOfServiceProceedings() {
            return this.claimDetailsValue('serviceOfProceedings');
        },
        preLitOrLit: function preLitOrLit() {
            return this.claimDetailsValue('proceduralStatus');
        },
        periodBetweenOnsetAndDod: function periodBetweenOnsetAndDod() {
            if (this.theDeceased.dateOfDeath === null || this.theDeceased.onsetOfSymptoms === null) {
                return null;
            }

            return (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'), 'days') / 365.25).toFixed(2);
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_3_components_LifeExpectancy_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default.a
    },
    watch: {
        '$form.$valid': function $form$valid(val) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(val);
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/claimDetails', {
        updateTheClaim: 'update'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/deceased', {
        updateTheDeceased: 'updateTheDeceased',
        updateTheDeceasedLifeExpectancy: 'updateTheDeceasedLifeExpectancy'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency', ['checkToUpdateMultipliers']), {
        updateLife: function updateLife(lifeExpectancy) {
            this.updateTheDeceasedLifeExpectancy({ lifeExpectancy: lifeExpectancy }).then(this.update.bind(this));
        },
        update: function update() {
            this.updateTheDeceased(this.theDeceased);
            this.checkToUpdateMultipliers();
            this.validateDateOfDeath();
            this.validateReductionInLife();
        },
        updateRetiredAtDeath: function updateRetiredAtDeath(event) {
            if (this.theDeceased.income.retired == 'true') {
                this.disabledAtAccident = 0;
            }
        },
        validDateOfProceedings: function validDateOfProceedings() {
            if (!this.theDeceased.dateOfDeath || this.claimDetailsValue.proceduralStatus !== 'litigated') {
                return true;
            }
            var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
            return this.preLitOrLit === 'litigated' ? mDateOfDeath.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY')) : true;
        },
        validDateOfDeathOnsetOfSymptoms: function validDateOfDeathOnsetOfSymptoms() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
            return mDateOfDeath.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'));
        },
        validOnsetOfSymptoms: function validOnsetOfSymptoms() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            var mDateOfBirth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfBirth, 'DD/MM/YYYY');
            return mDateOfBirth.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'));
        },
        validDateOfBirth: function validDateOfBirth() {
            if (!this.theDeceased.dateOfBirth) {
                return true;
            }
            var mDateOfBirth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfBirth, 'DD/MM/YYYY');
            return mDateOfBirth.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(18, 'years'));
        },
        validDateOfDeath: function validDateOfDeath() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
            return mDateOfDeath.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.assumedSettlement, 'DD/MM/YYYY'));
        },
        validDateOfDeathCurrent: function validDateOfDeathCurrent() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(), 'day');
        },
        validDateOfDeathDurtaion: function validDateOfDeathDurtaion() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
            return mDateOfDeath.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.assumedSettlement, 'DD/MM/YYYY').subtract(9, 'years'));
        },
        validateDateOfDeath: function validateDateOfDeath() {
            if (!this.theDeceased.dateOfDeath) {
                return false;
            }
            var valid = this.validOnsetOfSymptoms() && this.validDateOfProceedings() && this.validDateOfDeath() && this.validDateOfDeathDurtaion() && this.validDateOfDeathCurrent();

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(valid);
            return valid;
        },
        validateReductionInLife: function validateReductionInLife() {
            if (this.reductionInLifeExpectancy < 0) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(false);
                return false;
            }

            return true;
        },
        isValid: function isValid() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["e" /* isStepValid */])(2);
        }
    })
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_dependency_steps_dependants_Dependant_vue__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_dependency_steps_dependants_Dependant_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_dependency_steps_dependants_Dependant_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);










/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */]],
    components: {
        Dependant: __WEBPACK_IMPORTED_MODULE_3_pages_fatal_accident_claims_dependency_steps_dependants_Dependant_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/dependants', {
        dependants: 'dependants',
        valid: 'allDependantsValid'
    })),
    watch: {
        '$form.$valid': function $form$valid() {
            this.updateValid();
        },
        'valid': function valid() {
            this.updateValid();
        }
    },
    created: function created() {
        if (!this.dependants.length) {
            this.addDependant();
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('fatal/dependency/dependants', ['addDependant']), {
        add: function add() {
            var _this = this;

            this.addDependant().then(function () {
                _this.$nextTick(function () {
                    _this.updateValid();
                });
            });
        },
        updateValid: function updateValid() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.valid && this.$valid());
        },
        isValid: function isValid() {
            return this.$valid() && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["e" /* isStepValid */])(3);
        }
    })
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'dependant',
    props: ['index', 'stepValid'],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_roundValue__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', {
        'claimDetails': 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('fatal/dependency/dependants', {
        findDependant: 'findDependant',
        durationOfDependency: 'durationOfDependency',
        getPreTrialDependency: 'preTrialDependency'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', ['theDeceased', 'theDeceasedLifeExpectancy']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        deceasedDateOfDeath: {
            get: function get() {
                return this.theDeceasedLifeExpectancy['dateOfDeath'];
            }
        },
        theDependant: function theDependant() {
            var theDependant = {};
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.util.extend(theDependant, this.findDependant(this.index));
            return theDependant;
        },
        dependency: function dependency() {
            return this.durationOfDependency(this.index);
        },
        endOfDependencyDuration: function endOfDependencyDuration() {
            return this.roundValue(this.dependency.duration, 2);
        },
        age: function age() {
            if (this.theDependant.dateOfBirth) {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.theDependant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
            }
        },
        ageAtDeceasedDod: function ageAtDeceasedDod() {
            if (this.theDependant.dateOfBirth) {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.theDependant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
            }
        },
        ageAtAssumedSettlement: function ageAtAssumedSettlement() {
            if (this.theDependant.dateOfBirth) {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.claimDetails('assumedSettlement'), 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.theDependant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
            }
        },
        ageAtDeceasedButForDod: function ageAtDeceasedButForDod() {
            if (this.theDependant.dateOfBirth) {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.deceasedDateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.theDependant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('fatal/dependency/dependants', ['updateDependant', 'updateDependantLifeExpectancy', 'deleteDependant', 'updateDependantYouth']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('fatal/dependency', ['checkToUpdateMultipliers']), {
        deleteThisDependant: function deleteThisDependant() {
            this.deleteDependant(this.index);
        },
        update: function update() {
            this.updateDependant({ index: this.index, dependant: this.theDependant });
        },
        updateLife: function updateLife(lifeExpectancy) {
            var _this = this;

            this.updateDependantLifeExpectancy({ index: this.index, lifeExpectancy: lifeExpectancy }).then(function () {
                if (lifeExpectancy.method === 'enter_date' && (lifeExpectancy.dateOfDeathIsAssumed === "" || lifeExpectancy.dateOfDeathIsAssumed === null)) {
                    return;
                }
                _this.update();
                _this.checkToUpdateMultipliers();
            });
        },
        endOfDependencyValid: function endOfDependencyValid() {
            var valid = this.dependency.duration && this.roundValue(this.dependency.duration, 2) > 0.1 && this.dependency.duration !== null;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["b" /* setStepValid */])(this.$valid() && valid);

            return valid;
        }
    })
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_dependency_on_income_IncomePeriod_vue__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_dependency_on_income_IncomePeriod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_dependency_on_income_IncomePeriod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_WarningBox_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_WarningBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_WarningBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mixins_roundValue__ = __webpack_require__(19);


















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'income',
    props: {
        name: {
            type: String,
            required: true
        },
        income: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: null
        },
        person: {
            type: Object,
            required: true
        },
        tooltipValue: {
            type: String,
            default: null
        }
    },
    mounted: function mounted() {
        if (!this.income.periods.length) {
            this.index !== null ? this.addDependantIncomePeriod({ index: this.index }) : this.addDeceasedIncomePeriod();
        }

        this.calcRetirementData();
    },

    components: {
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default.a,
        IncomePeriod: __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_dependency_steps_dependency_on_income_IncomePeriod_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue___default.a,
        WarningBox: __WEBPACK_IMPORTED_MODULE_13_components_modal_WarningBox_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_9_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_mixins_roundValue__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('http', {
        loading: 'running'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', {
        claimDetailsValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', ['value', 'theDeceasedLifeExpectancy', 'theDeceasedIncomeValid', 'theDeceasedIncome']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/dependants', ['allDependantsIncomeValid', 'allDependantsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnIncome', ['durationOfDependency']), {
        startOfPeriod: function startOfPeriod() {
            return this.value('dateOfDeath');
        },
        endOfPeriod: function endOfPeriod() {
            return this.index !== null ? this.durationOfDependency(this.index).date : this.theDeceasedLifeExpectancy['dateOfDeath'];
        },
        innerIncome: function innerIncome() {
            var income = {};
            __WEBPACK_IMPORTED_MODULE_2_vue___default.a.util.extend(income, this.income);
            if (!income.retirementAgeCalc) {
                __WEBPACK_IMPORTED_MODULE_2_vue___default.a.set(income, 'retirementAgeCalc', 'manual');
            }

            return income;
        },

        employedAtDateOfDeath: {
            get: function get() {
                return this.person.employedAtDateOfDeath;
            },
            set: function set(value) {
                this.updatePerson('employedAtDateOfDeath', value).then(this.updateIncomeRelated.bind(this));
            }
        },
        levelOfEducation: {
            get: function get() {
                return this.person.levelOfEducation;
            },
            set: function set(value) {
                this.updatePerson('levelOfEducation', value).then(this.updateIncomeRelated.bind(this));
            }
        },
        retirementAge: {
            get: function get() {
                return this.innerIncome.retirementAge;
            },
            set: function set(value) {
                this.innerIncome.retirementAge = value;
                this.innerIncome.retirementDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.person.dateOfBirth, 'DD/MM/YYYY').add(value, 'years').format('DD/MM/YYYY');
            }
        },
        retirementDate: {
            get: function get() {
                return this.innerIncome.retirementDate;
            },
            set: function set(value) {
                this.innerIncome.retirementDate = value;
                this.innerIncome.retirementAge = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.person.dateOfBirth, 'DD/MM/YYYY'), 'years');
                this.updateIncomeRelated();
            }
        },
        retiredAtDeath: {
            get: function get() {
                return !!this.innerIncome.retired;
            },
            set: function set(value) {
                this.innerIncome.retired = value;
                this.updateIncomeRelated();
            }
        },
        disabledAtAccident: {
            get: function get() {
                return this.person.disabledAtAccident;
            },
            set: function set(value) {
                this.updatePerson('disabledAtAccident', value).then(this.updateIncomeRelated.bind(this));
            }
        },
        retirementAgeCalc: {
            get: function get() {
                return this.innerIncome.retirementAgeCalc;
            },
            set: function set(value) {
                this.innerIncome.retirementAgeCalc = value;
                this.updateIncomeRelated();
            }
        },
        contingencyMultiplier: {
            get: function get() {
                return this.innerIncome.contingencyMultiplier;
            },
            set: function set(value) {
                this.innerIncome.contingencyMultiplier = value;

                if (!value) {
                    this.innerIncome.multiplier = 1;
                }

                this.updateIncomeRelated();
            }
        },
        theMultiplier: {
            get: function get() {
                return this.innerIncome.multiplier;
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },

        retired: {
            get: function get() {
                return this.innerIncome.retired;
            },
            set: function set(value) {
                this.innerIncome.retired = value;
                this.updateIncomeRelated();
            }
        },
        assumedSettlement: {
            get: function get() {
                return this.claimDetailsValue('dateOfAssumedSettlement');
            }
        },
        ageAtTrial: function ageAtTrial() {
            var dateOfTrial = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.assumedSettlement, 'DD/MM/YYYY');
            var dateOfBirth = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.person.dateOfBirth, 'DD/MM/YYYY');
            return this.roundValue(dateOfTrial.diff(dateOfBirth, 'days') / 365.25, 2);
        },
        contingencyMultiplierPayload: function contingencyMultiplierPayload() {
            return {
                person: this.person,
                assumedSettlement: this.assumedSettlement
            };
        },
        showResult: function showResult() {
            return !this.retired && this.contingencyMultiplier && this.employedAtDateOfDeath !== null && this.levelOfEducation !== null && this.disabledAtAccident !== null;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/claimDetails', {
        updateTheClaim: 'update'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/dependencyOnIncome', ['updateAllIncome']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/deceased', ['addDeceasedIncomePeriod', 'updateRetirementAgeAndDate', 'updateDeceasedIncomePeriod', 'removeDeceasedInvalidPeriodAndAddDefaults', 'updateTheDeceasedValue', 'calculateLossOfEarnings']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/dependants', ['addDependantIncomePeriod', 'updateDependantIncomePeriod', 'removeDependantInvalidPeriodAndAddDefaults', 'updateDependencyOnIncomeValid', 'updateDependantRetirementAgeAndDate', 'updateDependant']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        updateRetirementPeriods: function updateRetirementPeriods() {
            var prom = this.index === null ? this.removeDeceasedInvalidPeriodAndAddDefaults() : this.removeDependantInvalidPeriodAndAddDefaults({ dependantIndex: this.index });
            prom.then(this.calcRetirementData.bind(this));
        },
        updatePeriod: function updatePeriod(payload) {
            (this.index === null ? this.updateDeceasedIncomePeriod(payload) : this.updateDependantIncomePeriod(payload)).then(this.callAction);

            this.updateDependencyOnIncomeValid(this.theDeceasedIncomeValid && this.allDependantsValid);
        },
        addPeriod: function addPeriod() {
            (this.index === null ? this.addDeceasedIncomePeriod() : this.addDependantIncomePeriod({ index: this.index })).then(this.callAction);
        },
        callAction: function callAction() {
            return this.$emit('action', { income: this.innerIncome, index: this.index });
        },
        resetContingency: function resetContingency() {
            this.contingencyMultiplier = false;
            this.employedAtDateOfDeath = null;
            this.levelOfEducation = null;
            this.disabledAtAccident = null;
        },
        updateEmployed: function updateEmployed() {
            if (this.retired) {
                this.resetContingency();
            }
            this.updateIncomeRelated();
        },
        updateContingency: function updateContingency() {
            if (!this.contingencyMultiplier) {
                this.resetContingency();
            }
            this.updateIncomeRelated();
        },
        updateIncomeAndMultipliers: function updateIncomeAndMultipliers() {
            var _this = this;

            if (this.showResult) {
                this.calculateLossOfEarnings().then(function () {
                    _this.updateAllIncome({ income: _this.innerIncome, index: _this.index, type: _this.name });
                });
            }
            this.updateAllIncome({ income: this.innerIncome, index: this.index, type: this.name });
        },
        updateIncomeRelated: function updateIncomeRelated() {
            this.callAction();
            this.updateIncomeAndMultipliers.bind(this);
        },
        calcRetirementData: function calcRetirementData() {
            this.name === "Deceased" ? this.updateRetirementAgeAndDate() : this.updateDependantRetirementAgeAndDate({ index: this.index });
        },
        updatePerson: function updatePerson(key, value) {
            if (this.name === "Deceased") {
                return this.updateTheDeceasedValue({
                    key: key, value: value, force: true
                });
            }
            return this.updateDependant({
                index: this.index,
                dependant: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, value)
            });
        }
    })
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_dependency_on_income_income_period_mixin__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'income-period',
    components: {
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_7_components_IconTooltip_vue___default.a
    },
    props: {
        retired: {
            type: Boolean,
            default: false
        },
        retirementDate: {
            default: ""
        },
        index: {
            type: Number,
            default: 0
        },
        maxIndex: {
            type: Number,
            default: 0
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_8_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_dependency_steps_dependency_on_income_income_period_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', ['theDeceased', 'getDeceasedIncomePeriod', 'getDeceasedIncomeStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('fatal/dependency/dependants', {
        findDependant: 'theDependant',
        getNoOfDependantPeriods: 'getNoOfDependantPeriods',
        getDependantIncomePeriod: 'getDependantIncomePeriod',
        getDependantIncomeStatus: 'getDependantIncomeStatus'
    }), {
        loading: {
            get: function get() {
                return this.getDeceasedIncomeStatus || this.getDependantIncomeStatus;
            }
        },
        endOfPeriodRules: function endOfPeriodRules() {
            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY'))) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.lifeExpectancy.dateOfDeath, 'DD/MM/YYYY'))) {
                return false;
            }
            return true;
        },
        incomeRules: function incomeRules() {
            if (this.retired) {
                return this.innerPeriod.pensionIncome < 1 ? false : true;
            }

            return this.innerPeriod.employmentIncome < 1 && this.innerPeriod.pensionIncome < 1 ? false : true;
        },
        endValid: function endValid() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY'));
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('fatal/dependency/deceased', ['addDeceasedIncomePeriod', 'updateDeceasedIncomePeriodValue', 'deleteDeceasedIncomePeriod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('fatal/dependency/dependants', ['addDependantIncomePeriod', 'updateDependantIncomePeriodValue', 'deleteDependantIncomePeriod']), {
        updatePeriod: function updatePeriod() {
            this.$emit('update', { index: this.index, period: this.innerPeriod, dependant: this.findDependant(this.dependant), deceased: this.theDeceased, dependantIndex: this.dependant });
        },
        deletePeriod: function deletePeriod() {
            var maxIndex = this.maxIndex - 1;

            if (this.dependant === null) {
                var prevIndex = this.index - 1;
                var nextIndex = this.index + 1;
                var nextPeriodEndOfPeriod = this.getDeceasedIncomePeriod(prevIndex).endOfPeriod;
                var nextDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(nextPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                if (this.index === maxIndex) {
                    this.updateDeceasedIncomePeriodValue({ index: prevIndex, key: 'endOfPeriod', value: this.theDeceased.lifeExpectancy.dateOfDeath });
                } else {
                    this.updateDeceasedIncomePeriodValue({ index: nextIndex, key: 'startOfPeriod', value: nextDay });
                }
                this.deleteDeceasedIncomePeriod({ index: this.index });
            } else {
                var _prevIndex = this.index - 1;
                var _nextIndex = this.index + 1;
                var prevPeriodEndOfPeriod = this.getDependantIncomePeriod(this.dependant, _prevIndex).endOfPeriod;
                var _nextDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                if (this.index === maxIndex) {
                    this.updateDependantIncomePeriodValue({ index: _prevIndex, key: 'endOfPeriod', value: this.theDeceased.lifeExpectancy.dateOfDeath, dependant: this.findDependant(this.dependant), dependantIndex: this.dependant });
                } else {
                    this.updateDependantIncomePeriodValue({ index: _nextIndex, key: 'startOfPeriod', value: _nextDay, dependant: this.findDependant(this.dependant), dependantIndex: this.dependant });
                }

                this.deleteDependantIncomePeriod({ index: this.index, dependant: this.findDependant(this.dependant), dependantIndex: this.dependant });
            }
        },
        updateNextPeriod: function updateNextPeriod() {
            var maxIndex = this.maxIndex - 1;
            var dependantMaxIndex = null;

            this.updatePeriod();

            if (!this.endValid) {
                return;
            }


            if (this.index < maxIndex) {

                var nextIndex = this.index + 1;
                var nextDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                this.dependant === null ? this.updateDeceasedIncomePeriodValue({
                    index: nextIndex,
                    key: 'startOfPeriod',
                    value: nextDay
                }) : this.updateDependantIncomePeriodValue({
                    index: nextIndex,
                    key: 'startOfPeriod',
                    value: nextDay,
                    dependant: this.findDependant(this.dependant),
                    dependantIndex: this.dependant
                });

                for (var i = nextIndex, len = maxIndex; i <= len; i++) {

                    var prevPeriodEndOfPeriod = '';
                    var periodEndOfPeriod = '';
                    var periodStartOfPeriod = '';

                    if (this.dependant === null) {
                        prevPeriodEndOfPeriod = this.getDeceasedIncomePeriod(i - 1).endOfPeriod;
                        periodEndOfPeriod = this.getDeceasedIncomePeriod(i).endOfPeriod;
                        periodStartOfPeriod = this.getDeceasedIncomePeriod(i).startOfPeriod;
                    } else {
                        prevPeriodEndOfPeriod = this.getDependantIncomePeriod(this.dependant, i - 1).endOfPeriod;
                        periodEndOfPeriod = this.getDependantIncomePeriod(this.dependant, i).endOfPeriod;
                        periodStartOfPeriod = this.getDependantIncomePeriod(this.dependant, i).startOfPeriod;
                    }

                    if (prevPeriodEndOfPeriod > periodStartOfPeriod) {
                        periodStartOfPeriod = __WEBPACK_IMPORTED_MODULE_2_moment___default()(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
                        this.dependant === null ? this.updateDeceasedIncomePeriodValue({
                            index: i,
                            key: 'startOfPeriod',
                            value: periodStartOfPeriod
                        }) : this.updateDependantIncomePeriodValue({
                            index: i,
                            key: 'startOfPeriod',
                            value: periodStartOfPeriod,
                            dependant: this.findDependant(this.dependant),
                            dependantIndex: this.dependant
                        });
                    }

                    if (periodEndOfPeriod <= periodStartOfPeriod && i !== len) {
                        this.dependant === null ? this.updateDeceasedIncomePeriodValue({
                            index: i,
                            key: 'endOfPeriod',
                            value: periodStartOfPeriod
                        }) : this.updateDependantIncomePeriodValue({
                            index: i,
                            key: 'endOfPeriod',
                            value: periodStartOfPeriod,
                            dependant: this.findDependant(this.dependant),
                            dependantIndex: this.dependant
                        });
                    }
                }
            }

            if (this.dependant !== null) {
                dependantMaxIndex = this.getNoOfDependantPeriods(this.dependant) - 1;
            }

            if (this.dependant === null) {
                if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.lifeExpectancy.dateOfDeath, 'DD/MM/YYYY')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY')) && this.index === maxIndex) {
                    this.addDeceasedIncomePeriod();
                }
            } else if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.lifeExpectancy.dateOfDeath, 'DD/MM/YYYY')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY')) && this.index === dependantMaxIndex) {
                this.addDependantIncomePeriod({ index: this.dependant });
            }
        }
    })
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_formatServerDate__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'multipliers',
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_mixins_formatServerDate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_mixins_dateFormat__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/proceduralDates', {
        procDate: 'date'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', {
        claimDetails: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', {
        deceasedDetails: 'value',
        theDeceased: 'theDeceased',
        theDeceasedNetIncome: 'theDeceasedNetIncome',
        theDeceasedGrossIncome: 'theDeceasedGrossIncome'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/dependants', ['dependantNetIncome']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnIncome', {
        multipliers: 'getAll',
        multiplierTable: 'table28',
        multiplierTable1and2: 'table1and2',
        preDependencyValue: 'preDependencyValue',
        postDependencyValue: 'postDependencyValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', {
        detailValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/multiplicand', {
        multiplicandTotal: 'determineTotal',
        theMultiplicand: 'theMultiplicand'
    }), {
        periodSettlementToEnd: {
            get: function get() {
                return this.multipliers.durationOfDependency;
            }
        },
        discountRate: {
            get: function get() {
                return this.detailValue('discountRate');
            },
            set: function set(value) {
                this.updateDetail({ key: 'discountRate', value: value });
                return this.updateDiscountTable(this.multipliers.discountTable);
            }
        },
        discountTable: {
            get: function get() {
                return this.multipliers.discountTable;
            },
            set: function set(value) {
                return this.updateDiscountTable(value);
            }
        },
        table1Or2Label: {
            get: function get() {
                return 'Ogden Table ' + (this.theDeceased.gender === 'female' ? 2 : 1) + ' Multiplier';
            }
        },
        calculatedIncomeDependency: {
            get: function get() {
                return this.preDependencyValue + this.postDependencyValue;
            }
        },
        multiplierPayload: function multiplierPayload() {
            return {
                assumedSettlement: this.claimDetails('assumedSettlement'),
                person: this.theDeceased,
                discountRate: this.discountRate,
                duration: this.periodSettlementToEnd
            };
        },
        preAndPostAssessmentPayload: function preAndPostAssessmentPayload() {
            return {
                assumedSettlement: this.claimDetails('assumedSettlement'),
                person: this.theDeceased
            };
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('fatal/dependency/dependencyOnIncome', ['updateDiscountTable']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('fatal/dependency/claimDetails', {
        updateDetail: 'update'
    }))
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'multiplicand',
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/dependants', {
        dependantsNetIncome: 'dependantNetIncome',
        dependantGrossIncome: 'dependantGrossIncome',
        hasMultipleDependants: 'hasMultipleDependants'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', {
        theDeceasedNetIncome: 'theDeceasedNetIncome',
        theDeceasedGrossIncome: 'theDeceasedGrossIncome',
        theDeceased: 'theDeceased'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/dependency/multiplicand', {
        theMultiplicand: 'theMultiplicand'
    }), {
        innerMultiplicand: function innerMultiplicand() {
            return _.cloneDeep(this.theMultiplicand);
        }
    }),
    components: { control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a },
    watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'innerMultiplicand.percentage', function innerMultiplicandPercentage() {
        this.updateMultiplicand();
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('fatal/dependency/multiplicand', {
        adjustTheMultiplicand: 'adjustTheMultiplicand'
    }), {
        updateMultiplicand: function updateMultiplicand() {
            if (this.innerMultiplicand.method === 'multiplicand_default') {
                this.innerMultiplicand.percentage = '';
                this.innerMultiplicand.user = '';
            }
            this.adjustTheMultiplicand(this.innerMultiplicand);
        }
    })
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'service',
    props: ['index'],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_4_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__["a" /* default */]],
    mounted: function mounted() {
        if (this.table) {
            this.update();
        }
    },
    created: function created() {
        this.updateValid();
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnIncome', {
        dependencyOnIncome: 'getAll'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('fatal/dependency/claimDetails', {
        detailValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', ['theDeceased']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('http', ['running']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('fatal/dependency/dependencyOnServices', {
        findService: 'find',
        findTable: 'table',
        allServicesProcessed: 'allServicesProcessed',
        getServicesStatus: 'getServicesStatus'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('fatal/dependency/dependants', ['preTrialDependency']), {
        loading: {
            get: function get() {
                return this.getServicesStatus;
            }
        },
        service: function service() {
            var service = {};
            __WEBPACK_IMPORTED_MODULE_6_vue___default.a.util.extend(service, this.findService(this.index));
            return service;
        },
        table: function table() {
            return this.findTable(this.index);
        },

        table1Or2Label: {
            get: function get() {
                return 'Ogden Table ' + (this.theDeceased.gender === 'female' ? 2 : 1) + ' Multiplier';
            }
        },
        discountRate: {
            get: function get() {
                return this.detailValue('discountRate');
            },
            set: function set(value) {
                this.updateDetail({ key: 'discountRate', value: value });
                return this.updateDiscountTable(this.dependencyOnIncome.discountTable);
            }
        },
        discountTable: {
            get: function get() {
                return this.dependencyOnIncome.discountTable;
            },
            set: function set(value) {
                return this.updateDiscountTable(value);
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },
        calculatedServices: function calculatedServices() {
            return this.table ? this.table.pre.dependencyValue + this.table.post.dependencyValue : 0;
        },
        servicesEndOfDependencyRules: function servicesEndOfDependencyRules() {
            return "min:" + this.theDeceased.dateOfDeath + '|' + "max:" + this.theDeceased.lifeExpectancy.dateOfDeath;
        },

        durationMask: {
            get: function get() {
                return this.service.durationType === 'life';
            },
            set: function set(value) {
                if (value) {
                    this.service.durationType = 'life';
                } else if (this.service.durationType === 'life') {
                    this.service.durationType = 'years_and_months';
                }
                this.update();
            }
        },
        preAndPostAssessmentPayload: function preAndPostAssessmentPayload() {
            return {
                assumedSettlement: this.detailValue('assumedSettlement'),
                person: this.theDeceased
            };
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('fatal/dependency/dependencyOnServices', {
        addService: 'add',
        updateService: 'update',
        deleteService: 'deleteService'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('fatal/dependency', ['checkToUpdateMultipliers']), {
        deleteThisService: function deleteThisService() {
            return this.deleteService(this.index).then(this.updateValid);
        },
        update: function update() {
            this.updateService({ index: this.index, service: this.service }).then(this.updateValid).then(this.checkToUpdateMultipliers);
        },
        updateValid: function updateValid() {
            this.$emit('check');
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('fatal/dependency/claimDetails', {
        updateDetail: 'update'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('fatal/dependency/dependencyOnIncome', ['updateDiscountTable']), {
        servicesTableUpdating: function servicesTableUpdating() {
            return this.apiRouteRequestRunning('/api/v1/calculators/monetary/services/table');
        }
    })

});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_slider_component__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_dependency_steps_general_damages_PslaAward__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_dependency_steps_general_damages_PslaAward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_dependency_steps_general_damages_PslaAward__);


















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'general-damages-psla-calculator',
    data: function data() {
        return {
            calculatedDurationOfSymptoms: 0,
            loading: {
                table: false,
                awards: false
            },
            upliftButton: true,
            uplift: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', { theDeceased: 'theDeceased' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('psla', { pslaValue: 'value' }), {
        table: {
            get: function get() {
                return this.pslaValue('table');
            }
        },
        awards: {
            get: function get() {
                return this.pslaValue('awards');
            }
        },
        filteredAwards: function filteredAwards() {
            var _this = this;

            if (!this.awards.length) {
                return [];
            }
            return this.awards.map(function (award) {
                var score = Math.abs(_this.ageAtDeath - award.age) + Math.abs(_this.calculatedDurationOfSymptoms - award.duration);
                return { score: score, award: award };
            }).sort(function (a, b) {
                if (a.score === b.score) {
                    return 0;
                }
                return a.score - b.score;
            }).map(function (info) {
                return info.award;
            }).slice(0, 10);
        },

        dateOfBirth: {
            get: function get() {
                return this.theDeceased.dateOfBirth;
            }
        },
        ageAtDeath: {
            get: function get() {
                return this.theDeceased.ageAtDeath;
            }
        },
        upperAge: {
            get: function get() {
                var _this2 = this;

                var upperAge = this.ages.reverse().filter(function (age) {
                    return age <= _this2.ageAtDeath;
                });

                if (!upperAge || upperAge.length < 1) {
                    return this.ages.reverse()[0];
                }

                return upperAge[0];
            }
        },
        ages: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.table);
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.theDeceased.dateOfDeath;
            }
        },
        onsetOfSymptoms: {
            get: function get() {
                return this.theDeceased.onsetOfSymptoms;
            }
        },
        durationOfSymptoms: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.onsetOfSymptoms, 'DD/MM/YYYY'), 'months');
            }
        },
        currentRpi: {
            get: function get() {
                return this.pslaValue('currentRpi');
            }
        }
    }),
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default.a,
        VueSlider: __WEBPACK_IMPORTED_MODULE_13_vue_slider_component___default.a,
        PslaAward: __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_dependency_steps_general_damages_PslaAward___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__["a" /* default */]],
    created: function created() {
        this.loadTableCheck();
        this.loadAwardsCheck();
        this.calculatedDurationOfSymptoms = this.durationOfSymptoms;
        this.loadCurrentRpi();
    },

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('psla', ['loadTable', 'loadAwards', 'loadCurrentRpi']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', { updateValue: 'updateValue' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        loadTableCheck: function loadTableCheck() {
            var _this3 = this;

            if (!this.table.length) {
                this.loading.table = true;
                this.loadTable().then(function () {
                    _this3.loading.table = false;
                });
            }
        },
        loadAwardsCheck: function loadAwardsCheck() {
            var _this4 = this;

            if (!this.awards.length) {
                this.loading.awards = true;
                this.loadAwards().then(function () {
                    _this4.loading.awards = false;
                });
            }
        },
        isExactMatch: function isExactMatch(index, age) {
            return this.isColMatch(index) && this.isRowMatch(age);
        },
        isColMatch: function isColMatch(index) {
            index++;

            if (index === 1 && this.calculatedDurationOfSymptoms <= 3) {
                return true;
            }

            if (index === 13 && this.calculatedDurationOfSymptoms >= 37) {
                return true;
            }

            return this.calculatedDurationOfSymptoms >= index * 3 - 2 && this.calculatedDurationOfSymptoms <= index * 3;
        },
        isRowMatch: function isRowMatch(age) {
            return this.upperAge === age;
        },
        getTariffTableTdStyle: function getTariffTableTdStyle(index, age) {
            if (this.isExactMatch(index, age)) {
                return 'cursor: pointer; background:#c5ecfe; font-weight: bold; font-size: 14px;';
            }

            if (this.isColMatch(index) || this.isRowMatch(age)) {
                return 'cursor: pointer; background:#c5ecfe; font-size: 14px;';
            }

            return 'cursor: pointer; font-size: 14px;';
        },
        applyUplift: function applyUplift() {
            this.upliftButton = !this.upliftButton;
            this.uplift = !this.uplift;
        },
        usePslaAward: function usePslaAward(value) {
            this.updateValue({ key: 'generalDamages', value: value });
            this.toggle('generalDamagesPslaModal');
        }
    })
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'psla-award',
    props: {
        award: {
            type: Object,
            required: true
        },
        showButtons: {
            type: Boolean,
            default: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */]],
    mounted: function mounted() {
        this.loadRpiData();
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('mini/inflation', ['rpiData']), {
        rpi: {
            get: function get() {
                return this.rpiData;
            }
        },
        amount: {
            get: function get() {
                return this.award.award;
            }
        },
        maxYear: {
            get: function get() {
                return this.rpiYears[0];
            }
        },
        rpiYears: {
            get: function get() {
                var data = this.rpiData;

                if (!data.length) {
                    return [];
                }

                return data.reduce(function (carry, item) {
                    if (!carry.length) {
                        carry = [];
                    }

                    if (!carry.includes(item.year)) {
                        carry.push(item.year);
                    }

                    return carry;
                }).reverse();
            }
        },
        maxMonths: {
            get: function get() {
                var months = [];
                for (var month = 1; month <= 12; month++) {
                    if (this.getRpiForDate(this.maxYear, month) !== 0) {
                        months.push(month);
                    }
                }

                return months.length;
            }
        },
        maxMonth: {
            get: function get() {
                return this.maxMonths;
            }
        },
        latestRPI: {
            get: function get() {
                return this.getRpiForDate(this.maxYear, this.maxMonth);
            }
        },
        equivalent: {
            get: function get() {
                return this.amount / this.getRpiForDate(2017, 1) * this.getRpiForDate(this.maxYear, this.maxMonth);
            }
        },
        afterDate: function afterDate() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()('01/' + this.maxMonth + '/' + this.maxYear, 'DD/M/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()('01/05/2017', 'DD/MM/YYYY'));
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('mini/inflation', {
        loadRpiData: 'loadRpiData',
        updateValue: 'updateValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', { updateHeadsOfLossValue: 'updateValue' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        usePslaAward: function usePslaAward(value) {
            this.updateHeadsOfLossValue({ key: 'generalDamages', value: value });
            this.toggle('generalDamagesPslaModal');
        },
        monthToString: function monthToString(value) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, 'M').format('MMMM');
        },
        getRpiForDate: function getRpiForDate(year, month) {
            if (!this.rpi.length) {
                return 0;
            }

            var rpi = this.rpi.reduce(function (carry, item) {
                if (item.year === year && item.month === month) {
                    return item.amount;
                }
                return carry;
            });

            if ((typeof rpi === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(rpi)) === 'object') {
                return 0;
            }

            return rpi;
        }
    })
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__);














var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'care-period',
    props: {
        index: {
            type: Number,
            required: true
        },
        showSubtotal: {
            default: true
        },
        showDelete: {
            default: true
        },
        miniCalc: {
            default: false
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', ['findPeriod', 'allPeriodsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', ['theDeceased']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/dependency/proceduralDates', {
        proceduralDatesValue: 'date'
    }), {
        periodStart: {
            get: function get() {
                return this.findPeriod(this.index).periodStart;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'periodStart', index: this.index, value: value });
            }
        },
        periodEnd: {
            get: function get() {
                return this.findPeriod(this.index).periodEnd;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'periodEnd', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        includeLastDay: {
            get: function get() {
                return this.findPeriod(this.index).includeLastDay;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'includeLastDay', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        includeFirstDay: {
            get: function get() {
                return this.findPeriod(this.index).includeFirstDay;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'includeFirstDay', index: this.index, value: value });
            }
        },
        rate: {
            get: function get() {
                return this.findPeriod(this.index).rate;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'rate', index: this.index, value: value });
            }
        },
        periodTotal: {
            get: function get() {
                return this.findPeriod(this.index).total.toFixed(2);
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'total', index: this.index, value: value });
            }
        },
        gratuitousCare: {
            get: function get() {
                return this.findPeriod(this.index).gratuitousCare;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'gratuitousCare', index: this.index, value: value });
            }
        },
        subTotalIcon: {
            get: function get() {
                return this.findPeriod(this.index).periodStart !== '' && this.findPeriod(this.index).periodEnd !== '' && this.findPeriod(this.index).hoursPerDay > 0 ? 'formula' : 'default';
            }
        },
        hoursPerDay: {
            get: function get() {
                return this.findPeriod(this.index).hoursPerDay;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'hoursPerDay', index: this.index, value: value });
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', {
        updatePeriodValue: 'updatePeriodValue',
        deleteCarePeriod: 'deleteCarePeriod',
        calcCareSubTotalForPeriod: 'calcCareSubTotalForPeriod'
    }), {
        deletePeriod: function deletePeriod() {
            this.deleteCarePeriod(this.index);
        },
        calcRate: function calcRate() {
            this.calcCareSubTotalForPeriod(this.index);
            this.$emit('update');
        },
        startPeriodValid: function startPeriodValid() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'));
        },
        endPeriodValid: function endPeriodValid() {
            if (this.miniCalc) {
                return;
            }
            var mPeriodEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY');
            return mPeriodEnd.isValid() ? mPeriodEnd.isSameOrBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY')) : false;
        },
        periodStartIsBeforeEnd: function periodStartIsBeforeEnd() {
            return this.periodEnd ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY')) : false;
        },
        periodStartIsBeforeAttendanceRates: function periodStartIsBeforeAttendanceRates() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()('01/04/2009', 'DD/MM/YYYY'));
        }
    })
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);















var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'earnings-period',
    props: {
        index: {
            type: Number,
            required: true
        },
        showSubtotal: {
            default: true
        },
        showDelete: {
            default: true
        }
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', ['findLossOfEarningsPeriod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', ['theDeceased']), {
        periodStart: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodStart;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodStart', index: this.index, value: value });
            }
        },
        periodEnd: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodEnd;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodEnd', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        includeLastDay: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).includeLastDay;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'includeLastDay', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        includeFirstDay: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).includeFirstDay;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'includeFirstDay', index: this.index, value: value });
            }
        },
        periodEmploymentType: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodEmploymentType;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodEmploymentType', index: this.index, value: value });
            }
        },
        periodNetGross: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodNetGross;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodNetGross', index: this.index, value: value });
            }
        },
        periodValue: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodValue;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodValue', index: this.index, value: value });
            }
        },
        periodTotal: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodTotal.toFixed(2);
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodTotal', index: this.index, value: value });
            }
        },
        onsetOfSymptoms: {
            get: function get() {
                var theDeceased = {};
                __WEBPACK_IMPORTED_MODULE_1_vue___default.a.util.extend(theDeceased, this.$store.getters['fatal/dependency/deceased/theDeceased']);
                return __WEBPACK_IMPORTED_MODULE_2_moment___default()(theDeceased.onsetOfSymptoms, 'DD/MM/YYYY');
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', {
        updatePastLossOfEarningsPeriodValue: 'updatePastLossOfEarningsPeriodValue',
        deleteLossOfEarningsPeriod: 'deleteLossOfEarningsPeriod',
        calcLossOfEarningsForPeriod: 'calcLossOfEarningsForPeriod'
    }), {
        deletePeriod: function deletePeriod() {
            this.deleteLossOfEarningsPeriod(this.index);
        },
        calcRate: function calcRate() {
            this.calcLossOfEarningsForPeriod(this.index);
            this.$emit('update');
        },
        periodStartIsValidDate: function periodStartIsValidDate() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isValid();
        },
        periodEndIsValidDate: function periodEndIsValidDate() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY').isValid();
        },
        periodStartIsBeforeEnd: function periodStartIsBeforeEnd() {
            return this.periodEnd ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY')) : false;
        },
        periodStartIsAfterOnsetOfSymptoms: function periodStartIsAfterOnsetOfSymptoms() {
            return this.periodStart && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isAfter(this.onsetOfSymptoms);
        },
        periodEndIsAfterOnsetOfSymptoms: function periodEndIsAfterOnsetOfSymptoms() {
            return this.periodEnd && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY').isAfter(this.onsetOfSymptoms);
        }
    })
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headOfLoss',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mounted: function mounted() {
        this.$emit('update');
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', ['findHeadOfLoss']), {
        name: {
            get: function get() {
                return this.findHeadOfLoss(this.index).name;
            },
            set: function set(value) {
                this.updateHeadOfLossValue({ key: 'name', index: this.index, value: value });
            }
        },
        value: {
            get: function get() {
                return this.findHeadOfLoss(this.index).value;
            },
            set: function set(value) {
                this.updateHeadOfLossValue({ key: 'value', index: this.index, value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', ['updateHeadOfLossValue', 'deleteHeadOfLoss']), {
        deleteThisHeadOfLoss: function deleteThisHeadOfLoss() {
            this.deleteHeadOfLoss(this.index);
            this.$emit('update');
        },
        updateValid: function updateValid() {
            this.$emit('update');
        }
    })
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);














var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'payment',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('fatal/dependency/headsOfLoss', {
        getHeadsOfLossTotal: 'getHeadsOfLossTotal',
        headsOfLossTotalMinusInterest: 'getHeadsOfLossTotalMinusInterest',
        headsOfLossValue: 'value',
        headsOfLoss: 'headsOfLoss',
        interestDate: 'interestDate'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('fatal/dependency/proceduralDates', {
        proceduralDatesValue: 'date'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('fatal/dependency/interimPayments', {
        findPayment: 'findPayment',
        allInterimPaymentsValid: 'allInterimPaymentsValid'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('fatal/dependency/deceased', {
        deceasedValue: 'theDeceased'
    }), {
        deceasedDod: {
            get: function get() {
                return this.deceasedValue['dateOfDeath'];
            }
        },
        interestType: {
            get: function get() {
                return this.headsOfLossValue('interestType');
            }
        },
        dateOfAssumedSettlement: {
            get: function get() {
                return this.proceduralDatesValue('dateOfAssumedSettlement');
            }
        },
        date: {
            get: function get() {
                return this.findPayment(this.index).date;
            },
            set: function set(value) {
                this.updatePayment({ key: 'date', index: this.index, value: value }).then(this.updateValid.bind(this));
            }
        },
        value: {
            get: function get() {
                return this.findPayment(this.index).value;
            },
            set: function set(value) {
                this.updatePayment({ key: 'value', index: this.index, value: value }).then(this.updateValid.bind(this));
            }
        },
        remainingTotal: function remainingTotal() {
            return numberVal(this.headsOfLossTotalMinusInterest - __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['fatal/dependency/interimPayments/interimPayments'].reduce(function (total, payment) {
                return total + payment.value;
            }, 0) + this.value);
        }
    }),
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('fatal/dependency/interimPayments', ['updatePayment', 'deletePayment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('fatal/dependency/headsOfLoss', {
        calcInterest: 'calcAllInterest'
    }), {
        deleteThisPayment: function deleteThisPayment() {
            this.deletePayment(this.index);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.allInterimPaymentsValid);
            this.updateInterest();
        },
        updateInterest: function updateInterest() {
            this.calcInterest();
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.allInterimPaymentsValid);
        },
        isValidDate: function isValidDate() {
            if (!this.date) {
                return true;
            }

            var mDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.date, 'DD/MM/YYYY');

            return mDate.isValid() && mDate.isAfter(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.deceasedDod, 'DD/MM/YYYY')) && mDate.isSameOrBefore(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.interestDate, 'DD/MM/YYYY'));
        }
    })
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'EstateClaim',
    components: {
        Timeline: __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default.a
    },
    mounted: function mounted() {
        this.resetOrLoad(this.$route);
    },

    watch: {
        '$route': function $route(to, from) {
            this.resetOrLoad(to);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('fatal/estate/step', {
        steps: 'allSteps',
        current: 'currentStep',
        stepNo: 'currentStepIndex'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('claim', { claimId: 'id' })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('claim', ['load', 'reset', 'initialise']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('menu', ['updateMenu']), {
        isVisible: function isVisible() {
            if (this.$route.params.id == this.claimId) {
                return true;
            }

            if (!this.$route.params.id && this.claimId) {
                return true;
            }

            return false;
        },
        resetOrLoad: function resetOrLoad(route) {
            var _this = this;

            var id = route.params.id;

            if (!id) {
                return this.reset().then(function () {
                    _this.initialise('fatal_accident_estate');
                });
            }

            if (this.claimId === parseInt(id)) {
                return;
            }

            this.load({ claim: { id: id }, router: this.$router });
        }
    })
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_html5_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_dropdown_Dropdown_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_dropdown_Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_dropdown_Dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_claims_dashboard_components_ReservesForClaim__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_claims_dashboard_components_ReservesForClaim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_claims_dashboard_components_ReservesForClaim__);




var HtmlEditor = new __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor___default.a();









var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        ReservesForClaim: __WEBPACK_IMPORTED_MODULE_9_pages_claims_dashboard_components_ReservesForClaim___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        HtmlEditor: HtmlEditor,
        dropdown: __WEBPACK_IMPORTED_MODULE_8_components_dropdown_Dropdown_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_dateFormat__["a" /* default */]],
    data: function data() {
        return {
            editingContent: null,
            showComparisonSchedule: false,
            theClaim: null,
            loading: false,
            isSaving: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', {
        headOfLoss: 'value',
        totalInterest: 'totalInterest',
        customHeadsOfLoss: 'headsOfLoss',
        periods: 'periods'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/interimPayments', {
        interimPayments: 'interimPayments'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/cru', ['getGeneralDamagesOffset', 'getPastLossOfEarningsOffset', 'getPastCostOfCareOffset', 'getPastCostOfTravelOffset']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), {
        subTotal: function subTotal() {
            return numberVal(this.headOfLoss('generalDamages')) + numberVal(this.headOfLoss('funeralExpenses')) + numberVal(this.headOfLoss('lossOfSpouse')) + numberVal(this.headOfLoss('pastLossOfEarnings')) + numberVal(this.headOfLoss('pastCostOfTravel')) + numberVal(this.headOfLoss('pastCostOfCare')) + numberVal(this.headOfLoss('misc')) + numberVal(this.calcCustomHeadsOfLoss) - numberVal(this.cruTotalDeductions);
        },
        interestTotal: function interestTotal() {
            return numberVal(this.headOfLoss('generalDamagesWithInterest')) + numberVal(this.headOfLoss('funeralExpensesWithInterest')) + numberVal(this.headOfLoss('lossOfSpouseWithInterest')) + numberVal(this.headOfLoss('pastLossOfEarningsWithInterest')) + numberVal(this.headOfLoss('pastCostOfCareWithInterest')) + numberVal(this.headOfLoss('pastCostOfTravelWithInterest')) + numberVal(this.headOfLoss('miscWithInterest')) + numberVal(this.calcCustomHeadsOfLossInterest);
        },
        total: function total() {
            return this.subTotal + this.interestTotal;
        },
        totalLessInterimPayments: function totalLessInterimPayments() {
            return this.total - numberVal(this.calcInterimPayments);
        },
        downloadUrl: function downloadUrl() {
            return '/api/v1/download/' + this.claimId;
        },
        calcCustomHeadsOfLoss: function calcCustomHeadsOfLoss() {
            var total = 0;
            if (this.customHeadsOfLoss) {
                this.customHeadsOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.value);
                });
            }
            return total;
        },
        calcCustomHeadsOfLossInterest: function calcCustomHeadsOfLossInterest() {
            var total = 0;
            if (this.customHeadsOfLoss) {
                this.customHeadsOfLoss.forEach(function (customHead, index) {
                    total = total + numberVal(customHead.interestAccrued);
                });
            }
            return total;
        },
        calcInterimPayments: function calcInterimPayments() {
            return this.interimPayments.reduce(function (total, interimPayment) {
                return total + numberVal(interimPayment.value);
            }, 0);
        },
        cruTotalDeductions: function cruTotalDeductions() {
            return this.getGeneralDamagesOffset + this.getPastLossOfEarningsOffset + this.getPastCostOfCareOffset + this.getPastCostOfTravelOffset;
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        createDocument: function createDocument(type) {
            this.createGeneratedDocument({ claimId: this.claimId, type: type });
        },
        deleteDocument: function deleteDocument(document) {
            if (this.requesting) {
                return;
            }
            this.deleteGeneratedDocument(document);
        },
        createComparisonSchedule: function createComparisonSchedule() {
            this.showComparisonSchedule = true;
        },
        theDocument: function theDocument(index) {
            return this.findDocument(index);
        },
        requestInProgress: function requestInProgress() {
            return this.apiRouteRequestRunning('/api/v1/generated-documents/load');
        }
    })
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_WarningBox_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_WarningBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_WarningBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Typeahead__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Typeahead__);















/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/estate/claimDetails', {
        detailValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('fatal/estate/dependencyOnIncome', { dependencyOnIncome: 'getAll' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        claimantName: {
            get: function get() {
                return this.detailValue('claimantName');
            },
            set: function set(value) {
                this.updateDetail({ key: 'claimantName', value: value }).then(this.updateValid.bind(this));
            }
        },
        claimantSolicitor: {
            get: function get() {
                return this.detailValue('claimantSolicitor');
            }
        },
        claimantReference: {
            get: function get() {
                return this.detailValue('claimantReference');
            },
            set: function set(value) {
                this.updateDetail({ key: 'claimantReference', value: value }).then(this.updateValid.bind(this));
            }
        },
        yourReference: {
            get: function get() {
                return this.detailValue('yourReference');
            },
            set: function set(value) {
                this.updateDetail({ key: 'yourReference', value: value }).then(this.updateValid.bind(this));
            }
        },
        defendantName: {
            get: function get() {
                return this.detailValue('defendantName');
            }
        },
        narrative: {
            get: function get() {
                return this.detailValue('claimNarrative');
            },
            set: function set(value) {
                this.updateDetail({ key: 'claimNarrative', value: value }).then(this.updateValid.bind(this));
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.detailValue('diseaseOrAccident');
            },
            set: function set(value) {
                var _this = this;

                this.updateDetail({ key: 'diseaseOrAccident', value: value }).then(function () {
                    if (_this.detailValue('diseaseOrAccident') === 'disease') {
                        _this.accidentType = null;
                        _this.otherAccidentType = null;
                    } else if (_this.detailValue('diseaseOrAccident') === 'accident') {
                        _this.diseaseType = null;
                        _this.otherDiseaseType = null;
                    }
                }).then(this.updateValid.bind(this));
            }
        },
        accidentType: {
            get: function get() {
                return this.detailValue('accidentType');
            },
            set: function set(value) {
                this.updateDetail({ key: 'accidentType', value: value }).then(this.updateValid.bind(this));
            }
        },
        otherAccidentType: {
            get: function get() {
                return this.detailValue('otherAccidentType');
            },
            set: function set(value) {
                this.updateDetail({ key: 'otherAccidentType', value: value }).then(this.updateValid.bind(this));
            }
        },
        diseaseType: {
            get: function get() {
                return this.detailValue('diseaseType');
            },
            set: function set(value) {
                this.updateDetail({ key: 'diseaseType', value: value }).then(this.updateValid.bind(this));
            }
        },
        otherDiseaseType: {
            get: function get() {
                return this.detailValue('otherDiseaseType');
            },
            set: function set(value) {
                this.updateDetail({ key: 'otherDiseaseType', value: value }).then(this.updateValid.bind(this));
            }
        },
        dateOfServiceProceedings: {
            get: function get() {
                return this.detailValue('serviceOfProceedings');
            },
            set: function set(value) {
                this.updateDetail({ key: 'serviceOfProceedings', value: value }).then(this.updateValid.bind(this));
            }
        },
        dateOfAssumedSettlement: {
            get: function get() {
                return this.detailValue('assumedSettlement');
            },
            set: function set(value) {
                this.updateDetail({ key: 'assumedSettlement', value: value }).then(this.updateValid.bind(this));
            }
        },
        preLitOrLit: {
            get: function get() {
                return this.detailValue('proceduralStatus');
            },
            set: function set(value) {
                this.updateDetail({ key: 'proceduralStatus', value: value }).then(this.updateValid.bind(this));
            }
        },
        discountRate: {
            get: function get() {
                return this.detailValue('discountRate');
            },
            set: function set(value) {
                this.updateDetail({ key: 'discountRate', value: value }).then(this.updateValid.bind(this));
            }
        },
        showServiceOfProceedingsValidationMessage_required: {
            get: function get() {
                if (!this.dateOfServiceProceedings || !this.dateOfAssumedSettlement) {
                    return false;
                }

                return !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY').isValid() || !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY').isValid();
            }
        },
        showServiceOfProceedingsValidationMessage_9years: {
            get: function get() {
                if (this.showServiceOfProceedingsValidationMessage_required) {
                    return false;
                }

                var mServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                    return false;
                }

                return mServiceOfProceedings.diff(mAssumedSettlement, 'years') < -9;
            }
        },
        showServiceOfProceedingsValidationMessage_before: {
            get: function get() {
                if (this.showServiceOfProceedingsValidationMessage_required) {
                    return false;
                }

                var mServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                    return false;
                }

                return !mServiceOfProceedings.isBefore(mAssumedSettlement);
            }
        },
        dateOfAssumedSettlementInPast: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_10_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY'), 'days') > 0;
            }
        },
        isValid: function isValid() {
            return this.$valid() && this.validServiceOfProceedings() && this.isValidAccidentOrDisease() && this.isValidClaimantSolicitor() && this.isValidDateOfSettlement() && this.isValidDefendant();
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__["a" /* default */]],
    watch: {
        isValid: function isValid() {
            this.updateValid();
        }
    },
    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        ControlWarning: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue___default.a,
        WarningBox: __WEBPACK_IMPORTED_MODULE_6_components_modal_WarningBox_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        Typeahead: __WEBPACK_IMPORTED_MODULE_11_components_Typeahead___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/estate/claimDetails', {
        updateDetail: 'update'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('fatal/estate/proceduralDates', ['setIssueProceedings', 'setServiceProceedings', 'setAssumedSettlement', 'setPreLitOrLit']), {
        updateValid: function updateValid() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["b" /* setStepValid */])(this.isValid);
        },
        validServiceOfProceedings: function validServiceOfProceedings() {
            var mServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY');
            var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

            if (this.preLitOrLit == 'pre-lit') {
                return true;
            }

            if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                return false;
            }

            if (!mServiceOfProceedings.isBefore(mAssumedSettlement)) {
                return false;
            }

            return mServiceOfProceedings.diff(mAssumedSettlement, 'years') >= -9;
        },
        isValidAccidentOrDisease: function isValidAccidentOrDisease() {
            if (this.diseaseOrAccident === 'disease') {
                return this.diseaseType !== null && (this.diseaseType.substr(0, 5) === 'Other' && this.otherDiseaseType !== null && this.otherDiseaseType.length >= 1 || this.diseaseType.substr(0, 5) !== 'Other');
            }

            if (this.diseaseOrAccident === 'accident') {
                return this.accidentType !== null && (this.accidentType.substr(0, 5) === 'Other' && this.otherAccidentType !== null && this.otherAccidentType.length >= 1 || this.accidentType.substr(0, 5) !== 'Other');
            }

            return false;
        },
        isValidClaimantSolicitor: function isValidClaimantSolicitor() {
            return this.claimantSolicitor && this.claimantSolicitor.name !== null && this.claimantSolicitor.name !== '';
        },
        isValidDateOfSettlement: function isValidDateOfSettlement() {
            return __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY', true);
        },
        isValidDefendant: function isValidDefendant() {
            return this.defendantName && this.defendantName.name !== null && this.defendantName.name !== '';
        },
        updateClaimantSolicitors: function updateClaimantSolicitors(value) {
            this.updateDetail({ key: 'claimantSolicitor', value: value }).then(this.updateValid.bind(this));
        },
        updateDefendant: function updateDefendant(value) {
            this.updateDetail({ key: 'defendantName', value: value }).then(this.updateValid.bind(this));
        }
    })
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_cru_benefits_GeneralDamages__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_cru_benefits_GeneralDamages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_cru_benefits_GeneralDamages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_cru_benefits_PastCostOfCare__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_cru_benefits_PastCostOfCare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_cru_benefits_PastCostOfCare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_cru_benefits_PastCostOfTravel__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_cru_benefits_PastCostOfTravel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_cru_benefits_PastCostOfTravel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_cru_benefits_PastLossOfEarnings__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_cru_benefits_PastLossOfEarnings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_cru_benefits_PastLossOfEarnings__);












/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Accordion: __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default.a,
        GeneralDamages: __WEBPACK_IMPORTED_MODULE_5_pages_fatal_accident_claims_cru_benefits_GeneralDamages___default.a,
        PastCostOfCare: __WEBPACK_IMPORTED_MODULE_6_pages_fatal_accident_claims_cru_benefits_PastCostOfCare___default.a,
        PastCostOfTravel: __WEBPACK_IMPORTED_MODULE_7_pages_fatal_accident_claims_cru_benefits_PastCostOfTravel___default.a,
        PastLossOfEarnings: __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_cru_benefits_PastLossOfEarnings___default.a
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('fatal/estate/cru', ['allValid']),
    mounted: function mounted() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_routingMethods__["b" /* setStepValid */])(this.allValid);
    },

    watch: {
        allValid: function allValid() {
            this.update();
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', ['calcAllInterest']), {
        update: function update() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_routingMethods__["b" /* setStepValid */])(this.allValid);
            if (this.allValid) {
                this.calcAllInterest();
            }
        }
    })
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_estate_steps_heads_of_loss_HeadOfLoss_vue__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_estate_steps_heads_of_loss_HeadOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_estate_steps_heads_of_loss_HeadOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_estate_steps_heads_of_loss_CarePeriod_vue__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_estate_steps_heads_of_loss_CarePeriod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_estate_steps_heads_of_loss_CarePeriod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_estate_steps_heads_of_loss_EarningsPeriod_vue__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_estate_steps_heads_of_loss_EarningsPeriod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_estate_steps_heads_of_loss_EarningsPeriod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_estate_steps_general_damages_GeneralDamagesPslaCalculator__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_estate_steps_general_damages_GeneralDamagesPslaCalculator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_estate_steps_general_damages_GeneralDamagesPslaCalculator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_directives_TwoDecimalPlaces__ = __webpack_require__(11);




















/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue___default.a,
        HeadOfLoss: __WEBPACK_IMPORTED_MODULE_8_pages_fatal_accident_claims_estate_steps_heads_of_loss_HeadOfLoss_vue___default.a,
        CarePeriod: __WEBPACK_IMPORTED_MODULE_9_pages_fatal_accident_claims_estate_steps_heads_of_loss_CarePeriod_vue___default.a,
        EarningsPeriod: __WEBPACK_IMPORTED_MODULE_10_pages_fatal_accident_claims_estate_steps_heads_of_loss_EarningsPeriod_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default.a,
        GeneralDamagesPslaCalculator: __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_estate_steps_general_damages_GeneralDamagesPslaCalculator___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_15_directives_TwoDecimalPlaces__["a" /* default */]
    },
    watch: {
        'generalDamages': function generalDamages(newVal, oldValue) {
            var _this = this;

            this.$nextTick(function () {
                _this.updateValid();
            });
        }
    },
    created: function created() {
        this.updateValid();
    },
    mounted: function mounted() {
        this.updateValid();
    },
    data: function data() {
        return {
            stepValid: false,
            loading: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', {
        findValue: 'value',
        headsOfLoss: 'headsOfLoss',
        allHeadsOfLossValid: 'allHeadsOfLossValid',
        periods: 'periods',
        pastLossOfEarningsPeriods: 'pastLossOfEarningsPeriods',
        allPeriodsValid: 'allPeriodsValid',
        pastLossOfEarningsPeriodsValid: 'pastLossOfEarningsPeriodsValid'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('fatal/estate/claimDetails', {
        claimValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('modal', ['modals']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('fatal/estate/deceased', { theDeceased: 'theDeceased' }), {
        diseaseType: {
            get: function get() {
                return this.claimValue('diseaseType');
            }
        },
        generalDamages: {
            get: function get() {
                return this.findValue('generalDamages');
            },
            set: function set(value) {
                this.updateValue({ key: 'generalDamages', value: value }).then(this.updateValid);
            }
        },
        funeralExpenses: {
            get: function get() {
                return this.findValue('funeralExpenses');
            },
            set: function set(value) {
                this.updateValue({ key: 'funeralExpenses', value: value }).then(this.updateValid);
            }
        },
        lossOfSpouse: {
            get: function get() {
                return this.findValue('lossOfSpouse');
            },
            set: function set(value) {
                this.updateValue({ key: 'lossOfSpouse', value: value }).then(this.updateValid);
            }
        },
        pastLossOfEarnings: {
            get: function get() {
                return this.findValue('pastLossOfEarnings');
            },
            set: function set(value) {
                this.updateValue({ key: 'pastLossOfEarnings', value: value }).then(this.updateValid);
            }
        },
        pastCostOfTravel: {
            get: function get() {
                return this.findValue('pastCostOfTravel');
            },
            set: function set(value) {
                this.updateValue({ key: 'pastCostOfTravel', value: value }).then(this.updateValid);
            }
        },
        misc: {
            get: function get() {
                return this.findValue('misc');
            },
            set: function set(value) {
                this.updateValue({ key: 'misc', value: value }).then(this.updateValid);
            }
        },
        careCalcType: {
            get: function get() {
                return this.findValue('careCalcType');
            },
            set: function set(value) {
                var _this2 = this;

                this.updateValue({ key: 'careCalcType', value: value }).then(this.updateValid);

                if (value !== 'own') {
                    this.updateValue({
                        key: 'ownCareFigure',
                        value: this.ownCareFigure || 0
                    });

                    if (!this.periods.length) {
                        this.addCarePeriod();
                    }
                }

                if (value === 'auto') {
                    this.loading = true;

                    return this.autoCalculateCare(this.findValue('gratuitousCare')).then(function () {
                        _this2.loading = false;
                    });
                }

                return this.updateValue({
                    key: 'pastCostOfCare',
                    value: 0
                });
            }
        },
        pastLossOfEarningsType: {
            get: function get() {
                return this.findValue('pastLossOfEarningsType');
            },
            set: function set(value) {
                this.updateValue({ key: 'pastLossOfEarningsType', value: value }).then(this.updateValid);
                if (value !== 'own') {
                    this.updateValue({
                        key: 'pastLossOfEarningsType',
                        value: this.pastLossOfEarningsType || 0
                    });

                    if (!this.pastLossOfEarningsPeriods.length) {
                        this.addLossOfEarningsPeriod();
                    }
                }
                return this.updateValue({
                    key: 'pastLossOfEarnings',
                    value: 0
                });
            }
        },
        gratuitousCare: {
            get: function get() {
                return this.findValue('gratuitousCare');
            },
            set: function set(value) {
                this.updateValue({ key: 'gratuitousCare', value: value }).then(this.updateValid);
                this.determineCalculateCare(value);
            }
        },
        ownCareFigure: {
            get: function get() {
                return this.findValue('ownCareFigure');
            },
            set: function set(value) {
                if (isNaN(value)) {
                    value = 0;
                }
                this.updateValue({ key: 'ownCareFigure', value: value }).then(this.updateValid);
                this.ownCalculateCare(this.findValue('gratuitousCare'));
            }
        },
        ownPastLossOfEarningsFigure: {
            get: function get() {
                return this.findValue('ownPastLossOfEarningsFigure');
            },
            set: function set(value) {
                if (isNaN(value)) {
                    value = 0;
                }
                this.updateValue({ key: 'ownPastLossOfEarningsFigure', value: value });
                this.updateValue({ key: 'pastLossOfEarnings', value: value }).then(this.updateValid);
            }
        },
        careIcon: {
            get: function get() {
                return this.findValue('careCalcType') === 'auto' ? 'formula' : 'default';
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', {
        updateValue: 'updateValue',
        calcInterest: 'calcAllInterest',
        addHeadOfLoss: 'addHeadOfLoss',
        addCarePeriod: 'addCarePeriod',
        addLossOfEarningsPeriod: 'addLossOfEarningsPeriod',
        autoCalculateCare: 'autoCalculateCare',
        ownCalculateCare: 'ownCalculateCare'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        calcInterestValue: function calcInterestValue() {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["e" /* isStepValid */])(6)) {
                this.calcInterest();
            }
        },
        determineCalculateCare: function determineCalculateCare(value) {
            if (this.findValue('careCalcType') === 'auto') {
                this.autoCalculateCare(value);
            } else if (this.findValue('careCalcType') === 'own') {
                this.ownCalculateCare(value);
            }
        },
        isValid: function isValid() {
            this.validPastLossOfEarningsPeriod = true;
            this.validCare = true;

            if (this.pastLossOfEarningsType === 'manual') {
                this.validPastLossOfEarningsPeriod = this.pastLossOfEarningsPeriodsValid;
            }

            if (this.careCalcType === 'manual') {
                this.validCare = this.allPeriodsValid;
            }

            return this.$valid() && this.allHeadsOfLossValid && this.validPastLossOfEarningsPeriod && this.validCare;
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["b" /* setStepValid */])(this.isValid());
        },
        toggleGeneralDamagesPslaModal: function toggleGeneralDamagesPslaModal() {
            this.toggle('generalDamagesPslaModal');
        },
        addNewHeadOfLoss: function addNewHeadOfLoss() {
            this.addHeadOfLoss();
            this.updateValid();
        }
    })
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_fatal_accident_claims_estate_steps_interim_Payment_vue__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_fatal_accident_claims_estate_steps_interim_Payment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pages_fatal_accident_claims_estate_steps_interim_Payment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_InterestItem_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_InterestItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_InterestItem_vue__);



















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'InterimPaymentsAndInterest',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', ['value', 'headsOfLoss', 'getModalPayload']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/interimPayments', ['interimPayments', 'allInterimPaymentsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/dependencyOnIncome', {
        incomePre: 'preDependencyValue',
        incomePost: 'postDependencyValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/deceased', {
        deceasedValue: 'theDeceased'
    }), {
        deceasedDod: {
            get: function get() {
                return this.deceasedValue['dateOfDeath'];
            }
        },
        interestType: {
            get: function get() {
                return this.value('interestType');
            },
            set: function set(value) {
                this.setValue({ key: 'interestType', value: value });
            }
        },
        customInterestDate: {
            get: function get() {
                return this.value('customInterestDate');
            },
            set: function set(value) {
                this.setValue({ key: 'customInterestDate', value: value });
            }
        },
        payload: {
            get: function get() {
                return this.getModalPayload;
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    created: function created() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(true);
        this.calcInterest();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default.a,
        Payment: __WEBPACK_IMPORTED_MODULE_12_pages_fatal_accident_claims_estate_steps_interim_Payment_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent_vue___default.a,
        InterestItem: __WEBPACK_IMPORTED_MODULE_15_components_InterestItem_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', {
        setValue: 'updateValue',
        updateInterest: 'calcNewValue',
        calcInterest: 'calcAllInterest',
        updateHeadOfLossValue: 'updateHeadOfLossValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/estate/interimPayments', ['addPayment']), {
        calcInterestValue: function calcInterestValue() {
            this.calcAllInterest();
        },
        onUpdate: function onUpdate(info) {
            this.setValue({ key: info.updates, value: info.value }).then(this.calcAllInterest.bind(this));
        },
        onUpdateCustom: function onUpdateCustom(info) {
            this.updateHeadOfLossValue({ index: info.updates, value: info.value, key: 'interest' }).then(this.calcAllInterest.bind(this));
        },
        isValidDate: function isValidDate() {
            var mDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.customInterestDate, 'DD/MM/YYYY');
            return mDate.isValid() && mDate.isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.deceasedDod, 'DD/MM/YYYY'));
        }
    })
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TheDeceased',
    created: function created() {
        this.validDateOfProceedings();
        this.validOnsetOfSymptoms();
        this.validateDateOfDeath();
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/claimDetails', {
        claimDetailsValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/deceased', {
        deceasedValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/proceduralDates', ['date']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        theDeceased: function theDeceased() {
            var theDeceased = {};
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.util.extend(theDeceased, this.$store.getters['fatal/estate/deceased/theDeceased']);
            return theDeceased;
        },

        levelOfEducation: {
            get: function get() {
                return this.claimDetailsValue('levelOfEducation');
            },
            set: function set(value) {
                this.updateTheClaim({ key: 'levelOfEducation', value: value });
            }
        },
        disabledAtAccident: {
            get: function get() {
                return this.claimDetailsValue('disabled');
            },
            set: function set(value) {
                this.updateTheClaim({ key: 'disabled', value: value });
            }
        },
        periodDeathToSettlement: function periodDeathToSettlement() {
            return this.deceasedValue('periodDeathToSettlement');
        },
        ageAtSettlement: function ageAtSettlement() {
            return this.deceasedValue('ageAtSettlement');
        },
        reductionInLifeExpectancy: function reductionInLifeExpectancy() {
            return this.theDeceased.lifeExpectancy.ageAtDeath - this.theDeceased.ageAtDeath;
        },
        assumedSettlement: function assumedSettlement() {
            return this.claimDetailsValue('assumedSettlement');
        },
        dateOfServiceProceedings: function dateOfServiceProceedings() {
            return this.claimDetailsValue('serviceOfProceedings');
        },
        preLitOrLit: function preLitOrLit() {
            return this.claimDetailsValue('proceduralStatus');
        },
        periodBetweenOnsetAndDod: function periodBetweenOnsetAndDod() {
            if (this.theDeceased.dateOfDeath === null || this.theDeceased.onsetOfSymptoms === null) {
                return null;
            }

            return (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'), 'days') / 365.25).toFixed(2);
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_3_components_LifeExpectancy_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default.a
    },
    watch: {
        '$form.$valid': function $form$valid(val) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(val);
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/estate/claimDetails', {
        updateTheClaim: 'update'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/estate/deceased', {
        updateTheDeceased: 'updateTheDeceased',
        updateTheDeceasedLifeExpectancy: 'updateTheDeceasedLifeExpectancy'
    }), {
        updateLife: function updateLife(lifeExpectancy) {
            this.updateTheDeceasedLifeExpectancy({ lifeExpectancy: lifeExpectancy }).then(this.update.bind(this));
        },
        update: function update() {
            this.updateTheDeceased(this.theDeceased);
            this.validateDateOfDeath();
        },
        validDateOfProceedings: function validDateOfProceedings() {
            if (!this.theDeceased.dateOfDeath || this.claimDetailsValue.proceduralStatus !== 'litigated') {
                return true;
            }
            var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
            return this.preLitOrLit === 'litigated' ? mDateOfDeath.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY')) : true;
        },
        validDateOfDeathOnsetOfSymptoms: function validDateOfDeathOnsetOfSymptoms() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
            return mDateOfDeath.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'));
        },
        validOnsetOfSymptoms: function validOnsetOfSymptoms() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            var mDateOfBirth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfBirth, 'DD/MM/YYYY');
            return mDateOfBirth.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'));
        },
        validDateOfBirth: function validDateOfBirth() {
            if (!this.theDeceased.dateOfBirth) {
                return true;
            }
            var mDateOfBirth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfBirth, 'DD/MM/YYYY');
            return mDateOfBirth.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(18, 'years'));
        },
        validDateOfDeath: function validDateOfDeath() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
            return mDateOfDeath.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.assumedSettlement, 'DD/MM/YYYY'));
        },
        validDateOfDeathDurtaion: function validDateOfDeathDurtaion() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY');
            return mDateOfDeath.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.assumedSettlement, 'DD/MM/YYYY').subtract(9, 'years'));
        },
        validDateOfDeathCurrent: function validDateOfDeathCurrent() {
            if (!this.theDeceased.dateOfDeath) {
                return true;
            }
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(), 'day');
        },
        validateDateOfDeath: function validateDateOfDeath() {
            if (!this.theDeceased.dateOfDeath) {
                return false;
            }
            var valid = this.validOnsetOfSymptoms() && this.validDateOfProceedings() && this.validDateOfDeath() && this.validDateOfDeathDurtaion() && this.validDateOfDeathCurrent();

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(valid);
            return valid;
        }
    })
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_slider_component__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_estate_steps_general_damages_PslaAward__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_estate_steps_general_damages_PslaAward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_estate_steps_general_damages_PslaAward__);


















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'general-damages-psla-calculator',
    data: function data() {
        return {
            calculatedDurationOfSymptoms: 0,
            loading: {
                table: false,
                awards: false
            },
            upliftButton: true,
            uplift: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('fatal/estate/deceased', { theDeceased: 'theDeceased' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('psla', { pslaValue: 'value' }), {
        table: {
            get: function get() {
                return this.pslaValue('table');
            }
        },
        awards: {
            get: function get() {
                return this.pslaValue('awards');
            }
        },
        filteredAwards: function filteredAwards() {
            var _this = this;

            if (!this.awards.length) {
                return [];
            }
            return this.awards.map(function (award) {
                var score = Math.abs(_this.ageAtDeath - award.age) + Math.abs(_this.calculatedDurationOfSymptoms - award.duration);
                return { score: score, award: award };
            }).sort(function (a, b) {
                if (a.score === b.score) {
                    return 0;
                }
                return a.score - b.score;
            }).map(function (info) {
                return info.award;
            }).slice(0, 10);
        },

        dateOfBirth: {
            get: function get() {
                return this.theDeceased.dateOfBirth;
            }
        },
        ageAtDeath: {
            get: function get() {
                return this.theDeceased.ageAtDeath;
            }
        },
        upperAge: {
            get: function get() {
                var _this2 = this;

                var upperAge = this.ages.reverse().filter(function (age) {
                    return age <= _this2.ageAtDeath;
                });

                if (!upperAge || upperAge.length < 1) {
                    return this.ages.reverse()[0];
                }

                return upperAge[0];
            }
        },
        ages: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.table);
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.theDeceased.dateOfDeath;
            }
        },
        onsetOfSymptoms: {
            get: function get() {
                return this.theDeceased.onsetOfSymptoms;
            }
        },
        durationOfSymptoms: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.onsetOfSymptoms, 'DD/MM/YYYY'), 'months');
            }
        }
    }),
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default.a,
        VueSlider: __WEBPACK_IMPORTED_MODULE_13_vue_slider_component___default.a,
        PslaAward: __WEBPACK_IMPORTED_MODULE_14_pages_fatal_accident_claims_estate_steps_general_damages_PslaAward___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__["a" /* default */]],
    created: function created() {
        this.loadTableCheck();
        this.loadAwardsCheck();
        this.calculatedDurationOfSymptoms = this.durationOfSymptoms;
    },

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('psla', ['loadTable', 'loadAwards']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', { updateValue: 'updateValue' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        loadTableCheck: function loadTableCheck() {
            var _this3 = this;

            if (!this.table.length) {
                this.loading.table = true;
                this.loadTable().then(function () {
                    _this3.loading.table = false;
                });
            }
        },
        loadAwardsCheck: function loadAwardsCheck() {
            var _this4 = this;

            if (!this.awards.length) {
                this.loading.awards = true;
                this.loadAwards().then(function () {
                    _this4.loading.awards = false;
                });
            }
        },
        isExactMatch: function isExactMatch(index, age) {
            return this.isColMatch(index) && this.isRowMatch(age);
        },
        isColMatch: function isColMatch(index) {
            index++;

            if (index === 1 && this.calculatedDurationOfSymptoms <= 3) {
                return true;
            }

            if (index === 13 && this.calculatedDurationOfSymptoms >= 37) {
                return true;
            }

            return this.calculatedDurationOfSymptoms >= index * 3 - 2 && this.calculatedDurationOfSymptoms <= index * 3;
        },
        isRowMatch: function isRowMatch(age) {
            return this.upperAge === age;
        },
        getTariffTableTdStyle: function getTariffTableTdStyle(index, age) {
            if (this.isExactMatch(index, age)) {
                return 'cursor: pointer; background:#c5ecfe; font-weight: bold; font-size: 14px;';
            }

            if (this.isColMatch(index) || this.isRowMatch(age)) {
                return 'cursor: pointer; background:#c5ecfe; font-size: 14px;';
            }

            return 'cursor: pointer; font-size: 14px;';
        },
        applyUplift: function applyUplift() {
            this.upliftButton = !this.upliftButton;
            this.uplift = !this.uplift;
        },
        usePslaAward: function usePslaAward(value) {
            this.updateValue({ key: 'generalDamages', value: value });
            this.toggle('generalDamagesPslaModal');
        }
    })
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'psla-award',
    props: ['award'],
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */]],
    mounted: function mounted() {
        this.loadRpiData();
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('mini/inflation', ['rpiData']), {
        rpi: {
            get: function get() {
                return this.rpiData;
            }
        },
        amount: {
            get: function get() {
                return this.award.award;
            }
        },
        maxYear: {
            get: function get() {
                return this.rpiYears[0];
            }
        },
        rpiYears: {
            get: function get() {
                var data = this.rpiData;

                if (!data.length) {
                    return [];
                }

                return data.reduce(function (carry, item) {
                    if (!carry.length) {
                        carry = [];
                    }

                    if (!carry.includes(item.year)) {
                        carry.push(item.year);
                    }

                    return carry;
                }).reverse();
            }
        },
        maxMonths: {
            get: function get() {
                var months = [];
                for (var month = 1; month <= 12; month++) {
                    if (this.getRpiForDate(this.maxYear, month) !== 0) {
                        months.push(month);
                    }
                }

                return months.length;
            }
        },
        maxMonth: {
            get: function get() {
                return this.maxMonths;
            }
        },
        latestRPI: {
            get: function get() {
                return this.getRpiForDate(this.maxYear, this.maxMonth);
            }
        },
        equivalent: {
            get: function get() {
                return this.amount / this.getRpiForDate(2017, 1) * this.getRpiForDate(this.maxYear, this.maxMonth);
            }
        },
        afterDate: function afterDate() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()('01/' + this.maxMonth + '/' + this.maxYear, 'DD/M/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()('01/05/2017', 'DD/MM/YYYY'));
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('mini/inflation', {
        loadRpiData: 'loadRpiData',
        updateValue: 'updateValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', { updateHeadsOfLossValue: 'updateValue' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        usePslaAward: function usePslaAward(value) {
            this.updateHeadsOfLossValue({ key: 'generalDamages', value: value });
            this.toggle('generalDamagesPslaModal');
        },
        monthToString: function monthToString(value) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, 'M').format('MMMM');
        },
        getRpiForDate: function getRpiForDate(year, month) {
            if (!this.rpi.length) {
                return 0;
            }

            var rpi = this.rpi.reduce(function (carry, item) {
                if (item.year === year && item.month === month) {
                    return item.amount;
                }
                return carry;
            });

            if ((typeof rpi === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(rpi)) === 'object') {
                return 0;
            }

            return rpi;
        }
    })
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__);














var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'care-period',
    props: {
        index: {
            type: Number,
            required: true
        },
        showSubtotal: {
            default: true
        },
        showDelete: {
            default: true
        },
        miniCalc: {
            default: false
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', ['findPeriod', 'allPeriodsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/estate/deceased', ['theDeceased']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/estate/proceduralDates', {
        proceduralDatesValue: 'date'
    }), {
        periodStart: {
            get: function get() {
                return this.findPeriod(this.index).periodStart;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'periodStart', index: this.index, value: value });
            }
        },
        periodEnd: {
            get: function get() {
                return this.findPeriod(this.index).periodEnd;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'periodEnd', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        includeLastDay: {
            get: function get() {
                return this.findPeriod(this.index).includeLastDay;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'includeLastDay', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        includeFirstDay: {
            get: function get() {
                return this.findPeriod(this.index).includeFirstDay;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'includeFirstDay', index: this.index, value: value });
            }
        },
        rate: {
            get: function get() {
                return this.findPeriod(this.index).rate;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'rate', index: this.index, value: value });
            }
        },
        periodTotal: {
            get: function get() {
                return this.findPeriod(this.index).total.toFixed(2);
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'total', index: this.index, value: value });
            }
        },
        gratuitousCare: {
            get: function get() {
                return this.findPeriod(this.index).gratuitousCare;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'gratuitousCare', index: this.index, value: value });
            }
        },
        subTotalIcon: {
            get: function get() {
                return this.findPeriod(this.index).periodStart !== '' && this.findPeriod(this.index).periodEnd !== '' && this.findPeriod(this.index).hoursPerDay > 0 ? 'formula' : 'default';
            }
        },
        hoursPerDay: {
            get: function get() {
                return this.findPeriod(this.index).hoursPerDay;
            },
            set: function set(value) {
                this.updatePeriodValue({ key: 'hoursPerDay', index: this.index, value: value });
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', {
        updatePeriodValue: 'updatePeriodValue',
        deleteCarePeriod: 'deleteCarePeriod',
        calcCareSubTotalForPeriod: 'calcCareSubTotalForPeriod'
    }), {
        deletePeriod: function deletePeriod() {
            this.deleteCarePeriod(this.index);
        },
        calcRate: function calcRate() {
            this.calcCareSubTotalForPeriod(this.index);
            this.$emit('update');
        },
        startPeriodValid: function startPeriodValid() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.onsetOfSymptoms, 'DD/MM/YYYY'));
        },
        endPeriodValid: function endPeriodValid() {
            if (this.miniCalc) {
                return;
            }
            var mPeriodEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY');
            return mPeriodEnd.isValid() ? mPeriodEnd.isSameOrBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY')) : false;
        },
        periodStartIsBeforeEnd: function periodStartIsBeforeEnd() {
            return this.periodEnd ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY')) : false;
        },
        periodStartIsBeforeAttendanceRates: function periodStartIsBeforeAttendanceRates() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()('01/04/2009', 'DD/MM/YYYY'));
        }
    })
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);















var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'earnings-period',
    props: {
        index: {
            type: Number,
            required: true
        },
        showSubtotal: {
            default: true
        },
        showDelete: {
            default: true
        }
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapState */])('fatal/estate/headsOfLoss', ['pastLossOfEarningsPeriods']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', ['findLossOfEarningsPeriod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('fatal/estate/deceased', ['theDeceased']), {
        periodStart: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodStart;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodStart', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        periodEnd: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodEnd;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodEnd', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        includeLastDay: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).includeLastDay;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'includeLastDay', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        includeFirstDay: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).includeFirstDay;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'includeFirstDay', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        periodEmploymentType: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodEmploymentType;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodEmploymentType', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        periodNetGross: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodNetGross;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodNetGross', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        periodValue: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodValue;
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodValue', index: this.index, value: value }).then(this.calcRate.bind(this));
            }
        },
        periodTotal: {
            get: function get() {
                return this.findLossOfEarningsPeriod(this.index).periodTotal.toFixed(2);
            },
            set: function set(value) {
                this.updatePastLossOfEarningsPeriodValue({ key: 'periodTotal', index: this.index, value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', {
        updatePastLossOfEarningsPeriodValue: 'updatePastLossOfEarningsPeriodValue',
        deleteLossOfEarningsPeriod: 'deleteLossOfEarningsPeriod',
        calcLossOfEarningsForPeriod: 'calcLossOfEarningsForPeriod'
    }), {
        deletePeriod: function deletePeriod() {
            this.deleteLossOfEarningsPeriod(this.index);
        },
        calcRate: function calcRate() {
            this.calcLossOfEarningsForPeriod(this.index);
            this.$emit('update');
        },
        endPeriodValid: function endPeriodValid() {
            var mPeriodEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY');
            return mPeriodEnd.isValid() ? mPeriodEnd.isSameOrBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.theDeceased.dateOfDeath, 'DD/MM/YYYY')) : false;
        },
        periodStartIsBeforeEnd: function periodStartIsBeforeEnd() {
            return this.periodEnd ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY')) : false;
        }
    })
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headOfLoss',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mounted: function mounted() {
        this.$emit('update');
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', ['findHeadOfLoss']), {
        name: {
            get: function get() {
                return this.findHeadOfLoss(this.index).name;
            },
            set: function set(value) {
                this.updateHeadOfLossValue({ key: 'name', index: this.index, value: value });
            }
        },
        value: {
            get: function get() {
                return this.findHeadOfLoss(this.index).value;
            },
            set: function set(value) {
                this.updateHeadOfLossValue({ key: 'value', index: this.index, value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', ['updateHeadOfLossValue', 'deleteHeadOfLoss']), {
        deleteThisHeadOfLoss: function deleteThisHeadOfLoss() {
            this.deleteHeadOfLoss(this.index);
            this.$emit('update');
        },
        updateValid: function updateValid() {
            this.$emit('update');
        }
    })
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);














var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'payment',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('fatal/estate/headsOfLoss', {
        getHeadsOfLossTotal: 'getHeadsOfLossTotal',
        headsOfLossTotalMinusInterest: 'getHeadsOfLossTotalMinusInterest',
        headsOfLossValue: 'value',
        headsOfLoss: 'headsOfLoss',
        interestDate: 'interestDate'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('fatal/estate/proceduralDates', {
        proceduralDatesValue: 'date'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('fatal/estate/interimPayments', {
        findPayment: 'findPayment',
        allInterimPaymentsValid: 'allInterimPaymentsValid'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('fatal/estate/deceased', {
        deceasedValue: 'theDeceased'
    }), {
        deceasedDod: {
            get: function get() {
                return this.deceasedValue['dateOfDeath'];
            }
        },
        interestType: {
            get: function get() {
                return this.headsOfLossValue('interestType');
            }
        },
        dateOfAssumedSettlement: {
            get: function get() {
                return this.proceduralDatesValue('dateOfAssumedSettlement');
            }
        },
        date: {
            get: function get() {
                return this.findPayment(this.index).date;
            },
            set: function set(value) {
                this.updatePayment({ key: 'date', index: this.index, value: value }).then(this.updateValid.bind(this));
            }
        },
        value: {
            get: function get() {
                return this.findPayment(this.index).value;
            },
            set: function set(value) {
                this.updatePayment({ key: 'value', index: this.index, value: value }).then(this.updateValid.bind(this));
            }
        },
        remainingTotal: function remainingTotal() {
            return numberVal(this.headsOfLossTotalMinusInterest - __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['fatal/estate/interimPayments/interimPayments'].reduce(function (total, payment) {
                return total + payment.value;
            }, 0) + this.value);
        }
    }),
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('fatal/estate/interimPayments', ['updatePayment', 'deletePayment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('fatal/estate/headsOfLoss', {
        calcInterest: 'calcAllInterest'
    }), {
        deleteThisPayment: function deleteThisPayment() {
            this.deletePayment(this.index);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.allInterimPaymentsValid);
            this.updateInterest();
        },
        updateInterest: function updateInterest() {
            this.calcInterest();
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.allInterimPaymentsValid);
        },
        isValidDate: function isValidDate() {
            if (!this.date) {
                return true;
            }

            var mDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.date, 'DD/MM/YYYY');

            return mDate.isValid() && mDate.isAfter(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.deceasedDod, 'DD/MM/YYYY')) && mDate.isSameOrBefore(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.interestDate, 'DD/MM/YYYY'));
        }
    })
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Header_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LostYearsClaims',
    components: {
        Timeline: __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_3_components_Header_vue___default.a
    },
    mounted: function mounted() {
        this.resetOrLoad(this.$route);
    },

    watch: {
        '$route': function $route(to, from) {
            this.resetOrLoad(to);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('lost/step', {
        steps: 'allSteps',
        current: 'currentStep',
        stepNo: 'currentStepIndex'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('claim', { claimId: 'id' })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('claim', ['load', 'reset', 'initialise']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('menu', ['updateMenu']), {
        isVisible: function isVisible() {
            if (this.$route.params.id == this.claimId) {
                return true;
            }

            if (!this.$route.params.id && this.claimId) {
                return true;
            }

            return false;
        },
        resetOrLoad: function resetOrLoad(route) {
            var _this = this;

            var id = route.params.id;

            if (!id) {
                return this.reset().then(function () {
                    _this.initialise('lost_years');
                });
            }

            if (this.claimId === parseInt(id)) {
                return;
            }

            this.load({ claim: { id: id }, router: this.$router });
        }
    })
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_html5_editor__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_html5_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_claims_dashboard_components_ReservesForClaim__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_claims_dashboard_components_ReservesForClaim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_claims_dashboard_components_ReservesForClaim__);















var HtmlEditor = new __WEBPACK_IMPORTED_MODULE_9_vue_html5_editor___default.a();

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'calculate-loss',
    data: function data() {
        return {
            editingContent: null,
            valid: false,
            theClaim: null,
            loading: false,
            isSaving: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('documents', {
        getGeneratedDocuments: 'getGeneratedDocuments',
        getDocumentsByType: 'getDocumentsByType',
        getEditingDocument: 'getEditingDocument',
        requesting: 'getRequestStatus',
        findDocument: 'getGeneratedDocument'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('lost/headsOfLoss', ['getHeadsOfLossValue', 'getAllCustomHeadOfLoss', 'getAllCustomHeadOfLossTotal', 'getAllCustomHeadOfLossInterestTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('lost/interimPayments', ['getAllInterimPaymentsTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('lost/lossOfIncome', ['futureLossTotal', 'pastLossTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('lost/cruBenefits', ['getGeneralDamagesOffset', 'getPastLossOfEarningsOffset', 'getPastCostOfCareOffset', 'getPastCostOfTravelOffset']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('claim', { claimId: 'id' }), {
        allCustomHeadOfLoss: {
            get: function get() {
                return this.getAllCustomHeadOfLoss;
            }
        },
        interestTotal: function interestTotal() {
            return numberVal(this.getHeadsOfLossValue('generalDamagesWithInterest')) + numberVal(this.getHeadsOfLossValue('pastDependencyOnServicesWithInterest')) + numberVal(this.getHeadsOfLossValue('pastCostOfCareWithInterest')) + numberVal(this.getHeadsOfLossValue('pastCostOfTravelWithInterest')) + numberVal(this.getHeadsOfLossValue('pastLossOfEarningsWithInterest')) + numberVal(this.getHeadsOfLossValue('miscWithInterest')) + numberVal(this.getAllCustomHeadOfLossInterestTotal);
        },
        subTotal: function subTotal() {
            return numberVal(this.getHeadsOfLossValue('generalDamages')) + numberVal(this.getHeadsOfLossValue('pastDependencyOnServices')) + numberVal(this.getHeadsOfLossValue('futureDependencyOnServices')) + numberVal(this.getHeadsOfLossValue('pastCostOfCare')) + numberVal(this.getHeadsOfLossValue('pastCostOfTravel')) + numberVal(this.pastLossTotal) + numberVal(this.getHeadsOfLossValue('misc')) + numberVal(this.getAllCustomHeadOfLossTotal) + numberVal(this.getHeadsOfLossValue('futureCostOfCare')) + numberVal(this.futureLossTotal) - numberVal(this.cruTotalDeductions);
        },
        total: function total() {
            return this.subTotal + this.interestTotal;
        },
        totalLessInterimPayments: function totalLessInterimPayments() {
            return this.total - numberVal(this.getAllInterimPaymentsTotal);
        },
        downloadUrl: function downloadUrl() {
            return '/api/v1/download/' + this.claimId + '?access_token=' + this.getToken;
        },
        cruTotalDeductions: function cruTotalDeductions() {
            return this.getGeneralDamagesOffset + this.getPastLossOfEarningsOffset + this.getPastCostOfCareOffset + this.getPastCostOfTravelOffset;
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_mixins_dateFormat__["a" /* default */]],
    components: {
        ReservesForClaim: __WEBPACK_IMPORTED_MODULE_11_pages_claims_dashboard_components_ReservesForClaim___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        HtmlEditor: HtmlEditor,
        StepButton: __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        back: function back() {
            if (this.prevValid) {
                this.$router.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_services_routingMethods__["d" /* prevStep */])().route);
            }
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('modal', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('documents', {
        toggleContent: 'toggleEditingDocument',
        createGeneratedDocument: 'createGeneratedDocument',
        deleteGeneratedDocument: 'deleteGeneratedDocument',
        getGeneratedDocumentsFromServer: 'getGeneratedDocumentsFromServer'
    }), {
        createDocument: function createDocument(type) {
            this.createGeneratedDocument({ claimId: this.claimId, claimType: __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['claim/type'], type: type });
        },
        deleteDocument: function deleteDocument(document) {
            if (this.requesting) {
                return;
            }
            this.deleteGeneratedDocument(document);
        },
        theDocument: function theDocument(index) {
            return this.findDocument(index);
        },
        requestInProgress: function requestInProgress() {
            return this.apiRouteRequestRunning('/api/v1/generated-documents/load');
        }
    })
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_directives_TwoDecimalPlaces__ = __webpack_require__(11);



var _watch;













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-info',
    mounted: function mounted() {
        this.updateLifeExpectancy(this.claimant.assumedLifeExpectancy);
        this.updateAssumedLifeExpectancy();
    },
    data: function data() {
        return {
            theDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('DD/MM/YYYY')
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lost/claimant', ['claimant', 'getClaimantValue', 'getClaimantDetail', 'getClaimantInfoValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lost/claimInfo', ['getClaimInfoValue']), {
        innerLifeExpectancy: function innerLifeExpectancy() {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.claimant.lifeExpectancy);
        },
        innerAssumedLifeExpectancy: function innerAssumedLifeExpectancy() {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.claimant.assumedLifeExpectancy);
        },
        currentAge: function currentAge() {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');
        },
        claimantReductionInLifeRules: function claimantReductionInLifeRules() {
            if (this.claimantReductionInLife < 0) {
                return false;
            }
            return true;
        },
        onsetRules: function onsetRules() {
            if (!this.onsetOfSymptoms) {
                return true;
            }

            var mOnsetOfSymptoms = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.onsetOfSymptoms, 'DD/MM/YYYY');

            if (!mOnsetOfSymptoms.isValid()) {
                return true;
            }

            return mOnsetOfSymptoms.isAfter(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'));
        },
        lifeExpectancyRules: function lifeExpectancyRules() {
            return this.getClaimantValue('lifeExpectancy').dateOfDeath;
        },

        ageAtOnsetOfSymptoms: {
            get: function get() {
                return this.getClaimantValue('ageAtOnset');
            }
        },
        assumedLifeExpectancyMethod: {
            get: function get() {
                return this.getClaimantValue('assumedLifeExpectancy').method;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.method = value;
                if (value === "assumed_date") {
                    this.dateOfDeath = null;
                }
            }
        },
        periodBetweenOnsetAndAssumedDod: {
            get: function get() {
                return this.getClaimInfoValue('periodBetweenOnsetAndAssumedDod');
            }
        },
        claimantReductionInLife: {
            get: function get() {
                return this.getClaimInfoValue('claimantReductionInLife');
            }
        },
        yearsLeft: {
            get: function get() {
                return this.getClaimantValue('assumedLifeExpectancy').yearsLeft;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.yearsLeft = value;
            }
        },
        monthsLeft: {
            get: function get() {
                return this.getClaimantValue('assumedLifeExpectancy').monthsLeft;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.monthsLeft = value;
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.getClaimantValue('assumedLifeExpectancy').dateOfDeath;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.dateOfDeath = value;
            }
        },
        ageAtDeath: {
            get: function get() {
                return this.getClaimantValue('assumedLifeExpectancy').ageAtDeath;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.ageAtDeath = value;
            }
        },
        percentageOfNormalLifeExpectancy: {
            get: function get() {
                return this.getClaimantValue('assumedLifeExpectancy').percentageOfNormalLifeExpectancy;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy = value;
            }
        },
        percentageReductionInNormalLifeExpectancy: {
            get: function get() {
                return this.getClaimantValue('assumedLifeExpectancy').percentageReductionInNormalLifeExpectancy;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy = value;
            }
        },
        percentageLabel: function percentageLabel() {
            return this.innerAssumedLifeExpectancy.method === 'percentage_of_normal_life_expectancy' ? 'Percentage of Normal Life Expectancy' : 'Percentage Reduction in Normal Life Expectancy';
        },

        dateOfBirth: {
            get: function get() {
                return this.getClaimantValue('dateOfBirth');
            }
        },
        levelOfEducation: {
            get: function get() {
                return this.getClaimantValue('levelOfEducation');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'levelOfEducation', value: value });
            }
        },
        disabledAtAccident: {
            get: function get() {
                return this.getClaimantValue('disabledAtAccident');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'disabledAtAccident', value: value });
            }
        },
        onsetOfSymptoms: {
            get: function get() {
                return this.getClaimantValue('onsetOfSymptoms');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'onsetOfSymptoms', value: value });
                this.updateOnsetAndAssumedDod();
            }
        },
        serviceOfProceedings: {
            get: function get() {
                return this.getClaimInfoValue('serviceOfProceedings');
            }
        }
    }),
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_12_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */]],
    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_10_components_form_control_DateInput_vue___default.a,
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_11_components_LifeExpectancy_vue___default.a
    },
    watch: (_watch = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, '$form.$valid', function $form$valid() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'onsetRules', function onsetRules() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'claimantReductionInLifeRules', function claimantReductionInLifeRules() {
        this.updateValid();
    }), _watch),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('lost/claimant', ['updateLifeExpectancy', 'updateClaimantValue', 'updateClaimantDetail', 'updateClaimantAssumedLifeExpectancy', 'updateReductionInLife', 'updateOnsetAndAssumedDod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('lost/claimInfo', ['updateClaimInfoValue']), {
        updateAssumedLifeExpectancy: function updateAssumedLifeExpectancy() {
            var assumedLifeExpectancy = this.innerAssumedLifeExpectancy;
            this.updateClaimantAssumedLifeExpectancy({ assumedLifeExpectancy: assumedLifeExpectancy });
        },
        updateLife: function updateLife(lifeExpectancy) {
            this.updateLifeExpectancy({ lifeExpectancy: lifeExpectancy });
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_services_routingMethods__["b" /* setStepValid */])(this.isValid());
        },
        isValid: function isValid() {
            return this.$valid() && this.onsetRules && this.claimantReductionInLifeRules;
        }
    })
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_LostYearsDOBDateInput_vue__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_LostYearsDOBDateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_LostYearsDOBDateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_WarningBox_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_WarningBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_WarningBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Typeahead__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_Typeahead__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claimant-details',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('lost/claimant', ['claimant', 'getClaimantValue', 'getClaimantDetail', 'getClaimantInfoValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        name: {
            get: function get() {
                return this.getClaimantValue('name');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'name', value: value });
            }
        },
        claimantSolicitor: {
            get: function get() {
                return this.getClaimantDetail('claimantSolicitor');
            }
        },
        claimantReference: {
            get: function get() {
                return this.getClaimantDetail('claimantReference');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'claimantReference', value: value });
            }
        },
        yourReference: {
            get: function get() {
                return this.getClaimantDetail('yourReference');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'yourReference', value: value });
            }
        },
        gender: {
            get: function get() {
                return this.getClaimantValue('gender');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'gender', value: value });
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.getClaimantValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'dateOfBirth', value: value });
            }
        },
        diseaseOrAccident: {
            get: function get() {
                return this.getClaimantDetail('diseaseOrAccident');
            },
            set: function set(value) {
                var _this = this;

                this.updateClaimantDetail({ key: 'diseaseOrAccident', value: value }).then(function () {
                    if (_this.diseaseOrAccident === 'disease') {
                        _this.accidentType = null;
                        _this.otherAccidentType = null;
                    } else if (_this.diseaseOrAccident === 'accident') {
                        _this.diseaseType = null;
                        _this.otherDiseaseType = null;
                    }
                }).then(this.updateValid.bind(this));
            }
        },
        accidentType: {
            get: function get() {
                return this.getClaimantDetail('accidentType');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'accidentType', value: value }).then(this.updateValid.bind(this));
            }
        },
        accidentTypeOther: {
            get: function get() {
                return this.getClaimantDetail('accidentTypeOther');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'accidentTypeOther', value: value }).then(this.updateValid.bind(this));
            }
        },
        diseaseType: {
            get: function get() {
                return this.getClaimantDetail('diseaseType');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'diseaseType', value: value });
            }
        },
        diseaseTypeOther: {
            get: function get() {
                return this.getClaimantDetail('diseaseTypeOther');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'diseaseTypeOther', value: value });
            }
        },
        defendantName: {
            get: function get() {
                return this.getClaimantDetail('defendantName');
            }
        },
        claimNarrative: {
            get: function get() {
                return this.getClaimantDetail('claimNarrative');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'claimNarrative', value: value });
            }
        },
        dateOfAssumedSettlement: {
            get: function get() {
                return this.getClaimantInfoValue('dateOfAssumedSettlement');
            },
            set: function set(value) {
                this.updateClaimInfoValue({ key: 'dateOfAssumedSettlement', value: value });
                this.checkIncomePeriods();
                this.updateLife(this.claimant.lifeExpectancy);
            }
        },
        dateOfAssumedSettlementInPast: {
            get: function get() {
                var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                if (!mAssumedSettlement.isValid()) {
                    return false;
                }

                return mAssumedSettlement.isBefore(__WEBPACK_IMPORTED_MODULE_10_moment___default()());
            }
        },
        discountRate: {
            get: function get() {
                return this.getClaimantInfoValue('discountRate');
            },
            set: function set(value) {
                this.updateClaimInfoValue({ key: 'discountRate', value: value });
            }
        },
        preLitOrLit: {
            get: function get() {
                return this.getClaimantInfoValue('proceduralStatus');
            },
            set: function set(value) {
                this.updateClaimInfoValue({ key: 'proceduralStatus', value: value });
            }
        },
        dateOfServiceProceedings: {
            get: function get() {
                return this.getClaimantInfoValue('dateOfServiceProceedings');
            },
            set: function set(value) {
                this.updateClaimInfoValue({ key: 'dateOfServiceProceedings', value: value });
            }
        },
        isValid: function isValid() {
            return this.$valid() && this.isValidClaimantSolicitor() && this.isValidDefendant();
        }
    }),
    data: function data() {
        return { valid: false };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    mounted: function mounted() {
        this.fetchSubMenu('lost');
    },

    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        ControlWarning: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        WarningBox: __WEBPACK_IMPORTED_MODULE_12_components_modal_WarningBox_vue___default.a,
        Typeahead: __WEBPACK_IMPORTED_MODULE_13_components_Typeahead___default.a,
        DateInputDOB: __WEBPACK_IMPORTED_MODULE_8_components_form_control_LostYearsDOBDateInput_vue___default.a
    },
    watch: {
        isValid: function isValid() {
            this.updateValid();
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('lost/claimant', ['updateClaimantValue', 'updateClaimantDetail', 'updateClaimInfoValue', 'updateOnsetAndAssumedDod', 'updateLifeExpectancy', 'checkIncomePeriods']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('menu', ['updateMenu', 'updateSubMenu']), {
        updateValid: function updateValid() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_services_routingMethods__["b" /* setStepValid */])(this.isValid);
        },
        fetchSubMenu: function fetchSubMenu(menu) {
            this.updateMenu(true);
            this.updateSubMenu(menu);
        },
        updateLife: function updateLife(lifeExpectancy) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_components_form_validator_validations__["a" /* validDate */])(this.dateOfBirth) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_components_form_validator_validations__["a" /* validDate */])(this.dateOfAssumedSettlement)) {
                return;
            }
            this.updateLifeExpectancy({ lifeExpectancy: lifeExpectancy });
        },
        assumedSettlementDateRules: function assumedSettlementDateRules() {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_components_form_validator_validations__["a" /* validDate */])(this.dateOfServiceProceedings)) {
                return __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY'));
            }
            return true;
        },
        serviceProceedingsDateRules: function serviceProceedingsDateRules() {
            return __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY'));
        },
        isValidClaimantSolicitor: function isValidClaimantSolicitor() {
            return this.claimantSolicitor && this.claimantSolicitor.name !== null && this.claimantSolicitor.name !== '';
        },
        isValidDefendant: function isValidDefendant() {
            return this.defendantName && this.defendantName.name !== null && this.defendantName.name !== '';
        },
        updateClaimantSolicitors: function updateClaimantSolicitors(value) {
            this.updateClaimantDetail({ key: 'claimantSolicitor', value: value });
        },
        updateDefendant: function updateDefendant(value) {
            this.updateClaimantDetail({ key: 'defendantName', value: value });
        }
    })
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_StepButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cru_benefits_GeneralDamages__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cru_benefits_GeneralDamages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__cru_benefits_GeneralDamages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cru_benefits_PastCostOfCare__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cru_benefits_PastCostOfCare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__cru_benefits_PastCostOfCare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cru_benefits_PastCostOfTravel__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cru_benefits_PastCostOfTravel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__cru_benefits_PastCostOfTravel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cru_benefits_PastLossOfEarnings__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cru_benefits_PastLossOfEarnings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__cru_benefits_PastLossOfEarnings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_routingMethods__ = __webpack_require__(13);















/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Accordion: __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_5_components_accordion_AccordionItem___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_0_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_1_components_form_control_Error___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_2_components_StepButton___default.a,
        GeneralDamages: __WEBPACK_IMPORTED_MODULE_7__cru_benefits_GeneralDamages___default.a,
        PastCostOfCare: __WEBPACK_IMPORTED_MODULE_8__cru_benefits_PastCostOfCare___default.a,
        PastCostOfTravel: __WEBPACK_IMPORTED_MODULE_9__cru_benefits_PastCostOfTravel___default.a,
        PastLossOfEarnings: __WEBPACK_IMPORTED_MODULE_10__cru_benefits_PastLossOfEarnings___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lost/cruBenefits', {
        findValue: 'value',
        findInclude: 'include',
        allValid: 'allValid'
    }),
    mounted: function mounted() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_routingMethods__["b" /* setStepValid */])(this.allValid);
    },

    watch: {
        allValid: __WEBPACK_IMPORTED_MODULE_11_services_routingMethods__["b" /* setStepValid */]
    },
    methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('lost/headsOfLoss', {
        setValue: 'updateValue',
        updateInterest: 'calcNewValue',
        calcInterest: 'calcInterest'
    })
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_lost_years_claims_steps_heads_of_loss_HeadOfLoss_vue__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_lost_years_claims_steps_heads_of_loss_HeadOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_lost_years_claims_steps_heads_of_loss_HeadOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_lost_years_claims_steps_heads_of_loss_Period_vue__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_lost_years_claims_steps_heads_of_loss_Period_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_lost_years_claims_steps_heads_of_loss_Period_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_lost_years_claims_steps_components_GeneralDamagesPslaCalculator_vue__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_lost_years_claims_steps_components_GeneralDamagesPslaCalculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_lost_years_claims_steps_components_GeneralDamagesPslaCalculator_vue__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'other-heads-of-loss',
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_9_components_StepButton_vue___default.a,
        HeadOfLoss: __WEBPACK_IMPORTED_MODULE_5_pages_lost_years_claims_steps_heads_of_loss_HeadOfLoss_vue___default.a,
        Period: __WEBPACK_IMPORTED_MODULE_8_pages_lost_years_claims_steps_heads_of_loss_Period_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent_vue___default.a,
        GeneralDamagesPslaCalculator: __WEBPACK_IMPORTED_MODULE_13_pages_lost_years_claims_steps_components_GeneralDamagesPslaCalculator_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('lost/headsOfLoss', ['getHeadsOfLossValue', 'getCareValue', 'allHeadsOfLossValid', 'allCarePeriodsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('lost/claimant', ['getClaimantDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('modal', ['modals']), {
        generalDamages: {
            get: function get() {
                return this.getHeadsOfLossValue('generalDamages');
            },
            set: function set(value) {
                this.setHeadsOfLossValue({ key: 'generalDamages', value: value }).then(this.updateValid);
            }
        },
        pastCostOfTravel: {
            get: function get() {
                return this.getHeadsOfLossValue('pastCostOfTravel');
            },
            set: function set(value) {
                this.setHeadsOfLossValue({ key: 'pastCostOfTravel', value: value }).then(this.updateValid);
            }
        },
        pastDependencyOnServices: {
            get: function get() {
                return this.getHeadsOfLossValue('pastDependencyOnServices');
            },
            set: function set(value) {
                this.setHeadsOfLossValue({ key: 'pastDependencyOnServices', value: value }).then(this.updateValid);
            }
        },
        futureDependencyOnServices: {
            get: function get() {
                return this.getHeadsOfLossValue('futureDependencyOnServices');
            },
            set: function set(value) {
                this.setHeadsOfLossValue({ key: 'futureDependencyOnServices', value: value }).then(this.updateValid);
            }
        },
        misc: {
            get: function get() {
                return this.getHeadsOfLossValue('misc');
            },
            set: function set(value) {
                this.setHeadsOfLossValue({ key: 'misc', value: value }).then(this.updateValid);
            }
        },
        customHeadsOfLoss: {
            get: function get() {
                return this.getHeadsOfLossValue('customHeadsOfLoss');
            }
        },
        pastCarePeriods: {
            get: function get() {
                return this.getCareValue('past').periods;
            }
        },
        futureCarePeriods: {
            get: function get() {
                return this.getCareValue('future').periods;
            }
        },
        costOfCareType: {
            get: function get() {
                return this.getCareValue('type');
            },
            set: function set(value) {
                this.setCareValue({ key: 'type', value: value }).then(this.updateValid);

                if (value === 'auto') {
                    return this.autoCalculateCare();
                }

                this.setCareValue({ key: 'totalValue', value: 0, type: 'past' }).then(this.updateValid());
            }
        },
        pastCareCalcType: {
            get: function get() {
                return this.getCareValue('past').type;
            },
            set: function set(value) {
                this.setCareValue({ key: 'type', value: value, type: 'past' }).then(this.updateValid);
            }
        },
        futureCareCalcType: {
            get: function get() {
                return this.getCareValue('future').type;
            },
            set: function set(value) {
                this.setCareValue({ key: 'type', value: value, type: 'future' }).then(this.updateValid());
            }
        },
        pastTotalValue: {
            get: function get() {
                return this.getCareValue('past').totalValue;
            },
            set: function set(value) {
                if (isNaN(value)) {
                    value = 0;
                }
                this.setCareValue({ key: 'totalValue', value: value, type: 'past' }).then(this.updateValid());
            }
        },
        futureTotalValue: {
            get: function get() {
                return this.getCareValue('future').totalValue;
            },
            set: function set(value) {
                if (isNaN(value)) {
                    value = 0;
                }
                this.setCareValue({ key: 'totalValue', value: value, type: 'future' }).then(this.updateValid());
            }
        },
        careIcon: {
            get: function get() {
                return this.getCareValue('type') === 'auto' ? 'formula' : 'default';
            }
        },
        diseaseType: {
            get: function get() {
                return this.getClaimantDetail('diseaseType');
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_12_directives_TwoDecimalPlaces__["a" /* default */]
    },
    watch: {
        'costOfCareType': function costOfCareType(newVal, oldValue) {
            var _this = this;

            this.$nextTick(function () {
                _this.updateValid();
            });
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('lost/headsOfLoss', ['setHeadsOfLossValue', 'setCareValue', 'addCustomHeadOfLoss', 'addCarePeriod', 'autoCalculateCare']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        addNewCarePeriod: function addNewCarePeriod(type) {
            this.addCarePeriod(type);
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_routingMethods__["b" /* setStepValid */])(this.isValid());
        },
        isValid: function isValid() {
            if (this.costOfCareType === 'auto' || this.costOfCareType === 'own') {
                this.validCare = this.allHeadsOfLossValid;
            }

            if (this.pastCareCalcType === 'manual') {
                this.validCare = this.allHeadsOfLossValid && this.allCarePeriodsValid('past');
            }

            if (this.futureCareCalcType === 'manual') {
                this.validCare = this.allHeadsOfLossValid && this.allCarePeriodsValid('future');
            }

            return this.$valid() && this.validCare && this.costOfCareType !== null;
        },
        toggleGeneralDamagesPslaModal: function toggleGeneralDamagesPslaModal() {
            this.toggle('generalDamagesPslaModal');
        }
    })
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_accordion_AccordionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_lost_years_claims_steps_income_Income_vue__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_lost_years_claims_steps_income_Income_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_lost_years_claims_steps_income_Income_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_modal_WarningBox_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_modal_WarningBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_modal_WarningBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_directives_TwoDecimalPlaces__ = __webpack_require__(11);






















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'income-information',
    mounted: function mounted() {
        this.calcRetirementData();
        this.calcRetirementAtOnset();
    },

    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_18_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('lost/claimant', ['claimant', 'getIncomeValue', 'getClaimantValue', 'getClaimantInfoValue']), {
        pastLossOfEarnings: {
            get: function get() {
                return this.getIncomeValue('pastLossOfEarnings');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'pastLossOfEarnings', value: value }).then(this.updateValid.bind(this));
            }
        },
        futureLossOfEarnings: {
            get: function get() {
                return this.getIncomeValue('futureLossOfEarnings');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'futureLossOfEarnings', value: value }).then(this.updateValid.bind(this));
            }
        },
        employedButFor: {
            get: function get() {
                return this.getClaimantValue('employedButFor');
            },
            set: function set(value) {
                if (value === false) {
                    this.updateClaimantValue({ key: 'contingencyMultiplier', value: false }).then(this.resetContingency()).then(this.resetFutureEmploymentIncome()).then(this.calculateLossOfEarnings());
                    this.updateIncomeValue({ key: 'retirementAgeCalc', value: 'auto' }).then(this.calcRetirementData());
                }

                this.updateClaimantValue({ key: 'employedButFor', value: value }).then(this.updateValid.bind(this));
            }
        },
        contingencyMultiplier: {
            get: function get() {
                return this.getIncomeValue('contingencyMultiplier');
            },
            set: function set(value) {
                if (value === false) {
                    this.resetContingency().then(this.updateIncomeValue({ key: 'contingencyMultiplier', value: value }).then(this.updateValid.bind(this)));
                }
                this.updateIncomeValue({ key: 'contingencyMultiplier', value: value }).then(this.updateValid.bind(this));
            }
        },
        levelOfEducation: {
            get: function get() {
                return this.getClaimantValue('levelOfEducation');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'levelOfEducation', value: value }).then(this.updateValid.bind(this));
            }
        },
        disabledAtAccident: {
            get: function get() {
                return this.getClaimantValue('disabledAtAccident');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'disabledAtAccident', value: value }).then(this.updateValid.bind(this));
            }
        },
        retirementAgeCalc: {
            get: function get() {
                return this.getIncomeValue('retirementAgeCalc');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'retirementAgeCalc', value: value });
                this.calcRetirementData();
            }
        },
        earliestRetirement: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.earliestRetirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');
            }
        },
        earliestRetirementDate: {
            get: function get() {
                if (this.retired) {
                    return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY').add(18, 'years').format('DD/MM/YYYY');
                }

                return __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('DD/MM/YYYY');
            }
        },
        retirementAge: {
            get: function get() {
                return this.getIncomeValue('retirementAge');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'retirementAge', value: value }).then(this.updateValid.bind(this));

                var newDate = __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY').add(value, 'years').format('DD/MM/YYYY');

                if (this.retirementDate !== newDate) {
                    this.retirementDate = newDate;
                }
            }
        },
        retirementDate: {
            get: function get() {
                var defaultRetirementAge = __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY').add(this.retirementAge, 'years').format('DD/MM/YYYY');
                var retirementDate = this.getIncomeValue('retirementDate') || defaultRetirementAge;

                return retirementDate;
            },
            set: function set(value) {
                var _this = this;

                var prev = this.retirementDate;
                this.updateIncomeValue({ key: 'retirementDate', value: value }).then(function () {
                    return _this.updateIncomePeriodForRetirementChange(prev);
                }).then(this.updateValid.bind(this));

                var newAge = __WEBPACK_IMPORTED_MODULE_15_moment___default()(value, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');

                if (this.retirementAge !== newAge) {
                    this.retirementAge = newAge;
                }
            }
        },
        multiplier: {
            get: function get() {
                return this.getIncomeValue('multiplier');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'multiplier', value: value });
                if (!value) {
                    this.updateIncomeValue({ key: 'multiplier', value: 1 });
                }
            }
        },
        employedAtAccident: {
            get: function get() {
                return this.claimant.employedAtAccident;
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'employedAtAccident', value: value });
            }
        },
        theMultiplier: {
            get: function get() {
                return this.getIncomeValue('multiplier');
            }
        },
        currentAge: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_15_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');
            }
        },
        showResult: {
            get: function get() {
                return this.employedButFor && this.contingencyMultiplier && this.employedAtAccident !== null && this.levelOfEducation !== null && this.disabledAtAccident !== null;
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },
        ageAtTrial: function ageAtTrial() {
            var dateOfTrial = __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.getClaimantInfoValue('dateOfAssumedSettlement'), 'DD/MM/YYYY');
            var dateOfBirth = __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY');
            return dateOfTrial.diff(dateOfBirth, 'years', true);
        },
        retired: function retired() {
            if (this.employedButFor === false) {
                return true;
            }
            return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.retirementDate, 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.getClaimantInfoValue('dateOfAssumedSettlement'), 'DD/MM/YYYY'));
        },
        retirementAgeRules: function retirementAgeRules() {
            if (this.retirementAge < this.earliestRetirement) {
                return false;
            }
            return true;
        },
        retirementDateRules: function retirementDateRules() {
            if (__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.retirementDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.earliestRetirementDate, 'DD/MM/YYYY'))) {
                return false;
            }
            return true;
        },
        retirementAtOnsetRules: function retirementAtOnsetRules() {
            if (this.employedButFor === true) {
                return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.retirementDate, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.getClaimantValue('onsetOfSymptoms'), 'DD/MM/YYYY'));
            }
            return true;
        },
        contingencyMultiplierPayload: function contingencyMultiplierPayload() {
            return {
                person: this.claimant,
                assumedSettlement: this.getClaimantInfoValue('dateOfAssumedSettlement')
            };
        },
        updateContingency: function updateContingency() {
            if (!this.contingencyMultiplier) {
                this.resetContingency();
            }
            this.calculateLossOfEarnings();
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_9_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17_mixins_roundValue__["a" /* default */]],
    components: {
        Accordion: __WEBPACK_IMPORTED_MODULE_4_components_accordion_Accordion_vue___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_5_components_accordion_AccordionItem_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_11_components_form_control_DateInput_vue___default.a,
        Income: __WEBPACK_IMPORTED_MODULE_14_pages_lost_years_claims_steps_income_Income_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_6_components_StepButton_vue___default.a,
        WarningBox: __WEBPACK_IMPORTED_MODULE_16_components_modal_WarningBox_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('lost/claimant', ['resetFutureEmploymentIncome', 'updateClaimantIncome', 'updateIncomeValue', 'updateRetirementAgeAndDate', 'updateClaimantValue', 'calculateLossOfEarnings', 'updateIncomePeriodForRetirementChange', 'updateIncomePeriodValue']), {
        updateIncome: function updateIncome(val) {
            this.updateClaimantIncome(val).then(this.updateValid);
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_routingMethods__["b" /* setStepValid */])(this.$valid());
        },
        isValid: function isValid() {
            return this.$valid() && this.validPastPeriods() && this.validFuturePeriods();
        },
        calcRetirementData: function calcRetirementData() {
            this.updateRetirementAgeAndDate();
        },
        calcRetirementAtOnset: function calcRetirementAtOnset() {
            if (this.employedButFor === null) {
                var retiredAtOnset = __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.retirementDate, 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.getClaimantValue('onsetOfSymptoms'), 'DD/MM/YYYY'));
                this.updateClaimantValue({ key: 'employedButFor', value: !retiredAtOnset }).then(this.updateValid.bind(this));
            }
        },
        resetContingency: function resetContingency() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.updateClaimantValue({ key: 'disabledAtAccident', value: null }), this.updateClaimantValue({ key: 'levelOfEducation', value: null }), this.updateClaimantValue({ key: 'employedAtAccident', value: null }), this.updateIncomeValue({ key: 'multiplier', value: 1 })]);
        },
        updateLossOfEarnings: function updateLossOfEarnings(type) {
            var pastPeriods = this.claimant.income[type + 'Periods'];

            if (!this[type + 'LossOfEarnings']) {
                pastPeriods.forEach(function (period, index) {
                    this.updateIncomePeriodValue({ index: index, key: 'employmentIncome', value: 0, type: type });
                    this.updateIncomePeriodValue({ index: index, key: 'pensionIncome', value: 0, type: type });
                    this.updateIncomePeriodValue({ index: index, key: 'totalGrossIncome', value: 0, type: type });
                    this.updateIncomePeriodValue({ index: index, key: 'totalNetIncome', value: 0, type: type });
                }, this);
            }
        },
        validPastPeriods: function validPastPeriods() {
            var _this2 = this;

            var pastPeriods = this.claimant.income['pastPeriods'];
            if (this.pastLossOfEarnings === false) {
                return true;
            }

            return pastPeriods.reduce(function (valid, period) {
                if (!valid) {
                    return false;
                }
                var startOfPeriod = __WEBPACK_IMPORTED_MODULE_15_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
                var endOfPeriod = __WEBPACK_IMPORTED_MODULE_15_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');
                var onsetOfSymptoms = __WEBPACK_IMPORTED_MODULE_15_moment___default()(_this2.getClaimantValue('onsetOfSymptoms'), 'DD/MM/YYYY');
                var dateOfAssessment = __WEBPACK_IMPORTED_MODULE_15_moment___default()(_this2.getClaimantInfoValue('dateOfAssumedSettlement'), 'DD/MM/YYYY');
                var validIncome = period.employmentIncome !== '' || period.pensionIncome !== '';

                return validIncome && startOfPeriod.isBefore(endOfPeriod) && onsetOfSymptoms.isSameOrBefore(startOfPeriod) && startOfPeriod.isBefore(dateOfAssessment) && endOfPeriod.isAfter(onsetOfSymptoms) && endOfPeriod.isSameOrBefore(dateOfAssessment);
            }, true);
        },
        validFuturePeriods: function validFuturePeriods() {
            var _this3 = this;

            var futurePeriods = this.claimant.income['futurePeriods'];
            if (this.futureLossOfEarnings === false) {
                return true;
            }

            return futurePeriods.reduce(function (valid, period) {
                if (!valid) {
                    return false;
                }
                var validIncome = period.employmentIncome !== '' || period.pensionIncome !== '';
                var startOfPeriod = __WEBPACK_IMPORTED_MODULE_15_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
                var endOfPeriod = __WEBPACK_IMPORTED_MODULE_15_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');
                var onsetOfSymptoms = __WEBPACK_IMPORTED_MODULE_15_moment___default()(_this3.getClaimantValue('onsetOfSymptoms'), 'DD/MM/YYYY');
                var dateOfDeath = __WEBPACK_IMPORTED_MODULE_15_moment___default()(_this3.getClaimantValue('lifeExpectancy').dateOfDeath, 'DD/MM/YYYY');
                return validIncome && startOfPeriod.isBefore(endOfPeriod) && onsetOfSymptoms.isSameOrBefore(startOfPeriod) && endOfPeriod.isAfter(onsetOfSymptoms) && startOfPeriod.isBefore(dateOfDeath) && endOfPeriod.isSameOrBefore(dateOfDeath);
            }, true);
        }
    })
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_lost_years_claims_steps_interim_Payment_vue__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_lost_years_claims_steps_interim_Payment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_lost_years_claims_steps_interim_Payment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_InterestItem_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_InterestItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_InterestItem_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'InterimPayments',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('lost/headsOfLoss', {
        getHeadsOfLossValue: 'getHeadsOfLossValue',
        getCustomHeadOfLoss: 'getCustomHeadOfLoss',
        getAllCustomHeadOfLoss: 'getAllCustomHeadOfLoss',
        getAllCareValue: 'getAllCareValue',
        getModalPayload: 'getModalPayload'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('lost/interimPayments', ['interimPayments', 'allInterimPaymentsValid']), {
        allCustomHeadOfLoss: {
            get: function get() {
                return this.getAllCustomHeadOfLoss;
            }
        },
        interestType: {
            get: function get() {
                return this.getHeadsOfLossValue('interestType');
            },
            set: function set(value) {
                this.setValue({ key: 'interestType', value: value });
            }
        },
        customInterestDate: {
            get: function get() {
                return this.getHeadsOfLossValue('customInterestDate');
            },
            set: function set(value) {
                this.setValue({ key: 'customInterestDate', value: value });
                this.updateValid.bind(this);
            }
        },
        payload: {
            get: function get() {
                return this.getModalPayload;
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    created: function created() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(true);
        this.calcAllInterest();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_2_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default.a,
        Payment: __WEBPACK_IMPORTED_MODULE_9_pages_lost_years_claims_steps_interim_Payment_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue___default.a,
        InterestItem: __WEBPACK_IMPORTED_MODULE_12_components_InterestItem_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('lost/headsOfLoss', {
        setValue: 'setHeadsOfLossValue',
        setCustomValue: 'setCustomHeadOfLossValue',
        calcAllInterest: 'calcAllInterest'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('lost/interimPayments', ['addPayment']), {
        calcInterestValue: function calcInterestValue() {
            this.calcAllInterest();
        },
        onUpdate: function onUpdate(info) {
            this.setValue({ key: info.updates, value: info.value }).then(this.calcAllInterest.bind(this));
        },
        onUpdateCustom: function onUpdateCustom(info) {
            this.setCustomValue({ index: info.updates, value: info.value, key: 'interest' }).then(this.calcAllInterest.bind(this));
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.isValid());
        },
        isValid: function isValid() {
            return this.$valid();
        }
    })
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_routingMethods__ = __webpack_require__(13);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loss-of-income',
    mounted: function mounted() {
        this.refresh();

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_services_routingMethods__["b" /* setStepValid */])(true);
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_roundValue__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('lost/claimant', ['claimant', 'getClaimantInfoValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('lost/lossOfIncome', ['pastLossPeriods', 'pastLossTotal', 'futureLossPeriods', 'futureLossTotal', 'isLoading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), {
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_5_components_IconTooltip___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent_vue___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('lost/lossOfIncome', ['refresh']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        toggleModal: function toggleModal(period) {
            this.toggle('calculation_' + this.uniqueId);

            this.getModalContent({
                endpoint: 'postAssessmentMultiplier',
                payload: { period: period, discountRate: this.getClaimantInfoValue('discountRate') }
            });
        }
    })
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_slider_component__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_lost_years_claims_steps_components_PslaAward__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_lost_years_claims_steps_components_PslaAward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_lost_years_claims_steps_components_PslaAward__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'general-damages-psla-calculator',
    data: function data() {
        return {
            calculatedDurationOfSymptoms: 0,
            loading: {
                table: false,
                awards: false
            },
            upliftButton: true,
            uplift: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('lost/claimant', { theClaimant: 'claimant' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('psla', { pslaValue: 'value' }), {
        table: {
            get: function get() {
                return this.pslaValue('table');
            }
        },
        awards: {
            get: function get() {
                return this.pslaValue('awards');
            }
        },
        filteredAwards: function filteredAwards() {
            var _this = this;

            if (!this.awards.length) {
                return [];
            }

            return this.awards.filter(function (award) {
                return award.age <= _this.ageAtDeath && award.duration <= _this.calculatedDurationOfSymptoms;
            });
        },

        dateOfBirth: {
            get: function get() {
                return this.theClaimant.dateOfBirth;
            }
        },
        ageAtDeath: {
            get: function get() {
                return this.roundValue(this.theClaimant.assumedLifeExpectancy.ageAtDeath, 2);
            }
        },
        upperAge: {
            get: function get() {
                var _this2 = this;

                var upperAge = this.ages.reverse().filter(function (age) {
                    return age <= _this2.ageAtDeath;
                });

                if (!upperAge || upperAge.length < 1) {
                    return this.ages.reverse()[0];
                }

                return upperAge[0];
            }
        },
        ages: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.table);
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.theClaimant.assumedLifeExpectancy.dateOfDeath;
            }
        },
        onsetOfSymptoms: {
            get: function get() {
                return this.theClaimant.onsetOfSymptoms;
            }
        },
        durationOfSymptoms: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.onsetOfSymptoms, 'DD/MM/YYYY'), 'months');
            }
        }
    }),
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalContent___default.a,
        VueSlider: __WEBPACK_IMPORTED_MODULE_12_vue_slider_component___default.a,
        PslaAward: __WEBPACK_IMPORTED_MODULE_13_pages_lost_years_claims_steps_components_PslaAward___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_mixins_roundValue__["a" /* default */]],
    created: function created() {
        this.loadTableCheck();
        this.loadAwardsCheck();
        this.calculatedDurationOfSymptoms = this.durationOfSymptoms;
    },

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('psla', ['loadTable', 'loadAwards']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('lost/headsOfLoss', { updateHeadsOfLossValue: 'setHeadsOfLossValue' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        loadTableCheck: function loadTableCheck() {
            var _this3 = this;

            if (!this.table.length) {
                this.loading.table = true;
                this.loadTable().then(function () {
                    _this3.loading.table = false;
                });
            }
        },
        loadAwardsCheck: function loadAwardsCheck() {
            var _this4 = this;

            if (!this.awards.length) {
                this.loading.awards = true;
                this.loadAwards().then(function () {
                    _this4.loading.awards = false;
                });
            }
        },
        isExactMatch: function isExactMatch(index, age) {
            return this.isColMatch(index) && this.isRowMatch(age);
        },
        isColMatch: function isColMatch(index) {
            index++;

            if (index === 1 && this.calculatedDurationOfSymptoms <= 3) {
                return true;
            }

            if (index === 13 && this.calculatedDurationOfSymptoms >= 37) {
                return true;
            }

            return this.calculatedDurationOfSymptoms >= index * 3 - 2 && this.calculatedDurationOfSymptoms <= index * 3;
        },
        isRowMatch: function isRowMatch(age) {
            return this.upperAge === age;
        },
        getTariffTableTdStyle: function getTariffTableTdStyle(index, age) {
            if (this.isExactMatch(index, age)) {
                return 'cursor: pointer; background:#c5ecfe; font-weight: bold; font-size: 14px;';
            }

            if (this.isColMatch(index) || this.isRowMatch(age)) {
                return 'cursor: pointer; background:#c5ecfe; font-size: 14px;';
            }

            return 'cursor: pointer; font-size: 14px;';
        },
        applyUplift: function applyUplift() {
            this.upliftButton = !this.upliftButton;
            this.uplift = !this.uplift;
        },
        usePslaAward: function usePslaAward(value) {
            this.updateHeadsOfLossValue({ key: 'generalDamages', value: value });
            this.toggle('generalDamagesPslaModal');
        }
    })
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'psla-award',
    props: ['award'],
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */]],
    mounted: function mounted() {
        this.loadRpiData();
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('mini/inflation', ['rpiData']), {
        rpi: {
            get: function get() {
                return this.rpiData;
            }
        },
        amount: {
            get: function get() {
                return this.award.award;
            }
        },
        maxYear: {
            get: function get() {
                return this.rpiYears[0];
            }
        },
        rpiYears: {
            get: function get() {
                var data = this.rpiData;

                if (!data.length) {
                    return [];
                }

                return data.reduce(function (carry, item) {
                    if (!carry.length) {
                        carry = [];
                    }

                    if (!carry.includes(item.year)) {
                        carry.push(item.year);
                    }

                    return carry;
                }).reverse();
            }
        },
        maxMonths: {
            get: function get() {
                var months = [];
                for (var month = 1; month <= 12; month++) {
                    if (this.getRpiForDate(this.maxYear, month) !== 0) {
                        months.push(month);
                    }
                }

                return months.length;
            }
        },
        maxMonth: {
            get: function get() {
                return this.maxMonths;
            }
        },
        latestRPI: {
            get: function get() {
                return this.getRpiForDate(this.maxYear, this.maxMonth);
            }
        },
        equivalent: {
            get: function get() {
                return this.amount / this.getRpiForDate(2017, 1) * this.getRpiForDate(this.maxYear, this.maxMonth);
            }
        },
        afterDate: function afterDate() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()('01/' + this.maxMonth + '/' + this.maxYear, 'DD/M/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()('01/05/2017', 'DD/MM/YYYY'));
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('mini/inflation', {
        loadRpiData: 'loadRpiData',
        updateValue: 'updateValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('lost/headsOfLoss', { updateHeadsOfLossValue: 'setHeadsOfLossValue' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        usePslaAward: function usePslaAward(value) {
            this.updateHeadsOfLossValue({ key: 'generalDamages', value: value });
            this.toggle('generalDamagesPslaModal');
        },
        monthToString: function monthToString(value) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, 'M').format('MMMM');
        },
        getRpiForDate: function getRpiForDate(year, month) {
            if (!this.rpi.length) {
                return 0;
            }

            var rpi = this.rpi.reduce(function (carry, item) {
                if (item.year === year && item.month === month) {
                    return item.amount;
                }
                return carry;
            });

            if ((typeof rpi === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(rpi)) === 'object') {
                return 0;
            }

            return rpi;
        }
    })
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_directives_TwoDecimalPlaces__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "benefit",
    mixins: [__WEBPACK_IMPORTED_MODULE_0_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_4_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default.a
    },
    props: {
        title: {
            type: String,
            required: true
        },
        storeKey: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        },
        showHeader: {
            type: Boolean,
            default: false
        },
        isLast: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        fieldName: function fieldName() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.snakeCase(this.title);
        },
        benefit: function benefit() {
            return this.$store.getters['lost/cruBenefits/' + this.storeKey];
        },

        amount: {
            get: function get() {
                return this.benefit.value;
            },
            set: function set(value) {
                this.updateValue({ key: this.storeKey, value: value }).then(this.calcInterest);
            }
        },
        include: {
            get: function get() {
                return this.benefit.include;
            },
            set: function set(value) {
                this.updateInclude({ key: this.storeKey, value: value }).then(this.calcInterest);
            }
        }
    },
    methods: {
        calcInterest: function calcInterest() {
            return this.$store.dispatch('lost/headsOfLoss/calcAllInterest');
        },
        updateValue: function updateValue(arg) {
            return this.$store.dispatch('lost/cruBenefits/updateValue', arg);
        },
        updateInclude: function updateInclude(arg) {
            return this.$store.dispatch('lost/cruBenefits/updateInclude', arg);
        }
    }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headOfLoss',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('lost/headsOfLoss', ['getCustomHeadOfLoss', 'allHeadsOfLossValid']), {
        name: {
            get: function get() {
                return this.getCustomHeadOfLoss(this.index).name;
            },
            set: function set(value) {
                this.setCustomHeadOfLossValue({ key: 'name', index: this.index, value: value });
            }
        },
        value: {
            get: function get() {
                return this.getCustomHeadOfLoss(this.index).value;
            },
            set: function set(value) {
                this.setCustomHeadOfLossValue({ key: 'value', index: this.index, value: value });
            }
        }
    }),
    created: function created() {
        this.updateValid();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('lost/headsOfLoss', ['setCustomHeadOfLossValue', 'deleteCustomHeadOfLoss']), {
        deleteThisHeadOfLoss: function deleteThisHeadOfLoss() {
            this.deleteCustomHeadOfLoss(this.index);
        },
        updateValid: function updateValid() {
            this.$emit('update');
        }
    })
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'period',
    props: {
        index: {
            type: Number,
            required: true
        },
        showSubtotal: {
            default: true
        },
        showDelete: {
            default: true
        },
        type: {
            type: String,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('lost/headsOfLoss', ['getCarePeriod', 'allCarePeriodsValid', 'findPeriod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('lost/claimant', ['claimant', 'getClaimantInfoValue']), {
        periodStart: {
            get: function get() {
                return this.getCarePeriod(this.type, this.index).periodStart;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'periodStart', index: this.index, value: value, type: this.type });
            }
        },
        periodEnd: {
            get: function get() {
                return this.getCarePeriod(this.type, this.index).periodEnd;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'periodEnd', index: this.index, value: value, type: this.type });
            }
        },
        hoursPerDay: {
            get: function get() {
                return this.getCarePeriod(this.type, this.index).hoursPerDay;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'hoursPerDay', index: this.index, value: value, type: this.type });
            }
        },
        rate: {
            get: function get() {
                return this.getCarePeriod(this.type, this.index).rate;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'rate', index: this.index, value: value, type: this.type });
            }
        },
        periodTotal: {
            get: function get() {
                return this.getCarePeriod(this.type, this.index).total.toFixed(2);
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'total', index: this.index, value: value, type: this.type });
            }
        },
        gratuitousCare: {
            get: function get() {
                return this.getCarePeriod(this.type, this.index).gratuitousCare;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'gratuitousCare', index: this.index, value: value, type: this.type });
            }
        },
        subTotalIcon: {
            get: function get() {
                return this.getCarePeriod(this.type, this.index).periodStart !== '' && this.getCarePeriod(this.type, this.index).periodEnd !== '' && this.getCarePeriod(this.type, this.index).hoursPerDay > 0 ? 'formula' : 'default';
            }
        },
        validationPeriodStart: {
            get: function get() {
                if (this.type === 'past') {
                    return this.claimant.onsetOfSymptoms;
                }

                return this.getClaimantInfoValue('dateOfAssumedSettlement');
            }
        },
        validationPeriodEnd: {
            get: function get() {
                if (this.type === 'past') {
                    return this.getClaimantInfoValue('dateOfAssumedSettlement');
                }

                return this.claimant.assumedLifeExpectancy.dateOfDeath;
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('lost/headsOfLoss', ['updateCarePeriodValue', 'deleteCarePeriod', 'calcCareTotalForPeriod']), {
        deletePeriod: function deletePeriod() {
            this.deleteCarePeriod({ index: this.index, type: this.type });
        },
        calcRate: function calcRate() {
            this.calcCareTotalForPeriod({ index: this.index, type: this.type });
            this.$emit('update');
        },
        startPeriodValid: function startPeriodValid() {
            if (this.type === 'past') {
                return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.claimant.onsetOfSymptoms, 'DD/MM/YYYY'));
            }

            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.getClaimantInfoValue('dateOfAssumedSettlement'), 'DD/MM/YYYY'));
        },
        endPeriodValid: function endPeriodValid() {
            if (this.type === 'past') {
                return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY').isValid() ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.getClaimantInfoValue('dateOfAssumedSettlement'), 'DD/MM/YYYY')) : false;
            }

            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.claimant.lifeExpectancy.dateOfDeath, 'DD/MM/YYYY'));
        },
        periodStartIsBeforeEnd: function periodStartIsBeforeEnd() {
            return this.periodEnd ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodEnd, 'DD/MM/YYYY')) : false;
        },
        periodStartIsBeforeAttendanceRates: function periodStartIsBeforeAttendanceRates() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()('01/04/2009', 'DD/MM/YYYY'));
        }
    })
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_lost_years_claims_steps_income_IncomePeriod_vue__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_lost_years_claims_steps_income_IncomePeriod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_lost_years_claims_steps_income_IncomePeriod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'income',
    props: {
        name: {
            type: String,
            required: true
        },
        income: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: null
        },
        retired: {
            type: Boolean,
            required: true
        },
        startDisabled: {
            type: Boolean,
            default: true
        },
        lossOfEarnings: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: "past"
        }
    },
    mounted: function mounted() {
        if (!this.innerIncome[this.type + 'Periods'].length) {
            this.incomePeriod().then(this.updateIncomePeriodForRetirementChange);
        }
    },

    components: {
        Control: __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        IncomePeriod: __WEBPACK_IMPORTED_MODULE_6_pages_lost_years_claims_steps_income_IncomePeriod_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_10_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('http', {
        loading: 'running'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('lost/claimant', ['claimant']), {
        innerIncome: function innerIncome() {
            var income = {};
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.util.extend(income, this.income);
            return income;
        },
        periods: function periods() {
            return this.innerIncome[this.type + 'Periods'];
        },
        periodsLength: function periodsLength() {
            return this.periods.length;
        },
        incomeRules: function incomeRules() {
            var periodIncomeCount = 0;

            this.periods.forEach(function (period, index) {
                if (period['employmentIncome'] > 0 || period['pensionIncome'] > 0) {
                    periodIncomeCount++;
                }
            }, this);

            return periodIncomeCount > 0;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('lost/incomeInformation', []), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('lost/claimant', ['addClaimantIncomePeriod', 'addIncomePeriod', 'updateIncomePeriod', 'updateIncomePeriodForRetirementChange']), {
        callAction: function callAction() {
            this.$emit('action', { income: this.innerIncome, index: this.index });
        },
        incomePeriod: function incomePeriod() {
            return this.addIncomePeriod(this.type);
        },
        updatePeriod: function updatePeriod(payload) {
            payload.type = this.type;
            this.updateIncomePeriod(payload);
        }
    })
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_lost_years_claims_steps_income_income_period_mixin__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__ = __webpack_require__(23);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'income-period',
    mounted: function mounted() {
        this.updatePeriod();
    },

    components: {
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue___default.a
    },
    props: {
        startDisabled: {
            type: Boolean,
            required: false
        },
        retired: {
            type: Boolean,
            required: true
        },
        lossOfEarnings: {
            type: Boolean,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        maxIndex: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_pages_lost_years_claims_steps_income_income_period_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('lost/claimant', ['claimant', 'getIncomePeriod', 'getClaimantInfoValue', 'getIncomeStatus']), {
        startOfPeriodRules: function startOfPeriodRules() {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__["a" /* validDate */])(this.innerPeriod.startOfPeriod) || this.innerPeriod.startOfPeriod === '' || this.innerPeriod.startOfPeriod === null) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.claimant.onsetOfSymptoms, 'DD/MM/YYYY'))) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.endOfPeriod, 'DD/MM/YYYY'))) {
                return false;
            }
            return true;
        },
        endOfPeriodRules: function endOfPeriodRules() {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__["a" /* validDate */])(this.innerPeriod.endOfPeriod) || this.innerPeriod.endOfPeriod === '' || this.innerPeriod.endOfPeriod === null) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.claimant.onsetOfSymptoms, 'DD/MM/YYYY'))) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.endOfPeriod, 'DD/MM/YYYY'))) {
                return false;
            }
            return true;
        },
        endOfPeriod: function endOfPeriod() {
            var endOfPeriod = this.getClaimantInfoValue('assumedSettlement');

            if (this.type === "future") {
                endOfPeriod = this.claimant.lifeExpectancy.dateOfDeath;
            }

            return endOfPeriod;
        },

        loading: {
            get: function get() {
                return this.getIncomeStatus;
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('lost/claimant', ['updateIncomePeriodValue', 'deleteIncomePeriod', 'addIncomePeriod']), {
        updatePeriod: function updatePeriod() {
            this.$emit('update', { index: this.index, period: this.innerPeriod });
        },
        deletePeriod: function deletePeriod() {
            var maxIndex = this.maxIndex - 1;
            var prevIndex = this.index - 1;
            var nextIndex = this.index + 1;
            var nextPeriodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: prevIndex }).endOfPeriod;
            var nextDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(nextPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

            this.index === maxIndex ? this.updateIncomePeriodValue({ type: this.type, index: prevIndex, key: 'endOfPeriod', value: this.endOfPeriod }) : this.updateIncomePeriodValue({ type: this.type, index: nextIndex, key: 'startOfPeriod', value: nextDay });

            this.deleteIncomePeriod({ index: this.index, type: this.type });
        },
        updateNextPeriod: function updateNextPeriod() {
            var maxIndex = this.maxIndex - 1;
            this.updatePeriod();

            if (this.index < maxIndex) {
                var nextIndex = this.index + 1;
                var nextDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                this.updateIncomePeriodValue({ type: this.type, index: nextIndex, key: 'startOfPeriod', value: nextDay });

                for (var i = nextIndex, len = maxIndex; i <= len; i++) {
                    var prevPeriodEndOfPeriod = '';
                    var periodEndOfPeriod = '';
                    var periodStartOfPeriod = '';

                    prevPeriodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: i - 1 }).endOfPeriod;
                    periodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: i }).endOfPeriod;
                    periodStartOfPeriod = this.getIncomePeriod({ type: this.type, index: i }).startOfPeriod;

                    if (prevPeriodEndOfPeriod > periodStartOfPeriod) {
                        periodStartOfPeriod = __WEBPACK_IMPORTED_MODULE_1_moment___default()(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
                        this.updateIncomePeriodValue({ type: this.type, index: i, key: 'startOfPeriod', value: periodStartOfPeriod });
                    }

                    if (periodEndOfPeriod <= periodStartOfPeriod && i !== len) {
                        this.updateIncomePeriodValue({ type: this.type, index: i, key: 'endOfPeriod', value: periodStartOfPeriod });
                    }
                }
            }

            if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.endOfPeriod, 'DD/MM/YYYY')) && __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY')) && this.index === maxIndex) {
                this.addIncomePeriod(this.type);
            }
        }
    })
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);














var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'payment',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('lost/headsOfLoss', ['getHeadsOfLossValue', 'interestDate', 'getHeadsOfLossTotalMinusInterest']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('lost/interimPayments', ['findPayment', 'allInterimPaymentsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('lost/claimant', ['getClaimantValue']), {
        onsetOfSymptoms: {
            get: function get() {
                return this.getClaimantValue('onsetOfSymptoms');
            }
        },
        date: {
            get: function get() {
                return this.findPayment(this.index).date;
            },
            set: function set(value) {
                this.updatePayment({ key: 'date', index: this.index, value: value }).then(this.updateValid.bind(this));
            }
        },
        value: {
            get: function get() {
                return this.findPayment(this.index).value;
            },
            set: function set(value) {
                this.updatePayment({ key: 'value', index: this.index, value: value }).then(this.updateValid.bind(this));
            }
        },
        remainingTotal: function remainingTotal() {
            return numberVal(this.getHeadsOfLossTotalMinusInterest - __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['lost/interimPayments/interimPayments'].reduce(function (total, payment) {
                return total + payment.value;
            }, 0) + this.value);
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('lost/interimPayments', ['updatePayment', 'deletePayment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('lost/headsOfLoss', ['calcAllInterest']), {
        deleteThisPayment: function deleteThisPayment() {
            this.deletePayment(this.index);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.allInterimPaymentsValid);
            this.updateInterest();
        },
        updateInterest: function updateInterest() {
            this.$emit('update');
            this.calcAllInterest();
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.allInterimPaymentsValid);
        },
        isValidDate: function isValidDate() {
            if (!this.date) {
                return true;
            }

            return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.date, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.onsetOfSymptoms, 'DD/MM/YYYY'));
        },
        isBeforeInterestDate: function isBeforeInterestDate() {
            if (!this.date || !this.interestDate) {
                return true;
            }

            var mInterestDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.interestDate, 'DD/MM/YYYY');

            if (!mInterestDate.isValid()) {
                return true;
            }

            return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.date, 'DD/MM/YYYY').isBefore(mInterestDate);
        }
    })
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'market-analysis'
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Icons_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_ValueBars__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_ValueBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_form_ValueBars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Header_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MiniCalculators',
    components: {
        Timeline: __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_3__components_Icons_vue___default.a,
        valueBars: __WEBPACK_IMPORTED_MODULE_4__components_form_ValueBars___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_5__components_IconTooltip_vue___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_6_components_Header_vue___default.a
    },
    mounted: function mounted() {
        this.fetchSubMenu('mini');
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('mini/step', {
        steps: 'allSteps',
        current: 'currentStep',
        stepNo: 'currentStepIndex'
    }), {
        checkHeader: function checkHeader() {
            var excludeGroup = ['age', 'care', 'dependency', 'gross', 'inflation', 'interest', 'interpolated', 'life', 'loss', 'meso', 'period', 'pre', 'retirement', 'loss'].map(this.isInRoutePath.bind(this)).every(function (isRoute) {
                return !isRoute;
            });

            return excludeGroup;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('dropdown', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('menu', ['updateMenu', 'updateMobileMenu', 'updateSubMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('fatal', { resetFatal: 'reset' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('lost', { resetLost: 'reset' }), {
        isRoute: function isRoute(route) {
            return !!this.$route.matched.filter(function (matched) {
                return matched && (matched.path.indexOf(route) !== -1 || matched.name === route);
            }).length;
        },
        isRouteByName: function isRouteByName(routeName) {
            return this.$route.name == routeName;
        },
        openSubMenu: function openSubMenu() {
            this.fetchSubMenu('mini');
        },
        fetchSubMenu: function fetchSubMenu(menu) {
            this.updateMenu(true);
            this.updateSubMenu(menu);
        },
        isInRoutePath: function isInRoutePath(routeName) {
            return ~this.$route.path.indexOf(routeName);
        }
    })
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DependantIncome',
    props: {
        index: {
            type: Number
        },
        showAddButton: {
            type: Boolean,
            default: true
        },
        reference: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        columnTwo: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/dependency', ['dependantIncome']), {
        income: {
            get: function get() {
                return this.dependantIncome(this.index);
            },
            set: function set(value) {
                this.updateDependant({ index: this.index, value: value });
                this.calculateTotal();
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/dependency', ['updateDependant', 'calculateTotal']), {
        addDependent: function addDependent() {
            this.$emit('addNewDependant');
            this.calculateTotal();
        },
        deleteDependant: function deleteDependant(index) {
            this.$emit('deleteDependant', index);
            this.calculateTotal();
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */]]
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'intro'
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_graphs_LineChart_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_components_MiniCalculatorHeader__);




















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'age-calculator',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('mini/interest', {
        getValue: 'value'
    }), {
        dateFrom: {
            get: function get() {
                return this.getValue('dateFrom');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateFrom', value: value });
            }
        },
        dateTo: {
            get: function get() {
                return this.getValue('dateTo');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateTo', value: value });
            }
        },
        interestRate: {
            get: function get() {
                return this.getValue('interestRate');
            },
            set: function set(value) {
                this.updateValue({ key: 'interestRate', value: value });
            }
        },
        principalAmount: {
            get: function get() {
                return this.getValue('principalAmount');
            },
            set: function set(value) {
                this.updateValue({ key: 'principalAmount', value: value });
            }
        },
        interestType: {
            get: function get() {
                return this.getValue('interestType');
            },
            set: function set(value) {
                this.updateValue({ key: 'interestType', value: value });
            }
        },
        compoundFrequency: {
            get: function get() {
                return this.getValue('compoundFrequency');
            },
            set: function set(value) {
                this.updateValue({ key: 'compoundFrequency', value: value });
            }
        },
        interestAccrued: {
            get: function get() {
                return this.getValue('interestAccrued');
            }
        },
        aggregateRate: {
            get: function get() {
                return this.getValue('aggregateRate');
            }
        },
        noOfDays: {
            get: function get() {
                return this.getValue('noOfDays');
            }
        },
        dailyRate: {
            get: function get() {
                return this.getValue('dailyRate');
            }
        },
        theTotal: {
            get: function get() {
                return this.getValue('theTotal');
            }
        },
        dateRules: function dateRules() {
            return this.dateTo ? this.dateTo > this.dateFrom : true;
        },
        totalInputs: function totalInputs() {
            return this.interestType === 'compound' ? 7 : 6;
        },
        frequency: function frequency() {
            switch (this.compoundFrequency) {
                case '52':
                    return 'weekly';
                case '12':
                    return 'monthly';
                case '4':
                    return 'quarterly';
                case '1':
                    return 'yearly';
            }
        }
    }),
    watch: {
        theTotal: function theTotal(value, newValue) {
            if (value !== newValue) {
                this.hidePrompt();
                this.showResults = true;
                this.updateChart();
            }
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_13_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue___default.a,
        LineChart: __WEBPACK_IMPORTED_MODULE_12_components_graphs_LineChart_js__["a" /* default */]
    },
    data: function data() {
        return {
            chartData: {},
            chartOptions: {},
            showResults: false
        };
    },
    created: function created() {
        this.resetForm();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('mini/interest', {
        resetForm: 'reset',
        updateValue: 'update',
        calcInterest: 'calcInterest'
    }), {
        updateTotal: function updateTotal() {
            var _this = this;

            this.calcInterest().then(function () {
                if (!_this.$valid()) {
                    return;
                }

                _this.hidePrompt();
                _this.showResults = true;
            });
        },
        resetTheForm: function resetTheForm() {
            this.resetForm();
        },
        updateChart: function updateChart() {
            var _this2 = this;

            var mDateTo = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateTo, 'DD/MM/YYYY');
            var mDateFrom = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateFrom, 'DD/MM/YYYY');
            var diff = mDateTo.diff(mDateFrom, 'days');

            this.chartData = {
                labels: [this.dateFrom, mDateFrom.add(diff / 2, 'days').format('DD/MM/YYYY'), this.dateTo],
                datasets: [{
                    label: 'Principal Amount',
                    type: 'line',
                    backgroundColor: ['#42E6F2'],
                    borderColor: ['#42E6F2'],
                    fill: false,
                    data: [this.principalAmount, this.principalAmount, this.principalAmount]
                }, {
                    label: 'Total including interest',
                    type: 'line',
                    backgroundColor: ['#4A89E5'],
                    borderColor: ['#4A89E5'],
                    fill: false,
                    data: [this.principalAmount, this.calcMiddlePoint(), this.theTotal]
                }]
            };

            this.chartOptions = {
                scales: {
                    yAxes: [{
                        ticks: {
                            userCallback: function userCallback(value, index, values) {
                                return _this2.currencyFormat(value);
                            }
                        }
                    }]
                }
            };
        },
        calcMiddlePoint: function calcMiddlePoint() {
            if (this.interestType === 'simple') {
                return this.interestAccrued / 2 + this.principalAmount;
            }
        }
    })
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'interpolated-multipliers',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/interpolatedMultipliers', {
        findValue: 'findValue'
    }), {
        ogdenTable: {
            get: function get() {
                return this.findValue('ogdenTable');
            },
            set: function set(value) {
                this.updateValue({ key: 'ogdenTable', value: value });
                this.resetCheck();
            }
        },
        discountRate: {
            get: function get() {
                return this.findValue('discountRate');
            },
            set: function set(value) {
                this.updateValue({ key: 'discountRate', value: value });
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.findValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateOfBirth', value: value });
                this.calculateAgeAtTrial();
            }
        },
        dateOfTrial: {
            get: function get() {
                return this.findValue('dateOfTrial');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateOfTrial', value: value });
                this.calculateAgeAtTrial();
            }
        },
        ageAtTrial: {
            get: function get() {
                return this.findValue('ageAtTrial');
            },
            set: function set(value) {
                this.updateValue({ key: 'ageAtTrial', value: value });
                this.calculateDateOfTrial();
            }
        },
        term: {
            get: function get() {
                return this.findValue('term');
            },
            set: function set(value) {
                this.updateValue({ key: 'term', value: value });
            }
        },
        ogdenTableInfo: {
            get: function get() {
                return this.findValue('ogdenTableInfo');
            }
        },
        multiplier: {
            get: function get() {
                var multiplier = this.findValue('multiplier');

                if (multiplier > 0) {
                    this.hidePrompt();
                }

                return multiplier;
            }
        },
        tableData: {
            get: function get() {
                return this.findValue('tableData');
            }
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a
    },
    mounted: function mounted() {
        this.loadOgdenTableInfo();
        this.resetValues();
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/interpolatedMultipliers', {
        updateValue: 'updateValue',
        loadOgdenTableInfo: 'loadOgdenTableInfo',
        calculateMultiplier: 'calculateMultiplier',
        resetValues: 'resetValues'
    }), {
        isValid: function isValid() {
            return this.ogdenTable !== null && this.discountRate !== null && this.ogdenTable !== 'table-28' && this.dateOfBirth && this.ageAtTrial && this.dateOfTrial && this.isValidAgeAtTrial() || this.ogdenTable === 'table-28' && this.isValidTerm();
        },
        reCalculateMultiplier: function reCalculateMultiplier() {
            if (!this.isValid()) {
                return;
            }

            this.calculateMultiplier();
        },
        calculateAgeAtTrial: function calculateAgeAtTrial() {
            if (this.dateOfBirth && this.dateOfTrial) {
                var dateOfTrial = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.dateOfTrial, 'DD/MM/YYYY');
                var dateOfBirth = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.dateOfBirth, 'DD/MM/YYYY');
                var ageAtTrial = this.roundValue(dateOfTrial.diff(dateOfBirth, 'days') / 365.25, 2);
                this.updateValue({ key: 'ageAtTrial', value: ageAtTrial });
            }
        },
        calculateDateOfTrial: function calculateDateOfTrial() {
            if (this.dateOfBirth && this.ageAtTrial) {
                var dateOfBirth = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.dateOfBirth, 'DD/MM/YYYY');
                var ageAtTrial = this.ageAtTrial;
                var dateOfTrial = dateOfBirth.add(ageAtTrial, 'years').format('DD/MM/YYYY');
                this.updateValue({ key: 'dateOfTrial', value: dateOfTrial });
            }
        },
        isValidAgeAtTrial: function isValidAgeAtTrial() {
            if (!this.ogdenTableInfo || !this.ogdenTable) {
                return true;
            }

            return this.ageAtTrial !== null && this.ageAtTrial >= this.ogdenTableInfo.tables[this.ogdenTable].min && this.ageAtTrial <= this.ogdenTableInfo.tables[this.ogdenTable].max;
        },
        ageAtTrialValidationMessage: function ageAtTrialValidationMessage() {
            if (!this.ogdenTable) {
                return '';
            }

            return 'The Age at Trial is required and must be between ' + this.ogdenTableInfo.tables[this.ogdenTable].min + ' - ' + this.ogdenTableInfo.tables[this.ogdenTable].max;
        },
        isValidTerm: function isValidTerm() {
            if (!this.ogdenTableInfo || !this.ogdenTable) {
                return true;
            }

            return this.term !== null && this.term >= this.ogdenTableInfo.tables[this.ogdenTable].min && this.term <= this.ogdenTableInfo.tables[this.ogdenTable].max;
        },
        termValidationMessage: function termValidationMessage() {
            if (!this.ogdenTable) {
                return '';
            }

            return 'The Term is required and must be between ' + this.ogdenTableInfo.tables[this.ogdenTable].min + ' - ' + this.ogdenTableInfo.tables[this.ogdenTable].max;
        },
        formulaData: function formulaData() {
            var thead = this.tableData.table.thead;
            var tbody = this.tableData.table.tbody;
            var discountRate = this.discountRate + '%';
            var data = [];
            var columnCount = 0;

            __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.forEach(thead, function (value, key) {
                if (value === discountRate) {
                    columnCount = key;
                }
            });

            __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.forEach(tbody, function (value, key) {
                data.push(value[0]);
                data.push(value[columnCount]);
            });

            return data;
        },
        resetCheck: function resetCheck() {
            if (this.findValue('ogdenTable') === 'table-28') {
                this.updateValue({ key: 'dateOfBirth', value: null });
                this.updateValue({ key: 'dateOfTrial', value: null });
                this.updateValue({ key: 'ageAtTrial', value: null });
                this.updateValue({ key: 'term', value: null });
            }
            this.updateValue({ key: 'multiplier', value: 0 });
            this.reCalculateMultiplier();
        }
    })
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_form_ValueBars__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_form_ValueBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_form_ValueBars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_components_MiniCalculatorHeader__);



















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'age-calculator',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('mini/age', { detailValue: 'value' }), {
        todaysDate: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD/MM/YYYY');
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.detailValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateDetail({ key: 'dateOfBirth', value: value });
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.detailValue('dateOfDeath');
            },
            set: function set(value) {
                this.updateDetail({ key: 'dateOfDeath', value: value });
            }
        },
        ageAtDeath: {
            get: function get() {
                var ageAtDeath = this.detailValue('age');

                if (ageAtDeath) {
                    this.hidePrompt();
                }

                return ageAtDeath;
            }
        },
        barValues: {
            get: function get() {
                return [this.roundValue(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateOfBirth, 'DD/MM/YYYY'), 'days', false) / 365.25, 2), this.roundValue(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.todaysDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateOfBirth, 'DD/MM/YYYY'), 'days', false) / 365.25, 2)];
            }
        },
        dateOfDeathRules: function dateOfDeathRules() {
            return "min:" + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.assumedSettlement, 'DD/MM/YYYY').subtract(9, 'years').format('DD/MM/YYYY') + "|" + "max:" + this.assumedSettlement;
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_mixins_roundValue__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_6_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_7_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_5_components_Icons_vue___default.a,
        ValueBars: __WEBPACK_IMPORTED_MODULE_13_components_form_ValueBars___default.a
    },
    data: function data() {
        return {
            value: 0
        };
    },
    created: function created() {
        this.resetForm();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('mini/age', {
        calculateAge: 'calculateAge',
        updateDetail: 'update',
        resetForm: 'reset'
    }), {
        calcAge: function calcAge() {
            this.calculateAge();
        },

        handler: function handler() {
            this.calcAge();

            if (!this.$valid()) {
                return;
            }

            this.hidePrompt();
        }

    })
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Icons__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_components_CarePeriod__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_components_CarePeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_components_CarePeriod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_store_modules_mini_care__ = __webpack_require__(246);



















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'care-calculator',
    created: function created() {
        this.resetForm();
        this.loadCareRates();
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/care', { detailValue: 'value' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), {
        periods: {
            get: function get() {
                return this.$store.getters['mini/care/periods'];
            },
            set: function set(value) {
                this.updateDetail({ key: 'periods', value: value });
            }
        },
        valid: function valid() {
            return !!this.periods.reduce(function (carry, period) {
                return carry ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_store_modules_mini_care__["a" /* validRequest */])(period) : carry;
            }, 1);
        },
        totalHours: function totalHours() {
            return this.periods.reduce(function (carry, period) {
                return carry + period.hours;
            }, 0);
        },
        total: function total() {
            return this.periods.reduce(function (carry, period) {
                return carry + period.total;
            }, 0);
        },

        rates: {
            get: function get() {
                return this.detailValue('rates');
            },
            set: function set(value) {
                this.updateDetail({ key: 'rates', value: value });
            }
        },
        showExplanation: function showExplanation() {
            return this.valid && this.total > 0 && this.periods.reduce(function (valid, period) {
                return !valid ? valid : period.total > 0;
            });
        }
    }),
    watch: {
        valid: function valid() {
            this.updatePrompt();
        },
        total: function total() {
            this.updatePrompt();
        }
    },
    mouted: function mouted() {
        this.hidePrompt();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_8_components_Icons___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        CarePeriod: __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_components_CarePeriod___default.a,
        modal: __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/care', {
        updateDetail: 'update',
        loadCareRates: 'loadCareRates',
        addPeriod: 'addPeriod',
        resetForm: 'reset'
    }), {
        diffInDays: function diffInDays(table) {
            return __WEBPACK_IMPORTED_MODULE_13_moment___default()(table.end.date).diff(__WEBPACK_IMPORTED_MODULE_13_moment___default()(table.start.date), 'days');
        },
        twoDp: function twoDp(value) {
            return (Math.round(value * 100) / 100).toFixed(2);
        },
        formatDate: function formatDate(date) {
            if (!date) {
                return 'N/A';
            }

            return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format('DD/MM/YYYY');
        },
        isLoading: function isLoading() {
            return this.apiRouteRequestRunning('/api/v1/mini-calculators/care/find-periods');
        },
        addCarePeriod: function addCarePeriod() {
            this.addPeriod();
        },
        toggleCareRatesModal: function toggleCareRatesModal() {
            this.toggle('care-rates');
        },
        formatModalDate: function formatModalDate(date) {
            return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        },
        getPeriodStart: function getPeriodStart(period) {
            if (!period.includeFirstDay) {
                return __WEBPACK_IMPORTED_MODULE_13_moment___default()(period.periodStart, 'DD/MM/YYYY').add(1, 'day').format('DD/MM/YYYY');
            }
            return period.periodStart;
        },
        getPeriodEnd: function getPeriodEnd(period) {
            if (!period.includeLastDay) {
                return __WEBPACK_IMPORTED_MODULE_13_moment___default()(period.periodEnd, 'DD/MM/YYYY').subtract(1, 'day').format('DD/MM/YYYY');
            }
            return period.periodEnd;
        },
        updatePrompt: function updatePrompt() {
            if (this.showExplanation) {
                this.hidePrompt();
            } else {
                this.showPrompt();
            }
        }
    })
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_mini_calculators_calculators_CalculatorComponents_DependantIncome_vue__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_mini_calculators_calculators_CalculatorComponents_DependantIncome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_mini_calculators_calculators_CalculatorComponents_DependantIncome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_components_MiniCalculatorPage_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_components_MiniCalculatorPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_components_MiniCalculatorPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_slider_component__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mixins_roundValue__ = __webpack_require__(19);





















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'dependency-multiplicand',
    created: function created() {
        this.reset();
        if (this.countDependants >= 1) {
            return;
        }
        this.createDependant();
    },
    data: function data() {
        return {
            sliderDisabled: false
        };
    },

    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('mini/dependency', ['getValue', 'totalDependantIncome', 'countDependants', 'getMultiplicand']), {
        deceasedNetIncome: {
            get: function get() {
                return this.getValue('deceasedIncome');
            },
            set: function set(value) {
                this.setValue({ key: 'deceasedIncome', value: value });
            }
        },
        multiplicand: {
            get: function get() {
                return this.getMultiplicand;
            },
            set: function set(value) {
                this.setValue({ key: 'multiplicand', value: value });
            }
        },
        total: {
            get: function get() {
                var total = this.getValue('total');

                if (total && this.deceasedNetIncome > 0) {
                    this.hidePrompt();
                }

                return total;
            }
        }
    }),
    watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'custom.value', function customValue() {
        this.updateCustom();
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15_mixins_currencyFormat__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default.a,
        DependantIncome: __WEBPACK_IMPORTED_MODULE_7_pages_mini_calculators_calculators_CalculatorComponents_DependantIncome_vue___default.a,
        VueSlider: __WEBPACK_IMPORTED_MODULE_12_vue_slider_component___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_components_MiniCalculatorPage_vue___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        MiniCalcIcons: __WEBPACK_IMPORTED_MODULE_13_components_Icons_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('mini/dependency', ['setValue', 'createDependant', 'deleteDependant', 'calculateTotal', 'updateCustomMultiplicand', 'reset']), {
        updateCustom: function updateCustom() {
            this.updateCustomMultiplicand(this.custom);
        },
        addDependant: function addDependant() {
            this.createDependant();
            this.resetMultiplicand();
        },
        removeDependant: function removeDependant(index) {
            if (this.countDependants === 1) {
                return;
            }
            this.deleteDependant(index);
            this.resetMultiplicand();
        },
        vueSliderFormatter: function vueSliderFormatter(value) {
            if (value === 66.6) {
                return '⅔';
            }

            return value + '%';
        },
        resetMultiplicand: function resetMultiplicand() {
            this.multiplicand = 0;
        }
    })
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_graphs_PieChart_js__ = __webpack_require__(117);


















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'earnings',
    data: function data() {
        return {
            chartData: {},
            chartOptions: {},
            showResults: false
        };
    },
    created: function created() {
        this.resetForm();
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/earnings', {
        findValue: 'findValue'
    }), {
        dateOfBirth: {
            get: function get() {
                return this.findValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateOfBirth', value: value });
            }
        },
        gender: {
            get: function get() {
                return this.findValue('gender');
            },
            set: function set(value) {
                this.updateValue({ key: 'gender', value: value });
            }
        },
        isRetired: {
            get: function get() {
                return this.findValue('isRetired');
            },
            set: function set(value) {
                this.updateValue({ key: 'isRetired', value: value });
            }
        },
        retirementDate: {
            get: function get() {
                return this.findValue('retirementDate');
            },
            set: function set(value) {
                this.updateValue({ key: 'retirementDate', value: value });
            }
        },
        dateFrom: {
            get: function get() {
                return this.findValue('dateFrom');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateFrom', value: value });
            }
        },
        dateTo: {
            get: function get() {
                return this.findValue('dateTo');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateTo', value: value });
            }
        },
        employmentType: {
            get: function get() {
                return this.findValue('employmentType');
            },
            set: function set(value) {
                this.updateValue({ key: 'employmentType', value: value });
            }
        },
        employmentIncome: {
            get: function get() {
                return this.findValue('employmentIncome');
            },
            set: function set(value) {
                this.updateValue({ key: 'employmentIncome', value: value });
            }
        },
        employmentIncomeNetGross: {
            get: function get() {
                return this.findValue('employmentIncomeNetGross');
            },
            set: function set(value) {
                this.updateValue({ key: 'employmentIncomeNetGross', value: value });
            }
        },
        totalGrossIncome: {
            get: function get() {
                return this.findValue('totalGrossIncome');
            }
        },
        totalNetIncome: {
            get: function get() {
                return this.findValue('totalNetIncome');
            }
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        PieChart: __WEBPACK_IMPORTED_MODULE_14_components_graphs_PieChart_js__["a" /* default */]
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_12_directives_TwoDecimalPlaces__["a" /* default */]
    },
    watch: {
        totalGrossIncome: function totalGrossIncome(value, newValue) {
            if (value !== newValue) {
                this.updateChart();
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/earnings', {
        updateValue: 'updateValue',
        calculateEarnings: 'calculateEarnings',
        resetForm: 'reset',
        updateRetirement: 'updateRetirement'
    }), {
        isValid: function isValid() {
            if (this.isRetired) {
                return this.isRetiredYesValid();
            }

            return this.isRetiredNoValid();
        },
        isRetiredYesValid: function isRetiredYesValid() {
            return this.dateOfBirth !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfBirth, 'DD/MM/YYYY').isValid() && this.dateFrom !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateFrom, 'DD/MM/YYYY').isValid() && this.dateTo !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateTo, 'DD/MM/YYYY').isValid() && this.dateFromIsBeforeDateTo() && this.employmentIncome > 0;
        },
        isRetiredNoValid: function isRetiredNoValid() {
            return this.dateOfBirth !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfBirth, 'DD/MM/YYYY').isValid() && this.retirementDate !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.retirementDate, 'DD/MM/YYYY').isValid() && this.dateFrom !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateFrom, 'DD/MM/YYYY').isValid() && this.dateTo !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateTo, 'DD/MM/YYYY').isValid() && this.dateFromIsBeforeDateTo() && this.employmentIncome > 0;
        },
        retirementDateIsValid: function retirementDateIsValid() {
            if (this.retirementDate === null) {
                return true;
            }

            var retirementDateMoment = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.retirementDate, 'DD/MM/YYYY');

            return retirementDateMoment.isValid();
        },
        dateFromIsValid: function dateFromIsValid() {
            if (this.dateFrom === null) {
                return true;
            }

            var dateFromMoment = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateFrom, 'DD/MM/YYYY');

            return dateFromMoment.isValid();
        },
        dateToIsValid: function dateToIsValid() {
            if (this.dateTo === null) {
                return true;
            }

            var dateToMoment = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateTo, 'DD/MM/YYYY');

            return dateToMoment.isValid() && this.dateFromIsBeforeDateTo();
        },
        dateFromIsBeforeDateTo: function dateFromIsBeforeDateTo() {
            var dateFromMoment = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateFrom, 'DD/MM/YYYY');
            var dateToMoment = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateTo, 'DD/MM/YYYY');
            return dateFromMoment.isValid() && dateToMoment.isValid() && dateFromMoment.isBefore(dateToMoment);
        },
        reCalculateRetired: function reCalculateRetired() {

            this.updateRetirement().then(this.reCalculateEarnings());
        },
        reCalculateEarnings: function reCalculateEarnings() {
            if (!this.isValid()) {
                return;
            }

            this.calculateEarnings();
            this.hidePrompt();
            this.showResults = true;
        },
        twoDp: function twoDp(value) {
            return (Math.round(value * 100) / 100).toFixed(2);
        },
        updateChart: function updateChart() {
            var netIncome = this.twoDp(this.totalNetIncome);
            var taxPaid = this.twoDp(this.totalGrossIncome - this.totalNetIncome);

            this.chartData = {
                labels: ['Net Earnings', 'Income Tax & NI Contributions Paid'],
                datasets: [{
                    label: 'Gross Income Breakdown',
                    backgroundColor: ['#4A89E5', '#c5ecfe'],
                    data: [netIncome, taxPaid]
                }]
            };

            this.chartOptions = {
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var allData = data.datasets[tooltipItem.datasetIndex].data;
                            var tooltipLabel = data.labels[tooltipItem.index];
                            var tooltipData = allData[tooltipItem.index];
                            return tooltipLabel + ': £' + tooltipData;
                        }
                    }
                }
            };
        },
        dateDiff: function dateDiff() {
            var dateFromM = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateFrom, 'DD/MM/YYYY');
            var dateToM = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateTo, 'DD/MM/YYYY');

            return dateToM.diff(dateFromM, 'y', true);
        }
    })
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mixins_percentageDifference__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_form_ValueBars__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_form_ValueBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_form_ValueBars__);





















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'inflation-calculator',
    created: function created() {
        this.resetForm();
    },

    computed: {
        rpi: function rpi() {
            return this.findValue('rpiData');
        },

        amount: {
            get: function get() {
                return this.findValue('amount');
            },
            set: function set(value) {
                this.updateValue({ key: 'amount', value: value });
            }
        },
        minYear: {
            get: function get() {
                return this.findValue('minYear');
            },
            set: function set(value) {
                this.updateValue({ key: 'minYear', value: value });
            }
        },
        minMonth: {
            get: function get() {
                return this.findValue('minMonth');
            },
            set: function set(value) {
                this.updateValue({ key: 'minMonth', value: value });
            }
        },
        maxYear: {
            get: function get() {
                return this.findValue('maxYear');
            },
            set: function set(value) {
                this.updateValue({ key: 'maxYear', value: value });
            }
        },
        maxMonth: {
            get: function get() {
                return this.findValue('maxMonth');
            },
            set: function set(value) {
                this.updateValue({ key: 'maxMonth', value: value });
            }
        },
        rpiYears: function rpiYears() {
            var data = this.findValue('rpiData');

            if (!data.length) {
                return [];
            }
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default()(data).map(function (item) {
                return item.year;
            }).uniq().reverse().value();
        },
        rpiMonths: function rpiMonths() {
            var _this = this;

            var data = this.findValue('rpiData');

            if (!data.length) {
                return [];
            }

            return __WEBPACK_IMPORTED_MODULE_1_lodash___default()(data).filter(function (item) {
                return item.year === _this.maxYear;
            }).map(function (item) {
                return item.month;
            }).value();
        },
        toYears: function toYears() {
            var _this2 = this;

            if (!this.minYear) {
                return this.rpiYears;
            }
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default()(this.rpiYears).filter(function (year) {
                return year >= _this2.minYear;
            }).value();
        },
        toMonths: function toMonths() {
            var _this3 = this;

            var now = __WEBPACK_IMPORTED_MODULE_16_moment___default()();
            var months = this.rpiMonths;
            if (!this.minMonth || this.minYear !== this.maxYear) {
                return 12;
            }

            if (this.maxYear === now.year()) {
                months.splice(now.month() - 1);
            }

            return __WEBPACK_IMPORTED_MODULE_1_lodash___default()(months).filter(function (month) {
                return month > _this3.minMonth;
            }).value();
        },
        fromRpi: function fromRpi() {
            return this.getRpiForDate(this.minYear, this.minMonth);
        },
        toRpi: function toRpi() {
            return this.getRpiForDate(this.maxYear, this.maxMonth);
        },
        equivalent: function equivalent() {
            return this.amount / this.fromRpi * this.toRpi;
        },
        startToEnd: function startToEnd() {
            var start = __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.minYear + '-' + this.minMonth, 'YYYY-M');
            var end = __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.maxYear + '-' + this.maxMonth, 'YYYY-M');

            return __WEBPACK_IMPORTED_MODULE_16_moment___default.a.duration(end.diff(start)).format('y[ years] [and] M[ months]').replace(" and 0 months", "");
        },
        barValues: function barValues() {
            return [this.twoDp(this.amount), this.twoDp(this.equivalent)];
        },
        difference: function difference() {
            return this.equivalent - this.amount;
        },
        isValid: function isValid() {
            return this.amount > 0 && this.minMonth !== null && this.minYear !== null && this.maxMonth !== null && this.maxYear !== null;
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13_mixins_percentageDifference__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_15_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        ValueBars: __WEBPACK_IMPORTED_MODULE_17_components_form_ValueBars___default.a
    },
    mounted: function mounted() {
        this.loadRpiData();
    },
    watch: {
        isValid: function isValid(valid) {
            if (valid) {
                this.hidePrompt();
            } else {
                this.showPrompt();
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('mini/inflation', {
        loadRpiData: 'loadRpiData',
        updateValue: 'updateValue',
        resetForm: 'reset'
    }), {
        twoDp: function twoDp(value) {
            return (Math.round(value * 100) / 100).toFixed(2);
        },
        monthToString: function monthToString(value) {
            return __WEBPACK_IMPORTED_MODULE_16_moment___default()(value, 'M').format('MMMM');
        },
        getRpiForDate: function getRpiForDate(year, month) {
            var data = this.findValue('rpiData');
            var match = __WEBPACK_IMPORTED_MODULE_1_lodash___default()(data).find(function (item) {
                return item.year === year && item.month === month;
            });
            if (match) {
                return match.amount;
            }
            return 0;
        },
        findValue: function findValue(key) {
            return this.$store.getters['mini/inflation/' + key];
        }
    })
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_form_ValueBars__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_form_ValueBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_form_ValueBars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mixins_roundValue__ = __webpack_require__(19);



var _watch;




















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'life-expectancy',
    created: function created() {
        this.resetForm();
    },

    watch: (_watch = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'percentageReductionInNormalLifeExpectancy', function percentageReductionInNormalLifeExpectancy() {
        this.calcAgeAtDeath();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'percentageOfNormalLifeExpectancy', function percentageOfNormalLifeExpectancy() {
        this.calcAgeAtDeath();
    }), _watch),
    data: function data() {
        return {
            showResults: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('mini/lifeExpectancy', {
        getAssumedSettlement: 'getAssumedSettlement',
        thePerson: 'thePerson',
        theResults: 'theResults'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('mini/age', { detailValue: 'value' }), {
        dateOfBirth: {
            get: function get() {
                return this.thePerson.dateOfBirth;
            },
            set: function set(value) {
                this.updatePerson({ key: 'dateOfBirth', value: value });
            }
        },
        gender: {
            get: function get() {
                return this.thePerson.gender;
            },
            set: function set(value) {
                this.updatePerson({ key: 'gender', value: value });
            }
        },
        lifeExpectancyMethod: {
            get: function get() {
                return this.thePerson.method;
            },
            set: function set(value) {
                this.updatePerson({ key: 'method', value: value });
            }
        },
        dateOfDeathIsAssumed: {
            get: function get() {
                return this.thePerson.dateOfDeathIsAssumed;
            },
            set: function set(value) {
                this.updatePerson({ key: 'dateOfDeathIsAssumed', value: value });
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.thePerson.dateOfDeath;
            },
            set: function set(value) {
                this.updatePerson({ key: 'dateOfDeath', value: value });
            }
        },
        ageAtDeath: {
            get: function get() {
                return this.thePerson.ageAtDeath;
            },
            set: function set(value) {
                this.updatePerson({ key: 'ageAtDeath', value: value });
            }
        },
        years: {
            get: function get() {
                return this.thePerson.yearsAndMonths.years;
            },
            set: function set(value) {
                this.updateYearsAndMonths({ key: 'years', value: value });
            }
        },
        months: {
            get: function get() {
                return this.thePerson.yearsAndMonths.months;
            },
            set: function set(value) {
                this.updateYearsAndMonths({ key: 'months', value: value });
            }
        },
        percentageOfNormalLifeExpectancy: {
            get: function get() {
                return this.thePerson.percentageOfNormalLifeExpectancy;
            },
            set: function set(value) {
                this.updatePerson({ key: 'percentageOfNormalLifeExpectancy', value: value });
            }
        },
        percentageReductionInNormalLifeExpectancy: {
            get: function get() {
                return this.thePerson.percentageReductionInNormalLifeExpectancy;
            },
            set: function set(value) {
                this.updatePerson({ key: 'percentageReductionInNormalLifeExpectancy', value: value });
            }
        },
        dateOfAssumedSettlement: {
            get: function get() {
                return this.getAssumedSettlement;
            },
            set: function set(value) {
                this.updateAssumedSettlement(value);
            }
        },
        intro: {
            get: function get() {
                return this.theResults.intro;
            }
        },
        explanation: {
            get: function get() {
                return this.theResults.explanation;
            }
        },
        outcome: {
            get: function get() {
                return this.theResults.outcome;
            }
        },
        formula: {
            get: function get() {
                return this.theResults.formula;
            }
        },
        tableData: {
            get: function get() {
                return this.theResults.tableData;
            }
        },
        dateOfDeathRules: function dateOfDeathRules() {
            return "min:" + __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.assumedSettlement, 'DD/MM/YYYY').subtract(9, 'years').format('DD/MM/YYYY') + "|" + "max:" + this.assumedSettlement;
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_9_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19_mixins_roundValue__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_15_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_7_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_8_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_12_components_form_control_DateInput_vue___default.a,
        TheLifeExpectancy: __WEBPACK_IMPORTED_MODULE_13_components_LifeExpectancy_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_16_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_17_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_11_components_Icons_vue___default.a,
        VueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a,
        ValueBars: __WEBPACK_IMPORTED_MODULE_18_components_form_ValueBars___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('mini/lifeExpectancy', {
        updatePerson: 'updatePerson',
        updateYearsAndMonths: 'updateYearsAndMonths',
        resetForm: 'reset',
        updateLifeExpectancy: 'updateLifeExpectancy',
        updateAssumedSettlement: 'updateAssumedSettlement'
    }), {
        resetTheForm: function resetTheForm() {
            this.resetForm();
        },
        updateCounter: function updateCounter(input) {
            this.counter = input;
        },
        calcAgeAtDeath: function calcAgeAtDeath() {
            if (this.validDob() && this.validDoAS()) {
                this.updateLifeExpectancy();
                this.handler();
            }
        },

        handler: function handler() {
            if (this.$valid() && !!this.lifeExpectancyMethod) {
                this.hidePrompt();
                this.showResults = true;
            }
        },
        ageToday: function ageToday() {
            var ageToday = Math.round(__WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.dateOfBirth, "DD/MM/YYYY"), 'days') / 365.25 * 100) / 100;

            if (!isNaN(ageToday)) {
                return ageToday;
            }

            return "";
        },
        dateToday: function dateToday() {
            return __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('DD/MM/YYYY');
        },
        validDob: function validDob() {
            if (!this.dateOfBirth) {
                return true;
            }

            var mDateOfBirth = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.dateOfBirth, 'DD/MM/YYYY');
            if (!mDateOfBirth.isValid()) {
                return true;
            }

            if (mDateOfBirth.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_5_moment___default()()) || mDateOfBirth.isSameOrBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(100, 'years'))) {
                return false;
            }

            return true;
        },
        validDoAS: function validDoAS() {
            if (!this.dateOfAssumedSettlement) {
                return true;
            }

            var mDateOfAssumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');
            if (!mDateOfAssumedSettlement.isValid()) {
                return true;
            }

            if (mDateOfAssumedSettlement.isBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.dateOfBirth, 'DD/MM/YYYY'))) {
                return false;
            }

            return true;
        },
        formulaData: function formulaData() {
            var thead = this.tableData.table.thead[1];
            var tbody = this.tableData.table.tbody;
            var data = [];
            var columnCount = 0;

            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(thead, function (value, key) {
                if (value === "0.00") {
                    columnCount = key;
                }
            });

            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(tbody, function (value, key) {
                data.push(value[0].value);
                data.push(value[columnCount].value);
            });

            return data;
        },
        result: function result() {
            return this.roundValue(this.ageAtDeath - this.ageToday(), 2);
        }
    })
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_IncomePeriod__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_IncomePeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_IncomePeriod__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loss-of-earnings',
    created: function created() {
        this.resetForm();
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/lossOfEarnings', {
        findValue: 'findValue',
        getPeriods: 'periods',
        periodsValid: 'periodsValid'
    }), {
        dateOfBirth: {
            get: function get() {
                return this.findValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateOfBirth', value: value });
            }
        },
        gender: {
            get: function get() {
                return this.findValue('gender');
            },
            set: function set(value) {
                this.updateValue({ key: 'gender', value: value });
            }
        },
        employmentType: {
            get: function get() {
                return this.findValue('employmentType');
            },
            set: function set(value) {
                this.updateValue({ key: 'employmentType', value: value });
            }
        },
        employmentIncome: {
            get: function get() {
                return this.findValue('employmentIncome');
            },
            set: function set(value) {
                this.updateValue({ key: 'employmentIncome', value: value });
            }
        },
        employmentNetGross: {
            get: function get() {
                return this.findValue('employmentNetGross');
            },
            set: function set(value) {
                this.updateValue({ key: 'employmentNetGross', value: value });
            }
        },
        retirementDate: {
            get: function get() {
                return this.findValue('retirementDate');
            }
        },
        totalNetIncome: {
            get: function get() {
                return this.findValue('totalNetIncome');
            }
        },
        loading: {
            get: function get() {
                return this.findValue('loading');
            }
        },
        totalNetLoss: {
            get: function get() {
                return this.findValue('totalNetLoss');
            }
        },
        isValid: function isValid() {
            return this.dateOfBirth !== null && this.dateOfBirth !== "" && this.gender !== null && this.gender !== "" && this.employmentType !== null && this.employmentIncome !== null && this.employmentIncome !== "" && this.employmentIncome > 0 && this.periodsValid;
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_12_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        IncomePeriod: __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_IncomePeriod___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/lossOfEarnings', {
        calculatePeriodLoss: 'calculatePeriodLoss',
        updateValue: 'updateValue',
        addPeriod: 'addPeriod',
        resetForm: 'reset'
    }), {
        addNewPeriod: function addNewPeriod() {
            this.addPeriod();
            this.calculateLoss();
        },
        periodDuration: function periodDuration(period) {
            return moment(period.endOfPeriod, 'DD/MM/YYYY').diff(moment(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true);
        },
        periodNetLoss: function periodNetLoss(period) {
            var duration = this.periodDuration(period);
            var preLossIncome = this.totalNetIncome;
            var lossIncome = period.totalNetIncome;

            return parseFloat(duration.toFixed(2)) * preLossIncome - parseFloat(duration.toFixed(2)) * lossIncome;
        },
        calculateLoss: function calculateLoss(payload) {
            if (!this.isValid) {
                this.showPrompt();
                this.showResults = false;
                return;
            }

            this.calculatePeriodLoss(payload.index);
            this.hidePrompt();
            this.showResults = true;
        }
    })
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_IconTooltip__);





















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loss-of-pension',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('mini/lossOfPension', {
        detailValue: 'value',
        pensionValue: 'pensionValue',
        getPension: 'pension',
        pensionUserInputValid: 'isPensionUserInputValid',
        personUserInputValid: 'isPersonUserInputValid'
    }), {
        gender: {
            get: function get() {
                return this.detailValue('gender');
            },
            set: function set(value) {
                this.updateDetail({ key: 'gender', value: value });
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.detailValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateDetail({ key: 'dateOfBirth', value: value });
            }
        },
        dateOfAssumedSettlement: {
            get: function get() {
                return this.detailValue('dateOfAssumedSettlement');
            },
            set: function set(value) {
                this.updateDetail({ key: 'dateOfAssumedSettlement', value: value });
            }
        },
        pensionMethod: {
            get: function get() {
                return this.pensionValue('pensionMethod');
            },
            set: function set(value) {
                this.updatePensionValue({ key: 'pensionMethod', value: value });
            }
        },
        lumpSumLoss: {
            get: function get() {
                return this.pensionValue('lumpSumLoss');
            },
            set: function set(value) {
                this.updatePensionValue({ key: 'lumpSumLoss', value: value });
            }
        },
        butForRetirementDate: {
            get: function get() {
                return this.pensionValue('butForRetirementDate');
            },
            set: function set(value) {
                this.updatePensionValue({ key: 'butForRetirementDate', value: value });
            }
        },
        butForRetirementAge: {
            get: function get() {
                return this.pensionValue('butForRetirementAge');
            },
            set: function set(value) {
                this.updatePensionValue({ key: 'butForRetirementAge', value: value });
            }
        },
        butForPensionLumpSum: {
            get: function get() {
                return this.pensionValue('butForPensionLumpSum');
            },
            set: function set(value) {
                var _this = this;

                this.updatePensionValue({ key: 'butForPensionLumpSum', value: value }).then(function () {
                    return _this.setPension({ key: 'lumpSumLossValue', value: _this.butForPensionLumpSum - _this.pensionLumpSum || 0 });
                });
            }
        },
        pensionLumpSum: {
            get: function get() {
                return this.pensionValue('pensionLumpSum');
            },
            set: function set(value) {
                var _this2 = this;

                this.updatePensionValue({ key: 'pensionLumpSum', value: value }).then(function () {
                    return _this2.updatePensionValue({ key: 'lumpSumLossValue', value: _this2.butForPensionLumpSum - _this2.pensionLumpSum || 0 });
                });
            }
        },
        dateLumpSumPaymentReceived: {
            get: function get() {
                return this.pensionValue('dateLumpSumPaymentReceived');
            },
            set: function set(value) {
                this.updatePensionValue({ key: 'dateLumpSumPaymentReceived', value: value });
            }
        },
        butForPensionAnnual: {
            get: function get() {
                return this.pensionValue('butForPensionAnnual');
            },
            set: function set(value) {
                var _this3 = this;

                this.updatePensionValue({ key: 'butForPensionAnnual', value: value }).then(function () {
                    return _this3.updatePensionValue({ key: 'pensionLossAnnual', value: _this3.butForPensionAnnual - _this3.pensionAnnual || 0 });
                });
            }
        },
        pensionAnnual: {
            get: function get() {
                return this.pensionValue('pensionAnnual');
            },
            set: function set(value) {
                var _this4 = this;

                this.updatePensionValue({ key: 'pensionAnnual', value: value }).then(function () {
                    return _this4.updatePensionValue({ key: 'pensionLossAnnual', value: _this4.butForPensionAnnual - _this4.pensionAnnual || 0 });
                });
            }
        },
        pensionLossAnnual: {
            get: function get() {
                return this.pensionValue('pensionLossAnnual');
            },
            set: function set(value) {
                this.setPension({ key: 'pensionLossAnnual', value: value });
            }
        },
        pensionLossMultiplier: {
            get: function get() {
                return this.pensionValue('pensionLossMultiplier');
            }
        },
        discountFactor: {
            get: function get() {
                return this.pensionValue('discountFactor');
            }
        },
        lumpSumLossPresentValue: {
            get: function get() {
                return this.pensionValue('lumpSumLossPresentValue');
            }
        },
        totalLoss: {
            get: function get() {
                return this.pensionValue('totalLoss');
            }
        },
        table21: {
            get: function get() {
                return this.detailValue('table21');
            }
        },
        table23: {
            get: function get() {
                return this.detailValue('table23');
            }
        },
        table27: {
            get: function get() {
                return this.detailValue('table27');
            }
        },
        lowerAge: {
            get: function get() {
                return this.detailValue('lowerAge');
            }
        },
        upperAge: {
            get: function get() {
                return this.detailValue('upperAge');
            }
        },
        lowerMultiplier: {
            get: function get() {
                return this.detailValue('lowerMultiplier');
            }
        },
        upperMultiplier: {
            get: function get() {
                return this.detailValue('upperMultiplier');
            }
        },
        acceleratedReceipt: {
            get: function get() {
                return this.pensionValue('acceleratedReceipt');
            }
        },
        lumpSumValid: function lumpSumValid() {
            if (this.pensionLumpSum > this.butForPensionLumpSum) {
                return false;
            }

            return true;
        },
        pensionAnnualIncomeValid: function pensionAnnualIncomeValid() {
            if (this.pensionAnnual > this.butForPensionAnnual) {
                return false;
            }

            return true;
        },
        isValid: function isValid() {
            return this.pensionUserInputValid && this.personUserInputValid;
        },
        modalPayload: function modalPayload() {
            return {
                pension: this.getPension,
                claimant: {
                    gender: this.detailValue('gender'),
                    dateOfBirth: this.detailValue('dateOfBirth')
                },
                claimInfo: {
                    dateOfAssumedSettlement: this.detailValue('dateOfAssumedSettlement'),
                    discountRate: "-0.75"
                }
            };
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_4_components_Icons_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_15_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_16_components_modal_ModalContent___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_17_components_IconTooltip___default.a
    },
    created: function created() {
        this.resetForm();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('mini/lossOfPension', {
        updateDetail: 'update',
        updatePensionValue: 'updatePensionValue',
        resetForm: 'reset',
        calculatePensionLoss: 'calculatePensionLoss',
        updateRetirement: 'updateRetirement'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        handler: function handler() {
            this.updateRetirement();

            if (!this.isValid) {
                return;
            }

            this.calculatePensionLoss();
            this.hidePrompt();
        },
        toggleDiscountFactorModal: function toggleDiscountFactorModal() {
            this.toggle('discount_factor_modal');

            this.getModalContent({
                endpoint: 'lumpSumMultiplier',
                payload: this.modalPayload
            });
        },
        togglePensionMultiplierModal: function togglePensionMultiplierModal() {
            this.toggle('pension_multiplier_modal');

            this.getModalContent({
                endpoint: 'pensionLossMultiplier',
                payload: this.modalPayload
            });
        }
    })
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPageAlternativeWidth__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPageAlternativeWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPageAlternativeWidth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_fatal_accident_claims_dependency_steps_general_damages_PslaAward__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_fatal_accident_claims_dependency_steps_general_damages_PslaAward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pages_fatal_accident_claims_dependency_steps_general_damages_PslaAward__);



















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mesothelioma-psla-calculator',
    data: function data() {
        return {
            loading: {
                table: false,
                awards: false
            },
            upliftButton: true,
            uplift: false,
            showResults: false,
            pslaAward: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('mini/meso', ['value']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('psla', { pslaValue: 'value' }), {
        dateOfBirth: {
            get: function get() {
                return this.value('dateOfBirth');
            },
            set: function set(value) {
                this.updateDetail({ key: 'dateOfBirth', value: value });

                var mDob = moment(value, 'DD/MM/YYYY');
                var mNow = moment();
                var age = this.roundYears(mNow.diff(mDob, 'years', true));
                this.updateDetail({ key: 'ageOfPerson', value: age });
            }
        },
        durationOfSymptoms: {
            get: function get() {
                return this.value('durationOfSymptoms');
            },
            set: function set(value) {
                this.updateDetail({ key: 'durationOfSymptoms', value: value });
            }
        },
        ageOfPerson: {
            get: function get() {
                return this.value('ageOfPerson');
            },
            set: function set(value) {
                this.updateDetail({ key: 'ageOfPerson', value: value });

                var mNow = moment();
                var dob = mNow.subtract(value, 'years').format('DD/MM/YYYY');
                this.updateDetail({ key: 'dateOfBirth', value: dob });
            }
        },
        table: {
            get: function get() {
                return this.pslaValue('table');
            }
        },
        awards: {
            get: function get() {
                return this.pslaValue('awards');
            }
        },
        currentRpi: {
            get: function get() {
                return this.pslaValue('currentRpi');
            }
        },
        ages: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.table);
            }
        },
        upperAge: {
            get: function get() {
                var _this = this;

                var upperAge = this.ages.reverse().filter(function (age) {
                    return age <= _this.ageOfPerson;
                });

                if (!upperAge || upperAge.length < 1) {
                    return this.ages.reverse()[0];
                }

                return upperAge[0];
            }
        },
        filteredAwards: function filteredAwards() {
            var _this2 = this;

            if (!this.awards.length) {
                return [];
            }
            return this.awards.map(function (award) {
                var score = Math.abs(_this2.ageAtDeath - award.age) + Math.abs(_this2.durationOfSymptoms - award.duration);
                return { score: score, award: award };
            }).sort(function (a, b) {
                if (a.score === b.score) {
                    return 0;
                }
                return a.score - b.score;
            }).map(function (info) {
                return info.award;
            }).slice(0, 10);
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_8_components_form_control_DateInput_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPageAlternativeWidth___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_4_components_Icons_vue___default.a,
        PslaAward: __WEBPACK_IMPORTED_MODULE_15_pages_fatal_accident_claims_dependency_steps_general_damages_PslaAward___default.a
    },
    created: function created() {
        this.resetForm();
        this.loadTableCheck();
        this.loadAwardsCheck();
        this.loadCurrentRpi();
    },

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('mini/meso', {
        calculateAge: 'calculateAge',
        calculateDateOfBirth: 'calculateDateOfBirth',
        updateDetail: 'update',
        resetForm: 'reset'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('psla', ['loadTable', 'loadAwards', 'loadCurrentRpi']), {
        loadTableCheck: function loadTableCheck() {
            var _this3 = this;

            if (!this.table.length) {
                this.loading.table = true;
                this.loadTable().then(function () {
                    _this3.loading.table = false;
                });
            }
        },
        loadAwardsCheck: function loadAwardsCheck() {
            var _this4 = this;

            this.awards = [];
            this.loading.awards = true;
            this.loadAwards().then(function () {
                _this4.loading.awards = false;
            });
        },
        isExactMatch: function isExactMatch(index, age) {
            return this.isColMatch(index) && this.isRowMatch(age);
        },
        isColMatch: function isColMatch(index) {
            index++;

            if (index === 1 && this.durationOfSymptoms <= 3) {
                return true;
            }

            if (index === 13 && this.durationOfSymptoms >= 37) {
                return true;
            }

            return this.durationOfSymptoms >= index * 3 - 2 && this.durationOfSymptoms <= index * 3;
        },
        isRowMatch: function isRowMatch(age) {
            return this.upperAge === age;
        },
        getTariffTableTdStyle: function getTariffTableTdStyle(index, age) {
            if (this.isExactMatch(index, age)) {
                this.setPslaAward(this.table[age][index]);
                return 'cursor: pointer; background:#c5ecfe; font-weight: bold; font-size: 14px;';
            }

            if (this.isColMatch(index) || this.isRowMatch(age)) {
                return 'cursor: pointer; background:#c5ecfe; font-size: 14px;';
            }

            return 'cursor: pointer; font-size: 14px;';
        },
        applyUplift: function applyUplift() {
            this.upliftButton = !this.upliftButton;
            this.uplift = !this.uplift;
        },
        isValid: function isValid() {
            return this.durationOfSymptoms !== null && this.durationOfSymptoms !== "" && this.dateOfBirth !== null && this.dateOfBirth !== "" && this.ageOfPerson !== null && this.ageOfPerson !== "" && moment(this.dateOfBirth, 'DD/MM/YYYY').isValid();
        },
        roundYears: function roundYears(years) {
            return Math.round(years * 100) / 100;
        },
        setPslaAward: function setPslaAward(value) {
            if (this.showResults) {
                this.uplift ? this.pslaAward = value * 1.1 : this.pslaAward = value;
            }
        },
        handler: function handler() {
            if (!this.isValid()) {
                this.showPrompt();
                this.pslaAward = null;
                return;
            }

            this.loadTableCheck();
            this.loadAwardsCheck();
            this.loadCurrentRpi();

            this.hidePrompt();
            this.showResults = true;
        }
    })
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_graphs_PieChart_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pension',
    data: function data() {
        return {
            chartData: {},
            chartOptions: {},
            showResults: false
        };
    },
    created: function created() {
        this.resetForm();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    props: {},
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])('mini/pension', { pension: 'all', total: 'total' }), {
        income: {
            get: function get() {
                return this.pension.income;
            },
            set: function set(value) {
                this.setPension({ key: 'income', value: value });
            }
        },
        pensionType: {
            get: function get() {
                return this.pension.pensionType;
            },
            set: function set(value) {
                this.setPension({ key: 'pensionType', value: value });
            }
        },
        fiscalYear: {
            get: function get() {
                return this.pension.fiscalYear;
            },
            set: function set(value) {
                this.setPension({ key: 'fiscalYear', value: value });
            }
        }
    }),
    watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'pension.results', function pensionResults() {
        this.updateChart();
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('mini/pension', { setPension: 'set', resetForm: 'reset' }), {
        twoDp: function twoDp(value) {
            return (Math.round(value * 100) / 100).toFixed(2);
        },
        updateChart: function updateChart() {
            this.hidePrompt();
            this.showResults = true;

            var netIncome = this.pension.results.netIncome;
            var taxPaid = this.pension.results.taxPaid;

            this.chartData = {
                labels: ['Net Income', 'Income Tax Paid'],
                datasets: [{
                    label: 'Gross Income Breakdown',
                    backgroundColor: ['#4A89E5', '#c5ecfe'],
                    data: [netIncome, taxPaid]
                }]
            };
        }
    }),
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_3_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_4_components_Icons___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_6_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a,
        PieChart: __WEBPACK_IMPORTED_MODULE_7_components_graphs_PieChart_js__["a" /* default */]
    }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_components_MiniCalculatorPage_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_components_MiniCalculatorPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_components_MiniCalculatorPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_components_MiniCalculatorHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);











;




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'period-between-two-dates',
    created: function created() {
        this.reset();
    },

    data: function data() {
        return {
            showResults: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('mini/period', ['getCalculator']), {
        firstDate: {
            get: function get() {
                return this.getCalculator.firstDate;
            },
            set: function set(value) {
                this.setCalculatorValue({ key: 'firstDate', value: value });
            }
        },
        secondDate: {
            get: function get() {
                return this.getCalculator.secondDate;
            },
            set: function set(value) {
                this.setCalculatorValue({ key: 'secondDate', value: value });
            }
        },
        displayFormat: {
            get: function get() {
                return this.getCalculator.displayFormat;
            },
            set: function set(value) {

                this.setCalculatorValue({ key: 'displayFormat', value: value });
            }
        },
        diffBetween: {
            get: function get() {
                return this.getCalculator.diffBetween;
            }
        },
        diffYears: {
            get: function get() {
                return this.getCalculator.diffYears;
            }
        },
        options: {
            get: function get() {
                return this.getCalculator.options;
            }
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default.a,
        MiniCalcIcons: __WEBPACK_IMPORTED_MODULE_7_components_Icons_vue___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_9_pages_mini_calculators_components_MiniCalculatorPage_vue___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_11_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('mini/period', ['setCalculatorValue', 'calculateDifference', 'setOptions', 'reset']), {
        isValid: function isValid() {
            return this.firstDate !== null && __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.firstDate, 'DD/MM/YYYY').isValid() && this.secondDate !== null && __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.secondDate, 'DD/MM/YYYY').isValid() && __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.firstDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.secondDate, 'DD/MM/YYYY')) && !this.optionsEmpty();
        },
        secondDateValidation: function secondDateValidation() {
            if (this.secondDate === null || this.firstDate === null) {
                return true;
            }
            return __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.secondDate, 'DD/MM/YYYY').isValid() && __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.firstDate, 'DD/MM/YYYY').isValid() && __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.secondDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.firstDate, 'DD/MM/YYYY'));
        },
        calculate: function calculate() {
            if (!this.isValid()) {
                return false;
            }

            this.hidePrompt();
            this.showResults = true;

            this.calculateDifference({
                firstDate: this.firstDate,
                secondDate: this.secondDate,
                options: this.options
            });
        },
        updateOptions: function updateOptions() {
            this.setOptions(this.options);
            this.calculate();

            if (!this.isValid()) {
                return;
            }

            this.hidePrompt();
            this.showResults = true;
        },
        optionsEmpty: function optionsEmpty() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options.show).every(function (option) {
                return !_this.options.show[option];
            });
        }
    })
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'retirement-age',
    created: function created() {
        this.resetForm();
    },

    data: function data() {
        return {
            showResults: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/retirementAge', {
        getValue: 'value'
    }), {
        gender: {
            get: function get() {
                return this.getValue('gender');
            },
            set: function set(value) {
                this.updateValue({ key: 'gender', value: value });
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.getValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateOfBirth', value: value });
            }
        },
        retirementAge: {
            get: function get() {
                return this.getValue('retirementAge');
            }
        },
        retirementDate: {
            get: function get() {
                return this.getValue('retirementDate');
            }
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput_vue___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_6_components_Icons_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/retirementAge', {
        updateValue: 'update',
        calcRetirementAge: 'calcRetirementAge',
        resetForm: 'reset'
    }), {
        isValid: function isValid() {
            return this.gender !== null && this.dateOfBirth !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfBirth, 'DD/MM/YYYY').isValid();
        },
        recalculate: function recalculate() {
            if (!this.isValid()) {
                return;
            }

            this.calcRetirementAge();
        },

        handler: function handler() {
            this.recalculate();

            if (!this.isValid()) {
                return;
            }

            this.hidePrompt();
            this.showResults = true;
        }
    })
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'table-discounts',
    created: function created() {
        this.resetForm();
    },

    data: function data() {
        return {
            showResults: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/tableDiscounts', {
        getValue: 'value'
    }), {
        preOrPost: {
            get: function get() {
                return this.getValue('preOrPost');
            },
            set: function set(value) {
                this.updateValue({ key: 'preOrPost', value: value });
            }
        },
        gender: {
            get: function get() {
                return this.getValue('gender');
            },
            set: function set(value) {
                this.updateValue({ key: 'gender', value: value });
            }
        },
        ageOfDeceased: {
            get: function get() {
                return this.getValue('ageOfDeceased');
            },
            set: function set(value) {
                this.updateValue({ key: 'ageOfDeceased', value: value });
                this.calcDod();
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.getValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateOfBirth', value: value });
                this.calcAge();
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.getValue('dateOfDeath');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateOfDeath', value: value });
                this.calcAge();
            }
        },
        dateOfTrialOrCessation: {
            get: function get() {
                return this.getValue('dateOfTrialOrCessation');
            },
            set: function set(value) {
                this.updateValue({ key: 'dateOfTrialOrCessation', value: value });
            }
        },
        discountResult: {
            get: function get() {
                return this.getValue('discountResult');
            }
        },
        discountResultLabel: {
            get: function get() {
                return this.getValue('label');
            }
        },
        tableData: {
            get: function get() {
                return this.getValue('tableData');
            }
        },
        explanation: {
            get: function get() {
                return this.getValue('explanation');
            }
        },
        periodBetweenDodAndDot: function periodBetweenDodAndDot() {
            return __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfTrialOrCessation, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfDeath, 'DD/MM/YYYY'), 'years');
        },
        ageRules: function ageRules() {
            return this.ageOfDeceased ? this.ageOfDeceased >= 10 && this.ageOfDeceased <= 90 : true;
        },
        dateOfTrialOrCessationRules: function dateOfTrialOrCessationRules() {
            return this.dateOfTrialOrCessation ? this.periodBetweenDodAndDot >= 0 && this.periodBetweenDodAndDot <= 9 : true;
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_pages_mini_calculators_calculators_mixins_MiniCalculatorBindings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput_vue___default.a,
        MiniCalculatorPage: __WEBPACK_IMPORTED_MODULE_5_pages_mini_calculators_components_MiniCalculatorPage___default.a,
        MiniCalculatorHeader: __WEBPACK_IMPORTED_MODULE_13_pages_mini_calculators_components_MiniCalculatorHeader___default.a,
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_6_components_Icons_vue___default.a,
        Intro: __WEBPACK_IMPORTED_MODULE_10_pages_mini_calculators_calculators_CalculatorComponents_Intro___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/tableDiscounts', {
        resetForm: 'reset',
        updateValue: 'update',
        calculateMultiplier: 'calcMultiplier'
    }), {
        resetTheForm: function resetTheForm() {
            this.resetForm();
        },
        calcAge: function calcAge() {
            if (this.dateOfBirth && this.dateOfDeath) {
                var dateOfDeath = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfDeath, 'DD/MM/YYYY');
                var dateOfBirth = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfBirth, 'DD/MM/YYYY');
                var ageOfDeceased = dateOfDeath.diff(dateOfBirth, 'years');
                this.updateValue({ key: 'ageOfDeceased', value: ageOfDeceased });
            }
        },
        calcDod: function calcDod() {
            if (this.dateOfBirth && this.ageOfDeceased) {
                var dateOfBirth = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfBirth, 'DD/MM/YYYY');
                var ageOfDeceased = this.ageOfDeceased;
                var newDateOfBirth = dateOfBirth.add(ageOfDeceased, 'years').format('DD/MM/YYYY');
                this.updateValue({ key: 'dateOfDeath', value: newDateOfBirth });
            }
        },
        isValid: function isValid() {
            var diffInYears = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfTrialOrCessation, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfDeath, 'DD/MM/YYYY'), 'years');

            return this.preOrPost !== null && this.gender !== null && this.dateOfBirth !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfBirth, 'DD/MM/YYYY').isValid() && this.ageOfDeceased >= 10 && this.ageOfDeceased <= 90 && this.dateOfTrialOrCessation !== null && __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.dateOfTrialOrCessation, 'DD/MM/YYYY').isValid() && diffInYears >= 0 && diffInYears <= 9;
        },
        calcMultiplier: function calcMultiplier() {
            if (!this.isValid()) {
                return;
            }

            this.calculateMultiplier();
        },

        handler: function handler() {
            this.calcMultiplier();

            if (!this.isValid()) {
                return;
            }

            this.hidePrompt();
            this.showResults = true;
        }
    })
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slider_component__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'care-period',
    props: {
        period: {
            type: Object,
            default: {}
        },
        index: {
            type: Number
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/care', ['periods']), {
        periodStartDateRules: function periodStartDateRules() {
            return !__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodStart, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodEnd, 'DD/MM/YYYY'));
        },
        periodEndDateRules: function periodEndDateRules() {
            return !__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodEnd, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodStart, 'DD/MM/YYYY'));
        },
        overlapsAnother: function overlapsAnother() {
            var _this = this;

            var otherPeriods = this.periods.filter(function (period, index) {
                return index !== _this.index;
            });
            if (!this.period.periodStart || !this.period.periodEnd || otherPeriods.length === 0) {
                return false;
            }
            var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodStart, 'DD/MM/YYYY');
            var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodEnd, 'DD/MM/YYYY');
            return otherPeriods.reduce(function (overlaps, period) {
                if (overlaps) {
                    return overlaps;
                }
                if (!period.periodStart || !period.periodEnd) {
                    return overlaps;
                }
                var currentStart = __WEBPACK_IMPORTED_MODULE_2_moment___default()(period.periodStart, 'DD/MM/YYYY');
                var currentEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(period.periodEnd, 'DD/MM/YYYY');
                return currentStart.isBefore(end) && currentEnd.isAfter(start);
            }, false);
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/care', {
        deletePeriod: 'deletePeriod',
        calculatePeriodTotal: 'calculatePeriodTotal',
        updatePeriod: 'updatePeriod'
    }), {
        updateTotal: function updateTotal() {
            this.calculatePeriodTotal(this.index);
        },
        deleteThisPeriod: function deleteThisPeriod() {
            this.deletePeriod(this.index);
        }
    }),
    components: {
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue___default.a,
        VueSlider: __WEBPACK_IMPORTED_MODULE_6_vue_slider_component___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */]]
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mini-calc-icons'
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slider_component__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'income-period',
    props: {
        period: {
            type: Object,
            default: {}
        },
        index: {
            type: Number
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('mini/lossOfEarnings', ['periods']), {
        periodStartIsValid: function periodStartIsValid() {
            return !__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodStart, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodEnd, 'DD/MM/YYYY'));
        },
        periodEndIsValid: function periodEndIsValid() {
            return !__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodEnd, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.period.periodStart, 'DD/MM/YYYY'));
        },
        isValid: function isValid() {
            return [this.period.startOfPeriod !== null && this.period.startOfPeriod !== "" && this.period.endOfPeriod !== null && this.period.endOfPeriod !== "" && this.period.employmentType !== null && this.period.employmentIncome !== null && this.period.employmentIncome !== "" && this.periodStartIsValid && this.periodEndIsValid];
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mini/lossOfEarnings', {
        deletePeriod: 'deletePeriod',
        updatePeriod: 'updatePeriod'
    }), {
        calculateLoss: function calculateLoss() {
            if (!this.isValid) {
                return;
            }

            this.updatePeriod({ index: this.index, period: this.period });
            this.$emit('update', { index: this.index });
        },
        deleteThisPeriod: function deleteThisPeriod() {
            this.deletePeriod(this.index);
        }
    }),
    components: {
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue___default.a,
        VueSlider: __WEBPACK_IMPORTED_MODULE_6_vue_slider_component___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__["a" /* default */]
    }
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_components_Icons__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_components_Icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_components_Icons__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mini-calculator-header',
    components: {
        'mini-calc-icons': __WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_components_Icons___default.a
    },
    props: {
        title: {
            type: String,
            default: ""
        },
        icon: {
            type: String,
            default: ""
        }
    }
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPrint__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPrint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPrint__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mini-calculator-page',
    computed: {
        totalInputs: {
            get: function get() {
                return this.calculator.totalInputs;
            }
        }
    },
    methods: {
        getRange: function getRange() {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.range(1, this.totalInputs + 1);
        }
    },
    components: {
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default.a,
        MiniCalculatorPrint: __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPrint___default.a
    }
});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPrint__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPrint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPrint__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mini-calculator-page',
    computed: {
        totalInputs: {
            get: function get() {
                return this.calculator.totalInputs;
            }
        }
    },
    methods: {
        getRange: function getRange() {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.range(1, this.totalInputs + 1);
        }
    },
    components: {
        miniCalcIcons: __WEBPACK_IMPORTED_MODULE_3_components_Icons_vue___default.a,
        MiniCalculatorPrint: __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_components_MiniCalculatorPrint___default.a
    }
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mini-calculator-print',
    methods: {
        print: function print() {
            var convertToArray = function convertToArray(nodeList) {
                return Array.prototype.slice.call(nodeList);
            };

            var page = window.open('', 'PRINT', 'height=800,width=600');
            var content = document.getElementById('print-panel');
            var newContent = content.cloneNode(true);
            var canvases = content.getElementsByTagName('canvas');
            var newCanvas = newContent.getElementsByTagName('canvas');

            convertToArray(newCanvas).forEach(function (canvas, index) {
                return canvas.getContext('2d').drawImage(canvases[index], 0, 0);
            });

            newContent.querySelector('.p-animated-calc__share').remove();

            page.document.write('<html><head id="head"><title>' + document.title + '</title>');
            page.document.write('</head><body id="body" >');
            page.document.write('<h1>ABC Quantum Tool - Mini Calculation</h1>');
            page.document.write('</body></html>');

            page.document.getElementById('body').appendChild(newContent);

            var head = page.document.getElementById('head');

            convertToArray(document.getElementsByTagName('link')).forEach(function (link) {
                return head.appendChild(link.cloneNode(true));
            });
            convertToArray(document.getElementsByTagName('style')).forEach(function (style) {
                return head.appendChild(style.cloneNode(true));
            });

            var vert = page.document.querySelectorAll('#print-panel > .flex-grid--vertical')[1];
            if (vert) {
                vert.style.height = 'inherit';
            }

            page.document.close();
            page.focus();

            page.print();
            page.close();

            return true;
        }
    }
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Header_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PersonalInjuryClaims',
    components: {
        Timeline: __WEBPACK_IMPORTED_MODULE_1_components_Timeline_vue___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_3_components_Header_vue___default.a
    },
    mounted: function mounted() {
        this.resetOrLoad(this.$route);
    },

    watch: {
        '$route': function $route(to, from) {
            this.resetOrLoad(to);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/step', {
        steps: 'allSteps',
        current: 'currentStep',
        stepNo: 'currentStepIndex'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('claim', { claimId: 'id' })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('claim', ['load', 'reset', 'initialise']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('menu', ['updateMenu']), {
        isVisible: function isVisible() {
            if (this.$route.params.id == this.claimId) {
                return true;
            }

            if (!this.$route.params.id && this.claimId) {
                return true;
            }

            return false;
        },
        resetOrLoad: function resetOrLoad(route) {
            var _this = this;

            var id = route.params.id;

            if (!id) {
                return this.reset().then(function () {
                    _this.initialise('personal_injury');
                });
            }

            if (this.claimId === parseInt(id)) {
                return;
            }

            this.load({ claim: { id: id }, router: this.$router });
        }
    })
});

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_IconTooltip__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'injury-select',
    beforeCreate: function beforeCreate() {
        this.$options.components.InjurySelect = __webpack_require__(221).default;
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_4_directives_TwoDecimalPlaces__["a" /* default */]
    },
    watch: {
        'injuryTypeId': function injuryTypeId(newVal, oldValue) {
            var _this = this;

            this.$nextTick(function () {
                _this.selectInjury();
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/generalDamages', {
        getUplift: 'getUplift',
        getGeneralDamages: 'getGeneralDamages',
        getJCGuidelinesInfo: 'getJCGuidelinesInfo'
    }), {
        generalDamages: {
            get: function get() {
                return this.getGeneralDamages(this.awardIndex);
            },
            set: function set(value) {
                var _this2 = this;

                if (!value || value < 1) {
                    value = 1.00;
                }
                this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex }).then(function () {
                    return _this2.$emit("award-selected", value);
                });
            }
        },
        uplift: {
            get: function get() {
                return this.getUplift(this.awardIndex);
            },
            set: function set(value) {
                this.updateValue({ key: 'uplift', value: value, index: this.awardIndex });
            }
        },
        low: {
            get: function get() {
                return this.tree[this.injuryTypeId]['lower_value'];
            }
        },
        lowUplift: {
            get: function get() {
                return this.tree[this.injuryTypeId]['lower_value_with_uplift'];
            }
        },
        mid: {
            get: function get() {
                return (this.tree[this.injuryTypeId]['upper_value'] + this.tree[this.injuryTypeId]['lower_value']) / 2;
            }
        },
        midUplift: {
            get: function get() {
                return (this.tree[this.injuryTypeId]['upper_value_with_uplift'] + this.tree[this.injuryTypeId]['lower_value_with_uplift']) / 2;
            }
        },
        upper: {
            get: function get() {
                return this.tree[this.injuryTypeId]['upper_value'];
            }
        },
        upperUplift: {
            get: function get() {
                return this.tree[this.injuryTypeId]['upper_value_with_uplift'];
            }
        }
    }),
    props: {
        tree: {
            type: Array,
            required: false
        },
        name: {
            type: String,
            required: false
        },
        selected: {
            required: true
        },
        level: {
            type: Number,
            default: 0,
            required: true
        },
        longTextValue: {
            type: Boolean,
            default: false
        },
        awardIndex: {
            type: Number,
            required: true
        }
    },
    data: function data() {
        return {
            injuryTypeId: typeof this.selected[this.level] !== 'undefined' ? this.selected[this.level] : null,
            award: 'mid',
            longText: false
        };
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_5_components_IconTooltip___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('personal/generalDamages', {
        updateValue: 'updateValue',
        fetchInjuries: 'fetchInjuries',
        removeAward: 'removeAward'
    }), {
        hasChildren: function hasChildren() {
            var _this3 = this;

            if (this.injuryTypeId === null) {
                return false;
            }

            if (typeof this.tree === 'undefined') {
                return false;
            }

            if (typeof this.tree[this.injuryTypeId] === 'undefined') {
                return false;
            }

            if (typeof this.tree[this.injuryTypeId]['children'] === 'undefined') {
                return false;
            }

            if (this.tree[this.injuryTypeId]['children'].length === 0) {
                this.calculateGeneralDamagesAverage();
                return false;
            }

            _.each(this.tree[this.injuryTypeId].children, function (branch) {
                if (branch.name.length > 100) {
                    _this3.longText = true;
                }
            });

            return true;
        },
        hasValue: function hasValue(key) {
            if (this.injuryTypeId === null) {
                return false;
            }

            if (typeof this.tree === 'undefined') {
                return false;
            }

            if (typeof this.tree[this.injuryTypeId] === 'undefined') {
                return false;
            }

            if (typeof this.tree[this.injuryTypeId][key] === 'undefined') {
                return false;
            }

            if (this.tree[this.injuryTypeId][key] === null) {
                return false;
            }
            return true;
        },
        hasDescription: function hasDescription() {
            if (this.injuryTypeId === null) {
                return false;
            }

            if (typeof this.tree === 'undefined') {
                return false;
            }

            if (typeof this.tree[this.injuryTypeId] === 'undefined') {
                return false;
            }

            if (typeof this.tree[this.injuryTypeId]['description'] === 'undefined') {
                return false;
            }

            if (this.tree[this.injuryTypeId]['description'] === '') {
                return false;
            }
            return true;
        },
        calculateGeneralDamagesAverage: function calculateGeneralDamagesAverage() {
            if (this.generalDamages === null) {

                var value = null;

                if (this.hasValue('lower_value')) {
                    value = (this.tree[this.injuryTypeId]['upper_value'] + this.tree[this.injuryTypeId]['lower_value']) / 2;
                    if (this.uplift) {
                        value = (this.tree[this.injuryTypeId]['upper_value_with_uplift'] + this.tree[this.injuryTypeId]['lower_value_with_uplift']) / 2;
                    }
                    this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex });
                    this.updateValid();
                    return value;
                } else if (this.hasValue('up_to_value')) {
                    value = this.tree[this.injuryTypeId]['up_to_value'];
                    this.award = 'lower';
                    if (this.uplift) {
                        value = this.tree[this.injuryTypeId]['up_to_value_with_uplift'];
                        this.award = 'upper';
                    }
                    this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex });
                    this.updateValid();
                    return value;
                } else if (this.hasValue('in_the_region_of')) {
                    value = this.tree[this.injuryTypeId]['in_the_region_of'];
                    this.award = 'lower';
                    if (this.uplift) {
                        value = this.tree[this.injuryTypeId]['in_the_region_of_with_uplift'];
                        this.award = 'upper';
                    }
                    this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex });
                    this.updateValid();
                    return value;
                } else if (this.hasValue('in_excess_of')) {
                    value = this.tree[this.injuryTypeId]['in_excess_of'];
                    this.award = 'lower';
                    if (this.uplift) {
                        value = this.tree[this.injuryTypeId]['in_excess_of_with_uplift'];
                        this.award = 'upper';
                    }
                    this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex });
                    this.updateValid();
                    return value;
                } else if (this.hasValue('a_few_hundred_pounds_to')) {
                    value = this.tree[this.injuryTypeId]['a_few_hundred_pounds_to'];
                    this.award = 'lower';
                    if (this.uplift) {
                        value = this.tree[this.injuryTypeId]['a_few_hundred_pounds_to_with_uplift'];
                        this.award = 'upper';
                    }
                    this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex });
                    this.updateValid();
                    return value;
                } else if (this.hasValue('not_less_than')) {
                    value = this.tree[this.injuryTypeId]['not_less_than'];
                    this.award = 'lower';
                    if (this.uplift) {
                        value = this.tree[this.injuryTypeId]['not_less_than_with_uplift'];
                        this.award = 'upper';
                    }
                    this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex });
                    this.updateValid();
                    return value;
                } else if (this.hasValue('rarely_exceed')) {
                    value = this.tree[this.injuryTypeId]['rarely_exceed'];
                    this.award = 'lower';
                    if (this.uplift) {
                        value = this.tree[this.injuryTypeId]['rarely_exceed_with_uplift'];
                        this.award = 'upper';
                    }
                    this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex });
                    this.updateValid();
                    return value;
                } else if (this.hasValue('likely_to_exceed')) {
                    value = this.tree[this.injuryTypeId]['likely_to_exceed'];
                    this.award = 'lower';
                    if (this.uplift) {
                        value = this.tree[this.injuryTypeId]['likely_to_exceed_with_uplift'];
                        this.award = 'upper';
                    }
                    this.updateValue({ key: 'generalDamages', value: value, index: this.awardIndex });
                    this.updateValid();
                    return value;
                }
            }
        },
        updateRadioButtons: function updateRadioButtons(clickedRadio) {

            var radioButtons = document.querySelectorAll('.p-general-damages__long-text input[type="radio"]');

            radioButtons.forEach(function (element) {
                element.checked = false;
            });

            radioButtons[clickedRadio].checked = true;

            this.injuryTypeId = clickedRadio;

            this.selectInjury();
        },
        selectInjury: function selectInjury() {
            var _this4 = this;

            if (this.tree[this.injuryTypeId]) {
                this.longText = false;

                _.each(this.tree[this.injuryTypeId].children, function (branch) {
                    if (branch.name.length > 100) {
                        _this4.longText = true;
                    }
                });

                if (this.hasChildren() && this.$refs.childSelect) {
                    this.$refs.childSelect.reset();
                }

                this.$emit("injury-selected", {
                    level: this.level,
                    value: this.injuryTypeId
                });

                this.resetAward();
            }
        },
        reset: function reset() {
            if (this.hasChildren() && this.$refs.childSelect) {
                this.$refs.childSelect.reset();
            }

            this.injuryTypeId = null;
        },
        adjustUplift: function adjustUplift() {
            if (this.uplift) {
                this.uplift = false;
                this.updateValue({ key: 'generalDamages', value: this.calculateAward(), index: this.awardIndex });
            } else {
                this.uplift = true;
                this.updateValue({ key: 'generalDamages', value: this.calculateAward(), index: this.awardIndex });
            }

            this.updateValid();
        },
        applyAward: function applyAward(award) {
            this.award = award;
            this.updateValue({ key: 'generalDamages', value: this.calculateAward(), index: this.awardIndex });
            this.updateValid();
        },
        calculateAward: function calculateAward() {
            switch (this.award) {
                case 'lower':
                    if (this.uplift) {
                        return this.tree[this.injuryTypeId]['lower_value_with_uplift'];
                    }
                    return this.tree[this.injuryTypeId]['lower_value'];
                case 'mid':
                    if (this.uplift) {
                        return (this.tree[this.injuryTypeId]['upper_value_with_uplift'] + this.tree[this.injuryTypeId]['lower_value_with_uplift']) / 2;
                    }
                    return (this.tree[this.injuryTypeId]['upper_value'] + this.tree[this.injuryTypeId]['lower_value']) / 2;
                case 'upper':
                    if (this.uplift) {
                        return this.tree[this.injuryTypeId]['upper_value_with_uplift'];
                    }
                    return this.tree[this.injuryTypeId]['upper_value'];
            }
        },
        resetAward: function resetAward() {
            this.updateValue({ key: 'generalDamages', value: null, index: this.awardIndex });
        },
        bubbleSelected: function bubbleSelected(val) {
            this.$emit("injury-selected", val);
        },
        updateValid: function updateValid() {
            this.$emit("award-selected");
        }
    })
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_dateFormat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_html5_editor__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_html5_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_claims_dashboard_components_InitialReservesCosts__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_claims_dashboard_components_InitialReservesCosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_claims_dashboard_components_InitialReservesCosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_claims_dashboard_components_ClaimInfo__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_claims_dashboard_components_ClaimInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_claims_dashboard_components_ClaimInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_claims_dashboard_components_ReservesForClaim__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_claims_dashboard_components_ReservesForClaim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_pages_claims_dashboard_components_ReservesForClaim__);




















var HtmlEditor = new __WEBPACK_IMPORTED_MODULE_10_vue_html5_editor___default.a();

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'calculate-loss',
    data: function data() {
        return {
            editingContent: null,
            valid: false,
            loading: false,
            isSaving: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('documents', {
        getGeneratedDocuments: 'getGeneratedDocuments',
        getDocumentsByType: 'getDocumentsByType',
        getEditingDocument: 'getEditingDocument',
        requesting: 'getRequestStatus',
        findDocument: 'getGeneratedDocument'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/interimPayments', ['getAllInterimPaymentsTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('claim', {
        claimId: 'id', theClaim: 'current'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['careTotal', 'servicesTotal', 'purchasesTotal', 'pensionValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/claimant', {
        claimant: 'claimant',
        claimantDetail: 'getClaimantDetail',
        claim: 'getClaimInfo',
        getClaimInfo: 'getClaimInfo',
        getClaimantValue: 'getClaimantValue',
        getIncomeValue: 'getIncomeValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/futureLosses', ['getLoss']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/cruBenefits', ['getGeneralDamagesOffset', 'getPastLossOfEarningsOffset', 'getPastCostOfCareOffset', 'getPastCostOfTravelOffset']), {

        futureLosses: {
            get: function get() {
                return this.getLoss('futureLosses');
            }
        },
        futureLossesStart: {
            get: function get() {
                return this.getLoss('futureLossesStart');
            }
        },
        futureLossesEnd: {
            get: function get() {
                return this.getLoss('futureLossesEnd');
            }
        },
        durationOfPeriod: {
            get: function get() {
                if (!this.futureLossesEnd || !this.futureLossesStart) {
                    return false;
                }

                return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.futureLossesEnd, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.futureLossesStart, 'DD/MM/YYYY'), 'years', true);
            }
        },
        multiplier: {
            get: function get() {
                return this.getLoss('multiplier');
            }
        },
        preInjuryDiscountFactor: {
            get: function get() {
                return this.getLoss('preInjuryDiscountFactor');
            }
        },
        assessmentDiscountFactor: {
            get: function get() {
                return this.getLoss('assessmentDiscountFactor');
            }
        },
        lossResult: {
            get: function get() {
                return this.getIncomeValue('preAccidentFutureLossOfEarningsNetTotal') - this.getIncomeValue('futureLossOfEarningsNetTotal');
            }
        },
        levelOfEducation: {
            get: function get() {
                return this.getClaimantValue('levelOfEducation');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'levelOfEducation', value: value });
            }
        },
        disabledAtAccident: {
            get: function get() {
                return this.getClaimantValue('disabledAtAccident');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'disabledAtAccident', value: value });
            }
        },
        employedAtAccident: {
            get: function get() {
                return this.getClaimantValue('employedAtAccident');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'employedAtAccident', value: value });
            }
        },
        disabledAtAssessment: {
            get: function get() {
                return this.getClaimantValue('disabledAtTrial');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'disabledAtTrial', value: value });
            }
        },
        employedAtAssessment: {
            get: function get() {
                return this.getClaimantValue('employedAtTrial');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'employedAtTrial', value: value });
            }
        },
        futureCareTotal: {
            get: function get() {
                return this.careTotal;
            }
        },
        futureServicesTotal: {
            get: function get() {
                return this.servicesTotal;
            }
        },
        futurePensionTotal: {
            get: function get() {
                return this.pensionValue('totalLoss');
            }
        },
        gender: function gender() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash__["startCase"](this.claimant.gender);
        },
        ageAtInjury: function ageAtInjury() {
            return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claim('dateOfInjury'), 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');
        },
        ageAtSettlement: function ageAtSettlement() {
            return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claim('dateOfAssumedSettlement'), 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');
        },
        ageToday: function ageToday() {
            return __WEBPACK_IMPORTED_MODULE_15_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');
        },
        today: function today() {
            return __WEBPACK_IMPORTED_MODULE_15_moment___default()().format("DD/MM/YYYY");
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/claimant', {
        getIncomeValue: 'getIncomeValue',
        pastPeriodsSubTotal: 'pastPeriodsSubTotal',
        pastAbsenceTotal: 'pastAbsenceTotal',
        pastIncomeTotal: 'pastIncomeTotal',
        getPostInjuryIncomePeriodPaymentsTotal: 'getPostInjuryIncomePeriodPaymentsTotal'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/calculateLoss', ['percent']), {
        preAccidentIncome: function preAccidentIncome() {
            return this.getIncomeValue('preAccident').totalNetIncome;
        },
        totalPaymentsMade: function totalPaymentsMade() {
            return this.getIncomeValue('otherPayments');
        },
        pastPeriods: function pastPeriods() {
            return this.getIncomeValue('pastPeriods');
        },
        pastLossOfEarnings: function pastLossOfEarnings() {
            return this.getIncomeValue('pastLossOfEarnings');
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/generalDamages', { getGeneralDamages: 'getSubTotalDiscounted' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/otherPastLosses', {
        otherPastLoss: 'value',
        allCustomHeadOfLoss: 'getAllCustomHeadOfLoss',
        customPastLoss: 'getCustomHeadOfLoss',
        customHeadsOfLossTotal: 'customHeadsOfLossTotal',
        customHeadsOfLossTotalWithInterest: 'customHeadsOfLossTotalWithInterest'
    }), {
        interestTotal: function interestTotal() {
            return numberVal(this.otherPastLoss('generalDamagesWithInterest')) + numberVal(this.otherPastLoss('pastLossOfEarningsWithInterest')) + numberVal(this.otherPastLoss('pastCostOfCareWithInterest')) + numberVal(this.otherPastLoss('pastCostOfServicesWithInterest')) + numberVal(this.otherPastLoss('pastCostOfTravelWithInterest')) + numberVal(this.otherPastLoss('miscWithInterest')) + numberVal(this.customHeadsOfLossTotalWithInterest);
        },
        subTotal: function subTotal() {
            return numberVal(this.getGeneralDamages) + numberVal(this.getIncomeValue('pastLossOfEarningsNetTotal')) + numberVal(this.otherPastLoss('pastCostOfCare')) + numberVal(this.otherPastLoss('pastCostOfServices')) + numberVal(this.otherPastLoss('pastCostOfTravel')) + numberVal(this.otherPastLoss('misc')) + numberVal(this.customHeadsOfLossTotal) + numberVal(this.lossResult) + numberVal(this.futurePensionTotal) + numberVal(this.futureCareTotal) + numberVal(this.purchasesTotal) + numberVal(this.futureServicesTotal) - numberVal(this.cruTotalDeductions);
        },
        total: function total() {
            return this.subTotal + this.interestTotal;
        },
        totalLessInterimPayments: function totalLessInterimPayments() {
            return this.total - numberVal(this.getAllInterimPaymentsTotal);
        },
        downloadUrl: function downloadUrl() {
            return '/api/v1/download/' + this.claimId + '?access_token=' + this.getToken;
        },
        cruTotalDeductions: function cruTotalDeductions() {
            return this.getGeneralDamagesOffset + this.getPastLossOfEarningsOffset + this.getPastCostOfCareOffset + this.getPastCostOfTravelOffset;
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },

        percentage: {
            get: function get() {
                return this.percent * 100;
            },
            set: function set(value) {
                this.setPercent(value / 100);
            }
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_mixins_dateFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_mixins_roundValue__["a" /* default */]],
    components: {
        ReservesForClaim: __WEBPACK_IMPORTED_MODULE_16_pages_claims_dashboard_components_ReservesForClaim___default.a,
        modal: __WEBPACK_IMPORTED_MODULE_8_components_modal_Modal_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        HtmlEditor: HtmlEditor,
        StepButton: __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        back: function back() {
            if (this.prevValid) {
                this.$router.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["d" /* prevStep */])().route);
            }
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('modal', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('documents', {
        toggleContent: 'toggleEditingDocument',
        createGeneratedDocument: 'createGeneratedDocument',
        deleteGeneratedDocument: 'deleteGeneratedDocument',
        getGeneratedDocumentsFromServer: 'getGeneratedDocumentsFromServer'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('claim', ['updateClaim', 'setCurrent']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('personal/calculateLoss', ['setPercent']), {
        createDocument: function createDocument(type) {
            this.createGeneratedDocument({ claimId: this.claimId, claimType: __WEBPACK_IMPORTED_MODULE_11_store_index__["a" /* default */].getters['claim/type'], type: type });
        },
        deleteDocument: function deleteDocument(document) {
            if (this.requesting) {
                return;
            }
            this.deleteGeneratedDocument(document);
        },
        theDocument: function theDocument(index) {
            return this.findDocument(index);
        },
        requestInProgress: function requestInProgress() {
            return this.apiRouteRequestRunning('/api/v1/generated-documents/load');
        },
        calcLoss: function calcLoss(period) {
            return (this.preAccidentIncome - (period.totalNetIncome || 0)) * period.duration;
        },
        adjustedForPercent: function adjustedForPercent(key) {
            var value = 0;
            switch (key) {
                case "generalDamages":
                    value = this.getGeneralDamages;
                    if (this.claim('proceduralStatus') === 'pre-lit') {
                        value += this.otherPastLoss('generalDamagesWithInterest');
                    }
                    break;
                case "pastLossOfEarnings":
                    value = this.getIncomeValue('pastLossOfEarningsNetTotal') + (this.otherPastLoss('pastLossOfEarningsWithInterest') || 0);
                    break;
                case 'pastLossOfEarnings':
                case 'pastCostOfServices':
                case 'pastCostOfTravel':
                case 'misc':
                    value = this.otherPastLoss(key) + this.otherPastLoss(key + 'WithInterest');
                    break;
                case 'subTotal':
                    value = this.subTotal + this.interestTotal;
                default:
                    value = this[key];

            }
            return value * this.percent;
        }
    })
});

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Warning_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Warning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_Warning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_WarningBox_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_WarningBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_WarningBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Typeahead__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_Typeahead__);



var _watch;














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claim-info',
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/claimant', ['getClaimantValue', 'getClaimantDetail', 'getClaimInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/generalDamages', {
        getValue: 'value'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        name: {
            get: function get() {
                return this.getClaimantValue('name');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'name', value: value });
            }
        },
        gender: {
            get: function get() {
                return this.getClaimantValue('gender');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'gender', value: value });
            }
        },
        minDateOfBirth: {
            get: function get() {
                var assumedSettlment = this.getClaimInfo('dateOfAssumedSettlement');

                if (!assumedSettlment || assumedSettlment === '') {
                    return '';
                }

                return __WEBPACK_IMPORTED_MODULE_10_moment___default()(assumedSettlment, 'DD/MM/YYYY').subtract(16, 'y').format('DD/MM/YYYY');
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.getClaimantValue('dateOfBirth');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'dateOfBirth', value: value });
            }
        },
        claimantSolicitor: {
            get: function get() {
                return this.getClaimantDetail('claimantSolicitor');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'claimantSolicitor', value: value });
            }
        },
        claimantReference: {
            get: function get() {
                return this.getClaimantDetail('claimantReference');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'claimantReference', value: value });
            }
        },
        yourReference: {
            get: function get() {
                return this.getClaimantDetail('yourReference');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'yourReference', value: value });
            }
        },
        claimType: {
            get: function get() {
                return this.getClaimantDetail('claimType');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'claimType', value: value });
            }
        },
        defendantName: {
            get: function get() {
                return this.getClaimantDetail('defendantName');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'defendantName', value: value });
            }
        },
        injuryType: {
            get: function get() {
                return this.getClaimantDetail('injuryType');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'injuryType', value: value });
            }
        },
        injuryTypeOther: {
            get: function get() {
                return this.getClaimantDetail('injuryTypeOther');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'injuryTypeOther', value: value });
            }
        },
        claimNarrative: {
            get: function get() {
                return this.getClaimantDetail('claimNarrative');
            },
            set: function set(value) {
                this.updateClaimantDetail({ key: 'claimNarrative', value: value });
            }
        },
        preLitOrLit: {
            get: function get() {
                return this.getClaimInfo('proceduralStatus');
            },
            set: function set(value) {
                this.updateClaimInfo({ key: 'proceduralStatus', value: value });
            }
        },
        dateOfInjury: {
            get: function get() {
                return this.getClaimInfo('dateOfInjury');
            },
            set: function set(value) {
                this.updateClaimInfo({ key: 'dateOfInjury', value: value });
            }
        },
        dateOfServiceProceedings: {
            get: function get() {
                return this.getClaimInfo('dateOfServiceProceedings');
            },
            set: function set(value) {
                this.updateClaimInfo({ key: 'dateOfServiceProceedings', value: value });
            }
        },
        dateOfAssumedSettlement: {
            get: function get() {
                return this.getClaimInfo('dateOfAssumedSettlement');
            },
            set: function set(value) {
                this.updateClaimInfo({ key: 'dateOfAssumedSettlement', value: value });
            }
        },
        discountRate: {
            get: function get() {
                return this.getClaimInfo('discountRate');
            },
            set: function set(value) {
                return this.updateClaimInfo({ key: 'discountRate', value: value });
            }
        },
        showDateInjuryInvalid: {
            get: function get() {
                if (!this.dateOfInjury) {
                    return false;
                }

                if (!__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfInjury, 'DD/MM/YYYY').isValid()) {
                    return false;
                }

                return !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfInjury, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_10_moment___default()());
            }
        },
        showdateOfInjuryAfterBirth: {
            get: function get() {
                if (!this.dateOfInjury || !this.dateOfBirth) {
                    return false;
                }

                if (!__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfInjury, 'DD/MM/YYYY').isValid() || !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfBirth, 'DD/MM/YYYY').isValid()) {
                    return false;
                }

                return !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfInjury, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfBirth, 'DD/MM/YYYY'));
            }
        },
        showServiceOfProceedingsValidationMessage_required: {
            get: function get() {
                if (!this.dateOfServiceProceedings || !this.dateOfAssumedSettlement) {
                    return false;
                }

                return !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY').isValid() || !__WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY').isValid();
            }
        },
        showServiceOfProceedingsValidationMessage_9years: {
            get: function get() {
                if (this.showServiceOfProceedingsValidationMessage_required) {
                    return false;
                }

                var mServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                    return false;
                }

                return mServiceOfProceedings.diff(mAssumedSettlement, 'years') < -9;
            }
        },
        showServiceOfProceedingsValidationMessage_before: {
            get: function get() {
                if (this.showServiceOfProceedingsValidationMessage_required) {
                    return false;
                }

                var mServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                    return false;
                }

                return !mServiceOfProceedings.isBefore(mAssumedSettlement);
            }
        },
        showDateOfAssumedSettlementValidationMessage_after: {
            get: function get() {
                var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');
                var mDateOfAccident = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfInjury, 'DD/MM/YYYY');

                if (!mAssumedSettlement.isValid() || !mDateOfAccident.isValid()) {
                    return false;
                }

                return !mAssumedSettlement.isAfter(mDateOfAccident);
            }
        },
        dateOfAssumedSettlementInPast: {
            get: function get() {
                var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                if (!mAssumedSettlement.isValid()) {
                    return false;
                }

                return mAssumedSettlement.isBefore(__WEBPACK_IMPORTED_MODULE_10_moment___default()());
            }
        }
    }),
    data: function data() {
        return { valid: false };
    },
    mounted: function mounted() {
        this.fetchInjuries;
        this.watchers();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__["a" /* default */]],
    components: {
        ControlWarning: __WEBPACK_IMPORTED_MODULE_6_components_form_control_Warning_vue___default.a,
        Icons: __WEBPACK_IMPORTED_MODULE_11_components_Icons_vue___default.a,
        WarningBox: __WEBPACK_IMPORTED_MODULE_12_components_modal_WarningBox_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_9_components_form_control_DateInput_vue___default.a,
        Typeahead: __WEBPACK_IMPORTED_MODULE_13_components_Typeahead___default.a
    },
    watch: (_watch = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, '$form.$valid', function $form$valid() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'showServiceOfProceedingsValidationMessage_required', function showServiceOfProceedingsValidationMessage_required() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'showServiceOfProceedingsValidationMessage_9years', function showServiceOfProceedingsValidationMessage_9years() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'showServiceOfProceedingsValidationMessage_before', function showServiceOfProceedingsValidationMessage_before() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'showDateOfAssumedSettlementValidationMessage_after', function showDateOfAssumedSettlementValidationMessage_after() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'showDateInjuryInvalid', function showDateInjuryInvalid() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'showdateOfInjuryAfterBirth', function showdateOfInjuryAfterBirth() {
        this.updateValid();
    }), _watch),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('personal/claimant', ['updateClaimantValue', 'updateClaimantDetail', 'updateClaimInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('personal/generalDamages', ['fetchInjuries', 'updateValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('personal/futureLosses', ['updateDiscountFactors']), {
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["b" /* setStepValid */])(this.isValid());
        },
        isValid: function isValid() {
            return !!(this.$valid() && !this.showServiceOfProceedingsValidationMessage_required && !this.showServiceOfProceedingsValidationMessage_9years && !this.showServiceOfProceedingsValidationMessage_before && !this.showDateOfAssumedSettlementValidationMessage_after && !this.showDateInjuryInvalid && !this.showdateOfInjuryAfterBirth && this.defendantName.name !== null && this.defendantName.name !== '' && this.claimantSolicitor.name !== null && this.claimantSolicitor.name !== '');
        },
        updateClaimantSolicitors: function updateClaimantSolicitors(value) {
            this.updateClaimantDetail({ key: 'claimantSolicitor', value: value });
            this.updateValid();
        },
        updateDefendant: function updateDefendant(value) {
            this.updateClaimantDetail({ key: 'defendantName', value: value });
            this.updateValid();
        },
        watchers: function watchers() {
            var _this = this;

            this.$watchAll(["dateOfBirth"], function (field, value) {
                _this.updateDiscountFactors();
            });
        }
    })
});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CruBenefits_Benefit_vue__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CruBenefits_Benefit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_CruBenefits_Benefit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_accordion_Accordion_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_accordion_Accordion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_accordion_Accordion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_accordion_AccordionItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cru_benefits_GeneralDamages__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cru_benefits_GeneralDamages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__cru_benefits_GeneralDamages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cru_benefits_PastCostOfCare__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cru_benefits_PastCostOfCare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__cru_benefits_PastCostOfCare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cru_benefits_PastCostOfTravel__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cru_benefits_PastCostOfTravel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__cru_benefits_PastCostOfTravel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cru_benefits_PastLossOfEarnings__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cru_benefits_PastLossOfEarnings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__cru_benefits_PastLossOfEarnings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_routingMethods__ = __webpack_require__(13);

















/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["b" /* setStepValid */])(this.allValid);
    },

    components: {
        Accordion: __WEBPACK_IMPORTED_MODULE_6_components_accordion_Accordion_vue___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_7_components_accordion_AccordionItem_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        Benefit: __WEBPACK_IMPORTED_MODULE_4_components_CruBenefits_Benefit_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_3_components_StepButton_vue___default.a,
        GeneralDamages: __WEBPACK_IMPORTED_MODULE_9__cru_benefits_GeneralDamages___default.a,
        PastCostOfCare: __WEBPACK_IMPORTED_MODULE_10__cru_benefits_PastCostOfCare___default.a,
        PastCostOfTravel: __WEBPACK_IMPORTED_MODULE_11__cru_benefits_PastCostOfTravel___default.a,
        PastLossOfEarnings: __WEBPACK_IMPORTED_MODULE_12__cru_benefits_PastLossOfEarnings___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/headsOfLoss', ['value']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/cruBenefits', {
        findValue: 'value',
        findInclude: 'include',
        allValid: 'allValid'
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('personal/headsOfLoss', {
        setValue: 'updateValue',
        updateInterest: 'calcNewValue',
        calcInterest: 'calcInterest'
    }))
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_income_PostAccidentIncome__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_income_PostAccidentIncome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_income_PostAccidentIncome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__income_FutureIncome__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__income_FutureIncome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__income_FutureIncome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_modal_WarningBox_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_modal_WarningBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_modal_WarningBox_vue__);






















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'future-loss-of-earnings',
    watch: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, 'isValid', function isValid() {
        this.updateValid();
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapGetters */])('personal/claimant', ['getClaimInfo', 'getClaimantValue', 'getIncomeValue', 'claimant', 'futureIncomePeriodsValid', 'futureEarningsValid', 'retiredBetweenInjuryAndSettlement']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapGetters */])('personal/futureLosses', ['getLoss']), {
        uniqueId: function uniqueId() {
            return this._uid;
        },
        ageAtSettlement: function ageAtSettlement() {
            return __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.getClaimInfo('dateOfAssumedSettlement'), 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
        },

        futureLosses: {
            get: function get() {
                return this.getLoss('futureLosses');
            },
            set: function set(value) {
                if (value === false) {
                    this.reset();
                }

                this.updateLoss({ key: 'futureLosses', value: value }).then(this.updateValid.bind(this));
            }
        },
        futureLossesConstant: {
            get: function get() {
                return this.getLoss('futureLossesConstant');
            },
            set: function set(value) {
                this.resetIsConstant();

                this.updateLoss({ key: 'futureLossesConstant', value: value });
            }
        },
        futureLossesToRetirement: {
            get: function get() {
                return this.getLoss('futureLossesToRetirement');
            },
            set: function set(value) {
                var _this = this;

                if (value === false) {
                    this.updateLoss({ key: 'futureLossesEndAge', value: null });
                    this.updateLoss({ key: 'futureLossesEnd', value: null });
                }

                this.updateLoss({ key: 'futureLossesToRetirement', value: value }).then(function () {
                    _this.updateTheFutureLossOfEarningsAndIncome();
                });
            }
        },
        futureLossesStart: {
            get: function get() {
                return this.getLoss('futureLossesStart');
            },
            set: function set(value) {
                this.updateLoss({ key: 'futureLossesStart', value: value });
            }
        },
        futureLossesEnd: {
            get: function get() {
                return this.getLoss('futureLossesEnd');
            },
            set: function set(value) {
                this.updateLoss({ key: 'futureLossesEnd', value: value });

                var newAge = __WEBPACK_IMPORTED_MODULE_11_moment___default()(value, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');

                if (this.futureLossesEndAge !== newAge) {
                    this.futureLossesEndAge = newAge;
                }
            }
        },
        futureLossesEndAge: {
            get: function get() {
                return this.getLoss('futureLossesEndAge');
            },
            set: function set(value) {
                this.updateLoss({ key: 'futureLossesEndAge', value: value });

                var newDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY').add(value, 'years').format('DD/MM/YYYY');

                if (this.futureLossesEnd !== newDate) {
                    this.futureLossesEnd = newDate;
                }
            }
        },
        retirementAge: {
            get: function get() {
                return this.getIncomeValue('retirementAge');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'retirementAge', value: value }).then(this.updateValid.bind(this));

                var newDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY').add(value, 'years').format('DD/MM/YYYY');

                if (this.retirementDate !== newDate) {
                    this.retirementDate = newDate;
                }
            }
        },
        retirementDate: {
            get: function get() {
                return this.getIncomeValue('retirementDate');
            },
            set: function set(value) {
                var prev = this.retirementDate;
                this.updateIncomeValue({ key: 'retirementDate', value: value }).then(this.updateValid.bind(this));

                var newAge = __WEBPACK_IMPORTED_MODULE_11_moment___default()(value, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years');

                if (this.retirementAge !== newAge) {
                    this.retirementAge = newAge;
                }

                this.updateLoss({ key: 'futureLossesEnd', value: value });
            }
        },
        futureLossesMortalityMultiplier: {
            get: function get() {
                return this.getLoss('futureLossesMortalityMultiplier');
            },
            set: function set(value) {
                this.updateLoss({ key: 'futureLossesMortalityMultiplier', value: value });
            }
        },
        levelOfEducation: {
            get: function get() {
                return this.getClaimantValue('levelOfEducation');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'levelOfEducation', value: value });
                this.updateDiscountIfValid();
            }
        },
        disabledAtAccident: {
            get: function get() {
                return this.getClaimantValue('disabledAtAccident');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'disabledAtAccident', value: value });
                this.updateDiscountIfValid();
            }
        },
        employedAtAccident: {
            get: function get() {
                return this.getClaimantValue('employedAtAccident');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'employedAtAccident', value: value });
                this.updateDiscountIfValid();
            }
        },
        disabledAtAssessment: {
            get: function get() {
                return this.getClaimantValue('disabledAtTrial');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'disabledAtTrial', value: value });
                this.updateDiscountIfValid();
            }
        },
        employedAtAssessment: {
            get: function get() {
                return this.getClaimantValue('employedAtTrial');
            },
            set: function set(value) {
                this.updateClaimantValue({ key: 'employedAtTrial', value: value });
                this.updateDiscountFactors();
            }
        },
        gender: {
            get: function get() {
                return this.getClaimantValue('gender');
            }
        },
        preInjuryDiscountFactor: {
            get: function get() {
                return this.getLoss('preInjuryDiscountFactor') || 0;
            }
        },
        assessmentDiscountFactor: {
            get: function get() {
                return this.getLoss('assessmentDiscountFactor');
            }
        },
        preAccidentMultiplicand: {
            get: function get() {
                return this.getIncomeValue('futureEarningsPreAccident').totalNetIncome;
            },
            set: function set() {}
        },
        postAccidentMultiplicand: {
            get: function get() {
                return this.getIncomeValue('futureEarningsPostAccident').totalNetIncome;
            }
        },
        durationOfPeriod: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesEnd, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesStart, 'DD/MM/YYYY'), 'years', true);
            }
        },
        multiplier: {
            get: function get() {
                return this.getLoss('multiplier') || 0;
            }
        },
        lossOfEarningsBeforeRetirement: {
            get: function get() {
                if (!this.futureLossesToRetirement) {
                    return true;
                }

                if (!this.retirementDate || !this.futureLossesStart) {
                    return false;
                }

                return __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.retirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesStart, 'DD/MM/YYYY'), 'days') > 0;
            }
        },
        preAccidentNetIncome: function preAccidentNetIncome() {
            if (this.getIncomeValue('preAccident').totalNetIncome > 0) {
                return this.getIncomeValue('preAccident').totalNetIncome;
            }
            return this.preAccidentMultiplicand;
        },
        preResult: function preResult() {
            var total = this.multiplier * this.preInjuryDiscountFactor * this.preAccidentNetIncome;
            this.updateIncomeValue({ key: 'preAccidentFutureLossOfEarningsNetTotal', value: total });
            return total;
        },
        postResult: function postResult() {
            var total = this.multiplier * this.assessmentDiscountFactor * this.getIncomeValue('futureEarningsPostAccident').totalNetIncome;
            this.updateIncomeValue({ key: 'futureLossOfEarningsNetTotal', value: total });
            return total;
        },
        lossResult: function lossResult() {
            return this.preResult - this.postNetTotal();
        },
        futureLossesConstantResult: function futureLossesConstantResult() {
            return this.preResult - this.postResult;
        },

        results: {
            get: function get() {
                return this.getLoss('results');
            },
            set: function set(value) {
                this.updateLoss({ key: 'results', value: value });
            }
        },
        multiplierPayload: function multiplierPayload() {
            return {
                assumedSettlement: this.getClaimInfo('dateOfAssumedSettlement'),
                person: this.claimant,
                discountRate: this.getClaimInfo('discountRate'),
                duration: __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesEnd, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesStart, 'DD/MM/YYYY'), 'years', true)
            };
        },
        futureLossOfEarningsValid: function futureLossOfEarningsValid() {
            return this.futureLosses && this.futureLossesConstant !== null && this.levelOfEducation !== null && this.employedAtAccident !== null && this.disabledAtAccident !== null && this.employedAtAssessment !== null && this.disabledAtAssessment !== null;
        },
        isValid: function isValid() {
            if (this.futureLosses === false) {
                return true;
            }

            if (this.futureLosses && this.futureLossesConstant === false) {
                return this.preInjuryDiscountFactor > 0 && this.assessmentDiscountFactor > 0 && this.futureLossesEnd !== "" && this.futureLossesEnd !== null && this.futureLossesToRetirement !== null && this.futureLossesMortalityMultiplier !== null && this.futureIncomePeriodsValid && this.lossResult > 0;
            }

            if (this.futureLosses && this.futureLossesConstant === true) {
                return this.preInjuryDiscountFactor > 0 && this.assessmentDiscountFactor > 0 && this.futureLossesMortalityMultiplier !== null && (this.futureLossesEnd !== "" || this.futureLossesEnd !== null) && this.futureEarningsValid && this.rangeOfLossOfEarningsRules && this.futureLossesConstantResult > 0;
            }

            return false;
        },
        rangeOfLossOfEarningsRules: function rangeOfLossOfEarningsRules() {
            if (this.futureLossesEnd !== null) {
                return __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesEnd, 'DD/MM/YYYY'));
            }

            return null;
        },
        preInjuryContingencyMultiplierPayload: function preInjuryContingencyMultiplierPayload() {
            return {
                disabled: this.disabledAtAccident,
                education: this.levelOfEducation,
                employment: this.employedAtAccident,
                gender: this.claimant.gender,
                dateOfBirth: this.claimant.dateOfBirth,
                assumedSettlement: this.getClaimInfo('dateOfAssumedSettlement')
            };
        },
        assessmentContingencyMultiplierPayload: function assessmentContingencyMultiplierPayload() {
            return {
                disabled: this.disabledAtAssessment,
                education: this.levelOfEducation,
                employment: this.employedAtAssessment,
                gender: this.claimant.gender,
                dateOfBirth: this.claimant.dateOfBirth,
                assumedSettlement: this.getClaimInfo('dateOfAssumedSettlement')
            };
        },
        validRetirementAge: function validRetirementAge() {
            return this.retirementAge >= 50 && this.retirementAge <= 80;
        }
    }),
    mounted: function mounted() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["b" /* setStepValid */])(this.isValid);

        if (!this.futureLossesStart) {
            this.futureLossesStart = this.getClaimInfo('dateOfAssumedSettlement');
        }

        if (!this.preAccidentMultiplicand) {
            this.preAccidentMultiplicand = this.getIncomeValue('preAccident').employmentIncome;
        }

        if (this.retiredBetweenInjuryAndSettlement) {
            this.futureLosses = false;
        }

        this.watchers();

        if (!this.retirementDate) {
            this.updateRetirementAgeAndDate();
        }
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_7_components_StepButton_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        PostAccidentIncome: __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_income_PostAccidentIncome___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_14_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_15_components_modal_ModalContent_vue___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_16_components_modal_ModalInTheWild___default.a,
        FutureIncome: __WEBPACK_IMPORTED_MODULE_17__income_FutureIncome___default.a,
        WarningBox: __WEBPACK_IMPORTED_MODULE_18_components_modal_WarningBox_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__["a" /* default */]
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapActions */])('personal/claimant', ['updateClaimantValue', 'updateIncomeValue', 'updateRetirementAgeAndDate', 'updateIncomePeriodForRetirementChange', 'updateFutureLossesEnd', 'clearFuturePeriods', 'updateFutureLossOfEarningsMultiplier', 'updateDiscountFactors']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapActions */])('personal/futureLosses', ['updateLoss', 'reset', 'resetIsConstant', 'updateDiscountFactors', 'updateResults', 'updateFutureLossOfEarnings', 'getFutureLossOfEarningsMultiplier']), {
        updateTheFutureLossOfEarnings: function updateTheFutureLossOfEarnings() {
            if (!this.lossOfEarningsBeforeRetirement) {
                return;
            }

            this.updateLoss({ key: 'futureLossesEnd', value: this.futureLossesToRetirement ? this.retirementDate : this.futureLossesEnd });

            this.updateFutureLossOfEarnings();
        },
        updateTheFutureLossOfEarningsAndIncome: function updateTheFutureLossOfEarningsAndIncome() {
            this.updateTheFutureLossOfEarnings();
            this.updateFutureLossOfEarningsMultiplier();
        },
        validRangeOfLossOfEarnings: function validRangeOfLossOfEarnings() {
            var startDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesStart, 'DD/MM/YYYY');

            switch (true) {
                case !this.futureLossesToRetirement && startDate.isAfter(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.futureLossesEnd, 'DD/MM/YYYY')):
                case this.futureLossesToRetirement && startDate.isAfter(__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.retirementDate, 'DD/MM/YYYY')):
                    return true;
                default:
                    return false;
            }
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_routingMethods__["b" /* setStepValid */])(this.isValid);
        },
        watchers: function watchers() {
            var _this2 = this;

            this.$watchAll(["preInjuryDiscountFactor", "assessmentDiscountFactor", "futureLossesStart", "futureLossesRetirementAge", "futureLossesEnd"], function (field, value) {
                _this2.updateResults();
            });

            this.$watchAll(["futureLossesEnd"], function (field, value) {
                _this2.updateFutureLossesEnd();
            });

            this.$watchAll(["futureLossesConstant"], function (field, value) {
                _this2.updateResults();
            });
        },
        updateIncome: function updateIncome() {
            this.updateResults();
        },
        periodDuration: function periodDuration(period) {
            return __WEBPACK_IMPORTED_MODULE_11_moment___default()(period.endOfPeriod, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true);
        },
        periodNetEarnings: function periodNetEarnings(period) {
            return this.currencyFormat(period.futureLossOfEarningsMultiplier * this.assessmentDiscountFactor * period.totalNetIncome);
        },
        postNetTotal: function postNetTotal() {
            var _this3 = this;

            var periods = this.getIncomeValue('futurePeriods').map(function (period) {
                return period.futureLossOfEarningsMultiplier * _this3.assessmentDiscountFactor * period.totalNetIncome;
            });

            var total = periods.reduce(function (total, carry) {
                return total + carry;
            }, 0);
            this.updateIncomeValue({ key: 'futureLossOfEarningsNetTotal', value: total });
            return total;
        },
        updateDiscountIfValid: function updateDiscountIfValid() {
            if (this.levelOfEducation === null || this.disabledAtAccident === null || this.employedAtAccident === null || this.disabledAtAssessment === null || this.employedAtAssessment === null) {
                return;
            }
            this.updateDiscountFactors();
        }
    })
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_components_InjurySelect_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_components_InjurySelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_components_InjurySelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__awards_Award__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__awards_Award___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__awards_Award__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__awards_AwardValueRow_vue__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__awards_AwardValueRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__awards_AwardValueRow_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'general-damages',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('personal/generalDamages', {
        getTree: 'getTree',
        getAward: 'getAward',
        getAwards: 'getAwards',
        getSubTotal: 'getSubTotal',
        getAwardsValid: 'getAwardsValid',
        getDiscountsValid: 'getDiscountsValid',
        getGeneralDamages: 'getGeneralDamages',
        getJCGuidelinesInfo: 'getJCGuidelinesInfo',
        getJCGuidelinesNames: 'getJCGuidelinesNames',
        getSubTotalDiscounted: 'getSubTotalDiscounted'
    })),
    mounted: function mounted() {
        this.fetchInjuries();
    },

    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__["a" /* default */]],
    components: { Award: __WEBPACK_IMPORTED_MODULE_9__awards_Award___default.a, StepButton: __WEBPACK_IMPORTED_MODULE_4_components_StepButton_vue___default.a, Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a, ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a, InjurySelect: __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_components_InjurySelect_vue___default.a, AwardValueRow: __WEBPACK_IMPORTED_MODULE_11__awards_AwardValueRow_vue___default.a },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('personal/generalDamages', {
        fetchInjuries: 'fetchInjuries',
        addAward: 'addAward'
    }), {
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.isValid());
        },
        isValid: function isValid() {
            return this.$valid() && this.getAwardsValid;
        },
        selectedAward: function selectedAward() {
            this.updateValid();
        }
    })
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StepButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StepButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_StepButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__interim_Payment__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__interim_Payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__interim_Payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_InterestItem__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_InterestItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_InterestItem__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'InterimPaymentsAndInterest',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/claimant', ['getIncomeValue', 'getClaimInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/otherPastLosses', ['value', 'getAllCustomHeadOfLoss', 'getModalPayload']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/interimPayments', ['interimPayments', 'allInterimPaymentsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant']), {
        showGeneralDamages: function showGeneralDamages() {
            return this.getClaimInfo('proceduralStatus') !== 'pre-lit';
        },

        pastLossOfEarnings: {
            get: function get() {
                return this.getIncomeValue('pastLossOfEarnings');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'pastLossOfEarnings', value: value });
            }
        },
        interestType: {
            get: function get() {
                return this.value('interestType');
            },
            set: function set(value) {
                this.setValue({ key: 'interestType', value: value });
            }
        },
        customInterestDate: {
            get: function get() {
                return this.value('customInterestDate');
            },
            set: function set(value) {
                this.setValue({ key: 'customInterestDate', value: value });
            }
        },
        payload: {
            get: function get() {
                return this.getModalPayload;
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },
        isValidDate: function isValidDate() {
            var mDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.customInterestDate, 'DD/MM/YYYY');
            return mDate.isValid();
        },
        isValidInterestDate: function isValidInterestDate() {
            var mDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.customInterestDate, 'DD/MM/YYYY');
            var mDateOfInjury = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY');
            return mDate.isAfter(mDateOfInjury);
        }
    }),
    created: function created() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_services_routingMethods__["b" /* setStepValid */])(true);
        this.calcAllInterest();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        StepButton: __WEBPACK_IMPORTED_MODULE_3_components_StepButton___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Error___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput___default.a,
        Payment: __WEBPACK_IMPORTED_MODULE_10__interim_Payment___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent___default.a,
        InterestItem: __WEBPACK_IMPORTED_MODULE_13_components_InterestItem___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('personal/otherPastLosses', {
        setValue: 'set',
        setCustomValue: 'setCustomHeadOfLossValue',
        calcAllInterest: 'calcAllInterest'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('personal/interimPayments', ['addPayment']), {
        onUpdate: function onUpdate(info) {
            this.setValue({ key: info.updates, value: info.value }).then(this.calcAllInterest.bind(this));
        },
        onUpdateCustom: function onUpdateCustom(info) {
            this.setCustomValue({ index: info.updates, value: info.value, key: 'interest' }).then(this.calcAllInterest.bind(this));
        }
    })
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_steps_other_future_losses_FuturePension_vue__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_steps_other_future_losses_FuturePension_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_steps_other_future_losses_FuturePension_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_other_future_losses_FutureCare_vue__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_other_future_losses_FutureCare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_other_future_losses_FutureCare_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_personal_injury_claims_steps_other_future_losses_FutureServices_vue__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_personal_injury_claims_steps_other_future_losses_FutureServices_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_personal_injury_claims_steps_other_future_losses_FutureServices_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_personal_injury_claims_steps_other_future_losses_FuturePurchases_vue__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_personal_injury_claims_steps_other_future_losses_FuturePurchases_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_personal_injury_claims_steps_other_future_losses_FuturePurchases_vue__);



var _watch;












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'other-future-losses',
    mounted: function mounted() {
        this.isValid;
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default.a,
        FutureCare: __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_other_future_losses_FutureCare_vue___default.a,
        FutureServices: __WEBPACK_IMPORTED_MODULE_10_pages_personal_injury_claims_steps_other_future_losses_FutureServices_vue___default.a,
        FuturePurchases: __WEBPACK_IMPORTED_MODULE_11_pages_personal_injury_claims_steps_other_future_losses_FuturePurchases_vue___default.a,
        FuturePension: __WEBPACK_IMPORTED_MODULE_8_pages_personal_injury_claims_steps_other_future_losses_FuturePension_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['value', 'pensionValid', 'careValid', 'servicesValue', 'servicesValid', 'purchasesValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo', 'getClaimantValue']), {
        hasOtherFutureLosses: {
            get: function get() {
                return this.value('hasOtherFutureLosses');
            },
            set: function set(value) {
                this.set({ key: 'hasOtherFutureLosses', value: value });
            }
        },
        isValid: function isValid() {
            if (this.hasOtherFutureLosses === false) {
                return true;
            }

            if (this.hasOtherFutureLosses) {
                return this.careValid && this.servicesValid && this.purchasesValid && this.pensionValid;
            }

            return false;
        }
    }),
    watch: (_watch = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'isValid', function isValid() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'pensionValid', function pensionValid() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'careValid', function careValid() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'servicesValid', function servicesValid() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'purchasesValid', function purchasesValid() {
        this.updateValid();
    }), _watch),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('personal/otherFutureLosses', ['set', 'updateCare', 'setServices', 'updateServices']), {
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.isValid);
        }
    })
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_steps_heads_of_loss_HeadOfLoss_vue__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_steps_heads_of_loss_HeadOfLoss_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_steps_heads_of_loss_HeadOfLoss_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_heads_of_loss_Period_vue__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_heads_of_loss_Period_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_heads_of_loss_Period_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_directives_TwoDecimalPlaces__ = __webpack_require__(11);



var _watch;














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'other-past-losses',
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_10_components_StepButton_vue___default.a,
        HeadOfLoss: __WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_steps_heads_of_loss_HeadOfLoss_vue___default.a,
        Period: __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_steps_heads_of_loss_Period_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalContent_vue___default.a
    },
    mounted: function mounted() {
        if (this.value('careCalcType') === null) {
            this.set({ key: 'careCalcType', value: 'own' });
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_routingMethods__["b" /* setStepValid */])(true);
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapGetters */])('personal/otherPastLosses', ['value', 'allCarePeriodsValid', 'allCustomHeadOfLossValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapGetters */])('personal/claimant', ['getClaimantDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapGetters */])('modal', ['modals']), {
        pastCostOfServices: {
            get: function get() {
                return this.value('pastCostOfServices');
            },
            set: function set(value) {
                this.set({ key: 'pastCostOfServices', value: value });
            }
        },
        pastCostOfTravel: {
            get: function get() {
                return this.value('pastCostOfTravel');
            },
            set: function set(value) {
                this.set({ key: 'pastCostOfTravel', value: value });
            }
        },
        misc: {
            get: function get() {
                return this.value('misc');
            },
            set: function set(value) {
                this.set({ key: 'misc', value: value });
            }
        },
        customHeadsOfLoss: {
            get: function get() {
                return this.value('headsOfLoss');
            }
        },
        careCalcType: {
            get: function get() {
                return this.value('careCalcType');
            },
            set: function set(value) {
                this.set({ key: 'careCalcType', value: value });
            }
        },
        pastCostOfCare: {
            get: function get() {
                return this.value('pastCostOfCare');
            },
            set: function set(value) {
                this.set({ key: 'pastCostOfCare', value: value });
            }
        },
        periods: {
            get: function get() {
                return this.value('periods');
            }
        }
    }),
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_13_directives_TwoDecimalPlaces__["a" /* default */]
    },
    watch: (_watch = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, '$form.$valid', function $form$valid() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'periods', function periods() {
        this.updateValid();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'customHeadsOfLoss', function customHeadsOfLoss() {
        this.updateValid();
    }), _watch),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapActions */])('personal/otherPastLosses', {
        set: 'set',
        addCustomHeadOfLoss: 'addCustomHeadOfLoss',
        addCarePeriod: 'addCarePeriod'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapActions */])('personal/generalDamages', {
        updateValue: 'updateValue'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_routingMethods__["b" /* setStepValid */])(this.isValid());
        },
        isValid: function isValid() {
            var headsOfLossValid = true;
            var carePeriodsValid = true;

            if (this.careCalcType === 'manual') {
                carePeriodsValid = this.allCarePeriodsValid();
            }

            if (this.customHeadsOfLoss.length) {
                headsOfLossValid = this.allCustomHeadOfLossValid;
            }

            return this.$valid() && carePeriodsValid && headsOfLossValid;
        }
    })
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__past_loss_of_earnings_PostAccidentEarnings__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__past_loss_of_earnings_PostAccidentEarnings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__past_loss_of_earnings_PostAccidentEarnings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__past_loss_of_earnings_PreAccidentEarnings__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__past_loss_of_earnings_PreAccidentEarnings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__past_loss_of_earnings_PreAccidentEarnings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__past_loss_of_earnings_PastLossOfEarningsCalculations__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__past_loss_of_earnings_PastLossOfEarningsCalculations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__past_loss_of_earnings_PastLossOfEarningsCalculations__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'past-loss-of-earnings',
    mounted: function mounted() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_services_routingMethods__["b" /* setStepValid */])(this.isValid);

        if (this.getPostInjuryIncomePeriods.length === 0) {
            this.addIncomePeriod('postInjury');
        }
    },
    data: function data() {
        return {
            preAccidentEarningsValid: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/claimant', ['getPostInjuryIncomePeriods', 'getPostInjuryIncomePeriodPayments', 'postInjuryIncomePeriodPaymentsValid', 'postInjuryIncomePeriodsValid', 'getIncomeValue']), {
        preAccidentEarnings: {
            get: function get() {
                return this.getIncomeValue('pastLossOfEarnings');
            },
            set: function set(value) {
                this.updateIncomeValue('pastLossOfEarning', value);
            }
        },
        ownPastLosses: {
            get: function get() {
                return this.getIncomeValue('ownPastLosses');
            }
        },
        isValid: function isValid() {
            if (this.preAccidentEarningsValid && !this.preAccidentEarnings) {
                return true;
            }
            if (this.preAccidentEarningsValid && this.ownPastLosses) {
                return true;
            }

            return this.preAccidentEarningsValid && this.postInjuryIncomePeriodPaymentsValid && this.postInjuryIncomePeriodsValid;
        }
    }),
    watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'isValid', function isValid() {
        this.updateValid();
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_mixins_currencyFormat__["a" /* default */]],
    components: {
        PastLossOfEarningsCalculator: __WEBPACK_IMPORTED_MODULE_13__past_loss_of_earnings_PastLossOfEarningsCalculations___default.a,
        PreAccidentEarnings: __WEBPACK_IMPORTED_MODULE_11__past_loss_of_earnings_PreAccidentEarnings___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_6_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_7_components_modal_ModalContent___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild___default.a,
        StepButton: __WEBPACK_IMPORTED_MODULE_12_components_StepButton_vue___default.a,
        PostAccidentEarnings: __WEBPACK_IMPORTED_MODULE_9__past_loss_of_earnings_PostAccidentEarnings___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__["a" /* default */]
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('personal/claimant', ['addIncomePeriod', 'updateIncomeValue']), {
        updatePreAccidentEarnings: function updatePreAccidentEarnings(data) {
            this.preAccidentEarningsValid = data.preAccidentEarningsValid;
            this.preAccidentEarnings = data.preAccidentEarnings;
            this.updateValid();
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_services_routingMethods__["b" /* setStepValid */])(this.isValid);
        }
    })
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_components_InjurySelect_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_components_InjurySelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_components_InjurySelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_IconTooltip__);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'psla-award',
    props: ['award', 'awardIndex'],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('personal/generalDamages', {
        getTree: 'getTree'
    }), {
        selected: {
            get: function get() {
                return this.award.path;
            }
        },
        tree: {
            get: function get() {
                return this.getTree;
            }
        }
    }),
    mounted: function mounted() {
        this.fetchInjuries();
    },

    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */]],
    components: { StepButton: __WEBPACK_IMPORTED_MODULE_5_components_StepButton_vue___default.a, Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a, ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a, DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a, InjurySelect: __WEBPACK_IMPORTED_MODULE_9_pages_personal_injury_claims_components_InjurySelect_vue___default.a, IconTooltip: __WEBPACK_IMPORTED_MODULE_10_components_IconTooltip___default.a },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('personal/generalDamages', {
        updateValue: 'updateValue',
        removeAward: 'removeAward',
        fetchInjuries: 'fetchInjuries'
    }), {
        selectedInjury: function selectedInjury(val) {
            if (typeof this.path === 'undefined') {
                this.path = this.getPath || [];
            }

            if (val.level === 0) {
                this.path = [];
                this.path[val.level] = val.value;
                this.updateValid();
                this.updateValue({ key: 'path', value: this.path, index: this.awardIndex });
                return;
            }

            this.path = this.path.slice(0, val.level);
            this.path[val.level] = val.value;
            this.updateValid();
            this.updateValue({ key: 'path', value: this.path, index: this.awardIndex });
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_services_routingMethods__["b" /* setStepValid */])(this.isValid());
        },
        isValid: function isValid() {
            return this.$valid() && this.award.getGeneralDamages > 0;
        },
        selectedAward: function selectedAward() {
            this.$emit("award-selected");
        },
        removeTheAward: function removeTheAward() {
            this.removeAward(this.awardIndex);
        }
    })
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_fragment__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AwardValueRow",
  props: {
    awardIndex: Number
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])("personal/generalDamages", ["getAward", "getJCGuidelinesInfo", "getJCGuidelinesNames", "getDiscountsValid"]), {
    award: function award() {
      return this.getAward(this.awardIndex);
    },

    discount: {
      get: function get() {
        return this.award.discount;
      },
      set: function set(value) {
        this.updateValue({ index: this.awardIndex, key: "discount", value: value || 0 });
      }
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_1_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__["a" /* default */]],
  components: { Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control_vue___default.a, ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error_vue___default.a, Fragment: __WEBPACK_IMPORTED_MODULE_5_vue_fragment__["b" /* Fragment */] },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])("personal/generalDamages", ["updateValue"]))
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_directives_TwoDecimalPlaces__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "benefit",
    mixins: [__WEBPACK_IMPORTED_MODULE_0_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_4_directives_TwoDecimalPlaces__["a" /* default */]
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default.a
    },
    props: {
        title: {
            type: String,
            required: true
        },
        storeKey: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        },
        showHeader: {
            type: Boolean,
            default: false
        },
        isLast: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        fieldName: function fieldName() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.snakeCase(this.title);
        },
        benefit: function benefit() {
            return this.$store.getters['personal/cruBenefits/' + this.storeKey];
        },

        amount: {
            get: function get() {
                return this.benefit.value;
            },
            set: function set(value) {
                this.updateValue({ key: this.storeKey, value: value });
            }
        },
        include: {
            get: function get() {
                return this.benefit.include;
            },
            set: function set(value) {
                this.updateInclude({ key: this.storeKey, value: value });
            }
        }
    },
    methods: {
        updateValue: function updateValue(arg) {
            return this.$store.dispatch('personal/cruBenefits/updateValue', arg);
        },
        updateInclude: function updateInclude(arg) {
            return this.$store.dispatch('personal/cruBenefits/updateInclude', arg);
        }
    }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Benefit__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Benefit: __WEBPACK_IMPORTED_MODULE_1__Benefit___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headOfLoss',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_6_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])('personal/otherPastLosses', ['getCustomHeadOfLoss', 'allHeadsOfLossValid']), {
        name: {
            get: function get() {
                return this.getCustomHeadOfLoss(this.index).name;
            },
            set: function set(value) {
                this.setCustomHeadOfLossValue({ key: 'name', index: this.index, value: value });
            }
        },
        value: {
            get: function get() {
                return this.getCustomHeadOfLoss(this.index).value;
            },
            set: function set(value) {
                this.setCustomHeadOfLossValue({ key: 'value', index: this.index, value: value });
            }
        }
    }),
    created: function created() {
        this.updateValid();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('personal/otherPastLosses', ['setCustomHeadOfLossValue', 'deleteCustomHeadOfLoss']), {
        deleteThisHeadOfLoss: function deleteThisHeadOfLoss() {
            this.deleteCustomHeadOfLoss(this.index);
            this.updateValid();
        },
        updateValid: function updateValid() {
            this.$emit('update');
        }
    })
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_ModalContent_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'period',
    props: {
        index: {
            type: Number,
            required: true
        },
        showSubtotal: {
            default: true
        },
        showDelete: {
            default: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_8_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalContent_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('personal/otherPastLosses', ['getCarePeriod', 'allCarePeriodsValid', 'findPeriod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo']), {
        periodStart: {
            get: function get() {
                return this.getCarePeriod(this.index).periodStart;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'periodStart', index: this.index, value: value });
            }
        },
        periodEnd: {
            get: function get() {
                return this.getCarePeriod(this.index).periodEnd;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'periodEnd', index: this.index, value: value });
            }
        },
        hoursPerDay: {
            get: function get() {
                return this.getCarePeriod(this.index).hoursPerDay;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'hoursPerDay', index: this.index, value: value });
            }
        },
        rate: {
            get: function get() {
                return this.getCarePeriod(this.index).rate;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'rate', index: this.index, value: value });
            }
        },
        periodTotal: {
            get: function get() {
                return this.getCarePeriod(this.index).total.toFixed(2);
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'total', index: this.index, value: value });
            }
        },
        gratuitousCare: {
            get: function get() {
                return this.getCarePeriod(this.index).gratuitousCare;
            },
            set: function set(value) {
                this.updateCarePeriodValue({ key: 'gratuitousCare', index: this.index, value: value });
            }
        },
        subTotalIcon: {
            get: function get() {
                return this.getCarePeriod(this.index).periodStart !== '' && this.getCarePeriod(this.index).periodEnd !== '' && this.getCarePeriod(this.index).hoursPerDay > 0 ? 'formula' : 'default';
            }
        },
        validationPeriodStart: {
            get: function get() {
                return this.getClaimInfo('dateOfInjury');
            }
        },
        validationPeriodEnd: {
            get: function get() {
                return this.getClaimInfo('dateOfAssumedSettlement');
            }
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('personal/otherPastLosses', ['updateCarePeriodValue', 'deleteCarePeriod', 'calcCareTotalForPeriod']), {
        deletePeriod: function deletePeriod() {
            this.deleteCarePeriod({ index: this.index });
        },
        calcRate: function calcRate() {
            this.calcCareTotalForPeriod({ index: this.index });
            this.$emit('update');
        },
        startPeriodValid: function startPeriodValid() {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.periodStart, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY'));
        },
        endPeriodValid: function endPeriodValid() {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.periodEnd, 'DD/MM/YYYY').isValid() ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.periodEnd, 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.getClaimInfo('dateOfAssumedSettlement'), 'DD/MM/YYYY')) : false;
        },
        periodStartIsBeforeEnd: function periodStartIsBeforeEnd() {
            return this.periodEnd ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.periodStart, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.periodEnd, 'DD/MM/YYYY')) : false;
        }
    })
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IncomePeriod__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IncomePeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__IncomePeriod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'income',
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_7_components_form_control_DateInput___default.a,
        IncomePeriod: __WEBPACK_IMPORTED_MODULE_4__IncomePeriod___default.a
    },
    props: {
        name: {
            type: String,
            required: true
        },
        income: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: null
        },
        retired: {
            type: Boolean,
            required: true
        },
        startDisabled: {
            type: Boolean,
            default: true
        },
        lossOfEarnings: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: "future"
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('http', {
        loading: 'running'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant']), {
        innerIncome: function innerIncome() {
            var income = {};
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.util.extend(income, this.income);
            return income;
        },
        periods: function periods() {
            return this.innerIncome[this.type + 'Periods'];
        },
        periodsLength: function periodsLength() {
            return this.periods.length;
        },
        incomeRules: function incomeRules() {
            var periodIncomeCount = 0;

            this.periods.forEach(function (period, index) {
                if (period['employmentIncome'] > 0 || period['pensionIncome'] > 0) {
                    periodIncomeCount++;
                }
            }, this);

            return periodIncomeCount > 0;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('personal/claimant', ['addClaimantIncomePeriod', 'addIncomePeriod', 'updatePostInjuryIncomePeriod', 'updateIncomePeriodForRetirementChange']), {
        callAction: function callAction() {
            this.$emit('action', { income: this.innerIncome, index: this.index });
        },
        updatePeriod: function updatePeriod(payload) {
            payload.type = this.type;
            this.updatePostInjuryIncomePeriod(payload);
        }
    })
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_lost_years_claims_steps_income_income_period_mixin__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mixins_currencyFormat__ = __webpack_require__(6);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'income-period',
    mounted: function mounted() {
        this.updatePeriod();
    },
    data: function data() {
        return {
            loading: false,
            nodes: [],
            selectedNode: null,
            selectedNodes: [],
            disabledNetGross: false
        };
    },

    watch: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, 'periodEmploymentIncome', function periodEmploymentIncome() {
        this.disabledNetGross = false;
    }),
    components: {
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        Control: __WEBPACK_IMPORTED_MODULE_5_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal___default.a
    },
    props: {
        startDisabled: {
            type: Boolean,
            required: false
        },
        retired: {
            type: Boolean,
            required: true
        },
        lossOfEarnings: {
            type: Boolean,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        maxIndex: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_13_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_pages_lost_years_claims_steps_income_income_period_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getIncomePeriod', 'getClaimInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('personal/futureLosses', ['getLoss']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])('modal', ['modals']), {
        isModalOpen: function isModalOpen() {
            var ons_salary = 'ons_salary_' + this.uniqueId;
            return this.modals && this.modals[ons_salary];
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },
        periodEmploymentIncome: function periodEmploymentIncome() {
            return this.innerPeriod.employmentIncome;
        },
        startOfPeriodRules: function startOfPeriodRules() {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__["a" /* validDate */])(this.innerPeriod.startOfPeriod) || this.innerPeriod.startOfPeriod === '' || this.innerPeriod.startOfPeriod === null) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY'))) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.endOfPeriod, 'DD/MM/YYYY'))) {
                return false;
            }
            return true;
        },
        endOfPeriodRules: function endOfPeriodRules() {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__["a" /* validDate */])(this.innerPeriod.endOfPeriod) || this.innerPeriod.endOfPeriod === '' || this.innerPeriod.endOfPeriod === null) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY'))) {
                return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.endOfPeriod, 'DD/MM/YYYY'))) {
                return false;
            }
            return true;
        },
        rangeOfPeriodRules: function rangeOfPeriodRules() {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY'));
        },
        incomeRules: function incomeRules() {
            if (this.innerPeriod.employmentIncome < 0) {
                return false;
            }
            if (this.innerPeriod.employmentIncome === "") {
                return false;
            }
            return true;
        },
        endOfPeriod: function endOfPeriod() {
            return this.getLoss('futureLossesEnd');
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('personal/claimant', ['updateIncomePeriodValue', 'deleteIncomePeriod', 'addIncomePeriod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        updatePeriod: function updatePeriod() {
            this.$emit('update', { index: this.index, period: this.innerPeriod });
        },
        deletePeriod: function deletePeriod() {
            var maxIndex = this.maxIndex - 1;
            var prevIndex = this.index - 1;
            var nextIndex = this.index + 1;
            var nextPeriodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: prevIndex }).endOfPeriod;
            var nextDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(nextPeriodEndOfPeriod, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');

            this.index === maxIndex ? this.updateIncomePeriodValue({ type: this.type, index: prevIndex, key: 'endOfPeriod', value: this.endOfPeriod }) : this.updateIncomePeriodValue({ type: this.type, index: nextIndex, key: 'startOfPeriod', value: nextDay });

            this.deleteIncomePeriod({ index: this.index, type: this.type });
        },
        updateNextPeriod: function updateNextPeriod() {
            var maxIndex = this.maxIndex - 1;
            this.updatePeriod();

            if (this.index < maxIndex) {
                var nextIndex = this.index + 1;
                var nextDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');

                this.updateIncomePeriodValue({ type: this.type, index: nextIndex, key: 'startOfPeriod', value: nextDay });

                for (var i = nextIndex, len = maxIndex; i <= len; i++) {
                    var prevPeriodEndOfPeriod = '';
                    var periodEndOfPeriod = '';
                    var periodStartOfPeriod = '';

                    prevPeriodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: i - 1 }).endOfPeriod;
                    periodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: i }).endOfPeriod;
                    periodStartOfPeriod = this.getIncomePeriod({ type: this.type, index: i }).startOfPeriod;

                    if (prevPeriodEndOfPeriod > periodStartOfPeriod) {
                        periodStartOfPeriod = __WEBPACK_IMPORTED_MODULE_2_moment___default()(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
                        this.updateIncomePeriodValue({ type: this.type, index: i, key: 'startOfPeriod', value: periodStartOfPeriod });
                    }

                    if (periodEndOfPeriod <= periodStartOfPeriod && i !== len) {
                        this.updateIncomePeriodValue({ type: this.type, index: i, key: 'endOfPeriod', value: periodStartOfPeriod });
                    }
                }
            }

            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.endOfPeriod, 'DD/MM/YYYY')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY')) && this.index === maxIndex) {
                this.addIncomePeriod(this.type);
            }
        },
        openDialog: function openDialog() {
            if (!this.isModalOpen) {
                this.nodes = [];
                this.selectedNode = null;
                this.selectedNodes = [];
                return this.toggle('ons_salary_' + this.uniqueId).then(this.updateNodes);
            }
        },
        closeModal: function closeModal() {
            if (this.isModalOpen) {
                return this.toggle('ons_salary_' + this.uniqueId);
            }
        },
        updateNodes: function updateNodes() {
            var _this = this;

            var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_11_services_Api__["a" /* default */].calculators.ons.salary(this.gender, code).then(function (nodes) {
                _this.nodes = nodes;
                _this.loading = false;
            });
        },
        selectNode: function selectNode(node) {
            if (node.code.length === 4) {
                return;
            }
            this.selectedNode = node;
            this.selectedNodes.push(node);
            return this.updateNodes(node.code);
        },
        unselectNode: function unselectNode(node) {
            var index = this.selectedNodes.indexOf(node);
            if (index === 0) {
                this.selectedNodes = [];
                this.selectedNode = null;
                return this.updateNodes();
            }
            this.selectedNodes.splice(index);
            var lastIndex = this.selectedNodes.length - 1;
            this.selectedNode = this.selectedNodes[lastIndex];
            this.updateNodes(this.selectedNode.code);
        },
        selectSalary: function selectSalary(node) {
            var _this2 = this;

            if (node === null) {
                return __WEBPACK_IMPORTED_MODULE_11_services_Api__["a" /* default */].calculators.ons.averageSalary(this.claimant.gender).then(function (result) {
                    _this2.innerPeriod.employmentIncome = result.value;
                    _this2.innerPeriod.employmentNetGross = 'gross';
                    _this2.updatePeriod();
                }).then(function () {
                    _this2.closeModal;
                    _this2.disabledNetGross = true;
                });
            }
            this.innerPeriod.employmentIncome = node.salary;
            this.updatePeriod();
            this.closeModal();
        },
        displaySalary: function displaySalary(node) {
            if (node.salary === "x") {
                return "No Information";
            }
            return this.currencyFormat(node.salary, '£', 0);
        },
        getLastNode: function getLastNode() {
            return this.selectedNodes.slice(-1)[0];
        }
    })
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'post-accident-income',
    data: function data() {
        return {
            loading: false,
            nodes: [],
            selectedNode: null,
            selectedNodes: [],
            preAccidentDisableNetGross: false,
            postAccidentDisableNetGross: false
        };
    },
    mounted: function mounted() {
        this.checkForPreAccidentEarnings();
    },

    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getIncomeValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/futureLosses', ['getLoss']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('modal', ['modals']), {
        isModalOpen: function isModalOpen() {
            var ons_salary = 'ons_salary_' + this.uniqueId;
            return this.modals && this.modals[ons_salary];
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },

        futureLossesConstant: {
            get: function get() {
                return this.getLoss('futureLossesConstant');
            }
        },
        preEmploymentIncome: {
            get: function get() {
                return this.getIncomeValue('futureEarningsPreAccident').employmentIncome;
            },
            set: function set(value) {
                this.preAccidentDisableNetGross = false;
                this.updateFutureEarningsPreAccidentEarningsValue({ key: 'employmentIncome', value: value }).then(this.updateFutureEarningsPreAccidentEarnings);
            }
        },
        preEmploymentNetGross: {
            get: function get() {
                return this.getIncomeValue('futureEarningsPreAccident').employmentNetGross;
            },
            set: function set(value) {
                this.updateFutureEarningsPreAccidentEarningsValue({ key: 'employmentNetGross', value: value }).then(this.updateFutureEarningsPreAccidentEarnings);
            }
        },
        preTotalNetIncome: {
            get: function get() {
                return this.getIncomeValue('futureEarningsPreAccident').totalNetIncome;
            }
        },
        postEmploymentIncome: {
            get: function get() {
                return this.getIncomeValue('futureEarningsPostAccident').employmentIncome;
            },
            set: function set(value) {
                this.postAccidentDisableNetGross = false;
                this.updateFutureEarningsPostAccidentEarningsValue({ key: 'employmentIncome', value: value }).then(this.updateFutureEarningsPostAccidentEarnings);
            }
        },
        postEmploymentNetGross: {
            get: function get() {
                return this.getIncomeValue('futureEarningsPostAccident').employmentNetGross;
            },
            set: function set(value) {
                this.updateFutureEarningsPostAccidentEarningsValue({ key: 'employmentNetGross', value: value }).then(this.updateFutureEarningsPostAccidentEarnings);
            }
        },
        postTotalNetIncome: {
            get: function get() {
                return this.getIncomeValue('futureEarningsPostAccident').totalNetIncome;
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('personal/claimant', ['updateFutureEarningsPreAccidentEarnings', 'updateFutureEarningsPreAccidentEarningsValue', 'updateFutureEarningsPostAccidentEarnings', 'updateFutureEarningsPostAccidentEarningsValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        openDialog: function openDialog(type) {
            if (!this.isModalOpen) {
                this.nodes = [];
                this.selectedNode = null;
                this.selectedNodes = [];
                this.type = type;
                return this.toggle('ons_salary_' + this.uniqueId).then(this.updateNodes);
            }
        },
        closeModal: function closeModal() {
            if (this.isModalOpen) {
                this.type = null;
                return this.toggle('ons_salary_' + this.uniqueId);
            }
        },
        updateNodes: function updateNodes() {
            var _this = this;

            var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].calculators.ons.salary(this.gender, code).then(function (nodes) {
                _this.nodes = nodes;
                _this.loading = false;
            });
        },
        selectNode: function selectNode(node) {
            if (node.code.length === 4) {
                return;
            }
            this.selectedNode = node;
            this.selectedNodes.push(node);
            return this.updateNodes(node.code);
        },
        unselectNode: function unselectNode(node) {
            var index = this.selectedNodes.indexOf(node);
            if (index === 0) {
                this.selectedNodes = [];
                this.selectedNode = null;
                return this.updateNodes();
            }
            this.selectedNodes.splice(index);
            var lastIndex = this.selectedNodes.length - 1;
            this.selectedNode = this.selectedNodes[lastIndex];
            this.updateNodes(this.selectedNode.code);
        },
        selectSalary: function selectSalary(node, type) {
            var _this2 = this;

            if (node === null) {
                return __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].calculators.ons.averageSalary(this.claimant.gender).then(function (result) {
                    if (type === 'pre') {
                        _this2.preEmploymentIncome = result.value;
                        _this2.updateFutureEarningsPreAccidentEarningsValue({ key: 'employmentNetGross', value: 'gross' });
                        _this2.preAccidentDisableNetGross = true;
                        _this2.updateFutureEarningsPreAccidentEarningsValue({ key: 'employmentIncome', value: result.value }).then(_this2.updateFutureEarningsPreAccidentEarnings);
                    } else {
                        _this2.postEmploymentIncome = result.salary;
                        _this2.updateFutureEarningsPostAccidentEarningsValue({ key: 'employmentNetGross', value: 'gross' });
                        _this2.postAccidentDisableNetGross = true;
                        _this2.updateFutureEarningsPostAccidentEarningsValue({ key: 'employmentIncome', value: result.value }).then(_this2.updateFutureEarningsPostAccidentEarnings);
                    }
                }).then(this.closeModal);
            }
            this.employmentIncome = node.salary;

            if (type === 'pre') {
                this.preEmploymentIncome = node.salary;
                this.updateFutureEarningsPreAccidentEarningsValue({ key: 'employmentIncome', value: node.salary }).then(this.updateFutureEarningsPreAccidentEarnings);
            } else {
                this.postEmploymentIncome = node.salary;
                this.updateFutureEarningsPostAccidentEarningsValue({ key: 'employmentIncome', value: node.salary }).then(this.updateFutureEarningsPostAccidentEarnings);
            }
            this.closeModal();
        },
        displaySalary: function displaySalary(node) {
            if (node.salary === "x") {
                return "No Information";
            }
            return this.currencyFormat(node.salary, '£', 0);
        },
        getLastNode: function getLastNode() {
            return this.selectedNodes.slice(-1)[0];
        },
        checkForPreAccidentEarnings: function checkForPreAccidentEarnings() {
            if (this.getIncomeValue('pastLossOfEarnings')) {
                this.updateFutureEarningsPreAccidentEarningsValue({
                    key: 'employmentIncome',
                    value: this.getIncomeValue('preAccident').employmentIncome });

                this.updateFutureEarningsPreAccidentEarningsValue({
                    key: 'employmentNetGross',
                    value: this.getIncomeValue('preAccident').employmentNetGross });

                this.updateFutureEarningsPreAccidentEarnings();
            }
        }
    })
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__ = __webpack_require__(11);














var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'payment',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_3_components_form_control_DateInput_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_10_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/generalDamages', ['getGeneralDamages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/interimPayments', ['findPayment', 'allInterimPaymentsValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/claimant', ['getClaimInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])('personal/otherPastLosses', ['interestDate']), {
        dateOfInjury: {
            get: function get() {
                return this.getClaimInfo('dateOfInjury');
            }
        },
        date: {
            get: function get() {
                return this.findPayment(this.index).date;
            },
            set: function set(value) {
                this.updatePayment({ key: 'date', index: this.index, value: value }).then(this.updateValid.bind(this));
            }
        },
        value: {
            get: function get() {
                return this.findPayment(this.index).value;
            },
            set: function set(value) {
                this.updatePayment({ key: 'value', index: this.index, value: value }).then(this.updateValid.bind(this));
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('personal/interimPayments', ['updatePayment', 'deletePayment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('personal/otherPastLosses', ['calcAllInterest']), {
        deleteThisPayment: function deleteThisPayment() {
            this.deletePayment(this.index);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.allInterimPaymentsValid);
            this.updateInterest();
        },
        updateInterest: function updateInterest() {
            this.$emit('update');
            this.calcAllInterest();
        },
        updateValid: function updateValid() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_services_routingMethods__["b" /* setStepValid */])(this.allInterimPaymentsValid);
        },
        isValidDate: function isValidDate() {
            if (!this.date) {
                return true;
            }

            return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.date, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY'));
        },
        isBeforeInterestDate: function isBeforeInterestDate() {
            if (!this.date || !this.interestDate) {
                return true;
            }

            var mInterestDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.interestDate, 'DD/MM/YYYY');

            if (!mInterestDate.isValid()) {
                return true;
            }

            return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.date, 'DD/MM/YYYY').isBefore(mInterestDate);
        }
    })
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FutureCarePeriod_vue__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FutureCarePeriod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__FutureCarePeriod_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'future-care',
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default.a,
        FutureCarePeriod: __WEBPACK_IMPORTED_MODULE_10__FutureCarePeriod_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_11_components_IconTooltip___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_12_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_13_components_modal_ModalContent_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['value', 'care', 'careTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo']), {
        futureLossOfCare: {
            get: function get() {
                return this.value('futureLossOfCare');
            },
            set: function set(value) {
                this.set({ key: 'futureLossOfCare', value: value });
            }
        },
        futureLossOfCareValid: function futureLossOfCareValid() {
            return this.care.reduce(function (valid, care) {
                return valid ? care.futureCareTotal > 0 : false;
            }, true);
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('personal/otherFutureLosses', ['set', 'addCare']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        toggleModal: function toggleModal(period) {
            this.toggle('calculation_' + this.uniqueId);

            this.getModalContent({
                endpoint: 'futureLossesForCare',
                payload: {
                    period: period,
                    discountRate: this.getClaimInfo('discountRate'),
                    person: {
                        gender: this.claimant.gender,
                        date_of_birth: this.claimant.dateOfBirth,
                        date_of_assumed_settlement: this.getClaimInfo('dateOfAssumedSettlement')
                    }
                }
            });
        }
    })

});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'future-care',
    props: {
        index: {
            type: Number,
            default: 0
        },
        care: {
            type: Object,
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__["a" /* default */]
    },
    data: function data() {
        return {
            theDate: moment().format('DD/MM/YYYY')
        };
    },
    mounted: function mounted() {
        if (this.care.careStartDate === null) {
            this.care.careStartDate = this.getClaimInfo('dateOfAssumedSettlement');
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['value', 'careValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo']), {
        thePerson: function thePerson() {
            return {
                lifeExpectancy: this.value('careLifeExpectancy'),
                gender: this.claimant.gender,
                dateOfBirth: this.claimant.dateOfBirth
            };
        },

        careStartDateValidation: {
            get: function get() {
                var mStartOfCare = moment(this.care.careStartDate, 'DD/MM/YYYY');
                var mDateOfAccident = moment(this.getClaimInfo('dateOfAssumedSettlement'), 'DD/MM/YYYY');

                if (!mStartOfCare.isValid() || !mDateOfAccident.isValid()) {
                    return false;
                }

                return mStartOfCare.isSameOrAfter(mDateOfAccident);
            }
        },
        careEndDateValidation: {
            get: function get() {
                var mStartOfCare = moment(this.care.careStartDate, 'DD/MM/YYYY');
                var mEndOfCare = moment(this.care.careEndDate, 'DD/MM/YYYY');

                if (!mStartOfCare.isValid() || !mEndOfCare.isValid()) {
                    return false;
                }

                return mEndOfCare.isSameOrAfter(mStartOfCare);
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('personal/otherFutureLosses', ['setCarePeriod', 'removeCarePeriod', 'updateLifeForCare', 'updateCare']), {
        lossesForLifeChanged: function lossesForLifeChanged() {
            if (this.care.lossesForLife === true) {
                var lifeExpectancy = this.value('careLifeExpectancy');
                this.updateLife(lifeExpectancy);
            }
            this.updateCarePeriod();
        },
        updateLife: function updateLife(lifeExpectancy) {
            this.updateLifeForCare({ lifeExpectancy: lifeExpectancy, index: this.index });
        },
        deleteCarePeriod: function deleteCarePeriod() {
            this.removeCarePeriod({ index: this.index });
        },
        updateCarePeriod: function updateCarePeriod() {
            this.updateCare({ index: this.index });
        },
        updateCareEndDate: function updateCareEndDate() {
            this.care.ageAtEndDate = moment(this.care.careEndDate, 'DD/MM/YYYY').diff(moment(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
            this.updateCarePeriod();
        },
        updateCareAge: function updateCareAge() {
            this.care.careEndDate = moment(this.claimant.dateOfBirth, 'DD/MM/YYYY').add(this.care.ageAtEndDate, 'y').format('DD/MM/YYYY');
            this.updateCarePeriod();
        }
    })
});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'future-pension',
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'claimInfo', 'getClaimInfo', 'getIncomeValue', 'getClaimantValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['pensionUserInputValid', 'value', 'pension', 'pensionValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/futureLosses', ['getLoss']), {
        uniqueId: function uniqueId() {
            return this._uid;
        },

        dateOfBirth: {
            get: function get() {
                return this.getClaimantValue('dateOfBirth');
            }
        },
        futureLosses: {
            get: function get() {
                return this.getLoss('futureLosses');
            }
        },
        futureLossOfPension: {
            get: function get() {
                return this.value('futureLossOfPension');
            },
            set: function set(value) {
                var _this = this;

                this.set({ key: 'futureLossOfPension', value: value }).then(function () {
                    return _this.resetPension();
                });
            }
        },
        pensionMethod: {
            get: function get() {
                return this.pensionValue('pensionMethod');
            },
            set: function set(value) {
                this.setPension({ key: 'pensionMethod', value: value });
            }
        },
        dateLumpSumPaymentReceived: {
            get: function get() {
                return this.pensionValue('dateLumpSumPaymentReceived');
            },
            set: function set(value) {
                this.setPension({ key: 'dateLumpSumPaymentReceived', value: value });
            }
        },
        periodOfAcceleratedReceipt: {
            get: function get() {
                return this.pensionValue('acceleratedReceipt');
            }
        },
        illHealthDisabilityPension: {
            get: function get() {
                return this.pensionValue('illHealthDisabilityPension');
            },
            set: function set(value) {
                this.setPension({ key: 'illHealthDisabilityPension', value: value });
            }
        },
        butForRetirementDate: {
            get: function get() {
                return this.pensionValue('butForRetirementDate');
            },
            set: function set(value) {
                var _this2 = this;

                this.setPension({ key: 'butForRetirementDate', value: value }).then(function () {
                    if (_this2.butForRetirementDate && _this2.dateOfBirth) {
                        var butForRetirementAge = _this2.roundValue(__WEBPACK_IMPORTED_MODULE_10_moment___default()(_this2.butForRetirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(_this2.dateOfBirth, 'DD/MM/YYYY'), 'years', true), 2);

                        if (butForRetirementAge !== _this2.butForRetirementAge) {
                            _this2.butForRetirementAge = butForRetirementAge;
                        }
                    }
                });
            }
        },
        butForRetirementAge: {
            get: function get() {
                return this.pensionValue('butForRetirementAge');
            },
            set: function set(value) {
                var _this3 = this;

                this.setPension({ key: 'butForRetirementAge', value: value }).then(function () {
                    if (_this3.butForRetirementAge && _this3.dateOfBirth) {
                        var butForRetirementDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(_this3.dateOfBirth, 'DD/MM/YYYY').add(_this3.butForRetirementAge, "year").format("DD/MM/YYYY");

                        if (butForRetirementDate !== _this3.butForRetirementDate) {
                            _this3.butForRetirementDate = butForRetirementDate;
                        }
                    }
                });
            }
        },
        retirementDate: {
            get: function get() {
                return this.pensionValue('retirementDate');
            },
            set: function set(value) {
                var _this4 = this;

                this.setPension({ key: 'retirementDate', value: value }).then(function () {
                    if (_this4.retirementDate && _this4.dateOfBirth) {
                        var retirementAge = _this4.roundValue(__WEBPACK_IMPORTED_MODULE_10_moment___default()(_this4.retirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(_this4.dateOfBirth, 'DD/MM/YYYY'), 'years', true), 2);

                        if (retirementAge !== _this4.retirementAge) {
                            _this4.retirementAge = retirementAge;
                        }
                    }
                });
            }
        },
        retirementAge: {
            get: function get() {
                return this.pensionValue('retirementAge');
            },
            set: function set(value) {
                var _this5 = this;

                this.setPension({ key: 'retirementAge', value: value }).then(function () {
                    if (_this5.retirementAge && _this5.dateOfBirth) {
                        var retirementDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(_this5.dateOfBirth, 'DD/MM/YYYY').add(_this5.retirementAge, "year").format("DD/MM/YYYY");

                        if (retirementDate !== _this5.retirementDate) {
                            _this5.retirementDate = retirementDate;
                        }
                    }
                });
            }
        },
        lumpSumLoss: {
            get: function get() {
                return this.pensionValue('lumpSumLoss');
            },
            set: function set(value) {
                var _this6 = this;

                if (!this.butForRetirementDate) {
                    this.butForRetirementDate = this.getIncomeValue('retirementDate');
                }

                this.setPension({ key: 'lumpSumLoss', value: value }).then(function () {
                    return _this6.resetLumpSum();
                });
            }
        },
        butForPensionLumpSum: {
            get: function get() {
                return this.pensionValue('butForPensionLumpSum');
            },
            set: function set(value) {
                var _this7 = this;

                this.setPension({ key: 'butForPensionLumpSum', value: value }).then(function () {
                    return _this7.setPension({ key: 'lumpSumLossValue', value: _this7.butForPensionLumpSum - _this7.pensionLumpSum || 0 });
                });
            }
        },
        pensionLumpSum: {
            get: function get() {
                return this.pensionValue('pensionLumpSum');
            },
            set: function set(value) {
                var _this8 = this;

                this.setPension({ key: 'pensionLumpSum', value: value }).then(function () {
                    return _this8.setPension({ key: 'lumpSumLossValue', value: _this8.butForPensionLumpSum - _this8.pensionLumpSum || 0 });
                });
            }
        },
        butForPensionAnnual: {
            get: function get() {
                return this.pensionValue('butForPensionAnnual');
            },
            set: function set(value) {
                var _this9 = this;

                this.setPension({ key: 'butForPensionAnnual', value: value }).then(function () {
                    return _this9.setPension({ key: 'pensionLossAnnual', value: _this9.butForPensionAnnual - _this9.pensionAnnual || 0 });
                });
            }
        },
        pensionAnnual: {
            get: function get() {
                return this.pensionValue('pensionAnnual');
            },
            set: function set(value) {
                var _this10 = this;

                this.setPension({ key: 'pensionAnnual', value: value }).then(function () {
                    return _this10.setPension({ key: 'pensionLossAnnual', value: _this10.butForPensionAnnual - _this10.pensionAnnual || 0 });
                });
            }
        },
        pensionLossAnnual: {
            get: function get() {
                return this.pensionValue('pensionLossAnnual');
            },
            set: function set(value) {
                this.setPension({ key: 'pensionLossAnnual', value: value });
            }
        },
        pensionLossMultiplier: {
            get: function get() {
                return this.pensionValue('pensionLossMultiplier');
            },
            set: function set(value) {
                this.setPension({ key: 'pensionLossMultiplier', value: value });
            }
        },
        totalLossAnnual: {
            get: function get() {
                return this.pensionValue('totalLossAnnual');
            },
            set: function set(value) {
                this.setPension({ key: 'totalLossAnnual', value: value });
            }
        },
        totalLoss: {
            get: function get() {
                return this.pensionValue('totalLoss');
            },
            set: function set(value) {
                this.setPension({ key: 'totalLoss', value: value });
            }
        },
        lifeMultiplier: {
            get: function get() {
                return this.pensionValue('lifeMultiplier');
            },
            set: function set(value) {
                this.setPension({ key: 'lifeMultiplier', value: value });
            }
        },
        discountFactor: {
            get: function get() {
                return this.pensionValue('discountFactor');
            },
            set: function set(value) {
                this.setPension({ key: 'discountFactor', value: value });
            }
        },
        multiplierToRetirement: {
            get: function get() {
                return this.pensionValue('multiplierToRetirement');
            },
            set: function set(value) {
                this.setPension({ key: 'multiplierToRetirement', value: value });
            }
        },
        longdenFactor: {
            get: function get() {
                return this.pensionValue('longdenFactor');
            },
            set: function set(value) {
                this.setPension({ key: 'longdenFactor', value: value });
            }
        },
        lumpSumLossValue: {
            get: function get() {
                return this.pensionValue('lumpSumLossValue');
            },
            set: function set(value) {
                this.setPension({ key: 'lumpSumLossValue', value: value });
            }
        },
        lumpSumLossPresentValue: {
            get: function get() {
                return this.pensionValue('lumpSumLossPresentValue');
            },
            set: function set(value) {
                this.setPension({ key: 'lumpSumLossPresentValue', value: value });
            }
        },
        pensionLossMultiplierModalPayload: function pensionLossMultiplierModalPayload() {
            return {
                pension: this.pension,
                claimant: this.claimant,
                claimInfo: this.claimInfo
            };
        },
        lumpSumMultiplierModalPayload: function lumpSumMultiplierModalPayload() {
            return {
                pension: this.pension,
                claimant: this.claimant,
                claimInfo: this.claimInfo
            };
        },
        lumpSumValid: function lumpSumValid() {
            if (this.pensionLumpSum > this.butForPensionLumpSum) {
                return false;
            }

            return true;
        },
        pensionAnnualIncomeValid: function pensionAnnualIncomeValid() {
            if (this.pensionAnnual > this.butForPensionAnnual) {
                return false;
            }

            return true;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('personal/otherFutureLosses', ['set', 'setPension', 'updatePension', 'resetLumpSum', 'resetPension']))
});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'future-purchase',
    props: {
        index: {
            type: Number,
            default: 0
        },
        purchase: {
            type: Object,
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_9_components_LifeExpectancy_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_10_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalContent_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_7_directives_TwoDecimalPlaces__["a" /* default */]
    },
    data: function data() {
        return {
            theDate: moment().format('DD/MM/YYYY')
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['value', 'purchaseValue']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo', 'getClaimantValue', 'getIncomeValue']), {
        purchaseDateValidation: {
            get: function get() {
                var mPurchaseDate = moment(this.purchase.purchaseDate, 'DD/MM/YYYY');
                var mDateOfAssessment = moment(this.getClaimInfo('dateOfAssumedSettlement'), 'DD/MM/YYYY');

                if (!mPurchaseDate.isValid() || !mDateOfAssessment.isValid()) {
                    return false;
                }

                return mPurchaseDate.isSameOrAfter(mDateOfAssessment);
            }
        },
        purchaseEndDateValidation: {
            get: function get() {
                var mPurchaseDate = moment(this.purchase.purchaseDate, 'DD/MM/YYYY');
                var mPurchaseEndDate = moment(this.purchase.purchaseEnd, 'DD/MM/YYYY');

                if (!mPurchaseDate.isValid() || !mPurchaseEndDate.isValid()) {
                    return false;
                }

                return mPurchaseDate.isBefore(mPurchaseEndDate);
            }
        },
        resaleValueValidation: {
            get: function get() {
                return this.purchase.resaleValue < this.purchase.multiplicand;
            }
        },
        updateAgeAtPurchase: function updateAgeAtPurchase() {
            if (this.purchase.purchaseDate !== null && this.purchase.purchaseDate !== '') {
                var mPurchaseDate = moment(this.purchase.purchaseDate, 'DD/MM/YYYY');
                var mDateOfBirth = moment(this.getClaimantValue('dateOfBirth'), 'DD/MM/YYYY');
                this.purchase.ageAtPurchase = mPurchaseDate.diff(mDateOfBirth, 'years', true).toFixed(2);
                this.setPurchase();
            }
        },
        updateResaleOption: function updateResaleOption() {
            if (!this.purchase.resaleOption) {
                this.purchase.resaleValue = 0;
            }
            this.setPurchase();
        },
        thePerson: function thePerson() {
            return {
                lifeExpectancy: this.value('purchasesLifeExpectancy'),
                gender: this.claimant.gender,
                dateOfBirth: this.claimant.dateOfBirth
            };
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },
        purchasePayload: function purchasePayload() {
            return {
                claimInfo: {
                    date_of_assumed_settlement: this.getClaimInfo('dateOfAssumedSettlement'),
                    discount_rate: this.getClaimInfo('discountRate'),
                    date_of_birth: this.claimant.dateOfBirth,
                    gender: this.claimant.gender
                },
                purchase: this.purchase
            };
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('personal/otherFutureLosses', ['set', 'updatePurchase', 'removePurchase', 'updateLifeForPurchases']), {
        purchaseUntilType: function purchaseUntilType() {
            if (this.purchase.purchaseUntil === 'retirement') {
                this.purchase.purchaseEnd = this.getIncomeValue('retirementDate');
            }
            if (this.purchase.purchaseUntil === 'life') {
                var lifeExpectancy = this.value('purchasesLifeExpectancy');
                this.updateLifeForPurchases({ lifeExpectancy: lifeExpectancy, index: this.index });
            }
            this.setPurchase();
        },
        updateDateOfPurchase: function updateDateOfPurchase() {
            if (!this.purchase.ageAtPurchase) {
                return;
            }

            if (this.purchase.ageAtPurchase < 0) {
                this.purchase.ageAtPurchase = 0;
                return;
            } else if (this.purchase.ageAtPurchase > 140) {
                this.purchase.ageAtPurchase = 140;
            }

            var mDateOfBirth = moment(this.getClaimantValue('dateOfBirth'), 'DD/MM/YYYY');
            this.purchase.purchaseDate = mDateOfBirth.add(this.purchase.ageAtPurchase, 'years').format('DD/MM/YYYY');
            this.setPurchase();

            this.purchase.ageAtPurchase = parseFloat(this.purchase.ageAtPurchase).toFixed(2);
        },
        updateLife: function updateLife(lifeExpectancy) {
            this.updateLifeForPurchases({ lifeExpectancy: lifeExpectancy, index: this.index });
        },
        deletePurchase: function deletePurchase() {
            this.removePurchase({ index: this.index });
        },
        setPurchase: function setPurchase() {
            this.updatePurchase({ index: this.index });
        },
        setPurchaseType: function setPurchaseType() {
            this.purchase.total = 0;
            this.purchase.discount = 0;
            this.updatePurchase({ index: this.index });
        }
    })
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FuturePurchase_vue__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FuturePurchase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__FuturePurchase_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'future-purchases',
    props: ['stepValid'],
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        futurePurchase: __WEBPACK_IMPORTED_MODULE_9__FuturePurchase_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_7_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['value', 'purchaseValue', 'purchasesTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo']), {
        futurePurchases: {
            get: function get() {
                return this.value('futurePurchases');
            },
            set: function set(value) {
                this.set({ key: 'futurePurchases', value: value });
            }
        },
        purchases: {
            get: function get() {
                return this.value('purchases');
            }
        },
        isStepValid: function isStepValid() {
            if (this.futurePurchases === false) {
                return true;
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('personal/otherFutureLosses', ['set', 'setPurchase', 'addPurchase']), {
        jsUcfirst: function jsUcfirst(string) {
            if (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
            return "";
        },
        defermentPeriod: function defermentPeriod(purchase) {
            return moment(purchase.purchaseDate, 'DD/MM/YYYY').diff(moment(this.getClaimInfo('dateOfAssumedSettlement'), 'DD/MM/YYYY'), 'Y', true).toFixed(2);
        },
        showResaleColumn: function showResaleColumn() {
            if (this.purchases.length) {
                return this.purchases.reduce(function (total, purchase) {
                    return total + purchase.resaleValue;
                }, 0) > 0;
            }
            return false;
        }
    })
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'future-services',
    props: {
        index: {
            type: Number,
            default: 0
        },
        service: {
            type: Object,
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        LifeExpectancy: __WEBPACK_IMPORTED_MODULE_6_components_LifeExpectancy_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_8_directives_TwoDecimalPlaces__["a" /* default */]
    },
    data: function data() {
        return {
            theDate: moment().format('DD/MM/YYYY')
        };
    },
    mounted: function mounted() {
        if (this.service.servicesStartDate === null) {
            this.service.servicesStartDate = this.getClaimInfo('dateOfAssumedSettlement');
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['value']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo']), {
        thePerson: function thePerson() {
            return {
                lifeExpectancy: this.value('servicesLifeExpectancy'),
                gender: this.claimant.gender,
                dateOfBirth: this.claimant.dateOfBirth
            };
        },

        servicesStartDateValidation: {
            get: function get() {
                var mStartOfService = moment(this.service.servicesStartDate, 'DD/MM/YYYY');
                var mDateOfAccident = moment(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY');

                if (!mStartOfService.isValid() || !mDateOfAccident.isValid()) {
                    return false;
                }

                return mStartOfService.isSameOrAfter(mDateOfAccident);
            }
        },
        servicesEndDateValidation: {
            get: function get() {
                var mStartOfService = moment(this.service.servicesStartDate, 'DD/MM/YYYY');
                var mEndOfService = moment(this.service.servicesEndDate, 'DD/MM/YYYY');

                if (!mStartOfService.isValid() || !mEndOfService.isValid()) {
                    return false;
                }

                return mEndOfService.isSameOrAfter(mStartOfService);
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('personal/otherFutureLosses', ['set', 'setServices', 'updateServices', 'removeService', 'updateLifeForServices']), {
        updateLife: function updateLife(lifeExpectancy) {
            this.updateLifeForServices({ lifeExpectancy: lifeExpectancy, index: this.index });
        },
        getServicesLifeExpectancy: function getServicesLifeExpectancy() {
            if (this.service.lossesForLife === true) {
                var lifeExpectancy = this.value('servicesLifeExpectancy');
                this.updateLife(lifeExpectancy);
            }
            this.updateServicePeriod();
        },
        deleteService: function deleteService() {
            this.removeService({ index: this.index });
        },
        updateServicePeriod: function updateServicePeriod() {
            this.updateServices({ index: this.index });
        },
        updateServiceEndDate: function updateServiceEndDate() {
            this.service.ageAtEndDate = moment(this.service.servicesEndDate, 'DD/MM/YYYY').diff(moment(this.claimant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
            this.updateServicePeriod();
        },
        updateServiceAge: function updateServiceAge() {
            this.service.servicesEndDate = moment(this.claimant.dateOfBirth, 'DD/MM/YYYY').add(this.service.ageAtEndDate, 'y').format('DD/MM/YYYY');
            this.updateServicePeriod();
        }
    })

});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FutureService_vue__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FutureService_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__FutureService_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'future-services',
    props: ['stepValid'],
    mixins: [__WEBPACK_IMPORTED_MODULE_5_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a,
        FutureService: __WEBPACK_IMPORTED_MODULE_9__FutureService_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_10_components_IconTooltip___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_11_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_12_components_modal_ModalContent_vue___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_7_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('personal/otherFutureLosses', ['value', 'services', 'servicesTotal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo']), {
        futureLossOfServices: {
            get: function get() {
                return this.value('futureLossOfServices');
            },
            set: function set(value) {
                this.set({ key: 'futureLossOfServices', value: value });
            }
        },
        futureLossOfServicesValid: function futureLossOfServicesValid() {
            return this.services.reduce(function (valid, service) {
                return valid ? service.futureServicesTotal > 0 : false;
            }, true);
        },
        uniqueId: function uniqueId() {
            return this._uid;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('personal/otherFutureLosses', ['set', 'addService']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        toggleModal: function toggleModal(service) {
            this.toggle('calculation_' + this.uniqueId);

            this.getModalContent({
                endpoint: 'futureLossesForServices',
                payload: {
                    service: service,
                    discountRate: this.getClaimInfo('discountRate'),
                    person: {
                        gender: this.claimant.gender,
                        date_of_birth: this.claimant.dateOfBirth,
                        date_of_assumed_settlement: this.getClaimInfo('dateOfAssumedSettlement')
                    }
                }
            });
        }
    })

});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'past-loss-of-earnings-calculator',
    components: {},
    mixins: [__WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_3_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/claimant', ['getPostInjuryIncomePeriods', 'getPreAccidentNetTotal', 'getPostInjuryIncomePeriodPayments'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('personal/claimant', ['updateIncomeValue']), {
        periodPaymentsTotal: function periodPaymentsTotal(index) {
            return this.postInjuryIncomePeriodPayments(index).reduce(function (total, carry) {
                return total + carry.total;
            }, 0);
        },
        postInjuryIncomePeriodPayments: function postInjuryIncomePeriodPayments(index) {
            return this.getPostInjuryIncomePeriodPayments({ index: index });
        },
        periodDuration: function periodDuration(period) {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()(period.endOfPeriod, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true);
        },
        periodNetLoss: function periodNetLoss(period, index) {
            var duration = this.periodDuration(period);
            var preAccidentIncome = this.getPreAccidentNetTotal;
            var postAccidentIncome = period.totalNetIncome;
            var periodPayments = this.periodPaymentsTotal(index);

            return parseFloat(duration.toFixed(2)) * preAccidentIncome - parseFloat(duration.toFixed(2)) * postAccidentIncome - periodPayments;
        },
        totalNetLoss: function totalNetLoss() {
            var _this = this;

            var periods = this.getPostInjuryIncomePeriods.map(function (period, index) {
                return parseFloat(_this.periodNetLoss(period, index).toFixed(2));
            });

            var total = periods.reduce(function (total, carry) {
                return total + carry;
            }, 0);
            this.updateIncomeValue({ key: 'pastLossOfEarningsNetTotal', value: total });
            return total;
        }
    })
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_claims_dashboard_components_Icons__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_claims_dashboard_components_Icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_claims_dashboard_components_Icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PostAccidentPayments__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PostAccidentPayments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__PostAccidentPayments__);



var _watch;

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'post-accident-earnings',
    props: {
        period: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        maxIndex: {
            type: Number,
            default: 0
        }
    },
    mounted: function mounted() {
        if (this.index === 0) {
            this.period.startOfPeriod = this.getClaimInfo('dateOfInjury');
        }
    },

    watch: (_watch = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'periodLength', function periodLength() {
        this.calculatePeriodNetTotal();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'periodTotalNetIncome', function periodTotalNetIncome() {
        this.calculatePeriodNetTotal();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'periodPaymentsTotal', function periodPaymentsTotal() {
        this.calculatePeriodNetTotal();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'getPreAccidentNetTotal', function getPreAccidentNetTotal() {
        this.calculatePeriodNetTotal();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'periodTotalNetLoss', function periodTotalNetLoss() {
        this.updatePostInjuryIncomePeriod();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_watch, 'periodEmploymentIncome', function periodEmploymentIncome() {
        this.disableNetGross = false;
    }), _watch),
    data: function data() {
        return {
            loading: false,
            nodes: [],
            selectedNode: null,
            selectedNodes: [],
            toggleOne: false,
            togglePayment: false,
            toggleCalcOne: true,
            disableNetGross: false
        };
    },

    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Error___default.a,
        ControlWarning: __WEBPACK_IMPORTED_MODULE_5_components_form_control_Warning_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_7_components_IconTooltip___default.a,
        ClaimsDashboardIcons: __WEBPACK_IMPORTED_MODULE_10_pages_claims_dashboard_components_Icons___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_13_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_14_components_modal_ModalContent___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_15_components_modal_ModalInTheWild___default.a,
        PostAccidentPayments: __WEBPACK_IMPORTED_MODULE_16__PostAccidentPayments___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_9_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getClaimInfo', 'getIncomePeriod', 'getPreAccidentNetTotal', 'getPostInjuryIncomePeriods', 'getPostInjuryIncomePeriodPayments']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('modal', ['modals']), {
        periodLength: function periodLength() {
            return this.getPostInjuryIncomePeriods.length;
        },
        periodEmploymentIncome: function periodEmploymentIncome() {
            return this.period.employmentIncome;
        },
        periodTotalNetIncome: function periodTotalNetIncome() {
            return this.period.totalNetIncome;
        },
        periodTotalNetLoss: function periodTotalNetLoss() {
            return this.period.totalNetLoss;
        },
        periodPaymentsTotal: function periodPaymentsTotal() {
            return this.postInjuryIncomePeriodPayments.reduce(function (total, carry) {
                return total + carry.total;
            }, 0);
        },
        postInjuryIncomePeriodPayments: function postInjuryIncomePeriodPayments() {
            return this.getPostInjuryIncomePeriodPayments({ index: this.index });
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },
        isModalOpen: function isModalOpen() {
            var ons_salary = 'ons_salary_' + this.uniqueId;
            return this.modals && this.modals[ons_salary];
        },
        isValid: function isValid() {
            if (this.period.employmentType !== 'absence') {
                return this.period.startOfPeriod !== "" && this.period.endOfPeriod !== "" && (this.period.employmentIncome !== "" || this.period.employmentIncome !== 0) && this.period.totalNetIncome > 0;
            }
            return this.period.startOfPeriod !== "" && this.period.endOfPeriod !== "";
        },
        paymentsValid: function paymentsValid() {
            return this.postInjuryIncomePeriodPayments.reduce(function (valid, value) {
                return valid ? value.total !== 0 && value.date !== "" : false;
            }, true);
        },
        totalPaymentsReceived: function totalPaymentsReceived() {
            return this.postInjuryIncomePeriodPayments.reduce(function (carry, item) {
                return carry + parseFloat(item.total);
            }, 0);
        },
        afterEndOfPeriodRule: function afterEndOfPeriodRule() {
            return moment(this.period.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.getClaimInfo('dateOfAssumedSettlement'), 'DD/MM/YYYY'));
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('personal/claimant', ['addPostInjuryIncomePeriod', 'updateIncomePeriod', 'addPostInjuryPeriodPayment', 'deletePostInjuryPeriod', 'deleteIncomePeriod', 'updateIncomePeriodValue', 'addIncomePeriod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        updatePostInjuryIncomePeriod: function updatePostInjuryIncomePeriod() {
            if (this.period.endOfPeriod === "" || this.period.endOfPeriod === null || this.period.startOfPeriod === "" || this.period.startOfPeriod === null || this.period.employmentType === "" || this.period.employmentIncome === "" || this.period.employmentIncome === null) {
                return;
            }

            if (this.period.employmentType === 'absence') {
                this.period.employmentIncome = 0;
            }

            this.updateIncomePeriod({
                index: this.index,
                type: 'postInjury',
                period: this.period
            });

            this.updateNextPeriod();
        },
        updateNextPeriod: function updateNextPeriod() {
            var maxIndex = this.maxIndex - 1;

            if (this.index < maxIndex) {
                var nextIndex = this.index + 1;
                var nextDay = moment(this.period.endOfPeriod, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');

                this.updateIncomePeriodValue({ type: 'postInjury', index: nextIndex, key: 'startOfPeriod', value: nextDay });

                for (var i = nextIndex, len = maxIndex; i <= len; i++) {
                    var prevPeriodEndOfPeriod = '';
                    var periodEndOfPeriod = '';
                    var periodStartOfPeriod = '';

                    prevPeriodEndOfPeriod = this.getIncomePeriod({ type: 'postInjury', index: i - 1 }).endOfPeriod;
                    periodEndOfPeriod = this.getIncomePeriod({ type: 'postInjury', index: i }).endOfPeriod;
                    periodStartOfPeriod = this.getIncomePeriod({ type: 'postInjury', index: i }).startOfPeriod;

                    if (prevPeriodEndOfPeriod > periodStartOfPeriod) {
                        periodStartOfPeriod = moment(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
                        this.updateIncomePeriodValue({ type: 'postInjury', index: i, key: 'startOfPeriod', value: periodStartOfPeriod });
                    }

                    if (periodEndOfPeriod <= periodStartOfPeriod && i !== len) {
                        this.updateIncomePeriodValue({ type: 'postInjury', index: i, key: 'endOfPeriod', value: periodStartOfPeriod });
                    }
                }
            }

            if (moment(this.period.endOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.getClaimInfo('dateOfAssumedSettlement'), 'DD/MM/YYYY')) && moment(this.period.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.period.startOfPeriod, 'DD/MM/YYYY')) && this.index === maxIndex) {
                this.addIncomePeriod('postInjury');
            }
        },
        addPayment: function addPayment() {
            this.addPostInjuryPeriodPayment({
                index: this.index
            });
        },
        removePeriod: function removePeriod() {
            var maxIndex = this.maxIndex - 1;
            var prevIndex = this.index - 1;
            var nextIndex = this.index + 1;
            var nextPeriodEndOfPeriod = this.getIncomePeriod({ type: 'postInjury', index: prevIndex }).endOfPeriod;
            var nextDay = moment(nextPeriodEndOfPeriod, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');

            this.index === maxIndex ? this.updateIncomePeriodValue({ type: 'postInjury', index: prevIndex, key: 'endOfPeriod', value: this.period.endOfPeriod }) : this.updateIncomePeriodValue({ type: 'postInjury', index: nextIndex, key: 'startOfPeriod', value: nextDay });

            this.deleteIncomePeriod({ index: this.index, type: 'postInjury' });
        },
        toggleFirst: function toggleFirst() {
            this.toggleOne = !this.toggleOne;
        },
        togglePayments: function togglePayments() {
            this.togglePayment = !this.togglePayment;
        },
        openDialog: function openDialog() {
            if (!this.isModalOpen) {
                this.nodes = [];
                this.selectedNode = null;
                this.selectedNodes = [];
                return this.toggle('ons_salary_' + this.uniqueId).then(this.updateNodes);
            }
        },
        closeModal: function closeModal() {
            if (this.isModalOpen) {
                return this.toggle('ons_salary_' + this.uniqueId);
            }
        },
        updateNodes: function updateNodes() {
            var _this = this;

            var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_12_services_Api__["a" /* default */].calculators.ons.salary(this.gender, code).then(function (nodes) {
                _this.nodes = nodes;
                _this.loading = false;
            });
        },
        selectNode: function selectNode(node) {
            if (node.code.length === 4) {
                return;
            }
            this.selectedNode = node;
            this.selectedNodes.push(node);
            return this.updateNodes(node.code);
        },
        unselectNode: function unselectNode(node) {
            var index = this.selectedNodes.indexOf(node);
            if (index === 0) {
                this.selectedNodes = [];
                this.selectedNode = null;
                return this.updateNodes();
            }
            this.selectedNodes.splice(index);
            var lastIndex = this.selectedNodes.length - 1;
            this.selectedNode = this.selectedNodes[lastIndex];
            this.updateNodes(this.selectedNode.code);
        },
        selectSalary: function selectSalary(node) {
            var _this2 = this;

            if (node === null) {
                return __WEBPACK_IMPORTED_MODULE_12_services_Api__["a" /* default */].calculators.ons.averageSalary(this.claimant.gender).then(function (result) {
                    _this2.period.employmentIncome = result.value;
                    _this2.period.employmentNetGross = 'gross';
                    _this2.updatePostInjuryIncomePeriod();
                }).then(function () {
                    _this2.closeModal;
                    _this2.disableNetGross = true;
                });
            }
            this.period.employmentIncome = node.salary;
            this.updatePostInjuryIncomePeriod();
            this.closeModal();
        },
        displaySalary: function displaySalary(node) {
            if (node.salary === "x") {
                return "No Information";
            }
            return this.currencyFormat(node.salary, '£', 0);
        },
        calculatePeriodNetTotal: function calculatePeriodNetTotal() {
            var duration = moment(this.period.endOfPeriod, 'DD/MM/YYYY').diff(moment(this.period.startOfPeriod, 'DD/MM/YYYY'), 'years', true);

            this.period.totalNetLoss = duration * this.getPreAccidentNetTotal - duration * this.period.totalNetIncome - this.periodPaymentsTotal || 0;
        },
        getLastNode: function getLastNode() {
            return this.selectedNodes.slice(-1)[0];
        }
    })
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Warning_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_Warning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_Warning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__ = __webpack_require__(11);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'post-accident-earnings',
    props: {
        payment: {
            type: Object,
            required: true
        },
        paymentIndex: {
            type: Number,
            required: true
        },
        periodIndex: {
            type: Number,
            required: true
        },
        periodStart: {
            type: String,
            required: true
        },
        periodEnd: {
            type: String,
            required: true
        }
    },
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default.a,
        ControlWarning: __WEBPACK_IMPORTED_MODULE_4_components_form_control_Warning_vue___default.a,
        DateInput: __WEBPACK_IMPORTED_MODULE_5_components_form_control_DateInput_vue___default.a,
        moment: __WEBPACK_IMPORTED_MODULE_8_moment___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_components_form_validator_mixin__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_9_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/claimant', ['getClaimInfo']), {
        paymentDateInvalid: {
            get: function get() {
                if (!this.payment.date) {
                    return true;
                }

                var paymentDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.payment.date, "DD/MM/YYYY");
                var dateOfInjury = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.getClaimInfo('dateOfInjury'), "DD/MM/YYYY");

                return paymentDate.isSameOrAfter(dateOfInjury) ? false : true;
            }
        },
        paymentTotalInvalid: {
            get: function get() {
                if (!this.payment.total) {
                    return true;
                }

                return this.payment.total < 1;
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('personal/claimant', ['removePostInjuryPayment']), {
        removePayment: function removePayment() {
            this.removePostInjuryPayment({
                period: this.periodIndex,
                payment: this.paymentIndex
            });
        },
        isValid: function isValid() {
            return !this.paymentDateInvalid && this.payment.total > 0;
        },
        updateValid: function updateValid() {
            this.$emit('update', { paymentValid: this.isValid() });
        }
    })
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mixins_currencyFormat__ = __webpack_require__(6);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pre-accident-earnings',
    data: function data() {
        return {
            loading: false,
            nodes: [],
            selectedNode: null,
            selectedNodes: [],
            disableNetGross: false
        };
    },
    mounted: function mounted() {
        this.updateValid();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_mixins_currencyFormat__["a" /* default */]],
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_6_components_IconTooltip___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalContent___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_9_components_modal_ModalInTheWild___default.a
    },
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_5_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('personal/claimant', ['resetPostInjuryPeriod', 'addIncomePeriod']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('personal/claimant', ['claimant', 'getIncomeValue', 'validAbsence']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('modal', ['modals']), {

        pastLossOfEarnings: {
            get: function get() {
                return this.getIncomeValue('pastLossOfEarnings');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'pastLossOfEarnings', value: value }).then(this.updateValid);
            }
        },
        otherPayments: {
            get: function get() {
                return this.getIncomeValue('otherPayments');
            },
            set: function set(value) {
                this.updateIncomeValue({ key: 'otherPayments', value: value });
            }
        },
        pastPeriods: function pastPeriods() {
            return this.getIncomeValue('pastPeriods');
        },
        isModalOpen: function isModalOpen() {
            var ons_salary = 'ons_salary_' + this.uniqueId;
            return this.modals && this.modals[ons_salary];
        },
        uniqueId: function uniqueId() {
            return this._uid;
        },

        employmentIncome: {
            get: function get() {
                return this.getIncomeValue('preAccident').employmentIncome;
            },
            set: function set(value) {
                this.disableNetGross = false;
                this.updatePreAccidentEarningsValue({ key: 'employmentIncome', value: value }).then(this.updatePreAccidentEarnings);
                this.updateValid();
            }
        },
        employmentNetGross: {
            get: function get() {
                return this.getIncomeValue('preAccident').employmentNetGross;
            },
            set: function set(value) {
                this.updatePreAccidentEarningsValue({ key: 'employmentNetGross', value: value }).then(this.updatePreAccidentEarnings);
                this.updateValid();
            }
        },
        employmentType: {
            get: function get() {
                return this.getIncomeValue('preAccident').employmentType;
            },
            set: function set(value) {
                this.updatePreAccidentEarningsValue({ key: 'employmentType', value: value }).then(this.updatePreAccidentEarnings);
                this.updateValid();
            }
        },
        ownPastLosses: {
            get: function get() {
                return this.getIncomeValue('ownPastLosses');
            },
            set: function set(value) {
                return this.updateIncomeValue({ key: 'ownPastLosses', value: value }).then(this.updateValid);
            }
        },
        pastLossOfEarningsNetTotal: {
            get: function get() {
                return this.getIncomeValue("pastLossOfEarningsNetTotal");
            },
            set: function set(value) {
                return this.updateIncomeValue({ key: 'pastLossOfEarningsNetTotal', value: value }).then(this.updateValid);
            }
        },
        ownFutureLosses: {
            get: function get() {
                return this.getIncomeValue('ownFutureLosses');
            },
            set: function set(value) {
                return this.updateIncomeValue({ key: 'ownFutureLosses', value: value });
            }
        },
        totalNetIncome: function totalNetIncome() {
            return this.getIncomeValue('preAccident').totalNetIncome;
        },
        ownMethodValid: function ownMethodValid() {
            return this.pastLossOfEarnings === true && this.ownPastLosses && this.pastLossOfEarningsNetTotal > 0;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('personal/claimant', ['updateIncomeValue', 'updatePreAccidentEarnings', 'updatePreAccidentEarningsValue']), {
        openDialog: function openDialog() {
            if (!this.isModalOpen) {
                this.nodes = [];
                this.selectedNode = null;
                this.selectedNodes = [];
                return this.toggle('ons_salary_' + this.uniqueId).then(this.updateNodes);
            }
        },
        closeModal: function closeModal() {
            if (this.isModalOpen) {
                return this.toggle('ons_salary_' + this.uniqueId);
            }
        },
        updateNodes: function updateNodes() {
            var _this = this;

            var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_10_services_Api__["a" /* default */].calculators.ons.salary(this.gender, code).then(function (nodes) {
                _this.nodes = nodes;
                _this.loading = false;
            });
        },
        selectNode: function selectNode(node) {
            if (node.code.length === 4) {
                return;
            }
            this.selectedNode = node;
            this.selectedNodes.push(node);
            return this.updateNodes(node.code);
        },
        unselectNode: function unselectNode(node) {
            var index = this.selectedNodes.indexOf(node);
            if (index === 0) {
                this.selectedNodes = [];
                this.selectedNode = null;
                return this.updateNodes();
            }
            this.selectedNodes.splice(index);
            var lastIndex = this.selectedNodes.length - 1;
            this.selectedNode = this.selectedNodes[lastIndex];
            this.updateNodes(this.selectedNode.code);
        },
        selectSalary: function selectSalary(node) {
            var _this2 = this;

            if (node === null) {
                return __WEBPACK_IMPORTED_MODULE_10_services_Api__["a" /* default */].calculators.ons.averageSalary(this.claimant.gender).then(function (result) {
                    _this2.employmentIncome = result.value;
                    _this2.updatePreAccidentEarningsValue({ key: 'employmentNetGross', value: 'gross' });
                    _this2.disableNetGross = true;
                    _this2.updatePreAccidentEarnings();
                }).then(this.closeModal);
            }
            this.employmentIncome = node.salary;
            this.updatePreAccidentEarnings();
            this.closeModal();
        },
        displaySalary: function displaySalary(node) {
            if (node.salary === "x") {
                return "No Information";
            }
            return this.currencyFormat(node.salary, '£', 0);
        },
        isValid: function isValid() {
            if (this.ownMethodValid) {
                return true;
            }
            if (this.pastLossOfEarnings === false) {
                return true;
            }
            if (this.pastLossOfEarnings === true) {
                if (this.ownPastLosses) {
                    return this.pastLossOfEarningsNetTotal > 0;
                }
                return this.employmentIncome > 0 && (this.totalNetIncome !== 0 || this.totalNetIncome !== '');
            }
            return false;
        },
        updateValid: function updateValid() {
            this.$emit('update', {
                preAccidentEarningsValid: this.isValid(),
                preAccidentEarnings: this.pastLossOfEarnings || this.ownMethodValid
            });
        },
        getLastNode: function getLastNode() {
            return this.selectedNodes.slice(-1)[0];
        }
    })
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_SwitchButton_vue__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_SwitchButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_SwitchButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_filter_FilterOptions_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_filter_FilterOptions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_filter_FilterOptions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_OptionFilters_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_OptionFilters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_OptionFilters_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_graphs_LineChart_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_graphs_BarChart_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_graphs_ScatterChart_js__ = __webpack_require__(830);











/* harmony default export */ __webpack_exports__["default"] = ({
    components: { Control: __WEBPACK_IMPORTED_MODULE_0_components_form_Control_vue___default.a, SwitchButton: __WEBPACK_IMPORTED_MODULE_1_components_form_SwitchButton_vue___default.a, Icons: __WEBPACK_IMPORTED_MODULE_2_components_Icons_vue___default.a, FilterOptions: __WEBPACK_IMPORTED_MODULE_3_components_filter_FilterOptions_vue___default.a, OptionFilters: __WEBPACK_IMPORTED_MODULE_4_components_OptionFilters_vue___default.a, LineChart: __WEBPACK_IMPORTED_MODULE_5_components_graphs_LineChart_js__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_6_components_graphs_BarChart_js__["a" /* default */], ScatterChart: __WEBPACK_IMPORTED_MODULE_7_components_graphs_ScatterChart_js__["a" /* default */] },
    methods: {
        isRouteByName: function isRouteByName(routeName) {
            return this.$route.name == routeName;
        }
    },
    props: {
        fatalAverageReserve: {
            type: Boolean,
            default: true
        },
        fatalReserveRange: {
            type: Boolean,
            default: false
        },
        fatalNumberOfClaims: {
            type: Boolean,
            default: true
        },
        lostAverageReserve: {
            type: Boolean,
            default: true
        },
        lostReserveRange: {
            type: Boolean,
            default: true
        },
        lostNumberOfClaims: {
            type: Boolean,
            default: true
        }
    }
});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'day-one-simple',
    components: { Control: __WEBPACK_IMPORTED_MODULE_1_components_form_Control_vue___default.a, ControlError: __WEBPACK_IMPORTED_MODULE_2_components_form_control_Error_vue___default.a, FormValidator: __WEBPACK_IMPORTED_MODULE_3_components_form_validator_mixin__["a" /* default */], DateInput: __WEBPACK_IMPORTED_MODULE_4_components_form_control_DateInput_vue___default.a, HeaderSection: __WEBPACK_IMPORTED_MODULE_5_components_Header_vue___default.a },
    data: function data() {
        var currentRoute = this.$route.path;
        var selectedClaimType = '';
        if (currentRoute === '/reserving/day-one-assessment/fatal') {
            selectedClaimType = 'fatal';
        }
        if (currentRoute === '/reserving/day-one-assessment/lost') {
            selectedClaimType = 'lost';
        }
        return {
            selectedClaimType: selectedClaimType
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        route: function route() {
            if (!this.selectedClaimType) {
                return;
            }
            this.$router.push({
                name: 'reserving::day-one-assessment::' + this.selectedClaimType
            });
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('windowWidth', ['updateWidth']))
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'salary-finder',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */]],
    props: {
        gender: {
            type: String,
            default: 'male'
        }
    },
    data: function data() {
        return {
            loading: false,
            nodes: [],
            selectedNode: null,
            selectedNodes: []
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('modal', ['modals']), {
        isModalOpen: function isModalOpen() {
            return this.modals && this.modals.ons_salary;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        openDialog: function openDialog() {
            if (!this.isModalOpen) {
                this.nodes = [];
                this.selectedNode = null;
                this.selectedNodes = [];
                return this.toggle('ons_salary').then(this.updateNodes);
            }
        },
        closeModal: function closeModal() {
            if (this.isModalOpen) {
                return this.toggle('ons_salary');
            }
        },
        updateNodes: function updateNodes() {
            var _this = this;

            var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].calculators.ons.salary(this.gender, code).then(function (nodes) {
                _this.nodes = nodes;
                _this.loading = false;
            });
        },
        selectNode: function selectNode(node) {
            if (node.code.length === 4) {
                return;
            }
            this.selectedNode = node;
            this.selectedNodes.push(node);
            return this.updateNodes(node.code);
        },
        unselectNode: function unselectNode(node) {
            var index = this.selectedNodes.indexOf(node);
            if (index === 0) {
                this.selectedNodes = [];
                this.selectedNode = null;
                return this.updateNodes();
            }
            this.selectedNodes.splice(index);
            var lastIndex = this.selectedNodes.length - 1;
            this.selectedNode = this.selectedNodes[lastIndex];
            this.updateNodes(this.selectedNode.code);
        },
        selectSalary: function selectSalary(node) {
            var _this2 = this;

            if (node === null) {
                this.loading = true;
                return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].calculators.ons.averageSalary(this.gender).then(function (result) {
                    _this2.$emit('update', {
                        occupation: {
                            description: 'National Average',
                            code: 'XXX'
                        },
                        salary: result.value
                    });
                }).then(this.closeModal);
            }
            this.$emit('update', {
                occupation: {
                    description: node.description,
                    code: node.code
                },
                salary: node.salary
            });
            this.closeModal();
        },
        displaySalary: function displaySalary(node) {
            if (node.salary === "x") {
                return "No Information";
            }
            return this.currencyFormat(node.salary, '£', 0);
        },
        getLastNode: function getLastNode() {
            return this.selectedNodes.slice(-1)[0];
        }
    })
});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__(349);







var MIN_HEIGHT = 400;
var MAX_WIDTH = 1400;
var DURATION = 500;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "bell-chart",
    props: {
        chartData: {
            type: Array,
            required: true
        },
        userPercentile: {
            type: Number,
            required: true
        },
        userLabel: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            width: 0,
            height: 0,
            margin: { top: 20, right: 20, bottom: 50, left: 65 },
            xScale: null,
            yScale: null,
            svg: null,
            groups: {
                axis: {
                    x: null,
                    y: null
                },
                marks: null,
                shadedAreas: null,
                referenceLines: null
            }
        };
    },
    created: function created() {
        this.updateWidth(window.innerWidth);
    },
    mounted: function mounted() {
        this.svg = __WEBPACK_IMPORTED_MODULE_2_d3__["a" /* select */](this.$refs.svg);

        this.init();

        window.addEventListener('resize', this.reset);
    },
    destroyed: function destroyed() {
        window.removeEventListener('resize', this.reset);
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        maxClaims: function maxClaims() {
            return this.chartData.reduce(function (max, item) {
                return item > max ? item : max;
            }, 0);
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth'])),
    watch: {
        chartData: function chartData() {
            this.draw();
        },
        maxClaims: function maxClaims() {
            this.draw();
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('windowWidth', ['updateWidth']), {
        init: function init() {
            this.determineHeightAndWidth();
            this.setupScales();
            this.setupGroups();
            this.setupAxisLabels();
            this.draw();
        },
        determineHeightAndWidth: function determineHeightAndWidth() {
            var container = __WEBPACK_IMPORTED_MODULE_2_d3__["a" /* select */](this.$refs.container);
            var containerWidth = parseFloat(container.style('width').replace('px', ''));
            var containerHeight = parseFloat(container.style('height').replace('px', ''));

            this.width = Math.min(MAX_WIDTH, isNaN(containerWidth) ? 500 : containerWidth);
            if (this.theCurrentWidth > 1024) {
                this.height = Math.max(MIN_HEIGHT, isNaN(containerHeight) ? 0 : containerHeight);
            } else {
                this.height = 300;
            }
        },
        setupScales: function setupScales() {
            this.xScale = __WEBPACK_IMPORTED_MODULE_2_d3__["b" /* scaleLinear */]().range([0, this.width - this.margin.left - this.margin.right]).domain([0, 100]);
            this.yScale = __WEBPACK_IMPORTED_MODULE_2_d3__["b" /* scaleLinear */]().range([this.height - this.margin.top - this.margin.bottom, 0]);
            this.applyDomainToScale();
        },
        applyDomainToScale: function applyDomainToScale() {
            this.yScale.domain([0, this.maxClaims + 1]);
        },
        setupGroups: function setupGroups() {
            this.svg.selectAll('g').remove();
            this.groups.axis.x = this.svg.append('g').attr("transform", "translate(" + this.margin.left + "," + (this.height - this.margin.bottom) + ")").attr('class', 'x axis');
            this.groups.axis.y = this.svg.append('g').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")").attr('class', 'y axis');
            this.groups.backgroundShading = this.svg.append('g').attr('class', 'background-shading').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
            this.groups.shadedAreas = this.svg.append('g').attr('class', 'shaded-areas').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
            this.groups.marks = this.svg.append('g').attr('class', 'marks').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
            this.groups.referenceLines = this.svg.append('g').attr('class', 'reference-lines').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
        },
        setupAxisLabels: function setupAxisLabels() {
            this.svg.append('g').attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")").attr('class', 'y axis-label').append('text').attr("transform", "rotate(-90)").attr("y", 0 - this.margin.left / 2).attr("x", 0 - this.height / 2).text("Number of Claims");
            this.svg.append('g').attr("transform", "translate(0," + (this.height - this.margin.bottom) + ")").attr('class', 'x axis-label').append('text').style("text-anchor", "middle").attr("y", this.margin.bottom).attr("x", this.width / 2).text("Percentile");
        },
        reset: function reset() {
            this.groups.axis.x.remove();
            this.groups.axis.y.remove();
            this.groups.marks.remove();
            this.groups.shadedAreas.remove();
            this.groups.referenceLines.remove();
            if (this.$refs && this.$refs.container) {
                this.init();
            }
        },
        draw: function draw() {
            this.drawAxis();
            this.drawBackGroundShading();
            this.drawLine();
            this.drawShadedAreas();
            this.drawReferenceLines();
        },
        drawAxis: function drawAxis() {
            this.applyDomainToScale();
            var xGroup = this.groups.axis.x;
            var yGroup = this.groups.axis.y;
            xGroup.transition().duration(DURATION).call(__WEBPACK_IMPORTED_MODULE_2_d3__["e" /* axisBottom */](this.xScale).tickFormat(function (d) {
                return __WEBPACK_IMPORTED_MODULE_2_d3__["d" /* format */]("0")(d) + '%';
            }));
            yGroup.transition().duration(DURATION).call(__WEBPACK_IMPORTED_MODULE_2_d3__["f" /* axisLeft */](this.yScale).tickFormat(function (d) {
                return Math.floor(d) !== d ? null : d;
            }));
        },
        drawLine: function drawLine() {
            var _this = this;

            this.applyDomainToScale();
            var lineValue = __WEBPACK_IMPORTED_MODULE_2_d3__["g" /* line */]().x(function (d, i) {
                return _this.xScale(i);
            }).y(this.yScale).curve(__WEBPACK_IMPORTED_MODULE_2_d3__["i" /* curveMonotoneX */]);
            var lineZero = __WEBPACK_IMPORTED_MODULE_2_d3__["g" /* line */]().x(function (d, i) {
                return _this.xScale(i);
            }).y(function () {
                return _this.yScale(0);
            }).curve(__WEBPACK_IMPORTED_MODULE_2_d3__["i" /* curveMonotoneX */]);

            var line = this.groups.marks.selectAll('.mark-line').data([this.chartData]);

            line.enter().append('path').attr('class', 'line mark-line').attr('d', lineZero).transition().duration(DURATION).attr('d', lineValue);

            line.transition().duration(DURATION).attr('d', lineValue);

            line.exit().remove();
        },
        drawBackGroundShading: function drawBackGroundShading() {
            var _this2 = this;

            var drawRectangle = function drawRectangle(className, start, end) {
                _this2.groups.backgroundShading.append('rect').attr("class", className).attr('x', _this2.xScale(start)).attr('y', _this2.yScale(_this2.maxClaims + 1)).attr('height', _this2.yScale(0) - _this2.yScale(_this2.maxClaims + 1)).attr('width', _this2.xScale(end) - _this2.xScale(start));
            };
            this.groups.backgroundShading.selectAll('rect').remove();
            drawRectangle('lower-percentile', 0, 25);
            drawRectangle('mid-percentile', 25, 75);
            drawRectangle('upper-percentile', 75, 100);
        },
        drawShadedAreas: function drawShadedAreas() {
            var _this3 = this;

            var areaValue = __WEBPACK_IMPORTED_MODULE_2_d3__["j" /* area */]().x(function (d, i) {
                return _this3.xScale(i);
            }).y0(this.yScale(0)).y1(this.yScale).curve(__WEBPACK_IMPORTED_MODULE_2_d3__["i" /* curveMonotoneX */]);
            var areaZero = __WEBPACK_IMPORTED_MODULE_2_d3__["j" /* area */]().x(function (d, i) {
                return _this3.xScale(i);
            }).y0(this.yScale(0)).y1(this.yScale(0)).curve(__WEBPACK_IMPORTED_MODULE_2_d3__["i" /* curveMonotoneX */]);

            var lowerQuarterShade = this.groups.shadedAreas.selectAll('.quartile-lower').data([this.chartData.slice(0, 26)]);
            var midQuarterShade = this.groups.shadedAreas.selectAll('.quartile-mid').data([Array(25).fill(0).concat(this.chartData.slice(25, 76))]);
            var upperQuarterShade = this.groups.shadedAreas.selectAll('.quartile-upper').data([Array(75).fill(0).concat(this.chartData.slice(75))]);

            var drawArea = function drawArea(area, className) {
                area.enter().append('path').attr('class', 'line ' + className).attr('d', areaZero).transition().duration(DURATION).attr('d', areaValue);

                area.transition().duration(DURATION).attr('d', areaValue);

                area.exit().remove();
            };

            drawArea(lowerQuarterShade, 'quartile-lower');
            drawArea(midQuarterShade, 'quartile-mid');
            drawArea(upperQuarterShade, 'quartile-upper');
        },
        drawReferenceLines: function drawReferenceLines() {
            var _this4 = this;

            var lineZero = __WEBPACK_IMPORTED_MODULE_2_d3__["j" /* area */]().x(this.xScale(0)).y0(this.yScale(0)).y1(this.yScale(this.maxClaims + 1));
            var lineValue = __WEBPACK_IMPORTED_MODULE_2_d3__["j" /* area */]().x(this.xScale).y0(this.yScale(0)).y1(this.yScale(this.maxClaims + 1));

            var drawLine = function drawLine(className, data) {
                var line = _this4.groups.referenceLines.selectAll('.' + className).data([[data]]);
                line.enter().append("path").attr("class", className).attr("d", lineZero).transition().duration(DURATION).attr("d", lineValue);
                line.transition().duration(DURATION).attr('d', lineValue);
                line.exit().remove();
            };

            drawLine('lower-percentile', 25);
            drawLine('user-percentile', this.userPercentile);
            drawLine('upper-percentile', 75);

            var text = this.groups.referenceLines.selectAll('text').data([[this.userPercentile]]);

            var adjustLeft = 5;
            var adjustRight = -15;
            var adjust = function () {
                if (_this4.userPercentile > 20 && _this4.userPercentile < 25) {
                    return adjustLeft;
                }

                if (_this4.userPercentile > 75 && _this4.userPercentile < 80) {
                    return adjustRight;
                }
                return _this4.userPercentile > 50 ? adjustLeft : adjustRight;
            }();

            text.enter().append('text').attr('class', 'label-text').data([this.userPercentile]).attr("transform", "rotate(-90)").attr("x", 0 - this.height / 2 - 30).attr("y", 0 - this.margin.left / 2).text("Your claim: " + this.userLabel + ' percentile').transition().duration(DURATION).attr('y', this.xScale(this.userPercentile) - adjust);
            text.text("Your claim: " + this.userLabel + ' percentile').transition().duration(DURATION).attr('y', this.xScale(this.userPercentile) - adjust);
        }
    })
});

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'calculation-modal',
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_2_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent___default.a
    },
    props: {
        name: {
            required: true,
            type: String
        },
        type: {
            required: true,
            type: String,
            default: 'lost'
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('reserves/dayOneFatal', {
        fatalModal: 'modalPayload'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('reserves/dayOneLost', {
        lostModal: 'modalPayload'
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle', 'getModalContent']), {
        toggleModal: function toggleModal() {
            this.toggle('calculation_modal');
            this.getModalContent({ endpoint: this.name, payload: { args: this.type === 'lost' ? this.lostModal : this.fatalModal } });
        }
    })
});

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'own-head-of-loss',
    props: {
        headOfLoss: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            default: 'fatal'
        }
    },
    computed: {
        name: {
            get: function get() {
                return this.headOfLoss.name;
            },
            set: function set(value) {
                if (this.type === 'fatal') {
                    return this.updateFatalHeadOfLoss({
                        key: 'name',
                        index: this.index,
                        value: value
                    });
                }
                return this.updateLostHeadOfLoss({
                    key: 'name',
                    index: this.index,
                    value: value
                });
            }
        },
        amount: {
            get: function get() {
                return this.headOfLoss.value;
            },
            set: function set(value) {
                if (this.type === 'fatal') {
                    return this.updateFatalHeadOfLoss({
                        key: 'value',
                        index: this.index,
                        value: value
                    });
                }
                return this.updateLostHeadOfLoss({
                    key: 'value',
                    index: this.index,
                    value: value
                });
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('reserves/dayOneFatal', {
        updateFatalHeadOfLoss: 'updateHeadOfLoss',
        deleteFatalHeadOfLoss: 'deleteHeadOfLoss'
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('reserves/dayOneLost', {
        updateLostHeadOfLoss: 'updateHeadOfLoss',
        deleteLostHeadOfLoss: 'deleteHeadOfLoss'
    }), {
        remove: function remove() {
            if (this.type === 'fatal') {
                return this.deleteFatalHeadOfLoss(this.index);
            }
            return this.deleteLostHeadOfLoss(this.index);
        }
    })

});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_graphs_BarChart__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BellChart__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BellChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__BellChart__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'reserve-performance-chart',
    components: {
        BellChart: __WEBPACK_IMPORTED_MODULE_9__BellChart___default.a,
        BarChart: __WEBPACK_IMPORTED_MODULE_3_components_graphs_BarChart__["a" /* default */],
        Control: __WEBPACK_IMPORTED_MODULE_4_components_form_Control___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_7_components_modal_Modal___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_8_components_modal_ModalInTheWild___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_roundValue__["a" /* default */]],
    data: function data() {
        return {
            chartType: 'all_claims',
            filterAttr: 'combined'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('reserves/dayOneFatal', ['chartData', 'totalReserve', 'apportionedClaimantReserve', 'apportionedDefenceReserve', 'apportionedDamagesReserve', 'noChartData']), {
        forChart: function forChart() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(this.chartData.groups[this.chartType].data[this.filterAttr]);
        },
        minPercentileLabel: function minPercentileLabel() {
            return this.currencyFormat(this.scaleMin, "£", 0) + " to " + this.currencyFormat(this.scaleMin + (this.scaleMax - this.scaleMin) * 0.25, "£", 0);
        },
        midPercentileLabel: function midPercentileLabel() {
            return this.currencyFormat(this.scaleMin + (this.scaleMax - this.scaleMin) * 0.25, "£", 0) + " to " + this.currencyFormat(this.scaleMin + (this.scaleMax - this.scaleMin) * 0.75, "£", 0);
        },
        maxPercentileLabel: function maxPercentileLabel() {
            return this.currencyFormat(this.scaleMin + (this.scaleMax - this.scaleMin) * 0.75, "£", 0) + " to " + this.currencyFormat(this.scaleMax, "£", 0);
        },
        userValue: function userValue() {
            switch (this.filterAttr) {
                case "combined":
                    return this.totalReserve;
                case 'damages':
                    return this.apportionedDamagesReserve;
                case "claimant-costs":
                    return this.apportionedClaimantReserve;
                case "defence-costs":
                    return this.apportionedDefenceReserve;
            }
        },
        userPercentile: function userPercentile() {
            var group = this.chartData.groups[this.chartType];
            if (!group) {
                return null;
            }
            var min = this.scaleMin;
            var max = this.scaleMax;
            if (this.userValue > max) {
                return 100;
            }
            if (this.userValue < min) {
                return 0;
            }
            var range = max - min;
            var diff = this.userValue - min;
            return Math.round(diff / range * 100);
        },
        scaleMin: function scaleMin() {
            return this.chartData.groups[this.chartType].min[this.filterAttr];
        },
        scaleMax: function scaleMax() {
            return this.chartData.groups[this.chartType].max[this.filterAttr];
        },
        chartTypes: function chartTypes() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.chain(this.chartData.groups).keys().keyBy(function (key) {
                return key;
            }).mapValues(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startCase).value();
        },
        filterTypes: function filterTypes() {
            return this.chartData.filters;
        }
    }),
    methods: {
        ordinalSuffixOf: function ordinalSuffixOf(i) {
            var j = i % 10,
                k = i % 100;
            if (j == 1 && k != 11) {
                return i + "st";
            }
            if (j == 2 && k != 12) {
                return i + "nd";
            }
            if (j == 3 && k != 13) {
                return i + "rd";
            }
            return i + "th";
        }
    }
});

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_Table__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Typeahead__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Typeahead__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: "day-one-save",
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild___default.a,
        ClaimTable: __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_Table___default.a,
        Typeahead: __WEBPACK_IMPORTED_MODULE_9_components_Typeahead___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__["a" /* default */]],
    data: function data() {
        return {
            showErrorMessage: false,
            showList: false,
            claim: false,
            isSaving: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('reserves/dayOneFatal', ['isValidForSave', 'exists', 'estateOrDependency', 'claimType']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        claimantName: {
            get: function get() {
                return this.getValue('claimantName');
            },
            set: function set(value) {
                this.updateValue({ key: 'claimantName', value: value });
                this.updateValid();
            }
        },
        claimantSolicitors: {
            get: function get() {
                return this.getValue('claimantSolicitors');
            }
        },
        claimantReference: {
            get: function get() {
                return this.getValue('claimantReference');
            },
            set: function set(value) {
                this.updateValue({ key: 'claimantReference', value: value });
                this.updateValid();
            }
        },
        yourReference: {
            get: function get() {
                return this.getValue('yourReference');
            },
            set: function set(value) {
                this.updateValue({ key: 'yourReference', value: value });
                this.updateValid();
            }
        },
        defendantName: {
            get: function get() {
                return this.getValue('defendantName');
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('reserves/dayOneFatal', ['updateValue', 'save', 'openAsClaim']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('claim', ['load']), {
        getValue: function getValue(attr) {
            return this.$store.getters['reserves/dayOneFatal/' + attr];
        },
        cancel: function cancel() {
            this.toggle('save_day_one_fatal');
        },
        updateValid: function updateValid() {
            var validForSave = this.$valid() && this.isValidForSave;
            this.showErrorMessage = !validForSave;

            return validForSave;
        },
        doSave: function doSave() {
            var _this = this;

            if (this.updateValid()) {
                this.isSaving = true;

                this.save().then(function () {
                    _this.isSaving = false;
                });
            }
        },
        routeToClaim: function routeToClaim() {
            var _this2 = this;

            this.openAsClaim().then(function (claimId) {
                var route = '/fatal-accidents/' + claimId + '/' + _this2.estateOrDependency + '/claim-data';
                return _this2.$router.push(route);
            });
        },
        getClaimType: function getClaimType() {
            if (this.claimType === 'fatal_accident') {
                return this.claimType + '_' + this.estateOrDependency;
            }

            return this.claimType;
        },
        toggleClaimList: function toggleClaimList() {
            this.showList = !this.showList;
        },
        attachToClaim: function attachToClaim(claim) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.updateValue({ key: 'claimantName', value: claim.claimant_name }), this.updateValue({ key: 'claimantSolicitors', value: {
                    id: claim.claimant_solicitor_id,
                    name: claim.claimant_solicitor,
                    type: 'claimant_solicitor'
                } }), this.updateValue({ key: 'claimantReference', value: claim.claimant_reference }), this.updateValue({ key: 'yourReference', value: claim.your_reference }), this.updateValue({ key: 'defendantName', value: {
                    id: claim.defendant_id,
                    name: claim.defendant_name,
                    type: 'defendant'
                } })]).then(function () {
                return _this3.save(claim.id);
            }).then(function () {
                return _this3.claim = claim;
            }).then(function () {
                return _this3.showList = false;
            });
        },
        openSummaryDocument: function openSummaryDocument() {
            window.open('/api/v1/day-one-summary/pdf/' + this.getValue('claimId') + '?access_token=' + this.getToken);
        },
        updateClaimantSolicitors: function updateClaimantSolicitors(value) {
            this.updateValue({ key: 'claimantSolicitors', value: value });
            this.updateValid();
        },
        updateDefendant: function updateDefendant(value) {
            this.updateValue({ key: 'defendantName', value: value });
            this.updateValid();
        }
    })
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_reserving_components_SalaryFinder__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_reserving_components_SalaryFinder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_reserving_components_SalaryFinder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'day-one-fatal',
    components: { Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a, ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a, FormValidator: __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], DateInput: __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default.a, SalaryFinder: __WEBPACK_IMPORTED_MODULE_7_pages_reserving_components_SalaryFinder___default.a },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__["a" /* default */]],
    mounted: function mounted() {
        this.reset();
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('reserves/dayOneFatal', ['isValid', 'formDirty']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        diseaseOrAccident: {
            get: function get() {
                return this.getValue('diseaseOrAccident');
            },
            set: function set(value) {
                return this.updateValue({ key: 'diseaseOrAccident', value: value });
            }
        },
        diseaseType: {
            get: function get() {
                return this.getValue('diseaseType');
            },
            set: function set(value) {
                this.updateValue({ key: 'accidentType', value: null });
                return this.updateValue({ key: 'diseaseType', value: value });
            }
        },
        accidentType: {
            get: function get() {
                return this.getValue('accidentType');
            },
            set: function set(value) {
                this.updateValue({ key: 'diseaseType', value: null });
                return this.updateValue({ key: 'accidentType', value: value });
            }
        },
        estateOrDependency: {
            get: function get() {
                return this.getValue('estateOrDependency');
            },
            set: function set(value) {
                console.log(value);
                return this.updateValue({ key: 'estateOrDependency', value: value });
            }
        },
        gender: {
            get: function get() {
                return this.getValue('gender');
            },
            set: function set(value) {
                return this.updateValue({ key: 'gender', value: value });
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.getValue('dateOfBirth');
            },
            set: function set(value) {
                return this.updateValue({ key: 'dateOfBirth', value: value });
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.getValue('dateOfDeath');
            },
            set: function set(value) {
                return this.updateValue({ key: 'dateOfDeath', value: value });
            }
        },
        ageAtDeath: {
            get: function get() {
                return this.getValue('ageAtDeath');
            },
            set: function set(value) {
                return this.updateValue({ key: 'ageAtDeath', value: value });
            }
        },
        assumedSettlement: {
            get: function get() {
                return this.getValue('assumedSettlement');
            },
            set: function set(value) {
                return this.updateValue({ key: 'assumedSettlement', value: value });
            }
        },
        employmentType: {
            get: function get() {
                return this.getValue('employmentType');
            },
            set: function set(value) {
                return this.updateValue({ key: 'employmentType', value: value });
            }
        },
        onsetOfSymptoms: {
            get: function get() {
                return this.getValue('onsetOfSymptoms');
            },
            set: function set(value) {
                return this.updateValue({ key: 'onsetOfSymptoms', value: value });
            }
        },
        proceduralStatus: {
            get: function get() {
                return this.getValue('proceduralStatus');
            },
            set: function set(value) {
                return this.updateValue({ key: 'proceduralStatus', value: value });
            }
        },
        numberOfDependants: {
            get: function get() {
                return this.getValue('numberOfDependants');
            },
            set: function set(value) {
                return this.updateValue({ key: 'numberOfDependants', value: value });
            }
        },
        dobRules: function dobRules() {
            return {
                type: "date",
                rules: 'max:' + __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('DD/MM/YYYY')
            };
        },
        dodRules: function dodRules() {
            return {
                type: "date",
                rules: 'min:' + this.dateOfBirth
            };
        },
        assumedRules: function assumedRules() {
            return {
                type: "date",
                rules: 'min:' + this.dateOfDeath
            };
        },
        oSoSRules: function oSoSRules() {
            return {
                type: "date",
                rules: 'max:' + this.dateOfDeath
            };
        },
        occupation: function occupation() {
            return this.getValue('occupation');
        },

        salary: {
            get: function get() {
                return this.getValue('salary');
            },
            set: function set(value) {
                return this.updateValue({ key: 'salary', value: value });
            }
        }
    }),
    data: function data() {
        return {
            showErrorMessage: false
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('reserves/dayOneFatal', ['updateValue', 'performCalculation', 'reset']), {
        getValue: function getValue(attr) {
            return this.$store.getters['reserves/dayOneFatal/' + attr];
        },
        calculate: function calculate() {
            this.showErrorMessage = !this.isValid || !this.$valid();
            if (!this.showErrorMessage) {
                var assignColumnOne = document.querySelector('.c-split-screen__column-one');

                var elementBounding = assignColumnOne.getBoundingClientRect();
                if (this.theCurrentWidth <= 1024) {
                    window.scrollTo(0, elementBounding.height + 108);
                } else {
                    window.scrollTo(0, 0);
                }

                this.performCalculation();
            }
        },
        updateSalary: function updateSalary(value) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.updateValue({ key: 'occupation', value: value.occupation }), this.updateValue({ key: 'salary', value: value.salary })]);
        }
    })
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_Accordion__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_accordion_Accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordian_content__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_graphs_BarChart__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CalculationModal__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CalculationModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CalculationModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DayOneSave__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DayOneSave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DayOneSave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OwnHeadOfLoss__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OwnHeadOfLoss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__OwnHeadOfLoss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__accordian_content_PslaModalContent__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__accordian_content_PslaModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__accordian_content_PslaModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ReservePerformanceChart__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ReservePerformanceChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ReservePerformanceChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__BellChart__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__BellChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__BellChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_directives_TwoDecimalPlaces__ = __webpack_require__(11);























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'day-one-fatal-results',
    components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__accordian_content__["a" /* default */], {
        BellChart: __WEBPACK_IMPORTED_MODULE_18__BellChart___default.a,
        Accordion: __WEBPACK_IMPORTED_MODULE_1_components_accordion_Accordion___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem___default.a,
        BarChart: __WEBPACK_IMPORTED_MODULE_4_components_graphs_BarChart__["a" /* default */],
        CalculationModal: __WEBPACK_IMPORTED_MODULE_5__CalculationModal___default.a,
        DayOneSave: __WEBPACK_IMPORTED_MODULE_7__DayOneSave___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild___default.a,
        PslaModalContent: __WEBPACK_IMPORTED_MODULE_14__accordian_content_PslaModalContent___default.a,
        OwnHeadOfLoss: __WEBPACK_IMPORTED_MODULE_13__OwnHeadOfLoss___default.a,
        ReservePerformanceChart: __WEBPACK_IMPORTED_MODULE_15__ReservePerformanceChart___default.a
    }),
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_19_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["a" /* mapGetters */])('reserves/dayOneFatal', ['hasResults', 'results', 'ageAtDeath', 'ageAtAssessment', 'claimantContribution', 'defenceContribution', 'damagesContribution', 'apportionedClaimantReserve', 'apportionedDefenceReserve', 'apportionedDamagesReserve', 'totalReserve', 'chartData', 'gender', 'durationOfSymptoms', 'dateOfDeath', 'ownHeadsOfLoss', 'totalDamages', 'estateOrDependency', 'exists', 'calculating', 'claimId', 'employmentType', 'dateOfBirth', 'modalPayload', 'diseaseType', 'ageAtDeath', 'defenceCosts', 'claimantCosts', 'dirtyForm']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), {
        retirementAge: function retirementAge() {
            return this.roundValue(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.results.calculation.retirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.dateOfBirth, 'DD/MM/YYYY'), 'years', true), 2);
        },

        generalDamages: {
            get: function get() {
                return this.results.damages.generalDamages;
            },
            set: function set(value) {
                return this.updateValue({
                    key: 'generalDamages',
                    value: value
                });
            }
        }
    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16_mixins_roundValue__["a" /* default */]],
    data: function data() {
        return {
            assumptions: false
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('reserves/dayOneFatal', ['updateValue', 'save', 'addHeadOfLoss']), {
        updateClaimantContribution: function updateClaimantContribution(event) {
            var value = parseFloat(event.target.value);
            value = this._smoothPercentile(value);
            return this.updateValue({
                key: 'claimantContribution',
                value: value
            });
        },
        updateDefenceContribution: function updateDefenceContribution(event) {
            var value = parseFloat(event.target.value);
            value = this._smoothPercentile(value);
            return this.updateValue({
                key: 'defenceContribution',
                value: value
            });
        },
        updateDamagesContribution: function updateDamagesContribution(event) {
            var value = parseFloat(event.target.value);
            value = this._smoothPercentile(value);
            return this.updateValue({
                key: 'damagesContribution',
                value: value
            });
        },
        updateClaimantCosts: function updateClaimantCosts(event) {
            var value = parseFloat(event.target.value);
            return this.updateValue({
                key: 'claimantCosts',
                value: value
            });
        },
        updateDefenceCosts: function updateDefenceCosts(event) {
            var value = parseFloat(event.target.value);
            return this.updateValue({
                key: 'defenceCosts',
                value: value
            });
        },
        openSummaryDocument: function openSummaryDocument() {
            window.open('/api/v1/day-one-summary/pdf/' + this.claimId + '?access_token=' + this.getToken);
        },

        _smoothPercentile: function _smoothPercentile(value) {
            if (value > 100) {
                value = 100;
            }
            if (value < 0) {
                value = 0;
            }
            return value;
        }
    })
});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "bereavement-award-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_1_components_modal_ModalContent___default.a
    },

    props: {
        person: {
            type: Object,
            required: true
        },
        value: {
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */]],
    created: function created() {
        this.load();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('modal', ['getModalContent']), {
        load: function load() {
            this.getModalContent({
                endpoint: 'dayOneBereavementAward',
                payload: {
                    args: { person: this.person, claim: { type: 'fatal_accident_dependency' } }
                }
            });
        }
    })
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "care-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__["a" /* default */]],
    props: {
        person: {
            type: Object,
            required: true
        },
        claim: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        value: {
            required: true
        }
    },
    created: function created() {
        this.load();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('modal', ['getModalContent']), {
        load: function load() {
            this.getModalContent({
                endpoint: 'dayOneCostOfCare',
                payload: {
                    args: { person: this.person, claim: this.claim, dependency_type: this.type }
                }
            });
        }
    })
});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "dependency-income-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "dependency-services-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "funeral-expenses-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "misc-modal",
    props: {
        value: {
            required: true
        },
        dateOfDeath: {
            type: String
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "past-loss-earnings-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "past-services-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_0_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Heading__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Paragraph__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PslaModalContent__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PslaModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PslaModalContent__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: "psla-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild___default.a,
        Heading: __WEBPACK_IMPORTED_MODULE_3_components_modal_Heading___default.a,
        Paragraph: __WEBPACK_IMPORTED_MODULE_4_components_modal_Paragraph___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip___default.a,
        PslaModalContent: __WEBPACK_IMPORTED_MODULE_9__PslaModalContent___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */]],
    props: {
        duration: {
            type: Number,
            required: true
        },
        age: {
            required: true
        },
        value: {
            required: true
        }
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            table: {}
        };
    },

    computed: {
        tableResults: function tableResults() {
            if (!this.table[50]) {
                return [];
            }
            var startRowIndex = this.ageIndex < 60 ? 0 : this.ageIndex > 80 ? 80 : this.ageIndex - 5;

            var startColumnIndex = this.columnIndexStart;
            var endColumnIndex = this.columnIndexEnd;

            return [this.table[startRowIndex].slice(startColumnIndex, endColumnIndex), this.table[startRowIndex + 5].slice(startColumnIndex, endColumnIndex), this.table[startRowIndex + 10].slice(startColumnIndex, endColumnIndex)];
        },
        columnIndexStart: function columnIndexStart() {
            if (this.durationIndex < 2) {
                return 0;
            }
            if (this.durationIndex === 12) {
                return this.durationIndex - 2;
            }
            return this.durationIndex - 1;
        },
        columnIndexEnd: function columnIndexEnd() {
            if (this.durationIndex === 0) {
                return this.durationIndex + 3;
            }
            return this.durationIndex + 2;
        },
        ageIndex: function ageIndex() {
            var age = parseFloat(this.age);
            if (age < 50) {
                return 50;
            }
            if (age > 90) {
                return 90;
            }
            return Math.ceil(age / 5) * 5;
        },
        ageLabels: function ageLabels() {
            return this.ageIndex < 60 ? [50, 55, 60] : this.ageIndex > 80 ? [80, 85, 90] : [this.ageIndex - 5, this.ageIndex, this.ageIndex + 5];
        },
        durationIndex: function durationIndex() {
            if (this.duration < 3) {
                return 0;
            }
            if (this.duration > 36) {
                return 12;
            }
            return Math.floor(this.duration / 3) - 1;
        },
        durationLabels: function durationLabels() {
            return this.durationIndex < 2 ? ["0-3", "4-6", "7-9"] : this.durationIndex > 9 ? ["31-33", "34-36", "37+"] : [(this.durationIndex - 1) * 3 - 2 + "-" + (this.durationIndex - 1) * 3, this.durationIndex * 3 - 2 + "-" + this.durationIndex * 3, (this.durationIndex + 1) * 3 - 2 + "-" + (this.durationIndex + 1) * 3];
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('psla', ['loadTable']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        init: function init() {
            var _this = this;

            this.loadTable().then(function (table) {
                return _this.table = table;
            });
        },
        toggleThis: function toggleThis() {
            this.toggle('day-one-res-psla');
        },
        calcCellStyle: function calcCellStyle(rowIndex, cellIndex) {
            if (this.durationIndex === 0) {
                if (rowIndex === 1 && cellIndex === 0) {
                    return 'background:#9f9';
                }
                if (rowIndex === 1 || cellIndex === 0) {
                    return 'background:#efe';
                }
            }

            if (this.durationIndex === 12) {
                if (rowIndex === 1 && cellIndex === 2) {
                    return 'background:#9f9';
                }
                if (rowIndex === 1 || cellIndex === 2) {
                    return 'background:#efe';
                }
            }

            if (this.durationIndex > 0 && this.durationIndex < 12) {
                if (rowIndex === 1 && cellIndex === 1) {
                    return 'background:#9f9';
                }
                if (rowIndex === 1 || cellIndex === 1) {
                    return 'background:#efe';
                }
            }

            return '';
        }
    })
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_modal_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem__);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: "psla-modal-content",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild___default.a,
        Heading: __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading___default.a,
        Paragraph: __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_1_components_IconTooltip_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */]],
    props: {
        duration: {
            type: Number,
            required: true
        },
        age: {
            required: true
        },
        value: {
            required: true
        }
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            table: {}
        };
    },

    computed: {
        tableResults: function tableResults() {
            if (!this.table[50]) {
                return [];
            }
            var startRowIndex = this.ageIndex <= 50 ? 50 : this.ageIndex > 80 ? 80 : this.ageIndex - 5;

            var startColumnIndex = this.columnIndexStart;
            var endColumnIndex = this.columnIndexEnd;

            return [this.table[startRowIndex].slice(startColumnIndex, endColumnIndex), this.table[startRowIndex + 5].slice(startColumnIndex, endColumnIndex), this.table[startRowIndex + 10].slice(startColumnIndex, endColumnIndex)];
        },
        columnIndexStart: function columnIndexStart() {
            if (this.durationIndex < 2) {
                return 0;
            }
            if (this.durationIndex === 12) {
                return this.durationIndex - 2;
            }
            return this.durationIndex - 1;
        },
        columnIndexEnd: function columnIndexEnd() {
            if (this.durationIndex === 0) {
                return this.durationIndex + 3;
            }
            if (this.durationIndex === 12) {
                return this.durationIndex + 1;
            }
            return this.durationIndex + 2;
        },
        ageIndex: function ageIndex() {
            var age = parseFloat(this.age);
            if (age < 50) {
                return 50;
            }
            if (age > 90) {
                return 90;
            }
            return Math.ceil(age / 5) * 5;
        },
        ageLabels: function ageLabels() {
            return this.ageIndex < 60 ? [50, 55, 60] : this.ageIndex > 80 ? [80, 85, 90] : [this.ageIndex - 5, this.ageIndex, this.ageIndex + 5];
        },
        durationIndex: function durationIndex() {
            if (this.duration < 3) {
                return 0;
            }
            if (this.duration > 36) {
                return 12;
            }
            return Math.floor(this.duration / 3);
        },
        durationLabels: function durationLabels() {
            return this.durationIndex < 2 ? ["0-3", "4-6", "7-9"] : this.durationIndex > 9 ? ["31-33", "34-36", "37+"] : [this.durationIndex * 3 - 2 + "-" + this.durationIndex * 3, (this.durationIndex + 1) * 3 - 2 + "-" + (this.durationIndex + 1) * 3, (this.durationIndex + 2) * 3 - 2 + "-" + (this.durationIndex + 2) * 3];
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('psla', ['loadTable']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        init: function init() {
            var _this = this;

            this.loadTable().then(function (table) {
                return _this.table = table;
            });
        },
        toggleThis: function toggleThis() {
            this.toggle('day-one-res-psla');
        },
        calcCellStyle: function calcCellStyle(rowIndex, cellIndex) {
            if (this.durationIndex === 0) {
                if (rowIndex === 1 && cellIndex === 0) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 1 || cellIndex === 0) {
                    return 'background:#C5ECFE';
                }
            }

            if (this.durationIndex === 12 && this.ageIndex <= 50) {
                if (rowIndex === 0 && cellIndex === 2) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 0 || cellIndex === 2) {
                    return 'background:#C5ECFE';
                }
            }

            if (this.durationIndex === 12 && this.ageIndex > 50 && this.ageIndex < 90) {
                if (rowIndex === 1 && cellIndex === 2) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 1 || cellIndex === 2) {
                    return 'background:#C5ECFE';
                }
            }

            if (this.durationIndex === 12 && this.ageIndex >= 90) {
                if (rowIndex === 2 && cellIndex === 2) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 2 || cellIndex === 2) {
                    return 'background:#C5ECFE';
                }
            }

            if (this.durationIndex > 0 && this.durationIndex < 12) {
                if (rowIndex === 1 && cellIndex === 1) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 1 || cellIndex === 1) {
                    return 'background:#C5ECFE';
                }
            }

            return '';
        }
    })
});

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_Table__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Typeahead__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Typeahead__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: "day-one-save",
    components: {
        Control: __WEBPACK_IMPORTED_MODULE_3_components_form_Control___default.a,
        ControlError: __WEBPACK_IMPORTED_MODULE_6_components_form_control_Error___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild___default.a,
        ClaimTable: __WEBPACK_IMPORTED_MODULE_8_pages_claims_dashboard_components_Table___default.a,
        Typeahead: __WEBPACK_IMPORTED_MODULE_9_components_Typeahead___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_components_form_validator_mixin__["a" /* default */]],
    data: function data() {
        return {
            showErrorMessage: false,
            showList: false,
            claim: false,
            isSaving: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('reserves/dayOneLost', ['isValidForSave', 'exists', 'estateOrDependency', 'claimType']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('user', ['showNames']), {
        claimantName: {
            get: function get() {
                return this.getValue('claimantName');
            },
            set: function set(value) {
                this.updateValue({ key: 'claimantName', value: value });
                this.updateValid();
            }
        },
        claimantSolicitors: {
            get: function get() {
                return this.getValue('claimantSolicitors');
            }
        },
        claimantReference: {
            get: function get() {
                return this.getValue('claimantReference');
            },
            set: function set(value) {
                this.updateValue({ key: 'claimantReference', value: value });
                this.updateValid();
            }
        },
        yourReference: {
            get: function get() {
                return this.getValue('yourReference');
            },
            set: function set(value) {
                this.updateValue({ key: 'yourReference', value: value });
                this.updateValid();
            }
        },
        defendantName: {
            get: function get() {
                return this.getValue('defendantName');
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('reserves/dayOneLost', ['updateValue', 'save', 'openAsClaim']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('modal', ['toggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('claim', ['load']), {
        getValue: function getValue(attr) {
            return this.$store.getters['reserves/dayOneLost/' + attr];
        },
        cancel: function cancel() {
            this.toggle('save_day_one_lost');
        },
        updateValid: function updateValid() {
            var validForSave = this.$valid() && this.isValidForSave;
            this.showErrorMessage = !validForSave;

            return validForSave;
        },
        doSave: function doSave() {
            var _this = this;

            if (this.updateValid()) {
                this.isSaving = true;

                this.save().then(function () {
                    _this.isSaving = false;
                });
            }
        },
        routeToClaim: function routeToClaim() {
            var _this2 = this;

            this.openAsClaim().then(function () {
                var route = '/lost-years/' + _this2.getValue('claimId') + '/claimant-details';
                return _this2.$router.push(route);
            });
        },
        toggleClaimList: function toggleClaimList() {
            this.showList = !this.showList;
        },
        attachToClaim: function attachToClaim(claim) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.updateValue({ key: 'claimantName', value: claim.claimant_name }), this.updateValue({
                key: 'claimantSolicitors', value: {
                    id: claim.claimant_solicitor_id,
                    name: claim.claimant_solicitor,
                    type: 'claimant_solicitor'
                }
            }), this.updateValue({ key: 'claimantReference', value: claim.claimant_reference }), this.updateValue({ key: 'yourReference', value: claim.your_reference }), this.updateValue({
                key: 'defendantName', value: {
                    id: claim.defendant_id,
                    name: claim.defendant_name,
                    type: 'defendant'
                }
            })]).then(function () {
                return _this3.save(claim.id);
            }).then(function () {
                return _this3.claim = claim;
            }).then(function () {
                return _this3.showList = false;
            });
        },
        openSummaryDocument: function openSummaryDocument() {
            window.open('/api/v1/day-one-summary/pdf/' + this.getValue('claimId') + '?access_token=' + this.getToken);
        },
        updateClaimantSolicitors: function updateClaimantSolicitors(value) {
            this.updateValue({ key: 'claimantSolicitors', value: value });
            this.updateValid();
        },
        updateDefendant: function updateDefendant(value) {
            this.updateValue({ key: 'defendantName', value: value });
            this.updateValid();
        }
    })
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_reserving_components_SalaryFinder__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_reserving_components_SalaryFinder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_reserving_components_SalaryFinder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_LifeExpectancy_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_LifeExpectancy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_LifeExpectancy_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'day-one-fatal',
    components: { Control: __WEBPACK_IMPORTED_MODULE_2_components_form_Control_vue___default.a, ControlError: __WEBPACK_IMPORTED_MODULE_3_components_form_control_Error_vue___default.a, FormValidator: __WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], DateInput: __WEBPACK_IMPORTED_MODULE_6_components_form_control_DateInput_vue___default.a, SalaryFinder: __WEBPACK_IMPORTED_MODULE_7_pages_reserving_components_SalaryFinder___default.a, LifeExpectancy: __WEBPACK_IMPORTED_MODULE_12_components_LifeExpectancy_vue___default.a },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_components_form_validator_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_mixins_currencyFormat__["a" /* default */]],
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_11_directives_TwoDecimalPlaces__["a" /* default */]
    },
    mounted: function mounted() {
        this.reset();
    },
    data: function data() {
        return {
            theDate: __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('DD/MM/YYYY'),
            showErrorMessage: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('reserves/dayOneLost', ['isValid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])('windowWidth', ['theCurrentWidth']), {
        innerLifeExpectancy: function innerLifeExpectancy() {
            return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(this.getValue('lifeExpectancy'));
        },
        innerAssumedLifeExpectancy: function innerAssumedLifeExpectancy() {
            return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(this.getValue('assumedLifeExpectancy'));
        },
        currentAge: function currentAge() {
            return __WEBPACK_IMPORTED_MODULE_9_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.dateOfBirth, 'DD/MM/YYYY'), 'years');
        },
        minAgeRules: function minAgeRules() {
            if (!this.assumedAgeAtDeath) {
                return false;
            }

            return __WEBPACK_IMPORTED_MODULE_9_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.dateOfBirth, 'DD/MM/YYYY'), 'years') > this.assumedAgeAtDeath;
        },

        diseaseOrAccident: {
            get: function get() {
                return this.getValue('diseaseOrAccident');
            },
            set: function set(value) {
                return this.updateValue({ key: 'diseaseOrAccident', value: value });
            }
        },
        diseaseType: {
            get: function get() {
                return this.getValue('diseaseType');
            },
            set: function set(value) {
                this.updateValue({ key: 'accidentType', value: null });
                return this.updateValue({ key: 'diseaseType', value: value });
            }
        },
        accidentType: {
            get: function get() {
                return this.getValue('accidentType');
            },
            set: function set(value) {
                this.updateValue({ key: 'diseaseType', value: null });
                return this.updateValue({ key: 'accidentType', value: value });
            }
        },
        gender: {
            get: function get() {
                return this.getValue('gender');
            },
            set: function set(value) {
                return this.updateValue({ key: 'gender', value: value });
            }
        },
        dateOfBirth: {
            get: function get() {
                return this.getValue('dateOfBirth');
            },
            set: function set(value) {
                return this.updateValue({ key: 'dateOfBirth', value: value });
            }
        },
        dateOfDeath: {
            get: function get() {
                return this.getValue('dateOfDeath');
            },
            set: function set(value) {
                return this.updateValue({ key: 'dateOfDeath', value: value });
            }
        },
        ageAtDeath: {
            get: function get() {
                return this.getValue('ageAtDeath');
            },
            set: function set(value) {
                return this.updateValue({ key: 'ageAtDeath', value: value });
            }
        },
        assumedSettlement: {
            get: function get() {
                return this.getValue('assumedSettlement');
            },
            set: function set(value) {
                return this.updateValue({ key: 'assumedSettlement', value: value });
            }
        },
        employmentType: {
            get: function get() {
                return this.getValue('employmentType');
            },
            set: function set(value) {
                return this.updateValue({ key: 'employmentType', value: value });
            }
        },
        onsetOfSymptoms: {
            get: function get() {
                return this.getValue('onsetOfSymptoms');
            },
            set: function set(value) {
                return this.updateValue({ key: 'onsetOfSymptoms', value: value });
            }
        },
        proceduralStatus: {
            get: function get() {
                return this.getValue('proceduralStatus');
            },
            set: function set(value) {
                return this.updateValue({ key: 'proceduralStatus', value: value });
            }
        },
        assumedLifeExpectancyMethod: {
            get: function get() {
                return this.getValue('assumedLifeExpectancy').method;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.method = value;
            }
        },
        yearsLeft: {
            get: function get() {
                return this.getValue('assumedLifeExpectancy').yearsLeft;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.yearsLeft = value;
            }
        },
        monthsLeft: {
            get: function get() {
                return this.getValue('assumedLifeExpectancy').monthsLeft;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.monthsLeft = value;
            }
        },
        assumedDateOfDeath: {
            get: function get() {
                return this.getValue('assumedLifeExpectancy').dateOfDeath;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.dateOfDeath = value;
            }
        },
        assumedAgeAtDeath: {
            get: function get() {
                return this.getValue('assumedLifeExpectancy').ageAtDeath;
            },
            set: function set(value) {
                this.innerAssumedLifeExpectancy.ageAtDeath = value;
            }
        },
        dobRules: function dobRules() {
            return {
                type: "date",
                rules: 'max:' + __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('DD/MM/YYYY')
            };
        },
        dodRules: function dodRules() {
            return {
                type: "date",
                rules: 'min:' + this.dateOfBirth
            };
        },
        assumedRules: function assumedRules() {
            return {
                type: "date",
                rules: 'min:' + this.dateOfDeath
            };
        },
        oSoSRules: function oSoSRules() {
            return {
                type: "date",
                rules: 'max:' + this.dateOfDeath
            };
        },
        occupation: function occupation() {
            return this.getValue('occupation');
        },

        salary: {
            get: function get() {
                return this.getValue('salary');
            },
            set: function set(value) {
                return this.updateValue({ key: 'salary', value: value });
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('reserves/dayOneLost', ['updateValue', 'performCalculation', 'reset', 'updateClaimantAssumedLifeExpectancy', 'updateLifeExpectancy']), {
        getValue: function getValue(attr) {
            return this.$store.getters['reserves/dayOneLost/' + attr];
        },
        calculate: function calculate() {
            this.showErrorMessage = !this.isValid || !this.$valid();
            if (!this.showErrorMessage) {
                var assignColumnOne = document.querySelector('.c-split-screen__column-one');

                var elementBounding = assignColumnOne.getBoundingClientRect();
                if (this.theCurrentWidth <= 1024) {
                    window.scrollTo(0, elementBounding.height + 108);
                } else {
                    window.scrollTo(0, 0);
                }

                this.performCalculation();
            }
        },
        updateSalary: function updateSalary(value) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.updateValue({ key: 'occupation', value: value.occupation }), this.updateValue({ key: 'salary', value: value.salary })]);
        },
        updateAssumedLifeExpectancy: function updateAssumedLifeExpectancy() {
            var assumedLifeExpectancy = this.innerAssumedLifeExpectancy;
            this.updateClaimantAssumedLifeExpectancy({ assumedLifeExpectancy: assumedLifeExpectancy });
        },
        updateLife: function updateLife(lifeExpectancy) {
            this.updateLifeExpectancy({ lifeExpectancy: lifeExpectancy });
        }
    })
});

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_Accordion__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_accordion_Accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordian_content__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_graphs_BarChart__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CalculationModal__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CalculationModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CalculationModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DayOneSave__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DayOneSave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DayOneSave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OwnHeadOfLoss__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OwnHeadOfLoss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__OwnHeadOfLoss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__accordian_content_PslaModalContent__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__accordian_content_PslaModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__accordian_content_PslaModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ReservePerformanceChart__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ReservePerformanceChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ReservePerformanceChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__BellChart__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__BellChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__BellChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_directives_TwoDecimalPlaces__ = __webpack_require__(11);























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'day-one-lost-results',
    components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__accordian_content__["a" /* default */], {
        BellChart: __WEBPACK_IMPORTED_MODULE_18__BellChart___default.a,
        Accordion: __WEBPACK_IMPORTED_MODULE_1_components_accordion_Accordion___default.a,
        AccordionItem: __WEBPACK_IMPORTED_MODULE_3_components_accordion_AccordionItem___default.a,
        BarChart: __WEBPACK_IMPORTED_MODULE_4_components_graphs_BarChart__["a" /* default */],
        CalculationModal: __WEBPACK_IMPORTED_MODULE_5__CalculationModal___default.a,
        DayOneSave: __WEBPACK_IMPORTED_MODULE_7__DayOneSave___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_8_components_IconTooltip___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_9_components_modal_Modal___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_10_components_modal_ModalContent___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_11_components_modal_ModalInTheWild___default.a,
        PslaModalContent: __WEBPACK_IMPORTED_MODULE_14__accordian_content_PslaModalContent___default.a,
        OwnHeadOfLoss: __WEBPACK_IMPORTED_MODULE_13__OwnHeadOfLoss___default.a,
        ReservePerformanceChart: __WEBPACK_IMPORTED_MODULE_15__ReservePerformanceChart___default.a
    }),
    directives: {
        'two-dp': __WEBPACK_IMPORTED_MODULE_19_directives_TwoDecimalPlaces__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["a" /* mapGetters */])('reserves/dayOneLost', ['hasResults', 'results', 'ageAtDeath', 'ageAtAssessment', 'claimantContribution', 'defenceContribution', 'damagesContribution', 'apportionedClaimantReserve', 'apportionedDefenceReserve', 'apportionedDamagesReserve', 'totalReserve', 'chartData', 'gender', 'durationOfSymptoms', 'dateOfDeath', 'ownHeadsOfLoss', 'totalDamages', 'estateOrDependency', 'exists', 'calculating', 'claimId', 'employmentType', 'dateOfBirth', 'modalPayload', 'diseaseType', 'assumedLifeExpectancy', 'defenceCosts', 'claimantCosts']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning']), {
        retirementAge: function retirementAge() {
            return this.roundValue(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.results.calculation.retirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.dateOfBirth, 'DD/MM/YYYY'), 'years', true), 2);
        },


        generalDamages: {
            get: function get() {
                return this.results.damages.generalDamages;
            },
            set: function set(value) {
                return this.updateValue({
                    key: 'generalDamages',
                    value: value
                });
            }
        }

    }),
    mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_currencyFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16_mixins_roundValue__["a" /* default */]],
    data: function data() {
        return {
            assumptions: false
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('reserves/dayOneLost', ['updateValue', 'save', 'addHeadOfLoss']), {
        updateClaimantContribution: function updateClaimantContribution(event) {
            var value = parseFloat(event.target.value);
            value = this._smoothPercentile(value);
            return this.updateValue({
                key: 'claimantContribution',
                value: value
            });
        },
        updateDefenceContribution: function updateDefenceContribution(event) {
            var value = parseFloat(event.target.value);
            value = this._smoothPercentile(value);
            return this.updateValue({
                key: 'defenceContribution',
                value: value
            });
        },
        updateDamagesContribution: function updateDamagesContribution(event) {
            var value = parseFloat(event.target.value);
            value = this._smoothPercentile(value);
            return this.updateValue({
                key: 'damagesContribution',
                value: value
            });
        },
        updateClaimantCosts: function updateClaimantCosts(event) {
            var value = parseFloat(event.target.value);
            return this.updateValue({
                key: 'claimantCosts',
                value: value
            });
        },
        updateDefenceCosts: function updateDefenceCosts(event) {
            var value = parseFloat(event.target.value);
            return this.updateValue({
                key: 'defenceCosts',
                value: value
            });
        },
        openSummaryDocument: function openSummaryDocument() {
            window.open('/api/v1/day-one-summary/pdf/' + this.claimId + '?access_token=' + this.getToken);
        },

        _smoothPercentile: function _smoothPercentile(value) {
            if (value > 100) {
                value = 100;
            }
            if (value < 0) {
                value = 0;
            }
            return value;
        }
    })
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "bereavement-award-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_2_components_accordion_AccordionItem___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_1_components_modal_ModalContent___default.a
    },

    props: {
        person: {
            type: Object,
            required: true
        },
        value: {
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_currencyFormat__["a" /* default */]],
    created: function created() {
        this.load();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('modal', ['getModalContent']), {
        load: function load() {
            this.getModalContent({
                endpoint: 'dayOneBereavementAward',
                payload: {
                    args: { person: this.person, claim: { type: 'fatal_accident_dependency' } }
                }
            });
        }
    })
});

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "care-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_3_components_modal_ModalContent___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_currencyFormat__["a" /* default */]],
    props: {
        person: {
            type: Object,
            required: true
        },
        claim: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true,
            default: 'lost'
        },
        value: {
            required: true
        }
    },
    created: function created() {
        this.load();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('modal', ['getModalContent']), {
        load: function load() {
            this.getModalContent({
                endpoint: 'dayOneCostOfCare',
                payload: {
                    args: { person: this.person, claim: this.claim, dependency_type: this.type }
                }
            });
        }
    })
});

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "dependency-services-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "funeral-expenses-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "loss-of-income-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "misc-modal",
    props: {
        value: {
            required: true
        },
        dateOfDeath: {
            type: String
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    }
});

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "past-loss-earnings-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_0_components_accordion_AccordionItem___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "past-services-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_1_components_accordion_AccordionItem_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_0_mixins_currencyFormat__["a" /* default */]],
    props: {
        value: {
            required: true
        }
    }
});

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_IconTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Heading__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Paragraph__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PslaModalContent__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PslaModalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PslaModalContent__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: "psla-modal",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild___default.a,
        Heading: __WEBPACK_IMPORTED_MODULE_3_components_modal_Heading___default.a,
        Paragraph: __WEBPACK_IMPORTED_MODULE_4_components_modal_Paragraph___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_2_components_IconTooltip___default.a,
        PslaModalContent: __WEBPACK_IMPORTED_MODULE_9__PslaModalContent___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_5_components_modal_Modal___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */]],
    props: {
        duration: {
            type: Number,
            required: true
        },
        age: {
            required: true
        },
        value: {
            required: true
        }
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            table: {}
        };
    },

    computed: {
        tableResults: function tableResults() {
            if (!this.table[50]) {
                return [];
            }
            var startRowIndex = this.ageIndex < 60 ? 0 : this.ageIndex > 80 ? 80 : this.ageIndex - 5;

            var startColumnIndex = this.columnIndexStart;
            var endColumnIndex = this.columnIndexEnd;

            return [this.table[startRowIndex].slice(startColumnIndex, endColumnIndex), this.table[startRowIndex + 5].slice(startColumnIndex, endColumnIndex), this.table[startRowIndex + 10].slice(startColumnIndex, endColumnIndex)];
        },
        columnIndexStart: function columnIndexStart() {
            if (this.durationIndex < 2) {
                return 0;
            }
            if (this.durationIndex === 12) {
                return this.durationIndex - 2;
            }
            return this.durationIndex - 1;
        },
        columnIndexEnd: function columnIndexEnd() {
            if (this.durationIndex === 0) {
                return this.durationIndex + 3;
            }
            return this.durationIndex + 2;
        },
        ageIndex: function ageIndex() {
            var age = parseFloat(this.age);
            if (age < 50) {
                return 50;
            }
            if (age > 90) {
                return 90;
            }
            return Math.ceil(age / 5) * 5;
        },
        ageLabels: function ageLabels() {
            return this.ageIndex < 60 ? [50, 55, 60] : this.ageIndex > 80 ? [80, 85, 90] : [this.ageIndex - 5, this.ageIndex, this.ageIndex + 5];
        },
        durationIndex: function durationIndex() {
            if (this.duration < 3) {
                return 0;
            }
            if (this.duration > 36) {
                return 12;
            }
            return Math.floor(this.duration / 3) - 1;
        },
        durationLabels: function durationLabels() {
            return this.durationIndex < 2 ? ["0-3", "4-6", "7-9"] : this.durationIndex > 9 ? ["31-33", "34-36", "37+"] : [(this.durationIndex - 1) * 3 - 2 + "-" + (this.durationIndex - 1) * 3, this.durationIndex * 3 - 2 + "-" + this.durationIndex * 3, (this.durationIndex + 1) * 3 - 2 + "-" + (this.durationIndex + 1) * 3];
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('psla', ['loadTable']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        init: function init() {
            var _this = this;

            this.loadTable().then(function (table) {
                return _this.table = table;
            });
        },
        toggleThis: function toggleThis() {
            this.toggle('day-one-res-psla');
        },
        calcCellStyle: function calcCellStyle(rowIndex, cellIndex) {
            if (this.durationIndex === 0) {
                if (rowIndex === 1 && cellIndex === 0) {
                    return 'background:#9f9';
                }
                if (rowIndex === 1 || cellIndex === 0) {
                    return 'background:#efe';
                }
            }

            if (this.durationIndex === 12) {
                if (rowIndex === 1 && cellIndex === 2) {
                    return 'background:#9f9';
                }
                if (rowIndex === 1 || cellIndex === 2) {
                    return 'background:#efe';
                }
            }

            if (this.durationIndex > 0 && this.durationIndex < 12) {
                if (rowIndex === 1 && cellIndex === 1) {
                    return 'background:#9f9';
                }
                if (rowIndex === 1 || cellIndex === 1) {
                    return 'background:#efe';
                }
            }

            return '';
        }
    })
});

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_IconTooltip_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_IconTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_IconTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_modal_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem__);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: "psla-modal-content",
    components: {
        AccordionItem: __WEBPACK_IMPORTED_MODULE_8_components_accordion_AccordionItem___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_6_components_modal_ModalInTheWild___default.a,
        Heading: __WEBPACK_IMPORTED_MODULE_2_components_modal_Heading___default.a,
        Paragraph: __WEBPACK_IMPORTED_MODULE_3_components_modal_Paragraph___default.a,
        IconTooltip: __WEBPACK_IMPORTED_MODULE_1_components_IconTooltip_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_4_components_modal_Modal___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_currencyFormat__["a" /* default */]],
    props: {
        duration: {
            type: Number,
            required: true
        },
        age: {
            required: true
        },
        value: {
            required: true
        }
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            table: {}
        };
    },

    computed: {
        tableResults: function tableResults() {
            if (!this.table[50]) {
                return [];
            }
            var startRowIndex = this.ageIndex <= 50 ? 50 : this.ageIndex > 80 ? 80 : this.ageIndex - 5;

            var startColumnIndex = this.columnIndexStart;
            var endColumnIndex = this.columnIndexEnd;

            return [this.table[startRowIndex].slice(startColumnIndex, endColumnIndex), this.table[startRowIndex + 5].slice(startColumnIndex, endColumnIndex), this.table[startRowIndex + 10].slice(startColumnIndex, endColumnIndex)];
        },
        columnIndexStart: function columnIndexStart() {
            if (this.durationIndex < 2) {
                return 0;
            }
            if (this.durationIndex === 12) {
                return this.durationIndex - 2;
            }
            return this.durationIndex - 1;
        },
        columnIndexEnd: function columnIndexEnd() {
            if (this.durationIndex === 0) {
                return this.durationIndex + 3;
            }
            if (this.durationIndex === 12) {
                return this.durationIndex + 1;
            }
            return this.durationIndex + 2;
        },
        ageIndex: function ageIndex() {
            var age = parseFloat(this.age);
            if (age < 50) {
                return 50;
            }
            if (age > 90) {
                return 90;
            }
            return Math.ceil(age / 5) * 5;
        },
        ageLabels: function ageLabels() {
            return this.ageIndex < 60 ? [50, 55, 60] : this.ageIndex > 80 ? [80, 85, 90] : [this.ageIndex - 5, this.ageIndex, this.ageIndex + 5];
        },
        durationIndex: function durationIndex() {
            if (this.duration < 3) {
                return 0;
            }
            if (this.duration > 36) {
                return 12;
            }
            return Math.floor(this.duration / 3);
        },
        durationLabels: function durationLabels() {
            return this.durationIndex < 2 ? ["0-3", "4-6", "7-9"] : this.durationIndex > 9 ? ["31-33", "34-36", "37+"] : [this.durationIndex * 3 - 2 + "-" + this.durationIndex * 3, (this.durationIndex + 1) * 3 - 2 + "-" + (this.durationIndex + 1) * 3, (this.durationIndex + 2) * 3 - 2 + "-" + (this.durationIndex + 2) * 3];
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('psla', ['loadTable']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('modal', ['toggle']), {
        init: function init() {
            var _this = this;

            this.loadTable().then(function (table) {
                return _this.table = table;
            });
        },
        toggleThis: function toggleThis() {
            this.toggle('day-one-res-psla');
        },
        calcCellStyle: function calcCellStyle(rowIndex, cellIndex) {
            if (this.durationIndex === 0) {
                if (rowIndex === 1 && cellIndex === 0) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 1 || cellIndex === 0) {
                    return 'background:#C5ECFE';
                }
            }

            if (this.durationIndex === 12 && this.ageIndex <= 50) {
                if (rowIndex === 0 && cellIndex === 2) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 0 || cellIndex === 2) {
                    return 'background:#C5ECFE';
                }
            }

            if (this.durationIndex === 12 && this.ageIndex > 50 && this.ageIndex < 90) {
                if (rowIndex === 1 && cellIndex === 2) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 1 || cellIndex === 2) {
                    return 'background:#C5ECFE';
                }
            }

            if (this.durationIndex === 12 && this.ageIndex >= 90) {
                if (rowIndex === 2 && cellIndex === 2) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 2 || cellIndex === 2) {
                    return 'background:#C5ECFE';
                }
            }

            if (this.durationIndex > 0 && this.durationIndex < 12) {
                if (rowIndex === 1 && cellIndex === 1) {
                    return 'background:#C5ECFE;font-weight:bold;';
                }
                if (rowIndex === 1 || cellIndex === 1) {
                    return 'background:#C5ECFE';
                }
            }

            return '';
        }
    })
});

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'documents',
    data: function data() {
        return {
            loading: true
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('user', ['getToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        resources: 'resources/getResources',
        documents: 'resources/getDocuments'
    }), {
        categoryList: {
            get: function get() {
                return this.resources.categoryList;
            }
        },
        category: {
            get: function get() {
                return this.resources.category;
            },
            set: function set(value) {
                if (value === 'All') {
                    value = null;
                }
                this.setTheCategory(value);
            }
        },
        documentName: {
            get: function get() {
                return this.resources.documentName;
            },
            set: function set(value) {
                this.setTheDocumentName(value);
            }
        },
        orderBy: {
            get: function get() {
                return this.resources.orderBy;
            },
            set: function set(value) {
                this.setTheOrderBy(value);
            }
        }
    }),
    created: function created() {
        this.documentSearch();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        getDocsFromServer: 'resources/getDocumentsFromServer',
        theDocumentSearch: 'resources/documentSearch',
        setTheCategory: 'resources/setCategory',
        setTheDocumentName: 'resources/setDocumentName',
        setTheOrderBy: 'resources/setOrderBy'
    }), {
        documentSearch: function documentSearch() {
            var _this = this;

            this.loading = true;

            this.theDocumentSearch().then(function () {
                _this.loading = false;
            });
        }
    })
});

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_resources_and_tools_OgdenTables_OgdenTableViewer_vue__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_resources_and_tools_OgdenTables_OgdenTableViewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_resources_and_tools_OgdenTables_OgdenTableViewer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_resources_and_tools_OgdenTables_AtAglanceViewer_vue__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_resources_and_tools_OgdenTables_AtAglanceViewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_resources_and_tools_OgdenTables_AtAglanceViewer_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    created: function created() {
        this.getOgdenList();
    },
    data: function data() {
        return {
            selectedTable: null,
            tableData: null,
            dataHeaders: null,
            discount: 0.00,
            gender: 'male',
            discounts: [-2.00, -1.50, -1.00, -0.75, -0.50, -0.25, 0.00, 0.50, 1.00, 1.50, 2.00, 2.50, 3.00]
        };
    },

    components: {
        OgdenTableViewer: __WEBPACK_IMPORTED_MODULE_3_pages_resources_and_tools_OgdenTables_OgdenTableViewer_vue___default.a,
        AtAGlanceViewer: __WEBPACK_IMPORTED_MODULE_4_pages_resources_and_tools_OgdenTables_AtAglanceViewer_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
        ogdenTables: 'resources/ogdenTables',
        ogdenTableData: 'resources/ogdenTableData',
        atAGlance: 'resources/atAGlance'
    })),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
        getOgdenList: 'resources/loadOgdenTables',
        getOgdenValues: 'resources/obtainOgdenTable',
        getAtAGlance: 'resources/atAGlance'
    }), {
        obtainOgdenTable: function obtainOgdenTable() {
            var _this = this;

            if (!this.selectedTable) {
                return;
            }
            this.getOgdenValues(this.selectedTable.value).then(function () {
                _this.tableData = _this.ogdenTableData[_this.selectedTable.value];
                _this.dataHeaders = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.ogdenTableData[_this.selectedTable.value]);
            });
        },
        atAGlanceViewer: function atAGlanceViewer() {
            this.getAtAGlance({ discount: this.discount, gender: this.gender });
        }
    })
});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_resources_and_tools_OgdenTables_mixins_Selector__ = __webpack_require__(240);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['tableData', 'name', 'description'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2_pages_resources_and_tools_OgdenTables_mixins_Selector__["a" /* default */]],
    computed: {
        headers: function headers() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.tableData).map(function (table) {
                return _this.tableData[table]['title'];
            });
        },
        eachTableAvailable: function eachTableAvailable() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.tableData).map(function (table) {
                return _this2.tableData[table]['data'];
            });
        },
        ageRange: function ageRange() {
            var _this3 = this;

            return Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.tableData).map(function (table) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.tableData[table]['data']).reduce(function (max, arr) {
                    return max >= arr ? max : arr;
                }, -Infinity);
            }))) + 1;
        }
    }
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_resources_and_tools_OgdenTables_mixins_Selector__ = __webpack_require__(240);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['tableData', 'name', 'description'],
    mixins: [__WEBPACK_IMPORTED_MODULE_0_pages_resources_and_tools_OgdenTables_mixins_Selector__["a" /* default */]],
    data: function data() {
        return {
            headers: ['Age at Date of Trial', '-2.00%', '-1.50%', '-1.00%', '0.75%', '-0.50%', '-0.25%', '0.00%', '0.50%', '1.00%', '-1.50%', '2.00%', '2.50%', '3.00%', 'Age at Date of Trial'],
            selectedColumn: null,
            selectedRow: null
        };
    }
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_Header_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        HeaderSection: __WEBPACK_IMPORTED_MODULE_0_components_Header_vue___default.a
    }
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Icons_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalContent_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_modal_ModalContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_policies_Disclaimer_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_policies_Disclaimer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_policies_Disclaimer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_policies_CookiePolicy_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_policies_CookiePolicy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_policies_CookiePolicy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_policies_PrivacyPolicy_vue__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_policies_PrivacyPolicy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_policies_PrivacyPolicy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Header_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Header_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'support',
    data: function data() {
        return {
            claimText: '',
            queryText: '',
            sent: false
        };
    },

    components: {
        Icons: __WEBPACK_IMPORTED_MODULE_2_components_Icons_vue___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_3_components_modal_Modal_vue___default.a,
        ModalContent: __WEBPACK_IMPORTED_MODULE_4_components_modal_ModalContent_vue___default.a,
        ModalInTheWild: __WEBPACK_IMPORTED_MODULE_5_components_modal_ModalInTheWild_vue___default.a,
        Disclaimer: __WEBPACK_IMPORTED_MODULE_6_components_policies_Disclaimer_vue___default.a,
        CookiePolicy: __WEBPACK_IMPORTED_MODULE_7_components_policies_CookiePolicy_vue___default.a,
        PrivacyPolicy: __WEBPACK_IMPORTED_MODULE_8_components_policies_PrivacyPolicy_vue___default.a,
        HeaderSection: __WEBPACK_IMPORTED_MODULE_9_components_Header_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('http', ['apiRouteRequestRunning'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('support', ['sendMail']), {
        sendEmail: function sendEmail() {
            var _this = this;

            this.sendMail({ claim: this.claimText, query: this.queryText }).then(function (response) {
                if (response) {
                    _this.sent = true;
                    _this.claimText = '';
                    _this.queryText = '';
                    setTimeout(function () {
                        this.reset();
                    }.bind(_this), 8000);
                }
            });
        },
        reset: function reset() {
            this.sent = false;
        }
    })
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_eventBus__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_form_validator_validations__ = __webpack_require__(23);










var inputEvent = ['blur', 'keyup', 'input', 'focus', 'click'];

var stateTemplate = function stateTemplate(ctrl) {
    return {
        $touched: false,

        $valid: false,

        $dirty: false,
        get $invalid() {
            return !this.$valid;
        },
        get $clean() {
            return !this.$dirty;
        },
        get $untouched() {
            return !this.$touched;
        },
        get $error() {
            return this.$invalid && (this.$touched || ctrl._isDisabled);
        }
    };
};

var FieldControl = function () {
    function FieldControl(el, bindings, vnode) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, FieldControl);

        this.name = el.name;
        this._rules = FieldControl.determineRulesFromEl(el);
        this._type = el.type || 'select';
        this._isDisabled = !!el.disabled;
        this._vm = vnode.context;
        this._el = el;
        this._component = vnode.child;
        this._state = stateTemplate(this);
        this._intitalValue = this._determineValue();
        this._parseBindings(bindings);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(FieldControl, [{
        key: 'validate',
        value: function validate() {
            var _this = this;

            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._determineValue();

            var valid = this._rules.reduce(function (valid, rule) {
                return !valid ? valid : _this._runRule(rule, value);
            }, true);
            this._updateState('$valid', valid);
            return valid;
        }
    }, {
        key: 'eventHandler',
        value: function eventHandler(type) {
            var _this2 = this;

            return function (event) {
                var value = _this2._determineValue(event);
                switch (type) {
                    case 'update':
                        _this2._component && _this2._determineDirty(value) && _this2._updateState('$touched', true);

                        _this2.validate(value);
                        break;
                    case 'input':
                    case 'change':
                        _this2._determineDirty(value);
                        break;
                    case 'blur':
                        _this2._updateState('$touched', true);
                        break;
                    default:
                        _this2.validate(value);
                }
            };
        }
    }, {
        key: 'register',
        value: function register() {
            if (this._el) {
                this._bindInputEvents();
            }
            if (this._component) {
                this._bindComponentEvents();
            }
            this.eventHandler('created')(this._intitalValue);
            this._registerToForm();

            return this;
        }
    }, {
        key: 'unregister',
        value: function unregister() {
            if (this._el) {
                this._unbindInputEvents();
            }
            if (this._component) {
                this._unBindComponentEvents();
            }
            this._unregisterFromForm();

            return this;
        }
    }, {
        key: 'updateBindings',
        value: function updateBindings(_ref) {
            var value = _ref.value,
                oldValue = _ref.oldValue;

            if (value === oldValue) return;

            this._parseBindings(value);
        }
    }, {
        key: 'updateItemChangeOnEl',
        value: function updateItemChangeOnEl(el) {
            this._isDisabled = !!el.disabled;
        }
    }, {
        key: '_parseBindings',
        value: function _parseBindings(_ref2) {
            var _ref2$modifiers = _ref2.modifiers,
                modifiers = _ref2$modifiers === undefined ? {} : _ref2$modifiers,
                value = _ref2.value,
                _ref2$arg = _ref2.arg,
                arg = _ref2$arg === undefined ? this.name : _ref2$arg,
                rules = _ref2.rules;

            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(modifiers).forEach(this._appendRules.bind(this));
            this.name = arg;
            switch (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) {
                case 'string':
                    return this._appendRules(value);
                case 'object':
                    if (value.type) {
                        this._type = value.type;
                    }
                    if (value.name) {
                        this.name = value.name;
                    }
                    if (value.rules) {
                        return this._appendRules(value.rules);
                    }
            }
            if (rules) this._appendRules(rules);
            return this;
        }
    }, {
        key: '_updateState',
        value: function _updateState(state, value) {
            if (this._state[state] === value) {
                return value;
            }
            this._state[state] = value;
            __WEBPACK_IMPORTED_MODULE_7_components_form_validator_eventBus__["a" /* default */].trigger('validator.field.stateChange', state);

            return value;
        }
    }, {
        key: '_appendRules',
        value: function _appendRules(rules) {
            if (!rules) return false;
            if (typeof rules === 'string') {
                rules = rules.split('|');
            }
            if (Array.isArray(rules)) {
                return this._updateRules(rules);
            }
            return false;
        }
    }, {
        key: '_updateRules',
        value: function _updateRules(rules) {
            var previous = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this._rules);

            this._rules = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniqBy(this._rules.concat(rules).reverse(), function (rule) {
                return rule.split(':')[0];
            });

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this._rules) !== previous;
        }
    }, {
        key: '_runRule',
        value: function _runRule(rule, value) {
            var _validators$_type;

            var ruleParts = rule.split(':');
            return (_validators$_type = __WEBPACK_IMPORTED_MODULE_8_components_form_validator_validations__["b" /* default */][this._type])[ruleParts.shift()].apply(_validators$_type, [value].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ruleParts)));
        }
    }, {
        key: '_determineDirty',
        value: function _determineDirty() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._determineValue();

            if (this._type === 'select-one') {
                return false;
            }

            return this._updateState('$dirty', this._intitalValue !== value);
        }
    }, {
        key: '_registerToForm',
        value: function _registerToForm() {
            var vm = this._vm;
            while (vm && !vm.$formCtrl) {
                vm = vm.$parent;
            }
            if (vm && vm.$formCtrl) {
                vm.$formCtrl.addField(this);
            } else {
                __WEBPACK_IMPORTED_MODULE_7_components_form_validator_eventBus__["a" /* default */].trigger('validator.field.register', this);
            }
        }
    }, {
        key: '_unregisterFromForm',
        value: function _unregisterFromForm() {
            __WEBPACK_IMPORTED_MODULE_7_components_form_validator_eventBus__["a" /* default */].trigger('validator.field.deregister', this);
        }
    }, {
        key: '_bindComponentEvents',
        value: function _bindComponentEvents() {
            this._componentCallBack = this.eventHandler('input');
            this._component.$on('input', this._componentCallBack);
        }
    }, {
        key: '_unBindComponentEvents',
        value: function _unBindComponentEvents() {
            this._component.$off('input', this._componentCallBack);
        }
    }, {
        key: '_bindInputEvents',
        value: function _bindInputEvents() {
            var _this3 = this;

            this._callbacks = inputEvent.map(function (event) {
                var listener = _this3.eventHandler(event);
                _this3._el.addEventListener(event, listener);
                return { event: event, listener: listener };
            });
        }
    }, {
        key: '_unbindInputEvents',
        value: function _unbindInputEvents() {
            var _this4 = this;

            this._callbacks.forEach(function (_ref3) {
                var event = _ref3.event,
                    listener = _ref3.listener;

                _this4._el.removeEventListener(event, listener);
            });
        }
    }, {
        key: '_determineValue',
        value: function _determineValue(event) {
            switch (typeof event === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(event)) {
                case 'number':
                case 'string':
                    return event;
                case 'object':
                    if (event && event.target) {
                        return event.target.value;
                    }
                    break;
                default:
                    return this._component ? this._component.value : this._el.value;
            }
        }
    }, {
        key: 'state',
        get: function get() {
            return this._state;
        }
    }], [{
        key: 'determineRulesFromEl',
        value: function determineRulesFromEl(el) {
            var rules = [];
            if (!el) {
                return rules;
            }
            if (el.required) {
                rules.push('required');
            }
            if (el.min) {
                rules.push('min:' + el.min);
            }
            if (el.max) {
                rules.push('max:' + el.max);
            }
            return rules;
        }
    }]);

    return FieldControl;
}();

/* harmony default export */ __webpack_exports__["a"] = (FieldControl);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__ = __webpack_require__(233);





var stateTemplate = function stateTemplate() {
    return {
        $valid: true,
        $invalid: {
            get: function get() {
                return !this.$valid;
            }
        },
        $touched: false,
        $untouched: {
            get: function get() {
                return !this.$touched;
            }
        },
        $dirty: false,
        $clean: {
            get: function get() {
                return !this.$dirty;
            }
        },
        $submitted: false,
        $error: false,
        $childForms: []
    };
};

var isArrInOneState = function isArrInOneState(key, arr, shouldBe) {
    return arr.reduce(function (value, item) {
        return value !== shouldBe ? value : item.state[key];
    }, shouldBe);
};

var FormControl = function () {
    function FormControl(vm) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FormControl);

        this._fields = [];
        this._vm = vm;
        this._state = stateTemplate();
        this._init = stateTemplate();
        this._forms = [];
        __WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */].trigger('validator.form.register', this);
        this._bindVmEvents();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FormControl, [{
        key: 'submit',
        value: function submit() {
            this._state.$submitted = true;
            this._fields.forEach(function (field) {
                return field.validate();
            });
            this._updateDerivedStates();
        }
    }, {
        key: 'addField',
        value: function addField(field) {
            this._fields.push(field);
            this._updateDerivedStates();
            __WEBPACK_IMPORTED_MODULE_2_vue___default.a.set(this._vm.$form, field.name, field.state);
            return false;
        }
    }, {
        key: 'removeField',
        value: function removeField(field) {
            this._fields.splice(this._fields.indexOf(field), 1);
            __WEBPACK_IMPORTED_MODULE_2_vue___default.a.delete(this._vm.$form, field.name);
            delete this[field.name];
            this._updateDerivedStates();
            return true;
        }
    }, {
        key: 'addForm',
        value: function addForm(form) {
            if (form === this) {
                return true;
            }
            this._forms.push(form);
            this._state.$childForms.push(form.state);
            this._updateDerivedStates();
            return true;
        }
    }, {
        key: 'removeForm',
        value: function removeForm(form) {
            var index = this._forms.indexOf(form);
            if (index === -1) {
                return true;
            }
            this._forms.splice(index, 1);
            this._state.$childForms.splice(index, 1);
            this._updateDerivedStates();
            return true;
        }
    }, {
        key: 'determine',
        value: function determine(state, field) {
            if (!field) {
                this._updateDerivedStates();
                return this._state[state];
            }
            return typeof this._state[field] !== 'undefined' ? this._state[field][state] : null;
        }
    }, {
        key: '_bindVmEvents',
        value: function _bindVmEvents() {
            this._boundEvents = [__WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */].on('validator.field.register', this.addField.bind(this)), __WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */].on('validator.field.deregister', this.removeField.bind(this)), __WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */].on('validator.field.stateChange', this._handleFieldStateChange.bind(this)), __WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */].on('validator.form.register', this.addForm.bind(this)), __WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */].on('validator.form.deregister', this.removeForm.bind(this))];
        }
    }, {
        key: 'remove',
        value: function remove() {
            __WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */].trigger('validator.form.deregister', this);
            this.unbindVmEvents();
        }
    }, {
        key: 'unbindVmEvents',
        value: function unbindVmEvents() {
            this._boundEvents.forEach(__WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_3_components_form_validator_eventBus__["a" /* default */]));
            this._boundEvents = [];
        }
    }, {
        key: '_handleFieldStateChange',
        value: function _handleFieldStateChange(key) {
            var updated = this._areAllFieldsOfState(key);
            if (updated === this._state[key]) return true;
            this._state[key] = updated;
            return true;
        }
    }, {
        key: '_updateDerivedStates',
        value: function _updateDerivedStates() {
            ['$dirty', '$touched', '$valid'].forEach(this._handleFieldStateChange.bind(this));
        }
    }, {
        key: '_areAllFieldsOfState',
        value: function _areAllFieldsOfState(key) {
            return isArrInOneState(key, this._fields, this._init[key]);
        }
    }, {
        key: '_areAllFormsOfState',
        value: function _areAllFormsOfState(key) {
            return this._forms.length === 0 ? this._init[key] : isArrInOneState(key, this._forms, this._init[key]);
        }
    }, {
        key: 'state',
        get: function get() {
            return this._state;
        }
    }]);

    return FormControl;
}();

/* harmony default export */ __webpack_exports__["a"] = (FormControl);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_validator_controls_FieldControl__ = __webpack_require__(825);


/* harmony default export */ __webpack_exports__["a"] = ({
    inserted: function inserted(el, bindings, vnode) {
        el.__fieldCtrl = new __WEBPACK_IMPORTED_MODULE_0_components_form_validator_controls_FieldControl__["a" /* default */](el, bindings, vnode).register();
    },
    update: function update(el, bindings) {
        if (typeof bindings.value === 'undefined') {
            bindings.value = {};
        }

        el.__fieldCtrl.updateBindings(bindings);

        el.__fieldCtrl.updateItemChangeOnEl(el);

        el.__fieldCtrl.eventHandler('update')();
    },
    unbind: function unbind(el) {
        el.__fieldCtrl.unregister();
    }
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_form_validator_directive__ = __webpack_require__(827);


var runPlugin = function runPlugin(Vue) {
    Vue.directive('field-control', __WEBPACK_IMPORTED_MODULE_0_components_form_validator_directive__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = ({
    install: runPlugin
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["HorizontalBar"].extend({
    mixins: [reactiveProp],
    props: ["options"],
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
}));

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Scatter"].extend({
    mixins: [reactiveProp],
    props: ["options"],
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
}));

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_form_validator__ = __webpack_require__(828);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_components_form_validator__["a" /* default */]);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_vue__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_router__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_fragment__ = __webpack_require__(224);










__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mixin({
    deeply: function deeply(map) {
        return function (object, callback) {
            return map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapValues(object, function (value) {
                if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isPlainObject(value)) {
                    return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.deeply(map)(value, callback);
                }

                if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isArray(value)) {
                    return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(value, function (item) {
                        return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.deeply(map)(item, callback);
                    });
                }

                return value;
            }), callback);
        };
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$watchAll = function (props, callback) {
    var _this = this;

    props.forEach(function (prop) {
        _this.$watch(prop, callback.bind(null, prop));
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_fragment__["a" /* Plugin */]);

var vue = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    store: __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3_router__["a" /* default */],
    Moment: __WEBPACK_IMPORTED_MODULE_4_moment___default.a,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2_App_vue___default.a);
    }
}).$mount('#app');

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        formatServerDate: function formatServerDate(value) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, 'YYYY-MM-DD HH:mm:SS').format('DD/MM/YYYY HH:mm');
        }
    }
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        openPassport: function openPassport() {
            var passportContent = document.querySelector('.p-passport__content');
            var closeIconLoggedIn = document.querySelector('.p-passport__loggedin .p-passport__icon--close');
            var closeIconLoggedOut = document.querySelector('.p-passport__loggedout .p-passport__icon--close');
            var loginTopBar = document.querySelector('.p-passport__loggedin');
            var logoutTopBar = document.querySelector('.p-passport__loggedout');
            var loginContent = document.querySelector('.p-passport__content-loggedin');
            var logoutContent = document.querySelector('.p-passport__content-loggedout');

            var buttonList = document.querySelectorAll(".p-passport__login-button, .p-passport__logout-button");
            var topbarList = document.querySelectorAll(".p-passport__logo, .p-passport__loggedin .p-passport__icon--close, .p-passport__loggedout .p-passport__icon--close");
            var loginButton = document.querySelectorAll(".loginButton");

            var valueArray = [{ elem: passportContent, disp: 'flex' }, { elem: closeIconLoggedIn, disp: 'block' }, { elem: closeIconLoggedOut, disp: 'block' }];

            for (var i = 0; i < valueArray.length; i++) {
                valueArray[i].elem.style.display = valueArray[i].elem.style.display === valueArray[i].disp ? '' : valueArray[i].disp;
            }
        }
    }
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_404_404_vue__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_404_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_404_404_vue__);


/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'fourOFour',
    path: '/*',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_404_404_vue___default.a
}]);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_503_503_vue__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_503_503_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_503_503_vue__);


/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'fiveOThree',
    path: '/*',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_503_503_vue___default.a
}]);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_claims_dashboard_ClaimsDashboard_vue__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_claims_dashboard_ClaimsDashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_claims_dashboard_ClaimsDashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_routingMethods__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'claims',
    path: '/claims',
    beforeEnter: function beforeEnter(to, from, next) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
    },
    component: __WEBPACK_IMPORTED_MODULE_0_pages_claims_dashboard_ClaimsDashboard_vue___default.a
}]);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompareValues__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompareValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CompareValues__);


/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'compare',
    path: '/compare',
    component: __WEBPACK_IMPORTED_MODULE_0__CompareValues___default.a
}]);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_discount_rate_comparison_DiscountRateComparison_vue__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_discount_rate_comparison_DiscountRateComparison_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_discount_rate_comparison_DiscountRateComparison_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_discount_rate_comparison_UpdateDiscountRate_vue__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_discount_rate_comparison_UpdateDiscountRate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_discount_rate_comparison_UpdateDiscountRate_vue__);



/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'discount-rate-comparison',
    path: '/discount-rate-comparison',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_discount_rate_comparison_DiscountRateComparison_vue___default.a
}, {
    name: 'update-discount-rate',
    path: '/update-discount-rate',
    component: __WEBPACK_IMPORTED_MODULE_1_pages_discount_rate_comparison_UpdateDiscountRate_vue___default.a
}]);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_executive_dashboard_ExecutiveDashboard_vue__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_executive_dashboard_ExecutiveDashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_executive_dashboard_ExecutiveDashboard_vue__);


/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'executive-dashboard',
    path: '/executive-dashboard',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_executive_dashboard_ExecutiveDashboard_vue___default.a
}]);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        period: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        dependant: {
            type: Number,
            default: null
        }
    },
    data: function data() {
        return {
            incomeType: 'net'
        };
    },

    computed: {
        innerPeriod: function innerPeriod() {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.period);
        },

        userValue: {
            get: function get() {
                return this.innerPeriod[this.innerPeriod.pensionIncomeType + 'PensionIncome'];
            },
            set: function set(value) {
                this.innerPeriod[this.innerPeriod.pensionIncomeType + 'PensionIncome'] = value;
                this.update();
            }
        },
        pensionType: {
            get: function get() {
                return this.innerPeriod.pensionIncomeType;
            },
            set: function set(value) {
                this.innerPeriod[value + 'PensionIncome'] = this.userValue;
                this.innerPeriod.pensionIncomeType = value;
                this.update();
            }
        },
        userIncomeType: {
            get: function get() {
                return this.incomeType;
            },
            set: function set(value) {
                this.incomeType = value;
                this.userIncomeValue = this.innerPeriod[this.incomeType + 'Income'];
            }
        },
        userIncomeValue: {
            get: function get() {
                return this.innerPeriod[this.incomeType + 'Income'];
            },
            set: function set(value) {
                this.innerPeriod[this.incomeType + 'Income'] = value;
                this.update();
            }
        }
    },
    methods: {
        update: function update() {
            this.$emit('update', {
                index: this.index,
                period: this.innerPeriod,
                dependant: this.dependant
            });
        }
    }
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_fatal_accident_claims_FatalAccidentClaims_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_fatal_accident_claims_FatalAccidentClaims_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_fatal_accident_claims_FatalAccidentClaims_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_dependency_routes__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_estate_routes__ = __webpack_require__(235);




/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'fatal',
    path: '/fatal-accidents/:id(\\d+)?',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_fatal_accident_claims_FatalAccidentClaims_vue___default.a,
    children: [__WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_dependency_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_pages_fatal_accident_claims_estate_routes__["a" /* default */]]
}]);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_market_analysis_MarketAnalysis_vue__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_market_analysis_MarketAnalysis_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_market_analysis_MarketAnalysis_vue__);


/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'market-analysis',
    path: '/market-analysis',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_market_analysis_MarketAnalysis_vue___default.a
}]);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PslaModal__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PslaModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PslaModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PastLossEarningsModal__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PastLossEarningsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PastLossEarningsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PastServicesModal__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PastServicesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PastServicesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BereavementAwardModal__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BereavementAwardModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BereavementAwardModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CareModal__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CareModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CareModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FuneralExpensesModal__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FuneralExpensesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FuneralExpensesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MiscModal__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MiscModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MiscModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DependencyServicesModal__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DependencyServicesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DependencyServicesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DependencyIncomeModal__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DependencyIncomeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DependencyIncomeModal__);










/* harmony default export */ __webpack_exports__["a"] = ({
    PslaModal: __WEBPACK_IMPORTED_MODULE_0__PslaModal___default.a,
    PastLossEarningsModal: __WEBPACK_IMPORTED_MODULE_1__PastLossEarningsModal___default.a,
    PastServicesModal: __WEBPACK_IMPORTED_MODULE_2__PastServicesModal___default.a,
    BereavementAwardModal: __WEBPACK_IMPORTED_MODULE_3__BereavementAwardModal___default.a,
    CareModal: __WEBPACK_IMPORTED_MODULE_4__CareModal___default.a,
    FuneralExpensesModal: __WEBPACK_IMPORTED_MODULE_5__FuneralExpensesModal___default.a,
    MiscModal: __WEBPACK_IMPORTED_MODULE_6__MiscModal___default.a,
    DependencyServicesModal: __WEBPACK_IMPORTED_MODULE_7__DependencyServicesModal___default.a,
    DependencyIncomeModal: __WEBPACK_IMPORTED_MODULE_8__DependencyIncomeModal___default.a
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PslaModal__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PslaModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PslaModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PastLossEarningsModal__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PastLossEarningsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PastLossEarningsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PastServicesModal__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PastServicesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PastServicesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BereavementAwardModal__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BereavementAwardModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BereavementAwardModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CareModal__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CareModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CareModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FuneralExpensesModal__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FuneralExpensesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FuneralExpensesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MiscModal__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MiscModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MiscModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DependencyServicesModal__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DependencyServicesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DependencyServicesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LossOfIncomeModal__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LossOfIncomeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__LossOfIncomeModal__);










/* harmony default export */ __webpack_exports__["a"] = ({
    PslaModal: __WEBPACK_IMPORTED_MODULE_0__PslaModal___default.a,
    PastLossEarningsModal: __WEBPACK_IMPORTED_MODULE_1__PastLossEarningsModal___default.a,
    PastServicesModal: __WEBPACK_IMPORTED_MODULE_2__PastServicesModal___default.a,
    BereavementAwardModal: __WEBPACK_IMPORTED_MODULE_3__BereavementAwardModal___default.a,
    CareModal: __WEBPACK_IMPORTED_MODULE_4__CareModal___default.a,
    FuneralExpensesModal: __WEBPACK_IMPORTED_MODULE_5__FuneralExpensesModal___default.a,
    MiscModal: __WEBPACK_IMPORTED_MODULE_6__MiscModal___default.a,
    DependencyServicesModal: __WEBPACK_IMPORTED_MODULE_7__DependencyServicesModal___default.a,
    LossOfIncomeModal: __WEBPACK_IMPORTED_MODULE_8__LossOfIncomeModal___default.a
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Reserving__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Reserving___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Reserving__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustomAssessment__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustomAssessment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CustomAssessment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DayOneSimple__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DayOneSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DayOneSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__day_one_fatal_Form__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__day_one_fatal_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__day_one_fatal_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__day_one_fatal_Results__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__day_one_fatal_Results___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__day_one_fatal_Results__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day_one_lost_Form__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day_one_lost_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__day_one_lost_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__day_one_lost_Results__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__day_one_lost_Results___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__day_one_lost_Results__);








/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'reserving',
    path: '/reserving',
    component: __WEBPACK_IMPORTED_MODULE_0__Reserving___default.a,
    children: [{
        name: 'reserving::day-one-assessment',
        path: 'day-one-assessment',
        component: __WEBPACK_IMPORTED_MODULE_2__components_DayOneSimple___default.a,
        children: [{
            name: 'reserving::day-one-assessment::fatal',
            path: 'fatal',
            components: {
                form: __WEBPACK_IMPORTED_MODULE_3__day_one_fatal_Form___default.a,
                results: __WEBPACK_IMPORTED_MODULE_4__day_one_fatal_Results___default.a
            }
        }, {
            name: 'reserving::day-one-assessment::lost',
            path: 'lost',
            components: {
                form: __WEBPACK_IMPORTED_MODULE_5__day_one_lost_Form___default.a,
                results: __WEBPACK_IMPORTED_MODULE_6__day_one_lost_Results___default.a
            }
        }]
    }, {
        name: 'reserving::custom-assessment',
        path: 'custom-assessment',
        component: __WEBPACK_IMPORTED_MODULE_1__CustomAssessment___default.a
    }]
}]);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_resources_and_tools_ResourcesAndTools_vue__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_resources_and_tools_ResourcesAndTools_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_resources_and_tools_ResourcesAndTools_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_resources_and_tools_OgdenTable_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_resources_and_tools_OgdenTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pages_resources_and_tools_OgdenTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_resources_and_tools_Documents_vue__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_resources_and_tools_Documents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pages_resources_and_tools_Documents_vue__);




/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'resources-and-tools',
    path: '/resources-and-tools/',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_resources_and_tools_ResourcesAndTools_vue___default.a,
    children: [{
        name: 'ogden-table',
        path: 'ogden-table-viewer',
        component: __WEBPACK_IMPORTED_MODULE_1_pages_resources_and_tools_OgdenTable_vue___default.a
    }, {
        name: 'at-a-glance',
        path: 'at-a-glance-viewer',
        component: __WEBPACK_IMPORTED_MODULE_1_pages_resources_and_tools_OgdenTable_vue___default.a
    }, {
        name: 'randt::documents',
        path: 'documents',
        component: __WEBPACK_IMPORTED_MODULE_2_pages_resources_and_tools_Documents_vue___default.a
    }]

}]);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_Homepage_vue__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_Homepage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_Homepage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_routes__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_lost_years_claims_routes__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_claims_dashboard_routes__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_routes__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_resources_and_tools_routes__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_routes__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_executive_dashboard_routes__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_reserving_routes__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_market_analysis_routes__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_support_routes__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_compare_routes__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_discount_rate_comparison_routes__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_404_routes__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_503_routes__ = __webpack_require__(836);
var _ref;

















/* harmony default export */ __webpack_exports__["a"] = ((_ref = [{
    name: 'homepage',
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0_pages_Homepage_vue___default.a
}]).concat.apply(_ref, [__WEBPACK_IMPORTED_MODULE_1_pages_fatal_accident_claims_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_pages_lost_years_claims_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_pages_claims_dashboard_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_pages_mini_calculators_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_pages_resources_and_tools_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_pages_personal_injury_claims_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_pages_executive_dashboard_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_pages_reserving_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_pages_market_analysis_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_pages_support_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_pages_compare_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_pages_discount_rate_comparison_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13_pages_404_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_pages_503_routes__["a" /* default */]]));

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_support_Support_vue__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_support_Support_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_support_Support_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_routingMethods__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'support',
    path: '/support',
    beforeEnter: function beforeEnter(to, from, next) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_routingMethods__["a" /* beforeEnter */])(to, from, next);
    },
    component: __WEBPACK_IMPORTED_MODULE_0_pages_support_Support_vue___default.a
}]);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAuthenticated;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(15);


var notAuthRoues = ["/", "/support"];

function isAuthenticated(to, from, next) {
    var token = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['user/getToken'];

    if (~notAuthRoues.indexOf(to.fullPath) || !!token) {
        next();
    } else {
        next("/");
    }
}

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'age';

/* harmony default export */ __webpack_exports__["a"] = ({
  retirementAge: function retirementAge(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'retirement-age', data);
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'care';

/* harmony default export */ __webpack_exports__["a"] = ({
  autoCalculate: function autoCalculate(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'auto-calculate', data);
  },

  detailed: function detailed(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'detailed', data);
  },

  futureLossesForCare: function futureLossesForCare(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'future-losses-for-care', data);
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'day-one';

/* harmony default export */ __webpack_exports__["a"] = ({
  table28Multiplier: function table28Multiplier(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'table-28-multiplier', data);
  },

  tableEDiscount: function tableEDiscount(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'table-e-discount', data);
  },

  tableFDiscount: function tableFDiscount(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'table-f-discount', data);
  },

  generalDamages: function generalDamages(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'general-damages', data);
  },

  bereavementAward: function bereavementAward(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'bereavement-award', data);
  },

  funeralExpenses: function funeralExpenses(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'funeral-expenses', data);
  },

  pastLossOfEarnings: function pastLossOfEarnings(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'past-loss-of-earnings', data);
  },

  pastCostOfServices: function pastCostOfServices(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'past-cost-of-services', data);
  },

  futureCostOfServices: function futureCostOfServices(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'future-cost-of-services', data);
  },

  miscellaneousCalc: function miscellaneousCalc(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'miscellaneous-calc', data);
  },

  costOfCare: function costOfCare(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'cost-of-care', data);
  },

  dependencyOnIncome: function dependencyOnIncome(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'dependency-on-income', data);
  },

  dependencyOnServices: function dependencyOnServices(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'dependency-on-services', data);
  }
});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'education';

/* harmony default export */ __webpack_exports__["a"] = ({
  educationAttainment: function educationAttainment(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'education-attainment', data);
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'heads-of-loss';

/* harmony default export */ __webpack_exports__["a"] = ({
  bereavementAward: function bereavementAward(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'bereavement-award', data, false);
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'interest';

/* harmony default export */ __webpack_exports__["a"] = ({
  default: function _default(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'default', data);
  },

  custom: function custom(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'custom', data);
  }
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'life-expectancy';

/* harmony default export */ __webpack_exports__["a"] = ({
  ogden: function ogden(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'ogden', data);
  },

  percentageOfNormal: function percentageOfNormal(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'percentage-of-normal', data);
  },

  percentageReduction: function percentageReduction(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'percentage-reduction', data);
  }
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'multipliers';

/* harmony default export */ __webpack_exports__["a"] = ({
  preAssessment: function preAssessment(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'pre-assessment', data);
  },

  postAssessment: function postAssessment(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'post-assessment', data);
  },

  postAssessmentMultiplier: function postAssessmentMultiplier(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'post-assessment-multiplier', data);
  },

  table1And2: function table1And2(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'table-1-and-2', data);
  },

  table28: function table28(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'table-28', data);
  },

  contingencyMultiplier: function contingencyMultiplier(data) {
    data.claim.assumedSettlement = moment(data.claim.assumedSettlement, 'DD/MM/YYYY').format('YYYY-MM-DD');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'contingency-multiplier', data);
  },

  preInjuryContingencyMultiplierPayload: function preInjuryContingencyMultiplierPayload(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'pre-injury-contingency-multiplier', data);
  },

  assessmentContingencyMultiplierPayload: function assessmentContingencyMultiplierPayload(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'assessment-contingency-multiplier', data);
  },

  purchase: function purchase(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'purchase', data);
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'pension';

/* harmony default export */ __webpack_exports__["a"] = ({
  pensionLossMultiplier: function pensionLossMultiplier(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'pension-multiplier', data);
  },

  lumpSumMultiplier: function lumpSumMultiplier(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'pension-loss', data);
  }
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__ = __webpack_require__(46);



var RESOURCE = 'services';

/* harmony default export */ __webpack_exports__["a"] = ({
  futureLossesForServices: function futureLossesForServices(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculatorModals__["b" /* RESOURCE */] + '/' + RESOURCE, 'future-losses-for-services', data);
  }
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculators__ = __webpack_require__(118);



var RESOURCE = 'ons';

/* harmony default export */ __webpack_exports__["a"] = ({
  salary: function salary(gender) {
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'salary', { code: code, gender: gender });
  },

  averageSalary: function averageSalary() {
    var gender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'male';
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_calculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'average-salary', { gender: gender });
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);


var RESOURCE = 'claims';

/* harmony default export */ __webpack_exports__["a"] = ({
  save: function save(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'save', data);
  },

  load: function load(claimId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'load', { claim_id: claimId });
  },

  search: function search(data, page, order, sort) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'search', { data: data, page: page, order: order, sort: sort });
  },

  delete: function _delete(claimId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'delete', { claim_id: claimId });
  },

  update: function update(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'update', data);
  },

  updateCosts: function updateCosts(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'costs', data);
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);


var RESOURCE = 'contacts';

/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])('' + RESOURCE, 'search', data).then(function (data) {
      return {
        data: data
      };
    });
  }
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__ = __webpack_require__(120);



/* harmony default export */ __webpack_exports__["a"] = ({
  results: function results(payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])('' + __WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__["b" /* RESOURCE */], 'discount-rate-comparison', payload);
  },

  preview: function preview(payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])('' + __WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__["b" /* RESOURCE */], 'discount-rate-preview', payload);
  },

  apply: function apply(payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])('' + __WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__["b" /* RESOURCE */], 'apply-discount-rate-update', payload);
  },

  checkProgress: function checkProgress(payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])('' + __WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__["b" /* RESOURCE */], 'discount-rate-progress', payload);
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_api_dashboards__ = __webpack_require__(120);




var RESOURCE = 'executive';

/* harmony default export */ __webpack_exports__["a"] = ({
  averageReserves: function averageReserves(filters) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_2_services_api_dashboards__["b" /* RESOURCE */] + '/' + RESOURCE, 'averageReserves', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      chartType: 'averageReserves'
    }, filters));
  },

  totalReserves: function totalReserves(filters) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_2_services_api_dashboards__["b" /* RESOURCE */] + '/' + RESOURCE, 'totalReserves', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      chartType: 'totalReserves'
    }, filters));
  },

  trendsInReserves: function trendsInReserves(filters) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_2_services_api_dashboards__["b" /* RESOURCE */] + '/' + RESOURCE, 'trendsInReserves', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      chartType: 'trendsInReserves'
    }, filters));
  }
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__ = __webpack_require__(120);



var RESOURCE = 'reserving';

/* harmony default export */ __webpack_exports__["a"] = ({
  dayOneAssessment: function dayOneAssessment(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__["b" /* RESOURCE */] + '/' + RESOURCE, 'advanced-assessment', data);
  },

  averageReserves: function averageReserves(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__["b" /* RESOURCE */] + '/' + RESOURCE, 'average', {
      disease_type: data.diseaseType
    });
  },

  simpleAssessment: function simpleAssessment(claim, person) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__["b" /* RESOURCE */] + '/' + RESOURCE, 'simple-assessment', { claim: claim, person: person });
  },

  compareAssessment: function compareAssessment(diseaseOrAccident, injuryType, claimType, discountRate, from, to) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_dashboards__["b" /* RESOURCE */] + '/' + RESOURCE, 'compare', { diseaseOrAccident: diseaseOrAccident, injuryType: injuryType, claimType: claimType, discountRate: discountRate, from: from, to: to, type: null });
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);


var RESOURCE = 'exceptions';

/* harmony default export */ __webpack_exports__["a"] = ({
    errors: function errors(data) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'slack', {
            type: 'Error',
            error_msg: data.err.message,
            error_stack: data.err.stack
        });
    },
    warnings: function warnings(data) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'slack', {
            type: 'Warning',
            error_msg: data.msg,
            error_stack: data.trace
        });
    }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);


var RESOURCE = 'generated-documents';

/* harmony default export */ __webpack_exports__["a"] = ({
  load: function load(claimId, page, filter) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'load', { claim_id: claimId, page: page, filter: filter });
  },

  save: function save(document) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'save', { document: document });
  },

  create: function create(type, claimId, claimType, discountRate) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'create', {
      claim_id: claimId,
      claim_type: claimType,
      type: type,
      discount_rate: discountRate
    });
  },

  delete: function _delete(document) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'delete', { document_id: document.id });
  },

  headsOfLoss: function headsOfLoss(claimId, discountRate) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(RESOURCE, 'fetchHeadsOfLoss', {
      claim_id: claimId,
      discount_rate: discountRate
    });
  }
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__ = __webpack_require__(71);



var RESOURCE = 'care';

/* harmony default export */ __webpack_exports__["a"] = ({
  careRates: function careRates() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'load');
  },
  findPeriods: function findPeriods(carePeriod) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'find-periods', { carePeriod: carePeriod });
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__ = __webpack_require__(71);



var RESOURCE = 'dates';

/* harmony default export */ __webpack_exports__["a"] = ({
  PeriodBetweenTwoDates: function PeriodBetweenTwoDates(dates) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'period-between-two-dates', {
      start_date: dates.firstDate,
      end_date: dates.secondDate,
      options: dates.options
    });
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__ = __webpack_require__(71);



var RESOURCE = 'pension';

/* harmony default export */ __webpack_exports__["a"] = ({
  calculate: function calculate(income) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'gross-net-pension', {
      fiscalYear: income.fiscalYear,
      income: income.income,
      pensionType: income.pensionType.toLowerCase()
    });
  }
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__ = __webpack_require__(71);



var RESOURCE = 'life-expectancy';

/* harmony default export */ __webpack_exports__["a"] = ({
  ogden: function ogden(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'ogden', data);
  },

  percentageOfNormal: function percentageOfNormal(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'percentage-of-normal', data);
  },

  percentageReduction: function percentageReduction(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'percentage-reduction', data);
  }

});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__ = __webpack_require__(71);



var RESOURCE = 'monetary';

/* harmony default export */ __webpack_exports__["a"] = ({
  interest: function interest(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'interest', {
      date_from: state.dateFrom,
      date_to: state.dateTo,
      interest_rate: state.interestRate,
      principal_amount: state.principalAmount,
      interest_type: state.interestType,
      compound_frequency: state.compoundFrequency
    });
  },
  careRates: function careRates() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_miniCalculators__["b" /* RESOURCE */] + '/' + RESOURCE, 'care/load-care-rates');
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_personalInjury__ = __webpack_require__(242);



var RESOURCE = 'general-damages';

/* harmony default export */ __webpack_exports__["a"] = ({
  injuries: function injuries(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_personalInjury__["b" /* RESOURCE */] + '/' + RESOURCE, 'injuries', data);
  }
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);


var RESOURCE = 'documents';

/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(name, category, orderBy) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])('' + RESOURCE, 'search', { name: name, category: category, orderBy: orderBy });
  },
  all: function all() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])('' + RESOURCE, 'all');
  }
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_resources__ = __webpack_require__(243);



var RESOURCE = 'ogden-tables';

/* harmony default export */ __webpack_exports__["a"] = ({
  tableInfo: function tableInfo() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_resources__["b" /* RESOURCE */] + '/' + RESOURCE, 'load');
  },
  obtainValues: function obtainValues(ogdenTable) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_resources__["b" /* RESOURCE */] + '/' + RESOURCE, 'obtain-values', { ogdenTable: ogdenTable });
  },
  atAGlance: function atAGlance(discount, gender) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])(__WEBPACK_IMPORTED_MODULE_1_services_api_resources__["b" /* RESOURCE */] + '/' + RESOURCE, 'at-a-glance', { discount: discount, gender: gender });
  }
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);


var RESOURCE = 'support';

/* harmony default export */ __webpack_exports__["a"] = ({
  sendEmail: function sendEmail(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["b" /* endpoint */])('' + RESOURCE, 'send-email', data).then(function (data) {
      return {
        sent: data.response
      };
    });
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export endpoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);


var endpoint = function endpoint(action, payload) {
  var showRunning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_services_Api__["c" /* makeCall */])('/api/passport/' + ('' + action), payload, showRunning);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(data) {
    return endpoint('login', data);
  },
  logout: function logout() {
    return endpoint('logout');
  },
  authenticate: function authenticate(data) {
    return endpoint('authenticate', data);
  },
  heartbeat: function heartbeat() {
    return endpoint('heartbeat', null, false);
  }
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (__webpack_require__.i({"NODE_ENV":"production"})[key]) {
        return __webpack_require__.i({"NODE_ENV":"production"})[key];
    }
    return defaultValue;
});;

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _mutations;

var types = {
    REGISTER_ACCORDION: 'REGISTER_ACCORDION',
    CHANGE_DISPLAYED_ACCORDION: 'CHANGE_DISPLAYED_ACCORDION',
    DEREGISTER_ACCORDION: 'DEREGISTER_ACCORDION'
};

var state = {
    accordions: []
};

var getters = {
    isOpen: function isOpen(state) {
        return function (index) {
            return state.accordions[index];
        };
    }
};

var actions = {
    register: function register(_ref) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch;
        var keepClosed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        commit(types.REGISTER_ACCORDION);
        var index = state.accordions.length - 1;

        if (!keepClosed && !~state.accordions.indexOf(true)) {
            return dispatch('setOpen', index).then(function () {
                return index;
            });
        }
        return index;
    },
    setOpen: function setOpen(_ref2, index) {
        var commit = _ref2.commit;
        return commit(types.CHANGE_DISPLAYED_ACCORDION, index);
    },
    deregister: function deregister(_ref3, index) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        commit(types.DEREGISTER_ACCORDION, index);
        if (!~state.accordions.indexOf(true)) {
            return dispatch('setOpen', state.accordions.indexOf(false));
        }
    },
    openNext: function openNext(_ref4, index) {
        var commit = _ref4.commit,
            state = _ref4.state;

        var lastIndex = state.accordions.length - 1;
        if (index === lastIndex) {
            return commit(types.CHANGE_DISPLAYED_ACCORDION, index - 1);
        }

        return commit(types.CHANGE_DISPLAYED_ACCORDION, index + 1);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.REGISTER_ACCORDION, function (state) {
    state.accordions.push(false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.CHANGE_DISPLAYED_ACCORDION, function (state, index) {
    state.accordions = state.accordions.map(function (show, accordionIndex) {
        return accordionIndex === index;
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.DEREGISTER_ACCORDION, function (state, index) {
    delete state.accordions[index];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_modules_shared_chartData__ = __webpack_require__(959);



var _mutations;





var mutationTypes = {
    UPDATE_AVERAGE_RESERVES_CHART_DATA: 'UPDATE_AVERAGE_RESERVES_CHART_DATA',
    UPDATE_TOTAL_RESERVES_CHART_DATA: 'UPDATE_TOTAL_RESERVES_CHART_DATA',
    UPDATE_TRENDS_IN_RESERVES_CHART_DATA: 'UPDATE_TRENDS_IN_RESERVES_CHART_DATA',
    UPDATE_AVERAGE_RESERVES_TYPE: 'UPDATE_AVERAGE_RESERVES_TYPE',
    UPDATE_TOTAL_RESERVES_TYPE: 'UPDATE_TOTAL_RESERVES_TYPE',
    UPDATE_TRENDS_IN_RESERVES_TYPE: 'UPDATE_TRENDS_IN_RESERVES_TYPE',
    UPDATE_TRENDS_IN_RESERVES_PERIOD: 'UPDATE_TRENDS_IN_RESERVES_PERIOD',
    START_RUNNING: 'START_RUNNING',
    STOP_RUNNING: 'STOP_RUNNING',
    UPDATE_FILTER: 'UPDATE_FILTER'
};

function chartTemplate() {
    return {
        number: {
            chartData: {}
        },
        value: {
            chartData: {}
        }
    };
}

function trendTemplate() {
    return {
        total: {
            data: {}
        },
        average: {
            data: {}
        },
        number: {
            data: {}
        }
    };
}

function trendChartTemplate() {
    return {
        month: trendTemplate(),
        quarter: trendTemplate(),
        year: trendTemplate()
    };
}

var state = {
    filters: {
        claimStatus: null,
        claimType: null,
        diseaseOrAccident: null,
        diseaseType: null,
        accidentType: null,
        claimCost: 'all',
        fromDate: null,
        toDate: null,
        reserveValue: null,
        fromReserve: null,
        toReserve: null
    },
    averageReserve: {
        type: 'value',
        charts: {
            all: chartTemplate(),
            damages: chartTemplate(),
            claimantCosts: chartTemplate(),
            defenceCosts: chartTemplate()
        },
        running: false
    },
    totalReserve: {
        type: 'value',
        charts: {
            all: chartTemplate(),
            damages: chartTemplate(),
            claimantCosts: chartTemplate(),
            defenceCosts: chartTemplate()
        },
        running: false
    },
    trendReserve: {
        period: 'month',
        type: 'average',
        charts: {
            all: trendChartTemplate(),
            damages: trendChartTemplate(),
            claimantCosts: trendChartTemplate(),
            defenceCosts: trendChartTemplate()
        },
        running: false
    }
};

var getters = {
    getPeriod: function getPeriod(state) {
        return function (key) {
            return state[key].period;
        };
    },
    averageReservesChartData: function averageReservesChartData(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_modules_shared_chartData__["a" /* averageChartData */])(state, 'value');
    },
    totalReservesChartData: function totalReservesChartData(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_modules_shared_chartData__["b" /* totalChartData */])(state, 'value');
    },
    trendsInAverageReservesChartData: function trendsInAverageReservesChartData(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_modules_shared_chartData__["c" /* trendsChartData */])(state, 'average');
    },
    trendsInTotalReservesChartData: function trendsInTotalReservesChartData(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_modules_shared_chartData__["c" /* trendsChartData */])(state, 'total');
    },
    caseNumbersChartData: function caseNumbersChartData(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_modules_shared_chartData__["b" /* totalChartData */])(state, 'number');
    },
    caseNumbersTrendChartData: function caseNumbersTrendChartData(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_modules_shared_chartData__["c" /* trendsChartData */])(state, 'number');
    },
    getRunning: function getRunning(state) {
        return function (key) {
            return state[key].running;
        };
    },
    diseaseOrAccident: function diseaseOrAccident(state) {
        return state.filters.diseaseOrAccident;
    },
    diseaseType: function diseaseType(state) {
        return state.filters.diseaseType;
    },
    accidentType: function accidentType(state) {
        return state.filters.accidentType;
    },
    claimCost: function claimCost(state) {
        return state.filters.claimCost;
    },
    claimStatus: function claimStatus(state) {
        return state.filters.claimStatus;
    },
    claimType: function claimType(state) {
        return state.filters.claimType;
    },
    fromDate: function fromDate(state) {
        return state.filters.fromDate;
    },
    toDate: function toDate(state) {
        return state.filters.toDate;
    },
    reserveValue: function reserveValue(state) {
        return state.filters.reserveValue;
    },
    fromReserve: function fromReserve(state) {
        return state.filters.fromReserve;
    },
    toReserve: function toReserve(state) {
        return state.filters.toReserve;
    },
    diseaseTypeSelected: function diseaseTypeSelected(state) {
        return state.filters.diseaseType !== null;
    },
    accidentTypeSelected: function accidentTypeSelected(state) {
        return state.filters.accidentType !== null;
    }
};

var actions = {
    averageReserves: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref) {
        var dispatch = _ref.dispatch,
            commit = _ref.commit,
            state = _ref.state;

        commit(mutationTypes.START_RUNNING, 'averageReserve');

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].dashboards.executive.averageReserves(state.filters).then(function (data) {
            return dispatch('updateAverageReserves', data);
        }).then(function () {
            return commit(mutationTypes.STOP_RUNNING, 'averageReserve');
        });
    }, 100),

    totalReserves: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref2) {
        var dispatch = _ref2.dispatch,
            commit = _ref2.commit,
            state = _ref2.state;

        commit(mutationTypes.START_RUNNING, 'totalReserve');

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].dashboards.executive.totalReserves(state.filters).then(function (data) {
            return dispatch('updateTotalReserves', data);
        }).then(function () {
            return commit(mutationTypes.STOP_RUNNING, 'totalReserve');
        });
    }, 100),

    trendsInReserves: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref3) {
        var dispatch = _ref3.dispatch,
            commit = _ref3.commit,
            state = _ref3.state;

        commit(mutationTypes.START_RUNNING, 'trendReserve');

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].dashboards.executive.trendsInReserves(state.filters).then(function (data) {
            return dispatch('updateTrendsInReserve', data);
        }).then(function () {
            return commit(mutationTypes.STOP_RUNNING, 'trendReserve');
        });
    }, 0),

    updateAverageReserves: function updateAverageReserves(_ref4, data) {
        var commit = _ref4.commit;

        return commit(mutationTypes.UPDATE_AVERAGE_RESERVES_CHART_DATA, data);
    },
    updateTotalReserves: function updateTotalReserves(_ref5, data) {
        var commit = _ref5.commit;

        return commit(mutationTypes.UPDATE_TOTAL_RESERVES_CHART_DATA, data);
    },
    updateTrendsInReserve: function updateTrendsInReserve(_ref6, data) {
        var commit = _ref6.commit;

        return commit(mutationTypes.UPDATE_TRENDS_IN_RESERVES_CHART_DATA, data);
    },
    updateAverageReservesType: function updateAverageReservesType(_ref7, data) {
        var commit = _ref7.commit;

        return commit(mutationTypes.UPDATE_AVERAGE_RESERVES_TYPE, data);
    },
    updateTotalReservesType: function updateTotalReservesType(_ref8, data) {
        var commit = _ref8.commit;

        return commit(mutationTypes.UPDATE_TOTAL_RESERVES_TYPE, data);
    },
    updateTrendsInReservesType: function updateTrendsInReservesType(_ref9, data) {
        var commit = _ref9.commit;

        return commit(mutationTypes.UPDATE_TRENDS_IN_RESERVES_TYPE, data);
    },
    updateTrendsInReservesPeriod: function updateTrendsInReservesPeriod(_ref10, data) {
        var commit = _ref10.commit;

        return commit(mutationTypes.UPDATE_TRENDS_IN_RESERVES_PERIOD, data);
    },
    updateAll: function updateAll(_ref11) {
        var dispatch = _ref11.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([dispatch('averageReserves'), dispatch('totalReserves'), dispatch('trendsInReserves')]);
    },
    updateFilter: function updateFilter(_ref12, _ref13) {
        var commit = _ref12.commit,
            dispatch = _ref12.dispatch;
        var filter = _ref13.filter,
            value = _ref13.value;

        commit(mutationTypes.UPDATE_FILTER, { filter: filter, value: value });
        if (filter !== 'claimCost') {
            return dispatch('updateAll');
        }
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_AVERAGE_RESERVES_CHART_DATA, function (state, data) {
    state.averageReserve.charts = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TOTAL_RESERVES_CHART_DATA, function (state, data) {
    state.totalReserve.charts = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TRENDS_IN_RESERVES_CHART_DATA, function (state, data) {
    state.trendReserve.charts = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_AVERAGE_RESERVES_TYPE, function (state, data) {
    state.averageReserve.type = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TOTAL_RESERVES_TYPE, function (state, data) {
    state.totalReserve.type = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TRENDS_IN_RESERVES_TYPE, function (state, data) {
    state.trendReserve.type = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TRENDS_IN_RESERVES_PERIOD, function (state, data) {
    state.trendReserve.period = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.START_RUNNING, function (state, key) {
    state[key].running = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.STOP_RUNNING, function (state, key) {
    state[key].running = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FILTER, function (state, _ref14) {
    var filter = _ref14.filter,
        value = _ref14.value;

    state.filters[filter] = value;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {}
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectedClaims */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _mutations;




var mutationTypes = {
    RESET: 'RESET',
    UPDATE: 'UPDATE',
    TOGGLE_DISCOUNT_RATE: 'TOGGLE_DISCOUNT_RATE',
    UPDATE_PREVIEW_CLAIM: 'UPDATE_PREVIEW_CLAIM',
    UPDATE_PROGRESS: 'UPDATE_PROGRESS',
    CLEAR_PREVIEW_DATA: 'CLEAR_PREVIEW_DATA',
    CHECKING_CANCEL: 'CHECKING_CANCEL',
    CHECKING_CANCELLED: 'CHECKING_CANCELLED'
};

var selectedClaims = function selectedClaims(claims) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reject(claims, function (claim) {
        return !claim.selected;
    }).map(function (claim) {
        return claim.id;
    });
};

function getClaimsToBeUpdatedTotal(state) {
    var selected = state.preview.data.map(function (data) {
        return data.selected ? 1 : 0;
    });

    return selected.reduce(function (carry, total) {
        return carry + total;
    }, 0);
}

var state = {
    discountRates: ['-2.00', '-1.50', '-1.00', '-0.75', '-0.50', '-0.25', '0.00', '0.50', '1.00', '1.50', '2.00', '2.50', '3.00'],
    chosenRates: [],
    claimId: null,
    claimStatus: null,
    claimType: null,
    diseaseOrAccident: null,
    diseaseType: null,
    accidentType: null,
    gender: null,
    updateDiscountRate: null,
    discountRatesOptions: null,
    results: {},
    preview: {
        data: [],
        total: 0,
        perPage: 5,
        from: 1,
        to: 0,
        currentPage: 1,
        lastPage: 2
    },
    loading: false,
    progress: {
        numberOfClaims: 0,
        numberCompleted: 0
    },
    processing: false,
    cancelCheck: false
};

var result = function result(state) {
    for (var _len = arguments.length, nodes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        nodes[_key - 1] = arguments[_key];
    }

    return nodes.reduce(function (nested, key) {
        return !nested ? {} : nested[key];
    }, state);
};

var getters = {
    individualClaim: function individualClaim(state) {
        return state.claimStatus === 'individual';
    },
    averageDataset: function averageDataset(state) {
        return function (rate) {
            return [state['results']['average'][rate]['pastLosses'], state['results']['average'][rate]['futureLosses']];
        };
    },
    averageTotal: function averageTotal(state) {
        return function (rate) {
            return result(state, 'results', 'average', rate, 'total');
        };
    },
    averageHeadsOfLossGraph: function averageHeadsOfLossGraph(state) {
        return function (rate) {
            return result(state, 'results', 'headsOfLoss', 'graphs', 'average')[rate];
        };
    },
    averageHeadsOfLossTable: function averageHeadsOfLossTable(state) {
        return result(state, 'results', 'headsOfLoss', 'tables', 'average');
    },
    totalDataset: function totalDataset(state) {
        return function (rate) {
            return [state['results']['total'][rate]['pastLosses'], state['results']['total'][rate]['futureLosses']];
        };
    },
    totalTotal: function totalTotal(state) {
        return function (rate) {
            return result(state, 'results', 'total', rate, 'total');
        };
    },
    totalHeadsOfLossGraph: function totalHeadsOfLossGraph(state) {
        return function (rate) {
            return result(state, 'results', 'headsOfLoss', 'graphs', 'total')[rate];
        };
    },
    totalHeadsOfLossTable: function totalHeadsOfLossTable(state) {
        return result(state, 'results', 'headsOfLoss', 'tables', 'total');
    },
    ageGroupGraph: function ageGroupGraph(state) {
        return function (rate) {
            return result(state, 'results', 'assessmentsByAge', 'ageGroup')[rate];
        };
    },
    rateGroupGraph: function rateGroupGraph(state) {
        return result(state, 'results', 'assessmentsByAge', 'rateGroup');
    },
    claimsToBeUpdatedTotal: function claimsToBeUpdatedTotal(state) {
        return getClaimsToBeUpdatedTotal(state);
    }
};

var actions = {
    update: function update(_ref, _update) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;

        if (_update.key !== 'discountRatesOptions') {
            dispatch('clearPreview');
        }
        commit(mutationTypes.UPDATE, _update);
    },
    clearPreview: function clearPreview(_ref2) {
        var commit = _ref2.commit;

        commit(mutationTypes.CLEAR_PREVIEW_DATA);
    },
    updateClaimSelect: function updateClaimSelect(_ref3, claimId) {
        var state = _ref3.state,
            commit = _ref3.commit;

        var key = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(state.preview.data, function (value, key) {
            if (value.id === claimId) {
                return key;
            }
        });

        commit(mutationTypes.UPDATE_PREVIEW_CLAIM, { key: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(key)[0] });
    },
    toggleDiscountRate: function toggleDiscountRate(_ref4, rate) {
        var commit = _ref4.commit;

        commit(mutationTypes.TOGGLE_DISCOUNT_RATE, rate);
        commit(mutationTypes.UPDATE, { key: 'results', value: {} });
    },
    compare: function compare(_ref5) {
        var commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        commit(mutationTypes.UPDATE, { key: 'loading', value: true });

        dispatch('update', { key: 'results', value: {} }).then(function () {
            __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].dashboards.discountComparison.results({
                chosenRates: state.chosenRates,
                claimId: state.claimId,
                claimStatus: state.claimStatus,
                claimType: state.claimType,
                diseaseOrAccident: state.diseaseOrAccident,
                diseaseType: state.diseaseType,
                accidentType: state.accidentType,
                gender: state.gender
            }).then(function (results) {
                var value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys)(results, function (value, key) {
                    var hasNumber = /\d/;
                    if (hasNumber.test(key)) {
                        return key;
                    }

                    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.camelCase(key);
                });
                commit(mutationTypes.UPDATE, { key: 'results', value: value });
                commit(mutationTypes.UPDATE, { key: 'loading', value: false });
            });
        });
    },
    loadPreview: function loadPreview(_ref6) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        commit(mutationTypes.UPDATE, { key: 'loading', value: true });


        dispatch('clearPreview').then(function () {
            __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].dashboards.discountComparison.preview({
                chosenRate: state.discountRates[state.updateDiscountRate],
                claimStatus: state.claimStatus,
                claimType: state.claimType,
                diseaseOrAccident: state.diseaseOrAccident,
                diseaseType: state.diseaseType,
                accidentType: state.accidentType,
                gender: state.gender,
                page: state.preview.currentPage
            }).then(function (preview) {
                var value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys)(preview.claims, function (value, key) {
                    if (~key.indexOf('%')) {
                        return key;
                    }

                    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.camelCase(key);
                });

                commit(mutationTypes.UPDATE, { key: 'preview', value: value });
                commit(mutationTypes.UPDATE, { key: 'loading', value: false });
            });
        });
    },
    apply: function apply(_ref7) {
        var commit = _ref7.commit,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        commit(mutationTypes.UPDATE, { key: 'processing', value: true });
        commit(mutationTypes.UPDATE_PROGRESS, { key: 'numberOfClaims', value: 0 });
        commit(mutationTypes.UPDATE_PROGRESS, { key: 'numberCompleted', value: 0 });

        __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].dashboards.discountComparison.apply({
            chosenRate: state.discountRates[state.updateDiscountRate],
            applyTo: state.discountRatesOptions,
            selectedClaims: selectedClaims(state.preview.data)
        }).then(function () {
            return dispatch('checkProgress');
        });
    },
    checkProgress: function checkProgress(_ref8) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        if (state.cancelCheck) {
            commit(mutationTypes.CHECKING_CANCELLED);
            return;
        }
        __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].dashboards.discountComparison.checkProgress().then(function (response) {
            if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(response.progress)) {
                commit(mutationTypes.UPDATE, { key: 'processing', value: true });
                commit(mutationTypes.UPDATE_PROGRESS, {
                    key: 'numberOfClaims',
                    value: response.progress.number_of_claims
                });
                commit(mutationTypes.UPDATE_PROGRESS, {
                    key: 'numberCompleted',
                    value: response.progress.number_completed
                });

                setTimeout(function () {
                    dispatch('checkProgress');
                }, 1000);

                return;
            }

            setTimeout(function () {
                commit(mutationTypes.UPDATE, { key: 'processing', value: false });
                dispatch('reset');
                return;
            }, 8000);
        });
    },
    cancelChecking: function cancelChecking(_ref9) {
        var commit = _ref9.commit;

        commit(mutationTypes.CHECKING_CANCEL);
    },
    reset: function reset(_ref10) {
        var commit = _ref10.commit;

        commit(mutationTypes.UPDATE, { key: 'loading', value: false });
        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.chosenRates = [];
    state.claimId = null;
    state.claimStatus = null;
    state.claimType = null;
    state.diseaseOrAccident = null;
    state.diseaseType = null;
    state.accidentType = null;
    state.gender = null;
    state.updateDiscountRate = null;
    state.discountRatesOptions = null;
    state.results = {};
    state.preview = {
        data: [],
        total: 0,
        perPage: 5,
        from: 1,
        to: 0,
        currentPage: 1,
        lastPage: 2
    };
    state.loading = false;
    state.progress = {
        numberOfClaims: 0,
        numberCompleted: 0
    };
    state.processing = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, _ref11) {
    var key = _ref11.key,
        value = _ref11.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_PROGRESS, function (state, _ref12) {
    var key = _ref12.key,
        value = _ref12.value;

    state.progress[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CLEAR_PREVIEW_DATA, function (state) {
    state.preview.data = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.TOGGLE_DISCOUNT_RATE, function (state, rate) {
    var index = state.chosenRates.indexOf(rate);

    index === -1 ? state.chosenRates.push(rate) : state.chosenRates.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_PREVIEW_CLAIM, function (state, _ref13) {
    var key = _ref13.key;

    state.preview.data[key].selected = !state.preview.data[key].selected;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CHECKING_CANCEL, function (state) {
    state.cancelCheck = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CHECKING_CANCELLED, function (state) {
    state.cancelCheck = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {}
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);




var _mutations;





var types = {
    RESET: 'RESET',
    SET_API_REQUEST_IN_PROGRESS: 'SET_API_REQUEST_IN_PROGRESS',
    SET_API_REQUEST_COMPLETE: 'SET_API_REQUEST_COMPLETE',
    UPDATE_FULL_LIST: 'UPDATE_FULL_LIST',
    UPDATE_DOCUMENT: 'UPDATE_DOCUMENT',
    UPDATE_DATA: 'UPDATE_DATA',
    TOGGLE_EDITING_DOCUMENT: 'TOGGLE_EDITING_DOCUMENT',
    QUIT_EDITING_DOCUMENT: 'QUIT_EDITING_DOCUMENT',
    DELETE_GENERATED_DOCUMENT: 'DELETE_GENERATED_DOCUMENT',
    UPDATE_SHOW_INTEREST: 'UPDATE_SHOW_INTEREST',
    EXIT_EDITING_DOCUMENT_ATTEMPTED: 'EXIT_EDITING_DOCUMENT_ATTEMPTED',
    EXIT_EDITING_DOCUMENT_FAILED: 'EXIT_EDITING_DOCUMENT_FAILED',
    UPDATE_DOCUMENT_NAME: 'UPDATE_DOCUMENT_NAME',
    UPDATE_PAGINATION: 'UPDATE_PAGINATION',
    UPDATE_HEADS_OF_LOSS: 'UPDATE_HEADS_OF_LOSS'
};

var state = {
    requesting: false,
    generatedDocuments: [],
    editingDocument: -1,
    exitAllowed: false,
    showingExitNotification: false,
    pagination: {
        total: 0,
        per_page: 0,
        from: 0,
        to: 0,
        current_page: 0,
        last_page: 0
    },
    headsOfLoss: {}
};

var getters = {
    getRequestStatus: function getRequestStatus(state) {
        return state.requesting;
    },
    getGeneratedDocuments: function getGeneratedDocuments() {
        return state.generatedDocuments;
    },
    getGeneratedDocument: function getGeneratedDocument(state) {
        return function (index) {
            return state.generatedDocuments[index];
        };
    },
    getEditingDocument: function getEditingDocument(state) {
        return state.editingDocument;
    },
    getShowInterest: function getShowInterest(state) {
        return function (index) {
            return state.generatedDocuments[index].show_interest;
        };
    },
    getDocumentDataByKey: function getDocumentDataByKey(state) {
        return function (_ref) {
            var index = _ref.index,
                key = _ref.key;

            if (typeof index === 'undefined') {
                return 0;
            }
            if (state.generatedDocuments[index].data === null) {
                return 0;
            }
            return state.generatedDocuments[index].data[key];
        };
    },
    showingExitNotification: function showingExitNotification(state) {
        return state.showingExitNotification;
    },
    getExitAllowed: function getExitAllowed(state) {
        return state.exitAllowed;
    },
    getDocumentsByType: function getDocumentsByType(state) {
        return function (type) {
            return state.generatedDocuments.filter(function (generatedDocument) {
                return generatedDocument.type === type;
            }).sort(function (a, b) {
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(a.updated_at, 'YYYY-MM-DD HH:mm:ss').isBefore(__WEBPACK_IMPORTED_MODULE_4_moment___default()(b.updated_at, 'YYYY-MM-DD HH:mm:ss')) ? 1 : -1;
            });
        };
    },
    getPagination: function getPagination() {
        return state.pagination;
    },
    getHeadsOfLoss: function getHeadsOfLoss(state) {
        return state.headsOfLoss;
    }
};

var actions = {
    resetDocuments: function resetDocuments(_ref2) {
        var commit = _ref2.commit;

        commit(types.RESET);
    },
    setApiRequestInProgress: function setApiRequestInProgress(_ref3) {
        var commit = _ref3.commit;

        commit(types.SET_API_REQUEST_IN_PROGRESS);
    },
    setApiRequestComplete: function setApiRequestComplete(_ref4) {
        var commit = _ref4.commit;

        commit(types.SET_API_REQUEST_COMPLETE);
    },
    quitEditingDocument: function quitEditingDocument(_ref5) {
        var commit = _ref5.commit;

        commit(types.QUIT_EDITING_DOCUMENT);
    },
    exitAttempted: function exitAttempted(_ref6) {
        var commit = _ref6.commit;

        commit(types.EXIT_EDITING_DOCUMENT_ATTEMPTED);
    },
    exitClosed: function exitClosed(_ref7) {
        var commit = _ref7.commit;

        commit(types.EXIT_EDITING_DOCUMENT_FAILED);
    },
    toggleEditingDocument: function toggleEditingDocument(_ref8, document) {
        var commit = _ref8.commit;

        commit(types.TOGGLE_EDITING_DOCUMENT, document);
    },
    deleteGeneratedDocument: function deleteGeneratedDocument(_ref9, document) {
        var commit = _ref9.commit,
            dispatch = _ref9.dispatch;

        dispatch('setApiRequestInProgress');
        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].generatedDocuments.delete(document).then(function () {
            commit(types.DELETE_GENERATED_DOCUMENT, document);
            dispatch('setApiRequestComplete');
        });
    },
    getGeneratedDocumentsFromServer: function getGeneratedDocumentsFromServer(_ref10, _ref11) {
        var commit = _ref10.commit,
            dispatch = _ref10.dispatch;
        var claimId = _ref11.claimId,
            page = _ref11.page,
            filter = _ref11.filter;

        dispatch('setApiRequestInProgress');
        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].generatedDocuments.load(claimId, page, filter).then(function (data) {
            commit(types.UPDATE_FULL_LIST, data);
            commit(types.UPDATE_PAGINATION, data);
            dispatch('setApiRequestComplete');
        });
    },
    saveGeneratedDocument: function saveGeneratedDocument(_ref12, _ref13) {
        var commit = _ref12.commit;
        var index = _ref13.index,
            document = _ref13.document;

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].generatedDocuments.save(document).then(function (data) {
            commit(types.UPDATE_DOCUMENT, { data: data, index: index });
        });
    },
    createGeneratedDocument: function createGeneratedDocument(_ref14, _ref15) {
        var commit = _ref14.commit,
            dispatch = _ref14.dispatch,
            getters = _ref14.getters;
        var type = _ref15.type,
            claimId = _ref15.claimId,
            claimType = _ref15.claimType,
            discountRate = _ref15.discountRate;

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].generatedDocuments.create(type, claimId, claimType, discountRate).then(function (data) {
            commit(types.UPDATE_FULL_LIST, data);
            dispatch('toggleEditingDocument', getters['getDocumentsByType'](type)[0]);
            return data;
        });
    },
    updateDocument: function updateDocument(_ref16, _ref17) {
        var dispatch = _ref16.dispatch;
        var index = _ref17.index,
            document = _ref17.document;

        var proms = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(document).filter(userSettable()).map(function (key) {
            return dispatch('updateDocumentValue', { key: key, value: document[key], index: index });
        });

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(proms);
    },
    updateDocumentName: function updateDocumentName(_ref18, _ref19) {
        var commit = _ref18.commit;
        var index = _ref19.index,
            value = _ref19.value;

        commit(types.UPDATE_DOCUMENT_NAME, { index: index, value: value });
    },
    updateDataByKey: function updateDataByKey(_ref20, _ref21) {
        var commit = _ref20.commit;
        var index = _ref21.index,
            key = _ref21.key,
            value = _ref21.value;

        commit(types.UPDATE_DATA, { index: index, key: key, value: value });
    },
    updateShowInterest: function updateShowInterest(_ref22, _ref23) {
        var commit = _ref22.commit;
        var index = _ref23.index;

        commit(types.UPDATE_SHOW_INTEREST, { index: index });
    },
    getMoveableHeadsOfLoss: function getMoveableHeadsOfLoss(_ref24, _ref25) {
        var commit = _ref24.commit;
        var claimId = _ref25.claimId,
            discountRate = _ref25.discountRate;

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].generatedDocuments.headsOfLoss(claimId, discountRate).then(function (data) {
            commit(types.UPDATE_HEADS_OF_LOSS, data);
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.RESET, function (state) {
    state.generatedDocuments = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_FULL_LIST, function (state, data) {
    state.generatedDocuments = data.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(a.updated_at, 'YYYY-MM-DD HH:mm:ss').isBefore(__WEBPACK_IMPORTED_MODULE_4_moment___default()(b.updated_at, 'YYYY-MM-DD HH:mm:ss')) ? 1 : -1;
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_DOCUMENT, function (state, _ref26) {
    var index = _ref26.index,
        data = _ref26.data;

    state.generatedDocuments[index] = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_DOCUMENT_NAME, function (state, _ref27) {
    var index = _ref27.index,
        value = _ref27.value;

    state.generatedDocuments[index].name = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_DATA, function (state, _ref28) {
    var index = _ref28.index,
        key = _ref28.key,
        value = _ref28.value;

    if (!value) {
        value = 0;
    }
    __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(state.generatedDocuments[index].data, key, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.DELETE_GENERATED_DOCUMENT, function (state, document) {
    state.generatedDocuments.splice(state.generatedDocuments.indexOf(document), 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.TOGGLE_EDITING_DOCUMENT, function (state, document) {
    state.editingDocument = state.generatedDocuments.map(function (document) {
        return document.id;
    }).indexOf(document.id);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.QUIT_EDITING_DOCUMENT, function (state) {
    state.showingExitNotification = false;
    state.exitAllowed = false;
    state.editingDocument = -1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.SET_API_REQUEST_IN_PROGRESS, function (state) {
    state.requesting = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.SET_API_REQUEST_COMPLETE, function (state) {
    state.requesting = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_SHOW_INTEREST, function (state, _ref29) {
    var index = _ref29.index;

    if (state.generatedDocuments[index].show_interest === 1) {
        state.generatedDocuments[index].show_interest = 0;
    } else {
        state.generatedDocuments[index].show_interest = 1;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.EXIT_EDITING_DOCUMENT_ATTEMPTED, function (state) {
    state.showingExitNotification = true;
    state.exitAllowed = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.EXIT_EDITING_DOCUMENT_FAILED, function (state) {
    state.showingExitNotification = false;
    state.exitAllowed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_PAGINATION, function (state, data) {
    state.pagination.total = data.total;
    state.pagination.per_page = data.per_page;
    state.pagination.from = data.from;
    state.pagination.to = data.to;
    state.pagination.current_page = data.current_page;
    state.pagination.last_page = data.last_page;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_HEADS_OF_LOSS, function (state, data) {
    state.headsOfLoss = data.heads_of_loss;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);


var _mutations;



var types = {
    REGISTER_DROPDOWN: 'REGISTER_DROPDOWN',
    UNREGISTER_DROPDOWN: 'UNREGISTER_DROPDOWN',
    TOGGLE_DROPDOWN: 'TOGGLE_DROPDOWN',
    CLOSE_DROPDOWN: 'CLOSE_DROPDOWN'
};

var state = {
    dropdowns: {}
};

var getters = {
    dropdowns: function dropdowns(state) {
        return state.dropdowns;
    }
};

var actions = {
    register: function register(_ref, name) {
        var commit = _ref.commit;
        return commit(types.REGISTER_DROPDOWN, name);
    },
    toggle: function toggle(_ref2, name) {
        var commit = _ref2.commit;
        return commit(types.TOGGLE_DROPDOWN, name);
    },
    unregister: function unregister(_ref3, name) {
        var commit = _ref3.commit;
        return commit(types.UNREGISTER_DROPDOWN, name);
    },
    close: function close(_ref4, name) {
        var commit = _ref4.commit;
        return commit(types.CLOSE_DROPDOWN, name);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.REGISTER_DROPDOWN, function (state, name) {
    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.set(state.dropdowns, name, false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UNREGISTER_DROPDOWN, function (state, name) {
    delete state.dropdowns[name];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.TOGGLE_DROPDOWN, function (state, name) {
    state.dropdowns[name] = !state.dropdowns[name];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.CLOSE_DROPDOWN, function (state, name) {
    state.dropdowns[name] = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_generators_step__ = __webpack_require__(21);









var mutationTypes = {
    RESET: 'RESET'
};

var state = {};

var getters = {};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;


        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([]);
    },
    process: function process(_ref3) {
        var rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 8,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_generators_step__["a" /* previousValid */])(rootState, 8) });
    },
    validate: function validate(_ref4) {
        var rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 8,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_generators_step__["a" /* previousValid */])(rootState, 8) });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 8,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.RESET, function (state) {});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_routingMethods__ = __webpack_require__(13);



var _mutations;








var mutationTypes = {
    RESET: 'RESET',
    UPDATE: 'UPDATE',
    SERVER_UPDATE: 'SERVER_UPDATE',
    UPDATE_DISCOUNT_RATE: 'UPDATE_DISCOUNT_RATE'
};

var state = {
    claimantName: null,
    defendantName: {
        id: null,
        name: null,
        type: null
    },
    claimantSolicitor: {
        id: null,
        name: null,
        type: null
    },
    claimantReference: null,
    yourReference: null,
    claimNarrative: null,
    diseaseOrAccident: null,
    accidentType: null,
    otherAccidentType: null,
    diseaseType: null,
    otherDiseaseType: null,
    proceduralStatus: 'pre-lit',
    serviceOfProceedings: null,
    assumedSettlement: null,
    discountRate: -0.25,
    levelOfEducation: null,
    disabled: 0,
    employedAtDeath: ''
};

var rules = {
    'claimantName': { type: 'text', rules: 'required' },
    'defendantName': { type: 'text', rules: 'required' },
    'claimantSolicitor': { type: 'text', rules: 'required' },
    'claimantReference': { type: 'text', rules: 'required' },
    'yourReference': { type: 'text', rules: 'required' },
    'claimNarrative': { type: 'text', rules: 'required' },

    'assumedSettlement': { type: 'date', rules: 'required' }
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    discountRate: function discountRate(state) {
        return state.discountRate;
    }
};

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE, { key: key, value: value });

        if (key === 'assumedSettlement') {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([dispatch('checkToUpdateLifeExpectancy'), __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/deceased/determineAgeOfDeathToSettlement'), __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/deceased/determineAgeAtSettlement')]);
        }
        if (key === 'discountRate') {
            return dispatch('updateDiscountRate', value);
        }
    },
    save: function save(_ref3, payload) {
        var dispatch = _ref3.dispatch;

        payload.data = state;

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref4, step) {
        var commit = _ref4.commit;

        var data = __WEBPACK_IMPORTED_MODULE_2_lodash__["deeply"](__WEBPACK_IMPORTED_MODULE_2_lodash__["mapKeys"])(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash__["camelCase"](key);
        }).data;

        commit(mutationTypes.SERVER_UPDATE, data);
    },
    process: function process(_ref5) {
        var rootState = _ref5.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 0,
            valid: true
        });
    },
    validate: function validate(_ref6) {
        var rootState = _ref6.rootState;

        var updatedRules = __WEBPACK_IMPORTED_MODULE_2_lodash__["clone"](rules);
        if (rootState.user.user.hideNames) {
            delete updatedRules['claimantName'];
        }
        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 0,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_store_generators_step__["a" /* previousValid */])(rootState, 0) && new __WEBPACK_IMPORTED_MODULE_5_services_Validator__["a" /* default */](state, updatedRules).validate()
        });
    },
    reset: function reset(_ref7) {
        var commit = _ref7.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 0,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    updateDiscountRate: function updateDiscountRate(_ref8, rate) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch;

        commit(mutationTypes.UPDATE_DISCOUNT_RATE, rate);

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_services_routingMethods__["e" /* isStepValid */])(4)) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([dispatch('fatal/dependency/checkToUpdateMultipliers', null, { root: true }), dispatch('fatal/dependency/updateServices', null, { root: true }), dispatch('fatal/dependency/updateServicesTable', null, { root: true })]);
    },
    checkToUpdateLifeExpectancy: function checkToUpdateLifeExpectancy(_ref9) {
        var dispatch = _ref9.dispatch;

        var lifeExpectancy = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceasedLifeExpectancy'];
        if (lifeExpectancy.dateOfDeath !== null) {
            dispatch('fatal/dependency/deceased/updateTheDeceasedLifeExpectancy', { lifeExpectancy: lifeExpectancy }, { root: true });
        }
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, _ref10) {
    var key = _ref10.key,
        value = _ref10.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DISCOUNT_RATE, function (state, rate) {
    state.discountRate = parseFloat(rate);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE, function (state, data) {
    state.claimantName = data.claimantName;
    state.claimantSolicitor = data.claimantSolicitor;
    state.claimantReference = data.claimantReference;
    state.yourReference = data.yourReference;
    state.claimNarrative = data.claimNarrative;
    state.diseaseOrAccident = data.diseaseOrAccident || 'disease';
    state.accidentType = data.accidentType;
    state.otherAccidentType = data.otherAccidentType;
    state.diseaseType = data.diseaseType;
    state.otherDiseaseType = data.otherDiseaseType;
    state.defendantName = data.defendantName;
    state.proceduralStatus = data.proceduralStatus;
    state.serviceOfProceedings = data.serviceOfProceedings;
    state.assumedSettlement = data.assumedSettlement;
    state.discountRate = data.discountRate;
    state.levelOfEducation = data.levelOfEducation;
    state.disabled = data.disabled;
    state.employedAtDeath = data.employedAtDeath;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.claimantName = null;
    state.claimantReference = null;
    state.yourReference = null;
    state.claimNarrative = null;
    state.diseaseOrAccident = null;
    state.accidentType = null;
    state.otherAccidentType = null;
    state.diseaseType = null;
    state.otherDiseaseType = null;
    state.proceduralStatus = 'pre-lit';
    state.serviceOfProceedings = null;
    state.assumedSettlement = null;
    state.discountRate = -0.25;
    state.levelOfEducation = null;
    state.disabled = 0;
    state.employedAtDeath = '';
    state.defendantName.id = null;
    state.defendantName.name = null;
    state.defendantName.type = null;
    state.claimantSolicitor.id = null;
    state.claimantSolicitor.name = null;
    state.claimantSolicitor.type = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_generators_step__ = __webpack_require__(21);



var _mutations;






var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    UPDATE_INCLUDE: 'UPDATE_INCLUDE',
    RESET: 'RESET',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER'
};

var cruTemplate = function cruTemplate() {
    return {
        value: 0,
        include: false
    };
};

var state = {
    gdPneumoconiosis: cruTemplate(),
    gdMesothelioma: cruTemplate(),
    ploeDisabilityWorkingAllowance: cruTemplate(),
    ploeEmploymentSupportAllowance: cruTemplate(),
    ploeIncapacityBenefit: cruTemplate(),
    ploeIncomeSupport: cruTemplate(),
    ploeIndustrialInjuriesDisablementBenefit: cruTemplate(),
    ploeInvalidityPension: cruTemplate(),
    ploeInvalidityAllowance: cruTemplate(),
    ploeJobseekersAllowance: cruTemplate(),
    ploeReducedEarningsAllowance: cruTemplate(),
    ploeSevereDisablementAllowance: cruTemplate(),
    ploeSicknessBenefit: cruTemplate(),
    ploeStatutorySickPay: cruTemplate(),
    ploeUnemployabilitySupplement: cruTemplate(),
    ploeUnemploymentBenefit: cruTemplate(),
    ploeUniversalCredit: cruTemplate(),
    pcocAttendanceAllowance: cruTemplate(),
    pcocDisabilityLivingAllowance: cruTemplate(),
    pcocIndustrialInjuriesDisablementBenefit: cruTemplate(),
    pcocPersonalIndependencePayment: cruTemplate(),
    pcotDisabilityLivingAllowance: cruTemplate(),
    pcotMobilityAllowance: cruTemplate(),
    pcotPersonalIndependencePayment: cruTemplate()
};

var rules = {};

var returnCruValue = function returnCruValue(cru) {
    if (cru.include) {
        return parseFloat(cru.value);
    }
    return 0;
};

var generalDamagesOffset = function generalDamagesOffset(state) {
    var cruTotal = returnCruValue(state.gdPneumoconiosis) + returnCruValue(state.gdMesothelioma);
    var gdHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/headsOfLoss/value']('generalDamages');

    if (cruTotal >= gdHeadOfLoss) {
        return gdHeadOfLoss;
    }

    return cruTotal;
};

var pastLossOfEarningsOffset = function pastLossOfEarningsOffset(state) {
    var cruTotal = returnCruValue(state.ploeDisabilityWorkingAllowance) + returnCruValue(state.ploeEmploymentSupportAllowance) + returnCruValue(state.ploeIncapacityBenefit) + returnCruValue(state.ploeIncomeSupport) + returnCruValue(state.ploeIndustrialInjuriesDisablementBenefit) + returnCruValue(state.ploeInvalidityPension) + returnCruValue(state.ploeInvalidityAllowance) + returnCruValue(state.ploeJobseekersAllowance) + returnCruValue(state.ploeReducedEarningsAllowance) + returnCruValue(state.ploeSevereDisablementAllowance) + returnCruValue(state.ploeSicknessBenefit) + returnCruValue(state.ploeStatutorySickPay) + returnCruValue(state.ploeUnemployabilitySupplement) + returnCruValue(state.ploeUnemploymentBenefit) + returnCruValue(state.ploeUniversalCredit);

    var ploeHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/headsOfLoss/value']('pastLossOfEarnings');

    if (cruTotal >= ploeHeadOfLoss) {
        return ploeHeadOfLoss;
    }

    return cruTotal;
};

var pastCostOfCareOffset = function pastCostOfCareOffset(state) {
    var cruTotal = returnCruValue(state.pcocAttendanceAllowance) + returnCruValue(state.pcocDisabilityLivingAllowance) + returnCruValue(state.pcocIndustrialInjuriesDisablementBenefit) + returnCruValue(state.pcocPersonalIndependencePayment);

    var pcocHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/headsOfLoss/value']('pastCostOfCare');

    if (cruTotal >= pcocHeadOfLoss) {
        return pcocHeadOfLoss;
    }

    return cruTotal;
};

var pastCostOfTravelOffset = function pastCostOfTravelOffset(state) {
    var cruTotal = returnCruValue(state.pcotDisabilityLivingAllowance) + returnCruValue(state.pcotMobilityAllowance) + returnCruValue(state.pcotPersonalIndependencePayment);

    var pcotHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/headsOfLoss/value']('pastCostOfTravel');

    if (cruTotal >= pcotHeadOfLoss) {
        return pcotHeadOfLoss;
    }

    return cruTotal;
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key].value;
        };
    },
    include: function include(state) {
        return function (key) {
            return state[key].include;
        };
    },
    allValid: function allValid(state) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).reduce(function (valid, benefit) {
            return !valid ? valid : !(state[benefit].include == true && state[benefit].value <= 0);
        }, true);
    },
    all: function all(state) {
        return state;
    },
    gdPneumoconiosis: function gdPneumoconiosis(state) {
        return state.gdPneumoconiosis;
    },
    gdMesothelioma: function gdMesothelioma(state) {
        return state.gdMesothelioma;
    },
    ploeDisabilityWorkingAllowance: function ploeDisabilityWorkingAllowance(state) {
        return state.ploeDisabilityWorkingAllowance;
    },
    ploeEmploymentSupportAllowance: function ploeEmploymentSupportAllowance(state) {
        return state.ploeEmploymentSupportAllowance;
    },
    ploeIncapacityBenefit: function ploeIncapacityBenefit(state) {
        return state.ploeIncapacityBenefit;
    },
    ploeIncomeSupport: function ploeIncomeSupport(state) {
        return state.ploeIncomeSupport;
    },
    ploeIndustrialInjuriesDisablementBenefit: function ploeIndustrialInjuriesDisablementBenefit(state) {
        return state.ploeIndustrialInjuriesDisablementBenefit;
    },
    ploeInvalidityPension: function ploeInvalidityPension(state) {
        return state.ploeInvalidityPension;
    },
    ploeInvalidityAllowance: function ploeInvalidityAllowance(state) {
        return state.ploeInvalidityAllowance;
    },
    ploeJobseekersAllowance: function ploeJobseekersAllowance(state) {
        return state.ploeJobseekersAllowance;
    },
    ploeReducedEarningsAllowance: function ploeReducedEarningsAllowance(state) {
        return state.ploeReducedEarningsAllowance;
    },
    ploeSevereDisablementAllowance: function ploeSevereDisablementAllowance(state) {
        return state.ploeSevereDisablementAllowance;
    },
    ploeSicknessBenefit: function ploeSicknessBenefit(state) {
        return state.ploeSicknessBenefit;
    },
    ploeStatutorySickPay: function ploeStatutorySickPay(state) {
        return state.ploeStatutorySickPay;
    },
    ploeUnemployabilitySupplement: function ploeUnemployabilitySupplement(state) {
        return state.ploeUnemployabilitySupplement;
    },
    ploeUnemploymentBenefit: function ploeUnemploymentBenefit(state) {
        return state.ploeUnemploymentBenefit;
    },
    ploeUniversalCredit: function ploeUniversalCredit(state) {
        return state.ploeUniversalCredit;
    },
    pcocAttendanceAllowance: function pcocAttendanceAllowance(state) {
        return state.pcocAttendanceAllowance;
    },
    pcocDisabilityLivingAllowance: function pcocDisabilityLivingAllowance(state) {
        return state.pcocDisabilityLivingAllowance;
    },
    pcocIndustrialInjuriesDisablementBenefit: function pcocIndustrialInjuriesDisablementBenefit(state) {
        return state.pcocIndustrialInjuriesDisablementBenefit;
    },
    pcocPersonalIndependencePayment: function pcocPersonalIndependencePayment(state) {
        return state.pcocPersonalIndependencePayment;
    },
    pcotDisabilityLivingAllowance: function pcotDisabilityLivingAllowance(state) {
        return state.pcotDisabilityLivingAllowance;
    },
    pcotMobilityAllowance: function pcotMobilityAllowance(state) {
        return state.pcotMobilityAllowance;
    },
    pcotPersonalIndependencePayment: function pcotPersonalIndependencePayment(state) {
        return state.pcotPersonalIndependencePayment;
    },
    getGeneralDamagesOffset: function getGeneralDamagesOffset(state) {
        return generalDamagesOffset(state);
    },
    getPastLossOfEarningsOffset: function getPastLossOfEarningsOffset(state) {
        return pastLossOfEarningsOffset(state);
    },
    getPastCostOfCareOffset: function getPastCostOfCareOffset(state) {
        return pastCostOfCareOffset(state);
    },
    getPastCostOfTravelOffset: function getPastCostOfTravelOffset(state) {
        return pastCostOfTravelOffset(state);
    }
};

var actions = {
    updateValue: function updateValue(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state;
        var key = _ref2.key,
            value = _ref2.value;

        if (state[key].value !== value) {
            return commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
        }
        return value;
    },
    updateInclude: function updateInclude(_ref3, _ref4) {
        var commit = _ref3.commit,
            state = _ref3.state;
        var key = _ref4.key,
            value = _ref4.value;

        if (state[key].include !== value) {
            return commit(mutationTypes.UPDATE_INCLUDE, { key: key, value: value });
        }
        return value;
    },
    updateFromServer: function updateFromServer(_ref5, _ref6) {
        var commit = _ref5.commit;
        var data = _ref6.data;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
            commit(mutationTypes.UPDATE_FROM_SERVER, { key: key, value: _.values(data[key]) });
        });
        return true;
    },
    save: function save(_ref7, payload) {
        var state = _ref7.state,
            dispatch = _ref7.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref8, step) {
        var dispatch = _ref8.dispatch;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;

        dispatch('updateFromServer', { data: data });
    },
    validate: function validate(_ref9) {
        var rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 6,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 6) && new __WEBPACK_IMPORTED_MODULE_3_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    process: function process(_ref10) {
        var rootState = _ref10.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 6,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 6) && new __WEBPACK_IMPORTED_MODULE_3_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref11) {
        var commit = _ref11.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 6,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref12) {
    var key = _ref12.key,
        value = _ref12.value;

    state[key].value = value[0];
    state[key].include = value[1];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, _ref13) {
    var key = _ref13.key,
        value = _ref13.value;

    state[key].value = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCLUDE, function (state, _ref14) {
    var key = _ref14.key,
        value = _ref14.value;

    state[key].include = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
        state[key] = cruTemplate();
    });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* unused harmony export throttleUpdateLife */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_generators_step__ = __webpack_require__(21);




var _mutations;












var mutationTypes = {
    RESET: 'RESET',
    UPDATE: 'UPDATE',
    UPDATE_DECEASED: 'UPDATE_DECEASED',
    SERVER_UPDATE_INCOME: 'SERVER_UPDATE_INCOME',
    UPDATE_DECEASED_INCOME: 'UPDATE_DECEASED_INCOME',
    SERVER_UPDATE_DECEASED: 'SERVER_UPDATE_DECEASED',
    ADD_DECEASED_INCOME_PERIOD: 'ADD_DECEASED_INCOME_PERIOD',
    UPDATE_DECEASED_INCOME_PERIOD: 'UPDATE_DECEASED_INCOME_PERIOD',
    DELETE_DECEASED_INCOME_PERIOD: 'DELETE_DECEASED_INCOME_PERIOD',
    UPDATE_DECEASED_LIFE_EXPECTANCY: 'UPDATE_DECEASED_LIFE_EXPECTANCY',
    UPDATING_DECEASED_INCOME_PERIOD: 'UPDATING_DECEASED_INCOME_PERIOD'
};

var state = {
    theDeceased: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["f" /* personTemplate */])(),
    periodDeathToSettlement: null,
    ageAtSettlement: null,
    updatingDeceasedIncome: false
};

var rules = {
    'theDeceased.name': { type: 'text', rules: 'required' },
    'theDeceased.gender': { type: 'text', rules: 'required' },
    'theDeceased.dateOfBirth': { type: 'date', rules: 'required' },
    'theDeceased.onsetOfSymptoms': { type: 'date', rules: 'required' },
    'theDeceased.dateOfDeath': { type: 'date', rules: 'required' }
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    theDeceased: function theDeceased(state) {
        return state.theDeceased;
    },
    theDeceasedIncome: function theDeceasedIncome(state) {
        return state.theDeceased.income;
    },
    theDeceasedLifeExpectancy: function theDeceasedLifeExpectancy(state) {
        return state.theDeceased.lifeExpectancy;
    },
    theDeceasedIncomeValid: function theDeceasedIncomeValid(state) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/proceduralDates/date']('dateOfAssumedSettlement'), 'DD/MM/YYYY');

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["d" /* incomeValid */])(assumedSettlement, state.theDeceased);
    },
    getDeceasedIncomePeriod: function getDeceasedIncomePeriod(state) {
        return function (index) {
            return state.theDeceased.income.periods[index];
        };
    },
    theDeceasedNetIncome: function theDeceasedNetIncome(state) {
        return state.theDeceased.income.netIncome + state.theDeceased.income.netPensionIncome;
    },
    theDeceasedGrossIncome: function theDeceasedGrossIncome(state) {
        return state.theDeceased.income.grossIncome + state.theDeceased.income.grossPensionIncome;
    },
    durationDeceasedDependency: function durationDeceasedDependency(state) {
        return state.theDeceased.lifeExpectancy.ageAtDeath - state.theDeceased.ageAtDeath;
    },
    getDeceasedIncomeStatus: function getDeceasedIncomeStatus(state) {
        return state.updatingDeceasedIncome;
    }
};

var theDeceasedEvents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["e" /* dynamicUpdates */])({
    ageAtDeath: 'updateTheDeceasedValue',
    lifeExpectancy: 'updateTheDeceasedLifeExpectancy',
    incomeValue: 'updateTheDeceasedIncomeValue',
    retirementDate: 'updateRetirementAgeAndDate'
});

var throttleUpdateLife = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (dispatch, action, person, lifeExpectancy, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, action, updatedLife, index);
        }).then(function () {
            return dispatch('updatePeriodsForLifeExpectancy');
        });
    }
}, 500);

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_modules_claim__["d" /* requestPayload */])(0));
    },
    load: function load(_ref2, step) {
        var commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.SERVER_UPDATE_DECEASED, data.theDeceased);
    },
    process: function process(_ref3) {
        var dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        var updatedRules = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(rules);
        if (rootState.user.user.hideNames) {
            delete updatedRules['theDeceased.name'];
        }
        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 1,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_generators_step__["a" /* previousValid */])(rootState, 1) && new __WEBPACK_IMPORTED_MODULE_7_services_Validator__["a" /* default */](state, updatedRules).validate()
        });

        dispatch('determineAgeOfDeathToSettlement');
        dispatch('determineAgeAtSettlement');
    },
    validate: function validate(_ref4) {
        var rootState = _ref4.rootState;

        var updateRules = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(rules);
        if (rootState.user.user.hideNames) {
            delete updateRules['theDeceased.name'];
        }
        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 1,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_generators_step__["a" /* previousValid */])(rootState, 1) && new __WEBPACK_IMPORTED_MODULE_7_services_Validator__["a" /* default */](state, updateRules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 1,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    update: function update(_ref6, _ref7) {
        var commit = _ref6.commit;
        var key = _ref7.key,
            value = _ref7.value;

        commit(mutationTypes.UPDATE, { key: key, value: value });
    },
    updateTheDeceasedLifeExpectancy: function updateTheDeceasedLifeExpectancy(_ref8, _ref9) {
        var dispatch = _ref8.dispatch,
            state = _ref8.state;
        var lifeExpectancy = _ref9.lifeExpectancy;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateTheDeceasedLifeExpectancyValue', lifeExpectancy).then(function () {
            return throttleUpdateLife(dispatch, 'updateTheDeceasedLifeExpectancyValue', state.theDeceased, lifeExpectancy);
        });
    },
    updateTheDeceasedLifeExpectancyValue: function updateTheDeceasedLifeExpectancyValue(_ref10, _ref11) {
        var commit = _ref10.commit,
            state = _ref10.state,
            dispatch = _ref10.dispatch;
        var key = _ref11.key,
            value = _ref11.value;

        if (state.theDeceased.lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_DECEASED_LIFE_EXPECTANCY, { key: key, value: value });
        }
    },
    updateTheDeceasedIncomeValue: function updateTheDeceasedIncomeValue(_ref12, _ref13) {
        var commit = _ref12.commit,
            state = _ref12.state;
        var key = _ref13.key,
            value = _ref13.value;

        if (state.theDeceased.income[key] === value || typeof value === 'number' && isNaN(value)) {

            return;
        }
        commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: key, value: value });
        return key;
    },

    updateRetirementAgeAndDate: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref14) {
        var state = _ref14.state,
            commit = _ref14.commit,
            dispatch = _ref14.dispatch;

        if (state.theDeceased.income.retirementAgeCalc === 'auto') {
            var previousRetirement = state.theDeceased.income.retirementDate;
            return __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].calculators.dates.statePensionAge(state.theDeceased).then(function (data) {
                commit(mutationTypes.UPDATE_DECEASED_INCOME, {
                    key: 'retirementAge',
                    value: data.statePension.retirementAge
                });
                commit(mutationTypes.UPDATE_DECEASED_INCOME, {
                    key: 'retirementDate',
                    value: data.statePension.retirementDate
                });
                dispatch('updateIncomePeriodForRetirementChange', previousRetirement);
            });
        }
    }, 500),

    updateIncomePeriodForRetirementChange: function updateIncomePeriodForRetirementChange(_ref15, previousRetirementDate) {
        var state = _ref15.state,
            commit = _ref15.commit;

        if (state.theDeceased.income.retired) {
            return;
        }

        var retirementDate = state.theDeceased.income.retirementDate;
        var periods = state.theDeceased.income.periods;
        var end = periods[periods.length - 1].endOfPeriod;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["c" /* splitPeriodsForRetirement */])(commit, mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, mutationTypes.ADD_DECEASED_INCOME_PERIOD, previousRetirementDate, retirementDate, periods, end);
    },
    removePeriodsSplitForTheRetired: function removePeriodsSplitForTheRetired(_ref16, previousRetirementDate) {
        var state = _ref16.state,
            dispatch = _ref16.dispatch;

        var retirementDate = state.theDeceased.income.retirementDate;
        var periods = state.theDeceased.income.periods;
        if (!state.theDeceased.income.retired) {
            return;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["g" /* removePeriodsSplitForTheRetired */])(dispatch, 'deleteDeceasedIncomePeriod', periods, previousRetirementDate, retirementDate);
    },
    updateIncomePeriodsForRetirement: function updateIncomePeriodsForRetirement(_ref17) {
        var state = _ref17.state,
            dispatch = _ref17.dispatch;

        var deceased = state.theDeceased;
        var periods = deceased.income.periods;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["h" /* updateIncomePeriodsForRetirement */])(dispatch, 'updateDeceasedIncomePeriodValue', periods, deceased.income.retired).then(function (updatedPeriodIndex) {
            var proms = updatedPeriodIndex.map(function (updated, index) {
                if (!updated) return;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["i" /* zeroCheck */])(dispatch, index, periods[index], deceased, 'updateDeceasedIncomePeriodValue', 'deceased').then(function () {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(periods[index], dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, deceased);
                });
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
        });
    },
    updatePeriodsForLifeExpectancy: function updatePeriodsForLifeExpectancy(_ref18) {
        var state = _ref18.state,
            rootState = _ref18.rootState,
            dispatch = _ref18.dispatch;

        if (!rootState.fatal.dependency.step.steps[0].valid || !rootState.fatal.dependency.step.steps[1].valid || !rootState.fatal.dependency.step.steps[2].valid || !rootState.fatal.dependency.step.steps[3].valid) {
            return;
        }

        var dateOfDeath = state.theDeceased.lifeExpectancy.dateOfDeath;
        var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateOfDeath, 'DD/MM/YYYY');
        var lastIndex = state.theDeceased.income.periods.length - 1;

        var proms = state.theDeceased.income.periods.map(function (period, index) {
            var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
            var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');

            if (start.isAfter(mDateOfDeath)) {
                return dispatch('deleteDeceasedIncomePeriod', { index: index });
            } else if (end.isAfter(mDateOfDeath) || index === lastIndex) {
                    return dispatch('updateDeceasedIncomePeriodValue', { index: index, key: 'endOfPeriod', value: dateOfDeath });
                }
        });
        proms.push(dispatch('updateIncomePeriodForRetirementChange'));
        proms.push(dispatch('fatal/dependency/dependants/updatePeriodsForLifeExpectancy', dateOfDeath, { root: true }));
        proms.push(dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true }));
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
    },
    determineAgeOfDeathToSettlement: function determineAgeOfDeathToSettlement(_ref19) {
        var commit = _ref19.commit,
            state = _ref19.state,
            rootGetters = _ref19.rootGetters;

        var mSettleDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(rootGetters['fatal/dependency/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY');
        var mDod = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.dateOfDeath, 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDod.isValid()) {
            commit(mutationTypes.UPDATE, { key: 'periodDeathToSettlement', value: Math.round(mSettleDate.diff(mDod, 'years', true) * 10) / 10 });
        }
    },
    determineAgeAtSettlement: function determineAgeAtSettlement(_ref20) {
        var commit = _ref20.commit,
            state = _ref20.state,
            rootGetters = _ref20.rootGetters;

        var mSettleDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(rootGetters['fatal/dependency/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY');
        var mDob = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.dateOfBirth, 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDob.isValid()) {
            commit(mutationTypes.UPDATE, { key: 'ageAtSettlement', value: Math.round(mSettleDate.diff(mDob, 'years', true) * 10) / 10 });
        }
    },
    updateTheDeceased: function updateTheDeceased(_ref21, theDeceased) {
        var dispatch = _ref21.dispatch;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateTheDeceasedValue', theDeceased);
    },
    updateTheDeceasedValue: function updateTheDeceasedValue(_ref22, _ref23) {
        var commit = _ref22.commit,
            state = _ref22.state,
            dispatch = _ref22.dispatch;
        var key = _ref23.key,
            value = _ref23.value,
            _ref23$force = _ref23.force,
            force = _ref23$force === undefined ? false : _ref23$force;

        if (state.theDeceased[key] !== value && (force || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["k" /* userSettable */])(key))) {
            commit(mutationTypes.UPDATE_DECEASED, { key: key, value: value });

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(theDeceasedEvents(key, dispatch, state.theDeceased)), [dispatch('determineAgeOfDeathToSettlement'), dispatch('determineAgeAtSettlement'), dispatch('fatal/dependency/dependantUpdate', key, { root: true })]));
        }
    },
    addDeceasedIncomePeriod: function addDeceasedIncomePeriod(_ref24) {
        var commit = _ref24.commit,
            state = _ref24.state;

        var periods = state.theDeceased.income.periods,
            start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["l" /* findNextPeriodStart */])(periods, state.theDeceased.dateOfDeath),
            end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["m" /* findNextPeriodEnd */])(periods, state.theDeceased.lifeExpectancy.dateOfDeath);

        commit(mutationTypes.ADD_DECEASED_INCOME_PERIOD, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["a" /* defaultIncomePeriodTemplate */])({
            start: start,
            end: end
        }));
    },
    updateDeceasedIncomePeriod: function updateDeceasedIncomePeriod(_ref25, _ref26) {
        var state = _ref25.state,
            commit = _ref25.commit,
            dispatch = _ref25.dispatch;
        var index = _ref26.index,
            period = _ref26.period,
            deceased = _ref26.deceased;

        if (!state.updatingDeceasedIncome) {
            commit(mutationTypes.UPDATING_DECEASED_INCOME_PERIOD);
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateDeceasedIncomePeriodValue', period, index).then(function (updatedKeys) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["n" /* doesIncomePeriodNeedToUpdate */])(updatedKeys) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["o" /* isValidIncome */])(period) || deceased.income.retirementAge < 50 || deceased.income.retirementAge === '') {
                return;
            }

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["i" /* zeroCheck */])(dispatch, index, period, deceased, 'updateDeceasedIncomePeriodValue', 'deceased').then(function () {
                dispatch('fatal/dependency/dependencyOnIncome/resetMultiplier', null, { root: true });
            }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, deceased)]);
        }).then(function () {
            if (state.updatingDeceasedIncome) {
                commit(mutationTypes.UPDATING_DECEASED_INCOME_PERIOD);
            }
        });
    },
    updateDeceasedIncomePeriodValue: function updateDeceasedIncomePeriodValue(_ref27, _ref28) {
        var commit = _ref27.commit,
            state = _ref27.state;
        var index = _ref28.index,
            key = _ref28.key,
            value = _ref28.value;

        if (state.theDeceased.income.periods[index]) {
            var currentPeriod = state.theDeceased.income.periods[index];
            if (currentPeriod[key] === value) {
                return;
            }
            commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: index, key: key, value: value });
            return key;
        }
    },
    deleteDeceasedIncomePeriod: function deleteDeceasedIncomePeriod(_ref29, _ref30) {
        var commit = _ref29.commit,
            state = _ref29.state,
            dispatch = _ref29.dispatch;
        var index = _ref30.index;

        var periodEnd = state.theDeceased.income.periods[index].endOfPeriod;
        commit(mutationTypes.DELETE_DECEASED_INCOME_PERIOD, index);
        dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });

        if (!state.theDeceased.income.periods.length) {
            return dispatch('addDeceasedIncomePeriod');
        }

        if (state.theDeceased.income.periods[index - 1]) {
            return dispatch('updateDeceasedIncomePeriodValue', {
                key: 'endOfPeriod',
                value: periodEnd,
                index: index - 1
            });
        }
    },
    removeDeceasedInvalidPeriodAndAddDefaults: function removeDeceasedInvalidPeriodAndAddDefaults(_ref31) {
        var commit = _ref31.commit,
            state = _ref31.state,
            dispatch = _ref31.dispatch;

        var dateOfDeath = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.dateOfDeath, 'DD/MM/YYYY');
        var retired = state.theDeceased.income.retired;

        state.theDeceased.income.periods.forEach(function (period, index) {
            var startOfPeriod = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
            if (retired) {
                commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: index, key: 'employmentIncome', value: 0 });
                dispatch('fatal/dependency/dependencyOnIncome/resetMultiplier', null, { root: true });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, state.theDeceased);
            }

            if (startOfPeriod.isBefore(dateOfDeath)) {
                dispatch('deleteDeceasedIncomePeriod', { index: index });
            }
        });
    },
    updateDeceasedIncome: function updateDeceasedIncome(_ref32, _ref33) {
        var dispatch = _ref32.dispatch,
            state = _ref32.state;
        var income = _ref33.income;

        var prevRetirementDate = state.theDeceased.income.retirementDate;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateTheDeceasedIncomeValue', income).then(function (keys) {
            if (~keys.indexOf('retirementDate') || ~keys.indexOf('retired') && !income.retired) {
                return dispatch('updateIncomePeriodForRetirementChange', prevRetirementDate);
            }
            if (~keys.indexOf('retired') && income.retired) {
                return dispatch('removePeriodsSplitForTheRetired', prevRetirementDate).then(function () {
                    return dispatch('updateIncomePeriodsForRetirement');
                });
            }
        });
    },
    serverUpdateDeceasedIncome: function serverUpdateDeceasedIncome(_ref34, _ref35) {
        var commit = _ref34.commit;
        var data = _ref35.data;

        commit(mutationTypes.SERVER_UPDATE_INCOME, data.deceased);
    },

    calculateLossOfEarnings: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref36) {
        var dispatch = _ref36.dispatch,
            state = _ref36.state,
            rootGetters = _ref36.rootGetters;

        var deceased = state.theDeceased;
        var mSettleDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(rootGetters['fatal/dependency/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY');
        var dob = __WEBPACK_IMPORTED_MODULE_5_moment___default()(deceased.dateOfBirth, 'DD/MM/YYYY');

        return __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].calculators.monetary.employmentContingencyDiscount({
            age: mSettleDate.diff(dob, 'years', true),
            disabled: deceased.disabledAtAccident,
            employment: deceased.employedAtDateOfDeath ? 'employed' : 'notEmployed',
            education: deceased.levelOfEducation,
            gender: deceased.gender
        }).then(function (data) {
            dispatch('updateTheDeceasedIncomeValue', { key: 'multiplier', value: data.multiplier });
        });
    }, 500)
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, _ref37) {
    var key = _ref37.key,
        value = _ref37.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED, function (state, _ref38) {
    var key = _ref38.key,
        value = _ref38.value;

    state.theDeceased[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_LIFE_EXPECTANCY, function (state, _ref39) {
    var key = _ref39.key,
        value = _ref39.value;

    state.theDeceased.lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_INCOME, function (state, _ref40) {
    var key = _ref40.key,
        value = _ref40.value;

    state.theDeceased.income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_INCOME, function (state, data) {
    state.theDeceased.income = data;
    state.theDeceased.employedAtDateOfDeath = data.employedAtDateOfDeath;
    state.theDeceased.levelOfEducation = data.levelOfEducation;
    state.theDeceased.disabledAtAccident = data.disabledAtAccident;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DECEASED_INCOME_PERIOD, function (state, payload) {
    state.theDeceased.income.periods.push(payload);
    state.theDeceased.income.netPensionIncome += payload.netPensionIncome;
    state.theDeceased.income.grossPensionIncome += payload.grossPensionIncome;
    state.theDeceased.income.netIncome += payload.netIncome;
    state.theDeceased.income.grossIncome += payload.grossIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, function (state, _ref41) {
    var key = _ref41.key,
        value = _ref41.value,
        index = _ref41.index;

    if (~key.indexOf('Income')) {
        state.theDeceased.income[key] -= state.theDeceased.income.periods[index][key] || 0;
    }
    state.theDeceased.income.periods[index][key] = value;
    if (~key.indexOf('Income')) {
        state.theDeceased.income[key] += value || 0;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DECEASED_INCOME_PERIOD, function (state, payload) {
    state.theDeceased.income.periods.splice(payload, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.theDeceased = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["f" /* personTemplate */])();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DECEASED, function (state, data) {
    state.theDeceased.name = data.name;
    state.theDeceased.gender = data.gender;
    state.theDeceased.onsetOfSymptoms = data.onsetOfSymptoms;
    state.theDeceased.dateOfBirth = data.dateOfBirth;
    state.theDeceased.dateOfDeath = data.dateOfDeath;
    state.theDeceased.ageAtDeath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["p" /* calcAgeDeath */])(state.theDeceased);
    state.theDeceased.lifeExpectancy = data.lifeExpectancy;
    state.theDeceased.income = data.income;
    state.theDeceased.levelOfEducation = data.levelOfEducation;
    state.theDeceased.disabledAtAccident = data.disabledAtAccident;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATING_DECEASED_INCOME_PERIOD, function (state) {
    state.updatingDeceasedIncome = !state.updatingDeceasedIncome;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* unused harmony export throttleUpdateLife */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_generators_step__ = __webpack_require__(21);




var _mutations;












var mutationTypes = {
    RESET: 'RESET',
    ADD_DEPENDANT: 'ADD_DEPENDANT',
    UPDATE_DEPENDANT: 'UPDATE_DEPENDANT',
    DELETE_DEPENDANT: 'DELETE_DEPENDANT',
    UPDATE_DEPENDANT_INCOME: 'UPDATE_DEPENDANT_INCOME',
    SERVER_UPDATE_DEPENDANT: 'SERVER_UPDATE_DEPENDANT',
    ADD_DEPENDANT_INCOME_PERIOD: 'ADD_DEPENDANT_INCOME_PERIOD',
    UPDATE_DEPENDANT_INCOME_PERIOD: 'UPDATE_DEPENDANT_INCOME_PERIOD',
    DELETE_DEPENDANT_INCOME_PERIOD: 'DELETE_DEPENDANT_INCOME_PERIOD',
    SERVER_UPDATE_DEPENDANTS_INCOME: 'SERVER_UPDATE_DEPENDANTS_INCOME',
    UPDATE_DEPENDANT_LIFE_EXPECTANCY: 'UPDATE_DEPENDANT_LIFE_EXPECTANCY',
    UPDATE_DEPENDENCY_ON_INCOME_VALID: 'UPDATE_DEPENDENCY_ON_INCOME_VALID',
    UPDATING_DEPENDANT_INCOME_PERIOD: 'UPDATING_DEPENDANT_INCOME_PERIOD'
};

var state = {
    theDependants: [],
    dependencyOnIncomeValid: false,
    updatingDependantIncome: false
};

var rules = {
    'theDependants': { type: 'array', rules: 'required' }
};

var determineDependency = function determineDependency(state) {
    return function (index) {
        if (!state.theDependants[index]) {
            return {};
        }

        var deceasedDateOfDeath = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['dateOfDeath'];
        var deceasedButForDate = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceasedLifeExpectancy']['dateOfDeath'];
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement');
        var dependantDateOfDeath = state.theDependants[index].lifeExpectancy.dateOfDeath;

        var mDeceasedDateOfDeath = __WEBPACK_IMPORTED_MODULE_5_moment___default()(deceasedDateOfDeath, 'DD/MM/YYYY');
        var mDeceasedButForDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(deceasedButForDate, 'DD/MM/YYYY');
        var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(assumedSettlement, 'DD/MM/YYYY');
        var mDependantDob = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDependants[index].dateOfBirth, 'DD/MM/YYYY');
        var mDependantDateOfDeath = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dependantDateOfDeath, 'DD/MM/YYYY');

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(assumedSettlement)) {
            return {};
        }

        if (Math.abs(mDeceasedDateOfDeath.diff(mDependantDob, 'years')) < 21) {
            var dependencyEndAge = 18;
            switch (state.theDependants[index].lifeExpectancy.method) {
                case 'dependent_until_custom':
                    dependencyEndAge = state.theDependants[index].lifeExpectancy.child.youthCutOffAge;
                    break;
                case 'dependent_until_16':
                    dependencyEndAge = 16;
                    break;
                case 'dependent_until_21':
                    dependencyEndAge = 21;
                    break;
            }

            var dependencyEnd = mDependantDob.add(dependencyEndAge, 'years');

            if (mDeceasedDateOfDeath.isAfter(dependencyEnd) || mDeceasedButForDate.isAfter(dependencyEndAge)) {
                return {
                    duration: dependencyEnd.diff(mDeceasedDateOfDeath, 'years', true),
                    date: dependencyEnd.format('DD/MM/YYYY'),
                    type: 'To dependant\'s age of ' + dependencyEndAge
                };
            }
        }

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(dependantDateOfDeath)) {
            return {};
        }

        if (mDeceasedDateOfDeath.isAfter(mDependantDateOfDeath) || mDeceasedButForDate.isAfter(mDependantDateOfDeath)) {
            return {
                duration: mDependantDateOfDeath.diff(mDeceasedDateOfDeath, 'years', true),
                date: mDependantDateOfDeath.format('DD/MM/YYYY'),
                type: "To end of dependant's life expectancy"
            };
        }

        return {
            duration: mDeceasedButForDate.diff(mDeceasedDateOfDeath, 'years', true),
            date: mDeceasedButForDate.format('DD/MM/YYYY'),
            type: "To end of the deceased's life expectancy"
        };
    };
};

var dependantUpdateEvents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["e" /* dynamicUpdates */])({
    lifeExpectancy: 'updateDependantLifeExpectancy',
    incomeValue: 'updateDependantIncomeValue',
    retirementDate: 'updateDependantRetirementDate'
});

var getPreTrialDependency = function getPreTrialDependency() {
    var dateOfDeath = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['dateOfDeath'];
    return __WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(dateOfDeath, 'DD/MM/YYYY'), 'years', true);
};

var getHasSplitPeriods = function getHasSplitPeriods(state) {
    return function () {
        return !__WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['income']['unchangedPension'] || !__WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['income']['retired'] ? true : state.theDependants.reduce(function (hasSplit, dependant) {
            return hasSplit || !dependant.income.unchangedPension || !dependant.income.retired;
        }, false);
    };
};

var throttleUpdateLife = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (dispatch, action, person, lifeExpectancy, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, action, updatedLife, index);
        });
    }
}, 500);

var valueFromState = function valueFromState(state, key) {
    return state[key];
};

var dependantValid = function dependantValid(rootState) {
    return function (dependant) {
        return (rootState.user.user.hideNames || !!dependant.name) && !!dependant.dateOfBirth && !!dependant.gender;
    };
};

var getters = {
    dependants: function dependants(state) {
        return state.theDependants;
    },
    allDependantsValid: function allDependantsValid(state, rootGetters, rootState) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_helper__["c" /* areAllTrue */])(state.theDependants, dependantValid(rootState));
    },
    findDependant: function findDependant(state) {
        return function (index) {
            return state.theDependants[index];
        };
    },
    theDependant: function theDependant(state) {
        return function (index) {
            return valueFromState(state.theDependants, index);
        };
    },
    durationOfDependency: function durationOfDependency(state) {
        return determineDependency(state);
    },
    preTrialDependency: function preTrialDependency(state) {
        return getPreTrialDependency();
    },
    dependantIncomeValid: function dependantIncomeValid(state) {
        return function (index) {
            var assumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/proceduralDates/date']('dateOfAssumedSettlement'), 'DD/MM/YYYY');
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["d" /* incomeValid */])(assumedSettlement, state.theDependants[index]);
        };
    },
    allDependantsIncomeValid: function allDependantsIncomeValid(state) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/proceduralDates/date']('dateOfAssumedSettlement'), 'DD/MM/YYYY');
        return state.theDependants.reduce(function (valid, value) {
            return !valid ? valid : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["d" /* incomeValid */])(assumedSettlement, value);
        }, true);
    },
    hasSplitPeriods: function hasSplitPeriods(state) {
        return getHasSplitPeriods(state);
    },
    getNoOfDependantPeriods: function getNoOfDependantPeriods(state) {
        return function (index) {
            return state.theDependants[index].income.periods.length;
        };
    },
    getDependantIncomePeriod: function getDependantIncomePeriod(state) {
        return function (dependant, index) {
            return state.theDependants[dependant].income.periods[index];
        };
    },
    getDependencyOnIncomeValid: function getDependencyOnIncomeValid(state) {
        return state.dependencyOnIncomeValid;
    },
    dependantNetIncome: function dependantNetIncome(state) {
        return state.theDependants.reduce(function (total, dependant) {
            return total + dependant.income.netIncome + dependant.income.netPensionIncome;
        }, 0);
    },
    getDependantIncomeStatus: function getDependantIncomeStatus(state) {
        return state.updatingDependantIncome;
    }
};

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;

        data.theDependants.map(function (dependant, index) {
            return commit(mutationTypes.SERVER_UPDATE_DEPENDANT, {
                dependant: dependant,
                index: index
            });
        });
    },
    process: function process(_ref3) {
        var rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 2,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_generators_step__["a" /* previousValid */])(rootState, 2) && new __WEBPACK_IMPORTED_MODULE_7_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 2,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_generators_step__["a" /* previousValid */])(rootState, 2) && new __WEBPACK_IMPORTED_MODULE_7_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 2,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    addDependant: function addDependant(_ref6) {
        var commit = _ref6.commit;

        commit(mutationTypes.ADD_DEPENDANT);
    },
    deleteDependant: function deleteDependant(_ref7, index) {
        var commit = _ref7.commit,
            state = _ref7.state,
            dispatch = _ref7.dispatch;

        commit(mutationTypes.DELETE_DEPENDANT, index);
        if (!state.theDependants.length) {
            return dispatch('addDependant');
        }
    },
    updateDependant: function updateDependant(_ref8, _ref9) {
        var dispatch = _ref8.dispatch;
        var index = _ref9.index,
            dependant = _ref9.dependant;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateDependantValue', dependant, index).then(function () {
            __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/dependency/checkToUpdateMultipliers');
        });
    },
    updateDependantValue: function updateDependantValue(_ref10, _ref11) {
        var commit = _ref10.commit,
            state = _ref10.state,
            dispatch = _ref10.dispatch;
        var key = _ref11.key,
            value = _ref11.value,
            index = _ref11.index;

        if (state.theDependants[index][key] !== value && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["k" /* userSettable */])(key)) {
            commit(mutationTypes.UPDATE_DEPENDANT, { key: key, value: value, index: index });

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(dependantUpdateEvents(key, dispatch, state.theDependants[index], index));
        }
    },
    updateDependantLifeExpectancy: function updateDependantLifeExpectancy(_ref12, _ref13) {
        var dispatch = _ref12.dispatch,
            state = _ref12.state;
        var index = _ref13.index,
            lifeExpectancy = _ref13.lifeExpectancy;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateDependantLifeExpectancyValue', lifeExpectancy, index).then(function () {
            return throttleUpdateLife(dispatch, 'updateDependantLifeExpectancyValue', state.theDependants[index], lifeExpectancy, index);
        });
    },
    updateDependantLifeExpectancyValue: function updateDependantLifeExpectancyValue(_ref14, _ref15) {
        var commit = _ref14.commit,
            state = _ref14.state;
        var key = _ref15.key,
            value = _ref15.value,
            index = _ref15.index;

        if (state.theDependants[index].lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_DEPENDANT_LIFE_EXPECTANCY, { key: key, value: value, index: index });
        }
    },
    addDependantIncomePeriod: function addDependantIncomePeriod(_ref16, _ref17) {
        var commit = _ref16.commit,
            state = _ref16.state;
        var index = _ref17.index;

        var person = state.theDependants[index];
        var periods = person.income.periods;

        commit(mutationTypes.ADD_DEPENDANT_INCOME_PERIOD, {
            dependant: index,
            period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["a" /* defaultIncomePeriodTemplate */])({
                start: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["l" /* findNextPeriodStart */])(periods, __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['dateOfDeath']),
                end: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["m" /* findNextPeriodEnd */])(periods, __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceasedLifeExpectancy']['dateOfDeath'])
            })
        });
    },
    updateDependantIncomePeriod: function updateDependantIncomePeriod(_ref18, _ref19) {
        var commit = _ref18.commit,
            dispatch = _ref18.dispatch,
            state = _ref18.state;
        var index = _ref19.index,
            period = _ref19.period,
            dependant = _ref19.dependant,
            dependantIndex = _ref19.dependantIndex;

        if (!state.updatingDependantIncome) {
            commit(mutationTypes.UPDATING_DEPENDANT_INCOME_PERIOD);
        }

        var proms = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(period).map(function (key) {
            return dispatch('updateDependantIncomePeriodValue', {
                key: key,
                value: period[key],
                index: index,
                dependant: dependant,
                dependantIndex: dependantIndex
            });
        });
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms).then(function (updatedKeys) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["n" /* doesIncomePeriodNeedToUpdate */])(updatedKeys) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["o" /* isValidIncome */])(period)) {
                return;
            }

            if (dependant.income.retirementAge < 50 || dependant.income.retirementAge === "" || dependant.income.retirementDate === null) {
                return;
            }

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["i" /* zeroCheck */])(dispatch, index, period, dependant, 'updateDependantIncomePeriodValue', 'dependant').then(function () {
                dispatch('fatal/dependency/dependencyOnIncome/resetMultiplier', null, { root: true });
            }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(period, dispatch, 'updateDependantIncomePeriodValue', {
                index: index,
                deceased: __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased'],
                dependant: state.theDependants[dependantIndex],
                dependantIndex: dependantIndex
            }, state.theDependants[dependantIndex])]);
        }).then(function () {
            if (state.updatingDependantIncome) {
                commit(mutationTypes.UPDATING_DEPENDANT_INCOME_PERIOD);
            }
        });
    },
    updateDependantIncomePeriodValue: function updateDependantIncomePeriodValue(_ref20, _ref21) {
        var commit = _ref20.commit;
        var index = _ref21.index,
            key = _ref21.key,
            value = _ref21.value,
            dependant = _ref21.dependant,
            dependantIndex = _ref21.dependantIndex;

        if (typeof dependant.income.periods[index] !== 'undefined') {
            var currentPeriod = dependant.income.periods[index];
            if (currentPeriod[key] === value) {
                return;
            }

            commit(mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, { index: index, key: key, value: value, dependant: dependant, dependantIndex: dependantIndex });
            return key;
        }
    },
    deleteDependantIncomePeriod: function deleteDependantIncomePeriod(_ref22, _ref23) {
        var commit = _ref22.commit,
            dispatch = _ref22.dispatch;
        var dependant = _ref23.dependant,
            dependantIndex = _ref23.dependantIndex,
            index = _ref23.index;

        var periods = dependant.income.periods;
        var endOfPeriod = periods[index].endOfPeriod;
        commit(mutationTypes.DELETE_DEPENDANT_INCOME_PERIOD, { dependantIndex: dependantIndex, index: index });
        dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });

        if (!periods.length) {
            return dispatch('addDependantIncomePeriod', { index: dependantIndex });
        }
        if (periods[index - 1]) {
            return dispatch('updateDependantIncomePeriodValue', {
                index: index - 1,
                key: 'endOfPeriod',
                value: endOfPeriod,
                dependant: dependant,
                dependantIndex: dependantIndex
            });
        }
    },
    updateDependantIncome: function updateDependantIncome(_ref24, _ref25) {
        var dispatch = _ref24.dispatch;
        var index = _ref25.index,
            income = _ref25.income;

        var previousRetirementDate = state.theDependants[index].income.retirementDate;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateDependantIncomeValue', income, index).then(function (keys) {
            if (~keys.indexOf('retired') && income.retired) {
                return dispatch('removePeriodsSplitForTheRetired', { previousRetirementDate: previousRetirementDate, index: index }).then(function () {
                    return dispatch('updateIncomePeriodsForRetirement', index);
                });
            }
            if (~keys.indexOf('retirementDate') || ~keys.indexOf('retired') && !income.retired) {
                return dispatch('updateIncomePeriodForRetirementChange', { previousRetirementDate: previousRetirementDate, index: index });
            }
        });
    },

    updateDependantRetirementAgeAndDate: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref26, _ref27) {
        var state = _ref26.state,
            commit = _ref26.commit,
            dispatch = _ref26.dispatch;
        var index = _ref27.index;

        var theDependant = state.theDependants[index];
        var previousRetirementDate = theDependant.income.retirementDate;

        if (theDependant.income.retirementAgeCalc === 'auto') {
            return __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].calculators.dates.statePensionAge(theDependant).then(function (data) {
                commit(mutationTypes.UPDATE_DEPENDANT_INCOME, {
                    key: 'retirementAge',
                    value: data.statePension.retirementAge,
                    index: index
                });
                commit(mutationTypes.UPDATE_DEPENDANT_INCOME, {
                    key: 'retirementDate',
                    value: data.statePension.retirementDate,
                    index: index
                });
                return dispatch('updateIncomePeriodForRetirementChange', { previousRetirementDate: previousRetirementDate, index: index });
            });
        }
    }, 500),

    updateDependantIncomeValue: function updateDependantIncomeValue(_ref28, _ref29) {
        var commit = _ref28.commit,
            state = _ref28.state;
        var key = _ref29.key,
            value = _ref29.value,
            index = _ref29.index;

        if (state.theDependants[index].income[key] === value || typeof value === "number" && isNaN(value)) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME, { key: key, value: value, index: index });
        return key;
    },
    removeDependantInvalidPeriodAndAddDefaults: function removeDependantInvalidPeriodAndAddDefaults(_ref30, _ref31) {
        var dispatch = _ref30.dispatch,
            state = _ref30.state,
            rootGetters = _ref30.rootGetters;
        var dependantIndex = _ref31.dependantIndex;

        var dateOfDeath = rootGetters['fatal/dependency/deceased/theDeceased'].dateOfDeath;

        state.theDependants[dependantIndex].income.periods.forEach(function (period, index) {
            if (state.theDependants[dependantIndex].income.retired) {
                dispatch('updateDependantIncomePeriodValue', {
                    key: 'employmentIncome',
                    value: 0,
                    index: index,
                    dependant: state.theDependants[dependantIndex],
                    dependantIndex: dependantIndex
                });

                dispatch('fatal/dependency/dependencyOnIncome/resetMultiplier', null, { root: true });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(period, dispatch, 'updateDependantIncomePeriodValue', {
                    index: index,
                    dependant: state.theDependants[dependantIndex]
                }, __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased'], state.theDependants[dependantIndex], dependantIndex);
            }

            if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()(dateOfDeath, 'DD/MM/YYYY'))) {
                dispatch('deleteDependantIncomePeriod', {
                    index: index,
                    dependant: state.theDependants[dependantIndex],
                    dependantIndex: dependantIndex
                });
            }
        });
    },
    updateDependencyOnIncomeValid: function updateDependencyOnIncomeValid(_ref32, valid) {
        var commit = _ref32.commit;

        commit(mutationTypes.UPDATE_DEPENDENCY_ON_INCOME_VALID, valid);
    },
    calcDurationForDependant: function calcDurationForDependant(_ref33, index) {
        var getters = _ref33.getters;

        return getters.durationOfDependency(index);
    },
    serverUpdateDependantsIncome: function serverUpdateDependantsIncome(_ref34, _ref35) {
        var commit = _ref34.commit;
        var data = _ref35.data;

        commit(mutationTypes.SERVER_UPDATE_DEPENDANTS_INCOME, data.dependants);
    },
    updatePeriodsForLifeExpectancy: function updatePeriodsForLifeExpectancy(_ref36, dateOfDeath) {
        var dispatch = _ref36.dispatch,
            state = _ref36.state;

        var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateOfDeath, 'DD/MM/YYYY');

        var proms = [];
        state.theDependants.forEach(function (dependant, dependantIndex) {
            var lastIndex = dependant.income.periods.length - 1;
            proms.concat(dependant.income.periods.map(function (period, index) {
                var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
                var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');

                if (start.isAfter(mDateOfDeath)) {
                    return dispatch('deleteDependantIncomePeriod', { dependant: dependant, dependantIndex: dependantIndex, index: index });
                } else if (end.isAfter(mDateOfDeath) || index === lastIndex) {
                        return dispatch('updateDependantIncomePeriodValue', {
                            index: index,
                            key: 'endOfPeriod',
                            value: dateOfDeath,
                            dependant: dependant,
                            dependantIndex: dependantIndex
                        });
                    }
            }));
        });
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
    },
    updateIncomePeriodForRetirementChange: function updateIncomePeriodForRetirementChange(_ref37, _ref38) {
        var state = _ref37.state,
            commit = _ref37.commit;
        var previousRetirementDate = _ref38.previousRetirementDate,
            index = _ref38.index;

        var dependant = state.theDependants[index];
        var retirementDate = dependant.income.retirementDate;
        var periods = dependant.income.periods;
        var end = periods[periods.length - 1].endOfPeriod;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["c" /* splitPeriodsForRetirement */])(commit, mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, mutationTypes.ADD_DEPENDANT_INCOME_PERIOD, previousRetirementDate, retirementDate, periods, end, dependant, index);
    },
    removePeriodsSplitForTheRetired: function removePeriodsSplitForTheRetired(_ref39, _ref40) {
        var dispatch = _ref39.dispatch,
            state = _ref39.state;
        var previousRetirementDate = _ref40.previousRetirementDate,
            index = _ref40.index;

        var dependant = state.theDependants[index];
        var retirementDate = dependant.income.retirementDate;
        var periods = dependant.income.periods;
        if (!dependant.income.retired) {
            return;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["g" /* removePeriodsSplitForTheRetired */])(dispatch, 'deleteDependantIncomePeriod', periods, previousRetirementDate, retirementDate, {
            dependant: dependant,
            dependantIndex: index
        });
    },
    updateIncomePeriodsForRetirement: function updateIncomePeriodsForRetirement(_ref41, dependantIndex) {
        var state = _ref41.state,
            dispatch = _ref41.dispatch;

        var dependant = state.theDependants[dependantIndex];
        var periods = dependant.income.periods;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["h" /* updateIncomePeriodsForRetirement */])(dispatch, 'updateDependantIncomePeriodValue', periods, dependant.income.retired, { dependant: dependant, dependantIndex: dependantIndex }).then(function (updatedPeriodIndex) {
            var proms = updatedPeriodIndex.map(function (updated, index) {
                if (!updated) return;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["i" /* zeroCheck */])(dispatch, index, periods[index], dependant, 'updateDependantIncomePeriodValue', 'dependant').then(function () {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(periods[index], dispatch, 'updateDependantIncomePeriodValue', {
                        index: index,
                        deceased: __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased'],
                        dependant: dependant,
                        dependantIndex: dependantIndex
                    }, state.theDependants[dependantIndex]);
                });
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANT, function (state) {
    var dependant = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["f" /* personTemplate */])();
    dependant.index = state.theDependants.length;
    state.theDependants.push(dependant);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT, function (state, _ref42) {
    var key = _ref42.key,
        value = _ref42.value,
        index = _ref42.index;

    state.theDependants[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DEPENDANTS_INCOME, function (state, data) {
    state.theDependants.map(function (dependant, key) {
        dependant.income = data[key];
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_LIFE_EXPECTANCY, function (state, _ref43) {
    var key = _ref43.key,
        value = _ref43.value,
        index = _ref43.index;

    state.theDependants[index].lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DEPENDANT, function (state, index) {
    state.theDependants.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANT_INCOME_PERIOD, function (state, _ref44) {
    var dependant = _ref44.dependant,
        period = _ref44.period;

    state.theDependants[dependant].income.periods.push(period);
    state.theDependants[dependant].income.netPensionIncome += period.netPensionIncome;
    state.theDependants[dependant].income.grossPensionIncome += period.grossPensionIncome;
    state.theDependants[dependant].income.netIncome += period.netIncome;
    state.theDependants[dependant].income.grossIncome += period.grossIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, function (state, _ref45) {
    var dependant = _ref45.dependant,
        key = _ref45.key,
        index = _ref45.index,
        value = _ref45.value,
        dependantIndex = _ref45.dependantIndex;

    var income = dependant.income;

    if (~key.indexOf('Income')) {
        income[key] -= income.periods[index][key] || 0;
    }
    income.periods[index][key] = value;
    if (~key.indexOf('Income')) {
        income[key] += value || 0;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DEPENDANT_INCOME_PERIOD, function (state, _ref46) {
    var dependantIndex = _ref46.dependantIndex,
        index = _ref46.index;

    state.theDependants[dependantIndex].income.periods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDENCY_ON_INCOME_VALID, function (state, valid) {
    state.dependencyOnIncomeValid = valid;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_INCOME, function (state, _ref47) {
    var key = _ref47.key,
        value = _ref47.value,
        index = _ref47.index;

    state.theDependants[index].income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.theDependants = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DEPENDANT, function (state, _ref48) {
    var dependant = _ref48.dependant,
        index = _ref48.index;

    state.theDependants.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["f" /* personTemplate */])());
    state.theDependants[index].id = dependant.id;
    state.theDependants[index].name = dependant.name;
    state.theDependants[index].gender = dependant.gender;
    state.theDependants[index].dateOfBirth = dependant.dateOfBirth;
    state.theDependants[index].lifeExpectancy = dependant.lifeExpectancy;
    state.theDependants[index].income = dependant.income;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATING_DEPENDANT_INCOME_PERIOD, function (state) {
    state.updatingDependantIncome = !state.updatingDependantIncome;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_generators_step__ = __webpack_require__(21);




var _mutations;












var mutationTypes = {
    RESET: 'RESET',
    LOAD_FROM_SERVER: 'LOAD_FROM_SERVER',
    UPDATE_DISCOUNT_RATE: 'UPDATE_DISCOUNT_RATE',
    UPDATE_DISCOUNT_TABLE: 'UPDATE_DISCOUNT_TABLE',
    RESET_MULTIPLIER_TABLE: 'RESET_MULTIPLIER_TABLE',
    UPDATE_MULTIPLIER_VALUE: 'UPDATE_MULTIPLIER_VALUE',
    LOAD_MULTIPLIER_TABLE1AND2: 'LOAD_MULTIPLIER_TABLE1AND2',
    UPDATE_MULTIPLIER_TABLE28_ROW: 'UPDATE_MULTIPLIER_TABLE28_ROW'
};

var convertTableRowFromServer = function convertTableRowFromServer(row) {
    return {
        period: row.period,
        numberOfDependants: row.numberOfDependants,
        start: __WEBPACK_IMPORTED_MODULE_3_moment___default()(row.start, 'DD-MM-YYYY').format('DD/MM/YYYY'),
        end: __WEBPACK_IMPORTED_MODULE_3_moment___default()(row.end, 'DD-MM-YYYY').format('DD/MM/YYYY'),
        duration: row.duration,
        formula: {
            base: row.formula.base,
            deceasedNet: row.formula.deceased_net,
            dependantsNet: row.formula.dependants_net,
            result: parseFloat(row.formula.result)
        },
        dependencyMultiplicand: row.dependencyMultiplicand,
        multiplier: row.multiplier,
        discountFactor: row.discountFactor,
        discountedMultiplier: row.discountedMultiplier,
        value: row.value
    };
};

var state = {
    total: null,
    discountTable: 28,
    periodSettlementToEnd: null,
    preAssessmentDiscount: null,
    postAssessmentDiscount: null,
    table28Multiplier: null,
    table1Or2Multiplier: null,
    table28: [],
    table1and2: [],
    durationOfDependency: null
};

var rules = {};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    getAll: function getAll(state) {
        return state;
    },
    table28: function table28(state) {
        return state.table28;
    },
    table1and2: function table1and2(state) {
        return state.table1and2;
    },
    preDependencyValue: function preDependencyValue(state) {
        if (state.discountTable === 28) {
            return state.table28.filter(function (row) {
                return row.period === 'pre';
            }).reduce(function (total, row) {
                return total + row.value;
            }, 0);
        }
        return state.table1and2.reduce(function (total, row) {
            return total + row.pre.periods.reduce(function (total, period) {
                return total + period.loss;
            }, 0);
        }, 0);
    },
    postDependencyValue: function postDependencyValue(state) {
        if (state.discountTable === 28) {
            return state.table28.filter(function (row) {
                return row.period === 'post';
            }).reduce(function (total, row) {
                return total + row.value;
            }, 0);
        }
        return state.table1and2.reduce(function (total, row) {
            return total + row.post.periods.reduce(function (total, period) {
                return total + period.loss;
            }, 0);
        }, 0);
    },
    discountTable: function discountTable(state) {
        return state.discountTable;
    },
    durationOfDependency: function durationOfDependency(state) {
        return state.durationOfDependency;
    }
};

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;


        var durationFind = __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/dependants/durationOfDependency'];

        payload.data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
            assumed_settlement: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/multiplicand/total']
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["r" /* financeValues */])(__WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased'], __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/durationDeceasedDependency'], 'deceased_'), {
            deceased: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["r" /* financeValues */])(__WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased'], __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/durationDeceasedDependency']),
            dependants: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/dependants/dependants'].map(function (dependant, i) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["r" /* financeValues */])(dependant, durationFind(i).duration);
            }),
            multiplicand: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/multiplicand/theMultiplicand'],
            discountTable: state.discountTable,
            table28: state.table28,
            table1and2: state.table1and2
        });

        __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_modules_claim__["d" /* requestPayload */])(0));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            commit = _ref2.commit;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;

        commit(mutationTypes.LOAD_FROM_SERVER, data);
        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/deceased/serverUpdateDeceasedIncome', { data: data });
        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/dependants/serverUpdateDependantsIncome', { data: data });
    },
    process: function process(_ref3) {
        var rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 3,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_generators_step__["a" /* previousValid */])(rootState, 3) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    validate: function validate(_ref4) {
        var rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 3,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_generators_step__["a" /* previousValid */])(rootState, 3) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        }).then(function () {
            __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
            __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/checkToUpdateMultipliers', null, { root: true });
            __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/dependants/updateDependencyOnIncomeValid', true);
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 3,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    updateDiscountTable: function updateDiscountTable(_ref6, rate) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch;

        commit(mutationTypes.UPDATE_DISCOUNT_TABLE, rate);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([dispatch('fatal/dependency/checkToUpdateMultipliers', null, { root: true }), dispatch('fatal/dependency/updateServices', null, { root: true }), dispatch('fatal/dependency/updateServicesTable', null, { root: true })]);
    },
    updateAllIncome: function updateAllIncome(_ref7, data) {
        var dispatch = _ref7.dispatch,
            state = _ref7.state;

        if (data.type === 'Deceased') {
            var updateIncome = __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased'].income.periods.map(function (period, index) {
                if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["o" /* isValidIncome */])(period) || data.income.retirementAge < 18 || data.income.retirementAge === "" || data.income.retirementDate === null) {
                    return;
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["s" /* unthrottledIncome */])(period, dispatch, 'fatal/dependency/deceased/updateDeceasedIncomePeriodValue', { index: index }, __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']);
            });

            dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
            return updateIncome;
        }
        var theDependant = __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/dependants/dependants'][data.index];
        data.income.periods.map(function (period, index) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["o" /* isValidIncome */])(period)) {
                return;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["s" /* unthrottledIncome */])(period, dispatch, 'fatal/dependency/dependants/updateDependantIncomePeriodValue', { index: index, dependant: theDependant, dependantIndex: data.index }, __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased'], data.index);
        });

        dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
    },
    updateFromServer: function updateFromServer(_ref8, serverValues) {
        var commit = _ref8.commit;

        commit(mutationTypes.UPDATE_MULTIPLIER_VALUE, {
            key: 'periodSettlementToEnd',
            value: serverValues.duration
        });
        commit(mutationTypes.UPDATE_MULTIPLIER_VALUE, {
            key: 'preAssessmentDiscount',
            value: serverValues.pre_assessment_discount
        });
        commit(mutationTypes.UPDATE_MULTIPLIER_VALUE, {
            key: 'postAssessmentDiscount',
            value: serverValues.post_assessment_discount
        });
        commit(mutationTypes.UPDATE_MULTIPLIER_VALUE, {
            key: 'table28Multiplier',
            value: serverValues.table_28_multiplier
        });
        commit(mutationTypes.UPDATE_MULTIPLIER_VALUE, {
            key: 'table1Or2Multiplier',
            value: serverValues.table_1_or_2_multiplier
        });
        commit(mutationTypes.UPDATE_MULTIPLIER_VALUE, {
            key: 'table1Or2Multiplier',
            value: serverValues.duration
        });
        commit(mutationTypes.UPDATE_MULTIPLIER_VALUE, {
            key: 'durationOfDependency',
            value: serverValues.duration
        });
        commit(mutationTypes.UPDATE_MULTIPLIER_VALUE, {
            key: 'value',
            value: serverValues.value
        });
    },
    updateTable28FromClaimLoad: function updateTable28FromClaimLoad(_ref9, serverValues) {
        var commit = _ref9.commit,
            dispatch = _ref9.dispatch;

        commit(mutationTypes.RESET_MULTIPLIER_TABLE);

        var objectLength = serverValues.length - 1;
        serverValues.forEach(function (row, key) {
            commit(mutationTypes.UPDATE_MULTIPLIER_TABLE28_ROW, convertTableRowFromServer(row));
            if (key === objectLength) {
                dispatch('fatal/dependency/headsOfLoss/updatePastDependencyOnIncome', null, { root: true });
            }
        });
    },
    updateTable1and2FromClaimLoad: function updateTable1and2FromClaimLoad(_ref10, serverValues) {
        var commit = _ref10.commit,
            dispatch = _ref10.dispatch;

        commit(mutationTypes.RESET_MULTIPLIER_TABLE);
        commit(mutationTypes.LOAD_MULTIPLIER_TABLE1AND2, serverValues);
        dispatch('fatal/dependency/headsOfLoss/updatePastDependencyOnIncome', null, { root: true });
    },
    resetMultiplier: function resetMultiplier(_ref11) {
        var commit = _ref11.commit;

        commit(mutationTypes.RESET_MULTIPLIER_TABLE);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_MULTIPLIER_VALUE, function (state, _ref12) {
    var key = _ref12.key,
        value = _ref12.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DISCOUNT_TABLE, function (state, table) {
    state.discountTable = parseInt(table, 10);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_MULTIPLIER_TABLE28_ROW, function (state, row) {
    state.table28.push(row);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOAD_MULTIPLIER_TABLE1AND2, function (state, serverValues) {
    state.table1and2.push(serverValues);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_MULTIPLIER_TABLE, function (state) {
    state.table28 = [];
    state.table1and2 = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOAD_FROM_SERVER, function (state, data) {
    state.discountTable = data.discountTable;
    state.periodSettlementToEnd = data.periodSettlementToEnd;
    state.preAssessmentDiscount = data.preAssessmentDiscount;
    state.postAssessmentDiscount = data.postAssessmentDiscount;
    state.table28Multiplier = data.table28Multiplier;
    state.table1Or2Multiplier = data.table1Or2Multiplier;
    state.value = data.value;
    state.table28 = data.table28;
    state.table1and2 = data.table1And2;
    state.durationOfDependency = data.durationOfDependency;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.discountTable = 28;
    state.periodSettlementToEnd = null;
    state.preAssessmentDiscount = null;
    state.postAssessmentDiscount = null;
    state.table28Multiplier = null;
    state.table1Or2Multiplier = null;
    state.value = null;
    state.table28 = [];
    state.table1and2 = [];
    state.durationOfDependency = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__ = __webpack_require__(33);




var _mutations;










var mutationTypes = {
    ADD_SERVICE: 'ADD_SERVICE',
    UPDATE_SERVICE: 'UPDATE_SERVICE',
    DELETE_SERVICE: 'DELETE_SERVICE',
    LOAD_FROM_SERVER: 'LOAD_FROM_SERVER',
    ADD_SERVICE_TABLE: 'ADD_SERVICE_TABLE',
    UPDATE_SERVICE_TABLE: 'UPDATE_SERVICE_TABLE',
    UPDATE_SERVICE_TABLE_LIST: 'UPDATE_SERVICE_TABLE_LIST',
    RESET: 'RESET',
    UPDATE_SERVICE_STATUS: 'UPDATE_SERVICE_STATUS'
};

var tableRowTemplate = function tableRowTemplate(serverRow) {
    return {
        period: serverRow.period || null,
        duration: serverRow.duration || 0,
        multiplicand: serverRow.multiplicand || 0,
        multiplier: serverRow.multiplier || 0,
        discount: serverRow.discount || 0,
        discountedMultiplier: serverRow.discounted_multiplier || 0,
        dependencyValue: serverRow.dependency_value || 0
    };
};

var state = {
    list: [],
    tableEntries: [],
    loading: false
};

var rules = {};

var getters = {
    find: function find(state) {
        return function (index) {
            return state.list[index];
        };
    },
    table: function table(state) {
        return function (index) {
            return state.tableEntries[index];
        };
    },
    all: function all(state) {
        return state.list;
    },
    allServicesProcessed: function allServicesProcessed(state) {
        return state.list.reduce(function (valid, service) {
            return !valid ? valid : service.calculatedDependency >= 0 && service.multiplicand >= 0;
        }, true);
    },
    preDependencyValue: function preDependencyValue(state) {
        return state.tableEntries.map(function (row) {
            return row.pre;
        }).reduce(function (total, row) {
            return total + row.dependencyValue;
        }, 0);
    },
    postDependencyValue: function postDependencyValue(state) {
        return state.tableEntries.map(function (row) {
            return row.post;
        }).reduce(function (total, row) {
            return total + row.dependencyValue;
        }, 0);
    },
    getServicesStatus: function getServicesStatus(state) {
        return state.loading;
    }
};

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;

        payload.data['services'] = state;

        __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_modules_claim__["d" /* requestPayload */])(3));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;

        commit(mutationTypes.LOAD_FROM_SERVER, data);
    },
    process: function process(_ref3) {
        var rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 4,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_generators_step__["a" /* previousValid */])(rootState, 4) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    validate: function validate(_ref4) {
        var rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 4,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_generators_step__["a" /* previousValid */])(rootState, 4) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 4,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    add: function add(_ref6) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        commit(mutationTypes.ADD_SERVICE);
        return dispatch('calcDuration', { index: state.list.length - 1 });
    },
    reCalcServices: function reCalcServices(_ref7) {
        var dispatch = _ref7.dispatch;

        if (state.list.length) {
            state.list.forEach(function (service, index) {
                return dispatch('calcDuration', { index: index });
            });
        }
    },
    updateTheMultiplicand: function updateTheMultiplicand(_ref8) {
        var dispatch = _ref8.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true })]);
    },
    calcDuration: function calcDuration(_ref9, _ref10) {
        var commit = _ref9.commit,
            rootGetters = _ref9.rootGetters,
            state = _ref9.state;
        var index = _ref10.index,
            key = _ref10.key;

        var dateOfDeath = rootGetters['fatal/dependency/deceased/theDeceased']['dateOfDeath'];
        var dateOfBirth = rootGetters['fatal/dependency/deceased/theDeceased']['dateOfBirth'];
        var mDateOfBirth = __WEBPACK_IMPORTED_MODULE_3_moment___default()(dateOfBirth, 'DD/MM/YYYY');
        var durationOfDependency = rootGetters['fatal/dependency/dependants/durationOfDependency'];
        var service = state.list[index];
        var assumedSettlement = rootGetters['fatal/dependency/claimDetails/value']('assumedSettlement');
        var mAssessmentDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(assumedSettlement, 'DD/MM/YYYY');
        var duration = durationOfDependency(0);
        var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_3_moment___default()(dateOfDeath, 'DD/MM/YYYY');
        var preTrial = mAssessmentDate.diff(mDateOfDeath, 'years', true);
        var assumedDateOfDeath = rootGetters['fatal/dependency/deceased/theDeceasedLifeExpectancy']['dateOfDeath'];
        switch (true) {
            case !service:
                return;
            case service.durationType === 'life':
                commit(mutationTypes.UPDATE_SERVICE, { key: 'duration', index: index, value: duration.duration + preTrial });
                commit(mutationTypes.UPDATE_SERVICE, { key: 'toDate', index: index, value: assumedDateOfDeath });
                break;
            case service.durationType === 'date' && key === 'toDate':
                var toDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(service.toDate, 'DD/MM/YYYY');
                if (!toDate.isValid()) {
                    break;
                }
                commit(mutationTypes.UPDATE_SERVICE, {
                    key: 'duration',
                    index: index,
                    value: toDate.diff(mDateOfDeath, 'years', true)
                });
                break;
            case service.durationType === 'years_and_months' && (key === 'years' || key === "months"):
                var endOfDuration = mDateOfDeath.clone().add(service.years, 'years').add(service.months, 'months');
                commit(mutationTypes.UPDATE_SERVICE, {
                    key: 'duration',
                    index: index,
                    value: endOfDuration.diff(mDateOfDeath, 'years', true)
                });
                commit(mutationTypes.UPDATE_SERVICE, { key: 'toDate', index: index, value: endOfDuration.format("DD/MM/YYYY") });
                break;
            case service.durationType === 'age' && key === 'age':
                var endOfAgeDuration = mDateOfBirth.clone().add(service.age, 'years');
                commit(mutationTypes.UPDATE_SERVICE, {
                    key: 'duration',
                    index: index,
                    value: endOfAgeDuration.diff(mDateOfDeath, 'years', true)
                });
                commit(mutationTypes.UPDATE_SERVICE, {
                    key: 'toDate',
                    index: index,
                    value: endOfAgeDuration.format("DD/MM/YYYY")
                });
                break;
            case service.durationType === 'date' && key === 'duration':
                commit(mutationTypes.UPDATE_SERVICE, {
                    key: 'toDate',
                    index: index,
                    value: mDateOfDeath.add(service.duration, 'years').format('DD/MM/YYYY')
                });
            case service.durationType === 'date':
                commit(mutationTypes.UPDATE_SERVICE, { key: 'duration', index: index, value: service.duration });
                commit(mutationTypes.UPDATE_SERVICE, { key: 'toDate', index: index, value: service.toDate });
                break;
        }
    },
    update: function update(_ref11, _ref12) {
        var dispatch = _ref11.dispatch;
        var index = _ref12.index,
            service = _ref12.service;

        var proms = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(service).map(function (key) {
            return dispatch('updateValue', { key: key, index: index, value: service[key] });
        });
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms).then(function (updatedKeys) {
            var proms = updatedKeys.map(function (key) {
                var triggerKeys = ['durationType', 'toDate', 'duration', 'years', 'months', 'age'];
                if (~triggerKeys.indexOf(key)) {
                    return dispatch('calcDuration', { index: index, key: key });
                }
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
        }).then(function () {
            return dispatch('updateValid', index);
        }).then(function (valid) {
            if (!valid && !isNaN(service.multiplicand)) {
                return;
            }
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([dispatch('fatal/dependency/updateServices', null, { root: true }), dispatch('fatal/dependency/updateServicesTable', null, { root: true }), dispatch('fatal/dependency/headsOfLoss/updatePastDependencyOnServices', null, { root: true })]);
        });
    },
    updateValue: function updateValue(_ref13, _ref14) {
        var commit = _ref13.commit,
            state = _ref13.state;
        var index = _ref14.index,
            key = _ref14.key,
            value = _ref14.value;

        if (state.list[index][key] !== value) {
            commit(mutationTypes.UPDATE_SERVICE, { index: index, key: key, value: value });
            return key;
        }
    },
    updateFromServer: function updateFromServer(_ref15, _ref16) {
        var dispatch = _ref15.dispatch;
        var index = _ref16.index,
            data = _ref16.data;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([dispatch('updateValue', { index: index, key: 'ogdenTableE', value: data.pre_assessment_discount }), dispatch('updateValue', { index: index, key: 'ogdenTableF', value: data.post_assessment_discount }), dispatch('updateValue', { index: index, key: 'ogdenTableTwentyEight', value: data.table_28_multiplier }), dispatch('updateValue', { index: index, key: 'calculatedDependency', value: data.value })]);
    },
    updateTableFromServer: function updateTableFromServer(_ref17, _ref18) {
        var commit = _ref17.commit,
            dispatch = _ref17.dispatch;
        var index = _ref18.index,
            data = _ref18.data;

        data.forEach(function (row) {
            commit(mutationTypes.UPDATE_SERVICE_TABLE, {
                index: index,
                tableRow: tableRowTemplate(row)
            });
        });
        dispatch('fatal/dependency/headsOfLoss/updatePastDependencyOnServices', null, { root: true });
    },
    updateValid: function updateValid(_ref19, index) {
        var dispatch = _ref19.dispatch,
            state = _ref19.state;

        var service = state.list[index];
        var valid = service.duration > 0 && service.multiplicand > 0;
        dispatch('updateValue', { key: 'valid', index: index, value: valid });
        return valid;
    },
    deleteService: function deleteService(_ref20, index) {
        var commit = _ref20.commit,
            state = _ref20.state,
            dispatch = _ref20.dispatch;

        commit(mutationTypes.DELETE_SERVICE, index);
        if (index === 0) {
            dispatch('add');
        }
    },
    updateServiceStatus: function updateServiceStatus(_ref21) {
        var commit = _ref21.commit;

        commit(mutationTypes.UPDATE_SERVICE_STATUS);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_SERVICE, function (state) {
    state.list.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["k" /* serviceTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_SERVICE, function (state, _ref22) {
    var key = _ref22.key,
        value = _ref22.value,
        index = _ref22.index;

    state.list[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_SERVICE_TABLE, function (state, _ref23) {
    var index = _ref23.index,
        tableRow = _ref23.tableRow;

    if (!state.tableEntries[index]) {
        state.tableEntries.push({
            pre: {},
            post: {}
        });
    }
    state.tableEntries[index][tableRow.period] = tableRow;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_SERVICE_TABLE_LIST, function (state, payload) {
    state.tableEntries = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_SERVICE, function (state, index) {
    state.list.splice(index, 1);
    state.tableEntries.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOAD_FROM_SERVER, function (state, data) {
    state.list = data.list;
    state.tableEntries = data.tableEntries;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.list = [];
    state.tableEntries = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_SERVICE_STATUS, function (state) {
    state.loading = !state.loading;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);



var _mutations;












var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',

    ADD_HEAD_OF_LOSS: 'ADD_HEAD_OF_LOSS',
    UPDATE_HEAD_OF_LOSS_VALUE: 'UPDATE_HEAD_OF_LOSS_VALUE',
    DELETE_HEAD_OF_LOSS: 'DELETE_HEAD_OF_LOSS',

    ADD_CARE_PERIOD: 'ADD_CARE_PERIOD',
    DELETE_CARE_PERIOD: 'DELETE_CARE_PERIOD',
    UPDATE_CARE_PERIOD_VALUE: 'UPDATE_CARE_PERIOD_VALUE',

    ADD_LOSS_OF_EARNINGS_PERIOD: 'ADD_LOSS_OF_EARNINGS_PERIOD',
    DELETE_LOSS_OF_EARNINGS_PERIOD: 'DELETE_LOSS_OF_EARNINGS_PERIOD',
    UPDATE_LOSS_OF_EARNINGS_PERIOD_VALUE: 'UPDATE_LOSS_OF_EARNINGS_PERIOD_VALUE',

    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    UPDATE_TOTAL_INTEREST: 'UPDATE_TOTAL_INTEREST',
    SET: 'SET',
    RESET: 'RESET',
    ADD_DEPENDANTS_HEAD_OF_LOSS: 'ADD_DEPENDANTS_HEAD_OF_LOSS',
    UPDATE_DEPENDANT_HEAD_OF_LOSS_VALUE: 'UPDATE_DEPENDANT_HEAD_OF_LOSS_VALUE',
    UPDATE_DEPENDANT_CUSTOM_HEAD_OF_LOSS_VALUE: 'UPDATE_DEPENDANT_CUSTOM_HEAD_OF_LOSS_VALUE',
    ADD_DEPENDANTS_CUSTOM_HEAD_OF_LOSS: 'ADD_DEPENDANTS_CUSTOM_HEAD_OF_LOSS',
    UPDATE_SUB_TOTAL: 'UPDATE_SUB_TOTAL',
    CLEAR_INTEREST: 'CLEAR_INTEREST'
};

var state = {
    bereavementAward: 0,
    bereavementAwardInterest: 0.5,
    bereavementAwardWithInterest: 0,

    careCalcType: 'own',
    customInterestDate: '',
    dependantsHeadsOfLoss: [],

    funeralExpenses: 0,
    funeralExpensesInterest: 0.5,
    funeralExpensesWithInterest: 0,

    futureDependencyOnIncome: 0,

    futureDependencyOnServices: 0,

    generalDamages: 0,
    generalDamagesInterest: 2.0,
    generalDamagesWithInterest: 0,

    gratuitousCare: false,

    headsOfLoss: [],

    interestType: 'today',

    lossOfSpouse: 0,
    lossOfSpouseInterest: 0.5,
    lossOfSpouseWithInterest: 0,

    misc: 0,
    miscInterest: 0.5,
    miscWithInterest: 0,

    ownCareFigure: 0,
    ownPastLossOfEarningsFigure: 0,

    pastCostOfCare: 0,
    pastCostOfCareInterest: 0.5,
    pastCostOfCareWithInterest: 0,
    pastCostOfTravel: 0,
    pastCostOfTravelInterest: 0.5,
    pastCostOfTravelWithInterest: 0,

    pastDependencyOnIncome: 0,
    pastDependencyOnIncomeInterest: 0.5,
    pastDependencyOnIncomeWithInterest: 0,

    pastDependencyOnServices: 0,
    pastDependencyOnServicesInterest: 0.5,
    pastDependencyOnServicesWithInterest: 0,

    pastLossOfEarnings: 0,
    pastLossOfEarningsInterest: 0.5,
    pastLossOfEarningsPeriods: [],
    pastLossOfEarningsType: 'own',
    pastLossOfEarningsWithInterest: 0,

    periods: [],

    subTotal: 0,

    totalInterest: 0
};

var rules = {
    'bereavementAward': { type: 'number', rules: 'required' }
};

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

var checkAllPeriodsValid = function checkAllPeriodsValid(state) {
    return state.periods.reduce(function (valid, period) {
        if (!valid) {
            return valid;
        }
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(period.periodStart, 'DD/MM/YYYY').isValid() && __WEBPACK_IMPORTED_MODULE_3_moment___default()(period.periodEnd, 'DD/MM/YYYY').isValid() && period.hoursPerDay > 0;
    }, true);
};

var checkPastLossOfEarningsPeriodsValid = function checkPastLossOfEarningsPeriodsValid(state) {
    return state.pastLossOfEarningsPeriods.reduce(function (valid, period) {
        if (!valid) {
            return valid;
        }

        var periodStart = __WEBPACK_IMPORTED_MODULE_3_moment___default()(period.periodStart, 'DD/MM/YYYY');
        var periodEnd = __WEBPACK_IMPORTED_MODULE_3_moment___default()(period.periodEnd, 'DD/MM/YYYY');
        var onsetOfSymptoms = __WEBPACK_IMPORTED_MODULE_3_moment___default()(__WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['onsetOfSymptoms'], 'DD/MM/YYYY');

        return periodStart.isValid() && periodEnd.isValid() && periodStart.isBefore(periodEnd) && periodStart.isAfter(onsetOfSymptoms) && periodEnd.isAfter(onsetOfSymptoms);
    }, true);
};

var getInterestDate = function getInterestDate(state) {
    switch (true) {
        case state.interestType === 'today':
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('DD/MM/YYYY');
            break;
        case state.interestType === 'assumed_settlement':
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(__WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY');
            break;
        case state.interestType === 'custom':
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(state.customInterestDate, 'DD/MM/YYYY').format('DD/MM/YYYY');
            break;
    }
};

var getAllHeadsOfLossValid = function getAllHeadsOfLossValid(state) {
    var allValid = true;

    if (typeof state.headsOfLoss !== 'undefined') {
        allValid = state.headsOfLoss.reduce(function (valid, headOfLoss) {
            return !valid ? valid : headOfLoss.name !== '' && headOfLoss.value > 0;
        }, allValid);
    }

    return allValid;
};

var calcHeadsOfLossTotal = function calcHeadsOfLossTotal() {
    var customHeadsOfLossTotal = state.headsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.value);
    }, 0);
    var customHeadsOfLossTotalWithInterest = state.headsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.withInterest);
    }, 0);

    var total = [state.generalDamages, state.generalDamagesWithInterest, state.bereavementAward, state.bereavementAwardWithInterest, state.funeralExpenses, state.funeralExpensesWithInterest, state.lossOfSpouse, state.lossOfSpouseWithInterest, state.pastCostOfTravel, state.pastCostOfTravelWithInterest, state.pastCostOfCare, state.pastCostOfCareWithInterest, state.pastLossOfEarnings, state.pastLossOfEarningsWithInterest, state.misc, state.miscWithInterest, state.pastDependencyOnIncome, state.pastDependencyOnIncomeWithInterest, state.pastDependencyOnServices, state.pastDependencyOnServicesWithInterest, customHeadsOfLossTotal, customHeadsOfLossTotalWithInterest].reduce(function (total, value) {
        return total + parseFloat(value, 10);
    }, 0);

    return numberVal(total).toFixed(2);
};

var calcHeadsOfLossTotalMinusInterest = function calcHeadsOfLossTotalMinusInterest() {
    var customHeadsOfLossTotal = state.headsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.value);
    }, 0);

    var total = [state.generalDamages, state.bereavementAward, state.funeralExpenses, state.lossOfSpouse, state.pastCostOfTravel, state.pastCostOfCare, state.pastLossOfEarnings, state.misc, state.pastDependencyOnIncome, state.pastDependencyOnServices, customHeadsOfLossTotal].reduce(function (total, value) {
        return total + parseFloat(value, 10);
    }, 0);

    return numberVal(total).toFixed(2);
};

var modalPayload = function modalPayload() {
    return {
        interimPayments: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/interimPayments/interimPayments'],
        assumedSettlement: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement'),
        serviceOfProceedings: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('serviceOfProceedings'),
        onsetOfSymptoms: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['onsetOfSymptoms'],
        assumedLifeExpectancy: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['assumedLifeExpectancy'],
        deductibles: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/cru/all'],
        headsOfLoss: state,
        headOfLoss: {}
    };
};

var getters = {
    getAll: function getAll(state) {
        return state;
    },
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    getModalPayload: function getModalPayload(state) {
        return modalPayload();
    },
    findHeadOfLoss: function findHeadOfLoss(state) {
        return function (index) {
            return state.headsOfLoss[index];
        };
    },
    headsOfLoss: function headsOfLoss(state) {
        return state.headsOfLoss;
    },
    findDependantsHeadsOfLoss: function findDependantsHeadsOfLoss(state) {
        return function (index) {
            return state.dependantsHeadsOfLoss[index];
        };
    },
    allHeadsOfLossValid: function allHeadsOfLossValid(state) {
        return getAllHeadsOfLossValid(state);
    },
    findPeriod: function findPeriod(state) {
        return function (index) {
            return state.periods[index];
        };
    },
    findLossOfEarningsPeriod: function findLossOfEarningsPeriod(state) {
        return function (index) {
            return state.pastLossOfEarningsPeriods[index];
        };
    },
    periods: function periods(state) {
        return state.periods;
    },
    allPeriodsValid: function allPeriodsValid(state) {
        return checkAllPeriodsValid(state);
    },
    pastLossOfEarningsPeriods: function pastLossOfEarningsPeriods(state) {
        return state.pastLossOfEarningsPeriods;
    },
    pastLossOfEarningsPeriodsValid: function pastLossOfEarningsPeriodsValid(state) {
        return checkPastLossOfEarningsPeriodsValid(state);
    },
    totalInterest: function totalInterest(state) {
        return state.totalInterest;
    },
    interestDate: function interestDate(state) {
        return getInterestDate(state);
    },
    getHeadsOfLossTotal: function getHeadsOfLossTotal(state) {
        return calcHeadsOfLossTotal();
    },
    getHeadsOfLossTotalMinusInterest: function getHeadsOfLossTotalMinusInterest(state) {
        return calcHeadsOfLossTotalMinusInterest();
    }
};

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.UPDATE_FROM_SERVER, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(state, data));
        commit(mutationTypes.SET, { key: 'periods', value: data.periods });
        commit(mutationTypes.SET, { key: 'pastLossOfEarningsPeriods', value: data.pastLossOfEarningsPeriods });
    },
    process: function process(_ref3) {
        var rootState = _ref3.rootState,
            dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 5,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_generators_step__["a" /* previousValid */])(rootState, 5) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });

        dispatch('determineBereavementAward');
    },
    validate: function validate(_ref4) {
        var dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 5,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_generators_step__["a" /* previousValid */])(rootState, 5) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        }).then(function () {
            return dispatch('determineBereavementAward');
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 5,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    updateValue: function updateValue(_ref6, _ref7) {
        var commit = _ref6.commit,
            state = _ref6.state,
            dispatch = _ref6.dispatch;
        var key = _ref7.key,
            value = _ref7.value;

        if (state[key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
        dispatch('updateSubTotal');
        return value;
    },
    updateValues: function updateValues(_ref8, data) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
            if (key.includes("custom_")) {
                commit(mutationTypes.UPDATE_HEAD_OF_LOSS_VALUE, {
                    key: data[key]['key'],
                    value: data[key]['value'],
                    index: data[key]['index']
                });
            }
            commit(mutationTypes.UPDATE_VALUE, { key: key + 'WithInterest', value: data[key] });
            dispatch('updateTotalInterest');
            dispatch('updateSubTotal');
        });
    },
    updateSubTotal: function updateSubTotal(_ref9) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootGetters = _ref9.rootGetters;

        var subTotal = numberVal(state.generalDamages) + numberVal(state.bereavementAward) + numberVal(state.funeralExpenses) + numberVal(state.lossOfSpouse) + numberVal(state.pastLossOfEarnings) + numberVal(state.pastCostOfTravel) + numberVal(state.pastCostOfCare) + numberVal(state.misc) + state.headsOfLoss.reduce(function (total, customHead) {
            return total + numberVal(customHead.value);
        }, 0) + numberVal(rootGetters['fatal/dependency/dependencyOnServices/preDependencyValue']) + numberVal(rootGetters['fatal/dependency/dependencyOnIncome/preDependencyValue']);
        commit(mutationTypes.UPDATE_SUB_TOTAL, numberVal(subTotal));
    },
    updateTotalInterest: function updateTotalInterest(_ref10) {
        var state = _ref10.state,
            commit = _ref10.commit;

        var total = numberVal(state.generalDamagesWithInterest) + numberVal(state.pastLossOfEarningsWithInterest) + numberVal(state.pastCostOfCareWithInterest) + numberVal(state.pastCostOfTravelWithInterest);
        commit(mutationTypes.UPDATE_TOTAL_INTEREST, total);
    },
    addHeadOfLoss: function addHeadOfLoss(_ref11) {
        var commit = _ref11.commit;

        commit(mutationTypes.ADD_HEAD_OF_LOSS);
    },
    addDependantHeadOfLoss: function addDependantHeadOfLoss(_ref12) {
        var commit = _ref12.commit;

        commit(mutationTypes.ADD_DEPENDANTS_HEAD_OF_LOSS);
    },
    deleteHeadOfLoss: function deleteHeadOfLoss(_ref13, index) {
        var commit = _ref13.commit;

        commit(mutationTypes.DELETE_HEAD_OF_LOSS, index);
    },
    addCarePeriod: function addCarePeriod(_ref14) {
        var commit = _ref14.commit;

        commit(mutationTypes.ADD_CARE_PERIOD);
    },
    addLossOfEarningsPeriod: function addLossOfEarningsPeriod(_ref15) {
        var commit = _ref15.commit;

        commit(mutationTypes.ADD_LOSS_OF_EARNINGS_PERIOD);
    },
    deleteCarePeriod: function deleteCarePeriod(_ref16, index) {
        var commit = _ref16.commit,
            dispatch = _ref16.dispatch;

        commit(mutationTypes.DELETE_CARE_PERIOD, index);
        return dispatch('updateCareTotal');
    },
    deleteLossOfEarningsPeriod: function deleteLossOfEarningsPeriod(_ref17, index) {
        var commit = _ref17.commit,
            dispatch = _ref17.dispatch;

        commit(mutationTypes.DELETE_LOSS_OF_EARNINGS_PERIOD, index);
        return dispatch('updatePastLossOfEarningsTotal');
    },
    updatePeriod: function updatePeriod(_ref18, _ref19) {
        var dispatch = _ref18.dispatch,
            commit = _ref18.commit;
        var care = _ref19.care,
            index = _ref19.index;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(care[0]).filter(function (key) {
            return key !== 'periodStart' && key !== 'periodEnd';
        }).forEach(function (key) {
            var value = care[0][key];
            commit(mutationTypes.UPDATE_CARE_PERIOD_VALUE, { key: key, value: value, index: index });
        });
        dispatch('updateCareTotal');
    },
    updatePeriodValue: function updatePeriodValue(_ref20, _ref21) {
        var commit = _ref20.commit,
            state = _ref20.state;
        var key = _ref21.key,
            value = _ref21.value,
            index = _ref21.index;

        if (key === 'hoursPerDay' && value > 24) {
            value = 24;
        }

        if (state.periods[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_CARE_PERIOD_VALUE, { key: key, value: value, index: index });
        return value;
    },
    updatePastLossOfEarningsPeriodValue: function updatePastLossOfEarningsPeriodValue(_ref22, _ref23) {
        var commit = _ref22.commit,
            state = _ref22.state;
        var key = _ref23.key,
            value = _ref23.value,
            index = _ref23.index;

        if (state.pastLossOfEarningsPeriods[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_LOSS_OF_EARNINGS_PERIOD_VALUE, { key: key, value: value, index: index });
        return value;
    },
    updateHeadOfLossValue: function updateHeadOfLossValue(_ref24, _ref25) {
        var commit = _ref24.commit,
            state = _ref24.state;
        var key = _ref25.key,
            value = _ref25.value,
            index = _ref25.index;

        if (state.headsOfLoss[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
        return value;
    },
    updateDependantHeadOfLossValue: function updateDependantHeadOfLossValue(_ref26, _ref27) {
        var commit = _ref26.commit,
            state = _ref26.state;
        var key = _ref27.key,
            value = _ref27.value,
            index = _ref27.index;

        if (state.dependantsHeadsOfLoss[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
        return value;
    },
    updateDependantCustomHeadOfLossValue: function updateDependantCustomHeadOfLossValue(_ref28, _ref29) {
        var commit = _ref28.commit,
            state = _ref28.state;
        var key = _ref29.key,
            value = _ref29.value,
            index = _ref29.index,
            comparisonIndex = _ref29.comparisonIndex;

        if (state.dependantsCustomHeadsOfLoss == 'undefined') {
            commit(mutationTypes.ADD_DEPENDANTS_CUSTOM_HEAD_OF_LOSS, { comparisonIndex: comparisonIndex });
        }
        commit(mutationTypes.UPDATE_DEPENDANT_CUSTOM_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
        return value;
    },
    determineBereavementAward: function determineBereavementAward(_ref30) {
        var dispatch = _ref30.dispatch,
            rootGetters = _ref30.rootGetters;

        var mDod = __WEBPACK_IMPORTED_MODULE_3_moment___default()(rootGetters['fatal/dependency/deceased/theDeceased']['dateOfDeath'], 'DD/MM/YYYY');
        if (!mDod.isValid()) {
            return;
        }
        if (mDod.isAfter('2020-04-30')) {
            return dispatch('updateValue', { key: 'bereavementAward', value: 15120 });
        }
        if (mDod.isAfter('2013-03-21')) {
            return dispatch('updateValue', { key: 'bereavementAward', value: 12980 });
        }
        if (mDod.isAfter('2008-01-01')) {
            return dispatch('updateValue', { key: 'bereavementAward', value: 11800 });
        }
        return dispatch('updateValue', { key: 'bereavementAward', value: 10000 });
    },
    calcAllInterest: function calcAllInterest(_ref31) {
        var dispatch = _ref31.dispatch,
            state = _ref31.state;

        if (state.interestType === 'none') {
            dispatch('clearInterest');return;
        }
        if (state.interestType === 'custom' && state.customInterestDate === '') {
            return;
        }
        var dateOfDeath = __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['dateOfDeath'];

        if (!dateOfDeath || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["e" /* isStepValid */])(2) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["e" /* isStepValid */])(6) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["e" /* isStepValid */])(8)) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].calculators.monetary.interest(__WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('proceduralStatus'), __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement'), __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('serviceOfProceedings'), __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['onsetOfSymptoms'], __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/deceased/theDeceased']['assumedLifeExpectancy'], __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/cru/all'], state, __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/dependency/interimPayments/interimPayments']).then(function (data) {
            return dispatch('updateValues', data);
        });
    },

    calcCareSubTotalForPeriod: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref32, index) {
        var dispatch = _ref32.dispatch,
            state = _ref32.state;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.periods[index].periodStart) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.periods[index].periodEnd) && state.periods[index].hoursPerDay > 0) {
            return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].calculators.monetary.detailedCare([state.periods[index]], state.gratuitousCare).then(function (care) {
                return dispatch('updatePeriod', { care: care, index: index });
            }).then(function () {
                return dispatch('updateCareTotal');
            });
        }
    }, 500),

    calcLossOfEarningsForPeriod: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref33, index) {
        var dispatch = _ref33.dispatch,
            state = _ref33.state,
            rootState = _ref33.rootState;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.pastLossOfEarningsPeriods[index].periodStart) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.pastLossOfEarningsPeriods[index].periodEnd) && state.pastLossOfEarningsPeriods[index].periodValue) {
            var period = state.pastLossOfEarningsPeriods[index];
            var person = rootState.fatal.dependency.deceased.theDeceased;

            return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].calculators.monetary.pastLossOfEarnings({ period: period, person: person }).then(function (result) {
                dispatch('updatePastLossOfEarningsPeriodValue', { key: 'periodTotal', value: result.period_total, index: index });
            }).then(function () {
                return dispatch('updatePastLossOfEarningsTotal');
            });
        }
    }, 500),

    updateCareTotal: function updateCareTotal(_ref34) {
        var commit = _ref34.commit,
            state = _ref34.state;

        var value = state.periods.reduce(function (total, period) {
            return total + numberVal(period.total);
        }, 0);
        commit(mutationTypes.UPDATE_VALUE, { key: 'pastCostOfCare', value: value.toFixed(2) });
    },
    updatePastLossOfEarningsTotal: function updatePastLossOfEarningsTotal(_ref35) {
        var commit = _ref35.commit,
            state = _ref35.state;

        var value = state.pastLossOfEarningsPeriods.reduce(function (total, period) {
            return total + numberVal(period.periodTotal);
        }, 0);
        commit(mutationTypes.UPDATE_VALUE, { key: 'pastLossOfEarnings', value: value.toFixed(2) });
    },
    ownCalculateCare: function ownCalculateCare(_ref36, value) {
        var commit = _ref36.commit,
            state = _ref36.state;

        var discountedCare = 0;
        if (value) {
            discountedCare = (state.ownCareFigure * 0.75).toFixed(2);
            commit(mutationTypes.UPDATE_VALUE, { key: 'pastCostOfCare', value: discountedCare });
        } else {
            commit(mutationTypes.UPDATE_VALUE, { key: 'pastCostOfCare', value: state.ownCareFigure });
        }
    },
    autoCalculateCare: function autoCalculateCare(_ref37, value) {
        var commit = _ref37.commit,
            dispatch = _ref37.dispatch;

        commit(mutationTypes.UPDATE_VALUE, { key: 'periods', value: [] });
        commit(mutationTypes.UPDATE_VALUE, { key: 'ownCareFigure', value: 0 });
        return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].calculators.monetary.autoCalculateCare(value).then(function (care) {
            return dispatch('updateValue', { key: 'pastCostOfCare', value: care.value });
        });
    },
    saveComparisonSchedule: function saveComparisonSchedule(_ref38) {
        var rootGetters = _ref38.rootGetters,
            dispatch = _ref38.dispatch;

        var data = rootGetters['fatal/dependency/dataForStep5'];
        return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.save(data).then(function (data) {
            dispatch('recordServerResponse', data);

            return data;
        });
    },
    updatePastDependencyOnIncome: function updatePastDependencyOnIncome(_ref39) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootGetters = _ref39.rootGetters;

        var pastDependencyOnIncome = rootGetters['fatal/dependency/dependencyOnIncome/preDependencyValue'];
        if (pastDependencyOnIncome) {
            commit(mutationTypes.UPDATE_VALUE, {
                key: 'pastDependencyOnIncome',
                value: numberVal(pastDependencyOnIncome.toFixed(2))
            });
        }
    },
    updatePastDependencyOnServices: function updatePastDependencyOnServices(_ref40) {
        var commit = _ref40.commit,
            rootGetters = _ref40.rootGetters;

        var pastDependencyOnServices = rootGetters['fatal/dependency/dependencyOnServices/preDependencyValue'];
        commit(mutationTypes.UPDATE_VALUE, {
            key: 'pastDependencyOnServices', value: numberVal(pastDependencyOnServices.toFixed(2))
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, _ref41) {
    var key = _ref41.key,
        value = _ref41.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_HEAD_OF_LOSS, function (state) {
    state.headsOfLoss.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["g" /* headOfLossTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANTS_HEAD_OF_LOSS, function (state) {
    state.dependantsHeadsOfLoss.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["h" /* dependantsHeadsOfLossTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANTS_CUSTOM_HEAD_OF_LOSS, function (state, _ref42) {
    var comparisonIndex = _ref42.comparisonIndex;

    state.dependantsHeadsOfLoss[comparisonIndex].dependantsCustomHeadsOfLoss.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["i" /* dependantsCustomHeadsOfLossTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_HEAD_OF_LOSS, function (state, index) {
    if (index === 0 && state.headsOfLoss.length === 1) {
        state.headsOfLoss = [];
    }
    state.headsOfLoss.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_CARE_PERIOD, function (state) {
    state.periods.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["e" /* carePeriodTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_CARE_PERIOD, function (state, index) {
    state.periods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CARE_PERIOD_VALUE, function (state, _ref43) {
    var key = _ref43.key,
        value = _ref43.value,
        index = _ref43.index;

    state.periods[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_LOSS_OF_EARNINGS_PERIOD, function (state) {
    state.pastLossOfEarningsPeriods.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["j" /* lossOfEarningsPeriodTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_LOSS_OF_EARNINGS_PERIOD, function (state, index) {
    state.pastLossOfEarningsPeriods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LOSS_OF_EARNINGS_PERIOD_VALUE, function (state, _ref44) {
    var key = _ref44.key,
        value = _ref44.value,
        index = _ref44.index;

    state.pastLossOfEarningsPeriods[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, _ref45) {
    var key = _ref45.key,
        value = _ref45.value;

    __WEBPACK_IMPORTED_MODULE_11_vue___default.a.set(state, key, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, data) {
    state.bereavementAward = data.bereavementAward;
    state.bereavementAwardInterest = data.bereavementAwardInterest;
    state.bereavementAwardWithInterest = data.bereavementAwardWithInterest;
    state.careCalcType = data.careCalcType;
    state.customInterestDate = data.customInterestDate;
    state.dependantsHeadsOfLoss = data.dependantsHeadsOfLoss;
    state.funeralExpenses = data.funeralExpenses;
    state.funeralExpensesInterest = data.funeralExpensesInterest;
    state.funeralExpensesWithInterest = data.funeralExpensesWithInterest;
    state.generalDamages = data.generalDamages;
    state.generalDamagesInterest = data.generalDamagesInterest;
    state.generalDamagesWithInterest = data.generalDamagesWithInterest;
    state.gratuitousCare = data.gratuitousCare;
    state.headsOfLoss = data.headsOfLoss;
    state.interestType = data.interestType;
    state.lossOfSpouse = data.lossOfSpouse;
    state.lossOfSpouseInterest = data.lossOfSpouseInterest;
    state.lossOfSpouseWithInterest = data.lossOfSpouseWithInterest;
    state.misc = data.misc;
    state.miscInterest = data.miscInterest;
    state.miscWithInterest = data.miscWithInterest;
    state.ownCareFigure = data.ownCareFigure;
    state.pastCostOfCare = data.pastCostOfCare;
    state.pastCostOfCareInterest = data.pastCostOfCareInterest;
    state.pastCostOfCareWithInterest = data.pastCostOfCareWithInterest;
    state.pastCostOfTravel = data.pastCostOfTravel;
    state.pastCostOfTravelInterest = data.pastCostOfTravelInterest;
    state.pastCostOfTravelWithInterest = data.pastCostOfTravelWithInterest;
    state.pastDependencyOnIncome = data.pastDependencyOnIncome;
    state.pastDependencyOnIncomeInterest = data.pastDependencyOnIncomeInterest;
    state.pastDependencyOnIncomeWithInterest = data.pastDependencyOnIncomeWithInterest;
    state.pastDependencyOnServices = data.pastDependencyOnServices;
    state.pastDependencyOnServicesInterest = data.pastDependencyOnServicesInterest;
    state.pastDependencyOnServicesWithInterest = data.pastDependencyOnServicesWithInterest;
    state.pastLossOfEarnings = data.pastLossOfEarnings;
    state.pastLossOfEarningsPeriods = data.pastLossOfEarningsPeriods;
    state.pastLossOfEarningsInterest = data.pastLossOfEarningsInterest;
    state.pastLossOfEarningsType = data.pastLossOfEarningsType;
    state.pastLossOfEarningsWithInterest = data.pastLossOfEarningsWithInterest;
    state.periods = data.periods;
    state.subTotal = data.subTotal;
    state.totalInterest = data.totalInterest;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TOTAL_INTEREST, function (state, value) {
    state.totalInterest = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_HEAD_OF_LOSS_VALUE, function (state, _ref46) {
    var key = _ref46.key,
        value = _ref46.value,
        index = _ref46.index;

    state.headsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_HEAD_OF_LOSS_VALUE, function (state, _ref47) {
    var key = _ref47.key,
        value = _ref47.value,
        index = _ref47.index;

    state.dependantsHeadsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_CUSTOM_HEAD_OF_LOSS_VALUE, function (state, _ref48) {
    var key = _ref48.key,
        value = _ref48.value,
        index = _ref48.index;

    state.dependantsCustomHeadsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_SUB_TOTAL, function (state, subTotal) {
    state.subTotal = subTotal;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.bereavementAward = 0;
    state.bereavementAwardInterest = 0.5;
    state.bereavementAwardWithInterest = 0;
    state.careCalcType = 'own';
    state.customInterestDate = '';
    state.dependantsHeadsOfLoss = [];
    state.funeralExpenses = 0;
    state.funeralExpensesInterest = 0.5;
    state.funeralExpensesWithInterest = 0;
    state.futureDependencyOnIncome = 0;
    state.futureDependencyOnServices = 0;
    state.generalDamages = 0;
    state.generalDamagesInterest = 2.0;
    state.generalDamagesWithInterest = 0;
    state.gratuitousCare = false;
    state.headsOfLoss = [];
    state.interestType = 'today';
    state.lossOfSpouse = 0;
    state.lossOfSpouseInterest = 0.5;
    state.lossOfSpouseWithInterest = 0;
    state.misc = 0;
    state.miscInterest = 0.5;
    state.miscWithInterest = 0;
    state.ownCareFigure = 0;
    state.ownPastLossOfEarningsFigure = 0;
    state.pastCostOfCare = 0;
    state.pastCostOfCareInterest = 0.5;
    state.pastCostOfCareWithInterest = 0;
    state.pastCostOfTravel = 0;
    state.pastCostOfTravelInterest = 0.5;
    state.pastCostOfTravelWithInterest = 0;
    state.pastDependencyOnIncome = 0;
    state.pastDependencyOnIncomeInterest = 0.5;
    state.pastDependencyOnIncomeWithInterest = 0;
    state.pastDependencyOnServices = 0;
    state.pastDependencyOnServicesInterest = 0.5;
    state.pastDependencyOnServicesWithInterest = 0;
    state.pastLossOfEarnings = 0;
    state.pastLossOfEarningsInterest = 0.5;
    state.pastLossOfEarningsPeriods = [];
    state.pastLossOfEarningsType = 'own';
    state.pastLossOfEarningsWithInterest = 0;
    state.periods = [];
    state.subTotal = 0;
    state.totalInterest = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CLEAR_INTEREST, function (state) {
    state.bereavementAwardWithInterest = 0;
    state.funeralExpensesWithInterest = 0;
    state.generalDamagesWithInterest = 0;
    state.lossOfSpouseWithInterest = 0;
    state.miscWithInterest = 0;
    state.pastCostOfCareWithInterest = 0;
    state.pastCostOfTravelWithInterest = 0;
    state.pastDependencyOnIncomeWithInterest = 0;
    state.pastDependencyOnServicesWithInterest = 0;
    state.pastLossOfEarningsWithInterest = 0;
    state.totalInterest = 0;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_modules_fatal_dependency_claimDetails__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_modules_fatal_dependency_calculateLoss__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_modules_fatal_dependency_people__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_fatal_dependency_proceduralDates__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_fatal_dependency_multiplicand__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_modules_fatal_dependency_headsOfLoss__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_fatal_dependency_dependencyOnServices__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_modules_fatal_dependency_step__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_modules_fatal_dependency_cru__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_store_modules_fatal_dependency_interimPayments__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store_modules_psla__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_store_modules_fatal_dependency_deceased__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_store_modules_fatal_dependency_dependants__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_store_modules_fatal_dependency_dependencyOnIncome__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_store_modules_lost_documents__ = __webpack_require__(158);























var mutationTypes = {
    LOADING_CLAIM: 'LOADING_CLAIM',
    UPDATING_TABLE: 'UPDATING_TABLE',
    CHANGE_CLAIM_ID: 'CHANGE_CLAIM_ID',
    FINISHED_LOADING_CLAIM: 'FINISHED_LOADING_CLAIM'
};

var state = {
    claimId: null
};

var getters = {};

var actions = {
    save: function save(_ref, payload) {
        var rootGetters = _ref.rootGetters;

        var individualStep = rootGetters['fatal/dependency/step/allSteps'][payload.step_number];

        return __WEBPACK_IMPORTED_MODULE_16_store_index__["a" /* default */].dispatch('fatal/dependency/' + individualStep.store + '/save', payload);
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            rootGetters = _ref2.rootGetters;

        var individualStep = rootGetters['fatal/dependency/step/allSteps'][parseInt(step.step_number, 10)];

        dispatch('checkForStepStore', individualStep).then(function () {
            return __WEBPACK_IMPORTED_MODULE_16_store_index__["a" /* default */].dispatch('fatal/dependency/' + individualStep.store + '/load', step);
        });
    },
    process: function process(_ref3, step) {
        var dispatch = _ref3.dispatch;

        dispatch('checkForStepStore', step).then(function () {
            return __WEBPACK_IMPORTED_MODULE_16_store_index__["a" /* default */].dispatch('fatal/dependency/' + step.store + '/process', step);
        }).then(function () {
            dispatch('updateMultipliers');
            dispatch('headsOfLoss/calcAllInterest');
        });
    },
    validate: function validate(_ref4, step) {
        var dispatch = _ref4.dispatch;

        dispatch('checkForStepStore', step).then(function () {
            __WEBPACK_IMPORTED_MODULE_16_store_index__["a" /* default */].dispatch('fatal/dependency/' + step.store + '/validate', step);
        }).then(function () {
            dispatch('checkToUpdateMultipliers');
            dispatch('headsOfLoss/calcAllInterest');
        });
    },
    reset: function reset(_ref5, step) {
        var dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        dispatch('checkForStepStore', step).then(function () {
            if (rootState.fatal.dependency[step.store]) {
                __WEBPACK_IMPORTED_MODULE_16_store_index__["a" /* default */].dispatch('fatal/dependency/' + step.store + '/reset', step);
            }
        });
    },
    checkForStepStore: function checkForStepStore(none, individualStep) {
        if (!individualStep.store) {
            throw { 'error': 'Step #' + individualStep.step + ' (' + individualStep.name + ') does not have a store defined in the routes meta' };
        }
    },
    checkToUpdateMultipliers: function checkToUpdateMultipliers(_ref6) {
        var state = _ref6.state,
            dispatch = _ref6.dispatch;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(1) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(2) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(3) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(4)) {
            return dispatch('updateMultipliers');
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(1) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(2) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(3) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(4) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_services_routingMethods__["e" /* isStepValid */])(5)) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([dispatch('updateServices'), dispatch('updateServicesTable')]);
        }
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
            return resolve(true);
        });
    },
    dependantUpdate: function dependantUpdate(_ref7, key) {
        var dispatch = _ref7.dispatch;

        switch (key) {
            case 'dateOfBirth':
                dispatch('proceduralDates/determineAgeAtSettlement');
                break;
            case 'dateOfDeath':
                dispatch('proceduralDates/determineAgeOfDeathToSettlement');
                dispatch('headsOfLoss/determineBereavementAward');
                break;
        }
    },

    updateTheMultiplicand: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.throttle(function (_ref8) {
        var state = _ref8.state,
            dispatch = _ref8.dispatch;

        var deceasedIncome = state.deceased.theDeceased.income.periods.map(function (period) {
            var startOfPeriod = __WEBPACK_IMPORTED_MODULE_15_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
            var endOfPeriod = __WEBPACK_IMPORTED_MODULE_15_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');
            var days = endOfPeriod.diff(startOfPeriod, 'days');
            return {
                days: days,
                multipliedNetIncome: period.totalNetIncome * days
            };
        }).reduce(function (total, period) {
            total[0].days += period.days;
            total[0].multipliedNetIncome += period.multipliedNetIncome;
            return total;
        }, [{
            days: 0,
            multipliedNetIncome: 0
        }]).reduce(function (total, result) {
            return result.multipliedNetIncome / result.days;
        }, 0);

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].calculators.monetary.multiplicand({ net_income: deceasedIncome }, state.dependants.theDependants, state.multiplicand.percentage).then(function (total) {
            return dispatch('multiplicand/updateTheValue', total);
        });
    }, 500),

    updateMultipliers: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref9) {
        var dispatch = _ref9.dispatch,
            state = _ref9.state,
            getters = _ref9.getters;

        var multiTotal = getters['multiplicand/determineTotal'];

        if (!state.deceased.theDeceased.lifeExpectancy.dateOfDeath) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].calculators.monetary.multiplier(state.deceased.theDeceased, __WEBPACK_IMPORTED_MODULE_16_store_index__["a" /* default */].getters['fatal/dependency/dependants/dependants'], state.claimDetails.claimantName, state.claimDetails.assumedSettlement, 'financial', getters['claimDetails/value']('discountRate'), getters['dependencyOnIncome/value']('discountTable'), multiTotal).then(function (data) {
            return dispatch('dependencyOnIncome/updateFromServer', data).then(function () {
                return dispatch('updateMultiplierTable');
            });
        });
    }, 500),

    updateMultiplierTable: function updateMultiplierTable(_ref10) {
        var dispatch = _ref10.dispatch,
            state = _ref10.state,
            getters = _ref10.getters;

        var multiTotal = getters['multiplicand/determineTotal'];
        var discountTable = getters['dependencyOnIncome/discountTable'];
        var dispatchUrl = 'dependencyOnIncome/updateTable1and2FromClaimLoad';

        if (state.dependants.theDependants.length < 1) {
            return;
        }

        if (discountTable === 28) {
            dispatchUrl = 'dependencyOnIncome/updateTable28FromClaimLoad';
        }

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].calculators.monetary.multiplierTable(state.deceased.theDeceased, state.dependants.theDependants, state.claimDetails.claimantName, state.claimDetails.assumedSettlement, getters['claimDetails/value']('discountRate'), getters['dependencyOnIncome/value']('discountTable'), multiTotal).then(function (data) {
            return dispatch(dispatchUrl, data);
        });
    },

    updateServices: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref11) {
        var dispatch = _ref11.dispatch,
            state = _ref11.state,
            getters = _ref11.getters;

        dispatch('dependencyOnServices/updateServiceStatus');
        var services = state.dependencyOnServices.list;
        var preTrial = getters['dependants/preTrialDependency'];
        if (!services.length) return;
        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].calculators.monetary.servicesMultiplier(state.deceased.theDeceased, state.claimDetails.claimantName, state.claimDetails.assumedSettlement, services, preTrial, getters['claimDetails/discountRate']).then(function (data) {
            var proms = data.map(function (data, index) {
                return dispatch('dependencyOnServices/updateFromServer', { data: data, index: index });
            });
            dispatch('dependencyOnServices/updateServiceStatus');
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(proms);
        });
    }, 500),

    updateServicesTable: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref12) {
        var dispatch = _ref12.dispatch,
            state = _ref12.state,
            getters = _ref12.getters;

        var services = state.dependencyOnServices.list;
        var preTrial = getters['dependants/preTrialDependency'];
        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].calculators.monetary.servicesTable(state.deceased.theDeceased, state.claimDetails.claimantName, state.claimDetails.assumedSettlement, services, preTrial, getters['claimDetails/discountRate'], getters['dependencyOnIncome/discountTable']).then(function (data) {
            var proms = data.map(function (data, index) {
                return dispatch('dependencyOnServices/updateTableFromServer', { data: data, index: index });
            });
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(proms);
        });
    }, 1000)
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.CHANGE_CLAIM_ID, function (state, payload) {
    state.claimId = payload;
});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {
        calculateLoss: __WEBPACK_IMPORTED_MODULE_5_store_modules_fatal_dependency_calculateLoss__["a" /* default */],
        claimDetails: __WEBPACK_IMPORTED_MODULE_4_store_modules_fatal_dependency_claimDetails__["a" /* default */],
        people: __WEBPACK_IMPORTED_MODULE_6_store_modules_fatal_dependency_people__["a" /* default */],
        proceduralDates: __WEBPACK_IMPORTED_MODULE_7_store_modules_fatal_dependency_proceduralDates__["a" /* default */],
        multiplicand: __WEBPACK_IMPORTED_MODULE_8_store_modules_fatal_dependency_multiplicand__["a" /* default */],
        dependencyOnServices: __WEBPACK_IMPORTED_MODULE_10_store_modules_fatal_dependency_dependencyOnServices__["a" /* default */],
        headsOfLoss: __WEBPACK_IMPORTED_MODULE_9_store_modules_fatal_dependency_headsOfLoss__["a" /* default */],
        cru: __WEBPACK_IMPORTED_MODULE_12_store_modules_fatal_dependency_cru__["a" /* default */],
        interimPayments: __WEBPACK_IMPORTED_MODULE_13_store_modules_fatal_dependency_interimPayments__["a" /* default */],
        psla: __WEBPACK_IMPORTED_MODULE_14_store_modules_psla__["a" /* default */],
        step: __WEBPACK_IMPORTED_MODULE_11_store_modules_fatal_dependency_step__["a" /* default */],
        deceased: __WEBPACK_IMPORTED_MODULE_17_store_modules_fatal_dependency_deceased__["a" /* default */],
        dependants: __WEBPACK_IMPORTED_MODULE_18_store_modules_fatal_dependency_dependants__["a" /* default */],
        dependencyOnIncome: __WEBPACK_IMPORTED_MODULE_19_store_modules_fatal_dependency_dependencyOnIncome__["a" /* default */],
        documents: __WEBPACK_IMPORTED_MODULE_21_store_modules_lost_documents__["a" /* default */]
    }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_validator_validations_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_generators_step__ = __webpack_require__(21);



var _mutations;









var mutationTypes = {
    ADD_INTERIM_PAYMENT: 'ADD_INTERIM_PAYMENT',
    UPDATE_INTERIM_PAYMENT: 'UPDATE_INTERIM_PAYMENT',
    DELETE_INTERIM_PAYMENT: 'DELETE_INTERIM_PAYMENT',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    RESET: 'RESET'
};

var state = {
    payments: []
};

var rules = {};

var paymentsTemplate = function paymentsTemplate() {
    return {
        date: '',
        value: 0
    };
};

var getters = {
    interimPayments: function interimPayments(state) {
        return state.payments;
    },
    findPayment: function findPayment(state) {
        return function (index) {
            return state.payments[index];
        };
    },
    allInterimPaymentsValid: function allInterimPaymentsValid(state, g, rs, rg) {
        var maxDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(rg['fatal/dependency/headsOfLoss/interestDate'], 'DD/MM/YYYY');
        return state.payments.reduce(function (valid, payment) {
            var mPaymentDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(payment.date, 'DD/MM/YYYY');
            return !valid ? valid : mPaymentDate.isValid() && payment.value > 0 && mPaymentDate.isBefore(maxDate);
        }, true);
    }
};

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_modules_claim__["d" /* requestPayload */])(5));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;

        dispatch('updateFromServer', { data: data });
    },
    validate: function validate(_ref3) {
        var rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 7,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_generators_step__["a" /* previousValid */])(rootState, 7) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    process: function process(_ref4) {
        var rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 7,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_generators_step__["a" /* previousValid */])(rootState, 7) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 7,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    addPayment: function addPayment(_ref6) {
        var commit = _ref6.commit;

        commit(mutationTypes.ADD_INTERIM_PAYMENT);
    },
    deletePayment: function deletePayment(_ref7, index) {
        var commit = _ref7.commit;

        commit(mutationTypes.DELETE_INTERIM_PAYMENT, index);
    },
    updatePayment: function updatePayment(_ref8, _ref9) {
        var commit = _ref8.commit,
            state = _ref8.state;
        var key = _ref9.key,
            value = _ref9.value,
            index = _ref9.index;

        if (state.payments[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_INTERIM_PAYMENT, { key: key, value: value, index: index });
        return value;
    },
    updateFromServer: function updateFromServer(_ref10, _ref11) {
        var commit = _ref10.commit;
        var data = _ref11.data;

        commit(mutationTypes.UPDATE_FROM_SERVER, data);

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.payments).reduce(function (valid, key) {
            return !valid ? valid : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_components_form_validator_validations_js__["d" /* stringRequired */])(state.payments[key].date);
        }, true);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_INTERIM_PAYMENT, function (state) {
    state.payments.push(paymentsTemplate());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_INTERIM_PAYMENT, function (state, index) {
    if (index === 0 && state.payments.length === 1) {
        state.payments = [];
    }
    state.payments.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INTERIM_PAYMENT, function (state, _ref12) {
    var key = _ref12.key,
        value = _ref12.value,
        index = _ref12.index;

    state.payments[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, values) {
    if (typeof values.payments != 'undefined') {
        state.payments = values.payments;
    } else {
        state.payments = [];
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.payments = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);




var _mutations;

var mutationTypes = {
    UPDATE_THE_MULTIPLICAND: 'UPDATE_THE_MULTIPLICAND',
    UPDATE_THE_MULTIPLICAND_TOTAL: 'UPDATE_THE_MULTIPLICAND_TOTAL',
    UPDATE_THE_MULTIPLICAND_PERCENTAGE: 'UPDATE_THE_MULTIPLICAND_PERCENTAGE',
    LOAD_FROM_SERVER: 'LOAD_FROM_SERVER',
    RESET: 'RESET'
};

var state = {
    periods: [],
    user: null,
    total: null,
    method: 'multiplicand_default',
    percentage: null
};

var getters = {
    total: function total(state) {
        return state.total;
    },
    determineTotal: function determineTotal(state) {
        return state.user ? state.user : state.total;
    },
    theMultiplicand: function theMultiplicand(state) {
        return state;
    }
};

var actions = {
    adjustTheMultiplicand: function adjustTheMultiplicand(_ref, multiplicand) {
        var dispatch = _ref.dispatch;

        var proms = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(multiplicand).map(function (key) {
            return dispatch('adjustTheMultiplicandValue', { key: key, value: multiplicand[key] });
        });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(proms);
    },
    adjustTheMultiplicandValue: function adjustTheMultiplicandValue(_ref2, _ref3) {
        var commit = _ref2.commit,
            state = _ref2.state,
            dispatch = _ref2.dispatch;
        var key = _ref3.key,
            value = _ref3.value;

        if (state[key] !== value) {
            commit(mutationTypes.UPDATE_THE_MULTIPLICAND, { key: key, value: value });
            return dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
        }
    },
    updateTheValue: function updateTheValue(_ref4, value) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch;

        commit(mutationTypes.UPDATE_THE_MULTIPLICAND_TOTAL, value);
        return dispatch('fatal/dependency/checkToUpdateMultipliers', null, { root: true });
    },
    loadFromServer: function loadFromServer(_ref5, payload) {
        var commit = _ref5.commit;

        commit(mutationTypes.LOAD_FROM_SERVER, payload);
    },
    reset: function reset(_ref6) {
        var commit = _ref6.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_THE_MULTIPLICAND, function (state, _ref7) {
    var key = _ref7.key,
        value = _ref7.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_THE_MULTIPLICAND_TOTAL, function (state, payload) {
    state.total = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOAD_FROM_SERVER, function (state, payload) {
    state.user = payload.user;
    state.total = payload.total;
    state.method = payload.method;
    state.percentage = payload.percentage;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.periods = [];
    state.user = null;
    state.total = null;
    state.method = 'multiplicand_default';
    state.percentage = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* unused harmony export throttleUpdateLife */
/* unused harmony export mutatePersonFromServer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);






var _mutations;









var mutationTypes = {
    UPDATE_DECEASED: 'UPDATE_DECEASED',
    RESET_DECEASED: 'RESET_DECEASED',
    SERVER_UPDATE_DECEASED: 'SERVER_UPDATE_DECEASED',
    SERVER_UPDATE_DECEASED_INCOME: 'SERVER_UPDATE_DECEASED_INCOME',
    UPDATE_DECEASED_LIFE_EXPECTANCY: 'UPDATE_DECEASED_LIFE_EXPECTANCY',
    UPDATE_DECEASED_INCOME: 'UPDATE_DECEASED_INCOME',
    ADD_DEPENDANT: 'ADD_DEPENDANT',
    UPDATE_DEPENDANT: 'UPDATE_DEPENDANT',
    RESET_DEPENDANTS: 'RESET_DEPENDANTS',
    SERVER_UPDATE_DEPENDANT: 'SERVER_UPDATE_DEPENDANT',
    SERVER_UPDATE_DEPENDANT_INCOME: 'SERVER_UPDATE_DEPENDANT_INCOME',
    DELETE_DEPENDANT: 'DELETE_DEPENDANT',
    UPDATE_DEPENDANT_LIFE_EXPECTANCY: 'UPDATE_DEPENDANT_LIFE_EXPECTANCY',
    UPDATE_DEPENDANT_INCOME: 'UPDATE_DEPENDANT_INCOME',
    ADD_DECEASED_INCOME_PERIOD: 'ADD_DECEASED_INCOME_PERIOD',
    UPDATE_DECEASED_INCOME_PERIOD: 'UPDATE_DECEASED_INCOME_PERIOD',
    DELETE_DECEASED_INCOME_PERIOD: 'DELETE_DECEASED_INCOME_PERIOD',
    ADD_DEPENDANT_INCOME_PERIOD: 'ADD_DEPENDANT_INCOME_PERIOD',
    UPDATE_DEPENDANT_INCOME_PERIOD: 'UPDATE_DEPENDANT_INCOME_PERIOD',
    DELETE_DEPENDANT_INCOME_PERIOD: 'DELETE_DEPENDANT_INCOME_PERIOD',
    UPDATE_DEPENDENCY_ON_INCOME_VALID: 'UPDATE_DEPENDENCY_ON_INCOME_VALID'
};

var DEFAULT_RETIREMENT = {
    male: 65,
    female: 62.5
};

function personTemplate() {
    return {
        name: '',
        dateOfBirth: null,
        dateOfDeath: null,
        onsetOfSymptoms: null,
        ageAtDeath: null,
        currentAge: null,
        gender: null,
        predictedDeath: null,
        levelOfEducation: null,
        income: incomeTemplate(),
        lifeExpectancy: lifeExpectancyTemplate()
    };
}

function incomeTemplate() {
    return {
        retired: true,
        retirementAge: 65,
        retirementDate: '',
        periods: []
    };
}

var defaultIncomePeriodTemplate = function defaultIncomePeriodTemplate(_ref) {
    var start = _ref.start,
        end = _ref.end;

    return {
        startOfPeriod: start,
        endOfPeriod: end,
        employmentType: 'employed',
        employmentIncome: 0,
        employmentNetGross: 'net',
        pensionIncome: 0,
        pensionNetGross: 'net',
        totalGrossIncome: 0,
        totalNetIncome: 0
    };
};

var incomePeriodTemplate = function incomePeriodTemplate(_ref2) {
    var start = _ref2.start,
        end = _ref2.end,
        employmentType = _ref2.employmentType,
        employmentIncome = _ref2.employmentIncome,
        employmentNetGross = _ref2.employmentNetGross,
        pensionIncome = _ref2.pensionIncome,
        pensionNetGross = _ref2.pensionNetGross,
        totalGrossIncome = _ref2.totalGrossIncome,
        totalNetIncome = _ref2.totalNetIncome;

    return {
        startOfPeriod: start,
        endOfPeriod: end,
        employmentType: employmentType,
        employmentIncome: employmentIncome,
        employmentNetGross: employmentNetGross,
        pensionIncome: pensionIncome,
        pensionNetGross: pensionNetGross,
        totalGrossIncome: totalGrossIncome,
        totalNetIncome: totalNetIncome
    };
};

function lifeExpectancyTemplate() {
    return {
        method: 'ogden_table',
        yearsAndMonths: {
            months: 0,
            years: 0
        },
        dateOfDeathIsAssumed: null,
        ageAtDeath: null,
        dateOfDeath: null,
        percentageOfNormalLifeExpectancy: 100,
        percentageReductionInNormalLifeExpectancy: 0,
        child: {
            youthCutOffAge: null,
            youthYearsLeft: null,
            youthCutOffDate: null
        }
    };
}

var state = {
    theDeceased: personTemplate(),
    dependants: [],
    dependencyOnIncomeValid: false
};

var findNextPeriodStart = function findNextPeriodStart(periods, worseCase) {
    return periods.reduce(function (min, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(min) ? periodDate : min;
    }, __WEBPACK_IMPORTED_MODULE_5_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var findNextPeriodEnd = function findNextPeriodEnd(periods, worseCase) {
    return periods.reduce(function (max, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(max) ? periodDate : max;
    }, __WEBPACK_IMPORTED_MODULE_5_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var determineDependency = function determineDependency(state, getters) {
    return function (index) {
        if (!state.dependants[index]) {
            return {};
        }
        var deceasedButForDate = state.theDeceased.lifeExpectancy.dateOfDeath;
        var assumedSettlement = getters['fatal/dependency/proceduralDates/date']('dateOfAssumedSettlement');
        var dependantDateOfDeath = state.dependants[index].lifeExpectancy.dateOfDeath;
        var mDeceasedButForDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(deceasedButForDate, 'DD/MM/YYYY');
        var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(assumedSettlement, 'DD/MM/YYYY');
        var mDependantDob = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.dependants[index].dateOfBirth, 'DD/MM/YYYY');
        var mDependantDateOfDeath = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dependantDateOfDeath, 'DD/MM/YYYY');

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(assumedSettlement) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(dependantDateOfDeath)) return {};

        if (Math.abs(mDependantDob.diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(), 'years')) < 21) {
            var dependencyEndAge = 18;
            switch (state.dependants[index].lifeExpectancy.method) {
                case 'dependent_until_custom':
                    dependencyEndAge = state.dependants[index].lifeExpectancy.child.youthCutOffAge;
                    break;
                case 'dependent_until_16':
                    dependencyEndAge = 16;
                    break;
                case 'dependent_until_21':
                    dependencyEndAge = 21;
                    break;
            }

            var dependencyEnd = mDependantDob.add(dependencyEndAge, 'years');

            if (mAssumedSettlement.isAfter(dependencyEnd) || mDeceasedButForDate.isAfter(dependencyEndAge)) {
                return {
                    duration: dependencyEnd.diff(mAssumedSettlement, 'years', true),
                    date: dependencyEnd.format('DD/MM/YYYY'),
                    type: 'To dependant\'s age of ' + dependencyEndAge
                };
            }
        }

        if (mAssumedSettlement.isAfter(mDependantDateOfDeath) || mDeceasedButForDate.isAfter(mDependantDateOfDeath)) {
            return {
                duration: mDependantDateOfDeath.diff(mAssumedSettlement, 'years', true),
                date: mDependantDateOfDeath.format('DD/MM/YYYY'),
                type: "To end of dependant's life expectancy"
            };
        }

        return {
            duration: mDeceasedButForDate.diff(mAssumedSettlement, 'years', true),
            date: mDeceasedButForDate.format('DD/MM/YYYY'),
            type: "To end of the deceased's life expectancy"
        };
    };
};

var valueFromState = function valueFromState(state, key) {
    return state[key];
};

var dependantValid = function dependantValid(dependant) {
    var valid = !!dependant.name && !!dependant.dateOfBirth && !!dependant.gender;
    return valid;
};

var dependantsNoChildren = function dependantsNoChildren(dependants) {
    return dependants.filter(function (dependant) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["q" /* isChild */])(dependant);
    });
};

var getters = {
    theDeceased: function theDeceased(state) {
        return valueFromState(state, 'theDeceased');
    },
    theDeceasedValue: function theDeceasedValue(state) {
        return function (key) {
            return valueFromState(state.theDeceased, [key]);
        };
    },
    theDeceasedIncomeValid: function theDeceasedIncomeValid(state) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['fatal/dependency/proceduralDates/date']('dateOfAssumedSettlement'), 'DD/MM/YYYY');

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["d" /* incomeValid */])(assumedSettlement, state.theDeceased);
    },
    durationDeceasedDependency: function durationDeceasedDependency(state) {
        return state.theDeceased.lifeExpectancy.ageAtDeath - state.theDeceased.ageAtDeath;
    },
    dependant: function dependant(state) {
        return function (index) {
            return valueFromState(state.dependants, index);
        };
    },
    dependants: function dependants(state) {
        return valueFromState(state, 'dependants');
    },
    dependantsNoChild: function dependantsNoChild(state) {
        return dependantsNoChildren(valueFromState(state, 'dependants'));
    },
    hasMultipleDependants: function hasMultipleDependants(state) {
        return valueFromState(state, 'dependants').length > 1;
    },
    noOfDependants: function noOfDependants(state) {
        return valueFromState(state, 'dependants').length;
    },
    allDependantsValid: function allDependantsValid(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_helper__["c" /* areAllTrue */])(valueFromState(state, 'dependants'), dependantValid);
    },
    dependantIncomeValid: function dependantIncomeValid(state) {
        return function (index) {
            var assumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['fatal/dependency/proceduralDates/date']('dateOfAssumedSettlement'), 'DD/MM/YYYY');

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["d" /* incomeValid */])(assumedSettlement, state.theDependants[index]);
        };
    },
    allDependantsIncomeValid: function allDependantsIncomeValid(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_helper__["c" /* areAllTrue */])(state.dependants, __WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["d" /* incomeValid */]);
    },
    theDeceasedNetIncome: function theDeceasedNetIncome(state) {
        return state.theDeceased.income.netIncome + state.theDeceased.income.netPensionIncome;
    },
    theDeceasedGrossIncome: function theDeceasedGrossIncome(state) {
        return state.theDeceased.income.grossIncome + state.theDeceased.income.grossPensionIncome;
    },
    dependantNetIncome: function dependantNetIncome(state) {
        return state.dependants.reduce(function (total, dependant) {
            return total + dependant.income.netIncome + dependant.income.netPensionIncome;
        }, 0);
    },
    dependantGrossIncome: function dependantGrossIncome(state) {
        return state.dependants.reduce(function (total, dependant) {
            return total + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["a" /* extractIncome */])(dependant, 'gross');
        }, 0);
    },

    maxDuration: function maxDuration(state, g, rs, rg) {
        return state.dependants.reduce(function (duration, dependant, index) {
            return duration;
        }, determineDependency(state, rg)(0));
    },
    hasSplitPeriods: function hasSplitPeriods(state) {
        if (!state.theDeceased.income.unchangedPension || !state.theDeceased.income.retired) {
            return true;
        }
        return state.dependants.reduce(function (hasSplit, dependant) {
            return hasSplit || !dependant.income.unchangedPension || !dependant.income.retired;
        }, false);
    },
    getDeceasedIncomePeriod: function getDeceasedIncomePeriod(state) {
        return function (index) {
            return state.theDeceased.income.periods[index];
        };
    },
    getDependantIncomePeriod: function getDependantIncomePeriod(state) {
        return function (dependant, index) {
            return state.dependants[dependant].income.periods[index];
        };
    },
    getDependencyOnIncomeValid: function getDependencyOnIncomeValid(state) {
        return state.dependencyOnIncomeValid;
    },
    getNoOfDependantPeriods: function getNoOfDependantPeriods(state) {
        return function (index) {
            return state.dependants[index].income.periods.length;
        };
    }
};

var updateObject = function updateObject(dispatch, action, obj) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var proms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return dispatch(action, { key: key, value: obj[key], index: index });
    });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms);
};

var dynamicUpdates = function dynamicUpdates(actions) {
    return function (key, dispatch, person, index) {
        var proms = [];
        switch (key) {
            case 'dateOfDeath':
            case 'dateOfBirth':
                if (actions.ageAtDeath) {
                    proms.push(dispatch(actions.ageAtDeath, {
                        key: 'ageAtDeath',
                        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["p" /* calcAgeDeath */])(person),
                        index: index,
                        force: true
                    }));
                }

                proms.push(dispatch(actions.lifeExpectancy, { lifeExpectancy: person.lifeExpectancy, index: index }));
                if (key == 'dateOfDeath') {
                    break;
                }

            case 'gender':
                proms.push(dispatch(actions.incomeValue, {
                    key: 'retirementAge',
                    value: DEFAULT_RETIREMENT[person.gender],
                    index: index
                }).then(function () {
                    return dispatch(actions.retirementDate, { index: index });
                }));
        }
        return proms;
    };
};

var theDeceasedEvents = dynamicUpdates({
    ageAtDeath: 'updateTheDeceasedValue',
    lifeExpectancy: 'updateTheDeceasedLifeExpectancy',
    incomeValue: 'updateTheDeceasedIncomeValue',
    retirementDate: 'updateRetirementAgeAndDate'
});

var dependantUpdateEvents = dynamicUpdates({
    lifeExpectancy: 'updateDependantLifeExpectancy',
    incomeValue: 'updateDependantIncomeValue',
    retirementDate: 'updateDependantRetirementDate'
});

var userSettable = function userSettable(key) {
    return key !== 'lifeExpectancy' && key !== 'income' && key !== 'ageAtDeath';
};

var incomeUpdates = function incomeUpdates(actions, dispatch, income, dateOfDeath, index) {
    return function (updatedKeys) {
        var proms = [];

        if (~updatedKeys.indexOf('retirementDate')) {
            proms.push(dispatch(actions.updateRetirementAge, { index: index }));
        }

        if (~updatedKeys.indexOf('retirementAge')) {
            proms.push(dispatch(actions.updateRetirementDate, { index: index }));
        }

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms);
    };
};

var doesIncomeNeedToUpdate = function doesIncomeNeedToUpdate(income, updatedKeys) {
    var triggerKeys = ['retired', 'grossIncome', 'netIncome', 'employmentType', 'netPensionIncome', 'grossPensionIncome'];
    var keys = updatedKeys.filter(function (key) {
        return key && ~triggerKeys.indexOf(key);
    });
    return !!keys.length;
};
var doesIncomePeriodNeedToUpdate = function doesIncomePeriodNeedToUpdate(updatedKeys) {
    var triggerKeys = ['startOfPeriod', 'endOfPeriod', 'employmentType', 'employmentIncome', 'employmentNetGross', 'pensionIncome', 'pensionNetGross', 'grossIncome', 'netIncome', 'netPensionIncome', 'grossPensionIncome'];
    var keys = updatedKeys.filter(function (key) {
        return key && ~triggerKeys.indexOf(key);
    });
    return !!keys.length;
};

var throttleUpdateLife = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.debounce(function (dispatch, action, person, lifeExpectancy, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return updateObject(dispatch, action, updatedLife, index);
        }).then(function () {
            return dispatch('updatePeriodsForLifeExpectancy');
        });
    }
}, 500);

var isValidIncome = function isValidIncome(period) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(period.startOfPeriod) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(period.endOfPeriod) && !isNaN(period.employmentIncome) && !isNaN(period.pensionIncome) && period.employmentIncome > 0 || period.pensionIncome > 0;
};

var zeroCheck = function zeroCheck(dispatch, index, period, person, action, type) {
    if (type === 'deceased') {
        if (person.income.retired === true && period.pensionIncome === 0) {
            dispatch(action, { key: 'totalNetIncome', value: 0, index: index });
        }
        if (person.income.retired === false && period.pensionIncome === 0 && period.employmentIncome === 0) {
            dispatch(action, { key: 'totalNetIncome', value: 0, index: index });
            dispatch(action, { key: 'totalGrossIncome', value: 0, index: index });
        }
    } else {
        if (person.income.retired === true && period.pensionIncome === 0) {
            dispatch(action, { key: 'totalNetIncome', value: 0, index: index, dependant: person });
        }
        if (person.income.retired === false && period.pensionIncome === 0 && period.employmentIncome === 0) {
            dispatch(action, { key: 'totalNetIncome', value: 0, index: index, dependant: person });
            dispatch(action, { key: 'totalGrossIncome', value: 0, index: index, dependant: person });
        }
    }
};

var throttledIncome = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.debounce(function (period, dispatch, action, args, deceased, dependant) {
    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.income(period, deceased, dependant).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {
                dispatch(action, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: key, value: updated[key] }, args));
            }
        });
    }).then(function () {
        return dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
    });
}, 500);

var unthrottledIncome = function unthrottledIncome(period, dispatch, action, args, deceased, dependant) {
    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.income(period, deceased, dependant).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {
                dispatch(action, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: key, value: updated[key] }, args));
            }
        });
    });
};

var actions = {
    updateTheDeceased: function updateTheDeceased(_ref3, theDeceased) {
        var dispatch = _ref3.dispatch;

        return updateObject(dispatch, 'updateTheDeceasedValue', theDeceased);
    },
    updateTheDeceasedValue: function updateTheDeceasedValue(_ref4, _ref5) {
        var commit = _ref4.commit,
            state = _ref4.state,
            dispatch = _ref4.dispatch;
        var key = _ref5.key,
            value = _ref5.value,
            _ref5$force = _ref5.force,
            force = _ref5$force === undefined ? false : _ref5$force;

        if (state.theDeceased[key] !== value && (force || userSettable(key))) {
            commit(mutationTypes.UPDATE_DECEASED, { key: key, value: value });

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(theDeceasedEvents(key, dispatch, state.theDeceased)), [dispatch('fatal/dependency/dependantUpdate', key, { root: true })]));
        }
    },
    updateTheDeceasedLifeExpectancy: function updateTheDeceasedLifeExpectancy(_ref6, _ref7) {
        var dispatch = _ref6.dispatch,
            state = _ref6.state;
        var lifeExpectancy = _ref7.lifeExpectancy;

        return updateObject(dispatch, 'updateTheDeceasedLifeExpectancyValue', lifeExpectancy).then(function () {
            return throttleUpdateLife(dispatch, 'updateTheDeceasedLifeExpectancyValue', state.theDeceased, lifeExpectancy);
        });
    },
    updateTheDeceasedLifeExpectancyValue: function updateTheDeceasedLifeExpectancyValue(_ref8, _ref9) {
        var commit = _ref8.commit,
            state = _ref8.state;
        var key = _ref9.key,
            value = _ref9.value;

        if (state.theDeceased.lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_DECEASED_LIFE_EXPECTANCY, { key: key, value: value });
        }
    },
    updateTheDeceasedIncome: function updateTheDeceasedIncome(_ref10, _ref11) {
        var dispatch = _ref10.dispatch,
            state = _ref10.state,
            getters = _ref10.getters;
        var income = _ref11.income;

        var actions = {
            updateRetirementAge: 'updateTheDeceasedRetirementAge',
            updateRetirementDate: 'updateTheDeceasedRetirementDate',
            updateValue: 'updateTheDeceasedIncomeValue'
        };
        var dependencyDuration = getters.durationOfDependency(0);

        return updateObject(dispatch, 'updateTheDeceasedIncomeValue', income).then(incomeUpdates(actions, dispatch, income, state.theDeceased.dateOfDeath, dependencyDuration));
    },
    updateTheDeceasedIncomeValue: function updateTheDeceasedIncomeValue(_ref12, _ref13) {
        var commit = _ref12.commit,
            state = _ref12.state;
        var key = _ref13.key,
            value = _ref13.value;

        if (state.theDeceased.income[key] === value) {
            return;
        }
        commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: key, value: value });
        return key;
    },
    updateTheDeceasedRetirementDate: function updateTheDeceasedRetirementDate(_ref14) {
        var commit = _ref14.commit,
            state = _ref14.state;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.theDeceased.dateOfBirth)) {
            return;
        }
        var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.dateOfBirth, 'DD/MM/YYYY').add(state.theDeceased.income.retirementAge, 'years').format('DD/MM/YYYY');
        if (!date || state.theDeceased.income.retirementDate === date) {
            return;
        }
        commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: 'retirementDate', value: date });
    },
    updateTheDeceasedRetirementAge: function updateTheDeceasedRetirementAge(_ref15) {
        var commit = _ref15.commit,
            state = _ref15.state;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.theDeceased.dateOfBirth) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.theDeceased.income.retirementDate)) {
            return;
        }
        var age = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.income.retirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
        if (isNaN(age) || state.theDeceased.income.retirementAge === age) {
            return;
        }
        commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: 'retirementAge', value: age });
    },
    addDependant: function addDependant(_ref16) {
        var commit = _ref16.commit;

        commit(mutationTypes.ADD_DEPENDANT);
    },
    updateDependant: function updateDependant(_ref17, _ref18) {
        var dispatch = _ref17.dispatch;
        var index = _ref18.index,
            dependant = _ref18.dependant;

        return updateObject(dispatch, 'updateDependantValue', dependant, index);
    },
    updateDependantValue: function updateDependantValue(_ref19, _ref20) {
        var commit = _ref19.commit,
            state = _ref19.state,
            dispatch = _ref19.dispatch;
        var key = _ref20.key,
            value = _ref20.value,
            index = _ref20.index;

        if (state.dependants[index][key] !== value && userSettable(key)) {
            commit(mutationTypes.UPDATE_DEPENDANT, { key: key, value: value, index: index });

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(dependantUpdateEvents(key, dispatch, state.dependants[index], index));
        }
    },
    updateDependantLifeExpectancy: function updateDependantLifeExpectancy(_ref21, _ref22) {
        var dispatch = _ref21.dispatch,
            state = _ref21.state;
        var index = _ref22.index,
            lifeExpectancy = _ref22.lifeExpectancy;

        return updateObject(dispatch, 'updateDependantLifeExpectancyValue', lifeExpectancy, index).then(function () {
            return throttleUpdateLife(dispatch, 'updateDependantLifeExpectancyValue', state.dependants[index], lifeExpectancy, index);
        });
    },
    updateDependantLifeExpectancyValue: function updateDependantLifeExpectancyValue(_ref23, _ref24) {
        var commit = _ref23.commit,
            state = _ref23.state;
        var key = _ref24.key,
            value = _ref24.value,
            index = _ref24.index;

        if (state.dependants[index].lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_DEPENDANT_LIFE_EXPECTANCY, { key: key, value: value, index: index });
        }
    },
    updateDependantYouth: function updateDependantYouth(_ref25, _ref26) {
        var commit = _ref25.commit;
        var key = _ref26.key,
            value = _ref26.value,
            index = _ref26.index;

        commit(mutationTypes.UPDATE_DEPENDANT_LIFE_EXPECTANCY, { key: key, value: value, index: index });
    },
    updateDependantIncome: function updateDependantIncome(_ref27, _ref28) {
        var dispatch = _ref27.dispatch,
            state = _ref27.state;
        var index = _ref28.index,
            income = _ref28.income;

        var actions = {
            updateRetirementAge: 'updateDependantRetirementAge',
            updateRetirementDate: 'updateDependantRetirementDate',
            updateValue: 'updateDependantIncomeValue'
        };

        return updateObject(dispatch, 'updateDependantIncomeValue', income, index).then(incomeUpdates(actions, dispatch, income, state.theDeceased.dateOfDeath, index));
    },
    updateDependantRetirementDate: function updateDependantRetirementDate(_ref29, _ref30) {
        var commit = _ref29.commit,
            state = _ref29.state;
        var index = _ref30.index;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.dependants[index].dateOfBirth)) {
            return;
        }
        var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.dependants[index].dateOfBirth, 'DD/MM/YYYY').add(state.dependants[index].income.retirementAge, 'years').format('DD/MM/YYYY');
        if (!date || state.dependants[index].income.retirementDate === date) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME, { key: 'retirementDate', value: date, index: index });
    },
    updateDependantRetirementAge: function updateDependantRetirementAge(_ref31, _ref32) {
        var commit = _ref31.commit,
            state = _ref31.state;
        var index = _ref32.index;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.dependants[index].dateOfBirth) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.dependants[index].income.retirementDate)) {
            return;
        }
        var age = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.dependants[index].income.retirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(state.dependants[index].dateOfBirth, 'DD/MM/YYYY'), 'years', true);
        if (isNaN(age) || state.dependants[index].income.retirementAge === age) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME, { key: 'retirementAge', value: age, index: index });
    },
    updateDependantIncomeValue: function updateDependantIncomeValue(_ref33, _ref34) {
        var commit = _ref33.commit,
            state = _ref33.state;
        var key = _ref34.key,
            value = _ref34.value,
            index = _ref34.index;

        if (state.dependants[index].income[key] === value) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME, { key: key, value: value, index: index });
        return key;
    },
    deleteDependant: function deleteDependant(_ref35, index) {
        var commit = _ref35.commit,
            state = _ref35.state,
            dispatch = _ref35.dispatch;

        commit(mutationTypes.DELETE_DEPENDANT, index);
        if (!state.dependants.length) {
            return dispatch('addDependant');
        }
    },
    calcDurationForDependant: function calcDurationForDependant(_ref36, index) {
        var getters = _ref36.getters;

        return getters.durationOfDependency(index);
    },
    addDeceasedIncomePeriod: function addDeceasedIncomePeriod(_ref37) {
        var commit = _ref37.commit,
            state = _ref37.state;

        var periods = state.theDeceased.income.periods,
            start = findNextPeriodStart(periods, state.theDeceased.dateOfDeath),
            end = findNextPeriodEnd(periods, state.theDeceased.lifeExpectancy.dateOfDeath);

        commit(mutationTypes.ADD_DECEASED_INCOME_PERIOD, defaultIncomePeriodTemplate({
            start: start,
            end: end
        }));
    },
    updateDependencyOnIncomeValid: function updateDependencyOnIncomeValid(_ref38, valid) {
        var commit = _ref38.commit;

        commit(mutationTypes.UPDATE_DEPENDENCY_ON_INCOME_VALID, valid);
    },
    updateDeceasedIncomePeriod: function updateDeceasedIncomePeriod(_ref39, _ref40) {
        var dispatch = _ref39.dispatch;
        var index = _ref40.index,
            period = _ref40.period,
            deceased = _ref40.deceased;

        updateObject(dispatch, 'updateDeceasedIncomePeriodValue', period, index).then(function (updatedKeys) {
            if (!doesIncomePeriodNeedToUpdate(updatedKeys)) {
                return;
            }
            zeroCheck(dispatch, index, period, deceased, 'updateDeceasedIncomePeriodValue', 'deceased');
            if (!isValidIncome(period) || deceased.income.retirementAge < 50 || deceased.income.retirementAge === "" || deceased.income.retirementDate === null) {
                return;
            }
            return throttledIncome(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, deceased);
        });
    },
    updateDeceasedIncomePeriodValue: function updateDeceasedIncomePeriodValue(_ref41, _ref42) {
        var commit = _ref41.commit,
            state = _ref41.state;
        var index = _ref42.index,
            key = _ref42.key,
            value = _ref42.value;

        if (state.theDeceased.income.periods[index]) {
            var currentPeriod = state.theDeceased.income.periods[index];
            if (currentPeriod[key] === value) {
                return;
            }
            commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: index, key: key, value: value });
            return key;
        }
    },
    deleteDeceasedIncomePeriod: function deleteDeceasedIncomePeriod(_ref43, _ref44) {
        var commit = _ref43.commit,
            state = _ref43.state,
            dispatch = _ref43.dispatch;
        var index = _ref44.index;

        commit(mutationTypes.DELETE_DECEASED_INCOME_PERIOD, index);
        if (!state.theDeceased.income.periods.length) {
            return dispatch('addDeceasedIncomePeriod');
        }
    },
    addDependantIncomePeriod: function addDependantIncomePeriod(_ref45, _ref46) {
        var commit = _ref45.commit,
            state = _ref45.state;
        var index = _ref46.index;

        var person = state.dependants[index];
        var periods = person.income.periods;

        commit(mutationTypes.ADD_DEPENDANT_INCOME_PERIOD, {
            dependant: index,
            period: defaultIncomePeriodTemplate({
                start: findNextPeriodStart(periods, state.theDeceased.dateOfDeath),
                end: findNextPeriodEnd(periods, state.theDeceased.lifeExpectancy.dateOfDeath)
            })
        });
    },
    updateDependantIncomePeriod: function updateDependantIncomePeriod(_ref47, _ref48) {
        var dispatch = _ref47.dispatch,
            state = _ref47.state;
        var index = _ref48.index,
            period = _ref48.period,
            dependant = _ref48.dependant;

        var proms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(period).map(function (key) {
            return dispatch('updateDependantIncomePeriodValue', { key: key, value: period[key], index: index, dependant: dependant });
        });
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms).then(function (updatedKeys) {
            if (!doesIncomePeriodNeedToUpdate(updatedKeys)) {
                return;
            }
            zeroCheck(dispatch, index, period, dependant, 'updateDependantIncomePeriodValue', 'dependant');
            if (!isValidIncome(period) || dependant.income.retirementAge < 50 || dependant.income.retirementAge === "" || dependant.income.retirementDate === null) {
                return;
            }
            throttledIncome(period, dispatch, 'updateDependantIncomePeriodValue', {
                index: index,
                dependant: dependant
            }, state.theDeceased, state.dependants[dependant]);
        });
    },
    updateDependantIncomePeriodValue: function updateDependantIncomePeriodValue(_ref49, _ref50) {
        var commit = _ref49.commit;
        var index = _ref50.index,
            key = _ref50.key,
            value = _ref50.value,
            dependant = _ref50.dependant;

        var currentPeriod = dependant.income.periods[index];
        if (currentPeriod[key] === value) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, { index: index, key: key, value: value, dependant: dependant });
        return key;
    },
    deleteDependantIncomePeriod: function deleteDependantIncomePeriod(_ref51, _ref52) {
        var commit = _ref51.commit,
            dispatch = _ref51.dispatch;
        var dependant = _ref52.dependant,
            index = _ref52.index;

        commit(mutationTypes.DELETE_DEPENDANT_INCOME_PERIOD, { dependant: dependant, index: index });
        if (!dependant.income.periods.length) {
            return dispatch('addDependantIncomePeriod', { index: dependant.index });
        }
    },
    updatePeriodsForDateOfDeath: function updatePeriodsForDateOfDeath(_ref53) {
        var commit = _ref53.commit,
            state = _ref53.state,
            dispatch = _ref53.dispatch;

        var dateOfDeath = state.theDeceased.dateOfDeath;
        if (state.theDeceased.income.periods.length) {
            commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: 0, key: 'startOfPeriod', value: dateOfDeath });
        }
        state.dependants.forEach(function (dependant, index) {
            if (dependant.income.periods.length) {
                commit(mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, {
                    index: 0,
                    key: 'startOfPeriod',
                    value: dateOfDeath,
                    dependant: state.dependants[index]
                });
            }
        });
        dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
    },
    updatePeriodsForLifeExpectancy: function updatePeriodsForLifeExpectancy(_ref54) {
        var commit = _ref54.commit,
            state = _ref54.state,
            dispatch = _ref54.dispatch;

        var dateOfDeath = state.theDeceased.lifeExpectancy.dateOfDeath;
        if (state.theDeceased.income.periods.length) {
            commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: state.theDeceased.income.periods.length - 1, key: 'endOfPeriod', value: dateOfDeath });
        }
        state.dependants.forEach(function (dependant, index) {
            if (dependant.income.periods.length) {
                commit(mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, {
                    index: dependant.income.periods.length - 1,
                    key: 'endOfPeriod',
                    value: state.theDeceased.lifeExpectancy.dateOfDeath,
                    dependant: state.dependants[index]
                });
            } else if (dependant.lifeExpectancy.dateOfDeath) {
                dispatch('addDependantIncomePeriod', { index: index });
            }
        });
        dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
    },
    removeDeceasedInvalidPeriodAndAddDefaults: function removeDeceasedInvalidPeriodAndAddDefaults(_ref55) {
        var commit = _ref55.commit,
            state = _ref55.state,
            dispatch = _ref55.dispatch;

        var dateOfDeath = state.theDeceased.dateOfDeath;

        state.theDeceased.income.periods.forEach(function (period, index) {
            if (state.theDeceased.income.retired) {
                commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: index, key: 'employmentIncome', value: 0 });
                throttledIncome(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, state.theDeceased);
            }

            var periodStart = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'),
                periodEnd = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');

            if (periodStart.isBefore(dateOfDeath)) {
                dispatch('deleteDeceasedIncomePeriod', { index: index });
            }
        });
    },
    removeDependantInvalidPeriodAndAddDefaults: function removeDependantInvalidPeriodAndAddDefaults(_ref56, _ref57) {
        var dispatch = _ref56.dispatch,
            state = _ref56.state;
        var index = _ref57.index;

        var dateOfDeath = state.dependants[index].dateOfDeathAssumed;

        state.dependants[index].income.periods.forEach(function (period, index) {
            if (state.dependants[index].income.retired) {
                dispatch('updateDependantIncomePeriodValue', {
                    key: 'employmentIncome',
                    value: 0,
                    index: index,
                    dependant: state.dependants[index]
                });
                throttledIncome(period, dispatch, 'updateDependantIncomePeriodValue', {
                    index: index,
                    dependant: state.dependants[index]
                }, state.theDeceased, state.dependants[index]);
            }

            var periodStart = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'),
                periodEnd = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');

            if (periodStart.isBefore(dateOfDeath)) {
                dispatch('deleteDependantIncomePeriod', { index: index, dependant: state.dependants[index] });
            }
        });
    },
    updateAllIncome: function updateAllIncome(_ref58, data) {
        var dispatch = _ref58.dispatch,
            state = _ref58.state;

        if (data.type === 'Deceased') {
            var updateIncome = state.theDeceased.income.periods.map(function (period, index) {
                if (!isValidIncome(period) || state.theDeceased.income.retirementAge < 50 || state.theDeceased.income.retirementAge === "" || state.theDeceased.income.retirementDate === null) {
                    return;
                }
                unthrottledIncome(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, state.theDeceased);
            });

            dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });

            return updateIncome;
        }

        var dependant = data.index || null;
        data.income.periods.map(function (period, index) {
            if (!isValidIncome(period) || state.dependants[dependant].income.retirementAge < 50 || state.dependants[dependant].income.retirementAge === "" || state.dependants[dependant].income.retirementDate === null) {
                return;
            }
            unthrottledIncome(period, dispatch, 'updateDependantIncomePeriodValue', {
                index: index,
                dependant: dependant
            }, state.theDeceased, data.income);
        });

        dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
    },
    reset: function reset(_ref59) {
        var commit = _ref59.commit;

        commit(mutationTypes.RESET_DECEASED);
        commit(mutationTypes.RESET_DEPENDANTS);
    },

    updateRetirementAgeAndDate: __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.debounce(function (_ref60) {
        var state = _ref60.state,
            commit = _ref60.commit;

        return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.dates.statePensionAge(state.theDeceased).then(function (data) {
            commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: 'retirementAge', value: data.statePension.retirementAge });
            commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: 'retirementDate', value: data.statePension.retirementDate });
        });
    }, 500)
};

var mutatePersonFromServer = function mutatePersonFromServer(person, payload, type) {
    var dob = __WEBPACK_IMPORTED_MODULE_5_moment___default()(payload.date_of_birth, 'YYYY-MM-DD');
    var dod = __WEBPACK_IMPORTED_MODULE_5_moment___default()(payload.date_of_death, 'YYYY-MM-DD');
    var onsetOfSymptoms = __WEBPACK_IMPORTED_MODULE_5_moment___default()(payload.onset_of_symptoms, 'YYYY-MM-DD');

    person.name = payload.name;
    person.gender = payload.gender;
    person.onsetOfSymptoms = onsetOfSymptoms.format('DD/MM/YYYY');
    person.dateOfBirth = dob.format('DD/MM/YYYY');
    if (dod.isValid()) {
        person.dateOfDeath = dod.isValid() ? dod.format('DD/MM/YYYY') : null;
        person.ageAtDeath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["p" /* calcAgeDeath */])(person);
    }
    person.lifeExpectancy = payload.full_life;
    person.income = payload.income;

    return true;
};

var mutatePersonIncomeFromServer = function mutatePersonIncomeFromServer(income, payload) {
    var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    income.retired = payload[prefix + 'retired'];
    income.retirementAge = payload[prefix + 'retirement_age'];
    income.retirementDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_helper__["b" /* dateFromServer */])(payload[prefix + 'retirement_date']);
    income.unchangedPension = payload[prefix + 'pension_unchanged'];
    income.netIncome = payload[prefix + 'net_income'];
    income.grossIncome = payload[prefix + 'gross_income'];
    income.netPensionIncome = payload[prefix + 'net_pension_income'];
    income.grossPensionIncome = payload[prefix + 'gross_pension__income'];
    income.employmentType = payload[prefix + 'employment_type'];
    income.periods = payload[prefix + 'periods'];
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED, function (state, _ref61) {
    var key = _ref61.key,
        value = _ref61.value;

    state.theDeceased[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_DECEASED, function (state) {
    state.theDeceased = personTemplate();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_LIFE_EXPECTANCY, function (state, _ref62) {
    var key = _ref62.key,
        value = _ref62.value;

    state.theDeceased.lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_INCOME, function (state, _ref63) {
    var key = _ref63.key,
        value = _ref63.value;

    state.theDeceased.income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANT, function (state) {
    var dependant = personTemplate();
    dependant.index = state.dependants.length;
    state.dependants.push(dependant);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT, function (state, _ref64) {
    var key = _ref64.key,
        value = _ref64.value,
        index = _ref64.index;

    state.dependants[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_DEPENDANTS, function (state) {
    state.dependants = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_LIFE_EXPECTANCY, function (state, _ref65) {
    var key = _ref65.key,
        value = _ref65.value,
        index = _ref65.index;

    state.dependants[index].lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_INCOME, function (state, _ref66) {
    var key = _ref66.key,
        value = _ref66.value,
        index = _ref66.index;

    state.dependants[index].income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DEPENDANT, function (state, index) {
    state.dependants.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DECEASED, function (state, payload) {
    state.theDeceased = personTemplate();
    return mutatePersonFromServer(state.theDeceased, payload, 'deceased');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DECEASED_INCOME, function (state, payload) {
    return mutatePersonIncomeFromServer(state.theDeceased.income, payload, 'deceased_');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DEPENDANT_INCOME, function (state, _ref67) {
    var index = _ref67.index,
        income = _ref67.income;

    return mutatePersonIncomeFromServer(state.dependants[index].income, income);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DEPENDANT, function (state, _ref68) {
    var dependant = _ref68.dependant;

    var index = state.dependants.length;
    state.dependants.push(personTemplate());
    state.dependants[index].index = index;
    return mutatePersonFromServer(state.dependants[index], dependant, 'dependant');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DECEASED_INCOME_PERIOD, function (state, payload) {
    state.theDeceased.income.periods.push(payload);
    state.theDeceased.income.netPensionIncome += payload.netPensionIncome;
    state.theDeceased.income.grossPensionIncome += payload.grossPensionIncome;
    state.theDeceased.income.netIncome += payload.netIncome;
    state.theDeceased.income.grossIncome += payload.grossIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, function (state, _ref69) {
    var key = _ref69.key,
        value = _ref69.value,
        index = _ref69.index;

    if (~key.indexOf('Income')) {
        state.theDeceased.income[key] -= state.theDeceased.income.periods[index][key] || 0;
    }
    state.theDeceased.income.periods[index][key] = value;
    if (~key.indexOf('Income')) {
        state.theDeceased.income[key] += value || 0;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DECEASED_INCOME_PERIOD, function (state, payload) {
    state.theDeceased.income.periods.splice(payload, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANT_INCOME_PERIOD, function (state, _ref70) {
    var dependant = _ref70.dependant,
        period = _ref70.period;

    state.dependants[dependant].income.periods.push(period);
    state.dependants[dependant].income.netPensionIncome += period.netPensionIncome;
    state.dependants[dependant].income.grossPensionIncome += period.grossPensionIncome;
    state.dependants[dependant].income.netIncome += period.netIncome;
    state.dependants[dependant].income.grossIncome += period.grossIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, function (state, _ref71) {
    var dependant = _ref71.dependant,
        key = _ref71.key,
        index = _ref71.index,
        value = _ref71.value;

    var income = state.dependants[dependant.index].income;
    if (~key.indexOf('Income')) {
        income[key] -= income.periods[index][key] || 0;
    }
    income.periods[index][key] = value;
    if (~key.indexOf('Income')) {
        income[key] += value || 0;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DEPENDANT_INCOME_PERIOD, function (state, _ref72) {
    var dependant = _ref72.dependant,
        index = _ref72.index;

    state.dependants[dependant.index].income.periods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDENCY_ON_INCOME_VALID, function (state, valid) {
    state.dependencyOnIncomeValid = valid;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_validations__ = __webpack_require__(23);



var _mutations;





var mutationTypes = {
    SET_DATE_OF_ISSUE_PROCEEDINGS: 'SET_DATE_OF_ISSUE_PROCEEDINGS',
    SET_DATE_OF_SERVICE_PROCEEDINGS: 'SET_DATE_OF_SERVICE_PROCEEDINGS',
    SET_DATE_OF_ASSUMED_SETTLEMENT: 'SET_DATE_OF_ASSUMED_SETTLEMENT',
    SET_AGE_OF_DEATH_TO_SETTLEMENT: 'SET_AGE_OF_DEATH_TO_SETTLEMENT',
    SET_AGE_AT_SETTLEMENT: 'SET_AGE_AT_SETTLEMENT',
    SET_PRE_LIT_OR_LIT: 'SET_PRE_LIT_OR_LIT',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    RESET: 'RESET'
};

var state = {
    preLitOrLit: 'pre-lit',
    dateOfIssueProceedings: null,
    dateOfServiceProceedings: null,
    dateOfAssumedSettlement: null,
    periodDeathToSettlement: null,
    ageAtSettlement: null
};

var getters = {
    date: function date(state) {
        return function (key) {
            return state[key];
        };
    },
    serviceOfProceedingsValid: function serviceOfProceedingsValid(state, g, rs, rg) {
        var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rg['fatal/dependency/people/theDeceasedValue']('dateOfDeath'), 'DD/MM/YYYY');
        var mDateOfServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rg['fatal/dependency/claimDetails/value']('serviceOfProceedings'), 'DD/MM/YYYY');
        var differenceInYears = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rg['fatal/dependency/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY').diff(mDateOfServiceOfProceedings, 'years');

        return differenceInYears <= 9 && differenceInYears >= 0 && ((mDateOfDeath.isValid() ? mDateOfDeath.isBefore(mDateOfServiceOfProceedings) : true) || (state.preLitOrLit !== 'litigated' ? true : mDateOfDeath.isBefore(mDateOfServiceOfProceedings)));
    },
    preTrialDependency: function preTrialDependency(state, g, rs, rg) {
        var dateOfDeath = rg['fatal/dependency/people/theDeceasedValue']('dateOfDeath');
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(state.dateOfAssumedSettlement, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(dateOfDeath, 'DD/MM/YYYY'), 'years', true);
    }
};

var actions = {
    setIssueProceedings: function setIssueProceedings(_ref, date) {
        var commit = _ref.commit;

        commit(mutationTypes.SET_DATE_OF_ISSUE_PROCEEDINGS, date);
    },
    setServiceProceedings: function setServiceProceedings(_ref2, date) {
        var commit = _ref2.commit;

        commit(mutationTypes.SET_DATE_OF_SERVICE_PROCEEDINGS, date);
    },
    setAssumedSettlement: function setAssumedSettlement(_ref3, date) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        commit(mutationTypes.SET_DATE_OF_ASSUMED_SETTLEMENT, date);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([dispatch('determineAgeOfDeathToSettlement'), dispatch('determineAgeAtSettlement'), dispatch('fatal/dependency/checkToUpdateMultipliers', null, { root: true })]);
    },
    setPreLitOrLit: function setPreLitOrLit(_ref4, value) {
        var commit = _ref4.commit;

        commit(mutationTypes.SET_PRE_LIT_OR_LIT, value);
    },
    determineAgeOfDeathToSettlement: function determineAgeOfDeathToSettlement(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state,
            rootGetters = _ref5.rootGetters;

        var mSettleDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(state.dateOfAssumedSettlement, 'DD/MM/YYYY');
        var mDod = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rootGetters['fatal/dependency/people/theDeceasedValue']('dateOfDeath'), 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDod.isValid()) {
            commit(mutationTypes.SET_AGE_OF_DEATH_TO_SETTLEMENT, mSettleDate.diff(mDod, 'years', true));
        }
    },
    determineAgeAtSettlement: function determineAgeAtSettlement(_ref6) {
        var commit = _ref6.commit,
            state = _ref6.state,
            rootGetters = _ref6.rootGetters;

        var mSettleDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(state.dateOfAssumedSettlement, 'DD/MM/YYYY');
        var mDob = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rootGetters['fatal/dependency/people/theDeceasedValue']('dateOfBirth'), 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDob.isValid()) {
            commit(mutationTypes.SET_AGE_AT_SETTLEMENT, mSettleDate.diff(mDob, 'years', true));
        }
    },
    load: function load(_ref7, step) {
        var dispatch = _ref7.dispatch,
            action = _ref7.action,
            commit = _ref7.commit;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;
        var proms = [];

        if (data.procedural_status) {
            proms.push(dispatch('setPreLitOrLit', dates.procedural_status));
        }
        if (dates.service_of_proceedings) {
            proms.push(dispatch('setServiceProceedings', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_helper__["b" /* dateFromServer */])(dates.service_of_proceedings)));
        }
        if (dates.assumed_settlement) {
            proms.push(dispatch('setAssumedSettlement', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_helper__["b" /* dateFromServer */])(dates.assumed_settlement)));
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(proms).then(function () {
            return state.ageAtSettlement > 0;
        });
    },
    reset: function reset(_ref8) {
        var commit = _ref8.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_DATE_OF_ISSUE_PROCEEDINGS, function (state, payload) {
    state.dateOfIssueProceedings = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_DATE_OF_SERVICE_PROCEEDINGS, function (state, payload) {
    state.dateOfServiceProceedings = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_DATE_OF_ASSUMED_SETTLEMENT, function (state, payload) {
    state.dateOfAssumedSettlement = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_AGE_OF_DEATH_TO_SETTLEMENT, function (state, payload) {
    state.periodDeathToSettlement = Math.round(payload * 10) / 10;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_AGE_AT_SETTLEMENT, function (state, payload) {
    state.ageAtSettlement = Math.round(payload * 10) / 10;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_PRE_LIT_OR_LIT, function (state, payload) {
    state.preLitOrLit = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.preLitOrLit = 'pre-lit';
    state.dateOfIssueProceedings = null;
    state.dateOfServiceProceedings = null;
    state.dateOfAssumedSettlement = null;
    state.periodDeathToSettlement = null;
    state.ageAtSettlement = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_fatal_accident_claims_dependency_routes__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_generators_step__ = __webpack_require__(21);



var steps = __WEBPACK_IMPORTED_MODULE_0_pages_fatal_accident_claims_dependency_routes__["a" /* default */].children.map(function (route) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_generators_step__["b" /* buildFromRoute */])({ route: route, prefix: 'fatal-accidents' });
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_generators_step__["c" /* default */])(steps));

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_generators_step__ = __webpack_require__(21);









var mutationTypes = {
    RESET: 'RESET'
};

var state = {};

var getters = {};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;


        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([]);
    },
    process: function process(_ref3) {
        var rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 5,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_generators_step__["a" /* previousValid */])(rootState, 5)
        });
    },
    validate: function validate(_ref4) {
        var rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 5,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_generators_step__["a" /* previousValid */])(rootState, 5) });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 5,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.RESET, function (state) {});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_generators_step__ = __webpack_require__(21);


var _mutations;







var mutationTypes = {
    RESET: 'RESET',
    UPDATE: 'UPDATE',
    SERVER_UPDATE: 'SERVER_UPDATE',
    UPDATE_DISCOUNT_RATE: 'UPDATE_DISCOUNT_RATE'
};

var state = {
    claimantName: null,
    defendantName: {
        id: null,
        name: null,
        type: null
    },
    claimantSolicitor: {
        id: null,
        name: null,
        type: null
    },
    claimantReference: null,
    yourReference: null,
    claimNarrative: null,
    diseaseOrAccident: null,
    accidentType: null,
    otherAccidentType: null,
    diseaseType: null,
    otherDiseaseType: null,
    proceduralStatus: 'pre-lit',
    serviceOfProceedings: null,
    assumedSettlement: null,
    discountRate: -0.25,
    levelOfEducation: null,
    disabled: 0,
    employedAtDeath: ''
};

var rules = {
    'claimantName': { type: 'text', rules: 'required' },
    'defendantName': { type: 'text', rules: 'required' },
    'claimantSolicitor': { type: 'text', rules: 'required' },
    'claimantReference': { type: 'text', rules: 'required' },
    'yourReference': { type: 'text', rules: 'required' },
    'claimNarrative': { type: 'text', rules: 'required' },

    'assumedSettlement': { type: 'date', rules: 'required' }
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    discountRate: function discountRate(state) {
        return state.discountRate;
    }
};

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE, { key: key, value: value });

        if (key === 'assumedSettlement') {
            dispatch('checkToUpdateLifeExpectancy');
            __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('fatal/estate/deceased/determineAgeOfDeathToSettlement');
            __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('fatal/estate/deceased/determineAgeAtSettlement');
        }
        if (key === 'discountRate') {
            return dispatch('updateDiscountRate', value);
        }
    },
    save: function save(_ref3, payload) {
        var dispatch = _ref3.dispatch;

        payload.data = state;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref4, step) {
        var commit = _ref4.commit;

        var data = __WEBPACK_IMPORTED_MODULE_1_lodash__["deeply"](__WEBPACK_IMPORTED_MODULE_1_lodash__["mapKeys"])(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash__["camelCase"](key);
        }).data;

        commit(mutationTypes.SERVER_UPDATE, data);
    },
    process: function process() {
        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 0,
            valid: true });
    },
    validate: function validate(_ref5) {
        var rootState = _ref5.rootState;

        var updateRules = __WEBPACK_IMPORTED_MODULE_1_lodash__["clone"](rules);
        if (rootState.user.user.hideNames) {
            delete updateRules['claimantName'];
        }
        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 0,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 0) && new __WEBPACK_IMPORTED_MODULE_4_services_Validator__["a" /* default */](state, updateRules).validate()
        });
    },
    reset: function reset(_ref6) {
        var commit = _ref6.commit;

        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 0,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    updateDiscountRate: function updateDiscountRate(_ref7, rate) {
        var commit = _ref7.commit,
            dispatch = _ref7.dispatch;

        commit(mutationTypes.UPDATE_DISCOUNT_RATE, rate);
    },
    checkToUpdateLifeExpectancy: function checkToUpdateLifeExpectancy(_ref8) {
        var dispatch = _ref8.dispatch;

        var lifeExpectancy = __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].getters['fatal/estate/deceased/theDeceasedLifeExpectancy'];
        if (lifeExpectancy.dateOfDeath !== null) {
            dispatch('fatal/estate/deceased/updateTheDeceasedLifeExpectancy', { lifeExpectancy: lifeExpectancy }, { root: true });
        }
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, _ref9) {
    var key = _ref9.key,
        value = _ref9.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DISCOUNT_RATE, function (state, rate) {
    state.discountRate = parseFloat(rate);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE, function (state, data) {
    state.claimantName = data.claimantName;
    state.claimantSolicitor = data.claimantSolicitor;
    state.claimantReference = data.claimantReference;
    state.yourReference = data.yourReference;
    state.claimNarrative = data.claimNarrative;
    state.diseaseOrAccident = data.diseaseOrAccident;
    state.diseaseType = data.diseaseType;
    state.otherDiseaseType = data.otherDiseaseType;
    state.accidentType = data.accidentType;
    state.otherAccidentType = data.otherAccidentType;
    state.defendantName = data.defendantName;
    state.proceduralStatus = data.proceduralStatus;
    state.serviceOfProceedings = data.serviceOfProceedings;
    state.assumedSettlement = data.assumedSettlement;
    state.discountRate = data.discountRate;
    state.levelOfEducation = data.levelOfEducation;
    state.disabled = data.disabled;
    state.employedAtDeath = data.employedAtDeath;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.claimantName = null;
    state.claimantReference = null;
    state.yourReference = null;
    state.claimNarrative = null;
    state.diseaseOrAccident = null;
    state.diseaseType = null;
    state.otherDiseaseType = null;
    state.accidentType = null;
    state.otherAccidentType = null;
    state.proceduralStatus = 'pre-lit';
    state.serviceOfProceedings = null;
    state.assumedSettlement = null;
    state.discountRate = -0.25;
    state.levelOfEducation = null;
    state.disabled = 0;
    state.employedAtDeath = '';
    state.defendantName.id = null;
    state.defendantName.name = null;
    state.defendantName.type = null;
    state.claimantSolicitor.id = null;
    state.claimantSolicitor.name = null;
    state.claimantSolicitor.type = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_generators_step__ = __webpack_require__(21);



var _mutations;






var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    UPDATE_INCLUDE: 'UPDATE_INCLUDE',
    RESET: 'RESET',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER'
};

var cruTemplate = function cruTemplate() {
    return {
        value: 0,
        include: false
    };
};

var state = {
    gdPneumoconiosis: cruTemplate(),
    gdMesothelioma: cruTemplate(),
    ploeDisabilityWorkingAllowance: cruTemplate(),
    ploeEmploymentSupportAllowance: cruTemplate(),
    ploeIncapacityBenefit: cruTemplate(),
    ploeIncomeSupport: cruTemplate(),
    ploeIndustrialInjuriesDisablementBenefit: cruTemplate(),
    ploeInvalidityPension: cruTemplate(),
    ploeInvalidityAllowance: cruTemplate(),
    ploeJobseekersAllowance: cruTemplate(),
    ploeReducedEarningsAllowance: cruTemplate(),
    ploeSevereDisablementAllowance: cruTemplate(),
    ploeSicknessBenefit: cruTemplate(),
    ploeStatutorySickPay: cruTemplate(),
    ploeUnemployabilitySupplement: cruTemplate(),
    ploeUnemploymentBenefit: cruTemplate(),
    ploeUniversalCredit: cruTemplate(),
    pcocAttendanceAllowance: cruTemplate(),
    pcocDisabilityLivingAllowance: cruTemplate(),
    pcocIndustrialInjuriesDisablementBenefit: cruTemplate(),
    pcocPersonalIndependencePayment: cruTemplate(),
    pcotDisabilityLivingAllowance: cruTemplate(),
    pcotMobilityAllowance: cruTemplate(),
    pcotPersonalIndependencePayment: cruTemplate()
};

var rules = {};

var returnCruValue = function returnCruValue(cru) {
    if (cru.include) {
        return parseFloat(cru.value);
    }
    return 0;
};

var generalDamagesOffset = function generalDamagesOffset(state) {
    var cruTotal = returnCruValue(state.gdPneumoconiosis) + returnCruValue(state.gdMesothelioma);
    var gdHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/estate/headsOfLoss/value']('generalDamages');

    if (cruTotal >= gdHeadOfLoss) {
        return gdHeadOfLoss;
    }

    return cruTotal;
};

var pastLossOfEarningsOffset = function pastLossOfEarningsOffset(state) {
    var cruTotal = returnCruValue(state.ploeDisabilityWorkingAllowance) + returnCruValue(state.ploeEmploymentSupportAllowance) + returnCruValue(state.ploeIncapacityBenefit) + returnCruValue(state.ploeIncomeSupport) + returnCruValue(state.ploeIndustrialInjuriesDisablementBenefit) + returnCruValue(state.ploeInvalidityPension) + returnCruValue(state.ploeInvalidityAllowance) + returnCruValue(state.ploeJobseekersAllowance) + returnCruValue(state.ploeReducedEarningsAllowance) + returnCruValue(state.ploeSevereDisablementAllowance) + returnCruValue(state.ploeSicknessBenefit) + returnCruValue(state.ploeStatutorySickPay) + returnCruValue(state.ploeUnemployabilitySupplement) + returnCruValue(state.ploeUnemploymentBenefit) + returnCruValue(state.ploeUniversalCredit);

    var ploeHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/estate/headsOfLoss/value']('pastLossOfEarnings');

    if (cruTotal >= ploeHeadOfLoss) {
        return ploeHeadOfLoss;
    }

    return cruTotal;
};

var pastCostOfCareOffset = function pastCostOfCareOffset(state) {
    var cruTotal = returnCruValue(state.pcocAttendanceAllowance) + returnCruValue(state.pcocDisabilityLivingAllowance) + returnCruValue(state.pcocIndustrialInjuriesDisablementBenefit) + returnCruValue(state.pcocPersonalIndependencePayment);

    var pcocHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/estate/headsOfLoss/value']('pastCostOfCare');

    if (cruTotal >= pcocHeadOfLoss) {
        return pcocHeadOfLoss;
    }

    return cruTotal;
};

var pastCostOfTravelOffset = function pastCostOfTravelOffset(state) {
    var cruTotal = returnCruValue(state.pcotDisabilityLivingAllowance) + returnCruValue(state.pcotMobilityAllowance) + returnCruValue(state.pcotPersonalIndependencePayment);

    var pcotHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['fatal/estate/headsOfLoss/value']('pastCostOfTravel');

    if (cruTotal >= pcotHeadOfLoss) {
        return pcotHeadOfLoss;
    }

    return cruTotal;
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key].value;
        };
    },
    include: function include(state) {
        return function (key) {
            return state[key].include;
        };
    },
    allValid: function allValid(state) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).reduce(function (valid, benefit) {
            return !valid ? valid : !(state[benefit].include == true && state[benefit].value <= 0);
        }, true);
    },
    all: function all(state) {
        return state;
    },
    gdPneumoconiosis: function gdPneumoconiosis(state) {
        return state.gdPneumoconiosis;
    },
    gdMesothelioma: function gdMesothelioma(state) {
        return state.gdMesothelioma;
    },
    ploeDisabilityWorkingAllowance: function ploeDisabilityWorkingAllowance(state) {
        return state.ploeDisabilityWorkingAllowance;
    },
    ploeEmploymentSupportAllowance: function ploeEmploymentSupportAllowance(state) {
        return state.ploeEmploymentSupportAllowance;
    },
    ploeIncapacityBenefit: function ploeIncapacityBenefit(state) {
        return state.ploeIncapacityBenefit;
    },
    ploeIncomeSupport: function ploeIncomeSupport(state) {
        return state.ploeIncomeSupport;
    },
    ploeIndustrialInjuriesDisablementBenefit: function ploeIndustrialInjuriesDisablementBenefit(state) {
        return state.ploeIndustrialInjuriesDisablementBenefit;
    },
    ploeInvalidityPension: function ploeInvalidityPension(state) {
        return state.ploeInvalidityPension;
    },
    ploeInvalidityAllowance: function ploeInvalidityAllowance(state) {
        return state.ploeInvalidityAllowance;
    },
    ploeJobseekersAllowance: function ploeJobseekersAllowance(state) {
        return state.ploeJobseekersAllowance;
    },
    ploeReducedEarningsAllowance: function ploeReducedEarningsAllowance(state) {
        return state.ploeReducedEarningsAllowance;
    },
    ploeSevereDisablementAllowance: function ploeSevereDisablementAllowance(state) {
        return state.ploeSevereDisablementAllowance;
    },
    ploeSicknessBenefit: function ploeSicknessBenefit(state) {
        return state.ploeSicknessBenefit;
    },
    ploeStatutorySickPay: function ploeStatutorySickPay(state) {
        return state.ploeStatutorySickPay;
    },
    ploeUnemployabilitySupplement: function ploeUnemployabilitySupplement(state) {
        return state.ploeUnemployabilitySupplement;
    },
    ploeUnemploymentBenefit: function ploeUnemploymentBenefit(state) {
        return state.ploeUnemploymentBenefit;
    },
    ploeUniversalCredit: function ploeUniversalCredit(state) {
        return state.ploeUniversalCredit;
    },
    pcocAttendanceAllowance: function pcocAttendanceAllowance(state) {
        return state.pcocAttendanceAllowance;
    },
    pcocDisabilityLivingAllowance: function pcocDisabilityLivingAllowance(state) {
        return state.pcocDisabilityLivingAllowance;
    },
    pcocIndustrialInjuriesDisablementBenefit: function pcocIndustrialInjuriesDisablementBenefit(state) {
        return state.pcocIndustrialInjuriesDisablementBenefit;
    },
    pcocPersonalIndependencePayment: function pcocPersonalIndependencePayment(state) {
        return state.pcocPersonalIndependencePayment;
    },
    pcotDisabilityLivingAllowance: function pcotDisabilityLivingAllowance(state) {
        return state.pcotDisabilityLivingAllowance;
    },
    pcotMobilityAllowance: function pcotMobilityAllowance(state) {
        return state.pcotMobilityAllowance;
    },
    pcotPersonalIndependencePayment: function pcotPersonalIndependencePayment(state) {
        return state.pcotPersonalIndependencePayment;
    },
    getGeneralDamagesOffset: function getGeneralDamagesOffset(state) {
        return generalDamagesOffset(state);
    },
    getPastLossOfEarningsOffset: function getPastLossOfEarningsOffset(state) {
        return pastLossOfEarningsOffset(state);
    },
    getPastCostOfCareOffset: function getPastCostOfCareOffset(state) {
        return pastCostOfCareOffset(state);
    },
    getPastCostOfTravelOffset: function getPastCostOfTravelOffset(state) {
        return pastCostOfTravelOffset(state);
    }
};

var actions = {
    updateValue: function updateValue(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        if (state[key].value !== value) {
            return commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
        }
        return value;
    },
    updateInclude: function updateInclude(_ref3, _ref4) {
        var commit = _ref3.commit,
            state = _ref3.state;
        var key = _ref4.key,
            value = _ref4.value;

        if (state[key].include !== value) {
            return commit(mutationTypes.UPDATE_INCLUDE, { key: key, value: value });
        }
        return value;
    },
    updateFromServer: function updateFromServer(_ref5, _ref6) {
        var commit = _ref5.commit;
        var data = _ref6.data;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
            commit(mutationTypes.UPDATE_FROM_SERVER, { key: key, value: _.values(data[key]) });
        });
        return true;
    },
    save: function save(_ref7, payload) {
        var state = _ref7.state,
            dispatch = _ref7.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref8, step) {
        var dispatch = _ref8.dispatch;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;

        dispatch('updateFromServer', { data: data });
    },
    validate: function validate(_ref9) {
        var rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 3,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 3) && new __WEBPACK_IMPORTED_MODULE_3_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    process: function process(_ref10) {
        var rootState = _ref10.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 3,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 3) && new __WEBPACK_IMPORTED_MODULE_3_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref11) {
        var commit = _ref11.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 3,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref12) {
    var key = _ref12.key,
        value = _ref12.value;

    state[key].value = value[0];
    state[key].include = value[1];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, _ref13) {
    var key = _ref13.key,
        value = _ref13.value;

    state[key].value = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCLUDE, function (state, _ref14) {
    var key = _ref14.key,
        value = _ref14.value;

    state[key].include = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
        state[key] = cruTemplate();
    });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* unused harmony export throttleUpdateLife */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_generators_step__ = __webpack_require__(21);




var _mutations;












var mutationTypes = {
    RESET: 'RESET',
    UPDATE: 'UPDATE',
    UPDATE_DECEASED: 'UPDATE_DECEASED',
    SERVER_UPDATE_INCOME: 'SERVER_UPDATE_INCOME',
    UPDATE_DECEASED_INCOME: 'UPDATE_DECEASED_INCOME',
    SERVER_UPDATE_DECEASED: 'SERVER_UPDATE_DECEASED',
    ADD_DECEASED_INCOME_PERIOD: 'ADD_DECEASED_INCOME_PERIOD',
    UPDATE_DECEASED_INCOME_PERIOD: 'UPDATE_DECEASED_INCOME_PERIOD',
    DELETE_DECEASED_INCOME_PERIOD: 'DELETE_DECEASED_INCOME_PERIOD',
    UPDATE_DECEASED_LIFE_EXPECTANCY: 'UPDATE_DECEASED_LIFE_EXPECTANCY'
};

var state = {
    theDeceased: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["f" /* personTemplate */])(),
    periodDeathToSettlement: null,
    ageAtSettlement: null
};

var rules = {
    'theDeceased.name': { type: 'text', rules: 'required' },
    'theDeceased.gender': { type: 'text', rules: 'required' },
    'theDeceased.dateOfBirth': { type: 'date', rules: 'required' },
    'theDeceased.onsetOfSymptoms': { type: 'date', rules: 'required' },
    'theDeceased.dateOfDeath': { type: 'date', rules: 'required' }
};

var getRules = function getRules(rootState) {
    var updateRules = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(rules);
    if (rootState.user.user.hideNames) {
        delete updateRules['claimantName'];
    }
    return updateRules;
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    theDeceased: function theDeceased(state) {
        return state.theDeceased;
    },
    theDeceasedIncome: function theDeceasedIncome(state) {
        return state.theDeceased.income;
    },
    theDeceasedLifeExpectancy: function theDeceasedLifeExpectancy(state) {
        return state.theDeceased.lifeExpectancy;
    },
    theDeceasedIncomeValid: function theDeceasedIncomeValid(state) {
        var dateOfAssumedSettlementStr = __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/proceduralDates/date']('dateOfAssumedSettlement');
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_4_moment___default()(dateOfAssumedSettlementStr, 'DD/MM/YYYY');

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["d" /* incomeValid */])(assumedSettlement, state.theDeceased);
    },
    getDeceasedIncomePeriod: function getDeceasedIncomePeriod(state) {
        return function (index) {
            return state.theDeceased.income.periods[index];
        };
    },
    theDeceasedNetIncome: function theDeceasedNetIncome(state) {
        return state.theDeceased.income.netIncome + state.theDeceased.income.netPensionIncome;
    },
    theDeceasedGrossIncome: function theDeceasedGrossIncome(state) {
        return state.theDeceased.income.grossIncome + state.theDeceased.income.grossPensionIncome;
    },
    durationDeceasedDependency: function durationDeceasedDependency(state) {
        return state.theDeceased.lifeExpectancy.ageAtDeath - state.theDeceased.ageAtDeath;
    }
};

var theDeceasedEvents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["e" /* dynamicUpdates */])({
    ageAtDeath: 'updateTheDeceasedValue',
    lifeExpectancy: 'updateTheDeceasedLifeExpectancy',
    incomeValue: 'updateTheDeceasedIncomeValue',
    retirementDate: 'updateRetirementAgeAndDate'
});

var throttleUpdateLife = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (dispatch, action, person, lifeExpectancy, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/claimDetails/value']('assumedSettlement');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, action, updatedLife, index);
        }).then(function () {
            return dispatch('updatePeriodsForLifeExpectancy');
        });
    }
}, 500);

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_modules_claim__["d" /* requestPayload */])(0));
    },
    load: function load(_ref2, step) {
        var commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.SERVER_UPDATE_DECEASED, data.theDeceased);
    },
    process: function process(_ref3) {
        var dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 1,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_generators_step__["a" /* previousValid */])(rootState, 1) && new __WEBPACK_IMPORTED_MODULE_7_services_Validator__["a" /* default */](state, getRules(rootState)).validate()
        });

        dispatch('determineAgeOfDeathToSettlement');
        dispatch('determineAgeAtSettlement');
    },
    validate: function validate(_ref4) {
        var rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 1,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_generators_step__["a" /* previousValid */])(rootState, 1) && new __WEBPACK_IMPORTED_MODULE_7_services_Validator__["a" /* default */](state, getRules(rootState)).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 1,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    update: function update(_ref6, _ref7) {
        var commit = _ref6.commit;
        var key = _ref7.key,
            value = _ref7.value;

        commit(mutationTypes.UPDATE, { key: key, value: value });
    },
    updateTheDeceasedLifeExpectancy: function updateTheDeceasedLifeExpectancy(_ref8, _ref9) {
        var dispatch = _ref8.dispatch,
            state = _ref8.state;
        var lifeExpectancy = _ref9.lifeExpectancy;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateTheDeceasedLifeExpectancyValue', lifeExpectancy).then(function () {
            return throttleUpdateLife(dispatch, 'updateTheDeceasedLifeExpectancyValue', state.theDeceased, lifeExpectancy);
        });
    },
    updateTheDeceasedLifeExpectancyValue: function updateTheDeceasedLifeExpectancyValue(_ref10, _ref11) {
        var commit = _ref10.commit,
            state = _ref10.state,
            dispatch = _ref10.dispatch;
        var key = _ref11.key,
            value = _ref11.value;

        if (state.theDeceased.lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_DECEASED_LIFE_EXPECTANCY, { key: key, value: value });
        }
    },
    updateTheDeceasedIncomeValue: function updateTheDeceasedIncomeValue(_ref12, _ref13) {
        var commit = _ref12.commit,
            state = _ref12.state;
        var key = _ref13.key,
            value = _ref13.value;

        if (state.theDeceased.income[key] === value || typeof value === 'number' && isNaN(value)) {

            return;
        }
        commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: key, value: value });
        return key;
    },

    updateRetirementAgeAndDate: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref14) {
        var state = _ref14.state,
            commit = _ref14.commit,
            dispatch = _ref14.dispatch;

        if (state.theDeceased.income.retirementAgeCalc === 'auto') {
            var previousRetirement = state.theDeceased.income.retirementDate;
            return __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].calculators.dates.statePensionAge(state.theDeceased).then(function (data) {
                commit(mutationTypes.UPDATE_DECEASED_INCOME, {
                    key: 'retirementAge',
                    value: data.statePension.retirementAge
                });
                commit(mutationTypes.UPDATE_DECEASED_INCOME, {
                    key: 'retirementDate',
                    value: data.statePension.retirementDate
                });
                dispatch('updateIncomePeriodForRetirementChange', previousRetirement);
            });
        }
    }, 500),

    updateIncomePeriodForRetirementChange: function updateIncomePeriodForRetirementChange(_ref15, previousRetirementDate) {
        var state = _ref15.state,
            commit = _ref15.commit;

        var retirementDate = state.theDeceased.income.retirementDate;
        var periods = state.theDeceased.income.periods;
        var end = periods[periods.length - 1].endOfPeriod;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["c" /* splitPeriodsForRetirement */])(commit, mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, mutationTypes.ADD_DECEASED_INCOME_PERIOD, previousRetirementDate, retirementDate, periods, end);
    },
    removePeriodsSplitForTheRetired: function removePeriodsSplitForTheRetired(_ref16, previousRetirementDate) {
        var state = _ref16.state,
            dispatch = _ref16.dispatch;

        var retirementDate = state.theDeceased.income.retirementDate;
        var periods = state.theDeceased.income.periods;
        if (!state.theDeceased.income.retired) {
            return;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["g" /* removePeriodsSplitForTheRetired */])(dispatch, 'deleteDeceasedIncomePeriod', periods, previousRetirementDate, retirementDate);
    },
    updateIncomePeriodsForRetirement: function updateIncomePeriodsForRetirement(_ref17) {
        var state = _ref17.state,
            dispatch = _ref17.dispatch;

        var deceased = state.theDeceased;
        var periods = deceased.income.periods;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["h" /* updateIncomePeriodsForRetirement */])(dispatch, 'updateDeceasedIncomePeriodValue', periods, deceased.income.retired).then(function (updatedPeriodIndex) {
            var proms = updatedPeriodIndex.map(function (updated, index) {
                if (!updated) return;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["i" /* zeroCheck */])(dispatch, index, periods[index], deceased, 'updateDeceasedIncomePeriodValue', 'deceased').then(function () {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(periods[index], dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, deceased);
                });
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
        });
    },
    updatePeriodsForLifeExpectancy: function updatePeriodsForLifeExpectancy(_ref18) {
        var state = _ref18.state,
            rootState = _ref18.rootState,
            dispatch = _ref18.dispatch;

        if (!rootState.fatal.estate.step.steps[0].valid || !rootState.fatal.estate.step.steps[1].valid || !rootState.fatal.estate.step.steps[2].valid || !rootState.fatal.estate.step.steps[3].valid) {
            return;
        }

        var dateOfDeath = state.theDeceased.lifeExpectancy.dateOfDeath;
        var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_4_moment___default()(dateOfDeath, 'DD/MM/YYYY');
        var lastIndex = state.theDeceased.income.periods.length - 1;

        var proms = state.theDeceased.income.periods.map(function (period, index) {
            var start = __WEBPACK_IMPORTED_MODULE_4_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
            var end = __WEBPACK_IMPORTED_MODULE_4_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');

            if (start.isAfter(mDateOfDeath)) {
                return dispatch('deleteDeceasedIncomePeriod', { index: index });
            } else if (end.isAfter(mDateOfDeath) || index === lastIndex) {
                    return dispatch('updateDeceasedIncomePeriodValue', { index: index, key: 'endOfPeriod', value: dateOfDeath });
                }
        });
        proms.push(dispatch('updateIncomePeriodForRetirementChange'));
        proms.push(dispatch('fatal/estate/dependants/updatePeriodsForLifeExpectancy', dateOfDeath, { root: true }));
        proms.push(dispatch('fatal/estate/updateTheMultiplicand', null, { root: true }));
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
    },
    determineAgeOfDeathToSettlement: function determineAgeOfDeathToSettlement(_ref19) {
        var commit = _ref19.commit,
            state = _ref19.state,
            rootGetters = _ref19.rootGetters;

        var mSettleDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(rootGetters['fatal/estate/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY');
        var mDod = __WEBPACK_IMPORTED_MODULE_4_moment___default()(state.theDeceased.dateOfDeath, 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDod.isValid()) {
            commit(mutationTypes.UPDATE, { key: 'periodDeathToSettlement', value: Math.round(mSettleDate.diff(mDod, 'years', true) * 10) / 10 });
        }
    },
    determineAgeAtSettlement: function determineAgeAtSettlement(_ref20) {
        var commit = _ref20.commit,
            state = _ref20.state,
            rootGetters = _ref20.rootGetters;

        var mSettleDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(rootGetters['fatal/estate/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY');
        var mDob = __WEBPACK_IMPORTED_MODULE_4_moment___default()(state.theDeceased.dateOfBirth, 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDob.isValid()) {
            commit(mutationTypes.UPDATE, { key: 'ageAtSettlement', value: Math.round(mSettleDate.diff(mDob, 'years', true) * 10) / 10 });
        }
    },
    updateTheDeceased: function updateTheDeceased(_ref21, theDeceased) {
        var dispatch = _ref21.dispatch;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateTheDeceasedValue', theDeceased);
    },
    updateTheDeceasedValue: function updateTheDeceasedValue(_ref22, _ref23) {
        var commit = _ref22.commit,
            state = _ref22.state,
            dispatch = _ref22.dispatch;
        var key = _ref23.key,
            value = _ref23.value,
            _ref23$force = _ref23.force,
            force = _ref23$force === undefined ? false : _ref23$force;

        if (state.theDeceased[key] !== value && (force || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["k" /* userSettable */])(key))) {
            commit(mutationTypes.UPDATE_DECEASED, { key: key, value: value });

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(theDeceasedEvents(key, dispatch, state.theDeceased)), [dispatch('determineAgeOfDeathToSettlement'), dispatch('determineAgeAtSettlement')]));
        }
    },
    addDeceasedIncomePeriod: function addDeceasedIncomePeriod(_ref24) {
        var commit = _ref24.commit,
            state = _ref24.state;

        var periods = state.theDeceased.income.periods,
            start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["l" /* findNextPeriodStart */])(periods, state.theDeceased.dateOfDeath),
            end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["m" /* findNextPeriodEnd */])(periods, state.theDeceased.lifeExpectancy.dateOfDeath);

        commit(mutationTypes.ADD_DECEASED_INCOME_PERIOD, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["a" /* defaultIncomePeriodTemplate */])({
            start: start,
            end: end
        }));
    },
    updateDeceasedIncomePeriod: function updateDeceasedIncomePeriod(_ref25, _ref26) {
        var dispatch = _ref25.dispatch;
        var index = _ref26.index,
            period = _ref26.period,
            deceased = _ref26.deceased;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateDeceasedIncomePeriodValue', period, index).then(function (updatedKeys) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["n" /* doesIncomePeriodNeedToUpdate */])(updatedKeys) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["o" /* isValidIncome */])(period) || deceased.income.retirementAge < 50 || deceased.income.retirementAge === '') {
                return;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["i" /* zeroCheck */])(dispatch, index, period, deceased, 'updateDeceasedIncomePeriodValue', 'deceased').then(function () {
                return dispatch('fatal/estate/dependencyOnIncome/resetMultiplier', null, { root: true });
            });

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, deceased);
        });
    },
    updateDeceasedIncomePeriodValue: function updateDeceasedIncomePeriodValue(_ref27, _ref28) {
        var commit = _ref27.commit,
            state = _ref27.state;
        var index = _ref28.index,
            key = _ref28.key,
            value = _ref28.value;

        if (state.theDeceased.income.periods[index]) {
            var currentPeriod = state.theDeceased.income.periods[index];
            if (currentPeriod[key] === value) {
                return;
            }
            commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: index, key: key, value: value });
            return key;
        }
    },
    deleteDeceasedIncomePeriod: function deleteDeceasedIncomePeriod(_ref29, _ref30) {
        var commit = _ref29.commit,
            state = _ref29.state,
            dispatch = _ref29.dispatch;
        var index = _ref30.index;

        var periodEnd = state.theDeceased.income.periods[index].endOfPeriod;
        commit(mutationTypes.DELETE_DECEASED_INCOME_PERIOD, index);

        if (!state.theDeceased.income.periods.length) {
            return dispatch('addDeceasedIncomePeriod');
        }

        if (state.theDeceased.income.periods[index - 1]) {
            return dispatch('updateDeceasedIncomePeriodValue', {
                key: 'endOfPeriod',
                value: periodEnd,
                index: index - 1
            });
        }
    },
    removeDeceasedInvalidPeriodAndAddDefaults: function removeDeceasedInvalidPeriodAndAddDefaults(_ref31) {
        var commit = _ref31.commit,
            state = _ref31.state,
            dispatch = _ref31.dispatch;

        var dateOfDeath = __WEBPACK_IMPORTED_MODULE_4_moment___default()(state.theDeceased.dateOfDeath, 'DD/MM/YYYY');
        var retired = state.theDeceased.income.retired;

        state.theDeceased.income.periods.forEach(function (period, index) {
            var startOfPeriod = __WEBPACK_IMPORTED_MODULE_4_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
            if (retired) {
                commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: index, key: 'employmentIncome', value: 0 });
                dispatch('fatal/estate/dependencyOnIncome/resetMultiplier', null, { root: true });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["j" /* throttledIncome */])(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, state.theDeceased);
            }

            if (startOfPeriod.isBefore(dateOfDeath)) {
                dispatch('deleteDeceasedIncomePeriod', { index: index });
            }
        });
    },
    updateDeceasedIncome: function updateDeceasedIncome(_ref32, _ref33) {
        var dispatch = _ref32.dispatch,
            state = _ref32.state;
        var income = _ref33.income;

        var prevRetirementDate = state.theDeceased.income.retirementDate;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["f" /* updateObject */])(dispatch, 'updateTheDeceasedIncomeValue', income).then(function (keys) {
            if (~keys.indexOf('retirementDate') || ~keys.indexOf('retired') && !income.retired) {
                return dispatch('updateIncomePeriodForRetirementChange', prevRetirementDate);
            }
            if (~keys.indexOf('retired') && income.retired) {
                return dispatch('removePeriodsSplitForTheRetired', prevRetirementDate).then(function () {
                    return dispatch('updateIncomePeriodsForRetirement');
                });
            }
        });
    },
    serverUpdateDeceasedIncome: function serverUpdateDeceasedIncome(_ref34, _ref35) {
        var commit = _ref34.commit;
        var data = _ref35.data;

        commit(mutationTypes.SERVER_UPDATE_INCOME, data.deceased);
    },

    calculateLossOfEarnings: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref36) {
        var dispatch = _ref36.dispatch,
            state = _ref36.state,
            rootGetters = _ref36.rootGetters;

        var deceased = state.theDeceased;
        var mSettleDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(rootGetters['fatal/estate/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY');
        var dob = __WEBPACK_IMPORTED_MODULE_4_moment___default()(deceased.dateOfBirth, 'DD/MM/YYYY');

        return __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].calculators.monetary.employmentContingencyDiscount({
            age: mSettleDate.diff(dob, 'years', true),
            disabled: deceased.disabledAtAccident,
            employment: deceased.employedAtDateOfDeath ? 'employed' : 'notEmployed',
            education: deceased.levelOfEducation,
            gender: deceased.gender
        }).then(function (data) {
            dispatch('updateTheDeceasedIncomeValue', { key: 'multiplier', value: data.multiplier });
        });
    }, 500)
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, _ref37) {
    var key = _ref37.key,
        value = _ref37.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED, function (state, _ref38) {
    var key = _ref38.key,
        value = _ref38.value;

    state.theDeceased[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_LIFE_EXPECTANCY, function (state, _ref39) {
    var key = _ref39.key,
        value = _ref39.value;

    state.theDeceased.lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_INCOME, function (state, _ref40) {
    var key = _ref40.key,
        value = _ref40.value;

    state.theDeceased.income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_INCOME, function (state, data) {
    state.theDeceased.income = data;
    state.theDeceased.employedAtDateOfDeath = data.employedAtDateOfDeath;
    state.theDeceased.levelOfEducation = data.levelOfEducation;
    state.theDeceased.disabledAtAccident = data.disabledAtAccident;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DECEASED_INCOME_PERIOD, function (state, payload) {
    state.theDeceased.income.periods.push(payload);
    state.theDeceased.income.netPensionIncome += payload.netPensionIncome;
    state.theDeceased.income.grossPensionIncome += payload.grossPensionIncome;
    state.theDeceased.income.netIncome += payload.netIncome;
    state.theDeceased.income.grossIncome += payload.grossIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, function (state, _ref41) {
    var key = _ref41.key,
        value = _ref41.value,
        index = _ref41.index;

    if (~key.indexOf('Income')) {
        state.theDeceased.income[key] -= state.theDeceased.income.periods[index][key] || 0;
    }
    state.theDeceased.income.periods[index][key] = value;
    if (~key.indexOf('Income')) {
        state.theDeceased.income[key] += value || 0;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DECEASED_INCOME_PERIOD, function (state, payload) {
    state.theDeceased.income.periods.splice(payload, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.theDeceased = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_shared_templates__["f" /* personTemplate */])();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DECEASED, function (state, data) {
    state.theDeceased.name = data.name;
    state.theDeceased.gender = data.gender;
    state.theDeceased.onsetOfSymptoms = data.onsetOfSymptoms;
    state.theDeceased.dateOfBirth = data.dateOfBirth;
    state.theDeceased.dateOfDeath = data.dateOfDeath;
    state.theDeceased.ageAtDeath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_services_personFunctions__["p" /* calcAgeDeath */])(state.theDeceased);
    state.theDeceased.lifeExpectancy = data.lifeExpectancy;
    state.theDeceased.income = data.income;
    state.theDeceased.levelOfEducation = data.levelOfEducation;
    state.theDeceased.disabledAtAccident = data.disabledAtAccident;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);



var _mutations;












var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',

    ADD_HEAD_OF_LOSS: 'ADD_HEAD_OF_LOSS',
    UPDATE_HEAD_OF_LOSS_VALUE: 'UPDATE_HEAD_OF_LOSS_VALUE',
    DELETE_HEAD_OF_LOSS: 'DELETE_HEAD_OF_LOSS',

    ADD_CARE_PERIOD: 'ADD_CARE_PERIOD',
    DELETE_CARE_PERIOD: 'DELETE_CARE_PERIOD',
    UPDATE_CARE_PERIOD_VALUE: 'UPDATE_CARE_PERIOD_VALUE',

    ADD_LOSS_OF_EARNINGS_PERIOD: 'ADD_LOSS_OF_EARNINGS_PERIOD',
    DELETE_LOSS_OF_EARNINGS_PERIOD: 'DELETE_LOSS_OF_EARNINGS_PERIOD',
    UPDATE_LOSS_OF_EARNINGS_PERIOD_VALUE: 'UPDATE_LOSS_OF_EARNINGS_PERIOD_VALUE',

    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    UPDATE_TOTAL_INTEREST: 'UPDATE_TOTAL_INTEREST',
    SET: 'SET',
    RESET: 'RESET',
    ADD_DEPENDANTS_HEAD_OF_LOSS: 'ADD_DEPENDANTS_HEAD_OF_LOSS',
    UPDATE_DEPENDANT_HEAD_OF_LOSS_VALUE: 'UPDATE_DEPENDANT_HEAD_OF_LOSS_VALUE',
    UPDATE_DEPENDANT_CUSTOM_HEAD_OF_LOSS_VALUE: 'UPDATE_DEPENDANT_CUSTOM_HEAD_OF_LOSS_VALUE',
    ADD_DEPENDANTS_CUSTOM_HEAD_OF_LOSS: 'ADD_DEPENDANTS_CUSTOM_HEAD_OF_LOSS',
    UPDATE_SUB_TOTAL: 'UPDATE_SUB_TOTAL',
    CLEAR_INTEREST: 'CLEAR_INTEREST'
};

var state = {
    careCalcType: 'own',
    customInterestDate: '',
    dependantsHeadsOfLoss: [],

    funeralExpenses: 0,
    funeralExpensesInterest: 0.5,
    funeralExpensesWithInterest: 0,

    futureDependencyOnIncome: 0,

    futureDependencyOnServices: 0,

    generalDamages: 0,
    generalDamagesInterest: 2.0,
    generalDamagesWithInterest: 0,

    gratuitousCare: false,

    headsOfLoss: [],

    interestType: 'today',

    lossOfSpouse: 0,
    lossOfSpouseInterest: 0.5,
    lossOfSpouseWithInterest: 0,

    misc: 0,
    miscInterest: 0.5,
    miscWithInterest: 0,

    ownCareFigure: 0,
    ownPastLossOfEarningsFigure: 0,

    pastCostOfCare: 0,
    pastCostOfCareInterest: 0.5,
    pastCostOfCareWithInterest: 0,
    pastCostOfTravel: 0,
    pastCostOfTravelInterest: 0.5,
    pastCostOfTravelWithInterest: 0,

    pastDependencyOnIncome: 0,
    pastDependencyOnIncomeInterest: 0.5,
    pastDependencyOnIncomeWithInterest: 0,

    pastDependencyOnServices: 0,
    pastDependencyOnServicesInterest: 0.5,
    pastDependencyOnServicesWithInterest: 0,

    pastLossOfEarnings: 0,
    pastLossOfEarningsInterest: 0.5,
    pastLossOfEarningsPeriods: [],
    pastLossOfEarningsType: 'own',
    pastLossOfEarningsWithInterest: 0,

    periods: [],

    subTotal: 0,

    totalInterest: 0
};

var rules = {};

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

var checkAllPeriodsValid = function checkAllPeriodsValid(state) {
    return state.periods.reduce(function (valid, period) {
        if (!valid) {
            return valid;
        }
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(period.periodStart, 'DD/MM/YYYY').isValid() && __WEBPACK_IMPORTED_MODULE_3_moment___default()(period.periodEnd, 'DD/MM/YYYY').isValid() && period.hoursPerDay > 0;
    }, true);
};

var checkPastLossOfEarningsPeriodsValid = function checkPastLossOfEarningsPeriodsValid(state) {
    return state.pastLossOfEarningsPeriods.reduce(function (valid, period) {
        if (!valid) {
            return valid;
        }
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(period.periodStart, 'DD/MM/YYYY').isValid() && __WEBPACK_IMPORTED_MODULE_3_moment___default()(period.periodEnd, 'DD/MM/YYYY').isValid() && period.periodValue > 0;
    }, true);
};

var getInterestDate = function getInterestDate(state) {
    switch (true) {
        case state.interestType === 'today':
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('DD/MM/YYYY');
            break;
        case state.interestType === 'assumed_settlement':
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(__WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY');
            break;
        case state.interestType === 'custom':
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(state.customInterestDate, 'DD/MM/YYYY').format('DD/MM/YYYY');
            break;
    }
};

var getAllHeadsOfLossValid = function getAllHeadsOfLossValid(state) {
    var allValid = true;

    if (typeof state.headsOfLoss !== 'undefined') {
        allValid = state.headsOfLoss.reduce(function (valid, headOfLoss) {
            return !valid ? valid : headOfLoss.name !== '' && headOfLoss.value > 0;
        }, allValid);
    }

    return allValid;
};

var calcHeadsOfLossTotal = function calcHeadsOfLossTotal() {
    var customHeadsOfLossTotal = state.headsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.value);
    }, 0);
    var customHeadsOfLossTotalWithInterest = state.headsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.withInterest);
    }, 0);

    var total = [state.generalDamages, state.generalDamagesWithInterest, state.funeralExpenses, state.funeralExpensesWithInterest, state.lossOfSpouse, state.lossOfSpouseWithInterest, state.pastCostOfTravel, state.pastCostOfTravelWithInterest, state.pastCostOfCare, state.pastCostOfCareWithInterest, state.pastLossOfEarnings, state.pastLossOfEarningsWithInterest, state.misc, state.miscWithInterest, state.pastDependencyOnIncome, state.pastDependencyOnIncomeWithInterest, state.pastDependencyOnServices, state.pastDependencyOnServicesWithInterest, customHeadsOfLossTotal, customHeadsOfLossTotalWithInterest].reduce(function (total, value) {
        return total + parseFloat(value, 10);
    }, 0);

    return numberVal(total).toFixed(2);
};

var calcHeadsOfLossTotalMinusInterest = function calcHeadsOfLossTotalMinusInterest() {
    var customHeadsOfLossTotal = state.headsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.value);
    }, 0);

    var total = [state.generalDamages, state.funeralExpenses, state.lossOfSpouse, state.pastCostOfTravel, state.pastCostOfCare, state.pastLossOfEarnings, state.misc, state.pastDependencyOnIncome, state.pastDependencyOnServices, customHeadsOfLossTotal].reduce(function (total, value) {
        return total + parseFloat(value, 10);
    }, 0);

    return numberVal(total).toFixed(2);
};

var modalPayload = function modalPayload() {
    return {
        interimPayments: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/interimPayments/interimPayments'],
        assumedSettlement: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/claimDetails/value']('assumedSettlement'),
        serviceOfProceedings: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/claimDetails/value']('serviceOfProceedings'),
        onsetOfSymptoms: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/deceased/theDeceased']['onsetOfSymptoms'],
        assumedLifeExpectancy: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/deceased/theDeceased']['assumedLifeExpectancy'],
        deductibles: __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/cru/all'],
        headsOfLoss: state,
        headOfLoss: {}
    };
};

var getters = {
    getAll: function getAll(state) {
        return state;
    },
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    getModalPayload: function getModalPayload(state) {
        return modalPayload();
    },
    findHeadOfLoss: function findHeadOfLoss(state) {
        return function (index) {
            return state.headsOfLoss[index];
        };
    },
    headsOfLoss: function headsOfLoss(state) {
        return state.headsOfLoss;
    },
    findDependantsHeadsOfLoss: function findDependantsHeadsOfLoss(state) {
        return function (index) {
            return state.dependantsHeadsOfLoss[index];
        };
    },
    allHeadsOfLossValid: function allHeadsOfLossValid(state) {
        return getAllHeadsOfLossValid(state);
    },
    findPeriod: function findPeriod(state) {
        return function (index) {
            return state.periods[index];
        };
    },
    findLossOfEarningsPeriod: function findLossOfEarningsPeriod(state) {
        return function (index) {
            return state.pastLossOfEarningsPeriods[index];
        };
    },
    periods: function periods(state) {
        return state.periods;
    },
    allPeriodsValid: function allPeriodsValid(state) {
        return checkAllPeriodsValid(state);
    },
    pastLossOfEarningsPeriods: function pastLossOfEarningsPeriods(state) {
        return state.pastLossOfEarningsPeriods;
    },
    pastLossOfEarningsPeriodsValid: function pastLossOfEarningsPeriodsValid(state) {
        return checkPastLossOfEarningsPeriodsValid(state);
    },
    totalInterest: function totalInterest(state) {
        return state.totalInterest;
    },
    interestDate: function interestDate(state) {
        return getInterestDate(state);
    },
    getHeadsOfLossTotal: function getHeadsOfLossTotal(state) {
        return calcHeadsOfLossTotal();
    },
    getHeadsOfLossTotalMinusInterest: function getHeadsOfLossTotalMinusInterest(state) {
        return calcHeadsOfLossTotalMinusInterest();
    }
};

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.UPDATE_FROM_SERVER, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(state, data));

        commit(mutationTypes.SET, { key: 'periods', value: data.periods });
        commit(mutationTypes.SET, { key: 'pastLossOfEarningsPeriods', value: data.pastLossOfEarningsPeriods });
    },
    process: function process(_ref3) {
        var rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 2,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_generators_step__["a" /* previousValid */])(rootState, 2) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    validate: function validate(_ref4) {
        var rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 2,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_generators_step__["a" /* previousValid */])(rootState, 2) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 2,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    updateValue: function updateValue(_ref6, _ref7) {
        var commit = _ref6.commit,
            state = _ref6.state,
            dispatch = _ref6.dispatch;
        var key = _ref7.key,
            value = _ref7.value;

        if (state[key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
        dispatch('updateSubTotal');
        return value;
    },
    updateValues: function updateValues(_ref8, data) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
            if (key.includes("custom_")) {
                commit(mutationTypes.UPDATE_HEAD_OF_LOSS_VALUE, {
                    key: data[key]['key'],
                    value: data[key]['value'],
                    index: data[key]['index']
                });
            }
            commit(mutationTypes.UPDATE_VALUE, { key: key + 'WithInterest', value: data[key] });
            dispatch('updateTotalInterest');
            dispatch('updateSubTotal');
        });
    },
    updateSubTotal: function updateSubTotal(_ref9) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootGetters = _ref9.rootGetters;

        var subTotal = numberVal(state.generalDamages) + numberVal(state.funeralExpenses) + numberVal(state.lossOfSpouse) + numberVal(state.pastLossOfEarnings) + numberVal(state.pastCostOfTravel) + numberVal(state.pastCostOfCare) + numberVal(state.misc) + state.headsOfLoss.reduce(function (total, customHead) {
            return total + numberVal(customHead.value);
        }, 0);
        commit(mutationTypes.UPDATE_SUB_TOTAL, numberVal(subTotal));
    },
    updateTotalInterest: function updateTotalInterest(_ref10) {
        var state = _ref10.state,
            commit = _ref10.commit;

        var total = numberVal(state.generalDamagesWithInterest) + numberVal(state.pastLossOfEarningsWithInterest) + numberVal(state.pastCostOfCareWithInterest) + numberVal(state.pastCostOfTravelWithInterest);
        commit(mutationTypes.UPDATE_TOTAL_INTEREST, total);
    },
    addHeadOfLoss: function addHeadOfLoss(_ref11) {
        var commit = _ref11.commit;

        commit(mutationTypes.ADD_HEAD_OF_LOSS);
    },
    addDependantHeadOfLoss: function addDependantHeadOfLoss(_ref12) {
        var commit = _ref12.commit;

        commit(mutationTypes.ADD_DEPENDANTS_HEAD_OF_LOSS);
    },
    deleteHeadOfLoss: function deleteHeadOfLoss(_ref13, index) {
        var commit = _ref13.commit;

        commit(mutationTypes.DELETE_HEAD_OF_LOSS, index);
    },
    addCarePeriod: function addCarePeriod(_ref14) {
        var commit = _ref14.commit;

        commit(mutationTypes.ADD_CARE_PERIOD);
    },
    addLossOfEarningsPeriod: function addLossOfEarningsPeriod(_ref15) {
        var commit = _ref15.commit;

        commit(mutationTypes.ADD_LOSS_OF_EARNINGS_PERIOD);
    },
    deleteCarePeriod: function deleteCarePeriod(_ref16, index) {
        var commit = _ref16.commit,
            dispatch = _ref16.dispatch;

        commit(mutationTypes.DELETE_CARE_PERIOD, index);
        return dispatch('updateCareTotal');
    },
    deleteLossOfEarningsPeriod: function deleteLossOfEarningsPeriod(_ref17, index) {
        var commit = _ref17.commit,
            dispatch = _ref17.dispatch;

        commit(mutationTypes.DELETE_LOSS_OF_EARNINGS_PERIOD, index);
        return dispatch('updatePastLossOfEarningsTotal');
    },
    updatePeriod: function updatePeriod(_ref18, _ref19) {
        var dispatch = _ref18.dispatch,
            commit = _ref18.commit;
        var care = _ref19.care,
            index = _ref19.index;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(care[0]).filter(function (key) {
            return key !== 'periodStart' && key !== 'periodEnd';
        }).forEach(function (key) {
            var value = care[0][key];
            commit(mutationTypes.UPDATE_CARE_PERIOD_VALUE, { key: key, value: value, index: index });
        });
        dispatch('updateCareTotal');
    },
    updatePeriodValue: function updatePeriodValue(_ref20, _ref21) {
        var commit = _ref20.commit,
            state = _ref20.state;
        var key = _ref21.key,
            value = _ref21.value,
            index = _ref21.index;

        if (key === 'hoursPerDay' && value > 24) {
            value = 24;
        }

        if (state.periods[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_CARE_PERIOD_VALUE, { key: key, value: value, index: index });
        return value;
    },
    updatePastLossOfEarningsPeriodValue: function updatePastLossOfEarningsPeriodValue(_ref22, _ref23) {
        var commit = _ref22.commit,
            state = _ref22.state;
        var key = _ref23.key,
            value = _ref23.value,
            index = _ref23.index;

        if (state.pastLossOfEarningsPeriods[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_LOSS_OF_EARNINGS_PERIOD_VALUE, { key: key, value: value, index: index });
        return value;
    },
    updateHeadOfLossValue: function updateHeadOfLossValue(_ref24, _ref25) {
        var commit = _ref24.commit,
            state = _ref24.state;
        var key = _ref25.key,
            value = _ref25.value,
            index = _ref25.index;

        if (state.headsOfLoss[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
        return value;
    },
    updateDependantHeadOfLossValue: function updateDependantHeadOfLossValue(_ref26, _ref27) {
        var commit = _ref26.commit,
            state = _ref26.state;
        var key = _ref27.key,
            value = _ref27.value,
            index = _ref27.index;

        if (state.dependantsHeadsOfLoss[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
        return value;
    },
    updateDependantCustomHeadOfLossValue: function updateDependantCustomHeadOfLossValue(_ref28, _ref29) {
        var commit = _ref28.commit,
            state = _ref28.state;
        var key = _ref29.key,
            value = _ref29.value,
            index = _ref29.index,
            comparisonIndex = _ref29.comparisonIndex;

        if (state.dependantsCustomHeadsOfLoss == 'undefined') {
            commit(mutationTypes.ADD_DEPENDANTS_CUSTOM_HEAD_OF_LOSS, { comparisonIndex: comparisonIndex });
        }
        commit(mutationTypes.UPDATE_DEPENDANT_CUSTOM_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
        return value;
    },
    calcAllInterest: function calcAllInterest(_ref30) {
        var dispatch = _ref30.dispatch,
            state = _ref30.state;

        if (state.interestType === 'custom' && state.customInterestDate === '') {
            return;
        }

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_routingMethods__["e" /* isStepValid */])(2)) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].calculators.monetary.interest(__WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/claimDetails/value']('proceduralStatus'), __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/claimDetails/value']('assumedSettlement'), __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/claimDetails/value']('serviceOfProceedings'), __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/deceased/theDeceased']['onsetOfSymptoms'], __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/deceased/theDeceased']['assumedLifeExpectancy'], __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/cru/all'], state, __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['fatal/estate/interimPayments/interimPayments']).then(function (data) {
            return dispatch('updateValues', data);
        });
    },

    calcCareSubTotalForPeriod: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref31, index) {
        var dispatch = _ref31.dispatch,
            state = _ref31.state;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.periods[index].periodStart) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.periods[index].periodEnd) && state.periods[index].hoursPerDay > 0) {
            return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].calculators.monetary.detailedCare([state.periods[index]], state.gratuitousCare).then(function (care) {
                return dispatch('updatePeriod', { care: care, index: index });
            }).then(function () {
                return dispatch('updateCareTotal');
            });
        }
    }, 500),

    calcLossOfEarningsForPeriod: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref32, index) {
        var dispatch = _ref32.dispatch,
            state = _ref32.state,
            rootState = _ref32.rootState;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.pastLossOfEarningsPeriods[index].periodStart) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.pastLossOfEarningsPeriods[index].periodEnd) && state.pastLossOfEarningsPeriods[index].periodValue) {
            var period = state.pastLossOfEarningsPeriods[index];
            var person = rootState.fatal.estate.deceased.theDeceased;

            return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].calculators.monetary.pastLossOfEarnings({ period: period, person: person }).then(function (result) {
                dispatch('updatePastLossOfEarningsPeriodValue', { key: 'periodTotal', value: result.period_total, index: index });
            }).then(function () {
                return dispatch('updatePastLossOfEarningsTotal');
            });
        }
    }, 500),

    updateCareTotal: function updateCareTotal(_ref33) {
        var commit = _ref33.commit,
            state = _ref33.state;

        var value = state.periods.reduce(function (total, period) {
            return total + numberVal(period.total);
        }, 0);
        commit(mutationTypes.UPDATE_VALUE, { key: 'pastCostOfCare', value: value.toFixed(2) });
    },
    updatePastLossOfEarningsTotal: function updatePastLossOfEarningsTotal(_ref34) {
        var commit = _ref34.commit,
            state = _ref34.state;

        var value = state.pastLossOfEarningsPeriods.reduce(function (total, period) {
            return total + numberVal(period.periodTotal);
        }, 0);
        commit(mutationTypes.UPDATE_VALUE, { key: 'pastLossOfEarnings', value: value.toFixed(2) });
    },
    ownCalculateCare: function ownCalculateCare(_ref35, value) {
        var commit = _ref35.commit,
            state = _ref35.state;

        var discountedCare = 0;
        if (value) {
            discountedCare = (state.ownCareFigure * 0.75).toFixed(2);
            commit(mutationTypes.UPDATE_VALUE, { key: 'pastCostOfCare', value: discountedCare });
        } else {
            commit(mutationTypes.UPDATE_VALUE, { key: 'pastCostOfCare', value: state.ownCareFigure });
        }
    },
    autoCalculateCare: function autoCalculateCare(_ref36, value) {
        var commit = _ref36.commit,
            dispatch = _ref36.dispatch;

        commit(mutationTypes.UPDATE_VALUE, { key: 'periods', value: [] });
        commit(mutationTypes.UPDATE_VALUE, { key: 'ownCareFigure', value: 0 });
        return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].calculators.monetary.autoCalculateCare(value).then(function (care) {
            return dispatch('updateValue', { key: 'pastCostOfCare', value: care.value });
        });
    },
    saveComparisonSchedule: function saveComparisonSchedule(_ref37) {
        var rootGetters = _ref37.rootGetters,
            dispatch = _ref37.dispatch;

        var data = rootGetters['fatal/estate/dataForStep5'];
        return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.save(data).then(function (data) {
            dispatch('recordServerResponse', data);

            return data;
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, _ref38) {
    var key = _ref38.key,
        value = _ref38.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_HEAD_OF_LOSS, function (state) {
    state.headsOfLoss.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["g" /* headOfLossTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANTS_HEAD_OF_LOSS, function (state) {
    state.dependantsHeadsOfLoss.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["h" /* dependantsHeadsOfLossTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANTS_CUSTOM_HEAD_OF_LOSS, function (state, _ref39) {
    var comparisonIndex = _ref39.comparisonIndex;

    state.dependantsHeadsOfLoss[comparisonIndex].dependantsCustomHeadsOfLoss.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["i" /* dependantsCustomHeadsOfLossTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_HEAD_OF_LOSS, function (state, index) {
    if (index === 0 && state.headsOfLoss.length === 1) {
        state.headsOfLoss = [];
    }
    state.headsOfLoss.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_CARE_PERIOD, function (state) {
    state.periods.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["e" /* carePeriodTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_CARE_PERIOD, function (state, index) {
    state.periods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CARE_PERIOD_VALUE, function (state, _ref40) {
    var key = _ref40.key,
        value = _ref40.value,
        index = _ref40.index;

    state.periods[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_LOSS_OF_EARNINGS_PERIOD, function (state) {
    state.pastLossOfEarningsPeriods.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_modules_shared_templates__["j" /* lossOfEarningsPeriodTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_LOSS_OF_EARNINGS_PERIOD, function (state, index) {
    state.pastLossOfEarningsPeriods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LOSS_OF_EARNINGS_PERIOD_VALUE, function (state, _ref41) {
    var key = _ref41.key,
        value = _ref41.value,
        index = _ref41.index;

    state.pastLossOfEarningsPeriods[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, _ref42) {
    var key = _ref42.key,
        value = _ref42.value;

    __WEBPACK_IMPORTED_MODULE_11_vue___default.a.set(state, key, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, data) {
    state.careCalcType = data.careCalcType;
    state.customInterestDate = data.customInterestDate;
    state.dependantsHeadsOfLoss = data.dependantsHeadsOfLoss;
    state.funeralExpenses = data.funeralExpenses;
    state.funeralExpensesInterest = data.funeralExpensesInterest;
    state.funeralExpensesWithInterest = data.funeralExpensesWithInterest;
    state.generalDamages = data.generalDamages;
    state.generalDamagesInterest = data.generalDamagesInterest;
    state.generalDamagesWithInterest = data.generalDamagesWithInterest;
    state.gratuitousCare = data.gratuitousCare;
    state.headsOfLoss = data.headsOfLoss;
    state.interestType = data.interestType;
    state.lossOfSpouse = data.lossOfSpouse;
    state.lossOfSpouseInterest = data.lossOfSpouseInterest;
    state.lossOfSpouseWithInterest = data.lossOfSpouseWithInterest;
    state.misc = data.misc;
    state.miscInterest = data.miscInterest;
    state.miscWithInterest = data.miscWithInterest;
    state.ownCareFigure = data.ownCareFigure;
    state.pastCostOfCare = data.pastCostOfCare;
    state.pastCostOfCareInterest = data.pastCostOfCareInterest;
    state.pastCostOfCareWithInterest = data.pastCostOfCareWithInterest;
    state.pastCostOfTravel = data.pastCostOfTravel;
    state.pastCostOfTravelInterest = data.pastCostOfTravelInterest;
    state.pastCostOfTravelWithInterest = data.pastCostOfTravelWithInterest;
    state.pastDependencyOnIncome = data.pastDependencyOnIncome;
    state.pastDependencyOnIncomeInterest = data.pastDependencyOnIncomeInterest;
    state.pastDependencyOnIncomeWithInterest = data.pastDependencyOnIncomeWithInterest;
    state.pastDependencyOnServices = data.pastDependencyOnServices;
    state.pastDependencyOnServicesInterest = data.pastDependencyOnServicesInterest;
    state.pastDependencyOnServicesWithInterest = data.pastDependencyOnServicesWithInterest;
    state.pastLossOfEarnings = data.pastLossOfEarnings;
    state.pastLossOfEarningsPeriods = data.pastLossOfEarningsPeriods;
    state.pastLossOfEarningsInterest = data.pastLossOfEarningsInterest;
    state.pastLossOfEarningsType = data.pastLossOfEarningsType;
    state.pastLossOfEarningsWithInterest = data.pastLossOfEarningsWithInterest;
    state.periods = data.periods;
    state.subTotal = data.subTotal;
    state.totalInterest = data.totalInterest;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TOTAL_INTEREST, function (state, value) {
    state.totalInterest = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_HEAD_OF_LOSS_VALUE, function (state, _ref43) {
    var key = _ref43.key,
        value = _ref43.value,
        index = _ref43.index;

    state.headsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_HEAD_OF_LOSS_VALUE, function (state, _ref44) {
    var key = _ref44.key,
        value = _ref44.value,
        index = _ref44.index;

    state.dependantsHeadsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_CUSTOM_HEAD_OF_LOSS_VALUE, function (state, _ref45) {
    var key = _ref45.key,
        value = _ref45.value,
        index = _ref45.index;

    state.dependantsCustomHeadsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_SUB_TOTAL, function (state, subTotal) {
    state.subTotal = subTotal;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.careCalcType = 'own';
    state.customInterestDate = '';
    state.dependantsHeadsOfLoss = [];
    state.funeralExpenses = 0;
    state.funeralExpensesInterest = 0.5;
    state.funeralExpensesWithInterest = 0;
    state.futureDependencyOnIncome = 0;
    state.futureDependencyOnServices = 0;
    state.generalDamages = 0;
    state.generalDamagesInterest = 2.0;
    state.generalDamagesWithInterest = 0;
    state.gratuitousCare = false;
    state.headsOfLoss = [];
    state.interestType = 'today';
    state.lossOfSpouse = 0;
    state.lossOfSpouseInterest = 0.5;
    state.lossOfSpouseWithInterest = 0;
    state.misc = 0;
    state.miscInterest = 0.5;
    state.miscWithInterest = 0;
    state.ownCareFigure = 0;
    state.ownPastLossOfEarningsFigure = 0;
    state.pastCostOfCare = 0;
    state.pastCostOfCareInterest = 0.5;
    state.pastCostOfCareWithInterest = 0;
    state.pastCostOfTravel = 0;
    state.pastCostOfTravelInterest = 0.5;
    state.pastCostOfTravelWithInterest = 0;
    state.pastDependencyOnIncome = 0;
    state.pastDependencyOnIncomeInterest = 0.5;
    state.pastDependencyOnIncomeWithInterest = 0;
    state.pastDependencyOnServices = 0;
    state.pastDependencyOnServicesInterest = 0.5;
    state.pastDependencyOnServicesWithInterest = 0;
    state.pastLossOfEarnings = 0;
    state.pastLossOfEarningsInterest = 0.5;
    state.pastLossOfEarningsPeriods = [];
    state.pastLossOfEarningsType = 'own';
    state.pastLossOfEarningsWithInterest = 0;
    state.periods = [];
    state.subTotal = 0;
    state.totalInterest = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CLEAR_INTEREST, function (state) {
    state.bereavementAwardWithInterest = 0;
    state.funeralExpensesWithInterest = 0;
    state.generalDamagesWithInterest = 0;
    state.lossOfSpouseWithInterest = 0;
    state.miscWithInterest = 0;
    state.pastCostOfCareWithInterest = 0;
    state.pastCostOfTravelWithInterest = 0;
    state.pastDependencyOnIncomeWithInterest = 0;
    state.pastDependencyOnServicesWithInterest = 0;
    state.pastLossOfEarningsWithInterest = 0;
    state.totalInterest = 0;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_modules_fatal_estate_claimDetails__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_modules_fatal_estate_calculateLoss__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_fatal_estate_people__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_fatal_estate_proceduralDates__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_modules_fatal_estate_headsOfLoss__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_fatal_estate_step__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_modules_fatal_estate_cru__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_modules_fatal_estate_interimPayments__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_store_modules_psla__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_store_modules_fatal_estate_deceased__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_routingMethods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_store_modules_lost_documents__ = __webpack_require__(158);




















var mutationTypes = {
    LOADING_CLAIM: 'LOADING_CLAIM',
    UPDATING_TABLE: 'UPDATING_TABLE',
    CHANGE_CLAIM_ID: 'CHANGE_CLAIM_ID',
    FINISHED_LOADING_CLAIM: 'FINISHED_LOADING_CLAIM'
};

var state = {
    claimId: null
};

var getters = {};

var actions = {
    save: function save(_ref, payload) {
        var rootGetters = _ref.rootGetters;

        var individualStep = rootGetters['fatal/estate/step/allSteps'][payload.step_number];

        return __WEBPACK_IMPORTED_MODULE_15_store_index__["a" /* default */].dispatch('fatal/estate/' + individualStep.store + '/save', payload);
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            rootGetters = _ref2.rootGetters;

        var individualStep = rootGetters['fatal/estate/step/allSteps'][parseInt(step.step_number, 10)];

        dispatch('checkForStepStore', individualStep).then(function () {
            return __WEBPACK_IMPORTED_MODULE_15_store_index__["a" /* default */].dispatch('fatal/estate/' + individualStep.store + '/load', step);
        });
    },
    process: function process(_ref3, step) {
        var dispatch = _ref3.dispatch;

        dispatch('checkForStepStore', step).then(function () {
            return __WEBPACK_IMPORTED_MODULE_15_store_index__["a" /* default */].dispatch('fatal/estate/' + step.store + '/process', step);
        }).then(function () {
            dispatch('headsOfLoss/calcAllInterest');
        });
    },
    validate: function validate(_ref4, step) {
        var dispatch = _ref4.dispatch;

        dispatch('checkForStepStore', step).then(function () {
            __WEBPACK_IMPORTED_MODULE_15_store_index__["a" /* default */].dispatch('fatal/estate/' + step.store + '/validate', step);
        });
    },
    reset: function reset(_ref5, step) {
        var dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        dispatch('checkForStepStore', step).then(function () {
            if (rootState.fatal.estate[step.store]) {
                __WEBPACK_IMPORTED_MODULE_15_store_index__["a" /* default */].dispatch('fatal/estate/' + step.store + '/reset', step);
            }
        });
    },
    checkForStepStore: function checkForStepStore(none, individualStep) {
        if (!individualStep.store) {
            throw { 'error': 'Step #' + individualStep.step + ' (' + individualStep.name + ') does not have a store defined in the routes meta' };
        }
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.CHANGE_CLAIM_ID, function (state, payload) {
    state.claimId = payload;
});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {
        calculateLoss: __WEBPACK_IMPORTED_MODULE_6_store_modules_fatal_estate_calculateLoss__["a" /* default */],
        claimDetails: __WEBPACK_IMPORTED_MODULE_5_store_modules_fatal_estate_claimDetails__["a" /* default */],
        people: __WEBPACK_IMPORTED_MODULE_7_store_modules_fatal_estate_people__["a" /* default */],
        proceduralDates: __WEBPACK_IMPORTED_MODULE_8_store_modules_fatal_estate_proceduralDates__["a" /* default */],
        headsOfLoss: __WEBPACK_IMPORTED_MODULE_9_store_modules_fatal_estate_headsOfLoss__["a" /* default */],
        cru: __WEBPACK_IMPORTED_MODULE_11_store_modules_fatal_estate_cru__["a" /* default */],
        interimPayments: __WEBPACK_IMPORTED_MODULE_12_store_modules_fatal_estate_interimPayments__["a" /* default */],
        psla: __WEBPACK_IMPORTED_MODULE_13_store_modules_psla__["a" /* default */],
        step: __WEBPACK_IMPORTED_MODULE_10_store_modules_fatal_estate_step__["a" /* default */],
        deceased: __WEBPACK_IMPORTED_MODULE_16_store_modules_fatal_estate_deceased__["a" /* default */],
        documents: __WEBPACK_IMPORTED_MODULE_18_store_modules_lost_documents__["a" /* default */]
    }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_validator_validations_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_generators_step__ = __webpack_require__(21);



var _mutations;









var mutationTypes = {
    ADD_INTERIM_PAYMENT: 'ADD_INTERIM_PAYMENT',
    UPDATE_INTERIM_PAYMENT: 'UPDATE_INTERIM_PAYMENT',
    DELETE_INTERIM_PAYMENT: 'DELETE_INTERIM_PAYMENT',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    RESET: 'RESET'
};

var state = {
    payments: []
};

var rules = {};

var paymentsTemplate = function paymentsTemplate() {
    return {
        date: '',
        value: 0
    };
};

var getters = {
    interimPayments: function interimPayments(state) {
        return state.payments;
    },
    findPayment: function findPayment(state) {
        return function (index) {
            return state.payments[index];
        };
    },
    allInterimPaymentsValid: function allInterimPaymentsValid(state, g, rs, rg) {
        var maxDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(rg['fatal/estate/headsOfLoss/interestDate'], 'DD/MM/YYYY');
        return state.payments.reduce(function (valid, payment) {
            var mPaymentDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(payment.date, 'DD/MM/YYYY');
            return !valid ? valid : mPaymentDate.isValid() && payment.value > 0 && mPaymentDate.isBefore(maxDate);
        }, true);
    }
};

var actions = {
    save: function save(_ref, payload) {
        var dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_modules_claim__["d" /* requestPayload */])(2));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;

        dispatch('updateFromServer', { data: data });
    },
    validate: function validate(_ref3) {
        var rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 4,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_generators_step__["a" /* previousValid */])(rootState, 4) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    process: function process(_ref4) {
        var rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 4,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_generators_step__["a" /* previousValid */])(rootState, 4) && new __WEBPACK_IMPORTED_MODULE_6_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('fatal/estate/step/setStepNumberValid', {
            stepNo: 4,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    addPayment: function addPayment(_ref6) {
        var commit = _ref6.commit;

        commit(mutationTypes.ADD_INTERIM_PAYMENT);
    },
    deletePayment: function deletePayment(_ref7, index) {
        var commit = _ref7.commit;

        commit(mutationTypes.DELETE_INTERIM_PAYMENT, index);
    },
    updatePayment: function updatePayment(_ref8, _ref9) {
        var commit = _ref8.commit,
            state = _ref8.state;
        var key = _ref9.key,
            value = _ref9.value,
            index = _ref9.index;

        if (state.payments[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_INTERIM_PAYMENT, { key: key, value: value, index: index });
        return value;
    },
    updateFromServer: function updateFromServer(_ref10, _ref11) {
        var commit = _ref10.commit;
        var data = _ref11.data;

        commit(mutationTypes.UPDATE_FROM_SERVER, data);

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.payments).reduce(function (valid, key) {
            return !valid ? valid : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_components_form_validator_validations_js__["d" /* stringRequired */])(state.payments[key].date);
        }, true);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_INTERIM_PAYMENT, function (state) {
    state.payments.push(paymentsTemplate());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_INTERIM_PAYMENT, function (state, index) {
    if (index === 0 && state.payments.length === 1) {
        state.payments = [];
    }
    state.payments.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INTERIM_PAYMENT, function (state, _ref12) {
    var key = _ref12.key,
        value = _ref12.value,
        index = _ref12.index;

    state.payments[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, values) {
    if (typeof values.payments != 'undefined') {
        state.payments = values.payments;
    } else {
        state.payments = [];
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.payments = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* unused harmony export throttleUpdateLife */
/* unused harmony export mutatePersonFromServer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);






var _mutations;









var mutationTypes = {
    UPDATE_DECEASED: 'UPDATE_DECEASED',
    RESET_DECEASED: 'RESET_DECEASED',
    SERVER_UPDATE_DECEASED: 'SERVER_UPDATE_DECEASED',
    SERVER_UPDATE_DECEASED_INCOME: 'SERVER_UPDATE_DECEASED_INCOME',
    UPDATE_DECEASED_LIFE_EXPECTANCY: 'UPDATE_DECEASED_LIFE_EXPECTANCY',
    UPDATE_DECEASED_INCOME: 'UPDATE_DECEASED_INCOME',
    ADD_DEPENDANT: 'ADD_DEPENDANT',
    UPDATE_DEPENDANT: 'UPDATE_DEPENDANT',
    RESET_DEPENDANTS: 'RESET_DEPENDANTS',
    SERVER_UPDATE_DEPENDANT: 'SERVER_UPDATE_DEPENDANT',
    SERVER_UPDATE_DEPENDANT_INCOME: 'SERVER_UPDATE_DEPENDANT_INCOME',
    DELETE_DEPENDANT: 'DELETE_DEPENDANT',
    UPDATE_DEPENDANT_LIFE_EXPECTANCY: 'UPDATE_DEPENDANT_LIFE_EXPECTANCY',
    UPDATE_DEPENDANT_INCOME: 'UPDATE_DEPENDANT_INCOME',
    ADD_DECEASED_INCOME_PERIOD: 'ADD_DECEASED_INCOME_PERIOD',
    UPDATE_DECEASED_INCOME_PERIOD: 'UPDATE_DECEASED_INCOME_PERIOD',
    DELETE_DECEASED_INCOME_PERIOD: 'DELETE_DECEASED_INCOME_PERIOD',
    ADD_DEPENDANT_INCOME_PERIOD: 'ADD_DEPENDANT_INCOME_PERIOD',
    UPDATE_DEPENDANT_INCOME_PERIOD: 'UPDATE_DEPENDANT_INCOME_PERIOD',
    DELETE_DEPENDANT_INCOME_PERIOD: 'DELETE_DEPENDANT_INCOME_PERIOD',
    UPDATE_DEPENDENCY_ON_INCOME_VALID: 'UPDATE_DEPENDENCY_ON_INCOME_VALID'
};

var DEFAULT_RETIREMENT = {
    male: 65,
    female: 62.5
};

function personTemplate() {
    return {
        name: '',
        dateOfBirth: null,
        dateOfDeath: null,
        onsetOfSymptoms: null,
        ageAtDeath: null,
        currentAge: null,
        gender: null,
        predictedDeath: null,
        levelOfEducation: null,
        income: incomeTemplate(),
        lifeExpectancy: lifeExpectancyTemplate()
    };
}

function incomeTemplate() {
    return {
        retired: true,
        retirementAge: 65,
        retirementDate: '',
        periods: []
    };
}

var defaultIncomePeriodTemplate = function defaultIncomePeriodTemplate(_ref) {
    var start = _ref.start,
        end = _ref.end;

    return {
        startOfPeriod: start,
        endOfPeriod: end,
        employmentType: 'employed',
        employmentIncome: 0,
        employmentNetGross: 'net',
        pensionIncome: 0,
        pensionNetGross: 'net',
        totalGrossIncome: 0,
        totalNetIncome: 0
    };
};

var incomePeriodTemplate = function incomePeriodTemplate(_ref2) {
    var start = _ref2.start,
        end = _ref2.end,
        employmentType = _ref2.employmentType,
        employmentIncome = _ref2.employmentIncome,
        employmentNetGross = _ref2.employmentNetGross,
        pensionIncome = _ref2.pensionIncome,
        pensionNetGross = _ref2.pensionNetGross,
        totalGrossIncome = _ref2.totalGrossIncome,
        totalNetIncome = _ref2.totalNetIncome;

    return {
        startOfPeriod: start,
        endOfPeriod: end,
        employmentType: employmentType,
        employmentIncome: employmentIncome,
        employmentNetGross: employmentNetGross,
        pensionIncome: pensionIncome,
        pensionNetGross: pensionNetGross,
        totalGrossIncome: totalGrossIncome,
        totalNetIncome: totalNetIncome
    };
};

function lifeExpectancyTemplate() {
    return {
        method: 'ogden_table',
        yearsAndMonths: {
            months: 0,
            years: 0
        },
        dateOfDeathIsAssumed: null,
        ageAtDeath: null,
        dateOfDeath: null,
        percentageOfNormalLifeExpectancy: 100,
        percentageReductionInNormalLifeExpectancy: 0,
        child: {
            youthCutOffAge: null,
            youthYearsLeft: null,
            youthCutOffDate: null
        }
    };
}

var state = {
    theDeceased: personTemplate(),
    dependants: [],
    dependencyOnIncomeValid: false
};

var findNextPeriodStart = function findNextPeriodStart(periods, worseCase) {
    return periods.reduce(function (min, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(min) ? periodDate : min;
    }, __WEBPACK_IMPORTED_MODULE_5_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var findNextPeriodEnd = function findNextPeriodEnd(periods, worseCase) {
    return periods.reduce(function (max, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(max) ? periodDate : max;
    }, __WEBPACK_IMPORTED_MODULE_5_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var determineDependency = function determineDependency(state, getters) {
    return function (index) {
        if (!state.dependants[index]) {
            return {};
        }
        var deceasedButForDate = state.theDeceased.lifeExpectancy.dateOfDeath;
        var assumedSettlement = getters['fatal/estate/proceduralDates/date']('dateOfAssumedSettlement');
        var dependantDateOfDeath = state.dependants[index].lifeExpectancy.dateOfDeath;
        var mDeceasedButForDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(deceasedButForDate, 'DD/MM/YYYY');
        var mAssumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(assumedSettlement, 'DD/MM/YYYY');
        var mDependantDob = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.dependants[index].dateOfBirth, 'DD/MM/YYYY');
        var mDependantDateOfDeath = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dependantDateOfDeath, 'DD/MM/YYYY');

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(assumedSettlement) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(dependantDateOfDeath)) return {};

        if (Math.abs(mDependantDob.diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(), 'years')) < 21) {
            var dependencyEndAge = 18;
            switch (state.dependants[index].lifeExpectancy.method) {
                case 'dependent_until_custom':
                    dependencyEndAge = state.dependants[index].lifeExpectancy.child.youthCutOffAge;
                    break;
                case 'dependent_until_16':
                    dependencyEndAge = 16;
                    break;
                case 'dependent_until_21':
                    dependencyEndAge = 21;
                    break;
            }

            var dependencyEnd = mDependantDob.add(dependencyEndAge, 'years');

            if (mAssumedSettlement.isAfter(dependencyEnd) || mDeceasedButForDate.isAfter(dependencyEndAge)) {
                return {
                    duration: dependencyEnd.diff(mAssumedSettlement, 'years', true),
                    date: dependencyEnd.format('DD/MM/YYYY'),
                    type: 'To dependant\'s age of ' + dependencyEndAge
                };
            }
        }

        if (mAssumedSettlement.isAfter(mDependantDateOfDeath) || mDeceasedButForDate.isAfter(mDependantDateOfDeath)) {
            return {
                duration: mDependantDateOfDeath.diff(mAssumedSettlement, 'years', true),
                date: mDependantDateOfDeath.format('DD/MM/YYYY'),
                type: "To end of dependant's life expectancy"
            };
        }

        return {
            duration: mDeceasedButForDate.diff(mAssumedSettlement, 'years', true),
            date: mDeceasedButForDate.format('DD/MM/YYYY'),
            type: "To end of the deceased's life expectancy"
        };
    };
};

var valueFromState = function valueFromState(state, key) {
    return state[key];
};

var dependantValid = function dependantValid(dependant) {
    var valid = !!dependant.name && !!dependant.dateOfBirth && !!dependant.gender;
    return valid;
};

var dependantsNoChildren = function dependantsNoChildren(dependants) {
    return dependants.filter(function (dependant) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["q" /* isChild */])(dependant);
    });
};

var getters = {
    theDeceased: function theDeceased(state) {
        return valueFromState(state, 'theDeceased');
    },
    theDeceasedValue: function theDeceasedValue(state) {
        return function (key) {
            return valueFromState(state.theDeceased, [key]);
        };
    },
    theDeceasedIncomeValid: function theDeceasedIncomeValid(state) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['fatal/estate/proceduralDates/date']('dateOfAssumedSettlement'), 'DD/MM/YYYY');

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["d" /* incomeValid */])(assumedSettlement, state.theDeceased);
    },
    durationDeceasedDependency: function durationDeceasedDependency(state) {
        return state.theDeceased.lifeExpectancy.ageAtDeath - state.theDeceased.ageAtDeath;
    },
    dependant: function dependant(state) {
        return function (index) {
            return valueFromState(state.dependants, index);
        };
    },
    dependants: function dependants(state) {
        return valueFromState(state, 'dependants');
    },
    dependantsNoChild: function dependantsNoChild(state) {
        return dependantsNoChildren(valueFromState(state, 'dependants'));
    },
    hasMultipleDependants: function hasMultipleDependants(state) {
        return valueFromState(state, 'dependants').length > 1;
    },
    noOfDependants: function noOfDependants(state) {
        return valueFromState(state, 'dependants').length;
    },
    allDependantsValid: function allDependantsValid(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_helper__["c" /* areAllTrue */])(valueFromState(state, 'dependants'), dependantValid);
    },
    dependantIncomeValid: function dependantIncomeValid(state) {
        return function (index) {
            var assumedSettlement = __WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['fatal/estate/proceduralDates/date']('dateOfAssumedSettlement'), 'DD/MM/YYYY');

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["d" /* incomeValid */])(assumedSettlement, state.theDependants[index]);
        };
    },
    allDependantsIncomeValid: function allDependantsIncomeValid(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_helper__["c" /* areAllTrue */])(state.dependants, __WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["d" /* incomeValid */]);
    },
    theDeceasedNetIncome: function theDeceasedNetIncome(state) {
        return state.theDeceased.income.netIncome + state.theDeceased.income.netPensionIncome;
    },
    theDeceasedGrossIncome: function theDeceasedGrossIncome(state) {
        return state.theDeceased.income.grossIncome + state.theDeceased.income.grossPensionIncome;
    },
    dependantNetIncome: function dependantNetIncome(state) {
        return state.dependants.reduce(function (total, dependant) {
            return total + dependant.income.netIncome + dependant.income.netPensionIncome;
        }, 0);
    },
    dependantGrossIncome: function dependantGrossIncome(state) {
        return state.dependants.reduce(function (total, dependant) {
            return total + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["a" /* extractIncome */])(dependant, 'gross');
        }, 0);
    },

    maxDuration: function maxDuration(state, g, rs, rg) {
        return state.dependants.reduce(function (duration, dependant, index) {
            return duration;
        }, determineDependency(state, rg)(0));
    },
    hasSplitPeriods: function hasSplitPeriods(state) {
        if (!state.theDeceased.income.unchangedPension || !state.theDeceased.income.retired) {
            return true;
        }
        return state.dependants.reduce(function (hasSplit, dependant) {
            return hasSplit || !dependant.income.unchangedPension || !dependant.income.retired;
        }, false);
    },
    getDeceasedIncomePeriod: function getDeceasedIncomePeriod(state) {
        return function (index) {
            return state.theDeceased.income.periods[index];
        };
    },
    getDependantIncomePeriod: function getDependantIncomePeriod(state) {
        return function (dependant, index) {
            return state.dependants[dependant].income.periods[index];
        };
    },
    getDependencyOnIncomeValid: function getDependencyOnIncomeValid(state) {
        return state.dependencyOnIncomeValid;
    },
    getNoOfDependantPeriods: function getNoOfDependantPeriods(state) {
        return function (index) {
            return state.dependants[index].income.periods.length;
        };
    }
};

var updateObject = function updateObject(dispatch, action, obj) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var proms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return dispatch(action, { key: key, value: obj[key], index: index });
    });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms);
};

var dynamicUpdates = function dynamicUpdates(actions) {
    return function (key, dispatch, person, index) {
        var proms = [];
        switch (key) {
            case 'dateOfDeath':
            case 'dateOfBirth':
                if (actions.ageAtDeath) {
                    proms.push(dispatch(actions.ageAtDeath, {
                        key: 'ageAtDeath',
                        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["p" /* calcAgeDeath */])(person),
                        index: index,
                        force: true
                    }));
                }

                proms.push(dispatch(actions.lifeExpectancy, { lifeExpectancy: person.lifeExpectancy, index: index }));
                if (key == 'dateOfDeath') {
                    break;
                }

            case 'gender':
                proms.push(dispatch(actions.incomeValue, {
                    key: 'retirementAge',
                    value: DEFAULT_RETIREMENT[person.gender],
                    index: index
                }).then(function () {
                    return dispatch(actions.retirementDate, { index: index });
                }));
        }
        return proms;
    };
};

var theDeceasedEvents = dynamicUpdates({
    ageAtDeath: 'updateTheDeceasedValue',
    lifeExpectancy: 'updateTheDeceasedLifeExpectancy',
    incomeValue: 'updateTheDeceasedIncomeValue',
    retirementDate: 'updateRetirementAgeAndDate'
});

var dependantUpdateEvents = dynamicUpdates({
    lifeExpectancy: 'updateDependantLifeExpectancy',
    incomeValue: 'updateDependantIncomeValue',
    retirementDate: 'updateDependantRetirementDate'
});

var userSettable = function userSettable(key) {
    return key !== 'lifeExpectancy' && key !== 'income' && key !== 'ageAtDeath';
};

var incomeUpdates = function incomeUpdates(actions, dispatch, income, dateOfDeath, index) {
    return function (updatedKeys) {
        var proms = [];

        if (~updatedKeys.indexOf('retirementDate')) {
            proms.push(dispatch(actions.updateRetirementAge, { index: index }));
        }

        if (~updatedKeys.indexOf('retirementAge')) {
            proms.push(dispatch(actions.updateRetirementDate, { index: index }));
        }

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms);
    };
};

var doesIncomeNeedToUpdate = function doesIncomeNeedToUpdate(income, updatedKeys) {
    var triggerKeys = ['retired', 'grossIncome', 'netIncome', 'employmentType', 'netPensionIncome', 'grossPensionIncome'];
    var keys = updatedKeys.filter(function (key) {
        return key && ~triggerKeys.indexOf(key);
    });
    return !!keys.length;
};
var doesIncomePeriodNeedToUpdate = function doesIncomePeriodNeedToUpdate(updatedKeys) {
    var triggerKeys = ['startOfPeriod', 'endOfPeriod', 'employmentType', 'employmentIncome', 'employmentNetGross', 'pensionIncome', 'pensionNetGross', 'grossIncome', 'netIncome', 'netPensionIncome', 'grossPensionIncome'];
    var keys = updatedKeys.filter(function (key) {
        return key && ~triggerKeys.indexOf(key);
    });
    return !!keys.length;
};

var throttleUpdateLife = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.debounce(function (dispatch, action, person, lifeExpectancy, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['fatal/dependency/claimDetails/value']('assumedSettlement');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return updateObject(dispatch, action, updatedLife, index);
        }).then(function () {
            return dispatch('updatePeriodsForLifeExpectancy');
        });
    }
}, 500);

var isValidIncome = function isValidIncome(period) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(period.startOfPeriod) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(period.endOfPeriod) && !isNaN(period.employmentIncome) && !isNaN(period.pensionIncome) && period.employmentIncome > 0 || period.pensionIncome > 0;
};

var zeroCheck = function zeroCheck(dispatch, index, period, person, action, type) {
    if (type === 'deceased') {
        if (person.income.retired === true && period.pensionIncome === 0) {
            dispatch(action, { key: 'totalNetIncome', value: 0, index: index });
        }
        if (person.income.retired === false && period.pensionIncome === 0 && period.employmentIncome === 0) {
            dispatch(action, { key: 'totalNetIncome', value: 0, index: index });
            dispatch(action, { key: 'totalGrossIncome', value: 0, index: index });
        }
    } else {
        if (person.income.retired === true && period.pensionIncome === 0) {
            dispatch(action, { key: 'totalNetIncome', value: 0, index: index, dependant: person });
        }
        if (person.income.retired === false && period.pensionIncome === 0 && period.employmentIncome === 0) {
            dispatch(action, { key: 'totalNetIncome', value: 0, index: index, dependant: person });
            dispatch(action, { key: 'totalGrossIncome', value: 0, index: index, dependant: person });
        }
    }
};

var throttledIncome = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.debounce(function (period, dispatch, action, args, deceased, dependant) {
    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.income(period, deceased, dependant).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {
                dispatch(action, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: key, value: updated[key] }, args));
            }
        });
    }).then(function () {
        return dispatch('fatal/estate/updateTheMultiplicand', null, { root: true });
    });
}, 500);

var unthrottledIncome = function unthrottledIncome(period, dispatch, action, args, deceased, dependant) {
    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.income(period, deceased, dependant).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {
                dispatch(action, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: key, value: updated[key] }, args));
            }
        });
    });
};

var actions = {
    updateTheDeceased: function updateTheDeceased(_ref3, theDeceased) {
        var dispatch = _ref3.dispatch;

        return updateObject(dispatch, 'updateTheDeceasedValue', theDeceased);
    },
    updateTheDeceasedValue: function updateTheDeceasedValue(_ref4, _ref5) {
        var commit = _ref4.commit,
            state = _ref4.state,
            dispatch = _ref4.dispatch;
        var key = _ref5.key,
            value = _ref5.value,
            _ref5$force = _ref5.force,
            force = _ref5$force === undefined ? false : _ref5$force;

        if (state.theDeceased[key] !== value && (force || userSettable(key))) {
            commit(mutationTypes.UPDATE_DECEASED, { key: key, value: value });

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(theDeceasedEvents(key, dispatch, state.theDeceased))));
        }
    },
    updateTheDeceasedLifeExpectancy: function updateTheDeceasedLifeExpectancy(_ref6, _ref7) {
        var dispatch = _ref6.dispatch,
            state = _ref6.state;
        var lifeExpectancy = _ref7.lifeExpectancy;

        return updateObject(dispatch, 'updateTheDeceasedLifeExpectancyValue', lifeExpectancy).then(function () {
            return throttleUpdateLife(dispatch, 'updateTheDeceasedLifeExpectancyValue', state.theDeceased, lifeExpectancy);
        });
    },
    updateTheDeceasedLifeExpectancyValue: function updateTheDeceasedLifeExpectancyValue(_ref8, _ref9) {
        var commit = _ref8.commit,
            state = _ref8.state;
        var key = _ref9.key,
            value = _ref9.value;

        if (state.theDeceased.lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_DECEASED_LIFE_EXPECTANCY, { key: key, value: value });
        }
    },
    updateTheDeceasedIncome: function updateTheDeceasedIncome(_ref10, _ref11) {
        var dispatch = _ref10.dispatch,
            state = _ref10.state,
            getters = _ref10.getters;
        var income = _ref11.income;

        var actions = {
            updateRetirementAge: 'updateTheDeceasedRetirementAge',
            updateRetirementDate: 'updateTheDeceasedRetirementDate',
            updateValue: 'updateTheDeceasedIncomeValue'
        };
        var dependencyDuration = getters.durationOfDependency(0);

        return updateObject(dispatch, 'updateTheDeceasedIncomeValue', income).then(incomeUpdates(actions, dispatch, income, state.theDeceased.dateOfDeath, dependencyDuration));
    },
    updateTheDeceasedIncomeValue: function updateTheDeceasedIncomeValue(_ref12, _ref13) {
        var commit = _ref12.commit,
            state = _ref12.state;
        var key = _ref13.key,
            value = _ref13.value;

        if (state.theDeceased.income[key] === value) {
            return;
        }
        commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: key, value: value });
        return key;
    },
    updateTheDeceasedRetirementDate: function updateTheDeceasedRetirementDate(_ref14) {
        var commit = _ref14.commit,
            state = _ref14.state;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.theDeceased.dateOfBirth)) {
            return;
        }
        var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.dateOfBirth, 'DD/MM/YYYY').add(state.theDeceased.income.retirementAge, 'years').format('DD/MM/YYYY');
        if (!date || state.theDeceased.income.retirementDate === date) {
            return;
        }
        commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: 'retirementDate', value: date });
    },
    updateTheDeceasedRetirementAge: function updateTheDeceasedRetirementAge(_ref15) {
        var commit = _ref15.commit,
            state = _ref15.state;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.theDeceased.dateOfBirth) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.theDeceased.income.retirementDate)) {
            return;
        }
        var age = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.income.retirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(state.theDeceased.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
        if (isNaN(age) || state.theDeceased.income.retirementAge === age) {
            return;
        }
        commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: 'retirementAge', value: age });
    },
    addDependant: function addDependant(_ref16) {
        var commit = _ref16.commit;

        commit(mutationTypes.ADD_DEPENDANT);
    },
    updateDependant: function updateDependant(_ref17, _ref18) {
        var dispatch = _ref17.dispatch;
        var index = _ref18.index,
            dependant = _ref18.dependant;

        return updateObject(dispatch, 'updateDependantValue', dependant, index);
    },
    updateDependantValue: function updateDependantValue(_ref19, _ref20) {
        var commit = _ref19.commit,
            state = _ref19.state,
            dispatch = _ref19.dispatch;
        var key = _ref20.key,
            value = _ref20.value,
            index = _ref20.index;

        if (state.dependants[index][key] !== value && userSettable(key)) {
            commit(mutationTypes.UPDATE_DEPENDANT, { key: key, value: value, index: index });

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(dependantUpdateEvents(key, dispatch, state.dependants[index], index));
        }
    },
    updateDependantLifeExpectancy: function updateDependantLifeExpectancy(_ref21, _ref22) {
        var dispatch = _ref21.dispatch,
            state = _ref21.state;
        var index = _ref22.index,
            lifeExpectancy = _ref22.lifeExpectancy;

        return updateObject(dispatch, 'updateDependantLifeExpectancyValue', lifeExpectancy, index).then(function () {
            return throttleUpdateLife(dispatch, 'updateDependantLifeExpectancyValue', state.dependants[index], lifeExpectancy, index);
        });
    },
    updateDependantLifeExpectancyValue: function updateDependantLifeExpectancyValue(_ref23, _ref24) {
        var commit = _ref23.commit,
            state = _ref23.state;
        var key = _ref24.key,
            value = _ref24.value,
            index = _ref24.index;

        if (state.dependants[index].lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_DEPENDANT_LIFE_EXPECTANCY, { key: key, value: value, index: index });
        }
    },
    updateDependantYouth: function updateDependantYouth(_ref25, _ref26) {
        var commit = _ref25.commit;
        var key = _ref26.key,
            value = _ref26.value,
            index = _ref26.index;

        commit(mutationTypes.UPDATE_DEPENDANT_LIFE_EXPECTANCY, { key: key, value: value, index: index });
    },
    updateDependantIncome: function updateDependantIncome(_ref27, _ref28) {
        var dispatch = _ref27.dispatch,
            state = _ref27.state;
        var index = _ref28.index,
            income = _ref28.income;

        var actions = {
            updateRetirementAge: 'updateDependantRetirementAge',
            updateRetirementDate: 'updateDependantRetirementDate',
            updateValue: 'updateDependantIncomeValue'
        };

        return updateObject(dispatch, 'updateDependantIncomeValue', income, index).then(incomeUpdates(actions, dispatch, income, state.theDeceased.dateOfDeath, index));
    },
    updateDependantRetirementDate: function updateDependantRetirementDate(_ref29, _ref30) {
        var commit = _ref29.commit,
            state = _ref29.state;
        var index = _ref30.index;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.dependants[index].dateOfBirth)) {
            return;
        }
        var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.dependants[index].dateOfBirth, 'DD/MM/YYYY').add(state.dependants[index].income.retirementAge, 'years').format('DD/MM/YYYY');
        if (!date || state.dependants[index].income.retirementDate === date) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME, { key: 'retirementDate', value: date, index: index });
    },
    updateDependantRetirementAge: function updateDependantRetirementAge(_ref31, _ref32) {
        var commit = _ref31.commit,
            state = _ref31.state;
        var index = _ref32.index;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.dependants[index].dateOfBirth) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(state.dependants[index].income.retirementDate)) {
            return;
        }
        var age = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.dependants[index].income.retirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(state.dependants[index].dateOfBirth, 'DD/MM/YYYY'), 'years', true);
        if (isNaN(age) || state.dependants[index].income.retirementAge === age) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME, { key: 'retirementAge', value: age, index: index });
    },
    updateDependantIncomeValue: function updateDependantIncomeValue(_ref33, _ref34) {
        var commit = _ref33.commit,
            state = _ref33.state;
        var key = _ref34.key,
            value = _ref34.value,
            index = _ref34.index;

        if (state.dependants[index].income[key] === value) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME, { key: key, value: value, index: index });
        return key;
    },
    deleteDependant: function deleteDependant(_ref35, index) {
        var commit = _ref35.commit,
            state = _ref35.state,
            dispatch = _ref35.dispatch;

        commit(mutationTypes.DELETE_DEPENDANT, index);
        if (!state.dependants.length) {
            return dispatch('addDependant');
        }
    },
    calcDurationForDependant: function calcDurationForDependant(_ref36, index) {
        var getters = _ref36.getters;

        return getters.durationOfDependency(index);
    },
    addDeceasedIncomePeriod: function addDeceasedIncomePeriod(_ref37) {
        var commit = _ref37.commit,
            state = _ref37.state;

        var periods = state.theDeceased.income.periods,
            start = findNextPeriodStart(periods, state.theDeceased.dateOfDeath),
            end = findNextPeriodEnd(periods, state.theDeceased.lifeExpectancy.dateOfDeath);

        commit(mutationTypes.ADD_DECEASED_INCOME_PERIOD, defaultIncomePeriodTemplate({
            start: start,
            end: end
        }));
    },
    updateDependencyOnIncomeValid: function updateDependencyOnIncomeValid(_ref38, valid) {
        var commit = _ref38.commit;

        commit(mutationTypes.UPDATE_DEPENDENCY_ON_INCOME_VALID, valid);
    },
    updateDeceasedIncomePeriod: function updateDeceasedIncomePeriod(_ref39, _ref40) {
        var dispatch = _ref39.dispatch;
        var index = _ref40.index,
            period = _ref40.period,
            deceased = _ref40.deceased;

        updateObject(dispatch, 'updateDeceasedIncomePeriodValue', period, index).then(function (updatedKeys) {
            if (!doesIncomePeriodNeedToUpdate(updatedKeys)) {
                return;
            }
            zeroCheck(dispatch, index, period, deceased, 'updateDeceasedIncomePeriodValue', 'deceased');
            if (!isValidIncome(period) || deceased.income.retirementAge < 50 || deceased.income.retirementAge === "") {
                return;
            }
            return throttledIncome(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, deceased);
        });
    },
    updateDeceasedIncomePeriodValue: function updateDeceasedIncomePeriodValue(_ref41, _ref42) {
        var commit = _ref41.commit,
            state = _ref41.state;
        var index = _ref42.index,
            key = _ref42.key,
            value = _ref42.value;

        if (state.theDeceased.income.periods[index]) {
            var currentPeriod = state.theDeceased.income.periods[index];
            if (currentPeriod[key] === value) {
                return;
            }
            commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: index, key: key, value: value });
            return key;
        }
    },
    deleteDeceasedIncomePeriod: function deleteDeceasedIncomePeriod(_ref43, _ref44) {
        var commit = _ref43.commit,
            state = _ref43.state,
            dispatch = _ref43.dispatch;
        var index = _ref44.index;

        commit(mutationTypes.DELETE_DECEASED_INCOME_PERIOD, index);
        if (!state.theDeceased.income.periods.length) {
            return dispatch('addDeceasedIncomePeriod');
        }
    },
    addDependantIncomePeriod: function addDependantIncomePeriod(_ref45, _ref46) {
        var commit = _ref45.commit,
            state = _ref45.state;
        var index = _ref46.index;

        var person = state.dependants[index];
        var periods = person.income.periods;

        commit(mutationTypes.ADD_DEPENDANT_INCOME_PERIOD, {
            dependant: index,
            period: defaultIncomePeriodTemplate({
                start: findNextPeriodStart(periods, state.theDeceased.dateOfDeath),
                end: findNextPeriodEnd(periods, state.theDeceased.lifeExpectancy.dateOfDeath)
            })
        });
    },
    updateDependantIncomePeriod: function updateDependantIncomePeriod(_ref47, _ref48) {
        var dispatch = _ref47.dispatch,
            state = _ref47.state;
        var index = _ref48.index,
            period = _ref48.period,
            dependant = _ref48.dependant;

        var proms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(period).map(function (key) {
            return dispatch('updateDependantIncomePeriodValue', { key: key, value: period[key], index: index, dependant: dependant });
        });
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms).then(function (updatedKeys) {
            if (!doesIncomePeriodNeedToUpdate(updatedKeys)) {
                return;
            }
            zeroCheck(dispatch, index, period, dependant, 'updateDependantIncomePeriodValue', 'dependant');
            if (!isValidIncome(period)) {
                return;
            }
            throttledIncome(period, dispatch, 'updateDependantIncomePeriodValue', {
                index: index,
                dependant: dependant
            }, state.theDeceased, state.dependants[dependant]);
        });
    },
    updateDependantIncomePeriodValue: function updateDependantIncomePeriodValue(_ref49, _ref50) {
        var commit = _ref49.commit;
        var index = _ref50.index,
            key = _ref50.key,
            value = _ref50.value,
            dependant = _ref50.dependant;

        var currentPeriod = dependant.income.periods[index];
        if (currentPeriod[key] === value) {
            return;
        }
        commit(mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, { index: index, key: key, value: value, dependant: dependant });
        return key;
    },
    deleteDependantIncomePeriod: function deleteDependantIncomePeriod(_ref51, _ref52) {
        var commit = _ref51.commit,
            dispatch = _ref51.dispatch;
        var dependant = _ref52.dependant,
            index = _ref52.index;

        commit(mutationTypes.DELETE_DEPENDANT_INCOME_PERIOD, { dependant: dependant, index: index });
        if (!dependant.income.periods.length) {
            return dispatch('addDependantIncomePeriod', { index: dependant.index });
        }
    },
    updatePeriodsForDateOfDeath: function updatePeriodsForDateOfDeath(_ref53) {
        var commit = _ref53.commit,
            state = _ref53.state,
            dispatch = _ref53.dispatch;

        var dateOfDeath = state.theDeceased.dateOfDeath;
        if (state.theDeceased.income.periods.length) {
            commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: 0, key: 'startOfPeriod', value: dateOfDeath });
        }
        state.dependants.forEach(function (dependant, index) {
            if (dependant.income.periods.length) {
                commit(mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, {
                    index: 0,
                    key: 'startOfPeriod',
                    value: dateOfDeath,
                    dependant: state.dependants[index]
                });
            }
        });
        dispatch('fatal/estate/updateTheMultiplicand', null, { root: true });
    },
    updatePeriodsForLifeExpectancy: function updatePeriodsForLifeExpectancy(_ref54) {
        var commit = _ref54.commit,
            state = _ref54.state,
            dispatch = _ref54.dispatch;

        var dateOfDeath = state.theDeceased.lifeExpectancy.dateOfDeath;
        if (state.theDeceased.income.periods.length) {
            commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: state.theDeceased.income.periods.length - 1, key: 'endOfPeriod', value: dateOfDeath });
        }
        state.dependants.forEach(function (dependant, index) {
            if (dependant.income.periods.length) {
                commit(mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, {
                    index: dependant.income.periods.length - 1,
                    key: 'endOfPeriod',
                    value: state.theDeceased.lifeExpectancy.dateOfDeath,
                    dependant: state.dependants[index]
                });
            } else if (dependant.lifeExpectancy.dateOfDeath) {
                dispatch('addDependantIncomePeriod', { index: index });
            }
        });
        dispatch('fatal/estate/updateTheMultiplicand', null, { root: true });
    },
    removeDeceasedInvalidPeriodAndAddDefaults: function removeDeceasedInvalidPeriodAndAddDefaults(_ref55) {
        var commit = _ref55.commit,
            state = _ref55.state,
            dispatch = _ref55.dispatch;

        var dateOfDeath = state.theDeceased.dateOfDeath;

        state.theDeceased.income.periods.forEach(function (period, index) {
            if (state.theDeceased.income.retired) {
                commit(mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, { index: index, key: 'employmentIncome', value: 0 });
                throttledIncome(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, state.theDeceased);
            }

            var periodStart = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'),
                periodEnd = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');

            if (periodStart.isBefore(dateOfDeath)) {
                dispatch('deleteDeceasedIncomePeriod', { index: index });
            }
        });
    },
    removeDependantInvalidPeriodAndAddDefaults: function removeDependantInvalidPeriodAndAddDefaults(_ref56, _ref57) {
        var dispatch = _ref56.dispatch,
            state = _ref56.state;
        var index = _ref57.index;

        var dateOfDeath = state.dependants[index].dateOfDeathAssumed;

        state.dependants[index].income.periods.forEach(function (period, index) {
            if (state.dependants[index].income.retired) {
                dispatch('updateDependantIncomePeriodValue', {
                    key: 'employmentIncome',
                    value: 0,
                    index: index,
                    dependant: state.dependants[index]
                });
                throttledIncome(period, dispatch, 'updateDependantIncomePeriodValue', {
                    index: index,
                    dependant: state.dependants[index]
                }, state.theDeceased, state.dependants[index]);
            }

            var periodStart = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'),
                periodEnd = __WEBPACK_IMPORTED_MODULE_5_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');

            if (periodStart.isBefore(dateOfDeath)) {
                dispatch('deleteDependantIncomePeriod', { index: index, dependant: state.dependants[index] });
            }
        });
    },
    updateAllIncome: function updateAllIncome(_ref58, data) {
        var dispatch = _ref58.dispatch,
            state = _ref58.state;

        if (data.type === 'Deceased') {
            var updateIncome = state.theDeceased.income.periods.map(function (period, index) {
                if (!isValidIncome(period) || data.income.retirementAge < 50 || data.income.retirementAge === "") {
                    return;
                }
                unthrottledIncome(period, dispatch, 'updateDeceasedIncomePeriodValue', { index: index }, state.theDeceased);
            });

            dispatch('fatal/estate/updateTheMultiplicand', null, { root: true });

            return updateIncome;
        }

        var dependant = data.index || null;
        data.income.periods.map(function (period, index) {
            if (!isValidIncome(period)) {
                return;
            }
            unthrottledIncome(period, dispatch, 'updateDependantIncomePeriodValue', {
                index: index,
                dependant: dependant
            }, state.theDeceased, data.income);
        });

        dispatch('fatal/estate/updateTheMultiplicand', null, { root: true });
    },
    reset: function reset(_ref59) {
        var commit = _ref59.commit;

        commit(mutationTypes.RESET_DECEASED);
        commit(mutationTypes.RESET_DEPENDANTS);
    },

    updateRetirementAgeAndDate: __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.debounce(function (_ref60) {
        var state = _ref60.state,
            commit = _ref60.commit;

        return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.dates.statePensionAge(state.theDeceased).then(function (data) {
            commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: 'retirementAge', value: data.statePension.retirementAge });
            commit(mutationTypes.UPDATE_DECEASED_INCOME, { key: 'retirementDate', value: data.statePension.retirementDate });
        });
    }, 500)
};

var mutatePersonFromServer = function mutatePersonFromServer(person, payload, type) {
    var dob = __WEBPACK_IMPORTED_MODULE_5_moment___default()(payload.date_of_birth, 'YYYY-MM-DD');
    var dod = __WEBPACK_IMPORTED_MODULE_5_moment___default()(payload.date_of_death, 'YYYY-MM-DD');
    var onsetOfSymptoms = __WEBPACK_IMPORTED_MODULE_5_moment___default()(payload.onset_of_symptoms, 'YYYY-MM-DD');

    person.name = payload.name;
    person.gender = payload.gender;
    person.onsetOfSymptoms = onsetOfSymptoms.format('DD/MM/YYYY');
    person.dateOfBirth = dob.format('DD/MM/YYYY');
    if (dod.isValid()) {
        person.dateOfDeath = dod.isValid() ? dod.format('DD/MM/YYYY') : null;
        person.ageAtDeath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_services_personFunctions__["p" /* calcAgeDeath */])(person);
    }
    person.lifeExpectancy = payload.full_life;
    person.income = payload.income;

    return true;
};

var mutatePersonIncomeFromServer = function mutatePersonIncomeFromServer(income, payload) {
    var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    income.retired = payload[prefix + 'retired'];
    income.retirementAge = payload[prefix + 'retirement_age'];
    income.retirementDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_helper__["b" /* dateFromServer */])(payload[prefix + 'retirement_date']);
    income.unchangedPension = payload[prefix + 'pension_unchanged'];
    income.netIncome = payload[prefix + 'net_income'];
    income.grossIncome = payload[prefix + 'gross_income'];
    income.netPensionIncome = payload[prefix + 'net_pension_income'];
    income.grossPensionIncome = payload[prefix + 'gross_pension__income'];
    income.employmentType = payload[prefix + 'employment_type'];
    income.periods = payload[prefix + 'periods'];
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED, function (state, _ref61) {
    var key = _ref61.key,
        value = _ref61.value;

    state.theDeceased[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_DECEASED, function (state) {
    state.theDeceased = personTemplate();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_LIFE_EXPECTANCY, function (state, _ref62) {
    var key = _ref62.key,
        value = _ref62.value;

    state.theDeceased.lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_INCOME, function (state, _ref63) {
    var key = _ref63.key,
        value = _ref63.value;

    state.theDeceased.income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANT, function (state) {
    var dependant = personTemplate();
    dependant.index = state.dependants.length;
    state.dependants.push(dependant);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT, function (state, _ref64) {
    var key = _ref64.key,
        value = _ref64.value,
        index = _ref64.index;

    state.dependants[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_DEPENDANTS, function (state) {
    state.dependants = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_LIFE_EXPECTANCY, function (state, _ref65) {
    var key = _ref65.key,
        value = _ref65.value,
        index = _ref65.index;

    state.dependants[index].lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_INCOME, function (state, _ref66) {
    var key = _ref66.key,
        value = _ref66.value,
        index = _ref66.index;

    state.dependants[index].income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DEPENDANT, function (state, index) {
    state.dependants.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DECEASED, function (state, payload) {
    state.theDeceased = personTemplate();
    return mutatePersonFromServer(state.theDeceased, payload, 'deceased');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DECEASED_INCOME, function (state, payload) {
    return mutatePersonIncomeFromServer(state.theDeceased.income, payload, 'deceased_');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DEPENDANT_INCOME, function (state, _ref67) {
    var index = _ref67.index,
        income = _ref67.income;

    return mutatePersonIncomeFromServer(state.dependants[index].income, income);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SERVER_UPDATE_DEPENDANT, function (state, _ref68) {
    var dependant = _ref68.dependant;

    var index = state.dependants.length;
    state.dependants.push(personTemplate());
    state.dependants[index].index = index;
    return mutatePersonFromServer(state.dependants[index], dependant, 'dependant');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DECEASED_INCOME_PERIOD, function (state, payload) {
    state.theDeceased.income.periods.push(payload);
    state.theDeceased.income.netPensionIncome += payload.netPensionIncome;
    state.theDeceased.income.grossPensionIncome += payload.grossPensionIncome;
    state.theDeceased.income.netIncome += payload.netIncome;
    state.theDeceased.income.grossIncome += payload.grossIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED_INCOME_PERIOD, function (state, _ref69) {
    var key = _ref69.key,
        value = _ref69.value,
        index = _ref69.index;

    if (~key.indexOf('Income')) {
        state.theDeceased.income[key] -= state.theDeceased.income.periods[index][key] || 0;
    }
    state.theDeceased.income.periods[index][key] = value;
    if (~key.indexOf('Income')) {
        state.theDeceased.income[key] += value || 0;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DECEASED_INCOME_PERIOD, function (state, payload) {
    state.theDeceased.income.periods.splice(payload, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_DEPENDANT_INCOME_PERIOD, function (state, _ref70) {
    var dependant = _ref70.dependant,
        period = _ref70.period;

    state.dependants[dependant].income.periods.push(period);
    state.dependants[dependant].income.netPensionIncome += period.netPensionIncome;
    state.dependants[dependant].income.grossPensionIncome += period.grossPensionIncome;
    state.dependants[dependant].income.netIncome += period.netIncome;
    state.dependants[dependant].income.grossIncome += period.grossIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDANT_INCOME_PERIOD, function (state, _ref71) {
    var dependant = _ref71.dependant,
        key = _ref71.key,
        index = _ref71.index,
        value = _ref71.value;

    var income = state.dependants[dependant.index].income;
    if (~key.indexOf('Income')) {
        income[key] -= income.periods[index][key] || 0;
    }
    income.periods[index][key] = value;
    if (~key.indexOf('Income')) {
        income[key] += value || 0;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_DEPENDANT_INCOME_PERIOD, function (state, _ref72) {
    var dependant = _ref72.dependant,
        index = _ref72.index;

    state.dependants[dependant.index].income.periods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDENCY_ON_INCOME_VALID, function (state, valid) {
    state.dependencyOnIncomeValid = valid;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_validator_validations__ = __webpack_require__(23);



var _mutations;





var mutationTypes = {
    SET_DATE_OF_ISSUE_PROCEEDINGS: 'SET_DATE_OF_ISSUE_PROCEEDINGS',
    SET_DATE_OF_SERVICE_PROCEEDINGS: 'SET_DATE_OF_SERVICE_PROCEEDINGS',
    SET_DATE_OF_ASSUMED_SETTLEMENT: 'SET_DATE_OF_ASSUMED_SETTLEMENT',
    SET_AGE_OF_DEATH_TO_SETTLEMENT: 'SET_AGE_OF_DEATH_TO_SETTLEMENT',
    SET_AGE_AT_SETTLEMENT: 'SET_AGE_AT_SETTLEMENT',
    SET_PRE_LIT_OR_LIT: 'SET_PRE_LIT_OR_LIT',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    RESET: 'RESET'
};

var state = {
    preLitOrLit: 'pre-lit',
    dateOfIssueProceedings: null,
    dateOfServiceProceedings: null,
    dateOfAssumedSettlement: null,
    periodDeathToSettlement: null,
    ageAtSettlement: null
};

var getters = {
    date: function date(state) {
        return function (key) {
            return state[key];
        };
    },
    serviceOfProceedingsValid: function serviceOfProceedingsValid(state, g, rs, rg) {
        var mDateOfDeath = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rg['fatal/estate/people/theDeceasedValue']('dateOfDeath'), 'DD/MM/YYYY');
        var mDateOfServiceOfProceedings = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rg['fatal/estate/claimDetails/value']('serviceOfProceedings'), 'DD/MM/YYYY');
        var differenceInYears = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rg['fatal/estate/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY').diff(mDateOfServiceOfProceedings, 'years');

        return differenceInYears <= 9 && differenceInYears >= 0 && (mDateOfDeath.isValid() ? mDateOfDeath.isBefore(mDateOfServiceOfProceedings) :  true ? true : mDateOfDeath.isBefore(mDateOfServiceOfProceedings));
    }
};

var actions = {
    setIssueProceedings: function setIssueProceedings(_ref, date) {
        var commit = _ref.commit;

        commit(mutationTypes.SET_DATE_OF_ISSUE_PROCEEDINGS, date);
    },
    setServiceProceedings: function setServiceProceedings(_ref2, date) {
        var commit = _ref2.commit;

        commit(mutationTypes.SET_DATE_OF_SERVICE_PROCEEDINGS, date);
    },
    setAssumedSettlement: function setAssumedSettlement(_ref3, date) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        commit(mutationTypes.SET_DATE_OF_ASSUMED_SETTLEMENT, date);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([dispatch('determineAgeOfDeathToSettlement'), dispatch('determineAgeAtSettlement')]);
    },
    setPreLitOrLit: function setPreLitOrLit(_ref4, value) {
        var commit = _ref4.commit;

        commit(mutationTypes.SET_PRE_LIT_OR_LIT, value);
    },
    determineAgeOfDeathToSettlement: function determineAgeOfDeathToSettlement(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state,
            rootGetters = _ref5.rootGetters;

        var mSettleDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(state.dateOfAssumedSettlement, 'DD/MM/YYYY');
        var mDod = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rootGetters['fatal/estate/people/theDeceasedValue']('dateOfDeath'), 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDod.isValid()) {
            commit(mutationTypes.SET_AGE_OF_DEATH_TO_SETTLEMENT, mSettleDate.diff(mDod, 'years', true));
        }
    },
    determineAgeAtSettlement: function determineAgeAtSettlement(_ref6) {
        var commit = _ref6.commit,
            state = _ref6.state,
            rootGetters = _ref6.rootGetters;

        var mSettleDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(state.dateOfAssumedSettlement, 'DD/MM/YYYY');
        var mDob = __WEBPACK_IMPORTED_MODULE_2_moment___default()(rootGetters['fatal/estate/people/theDeceasedValue']('dateOfBirth'), 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDob.isValid()) {
            commit(mutationTypes.SET_AGE_AT_SETTLEMENT, mSettleDate.diff(mDob, 'years', true));
        }
    },
    load: function load(_ref7, step) {
        var dispatch = _ref7.dispatch,
            action = _ref7.action,
            commit = _ref7.commit;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;
        var proms = [];

        if (data.procedural_status) {
            proms.push(dispatch('setPreLitOrLit', dates.procedural_status));
        }
        if (dates.service_of_proceedings) {
            proms.push(dispatch('setServiceProceedings', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_helper__["b" /* dateFromServer */])(dates.service_of_proceedings)));
        }
        if (dates.assumed_settlement) {
            proms.push(dispatch('setAssumedSettlement', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_helper__["b" /* dateFromServer */])(dates.assumed_settlement)));
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(proms).then(function () {
            return state.ageAtSettlement > 0;
        });
    },
    reset: function reset(_ref8) {
        var commit = _ref8.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_DATE_OF_ISSUE_PROCEEDINGS, function (state, payload) {
    state.dateOfIssueProceedings = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_DATE_OF_SERVICE_PROCEEDINGS, function (state, payload) {
    state.dateOfServiceProceedings = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_DATE_OF_ASSUMED_SETTLEMENT, function (state, payload) {
    state.dateOfAssumedSettlement = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_AGE_OF_DEATH_TO_SETTLEMENT, function (state, payload) {
    state.periodDeathToSettlement = Math.round(payload * 10) / 10;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_AGE_AT_SETTLEMENT, function (state, payload) {
    state.ageAtSettlement = Math.round(payload * 10) / 10;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_PRE_LIT_OR_LIT, function (state, payload) {
    state.preLitOrLit = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.preLitOrLit = 'pre-lit';
    state.dateOfIssueProceedings = null;
    state.dateOfServiceProceedings = null;
    state.dateOfAssumedSettlement = null;
    state.periodDeathToSettlement = null;
    state.ageAtSettlement = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_fatal_accident_claims_estate_routes__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_generators_step__ = __webpack_require__(21);




var steps = __WEBPACK_IMPORTED_MODULE_0_pages_fatal_accident_claims_estate_routes__["a" /* default */].children.map(function (route) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_generators_step__["b" /* buildFromRoute */])({ route: route, prefix: 'fatal-accidents' });
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_generators_step__["c" /* default */])(steps));

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_index__ = __webpack_require__(15);


var _mutations;



var types = {
    UPDATE_HEADER_WIDTH: 'UPDATE_HEADER_WIDTH',
    UPDATE_HEADER_POSITION: 'UPDATE_HEADER_POSITION',
    SET_INITIAL_HEADER_WIDTH: 'SET_INITIAL_HEADER_WIDTH',
    SET_INITIAL_HEADER_POSITION: 'SET_INITIAL_HEADER_POSITION'
};

var state = {
    theHeaderWidth: 0,
    theHeaderPosition: '',
    initialHeaderWidth: 0,
    initialHeaderPosition: ''
};

var getters = {
    theCurrentHeaderWidth: function theCurrentHeaderWidth(state) {
        return state.theHeaderWidth;
    },
    theCurrentHeaderPosition: function theCurrentHeaderPosition(state) {
        return state.theHeaderPosition;
    },
    theInitialHeaderWidth: function theInitialHeaderWidth(state) {
        return state.initialHeaderWidth;
    },
    theInitialHeaderPosition: function theInitialHeaderPosition(state) {
        return state.initialHeaderPosition;
    }
};

var actions = {
    updateHeaderWidth: function updateHeaderWidth(_ref, width) {
        var commit = _ref.commit;
        return commit(types.UPDATE_HEADER_WIDTH, width);
    },
    updateHeaderPosition: function updateHeaderPosition(_ref2, width) {
        var commit = _ref2.commit;
        return commit(types.UPDATE_HEADER_POSITION, width);
    },
    setInitialHeaderWidth: function setInitialHeaderWidth(_ref3, width) {
        var commit = _ref3.commit;
        return commit(types.SET_INITIAL_HEADER_WIDTH, width);
    },
    setInitialHeaderPosition: function setInitialHeaderPosition(_ref4, position) {
        var commit = _ref4.commit;
        return commit(types.SET_INITIAL_HEADER_POSITION, position);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.SET_INITIAL_HEADER_WIDTH, function (state, _ref5) {
    var initialWidthValue = _ref5.initialWidthValue;


    state.initialHeaderWidth = initialWidthValue;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_HEADER_WIDTH, function (state, _ref6) {
    var windowWidth = _ref6.windowWidth;


    if (__WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].getters["menu/isMenuCollapsed"] === true) {
        state.theHeaderWidth = 98 + '%';
    } else if (windowWidth >= 1600 && state.initialHeaderPosition === 'fixed') {
        state.theHeaderWidth = 84 + '%';
    } else if (windowWidth <= 1024) {
        state.theHeaderWidth = 100 + '%';
    } else {
        state.theHeaderWidth = state.initialHeaderWidth + '%';
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.SET_INITIAL_HEADER_POSITION, function (state, _ref7) {
    var initialPositionValue = _ref7.initialPositionValue;


    state.initialHeaderPosition = initialPositionValue;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_HEADER_POSITION, function (state, _ref8) {
    var windowWidth = _ref8.windowWidth;


    state.theHeaderPosition = windowWidth <= 1024 ? 'relative' : state.initialHeaderPosition;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _mutations;

var mutationTypes = {
    HTTP_START: 'HTTP_START',
    HTTP_STOP: 'HTTP_STOP',
    HTTP_REPORT_ERROR: 'REPORT_ERROR',
    HTTP_CLEAR_ERROR: 'HTTP_CLEAR_ERROR',
    ADD_SERVER_RESPONSE: 'ADD_SERVER_RESPONSE',
    ADD_REQUEST_HISTORY: 'ADD_REQUEST_HISTORY',
    UPDATE_REQUEST_HISTORY: 'UPDATE_REQUEST_HISTORY',
    UPDATE_REQUEST_HISTORY_ERROR: 'UPDATE_REQUEST_HISTORY_ERROR',
    MAINTENANCE_MODE: 'MAINTENANCE_MODE'
};

var state = {
    running: false,
    hasError: false,
    maintenanceStatus: false,
    lastError: '',
    errors: [],
    responseHistory: [],
    requestHistory: {
        error: {
            exception: null,
            url: null,
            message: null
        }
    }
};

var getters = {
    url: function url(state) {
        return state.url;
    },
    running: function running(state) {
        return state.running;
    },
    hasError: function hasError(state) {
        return state.hasError;
    },
    lastError: function lastError(state) {
        return state.lastError;
    },
    errors: function errors(state) {
        return state.errors;
    },
    errorToDisplay: function errorToDisplay(state) {
        return state.requestHistory.error;
    },
    apiRouteRequestRunning: function apiRouteRequestRunning(state) {
        return function (apiRoute) {
            return state.requestHistory[apiRoute] === 'running';
        };
    },
    getMaintenanceStatus: function getMaintenanceStatus(state) {
        return state.maintenanceStatus;
    }
};

var actions = {
    start: function start(_ref, _ref2) {
        var commit = _ref.commit;
        var url = _ref2.url,
            _ref2$showRunning = _ref2.showRunning,
            showRunning = _ref2$showRunning === undefined ? true : _ref2$showRunning;

        if (showRunning) {
            commit(mutationTypes.HTTP_START);
        }
        commit(mutationTypes.ADD_REQUEST_HISTORY, url);
    },
    stop: function stop(_ref3, _ref4) {
        var commit = _ref3.commit;
        var response = _ref4.response,
            _ref4$showRunning = _ref4.showRunning,
            showRunning = _ref4$showRunning === undefined ? true : _ref4$showRunning;

        if (showRunning) {
            commit(mutationTypes.HTTP_STOP);
        }
        commit(mutationTypes.UPDATE_REQUEST_HISTORY, response);
        commit(mutationTypes.ADD_SERVER_RESPONSE, response);
    },
    error: function error(_ref5, _error) {
        var commit = _ref5.commit,
            dispatch = _ref5.dispatch;

        commit(mutationTypes.HTTP_REPORT_ERROR, _error.response);
        commit(mutationTypes.UPDATE_REQUEST_HISTORY_ERROR, _error.response.data);

        if (_error.response.data.exception === 'AuthenticationException' || _error.response.data.error === 'Unauthenticated.') {
            dispatch('user/resetUser', {}, { root: true });
            return;
        }

        if (_error.response.data.exception === "MaintenanceModeException") {
            commit(mutationTypes.MAINTENANCE_MODE);
            return;
        }

        switch (_error.response.status) {
            case 404:
                return;
            default:
                dispatch('modal/toggle', 'error_modal', { root: true });
        }
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.HTTP_START, function (state) {
    state.running = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.HTTP_STOP, function (state) {
    state.running = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.HTTP_REPORT_ERROR, function (state, payload) {
    state.hasError = true;
    state.running = false;
    state.lastError = payload;
    state.errors.push(payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.HTTP_CLEAR_ERROR, function (state) {
    state.hasError = false;
    state.requestHistory.error = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_SERVER_RESPONSE, function (state, payload) {
    state.responseHistory.push(payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_REQUEST_HISTORY, function (state, url) {
    state.requestHistory[url] = 'running';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_REQUEST_HISTORY, function (state, payload) {
    state.requestHistory[payload.config.url] = 'finished';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_REQUEST_HISTORY_ERROR, function (state, payload) {
    state.requestHistory.error = payload;
    state.requestHistory[payload.url] = 'error';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.MAINTENANCE_MODE, function (state) {
    state.maintenanceStatus = true;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_generators_step__ = __webpack_require__(21);





var mutationTypes = {
    RESET: 'RESET'
};

var state = {};

var rules = {};

var getters = {};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([]);
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        dispatch('lost/step/setStepNumberValid', {
            stepNo: 7,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_generators_step__["a" /* previousValid */])(rootState, 7)
        }, { root: true });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit,
            dispatch = _ref5.dispatch;

        dispatch('lost/step/setStepNumberValid', {
            stepNo: 7,
            valid: false
        }, { root: true });

        commit(mutationTypes.RESET);
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.RESET, function (state) {});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_generators_step__ = __webpack_require__(21);


var _mutations;






var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET'
};

var state = {
    periodBetweenOnsetAndAssumedDod: 0,
    claimantReductionInLife: 0,
    discountRate: -0.25
};

var rules = {
    periodBetweenOnsetAndAssumedDod: { type: 'number', rules: 'required|min:0.1' },
    claimantReductionInLife: { type: 'number', rules: 'required|min:0.1' }
};

var rootRules = {
    'lost.claimant.theClaimant.onsetOfSymptoms': { type: 'date', rules: 'required' },
    'lost.claimant.theClaimant.assumedLifeExpectancy.dateOfDeath': { type: 'date', rules: 'required' }
};

var getters = {
    getClaimInfoValue: function getClaimInfoValue(state) {
        return function (key) {
            return state[key];
        };
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        payload.data = state;
        payload.data.onset_of_symptoms = rootState.lost.claimant.theClaimant.onsetOfSymptoms;
        payload.data.level_of_education = rootState.lost.claimant.theClaimant.levelOfEducation;
        payload.data.disabled = rootState.lost.claimant.theClaimant.disabledAtAccident;
        payload.data.age_at_death = rootState.lost.claimant.theClaimant.assumedLifeExpectancy.ageAtDeath;

        __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        dispatch('lost/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_store_modules_claim__["d" /* requestPayload */])(0), { root: true });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;
        commit(mutationTypes.UPDATE_VALUE, { key: 'discountRate', value: data.discountRate });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        dispatch('lost/step/setStepNumberValid', {
            stepNo: 1,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_generators_step__["a" /* previousValid */])(rootState, 1) && new __WEBPACK_IMPORTED_MODULE_3_services_Validator__["a" /* default */](rootState, rootRules).validate() && new __WEBPACK_IMPORTED_MODULE_3_services_Validator__["a" /* default */](state, rules).validate()
        }, { root: true });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit,
            dispatch = _ref5.dispatch;

        dispatch('lost/step/setStepNumberValid', {
            stepNo: 1,
            valid: false
        }, { root: true });

        commit(mutationTypes.RESET);
    },
    updateClaimInfoValue: function updateClaimInfoValue(_ref6, _ref7) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch;
        var key = _ref7.key,
            value = _ref7.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.periodBetweenOnsetAndAssumedDod = 0;
    state.claimantReductionInLife = 0;
    state.discountRate = -0.25;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttleUpdateLife */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);






var _mutations;










var mutationTypes = {
    SET: 'SET',
    UPDATE_CLAIMANT_VALUE: 'UPDATE_CLAIMANT_VALUE',
    UPDATE_CLAIMANT_DETAIL: 'UPDATE_CLAIMANT_DETAIL',
    UPDATE_LIFE_EXPECTANCY: 'UPDATE_LIFE_EXPECTANCY',
    UPDATE_LIFE_ASSUMED_EXPECTANCY: 'UPDATE_LIFE_ASSUMED_EXPECTANCY',
    UPDATE_INCOME: 'UPDATE_INCOME',
    ADD_INCOME_PERIOD: 'ADD_INCOME_PERIOD',
    UPDATE_INCOME_PERIOD: 'UPDATE_INCOME_PERIOD',
    DELETE_INCOME_PERIOD: 'DELETE_INCOME_PERIOD',
    UPDATE_STATE_PENSION_AGE: 'UPDATE_STATE_PENSION_AGE',
    UPDATE_CLAIM_INFO_VALUE: 'UPDATE_CLAIM_INFO_VALUE',
    RESET_EMPLOYED_INCOME: 'RESET_EMPLOYED_INCOME',
    RESET_PENSION_INCOME: 'RESET_PENSION_INCOME',
    RESET: 'RESET',
    UPDATING_INCOME_PERIOD: 'UPDATING_INCOME_PERIOD'
};

var state = {
    theClaimant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_store_modules_shared_templates__["f" /* personTemplate */])(),

    claimantDetails: {
        claimNarrative: null,
        diseaseOrAccident: null,
        diseaseType: null,
        diseaseTypeOther: '',
        accidentType: null,
        accidentTypeOther: '',
        defendantName: {
            id: null,
            name: null,
            type: null
        },
        claimantSolicitor: {
            id: null,
            name: null,
            type: null
        },
        claimantReference: null,
        yourReference: null
    },
    claimInfo: {
        discountRate: -0.25,
        periodBetweenOnsetAndAssumedDod: 0,
        claimantReductionInLife: 0,
        proceduralStatus: 'pre-lit',
        dateOfIssueProceedings: null,
        dateOfServiceProceedings: null,
        dateOfAssumedSettlement: null
    },
    updatingIncome: false
};

var rules = {
    'theClaimant.name': { type: 'text', rules: 'required' },
    'theClaimant.gender': { type: 'text', rules: 'required' },
    'theClaimant.dateOfBirth': { type: 'date', rules: 'required' },
    'claimantDetails.claimantSolicitor': { type: 'text', rules: 'required' },
    'claimantDetails.claimantReference': { type: 'text', rules: 'required' },
    'claimantDetails.diseaseOrAccident': { type: 'text', rules: 'required' },
    'claimantDetails.claimNarrative': { type: 'text', rules: 'required' },
    'claimantDetails.defendantName': { type: 'text', rules: 'required' }
};

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

var updateObject = function updateObject(dispatch, action, obj) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([]);
    }

    var proms = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return dispatch(action, { key: key, value: obj[key], index: index });
    });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms);
};

var throttleUpdateLife = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function (dispatch, getters, action, person, lifeExpectancy, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        if (lifeExpectancy.method == 'assumed_percentage_of_life') {
            lifeExpectancy.method = 'percentage_of_normal_life_expectancy';
        }

        if (lifeExpectancy.method == 'assumed_reduction_in_life') {
            lifeExpectancy.method = 'percentage_reduction_in_normal_life_expectancy';
        }

        var assumedSettlement = getters['lost/claimant/getClaimantInfoValue']('dateOfAssumedSettlement');

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return updateObject(dispatch, action, updatedLife, index);
        }).then(function () {
            return dispatch('updateReductionInLife');
        }).then(function () {
            if (state.theClaimant.income.futurePeriods.length) {
                dispatch('updateIncomePeriodValue', {
                    index: state.theClaimant.income.futurePeriods.length - 1,
                    key: 'endOfPeriod',
                    value: state.theClaimant.lifeExpectancy.dateOfDeath,
                    type: 'future'
                });
            }
        });
    }
}, 500);

var calcAssumedLifeExpectancy = function calcAssumedLifeExpectancy(_ref) {
    var state = _ref.state,
        assumedLifeExpectancy = _ref.assumedLifeExpectancy;

    if (assumedLifeExpectancy.ageAtDeath || assumedLifeExpectancy.dateOfDeath || assumedLifeExpectancy.yearsLeft || assumedLifeExpectancy.monthsLeft || assumedLifeExpectancy.percentageOfNormalLifeExpectancy !== null || assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy !== null) {
        switch (assumedLifeExpectancy.method) {
            case 'assumed_years_and_months_left':
                return {
                    method: 'assumed_years_and_months_left',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: __WEBPACK_IMPORTED_MODULE_10_moment___default()().add(assumedLifeExpectancy.yearsLeft, 'years').add(assumedLifeExpectancy.monthsLeft, 'months').format('DD/MM/YYYY'),
                    ageAtDeath: __WEBPACK_IMPORTED_MODULE_10_moment___default()().add(assumedLifeExpectancy.yearsLeft, 'years').add(assumedLifeExpectancy.monthsLeft, 'months').diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY'), 'days') / 365.25,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_date':
                return {
                    method: 'assumed_date',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: __WEBPACK_IMPORTED_MODULE_10_moment___default()(assumedLifeExpectancy.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY'), 'days') / 365.25,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_age_at_death':
                var assumedDateDiff = __WEBPACK_IMPORTED_MODULE_10_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY').add(assumedLifeExpectancy.ageAtDeath, 'years').diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(), 'months');

                return {
                    method: 'assumed_age_at_death',
                    yearsLeft: Math.floor(assumedDateDiff / 12),
                    monthsLeft: assumedDateDiff - Math.floor(assumedDateDiff / 12) * 12,
                    dateOfDeath: __WEBPACK_IMPORTED_MODULE_10_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY').add(assumedLifeExpectancy.ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_percentage_of_life':
                assumedLifeExpectancy.percentageOfNormalLifeExpectancy = assumedLifeExpectancy.percentageOfNormalLifeExpectancy || 0;

                return {
                    method: 'assumed_percentage_of_life',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: assumedLifeExpectancy.percentageOfNormalLifeExpectancy,
                    percentageReductionInNormalLifeExpectancy: 100 - assumedLifeExpectancy.percentageOfNormalLifeExpectancy
                };
            case 'assumed_reduction_in_life':
                assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy = assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy || 0;

                return {
                    method: 'assumed_reduction_in_life',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: 100 - assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy,
                    percentageReductionInNormalLifeExpectancy: assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy
                };
        }
    }

    return assumedLifeExpectancy;
};

var findNextPeriodStart = function findNextPeriodStart(periods, worseCase) {
    return periods.reduce(function (min, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(period.endOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(min) ? periodDate : min;
    }, __WEBPACK_IMPORTED_MODULE_10_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var findNextPeriodEnd = function findNextPeriodEnd(periods, worseCase) {
    return periods.reduce(function (max, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(max) ? periodDate : max;
    }, __WEBPACK_IMPORTED_MODULE_10_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var throttledIncome = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function (period, dispatch, action, args) {
    return __WEBPACK_IMPORTED_MODULE_8_services_Api__["a" /* default */].calculators.monetary.income(period, state.theClaimant).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {
                return dispatch(action, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key, value: updated[key] }, args));
            }
        });
    }, 500);
});

var getters = {
    claimant: function claimant(state) {
        return state.theClaimant;
    },
    getClaimantValue: function getClaimantValue(state) {
        return function (key) {
            return state.theClaimant[key];
        };
    },
    getClaimantDetail: function getClaimantDetail(state) {
        return function (key) {
            return state.claimantDetails[key];
        };
    },
    getClaimantInfoValue: function getClaimantInfoValue(state) {
        return function (key) {
            return state.claimInfo[key];
        };
    },
    getIncomeValue: function getIncomeValue(state) {
        return function (key) {
            return state.theClaimant.income[key];
        };
    },
    getIncomePeriod: function getIncomePeriod(state) {
        return function (_ref2) {
            var index = _ref2.index,
                type = _ref2.type;
            return state.theClaimant.income[type + 'Periods'][index];
        };
    },
    getAllFutureLossOfIncomeTotal: function getAllFutureLossOfIncomeTotal(state) {
        return state.theClaimant.income.futurePeriods.reduce(function (total, future) {
            return total + numberVal(future.totalNetIncome);
        }, 0);
    },
    getAllPastLossOfIncomeTotal: function getAllPastLossOfIncomeTotal(state) {
        return state.theClaimant.income.pastPeriods.reduce(function (total, past) {
            return total + numberVal(past.totalNetIncome);
        }, 0);
    },
    getIncomeStatus: function getIncomeStatus(state) {
        return state.updatingIncome;
    }
};

var actions = {
    save: function save(_ref3, payload) {
        var getters = _ref3.getters,
            dispatch = _ref3.dispatch;

        payload.data = state;

        return __WEBPACK_IMPORTED_MODULE_8_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref4, step) {
        var dispatch = _ref4.dispatch,
            action = _ref4.action,
            commit = _ref4.commit;

        var data = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.camelCase(key);
        }).data;
        var theClaimant = data.theClaimant;
        var claimantDetails = data.claimantDetails;
        var claimInfo = data.claimInfo;

        commit(mutationTypes.SET, { key: 'theClaimant', value: theClaimant });
        commit(mutationTypes.SET, { key: 'claimantDetails', value: claimantDetails });
        commit(mutationTypes.SET, { key: 'claimInfo', value: claimInfo });

        dispatch('updateOnsetAndAssumedDod');
        dispatch('updateReductionInLife');
    },
    process: function process(_ref5) {
        var commit = _ref5.commit,
            dispatch = _ref5.dispatch;
    },
    validate: function validate(_ref6) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            state = _ref6.state,
            rootState = _ref6.rootState;

        var updateRules = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.clone(rules);

        if (rootState.user.user.hideNames) {
            delete updateRules['theClaimant.name'];
        }
        dispatch('lost/step/setStepNumberValid', {
            stepNo: 0,
            valid: new __WEBPACK_IMPORTED_MODULE_11_services_Validator__["a" /* default */](state, updateRules).validate()
        }, { root: true });
    },
    reset: function reset(_ref7) {
        var commit = _ref7.commit,
            dispatch = _ref7.dispatch;

        dispatch('lost/step/setStepNumberValid', {
            stepNo: 0,
            valid: false
        }, { root: true });

        commit(mutationTypes.RESET);
    },
    resetFutureEmploymentIncome: function resetFutureEmploymentIncome(_ref8) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        state.theClaimant.income.futurePeriods.forEach(function (oldPeriod, index) {
            var period = oldPeriod;
            period.employmentIncome = 0;
            dispatch('updateIncomePeriod', { index: index, period: period, type: 'future' });
        });
    },
    updateClaimantValue: function updateClaimantValue(_ref9, _ref10) {
        var commit = _ref9.commit,
            dispatch = _ref9.dispatch;
        var key = _ref10.key,
            value = _ref10.value;

        commit(mutationTypes.UPDATE_CLAIMANT_VALUE, { key: key, value: value });

        if (key === 'dateOfBirth') {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([dispatch('updateLifeExpectancy', { lifeExpectancy: state.theClaimant.lifeExpectancy }), dispatch('updateRetirementAgeAndDate')]);
        }

        if (key === 'employedButFor') {
            return value ? commit(mutationTypes.RESET_EMPLOYED_INCOME) : commit(mutationTypes.RESET_PENSION_INCOME);
        }
    },
    updateClaimantDetail: function updateClaimantDetail(_ref11, _ref12) {
        var commit = _ref11.commit;
        var key = _ref12.key,
            value = _ref12.value;

        commit(mutationTypes.UPDATE_CLAIMANT_DETAIL, { key: key, value: value });
    },
    updateClaimantAssumedLifeExpectancy: function updateClaimantAssumedLifeExpectancy(_ref13, _ref14) {
        var dispatch = _ref13.dispatch,
            state = _ref13.state,
            rootGetters = _ref13.rootGetters;
        var assumedLifeExpectancy = _ref14.assumedLifeExpectancy;

        var assumedLifeExpectancyResult = calcAssumedLifeExpectancy({ state: state, assumedLifeExpectancy: assumedLifeExpectancy });

        return updateObject(dispatch, 'updateClaimantAssumedLifeExpectancyValue', assumedLifeExpectancyResult).then(function () {
            return throttleUpdateLife(dispatch, rootGetters, 'updateClaimantAssumedLifeExpectancyValue', state.theClaimant, assumedLifeExpectancyResult);
        });
    },
    updateClaimantAssumedLifeExpectancyValue: function updateClaimantAssumedLifeExpectancyValue(_ref15, _ref16) {
        var commit = _ref15.commit,
            state = _ref15.state,
            dispatch = _ref15.dispatch;
        var key = _ref16.key,
            value = _ref16.value;

        if (state.theClaimant.assumedLifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_LIFE_ASSUMED_EXPECTANCY, { key: key, value: value });
            dispatch('updateOnsetAndAssumedDod');
            dispatch('updateReductionInLife');
        }
    },
    updateOnsetAndAssumedDod: function updateOnsetAndAssumedDod(_ref17) {
        var state = _ref17.state,
            dispatch = _ref17.dispatch;

        if (state.theClaimant.assumedLifeExpectancy.dateOfDeath && state.theClaimant.onsetOfSymptoms) {
            var onsetAndAssumedDod = __WEBPACK_IMPORTED_MODULE_10_moment___default()(state.theClaimant.assumedLifeExpectancy.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(state.theClaimant.onsetOfSymptoms, 'DD/MM/YYYY'), 'days') / 365.25;
            dispatch('lost/claimInfo/updateClaimInfoValue', { key: 'periodBetweenOnsetAndAssumedDod', value: onsetAndAssumedDod }, { root: true });
        }
        dispatch('updateAgeAtOnset');
    },
    updateAgeAtOnset: function updateAgeAtOnset(_ref18) {
        var state = _ref18.state,
            commit = _ref18.commit;

        var ageAtOnset = __WEBPACK_IMPORTED_MODULE_10_moment___default()(state.theClaimant.onsetOfSymptoms, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY'), 'days') / 365.25;

        commit(mutationTypes.UPDATE_CLAIMANT_VALUE, { key: 'ageAtOnset', value: ageAtOnset });
    },
    updateReductionInLife: function updateReductionInLife(_ref19) {
        var state = _ref19.state,
            dispatch = _ref19.dispatch;

        if (state.theClaimant.assumedLifeExpectancy.ageAtDeath && state.theClaimant.lifeExpectancy.ageAtDeath) {
            var claimantReductionInLife = state.theClaimant.lifeExpectancy.ageAtDeath - state.theClaimant.assumedLifeExpectancy.ageAtDeath;
            dispatch('lost/claimInfo/updateClaimInfoValue', { key: 'claimantReductionInLife', value: claimantReductionInLife }, { root: true });
        }
    },
    updateLifeExpectancy: function updateLifeExpectancy(_ref20, _ref21) {
        var dispatch = _ref20.dispatch,
            state = _ref20.state,
            rootGetters = _ref20.rootGetters;
        var lifeExpectancy = _ref21.lifeExpectancy;

        return updateObject(dispatch, 'updateLifeExpectancyValue', lifeExpectancy).then(function () {
            return throttleUpdateLife(dispatch, rootGetters, 'updateLifeExpectancyValue', state.theClaimant, lifeExpectancy);
        });
    },
    updateLifeExpectancyValue: function updateLifeExpectancyValue(_ref22, _ref23) {
        var commit = _ref22.commit,
            state = _ref22.state;
        var key = _ref23.key,
            value = _ref23.value;

        if (state.theClaimant.lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_LIFE_EXPECTANCY, { key: key, value: value });
        }
    },
    updateClaimantIncome: function updateClaimantIncome(_ref24, _ref25) {
        var dispatch = _ref24.dispatch;
        var income = _ref25.income;

        return updateObject(dispatch, 'updateIncomeValue', income);
    },
    updateIncomeValue: function updateIncomeValue(_ref26, _ref27) {
        var commit = _ref26.commit,
            state = _ref26.state,
            dispatch = _ref26.dispatch;
        var key = _ref27.key,
            value = _ref27.value;

        if (state.theClaimant.income[key] !== value) {
            commit(mutationTypes.UPDATE_INCOME, { key: key, value: value });
        }

        if (key === 'contingencyMultiplier' || key === 'employedAtDateOfDeath') {
            return dispatch('calculateLossOfEarnings');
        }
    },

    calculateLossOfEarnings: __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function (_ref28) {
        var state = _ref28.state,
            dispatch = _ref28.dispatch;

        var claimant = state.theClaimant;

        if (!claimant.income.contingencyMultiplier || claimant.employedAtAccident === null || claimant.levelOfEducation === null || claimant.disabledAtAccident === null) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_8_services_Api__["a" /* default */].calculators.monetary.employmentContingencyDiscount({
            age: __WEBPACK_IMPORTED_MODULE_10_moment___default()(state.claimInfo.dateOfAssumedSettlement, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(claimant.dateOfBirth, 'DD/MM/YYYY'), 'years'),
            disabled: claimant.disabledAtAccident,
            employment: claimant.employedAtAccident ? 'employed' : 'notEmployed',
            education: claimant.levelOfEducation,
            gender: claimant.gender
        }).then(function (data) {
            dispatch('updateIncomeValue', { key: 'multiplier', value: data.multiplier });
        });
    }, 500),

    addIncomePeriod: function addIncomePeriod(_ref29, type) {
        var commit = _ref29.commit,
            state = _ref29.state;

        var periods = state.theClaimant.income[type + 'Periods'],
            start = findNextPeriodStart(periods, state.theClaimant.onsetOfSymptoms),
            end = findNextPeriodEnd(periods, state.theClaimant.assumedLifeExpectancy.dateOfDeath);

        if (__WEBPACK_IMPORTED_MODULE_10_moment___default()(start, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_10_moment___default()(end, 'DD/MM/YYYY'))) {
            start = end;
        }

        if (type === 'future') {
            start = findNextPeriodStart(periods, state.theClaimant.assumedLifeExpectancy.dateOfDeath);
            end = findNextPeriodEnd(periods, state.theClaimant.lifeExpectancy.dateOfDeath);
        }

        commit(mutationTypes.ADD_INCOME_PERIOD, {
            type: type, period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_store_modules_shared_templates__["a" /* defaultIncomePeriodTemplate */])({
                start: start,
                end: end
            })
        });
    },
    updateIncomePeriod: function updateIncomePeriod(_ref30, _ref31) {
        var commit = _ref30.commit,
            dispatch = _ref30.dispatch,
            state = _ref30.state;
        var index = _ref31.index,
            period = _ref31.period,
            type = _ref31.type;

        if (!state.updatingIncome) {
            commit(mutationTypes.UPDATING_INCOME_PERIOD);
        }

        var proms = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(period).map(function (key) {
            return dispatch('updateIncomePeriodValue', { type: type, key: key, value: period[key], index: index });
        });

        if (period.endOfPeriod === "" || period.endOfPeriod === null || period.startOfPeriod === "" || period.startOfPeriod === null || period.employmentIncome === "" || period.pensionIncome === "" || period.employmentIncome === null || period.pensionIncome === null) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms).then(function () {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([throttledIncome(period, dispatch, 'updateIncomePeriodValue', { index: index, type: type })]);
        }).then(function () {
            if (state.updatingIncome) {
                commit(mutationTypes.UPDATING_INCOME_PERIOD);
            }
        });
    },
    updateIncomePeriodValue: function updateIncomePeriodValue(_ref32, _ref33) {
        var commit = _ref32.commit,
            state = _ref32.state;
        var index = _ref33.index,
            key = _ref33.key,
            value = _ref33.value,
            type = _ref33.type;

        var currentPeriod = state.theClaimant.income[type + 'Periods'][index];
        if (currentPeriod[key] === value) {
            return;
        }
        commit(mutationTypes.UPDATE_INCOME_PERIOD, { index: index, key: key, value: value, type: type });
    },
    deleteIncomePeriod: function deleteIncomePeriod(_ref34, _ref35) {
        var commit = _ref34.commit,
            state = _ref34.state,
            dispatch = _ref34.dispatch;
        var index = _ref35.index,
            type = _ref35.type;

        commit(mutationTypes.DELETE_INCOME_PERIOD, { index: index, type: type });
        if (!state.theClaimant.income[type + 'Periods'].length) {
            return dispatch('addIncomePeriod', { type: type });
        }
    },

    updateRetirementAgeAndDate: __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function (_ref36) {
        var state = _ref36.state,
            commit = _ref36.commit,
            dispatch = _ref36.dispatch;

        if (!new __WEBPACK_IMPORTED_MODULE_11_services_Validator__["a" /* default */](state, { 'theClaimant.dateOfBirth': { type: 'date', rules: 'required' } }).validate()) {
            return;
        }

        if (state.theClaimant.income.retirementAgeCalc === 'auto') {
            var previousRetirementDate = state.theClaimant.income.retirementDate;
            return __WEBPACK_IMPORTED_MODULE_8_services_Api__["a" /* default */].calculators.dates.statePensionAge(state.theClaimant).then(function (data) {
                commit(mutationTypes.UPDATE_STATE_PENSION_AGE, {
                    key: 'retirementAge',
                    value: data.statePension.retirementAge
                });
                commit(mutationTypes.UPDATE_STATE_PENSION_AGE, {
                    key: 'retirementDate',
                    value: data.statePension.retirementDate
                });
                return dispatch('updateIncomePeriodForRetirementChange', previousRetirementDate);
            });
        }
    }, 500),
    updateIncomePeriodForRetirementChange: function updateIncomePeriodForRetirementChange(_ref37, previousRetirementDate) {
        var state = _ref37.state,
            commit = _ref37.commit;

        var retirementDate = state.theClaimant.income.retirementDate;
        var periods = state.theClaimant.income.futurePeriods;
        if (!periods.length) {
            return;
        }
        var end = periods[periods.length - 1].endOfPeriod;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_services_personFunctions__["c" /* splitPeriodsForRetirement */])(commit, mutationTypes.UPDATE_INCOME_PERIOD, mutationTypes.ADD_INCOME_PERIOD, previousRetirementDate, retirementDate, periods, end, false, 0, 'future');
    },
    updateClaimInfoValue: function updateClaimInfoValue(_ref38, _ref39) {
        var commit = _ref38.commit,
            dispatch = _ref38.dispatch,
            rootGetters = _ref38.rootGetters;
        var key = _ref39.key,
            value = _ref39.value;

        commit(mutationTypes.UPDATE_CLAIM_INFO_VALUE, { key: key, value: value });
        if (key === 'proceduralStatus') {
            return dispatch('lost/headsOfLoss/proceduralStatusChanges', value, { root: true });
        }
        if (key === "discountRate" && rootGetters['lost/step/valid'](3)) {
            dispatch('lost/lossOfIncome/refresh', value, { root: true });
        }
    },
    checkIncomePeriods: function checkIncomePeriods(_ref40) {
        var dispatch = _ref40.dispatch,
            getters = _ref40.getters;

        if (getters['getIncomePeriod']({ type: 'future', index: 0 })) {
            dispatch('updateIncomePeriodValue', {
                index: 0,
                key: 'startOfPeriod',
                value: state.theClaimant.assumedLifeExpectancy.dateOfDeath,
                type: 'future'
            });
        }

        if (getters['getClaimantValue']('income').pastPeriods.length) {
            dispatch('updateIncomePeriodValue', {
                index: getters['getClaimantValue']('income').pastPeriods.length - 1,
                key: 'endOfPeriod',
                value: state.theClaimant.assumedLifeExpectancy.dateOfDeath,
                type: 'past'
            });
        }
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_12_vue___default.a.set(state, payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIMANT_VALUE, function (state, payload) {
    state.theClaimant[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIMANT_DETAIL, function (state, payload) {
    state.claimantDetails[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIM_INFO_VALUE, function (state, payload) {
    state.claimInfo[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCOME, function (state, _ref41) {
    var key = _ref41.key,
        value = _ref41.value;

    state.theClaimant.income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LIFE_EXPECTANCY, function (state, _ref42) {
    var key = _ref42.key,
        value = _ref42.value;

    state.theClaimant.lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LIFE_ASSUMED_EXPECTANCY, function (state, _ref43) {
    var key = _ref43.key,
        value = _ref43.value;

    state.theClaimant.assumedLifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_INCOME_PERIOD, function (state, payload) {
    state.theClaimant.income[payload.type + 'Periods'].push(payload.period);
    state.theClaimant.income.netPensionIncome += payload.period.netPensionIncome;
    state.theClaimant.income.grossPensionIncome += payload.period.grossPensionIncome;
    state.theClaimant.income.netIncome += payload.period.netIncome;
    state.theClaimant.income.grossIncome += payload.period.grossIncome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCOME_PERIOD, function (state, _ref44) {
    var key = _ref44.key,
        value = _ref44.value,
        index = _ref44.index,
        type = _ref44.type;

    state.theClaimant.income[type + 'Periods'][index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_INCOME_PERIOD, function (state, payload) {
    state.theClaimant.income[payload.type + 'Periods'].splice(payload.index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.theClaimant = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_store_modules_shared_templates__["f" /* personTemplate */])();
    state.claimantDetails.diseaseOrAccident = null;
    state.claimantDetails.accidentType = null;
    state.claimantDetails.accidentTypeOther = '';
    state.claimantDetails.diseaseType = null;
    state.claimantDetails.diseaseTypeOther = '';
    state.claimantDetails.claimantReference = null;
    state.claimantDetails.yourReference = null;
    state.claimantDetails.claimNarrative = null;
    state.claimantDetails.defendantName.id = null;
    state.claimantDetails.defendantName.name = null;
    state.claimantDetails.defendantName.type = null;
    state.claimantDetails.claimantSolicitor.id = null;
    state.claimantDetails.claimantSolicitor.name = null;
    state.claimantDetails.claimantSolicitor.type = null;
    state.claimInfo.discountRate = -0.25;
    state.claimInfo.periodBetweenOnsetAndAssumedDod = 0;
    state.claimInfo.claimantReductionInLife = 0;
    state.claimInfo.proceduralStatus = 'pre-lit';
    state.claimInfo.dateOfIssueProceedings = null;
    state.claimInfo.dateOfServiceProceedings = null;
    state.claimInfo.dateOfAssumedSettlement = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_STATE_PENSION_AGE, function (state, _ref45) {
    var key = _ref45.key,
        value = _ref45.value;

    state.theClaimant.income[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_EMPLOYED_INCOME, function (state) {
    state.theClaimant.income.pastPeriods.map(function (period) {
        period.employmentIncome = 0;
        if (period.pensionNetGross === 'net') {
            period.totalNetIncome = period.pensionIncome;
        } else {
            period.totalGrossIncome = period.pensionIncome;
        }
        return period;
    });
    state.theClaimant.income.futurePeriods.map(function (period) {
        period.employmentIncome = 0;
        if (period.pensionNetGross === 'net') {
            period.totalNetIncome = period.pensionIncome;
        } else {
            period.totalGrossIncome = period.pensionIncome;
        }
        return period;
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_PENSION_INCOME, function (state) {
    state.theClaimant.income.pastPeriods.map(function (period) {
        period.pensionIncome = 0;
        if (period.employmentNetGross === 'net') {
            period.totalNetIncome = period.employmentIncome;
        } else {
            period.totalGrossIncome = period.employmentIncome;
        }
        return period;
    });
    state.theClaimant.income.futurePeriods.map(function (period) {
        period.pensionIncome = 0;
        if (period.employmentNetGross === 'net') {
            period.totalNetIncome = period.employmentIncome;
        } else {
            period.totalGrossIncome = period.employmentIncome;
        }
        return period;
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATING_INCOME_PERIOD, function (state) {
    state.updatingIncome = !state.updatingIncome;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_generators_step__ = __webpack_require__(21);



var _mutations;







var mutationTypes = {
    RESET: 'RESET',
    UPDATE_VALUE: 'UPDATE_VALUE',
    UPDATE_INCLUDE: 'UPDATE_INCLUDE',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER'
};

var cruTemplate = function cruTemplate() {
    return {
        value: 0,
        include: false
    };
};

var state = {
    gdPneumoconiosis: cruTemplate(),
    gdMesothelioma: cruTemplate(),
    ploeDisabilityWorkingAllowance: cruTemplate(),
    ploeEmploymentSupportAllowance: cruTemplate(),
    ploeIncapacityBenefit: cruTemplate(),
    ploeIncomeSupport: cruTemplate(),
    ploeIndustrialInjuriesDisablementBenefit: cruTemplate(),
    ploeInvalidityPension: cruTemplate(),
    ploeInvalidityAllowance: cruTemplate(),
    ploeJobseekersAllowance: cruTemplate(),
    ploeReducedEarningsAllowance: cruTemplate(),
    ploeSevereDisablementAllowance: cruTemplate(),
    ploeSicknessBenefit: cruTemplate(),
    ploeStatutorySickPay: cruTemplate(),
    ploeUnemployabilitySupplement: cruTemplate(),
    ploeUnemploymentBenefit: cruTemplate(),
    ploeUniversalCredit: cruTemplate(),
    pcocAttendanceAllowance: cruTemplate(),
    pcocDisabilityLivingAllowance: cruTemplate(),
    pcocIndustrialInjuriesDisablementBenefit: cruTemplate(),
    pcocPersonalIndependencePayment: cruTemplate(),
    pcotDisabilityLivingAllowance: cruTemplate(),
    pcotMobilityAllowance: cruTemplate(),
    pcotPersonalIndependencePayment: cruTemplate()
};

var rules = {};

var returnCruValue = function returnCruValue(cru) {
    if (cru.include) {
        return parseFloat(cru.value);
    }
    return 0;
};

var generalDamagesOffset = function generalDamagesOffset(state) {
    var cruTotal = returnCruValue(state.gdPneumoconiosis) + returnCruValue(state.gdMesothelioma);
    var gdHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['lost/headsOfLoss/getHeadsOfLossValue']('generalDamages');

    if (cruTotal >= gdHeadOfLoss) {
        return gdHeadOfLoss;
    }

    return cruTotal;
};

var pastLossOfEarningsOffset = function pastLossOfEarningsOffset(state) {
    var cruTotal = returnCruValue(state.ploeDisabilityWorkingAllowance) + returnCruValue(state.ploeEmploymentSupportAllowance) + returnCruValue(state.ploeIncapacityBenefit) + returnCruValue(state.ploeIncomeSupport) + returnCruValue(state.ploeIndustrialInjuriesDisablementBenefit) + returnCruValue(state.ploeInvalidityPension) + returnCruValue(state.ploeInvalidityAllowance) + returnCruValue(state.ploeJobseekersAllowance) + returnCruValue(state.ploeReducedEarningsAllowance) + returnCruValue(state.ploeSevereDisablementAllowance) + returnCruValue(state.ploeSicknessBenefit) + returnCruValue(state.ploeStatutorySickPay) + returnCruValue(state.ploeUnemployabilitySupplement) + returnCruValue(state.ploeUnemploymentBenefit) + returnCruValue(state.ploeUniversalCredit);

    var ploeHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['lost/headsOfLoss/getHeadsOfLossValue']('pastLossOfEarnings');

    if (cruTotal >= ploeHeadOfLoss) {
        return ploeHeadOfLoss;
    }

    return cruTotal;
};

var pastCostOfCareOffset = function pastCostOfCareOffset(state) {
    var cruTotal = returnCruValue(state.pcocAttendanceAllowance) + returnCruValue(state.pcocDisabilityLivingAllowance) + returnCruValue(state.pcocIndustrialInjuriesDisablementBenefit) + returnCruValue(state.pcocPersonalIndependencePayment);

    var pcocHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['lost/headsOfLoss/getHeadsOfLossValue']('pastCostOfCare');

    if (cruTotal >= pcocHeadOfLoss) {
        return pcocHeadOfLoss;
    }

    return cruTotal;
};

var pastCostOfTravelOffset = function pastCostOfTravelOffset(state) {
    var cruTotal = returnCruValue(state.pcotDisabilityLivingAllowance) + returnCruValue(state.pcotMobilityAllowance) + returnCruValue(state.pcotPersonalIndependencePayment);

    var pcotHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['lost/headsOfLoss/getHeadsOfLossValue']('pastCostOfTravel');

    if (cruTotal >= pcotHeadOfLoss) {
        return pcotHeadOfLoss;
    }

    return cruTotal;
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key].value;
        };
    },

    include: function include(state) {
        return function (key) {
            return state[key].include;
        };
    },

    allValid: function allValid(state) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).reduce(function (valid, benefit) {
            return !valid ? valid : !(state[benefit].include && state[benefit].value <= 0);
        }, true);
    },

    all: function all(state) {
        return state;
    },
    gdPneumoconiosis: function gdPneumoconiosis(state) {
        return state.gdPneumoconiosis;
    },
    gdMesothelioma: function gdMesothelioma(state) {
        return state.gdMesothelioma;
    },
    ploeDisabilityWorkingAllowance: function ploeDisabilityWorkingAllowance(state) {
        return state.ploeDisabilityWorkingAllowance;
    },
    ploeEmploymentSupportAllowance: function ploeEmploymentSupportAllowance(state) {
        return state.ploeEmploymentSupportAllowance;
    },
    ploeIncapacityBenefit: function ploeIncapacityBenefit(state) {
        return state.ploeIncapacityBenefit;
    },
    ploeIncomeSupport: function ploeIncomeSupport(state) {
        return state.ploeIncomeSupport;
    },
    ploeIndustrialInjuriesDisablementBenefit: function ploeIndustrialInjuriesDisablementBenefit(state) {
        return state.ploeIndustrialInjuriesDisablementBenefit;
    },
    ploeInvalidityPension: function ploeInvalidityPension(state) {
        return state.ploeInvalidityPension;
    },
    ploeInvalidityAllowance: function ploeInvalidityAllowance(state) {
        return state.ploeInvalidityAllowance;
    },
    ploeJobseekersAllowance: function ploeJobseekersAllowance(state) {
        return state.ploeJobseekersAllowance;
    },
    ploeReducedEarningsAllowance: function ploeReducedEarningsAllowance(state) {
        return state.ploeReducedEarningsAllowance;
    },
    ploeSevereDisablementAllowance: function ploeSevereDisablementAllowance(state) {
        return state.ploeSevereDisablementAllowance;
    },
    ploeSicknessBenefit: function ploeSicknessBenefit(state) {
        return state.ploeSicknessBenefit;
    },
    ploeStatutorySickPay: function ploeStatutorySickPay(state) {
        return state.ploeStatutorySickPay;
    },
    ploeUnemployabilitySupplement: function ploeUnemployabilitySupplement(state) {
        return state.ploeUnemployabilitySupplement;
    },
    ploeUnemploymentBenefit: function ploeUnemploymentBenefit(state) {
        return state.ploeUnemploymentBenefit;
    },
    ploeUniversalCredit: function ploeUniversalCredit(state) {
        return state.ploeUniversalCredit;
    },
    pcocAttendanceAllowance: function pcocAttendanceAllowance(state) {
        return state.pcocAttendanceAllowance;
    },
    pcocDisabilityLivingAllowance: function pcocDisabilityLivingAllowance(state) {
        return state.pcocDisabilityLivingAllowance;
    },
    pcocIndustrialInjuriesDisablementBenefit: function pcocIndustrialInjuriesDisablementBenefit(state) {
        return state.pcocIndustrialInjuriesDisablementBenefit;
    },
    pcocPersonalIndependencePayment: function pcocPersonalIndependencePayment(state) {
        return state.pcocPersonalIndependencePayment;
    },
    pcotDisabilityLivingAllowance: function pcotDisabilityLivingAllowance(state) {
        return state.pcotDisabilityLivingAllowance;
    },
    pcotMobilityAllowance: function pcotMobilityAllowance(state) {
        return state.pcotMobilityAllowance;
    },
    pcotPersonalIndependencePayment: function pcotPersonalIndependencePayment(state) {
        return state.pcotPersonalIndependencePayment;
    },
    getGeneralDamagesOffset: function getGeneralDamagesOffset(state) {
        return generalDamagesOffset(state);
    },
    getPastLossOfEarningsOffset: function getPastLossOfEarningsOffset(state) {
        return pastLossOfEarningsOffset(state);
    },
    getPastCostOfCareOffset: function getPastCostOfCareOffset(state) {
        return pastCostOfCareOffset(state);
    },
    getPastCostOfTravelOffset: function getPastCostOfTravelOffset(state) {
        return pastCostOfTravelOffset(state);
    }
};

var actions = {
    save: function save(_ref, payload) {
        var state = _ref.state,
            getters = _ref.getters,
            dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.UPDATE_FROM_SERVER, { data: data });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 5,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_store_generators_step__["a" /* previousValid */])(rootState, 5) && new __WEBPACK_IMPORTED_MODULE_5_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 5,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    updateValue: function updateValue(_ref6, _ref7) {
        var commit = _ref6.commit,
            state = _ref6.state,
            dispatch = _ref6.dispatch;
        var key = _ref7.key,
            value = _ref7.value;

        if (!~key.indexOf('Toggle') !== true) {
            return dispatch('updateInclude', { key: key, value: !!value });
        }

        if (state[key].value !== value) {
            return commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
        }
        return value;
    },
    updateInclude: function updateInclude(_ref8, _ref9) {
        var commit = _ref8.commit,
            state = _ref8.state;
        var key = _ref9.key,
            value = _ref9.value;

        var stateField = !~key.indexOf('Toggle') ? key : key.replace('Toggle', '');
        if (state[stateField].include !== value) {
            return commit(mutationTypes.UPDATE_INCLUDE, { key: stateField, value: value });
        }
        return value;
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, _ref10) {
    var key = _ref10.key,
        value = _ref10.value;

    state[key].value = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCLUDE, function (state, _ref11) {
    var key = _ref11.key,
        value = _ref11.value;

    state[key].include = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref12) {
    var data = _ref12.data;

    state.gdPneumoconiosis = data.gdPneumoconiosis || cruTemplate();
    state.gdMesothelioma = data.gdMesothelioma || cruTemplate();
    state.ploeDisabilityWorkingAllowance = data.ploeDisabilityWorkingAllowance || cruTemplate();
    state.ploeEmploymentSupportAllowance = data.ploeEmploymentSupportAllowance || cruTemplate();
    state.ploeIncapacityBenefit = data.ploeIncapacityBenefit || cruTemplate();
    state.ploeIncomeSupport = data.ploeIncomeSupport || cruTemplate();
    state.ploeIndustrialInjuriesDisablementBenefit = data.ploeIndustrialInjuriesDisablementBenefit || cruTemplate();
    state.ploeInvalidityPension = data.ploeInvalidityPension || cruTemplate();
    state.ploeInvalidityAllowance = data.ploeInvalidityAllowance || cruTemplate();
    state.ploeJobseekersAllowance = data.ploeJobseekersAllowance || cruTemplate();
    state.ploeReducedEarningsAllowance = data.ploeReducedEarningsAllowance || cruTemplate();
    state.ploeSevereDisablementAllowance = data.ploeSevereDisablementAllowance || cruTemplate();
    state.ploeSicknessBenefit = data.ploeSicknessBenefit || cruTemplate();
    state.ploeStatutorySickPay = data.ploeStatutorySickPay || cruTemplate();
    state.ploeUnemployabilitySupplement = data.ploeUnemployabilitySupplement || cruTemplate();
    state.ploeUnemploymentBenefit = data.ploeUnemploymentBenefit || cruTemplate();
    state.ploeUniversalCredit = data.ploeUniversalCredit || cruTemplate();
    state.pcocAttendanceAllowance = data.pcocAttendanceAllowance || cruTemplate();
    state.pcocDisabilityLivingAllowance = data.pcocDisabilityLivingAllowance || cruTemplate();
    state.pcocIndustrialInjuriesDisablementBenefit = data.pcocIndustrialInjuriesDisablementBenefit || cruTemplate();
    state.pcocPersonalIndependencePayment = data.pcocPersonalIndependencePayment || cruTemplate();
    state.pcotDisabilityLivingAllowance = data.pcotDisabilityLivingAllowance || cruTemplate();
    state.pcotMobilityAllowance = data.pcotMobilityAllowance || cruTemplate();
    state.pcotPersonalIndependencePayment = data.pcotPersonalIndependencePayment || cruTemplate();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
        state[key] = cruTemplate();
    });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_generators_step__ = __webpack_require__(21);



var _mutations;











var mutationTypes = {
    SET: 'SET',
    RESET: 'RESET',
    UPDATE_HEADS_OF_LOSS_VALUE: 'UPDATE_HEADS_OF_LOSS_VALUE',
    UPDATE_CARE_VALUE: 'UPDATE_CARE_VALUE',
    ADD_CUSTOM_HEAD_OF_LOSS: 'ADD_CUSTOM_HEAD_OF_LOSS',
    UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE: 'UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE',
    DELETE_CUSTOM_HEAD_OF_LOSS: 'DELETE_CUSTOM_HEAD_OF_LOSS',
    ADD_CARE_PERIOD: 'ADD_CARE_PERIOD',
    DELETE_CARE_PERIOD: 'DELETE_CARE_PERIOD',
    UPDATE_CARE_PERIOD_VALUE: 'UPDATE_CARE_PERIOD_VALUE',
    UPDATE_INTEREST_VALUE: 'UPDATE_INTEREST_VALUE',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    CLEAR_INTEREST: 'CLEAR_INTEREST'
};

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

var calcHeadsOfLossTotal = function calcHeadsOfLossTotal() {
    var customHeadsOfLossTotal = state.customHeadsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.value);
    }, 0);
    var customHeadsOfLossTotalWithInterest = state.customHeadsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.withInterest);
    }, 0);
    var total = [state.generalDamages, state.generalDamagesWithInterest, state.pastCostOfCare, state.pastCostOfCareWithInterest, state.pastCostOfTravel, state.pastCostOfTravelWithInterest, state.pastLossOfEarnings, state.pastLossOfEarningsWithInterest, state.futureCostOfCare, state.futureCostOfCareWithInterest, state.pastDependencyOnServices, state.pastDependencyOnServicesWithInterest, state.futureDependencyOnServices, state.misc, state.miscWithInterest, customHeadsOfLossTotal, customHeadsOfLossTotalWithInterest].reduce(function (total, value) {
        return total + parseFloat(value, 10);
    }, 0);

    return numberVal(total).toFixed(2);
};

var calcHeadsOfLossTotalMinusInterest = function calcHeadsOfLossTotalMinusInterest() {
    var customHeadsOfLossTotal = state.customHeadsOfLoss.reduce(function (total, customHeadsOfLoss) {
        return total + numberVal(customHeadsOfLoss.value);
    }, 0);

    var total = [state.generalDamages, state.pastCostOfCare, state.pastCostOfTravel, state.pastLossOfEarnings, state.futureCostOfCare, state.pastDependencyOnServices, state.futureDependencyOnServices, state.misc, customHeadsOfLossTotal].reduce(function (total, value) {
        return total + parseFloat(value, 10);
    }, 0);

    return numberVal(total).toFixed(2);
};

var modalPayload = function modalPayload() {
    return {
        interimPayments: __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/interimPayments/interimPayments'],
        assumedSettlement: __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantInfoValue']('dateOfAssumedSettlement'),
        serviceOfProceedings: __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantInfoValue']('dateOfServiceProceedings'),
        onsetOfSymptoms: __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantValue']('onsetOfSymptoms'),
        assumedLifeExpectancy: __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantValue']('assumedLifeExpectancy'),
        deductibles: __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/cruBenefits/all'],
        headsOfLoss: state,
        headOfLoss: {}
    };
};

var state = {
    generalDamages: 0,
    pastCostOfTravel: 0,
    pastLossOfEarnings: 0,
    pastCostOfCare: 0,
    futureCostOfCare: 0,
    pastDependencyOnServices: 0,
    futureDependencyOnServices: 0,
    misc: 0,
    generalDamagesWithInterest: 0,
    pastCostOfTravelWithInterest: 0,
    pastCostOfCareWithInterest: 0,
    futureCostOfCareWithInterest: 0,
    pastDependencyOnServicesWithInterest: 0,
    miscWithInterest: 0,
    pastLossOfEarningsWithInterest: 0,
    generalDamagesInterest: 2.00,
    pastCostOfTravelInterest: 0.5,
    miscInterest: 0.5,
    pastCostOfCareInterest: 0.5,
    futureCostOfCareInterest: 0.5,
    pastLossOfEarningsInterest: 0.5,
    pastDependencyOnServicesInterest: 0.5,
    customHeadsOfLoss: [],
    care: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_modules_shared_templates__["c" /* careTemplate */])(),
    interestType: 'today',
    customInterestDate: ''
};

var rules = {};

var getters = {
    getAll: function getAll(state) {
        return state;
    },
    getModalPayload: function getModalPayload(state) {
        return modalPayload();
    },
    getHeadsOfLossValue: function getHeadsOfLossValue(state) {
        return function (key) {
            return state[key];
        };
    },
    getHeadsOfLossTotal: function getHeadsOfLossTotal(state) {
        return calcHeadsOfLossTotal();
    },
    getCareValue: function getCareValue(state) {
        return function (key) {
            return state.care[key];
        };
    },
    getAllCareValue: function getAllCareValue(state) {
        return state.care.past.totalValue + state.care.future.totalValue;
    },
    getCustomHeadOfLoss: function getCustomHeadOfLoss(state) {
        return function (index) {
            return state.customHeadsOfLoss[index];
        };
    },
    getAllCustomHeadOfLoss: function getAllCustomHeadOfLoss(state) {
        return state.customHeadsOfLoss;
    },
    getAllCustomHeadOfLossTotal: function getAllCustomHeadOfLossTotal(state) {
        return state.customHeadsOfLoss.reduce(function (total, customHeadsOfLoss) {
            return total + numberVal(customHeadsOfLoss.value);
        }, 0);
    },
    getAllCustomHeadOfLossInterestTotal: function getAllCustomHeadOfLossInterestTotal(state) {
        return state.customHeadsOfLoss.reduce(function (total, customHeadsOfLoss) {
            return total + numberVal(customHeadsOfLoss.interestAccrued);
        }, 0);
    },
    getHeadsOfLossTotalMinusInterest: function getHeadsOfLossTotalMinusInterest(state) {
        return calcHeadsOfLossTotalMinusInterest();
    },
    allHeadsOfLossValid: function allHeadsOfLossValid(state) {
        return state.customHeadsOfLoss.reduce(function (valid, headOfLoss) {
            return !valid ? valid : headOfLoss.name !== '' && headOfLoss.value > 0;
        }, true);
    },
    getCarePeriod: function getCarePeriod(state) {
        return function (type, index) {
            return state.care[type].periods[index];
        };
    },
    allCarePeriodsValid: function allCarePeriodsValid(state) {
        return function (type) {
            return state.care[type].periods.reduce(function (valid, period) {
                if (!valid) {
                    return valid;
                }
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(period.periodStart, 'DD/MM/YYYY').isValid() && __WEBPACK_IMPORTED_MODULE_4_moment___default()(period.periodEnd, 'DD/MM/YYYY').isValid() && period.hoursPerDay > 0;
            }, true);
        };
    },
    interestDate: function interestDate(state) {
        switch (true) {
            case state.interestType === 'today':
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('DD/MM/YYYY');
                break;
            case state.interestType === 'assumed_settlement':
                return __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantInfoValue']('dateOfAssumedSettlement');
                break;
            case state.interestType === 'custom':
                return state.customInterestDate;
                break;
        }
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;

        var care = data.care;
        var customHeadOfLoss = data.customHeadOfLoss;

        commit(mutationTypes.SET, { key: 'care', value: care });
        commit(mutationTypes.SET, { key: 'customHeadOfLoss', value: customHeadOfLoss });
        commit(mutationTypes.UPDATE_FROM_SERVER, { data: data });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 4,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_generators_step__["a" /* previousValid */])(rootState, 4) && new __WEBPACK_IMPORTED_MODULE_9_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 4,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    setHeadsOfLossValue: function setHeadsOfLossValue(_ref6, _ref7) {
        var commit = _ref6.commit;
        var key = _ref7.key,
            value = _ref7.value;

        commit(mutationTypes.UPDATE_HEADS_OF_LOSS_VALUE, { key: key, value: value });
    },
    setCareValue: function setCareValue(_ref8, _ref9) {
        var commit = _ref8.commit;
        var key = _ref9.key,
            value = _ref9.value,
            type = _ref9.type;

        commit(mutationTypes.UPDATE_CARE_VALUE, { key: key, value: value, type: type });

        if (type) {
            commit(mutationTypes.UPDATE_INTEREST_VALUE, { key: type + 'CostOfCare', value: numberVal(value) });
        }
    },
    addCustomHeadOfLoss: function addCustomHeadOfLoss(_ref10) {
        var commit = _ref10.commit;

        commit(mutationTypes.ADD_CUSTOM_HEAD_OF_LOSS);
    },
    setCustomHeadOfLossValue: function setCustomHeadOfLossValue(_ref11, _ref12) {
        var commit = _ref11.commit,
            state = _ref11.state,
            dispatch = _ref11.dispatch;
        var key = _ref12.key,
            value = _ref12.value,
            index = _ref12.index;

        if (state.customHeadsOfLoss[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
        return value;
    },
    deleteCustomHeadOfLoss: function deleteCustomHeadOfLoss(_ref13, index) {
        var commit = _ref13.commit;

        commit(mutationTypes.DELETE_CUSTOM_HEAD_OF_LOSS, index);
    },

    autoCalculateCare: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref14, value) {
        var commit = _ref14.commit,
            dispatch = _ref14.dispatch;

        commit(mutationTypes.UPDATE_CARE_VALUE, { key: 'periods', value: [] });
        commit(mutationTypes.UPDATE_CARE_VALUE, { key: 'ownCareFigure', value: 0 });
        return __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].calculators.monetary.autoCalculateCare(false).then(function (care) {
            return dispatch('setCareValue', { key: 'totalValue', value: care.value, type: 'past' });
        });
    }, 500),

    addCarePeriod: function addCarePeriod(_ref15, type) {
        var commit = _ref15.commit;

        commit(mutationTypes.ADD_CARE_PERIOD, type);
    },
    updateCarePeriodValue: function updateCarePeriodValue(_ref16, _ref17) {
        var commit = _ref16.commit,
            state = _ref16.state;
        var key = _ref17.key,
            value = _ref17.value,
            index = _ref17.index,
            type = _ref17.type;

        if (key === 'hoursPerDay' && value > 24) {
            value = 24;
        }

        if (state.care[type].periods[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_CARE_PERIOD_VALUE, { key: key, value: value, index: index, type: type });
        return value;
    },
    updateCarePeriod: function updateCarePeriod(_ref18, _ref19) {
        var dispatch = _ref18.dispatch,
            commit = _ref18.commit;
        var care = _ref19.care,
            index = _ref19.index,
            type = _ref19.type;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(care[0]).forEach(function (key) {
            var value = care[0][key];
            commit(mutationTypes.UPDATE_CARE_PERIOD_VALUE, { key: key, value: value, index: index, type: type });
        });
        dispatch('updateCareTotal', type);
    },
    deleteCarePeriod: function deleteCarePeriod(_ref20, _ref21) {
        var commit = _ref20.commit,
            dispatch = _ref20.dispatch,
            state = _ref20.state;
        var index = _ref21.index,
            type = _ref21.type;

        commit(mutationTypes.DELETE_CARE_PERIOD, { index: index, type: type });
        if (state.care[type].periods.length === 0) {
            dispatch('addCarePeriod', type);
        }
        return dispatch('updateCareTotal', type);
    },
    updateCareTotal: function updateCareTotal(_ref22, type) {
        var commit = _ref22.commit,
            state = _ref22.state;

        var value = state.care[type].periods.reduce(function (total, period) {
            return total + numberVal(period.total);
        }, 0);
        commit(mutationTypes.UPDATE_CARE_VALUE, { key: 'totalValue', value: numberVal(value), type: type });
        commit(mutationTypes.UPDATE_INTEREST_VALUE, { key: type + 'CostOfCare', value: numberVal(value) });
    },

    calcCareTotalForPeriod: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref23, _ref24) {
        var dispatch = _ref23.dispatch,
            state = _ref23.state;
        var index = _ref24.index,
            type = _ref24.type;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.care[type].periods[index].periodStart) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_components_form_validator_validations__["a" /* validDate */])(state.care[type].periods[index].periodEnd) && state.care[type].periods[index].hoursPerDay > 0) {
            return __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].calculators.monetary.detailedCare([state.care[type].periods[index]], state.care[type].periods[index].gratuitousCare).then(function (care) {
                return dispatch('updateCarePeriod', { care: care, index: index, type: type });
            });
        }
    }, 500),

    calcAllInterest: function calcAllInterest(_ref25) {
        var dispatch = _ref25.dispatch,
            state = _ref25.state;

        if (state.interestType === 'none') {
            dispatch('clearInterest');return;
        }
        if (state.interestType === 'custom' && state.customInterestDate === '') {
            return;
        }

        var value = __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getAllPastLossOfIncomeTotal'];
        dispatch('setHeadsOfLossValue', { key: 'pastLossOfEarnings', value: value });

        return __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].calculators.monetary.interest(__WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantInfoValue']('proceduralStatus'), __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantInfoValue']('dateOfAssumedSettlement'), __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantInfoValue']('dateOfServiceProceedings'), __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantValue']('onsetOfSymptoms'), __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantValue']('assumedLifeExpectancy'), __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/cruBenefits/all'], state, __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/interimPayments/interimPayments'], __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/lossOfIncome/pastLossTotal']).then(function (data) {
            return dispatch('updateInterestValues', data);
        });
    },
    clearInterest: function clearInterest(_ref26) {
        var commit = _ref26.commit,
            state = _ref26.state;

        state.customHeadsOfLoss.forEach(function (item, key) {
            commit(mutationTypes.UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE, { key: 'interestAccrued', value: 0, index: key });
        });

        commit(mutationTypes.CLEAR_INTEREST);
    },
    updateInterestValues: function updateInterestValues(_ref27, data) {
        var commit = _ref27.commit,
            dispatch = _ref27.dispatch;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
            if (key.includes("custom_")) {
                commit(mutationTypes.UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE, {
                    key: data[key]['key'],
                    value: data[key]['value'],
                    index: data[key]['index']
                });
            }
            commit(mutationTypes.UPDATE_INTEREST_VALUE, { key: key + 'WithInterest', value: data[key] });
        });
    },

    calcCustomInterest: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (_ref28) {
        var dispatch = _ref28.dispatch,
            state = _ref28.state;

        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantInfoValue']('dateOfAssumedSettlement');
        var onsetOfSymptoms = __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['lost/claimant/getClaimantValue']('onsetOfSymptoms');

        return __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].calculators.monetary.customInterest(assumedSettlement, onsetOfSymptoms, state).then(function (data) {
            return dispatch('updateCustomHeadsOfLossInterestValue', data);
        }).then(function () {
            return dispatch('forceSave');
        });
    }, 500),

    updateCustomHeadsOfLossInterestValue: function updateCustomHeadsOfLossInterestValue(_ref29, data) {
        var commit = _ref29.commit,
            dispatch = _ref29.dispatch;

        data.map(function (obj, index) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
                var value = obj[key];
                commit(mutationTypes.UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
            });
        });
    },
    forceSave: function forceSave(_ref30) {
        var dispatch = _ref30.dispatch;

        var payload = {
            claim_type: 'lost_years',
            claim_id: __WEBPACK_IMPORTED_MODULE_6_store_index__["a" /* default */].getters['claim/id'],
            step_number: 4,
            data: {}
        };

        dispatch('save', payload);
    },
    proceduralStatusChanges: function proceduralStatusChanges(_ref31, status) {
        var commit = _ref31.commit;

        if (status === "litigated") {
            commit(mutationTypes.UPDATE_INTEREST_VALUE, { key: 'generalDamagesInterest', value: 2 });
        } else {
            commit(mutationTypes.UPDATE_INTEREST_VALUE, { key: 'generalDamagesInterest', value: 0 });
        }
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_HEADS_OF_LOSS_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INTEREST_VALUE, function (state, _ref32) {
    var key = _ref32.key,
        value = _ref32.value;

    state[key] = numberVal(value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CARE_VALUE, function (state, payload) {
    if (!payload.type) {
        state.care[payload.key] = payload.value;
        return;
    }
    state.care[payload.type][payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_CUSTOM_HEAD_OF_LOSS, function (state) {
    state.customHeadsOfLoss.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_modules_shared_templates__["d" /* customHeadsOfLossTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE, function (state, _ref33) {
    var key = _ref33.key,
        value = _ref33.value,
        index = _ref33.index;

    state.customHeadsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_CUSTOM_HEAD_OF_LOSS, function (state, index) {
    if (index === 0 && state.customHeadsOfLoss.length === 1) {
        state.customHeadsOfLoss = [];
    }
    state.customHeadsOfLoss.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_CARE_PERIOD, function (state, type) {
    state.care[type].periods.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_modules_shared_templates__["e" /* carePeriodTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_CARE_PERIOD, function (state, _ref34) {
    var index = _ref34.index,
        type = _ref34.type;

    state.care[type].periods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CARE_PERIOD_VALUE, function (state, _ref35) {
    var key = _ref35.key,
        value = _ref35.value,
        index = _ref35.index,
        type = _ref35.type;

    state.care[type].periods[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_2_vue___default.a.set(state, payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref36) {
    var data = _ref36.data;

    state.generalDamages = data.generalDamages;
    state.pastCostOfTravel = data.pastCostOfTravel;
    state.pastLossOfEarnings = data.pastLossOfEarnings;
    state.pastDependencyOnServices = data.pastDependencyOnServices;
    state.futureDependencyOnServices = data.futureDependencyOnServices;
    state.pastCostOfCare = data.pastCostOfCare;
    state.futureCostOfCare = data.futureCostOfCare;
    state.misc = data.misc;
    state.generalDamagesWithInterest = data.generalDamagesWithInterest;
    state.pastCostOfTravelWithInterest = data.pastCostOfTravelWithInterest;
    state.pastCostOfCareWithInterest = data.pastCostOfCareWithInterest;
    state.futureCostOfCareWithInterest = data.futureCostOfCareWithInterest;
    state.pastDependencyOnServicesWithInterest = data.pastDependencyOnServicesWithInterest;
    state.miscWithInterest = data.miscWithInterest;
    state.pastLossOfEarningsWithInterest = data.pastLossOfEarningsWithInterest;
    state.generalDamagesInterest = data.generalDamagesInterest;
    state.pastCostOfTravelInterest = data.pastCostOfTravelInterest;
    state.miscInterest = data.miscInterest;
    state.pastCostOfCareInterest = data.pastCostOfCareInterest;
    state.futureCostOfCareInterest = data.futureCostOfCareInterest;
    state.pastLossOfEarningsInterest = data.pastLossOfEarningsInterest;
    state.customHeadsOfLoss = data.customHeadsOfLoss;
    state.care = data.care;
    state.interestType = data.interestType;
    state.customInterestDate = data.customInterestDate;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.generalDamages = 0;
    state.pastCostOfTravel = 0;
    state.pastLossOfEarnings = 0;
    state.pastCostOfCare = 0;
    state.futureCostOfCare = 0;
    state.pastDependencyOnServices = 0;
    state.futureDependencyOnServices = 0;
    state.misc = 0;
    state.generalDamagesWithInterest = 0;
    state.pastCostOfTravelWithInterest = 0;
    state.pastCostOfCareWithInterest = 0;
    state.futureCostOfCareWithInterest = 0;
    state.pastDependencyOnServicesWithInterest = 0;
    state.miscWithInterest = 0;
    state.pastLossOfEarningsWithInterest = 0;
    state.generalDamagesInterest = 2.00;
    state.pastCostOfTravelInterest = 0.5;
    state.miscInterest = 0.5;
    state.pastCostOfCareInterest = 0.5;
    state.futureCostOfCareInterest = 0.5;
    state.pastLossOfEarningsInterest = 0.5;
    state.pastDependencyOnServicesInterest = 0.5;
    state.customHeadsOfLoss = [];
    state.care = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_modules_shared_templates__["c" /* careTemplate */])();
    state.interestType = 'today';
    state.customInterestDate = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CLEAR_INTEREST, function (state) {
    state.generalDamagesWithInterest = 0;
    state.pastCostOfTravelWithInterest = 0;
    state.pastCostOfCareWithInterest = 0;
    state.futureCostOfCareWithInterest = 0;
    state.pastDependencyOnServicesWithInterest = 0;
    state.miscWithInterest = 0;
    state.pastLossOfEarningsWithInterest = 0;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_generators_step__ = __webpack_require__(21);







var mutationTypes = {
    RESET: 'RESET'
};

var state = {};

var rules = {};

var rootRules = {
    'lost.claimant.theClaimant.income.retirementAge': { type: 'number', rules: 'required|min:18' },
    'lost.claimant.theClaimant.income.retirementDate': { type: 'date', rules: 'required' }
};

var getters = {};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        payload.data = state;
        payload.data.retirement_date = rootState.lost.claimant.theClaimant.income.retirementDate;
        payload.data.assumed_date_of_death = rootState.lost.claimant.theClaimant.assumedLifeExpectancy.dateOfDeath;

        __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('lost/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_modules_claim__["d" /* requestPayload */])(0));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 2,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 2) && new __WEBPACK_IMPORTED_MODULE_4_services_Validator__["a" /* default */](rootState, rootRules).validate() && new __WEBPACK_IMPORTED_MODULE_4_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 2,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.RESET, function (state) {});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_modules_claim__ = __webpack_require__(29);


var _mutations;














var mutationTypes = {
    ADD_INTERIM_PAYMENT: 'ADD_INTERIM_PAYMENT',
    UPDATE_INTERIM_PAYMENT: 'UPDATE_INTERIM_PAYMENT',
    DELETE_INTERIM_PAYMENT: 'DELETE_INTERIM_PAYMENT',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    RESET: 'RESET',
    SET: 'SET'
};

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

var state = {
    payments: []
};

var rules = {};

var getters = {
    interimPayments: function interimPayments(state) {
        return state.payments;
    },
    findPayment: function findPayment(state) {
        return function (index) {
            return state.payments[index];
        };
    },
    getAllInterimPaymentsTotal: function getAllInterimPaymentsTotal(state) {
        return state.payments.reduce(function (total, interimPayment) {
            return total + numberVal(interimPayment.value);
        }, 0);
    },
    allInterimPaymentsValid: function allInterimPaymentsValid(state) {
        var maxDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(__WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['lost/headsOfLoss/interestDate'], 'DD/MM/YYYY');
        return state.payments.reduce(function (valid, payment) {
            var mPaymentDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(payment.date, 'DD/MM/YYYY');
            return !valid ? valid : mPaymentDate.isValid() && payment.value > 0 && mPaymentDate.isBefore(maxDate);
        }, true);
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('lost/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_claim__["d" /* requestPayload */])(4));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.SET, { key: 'payments', value: data.payments });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 6,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_store_generators_step__["a" /* previousValid */])(rootState, 6) && new __WEBPACK_IMPORTED_MODULE_10_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 6,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    addPayment: function addPayment(_ref6) {
        var commit = _ref6.commit;

        commit(mutationTypes.ADD_INTERIM_PAYMENT);
    },
    deletePayment: function deletePayment(_ref7, index) {
        var commit = _ref7.commit;

        commit(mutationTypes.DELETE_INTERIM_PAYMENT, index);
    },
    updatePayment: function updatePayment(_ref8, _ref9) {
        var commit = _ref8.commit,
            state = _ref8.state;
        var key = _ref9.key,
            value = _ref9.value,
            index = _ref9.index;

        if (state.payments[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_INTERIM_PAYMENT, { key: key, value: value, index: index });
        return value;
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.payments = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_INTERIM_PAYMENT, function (state) {
    state.payments.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_store_modules_shared_templates__["b" /* paymentsTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_INTERIM_PAYMENT, function (state, index) {
    if (index === 0 && state.payments.length === 1) {
        state.payments = [];
    }
    state.payments.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INTERIM_PAYMENT, function (state, _ref10) {
    var key = _ref10.key,
        value = _ref10.value,
        index = _ref10.index;

    state.payments[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_9_vue___default.a.set(state, payload.key, payload.value);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_generators_step__ = __webpack_require__(21);


var _mutations;







var mutationTypes = {
    RESET: 'RESET',
    UPDATE_DATA: 'UPDATE_DATA',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    UPDATING_STATUS: 'UPDATING_STATUS'
};

var state = {
    pastLossPeriods: null,
    pastLossDuration: null,
    pastLossMultiplier: null,
    pastLossTotal: null,
    futureLossPeriods: null,
    futureLossDuration: null,
    futureLossMultiplier: null,
    futureLossTotal: null,
    isLoading: false
};

var rules = {};

var getters = {
    pastLossPeriods: function pastLossPeriods(state) {
        return state.pastLossPeriods;
    },
    pastLossDuration: function pastLossDuration(state) {
        return state.pastLossDuration;
    },
    pastLossMultiplier: function pastLossMultiplier(state) {
        return state.pastLossMultiplier;
    },
    pastLossTotal: function pastLossTotal(state) {
        return state.pastLossTotal;
    },
    futureLossPeriods: function futureLossPeriods(state) {
        return state.futureLossPeriods;
    },
    futureLossDuration: function futureLossDuration(state) {
        return state.futureLossDuration;
    },
    futureLossMultiplier: function futureLossMultiplier(state) {
        return state.futureLossMultiplier;
    },
    futureLossTotal: function futureLossTotal(state) {
        return state.futureLossTotal;
    },
    isLoading: function isLoading(state) {
        return state.isLoading;
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.UPDATE_FROM_SERVER, { data: data });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 3,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 3) && new __WEBPACK_IMPORTED_MODULE_4_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('lost/step/setStepNumberValid', {
            stepNo: 3,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    refresh: function refresh(_ref6, payload) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            getters = _ref6.getters,
            rootState = _ref6.rootState;

        if (!state.isLoading) {
            commit(mutationTypes.UPDATING_STATUS);
        }

        __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].calculators.monetary.lossOfIncomeTables(rootState.lost.claimant.theClaimant, rootState.lost.claimant.claimInfo.dateOfAssumedSettlement, rootState.lost.claimInfo.discountRate).then(function (data) {
            commit(mutationTypes.UPDATE_DATA, { data: data });
            if (state.isLoading) {
                commit(mutationTypes.UPDATING_STATUS);
            }
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DATA, function (state, _ref7) {
    var data = _ref7.data;

    state.pastLossPeriods = data.past_loss_periods;
    state.pastLossDuration = data.past_loss_duration;
    state.pastLossMultiplier = data.past_loss_multiplier;
    state.pastLossTotal = data.past_loss_total;
    state.futureLossPeriods = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(data.future_loss_periods);
    state.futureLossDuration = data.future_loss_duration;
    state.futureLossMultiplier = data.future_loss_multiplier;
    state.futureLossTotal = data.future_loss_total;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref8) {
    var data = _ref8.data;

    state.pastLossPeriods = data.pastLossPeriods;
    state.pastLossDuration = data.pastLossDuration;
    state.pastLossMultiplier = data.pastLossMultiplier;
    state.pastLossTotal = data.pastLossTotal;
    state.futureLossPeriods = data.futureLossPeriods;
    state.futureLossDuration = data.futureLossDuration;
    state.futureLossMultiplier = data.futureLossMultiplier;
    state.futureLossTotal = data.futureLossTotal;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATING_STATUS, function () {
    state.isLoading = !state.isLoading;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_lost_years_claims_routes__ = __webpack_require__(236);


var _mutations;



var types = {
    INCREMENT_STEP: 'INCREMENT_STEP',
    DECREMENT_STEP: 'DECREMENT_STEP',
    SET_STEP_VALID: 'SET_STEP_VALID',
    RESET: 'RESET'
};

var state = function state(steps) {
    return {
        currentStepIndex: 0,
        steps: steps,
        currentStep: null
    };
};

var getters = {
    currentStep: function currentStep(state) {
        return state.currentStep;
    },
    currentStepIndex: function currentStepIndex(state) {
        return state.currentStepIndex;
    },
    valid: function valid(state) {
        return function (index) {
            return state.steps[index] && state.steps[index].valid;
        };
    },
    next: function next(state) {
        if (state.currentStepIndex.index + 1 < state.currentStepIndex) {
            return state.steps[state.currentStepIndex + 1];
        }
        return null;
    },
    prev: function prev(state) {
        if (state.currentStepIndex.index - 1 >= 0) {
            return state.steps[state.currentStepIndex - 1];
        }
        return null;
    },
    allSteps: function allSteps(state) {
        return state.steps;
    }

};

var actions = {
    setValid: function setValid(_ref, valid) {
        var commit = _ref.commit;

        commit(types.SET_STEP_VALID, { valid: valid });
    },
    setStepNumberValid: function setStepNumberValid(_ref2, _ref3) {
        var commit = _ref2.commit;
        var stepNo = _ref3.stepNo,
            valid = _ref3.valid;

        commit(types.SET_STEP_VALID, { valid: { index: stepNo, valid: !!valid } });
    },
    reset: function reset(_ref4) {
        var commit = _ref4.commit;

        commit(types.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.SET_STEP_VALID, function (state, _ref5) {
    var valid = _ref5.valid;

    if (!state.steps[valid.index]) {
        return;
    }

    state.steps[valid.index].valid = valid.valid;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.RESET, function (state) {
    state.steps.forEach(function (step) {
        return step.valid = false;
    });
    state.currentStepIndex = 0;
    state.currentStep = state.steps[0];
}), _mutations);

var buildFromRoute = function buildFromRoute(_ref6) {
    var route = _ref6.route,
        prefix = _ref6.prefix;
    return {
        route: route,
        name: route.meta.name,
        store: route.meta.store,
        step: route.meta.step,
        valid: false
    };
};

var steps = __WEBPACK_IMPORTED_MODULE_1_pages_lost_years_claims_routes__["a" /* default */][0].children.map(function (route) {
    return buildFromRoute({ route: route, prefix: 'lost-years' });
});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state(steps),
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_index__ = __webpack_require__(15);


var _mutations;



var types = {
    RESET: 'RESET',
    UPDATE_MENU: 'UPDATE_MENU',
    COLLAPSE_MENU: 'COLLAPSE_MENU',
    UPDATE_MOBILE_MENU: 'UPDATE_MOBILE_MENU',
    UPDATE_SUBMENU: 'UPDATE_SUBMENU',
    UPDATE_PASSPORT_MENU: 'UPDATE_PASSPORT_MENU'
};

var state = {
    open: false,
    collapsed: false,
    mobileOpen: false,
    subMenu: null,
    passportMenu: false
};

var fetchSubMenu = function fetchSubMenu(state) {
    return {
        current: __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].getters[state.subMenu + '/step/currentStep'],
        stepNo: __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].getters[state.subMenu + '/step/currentStepIndex'],
        allSteps: __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].getters[state.subMenu + '/step/allSteps']
    };
};

var getters = {
    isMenuOpen: function isMenuOpen(state) {
        return state.open;
    },
    isMenuCollapsed: function isMenuCollapsed(state) {
        return state.collapsed;
    },
    isMobileMenuOpen: function isMobileMenuOpen(state) {
        return state.mobileOpen;
    },
    getSubMenu: function getSubMenu(state) {
        return fetchSubMenu(state);
    },
    subMenuStatus: function subMenuStatus(state) {
        return state.subMenu;
    },
    isPassportOpen: function isPassportOpen(state) {
        return state.passportMenu;
    }
};

var actions = {
    reset: function reset(_ref) {
        var commit = _ref.commit;
        commit(types.RESET);
    },
    updateMenu: function updateMenu(_ref2, menu) {
        var commit = _ref2.commit;
        commit(types.UPDATE_MENU, menu);
    },

    collapseMenu: function collapseMenu(_ref3) {
        var commit = _ref3.commit;

        commit(types.COLLAPSE_MENU);
        __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].dispatch('headerWidth/updateHeaderWidth', __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].getters["headerWidth/theCurrentHeaderWidth"]);
    },
    updateMobileMenu: function updateMobileMenu(_ref4) {
        var commit = _ref4.commit;
        return commit(types.UPDATE_MOBILE_MENU);
    },
    updateSubMenu: function updateSubMenu(_ref5, menu) {
        var commit = _ref5.commit;
        commit(types.UPDATE_SUBMENU, menu);
    },
    updatePassportMenu: function updatePassportMenu(_ref6, menu) {
        var commit = _ref6.commit;
        commit(types.UPDATE_PASSPORT_MENU, menu);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.RESET, function (state) {
    state.open = false;
    state.collapsed = false;
    state.mobileOpen = false;
    state.subMenu = null;
    state.passportMenu = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_MENU, function (state, menu) {
    state.open = menu || !state.open;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.COLLAPSE_MENU, function (state) {
    state.collapsed = !state.collapsed;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_MOBILE_MENU, function (state) {
    state.mobileOpen = !state.mobileOpen;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_SUBMENU, function (state, menu) {
    state.subMenu = menu;

    if (!state.subMenu) {
        state.open = false;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_PASSPORT_MENU, function (state) {
    state.passportMenu = !state.passportMenu;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var _mutations;



var mutationTypes = {
    UPDATE_AGE: 'UPDATE_AGE',
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET'
};

var state = {
    dateOfBirth: null,
    dateOfDeath: null,
    age: null
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    }
};

function roundYears(years) {
    return Math.round(years * 100) / 100;
}

var actions = {
    calculateAge: function calculateAge(_ref) {
        var state = _ref.state,
            commit = _ref.commit;

        var mDob = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.dateOfBirth, 'DD/MM/YYYY');
        var mDod = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.dateOfDeath, 'DD/MM/YYYY');
        if (mDob.isValid() && mDod.isValid()) {
            var age = roundYears(mDod.diff(mDob, 'years', true));
            commit(mutationTypes.UPDATE_AGE, { age: age });
        }
    },
    update: function update(_ref2, _ref3) {
        var commit = _ref2.commit;
        var key = _ref3.key,
            value = _ref3.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    },
    reset: function reset(_ref4) {
        var commit = _ref4.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_AGE, function (state, age) {
    state.age = age.age;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.age = null;
    state.dateOfDeath = null;
    state.dateOfBirth = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _mutations;

var dependentTemplate = function dependentTemplate() {
    return {
        income: 0
    };
};

var state = {
    deceasedIncome: 0,
    dependants: [],
    multiplicand: 0,
    total: 0
};

var types = {
    SET_VALUE: 'SET_VALUE',
    CREATE_DEPENDANT: 'CREATE_DEPENDANT',
    UPDATE_DEPENDANT: 'UPDATE_DEPENDANT',
    DELETE_DEPENDANT: 'DELETE_DEPENDANT',
    UPDATE_MULTIPLICAND: 'UPDATE_MULTIPLICAND',
    RESET: 'RESET'
};

var getters = {
    getMultiplicand: function getMultiplicand(state) {
        if (!state.multiplicand || state.multiplicand === 0) {
            return state.dependants.length > 1 ? 75 : 66.6;
        }
        return state.multiplicand;
    },
    dependantIncome: function dependantIncome(state) {
        return function (index) {
            return state.dependants[index].income;
        };
    },
    getValue: function getValue(state) {
        return function (key) {
            return state[key];
        };
    },
    countDependants: function countDependants(state) {
        return state.dependants.length;
    },
    totalDependantIncome: function totalDependantIncome(state) {
        return Number(state.dependants.reduce(function (income, dependant) {
            return income + dependant.income;
        }, 0));
    }
};

var actions = {
    setValue: function setValue(_ref, _ref2) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        commit(types.SET_VALUE, { key: key, value: value });
        return dispatch('calculateTotal');
    },
    createDependant: function createDependant(_ref3) {
        var commit = _ref3.commit;

        commit(types.CREATE_DEPENDANT);
    },
    deleteDependant: function deleteDependant(_ref4, index) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch;

        commit(types.DELETE_DEPENDANT, index);
        return dispatch('calculateTotal');
    },
    updateDependant: function updateDependant(_ref5, _ref6) {
        var commit = _ref5.commit;
        var index = _ref6.index,
            value = _ref6.value;

        commit(types.UPDATE_DEPENDANT, { index: index, value: value });
    },
    calculateTotal: function calculateTotal(_ref7) {
        var commit = _ref7.commit,
            getters = _ref7.getters,
            state = _ref7.state;

        commit(types.SET_VALUE, {
            key: 'total',
            value: state.multiplicand / 100 * (getters['totalDependantIncome'] + getters['getValue']('deceasedIncome')) - getters['totalDependantIncome']
        });
    },
    updateMultiplicand: function updateMultiplicand(_ref8, value) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch;

        commit(types.UPDATE_MULTIPLICAND, value);
        return dispatch('calculateTotal');
    },
    reset: function reset(_ref9) {
        var commit = _ref9.commit;

        commit(types.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.SET_VALUE, function (state, _ref10) {
    var key = _ref10.key,
        value = _ref10.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.CREATE_DEPENDANT, function (state) {
    state.dependants.push(dependentTemplate());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.DELETE_DEPENDANT, function (state, index) {
    state.dependants.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_DEPENDANT, function (state, _ref11) {
    var index = _ref11.index,
        value = _ref11.value;

    state.dependants[index].income = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_MULTIPLICAND, function (state, value) {
    state.multiplicand = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.RESET, function (state) {
    state.deceasedIncome = 0;
    state.dependants = [];
    state.multiplicand = 0;
    state.total = 0;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_calculators_dates__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_calculators_monetary__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);


var _mutations;







var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET'
};

var state = {
    dateOfBirth: null,
    gender: null,
    isRetired: false,
    dateFrom: null,
    dateTo: null,
    retirementDate: null,
    employmentType: 'employed',
    employmentIncome: 0,
    employmentIncomeNetGross: 'gross',
    totalGrossIncome: 0,
    totalNetIncome: 0
};

var getters = {
    findValue: function findValue(state) {
        return function (key) {
            return state[key];
        };
    }
};

var actions = {
    updateValue: function updateValue(_ref, _ref2) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    },

    calculateEarnings: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref3) {
        var state = _ref3.state,
            commit = _ref3.commit;

        var incomeData = {
            employmentIncome: state.employmentIncome,
            employmentType: state.employmentType,
            endOfPeriod: state.dateTo,
            startOfPeriod: state.dateFrom,
            employmentNetGross: state.employmentIncomeNetGross,
            retired: state.isRetired,
            retirementDate: state.retirementDate
        };

        __WEBPACK_IMPORTED_MODULE_2__services_api_calculators_monetary__["a" /* default */].miniIncome(incomeData).then(function (data) {
            commit(mutationTypes.UPDATE_VALUE, { key: 'totalNetIncome', value: data.totalNetIncome });
            commit(mutationTypes.UPDATE_VALUE, { key: 'totalGrossIncome', value: data.totalGrossIncome });
        });
    }, 500),
    updateRetirement: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_components_form_validator_validations__["a" /* validDate */])(state.dateOfBirth) || !state.gender) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_1__services_api_calculators_dates__["a" /* default */].statePensionAge(state).then(function (data) {
            var dateFromM = __WEBPACK_IMPORTED_MODULE_4_moment___default()(state.dateFrom, 'DD/MM/YYYY');
            var retirementDateM = __WEBPACK_IMPORTED_MODULE_4_moment___default()(data.statePension.retirementDate, 'DD/MM/YYYY');

            commit(mutationTypes.UPDATE_VALUE, { key: 'isRetired', value: retirementDateM.isBefore(dateFromM) });
            commit(mutationTypes.UPDATE_VALUE, { key: 'retirementDate', value: data.statePension.retirementDate });
        });
    }, 500),
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.isRetired = false;
    state.dateFrom = null;
    state.dateOfBirth = null;
    state.dateTo = null;
    state.retirementDate = null;
    state.employmentType = 'employed';
    state.employmentIncome = 0;
    state.employmentIncomeNetGross = 'gross';
    state.totalGrossIncome = 0;
    state.totalNetIncome = 0;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_modules_mini_step__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_modules_mini_age__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_modules_mini_lifeExpectancy__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_modules_mini_lossOfPension__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_modules_mini_inflation__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_modules_mini_interpolatedMultipliers__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_modules_mini_period__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_mini_pension__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_mini_earnings__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_modules_mini_lossOfEarnings__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_mini_interest__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_modules_mini_tableDiscounts__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_modules_mini_retirementAge__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_store_modules_mini_dependency__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store_modules_mini_care__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_store_modules_mini_meso__ = __webpack_require__(933);

















var state = {};

var getters = {};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {
        step: __WEBPACK_IMPORTED_MODULE_0_store_modules_mini_step__["a" /* default */],
        age: __WEBPACK_IMPORTED_MODULE_1_store_modules_mini_age__["a" /* default */],
        inflation: __WEBPACK_IMPORTED_MODULE_4_store_modules_mini_inflation__["a" /* default */],
        interpolatedMultipliers: __WEBPACK_IMPORTED_MODULE_5_store_modules_mini_interpolatedMultipliers__["a" /* default */],
        lifeExpectancy: __WEBPACK_IMPORTED_MODULE_2_store_modules_mini_lifeExpectancy__["a" /* default */],
        period: __WEBPACK_IMPORTED_MODULE_6_store_modules_mini_period__["a" /* default */],
        pension: __WEBPACK_IMPORTED_MODULE_7_store_modules_mini_pension__["a" /* default */],
        interest: __WEBPACK_IMPORTED_MODULE_10_store_modules_mini_interest__["a" /* default */],
        tableDiscounts: __WEBPACK_IMPORTED_MODULE_11_store_modules_mini_tableDiscounts__["a" /* default */],
        retirementAge: __WEBPACK_IMPORTED_MODULE_12_store_modules_mini_retirementAge__["a" /* default */],
        earnings: __WEBPACK_IMPORTED_MODULE_8_store_modules_mini_earnings__["a" /* default */],
        dependency: __WEBPACK_IMPORTED_MODULE_13_store_modules_mini_dependency__["a" /* default */],
        care: __WEBPACK_IMPORTED_MODULE_14_store_modules_mini_care__["b" /* default */],
        meso: __WEBPACK_IMPORTED_MODULE_15_store_modules_mini_meso__["a" /* default */],
        lossOfEarnings: __WEBPACK_IMPORTED_MODULE_9_store_modules_mini_lossOfEarnings__["a" /* default */],
        lossOfPension: __WEBPACK_IMPORTED_MODULE_3_store_modules_mini_lossOfPension__["a" /* default */]
    }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_api_calculators_monetary__ = __webpack_require__(119);


var _mutations;



var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET'
};

var state = {
    amount: 0,
    minMonth: null,
    minYear: null,
    maxMonth: 9,
    maxYear: 2017,
    rpiData: []
};

var getters = {
    amount: function amount(state) {
        return state.amount;
    },
    minMonth: function minMonth(state) {
        return state.minMonth;
    },
    minYear: function minYear(state) {
        return state.minYear;
    },
    maxMonth: function maxMonth(state) {
        return state.maxMonth;
    },
    maxYear: function maxYear(state) {
        return state.maxYear;
    },
    rpiData: function rpiData(state) {
        return state.rpiData;
    }
};

var actions = {
    loadRpiData: function loadRpiData(_ref) {
        var commit = _ref.commit,
            state = _ref.state;

        if (state.rpiData.length) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_1_services_api_calculators_monetary__["a" /* default */].rpiTable().then(function (value) {
            commit(mutationTypes.UPDATE_VALUE, { key: 'rpiData', value: value });
        });
    },
    updateValue: function updateValue(_ref2, _ref3) {
        var commit = _ref2.commit;
        var key = _ref3.key,
            value = _ref3.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    },
    reset: function reset(_ref4) {
        var commit = _ref4.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.amount = 0;
    state.minMonth = null;
    state.minYear = null;
    state.maxMonth = null;
    state.maxYear = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _mutations;




var mutationTypes = {
    UPDATE: 'UPDATE',
    RESULT: 'RESULT',
    RESET: 'RESET'
};

var state = {
    dateFrom: null,
    dateTo: null,
    interestRate: 0,
    principalAmount: 0,
    interestType: null,
    compoundFrequency: 1,
    interestAccrued: 0,
    aggregateRate: 0,
    noOfDays: 0,
    dailyRate: 0,
    theTotal: 0
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    }
};

function calcInterestGate(state) {
    return state.dateFrom !== null && state.dateTo !== null && state.dateTo > state.dateFrom && state.interestRate > 0 && state.principalAmount > 0 && state.interestType !== null;
}

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE, { key: key, value: value });
    },

    calcInterest: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref3) {
        var dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (calcInterestGate(state)) {
            return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].miniCalculators.monetary.interest(state).then(function (data) {
                return dispatch('result', data);
            });
        }
    }, 500),
    result: function result(_ref4, data) {
        var commit = _ref4.commit;

        commit(mutationTypes.RESULT, data);
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.dateFrom = null;
    state.dateTo = null;
    state.interestRate = 0;
    state.principalAmount = 0;
    state.interestAccrued = 0;
    state.interestType = null;
    state.compoundFrequency = 1;
    state.aggregateRate = 0;
    state.noOfDays = 0;
    state.dailyRate = 0;
    state.theTotal = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESULT, function (state, data) {
    state.interestAccrued = data.interest_accrued;
    state.aggregateRate = data.aggregate_rate;
    state.noOfDays = data.number_of_days;
    state.dailyRate = data.daily_rate;
    state.theTotal = data.total;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_mini_calculators_multipliers__ = __webpack_require__(241);


var _mutations;



var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET_VALUES: 'RESET_VALUES'
};

var state = {
    ogdenTableInfo: [],
    ogdenTable: null,
    multiplier: 0,
    discountRate: '-0.25',
    dateOfBirth: null,
    dateOfTrial: null,
    ageAtTrial: null,
    term: null,
    tableData: null
};

var getters = {
    findValue: function findValue(state) {
        return function (key) {
            return state[key];
        };
    }
};

var actions = {
    loadOgdenTableInfo: function loadOgdenTableInfo(_ref) {
        var commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_api_mini_calculators_multipliers__["a" /* default */].ogdenTableInfo().then(function (updated) {
            commit(mutationTypes.UPDATE_VALUE, { key: 'ogdenTableInfo', value: updated });
        });
    },
    updateValue: function updateValue(_ref2, _ref3) {
        var commit = _ref2.commit;
        var key = _ref3.key,
            value = _ref3.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    },
    calculateMultiplier: function calculateMultiplier(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit;

        if (state.ogdenTable.length < 7 || state.discountRate === null || state.term === '') {
            return;
        }

        var table = state.ogdenTable.slice(6);
        if (table < 1 || table > 28 || table === '27') {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_1__services_api_mini_calculators_multipliers__["a" /* default */].lookupOgdenMultiplier({
            table: table,
            col: state.discountRate,
            row: table === '28' ? state.term : state.ageAtTrial
        }).then(function (data) {
            commit(mutationTypes.UPDATE_VALUE, { key: 'multiplier', value: data.multiplier });
            commit(mutationTypes.UPDATE_VALUE, { key: 'tableData', value: data.tableData });
        });
    },
    resetValues: function resetValues(_ref5) {
        var commit = _ref5.commit;

        commit(mutationTypes.RESET_VALUES);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_VALUES, function (state) {
    state.ogdenTableInfo = [];
    state.ogdenTable = null;
    state.multiplier = 0;
    state.discountRate = '-0.25';
    state.dateOfBirth = null;
    state.dateOfTrial = null;
    state.ageAtTrial = null;
    state.term = null;
    state.tableData = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttleUpdateLife */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);




var _mutations;





var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    UPDATE_YEARS_AND_MONTHS: 'UPDATE_YEARS_AND_MONTHS',
    UPDATE_LIFE_EXPECTANCY: 'UPDATE_LIFE_EXPECTANCY',
    RESET: 'RESET',
    RESET_END_OF_LIFE: 'RESET_END_OF_LIFE',
    UPDATE_RESULTS: 'UPDATE_RESULTS',
    UPDATE_ASSUMED_SETTLEMENT: 'UPDATE_ASSUMED_SETTLEMENT'
};

var state = {
    person: {
        gender: '',
        dateOfBirth: null,
        method: '',
        yearsAndMonths: {
            months: 0,
            years: 0
        },
        dateOfDeathIsAssumed: null,
        ageAtDeath: null,
        dateOfDeath: null,
        percentageOfNormalLifeExpectancy: 100,
        percentageReductionInNormalLifeExpectancy: 0
    },
    assumedSettlement: null,
    results: {
        formula: null,
        tableData: null,
        intro: null,
        explanation: null,
        outcome: null
    }
};

var isValid = function isValid(lifeExpectancy, dispatch) {
    if (lifeExpectancy.method !== 'age_at_death') {
        dispatch('resetEndOfLife');
    }

    return lifeExpectancy.method !== '' && !!lifeExpectancy.gender && !!lifeExpectancy.dateOfBirth;
};

var updateObject = function updateObject(dispatch, action, obj) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var proms = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return dispatch(action, { key: key, value: obj[key], index: index });
    });
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(proms);
};

var throttleUpdateLife = _.debounce(function (dispatch, action, person, lifeExpectancy, assumedSettlement, index) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
        return updateObject(dispatch, action, updatedLife, index);
    });
}, 500);

var postData = function postData(state, value) {
    return {
        person: {
            name: 'mini-calc',
            gender: state.person.gender,
            date_of_birth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_services_Api__["d" /* dateToServer */])(state.person.dateOfBirth)
        },
        claim: {
            assumed_settlement: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')
        },
        type: 'person',
        value: value
    };
};

var getLifeData = function getLifeData(state) {
    switch (state.person.method) {
        case 'ogden_table':
            return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].miniCalculators.lifeExpectancy.ogden(postData(state));
        case 'percentage_of_normal_life_expectancy':
            return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].miniCalculators.lifeExpectancy.percentageOfNormal(postData(state, state.person.percentageOfNormalLifeExpectancy));
        case 'percentage_reduction_in_normal_life_expectancy':
            return __WEBPACK_IMPORTED_MODULE_4_services_Api__["a" /* default */].miniCalculators.lifeExpectancy.percentageReduction(postData(state, state.person.percentageReductionInNormalLifeExpectancy));
    }
};

var getters = {
    thePerson: function thePerson(state) {
        return state.person;
    },
    theResults: function theResults(state) {
        return state.results;
    },
    getAssumedSettlement: function getAssumedSettlement(state) {
        return state.assumedSettlement;
    }
};

var actions = {
    updatePerson: function updatePerson(_ref, _ref2) {
        var commit = _ref.commit;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    },
    updateYearsAndMonths: function updateYearsAndMonths(_ref3, _ref4) {
        var commit = _ref3.commit;
        var key = _ref4.key,
            value = _ref4.value;

        commit(mutationTypes.UPDATE_YEARS_AND_MONTHS, { key: key, value: value });
    },
    updateAssumedSettlement: function updateAssumedSettlement(_ref5, value) {
        var commit = _ref5.commit;

        commit(mutationTypes.UPDATE_ASSUMED_SETTLEMENT, value);
    },
    reset: function reset(_ref6) {
        var commit = _ref6.commit;

        commit(mutationTypes.RESET);
    },
    updateLifeExpectancy: function updateLifeExpectancy(_ref7) {
        var dispatch = _ref7.dispatch,
            state = _ref7.state;

        if (!isValid(state.person, dispatch)) {
            return;
        }

        if (state.person.method === 'ogden_table' || state.person.method === 'percentage_of_normal_life_expectancy' || state.person.method === 'percentage_reduction_in_normal_life_expectancy') {
            getLifeData(state).then(function (data) {
                return dispatch('updateResults', data);
            });
        }

        return updateObject(dispatch, 'updatePerson', state.person).then(function () {
            return throttleUpdateLife(dispatch, 'updatePerson', state.person, state.person, state.assumedSettlement);
        });
    },
    resetEndOfLife: function resetEndOfLife(_ref8) {
        var commit = _ref8.commit;

        commit(mutationTypes.RESET_END_OF_LIFE);
    },
    updateResults: function updateResults(_ref9, data) {
        var commit = _ref9.commit;

        commit(mutationTypes.UPDATE_RESULTS, data);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state.person[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_ASSUMED_SETTLEMENT, function (state, value) {
    state.assumedSettlement = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_YEARS_AND_MONTHS, function (state, payload) {
    state.person.yearsAndMonths[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.person.gender = '';
    state.person.dateOfDeath = null;
    state.person.dateOfBirth = null;
    state.person.method = '';
    state.assumedSettlement = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_END_OF_LIFE, function (state) {
    state.person.ageAtDeath = null;
    state.person.dateOfDeath = null;
    state.results.formula = null;
    state.results.tableData = null;
    state.results.intro = null;
    state.results.explanation = null;
    state.results.outcome = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_RESULTS, function (state, data) {
    state.results.intro = data[0].Paragraph.content;
    state.results.explanation = data[1].Paragraph.content;
    state.results.outcome = data[2].Paragraph.content;
    state.results.tableData = data[3].TableData;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultPeriodTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_calculators_monetary__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_calculators_dates__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_moment__);


var _mutations;








var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    ADD_INCOME_PERIOD: 'ADD_INCOME_PERIOD',
    UPDATE_INCOME_PERIOD: 'UPDATE_INCOME_PERIOD',
    UPDATE_INCOME_PERIOD_VALUE: 'UPDATE_INCOME_PERIOD_VALUE',
    DELETE_INCOME_PERIOD: 'DELETE_INCOME_PERIOD',
    RESET: 'RESET',
    LOADING: 'LOADING'
};

var allPeriodsValid = function allPeriodsValid(state) {
    var periods = state.periods.map(function (period) {
        if (period.employmentType !== 'absence') {
            return period.startOfPeriod !== "" && period.startOfPeriod !== null && period.endOfPeriod !== "" && period.endOfPeriod !== null && (period.employmentIncome !== null || period.employmentIncome !== "") && period.employmentType !== null;
        }
        return period.startOfPeriod !== "" && period.startOfPeriod !== null && period.endOfPeriod !== "" && period.endOfPeriod !== null && period.employmentType !== null;
    });

    return periods.reduce(function (valid, value) {
        return valid ? value === true : false;
    }, true);
};

var getPeriodDate = function getPeriodDate(state) {
    var sorted = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sortBy(state.periods, [function (period) {
        return __WEBPACK_IMPORTED_MODULE_6_moment_moment___default()(period.startOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
    }]);

    return sorted[0].startOfPeriod;
};

var periodNetLoss = function periodNetLoss(state, period) {
    var duration = __WEBPACK_IMPORTED_MODULE_6_moment_moment___default()(period.endOfPeriod, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_6_moment_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true);
    var preLossIncome = state.totalNetIncome;
    var lossIncome = period.totalNetIncome;

    return parseFloat(duration.toFixed(2)) * preLossIncome - parseFloat(duration.toFixed(2)) * lossIncome;
};

function defaultPeriodTemplate() {
    return {
        startOfPeriod: null,
        endOfPeriod: null,
        employmentType: null,
        employmentIncome: 0,
        employmentNetGross: 'gross'
    };
};

var state = {
    dateOfBirth: null,
    gender: null,
    retirementDate: null,
    employmentType: 'employed',
    employmentIncome: 0,
    employmentNetGross: 'gross',
    periods: [],
    totalNetIncome: 0,
    totalGrossIncome: 0,
    totalNetLoss: 0,
    loading: false
};

var getters = {
    findValue: function findValue(state) {
        return function (key) {
            return state[key];
        };
    },
    periods: function periods(state) {
        return state.periods;
    },
    periodsValid: function periodsValid(state) {
        return allPeriodsValid(state);
    }
};

var actions = {
    updateValue: function updateValue(_ref, _ref2) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });

        if (key === 'dateOfBirth' || key === 'gender') {
            dispatch('statePensionDate');
        }

        dispatch('calculatePeriodLoss');
    },
    statePensionDate: function statePensionDate(_ref3) {
        var state = _ref3.state,
            commit = _ref3.commit;

        if (!state.dateOfBirth || !state.gender) {
            return;
        }

        var person = {
            dateOfBirth: state.dateOfBirth,
            gender: state.gender
        };

        return __WEBPACK_IMPORTED_MODULE_2__services_api_calculators_dates__["a" /* default */].statePensionAge(person).then(function (data) {
            commit(mutationTypes.UPDATE_VALUE, {
                key: 'retirementDate',
                value: data.statePension.retirementDate
            });
        });
    },
    addPeriod: function addPeriod(_ref4) {
        var commit = _ref4.commit;

        commit(mutationTypes.ADD_INCOME_PERIOD);
    },
    updatePeriod: function updatePeriod(_ref5, payload) {
        var commit = _ref5.commit,
            state = _ref5.state;

        commit(mutationTypes.UPDATE_INCOME_PERIOD, payload);
    },
    deletePeriod: function deletePeriod(_ref6, index) {
        var commit = _ref6.commit;

        commit(mutationTypes.DELETE_INCOME_PERIOD, index);
    },
    calculatePeriodLoss: function calculatePeriodLoss(_ref7, index) {
        var state = _ref7.state,
            dispatch = _ref7.dispatch;

        dispatch('calculateIncome');
        dispatch('calculateLossOfEarnings', { period: state.periods[index], index: index });
    },

    calculateIncome: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref8) {
        var state = _ref8.state,
            commit = _ref8.commit,
            dispatch = _ref8.dispatch;

        if (allPeriodsValid(state)) {
            var endOfPeriod = getPeriodDate(state);

            var period = {
                employmentType: state.employmentType,
                employmentIncome: state.employmentIncome,
                employmentNetGross: state.employmentNetGross,
                startOfPeriod: __WEBPACK_IMPORTED_MODULE_6_moment_moment___default()(endOfPeriod, 'DD/MM/YYYY').subtract(1, "year").format('DD/MM/YYYY'),
                endOfPeriod: endOfPeriod
            };

            var person = {
                income: {
                    retirementDate: state.retirementDate
                }
            };

            commit(mutationTypes.LOADING, true);

            __WEBPACK_IMPORTED_MODULE_1__services_api_calculators_monetary__["a" /* default */].income(period, person).then(function (data) {
                commit(mutationTypes.LOADING, false);
                commit(mutationTypes.UPDATE_VALUE, { key: 'totalNetIncome', value: data.totalNetIncome });
                commit(mutationTypes.UPDATE_VALUE, { key: 'totalGrossIncome', value: data.totalGrossIncome });
                dispatch('calculateTotalNetLoss');
            });
        }
    }, 1000),
    calculateLossOfEarnings: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref9, _ref10) {
        var state = _ref9.state,
            commit = _ref9.commit,
            dispatch = _ref9.dispatch;
        var period = _ref10.period,
            index = _ref10.index;

        if (allPeriodsValid(state)) {
            var person = {
                income: {
                    retirementDate: state.retirementDate
                }
            };

            commit(mutationTypes.LOADING, true);

            __WEBPACK_IMPORTED_MODULE_1__services_api_calculators_monetary__["a" /* default */].income(period, person).then(function (data) {
                commit(mutationTypes.LOADING, false);
                commit(mutationTypes.UPDATE_INCOME_PERIOD_VALUE, {
                    index: index,
                    key: 'totalNetIncome',
                    value: data.totalNetIncome
                });
                commit(mutationTypes.UPDATE_INCOME_PERIOD_VALUE, {
                    index: index,
                    key: 'totalGrossIncome',
                    value: data.totalGrossIncome
                });
                dispatch('calculateTotalNetLoss');
            });
        }
    }, 1000),
    calculateTotalNetLoss: function calculateTotalNetLoss(_ref11) {
        var state = _ref11.state,
            commit = _ref11.commit;

        var periods = state.periods.map(function (period) {
            return parseFloat(periodNetLoss(state, period).toFixed(2));
        });

        var total = periods.reduce(function (total, carry) {
            return total + carry;
        }, 0) || 0;

        commit(mutationTypes.UPDATE_VALUE, { key: 'totalNetLoss', value: total });
    },
    reset: function reset(_ref12) {
        var commit = _ref12.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_INCOME_PERIOD, function (state) {
    state.periods.push(defaultPeriodTemplate());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_INCOME_PERIOD, function (state, index) {
    state.periods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCOME_PERIOD_VALUE, function (state, payload) {
    state.periods[payload.index][payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCOME_PERIOD, function (state, payload) {
    state.periods[payload.index] = payload.period;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOADING, function (state, boolean) {
    state.loading = boolean;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.dateOfBirth = null;
    state.gender = null;
    state.retirementDate = null;
    state.employmentType = 'employed';
    state.employmentIncome = 0;
    state.employmentIncomeNetGross = 'gross';
    state.periods = [];
    state.periods.push(defaultPeriodTemplate());
    state.totalNetIncome = 0;
    state.totalGrossIncome = 0;
    state.totalNetLoss = 0;
    state.loading = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);


var _mutations;





var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    UPDATE_PENSION_VALUE: 'UPDATE_PENSION_VALUE',
    RESET: 'RESET'
};

var _isPersonUserInputValid = function _isPersonUserInputValid(state) {
    return state.gender !== null && state.dateOfBirth !== null && state.dateOfBirth !== '' && state.dateOfAssumedSettlement !== null && state.dateOfAssumedSettlement !== '';
};

var isPensionValid = function isPensionValid(state) {
    var pension = state.pension;

    if (!_isPensionUserInputValid(state)) {
        return false;
    }

    if (!pension.pensionLossMultiplier || !pension.totalLoss) {
        return false;
    }

    if (pension.lumpSumLoss && (pension.lumpSumLossPresentValue === null || pension.longdenFactor === null)) {
        return false;
    }

    return true;
};

var _isPensionUserInputValid = function _isPensionUserInputValid(state) {
    var pension = state.pension;

    if (!pension.butForRetirementDate || !pension.butForRetirementAge || !pension.pensionMethod || !pension.butForPensionAnnual || pension.pensionAnnual === null || pension.pensionAnnual === '' || pension.lumpSumLoss === null || pension.pensionAnnual > pension.butForPensionAnnual) {
        return false;
    }

    if (pension.lumpSumLoss && (!pension.butForPensionLumpSum || pension.pensionLumpSum === null || pension.pensionLumpSum === '' || pension.dateLumpSumPaymentReceived === null || pension.dateLumpSumPaymentReceived === '' || pension.pensionLumpSum > pension.butForPensionLumpSum)) {
        return false;
    }

    return true;
};

var state = {
    gender: null,
    dateOfBirth: null,
    dateOfAssumedSettlement: null,
    ageAtTrial: null,
    term: null,
    table21: null,
    table23: null,
    table27: null,
    upperAge: null,
    lowerAge: null,
    lowerMultiplier: null,
    upperMultiplier: null,

    pension: {
        illHealthDisabilityPension: false,

        pensionMethod: null,

        acceleratedReceipt: null,

        butForRetirementDate: null,
        butForRetirementAge: null,
        retirementDate: null,
        multiplierToRetirement: null,

        lifeMultiplier: null,
        discountFactor: null,

        lumpSumLoss: null,
        butForPensionLumpSum: 0,
        pensionLumpSum: 0,
        longdenFactor: null,
        lumpSumLossValue: null,
        lumpSumLossPresentValue: null,
        dateLumpSumPaymentReceived: null,

        butForPensionAnnual: 0,
        pensionAnnual: 0,

        pensionLossAnnual: null,

        pensionLossMultiplier: null,

        totalLossAnnual: null,

        totalLoss: null
    }
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    pensionValue: function pensionValue(state) {
        return function (key) {
            return state.pension[key];
        };
    },
    pension: function pension(state) {
        return state.pension;
    },
    isPensionUserInputValid: function isPensionUserInputValid(state) {
        return _isPensionUserInputValid(state);
    },
    isPersonUserInputValid: function isPersonUserInputValid(state) {
        return _isPersonUserInputValid(state);
    }
};

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch,
            state = _ref.state;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });

        if (state.dateOfBirth && state.dateOfAssumedSettlement) {
            dispatch('updateAgeAtTrial');
        }
    },
    updateAgeAtTrial: function updateAgeAtTrial(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;

        var ageAtTrial = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.dateOfAssumedSettlement, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(state.dateOfBirth, 'DD/MM/YYYY'), 'years', true);

        commit(mutationTypes.UPDATE_VALUE, { key: 'ageAtTrial', value: ageAtTrial });
    },
    updatePensionValue: function updatePensionValue(_ref4, _ref5) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            state = _ref4.state;
        var key = _ref5.key,
            value = _ref5.value;

        commit(mutationTypes.UPDATE_PENSION_VALUE, { key: key, value: value });

        if (state.pension.butForRetirementDate && state.pension.dateLumpSumPaymentReceived) {
            dispatch('updateAcceleratedReceipt');
        }
    },
    updateAcceleratedReceipt: function updateAcceleratedReceipt(_ref6) {
        var commit = _ref6.commit,
            state = _ref6.state;

        var acceleratedReceipt = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.pension.butForRetirementDate, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(state.pension.dateLumpSumPaymentReceived, 'DD/MM/YYYY'), 'years', true).toFixed(2);

        commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'acceleratedReceipt', value: acceleratedReceipt });
    },

    updateRetirement: __WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"](function (_ref7) {
        var commit = _ref7.commit,
            state = _ref7.state;

        if (state.gender && state.dateOfBirth) {
            var person = {
                gender: state.gender,
                dateOfBirth: state.dateOfBirth
            };
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculators.dates.statePensionAge(person).then(function (data) {
                var divided = data.statePension.retirementAge / 5;

                commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'butForRetirementDate', value: data.statePension.retirementDate });
                commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'butForRetirementAge', value: data.statePension.retirementAge });
                commit(mutationTypes.UPDATE_VALUE, { key: 'lowerAge', value: 5 * Math.floor(divided) });
                commit(mutationTypes.UPDATE_VALUE, { key: 'upperAge', value: 5 * Math.ceil(divided) });
            });
        }
    }, 500),
    calculatePensionLoss: __WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"](function (_ref8) {
        var state = _ref8.state,
            commit = _ref8.commit;

        if (!_isPensionUserInputValid(state) && !_isPersonUserInputValid(state)) {
            return;
        }

        var claimant = {
            theClaimant: {
                gender: state.gender,
                dateOfBirth: state.dateOfBirth
            },
            claimInfo: {
                dateOfAssumedSettlement: state.dateOfAssumedSettlement,
                discountRate: '-0.25'
            }
        };

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculators.monetary.pensionLoss(claimant, state.pension).then(function (data) {
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'discountFactor', value: data.discountFactor });
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'lifeMultiplier', value: data.lifeMultiplier });
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'longdenFactor', value: data.longdenFactor });
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'lumpSumLossPresentValue', value: data.lumpSumLossPresentValue });
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'multiplierToRetirement', value: data.multiplierToRetirement });
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'pensionLossMultiplier', value: data.pensionLossMultiplier.toFixed(2) });
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'totalLoss', value: data.totalLoss });
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'totalLossAnnual', value: data.totalLossAnnual });
            commit(mutationTypes.UPDATE_PENSION_VALUE, { key: 'acceleratedReceipt', value: data.acceleratedReceipt });
        });
    }, 500),
    reset: function reset(_ref9) {
        var commit = _ref9.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_PENSION_VALUE, function (state, payload) {
    state.pension[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.gender = null;
    state.dateOfBirth = null;
    state.dateOfAssumedSettlement = null;
    state.ageAtTrial = null;
    state.term = null;
    state.table21 = null;
    state.table23 = null;
    state.table27 = null;
    state.upperAge = null;
    state.lowerAge = null;
    state.lowerMultiplier = null;
    state.upperMultiplier = null;
    state.acceleratedReceipt = null;
    state.pension.illHealthDisabilityPension = false;
    state.pension.pensionMethod = null;
    state.pension.dateLumpSumPaymentReceived = null;
    state.pension.butForRetirementDate = null;
    state.pension.butForRetirementAge = null;
    state.pension.retirementDate = null;
    state.pension.multiplierToRetirement = null;
    state.pension.lifeMultiplier = null;
    state.pension.discountFactor = null;
    state.pension.lumpSumLoss = null;
    state.pension.butForPensionLumpSum = 0;
    state.pension.pensionLumpSum = 0;
    state.pension.longdenFactor = null;
    state.pension.lumpSumLossValue = null;
    state.pension.lumpSumLossPresentValue = null;
    state.pension.butForPensionAnnual = 0;
    state.pension.pensionAnnual = 0;
    state.pension.pensionLossAnnual = null;
    state.pension.pensionLossMultiplier = null;
    state.pension.totalLossAnnual = null;
    state.pension.totalLoss = null;
    state.pension.acceleratedReceipt = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var _mutations;



var mutationTypes = {
    UPDATE_AGE: 'UPDATE_AGE',
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET'
};

var state = {
    dateOfBirth: null,
    durationOfSymptoms: null,
    ageOfPerson: null
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    }
};

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    },
    reset: function reset(_ref3) {
        var commit = _ref3.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_AGE, function (state, age) {
    state.ageOfPerson = age.age;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.ageOfPerson = null;
    state.dateOfBirth = null;
    state.durationOfSymptoms = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* unused harmony export currentFiscalYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Api_js__ = __webpack_require__(5);


var _mutations;





var mutationTypes = {
    SET: 'SET',
    RESET: 'RESET'
};

var currentFiscalYear = function currentFiscalYear() {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('Y') + '/' + __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'years').format('YY');
};

var state = {
    income: 0,
    pensionType: 'Gross',
    fiscalYear: currentFiscalYear(),
    total: 0,
    results: {}
};

var getters = {
    income: function income(state) {
        return state.income;
    },
    all: function all(state) {
        return state;
    }
};

var actions = {
    set: function set(_ref, _ref2) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.SET, { key: key, value: value });
        dispatch('calculatePension');
    },

    calculatePension: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref3) {
        var dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(state.fiscalYear, 'YYYY/YY').isValid() && state.income > 0 && (state.pensionType == 'NET' || state.pensionType == 'Gross')) {
            return __WEBPACK_IMPORTED_MODULE_3__services_Api_js__["a" /* default */].miniCalculators.grossNetPension.calculate(state).then(function (data) {
                dispatch('setTotal', data);
            });
        }
    }, 500),
    setTotal: function setTotal(_ref4, data) {
        var commit = _ref4.commit;

        commit(mutationTypes.SET, { key: 'results', value: data });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, _ref6) {
    var key = _ref6.key,
        value = _ref6.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.income = 0;
    state.pensionType = 'Gross';
    state.fiscalYear = currentFiscalYear();
    state.total = 0;
    state.results = {};
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);


var _mutations;





__webpack_require__(1327);
__webpack_require__(1326);

var types = {
    UPDATE_CALCULATOR_VALUE: 'UPDATE_CALCULATOR_VALUE',
    UPDATE_OPTIONS: 'UPDATE_OPTIONS',
    CALCULATE_DIFFERENCE: 'CALCULATE_DIFFERENCE',
    UPDATE_OPTION: 'UPDATE_OPTION',
    RESET: 'RESET'
};

var state = {
    firstDate: null,
    secondDate: null,
    options: {
        show: {
            years: true,
            months: true,
            weeks: false,
            days: true
        },
        dp: 2,
        includeFirstDay: true,
        includeLastDay: true,
        includeBankHolidays: true,
        numberOfBankHolidays: 0,
        numberOfWeekendDays: 0,
        includeWeekends: true
    },
    diffBetween: null,
    diffYears: null
};

var getters = {
    getCalculator: function getCalculator(state) {
        return state;
    }
};

var actions = {
    calculateDifference: function calculateDifference(_ref, firstDate, secondDate, options) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].miniCalculators.dates.PeriodBetweenTwoDates(firstDate, secondDate, options).then(function (data) {
            commit(types.UPDATE_OPTION, { key: 'numberOfBankHolidays', value: data.number_of_bank_holidays });
            commit(types.UPDATE_OPTION, { key: 'numberOfWeekendDays', value: data.number_of_weekend_days });
            commit(types.UPDATE_CALCULATOR_VALUE, { key: 'diffBetween', value: data.diff });
            commit(types.UPDATE_CALCULATOR_VALUE, { key: 'diffYears', value: data.years });
        });
    },
    setOptions: function setOptions(_ref2, options) {
        var commit = _ref2.commit;

        commit(types.UPDATE_OPTIONS, options);
    },
    setCalculatorValue: function setCalculatorValue(_ref3, _ref4) {
        var commit = _ref3.commit;
        var key = _ref4.key,
            value = _ref4.value;

        commit(types.UPDATE_CALCULATOR_VALUE, { key: key, value: value });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        commit(types.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_CALCULATOR_VALUE, function (state, _ref6) {
    var key = _ref6.key,
        value = _ref6.value;

    state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_OPTIONS, function (state, options) {
    state.options = options;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_OPTION, function (state, _ref7) {
    var key = _ref7.key,
        value = _ref7.value;

    state.options[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.RESET, function (state) {
    state.firstDate = null;
    state.secondDate = null;
    state.options.show.years = true;
    state.options.show.months = true;
    state.options.show.weeks = false;
    state.options.show.days = true;
    state.options.dp = 2;
    state.options.includeFirstDay = true;
    state.options.includeLastDay = true;
    state.options.bankHolidays = true;
    state.options.weekends = true;
    state.options.numberOfBankHolidays = 0;
    state.options.numberOfWeekendDays = 0;
    state.diffBetween = null;
    state.diffYears = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _mutations;




var mutationTypes = {
    UPDATE: 'UPDATE',
    RESULT: 'RESULT',
    RESET: 'RESET'
};

var state = {
    gender: 'male',
    dateOfBirth: null,
    retirementAge: null,
    retirementDate: null
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    }
};

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE, { key: key, value: value });
    },

    calcRetirementAge: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref3) {
        var dispatch = _ref3.dispatch,
            state = _ref3.state;

        var person = {
            gender: state.gender,
            dateOfBirth: state.dateOfBirth
        };
        return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].calculators.dates.statePensionAge(person).then(function (data) {
            return dispatch('result', data);
        });
    }, 500),
    result: function result(_ref4, data) {
        var commit = _ref4.commit;

        commit(mutationTypes.RESULT, data);
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESULT, function (state, data) {
    state.retirementAge = data.statePension.retirementAge;
    state.retirementDate = data.statePension.retirementDate;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.gender = 'male';
    state.dateOfBirth = null;
    state.retirementAge = null;
    state.retirementDate = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_routes__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_generators_step__ = __webpack_require__(21);




var steps = __WEBPACK_IMPORTED_MODULE_0_pages_mini_calculators_routes__["a" /* default */][0].children.map(function (route) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_generators_step__["b" /* buildFromRoute */])({ route: route, prefix: 'mini-calculators' });
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_generators_step__["c" /* default */])(steps));

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _mutations;




var mutationTypes = {
    UPDATE: 'UPDATE',
    RESULT: 'RESULT',
    RESET: 'RESET'
};

var state = {
    preOrPost: null,
    gender: null,
    ageOfDeceased: 0,
    dateOfBirth: null,
    dateOfDeath: null,
    dateOfTrialOrCessation: null,
    discountResult: 0,
    label: 'Pre or Post-assessment Discount',
    tableData: null,
    explanation: null
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    }
};

function calcMultiplier(state) {
    return state.preOrPost !== null && state.gender !== null && state.ageOfDeceased >= 10 && state.ageOfDeceased <= 90 && state.dateOfDeath !== null && state.dateOfDeath !== '' && state.dateOfTrialOrCessation !== null && state.dateOfTrialOrCessation !== '';
}

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutationTypes.UPDATE, { key: key, value: value });
    },

    calcMultiplier: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref3) {
        var dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (calcMultiplier(state)) {
            return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].miniCalculators.multipliers.tableEandF(state).then(function (data) {
                return dispatch('result', data);
            });
        }
    }, 500),
    result: function result(_ref4, data) {
        var commit = _ref4.commit;

        commit(mutationTypes.RESULT, data);
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.preOrPost = null;
    state.gender = null;
    state.ageOfDeceased = 0;
    state.dateOfBirth = null;
    state.dateOfDeath = null;
    state.dateOfTrialOrCessation = null;
    state.discountResult = 0;
    state.label = 'Pre or Post-assessment Discount';
    state.tableData = null;
    state.explanation = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESULT, function (state, data) {
    state.discountResult = data.result;
    state.label = data.label;
    state.tableData = data.tableData;
    state.explanation = data.explanation;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* unused harmony export dateToServer */
/* unused harmony export claimType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


var _mutations;






var types = {
    REGISTER_MODAL: 'REGISTER_MODAL',
    UNREGISTER_MODAL: 'UNREGISTER_MODAL',
    TOGGLE_MODAL: 'TOGGLE_MODAL',
    UPDATE_MODAL_CONTENT: 'UPDATE_MODAL_CONTENT',
    RESET_MODAL: 'RESET_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL'
};

var state = {
    modals: {},
    content: []
};

var dateToServer = function dateToServer(date) {
    return date ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
};

var claimType = function claimType() {
    return __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].getters['claim/type'];
};

var modalEndpoint = function modalEndpoint(calcType, args) {
    switch (calcType) {
        case 'ogden_table':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.lifeExpectancy.ogden;
        case 'percentage_of_normal_life_expectancy':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.lifeExpectancy.percentageOfNormal;
        case 'percentage_reduction_in_normal_life_expectancy':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.lifeExpectancy.percentageReduction;
        case 'table28':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.table28;
        case 'table1and2':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.table1And2;
        case 'pre':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.preAssessment;
        case 'post':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.postAssessment;
        case 'autoCare':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.care.autoCalculate;
        case 'detailedCare':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.care.detailed;
        case 'bereavementAward':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.headsOfLoss.bereavementAward;
        case 'interest':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.interest.default;
        case 'customInterest':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.interest.custom;
        case 'educationAttainment':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.education.educationAttainment;
        case 'expectedRetirementAge':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.age.retirementAge;
        case 'contingencyMultiplier':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.contingencyMultiplier;
        case 'preInjuryContingencyMultiplierPayload':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.preInjuryContingencyMultiplierPayload;
        case 'assessmentContingencyMultiplierPayload':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.assessmentContingencyMultiplierPayload;
        case 'purchase':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.purchase;
        case 'postAssessmentMultiplier':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.multipliers.postAssessmentMultiplier;
        case 'futureLossesForCare':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.care.futureLossesForCare;
        case 'futureLossesForServices':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.services.futureLossesForServices;
        case 'pensionLossMultiplier':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.pension.pensionLossMultiplier;
        case 'lumpSumMultiplier':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.pension.lumpSumMultiplier;

        case 'dayOneTable28Multiplier':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.table28Multiplier;
        case 'dayOneTableEDiscount':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.tableEDiscount;
        case 'dayOneTableFDiscount':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.tableFDiscount;
        case 'dayOneGeneralDamages':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.generalDamages;
        case 'dayOneBereavementAward':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.bereavementAward;
        case 'dayOneFuneralExpenses':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.funeralExpenses;
        case 'dayOnePastLossOfEarnings':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.pastLossOfEarnings;
        case 'dayOnePastCostOfServices':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.pastCostOfServices;
        case 'dayOneFutureCostOfServices':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.futureCostOfServices;
        case 'dayOneMiscellaneousCalc':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.miscellaneousCalc;
        case 'dayOneCostOfCare':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.costOfCare;
        case 'dayOneDependencyOnIncome':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.dependencyOnIncome;
        case 'dayOneDependencyOnServices':
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculatorModals.dayOne.dependencyOnServices;
    }
};

var modalPayload = function modalPayload(calcType, payload) {
    switch (calcType) {
        case 'ogden_table':
            return ogdenPayload(payload);
        case 'percentage_of_normal_life_expectancy':
            return percentagePayload(payload);
        case 'percentage_reduction_in_normal_life_expectancy':
            return percentagePayload(payload);
        case 'table28':
            return table28Payload(payload);
        case 'table1and2':
            return table1And2Payload(payload);
        case 'pre':
        case 'post':
            return prePostPayload(payload);
        case 'autoCare':
            return autoCarePayload();
        case 'detailedCare':
            return detailedCarePayload(payload);
        case 'bereavementAward':
            return bereavementAwardPayload(payload);
        case 'interest':
            return interestPayload(payload);
        case 'customInterest':
            return payload;
        case 'educationAttainment':
            return educationAttainmentPayload();
        case 'expectedRetirementAge':
            return retirementAgePayload(payload);
        case 'contingencyMultiplier':
            return contingencyMultiplierPayload(payload);
        case 'postAssessmentMultiplier':
            return postAssessmentMultiplier(payload);
        case 'preInjuryContingencyMultiplierPayload':
            return preInjuryContingencyMultiplierPayload(payload);
        case 'assessmentContingencyMultiplierPayload':
            return assessmentContingencyMultiplierPayload(payload);
        case 'purchase':
            return purchasePayload(payload);
        case 'futureLossesForCare':
            return futureLossesForCare(payload);
        case 'futureLossesForServices':
            return futureLossesForServices(payload);
        case 'pensionLossMultiplier':
            return pensionLossMultiplier(payload);
        case 'lumpSumMultiplier':
            return lumpSumMultiplier(payload);
        default:
            return payload.args;
    }
};

var autoCarePayload = function autoCarePayload() {
    return {
        claim: {
            type: claimType()
        }
    };
};

var ogdenPayload = function ogdenPayload(_ref) {
    var assumedSettlement = _ref.assumedSettlement,
        person = _ref.person,
        type = _ref.type;

    return {
        type: type,
        person: {
            name: person.name,
            gender: person.gender,
            date_of_birth: dateToServer(person.dateOfBirth)
        },
        claim: {
            assumed_settlement: dateToServer(assumedSettlement),
            type: claimType()
        }
    };
};

var percentagePayload = function percentagePayload(_ref2) {
    var assumedSettlement = _ref2.assumedSettlement,
        person = _ref2.person,
        type = _ref2.type,
        value = _ref2.value;

    return {
        type: type,
        person: {
            name: person.name,
            gender: person.gender,
            date_of_birth: dateToServer(person.dateOfBirth)
        },
        claim: {
            assumed_settlement: dateToServer(assumedSettlement),
            type: claimType()
        },
        value: value
    };
};

var table28Payload = function table28Payload(_ref3) {
    var assumedSettlement = _ref3.assumedSettlement,
        person = _ref3.person,
        discountRate = _ref3.discountRate,
        duration = _ref3.duration;

    return {
        person: {
            name: person.name,
            gender: person.gender,
            date_of_birth: dateToServer(person.dateOfBirth),
            date_of_death_assumed: dateToServer(person.lifeExpectancy.dateOfDeath)
        },
        claim: {
            assumed_settlement: dateToServer(assumedSettlement),
            type: claimType()
        },
        discount_rate: discountRate,
        duration: duration
    };
};

var table1And2Payload = function table1And2Payload(_ref4) {
    var assumedSettlement = _ref4.assumedSettlement,
        person = _ref4.person,
        discountRate = _ref4.discountRate,
        duration = _ref4.duration;

    return {
        person: {
            name: person.name,
            gender: person.gender,
            date_of_birth: dateToServer(person.dateOfBirth),
            date_of_death_assumed: dateToServer(person.lifeExpectancy.dateOfDeath)
        },
        claim: {
            assumed_settlement: dateToServer(assumedSettlement),
            type: claimType()
        },
        discount_rate: discountRate,
        duration: duration
    };
};

var prePostPayload = function prePostPayload(_ref5) {
    var assumedSettlement = _ref5.assumedSettlement,
        person = _ref5.person;

    return {
        person: {
            name: person.name,
            gender: person.gender,
            date_of_birth: dateToServer(person.dateOfBirth),
            date_of_death: dateToServer(person.dateOfDeath)
        },
        claim: {
            assumed_settlement: dateToServer(assumedSettlement),
            type: claimType()
        }
    };
};

var postAssessmentMultiplier = function postAssessmentMultiplier(_ref6) {
    var period = _ref6.period,
        discountRate = _ref6.discountRate;

    return {
        period: {
            period_start: period.period_from,
            period_end: period.period_to,
            period_duration: period.duration_years,
            period_deferment: period.deferment,
            period_income_multiplicand: period.income_multiplicand,
            period_discounted_multiplicand: period.discounted_multiplicand,
            period_multiplier: period.multiplier,
            period_value: period.value
        },
        claim: {
            type: claimType()
        },
        discount_rate: discountRate
    };
};

var detailedCarePayload = function detailedCarePayload(_ref7) {
    var period = _ref7.period;

    return {
        care_period: {
            period_start: period.periodStart,
            period_end: period.periodEnd,
            hours_per_day: period.hoursPerDay,
            number_of_days: period.numberOfDays,
            rate: period.rate,
            total: period.total,
            gratuitous_care: period.gratuitousCare,
            include_first_day: period.includeFirstDay,
            include_last_day: period.includeLastDay
        },
        claim: {
            type: claimType()
        }
    };
};

var futureLossesForCare = function futureLossesForCare(_ref8) {
    var period = _ref8.period,
        discountRate = _ref8.discountRate,
        person = _ref8.person;

    return {
        period: period,
        person: {
            gender: person.gender,
            date_of_birth: dateToServer(person.date_of_birth)
        },
        claim: {
            type: claimType()
        },
        claimInfo: {
            discount_rate: discountRate,
            date_of_assumed_settlement: dateToServer(person.date_of_assumed_settlement)
        }
    };
};

var futureLossesForServices = function futureLossesForServices(_ref9) {
    var service = _ref9.service,
        discountRate = _ref9.discountRate,
        person = _ref9.person;

    return {
        service: service,
        person: {
            gender: person.gender,
            date_of_birth: dateToServer(person.date_of_birth)
        },
        claim: {
            type: claimType()
        },
        claimInfo: {
            discount_rate: discountRate,
            date_of_assumed_settlement: dateToServer(person.date_of_assumed_settlement)
        }
    };
};

var pensionLossMultiplier = function pensionLossMultiplier(_ref10) {
    var pension = _ref10.pension,
        claimant = _ref10.claimant,
        claimInfo = _ref10.claimInfo;

    return {
        pension: pension,
        claimInfo: {
            discount_rate: claimInfo.discountRate,
            date_of_assumed_settlement: dateToServer(claimInfo.dateOfAssumedSettlement)
        },
        person: {
            gender: claimant.gender,
            date_of_birth: dateToServer(claimant.dateOfBirth)
        },
        claim: {
            type: "personal_injury"
        }
    };
};

var lumpSumMultiplier = function lumpSumMultiplier(_ref11) {
    var pension = _ref11.pension,
        claimant = _ref11.claimant,
        claimInfo = _ref11.claimInfo;

    return {
        pension: pension,
        claimInfo: {
            discount_rate: claimInfo.discountRate,
            date_of_assumed_settlement: dateToServer(claimInfo.dateOfAssumedSettlement)
        },
        person: {
            gender: claimant.gender,
            date_of_birth: dateToServer(claimant.dateOfBirth)
        },
        claim: {
            type: "personal_injury"
        }
    };
};

var bereavementAwardPayload = function bereavementAwardPayload(_ref12) {
    var person = _ref12.person,
        _ref12$type = _ref12.type,
        type = _ref12$type === undefined ? claimType() : _ref12$type;

    return {
        person: {
            name: person.name,
            gender: person.gender,
            date_of_birth: dateToServer(person.dateOfBirth),
            date_of_death: dateToServer(person.dateOfDeath)
        },
        claim: { type: type }
    };
};

var interestPayload = function interestPayload(_ref13) {
    var interimPayments = _ref13.interimPayments,
        assumedSettlement = _ref13.assumedSettlement,
        serviceOfProceedings = _ref13.serviceOfProceedings,
        onsetOfSymptoms = _ref13.onsetOfSymptoms,
        assumedLifeExpectancy = _ref13.assumedLifeExpectancy,
        deductibles = _ref13.deductibles,
        headsOfLoss = _ref13.headsOfLoss,
        headOfLoss = _ref13.headOfLoss;

    return {
        claim: {
            assumed_settlement: dateToServer(assumedSettlement),
            service_of_proceedings: dateToServer(serviceOfProceedings),
            type: claimType()
        },
        deceased: {
            onset_of_symptoms: dateToServer(onsetOfSymptoms)
        },
        deductibles: deductibles,
        heads_of_loss: {
            pastDependencyOnIncome: headsOfLoss.pastDependencyOnIncome,
            pastDependencyOnServices: headsOfLoss.pastDependencyOnServices || headsOfLoss.pastCostOfServices,
            generalDamages: headsOfLoss.generalDamages,
            bereavementAward: headsOfLoss.bereavementAward,
            funeralExpenses: headsOfLoss.funeralExpenses,
            lossOfSpouse: headsOfLoss.lossOfSpouse,
            pastLossOfEarnings: headsOfLoss.pastLossOfEarnings,
            pastCostOfCare: headsOfLoss.pastCostOfCare,
            futureCostOfCare: headsOfLoss.futureCostOfCare,
            pastCostOfTravel: headsOfLoss.pastCostOfTravel,
            misc: headsOfLoss.misc
        },
        head_of_loss: headOfLoss,
        interest: {
            pastDependencyOnIncomeInterest: headsOfLoss.pastDependencyOnIncomeInterest,
            pastDependencyOnServicesInterest: headsOfLoss.pastDependencyOnServicesInterest || headsOfLoss.pastCostOfServicesInterest,
            generalDamagesInterest: headsOfLoss.generalDamagesInterest,
            bereavementAwardInterest: headsOfLoss.bereavementAwardInterest,
            funeralExpensesInterest: headsOfLoss.funeralExpensesInterest,
            lossOfSpouseInterest: headsOfLoss.lossOfSpouseInterest,
            pastCostOfCareInterest: headsOfLoss.pastCostOfCareInterest,
            futureCostOfCareInterest: headsOfLoss.futureCostOfCareInterest,
            pastCostOfTravelInterest: headsOfLoss.pastCostOfTravelInterest,
            pastLossOfEarningsInterest: headsOfLoss.pastLossOfEarningsInterest,
            miscInterest: headsOfLoss.miscInterest
        },
        interestPeriod: {
            type: headsOfLoss.interestType,
            value: headsOfLoss.customInterestDate
        },
        interimPayments: interimPayments,
        custom_heads_of_loss: headsOfLoss.customHeadsOfLoss ? headsOfLoss.customHeadsOfLoss : headsOfLoss.headsOfLoss
    };
};

var customInterestPayload = function customInterestPayload(_ref14) {
    var assumedSettlement = _ref14.assumedSettlement,
        person = _ref14.person,
        customHeadOfLoss = _ref14.customHeadOfLoss;

    return {
        claim: {
            assumed_settlement: dateToServer(assumedSettlement),
            type: claimType()
        },
        deceased: {
            date_of_death: dateToServer(person.dateOfDeath)
        },
        custom: customHeadOfLoss
    };
};

var educationAttainmentPayload = function educationAttainmentPayload() {
    return {
        claim: {
            type: claimType()
        }
    };
};

var retirementAgePayload = function retirementAgePayload(_ref15) {
    var person = _ref15.person;

    return {
        claim: {
            type: claimType()
        },
        person: person
    };
};

var contingencyMultiplierPayload = function contingencyMultiplierPayload(_ref16) {
    var assumedSettlement = _ref16.assumedSettlement,
        person = _ref16.person;

    return {
        claim: {
            type: claimType(),
            disabled: person.disabledAtAccident,
            employedAtDeath: person.employedAtDateOfDeath ? 'employed' : 'notEmployed',
            levelOfEducation: person.levelOfEducation,
            assumedSettlement: assumedSettlement
        },
        person: person,
        employedAtAccident: person.employedAtAccident
    };
};

var preInjuryContingencyMultiplierPayload = function preInjuryContingencyMultiplierPayload(_ref17) {
    var disabled = _ref17.disabled,
        education = _ref17.education,
        employment = _ref17.employment,
        gender = _ref17.gender,
        dateOfBirth = _ref17.dateOfBirth,
        assumedSettlement = _ref17.assumedSettlement;

    return {
        claim: {
            type: claimType()
        },
        disabled: disabled,
        education: education,
        employment: employment,
        gender: gender,
        dateOfBirth: dateOfBirth,
        assumedSettlement: assumedSettlement
    };
};

var assessmentContingencyMultiplierPayload = function assessmentContingencyMultiplierPayload(_ref18) {
    var disabled = _ref18.disabled,
        education = _ref18.education,
        employment = _ref18.employment,
        gender = _ref18.gender,
        dateOfBirth = _ref18.dateOfBirth,
        assumedSettlement = _ref18.assumedSettlement;

    return {
        claim: {
            type: claimType()
        },
        disabled: disabled,
        education: education,
        employment: employment,
        gender: gender,
        dateOfBirth: dateOfBirth,
        assumedSettlement: assumedSettlement
    };
};

var purchasePayload = function purchasePayload(_ref19) {
    var purchase = _ref19.purchase,
        claimInfo = _ref19.claimInfo;

    return {
        purchase: {
            description: purchase.description,
            discount: purchase.discount,
            frequency: purchase.frequency,
            multiplicand: purchase.multiplicand,
            multiplier: purchase.multiplier,
            purchase_date: purchase.purchaseDate,
            purchase_end_date: purchase.purchaseEnd,
            purchase_until: purchase.purchaseUntil,
            resale_option: purchase.resaleOption,
            resale_total: purchase.resaleTotal,
            resale_value: purchase.resaleValue,
            mortality_multiplier: purchase.mortalityMultiplier,
            total: purchase.total,
            type: purchase.type,
            assumed_settlement: claimInfo.date_of_assumed_settlement,
            date_of_birth: claimInfo.date_of_birth,
            discount_rate: claimInfo.discount_rate,
            gender: claimInfo.gender
        },
        claim: {
            type: claimType()
        }
    };
};

var getters = {
    modals: function modals(state) {
        return state.modals;
    },

    modalContent: function modalContent(state) {
        return state.content;
    }
};

var actions = {
    register: function register(_ref20, name) {
        var commit = _ref20.commit;
        return commit(types.REGISTER_MODAL, name);
    },

    toggle: function toggle(_ref21, name) {
        var commit = _ref21.commit;

        commit(types.TOGGLE_MODAL, name);
    },

    unregister: function unregister(_ref22, name) {
        var commit = _ref22.commit;
        return commit(types.UNREGISTER_MODAL, name);
    },
    getModalContent: function getModalContent(_ref23, _ref24) {
        var dispatch = _ref23.dispatch;
        var endpoint = _ref24.endpoint,
            payload = _ref24.payload;

        var hitEndpoint = modalEndpoint(endpoint);

        var withPayload = modalPayload(endpoint, payload);

        return hitEndpoint(withPayload).then(function (result) {
            return dispatch('updateModalContent', result);
        });
    },
    updateModalContent: function updateModalContent(_ref25, content) {
        var commit = _ref25.commit;

        commit(types.UPDATE_MODAL_CONTENT, content);
    },
    resetModal: function resetModal(_ref26) {
        var commit = _ref26.commit;

        commit(types.RESET_MODAL);
    },


    closeModal: function closeModal(_ref27, name) {
        var commit = _ref27.commit;
        return commit(types.CLOSE_MODAL, name);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.REGISTER_MODAL, function (state, name) {
    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.set(state.modals, name, false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UNREGISTER_MODAL, function (state, name) {
    delete state.modals[name];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.TOGGLE_MODAL, function (state, name) {
    state.modals[name] = !state.modals[name];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_MODAL_CONTENT, function (state, content) {
    state.content = content;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.RESET_MODAL, function (state) {
    state.content = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.CLOSE_MODAL, function (state, name) {
    state.modals[name] = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_generators_step__ = __webpack_require__(21);


var _mutations;





var mutationTypes = {
    RESET: 'RESET',
    SET_PERCENT: 'SET_PERCENT'
};

var state = {
    percent: 1
};

var getters = {
    percent: function percent(state) {
        return state.percent;
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            state = _ref.state;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch;

        return dispatch('setPercent', step.percent);
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 8,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_generators_step__["a" /* previousValid */])(rootState, 8)
        });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 8,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_generators_step__["a" /* previousValid */])(rootState, 8) });
    },
    setPercent: function setPercent(_ref5, value) {
        var commit = _ref5.commit;

        if (value !== 0 && !value) {
            value = 1;
        }
        return commit(mutationTypes.SET_PERCENT, value);
    },
    reset: function reset(_ref6) {
        var commit = _ref6.commit;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 8,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state = {
        percent: 1
    };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_PERCENT, function (state, percent) {
    state.percent = percent;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttleUpdateLife */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_personFunctions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);






var _mutations;












var mutationTypes = {
    SET: 'SET',
    CLEAR_STEP: 'CLEAR_STEP',
    UPDATE_CLAIMANT_VALUE: 'UPDATE_CLAIMANT_VALUE',
    UPDATE_CLAIMANT_DETAIL: 'UPDATE_CLAIMANT_DETAIL',
    UPDATE_LIFE_EXPECTANCY: 'UPDATE_LIFE_EXPECTANCY',
    UPDATE_CLAIM_INFO_VALUE: 'UPDATE_CLAIM_INFO_VALUE',
    UPDATE_LIFE_ASSUMED_EXPECTANCY: 'UPDATE_LIFE_ASSUMED_EXPECTANCY',
    UPDATE_INCOME: 'UPDATE_INCOME',
    ADD_INCOME_PERIOD: 'ADD_INCOME_PERIOD',
    UPDATE_INCOME_PERIOD: 'UPDATE_INCOME_PERIOD',
    DELETE_INCOME_PERIOD: 'DELETE_INCOME_PERIOD',
    RESET: 'RESET',
    ADD_EARNINGS_AT_INJURY: 'ADD_EARNINGS_AT_INJURY',
    ADD_POST_INJURY_INCOME_PERIOD: 'ADD_POST_INJURY_INCOME_PERIOD',
    UPDATE_PRE_ACCIDENT_EARNINGS: 'UPDATE_PRE_ACCIDENT_EARNINGS',
    UPDATE_FUTURE_EARNINGS_PRE_ACCIDENT_EARNINGS: 'UPDATE_FUTURE_EARNINGS_PRE_ACCIDENT_EARNINGS',
    UPDATE_FUTURE_EARNINGS_POST_ACCIDENT_EARNINGS: 'UPDATE_FUTURE_EARNINGS_POST_ACCIDENT_EARNINGS',
    ADD_ABSENCE_PERIOD: 'ADD_ABSENCE_PERIOD',
    DELETE_ABSENCE_PERIOD: 'DELETE_ABSENCE_PERIOD',
    UPDATE_ABSENCE_PERIOD: 'UPDATE_ABSENCE_PERIOD',
    CLEAR_PERIODS: 'CLEAR_PERIODS',
    ADD_POST_INJURY_PAYMENT: 'ADD_POST_INJURY_PAYMENT',
    DELETE_POST_INJURY_PAYMENT: 'DELETE_POST_INJURY_PAYMENT',
    DELETE_POST_INJURY_INCOME_PERIOD: 'DELETE_POST_INJURY_INCOME_PERIOD',
    RESET_POST_INJURY_INCOME_PERIOD: 'RESET_POST_INJURY_INCOME_PERIOD'
};

var rules = {
    'theClaimant.name': { type: 'text', rules: 'required' },
    'theClaimant.gender': { type: 'text', rules: 'required' },
    'theClaimant.dateOfBirth': { type: 'date', rules: 'required' },
    'claimantDetails.claimantSolicitor': { type: 'text', rules: 'required' },
    'claimantDetails.claimantReference': { type: 'text', rules: 'required' },
    'claimantDetails.injuryType': { type: 'text', rules: 'required' },
    'claimantDetails.defendantName': { type: 'text', rules: 'required' },
    'claimantDetails.yourReference': { type: 'text', rules: 'required' },
    'claimInfo.dateOfInjury': { type: 'date', rules: 'required' },
    'claimInfo.dateOfAssumedSettlement': { type: 'date', rules: 'required' },
    'claimantDetails.claimNarrative': { type: 'text', rules: 'required' }
};

function initialState() {
    return {
        theClaimant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_modules_shared_templates__["f" /* personTemplate */])(),

        claimantDetails: {
            claimNarrative: null,
            injuryType: null,
            injuryTypeOther: null,
            defendantName: {
                id: null,
                name: null,
                type: null
            },
            claimantSolicitor: {
                id: null,
                name: null,
                type: null
            },
            claimantReference: null,
            yourReference: null
        },

        claimInfo: {
            discountRate: -0.25,
            claimantReductionInLife: 0,
            proceduralStatus: 'pre-lit',
            dateOfInjury: null,
            dateOfIssueProceedings: null,
            dateOfServiceProceedings: null,
            dateOfAssumedSettlement: null,
            duration: 0,
            gender: null
        }
    };
}

var state = initialState();

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

var m = function m(value) {
    return __WEBPACK_IMPORTED_MODULE_9_moment___default()(value, 'DD/MM/YYYY');
};

var updateObject = function updateObject(dispatch, action, obj) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var proms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return dispatch(action, { key: key, value: obj[key], index: index });
    });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms);
};

var findNextPeriodStart = function findNextPeriodStart(periods, worseCase) {
    return periods.reduce(function (min, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(period.endOfPeriod, 'DD/MM/YYYY').add(1, 'days');
        return periodDate.isAfter(min) ? periodDate : min;
    }, __WEBPACK_IMPORTED_MODULE_9_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var findNextPeriodEnd = function findNextPeriodEnd(periods, worseCase) {
    return periods.reduce(function (max, period) {
        var periodDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(period.startOfPeriod, 'DD/MM/YYYY');
        return periodDate.isAfter(max) ? periodDate : max;
    }, __WEBPACK_IMPORTED_MODULE_9_moment___default()(worseCase, 'DD/MM/YYYY')).format('DD/MM/YYYY');
};

var throttledIncome = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function (period, theClaimant, dispatch, action, args) {
    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.income(period, theClaimant).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {
                dispatch(action, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: key, value: updated[key] }, args));
            }
        });
    });
}, 500);

var periodHasStartAndEnd = function periodHasStartAndEnd(period) {
    return period.startOfPeriod && period.endOfPeriod;
};

var throttledPostInjuryIncome = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function (period, state, dispatch, action, args) {
    return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.postInjuryIncome(period, state.theClaimant, state.claimInfo.dateOfInjury).then(function (updated) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(updated).forEach(function (key) {
            if (updated[key] !== null) {
                dispatch(action, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: key, value: updated[key] }, args));
            }
        });
    });
}, 500);

var throttleUpdateLife = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function (dispatch, action, person, lifeExpectancy, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        if (lifeExpectancy.method === 'assumed_percentage_of_life') {
            lifeExpectancy.method = 'percentage_of_normal_life_expectancy';
            lifeExpectancy.method = 'percentage_reduction_in_normal_life_expectancy';
        }

        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement');

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return updateObject(dispatch, action, updatedLife, index);
        });
    }
}, 500);

var calcAssumedLifeExpectancy = function calcAssumedLifeExpectancy(_ref) {
    var state = _ref.state,
        assumedLifeExpectancy = _ref.assumedLifeExpectancy;

    if (assumedLifeExpectancy.ageAtDeath || assumedLifeExpectancy.dateOfDeath || assumedLifeExpectancy.yearsLeft || assumedLifeExpectancy.monthsLeft || assumedLifeExpectancy.percentageOfNormalLifeExpectancy !== null || assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy !== null) {
        switch (assumedLifeExpectancy.method) {
            case 'assumed_years_and_months_left':
                return {
                    method: 'assumed_years_and_months_left',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: __WEBPACK_IMPORTED_MODULE_9_moment___default()().add(assumedLifeExpectancy.yearsLeft, 'years').add(assumedLifeExpectancy.monthsLeft, 'months').format('DD/MM/YYYY'),
                    ageAtDeath: __WEBPACK_IMPORTED_MODULE_9_moment___default()().add(assumedLifeExpectancy.yearsLeft, 'years').add(assumedLifeExpectancy.monthsLeft, 'months').diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY'), 'days') / 365.25,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_date':
                return {
                    method: 'assumed_date',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: __WEBPACK_IMPORTED_MODULE_9_moment___default()(assumedLifeExpectancy.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY'), 'days') / 365.25,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_age_at_death':
                var assumedDateDiff = __WEBPACK_IMPORTED_MODULE_9_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY').add(assumedLifeExpectancy.ageAtDeath, 'years').diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(), 'months');

                return {
                    method: 'assumed_age_at_death',
                    yearsLeft: Math.floor(assumedDateDiff / 12),
                    monthsLeft: assumedDateDiff - Math.floor(assumedDateDiff / 12) * 12,
                    dateOfDeath: __WEBPACK_IMPORTED_MODULE_9_moment___default()(state.theClaimant.dateOfBirth, 'DD/MM/YYYY').add(assumedLifeExpectancy.ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_percentage_of_life':
                assumedLifeExpectancy.percentageOfNormalLifeExpectancy = assumedLifeExpectancy.percentageOfNormalLifeExpectancy || 0;

                return {
                    method: 'assumed_percentage_of_life',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: assumedLifeExpectancy.percentageOfNormalLifeExpectancy,
                    percentageReductionInNormalLifeExpectancy: 100 - assumedLifeExpectancy.percentageOfNormalLifeExpectancy
                };
            case 'assumed_reduction_in_life':
                assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy = assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy || 0;

                return {
                    method: 'assumed_reduction_in_life',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: 100 - assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy,
                    percentageReductionInNormalLifeExpectancy: assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy
                };
        }
    }

    return assumedLifeExpectancy;
};

var _postInjuryIncomePeriodPaymentsValid = function _postInjuryIncomePeriodPaymentsValid(state) {
    var payments = state.theClaimant.income.postInjuryPeriods.map(function (period) {
        return period.paymentsReceived.reduce(function (valid, value) {
            return valid ? value.total !== "" && value.total !== 0 && value.date !== "" && __WEBPACK_IMPORTED_MODULE_9_moment___default()(value.date, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_9_moment___default()(state.claimInfo.dateOfInjury, 'DD/MM/YYYY')) : false;
        }, true);
    });

    return payments.reduce(function (valid, value) {
        return valid ? value === true : false;
    }, true);
};

var _postInjuryIncomePeriodsValid = function _postInjuryIncomePeriodsValid(state) {
    var periods = state.theClaimant.income.postInjuryPeriods.map(function (period) {
        if (period.employmentType !== 'absence') {
            return period.startOfPeriod !== "" && period.endOfPeriod !== "" && (period.employmentIncome !== "" || period.employmentIncome !== 0) && period.totalNetIncome > 0 && period.totalNetLoss > 0 && period.employmentType !== "";
        }
        return period.startOfPeriod !== "" && period.endOfPeriod !== "" && period.employmentType !== "";
    });

    return periods.reduce(function (valid, value) {
        return valid ? value === true : false;
    }, true);
};

var _futureEarningsValid = function _futureEarningsValid(state) {
    var preAccidentPeriods = state.theClaimant.income.futureEarningsPreAccident;
    var preAccidentPeriodsValid = preAccidentPeriods.totalNetIncome >= 0 && preAccidentPeriods.employmentIncome >= 0;

    var postAccidentPeriods = state.theClaimant.income.futureEarningsPostAccident;
    var postAccidentPeriodsValid = postAccidentPeriods.totalNetIncome >= 0 && postAccidentPeriods.employmentIncome >= 0;

    return preAccidentPeriodsValid && postAccidentPeriodsValid;
};

var _futureIncomePeriodsValid = function _futureIncomePeriodsValid(state) {
    var periods = state.theClaimant.income.futurePeriods.map(function (period) {
        return period.startOfPeriod !== "" && period.endOfPeriod !== "" && (period.employmentIncome !== "" || period.employmentIncome !== 0) && period.totalNetIncome >= 0 && __WEBPACK_IMPORTED_MODULE_9_moment___default()(period.startOfPeriod, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_9_moment___default()(period.endOfPeriod, 'DD/MM/YYYY'));
    });

    return periods.reduce(function (valid, value) {
        return valid ? value === true : false;
    }, true);
};

var postInjuryIncomePeriodPaymentsTotal = function postInjuryIncomePeriodPaymentsTotal(state) {
    return state.theClaimant.income.postInjuryPeriods.map(function (period, index) {
        return state.theClaimant.income.postInjuryPeriods[index].paymentsReceived.reduce(function (total, carry) {
            return total + carry.total;
        }, 0);
    }).reduce(function (total, payment) {
        return total + payment;
    }, 0);
};

var _retiredBetweenInjuryAndSettlement = function _retiredBetweenInjuryAndSettlement(state) {
    return __WEBPACK_IMPORTED_MODULE_9_moment___default()(state.theClaimant.income.retirementDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_9_moment___default()(state.claimInfo.dateOfAssumedSettlement, 'DD/MM/YYYY'));
};

var getters = {
    claimant: function claimant(state) {
        return state.theClaimant;
    },
    claimInfo: function claimInfo(state) {
        return state.claimInfo;
    },
    getClaimantValue: function getClaimantValue(state) {
        return function (key) {
            return state.theClaimant[key];
        };
    },
    getClaimantDetail: function getClaimantDetail(state) {
        return function (key) {
            return state.claimantDetails[key];
        };
    },
    getClaimInfo: function getClaimInfo(state) {
        return function (key) {
            return state.claimInfo[key];
        };
    },
    getIncomeValue: function getIncomeValue(state) {
        return function (key) {
            return state.theClaimant.income[key];
        };
    },
    getIncomePeriod: function getIncomePeriod(state) {
        return function (_ref2) {
            var index = _ref2.index,
                type = _ref2.type;
            return state.theClaimant.income[type + 'Periods'][index];
        };
    },
    getPreAccidentNetTotal: function getPreAccidentNetTotal(state) {
        return state.theClaimant.income.preAccident.totalNetIncome;
    },
    getPostInjuryIncomePeriods: function getPostInjuryIncomePeriods(state) {
        return state.theClaimant.income.postInjuryPeriods;
    },
    getPostInjuryIncomePeriodPayments: function getPostInjuryIncomePeriodPayments(state) {
        return function (_ref3) {
            var index = _ref3.index;
            return state.theClaimant.income.postInjuryPeriods[index].paymentsReceived;
        };
    },
    getPostInjuryIncomePeriodPaymentsTotal: function getPostInjuryIncomePeriodPaymentsTotal(state) {
        return postInjuryIncomePeriodPaymentsTotal(state);
    },
    postInjuryIncomePeriodPaymentsValid: function postInjuryIncomePeriodPaymentsValid(state) {
        return _postInjuryIncomePeriodPaymentsValid(state);
    },
    postInjuryIncomePeriodsValid: function postInjuryIncomePeriodsValid(state) {
        return _postInjuryIncomePeriodsValid(state);
    },
    futureEarningsValid: function futureEarningsValid(state) {
        return _futureEarningsValid(state);
    },
    getAllFutureLossOfIncomeTotal: function getAllFutureLossOfIncomeTotal(state) {
        return state.theClaimant.income.futurePeriods.reduce(function (total, future) {
            return total + numberVal(future.totalNetIncome);
        }, 0);
    },
    getPeriodsOfReducedEarningsTotal: function getPeriodsOfReducedEarningsTotal(state) {
        return state.theClaimant.income.pastPeriods.reduce(function (total, past) {
            return total + numberVal(past.totalNetIncome);
        }, 0);
    },
    futureIncomePeriodsValid: function futureIncomePeriodsValid(state) {
        return _futureIncomePeriodsValid(state);
    },
    pastPeriodsSubTotal: function pastPeriodsSubTotal(state) {
        var preAccident = state.theClaimant.income.preAccident.totalNetIncome;
        var calcPeriod = function calcPeriod(period) {
            return (preAccident - (period.totalNetIncome || 0)) * period.duration;
        };
        var sumPeriods = function sumPeriods(total, period) {
            return total + calcPeriod(period);
        };
        return state.theClaimant.income.pastPeriods.reduce(sumPeriods, 0);
    },
    pastIncomeTotal: function pastIncomeTotal(state, getters) {
        return getters.pastAbsenceTotal + getters.pastPeriodsSubTotal;
    },
    retiredBetweenInjuryAndSettlement: function retiredBetweenInjuryAndSettlement(state) {
        return _retiredBetweenInjuryAndSettlement(state);
    }
};

var actions = {
    save: function save(_ref4, payload) {
        var getters = _ref4.getters,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        payload.data = state;

        return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref5, step) {
        var dispatch = _ref5.dispatch,
            action = _ref5.action,
            commit = _ref5.commit;

        var data = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.camelCase(key);
        }).data;
        var theClaimant = data.theClaimant;
        var claimantDetails = data.claimantDetails;
        var claimInfo = data.claimInfo;
        theClaimant.income.ownPastLosses = !!theClaimant.income.ownPastLosses;
        theClaimant.income.ownFutureLosses = !!theClaimant.income.ownFutureLosses;

        commit(mutationTypes.SET, { key: 'theClaimant', value: theClaimant });
        commit(mutationTypes.SET, { key: 'claimantDetails', value: claimantDetails });
        commit(mutationTypes.SET, { key: 'claimInfo', value: claimInfo });
    },
    process: function process(_ref6) {
        var dispatch = _ref6.dispatch;

        dispatch('personal/step/setStepNumberValid', {
            stepNo: 0,
            valid: true }, { root: true });
    },
    validate: function validate(_ref7) {
        var commit = _ref7.commit,
            rootState = _ref7.rootState;

        var updateRules = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.clone(rules);
        if (rootState.user.user.hideNames) {
            delete rules['theClaimant.name'];
        }
        var validity = new __WEBPACK_IMPORTED_MODULE_12_services_Validator__["a" /* default */](state, updateRules).validate();

        __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 0,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_store_generators_step__["a" /* previousValid */])(rootState, 0) && validity
        });
    },
    reset: function reset(_ref8) {
        var commit = _ref8.commit;

        commit(mutationTypes.RESET);
    },
    updateClaimantValue: function updateClaimantValue(_ref9, _ref10) {
        var commit = _ref9.commit,
            dispatch = _ref9.dispatch;
        var key = _ref10.key,
            value = _ref10.value;

        commit(mutationTypes.UPDATE_CLAIMANT_VALUE, { key: key, value: value });

        if (key === "gender") {
            commit(mutationTypes.UPDATE_CLAIM_INFO_VALUE, { key: key, value: value });
        }

        if (key === 'dateOfBirth' || key === "gender") {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([dispatch('updateRetirementAgeAndDate'), dispatch('updateLifeExpectancies')]);
        }
    },
    updateClaimantDetail: function updateClaimantDetail(_ref11, _ref12) {
        var commit = _ref11.commit;
        var key = _ref12.key,
            value = _ref12.value;

        commit(mutationTypes.UPDATE_CLAIMANT_DETAIL, { key: key, value: value });
    },
    updateClaimInfo: function updateClaimInfo(_ref13, _ref14) {
        var state = _ref13.state,
            commit = _ref13.commit,
            dispatch = _ref13.dispatch,
            rootGetters = _ref13.rootGetters;
        var key = _ref14.key,
            value = _ref14.value;

        commit(mutationTypes.UPDATE_CLAIM_INFO_VALUE, { key: key, value: value });

        if (key === 'dateOfAssumedSettlement' || key === 'dateOfInjury') {
            var startDate = state.claimInfo.dateOfInjury;
            var endDate = state.claimInfo.dateOfAssumedSettlement;
            if (!startDate || !endDate) {
                return;
            }
            dispatch('accidentToSettlementDuration', { startDate: startDate, endDate: endDate }).then(function (data) {
                var duration = Number(data.years.split(" ")[0]);
                commit(mutationTypes.UPDATE_CLAIM_INFO_VALUE, { key: 'duration', value: duration });
            });
        }

        if (key === 'dateOfInjury') {
            dispatch('updateDateOfInjuryCare');
            dispatch('updateDateOfInjuryPastLossOfEarnings', value);
        }

        if (key === 'dateOfAssumedSettlement') {
            dispatch('updateDateOfAssumedSettlementCare', value);
            dispatch('updateDateOfAssumedSettlementPastLossOfEarnings', value);
            dispatch('updateDateOfAssumedSettlementFutureLosses', value);
        }

        if (key === "discountRate" && rootGetters['personal/futureLosses/shouldUpdatedFutureLosses']) {
            dispatch('personal/futureLosses/updateDiscountFactors', null, { root: true }).then(function () {
                return dispatch('updateFutureLossesEnd');
            }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(state.theClaimant.income.futurePeriods.map(function (period, index) {
                    return dispatch('getFutureLossOfEarningsMultiplier', index);
                }));
            }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([dispatch('personal/otherFutureLosses/refresh', null, { root: true }), dispatch('personal/futureLosses/updateFutureLossOfEarnings', null, { root: true }), dispatch('personal/futureLosses/updateResults', null, { root: true })]);
            });
        }
    },
    updateDateOfInjuryCare: function updateDateOfInjuryCare(_ref15) {
        var state = _ref15.state;

        if (__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherPastLosses/value']('careCalcType') === 'manual') {
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherPastLosses/updateCarePeriodValue', { key: 'periodStart', value: state.claimInfo.dateOfInjury, index: 0 }).then(__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherPastLosses/calcCareTotalForPeriod', { index: 0 }));
        }
    },
    updateDateOfInjuryPastLossOfEarnings: function updateDateOfInjuryPastLossOfEarnings(_ref16, value) {
        var state = _ref16.state,
            dispatch = _ref16.dispatch;

        if (state.theClaimant.income.pastLossOfEarnings) {
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
                stepNo: 2,
                valid: false
            });

            var period = state.theClaimant.income.postInjuryPeriods[0];
            var duration = __WEBPACK_IMPORTED_MODULE_9_moment___default()(period.endOfPeriod, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(value, 'DD/MM/YYYY'), 'years', true);
            var postInjuryPayments = period.paymentsReceived;

            var periodPaymentsTotal = postInjuryPayments.reduce(function (total, carry) {
                return total + carry.total;
            }, 0);

            period.totalNetLoss = duration * state.theClaimant.income.preAccident.totalNetIncome - duration * period.totalNetIncome - periodPaymentsTotal || 0;

            dispatch('updateIncomePeriod', { index: 0, period: period, type: 'postInjury' });
        }
    },
    updateDateOfAssumedSettlementCare: function updateDateOfAssumedSettlementCare(value) {
        if (__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherPastLosses/value']('careCalcType') === 'manual') {
            var count = __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherPastLosses/value']('periods').length;
            var period = __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherPastLosses/value']('periods')[count - 1];

            if (__WEBPACK_IMPORTED_MODULE_9_moment___default()(period.periodEnd, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_9_moment___default()(value, 'DD/MM/YYY'))) {
                __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherPastLosses/updateCarePeriodValue', { key: 'periodEnd', value: value, index: count - 1 }).then(__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherPastLosses/calcCareTotalForPeriod', { index: count - 1 }));
            }
        }
    },
    updateDateOfAssumedSettlementPastLossOfEarnings: function updateDateOfAssumedSettlementPastLossOfEarnings(_ref17, value) {
        var state = _ref17.state,
            dispatch = _ref17.dispatch;

        if (state.theClaimant.income.pastLossOfEarnings) {
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
                stepNo: 2,
                valid: false
            });

            var count = state.theClaimant.income.postInjuryPeriods.length;
            var period = state.theClaimant.income.postInjuryPeriods[count - 1];
            var duration = __WEBPACK_IMPORTED_MODULE_9_moment___default()(value, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true);
            var postInjuryPayments = period.paymentsReceived;
            var periodPaymentsTotal = postInjuryPayments.reduce(function (total, carry) {
                return total + carry.total;
            }, 0);

            period.totalNetLoss = duration * state.theClaimant.income.preAccident.totalNetIncome - duration * period.totalNetIncome - periodPaymentsTotal || 0;

            period.endOfPeriod = value;

            dispatch('updateIncomePeriod', { index: count - 1, period: period, type: 'postInjury' });
        }
    },
    updateDateOfAssumedSettlementFutureLosses: function updateDateOfAssumedSettlementFutureLosses(_ref18, value) {
        var state = _ref18.state,
            dispatch = _ref18.dispatch;

        if (__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/futureLosses/getLoss']('futureLosses')) {
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
                stepNo: 4,
                valid: false
            });
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/futureLosses/updateLoss', { key: 'futureLossesStart', value: value }).then(__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/futureLosses/updateFutureLossOfEarnings'));

            var period = state.theClaimant.income.futurePeriods[0];
            period.startOfPeriod = value;
            dispatch('updatePostInjuryIncomePeriod', { index: 0, period: period, type: 'future' });
        }
    },
    updateClaimantIncome: function updateClaimantIncome(_ref19, _ref20) {
        var dispatch = _ref19.dispatch;
        var income = _ref20.income;

        return updateObject(dispatch, 'updateIncomeValue', income);
    },
    updateFutureEarningsPreAccidentEarnings: function updateFutureEarningsPreAccidentEarnings(_ref21) {
        var state = _ref21.state,
            dispatch = _ref21.dispatch;

        var period = {
            employmentIncome: state.theClaimant.income.futureEarningsPreAccident.employmentIncome,
            employmentNetGross: state.theClaimant.income.futureEarningsPreAccident.employmentNetGross,
            startOfPeriod: state.claimInfo.dateOfAssumedSettlement,
            endOfPeriod: __WEBPACK_IMPORTED_MODULE_9_moment___default()(state.claimInfo.dateOfAssumedSettlement, 'DD/MM/YYYY').add(1, 'y').format('DD/MM/YYYY')
        };

        throttledIncome(period, state.theClaimant, dispatch, 'updateFutureEarningsPreAccidentEarningsValue');
    },
    updateFutureEarningsPreAccidentEarningsValue: function updateFutureEarningsPreAccidentEarningsValue(_ref22, payload) {
        var commit = _ref22.commit,
            dispatch = _ref22.dispatch;

        commit(mutationTypes.UPDATE_FUTURE_EARNINGS_PRE_ACCIDENT_EARNINGS, payload);

        if (payload.key === 'employmentNetGross') {
            dispatch('updateFutureEarningsPostAccidentEarnings');
        }
    },
    updateFutureEarningsPostAccidentEarnings: function updateFutureEarningsPostAccidentEarnings(_ref23) {
        var state = _ref23.state,
            dispatch = _ref23.dispatch;

        var period = {
            employmentIncome: state.theClaimant.income.futureEarningsPostAccident.employmentIncome,
            employmentNetGross: state.theClaimant.income.futureEarningsPostAccident.employmentNetGross,
            startOfPeriod: state.claimInfo.dateOfAssumedSettlement,
            endOfPeriod: __WEBPACK_IMPORTED_MODULE_9_moment___default()(state.claimInfo.dateOfAssumedSettlement, 'DD/MM/YYYY').add(1, 'y').format('DD/MM/YYYY')
        };

        throttledIncome(period, state.theClaimant, dispatch, 'updateFutureEarningsPostAccidentEarningsValue');
    },
    updateFutureEarningsPostAccidentEarningsValue: function updateFutureEarningsPostAccidentEarningsValue(_ref24, payload) {
        var commit = _ref24.commit,
            dispatch = _ref24.dispatch;

        commit(mutationTypes.UPDATE_FUTURE_EARNINGS_POST_ACCIDENT_EARNINGS, payload);

        if (payload.key === 'employmentNetGross') {
            dispatch('updateFutureEarningsPostAccidentEarnings');
        }
    },
    updateIncomeValue: function updateIncomeValue(_ref25, _ref26) {
        var commit = _ref25.commit,
            state = _ref25.state,
            dispatch = _ref25.dispatch;
        var key = _ref26.key,
            value = _ref26.value;

        if (key != null && state.theClaimant.income[key] !== value) {
            commit(mutationTypes.UPDATE_INCOME, { key: key, value: value });
        }

        if (key === 'pastLossOfEarnings' && value === false) {
            commit(mutationTypes.CLEAR_STEP);
        }
    },
    addIncomePeriod: function addIncomePeriod(_ref27, type) {
        var commit = _ref27.commit,
            state = _ref27.state;

        var periods = state.theClaimant.income[type + 'Periods'];
        var start = typeof periods !== 'undefined' ? findNextPeriodStart(periods, state.claimInfo.dateOfInjury) : state.claimInfo.dateOfInjury;
        var end = typeof periods !== 'undefined' ? findNextPeriodEnd(periods, state.claimInfo.dateOfAssumedSettlement) : state.claimInfo.dateOfAssumedSettlement;

        if (__WEBPACK_IMPORTED_MODULE_9_moment___default()(start, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_9_moment___default()(end, 'DD/MM/YYYY'))) {
            start = end;
        }

        if (type === 'postInjury') {
            if (_retiredBetweenInjuryAndSettlement(state)) {
                end = state.theClaimant.income.retirementDate;
            }

            return commit(mutationTypes.ADD_POST_INJURY_INCOME_PERIOD, {
                type: type, period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_modules_shared_templates__["q" /* postInjuryIncomeTemplate */])({
                    start: start,
                    end: end
                })
            });
        }

        if (type === 'past') {
            start = findNextPeriodStart(periods, state.claimInfo.dateOfInjury);
            end = findNextPeriodEnd(periods, state.claimInfo.dateOfAssumedSettlement);
        }

        if (type === 'future') {
            start = findNextPeriodStart(periods, state.claimInfo.dateOfAssumedSettlement);
            end = findNextPeriodEnd(periods, __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/futureLosses/getLoss']('futureLossesEnd') || state.theClaimant.income.retirementDate);
        }

        commit(mutationTypes.ADD_INCOME_PERIOD, {
            type: type,
            period: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_modules_shared_templates__["a" /* defaultIncomePeriodTemplate */])({
                start: start ? start : "",
                end: end ? end : ""
            })
        });
    },
    updateIncomePeriod: function updateIncomePeriod(_ref28, _ref29) {
        var dispatch = _ref28.dispatch,
            state = _ref28.state;
        var index = _ref29.index,
            period = _ref29.period,
            type = _ref29.type;

        var proms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(period).map(function (key) {
            return dispatch('updateIncomePeriodValue', { type: type, key: key, value: period[key], index: index });
        });

        if (period.endOfPeriod === "" || period.endOfPeriod === null || period.startOfPeriod === "" || period.startOfPeriod === null || period.employmentIncome === "" || period.pensionIncome === "" || period.employmentIncome < 1 || period.pensionIncome < 1 || period.employmentIncome === null || period.pensionIncome === null) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms).then(function () {
            throttledIncome(period, state.theClaimant, dispatch, 'updateIncomePeriodValue', { index: index, type: type });
        });
    },
    updateIncomePeriodValue: function updateIncomePeriodValue(_ref30, _ref31) {
        var commit = _ref30.commit,
            state = _ref30.state,
            dispatch = _ref30.dispatch;
        var index = _ref31.index,
            key = _ref31.key,
            value = _ref31.value,
            type = _ref31.type;

        var currentPeriod = state.theClaimant.income[type + 'Periods'][index];
        if (currentPeriod[key] === value || type === "past" && key === "duration") {
            return;
        }
        commit(mutationTypes.UPDATE_INCOME_PERIOD, { index: index, key: key, value: value, type: type });

        if (type === 'future') {
            dispatch('getFutureLossOfEarningsMultiplier', index);
        }
    },
    addPostInjuryIncomePeriod: function addPostInjuryIncomePeriod(_ref32) {
        var commit = _ref32.commit;

        commit(mutationTypes.ADD_POST_INJURY_INCOME_PERIOD);
    },
    deletePostInjuryPeriod: function deletePostInjuryPeriod(_ref33, _ref34) {
        var commit = _ref33.commit;
        var index = _ref34.index;

        commit(mutationTypes.DELETE_POST_INJURY_INCOME_PERIOD, { index: index });
    },
    resetPostInjuryPeriod: function resetPostInjuryPeriod(_ref35) {
        var commit = _ref35.commit;

        commit(mutationTypes.RESET_POST_INJURY_INCOME_PERIOD);
    },
    addPostInjuryPeriodPayment: function addPostInjuryPeriodPayment(_ref36, _ref37) {
        var commit = _ref36.commit;
        var index = _ref37.index;

        commit(mutationTypes.ADD_POST_INJURY_PAYMENT, index);
    },
    removePostInjuryPayment: function removePostInjuryPayment(_ref38, _ref39) {
        var commit = _ref38.commit;
        var period = _ref39.period,
            payment = _ref39.payment;

        commit(mutationTypes.DELETE_POST_INJURY_PAYMENT, { period: period, payment: payment });
    },
    updatePostInjuryIncomePeriod: function updatePostInjuryIncomePeriod(_ref40, _ref41) {
        var state = _ref40.state,
            dispatch = _ref40.dispatch,
            commit = _ref40.commit;
        var index = _ref41.index,
            period = _ref41.period,
            type = _ref41.type;

        var proms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(period).map(function (key) {
            return dispatch('updateIncomePeriodValue', { type: type, key: key, value: period[key], index: index });
        });

        if (period.startOfPeriod && period.startOfPeriod === '' || period.endOfPeriod && period.endOfPeriod === '' || period.employmentIncome === 0 || period.employmentType === '' || __WEBPACK_IMPORTED_MODULE_9_moment___default()(period.startOfPeriod, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_9_moment___default()(period.endOfPeriod))) {
            commit(mutationTypes.UPDATE_INCOME_PERIOD, { index: index, key: 'totalNetIncome', value: 0, type: type });
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(proms).then(function () {
            return throttledPostInjuryIncome(period, state, dispatch, 'updateIncomePeriodValue', { index: index, type: type });
        });
    },
    deleteIncomePeriod: function deleteIncomePeriod(_ref42, _ref43) {
        var commit = _ref42.commit,
            state = _ref42.state,
            dispatch = _ref42.dispatch;
        var index = _ref43.index,
            type = _ref43.type;

        commit(mutationTypes.DELETE_INCOME_PERIOD, { index: index, type: type });
        if (!state.theClaimant.income[type + 'Periods'].length) {
            return dispatch('addIncomePeriod', { type: type });
        }
    },

    updateRetirementAgeAndDate: __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function (_ref44) {
        var state = _ref44.state,
            commit = _ref44.commit,
            dispatch = _ref44.dispatch;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_components_form_validator_validations__["a" /* validDate */])(state.theClaimant.dateOfBirth) || !state.theClaimant.gender) {
            return;
        }
        return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.dates.statePensionAge(state.theClaimant).then(function (data) {
            commit(mutationTypes.UPDATE_INCOME, {
                key: 'retirementAge',
                value: data.statePension.retirementAge
            });
            commit(mutationTypes.UPDATE_INCOME, {
                key: 'retirementDate',
                value: data.statePension.retirementDate
            });
            dispatch('updateFutureLossesEnd');
            dispatch('checkToUpdatePension', data);
        });
    }, 500),
    checkToUpdatePension: function checkToUpdatePension(_ref45, data) {
        var rootState = _ref45.rootState;

        if (__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/value']('futureLossOfPension')) {
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherFutureLosses/setPension', {
                key: 'butForRetirementDate',
                value: data.statePension.retirementDate
            });
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherFutureLosses/setPension', {
                key: 'butForRetirementAge',
                value: data.statePension.retirementAge
            });
        }
    },
    updateLifeExpectancies: function updateLifeExpectancies() {
        if (__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/value']('futureLossOfCare') && __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/careValue']('lossesForLife')) {

            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherFutureLosses/updateLifeForCare', __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/value']('careLifeExpectancy')).then(__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherFutureLosses/updateCare'));
        }

        if (__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/value']('futureLossOfServices') && __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/servicesValue']('lossesForLife')) {

            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherFutureLosses/updateLifeForServices', __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/value']('servicesLifeExpectancy')).then(__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherFutureLosses/updateServices'));
        }
    },
    updateFutureLossesEnd: function updateFutureLossesEnd(_ref46) {
        var state = _ref46.state,
            dispatch = _ref46.dispatch;

        if (__WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/futureLosses/getLoss']('futureLosses')) {
            var futureLossesEnd = __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/futureLosses/getLoss']('futureLossesToRetirement') ? state.theClaimant.income.retirementDate : __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/futureLosses/getLoss']('futureLossesEnd');

            var futurePeriods = state.theClaimant.income.futurePeriods;

            dispatch('updateIncomePeriodValue', {
                index: futurePeriods.length - 1,
                key: 'endOfPeriod',
                value: futureLossesEnd,
                type: 'future'
            });

            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/futureLosses/updateLoss', { key: 'futureLossesEnd', value: futureLossesEnd });
        }
    },
    clearFuturePeriods: function clearFuturePeriods(_ref47) {
        var commit = _ref47.commit,
            dispatch = _ref47.dispatch;

        commit(mutationTypes.CLEAR_PERIODS);
        dispatch('addIncomePeriod', 'future');
    },
    updatePreAccidentEarnings: function updatePreAccidentEarnings(_ref48) {
        var state = _ref48.state,
            dispatch = _ref48.dispatch;

        var period = {
            employmentType: state.theClaimant.income.preAccident.employmentType,
            employmentIncome: state.theClaimant.income.preAccident.employmentIncome,
            employmentNetGross: state.theClaimant.income.preAccident.employmentNetGross,
            startOfPeriod: state.claimInfo.dateOfInjury,
            endOfPeriod: state.claimInfo.dateOfAssumedSettlement
        };

        throttledIncome(period, state.theClaimant, dispatch, 'updatePreAccidentEarningsValue');
    },
    updatePreAccidentEarningsValue: function updatePreAccidentEarningsValue(_ref49, payload) {
        var commit = _ref49.commit,
            dispatch = _ref49.dispatch;

        commit(mutationTypes.UPDATE_PRE_ACCIDENT_EARNINGS, payload);

        if (payload.key === 'employmentNetGross' || payload.key === "employmentType") {
            return dispatch("updatePreAccidentEarnings");
        }
    },
    accidentToSettlementDuration: function accidentToSettlementDuration(_ref50, _ref51) {
        var state = _ref50.state;
        var startDate = _ref51.startDate,
            endDate = _ref51.endDate;

        if (state.claimInfo.dateOfAssumedSettlement && state.claimInfo.dateOfInjury) {
            var dates = {
                firstDate: startDate,
                secondDate: endDate,
                options: {
                    dp: 2,
                    includeBankHolidays: true,
                    includeFirstDay: true,
                    includeLastDay: true,
                    includeWeekends: true,
                    show: {
                        years: true,
                        months: false,
                        weeks: false,
                        days: false
                    }
                }
            };

            return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].miniCalculators.dates.PeriodBetweenTwoDates(dates);
        }
    },
    updateLifeExpectancy: function updateLifeExpectancy(_ref52, _ref53) {
        var dispatch = _ref52.dispatch,
            state = _ref52.state;
        var lifeExpectancy = _ref53.lifeExpectancy,
            type = _ref53.type;

        return updateObject(dispatch, 'updateLifeExpectancyValue', lifeExpectancy).then(function () {
            return throttleUpdateLife(dispatch, 'updateLifeExpectancyValue', state.theClaimant, lifeExpectancy);
        });
    },
    updateLifeExpectancyValue: function updateLifeExpectancyValue(_ref54, _ref55) {
        var commit = _ref54.commit,
            state = _ref54.state,
            dispatch = _ref54.dispatch;
        var key = _ref55.key,
            value = _ref55.value;

        if (state.theClaimant.lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_LIFE_EXPECTANCY, { key: key, value: value });
        }

        if (key === 'dateOfDeath' && __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/value']('reductionInLife') === false) {
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherFutureLosses/set', {
                key: 'careEndDate',
                value: value
            });
        }
    },
    updateClaimantAssumedLifeExpectancy: function updateClaimantAssumedLifeExpectancy(_ref56, _ref57) {
        var dispatch = _ref56.dispatch,
            state = _ref56.state;
        var assumedLifeExpectancy = _ref57.assumedLifeExpectancy;

        var assumedLifeExpectancyResult = calcAssumedLifeExpectancy({ state: state, assumedLifeExpectancy: assumedLifeExpectancy });

        return updateObject(dispatch, 'updateClaimantAssumedLifeExpectancyValue', assumedLifeExpectancyResult).then(function () {
            return throttleUpdateLife(dispatch, 'updateClaimantAssumedLifeExpectancyValue', state.theClaimant, assumedLifeExpectancyResult);
        });
    },
    updateClaimantAssumedLifeExpectancyValue: function updateClaimantAssumedLifeExpectancyValue(_ref58, _ref59) {
        var commit = _ref58.commit,
            state = _ref58.state,
            dispatch = _ref58.dispatch;
        var key = _ref59.key,
            value = _ref59.value;

        commit(mutationTypes.UPDATE_LIFE_ASSUMED_EXPECTANCY, { key: key, value: value });

        if (key === 'dateOfDeath' && __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/otherFutureLosses/value']('reductionInLife') === true) {
            __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].dispatch('personal/otherFutureLosses/set', {
                key: 'careEndDate',
                value: value
            });
        }

        dispatch('updateReductionInLife');
    },
    updateReductionInLife: function updateReductionInLife(_ref60) {
        var state = _ref60.state,
            dispatch = _ref60.dispatch;

        if (state.theClaimant.assumedLifeExpectancy.ageAtDeath && state.theClaimant.lifeExpectancy.ageAtDeath) {
            var claimantReductionInLife = state.theClaimant.lifeExpectancy.ageAtDeath - state.theClaimant.assumedLifeExpectancy.ageAtDeath;
            dispatch('updateClaimInfo', { key: 'claimantReductionInLife', value: claimantReductionInLife });
        }
    },
    getFutureLossOfEarningsMultiplier: function getFutureLossOfEarningsMultiplier(_ref61, index) {
        var state = _ref61.state,
            commit = _ref61.commit,
            dispatch = _ref61.dispatch;

        var period = state.theClaimant.income.futurePeriods[index];
        var duration = __WEBPACK_IMPORTED_MODULE_9_moment___default()(period.endOfPeriod, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true);
        var MortalityMultiplier = __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/futureLosses/getLoss']('futureLossesMortalityMultiplier');
        var futureLossesToRetirement = __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/futureLosses/getLoss']('futureLossesToRetirement');

        if (duration > 0 && MortalityMultiplier !== null) {
            var claimInfo = __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo'];
            var claimantInfo = __WEBPACK_IMPORTED_MODULE_10_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue'];
            return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.futureLossMultiplier({
                duration: __WEBPACK_IMPORTED_MODULE_9_moment___default()(period.endOfPeriod, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true),
                discountRate: claimInfo('discountRate'),
                gender: claimantInfo('gender'),
                dateOfBirth: claimantInfo('dateOfBirth'),
                assumedSettlement: claimInfo('dateOfAssumedSettlement'),
                retirementAge: claimantInfo('income').retirementAge,
                futureLossesToRetirement: futureLossesToRetirement
            }).then(function (data) {
                return dispatch('updateIncomePeriodValue', {
                    index: index,
                    key: 'futureLossOfEarningsMultiplier',
                    value: data.multiplier.toFixed(2),
                    type: 'future'
                });
            });
        }
    },
    updateFutureLossOfEarningsMultiplier: function updateFutureLossOfEarningsMultiplier(_ref62) {
        var state = _ref62.state,
            dispatch = _ref62.dispatch;

        state.theClaimant.income.futurePeriods.forEach(function (period, index) {
            dispatch('getFutureLossOfEarningsMultiplier', index);
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(state, payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIMANT_VALUE, function (state, payload) {
    state.theClaimant[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIMANT_DETAIL, function (state, payload) {
    state.claimantDetails[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIM_INFO_VALUE, function (state, payload) {
    state.claimInfo[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCOME, function (state, _ref63) {
    var key = _ref63.key,
        value = _ref63.value;

    state.theClaimant.income = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.theClaimant.income, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, value));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LIFE_EXPECTANCY, function (state, _ref64) {
    var key = _ref64.key,
        value = _ref64.value;

    state.theClaimant.lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LIFE_ASSUMED_EXPECTANCY, function (state, _ref65) {
    var key = _ref65.key,
        value = _ref65.value;

    state.theClaimant.assumedLifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_INCOME_PERIOD, function (state, payload) {
    payload.period.index = state.theClaimant.income[payload.type + 'Periods'].length;
    state.theClaimant.income[payload.type + 'Periods'].push(payload.period);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCOME_PERIOD, function (state, _ref66) {
    var key = _ref66.key,
        value = _ref66.value,
        index = _ref66.index,
        type = _ref66.type;

    var period = state.theClaimant.income[type + 'Periods'][index];
    period[key] = value;
    if ((key === "startOfPeriod" || key === "endOfPeriod") && period.startOfPeriod && period.endOfPeriod) {
        period.duration = Math.round(m(period.endOfPeriod).diff(m(period.startOfPeriod), 'years', true) * 10) / 10;
    }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_INCOME_PERIOD, function (state, payload) {
    state.theClaimant.income[payload.type + 'Periods'].splice(payload.index, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, initialState());
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_EARNINGS_AT_INJURY, function (state) {
    state.theClaimant.income.pastPeriods.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_modules_shared_templates__["r" /* earningsAtInjuryTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_POST_INJURY_INCOME_PERIOD, function (state, payload) {
    payload.period.index = state.theClaimant.income[payload.type + 'Periods'].length;
    state.theClaimant.income.postInjuryPeriods.push(payload.period);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_POST_INJURY_INCOME_PERIOD, function (state, index) {
    state.theClaimant.income.postInjuryPeriods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_POST_INJURY_INCOME_PERIOD, function (state) {
    state.theClaimant.income.postInjuryPeriods = [];
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_POST_INJURY_PAYMENT, function (state, index) {
    state.theClaimant.income.postInjuryPeriods[index].paymentsReceived.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_modules_shared_templates__["s" /* paymentsReceivedTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_POST_INJURY_PAYMENT, function (state, payload) {
    state.theClaimant.income.postInjuryPeriods[payload.period].paymentsReceived.splice(payload.payment, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_PRE_ACCIDENT_EARNINGS, function (state, payload) {
    state.theClaimant.income.preAccident[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FUTURE_EARNINGS_PRE_ACCIDENT_EARNINGS, function (state, payload) {
    state.theClaimant.income.futureEarningsPreAccident[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FUTURE_EARNINGS_POST_ACCIDENT_EARNINGS, function (state, payload) {
    state.theClaimant.income.futureEarningsPostAccident[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_ABSENCE_PERIOD, function (state) {
    state.theClaimant.income.absencePeriods.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_modules_shared_templates__["t" /* absenceTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_ABSENCE_PERIOD, function (state, index) {
    state.theClaimant.income.absencePeriods.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_ABSENCE_PERIOD, function (state, _ref67) {
    var key = _ref67.key,
        value = _ref67.value,
        index = _ref67.index;

    var absencePeriod = state.theClaimant.income.absencePeriods[index];
    absencePeriod[key] = value;
    if ((key === "startOfPeriod" || key === "endOfPeriod") && absencePeriod.startOfPeriod && absencePeriod.endOfPeriod) {
        absencePeriod.duration = Math.round(m(absencePeriod.endOfPeriod).diff(m(absencePeriod.startOfPeriod), 'years', true) * 10) / 10;
    }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LIFE_EXPECTANCY, function (state, _ref68) {
    var key = _ref68.key,
        value = _ref68.value;

    state.theClaimant.lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CLEAR_PERIODS, function (state) {
    state.theClaimant.income.futurePeriods = [];
    state.theClaimant.income.pastPeriods = [];
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CLEAR_STEP, function (state) {
    state.theClaimant.income.preAccident.employmentType = 'employed';
    state.theClaimant.income.preAccident.employmentIncome = 0;
    state.theClaimant.income.preAccident.employmentNetGross = 'gross';
    state.theClaimant.income.preAccident.totalNetIncome = 0;
    state.theClaimant.income.postInjuryPeriods = [];

    var periods = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.theClaimant.income.postInjuryPeriods);
    var start = findNextPeriodStart(periods, state.claimInfo.dateOfInjury);
    var end = findNextPeriodStart(periods, state.claimInfo.dateOfAssumedSettlement);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.theClaimant.income.postInjuryPeriods, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_modules_shared_templates__["q" /* postInjuryIncomeTemplate */])({ start: start, end: end })]);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_generators_step__ = __webpack_require__(21);







var mutationTypes = {
    RESET: 'RESET'
};

var rootRules = {
    'personal.claimant.theClaimant.gender': { type: 'text', rules: 'required' },
    'personal.claimant.theClaimant.dateOfBirth': { type: 'date', rules: 'required' },
    'personal.claimant.theClaimant.levelOfEducation': { type: 'text', rules: 'required' },
    'personal.claimant.theClaimant.disabledAtAccident': { type: 'text', rules: 'required' },
    'personal.claimant.theClaimant.employedAtAccident': { type: 'text', rules: 'required' },
    'personal.claimant.theClaimant.disabledAtTrial': { type: 'text', rules: 'required' },
    'personal.claimant.theClaimant.employedAtTrial': { type: 'text', rules: 'required' }
};

var state = {};

var getters = {};

var actions = {
    save: function save(_ref) {
        var rootState = _ref.rootState;

        __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].claims.save({}).then(function (response) {
            return response;
        });

        var payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_modules_claim__["d" /* requestPayload */])(0);
        payload.data = rootState.personal.claimant;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('personal/save', payload);
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 1,
            valid: true });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 1,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 1) && new __WEBPACK_IMPORTED_MODULE_4_services_Validator__["a" /* default */](rootState, rootRules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 1,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.RESET, function (state) {});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_generators_step__ = __webpack_require__(21);



var _mutations;






var mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    UPDATE_INCLUDE: 'UPDATE_INCLUDE',
    RESET: 'RESET',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER'
};

var cruTemplate = function cruTemplate() {
    return {
        value: 0,
        include: false
    };
};

var getTotal = function getTotal(state) {
    var cru = _.mapValues(state, function (cru) {
        if (cru.include === true) {
            return cru.value;
        }
        return 0;
    });

    var totals = _.values(cru);

    return totals.reduce(function (carry, item) {
        return carry + item;
    });
};

var state = {
    gdPneumoconiosis: cruTemplate(),
    gdMesothelioma: cruTemplate(),
    ploeDisabilityWorkingAllowance: cruTemplate(),
    ploeEmploymentSupportAllowance: cruTemplate(),
    ploeIncapacityBenefit: cruTemplate(),
    ploeIncomeSupport: cruTemplate(),
    ploeIndustrialInjuriesDisablementBenefit: cruTemplate(),
    ploeInvalidityPension: cruTemplate(),
    ploeInvalidityAllowance: cruTemplate(),
    ploeJobseekersAllowance: cruTemplate(),
    ploeReducedEarningsAllowance: cruTemplate(),
    ploeSevereDisablementAllowance: cruTemplate(),
    ploeSicknessBenefit: cruTemplate(),
    ploeStatutorySickPay: cruTemplate(),
    ploeUnemployabilitySupplement: cruTemplate(),
    ploeUnemploymentBenefit: cruTemplate(),
    ploeUniversalCredit: cruTemplate(),
    pcocAttendanceAllowance: cruTemplate(),
    pcocDisabilityLivingAllowance: cruTemplate(),
    pcocIndustrialInjuriesDisablementBenefit: cruTemplate(),
    pcocPersonalIndependencePayment: cruTemplate(),
    pcotDisabilityLivingAllowance: cruTemplate(),
    pcotMobilityAllowance: cruTemplate(),
    pcotPersonalIndependencePayment: cruTemplate()
};

var rules = {};

var returnCruValue = function returnCruValue(cru) {
    if (cru.include) {
        return parseFloat(cru.value);
    }
    return 0;
};

var generalDamagesOffset = function generalDamagesOffset(state) {
    var cruTotal = returnCruValue(state.gdPneumoconiosis) + returnCruValue(state.gdMesothelioma);
    var gdHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['personal/generalDamages/getGeneralDamages'];

    if (cruTotal >= gdHeadOfLoss) {
        return gdHeadOfLoss;
    }

    return cruTotal;
};

var pastLossOfEarningsOffset = function pastLossOfEarningsOffset(state) {
    var cruTotal = returnCruValue(state.ploeDisabilityWorkingAllowance) + returnCruValue(state.ploeEmploymentSupportAllowance) + returnCruValue(state.ploeIncapacityBenefit) + returnCruValue(state.ploeIncomeSupport) + returnCruValue(state.ploeIndustrialInjuriesDisablementBenefit) + returnCruValue(state.ploeInvalidityPension) + returnCruValue(state.ploeInvalidityAllowance) + returnCruValue(state.ploeJobseekersAllowance) + returnCruValue(state.ploeReducedEarningsAllowance) + returnCruValue(state.ploeSevereDisablementAllowance) + returnCruValue(state.ploeSicknessBenefit) + returnCruValue(state.ploeStatutorySickPay) + returnCruValue(state.ploeUnemployabilitySupplement) + returnCruValue(state.ploeUnemploymentBenefit) + returnCruValue(state.ploeUniversalCredit);

    var ploeHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['personal/claimant/getIncomeValue']('pastLossOfEarningsNetTotal');

    if (cruTotal >= ploeHeadOfLoss) {
        return ploeHeadOfLoss;
    }

    return cruTotal;
};

var pastCostOfCareOffset = function pastCostOfCareOffset(state) {
    var cruTotal = returnCruValue(state.pcocAttendanceAllowance) + returnCruValue(state.pcocDisabilityLivingAllowance) + returnCruValue(state.pcocIndustrialInjuriesDisablementBenefit) + returnCruValue(state.pcocPersonalIndependencePayment);

    var pcocHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['personal/otherPastLosses/value']('pastCostOfCare');

    if (cruTotal >= pcocHeadOfLoss) {
        return pcocHeadOfLoss;
    }

    return cruTotal;
};

var pastCostOfTravelOffset = function pastCostOfTravelOffset(state) {
    var cruTotal = returnCruValue(state.pcotDisabilityLivingAllowance) + returnCruValue(state.pcotMobilityAllowance) + returnCruValue(state.pcotPersonalIndependencePayment);

    var pcotHeadOfLoss = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['personal/otherPastLosses/value']('pastCostOfTravel');

    if (cruTotal >= pcotHeadOfLoss) {
        return pcotHeadOfLoss;
    }

    return cruTotal;
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key].value;
        };
    },
    include: function include(state) {
        return function (key) {
            return state[key].include;
        };
    },
    allValid: function allValid(state) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).reduce(function (valid, benefit) {
            return !valid ? valid : !(state[benefit].include === true && state[benefit].value <= 0);
        }, true);
    },
    all: function all(state) {
        return state;
    },
    gdPneumoconiosis: function gdPneumoconiosis(state) {
        return state.gdPneumoconiosis;
    },
    gdMesothelioma: function gdMesothelioma(state) {
        return state.gdMesothelioma;
    },
    ploeDisabilityWorkingAllowance: function ploeDisabilityWorkingAllowance(state) {
        return state.ploeDisabilityWorkingAllowance;
    },
    ploeEmploymentSupportAllowance: function ploeEmploymentSupportAllowance(state) {
        return state.ploeEmploymentSupportAllowance;
    },
    ploeIncapacityBenefit: function ploeIncapacityBenefit(state) {
        return state.ploeIncapacityBenefit;
    },
    ploeIncomeSupport: function ploeIncomeSupport(state) {
        return state.ploeIncomeSupport;
    },
    ploeIndustrialInjuriesDisablementBenefit: function ploeIndustrialInjuriesDisablementBenefit(state) {
        return state.ploeIndustrialInjuriesDisablementBenefit;
    },
    ploeInvalidityPension: function ploeInvalidityPension(state) {
        return state.ploeInvalidityPension;
    },
    ploeInvalidityAllowance: function ploeInvalidityAllowance(state) {
        return state.ploeInvalidityAllowance;
    },
    ploeJobseekersAllowance: function ploeJobseekersAllowance(state) {
        return state.ploeJobseekersAllowance;
    },
    ploeReducedEarningsAllowance: function ploeReducedEarningsAllowance(state) {
        return state.ploeReducedEarningsAllowance;
    },
    ploeSevereDisablementAllowance: function ploeSevereDisablementAllowance(state) {
        return state.ploeSevereDisablementAllowance;
    },
    ploeSicknessBenefit: function ploeSicknessBenefit(state) {
        return state.ploeSicknessBenefit;
    },
    ploeStatutorySickPay: function ploeStatutorySickPay(state) {
        return state.ploeStatutorySickPay;
    },
    ploeUnemployabilitySupplement: function ploeUnemployabilitySupplement(state) {
        return state.ploeUnemployabilitySupplement;
    },
    ploeUnemploymentBenefit: function ploeUnemploymentBenefit(state) {
        return state.ploeUnemploymentBenefit;
    },
    ploeUniversalCredit: function ploeUniversalCredit(state) {
        return state.ploeUniversalCredit;
    },
    pcocAttendanceAllowance: function pcocAttendanceAllowance(state) {
        return state.pcocAttendanceAllowance;
    },
    pcocDisabilityLivingAllowance: function pcocDisabilityLivingAllowance(state) {
        return state.pcocDisabilityLivingAllowance;
    },
    pcocIndustrialInjuriesDisablementBenefit: function pcocIndustrialInjuriesDisablementBenefit(state) {
        return state.pcocIndustrialInjuriesDisablementBenefit;
    },
    pcocPersonalIndependencePayment: function pcocPersonalIndependencePayment(state) {
        return state.pcocPersonalIndependencePayment;
    },
    pcotDisabilityLivingAllowance: function pcotDisabilityLivingAllowance(state) {
        return state.pcotDisabilityLivingAllowance;
    },
    pcotMobilityAllowance: function pcotMobilityAllowance(state) {
        return state.pcotMobilityAllowance;
    },
    pcotPersonalIndependencePayment: function pcotPersonalIndependencePayment(state) {
        return state.pcotPersonalIndependencePayment;
    },
    getCruTotal: function getCruTotal(state) {
        return getTotal(state);
    },
    getGeneralDamagesOffset: function getGeneralDamagesOffset(state) {
        return generalDamagesOffset(state);
    },
    getPastLossOfEarningsOffset: function getPastLossOfEarningsOffset(state) {
        return pastLossOfEarningsOffset(state);
    },
    getPastCostOfCareOffset: function getPastCostOfCareOffset(state) {
        return pastCostOfCareOffset(state);
    },
    getPastCostOfTravelOffset: function getPastCostOfTravelOffset(state) {
        return pastCostOfTravelOffset(state);
    }
};

var actions = {
    updateValue: function updateValue(_ref, _ref2) {
        var commit = _ref.commit,
            state = _ref.state;
        var key = _ref2.key,
            value = _ref2.value;

        return commit(mutationTypes.UPDATE_VALUE, { key: key, value: value });
    },
    updateInclude: function updateInclude(_ref3, _ref4) {
        var commit = _ref3.commit,
            state = _ref3.state;
        var key = _ref4.key,
            value = _ref4.value;

        return commit(mutationTypes.UPDATE_INCLUDE, { key: key, value: value });
    },
    updateFromServer: function updateFromServer(_ref5, _ref6) {
        var commit = _ref5.commit;
        var data = _ref6.data;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
            commit(mutationTypes.UPDATE_FROM_SERVER, { key: key, value: _.values(data[key]) });
        });
        return true;
    },
    save: function save(_ref7, payload) {
        var state = _ref7.state,
            dispatch = _ref7.dispatch;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref8, step) {
        var dispatch = _ref8.dispatch;

        var data = _.deeply(_.mapKeys)(step, function (value, key) {
            return _.camelCase(key);
        }).data;

        dispatch('updateFromServer', { data: data });
    },
    validate: function validate(_ref9) {
        var commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 6,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 6) && new __WEBPACK_IMPORTED_MODULE_3_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    process: function process(_ref10) {
        var dispatch = _ref10.dispatch;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 6,
            valid: true });
    },
    reset: function reset(_ref11) {
        var commit = _ref11.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 6,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref12) {
    var key = _ref12.key,
        value = _ref12.value;

    state[key].value = value[0];
    state[key].include = value[1];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_VALUE, function (state, _ref13) {
    var key = _ref13.key,
        value = _ref13.value;

    state[key].value = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INCLUDE, function (state, _ref14) {
    var key = _ref14.key,
        value = _ref14.value;

    state[key].include = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
        state[key] = cruTemplate();
    });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_helper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);



var mutationTypes = {};

var state = {};

var getters = {};

var actions = {
  save: function save(_ref, payload) {
    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;
  },
  load: function load(_ref2, step) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootGetters = _ref2.rootGetters;
  },
  validate: function validate(_ref3, step) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootGetters = _ref3.rootGetters;
  },
  process: function process(_ref4, step) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        rootState = _ref4.rootState;
  },
  reset: function reset(_ref5, step) {
    var dispatch = _ref5.dispatch,
        rootState = _ref5.rootState;
  }
};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_Validator__ = __webpack_require__(24);




var _mutations;









var mutationTypes = {
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    UPDATE: 'UPDATE',
    RESET: 'RESET',
    RESET_IS_CONSTANT: 'RESET_IS_CONSTANT'
};

var rules = {
    'futureLosses': { type: 'text', rules: 'required' }
};

function initialState() {
    return {
        futureLosses: null,
        futureLossesConstant: null,
        futureLossesToRetirement: null,
        futureLossesStart: null,
        futureLossesEnd: null,
        futureLossesEndAge: null,
        preInjuryDiscountFactor: null,
        assessmentDiscountFactor: null,
        results: null,
        multiplier: 0,
        futureLossesMortalityMultiplier: false
    };
}

var state = initialState();

var getters = {
    getLoss: function getLoss(state) {
        return function (key) {
            return state[key];
        };
    },
    shouldUpdatedFutureLosses: function shouldUpdatedFutureLosses(state) {
        return !!state.results;
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState,
            state = _ref.state;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        }).then(function () {
            return dispatch('personal/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_store_modules_claim__["d" /* requestPayload */])(0), { root: true });
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.camelCase(key);
        }).data;
        commit(mutationTypes.UPDATE_FROM_SERVER, { data: data });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 4,
            valid: true });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            state = _ref4.state,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 4,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_store_generators_step__["a" /* previousValid */])(rootState, 4) && new __WEBPACK_IMPORTED_MODULE_9_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 4,
            valid: false
        });

        commit(mutationTypes.RESET);
        commit(mutationTypes.RESET_IS_CONSTANT);
    },
    resetIsConstant: function resetIsConstant(_ref6) {
        var commit = _ref6.commit,
            rootState = _ref6.rootState;

        rootState.personal.claimant.theClaimant = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rootState.personal.claimant.theClaimant, {
            levelOfEducation: null,
            employedAtAccident: null,
            employedAtTrial: null,
            disabledAtAccident: null,
            disabledAtTrial: null
        });

        commit(mutationTypes.RESET_IS_CONSTANT);
    },
    updateLoss: function updateLoss(_ref7, _ref8) {
        var commit = _ref7.commit,
            state = _ref7.state;
        var key = _ref8.key,
            value = _ref8.value;

        commit(mutationTypes.UPDATE, { key: key, value: value });
    },
    updateDiscountFactors: function updateDiscountFactors(_ref9) {
        var commit = _ref9.commit,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        var proms = ['preInjuryDiscountFactor', 'assessmentDiscountFactor'].map(function (key) {
            return dispatch('updateIndividualDiscountFactor', key);
        });

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(proms).then(function () {});
    },
    updateIndividualDiscountFactor: function updateIndividualDiscountFactor(_ref10, type) {
        var commit = _ref10.commit,
            state = _ref10.state,
            rootState = _ref10.rootState,
            dispatch = _ref10.dispatch;

        var claimant = rootState.personal.claimant;

        var education = claimant.theClaimant.levelOfEducation;
        var disabled = type === 'preInjuryDiscountFactor' ? claimant.theClaimant.disabledAtAccident : claimant.theClaimant.disabledAtTrial;
        var employment = type === 'preInjuryDiscountFactor' ? claimant.theClaimant.employedAtAccident : claimant.theClaimant.employedAtTrial;

        if (!education || employment === null || disabled === null) {
            return;
        }

        if (__WEBPACK_IMPORTED_MODULE_6_moment___default()(claimant.claimInfo.dateOfAssumedSettlement, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_6_moment___default()(claimant.theClaimant.dateOfBirth, 'DD/MM/YYYY'), 'years') > 54) {
            return commit(mutationTypes.UPDATE, { key: type, value: 1 });
        }

        var payload = {
            age: __WEBPACK_IMPORTED_MODULE_6_moment___default()(claimant.claimInfo.dateOfAssumedSettlement, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_6_moment___default()(claimant.theClaimant.dateOfBirth, 'DD/MM/YYYY'), 'years'),
            gender: claimant.theClaimant.gender,
            education: education,
            disabled: disabled,
            employment: employment ? 'employed' : 'notEmployed'
        };

        return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].calculators.monetary.employmentContingencyDiscount(payload).then(function (data) {
            return commit(mutationTypes.UPDATE, { key: type, value: data.multiplier });
        }).then(function () {
            return dispatch('updateLossTotals');
        });
    },
    updateResults: function updateResults(_ref11) {
        var commit = _ref11.commit,
            state = _ref11.state;

        if (!state.preInjuryDiscountFactor || !state.assessmentDiscountFactor || !state.futureLossesStart || !state.futureLossesEnd) {
            return;
        }

        commit(mutationTypes.UPDATE, { key: 'results', value: [true] });
    },


    updateFutureLossOfEarnings: __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.debounce(function (_ref12) {
        var state = _ref12.state,
            commit = _ref12.commit,
            dispatch = _ref12.dispatch;

        if (state.futureLossesStart && state.futureLossesEnd && state.futureLossesMortalityMultiplier !== null) {
            var claimInfo = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo'];
            var claimantInfo = __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue'];
            return __WEBPACK_IMPORTED_MODULE_3_services_Api__["a" /* default */].calculators.monetary.futureLossMultiplier({
                duration: __WEBPACK_IMPORTED_MODULE_6_moment___default()(state.futureLossesEnd, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_6_moment___default()(state.futureLossesStart, 'DD/MM/YYYY'), 'years', true),
                discountRate: claimInfo('discountRate'),
                gender: claimantInfo('gender'),
                dateOfBirth: claimantInfo('dateOfBirth'),
                assumedSettlement: claimInfo('dateOfAssumedSettlement'),
                retirementAge: claimantInfo('income').retirementAge,
                futureLossesToRetirement: state.futureLossesToRetirement
            }).then(function (data) {
                return commit(mutationTypes.UPDATE, { key: 'multiplier', value: data.multiplier });
            }).then(function () {
                return dispatch('updateLossTotals');
            });
        }
    }, 500),

    updateLossTotals: function updateLossTotals(_ref13) {
        var state = _ref13.state,
            dispatch = _ref13.dispatch,
            rootGetters = _ref13.rootGetters;

        var totalNetIncome = rootGetters['personal/claimant/getIncomeValue']('futureEarningsPostAccident').totalNetIncome;
        if (!totalNetIncome || !state.multiplier || !state.assessmentDiscountFactor) {
            return;
        }
        var total = state.multiplier * state.assessmentDiscountFactor * totalNetIncome;
        return dispatch('personal/claimant/updateIncomeValue', {
            key: 'futureLossOfEarningsNetTotal',
            value: total
        }, { 'root': true });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE, function (state, payload) {
    state[payload.key] = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.futureLosses = null;
    state.futureLossesConstant = null;
    state.futureLossesToRetirement = null;
    state.futureLossesEnd = null;
    state.futureLossesEndAge = null;
    state.preInjuryDiscountFactor = null;
    state.assessmentDiscountFactor = null;
    state.results = null;
    state.multiplier = null;
    state.futureLossesMortalityMultiplier = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_IS_CONSTANT, function (state, rootState) {
    state.preInjuryDiscountFactor = 0;
    state.assessmentDiscountFactor = 0;
    state.results = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref14) {
    var data = _ref14.data;

    state.futureLosses = data.futureLosses;
    state.futureLossesConstant = data.futureLossesConstant;
    state.futureLossesToRetirement = data.futureLossesToRetirement;
    state.futureLossesStart = data.futureLossesStart;
    state.futureLossesEnd = data.futureLossesEnd;
    state.futureLossesEndAge = data.futureLossesEndAge;
    state.preInjuryDiscountFactor = data.preInjuryDiscountFactor;
    state.assessmentDiscountFactor = data.assessmentDiscountFactor;
    state.results = data.results;
    state.multiplier = data.multiplier;
    state.futureLossesMortalityMultiplier = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bignumber_js__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bignumber_js__);



var _mutations;










var mutationTypes = {
    ADD_AWARD: 'ADD_AWARD',
    UPDATE_TREE: 'UPDATE_TREE',
    UPDATE_AWARD: 'UPDATE_AWARD',
    REMOVE_AWARD: 'REMOVE_AWARD',
    RESET: 'RESET',
    LOAD: 'LOAD'
};

var rules = {
    'awards': { type: 'array', rules: 'required' }
};

function initialState() {
    return {
        tree: null,
        awards: []
    };
}
function jcGuidelinesInfo(state, index) {
    if (!state.awards[index].path.length) {
        return;
    }

    var path = state.awards[index].path.slice(0);
    var branch = state.tree[path[0]];

    if (!branch) {
        return;
    }

    var item = branch.chapter;

    path.splice(0, 1);

    var result = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.reduce(path, function (result, value, key) {
        branch = branch.children[value];
        result.push(branch.index);

        return result;
    }, []);

    result.unshift(item);

    return result.toString();
}

function jcGuidelinesNames(state, index) {
    if (!state.awards[index].path.length) {
        return;
    }

    var path = state.awards[index].path.slice(0);
    var branch = state.tree[path[0]];

    if (!branch) {
        return;
    }

    path.splice(0, 1);

    var result = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.reduce(path, function (result, value, key) {
        branch = branch.children[value];
        result.push(branch.name);

        return result;
    }, []);

    return result.toString();
}

function awardsValid(state) {
    if (!state.awards.length) {
        return;
    }

    var awards = state.awards.map(function (award) {
        return award.generalDamages > 0;
    });

    return awards.reduce(function (valid, value) {
        return valid ? value === true : false;
    }, true);
}

function discountsValid(state) {
    if (!state.awards.length) {
        return;
    }

    var awards = state.awards.map(function (award) {
        return award.discount >= 0 && award.discount <= 100 && award.discount !== '';
    });

    return awards.reduce(function (valid, value) {
        return valid ? value === true : false;
    }, true);
}

var state = initialState();

var getters = {
    getAward: function getAward(state) {
        return function (index) {
            return state.awards[index];
        };
    },
    getTree: function getTree(state) {
        return state.tree;
    },
    getGeneralDamages: function getGeneralDamages(state) {
        return function (index) {
            return state.awards[index].generalDamages;
        };
    },
    getPath: function getPath(state) {
        return function (index) {
            return state.awards[index].path;
        };
    },
    getJCGuidelinesInfo: function getJCGuidelinesInfo(state) {
        return function (index) {
            return jcGuidelinesInfo(state, index);
        };
    },
    getJCGuidelinesNames: function getJCGuidelinesNames(state) {
        return function (index) {
            return jcGuidelinesNames(state, index);
        };
    },
    getAwards: function getAwards(state) {
        return state.awards;
    },
    getUplift: function getUplift(state) {
        return function (index) {
            return state.awards[index].uplift;
        };
    },
    getAwardsValid: function getAwardsValid(state) {
        return awardsValid(state);
    },
    getDiscountsValid: function getDiscountsValid(state) {
        return discountsValid(state);
    },
    getSubTotal: function getSubTotal(state) {
        return state.awards.reduce(function (carry, award) {
            return carry + award.generalDamages;
        }, 0);
    },
    getSubTotalDiscounted: function getSubTotalDiscounted(state) {
        return state.awards.reduce(function (carry, award) {
            return carry + award.total;
        }, 0);
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            state = _ref.state;

        payload.data = {
            awards: state.awards
        };

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('personal/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_store_modules_claim__["d" /* requestPayload */])(2));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = [];

        __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(step.data.awards, function (award, key) {
            return data.push(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.mapKeys(award, function (value, key) {
                return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.camelCase(key);
            }));
        });

        commit(mutationTypes.LOAD, { key: 'awards', value: data });
    },
    process: function process(_ref3) {
        var dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 1,
            valid: true });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState,
            state = _ref4.state;

        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 1,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_generators_step__["a" /* previousValid */])(rootState, 1) && new __WEBPACK_IMPORTED_MODULE_5_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_3_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 1,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    updateValue: function updateValue(_ref6, _ref7) {
        var commit = _ref6.commit;
        var key = _ref7.key,
            value = _ref7.value,
            index = _ref7.index;

        commit(mutationTypes.UPDATE_AWARD, { key: key, value: value, index: index });
    },
    updateTree: function updateTree(_ref8, _ref9) {
        var commit = _ref8.commit;
        var key = _ref9.key,
            value = _ref9.value;

        commit(mutationTypes.UPDATE_TREE, { key: key, value: value });
    },
    fetchInjuries: function fetchInjuries(_ref10) {
        var dispatch = _ref10.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].personalInjury.generalDamages.injuries().then(function (data) {
            dispatch('updateTree', { key: 'tree', value: data });
            dispatch('addAwardCheck');
        });
    },
    addAwardCheck: function addAwardCheck(_ref11) {
        var state = _ref11.state,
            dispatch = _ref11.dispatch;

        if (!state.awards.length) {
            dispatch('addAward');
        }
    },
    addAward: function addAward(_ref12) {
        var commit = _ref12.commit;

        commit(mutationTypes.ADD_AWARD);
    },
    removeAward: function removeAward(_ref13, index) {
        var commit = _ref13.commit,
            dispatch = _ref13.dispatch;

        commit(mutationTypes.REMOVE_AWARD, index);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_AWARD, function (state, payload) {
    var award = state.awards[payload.index];
    if (!award) return;
    award[payload.key] = payload.value;
    var gd = __WEBPACK_IMPORTED_MODULE_9_bignumber_js___default()(award.generalDamages || 0);
    var discount = __WEBPACK_IMPORTED_MODULE_9_bignumber_js___default()(1).minus(__WEBPACK_IMPORTED_MODULE_9_bignumber_js___default()(award.discount || 0).dividedBy(100));
    var total = gd.times(discount);

    award.total = +total.toFixed(2);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TREE, function (state, payload) {
    state.tree = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_AWARD, function (state) {
    state.awards.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_modules_shared_templates__["p" /* generalDamagesTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.REMOVE_AWARD, function (state, index) {
    state.awards.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOAD, function (state, payload) {
    state.awards = payload.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, initialState());
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_modules_personal_step__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__claimant__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generalDamages__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cruBenefits__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interimPayments__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__calculateLoss__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lossOfIncome__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pastLossOfEarnings__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__futureLosses__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__otherPastLosses__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__otherFutureLosses__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__claimantDetails__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__documents__ = __webpack_require__(944);














var claimType = 'personal_injury';

var mutationTypes = {};

var state = {};

var getters = {};

var actions = {
  save: function save(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        rootGetters = _ref.rootGetters;

    var individualStep = rootGetters['personal/step/allSteps'][payload.step_number];

    return dispatch('personal/' + individualStep.store + '/save', payload, { root: true });
  },
  load: function load(_ref2, step) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootGetters = _ref2.rootGetters;

    var individualStep = rootGetters['personal/step/allSteps'][parseInt(step.step_number, 10)];

    dispatch('checkForStepStore', individualStep).then(function () {
      return dispatch('personal/' + individualStep.store + '/load', step, { root: true });
    });
  },
  process: function process(_ref3, step) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootState = _ref3.rootState;

    dispatch('checkForStepStore', step).then(function () {
      return dispatch('personal/' + step.store + '/process', step, { root: true });
    });
  },
  validate: function validate(_ref4, step) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        rootState = _ref4.rootState;

    dispatch('checkForStepStore', step).then(function () {
      return dispatch('personal/' + step.store + '/validate', step, { root: true });
    });
  },
  reset: function reset(_ref5, step) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    dispatch('checkForStepStore', step).then(function () {
      return dispatch('personal/' + step.store + '/reset', step, { root: true });
    });
  },
  checkForStepStore: function checkForStepStore(noop, individualStep) {
    if (!individualStep.store) {
      throw { 'error': 'Step #' + individualStep.step + ' (' + individualStep.name + ') does not have a store defined in the routes meta' };
    }
  }
};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  modules: {
    step: __WEBPACK_IMPORTED_MODULE_0_store_modules_personal_step__["a" /* default */],
    claimant: __WEBPACK_IMPORTED_MODULE_1__claimant__["a" /* default */],
    claimantDetails: __WEBPACK_IMPORTED_MODULE_11__claimantDetails__["a" /* default */],
    generalDamages: __WEBPACK_IMPORTED_MODULE_2__generalDamages__["a" /* default */],
    cruBenefits: __WEBPACK_IMPORTED_MODULE_3__cruBenefits__["a" /* default */],
    interimPayments: __WEBPACK_IMPORTED_MODULE_4__interimPayments__["a" /* default */],
    calculateLoss: __WEBPACK_IMPORTED_MODULE_5__calculateLoss__["a" /* default */],
    lossOfIncome: __WEBPACK_IMPORTED_MODULE_6__lossOfIncome__["a" /* default */],
    pastLossOfEarnings: __WEBPACK_IMPORTED_MODULE_7__pastLossOfEarnings__["a" /* default */],
    futureLosses: __WEBPACK_IMPORTED_MODULE_8__futureLosses__["a" /* default */],
    otherPastLosses: __WEBPACK_IMPORTED_MODULE_9__otherPastLosses__["a" /* default */],
    otherFutureLosses: __WEBPACK_IMPORTED_MODULE_10__otherFutureLosses__["a" /* default */],
    documents: __WEBPACK_IMPORTED_MODULE_12__documents__["a" /* default */]
  }
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);


var _mutations;











var mutationTypes = {
    ADD_INTERIM_PAYMENT: 'ADD_INTERIM_PAYMENT',
    UPDATE_INTERIM_PAYMENT: 'UPDATE_INTERIM_PAYMENT',
    DELETE_INTERIM_PAYMENT: 'DELETE_INTERIM_PAYMENT',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    RESET: 'RESET',
    SET: 'SET'
};

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

var rules = {};

var state = {
    payments: []
};

var getters = {
    interimPayments: function interimPayments(state) {
        return state.payments;
    },
    findPayment: function findPayment(state) {
        return function (index) {
            return state.payments[index];
        };
    },
    getAllInterimPaymentsTotal: function getAllInterimPaymentsTotal(state) {
        return state.payments.reduce(function (total, interimPayment) {
            return total + numberVal(interimPayment.value);
        }, 0);
    },
    allInterimPaymentsValid: function allInterimPaymentsValid(state) {
        var maxDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(__WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].getters['lost/headsOfLoss/interestDate'], 'DD/MM/YYYY');
        return state.payments.reduce(function (valid, payment) {
            var mPaymentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(payment.date, 'DD/MM/YYYY');
            return !valid ? valid : mPaymentDate.isValid() && payment.value > 0 && mPaymentDate.isBefore(maxDate);
        }, true);
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            state = _ref.state;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('personal/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_modules_claim__["d" /* requestPayload */])(3));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.SET, { key: 'payments', value: data.payments });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 7,
            valid: true
        });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 7,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_store_generators_step__["a" /* previousValid */])(rootState, 7) && new __WEBPACK_IMPORTED_MODULE_8_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_5_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 7,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    addPayment: function addPayment(_ref6) {
        var commit = _ref6.commit;

        commit(mutationTypes.ADD_INTERIM_PAYMENT);
    },
    deletePayment: function deletePayment(_ref7, index) {
        var commit = _ref7.commit;

        commit(mutationTypes.DELETE_INTERIM_PAYMENT, index);
    },
    updatePayment: function updatePayment(_ref8, _ref9) {
        var commit = _ref8.commit,
            state = _ref8.state;
        var key = _ref9.key,
            value = _ref9.value,
            index = _ref9.index;

        if (state.payments[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_INTERIM_PAYMENT, { key: key, value: value, index: index });
        return value;
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.payments = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_INTERIM_PAYMENT, function (state) {
    state.payments.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_modules_shared_templates__["b" /* paymentsTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_INTERIM_PAYMENT, function (state, index) {
    if (index === 0 && state.payments.length === 1) {
        state.payments = [];
    }
    state.payments.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_INTERIM_PAYMENT, function (state, _ref10) {
    var key = _ref10.key,
        value = _ref10.value,
        index = _ref10.index;

    state.payments[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_9_vue___default.a.set(state, payload.key, payload.value);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_modules_claim__ = __webpack_require__(29);



var _mutations;








var mutationTypes = {
    RESET: 'RESET',
    FINISHED_REFRESH: 'FINISHED_REFRESH',
    UPDATE_DATA: 'UPDATE_DATA',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER'
};

var rules = {
    'assumedLossTotal': { type: 'number', rules: 'required' },
    'futureLossTotal': { type: 'number', rules: 'required' }
};

function initialState() {
    return {
        pastLossPeriods: null,
        pastLossDuration: null,
        pastLossMultiplier: null,
        pastNetLossTotal: null,
        assumedLossTotal: null,
        assumedLossMultiplier: null,
        futureLossPeriods: null,
        futureLossDuration: null,
        futureLossMultiplier: null,
        futureLossTotal: null
    };
}

var state = initialState();

var getters = {
    pastLossPeriods: function pastLossPeriods(state) {
        return state.pastLossPeriods;
    },
    pastLossDuration: function pastLossDuration(state) {
        return state.pastLossDuration;
    },
    pastLossMultiplier: function pastLossMultiplier(state) {
        return state.pastLossMultiplier;
    },
    pastNetLossTotal: function pastNetLossTotal(state) {
        return state.pastNetLossTotal;
    },
    assumedLossTotal: function assumedLossTotal(state) {
        return state.assumedLossTotal;
    },
    assumedLossMultiplier: function assumedLossMultiplier(state) {
        return state.assumedLossMultiplier;
    },
    futureLossPeriods: function futureLossPeriods(state) {
        return state.futureLossPeriods;
    },
    futureLossDuration: function futureLossDuration(state) {
        return state.futureLossDuration;
    },
    futureLossMultiplier: function futureLossMultiplier(state) {
        return state.futureLossMultiplier;
    },
    futureLossTotal: function futureLossTotal(state) {
        return state.futureLossTotal;
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            state = _ref.state;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_store_modules_claim__["d" /* requestPayload */])(5));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(key);
        }).data;

        commit(mutationTypes.UPDATE_FROM_SERVER, { data: data });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 4,
            valid: true });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 4,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_store_generators_step__["a" /* previousValid */])(rootState, 4) && new __WEBPACK_IMPORTED_MODULE_5_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 4,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    updatePastLossOfEarnings: function updatePastLossOfEarnings(_ref6, duration) {
        var rootState = _ref6.rootState;

        var netIncomePerAnnum = rootState.personal.claimant.theClaimant.income.pastPeriods[0].totalNetIncome;
        var totalPastNetIncomeLoss = netIncomePerAnnum * duration - state.pastNetLossTotal;

        __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */].dispatch('personal/headsOfLoss/setHeadsOfLossValue', { key: 'pastLossOfEarnings', value: totalPastNetIncomeLoss });
    },
    refresh: function refresh(_ref7, payload) {
        var commit = _ref7.commit,
            dispatch = _ref7.dispatch,
            getters = _ref7.getters,
            rootState = _ref7.rootState;

        __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].calculators.monetary.postInjuryLossOfIncomeTables(rootState.personal.claimant.theClaimant, rootState.personal.claimant.claimInfo).then(function (data) {
            commit(mutationTypes.UPDATE_DATA, { data: data });
            commit(mutationTypes.FINISHED_REFRESH);
            dispatch('updatePastLossOfEarnings', data.past_loss_duration);
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, initialState());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DATA, function (state, _ref8) {
    var data = _ref8.data;

    state.pastLossPeriods = data.past_loss_periods;
    state.pastLossDuration = data.past_loss_duration;
    state.pastLossMultiplier = data.past_loss_multiplier;
    state.assumedLossTotal = data.assumed_loss_total;
    state.pastNetLossTotal = data.past_net_loss_total;
    state.assumedLossMultiplier = data.assumed_loss_multiplier;
    state.futureLossPeriods = data.future_loss_periods;
    state.futureLossDuration = data.future_loss_duration;
    state.futureLossMultiplier = data.future_loss_multiplier;
    state.futureLossTotal = data.future_loss_total;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref9) {
    var data = _ref9.data;

    state.pastLossPeriods = data.pastLossPeriods;
    state.pastLossDuration = data.pastLossDuration;
    state.pastLossMultiplier = data.pastLossMultiplier;
    state.pastNetLossTotal = data.pastNetLossTotal;
    state.assumedLossTotal = data.assumedLossTotal;
    state.assumedLossMultiplier = data.assumedLossMultiplier;
    state.futureLossPeriods = data.futureLossPeriods;
    state.futureLossDuration = data.futureLossDuration;
    state.futureLossMultiplier = data.futureLossMultiplier;
    state.futureLossTotal = data.futureLossTotal;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.FINISHED_REFRESH, function () {}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttleUpdateLife */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_personFunctions__ = __webpack_require__(38);





var _mutations;













var mutationTypes = {
    RESET: 'RESET',
    SET: 'SET',
    SET_PENSION: 'SET_PENSION',
    SET_CARE: 'SET_CARE',
    CLEAR_STEP: 'CLEAR_STEP',
    ADD_SERVICE: 'ADD_SERVICE',
    SET_SERVICES: 'SET_SERVICES',
    ADD_PURCHASE: 'ADD_PURCHASE',
    SET_PURCHASE: 'SET_PURCHASE',
    REMOVE_SERVICE: 'REMOVE_SERVICE',
    REMOVE_PURCHASE: 'REMOVE_PURCHASE',
    ADD_CARE_PERIOD: 'ADD_CARE_PERIOD',
    SET_CARE_PERIOD: 'SET_CARE_PERIOD',
    REMOVE_CARE_PERIOD: 'REMOVE_CARE_PERIOD',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    UPDATE_CARE_LIFE_EXPECTANCY: 'UPDATE_CARE_LIFE_EXPECTANCY',
    UPDATE_SERVICES_LIFE_EXPECTANCY: 'UPDATE_SERVICES_LIFE_EXPECTANCY',
    UPDATE_PURCHASES_LIFE_EXPECTANCY: 'UPDATE_PURCHASES_LIFE_EXPECTANCY'
};

var rules = {
    'hasOtherFutureLosses': { type: 'text', rules: 'required' }
};

var updateObject = function updateObject(dispatch, action, obj) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var proms = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return dispatch(action, { key: key, value: obj[key], index: index });
    });
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
};

var throttleUpdateLife = function throttleUpdateLife(dispatch, action, person, lifeExpectancy, index) {

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        if (lifeExpectancy.method == 'assumed_percentage_of_life') {
            lifeExpectancy.method = 'percentage_of_normal_life_expectancy';
        }

        if (lifeExpectancy.method == 'assumed_reduction_in_life') {
            lifeExpectancy.method = 'percentage_reduction_in_normal_life_expectancy';
        }

        var assumedSettlement = __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement');

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_services_personFunctions__["b" /* determineLife */])(assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return updateObject(dispatch, action, updatedLife, index);
        });
    }
};

var isPensionUserInputValid = function isPensionUserInputValid(state) {
    var pension = state.pension;

    if (!pension.butForRetirementDate || !pension.butForRetirementAge || pension.butForRetirementAge < 50 || !pension.pensionMethod || !pension.butForPensionAnnual || pension.pensionAnnual === null || pension.pensionAnnual === '' || !pension.pensionLossAnnual || pension.lumpSumLoss === null || pension.pensionAnnual > pension.butForPensionAnnual) {
        return false;
    }

    if (pension.lumpSumLoss && (!pension.butForPensionLumpSum || pension.pensionLumpSum === null || pension.pensionLumpSum === '' || pension.dateLumpSumPaymentReceived === null || pension.dateLumpSumPaymentReceived === '' || pension.pensionLumpSum > pension.butForPensionLumpSum)) {
        return false;
    }

    return true;
};

var isPensionValid = function isPensionValid(state) {
    var pension = state.pension;

    if (state.futureLossOfPension === false) {
        return true;
    }

    if (!isPensionUserInputValid(state)) {
        return false;
    }

    if (!pension.pensionLossMultiplier || !pension.totalLoss) {
        return false;
    }

    if (pension.lumpSumLoss && (pension.lumpSumLossPresentValue === null || pension.longdenFactor === null)) {
        return false;
    }

    return true;
};

var isCareValid = function isCareValid(state) {
    if (state.futureLossOfCare === null) {
        return false;
    }

    if (state.futureLossOfCare === false) {
        return true;
    }

    return state.care.reduce(function (valid, care) {
        return !valid ? valid : careValid(care);
    }, true);
};

var careValid = function careValid(care) {
    return care.description !== null && care.description !== '' && care.careStartDate !== null && care.careStartDate !== '' && care.careEndDate !== null && care.careEndDate !== '' && care.duration !== 0 && care.multiplier !== 0 && care.multiplicand !== 0 && care.multiplicand !== '' && care.lossesForLife !== null && care.futureCareTotal !== 0 && __WEBPACK_IMPORTED_MODULE_6_moment___default()(care.careStartDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(care.careEndDate, 'DD/MM/YYYY')) && care.mortalityMultiplier !== null;
};

var isServicesValid = function isServicesValid(state) {
    if (state.futureLossOfServices === null) {
        return false;
    }

    if (state.futureLossOfServices === false) {
        return true;
    }

    return state.services.reduce(function (valid, service) {
        return !valid ? valid : servicesValid(service);
    }, true);
};

var servicesValid = function servicesValid(service) {
    return service.description !== null && service.description !== '' && service.servicesStartDate !== null && service.servicesStartDate !== '' && service.servicesEndDate !== null && service.servicesEndDate !== '' && service.duration !== 0 && service.multiplier !== 0 && service.multiplicand !== 0 && service.multiplicand !== '' && service.lossesForLife !== null && service.futureServicesTotal !== 0 && __WEBPACK_IMPORTED_MODULE_6_moment___default()(service.servicesStartDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(service.servicesEndDate, 'DD/MM/YYYY')) && service.mortalityMultiplier !== null;
};

var isPurchasesValid = function isPurchasesValid(state) {
    if (state.futurePurchases === null) {
        return false;
    }

    if (state.futurePurchases === false) {
        return true;
    }

    return state.purchases.reduce(function (valid, purchase) {
        return !valid ? valid : purchaseValid(purchase);
    }, true);
};

var purchaseValid = function purchaseValid(purchase) {
    if (purchase.type !== null && purchase.type === 'one') {
        return purchase.description !== null && purchase.description !== '' && purchase.type !== null && __WEBPACK_IMPORTED_MODULE_6_moment___default()(__WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'), 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(purchase.purchaseDate, 'DD/MM/YYYY')) && purchase.purchaseDate !== null && purchase.purchaseDate !== '' && purchase.resaleValue < purchase.multiplicand && purchase.ageAtPurchase !== 0 && purchase.ageAtPurchase !== '' && purchase.multiplicand !== 0 && purchase.discount !== 0 && purchase.total !== 0;
    }

    if (purchase.type !== null && purchase.type === 'recurring') {
        return purchase.description !== null && purchase.description !== '' && purchase.type !== null && __WEBPACK_IMPORTED_MODULE_6_moment___default()(__WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'), 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(purchase.purchaseDate, 'DD/MM/YYYY')) && purchase.purchaseDate !== null && purchase.purchaseDate !== '' && purchase.purchaseEnd !== null && purchase.purchaseEnd !== '' && purchase.frequency !== null && purchase.frequency !== '' && purchase.resaleValue < purchase.multiplicand && purchase.ageAtPurchase !== 0 && purchase.ageAtPurchase !== '' && purchase.multiplicand !== 0 && purchase.discount !== 0 && purchase.total !== 0;
    }

    if (purchase.type !== null && purchase.type === 'continuous') {
        return purchase.description !== null && purchase.description !== '' && purchase.type !== null && __WEBPACK_IMPORTED_MODULE_6_moment___default()(__WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'), 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(purchase.purchaseDate, 'DD/MM/YYYY')) && purchase.purchaseDate !== null && purchase.purchaseDate !== '' && purchase.purchaseEnd !== null && purchase.purchaseEnd !== '' && purchase.ageAtPurchase !== 0 && purchase.ageAtPurchase !== '' && purchase.multiplicand !== 0 && purchase.discount !== 0 && purchase.total !== 0;
    }
};

var getPurchasesTotal = function getPurchasesTotal(state) {
    var totals = state.purchases.map(function (purchase) {
        return purchase.total;
    });

    return totals.reduce(function (carry, item) {
        return carry + item;
    }, 0);
};

var getCareTotal = function getCareTotal(state) {
    var totals = state.care.map(function (period) {
        return period.futureCareTotal;
    });

    return totals.reduce(function (carry, item) {
        return carry + item;
    }, 0);
};

var getServicesTotal = function getServicesTotal(state) {
    var totals = state.services.map(function (period) {
        return period.futureServicesTotal;
    });

    return totals.reduce(function (carry, item) {
        return carry + item;
    }, 0);
};

function initialState() {
    return {
        hasOtherFutureLosses: null,

        futureLossOfPension: null,
        pension: {
            illHealthDisabilityPension: false,

            pensionMethod: null,

            acceleratedReceipt: null,

            butForRetirementDate: null,
            butForRetirementAge: null,
            retirementDate: null,
            multiplierToRetirement: null,

            lifeMultiplier: null,
            discountFactor: null,

            lumpSumLoss: null,
            butForPensionLumpSum: 0,
            pensionLumpSum: 0,
            longdenFactor: null,
            lumpSumLossValue: null,
            lumpSumLossPresentValue: null,
            dateLumpSumPaymentReceived: null,

            butForPensionAnnual: 0,
            pensionAnnual: 0,

            pensionLossAnnual: null,

            pensionLossMultiplier: null,

            totalLossAnnual: null,

            totalLoss: null
        },

        futureLossOfCare: null,
        care: [],
        careLifeExpectancy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["l" /* lifeExpectancyTemplate */])(),

        futureLossOfServices: null,
        services: [],
        servicesLifeExpectancy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["l" /* lifeExpectancyTemplate */])(),

        futurePurchases: null,
        purchases: [],
        purchasesLifeExpectancy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["l" /* lifeExpectancyTemplate */])()
    };
}

var state = initialState();

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    pensionValue: function pensionValue(state) {
        return function (key) {
            return state.pension[key];
        };
    },
    care: function care(state) {
        return state.care;
    },
    carePeriod: function carePeriod(state) {
        return function (index) {
            return state.care[index];
        };
    },
    careValue: function careValue(state) {
        return function (key) {
            return state.care[key];
        };
    },
    careTotal: function careTotal(state) {
        return getCareTotal(state);
    },
    services: function services(state) {
        return state.services;
    },
    service: function service(state) {
        return function (index) {
            return state.service[index];
        };
    },
    servicesTotal: function servicesTotal(state) {
        return getServicesTotal(state);
    },
    servicesValue: function servicesValue(state) {
        return function (key) {
            return state.services[key];
        };
    },
    purchaseValue: function purchaseValue(state) {
        return function (key) {
            return state.purchases[key];
        };
    },
    pensionUserInputValid: function pensionUserInputValid(state) {
        return isPensionUserInputValid(state);
    },
    pensionValid: function pensionValid(state) {
        return isPensionValid(state);
    },
    careValid: function careValid(state) {
        return isCareValid(state);
    },
    servicesValid: function servicesValid(state) {
        return isServicesValid(state);
    },
    purchasesValid: function purchasesValid(state) {
        return isPurchasesValid(state);
    },
    purchasesTotal: function purchasesTotal(state) {
        return getPurchasesTotal(state);
    },
    pension: function pension(state) {
        return state.pension;
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            state = _ref.state;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        }).then(function () {
            return __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('personal/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_store_modules_claim__["d" /* requestPayload */])(0));
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.camelCase(key);
        }).data;
        commit(mutationTypes.UPDATE_FROM_SERVER, { data: data });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 5,
            valid: true });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            state = _ref4.state,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 5,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_generators_step__["a" /* previousValid */])(rootState, 5) && new __WEBPACK_IMPORTED_MODULE_11_services_Validator__["a" /* default */](state, rules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 5,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    set: function set(_ref6, _ref7) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch;
        var key = _ref7.key,
            value = _ref7.value;

        commit(mutationTypes.SET, { key: key, value: value });

        if (key === 'hasOtherFutureLosses' && value === false) {
            commit(mutationTypes.CLEAR_STEP);
        }

        switch (key) {
            case 'futurePurchases':
                dispatch('updateFuturePurchases');
                break;
            case 'futureLossOfCare':
                dispatch('updateFutureCare');
                break;
            case 'futureLossOfServices':
                dispatch('updateFutureServices');
                break;
        }
    },
    setPension: function setPension(_ref8, _ref9) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch;
        var key = _ref9.key,
            value = _ref9.value;

        commit(mutationTypes.SET_PENSION, { key: key, value: value });

        dispatch('updatePension');
    },
    setCare: function setCare(_ref10, _ref11) {
        var commit = _ref10.commit,
            dispatch = _ref10.dispatch;
        var key = _ref11.key,
            value = _ref11.value;

        commit(mutationTypes.SET_CARE, { key: key, value: value });

        dispatch('updateCare');
    },
    setServices: function setServices(_ref12, _ref13) {
        var commit = _ref12.commit,
            dispatch = _ref12.dispatch;
        var key = _ref13.key,
            value = _ref13.value;

        commit(mutationTypes.SET_SERVICES, { key: key, value: value });

        dispatch('updateServices');
    },


    updatePension: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref14) {
        var rootState = _ref14.rootState,
            state = _ref14.state,
            commit = _ref14.commit;

        if (!isPensionUserInputValid(state)) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.pensionLoss(rootState.personal.claimant, state.pension).then(function (data) {
            commit(mutationTypes.SET_PENSION, { key: 'discountFactor', value: data.discountFactor });
            commit(mutationTypes.SET_PENSION, { key: 'lifeMultiplier', value: data.lifeMultiplier });
            commit(mutationTypes.SET_PENSION, { key: 'longdenFactor', value: data.longdenFactor });
            commit(mutationTypes.SET_PENSION, { key: 'lumpSumLossPresentValue', value: data.lumpSumLossPresentValue });
            commit(mutationTypes.SET_PENSION, { key: 'multiplierToRetirement', value: data.multiplierToRetirement });
            commit(mutationTypes.SET_PENSION, { key: 'pensionLossMultiplier', value: data.pensionLossMultiplier });
            commit(mutationTypes.SET_PENSION, { key: 'totalLoss', value: data.totalLoss });
            commit(mutationTypes.SET_PENSION, { key: 'totalLossAnnual', value: data.totalLossAnnual });
            commit(mutationTypes.SET_PENSION, { key: 'acceleratedReceipt', value: data.acceleratedReceipt });
        });
    }, 500),

    updateFuturePurchases: function updateFuturePurchases(_ref15) {
        var state = _ref15.state,
            dispatch = _ref15.dispatch,
            commit = _ref15.commit;

        if (state.futurePurchases) {
            return dispatch('addPurchase');
        }

        commit(mutationTypes.SET, { key: 'purchases', value: [] });
    },
    updateFutureCare: function updateFutureCare(_ref16) {
        var state = _ref16.state,
            dispatch = _ref16.dispatch,
            commit = _ref16.commit;

        if (state.futureLossOfCare) {
            return dispatch('addCare');
        }

        commit(mutationTypes.SET, { key: 'care', value: [] });
    },
    updateFutureServices: function updateFutureServices(_ref17) {
        var state = _ref17.state,
            dispatch = _ref17.dispatch,
            commit = _ref17.commit;

        if (state.futureLossOfServices) {
            return dispatch('addService');
        }

        commit(mutationTypes.SET, { key: 'services', value: [] });
    },
    addPurchase: function addPurchase(_ref18) {
        var commit = _ref18.commit;

        commit(mutationTypes.ADD_PURCHASE);
    },
    addCare: function addCare(_ref19) {
        var commit = _ref19.commit;

        commit(mutationTypes.ADD_CARE_PERIOD);
    },
    addService: function addService(_ref20) {
        var commit = _ref20.commit;

        commit(mutationTypes.ADD_SERVICE);
    },
    setPurchase: function setPurchase(_ref21, _ref22) {
        var commit = _ref21.commit,
            dispatch = _ref21.dispatch;
        var index = _ref22.index,
            key = _ref22.key,
            value = _ref22.value;

        commit(mutationTypes.SET_PURCHASE, { index: index, key: key, value: value });

        dispatch('updatePurchase', index);
    },
    setCarePeriod: function setCarePeriod(_ref23, _ref24) {
        var commit = _ref23.commit,
            dispatch = _ref23.dispatch;
        var index = _ref24.index,
            key = _ref24.key,
            value = _ref24.value;

        commit(mutationTypes.SET_CARE_PERIOD, { index: index, key: key, value: value });

        dispatch('updateCare', index);
    },
    removePurchase: function removePurchase(_ref25, _ref26) {
        var state = _ref25.state,
            commit = _ref25.commit,
            dispatch = _ref25.dispatch;
        var index = _ref26.index;

        commit(mutationTypes.REMOVE_PURCHASE, index);

        if (!state.purchases.length) {
            return dispatch('addPurchase');
        }
    },
    removeCarePeriod: function removeCarePeriod(_ref27, _ref28) {
        var state = _ref27.state,
            commit = _ref27.commit,
            dispatch = _ref27.dispatch;
        var index = _ref28.index;

        commit(mutationTypes.REMOVE_CARE_PERIOD, index);

        if (!state.care.length) {
            return dispatch('addCare');
        }
    },
    removeService: function removeService(_ref29, _ref30) {
        var state = _ref29.state,
            commit = _ref29.commit,
            dispatch = _ref29.dispatch;
        var index = _ref30.index;

        commit(mutationTypes.REMOVE_SERVICE, index);

        if (!state.services.length) {
            return dispatch('addService');
        }
    },

    updatePurchase: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref31, _ref32) {
        var state = _ref31.state,
            commit = _ref31.commit;
        var index = _ref32.index;

        var purchase = null;

        if (state.purchases[index].purchaseDate === null || state.purchases[index].purchaseDate === '' || __WEBPACK_IMPORTED_MODULE_6_moment___default()(state.purchases[index].purchaseDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(__WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'), 'DD/MM/YYYY')) || state.purchases[index].multiplicand === 0 || state.purchases[index].multiplicand === '' || state.purchases[index].multiplicand < state.purchases[index].resaleValue || state.purchases[index].multiplicand === null || state.purchases[index].ageAtPurchase === 0 || state.purchases[index].ageAtPurchase === '' || state.purchases[index].resaleOption === null || state.purchases[index].mortalityMultiplier === null) {
            return;
        }

        if (state.purchases[index].type === 'one') {
            purchase = {
                dateOfPurchase: state.purchases[index].purchaseDate,
                discountRate: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('discountRate'),
                dateOfBirth: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('dateOfBirth'),
                assumedSettlement: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'),
                multiplicand: state.purchases[index].multiplicand,
                resaleValue: state.purchases[index].resaleOption ? state.purchases[index].resaleValue : 0,
                type: state.purchases[index].type,
                gender: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('gender'),
                mortalityMultiplier: state.purchases[index].mortalityMultiplier
            };

            return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.futurePurchase(purchase).then(function (data) {
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'discount', value: data.discount });
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'total', value: data.total });
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'resaleTotal', value: data.resale_total });
            });
        }

        if (state.purchases[index].type === 'continuous' && state.purchases[index].purchaseEnd !== null && state.purchases[index].purchaseEnd !== '' && __WEBPACK_IMPORTED_MODULE_6_moment___default()(state.purchases[index].purchaseDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(state.purchases[index].purchaseEnd, 'DD/MM/YYYY')) && state.purchases[index].mortalityMultiplier !== null) {
            purchase = {
                dateOfPurchase: state.purchases[index].purchaseDate,
                discountRate: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('discountRate'),
                dateOfBirth: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('dateOfBirth'),
                assumedSettlement: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'),
                multiplicand: state.purchases[index].multiplicand,
                resaleValue: state.purchases[index].resaleOption ? state.purchases[index].resaleValue : 0,
                type: state.purchases[index].type,
                purchaseEnd: state.purchases[index].purchaseEnd,
                frequency: state.purchases[index].frequency,
                gender: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('gender'),
                mortalityMultiplier: state.purchases[index].mortalityMultiplier
            };

            return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.futurePurchase(purchase).then(function (data) {
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'discount', value: data.discount });
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'total', value: data.total });
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'resaleTotal', value: data.resale_total });
            });
        }

        if (state.purchases[index].type === 'recurring' && state.purchases[index].purchaseEnd !== null && state.purchases[index].purchaseEnd !== '' && __WEBPACK_IMPORTED_MODULE_6_moment___default()(state.purchases[index].purchaseDate, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(state.purchases[index].purchaseEnd, 'DD/MM/YYYY')) && state.purchases[index].frequency !== 0 && state.purchases[index].frequency !== '' && state.purchases[index].mortalityMultiplier !== null) {
            purchase = {
                dateOfPurchase: state.purchases[index].purchaseDate,
                discountRate: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('discountRate'),
                dateOfBirth: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('dateOfBirth'),
                assumedSettlement: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'),
                multiplicand: state.purchases[index].multiplicand,
                resaleValue: state.purchases[index].resaleOption ? state.purchases[index].resaleValue : 0,
                type: state.purchases[index].type,
                purchaseEnd: state.purchases[index].purchaseEnd,
                frequency: state.purchases[index].frequency,
                gender: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('gender'),
                mortalityMultiplier: state.purchases[index].mortalityMultiplier
            };

            return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.futurePurchase(purchase).then(function (data) {
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'discount', value: data.discount });
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'total', value: data.total });
                commit(mutationTypes.SET_PURCHASE, { index: index, key: 'resaleTotal', value: data.resale_total });
            });
        }
    }, 500),

    updateCare: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref33, _ref34) {
        var state = _ref33.state,
            commit = _ref33.commit;
        var index = _ref34.index;


        if (state.care[index].careStartDate === null || state.care[index].careStartDate === '' || state.care[index].careEndDate === null || state.care[index].careEndDate === '' || state.care[index].multiplicand === 0 || state.care[index].multiplicand === '' || state.care[index].multiplicand === null || state.care[index].lossesForLife === null || state.care[index].mortalityMultiplier === null || __WEBPACK_IMPORTED_MODULE_6_moment___default()(state.care[index].careStartDate, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_6_moment___default()(state.care[index].careEndDate, 'DD/MM/YYYY'))) {
            return;
        }

        var care = {
            multiplicand: state.care[index].multiplicand,
            startDate: state.care[index].careStartDate,
            gender: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('gender'),
            discountRate: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('discountRate'),
            dateOfBirth: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('dateOfBirth'),
            assumedSettlement: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'),
            endDate: state.care[index].careEndDate,
            mortalityMultiplier: state.care[index].mortalityMultiplier
        };

        return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.otherFutureLosses(care).then(function (data) {
            commit(mutationTypes.SET_CARE, { key: 'multiplier', value: data.multiplier, index: index });
            commit(mutationTypes.SET_CARE, { key: 'futureCareTotal', value: data.total, index: index });
            commit(mutationTypes.SET_CARE, { key: 'duration', value: data.duration, index: index });
        });
    }, 500),

    updateServices: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref35, _ref36) {
        var state = _ref35.state,
            commit = _ref35.commit;
        var index = _ref36.index;


        if (state.services[index].servicesStartDate === null || state.services[index].servicesStartDate === '' || state.services[index].servicesEndDate === null || state.services[index].servicesEndDate === '' || state.services[index].multiplicand === 0 || state.services[index].multiplicand === '' || state.services[index].multiplicand === null || state.services[index].lossesForLife === null || state.services[index].mortalityMultiplier === null || __WEBPACK_IMPORTED_MODULE_6_moment___default()(state.services[index].servicesStartDate, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_6_moment___default()(state.services[index].servicesEndDate, 'DD/MM/YYYY'))) {
            return;
        }

        var service = {
            multiplicand: state.services[index].multiplicand,
            startDate: state.services[index].servicesStartDate,
            gender: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('gender'),
            discountRate: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('discountRate'),
            dateOfBirth: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('dateOfBirth'),
            assumedSettlement: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'),
            endDate: state.services[index].servicesEndDate,
            mortalityMultiplier: state.services[index].mortalityMultiplier
        };

        return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.otherFutureLosses(service).then(function (data) {
            commit(mutationTypes.SET_SERVICES, { key: 'multiplier', value: data.multiplier, index: index });
            commit(mutationTypes.SET_SERVICES, { key: 'futureServicesTotal', value: data.total, index: index });
            commit(mutationTypes.SET_SERVICES, { key: 'duration', value: data.duration, index: index });
        });
    }, 500),

    updateLifeForPurchases: function updateLifeForPurchases(_ref37, _ref38) {
        var commit = _ref37.commit,
            dispatch = _ref37.dispatch;
        var lifeExpectancy = _ref38.lifeExpectancy,
            index = _ref38.index;

        return updateObject(dispatch, 'updatePurchasesLifeExpectancyValue', lifeExpectancy, index).then(function () {
            return throttleUpdateLife(dispatch, 'updatePurchasesLifeExpectancyValue', __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/claimant'], lifeExpectancy, index);
        });
    },
    updatePurchasesLifeExpectancyValue: function updatePurchasesLifeExpectancyValue(_ref39, _ref40) {
        var commit = _ref39.commit,
            dispatch = _ref39.dispatch;
        var index = _ref40.index,
            key = _ref40.key,
            value = _ref40.value;

        commit(mutationTypes.UPDATE_PURCHASES_LIFE_EXPECTANCY, { index: index, key: key, value: value });
        dispatch('updatePurchase', { index: index });
    },
    updateLifeForCare: function updateLifeForCare(_ref41, _ref42) {
        var commit = _ref41.commit,
            dispatch = _ref41.dispatch;
        var lifeExpectancy = _ref42.lifeExpectancy,
            index = _ref42.index;

        return updateObject(dispatch, 'updateCareLifeExpectancyValue', lifeExpectancy, index).then(function () {
            return throttleUpdateLife(dispatch, 'updateCareLifeExpectancyValue', __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/claimant'], lifeExpectancy, index);
        });
    },
    updateCareLifeExpectancyValue: function updateCareLifeExpectancyValue(_ref43, _ref44) {
        var commit = _ref43.commit,
            dispatch = _ref43.dispatch;
        var index = _ref44.index,
            key = _ref44.key,
            value = _ref44.value;

        commit(mutationTypes.UPDATE_CARE_LIFE_EXPECTANCY, { index: index, key: key, value: value });

        if (key === 'dateOfDeath') {
            commit(mutationTypes.SET_CARE_PERIOD, { index: index, key: 'careEndDate', value: value });
        }

        dispatch('updateCare', { index: index });
    },
    updateLifeForServices: function updateLifeForServices(_ref45, _ref46) {
        var commit = _ref45.commit,
            dispatch = _ref45.dispatch;
        var lifeExpectancy = _ref46.lifeExpectancy,
            index = _ref46.index;

        return updateObject(dispatch, 'updateServicesLifeExpectancyValue', lifeExpectancy, index).then(function () {
            return throttleUpdateLife(dispatch, 'updateServicesLifeExpectancyValue', __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/claimant'], lifeExpectancy, index);
        });
    },
    updateServicesLifeExpectancyValue: function updateServicesLifeExpectancyValue(_ref47, _ref48) {
        var commit = _ref47.commit,
            dispatch = _ref47.dispatch;
        var index = _ref48.index,
            key = _ref48.key,
            value = _ref48.value;

        commit(mutationTypes.UPDATE_SERVICES_LIFE_EXPECTANCY, { index: index, key: key, value: value });

        if (key === 'dateOfDeath') {
            commit(mutationTypes.SET_SERVICES, { index: index, key: 'servicesEndDate', value: value });
        }

        dispatch('updateServices', { index: index });
    },
    resetLumpSum: function resetLumpSum(_ref49) {
        var commit = _ref49.commit,
            state = _ref49.state;

        if (state.pension.lumpSumLoss === false) {
            commit(mutationTypes.SET_PENSION, { key: 'butForPensionLumpSum', value: 0 });
            commit(mutationTypes.SET_PENSION, { key: 'pensionLumpSum', value: 0 });
            commit(mutationTypes.SET_PENSION, { key: 'discountFactor', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'dateLumpSumPaymentReceived', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'acceleratedReceipt', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'lumpSumLossValue', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'lumpSumLossPresentValue', value: null });
        }
    },
    resetPension: function resetPension(_ref50) {
        var commit = _ref50.commit,
            state = _ref50.state;

        if (state.futureLossOfPension === false) {
            commit(mutationTypes.SET_PENSION, { key: 'illHealthDisabilityPension', value: false });
            commit(mutationTypes.SET_PENSION, { key: 'pensionMethod', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'dateLumpSumPaymentReceived', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'butForRetirementDate', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'retirementDate', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'multiplierToRetirement', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'lifeMultiplier', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'discountFactor', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'lumpSumLoss', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'butForPensionLumpSum', value: 0 });
            commit(mutationTypes.SET_PENSION, { key: 'pensionLumpSum', value: 0 });
            commit(mutationTypes.SET_PENSION, { key: 'longdenFactor', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'lumpSumLossValue', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'lumpSumLossPresentValue', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'butForPensionAnnual', value: 0 });
            commit(mutationTypes.SET_PENSION, { key: 'pensionAnnual', value: 0 });
            commit(mutationTypes.SET_PENSION, { key: 'pensionLossAnnual', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'pensionLossMultiplier', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'totalLossAnnual', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'totalLoss', value: null });
            commit(mutationTypes.SET_PENSION, { key: 'acceleratedReceipt', value: null });
        }
    },
    refresh: function refresh(_ref51) {
        var dispatch = _ref51.dispatch,
            state = _ref51.state;

        var purchases = state.purchases.map(function (purchase, index) {
            return dispatch('updatePurchase', { index: index });
        });
        var services = state.services.map(function (service, index) {
            return dispatch('updateService', { index: index });
        });
        var care = state.care.map(function (service, index) {
            return dispatch('updateCare', { index: index });
        });
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(purchases), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(services), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(care)]);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref52) {
    var data = _ref52.data;

    state.hasOtherFutureLosses = data.hasOtherFutureLosses;
    state.futureLossOfCare = data.futureLossOfCare;
    state.care = data.care;
    state.careLifeExpectancy = data.careLifeExpectancy;
    state.futureLossOfServices = data.futureLossOfServices;
    state.services = data.services;
    state.servicesLifeExpectancy = data.servicesLifeExpectancy;
    state.futurePurchases = data.futurePurchases;
    state.purchases = data.purchases;
    state.purchasesLifeExpectancy = data.purchasesLifeExpectancy;
    state.futureLossOfPension = data.futureLossOfPension;
    state.pension = data.pension;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, initialState());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state, payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_PENSION, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state.pension, payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_CARE, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state.care[payload.index], payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_SERVICES, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state.services[payload.index], payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_PURCHASE, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state.purchases[payload.index], payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_CARE_PERIOD, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state.care[payload.index], payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CARE_LIFE_EXPECTANCY, function (state, _ref53) {
    var key = _ref53.key,
        value = _ref53.value;

    state.careLifeExpectancy[key] = value;
    if (key === 'dateOfDeath') {
        state.care.careEndDate = value;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_SERVICES_LIFE_EXPECTANCY, function (state, _ref54) {
    var key = _ref54.key,
        value = _ref54.value;

    state.servicesLifeExpectancy[key] = value;
    if (key === 'dateOfDeath') {
        state.services.servicesEndDate = value;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_PURCHASES_LIFE_EXPECTANCY, function (state, _ref55) {
    var index = _ref55.index,
        key = _ref55.key,
        value = _ref55.value;

    state.purchasesLifeExpectancy[key] = value;
    if (key === 'dateOfDeath') {
        state.purchases[index].purchaseEnd = value;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_PURCHASE, function (state) {
    state.purchases.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["m" /* purchaseTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_CARE_PERIOD, function (state) {
    state.care.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["n" /* otherFutureLossesCareTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_SERVICE, function (state) {
    state.services.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["o" /* otherFutureLossesServicesTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.REMOVE_PURCHASE, function (state, index) {
    state.purchases.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.REMOVE_CARE_PERIOD, function (state, index) {
    state.care.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.REMOVE_SERVICE, function (state, index) {
    state.services.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CLEAR_STEP, function (state) {
    state.futureLossOfCare = null;
    state.care = [];
    state.careLifeExpectancy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["l" /* lifeExpectancyTemplate */])();
    state.futureLossOfServices = null;
    state.services = [];
    state.servicesLifeExpectancy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["l" /* lifeExpectancyTemplate */])();
    state.futurePurchases = null;
    state.purchases = [];
    state.purchasesLifeExpectancy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_store_modules_shared_templates__["l" /* lifeExpectancyTemplate */])();
    state.futureLossOfPension = null;
    state.pension.illHealthDisabilityPension = false;
    state.pension.pensionMethod = null;
    state.pension.dateLumpSumPaymentReceived = null;
    state.pension.butForRetirementDate = null;
    state.pension.retirementDate = null;
    state.pension.multiplierToRetirement = null;
    state.pension.lifeMultiplier = null;
    state.pension.discountFactor = null;
    state.pension.lumpSumLoss = null;
    state.pension.butForPensionLumpSum = 0;
    state.pension.pensionLumpSum = 0;
    state.pension.longdenFactor = null;
    state.pension.lumpSumLossValue = null;
    state.pension.lumpSumLossPresentValue = null;
    state.pension.butForPensionAnnual = 0;
    state.pension.pensionAnnual = 0;
    state.pension.pensionLossAnnual = null;
    state.pension.pensionLossMultiplier = null;
    state.pension.totalLossAnnual = null;
    state.pension.totalLoss = null;
    state.pension.acceleratedReceipt = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_modules_shared_templates__ = __webpack_require__(33);





var _mutations;










var mutationTypes = {
    SET: 'SET',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    ADD_CUSTOM_HEAD_OF_LOSS: 'ADD_CUSTOM_HEAD_OF_LOSS',
    DELETE_CUSTOM_HEAD_OF_LOSS: 'DELETE_CUSTOM_HEAD_OF_LOSS',
    UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE: 'UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE',
    ADD_CARE_PERIOD: 'ADD_CARE_PERIOD',
    UPDATE_CARE_PERIOD_VALUE: 'UPDATE_CARE_PERIOD_VALUE',
    UPDATE_CARE_VALUE: 'UPDATE_CARE_VALUE',
    UPDATE_INTEREST_VALUE: 'UPDATE_INTEREST_VALUE',
    DELETE_CARE_PERIOD: 'DELETE_CARE_PERIOD',
    RESET: 'RESET',
    RESET_INTEREST: 'RESET_INTEREST'
};

var numberVal = function numberVal(value) {
    return parseFloat(value || 0);
};

var rules = {};

function initialState() {
    return {
        generalDamagesInterest: 2.0,
        generalDamagesWithInterest: 0,

        pastLossOfEarnings: 0,
        pastLossOfEarningsInterest: 0.5,
        pastLossOfEarningsWithInterest: 0,

        pastReducedEarningsInterest: 0.5,
        pastReducedEarningsWithInterest: 0,

        pastCostOfServices: 0,
        pastCostOfServicesInterest: 0.5,
        pastCostOfServicesWithInterest: 0,

        pastCostOfTravel: 0,
        pastCostOfTravelInterest: 0.5,
        pastCostOfTravelWithInterest: 0,

        misc: 0,
        miscInterest: 0.5,
        miscWithInterest: 0,

        headsOfLoss: [],
        customHeadsOfLossTotal: 0,
        customHeadsOfLossTotalWithInterest: 0,

        careCalcType: null,
        pastCostOfCare: 0,
        pastCostOfCareInterest: 0.5,
        pastCostOfCareWithInterest: 0,
        periods: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_store_modules_shared_templates__["e" /* carePeriodTemplate */])()],

        interestType: 'none',
        customInterestDate: null
    };
}

var state = initialState();

var modalPayload = function modalPayload(state) {

    state.pastLossOfEarnings = __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getIncomeValue']('pastLossOfEarningsNetTotal');

    return {
        interimPayments: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/interimPayments/interimPayments'],
        assumedSettlement: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfAssumedSettlement'),
        serviceOfProceedings: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfServiceProceedings'),
        onsetOfSymptoms: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimInfo']('dateOfInjury'),
        assumedLifeExpectancy: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/claimant/getClaimantValue']('assumedLifeExpectancy'),
        deductibles: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/cruBenefits/all'],
        headsOfLoss: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state, {
            generalDamages: __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].getters['personal/generalDamages/getGeneralDamages']
        }),
        headOfLoss: {}
    };
};

var getters = {
    value: function value(state) {
        return function (key) {
            return state[key];
        };
    },
    getModalPayload: function getModalPayload(state) {
        return modalPayload(state);
    },
    getCarePeriod: function getCarePeriod(state) {
        return function (index) {
            return state.periods[index];
        };
    },
    getCustomHeadOfLoss: function getCustomHeadOfLoss(state) {
        return function (index) {
            return state.headsOfLoss[index];
        };
    },
    getAllCustomHeadOfLoss: function getAllCustomHeadOfLoss(state) {
        return state.headsOfLoss;
    },
    customHeadsOfLossTotal: function customHeadsOfLossTotal(state) {
        return state.headsOfLoss.reduce(function (total, headOfLoss) {
            return total + headOfLoss.value;
        }, 0);
    },
    customHeadsOfLossTotalWithInterest: function customHeadsOfLossTotalWithInterest(state) {
        return state.headsOfLoss.reduce(function (total, headOfLoss) {
            return total + headOfLoss.interestAccrued;
        }, 0);
    },
    allCarePeriodsValid: function allCarePeriodsValid(state) {
        return function (type) {
            return state.periods.reduce(function (valid, period) {
                if (!valid) {
                    return valid;
                }
                return __WEBPACK_IMPORTED_MODULE_6_moment___default()(period.periodStart, 'DD/MM/YYYY').isValid() && __WEBPACK_IMPORTED_MODULE_6_moment___default()(period.periodEnd, 'DD/MM/YYYY').isValid() && period.hoursPerDay > 0;
            }, true);
        };
    },
    interestDate: function interestDate(state, getters, rootState) {
        switch (state.interestType) {
            case "today":
                return __WEBPACK_IMPORTED_MODULE_6_moment___default()().format("DD/MM/YYYY");
            case "assumed_settlement":
                return rootState.personal.claimant.claimInfo.dateOfAssumedSettlement;
            case "custom":
                return state.customInterestDate;
            case "none":
                return null;
        }
    },
    allCustomHeadOfLossValid: function allCustomHeadOfLossValid(state) {
        return state.headsOfLoss.reduce(function (valid, headOfLoss) {
            if (!valid) {
                return valid;
            }
            return headOfLoss.name !== null && headOfLoss.name !== "" && headOfLoss.value > 0;
        }, true);
    }
};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            state = _ref.state;

        payload.data = state;

        __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;

        var data = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.deeply(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapKeys)(step, function (value, key) {
            return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.camelCase(key);
        }).data;
        commit(mutationTypes.UPDATE_FROM_SERVER, { data: data });
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 3,
            valid: true });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 3,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_store_generators_step__["a" /* previousValid */])(rootState, 3)
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_8_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 3,
            valid: false
        });

        commit(mutationTypes.RESET);
    },
    set: function set(_ref6, _ref7) {
        var commit = _ref6.commit,
            state = _ref6.state,
            dispatch = _ref6.dispatch;
        var key = _ref7.key,
            value = _ref7.value;

        if (state[key] === value) {
            return value;
        }
        commit(mutationTypes.SET, { key: key, value: value });

        return value;
    },
    addCustomHeadOfLoss: function addCustomHeadOfLoss(_ref8) {
        var commit = _ref8.commit;

        commit(mutationTypes.ADD_CUSTOM_HEAD_OF_LOSS);
    },
    setCustomHeadOfLossValue: function setCustomHeadOfLossValue(_ref9, _ref10) {
        var commit = _ref9.commit,
            state = _ref9.state,
            dispatch = _ref9.dispatch;
        var key = _ref10.key,
            value = _ref10.value,
            index = _ref10.index;

        if (state.headsOfLoss[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE, { key: key, value: value, index: index });
        return value;
    },
    deleteCustomHeadOfLoss: function deleteCustomHeadOfLoss(_ref11, index) {
        var commit = _ref11.commit;

        commit(mutationTypes.DELETE_CUSTOM_HEAD_OF_LOSS, index);
    },
    addCarePeriod: function addCarePeriod(_ref12) {
        var commit = _ref12.commit;

        commit(mutationTypes.ADD_CARE_PERIOD);
    },
    deleteCarePeriod: function deleteCarePeriod(_ref13, index) {
        var commit = _ref13.commit,
            dispatch = _ref13.dispatch,
            state = _ref13.state;

        commit(mutationTypes.DELETE_CARE_PERIOD, index);
        if (state.periods.length === 0) {
            dispatch('addCarePeriod');
        }
        return dispatch('updateCareTotal');
    },
    updateCarePeriodValue: function updateCarePeriodValue(_ref14, _ref15) {
        var commit = _ref14.commit,
            state = _ref14.state;
        var key = _ref15.key,
            value = _ref15.value,
            index = _ref15.index;

        if (key === 'hoursPerDay' && value > 24) {
            value = 24;
        }

        if (state.periods[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_CARE_PERIOD_VALUE, { key: key, value: value, index: index });
        return value;
    },

    calcCareTotalForPeriod: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (_ref16, _ref17) {
        var dispatch = _ref16.dispatch,
            state = _ref16.state;
        var index = _ref17.index;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__["a" /* validDate */])(state.periods[index].periodStart) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_components_form_validator_validations__["a" /* validDate */])(state.periods[index].periodEnd) && state.periods[index].hoursPerDay > 0) {
            return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.detailedCare([state.periods[index]], state.periods[index].gratuitousCare).then(function (care) {
                return dispatch('updateCarePeriod', { care: care, index: index });
            });
        }
    }, 500),

    updateCarePeriod: function updateCarePeriod(_ref18, _ref19) {
        var dispatch = _ref18.dispatch,
            commit = _ref18.commit;
        var care = _ref19.care,
            index = _ref19.index;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(care[0]).forEach(function (key) {
            var value = care[0][key];
            commit(mutationTypes.UPDATE_CARE_PERIOD_VALUE, { key: key, value: value, index: index });
        });
        dispatch('updateCareTotal');
    },
    updateCareTotal: function updateCareTotal(_ref20) {
        var commit = _ref20.commit,
            state = _ref20.state;

        var value = state.periods.reduce(function (total, period) {
            return total + numberVal(period.total);
        }, 0);
        commit(mutationTypes.SET, { key: 'pastCostOfCare', value: value });
    },
    calcAllInterest: function calcAllInterest(_ref21) {
        var dispatch = _ref21.dispatch,
            state = _ref21.state,
            rootGetters = _ref21.rootGetters;

        if (state.interestType === "none") {
            return dispatch('resetInterest');
        }
        if (state.interestType === 'custom' && (state.customInterestDate === '' || state.customInterestDate === null)) {
            return null;
        }

        var claimInfo = rootGetters['personal/claimant/getClaimInfo'];
        var claimant = rootGetters['personal/claimant/claimant'];

        if (__WEBPACK_IMPORTED_MODULE_6_moment___default()(state.customInterestDate, 'DD/MM/YYYY').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()(claimInfo('dateOfInjury'), 'DD/MM/YYYY'))) {
            return;
        }

        var headsOfLoss = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state, {
            pastLossOfEarnings: rootGetters['personal/claimant/getIncomeValue']('pastLossOfEarningsNetTotal'),
            generalDamages: rootGetters['personal/generalDamages/getGeneralDamages']
        });

        return __WEBPACK_IMPORTED_MODULE_7_services_Api__["a" /* default */].calculators.monetary.interest(claimInfo('proceduralStatus'), claimInfo('dateOfAssumedSettlement'), claimInfo('dateOfServiceProceedings'), claimInfo('dateOfInjury'), claimant.lifeExpectancy.dateOfDeath, rootGetters['personal/cruBenefits/all'], headsOfLoss, rootGetters['personal/interimPayments/interimPayments']).then(function (data) {
            return dispatch('updateInterestValues', data);
        });
    },
    updateInterestValues: function updateInterestValues(_ref22, data) {
        var commit = _ref22.commit;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
            if (key.includes("custom_")) {
                commit(mutationTypes.UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE, {
                    key: data[key]['key'],
                    value: data[key]['value'],
                    index: data[key]['index']
                });
            }
            commit(mutationTypes.SET, { key: key + 'WithInterest', value: data[key] });
        });
    },
    resetInterest: function resetInterest(_ref23) {
        var commit = _ref23.commit;

        commit(mutationTypes.RESET_INTEREST);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state, payload.key, payload.value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER, function (state, _ref24) {
    var data = _ref24.data;

    state.generalDamagesInterest = data.generalDamagesInterest;
    state.generalDamagesWithInterest = data.generalDamagesWithInterest;
    state.pastLossOfEarnings = data.pastLossOfEarnings;
    state.pastLossOfEarningsInterest = data.pastLossOfEarningsInterest;
    state.pastLossOfEarningsWithInterest = data.pastLossOfEarningsWithInterest;
    state.pastReducedEarningsInterest = data.pastReducedEarningsInterest;
    state.pastReducedEarningsWithInterest = data.pastReducedEarningsWithInterest;
    state.pastCostOfServices = data.pastCostOfServices;
    state.pastCostOfServicesInterest = data.pastCostOfServicesInterest;
    state.pastCostOfServicesWithInterest = data.pastCostOfServicesWithInterest;
    state.pastCostOfTravel = data.pastCostOfTravel;
    state.pastCostOfTravelInterest = data.pastCostOfTravelInterest;
    state.pastCostOfTravelWithInterest = data.pastCostOfTravelWithInterest;
    state.misc = data.misc;
    state.miscInterest = data.miscInterest;
    state.miscWithInterest = data.miscWithInterest;
    state.headsOfLoss = data.headsOfLoss;
    state.customHeadsOfLossTotal = data.customHeadsOfLossTotal;
    state.customHeadsOfLossTotalWithInterest = data.customHeadsOfLossTotalWithInterest;
    state.careCalcType = data.careCalcType;
    state.pastCostOfCare = data.pastCostOfCare;
    state.pastCostOfCareInterest = data.pastCostOfCareInterest;
    state.pastCostOfCareWithInterest = data.pastCostOfCareWithInterest;
    state.periods = data.periods;
    state.interestType = data.interestType;
    state.customInterestDate = data.customInterestDate;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, initialState());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_CUSTOM_HEAD_OF_LOSS, function (state) {
    if (state.headsOfLoss && state.headsOfLoss.length > 0) {
        switch (true) {
            case state.headsOfLoss[state.headsOfLoss.length - 1].name === '':
            case state.headsOfLoss[state.headsOfLoss.length - 1].value <= 0:
                return false;
        }
    }

    state.headsOfLoss.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_store_modules_shared_templates__["d" /* customHeadsOfLossTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_CUSTOM_HEAD_OF_LOSS, function (state, index) {
    if (index === 0 && state.headsOfLoss.length === 1) {
        state.headsOfLoss = [];
    }
    state.headsOfLoss.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CUSTOM_HEAD_OF_LOSS_VALUE, function (state, _ref25) {
    var key = _ref25.key,
        value = _ref25.value,
        index = _ref25.index;

    state.headsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_CARE_PERIOD, function (state) {
    state.periods.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_store_modules_shared_templates__["e" /* carePeriodTemplate */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CARE_PERIOD_VALUE, function (state, _ref26) {
    var key = _ref26.key,
        value = _ref26.value,
        index = _ref26.index;

    state.periods[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_CARE_PERIOD, function (state, data) {
    state.periods.splice(data.index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_INTEREST, function (state) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
        if (key.substr(-12) === "WithInterest") {
            state[key] = 0;
        }
    });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_modules_claim__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_generators_step__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Validator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Api__ = __webpack_require__(5);







var mutationTypes = {
    RESET: 'RESET'
};

var rootRules = {
    'personal.claimant.theClaimant.income.pastLossOfEarnings': { type: 'text', rules: 'required' }
};

var state = {};

var getters = {};

var actions = {
    save: function save(_ref, payload) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState,
            state = _ref.state;

        payload.data = state;
        payload.data.retirement_date = rootState.personal.claimant.theClaimant.income.retirementDate;
        payload.data.assumed_date_of_death = rootState.personal.claimant.theClaimant.assumedLifeExpectancy.dateOfDeath;

        __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].claims.save(payload).then(function (response) {
            return response;
        });

        __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].dispatch('personal/save', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_store_modules_claim__["d" /* requestPayload */])(0));
    },
    load: function load(_ref2, step) {
        var dispatch = _ref2.dispatch,
            action = _ref2.action,
            commit = _ref2.commit;
    },
    process: function process(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 2,
            valid: true });
    },
    validate: function validate(_ref4) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 2,
            valid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_generators_step__["a" /* previousValid */])(rootState, 2) && new __WEBPACK_IMPORTED_MODULE_4_services_Validator__["a" /* default */](rootState, rootRules).validate()
        });
    },
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        __WEBPACK_IMPORTED_MODULE_1_store_index__["a" /* default */].dispatch('personal/step/setStepNumberValid', {
            stepNo: 2,
            valid: false
        });

        commit(mutationTypes.RESET);
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, mutationTypes.RESET, function (state) {});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_personal_injury_claims_routes__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_generators_step__ = __webpack_require__(21);



var steps = __WEBPACK_IMPORTED_MODULE_0_pages_personal_injury_claims_routes__["a" /* default */][0].children.map(function (route) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_generators_step__["b" /* buildFromRoute */])({ route: route, prefix: 'personal-injury' });
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_store_generators_step__["c" /* default */])(steps));

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);



var _mutations;



var mutataionTypes = {
    UPDATE: 'UPDATE',
    RESET: 'RESET',
    RESET_TYPE: 'RESET_TYPE',
    UPDATE_CLAIMS: 'UPDATE_CLAIMS'
};

var initialState = function initialState() {
    return {
        diseaseOrAccident: null,
        diseaseType: null,
        accidentType: null,
        claimType: null,
        discountRate: -.25,
        from: 'dayOne',
        to: 'paid',
        claims: [],
        range: [-0.20, 0.20],
        searchTerm: '',
        calculating: false,
        hasNoClaims: false,
        includeInTable: 'all'
    };
};

var state = initialState();

function getAverageDifference(state, getters) {
    var difference = getters.claims.map(function (claim) {
        return Math.abs(claim.to - claim.from);
    });

    var average = difference.reduce(function (total, value) {
        return total + value;
    }, 0);

    return average / getters.claims.length;
}

var getters = {
    calculating: function calculating(state) {
        return state.calculating;
    },
    diseaseOrAccident: function diseaseOrAccident(state) {
        return state.diseaseOrAccident;
    },
    diseaseType: function diseaseType(state) {
        return state.diseaseType;
    },
    accidentType: function accidentType(state) {
        return state.accidentType;
    },
    claimType: function claimType(state) {
        return state.claimType;
    },
    discountRate: function discountRate(state) {
        return state.discountRate;
    },
    from: function from(state) {
        return state.from;
    },
    to: function to(state) {
        return state.to;
    },
    range: function range(state) {
        return state.range;
    },
    claims: function claims(state) {
        return state.claims.filter(function (claim) {
            return claim.outcome === 'Paid' || state.from !== 'paid' && state.to !== 'paid';
        }).map(function (claim) {
            var difference = claim[state.to] - claim[state.from];
            return {
                id: claim.id,
                type: claim.type,
                reference: claim.reference,
                claimHandler: claim.claimsHandler,
                from: parseFloat(claim[state.from]),
                to: parseFloat(claim[state.to]),
                difference: parseFloat(difference),
                percent: difference / parseFloat(claim[state.from])
            };
        });
    },
    hasClaims: function hasClaims(state) {
        return !!(state.claims && state.claims.length);
    },
    hasNoClaims: function hasNoClaims(state) {
        return state.hasNoClaims;
    },
    hasPaidClaims: function hasPaidClaims(state) {
        if (!state.claims || state.claims.length === 0) {
            return false;
        }
        return !!state.claims.filter(function (claim) {
            return claim.outcome === 'Paid' || state.from !== 'paid' && state.to !== 'paid';
        }).length;
    },
    numberOfPaid: function numberOfPaid(state) {
        if (!state.claims || state.claims.length === 0) {
            return 0;
        }
        return state.claims.filter(function (claim) {
            return claim.outcome === 'Paid' || state.from !== 'paid' && state.to !== 'paid';
        }).length;
    },
    tableClaims: function tableClaims(state, getters) {
        return getters.claims.filter(function (claim) {
            switch (state.includeInTable) {
                case 'all':
                    return true;
                case 'under':
                    return claim.percent < state.range[0];
                case 'over':
                    return claim.percent > state.range[1];
                case 'inside':
                    return claim.percent >= state.range[0] && claim.percent <= state.range[1];
                case 'outside':
                    return claim.percent < state.range[0] || claim.percent > state.range[1];
            }
        }).sort(function (a, b) {
            return Math.abs(b.difference) - Math.abs(a.difference);
        });
    },
    totalClaims: function totalClaims(state) {
        return state.claims.length;
    },
    averageFrom: function averageFrom(state, getters) {
        return getters.claims.reduce(function (total, claim) {
            return total + claim.from;
        }, 0) / getters.claims.length;
    },
    averageTo: function averageTo(state, getters) {
        return getters.claims.reduce(function (total, claim) {
            return total + claim.to;
        }, 0) / getters.claims.length;
    },
    averageDifference: function averageDifference(state, getters) {
        return getAverageDifference(state, getters);
    },
    includeInTable: function includeInTable(state) {
        return state.includeInTable;
    }
};

var actions = {
    update: function update(_ref, _ref2) {
        var commit = _ref.commit;
        var key = _ref2.key,
            value = _ref2.value;

        commit(mutataionTypes.UPDATE, { key: key, value: value });
    },
    resetType: function resetType(_ref3, _ref4) {
        var commit = _ref3.commit;
        var key = _ref4.key;

        commit(mutataionTypes.RESET_TYPE, { key: key });
    },
    calculate: function calculate(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state,
            dispatch = _ref5.dispatch;


        var injuryType = null;

        switch (state.diseaseOrAccident) {
            case 'disease':
                injuryType = state.diseaseType;
                break;
            case 'accident':
                injuryType = state.accidentType;
                break;
        }

        return dispatch('update', { key: 'calculating', value: true }).then(function () {
            return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].dashboards.reserving.compareAssessment(state.diseaseOrAccident, injuryType, state.claimType, state.discountRate, state.from, state.to);
        }).then(function (results) {
            return commit(mutataionTypes.UPDATE_CLAIMS, results);
        }).then(function () {
            return dispatch('update', { key: 'calculating', value: false });
        });
    },
    search: function search(_ref6, term) {
        var commit = _ref6.commit;

        commit(mutataionTypes.UPDATE, { key: 'searchTerm', value: term });
    },
    resetSearch: function resetSearch(_ref7) {
        var commit = _ref7.commit;

        commit(mutataionTypes.UPDATE, { key: 'searchTerm', value: '' });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutataionTypes.UPDATE, function (state, _ref8) {
    var key = _ref8.key,
        value = _ref8.value;

    state[key] = value;
    if (key === 'calculating' && value) {
        state.hasNoClaims = false;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutataionTypes.RESET_TYPE, function (state, _ref9) {
    var key = _ref9.key,
        value = _ref9.value;

    state[key] = value;

    switch (key) {
        case 'accidentType':
            state.accidentType = null;
            break;
        case 'diseaseType':
            state.diseaseType = null;
            break;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutataionTypes.UPDATE_CLAIMS, function (state, claims) {
    state.claims = claims;
    state.hasNoClaims = !claims || claims.length === 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutataionTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, initialState());
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__ = __webpack_require__(19);





var _mutations;






var m = function m(value) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, 'DD/MM/YYYY');
};

var serverDate = function serverDate(date) {
    return m(date).format('YYYY-MM-DD');
};

var notNull = function notNull(value) {
    return value !== null;
};

var camelCaseObjectKeys = function camelCaseObjectKeys(src) {
    var ret = {};
    var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(src);
    keys.forEach(function (key, i) {
        return ret[__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.camelCase(key)] = src[key];
    });
    return ret;
};

var camelCaseObjectKeysDeep = function camelCaseObjectKeysDeep(src) {
    return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.chain(camelCaseObjectKeys(src)).mapValues(function (value) {
        return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isObjectLike(value) ? camelCaseObjectKeysDeep(value) : value;
    }).value();
};

var checkForServerDates = function checkForServerDates(src) {
    return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.chain(src).mapValues(function (value) {
        if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isObjectLike(value)) {
            return checkForServerDates(value);
        }

        if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isString(value) && /[\d]{4}-[\d]{1,2}-[\d]{1,2}/.test(value)) {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
        return value;
    }).value();
};

var mutationTypes = {
    UPDATE_DECEASED: 'UPDATE_DECEASED',
    UPDATE_CLAIM: 'UPDATE_CLAIM',
    UPDATE_CLAIM_ID: 'UPDATE_CLAIM_ID',
    UPDATE_NAME_AND_REFERENCE: 'UPDATE_NAME_AND_REFERENCE',
    UPDATE_DEPENDENCY_TYPE: 'UPDATE_DEPENDENCY_TYPE',
    SET_AGE: 'SET_AGE',
    UPDATE_RESULT: 'UPDATE_RESULT',
    RESET_RESULT: 'RESET_RESULT',
    UPDATE_CONTRIBUTION: 'UPDATE_CONTRIBUTION',
    RESET: 'RESET',
    UPDATE_FROM_SERVER_STEP: 'UPDATE_FROM_SERVER_STEP',
    ADD_OWN_HEAD_OF_LOSS: 'ADD_OWN_HEAD_OF_LOSS',
    UPDATE_OWN_HEAD_OF_LOSS: 'UPDATE_OWN_HEAD_OF_LOSS',
    DELETE_OWN_HEAD_OF_LOSS: 'DELETE_OWN_HEAD_OF_LOSS',
    START_CALCULATING: 'START_CALCULATING',
    STOP_CALCULATING: 'STOP_CALCULATING',
    UPDATE_COSTS: 'UPDATE_COSTS',
    UPDATE_CLAIMANT_SOLICITOR_ID: 'UPDATE_CLAIMANT_SOLICITOR_ID',
    UPDATE_DEFENDANT_ID: 'UPDATE_DEFENDANT_ID',
    SET_FORM_DIRTY: 'SET_FORM_DIRTY',
    SET_FORM_CLEAN: 'SET_FORM_CLEAN',
    UPDATE_GENERAL_DAMAGES: 'UPDATE_GENERAL_DAMAGES'

};

var initialState = function initialState() {
    return {
        claimId: null,
        stepId: null,
        dependencyType: null,
        hasResults: false,
        dirtyForm: false,
        nameAndReference: {
            claimantName: null,
            claimantReference: null,
            yourReference: null,
            defendantName: {
                id: null,
                name: null,
                type: null
            },
            claimantSolicitors: {
                id: null,
                name: null,
                type: null
            }
        },
        claim: {
            type: 'fatal_accident',
            diseaseOrAccident: null,
            accidentType: null,
            diseaseType: null,
            assumedSettlement: null,
            proceduralStatus: null,
            numberOfDependants: null
        },
        person: {
            gender: null,
            dateOfBirth: null,
            dateOfDeath: null,
            ageAtDeath: null,
            employmentType: null,
            onsetOfSymptoms: null,
            salary: null,
            occupation: {
                code: '',
                description: ''
            }
        },
        results: {
            calculation: {
                deceasedAgeDeath: null,
                periodBetweenDodAndAssessment: null,
                deceasedAgeAtAssessment: null,
                periodOfDependencyFromAssessment: null,
                ogdenDiscountRate: null,
                table28Multiplier: null,
                preAssessmentDiscount: null,
                postAssessmentDiscount: null,
                retirementDate: null
            },
            damages: {
                generalDamages: null,
                pastLossOfEarnings: null,
                pastCostOfDiy: null,
                bereavementAward: null,
                care: null,
                funeralExpenses: null,
                miscellaneous: null,
                dependencyOnIncome: null,
                dependencyOnServices: null,
                totalDamages: null
            },
            reserve: {
                claimantCosts: null,
                defenceCosts: null
            },
            chart: {}
        },
        contributions: {
            damages: 100,
            claimant: 100,
            defence: 100
        },
        ownHeadsOfLoss: [],
        calculating: false
    };
};

function claimForServer(state, modal) {
    return {
        type: modal ? state.claim.type + '_' + state.dependencyType : state.claim.type,
        diseaseOrAccident: state.claim.diseaseOrAccident,
        diseaseType: state.claim.diseaseType,
        accidentType: state.claim.accidentType,
        assumedSettlement: serverDate(state.claim.assumedSettlement),
        proceduralStatus: state.claim.proceduralStatus,
        numberOfDependants: state.claim.numberOfDependants,
        dependencyType: state.dependencyType
    };
}

function personForServer(state) {
    return {
        gender: state.person.gender,
        dateOfBirth: serverDate(state.person.dateOfBirth),
        dateOfDeath: serverDate(state.person.dateOfDeath),
        ageAtDeath: state.person.ageAtDeath,
        employmentType: state.person.employmentType,
        onsetOfSymptoms: serverDate(state.person.onsetOfSymptoms),
        salary: state.person.salary,
        occupation: state.person.occupation
    };
}

var state = initialState();

var getters = {
    modalPayload: function modalPayload(state) {
        return {
            dependencyType: state.dependencyType,
            claim: claimForServer(state, true),
            person: personForServer(state)
        };
    },
    diseaseOrAccident: function diseaseOrAccident(state) {
        return state.claim.diseaseOrAccident;
    },
    diseaseType: function diseaseType(state) {
        return state.claim.diseaseType;
    },
    accidentType: function accidentType(state) {
        return state.claim.accidentType;
    },
    estateOrDependency: function estateOrDependency(state) {
        return state.dependencyType;
    },
    gender: function gender(state) {
        return state.person.gender;
    },
    dateOfBirth: function dateOfBirth(state) {
        return state.person.dateOfBirth;
    },
    dateOfDeath: function dateOfDeath(state) {
        return state.person.dateOfDeath;
    },
    ageAtDeath: function ageAtDeath(state) {
        return state.person.ageAtDeath;
    },
    assumedSettlement: function assumedSettlement(state) {
        return state.claim.assumedSettlement;
    },
    employmentType: function employmentType(state) {
        return state.person.employmentType;
    },
    onsetOfSymptoms: function onsetOfSymptoms(state) {
        return state.person.onsetOfSymptoms;
    },
    occupation: function occupation(state) {
        return state.person.occupation;
    },
    salary: function salary(state) {
        return state.person.salary;
    },
    proceduralStatus: function proceduralStatus(state) {
        return state.claim.proceduralStatus;
    },
    numberOfDependants: function numberOfDependants(state) {
        return state.claim.numberOfDependants;
    },
    ageAtAssessment: function ageAtAssessment(state) {
        return m(state.claim.assumedSettlement).diff(m(state.person.dateOfBirth), 'years', true);
    },
    claimantName: function claimantName(state) {
        return state.nameAndReference.claimantName;
    },
    claimantSolicitors: function claimantSolicitors(state) {
        return state.nameAndReference.claimantSolicitors;
    },
    claimantReference: function claimantReference(state) {
        return state.nameAndReference.claimantReference;
    },
    yourReference: function yourReference(state) {
        return state.nameAndReference.yourReference;
    },
    defendantName: function defendantName(state) {
        return state.nameAndReference.defendantName;
    },
    hasResults: function hasResults(state) {
        return state.hasResults;
    },
    isValid: function isValid(state) {
        var toTest = [state.dependencyType, state.person.gender, state.person.dateOfBirth, state.person.dateOfDeath, state.person.ageAtDeath, state.person.employmentType, state.person.onsetOfSymptoms, state.claim.diseaseOrAccident === 'disease' ? state.claim.diseaseType : true, state.claim.diseaseOrAccident === 'accident' ? state.claim.accidentType : true, state.claim.assumedSettlement, state.claim.proceduralStatus, state.person.employmentType === 'employed' ? state.person.income : true, state.dependencyType === 'dependency' ? state.claim.numberOfDependants : true];
        return toTest.every(notNull);
    },
    results: function results(state) {
        return state.results;
    },
    claimantContribution: function claimantContribution(state) {
        return state.contributions.claimant;
    },
    defenceContribution: function defenceContribution(state) {
        return state.contributions.defence;
    },
    damagesContribution: function damagesContribution(state) {
        return state.contributions.damages;
    },
    apportionedClaimantReserve: function apportionedClaimantReserve(state) {
        return state.results.reserve.claimantCosts * (state.contributions.claimant / 100) || 0;
    },
    apportionedDefenceReserve: function apportionedDefenceReserve(state) {
        return state.results.reserve.defenceCosts * (state.contributions.defence / 100) || 0;
    },
    apportionedDamagesReserve: function apportionedDamagesReserve(state, getters) {
        return getters.totalDamages * (state.contributions.damages / 100) || 0;
    },
    totalReserve: function totalReserve(state, getters) {
        return getters.apportionedClaimantReserve + getters.apportionedDefenceReserve + getters.apportionedDamagesReserve;
    },
    totalDamages: function totalDamages(state) {
        return state.results.damages.totalDamages + state.ownHeadsOfLoss.reduce(function (total, head) {
            return total + head.value;
        }, 0);
    },
    chartData: function chartData(state) {
        return state.results.chart;
    },
    durationOfSymptoms: function durationOfSymptoms(state) {
        return m(state.person.dateOfDeath).diff(m(state.person.onsetOfSymptoms), 'months');
    },
    isValidForSave: function isValidForSave(state, getters, rootState) {
        return (rootState.user.user.hideNames || state.nameAndReference.claimantName !== null) && state.nameAndReference.claimantSolicitors.name !== null && state.nameAndReference.claimantReference !== null && state.nameAndReference.yourReference !== null && state.nameAndReference.defendantName.name !== null && state.nameAndReference.claimantName !== '' && state.nameAndReference.claimantSolicitors.name !== '' && state.nameAndReference.claimantReference !== '' && state.nameAndReference.yourReference !== '' && state.nameAndReference.defendantName.name !== '';
    },
    exists: function exists(state) {
        return !!state.claimId;
    },
    ownHeadsOfLoss: function ownHeadsOfLoss(state) {
        return state.ownHeadsOfLoss;
    },
    claimId: function claimId(state) {
        return state.claimId;
    },
    calculating: function calculating(state) {
        return state.calculating;
    },
    noChartData: function noChartData(state) {
        return !state.results.chart || !state.results.chart.count;
    },
    claimType: function claimType(state) {
        return state.claim.type;
    },
    defenceCosts: function defenceCosts(state) {
        return state.results.reserve.defenceCosts;
    },
    claimantCosts: function claimantCosts(state) {
        return state.results.reserve.claimantCosts;
    },
    dirtyForm: function dirtyForm(state) {
        return state.dirtyForm;
    }
};

var actions = {
    updateValue: function updateValue(_ref, _ref2) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        var key = _ref2.key,
            value = _ref2.value;

        switch (key) {
            case 'estateOrDependency':
                commit(mutationTypes.SET_FORM_DIRTY);
                return commit(mutationTypes.UPDATE_DEPENDENCY_TYPE, value);
            case 'dateOfBirth':
            case 'dateOfDeath':
            case 'ageAtDeath':
                commit(mutationTypes.SET_FORM_DIRTY);
                return dispatch('updateAge', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, key, value)).then(function () {
                    return commit(mutationTypes.UPDATE_DECEASED, { key: key, value: value });
                });
            case 'gender':
            case 'employmentType':
            case 'onsetOfSymptoms':
            case 'occupation':
            case 'salary':
                commit(mutationTypes.SET_FORM_DIRTY);
                return commit(mutationTypes.UPDATE_DECEASED, { key: key, value: value });
            case 'diseaseType':
            case 'accidentType':
            case 'diseaseOrAccident':
            case 'assumedSettlement':
            case 'proceduralStatus':
            case 'numberOfDependants':
                commit(mutationTypes.SET_FORM_DIRTY);
                return commit(mutationTypes.UPDATE_CLAIM, { key: key, value: value });
            case 'claimantContribution':
                return commit(mutationTypes.UPDATE_CONTRIBUTION, { type: 'claimant', value: value });
            case 'defenceContribution':
                return commit(mutationTypes.UPDATE_CONTRIBUTION, { type: 'defence', value: value });
            case 'damagesContribution':
                return commit(mutationTypes.UPDATE_CONTRIBUTION, { type: 'damages', value: value });
            case 'claimantName':
            case 'claimantSolicitors':
                return commit(mutationTypes.UPDATE_NAME_AND_REFERENCE, { key: key, value: value });
            case 'claimantReference':
            case 'yourReference':
            case 'defendantName':
                return commit(mutationTypes.UPDATE_NAME_AND_REFERENCE, { key: key, value: value });
            case 'type':
                return commit(mutationTypes.UPDATE_CLAIM, { key: key, value: value });
            case 'defenceCosts':
                return commit(mutationTypes.UPDATE_COSTS, { key: key, value: value });
            case 'claimantCosts':
                return commit(mutationTypes.UPDATE_COSTS, { key: key, value: value });
            case 'generalDamages':
                return commit(mutationTypes.UPDATE_GENERAL_DAMAGES, value);
        }
    },
    performCalculation: function performCalculation(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;

        commit(mutationTypes.RESET_RESULT);
        commit(mutationTypes.START_CALCULATING);
        return __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].dashboards.reserving.simpleAssessment(claimForServer(state), personForServer(state)).then(function (results) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.results).map(function (key) {
                return commit(mutationTypes.UPDATE_RESULT, {
                    type: key,
                    data: camelCaseObjectKeys(results[key])
                });
            });
        }).then(function () {
            return commit(mutationTypes.SET_FORM_CLEAN);
        }).then(function () {
            return commit(mutationTypes.STOP_CALCULATING);
        });
    },
    updateAge: function updateAge(_ref4, _ref5) {
        var commit = _ref4.commit,
            state = _ref4.state;
        var dateOfBirth = _ref5.dateOfBirth,
            dateOfDeath = _ref5.dateOfDeath,
            ageAtDeath = _ref5.ageAtDeath;

        switch (true) {
            case !!(dateOfBirth && dateOfDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: dateOfBirth,
                    dateOfDeath: dateOfDeath,
                    ageAtDeath: m(dateOfDeath).diff(m(dateOfBirth), 'years', true)
                });
            case !!(dateOfBirth && ageAtDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: dateOfBirth,
                    dateOfDeath: m(dateOfBirth).add(ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: ageAtDeath
                });
            case !!(dateOfDeath && ageAtDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: m(dateOfDeath).subtract(ageAtDeath, 'years').format('DD/MM/YYYY'),
                    dateOfDeath: dateOfDeath,
                    ageAtDeath: ageAtDeath
                });

            case !!(dateOfBirth && state.person.dateOfDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: dateOfBirth,
                    dateOfDeath: state.person.dateOfDeath,
                    ageAtDeath: m(state.person.dateOfDeath).diff(m(dateOfBirth), 'years', true)
                });
            case !!(ageAtDeath && state.person.dateOfBirth):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: state.person.dateOfBirth,
                    dateOfDeath: m(state.person.dateOfBirth).add(ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: ageAtDeath
                });
            case !!(dateOfBirth && state.person.ageAtDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: dateOfBirth,
                    dateOfDeath: m(dateOfBirth).add(state.person.ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: state.person.ageAtDeath
                });
            case !!(ageAtDeath && state.person.dateOfDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: m(state.person.dateOfDeath).subtract(ageAtDeath, 'years').format('DD/MM/YYYY'),
                    dateOfDeath: state.person.dateOfDeath,
                    ageAtDeath: ageAtDeath
                });
            case !!(dateOfDeath && state.person.dateOfBirth):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: state.person.dateOfBirth,
                    dateOfDeath: dateOfDeath,
                    ageAtDeath: m(dateOfDeath).diff(m(state.person.dateOfBirth), 'years', true)
                });
            case !!(dateOfDeath && state.person.ageAtDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: m(state.person.dateOfDeath).subtract(state.person.ageAtDeath, 'years').format('DD/MM/YYYY'),
                    dateOfDeath: dateOfDeath,
                    ageAtDeath: state.person.ageAtDeath
                });

            case !!dateOfBirth:
                return commit(mutationTypes.UPDATE_DECEASED, { key: 'dateOfBirth', value: dateOfBirth });
            case !!dateOfDeath:
                return commit(mutationTypes.UPDATE_DECEASED, { key: 'dateOfDeath', value: dateOfDeath });
            case !!ageAtDeath:
                return commit(mutationTypes.UPDATE_DECEASED, { key: 'ageAtDeath', value: ageAtDeath });
        }
    },
    reset: function reset(_ref6) {
        var commit = _ref6.commit;

        return commit(mutationTypes.RESET);
    },
    save: function save(_ref7) {
        var commit = _ref7.commit,
            state = _ref7.state;
        var claimId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.claimId;

        return __WEBPACK_IMPORTED_MODULE_5_services_Api__["a" /* default */].claims.save({
            claim_id: claimId,
            step_id: state.stepId,
            claim_type: 'day_one_only_fatal_accident',
            step_number: 0,
            data: {
                dependencyType: state.dependencyType,
                nameAndReference: state.nameAndReference,
                claim: claimForServer(state),
                person: personForServer(state),
                results: {
                    calculation: state.results.calculation,
                    damages: state.results.damages,
                    reserve: state.results.reserve,
                    chart: state.results.chart
                },
                contributions: state.contributions,
                ownHeadsOfLoss: state.ownHeadsOfLoss
            }
        }).then(function (result) {
            commit(mutationTypes.UPDATE_CLAIM_ID, { claimId: result.step.claim_id, stepId: result.step.step_id });
            return result.step.claim_id;
        });
    },
    openAsClaim: function openAsClaim(_ref8) {
        var dispatch = _ref8.dispatch,
            state = _ref8.state;

        var updateClaim = function updateClaim(key, value) {
            return dispatch('fatal/' + state.dependencyType + '/claimDetails/update', {
                key: key,
                value: value
            }, { root: true });
        };
        var dispatchTo = 'fatal/' + state.dependencyType + '/deceased/updateTheDeceased';

        return dispatch('claim/reset', null, { root: true }).then(function () {
            return dispatch('claim/initialise', state.claim.type + '_' + state.dependencyType, { root: true });
        }).then(function () {
            return dispatch('claim/setClaimId', state.claimId, { root: true });
        }).then(function () {
            return dispatch('menu/updateSubMenu', 'fatal/' + state.dependencyType, { root: true });
        }).then(function () {
            return dispatch('menu/updateMenu', '', { root: true });
        }).then(function () {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([updateClaim('claimantName', state.nameAndReference.claimantName), updateClaim('defendantName', state.nameAndReference.defendantName), updateClaim('claimantSolicitor', state.nameAndReference.claimantSolicitors), updateClaim('claimantReference', state.nameAndReference.claimantReference), updateClaim('yourReference', state.nameAndReference.yourReference), updateClaim('assumedSettlement', state.claim.assumedSettlement), updateClaim('diseaseOrAccident', state.claim.diseaseOrAccident), updateClaim('diseaseType', state.claim.diseaseType), updateClaim('accidentType', state.claim.accidentType), dispatch(dispatchTo, {
                gender: state.person.gender,
                dateOfBirth: state.person.dateOfBirth,
                dateOfDeath: state.person.dateOfDeath,
                onsetOfSymptoms: state.person.onsetOfSymptoms
            }, { root: true })]);
        }).then(function () {
            return state.claimId;
        });
    },
    load: function load(_ref9, response) {
        var commit = _ref9.commit;

        var step = response.steps[0];

        commit(mutationTypes.UPDATE_FROM_SERVER_STEP, step);

        if (response.claimant_solicitor_id) {
            commit(mutationTypes.UPDATE_CLAIMANT_SOLICITOR_ID, response.claimant_solicitor_id);
        }

        if (response.defendant_id) {
            commit(mutationTypes.UPDATE_DEFENDANT_ID, response.defendant_id);
        }

        return;
    },
    addHeadOfLoss: function addHeadOfLoss(_ref10) {
        var commit = _ref10.commit;

        return commit(mutationTypes.ADD_OWN_HEAD_OF_LOSS);
    },
    updateHeadOfLoss: function updateHeadOfLoss(_ref11, _ref12) {
        var commit = _ref11.commit;
        var index = _ref12.index,
            key = _ref12.key,
            value = _ref12.value;

        return commit(mutationTypes.UPDATE_OWN_HEAD_OF_LOSS, { index: index, key: key, value: value });
    },
    deleteHeadOfLoss: function deleteHeadOfLoss(_ref13, index) {
        var commit = _ref13.commit;

        return commit(mutationTypes.DELETE_OWN_HEAD_OF_LOSS, index);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DECEASED, function (state, _ref14) {
    var key = _ref14.key,
        value = _ref14.value;

    state.person[key] = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDENCY_TYPE, function (state, value) {
    state.dependencyType = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIM, function (state, _ref15) {
    var key = _ref15.key,
        value = _ref15.value;

    state.claim[key] = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_NAME_AND_REFERENCE, function (state, _ref16) {
    var key = _ref16.key,
        value = _ref16.value;

    state.nameAndReference[key] = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIMANT_SOLICITOR_ID, function (state, value) {
    state.nameAndReference.claimantSolicitors.id = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEFENDANT_ID, function (state, value) {
    state.nameAndReference.defendantName.id = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_AGE, function (state, _ref17) {
    var dateOfBirth = _ref17.dateOfBirth,
        dateOfDeath = _ref17.dateOfDeath,
        ageAtDeath = _ref17.ageAtDeath;

    state.person.dateOfBirth = dateOfBirth;
    state.person.dateOfDeath = dateOfDeath;
    state.person.ageAtDeath = __WEBPACK_IMPORTED_MODULE_7_mixins_roundValue__["a" /* default */].methods.roundValue(ageAtDeath, 2);
    state.person.employmentType = ageAtDeath > 64 ? 'retired' : 'employed';
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_RESULT, function (state, _ref18) {
    var type = _ref18.type,
        data = _ref18.data;

    state.results[type] = data;
    state.hasResults = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_RESULT, function (state) {
    state.hasResults = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CONTRIBUTION, function (state, _ref19) {
    var type = _ref19.type,
        value = _ref19.value;

    state.contributions[type] = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, initialState());
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIM_ID, function (state, _ref20) {
    var claimId = _ref20.claimId,
        stepId = _ref20.stepId;

    state.claimId = claimId;
    state.stepId = stepId;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER_STEP, function (state, step) {
    var data = camelCaseObjectKeysDeep(step.data);
    state.claimId = step.claim_id;
    state.stepId = step.id;
    state.dependencyType = step.data.dependency_type;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.claim, checkForServerDates(data.claim));
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.nameAndReference, checkForServerDates(data.nameAndReference));
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.person, checkForServerDates(data.person));
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.results, data.results);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.contributions, data.contributions);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.ownHeadsOfLoss, data.ownHeadsOfLoss);
    state.hasResults = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_OWN_HEAD_OF_LOSS, function (state) {
    state.ownHeadsOfLoss.push({
        name: null, value: 0
    });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_OWN_HEAD_OF_LOSS, function (state, _ref21) {
    var index = _ref21.index,
        key = _ref21.key,
        value = _ref21.value;

    state.ownHeadsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_OWN_HEAD_OF_LOSS, function (state, index) {
    state.ownHeadsOfLoss.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.START_CALCULATING, function (state) {
    state.calculating = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.STOP_CALCULATING, function (state) {
    state.calculating = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_FORM_DIRTY, function (state) {
    state.dirtyForm = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_FORM_CLEAN, function (state) {
    state.dirtyForm = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_COSTS, function (state, _ref22) {
    var key = _ref22.key,
        value = _ref22.value;

    state.results.reserve[key] = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_GENERAL_DAMAGES, function (state, value) {
    state.results.damages.totalDamages -= state.results.damages.generalDamages;
    state.results.damages.generalDamages = value;
    state.results.damages.totalDamages += value;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttleUpdateLife */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_roundValue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_personFunctions__ = __webpack_require__(38);






var _mutations;








var m = function m(value) {
    return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value, 'DD/MM/YYYY');
};

var serverDate = function serverDate(date) {
    return m(date).format('YYYY-MM-DD');
};

var notNull = function notNull(value) {
    return value !== null;
};

var camelCaseObjectKeys = function camelCaseObjectKeys(src) {
    var ret = {};
    var keys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(src);
    keys.forEach(function (key, i) {
        return ret[__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.camelCase(key)] = src[key];
    });
    return ret;
};

var camelCaseObjectKeysDeep = function camelCaseObjectKeysDeep(src) {
    return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.chain(camelCaseObjectKeys(src)).mapValues(function (value) {
        return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isObjectLike(value) ? camelCaseObjectKeysDeep(value) : value;
    }).value();
};

var checkForServerDates = function checkForServerDates(src) {
    return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.chain(src).mapValues(function (value) {
        if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isObjectLike(value)) {
            return checkForServerDates(value);
        }

        if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isString(value) && /[\d]{4}-[\d]{1,2}-[\d]{1,2}/.test(value)) {
            return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
        return value;
    }).value();
};

var calcAssumedLifeExpectancy = function calcAssumedLifeExpectancy(_ref) {
    var state = _ref.state,
        assumedLifeExpectancy = _ref.assumedLifeExpectancy;

    if (assumedLifeExpectancy.ageAtDeath || assumedLifeExpectancy.dateOfDeath || assumedLifeExpectancy.yearsLeft || assumedLifeExpectancy.monthsLeft || assumedLifeExpectancy.percentageOfNormalLifeExpectancy !== null || assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy !== null) {
        switch (assumedLifeExpectancy.method) {
            case 'assumed_years_and_months_left':
                return {
                    method: 'assumed_years_and_months_left',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(assumedLifeExpectancy.yearsLeft, 'years').add(assumedLifeExpectancy.monthsLeft, 'months').format('DD/MM/YYYY'),
                    ageAtDeath: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(assumedLifeExpectancy.yearsLeft, 'years').add(assumedLifeExpectancy.monthsLeft, 'months').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(state.claimant.dateOfBirth, 'DD/MM/YYYY'), 'days') / 365.25,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_date':
                return {
                    method: 'assumed_date',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: __WEBPACK_IMPORTED_MODULE_5_moment___default()(assumedLifeExpectancy.dateOfDeath, 'DD/MM/YYYY').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(state.claimant.dateOfBirth, 'DD/MM/YYYY'), 'days') / 365.25,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_age_at_death':
                var assumedDateDiff = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.claimant.dateOfBirth, 'DD/MM/YYYY').add(assumedLifeExpectancy.ageAtDeath, 'years').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(), 'months');

                return {
                    method: 'assumed_age_at_death',
                    yearsLeft: Math.floor(assumedDateDiff / 12),
                    monthsLeft: assumedDateDiff - Math.floor(assumedDateDiff / 12) * 12,
                    dateOfDeath: __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.claimant.dateOfBirth, 'DD/MM/YYYY').add(assumedLifeExpectancy.ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: 100,
                    percentageReductionInNormalLifeExpectancy: 0
                };
            case 'assumed_percentage_of_life':
                assumedLifeExpectancy.percentageOfNormalLifeExpectancy = assumedLifeExpectancy.percentageOfNormalLifeExpectancy || 0;

                return {
                    method: 'assumed_percentage_of_life',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: assumedLifeExpectancy.percentageOfNormalLifeExpectancy,
                    percentageReductionInNormalLifeExpectancy: 100 - assumedLifeExpectancy.percentageOfNormalLifeExpectancy
                };
            case 'assumed_reduction_in_life':
                assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy = assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy || 0;

                return {
                    method: 'assumed_reduction_in_life',
                    yearsLeft: assumedLifeExpectancy.yearsLeft,
                    monthsLeft: assumedLifeExpectancy.monthsLeft,
                    dateOfDeath: assumedLifeExpectancy.dateOfDeath,
                    ageAtDeath: assumedLifeExpectancy.ageAtDeath,
                    percentageOfNormalLifeExpectancy: 100 - assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy,
                    percentageReductionInNormalLifeExpectancy: assumedLifeExpectancy.percentageReductionInNormalLifeExpectancy
                };
        }
    }

    return assumedLifeExpectancy;
};

var updateObject = function updateObject(dispatch, action, obj) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([]);
    }

    var proms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return dispatch(action, { key: key, value: obj[key], index: index });
    });
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(proms);
};

var throttleUpdateLife = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.debounce(function (state, dispatch, action, person, lifeExpectancy, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_components_form_validator_validations__["a" /* validDate */])(person.dateOfBirth)) {
        if (lifeExpectancy.method == 'assumed_percentage_of_life') {
            lifeExpectancy.method = 'percentage_of_normal_life_expectancy';
        }

        if (lifeExpectancy.method == 'assumed_reduction_in_life') {
            lifeExpectancy.method = 'percentage_reduction_in_normal_life_expectancy';
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_services_personFunctions__["b" /* determineLife */])(state.claim.assumedSettlement, person, lifeExpectancy).then(function (updatedLife) {
            return updateObject(dispatch, action, updatedLife, index);
        }).then(function () {
            return dispatch('updateReductionInLife');
        });
    }
}, 500);

var mutationTypes = {
    UPDATE_CLAIMANT: 'UPDATE_CLAIMANT',
    UPDATE_CLAIM: 'UPDATE_CLAIM',
    UPDATE_CLAIM_ID: 'UPDATE_CLAIM_ID',
    UPDATE_NAME_AND_REFERENCE: 'UPDATE_NAME_AND_REFERENCE',
    UPDATE_DEPENDENCY_TYPE: 'UPDATE_DEPENDENCY_TYPE',
    SET_AGE: 'SET_AGE',
    UPDATE_RESULT: 'UPDATE_RESULT',
    RESET_RESULT: 'RESET_RESULT',
    UPDATE_CONTRIBUTION: 'UPDATE_CONTRIBUTION',
    RESET: 'RESET',
    UPDATE_FROM_SERVER_STEP: 'UPDATE_FROM_SERVER_STEP',
    ADD_OWN_HEAD_OF_LOSS: 'ADD_OWN_HEAD_OF_LOSS',
    UPDATE_OWN_HEAD_OF_LOSS: 'UPDATE_OWN_HEAD_OF_LOSS',
    DELETE_OWN_HEAD_OF_LOSS: 'DELETE_OWN_HEAD_OF_LOSS',
    START_CALCULATING: 'START_CALCULATING',
    STOP_CALCULATING: 'STOP_CALCULATING',
    UPDATE_LIFE_ASSUMED_EXPECTANCY: 'UPDATE_LIFE_ASSUMED_EXPECTANCY',
    UPDATE_LIFE_EXPECTANCY: 'UPDATE_LIFE_EXPECTANCY',
    UPDATE_COSTS: 'UPDATE_COSTS',
    UPDATE_CLAIMANT_SOLICITOR_ID: 'UPDATE_CLAIMANT_SOLICITOR_ID',
    UPDATE_DEFENDANT_ID: 'UPDATE_DEFENDANT_ID',
    UPDATE_GENERAL_DAMAGES: 'UPDATE_GENERAL_DAMAGES'
};

var initialState = function initialState() {
    return {
        claimId: null,
        stepId: null,
        hasResults: false,
        nameAndReference: {
            claimantName: null,
            claimantReference: null,
            yourReference: null,
            defendantName: {
                id: null,
                name: null,
                type: null
            },
            claimantSolicitors: {
                id: null,
                name: null,
                type: null
            }
        },
        claim: {
            type: 'lost_years',
            diseaseOrAccident: null,
            accidentType: null,
            diseaseType: null,
            assumedSettlement: null,
            proceduralStatus: null,
            claimantReductionInLife: 0
        },
        claimant: {
            gender: null,
            dateOfBirth: null,
            dateOfDeath: null,
            ageAtDeath: null,
            employmentType: null,
            onsetOfSymptoms: null,
            salary: null,
            occupation: {
                code: '',
                description: ''
            },
            assumedLifeExpectancy: {
                method: null,
                yearsLeft: 0,
                monthsLeft: 0,
                ageAtDeath: '',
                dateOfDeath: ''
            },
            lifeExpectancy: {
                method: 'ogden_table',
                yearsAndMonths: {
                    months: 0,
                    years: 0
                },
                dateOfDeathIsAssumed: null,
                ageAtDeath: null,
                dateOfDeath: null,
                percentageOfNormalLifeExpectancy: 100,
                percentageReductionInNormalLifeExpectancy: 0
            }
        },
        results: {
            calculation: {
                deceasedAgeAtAssumedDeath: null,
                periodBetweenDodAndAssessment: null,
                deceasedAgeAtAssessment: null,
                ogdenDiscountRate: null,
                table28Multiplier: null,
                preAssessmentDiscount: null,
                postAssessmentDiscount: null,
                retirementDate: null
            },
            damages: {
                generalDamages: null,
                pastLossOfEarnings: null,
                futureLossOfEarnings: null,
                pastCostOfDiy: null,
                bereavementAward: null,
                care: null,
                funeralExpenses: null,
                miscellaneous: null,
                totalDamages: null
            },
            reserve: {
                claimantCosts: null,
                defenceCosts: null
            },
            chart: {}
        },
        contributions: {
            damages: 100,
            claimant: 100,
            defence: 100
        },
        ownHeadsOfLoss: [],
        calculating: false
    };
};

function claimForServer(state) {
    return {
        type: state.claim.type,
        diseaseOrAccident: state.claim.diseaseOrAccident,
        diseaseType: state.claim.diseaseType,
        accidentType: state.claim.accidentType,
        assumedSettlement: serverDate(state.claim.assumedSettlement),
        proceduralStatus: state.claim.proceduralStatus,
        numberOfDependants: 0
    };
}

function personForServer(state) {
    return {
        gender: state.claimant.gender,
        dateOfBirth: serverDate(state.claimant.dateOfBirth),
        ageAtDeath: state.claimant.ageAtDeath,
        employmentType: state.claimant.employmentType,
        onsetOfSymptoms: serverDate(state.claimant.onsetOfSymptoms),
        salary: state.claimant.salary,
        occupation: state.claimant.occupation,
        dateOfDeathAssumed: serverDate(state.claimant.assumedLifeExpectancy.dateOfDeath),
        dateOfDeath: serverDate(state.claimant.dateOfDeath),
        assumed: state.claimant.assumedLifeExpectancy
    };
}

var state = initialState();

var getters = {
    modalPayload: function modalPayload(state) {
        return {
            dependencyType: state.dependencyType,
            claim: claimForServer(state),
            person: personForServer(state)
        };
    },
    claimant: function claimant(state) {
        return state.claimant;
    },
    diseaseOrAccident: function diseaseOrAccident(state) {
        return state.claim.diseaseOrAccident;
    },
    diseaseType: function diseaseType(state) {
        return state.claim.diseaseType;
    },
    accidentType: function accidentType(state) {
        return state.claim.accidentType;
    },
    estateOrDependency: function estateOrDependency(state) {
        return state.dependencyType;
    },
    gender: function gender(state) {
        return state.claimant.gender;
    },
    dateOfBirth: function dateOfBirth(state) {
        return state.claimant.dateOfBirth;
    },
    assumedLifeExpectancy: function assumedLifeExpectancy(state) {
        return state.claimant.assumedLifeExpectancy;
    },
    ageAtDeath: function ageAtDeath(state) {
        return state.claimant.ageAtDeath;
    },
    assumedSettlement: function assumedSettlement(state) {
        return state.claim.assumedSettlement;
    },
    employmentType: function employmentType(state) {
        return state.claimant.employmentType;
    },
    onsetOfSymptoms: function onsetOfSymptoms(state) {
        return state.claimant.onsetOfSymptoms;
    },
    occupation: function occupation(state) {
        return state.claimant.occupation;
    },
    salary: function salary(state) {
        return state.claimant.salary;
    },
    proceduralStatus: function proceduralStatus(state) {
        return state.claim.proceduralStatus;
    },
    numberOfDependants: function numberOfDependants(state) {
        return state.claim.numberOfDependants;
    },
    ageAtAssessment: function ageAtAssessment(state) {
        return m(state.claim.assumedSettlement).diff(m(state.claimant.dateOfBirth), 'years', true);
    },
    claimantName: function claimantName(state) {
        return state.nameAndReference.claimantName;
    },
    claimantSolicitors: function claimantSolicitors(state) {
        return state.nameAndReference.claimantSolicitors;
    },
    claimantReference: function claimantReference(state) {
        return state.nameAndReference.claimantReference;
    },
    yourReference: function yourReference(state) {
        return state.nameAndReference.yourReference;
    },
    defendantName: function defendantName(state) {
        return state.nameAndReference.defendantName;
    },
    hasResults: function hasResults(state) {
        return state.hasResults;
    },
    isValid: function isValid(state) {
        var toTest = [state.claim.diseaseOrAccident === 'disease' ? state.claim.diseaseType : true, state.claim.diseaseOrAccident === 'accident' ? state.claim.accidentType : true, state.claimant.gender, state.claimant.dateOfBirth, state.claimant.onsetOfSymptoms, state.claim.assumedSettlement, state.claimant.assumedLifeExpectancy.dateOfDeath, state.claimant.assumedLifeExpectancy.ageAtDeath, state.claimant.employmentType, state.claim.proceduralStatus, state.claimant.employmentType === 'employed' ? state.claimant.income : true];
        return toTest.every(notNull);
    },
    results: function results(state) {
        return state.results;
    },
    claimantContribution: function claimantContribution(state) {
        return state.contributions.claimant;
    },
    defenceContribution: function defenceContribution(state) {
        return state.contributions.defence;
    },
    damagesContribution: function damagesContribution(state) {
        return state.contributions.damages;
    },
    apportionedClaimantReserve: function apportionedClaimantReserve(state) {
        return state.results.reserve.claimantCosts * (state.contributions.claimant / 100) || 0;
    },
    apportionedDefenceReserve: function apportionedDefenceReserve(state) {
        return state.results.reserve.defenceCosts * (state.contributions.defence / 100) || 0;
    },
    apportionedDamagesReserve: function apportionedDamagesReserve(state, getters) {
        return getters.totalDamages * (state.contributions.damages / 100) || 0;
    },
    totalReserve: function totalReserve(state, getters) {
        return getters.apportionedClaimantReserve + getters.apportionedDefenceReserve + getters.apportionedDamagesReserve;
    },
    totalDamages: function totalDamages(state) {
        return state.results.damages.totalDamages + state.ownHeadsOfLoss.reduce(function (total, head) {
            return total + head.value;
        }, 0);
    },
    chartData: function chartData(state) {
        return state.results.chart;
    },
    durationOfSymptoms: function durationOfSymptoms(state) {
        return m(state.claimant.assumedLifeExpectancy.dateOfDeath).diff(m(state.claimant.onsetOfSymptoms), 'months');
    },
    isValidForSave: function isValidForSave(state) {
        return state.nameAndReference.claimantName !== null && state.nameAndReference.claimantSolicitors.name !== null && state.nameAndReference.claimantReference !== null && state.nameAndReference.yourReference !== null && state.nameAndReference.defendantName.name !== null && state.nameAndReference.claimantName !== '' && state.nameAndReference.claimantSolicitors.name !== '' && state.nameAndReference.claimantReference !== '' && state.nameAndReference.yourReference !== '' && state.nameAndReference.defendantName.name !== '';
    },
    exists: function exists(state) {
        return !!state.claimId;
    },
    ownHeadsOfLoss: function ownHeadsOfLoss(state) {
        return state.ownHeadsOfLoss;
    },
    claimId: function claimId(state) {
        return state.claimId;
    },
    calculating: function calculating(state) {
        return state.calculating;
    },
    noChartData: function noChartData(state) {
        return !state.results.chart || !state.results.chart.count;
    },
    claimType: function claimType(state) {
        return state.claim.type;
    },
    defenceCosts: function defenceCosts(state) {
        return state.results.reserve.defenceCosts;
    },
    claimantCosts: function claimantCosts(state) {
        return state.results.reserve.claimantCosts;
    }
};

var actions = {
    updateValue: function updateValue(_ref2, _ref3) {
        var commit = _ref2.commit,
            dispatch = _ref2.dispatch;
        var key = _ref3.key,
            value = _ref3.value;

        switch (key) {
            case 'dateOfBirth':
                return commit(mutationTypes.UPDATE_CLAIMANT, { key: key, value: value });
            case 'ageAtDeath':
                return dispatch('updateAge', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, value)).then(function () {
                    return commit(mutationTypes.UPDATE_CLAIMANT, { key: key, value: value });
                });
            case 'gender':
            case 'employmentType':
            case 'onsetOfSymptoms':
            case 'occupation':
            case 'salary':
                return commit(mutationTypes.UPDATE_CLAIMANT, { key: key, value: value });
            case 'diseaseType':
            case 'accidentType':
            case 'diseaseOrAccident':
                return commit(mutationTypes.UPDATE_CLAIM, { key: key, value: value });
            case 'assumedSettlement':
            case 'proceduralStatus':
                return commit(mutationTypes.UPDATE_CLAIM, { key: key, value: value });
            case 'claimantContribution':
                return commit(mutationTypes.UPDATE_CONTRIBUTION, { type: 'claimant', value: value });
            case 'defenceContribution':
                return commit(mutationTypes.UPDATE_CONTRIBUTION, { type: 'defence', value: value });
            case 'damagesContribution':
                return commit(mutationTypes.UPDATE_CONTRIBUTION, { type: 'damages', value: value });
            case 'claimantName':
            case 'claimantSolicitors':
                return commit(mutationTypes.UPDATE_NAME_AND_REFERENCE, { key: key, value: value });
            case 'claimantReference':
            case 'yourReference':
            case 'defendantName':
                return commit(mutationTypes.UPDATE_NAME_AND_REFERENCE, { key: key, value: value });
            case 'type':
                return commit(mutationTypes.UPDATE_CLAIM, { key: key, value: value });
            case 'claimantReductionInLife':
                return commit(mutationTypes.UPDATE_CLAIM, { key: key, value: value });
            case 'defenceCosts':
                return commit(mutationTypes.UPDATE_COSTS, { key: key, value: value });
            case 'claimantCosts':
                return commit(mutationTypes.UPDATE_COSTS, { key: key, value: value });
            case 'generalDamages':
                return commit(mutationTypes.UPDATE_GENERAL_DAMAGES, value);
        }
    },
    updateClaimantAssumedLifeExpectancy: function updateClaimantAssumedLifeExpectancy(_ref4, _ref5) {
        var dispatch = _ref4.dispatch,
            state = _ref4.state;
        var assumedLifeExpectancy = _ref5.assumedLifeExpectancy;

        var assumedLifeExpectancyResult = calcAssumedLifeExpectancy({ state: state, assumedLifeExpectancy: assumedLifeExpectancy });

        return updateObject(dispatch, 'updateClaimantAssumedLifeExpectancyValue', assumedLifeExpectancyResult).then(function () {
            return throttleUpdateLife(state, dispatch, 'updateClaimantAssumedLifeExpectancyValue', state.claimant, assumedLifeExpectancyResult);
        });
    },
    updateClaimantAssumedLifeExpectancyValue: function updateClaimantAssumedLifeExpectancyValue(_ref6, _ref7) {
        var commit = _ref6.commit,
            state = _ref6.state,
            dispatch = _ref6.dispatch;
        var key = _ref7.key,
            value = _ref7.value;

        if (state.claimant.assumedLifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_LIFE_ASSUMED_EXPECTANCY, { key: key, value: value });
            dispatch('updateReductionInLife');
        }
    },
    updateReductionInLife: function updateReductionInLife(_ref8) {
        var state = _ref8.state,
            dispatch = _ref8.dispatch;

        if (state.claimant.assumedLifeExpectancy.ageAtDeath && state.claimant.lifeExpectancy.ageAtDeath) {
            var claimantReductionInLife = state.claimant.lifeExpectancy.ageAtDeath - state.claimant.assumedLifeExpectancy.ageAtDeath;
            dispatch('updateValue', { key: 'claimantReductionInLife', value: claimantReductionInLife });
        }
    },
    updateLifeExpectancy: function updateLifeExpectancy(_ref9, _ref10) {
        var dispatch = _ref9.dispatch,
            state = _ref9.state;
        var lifeExpectancy = _ref10.lifeExpectancy;

        return updateObject(dispatch, 'updateLifeExpectancyValue', lifeExpectancy).then(function () {
            return throttleUpdateLife(state, dispatch, 'updateLifeExpectancyValue', state.claimant, lifeExpectancy);
        });
    },
    updateLifeExpectancyValue: function updateLifeExpectancyValue(_ref11, _ref12) {
        var commit = _ref11.commit,
            state = _ref11.state;
        var key = _ref12.key,
            value = _ref12.value;

        if (state.claimant.lifeExpectancy[key] !== value) {
            commit(mutationTypes.UPDATE_LIFE_EXPECTANCY, { key: key, value: value });
        }
    },
    performCalculation: function performCalculation(_ref13) {
        var commit = _ref13.commit,
            state = _ref13.state;

        commit(mutationTypes.RESET_RESULT);
        commit(mutationTypes.START_CALCULATING);
        return __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].dashboards.reserving.simpleAssessment(claimForServer(state), personForServer(state)).then(function (results) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.results).map(function (key) {
                return commit(mutationTypes.UPDATE_RESULT, {
                    type: key,
                    data: camelCaseObjectKeys(results[key])
                });
            });

            commit(mutationTypes.UPDATE_CLAIMANT, {
                key: 'dateOfDeath',
                value: results.calculation.expected_end_of_life_date
            });
            commit(mutationTypes.UPDATE_CLAIMANT, {
                key: 'ageAtDeath',
                value: results.calculation.age_at_expected_end_of_life
            });
        }).then(function () {
            return commit(mutationTypes.STOP_CALCULATING);
        });
    },
    updateAge: function updateAge(_ref14, _ref15) {
        var commit = _ref14.commit,
            state = _ref14.state;
        var dateOfBirth = _ref15.dateOfBirth,
            dateOfDeath = _ref15.dateOfDeath,
            ageAtDeath = _ref15.ageAtDeath;

        switch (true) {
            case !!(dateOfBirth && dateOfDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: dateOfBirth,
                    dateOfDeath: dateOfDeath,
                    ageAtDeath: m(dateOfDeath).diff(m(dateOfBirth), 'years', true)
                });
            case !!(dateOfBirth && ageAtDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: dateOfBirth,
                    dateOfDeath: m(dateOfBirth).add(ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: ageAtDeath
                });
            case !!(dateOfDeath && ageAtDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: m(dateOfDeath).subtract(ageAtDeath, 'years').format('DD/MM/YYYY'),
                    dateOfDeath: dateOfDeath,
                    ageAtDeath: ageAtDeath
                });

            case !!(dateOfBirth && state.claimant.dateOfDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: dateOfBirth,
                    dateOfDeath: state.claimant.dateOfDeath,
                    ageAtDeath: m(state.claimant.dateOfDeath).diff(m(dateOfBirth), 'years', true)
                });
            case !!(ageAtDeath && state.claimant.dateOfBirth):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: state.claimant.dateOfBirth,
                    dateOfDeath: m(state.claimant.dateOfBirth).add(ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: ageAtDeath
                });
            case !!(dateOfBirth && state.claimant.ageAtDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: dateOfBirth,
                    dateOfDeath: m(dateOfBirth).add(state.claimant.ageAtDeath, 'years').format('DD/MM/YYYY'),
                    ageAtDeath: state.claimant.ageAtDeath
                });
            case !!(ageAtDeath && state.claimant.dateOfDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: m(state.claimant.dateOfDeath).subtract(ageAtDeath, 'years').format('DD/MM/YYYY'),
                    dateOfDeath: state.claimant.dateOfDeath,
                    ageAtDeath: ageAtDeath
                });
            case !!(dateOfDeath && state.claimant.dateOfBirth):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: state.claimant.dateOfBirth,
                    dateOfDeath: dateOfDeath,
                    ageAtDeath: m(dateOfDeath).diff(m(state.claimant.dateOfBirth), 'years', true)
                });
            case !!(dateOfDeath && state.claimant.ageAtDeath):
                return commit(mutationTypes.SET_AGE, {
                    dateOfBirth: m(state.claimant.dateOfDeath).subtract(state.claimant.ageAtDeath, 'years').format('DD/MM/YYYY'),
                    dateOfDeath: dateOfDeath,
                    ageAtDeath: state.claimant.ageAtDeath
                });

            case !!dateOfBirth:
                return commit(mutationTypes.UPDATE_CLAIMANT, { key: 'dateOfBirth', value: dateOfBirth });
            case !!dateOfDeath:
                return commit(mutationTypes.UPDATE_CLAIMANT, { key: 'dateOfDeath', value: dateOfDeath });
            case !!ageAtDeath:
                return commit(mutationTypes.UPDATE_CLAIMANT, { key: 'ageAtDeath', value: ageAtDeath });
        }
    },
    reset: function reset(_ref16) {
        var commit = _ref16.commit;

        return commit(mutationTypes.RESET);
    },
    save: function save(_ref17) {
        var commit = _ref17.commit,
            state = _ref17.state;
        var claimId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.claimId;

        return __WEBPACK_IMPORTED_MODULE_6_services_Api__["a" /* default */].claims.save({
            claim_id: claimId,
            step_id: state.stepId,
            claim_type: 'day_one_only_lost_years',
            step_number: 0,
            data: {
                dependencyType: state.dependencyType,
                nameAndReference: state.nameAndReference,
                claim: claimForServer(state),
                person: personForServer(state),
                results: {
                    calculation: state.results.calculation,
                    damages: state.results.damages,
                    reserve: state.results.reserve,
                    chart: state.results.chart
                },
                contributions: state.contributions,
                ownHeadsOfLoss: state.ownHeadsOfLoss
            }
        }).then(function (result) {
            commit(mutationTypes.UPDATE_CLAIM_ID, { claimId: result.step.claim_id, stepId: result.step.step_id });
            return result.step.claim_id;
        });
    },
    openAsClaim: function openAsClaim(_ref18) {
        var dispatch = _ref18.dispatch,
            state = _ref18.state,
            rootState = _ref18.rootState;

        var updateClaim = function updateClaim(_ref19) {
            var type = _ref19.type,
                key = _ref19.key,
                value = _ref19.value;

            return dispatch('lost/claimant/' + type, { key: key, value: value }, { root: true });
        };

        var dispatchToClaimantDetails = 'lost/claimant/updateClaimantDetail';
        var dispatchToClaimant = 'lost/claimant/updateClaimantValue';
        var dispatchToClaimInfo = 'lost/claimant/updateClaimInfoValue';

        return dispatch('claim/reset', null, { root: true }).then(function () {
            return dispatch('claim/initialise', state.claim.type, { root: true });
        }).then(function () {
            return dispatch('claim/setClaimId', state.claimId, { root: true });
        }).then(function () {
            return dispatch('menu/updateSubMenu', 'lost', { root: true });
        }).then(function () {
            return dispatch('menu/updateMenu', '', { root: true });
        }).then(function () {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([updateClaim({
                type: 'updateClaimantDetail',
                key: 'defendantName',
                value: state.nameAndReference.defendantName
            }), updateClaim({
                type: 'updateClaimantDetail',
                key: 'claimantSolicitor',
                value: state.nameAndReference.claimantSolicitors
            }), updateClaim({
                type: 'updateClaimantDetail',
                key: 'claimantReference',
                value: state.nameAndReference.claimantReference
            }), updateClaim({
                type: 'updateClaimantDetail',
                key: 'yourReference',
                value: state.nameAndReference.yourReference
            }), updateClaim({ type: 'updateClaimantDetail', key: 'diseaseType', value: state.claim.diseaseType }), updateClaim({
                type: 'updateClaimantDetail',
                key: 'diseaseOrAccident',
                value: state.claim.diseaseOrAccident
            }), updateClaim({ type: 'updateClaimantDetail', key: 'diseaseType', value: state.claim.diseaseType }), updateClaim({ type: 'updateClaimantDetail', key: 'accidentType', value: state.claim.accidentType }), updateClaim({ type: 'updateClaimantValue', key: 'name', value: state.nameAndReference.claimantName }), updateClaim({ type: 'updateClaimantValue', key: 'gender', value: state.claimant.gender }), updateClaim({ type: 'updateClaimantValue', key: 'dateOfBirth', value: state.claimant.dateOfBirth }), updateClaim({ type: 'updateClaimantValue', key: 'dateOfDeath', value: state.claimant.dateOfDeath }), updateClaim({
                type: 'updateClaimantValue',
                key: 'onsetOfSymptoms',
                value: state.claimant.onsetOfSymptoms
            }), updateClaim({
                type: 'updateClaimInfoValue',
                key: 'dateOfAssumedSettlement',
                value: state.claim.assumedSettlement
            })]);
        }).then(function () {
            return state.claimId;
        });
    },
    load: function load(_ref20, response) {
        var commit = _ref20.commit;

        var step = response.steps[0];

        commit(mutationTypes.UPDATE_FROM_SERVER_STEP, step);

        if (response.claimant_solicitor_id) {
            commit(mutationTypes.UPDATE_CLAIMANT_SOLICITOR_ID, response.claimant_solicitor_id);
        }

        if (response.defendant_id) {
            commit(mutationTypes.UPDATE_DEFENDANT_ID, response.defendant_id);
        }

        return;
    },
    addHeadOfLoss: function addHeadOfLoss(_ref21) {
        var commit = _ref21.commit;

        return commit(mutationTypes.ADD_OWN_HEAD_OF_LOSS);
    },
    updateHeadOfLoss: function updateHeadOfLoss(_ref22, _ref23) {
        var commit = _ref22.commit;
        var index = _ref23.index,
            key = _ref23.key,
            value = _ref23.value;

        return commit(mutationTypes.UPDATE_OWN_HEAD_OF_LOSS, { index: index, key: key, value: value });
    },
    deleteHeadOfLoss: function deleteHeadOfLoss(_ref24, index) {
        var commit = _ref24.commit;

        return commit(mutationTypes.DELETE_OWN_HEAD_OF_LOSS, index);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIMANT, function (state, _ref25) {
    var key = _ref25.key,
        value = _ref25.value;

    state.claimant[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEPENDENCY_TYPE, function (state, value) {
    state.dependencyType = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIM, function (state, _ref26) {
    var key = _ref26.key,
        value = _ref26.value;

    state.claim[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_NAME_AND_REFERENCE, function (state, _ref27) {
    var key = _ref27.key,
        value = _ref27.value;

    state.nameAndReference[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIMANT_SOLICITOR_ID, function (state, value) {
    state.nameAndReference.claimantSolicitors.id = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DEFENDANT_ID, function (state, value) {
    state.nameAndReference.defendantName.id = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.SET_AGE, function (state, _ref28) {
    var dateOfBirth = _ref28.dateOfBirth,
        dateOfDeath = _ref28.dateOfDeath,
        ageAtDeath = _ref28.ageAtDeath;

    state.claimant.dateOfBirth = dateOfBirth;
    state.claimant.dateOfDeath = dateOfDeath;
    state.claimant.ageAtDeath = __WEBPACK_IMPORTED_MODULE_8_mixins_roundValue__["a" /* default */].methods.roundValue(ageAtDeath, 2);
    state.claimant.employmentType = ageAtDeath > 64 ? 'retired' : 'employed';
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_RESULT, function (state, _ref29) {
    var type = _ref29.type,
        data = _ref29.data;

    state.results[type] = data;
    state.hasResults = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET_RESULT, function (state) {
    state.hasResults = false;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CONTRIBUTION, function (state, _ref30) {
    var type = _ref30.type,
        value = _ref30.value;

    state.contributions[type] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, initialState());
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CLAIM_ID, function (state, _ref31) {
    var claimId = _ref31.claimId,
        stepId = _ref31.stepId;

    state.claimId = claimId;
    state.stepId = stepId;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FROM_SERVER_STEP, function (state, step) {
    var data = camelCaseObjectKeysDeep(step.data);
    state.claimId = step.claim_id;
    state.stepId = step.id;
    state.dependencyType = step.data.dependency_type;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.claim, checkForServerDates(data.claim));
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.nameAndReference, checkForServerDates(data.nameAndReference));
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.claimant, checkForServerDates(data.person));
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.results, data.results);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.contributions, data.contributions);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.ownHeadsOfLoss, data.ownHeadsOfLoss);
    state.claimant.assumedLifeExpectancy = {
        method: step.data.person.assumed.method,
        yearsLeft: step.data.person.assumed.years_left,
        monthsLeft: step.data.person.assumed.months_left,
        ageAtDeath: step.data.person.assumed.age_at_death,
        dateOfDeath: step.data.person.assumed.date_of_death
    };
    state.hasResults = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ADD_OWN_HEAD_OF_LOSS, function (state) {
    state.ownHeadsOfLoss.push({
        name: null, value: 0
    });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_OWN_HEAD_OF_LOSS, function (state, _ref32) {
    var index = _ref32.index,
        key = _ref32.key,
        value = _ref32.value;

    state.ownHeadsOfLoss[index][key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DELETE_OWN_HEAD_OF_LOSS, function (state, index) {
    state.ownHeadsOfLoss.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.START_CALCULATING, function (state) {
    state.calculating = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.STOP_CALCULATING, function (state) {
    state.calculating = false;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LIFE_ASSUMED_EXPECTANCY, function (state, _ref33) {
    var key = _ref33.key,
        value = _ref33.value;

    state.claimant.assumedLifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_LIFE_EXPECTANCY, function (state, _ref34) {
    var key = _ref34.key,
        value = _ref34.value;

    state.claimant.lifeExpectancy[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_COSTS, function (state, _ref35) {
    var key = _ref35.key,
        value = _ref35.value;

    state.results.reserve[key] = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_GENERAL_DAMAGES, function (state, value) {
    state.results.damages.totalDamages -= state.results.damages.generalDamages;
    state.results.damages.generalDamages = value;
    state.results.damages.totalDamages += value;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_modules_shared_chartDataSets__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_modules_shared_tableData__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dayOneFatal__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dayOneLost__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__compare__ = __webpack_require__(954);


var _mutations;









var mutationTypes = {
    RESET: 'RESET',
    UPDATE_FILTER: 'UPDATE_FILTER',
    UPDATE_RESULTS: 'UPDATE_RESULTS'
};

function summaryPeriodTemplate() {
    return {
        average_initial_reserve: [],
        reserve_range: [],
        new_claims: []
    };
}

function graphTemplate() {
    return {
        data: {
            fatal: [],
            lost: []
        }
    };
}

var state = {
    dayOneAssessmentFilter: {
        claimStatus: null,
        claimType: null,
        discountRate: null,
        diseaseType: null,
        onsetOfSymptoms: [null, null],
        gender: null,
        proceduralStatus: null,
        employedAtDeath: null,
        disabled: null,
        active: null,
        ageAtOnset: [null, null],
        ageAtDeath: [null, null],
        ageOfClaimant: [null, null],
        levelOfEducation: null,
        disabledAtAccident: null,
        serviceOfProceedings: [null, null]
    },
    dayOneAssessmentResults: {
        confidence: {
            percentage: 0
        },
        scatter: {
            labels: {
                type: ''
            },
            data: {}
        }
    }
};

var getters = {
    getTableData: function getTableData(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_store_modules_shared_tableData__["a" /* tableData */])(state);
    },
    getAxes: function getAxes(state) {
        return function (key) {
            return state.dayOneAssessmentResults.scatter.labels[key];
        };
    },
    getFilter: function getFilter(state) {
        return function (key) {
            return state.dayOneAssessmentFilter[key];
        };
    },
    getFilters: function getFilters(state) {
        return state.dayOneAssessmentFilter;
    },
    getReserveData: function getReserveData(state) {
        return function (key) {
            return state.dayOneAssessmentResults[key];
        };
    },
    getChartTicks: function getChartTicks(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_modules_shared_chartDataSets__["a" /* chartTicks */])(state);
    },
    getChartDataSets: function getChartDataSets(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_modules_shared_chartDataSets__["b" /* chartDataSets */])(state);
    },
    getConfidenceChartDataSet: function getConfidenceChartDataSet(state) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_store_modules_shared_chartDataSets__["c" /* confidenceChartDataSets */])(state);
    }
};

var actions = {
    analyse: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref) {
        var dispatch = _ref.dispatch,
            state = _ref.state;

        return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].dashboards.reserving.dayOneAssessment(state.dayOneAssessmentFilter).then(function (data) {
            return dispatch('updateResults', { data: data, index: 'dayOneAssessmentResults' });
        });
    }, 500),

    updateFilters: function updateFilters(_ref2, _ref3) {
        var commit = _ref2.commit;
        var key = _ref3.key,
            value = _ref3.value;

        commit(mutationTypes.UPDATE_FILTER, { key: key, value: value });
    },
    updateResults: function updateResults(_ref4, _ref5) {
        var commit = _ref4.commit;
        var data = _ref5.data,
            index = _ref5.index;

        commit(mutationTypes.UPDATE_RESULTS, { data: data, index: index });
    },
    resetFilters: function resetFilters(_ref6) {
        var commit = _ref6.commit;

        commit(mutationTypes.RESET);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_FILTER, function (state, _ref7) {
    var key = _ref7.key,
        value = _ref7.value;

    state.dayOneAssessmentFilter[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_RESULTS, function (state, _ref8) {
    var data = _ref8.data,
        index = _ref8.index;

    state[index] = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
    state.dayOneAssessmentFilter.claimType = null;
    state.dayOneAssessmentFilter.discountRate = null;
    state.dayOneAssessmentFilter.diseaseType = null;
    state.dayOneAssessmentFilter.onsetOfSymptoms = [null, null];
    state.dayOneAssessmentFilter.gender = null;
    state.dayOneAssessmentFilter.proceduralStatus = null;
    state.dayOneAssessmentFilter.employedAtDeath = null;
    state.dayOneAssessmentFilter.disabled = null;
    state.dayOneAssessmentFilter.active = null;
    state.dayOneAssessmentFilter.ageAtOnset = [null, null];
    state.dayOneAssessmentFilter.ageAtDeath = [null, null];
    state.dayOneAssessmentFilter.ageOfClaimant = [null, null];
    state.dayOneAssessmentFilter.levelOfEducation = null;
    state.dayOneAssessmentFilter.disabledAtAccident = null;
    state.dayOneAssessmentFilter.serviceOfProceedings = [null, null];

    state.dayOneAssessmentResults = {
        confidence: {
            percentage: 0
        },
        scatter: {
            labels: {
                type: ''
            },
            data: {}
        }
    };
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {
        dayOneFatal: __WEBPACK_IMPORTED_MODULE_5__dayOneFatal__["a" /* default */],
        dayOneLost: __WEBPACK_IMPORTED_MODULE_6__dayOneLost__["a" /* default */],
        compare: __WEBPACK_IMPORTED_MODULE_7__compare__["a" /* default */]
    }
});

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Api__ = __webpack_require__(5);


var _mutations;




var mutationTypes = {
    DOCUMENTS: 'DOCUMENTS',
    UPDATE_CATEGORY: 'UPDATE_CATEGORY',
    UPDATE_DOCUMENT_NAME: 'UPDATE_DOCUMENT_NAME',
    UPDATE_ORDER: 'UPDATE_ORDER',
    CATEGORY_LIST: 'CATEGORY_LIST',
    UPDATE_OGDEN_TABLES: 'UPDATE_OGDEN_TABLES',
    UPDATE_OGDEN_TABLE_DATA: 'UPDATE_OGDEN_TABLE_DATA',
    UPDATE_AT_A_GLANCE: 'UPDATE_AT_A_GLANCE'
};

var state = {
    documents: [],
    orderBy: 'ASC',
    documentName: null,
    categoryList: null,
    category: null,
    ogdenTables: [],
    ogdenTableData: {},
    atAGlance: {}
};

var getters = {
    getDocuments: function getDocuments() {
        return state.documents;
    },
    getResources: function getResources() {
        return state;
    },
    ogdenTables: function ogdenTables() {
        return state.ogdenTables;
    },
    ogdenTableData: function ogdenTableData() {
        return state.ogdenTableData;
    },
    atAGlance: function atAGlance() {
        return state.atAGlance;
    }
};

var actions = {
    getDocumentsFromServer: function getDocumentsFromServer(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].resources.documents.all().then(function (data) {
            commit(mutationTypes.DOCUMENTS, data.documents);
            commit(mutationTypes.CATEGORY_LIST, data.categories);
        });
    },
    setCategory: function setCategory(_ref2, value) {
        var commit = _ref2.commit;

        commit(mutationTypes.UPDATE_CATEGORY, value);
    },
    setDocumentName: function setDocumentName(_ref3, value) {
        var commit = _ref3.commit;

        commit(mutationTypes.UPDATE_DOCUMENT_NAME, value);
    },
    setOrderBy: function setOrderBy(_ref4, value) {
        var commit = _ref4.commit;

        commit(mutationTypes.UPDATE_ORDER, value);
    },
    documentSearch: function documentSearch(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].resources.documents.search(state.documentName, state.category, state.orderBy).then(function (data) {
            return commit(mutationTypes.DOCUMENTS, data);
        });
    },
    loadOgdenTables: function loadOgdenTables(_ref6) {
        var commit = _ref6.commit;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].resources.ogden.tableInfo().then(function (data) {
            return commit(mutationTypes.UPDATE_OGDEN_TABLES, data);
        });
    },
    obtainOgdenTable: function obtainOgdenTable(_ref7, name) {
        var commit = _ref7.commit,
            state = _ref7.state;

        if (state.ogdenTableData[name]) {
            return;
        }
        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].resources.ogden.obtainValues(name).then(function (data) {
            return commit(mutationTypes.UPDATE_OGDEN_TABLE_DATA, {
                data: data,
                name: name
            });
        });
    },
    atAGlance: function atAGlance(_ref8, _ref9) {
        var commit = _ref8.commit,
            state = _ref8.state;
        var discount = _ref9.discount,
            gender = _ref9.gender;

        return __WEBPACK_IMPORTED_MODULE_2_services_Api__["a" /* default */].resources.ogden.atAGlance(discount, gender).then(function (data) {
            return commit(mutationTypes.UPDATE_AT_A_GLANCE, {
                data: data,
                discount: discount,
                gender: gender
            });
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.DOCUMENTS, function (state, data) {
    state.documents = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.CATEGORY_LIST, function (state, data) {
    state.categoryList = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_CATEGORY, function (state, data) {
    state.category = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_DOCUMENT_NAME, function (state, data) {
    state.documentName = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_ORDER, function (state, data) {
    state.orderBy = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_OGDEN_TABLES, function (state, data) {
    state.ogdenTables = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_OGDEN_TABLE_DATA, function (state, payload) {
    state.ogdenTableData[payload.name] = payload.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_AT_A_GLANCE, function (state, payload) {
    state.atAGlance = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {}
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export chartColours */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trendsChartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return averageChartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return totalChartData; });
/* unused harmony export averageReserveLineChartData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var chartColours = ['#45BFFC', '#3DF2C3', '#CD5CD8', '#EB1458', '#7DD3F4', '#94F7DB', '#E18FEF', '#F94B8A', '#4A89E5', '#EA7A68', '#9A4CD9', '#BF104F', '#422960', '#007180', '#2ECE9D'];

var claimCostLabels = ['Damages Reserve', 'Claimant Costs Reserve', 'Defence Costs Reserve'];

var trendsChartData = function trendsChartData(state, type) {
    var chartData = state.trendReserve.charts;
    var diseaseType = state.filters.diseaseType;
    var isDiseaseTypeSet = diseaseType !== null;
    var data = [];
    var claimCost = state.filters.claimCost;
    var period = state.trendReserve.period;
    var labels = [];

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData).length) {
        for (var key in chartData[claimCost][period][type].data) {
            labels.push(key);
        }
        data = formatTrendData(chartData, isDiseaseTypeSet, claimCost, period, type, diseaseType);
    }

    return { data: data, labels: labels, type: type };
};

function extractChartData(chartData) {
    var data = [];
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData).length) {
        for (var key in chartData) {
            if (chartData.hasOwnProperty(key)) {
                data.push(chartData[key]);
            }
        }
    }
    return data;
}

function extractChartLabels(chartData) {
    var labels = [];
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData).length) {
        for (var key in chartData) {
            if (chartData.hasOwnProperty(key)) {
                labels.push(key);
            }
        }
    }
    return labels;
}

function prepareChartDataSet(data, colour) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return {
        label: label,
        data: data,
        backgroundColor: colour,
        borderWidth: 0
    };
}

function getDataSets(isDiseaseTypeSet, chart, type, cost) {
    var dataSets = [];
    if (isDiseaseTypeSet) {
        dataSets = [prepareChartDataSet(extractChartData(chart.damages[type].chartData), chartColours[0], 'Damages Reserve'), prepareChartDataSet(extractChartData(chart.claimantCosts[type].chartData), chartColours[1], 'Claimant Costs Reserve'), prepareChartDataSet(extractChartData(chart.defenceCosts[type].chartData), chartColours[2], 'Defence Costs Reserve')];
    } else {
        dataSets.push(prepareChartDataSet(extractChartData(chart[cost][type].chartData), chartColours));
    }
    return dataSets;
}

function getPieDataSets(isDiseaseTypeSet, chart, type, cost) {
    var dataSets = [];
    if (isDiseaseTypeSet) {
        dataSets = [prepareChartDataSet(extractChartData(chart.damages[type].chartData).concat(extractChartData(chart.claimantCosts[type].chartData)).concat(extractChartData(chart.defenceCosts[type].chartData)), chartColours)];
    } else {
        dataSets.push(prepareChartDataSet(extractChartData(chart[cost][type].chartData), chartColours));
    }
    return dataSets;
}

function labels(isDiseaseTypeSet, chart, cost, type) {
    return isDiseaseTypeSet ? claimCostLabels : extractChartLabels(chart[cost][type].chartData);
}

var averageChartData = function averageChartData(state, type) {
    var chart = state.averageReserve.charts;
    var isDiseaseTypeSet = state.filters.diseaseType !== null;
    var cost = state.filters.claimCost;
    var dataSets = getDataSets(isDiseaseTypeSet, chart, type, cost);
    var pieDataSets = getPieDataSets(isDiseaseTypeSet, chart, type, cost);
    var hasData = !!dataSets[0].data.length;

    return {
        dataSets: dataSets,
        pieDataSets: pieDataSets,
        labels: labels(isDiseaseTypeSet, chart, cost, type),
        type: type,
        hasData: hasData,
        average: state.averageReserve.charts.all.overallAverage
    };
};

var totalChartData = function totalChartData(state, type) {
    var chart = state.totalReserve.charts;
    var isDiseaseTypeSet = state.filters.diseaseType !== null;
    var cost = state.filters.claimCost;
    var dataSets = getDataSets(isDiseaseTypeSet, chart, type, cost);
    var pieDataSets = getPieDataSets(isDiseaseTypeSet, chart, type, cost);
    var hasData = !!dataSets[0].data.length;

    return {
        dataSets: dataSets,
        pieDataSets: pieDataSets,
        labels: labels(isDiseaseTypeSet, chart, cost, type),
        type: type,
        hasData: hasData
    };
};

function trendByDiseaseType(chartData) {
    var diseaseType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var newItem = {};
    var i = 0;

    for (var date in chartData) {
        for (var disease in chartData[date]) {
            if (!chartData[date].hasOwnProperty(disease) || diseaseType !== null && diseaseType !== disease) {
                continue;
            }

            if (!newItem[disease]) {
                newItem[disease] = {
                    label: disease,
                    type: 'line',
                    backgroundColor: [chartColours[i]],
                    borderColor: [chartColours[i]],
                    fill: false,
                    data: []
                };
                i++;
            }

            newItem[disease].data.push(chartData[date][disease]);
        }
    }
    return newItem;
}

function trendByCostType(chartData, diseaseType, period, type) {
    var data = [trendByDiseaseType(chartData.damages[period][type].data)[diseaseType], trendByDiseaseType(chartData.claimantCosts[period][type].data)[diseaseType], trendByDiseaseType(chartData.defenceCosts[period][type].data)[diseaseType]];
    if (!data[0]) {
        return [];
    }
    data[0].label = claimCostLabels[0];
    data[1].label = claimCostLabels[1];
    data[2].label = claimCostLabels[2];
    data[0].backgroundColor = [chartColours[0]];
    data[1].backgroundColor = [chartColours[1]];
    data[2].backgroundColor = [chartColours[2]];
    data[0].borderColor = [chartColours[0]];
    data[1].borderColor = [chartColours[1]];
    data[2].borderColor = [chartColours[2]];
    return data;
}

var formatTrendData = function formatTrendData(chartData, isDiseaseTypeSelected, claimCost, period, type, diseaseType) {
    var data = isDiseaseTypeSelected && type !== 'number' ? trendByCostType(chartData, diseaseType, period, type) : trendByDiseaseType(chartData[claimCost][period][type].data);
    var values = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(data);
    var maxLength = values.reduce(function (max, item) {
        return Math.max(max, item.data.length);
    }, 0);

    return values.map(function (item) {
        while (item.data.length < maxLength) {
            item.data.push(0);
        }
        return item;
    });
};

var averageReserveLineChartData = function averageReserveLineChartData(state, type) {
    var chartData = state.averageReserves.graphs.chartData;
    var data = [];

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData).length) {
        for (var key in chartData) {
            data.push(typeof chartData[key][type] !== 'undefined' ? chartData[key][type] : 0);
        }
    }

    data.splice(-1, 1);

    return data;
};

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export myColours */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chartDataSets; });
/* unused harmony export makeChartGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chartTicks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return confidenceChartDataSets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var myColours = ['#45BFFC', '#CD5CD8', '#3DF2C3', '#EB1458', '#782ABE', '#7DD3F4', '#E18FEF', '#94F7DB', '#F94B8A', '#9265CC', '#4A89E5', '#9A4CD9', '#2ECE9D', '#BF104F', '#422960'];

var chartDataSets = function chartDataSets(state) {
    var chartData = state.dayOneAssessmentResults.scatter.data;
    var type = state.dayOneAssessmentResults.scatter.labels.type;
    var padding = 0;
    var data = [];
    var colour = 0;

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData).length) {
        for (var group in chartData) {
            var axes = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(chartData[group], function (claim) {
                return claim.cost.total_initial_reserve;
            }).map(function (claim, index) {
                return {
                    x: index + 1,
                    y: claim.cost.total_initial_reserve
                };
            });

            data.push({
                label: group,
                backgroundColor: myColours[colour],
                borderColor: myColours[colour],
                data: axes
            });

            colour++;
        }
    }

    return data;
};

var makeChartGroup = function makeChartGroup(chartData, group) {
    var padding = 0;
    var data = [];
    var colour = 0;

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData).length) {
        for (var _group in chartData) {
            var axes = chartData[_group].map(function (point, index) {
                return {
                    x: index + 1,
                    y: point[key]
                };
            });

            data.push({
                label: _group,
                backgroundColor: myColours[colour],
                borderColor: myColours[colour],
                data: axes
            });

            colour++;
        }
    }

    return data;
};

var chartTicks = function chartTicks(state) {
    var type = state.dayOneAssessmentResults.scatter.labels.type;

    return {
        callback: function callback(value, index, values) {
            return Math.floor(value) === value ? value : null;
        },
        min: 0,
        beginAtZero: true,
        autoSkip: true,
        maxTicksLimit: 10,
        suggestedMin: 0,
        suggestedMax: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.dayOneAssessmentResults.scatter.data).length + 1
    };
};

var confidenceChartDataSets = function confidenceChartDataSets(state) {
    var confidence = state.dayOneAssessmentResults.confidence.percentage;
    var confidenceColours = getConfidenceColours(confidence);

    return [{
        data: [confidence, 100 - confidence],
        backgroundColor: confidenceColours,
        hoverBackgroundColor: confidenceColours
    }];
};

function getConfidenceColours(confidence) {
    switch (true) {
        case confidence <= 30:
            return ['#D94C8C', '#cbcbcb'];
            break;
        case confidence <= 60:
            return ['#edf97b', '#cbcbcb'];
            break;
        case confidence <= 100:
            return ['#3DF2C3', '#cbcbcb'];
            break;
    }
}

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tableData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var tableData = function tableData(state) {
    var chartData = state.dayOneAssessmentResults.scatter.data;
    var type = state.dayOneAssessmentResults.scatter.labels.type;

    var data = [];

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(chartData).length) {
        for (var gender in chartData) {
            for (var index = 0; index < chartData[gender].length; index++) {
                data.push(chartData[gender][index]);
            }
        }
    }

    return data;
};

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_index__ = __webpack_require__(15);




var mutationTypes = {};

var state = {};

var getters = {};

var actions = {
  sendMail: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (noop, _ref) {
    var claim = _ref.claim,
        query = _ref.query;

    if (query !== '') {
      return __WEBPACK_IMPORTED_MODULE_0_services_Api__["a" /* default */].support.sendEmail({ claim: claim, query: query, userId: __WEBPACK_IMPORTED_MODULE_2_store_index__["a" /* default */].getters['user/getUserId'] }).then(function (data) {
        return data.sent;
      });
    }
  }, 500)
};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  modules: {}
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

var types = {
    UPDATE_TIMELINE: 'UPDATE_TIMELINE'
};

var state = {
    open: true
};

var getters = {
    isTimelineOpen: function isTimelineOpen(state) {
        return state.open;
    }
};

var actions = {
    updateTimeline: function updateTimeline(_ref) {
        var commit = _ref.commit;
        return commit(types.UPDATE_TIMELINE);
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, types.UPDATE_TIMELINE, function (state) {
    state.open = !state.open;
});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutationTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_Api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _mutations;




var mutationTypes = {
  RESET: "RESET",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_TOKEN: "UPDATE_TOKEN",
  ERROR: "ERROR",
  NO_ERROR: "NO_ERROR",
  LOCKED: "LOCKED",
  LOCKED_ERRORS: "LOCKED_ERRORS"
};

function userTemplate() {
  return {
    id: null,
    fullName: null,
    firstName: null,
    lastName: null,
    email: null,
    token: null,
    loginToken: null,
    hideNames: false
  };
}

var state = {
  user: userTemplate(),
  token: null,
  error: false,
  locked: false,
  lockedErrors: null
};

var getters = {
  getUser: function getUser(state) {
    return state.user;
  },
  getUserId: function getUserId(state) {
    return state.user.id || null;
  },
  getUserFullName: function getUserFullName(state) {
    return state.user.fullName || null;
  },
  getUserFirstName: function getUserFirstName(state) {
    return state.user.firstName || null;
  },
  getUserLastName: function getUserLastName(state) {
    return state.user.lastName || null;
  },
  getUserEmail: function getUserEmail(state) {
    return state.user.email || null;
  },
  getToken: function getToken(state) {
    return state.token || null;
  },
  getLoginToken: function getLoginToken(state) {
    return state.user.loginToken || null;
  },
  hasError: function hasError(state) {
    return state.error;
  },
  hasLockedErrors: function hasLockedErrors(state) {
    return state.lockedErrors;
  },
  isLocked: function isLocked(state) {
    return state.locked;
  },
  hideNames: function hideNames(state) {
    return state.user.hideNames;
  },
  showNames: function showNames(state) {
    return !state.user.hideNames;
  }
};

var actions = {
  loginUser: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref, _ref2) {
    var commit = _ref.commit;
    var email = _ref2.email,
        password = _ref2.password;

    commit(mutationTypes.RESET);

    return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].users.login({ email: email, password: password }).then(function (response) {
      if (response.success) {
        commit(mutationTypes.NO_ERROR);
        commit(mutationTypes.UPDATE_USER, { user: response.user });
        commit(mutationTypes.UPDATE_TOKEN, { token: response.token });
        return;
      }

      commit(mutationTypes.ERROR, true);
    });
  }, 500),

  logoutUser: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref3) {
    var commit = _ref3.commit;

    return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].users.logout().then(function (data) {
      commit(mutationTypes.RESET);
    });
  }, 500),

  authenticateUser: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref4, authenticate) {
    var commit = _ref4.commit;

    return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].users.authenticate({ authenticate: authenticate }).then(function (response) {
      if (response.success) {
        commit(mutationTypes.NO_ERROR);
        commit(mutationTypes.UPDATE_USER, { user: response.user });
        commit(mutationTypes.UPDATE_TOKEN, { token: response.token });

        window.location = "/";
        return;
      }

      commit(mutationTypes.ERROR, true);
      window.location = "/";
    });
  }, 500),

  continueUser: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (_ref5, _ref6) {
    var commit = _ref5.commit;
    var email = _ref6.email,
        password = _ref6.password;

    return __WEBPACK_IMPORTED_MODULE_1_services_Api__["a" /* default */].users.login({ email: email, password: password }).then(function (response) {
      if (response.success) {
        commit(mutationTypes.NO_ERROR);
        commit(mutationTypes.UPDATE_USER, { user: response.user });
        commit(mutationTypes.UPDATE_TOKEN, { token: response.token });
        commit(mutationTypes.LOCKED_ERRORS, null);
        return;
      }

      commit(mutationTypes.LOCKED_ERRORS, response);
    });
  }, 500),

  lock: function lock(_ref7) {
    var commit = _ref7.commit;

    commit(mutationTypes.LOCKED);
  },
  resetErrors: function resetErrors(_ref8) {
    var commit = _ref8.commit;

    commit(mutationTypes.ERROR, null);
  },
  resetUser: function resetUser(_ref9) {
    var commit = _ref9.commit;

    commit(mutationTypes.RESET);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_USER, function (state, _ref10) {
  var user = _ref10.user;

  state.user.id = user.id;
  state.user.firstName = user.first_name;
  state.user.lastName = user.last_name;
  state.user.fullName = user.full_name;
  state.user.email = user.email;
  state.user.loginToken = user.login_token;
  state.user.hideNames = false;
  state.locked = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.UPDATE_TOKEN, function (state, _ref11) {
  var token = _ref11.token;

  state.token = token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.ERROR, function (state, error) {
  state.error = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOCKED_ERRORS, function (state, response) {
  state.lockedErrors = response;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.NO_ERROR, function (state) {
  state.error = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.LOCKED, function (state) {
  state.locked = true;
  state.token = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationTypes.RESET, function (state) {
  state.user = userTemplate();
  state.token = null;
  state.error = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  modules: {}
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

var types = {
    UPDATE_WIDTH: 'UPDATE_WIDTH'
};

var state = {
    theWidth: 0
};

var getters = {
    theCurrentWidth: function theCurrentWidth(state) {
        return state.theWidth;
    }
};

var actions = {
    updateWidth: function updateWidth(_ref, width) {
        var commit = _ref.commit;
        return commit(types.UPDATE_WIDTH, { width: width });
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, types.UPDATE_WIDTH, function (state, _ref2) {
    var width = _ref2.width;

    state.theWidth = width;
});

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'router/ROUTE_CHANGED': function routerROUTE_CHANGED(state, payload) {
        if (!payload.to.matched[0]) {
            return;
        }

        var matches = _.filter(payload.to.matched, function (route) {
            return !!route.meta.claimStore;
        });

        if (!matches.length || !matches[0].meta) {
            return;
        }

        var claimStore = matches[0].meta.claimStore;

        var store = void 0;

        if (~claimStore.indexOf('/')) {
            store = claimStore.split('/').reduce(function (object, index) {
                return object[index];
            }, state);
        } else {
            store = state[claimStore];
        }

        store.step.currentStepIndex = payload.to.meta.step - 1;
        store.step.currentStep = store.step.steps[payload.to.meta.step - 1];
    },
    'route/ROUTE_CHANGED': function routeROUTE_CHANGED(state, payload) {
        if (!payload.to.matched[0]) {
            return;
        }

        var matches = _.filter(payload.to.matched, function (route) {
            return !!route.meta.claimStore;
        });

        if (!matches.length || !matches[0].meta) {
            return;
        }

        var claimStore = matches[0].meta.claimStore;

        var store = void 0;

        if (~claimStore.indexOf('/')) {
            store = claimStore.split('/').reduce(function (object, index) {
                return object[index];
            }, state);
        } else {
            store = state[claimStore];
        }

        store.step.currentStepIndex = payload.to.meta.step - 1;
        store.step.currentStep = store.step.steps[payload.to.meta.step - 1];
    }
});

/***/ }),
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 350,
	"./af.js": 350,
	"./ar": 357,
	"./ar-dz": 351,
	"./ar-dz.js": 351,
	"./ar-kw": 352,
	"./ar-kw.js": 352,
	"./ar-ly": 353,
	"./ar-ly.js": 353,
	"./ar-ma": 354,
	"./ar-ma.js": 354,
	"./ar-sa": 355,
	"./ar-sa.js": 355,
	"./ar-tn": 356,
	"./ar-tn.js": 356,
	"./ar.js": 357,
	"./az": 358,
	"./az.js": 358,
	"./be": 359,
	"./be.js": 359,
	"./bg": 360,
	"./bg.js": 360,
	"./bm": 361,
	"./bm.js": 361,
	"./bn": 363,
	"./bn-bd": 362,
	"./bn-bd.js": 362,
	"./bn.js": 363,
	"./bo": 364,
	"./bo.js": 364,
	"./br": 365,
	"./br.js": 365,
	"./bs": 366,
	"./bs.js": 366,
	"./ca": 367,
	"./ca.js": 367,
	"./cs": 368,
	"./cs.js": 368,
	"./cv": 369,
	"./cv.js": 369,
	"./cy": 370,
	"./cy.js": 370,
	"./da": 371,
	"./da.js": 371,
	"./de": 374,
	"./de-at": 372,
	"./de-at.js": 372,
	"./de-ch": 373,
	"./de-ch.js": 373,
	"./de.js": 374,
	"./dv": 375,
	"./dv.js": 375,
	"./el": 376,
	"./el.js": 376,
	"./en-au": 377,
	"./en-au.js": 377,
	"./en-ca": 378,
	"./en-ca.js": 378,
	"./en-gb": 379,
	"./en-gb.js": 379,
	"./en-ie": 380,
	"./en-ie.js": 380,
	"./en-il": 381,
	"./en-il.js": 381,
	"./en-in": 382,
	"./en-in.js": 382,
	"./en-nz": 383,
	"./en-nz.js": 383,
	"./en-sg": 384,
	"./en-sg.js": 384,
	"./eo": 385,
	"./eo.js": 385,
	"./es": 389,
	"./es-do": 386,
	"./es-do.js": 386,
	"./es-mx": 387,
	"./es-mx.js": 387,
	"./es-us": 388,
	"./es-us.js": 388,
	"./es.js": 389,
	"./et": 390,
	"./et.js": 390,
	"./eu": 391,
	"./eu.js": 391,
	"./fa": 392,
	"./fa.js": 392,
	"./fi": 393,
	"./fi.js": 393,
	"./fil": 394,
	"./fil.js": 394,
	"./fo": 395,
	"./fo.js": 395,
	"./fr": 398,
	"./fr-ca": 396,
	"./fr-ca.js": 396,
	"./fr-ch": 397,
	"./fr-ch.js": 397,
	"./fr.js": 398,
	"./fy": 399,
	"./fy.js": 399,
	"./ga": 400,
	"./ga.js": 400,
	"./gd": 401,
	"./gd.js": 401,
	"./gl": 402,
	"./gl.js": 402,
	"./gom-deva": 403,
	"./gom-deva.js": 403,
	"./gom-latn": 404,
	"./gom-latn.js": 404,
	"./gu": 405,
	"./gu.js": 405,
	"./he": 406,
	"./he.js": 406,
	"./hi": 407,
	"./hi.js": 407,
	"./hr": 408,
	"./hr.js": 408,
	"./hu": 409,
	"./hu.js": 409,
	"./hy-am": 410,
	"./hy-am.js": 410,
	"./id": 411,
	"./id.js": 411,
	"./is": 412,
	"./is.js": 412,
	"./it": 414,
	"./it-ch": 413,
	"./it-ch.js": 413,
	"./it.js": 414,
	"./ja": 415,
	"./ja.js": 415,
	"./jv": 416,
	"./jv.js": 416,
	"./ka": 417,
	"./ka.js": 417,
	"./kk": 418,
	"./kk.js": 418,
	"./km": 419,
	"./km.js": 419,
	"./kn": 420,
	"./kn.js": 420,
	"./ko": 421,
	"./ko.js": 421,
	"./ku": 422,
	"./ku.js": 422,
	"./ky": 423,
	"./ky.js": 423,
	"./lb": 424,
	"./lb.js": 424,
	"./lo": 425,
	"./lo.js": 425,
	"./lt": 426,
	"./lt.js": 426,
	"./lv": 427,
	"./lv.js": 427,
	"./me": 428,
	"./me.js": 428,
	"./mi": 429,
	"./mi.js": 429,
	"./mk": 430,
	"./mk.js": 430,
	"./ml": 431,
	"./ml.js": 431,
	"./mn": 432,
	"./mn.js": 432,
	"./mr": 433,
	"./mr.js": 433,
	"./ms": 435,
	"./ms-my": 434,
	"./ms-my.js": 434,
	"./ms.js": 435,
	"./mt": 436,
	"./mt.js": 436,
	"./my": 437,
	"./my.js": 437,
	"./nb": 438,
	"./nb.js": 438,
	"./ne": 439,
	"./ne.js": 439,
	"./nl": 441,
	"./nl-be": 440,
	"./nl-be.js": 440,
	"./nl.js": 441,
	"./nn": 442,
	"./nn.js": 442,
	"./oc-lnc": 443,
	"./oc-lnc.js": 443,
	"./pa-in": 444,
	"./pa-in.js": 444,
	"./pl": 445,
	"./pl.js": 445,
	"./pt": 447,
	"./pt-br": 446,
	"./pt-br.js": 446,
	"./pt.js": 447,
	"./ro": 448,
	"./ro.js": 448,
	"./ru": 449,
	"./ru.js": 449,
	"./sd": 450,
	"./sd.js": 450,
	"./se": 451,
	"./se.js": 451,
	"./si": 452,
	"./si.js": 452,
	"./sk": 453,
	"./sk.js": 453,
	"./sl": 454,
	"./sl.js": 454,
	"./sq": 455,
	"./sq.js": 455,
	"./sr": 457,
	"./sr-cyrl": 456,
	"./sr-cyrl.js": 456,
	"./sr.js": 457,
	"./ss": 458,
	"./ss.js": 458,
	"./sv": 459,
	"./sv.js": 459,
	"./sw": 460,
	"./sw.js": 460,
	"./ta": 461,
	"./ta.js": 461,
	"./te": 462,
	"./te.js": 462,
	"./tet": 463,
	"./tet.js": 463,
	"./tg": 464,
	"./tg.js": 464,
	"./th": 465,
	"./th.js": 465,
	"./tk": 466,
	"./tk.js": 466,
	"./tl-ph": 467,
	"./tl-ph.js": 467,
	"./tlh": 468,
	"./tlh.js": 468,
	"./tr": 469,
	"./tr.js": 469,
	"./tzl": 470,
	"./tzl.js": 470,
	"./tzm": 472,
	"./tzm-latn": 471,
	"./tzm-latn.js": 471,
	"./tzm.js": 472,
	"./ug-cn": 473,
	"./ug-cn.js": 473,
	"./uk": 474,
	"./uk.js": 474,
	"./ur": 475,
	"./ur.js": 475,
	"./uz": 477,
	"./uz-latn": 476,
	"./uz-latn.js": 476,
	"./uz.js": 477,
	"./vi": 478,
	"./vi.js": 478,
	"./x-pseudo": 479,
	"./x-pseudo.js": 479,
	"./yo": 480,
	"./yo.js": 480,
	"./zh-cn": 481,
	"./zh-cn.js": 481,
	"./zh-hk": 482,
	"./zh-hk.js": 482,
	"./zh-mo": 483,
	"./zh-mo.js": 483,
	"./zh-tw": 484,
	"./zh-tw.js": 484
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1328;

/***/ }),
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","/app"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"/app","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1311)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1657),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1615),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1656),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1803),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1668),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1794),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1735),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1805),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1618),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1764),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1658),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1831),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1825),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1829),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1580),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1631),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1680),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1307)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1612),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1316)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1308)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1622),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1632),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1729),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1751),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1659),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1739),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1698),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1690),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1310)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1559),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1324)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1812),
  /* scopeId */
  "data-v-d0b0cff6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1588),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1317)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1716),
  /* scopeId */
  "data-v-604f76ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1828),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1630),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1571),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1727),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1752),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1702),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1666),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1781),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1604),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1675),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1824),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1567),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1814),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1610),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1728),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1587),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1590),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1823),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1605),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1731),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1796),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1662),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1602),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1713),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1620),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1570),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1771),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1696),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1574),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1837),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1621),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1616),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1589),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1779),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1754),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1715),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1783),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1613),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1809),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1593),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1738),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1667),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1676),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1679),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1807),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1813),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(1693),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(1692),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(1721),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1755),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1686),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1833),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1776),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1685),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1723),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1774),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1746),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1691),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1734),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1554),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1701),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1564),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(1722),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1573),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(1772),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(1628),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(1565),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(1595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(1726),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(1820),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(1732),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(1749),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(1745),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(1802),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(1600),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(1599),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(1596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(1672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(1725),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(1652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(1649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(1710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(1744),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(1775),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(1835),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(1760),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(1819),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(1806),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(1800),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(1797),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(742),
  /* template */
  __webpack_require__(1687),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(1556),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(745),
  /* template */
  __webpack_require__(1553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(1720),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(750),
  /* template */
  __webpack_require__(1750),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(1558),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(753),
  /* template */
  __webpack_require__(1645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(754),
  /* template */
  __webpack_require__(1682),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(755),
  /* template */
  __webpack_require__(1625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(756),
  /* template */
  __webpack_require__(1769),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(757),
  /* template */
  __webpack_require__(1768),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(758),
  /* template */
  __webpack_require__(1611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(1575),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(1647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(1650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1320)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(1759),
  /* scopeId */
  "data-v-7ca213fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(1688),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1740),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1712),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(767),
  /* template */
  __webpack_require__(1821),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(1705),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(1780),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(1569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(1709),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1717),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(773),
  /* template */
  __webpack_require__(1583),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(1578),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(1765),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(1826),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(777),
  /* template */
  __webpack_require__(1789),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(1817),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(779),
  /* template */
  __webpack_require__(1762),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(1624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(781),
  /* template */
  __webpack_require__(1576),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(782),
  /* template */
  __webpack_require__(1609),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(1703),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1816),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1322)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(785),
  /* template */
  __webpack_require__(1786),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1319)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(786),
  /* template */
  __webpack_require__(1737),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1312)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(1670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1637),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1555),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1724),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(1660),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1683),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1591),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1706),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(1594),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(801),
  /* template */
  __webpack_require__(1832),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(802),
  /* template */
  __webpack_require__(1827),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(1634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(1792),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(806),
  /* template */
  __webpack_require__(1773),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(807),
  /* template */
  __webpack_require__(1808),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(808),
  /* template */
  __webpack_require__(1642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(1757),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(810),
  /* template */
  __webpack_require__(1736),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(811),
  /* template */
  __webpack_require__(1684),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(1560),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(813),
  /* template */
  __webpack_require__(1811),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(1793),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(1614),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(1791),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1747),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1704),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1788),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1742),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1818),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1636),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1664),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fatal-icons'), _vm._v(" "), _c('div', {
    staticClass: "u-full-width u-d-block"
  }, [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('h2', [_vm._v("Claim Documents")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-padding-t-20"
  }, [(_vm.claimType === 'fatal_accident_dependency') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'fatal::dependency.step-9',
        params: {
          id: _vm.claimId
        }
      }
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'fatal_accident_estate') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'fatal::estate.step-6',
        params: {
          id: _vm.claimId
        }
      }
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'lost_years') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lost::step-8',
        params: {
          id: _vm.claimId
        }
      }
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'personal_injury') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'personal::step-9',
        params: {
          id: _vm.claimId
        }
      }
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex a-form-inputs u-flex-wrap u-align-items-flex-end u-margin-bottom-20 u-r-margin-bottom-0"
  }, [_c('div', [_c('div', {
    staticClass: "u-margin-bottom-10 u-bold"
  }, [_vm._v("\n                    Document Type\n                ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "name": "document_type",
      "id": "documentType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.documentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "offer_letter"
    }
  }, [_vm._v("Offer Letter")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "executive_summary"
    }
  }, [_vm._v("Executive Summary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "schedule_of_loss"
    }
  }, [_vm._v("Schedule of Loss")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "comparison_schedule"
    }
  }, [_vm._v("Comparison Schedule")])])]), _vm._v(" "), (_vm.documentType !== 'offer_letter' && _vm.documentType !== '' && _vm.claimType !== 'personal_injury') ? _c('div', {
    staticClass: "u-margin-trbl-0-0-0-10"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-bold"
  }, [_vm._v("\n                    Discount Rate\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_rate",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.discountRate),
      expression: "discountRate",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    staticClass: "u-full-width",
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateDiscountRate]
    }
  }, [_c('option', {
    domProps: {
      "value": -2.00
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.50
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.00
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.50
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.00
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.50
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.00
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.50
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.00
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.50
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.00
    }
  }, [_vm._v("3.00%")])])])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button u-margin-trbl-0-0-0-10",
    class: _vm.documentType === '' ? 'disabled' : '',
    attrs: {
      "disabled": _vm.documentType === ''
    },
    on: {
      "click": _vm.createDocument
    }
  }, [_vm._v("Generate\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width p-generate-schedule__table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.getGeneratedDocuments), function(document, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(document.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(document.type.replace(/[_-]/g, " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(document.discount_rate).toFixed(2)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(document.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(document.updated_at)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "200"
      }
    }, [_c('div', {
      staticClass: "u-d-flex u-flex-space-between"
    }, [(_vm.claimType === 'fatal_accident_dependency') ? _c('router-link', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "to": {
          name: 'fatal::dependency.documents.editor',
          params: {
            id: _vm.claimId,
            document_id: index
          }
        }
      }
    }, [(document.type !== 'executive_summary') ? _c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_' + index,
        "tooltip-text": "edit",
        "side": "left",
        "text-width": "110",
        "icon-type": "edit"
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'fatal_accident_estate') ? _c('router-link', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "to": {
          name: 'fatal::estate.documents.editor',
          params: {
            id: _vm.claimId,
            document_id: index
          }
        }
      }
    }, [(document.type !== 'executive_summary') ? _c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_' + index,
        "tooltip-text": "edit",
        "side": "left",
        "text-width": "110",
        "icon-type": "edit"
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'lost_years') ? _c('router-link', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "to": {
          name: 'lost::documents.editor',
          params: {
            id: _vm.claimId,
            document_id: index
          }
        }
      }
    }, [(document.type !== 'executive_summary') ? _c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_' + index,
        "tooltip-text": "edit",
        "side": "left",
        "text-width": "110",
        "icon-type": "edit"
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'personal_injury') ? _c('router-link', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "to": {
          name: 'personal::documents.editor',
          params: {
            id: _vm.claimId,
            document_id: index
          }
        }
      }
    }, [_c('div', {
      staticClass: "u-float-l"
    }, [(document.type !== 'executive_summary') ? _c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_' + index,
        "tooltip-text": "edit",
        "side": "left",
        "text-width": "110",
        "icon-type": "edit"
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (document.type !== 'comparison_schedule') ? _c('a', {
      attrs: {
        "href": '/api/v1/generated-documents/pdf/' + document.id + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'download_schedule_of_loss' + index,
        "tooltip-text": "download",
        "side": "left",
        "text-width": "150",
        "icon-type": "download"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (document.type === 'comparison_schedule') ? _c('a', {
      attrs: {
        "href": '/api/v1/comparison-schedule/pdf/' + document.id + '?document_id=' + document.id + '&discount_rate=' + document.discount_rate + '&access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'download_comparison_schedule' + index,
        "tooltip-text": "download",
        "side": "left",
        "text-width": "150",
        "icon-type": "download"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.deleteDocument(document)
        }
      }
    }, [_c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'delete' + index,
        "tooltip-text": "delete",
        "side": "left",
        "text-width": "110",
        "icon-type": "delete"
      }
    })], 1)])], 1)])])
  }), _vm._v(" "), (_vm.getGeneratedDocuments.length === 0) ? _c('tr', [_vm._m(1)]) : _vm._e()], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('h2', [_vm._v("Name")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Type")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Discount Rate")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Created")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Updated")])]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                            No claim documents created yet.\n                        ")])])
}]}

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-care__period"
  }, [_c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n        Period " + _vm._s(_vm.index + 1) + "\n    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Start of Loss of Earnings"
    }
  }, [_c('date-input', {
    ref: "startOfPeriod",
    on: {
      "input": function($event) {
        return _vm.calculateLoss()
      }
    },
    model: {
      value: (_vm.period.startOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.period, "startOfPeriod", $$v)
      },
      expression: "period.startOfPeriod"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodStartIsValid
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY and must be before the End of Loss of Earnings Date\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "End of Loss of Earnings"
    }
  }, [_c('date-input', {
    ref: "endOfPeriod",
    on: {
      "input": function($event) {
        return _vm.calculateLoss()
      }
    },
    model: {
      value: (_vm.period.endOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.period, "endOfPeriod", $$v)
      },
      expression: "period.endOfPeriod"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEndIsValid
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY, and must be after the Start of Loss of Earnings Date\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentType),
      expression: "period.employmentType"
    }],
    ref: "employmentType",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "employmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.calculateLoss()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "absence"
    }
  }, [_vm._v("Absent")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Income"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentIncome),
      expression: "period.employmentIncome"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "employmentIncome",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.period.employmentIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.period, "employmentIncome", $event.target.value)
      }, function($event) {
        return _vm.calculateLoss()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentNetGross),
      expression: "period.employmentNetGross"
    }],
    ref: "employmentNetGross",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.calculateLoss()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])])])]), _vm._v(" "), _c('control', [_c('button', {
    staticClass: "a-button a-button--smaller",
    class: _vm.index === 0 ? 'disabled' : '',
    attrs: {
      "disabled": _vm.index === 0
    },
    on: {
      "click": function($event) {
        return _vm.deleteThisPeriod()
      }
    }
  }, [_vm._v("\n            Delete Income Period\n        ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimantForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "for": "claimantName",
      "label": "Claimant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "field-control",
      rawName: "v-field-control:claimantName.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "claimantName",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "claimantName",
      "id": "claimantName",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimantName')
    }
  }, [_vm._v("\n                        The claimant name is required and must be a valid name\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Claimant Solicitors',
      "error-message": 'The claimant solicitor is required and must be a valid name',
      "value": _vm.claimantSolicitor,
      "type": 'claimant_solicitors'
    },
    on: {
      "update": _vm.updateClaimantSolicitors
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimaint_reference",
      "label": "Claimant Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantReference),
      expression: "claimantReference"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    staticClass: "input",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "maxlength": "100",
      "name": "claimaint_reference",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimantReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimaint_reference')
    }
  }, [_vm._v("\n                        The claimant reference is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimant_gender",
      "label": "Claimant Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "required": "",
      "name": "claimant_gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_gender')
    }
  }, [_vm._v("\n                        The claimant's gender is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimant_date_of_birth",
      "label": "Claimant Date of Birth"
    }
  }, [_c('date-input-d-o-b', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claimant_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "claimant_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_date_of_birth')
    }
  }, [_vm._v("\n                        The claimant's date of birth is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "name": "disease_or_accident",
      "label": "Disease or Accident?"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    attrs: {
      "name": "disease_or_accident",
      "id": "disease_or_accident",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_or_accident')
    }
  }, [_vm._v("\n                        The disease type is required\n                    ")])], 1), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', [_c('control', {
    attrs: {
      "name": "disease_type",
      "label": "Disease"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    attrs: {
      "name": "disease_type",
      "id": "disease_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" - - -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer — Specify Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" - - -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_type')
    }
  }, [_vm._v("\n                            The disease type is required\n                        ")])], 1), _vm._v(" "), (_vm.diseaseType && _vm.diseaseType.substr(0, 5) === 'Other') ? _c('control', {
    attrs: {
      "name": "disease_type_other",
      "label": "Disease Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherDiseaseType),
      expression: "otherDiseaseType"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "disease_type_other",
      "id": "disease_type_other",
      "required": ""
    },
    domProps: {
      "value": (_vm.otherDiseaseType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherDiseaseType = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_type_other') || _vm.otherDiseaseType === null || _vm.otherDiseaseType === undefined
    }
  }, [_vm._v("\n                            The disease type is required\n                        ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident') ? _c('div', [_c('control', {
    attrs: {
      "name": "accident_type",
      "label": "Accident"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    attrs: {
      "name": "accident_type",
      "id": "accident_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('accident_type')
    }
  }, [_vm._v("\n                            The accident type is required\n                        ")])], 1), _vm._v(" "), (_vm.accidentType && _vm.accidentType.substr(0, 5) === 'Other') ? _c('control', {
    attrs: {
      "name": "other_accident_type",
      "label": "Accident Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentTypeOther),
      expression: "accidentTypeOther"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "other_accident_type",
      "id": "other_accident_type",
      "required": ""
    },
    domProps: {
      "value": (_vm.accidentTypeOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accidentTypeOther = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('accident_type_other') || _vm.accidentTypeOther === null || _vm.accidentTypeOther === undefined
    }
  }, [_vm._v("\n                            The accident type is required\n                        ")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "your_reference",
      "label": "Your Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yourReference),
      expression: "yourReference"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "your_reference",
      "maxlength": "30",
      "type": "text"
    },
    domProps: {
      "value": (_vm.yourReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('your_reference')
    }
  }, [_vm._v("\n                        Your reference is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pre_lit_or_lit",
      "label": "Procedural Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preLitOrLit),
      expression: "preLitOrLit"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "pre_lit_or_lit",
      "id": "pre_lit_or_lit",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preLitOrLit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre-lit"
    }
  }, [_vm._v("Pre-Litigation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "litigated"
    }
  }, [_vm._v("Litigated")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pre_lit_or_lit')
    }
  }, [_vm._v("\n                        Procedural status is required\n                    ")])], 1), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Defendant Name',
      "error-message": 'The defendant name is required and must be a valid name',
      "value": _vm.defendantName,
      "type": 'defendant'
    },
    on: {
      "update": _vm.updateDefendant
    }
  }), _vm._v(" "), (_vm.preLitOrLit == 'litigated') ? _c('control', {
    attrs: {
      "for": "service_of_proceedings",
      "label": "Date of Service of Proceedings"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_service_proceedings.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_service_proceedings",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfServiceProceedings),
      callback: function($$v) {
        _vm.dateOfServiceProceedings = $$v
      },
      expression: "dateOfServiceProceedings"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_service_proceedings') || (!_vm.serviceProceedingsDateRules() && _vm.dateOfAssumedSettlement !== null)
    }
  }, [_vm._v("\n                        Date of service of proceedings is required, must be in the format DD/MM/YYYY, must be\n                        on or before date of assumed settlement/trial "), (_vm.dateOfAssumedSettlement) ? _c('span', [_vm._v("(" + _vm._s(_vm.dateOfAssumedSettlement) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement/Trial"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement') || (!_vm.assumedSettlementDateRules() && _vm.dateOfAssumedSettlement !== null)
    }
  }, [_vm._v("\n                        Date of assumed settlement/trial is required, must be in the format DD/MM/YYYY,\n                        must be after the date of service of proceedings\n                        and after no more than 9 years after the date of issue of proceedings\n                    ")]), _vm._v(" "), _c('control-warning', {
    attrs: {
      "show": _vm.dateOfAssumedSettlementInPast
    }
  }, [_c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-warning-box__orange"
  }, [_vm._v("Date of assumed settlement is in the past")])])], 1)], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_rate",
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('discount_rate')
    }
  }, [_vm._v("\n                        Discount rate is required\n                    ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs flex-grid__item--full"
  }, [_c('control', {
    attrs: {
      "for": "claim_narrative",
      "label": "Claim Narrative",
      "tip-text": "Provide a brief background to the claim and issues in dispute. This narrative will populate your counter-schedule of loss.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "claim_narrative"
    }
  }, [_c('textarea', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claim_narrative.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "claim_narrative",
      modifiers: {
        "required": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.claimNarrative),
      expression: "claimNarrative"
    }],
    staticClass: "u-full-width",
    attrs: {
      "required": "",
      "rows": "4",
      "name": "claim_narrative"
    },
    domProps: {
      "value": (_vm.claimNarrative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimNarrative = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claim_narrative')
    }
  }, [_vm._v("\n                    The claim narrative is required\n                ")])], 1)], 1)]), _vm._v(" "), _c('step-button', {
    attrs: {
      "prev-valid": false,
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__form"
  }, [_c('control', {
    attrs: {
      "label": "Disease or Accident",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])])]), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('control', {
    attrs: {
      "label": "Disease Type",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer")])])]) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident') ? _c('control', {
    attrs: {
      "label": "Accident Type",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Dependency or Estate Claim",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.estateOrDependency),
      expression: "estateOrDependency"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.estateOrDependency = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependency"
    }
  }, [_vm._v("Dependency Claim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "estate"
    }
  }, [_vm._v("Estate Claim")])])]), _vm._v(" "), (_vm.estateOrDependency == 'dependency') ? _c('control', {
    attrs: {
      "label": "Number of Dependants",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberOfDependants),
      expression: "numberOfDependants"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.numberOfDependants = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("1 Dependent")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("2 Dependents")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("3 Dependents")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("4 Dependents")])])]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gender of Deceased",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Deceased's DOB",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:dob",
      value: (_vm.dobRules),
      expression: "dobRules",
      arg: "dob"
    }],
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dob')
    }
  }, [_vm._v("\n            The person must be born in the past\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Onset of Symptoms",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:osos",
      value: (_vm.oSoSRules),
      expression: "oSoSRules",
      arg: "osos"
    }],
    model: {
      value: (_vm.onsetOfSymptoms),
      callback: function($$v) {
        _vm.onsetOfSymptoms = $$v
      },
      expression: "onsetOfSymptoms"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('osos')
    }
  }, [_vm._v("\n            The symptoms must be before the date of death\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Deceased's Date of Death",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:dod",
      value: (_vm.dodRules),
      expression: "dodRules",
      arg: "dod"
    }],
    model: {
      value: (_vm.dateOfDeath),
      callback: function($$v) {
        _vm.dateOfDeath = $$v
      },
      expression: "dateOfDeath"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dod')
    }
  }, [_vm._v("\n            The person must have died after they were born.\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Deceased's Age on Death",
      "before-after": "years-old",
      "icon-space": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date of Assessment (or assumed)",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:assumed",
      value: (_vm.assumedRules),
      expression: "assumedRules",
      arg: "assumed"
    }],
    model: {
      value: (_vm.assumedSettlement),
      callback: function($$v) {
        _vm.assumedSettlement = $$v
      },
      expression: "assumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('assumed')
    }
  }, [_vm._v("\n            The assessment date must be after death.\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employed or Retired",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "retired"
    }
  }, [_vm._v("Retired")])])]), _vm._v(" "), (_vm.employmentType == 'employed') ? _c('div', [_c('control', {
    attrs: {
      "label": "Gross Annual Salary",
      "before-after": "pound",
      "icon-space": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salary),
      expression: "salary"
    }],
    attrs: {
      "type": "text",
      "min": "0"
    },
    domProps: {
      "value": (_vm.salary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salary = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.gender) ? _c('salary-finder', {
    attrs: {
      "gender": _vm.gender
    },
    on: {
      "update": _vm.updateSalary
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Procedural Status",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proceduralStatus),
      expression: "proceduralStatus"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.proceduralStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pre-lit"
    }
  }, [_vm._v("Pre-Litigation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "litigated"
    }
  }, [_vm._v("Litigated")])])]), _vm._v(" "), (_vm.showErrorMessage) ? _c('div', [_c('span', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("You must complete all fields.")])]) : _vm._e(), _vm._v("\n    Calculate the results:\n    "), _c('div', [_c('button', {
    staticClass: "a-button u-no-margin",
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-care__period"
  }, [_c('control', {
    attrs: {
      "no-flex-margin": true,
      "label": 'Period ' + Number(_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    ref: "periodStart",
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": function($event) {
        return _vm.updateTotal()
      }
    },
    model: {
      value: (_vm.period.periodStart),
      callback: function($$v) {
        _vm.$set(_vm.period, "periodStart", $$v)
      },
      expression: "period.periodStart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.includeFirstDay),
      expression: "period.includeFirstDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.period.includeFirstDay) ? _vm._i(_vm.period.includeFirstDay, null) > -1 : (_vm.period.includeFirstDay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.period.includeFirstDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.period, "includeFirstDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.period, "includeFirstDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.period, "includeFirstDay", $$c)
        }
      }, _vm.updateTotal]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include first day")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodStartDateRules
    }
  }, [_vm._v("\n                    The Period Start Date is required and must be in the format DD/MM/YYYY\n                    and can not be after the Period End Date\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    ref: "periodEnd",
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.updateTotal
    },
    model: {
      value: (_vm.period.periodEnd),
      callback: function($$v) {
        _vm.$set(_vm.period, "periodEnd", $$v)
      },
      expression: "period.periodEnd"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.includeLastDay),
      expression: "period.includeLastDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.period.includeLastDay) ? _vm._i(_vm.period.includeLastDay, null) > -1 : (_vm.period.includeLastDay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.period.includeLastDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.period, "includeLastDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.period, "includeLastDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.period, "includeLastDay", $$c)
        }
      }, _vm.updateTotal]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include last day")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEndDateRules
    }
  }, [_vm._v("\n                    The Period End Date is required and must be in the format DD/MM/YYYY\n                    and can not be before the Period Start Date\n                ")])], 1)]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.overlapsAnother
    }
  }, [_vm._v("\n            This period overlaps another.\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Hours per Day"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.period.hoursPerDay),
      expression: "period.hoursPerDay"
    }],
    attrs: {
      "name": "hours_per_day"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "hoursPerDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }, _vm._l((24), function(hour) {
    return _c('option', {
      domProps: {
        "value": hour
      }
    }, [_vm._v("\n                " + _vm._s(hour) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.rate),
      expression: "period.rate"
    }],
    ref: "rates",
    attrs: {
      "id": "method1",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "rate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "basic"
    }
  }, [_vm._v("Basic Rate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "aggregate"
    }
  }, [_vm._v("Aggregate")])]), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-top-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.gratuitousCare),
      expression: "period.gratuitousCare"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.period.gratuitousCare) ? _vm._i(_vm.period.gratuitousCare, null) > -1 : (_vm.period.gratuitousCare)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.period.gratuitousCare,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.period, "gratuitousCare", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.period, "gratuitousCare", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.period, "gratuitousCare", $$c)
        }
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Gratuitous Care Discount")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.period.total, '')
    }
  })]), _vm._v(" "), _c('control', [_c('button', {
    staticClass: "a-button a-button--smaller",
    class: _vm.index === 0 ? 'disabled' : '',
    attrs: {
      "disabled": _vm.index === 0
    },
    on: {
      "click": function($event) {
        return _vm.deleteThisPeriod()
      }
    }
  }, [_vm._v("\n            Delete Care Period\n        ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "u-position-relative",
    class: {
      'c-option-list--select-style': _vm.selectStyle
    },
    on: {
      "click": function($event) {
        return _vm.updateListOptions()
      }
    }
  }, [_c('div', {
    staticClass: "c-option-list__parent-heading u-d-inline-block",
    attrs: {
      "id": "c-option-list__parent-heading"
    }
  }, [_c('h2', {
    staticClass: "c-option-list__heading",
    class: _vm.name
  }, [_vm._v("\n                " + _vm._s(_vm.heading) + "\n            ")]), _vm._v(" "), (_vm.selectStyle) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#select-arrow",
      "id": "c-option-list__arrow"
    }
  })]) : _c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#triangle-down",
      "id": "c-option-list__arrow"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-option-list",
    class: _vm.name,
    attrs: {
      "id": "c-option-list"
    }
  }, [_c('ul', [_vm._t("default")], 2)])]), _vm._v(" "), (_vm.filterSelected) ? _c('div', {
    on: {
      "click": _vm.resetDefaultHeading
    }
  }, [_vm._t("add")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n        Key Information\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "66%"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "33%"
    }
  }, [_vm._v(_vm._s(_vm.gender))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DOB")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.claimant.dateOfBirth))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Age At Date Of Injury/Accident (" + _vm._s(_vm.claim('dateOfInjury')) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ageAtInjury))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Age At Assumed Settlement (" + _vm._s(_vm.claim('dateOfAssumedSettlement')) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ageAtSettlement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Age Today (" + _vm._s(_vm.today) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ageToday))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width"
  }, [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "33%",
      "colspan": "2"
    }
  }, [_vm._v("Pre-Accident Net Income per Annum")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "33%"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.preAccidentIncome)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total Payments Made")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getPostInjuryIncomePeriodPaymentsTotal)))])]), _vm._v(" "), _vm._l((_vm.pastPeriods), function(period) {
    return (_vm.calcLoss(period) > 0) ? _c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "rowspan": "4"
      }
    }, [_vm._v("Period Of Reduced Income")]), _vm._v(" "), _c('td', [_vm._v("Start")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.startOfPeriod))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("End")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.endOfPeriod))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Duration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.duration.toFixed(2)) + " years")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Net Income P.A.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.totalNetIncome)))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.futureLosses) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Periods of Future Loss")]), _vm._v(" "), _c('td', [_vm._v("Start")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesStart))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("End")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesEnd))])]), _vm._v(" "), (_vm.durationOfPeriod) ? _c('tr', [_c('td', [_vm._v("Duration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.durationOfPeriod.toFixed(2)) + " years")])]) : _vm._e()]) : _vm._e()], 2)]), _vm._v(" "), (_vm.futureLosses) ? _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Pre-Accident")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.disabledAtAccident ? 'Disabled' : 'Not Disabled'))]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n                    Discount Factor: " + _vm._s(_vm.roundValue(_vm.preInjuryDiscountFactor, 2)) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.employedAtAccident ? 'Employed' : 'Not Employed'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.levelOfEducation) + " — Education")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Post-Accident")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.disabledAtAssessment ? 'Disabled' : 'Not Disabled'))]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n                    Discount Factor: " + _vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.employedAtAssessment ? 'Employed' : 'Not Employed'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.levelOfEducation) + " — Education")])])]), _vm._v(" "), _c('tbody', [(_vm.durationOfPeriod) ? _c('tr', [_c('td', [_vm._v("Duration of Future Loss")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.durationOfPeriod.toFixed(2)) + " years")])]) : _vm._e()]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Multiplier")]), _vm._v(" "), _c('td', [_vm._v("Ogden Table 36")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.multiplier.toFixed(2)))])])])])]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("\n        Heads of Loss\n    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "percentage",
      "label": "Your Percentage of the claim"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "percentage",
      "id": "percentage",
      "max": "100",
      "min": "0",
      "step": "0.1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tr', [_c('td', [_vm._v("General Damages")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getGeneralDamages)))]), _vm._v(" "), (_vm.claim('proceduralStatus') === 'pre-lit') ? _c('td') : _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.otherPastLoss('generalDamagesWithInterest'))) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('generalDamages'))) + "\n                ")])]), _vm._v(" "), (_vm.pastLossOfEarnings) ? _c('tr', [_c('td', [_vm._v("Past Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getIncomeValue('pastLossOfEarningsNetTotal'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastLossOfEarningsWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('pastLossOfEarnings'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.otherPastLoss('pastCostOfCare') > 0) ? _c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfCareWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('pastCostOfCare'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.otherPastLoss('pastCostOfServices') > 0) ? _c('tr', [_c('td', [_vm._v("Past Cost of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfServices'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfServicesWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('pastCostOfServices'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.otherPastLoss('pastCostOfTravel') > 0) ? _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfTravelWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('pastCostOfTravel'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.otherPastLoss('misc') > 0) ? _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('misc'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('miscWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('misc'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.allCustomHeadOfLoss), function(headOfLoss) {
    return (_vm.customHeadsOfLossTotal > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(headOfLoss.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(headOfLoss.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(headOfLoss.interestAccrued)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.futurePensionTotal > 0) ? _c('tr', [_c('td', [_vm._v("Future Loss of Pension")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futurePensionTotal)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('futurePensionTotal'))))])]) : _vm._e(), _vm._v(" "), (_vm.futureCareTotal > 0) ? _c('tr', [_c('td', [_vm._v("Future Loss of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureCareTotal)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('futureCareTotal'))))])]) : _vm._e(), _vm._v(" "), (_vm.futureServicesTotal > 0) ? _c('tr', [_c('td', [_vm._v("Future Loss of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureServicesTotal)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('futureServicesTotal'))))])]) : _vm._e(), _vm._v(" "), (_vm.purchasesTotal > 0) ? _c('tr', [_c('td', [_vm._v("Future Purchases")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.purchasesTotal)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('purchasesTotal'))))])]) : _vm._e(), _vm._v(" "), (_vm.lossResult > 0) ? _c('tr', [_c('td', [_vm._v("Future Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.lossResult)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('lossResult'))))])]) : _vm._e(), _vm._v(" "), (_vm.cruTotalDeductions > 0) ? _c('tr', [_c('td', [_vm._v("CRU Benefits")]), _vm._v(" "), _c('td', [_vm._v("- " + _vm._s(_vm.currencyFormat(_vm.cruTotalDeductions)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('cruTotalDeductions'))))])]) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.subTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('subTotal'))))])]), _vm._v(" "), (_vm.getAllInterimPaymentsTotal > 0) ? _c('tr', {
    staticClass: "a-table--penultimate"
  }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.total)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('total'))))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total "), (_vm.getAllInterimPaymentsTotal > 0) ? _c('span', [_vm._v("less interim payment(s)")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalLessInterimPayments)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('totalLessInterimPayments'))))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "step-button flex-state-buttons flex-state-buttons--block a-table--center"
  }, [_c('div', [_c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'personal::step-8'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'personal::documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                View Documents\n            ")])], 1)]), _vm._v(" "), _c('reserves-for-claim')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("The Claimant")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h2', [_vm._v("Income, Absenses From Work & Any Future Periods of Loss")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h2', [_vm._v("Multipliers & Discount Factors for Contingencies Other Than Mortality")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_c('h2', [_vm._v("Amount")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_c('h2', [_vm._v("Interest")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_c('h2', [_vm._v("Apportioned Total")])])])
}]}

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs p-compare-reserve"
  }, [_c('h2', {
    staticClass: "u-centre chart"
  }, [_vm._v("Difference between " + _vm._s(_vm.fromLabel) + " and " + _vm._s(_vm.toLabel))]), _vm._v(" "), (_vm.theCurrentWidth >= 600) ? _c('range-chart', {
    attrs: {
      "claims": _vm.claims,
      "range": _vm.range
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Funeral Expenses — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is based on an average from claims of a similar type. Where there is insufficient\n        data within the tool to derive an average a figure of £5,000 is applied.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__salary-finder"
  }, [_c('p', [_vm._v("Choose a salary:")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin ashe",
    on: {
      "click": function($event) {
        return _vm.selectSalary(null)
      }
    }
  }, [_vm._v("\n        Use ASHE average for " + _vm._s(_vm.gender == "male" ? 'men' : 'women') + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin refine",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n        Refine by occupation\n    ")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ons_salary",
      "no-default-button": "true"
    }
  }, [_c('div', {
    staticClass: "p-day-one__refine-occupation"
  }, [_c('h2', [_vm._v("Refine by occupation")]), _vm._v(" "), (_vm.selectedNode) ? _c('div', [_c('p', [_vm._v("\n                    Your current selection - "), _c('strong', [_vm._v(_vm._s(_vm.getLastNode().description))]), _c('br'), _vm._v(" "), (_vm.getLastNode().code.length !== 3) ? _c('span', [_vm._v("Select a salary, expand down further or use the average salary for this whole group")]) : _c('span', [_vm._v("Select a salary or use the average salary for this whole group")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.unselectNode(_vm.selectedNode)
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.selectSalary(_vm.selectedNode)
      }
    }
  }, [_vm._v("Use average " + _vm._s(_vm.displaySalary(_vm.selectedNode)))])]) : _c('div', [_c('p', [_vm._v("\n                    Select a salary or expand the group\n                ")])]), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "a-table__small a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('tbody', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "a-loader--table"
  })])]) : _c('tbody', _vm._l((_vm.nodes), function(node) {
    return _c('tr', {
      staticClass: "selected--row"
    }, [_c('td', [_vm._v(_vm._s(node.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displaySalary(node)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "a-button a-button--small",
      attrs: {
        "disabled": node.code.length === 4
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectNode(node)
        }
      }
    }, [_vm._v("\n                                    Expand\n                                ")])]), _vm._v(" "), _c('td', [(node.salary !== 'x') ? _c('button', {
      staticClass: "a-button a-button--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectSalary(node, _vm.type)
        }
      }
    }, [_vm._v("\n                                    Select\n                                ")]) : _vm._e()])])
  }), 0)])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])
},staticRenderFns: []}

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimCosts),
      expression: "claimCosts"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.claimCosts = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "damages"
    }
  }, [_vm._v("Damages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "claimantCosts"
    }
  }, [_vm._v("Claimant Costs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "defenceCosts"
    }
  }, [_vm._v("Defence Costs")])])
},staticRenderFns: []}

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('accordion', [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Claimant Income Information\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid u-r-margin-bottom-0 a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-bold"
  }, [_vm._v("\n                        Was the Claimant Retired at Onset of Disease?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_but_for",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "If the claimant had stopped working at the onset of symptoms, regardless of whether they had reached state pension age, they would be classed as having been retired.",
      "tip-width": "200",
      "tip-name": "retired_at_onset_of_disease"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedButFor),
      expression: "employedButFor"
    }],
    attrs: {
      "id": "employed_but_for"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedButFor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (_vm.employedButFor) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                        Apply Employment Contingency Discounts\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "contingency_multiplier",
      "tip-show": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "Contingency discount is available when the the deceased was under the age of 67 at settlement/trial.",
      "tip-width": "200",
      "tip-name": 'contingency_multiplier_the_claimant',
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contingencyMultiplier),
      expression: "contingencyMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "contingency_multiplier",
      "required": "",
      "disabled": _vm.ageAtTrial > 67
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contingencyMultiplier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateContingency]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('contingency_multiplier')
    }
  }, [_vm._v("\n                        Apply employment contingency discounts is required\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.employedButFor && _vm.ageAtTrial > 54) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }), _vm._v(" "), _c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-10"
  }, [_vm._v("\n                            Please note the discount figures only apply up to age 54\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-40",
    attrs: {
      "slot": "b"
    },
    slot: "b"
  }, [_c('p', {
    staticClass: "c-warning-box--link"
  }, [_vm._v("Read the full description here")])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.employedButFor && _vm.contingencyMultiplier) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                        Claimant Employed at Onset of Disease?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_at_accident",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "If the claimant had stopped working at the onset of symptoms, regardless of whether they had reached state pension age, they would be classed as having been retired.",
      "tip-width": "200",
      "tip-name": "employed_at_accident"
    },
    on: {
      "change": _vm.calculateLossOfEarnings
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedAtAccident),
      expression: "employedAtAccident"
    }],
    attrs: {
      "id": "employed_at_accident"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes — Employed")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No — Not Employed")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                        Claimant Level of Education\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "level_of_education"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.levelOfEducation),
      expression: "levelOfEducation"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "level_of_education",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.levelOfEducation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calculateLossOfEarnings]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Degree or equivalent or higher")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GE-A"
    }
  }, [_vm._v("GCSE grades A–C up to A levels or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("Below GCSE grade C or CSE grade 1 or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("No qualifications")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('level_of_education')
    }
  }, [_vm._v("\n                            Level of Education is required\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                        Was the Claimant Disabled?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "claimant_disabled"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledAtAccident),
      expression: "disabledAtAccident"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimant_disabled",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calculateLossOfEarnings]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Not Disabled")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Disabled")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_disabled')
    }
  }, [_vm._v("\n                            Claimant Disabled is required\n                        ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.showResult) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                        Table A–D Discount Factor\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "table_a_d_discount_factor",
      "modal-name": 'income_' + _vm.uniqueId,
      "endpoint": 'contingencyMultiplier',
      "payload": _vm.contingencyMultiplierPayload,
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": _vm.theMultiplier
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.employedButFor === true) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("Retirement Age")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_age_calc",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "Use government recommended retirement age/date or manually enter own",
      "tip-width": "200",
      "tip-name": "retirement_age_calc",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirementAgeCalc),
      expression: "retirementAgeCalc"
    }],
    attrs: {
      "id": "retirement_age_calc"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.retirementAgeCalc = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcRetirementData]
    }
  }, [_c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Manual")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("Expected Retirement Age")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_age",
      "before-after": "years-old",
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "retirement_age",
      "modal-name": 'income_' + _vm.uniqueId,
      "payload": {
        person: this.claimant
      },
      "endpoint": 'expectedRetirementAge',
      "tip-show": _vm.retirementAgeCalc == 'auto',
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.retirementAge),
      expression: "retirementAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "disabled": _vm.retirementAgeCalc === 'auto',
      "min": _vm.earliestRetirement,
      "name": "retirement_age"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.retirementDateRules || !_vm.retirementAgeRules
    }
  }, [_vm._v("\n                            The Retirement Age must be greater than " + _vm._s(_vm.earliestRetirement) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("Expected Retirement Date")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_date",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:retirement_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "retirement_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.retirementAgeCalc === 'auto'
    },
    model: {
      value: (_vm.retirementDate),
      callback: function($$v) {
        _vm.retirementDate = $$v
      },
      expression: "retirementDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": (!_vm.retirementDateRules || !_vm.retirementAgeRules) && _vm.employedButFor !== true
    }
  }, [_vm._v("\n                            The Retirement Date must be after " + _vm._s(_vm.earliestRetirementDate) + "\n                        ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.retirementAtOnsetRules
    }
  }, [_vm._v("\n                            The Retirement Date must be after the onset of symptoms " + _vm._s(_vm.getClaimantValue('onsetOfSymptoms')) + "\n                        ")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Past Loss of Earnings\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Is there any past loss of earnings?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings"
    }],
    attrs: {
      "id": "past_loss_of_earnings"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pastLossOfEarnings = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateLossOfEarnings('past')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.pastLossOfEarnings) ? _c('income', {
    attrs: {
      "name": "Claimant",
      "retired": true,
      "income": _vm.claimant.income,
      "lossOfEarnings": _vm.pastLossOfEarnings,
      "start-disabled": false,
      "type": "past"
    },
    on: {
      "action": _vm.updateIncome
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Future Loss of Earnings & Pension\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Is there any future loss of earnings and / or pension?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_loss_of_earnings",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossOfEarnings),
      expression: "futureLossOfEarnings"
    }],
    attrs: {
      "id": "future_loss_of_earnings"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossOfEarnings = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateLossOfEarnings('future')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.futureLossOfEarnings) ? _c('income', {
    attrs: {
      "name": "Claimant",
      "retired": _vm.retired,
      "income": _vm.claimant.income,
      "lossOfEarnings": _vm.futureLossOfEarnings,
      "type": "future"
    },
    on: {
      "action": _vm.updateIncome
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "warning_text_lost_years",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("The discount figures")]), _vm._v(" "), _c('p', [_vm._v("Do you wish to discount the future loss of earnings multiplier for contingencies other than mortality? For example, to reflect the risks and vicissitudes of life, such as periods not earning from ill-health or loss of employment or taking care for dependents. If so then Tables A-D of the Ogden Tables provide framework figures for discounting the multiplier to reflect these risks. Please note the discount figures only apply up to age "), _c('strong', [_vm._v("54")]), _vm._v(". Thereafter the tables state:")]), _vm._v(" "), _c('blockquote', [_c('i', [_vm._v("‘For older ages the reduction factors increase towards 1 at retirement age for those who are employed and fall towards 0 for those who are not employed. However, where the claimant is older than "), _c('strong', [_vm._v("54")]), _vm._v(", it is anticipated that the likely future course if employment status will be particularly dependent on individual circumstances, so that the use of factors based on averages would not be appropriate. Hence reduction factors are not provided for older ages’.")])]), _vm._v(" "), _c('p', [_vm._v("ABCQuantum does however provide discount factors beyond age "), _c('strong', [_vm._v("54")]), _vm._v(" to retirement age by simple interpolation. So for an employed male aged "), _c('strong', [_vm._v("54")]), _vm._v(", not disabled with A level qualifications the discount factor in "), _c('strong', [_vm._v("Table A is 0.79")]), _vm._v(". The figure at retirement age of say "), _c('strong', [_vm._v("65/66 is 1.0")]), _vm._v(". For ages between "), _c('strong', [_vm._v("54–65/66")]), _vm._v(" we interpolate between the figures "), _c('strong', [_vm._v("0.79–1.0")]), _vm._v(".")])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'income_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of Travel\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Disability Living Allowance (mobility component)",
      "store-key": "pcotDisabilityLivingAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Mobility Allowance",
      "store-key": "pcotMobilityAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Personal Independence Payment (mobility component)",
      "store-key": "pcotPersonalIndependencePayment",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-warning-box"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('icons'), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._t("icon")], 2), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._t("b")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Claim Status\n        ")]), _vm._v(" "), _c('claim-status')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Claim Type\n        ")]), _vm._v(" "), _c('claim-type')], 1), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Disease or Accident\n        ")]), _vm._v(" "), _c('disease-or-accident')], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Disease Type\n        ")]), _vm._v(" "), _c('disease-type')], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident' || _vm.claimType === 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Accident Type\n        ")]), _vm._v(" "), _c('accident-type')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Gender\n        ")]), _vm._v(" "), _c('gender')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Update Discount Rate\n        ")]), _vm._v(" "), _c('update-discount-rate')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "flex-grid__g-7"
  }, [_c('claim-status')], 1), _vm._v(" "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "search_individual_claim"
    }
  }, [_c('button', {
    staticClass: "a-button a-button--small u-no-margin"
  }, [_vm._v("\n                    Load Claim\n                ")])])], 1), _vm._v(" "), _c('individual-search-modal')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "prevent": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "submit", undefined, $event.key, undefined)) { return null; }
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "a-table a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.periods), function(period, periodIndex) {
    return _c('income-period', {
      attrs: {
        "start-disabled": _vm.startDisabled,
        "period": period,
        "index": periodIndex,
        "dependant": _vm.index,
        "maxIndex": _vm.periodsLength,
        "retired": _vm.retired,
        "lossOfEarnings": _vm.lossOfEarnings,
        "type": _vm.type
      },
      on: {
        "update": _vm.updatePeriod
      }
    })
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addIncomePeriod('future')
      }
    }
  }, [_vm._v("\n            Add another period\n        ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Employment Type")]), _vm._v(" "), _c('th', [_vm._v("Total Income per Annum")]), _vm._v(" "), _c('th', [_vm._v("Income Type")]), _vm._v(" "), _c('th', [_vm._v("Total Net Income per Annum")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Delete Period")])])])
}]}

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isVisible()) ? _c('div', [_c('timeline', {
    attrs: {
      "steps": this.steps,
      "current": this.current,
      "stepNo": this.stepNo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content__mob-main-column"
  }, [_c('router-view')], 1)], 1) : _c('div', {
    staticClass: "a-loader--big__container"
  }, [_c('div', {
    staticClass: "a-loader--big"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Assess and analyse reserves on your entire book of claims. Perform predictive analysis to help with IBNR\n        assessments. Changes in IBNR requirements following discount rate changes can be performed in seconds —\n        even for 1000s of claims.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Please select claims and two discount rates to compare Heads of Loss\n    ")]), _vm._v(" "), (_vm.individualClaim) ? _c('div', [_c('individual-search')], 1) : _c('div', [_c('book-of-business-search')], 1), _vm._v(" "), _c('discount-rates'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    attrs: {
      "disabled": _vm.disableCompare
    },
    on: {
      "click": function($event) {
        return _vm.compare()
      }
    }
  }, [_vm._v("Compare")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.loading && _vm.results.count === undefined) ? _c('div', {
    staticClass: "a-loader--results"
  }) : _vm._e(), _vm._v(" "), (_vm.results.count > 0) ? _c('div', {
    staticStyle: {
      "margin": "20px 0 40px"
    }
  }, [_vm._v("\n        Discount Rate Comparison based on " + _vm._s(_vm.results.count) + " matching claims.\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gd-psla-calculator__psla-award"
  }, [_c('h2', [_vm._v(_vm._s(_vm.award.case_name))]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('tr', [_c('td', [_vm._v("Claimant Age at Trial/Deceased Age")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.age_display))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Updated PSLA Award (May 2017)")]), _vm._v(" "), _c('td', {
    staticClass: "c-gd-psla-calculator__award-container u-position-relative"
  }, [_c('div', {
    staticClass: "c-gd-psla-calculator__award"
  }, [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.award.award)) + "\n                    ")]), _vm._v(" "), (_vm.showButtons) ? _c('button', {
    staticClass: "a-button a-button--smaller u-float-r",
    on: {
      "click": function($event) {
        return _vm.usePslaAward(_vm.award.award)
      }
    }
  }, [_vm._v("\n                        Use this PSLA Award\n                    ")]) : _vm._e()])]), _vm._v(" "), (_vm.afterDate) ? _c('tr', [_c('td', [_vm._v("Updated PSLA Award (" + _vm._s(_vm.monthToString(_vm.maxMonth)) + " " + _vm._s(_vm.maxYear) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "c-gd-psla-calculator__award-container u-position-relative"
  }, [_c('div', {
    staticClass: "c-gd-psla-calculator__award"
  }, [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.equivalent)) + "\n                    ")]), _vm._v(" "), (_vm.showButtons) ? _c('button', {
    staticClass: "a-button a-button--smaller u-float-r",
    on: {
      "click": function($event) {
        return _vm.usePslaAward(_vm.equivalent)
      }
    }
  }, [_vm._v("\n                        Use this PSLA Award\n                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Duration of Symptoms")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.duration) + " month" + _vm._s(_vm.award.duration === 1 ? '' : 's'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reduction in Life Expectancy")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.reduction_in_life))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Effects of Injury")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.effects))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gd-psla-calculator__psla-award"
  }, [_c('h2', [_vm._v(_vm._s(_vm.award.case_name))]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('tr', [_c('td', [_vm._v("Claimant Age at Trial/Deceased Age")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.age_display))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Updated PSLA Award (May 2017)")]), _vm._v(" "), _c('td', {
    staticClass: "c-gd-psla-calculator__award-container u-position-relative"
  }, [_c('div', {
    staticClass: "c-gd-psla-calculator__award"
  }, [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.award.award)) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller u-float-r",
    on: {
      "click": function($event) {
        return _vm.usePslaAward(_vm.award.award)
      }
    }
  }, [_vm._v("\n                        Use this PSLA Award\n                    ")])])]), _vm._v(" "), (_vm.afterDate) ? _c('tr', [_c('td', [_vm._v("Updated PSLA Award (" + _vm._s(_vm.monthToString(_vm.maxMonth)) + " " + _vm._s(_vm.maxYear) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "c-gd-psla-calculator__award-container u-position-relative"
  }, [_c('div', {
    staticClass: "c-gd-psla-calculator__award"
  }, [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.equivalent)) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller u-float-r",
    on: {
      "click": function($event) {
        return _vm.usePslaAward(_vm.equivalent)
      }
    }
  }, [_vm._v("\n                        Use this PSLA Award\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Duration of Symptoms")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.duration) + " month" + _vm._s(_vm.award.duration === 1 ? '' : 's'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reduction in Life Expectancy")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.reduction_in_life))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Effects of Injury")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.effects))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs a-form-inputs--table"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('accordion', [_c('general-damages', {
    attrs: {
      "estate-type": "dependency"
    }
  }), _vm._v(" "), _c('past-cost-of-care', {
    attrs: {
      "estate-type": "dependency"
    }
  }), _vm._v(" "), _c('past-cost-of-travel', {
    attrs: {
      "estate-type": "dependency"
    }
  }), _vm._v(" "), _c('past-loss-of-earnings', {
    attrs: {
      "estate-type": "dependency"
    }
  })], 1), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.allValid
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "headsOfLossForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "past_loss_of_services",
      "label": "Past Cost of Services",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfServices),
      expression: "pastCostOfServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "past_loss_of_services",
      "name": "past_loss_of_services",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfServices)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfServices = _vm.pastCostOfServices || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfServices = _vm.pastCostOfServices || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfServices = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_cost_of_travel",
      "label": "Past Cost of Travel",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "past_cost_of_travel",
      "name": "past_cost_of_travel",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "miscellaneous_costs",
      "label": "Miscellaneous - Medication, Appliances, Additional Food & Energy Costs",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "miscellaneous_costs",
      "name": "miscellaneous_costs",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "focus": function($event) {
        _vm.misc = _vm.misc || ''
      },
      "blur": [function($event) {
        _vm.misc = _vm.misc || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.customHeadsOfLoss.length), function(index) {
    return _c('div', [_c('head-of-loss', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin u-r-margin-top-20 u-r-margin-bottom-20",
    on: {
      "click": _vm.addCustomHeadOfLoss
    }
  }, [_vm._v("\n                    Add Another Head of Loss\n                ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Past Cost of Care",
      "tip-text": "You have two options to assess the past cost of care claim.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "200",
      "tip-name": "care"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.careCalcType),
      expression: "careCalcType"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "careCalcType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.careCalcType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateValid]
    }
  }, [_c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])])]), _vm._v(" "), (_vm.careCalcType === 'own') ? _c('control', {
    attrs: {
      "for": "pastCostOfCare",
      "label": "Enter Your Own Figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCare),
      expression: "pastCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pastCostOfCare.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "pastCostOfCare",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "pastCostOfCare",
      "min": "0.00"
    },
    domProps: {
      "value": (_vm.pastCostOfCare)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfCare = _vm.pastCostOfCare || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfCare = _vm.pastCostOfCare || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCare = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pastCostOfCare')
    }
  }, [_vm._v("\n                        Your own care figure should be greater than £0.00\n                    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.periods.length), function(index) {
    return (_vm.careCalcType === 'manual') ? _c('div', [_c('period', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.periods.length >= 0 && _vm.careCalcType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": _vm.addCarePeriod
    }
  }, [_vm._v("\n                    Add Period\n                ")]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "care_total",
      "label": "Care Total",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.pastCostOfCare, '')
    }
  })])], 2)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Calculations\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.getPostInjuryIncomePeriods), function(period, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(period.startOfPeriod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.endOfPeriod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.periodDuration(period).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getPreAccidentNetTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.totalNetIncome)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.periodPaymentsTotal(index))))]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.currencyFormat(_vm.getPreAccidentNetTotal)) + " x " + _vm._s(_vm.periodDuration(period).toFixed(2)) + ") -\n                        (" + _vm._s(_vm.currencyFormat(period.totalNetIncome)) + " x " + _vm._s(_vm.periodDuration(period).toFixed(2)) + ") -\n                        " + _vm._s(_vm.currencyFormat(_vm.periodPaymentsTotal(index))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.periodNetLoss(period, index))))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n                    Total Net Loss\n                ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.totalNetLoss())) + "\n                    ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Pre-Accident"), _c('br'), _vm._v("Annual Income")]), _vm._v(" "), _c('th', [_vm._v("Post Accident"), _c('br'), _vm._v("Annual Income")]), _vm._v(" "), _c('th', [_vm._v("Total Payments")]), _vm._v(" "), _c('th', [_vm._v("Formula")]), _vm._v(" "), _c('th', [_vm._v("Period Net Loss")])])])
}]}

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-mini-calc-icons"
  }, [_c('svg', {
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('svg', {
    attrs: {
      "id": "add",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M116.9 56.9H63.1V3.1C63.1 1.4 61.7 0 60 0s-3.1 1.4-3.1 3.1v53.8H3.1C1.4 56.9 0 58.3 0 60c0 1.7 1.4 3.1 3.1 3.1h53.8v53.8c0 1.7 1.4 3.1 3.1 3.1s3.1-1.4 3.1-3.1V63.1h53.8c1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.1-3.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "apply",
      "viewBox": "0 0 145.3 119.4"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 119.6c-.5 0-1-.1-1.6-.3-1.8-.7-2.8-2.7-2.4-4.5 15-69.5 66.5-82.5 83.7-84.9v-26c0-1.6 1-3.1 2.5-3.7 1.5-.6 3.2-.3 4.4.8l53.5 52.6c.8.8 1.2 1.8 1.2 2.9 0 1.1-.4 2.1-1.2 2.9L90.6 112c-1.1 1.1-2.9 1.5-4.4.8-1.5-.6-2.5-2.1-2.5-3.7V82.5h-.2c-14.8 0-55 3.1-76.3 35.3-.6 1.2-1.9 1.8-3.2 1.8zm79.7-45.1c1.8 0 3.3 0 4.3.1 2.1.1 3.8 1.9 3.8 4v20.9l43.8-43.1-43.8-43v20c0 2.1-1.6 3.8-3.7 4-9.8.8-55.8 7.7-75.3 61.7C37 77 70.3 74.5 83.7 74.5z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "delete",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M109.1 11.3H76.9V5.6c0-3.1-2.5-5.6-5.6-5.6H48.8c-3.1 0-5.6 2.5-5.6 5.6v5.7H10.9c-1.6 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8h5.2l3.6 92.9c.2 5.7 4.9 10.1 10.5 10.1h59.5c5.7 0 10.3-4.5 10.5-10.1l3.6-92.9h5.2c1.6 0 2.8-1.3 2.8-2.8.1-1.5-1.2-2.8-2.7-2.8zM48.8 5.6h22.4v5.6H48.8V5.6zm45.9 104c-.1 2.6-2.3 4.7-4.9 4.7H30.3c-2.6 0-4.8-2.1-4.9-4.7l-3.6-92.7h76.4l-3.5 92.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M42.8 42.6c0-1.5-1.3-2.8-2.8-2.8-1.6 0-2.8 1.3-2.8 2.9l.9 46.1c0 1.5 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.9l-.9-46.1zM60 39.8c-1.6 0-2.8 1.3-2.8 2.8v46.1c0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8V42.6c0-1.6-1.2-2.8-2.8-2.8zM80.1 39.8c-1.5 0-2.9 1.2-2.9 2.8l-.9 46.1c0 1.6 1.2 2.8 2.8 2.9 1.5 0 2.8-1.2 2.8-2.8l.9-46.1c.1-1.6-1.1-2.9-2.7-2.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "edit",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M16.3 120l-5.4-31.5 59-83.1c2-2.8 4.9-4.6 8.3-5.2 3.4-.6 6.7.2 9.5 2.2l16.2 11.5c2.8 2 4.6 4.9 5.2 8.3.6 3.4-.2 6.7-2.2 9.5l-59 83.1-31.6 5.2zm1.6-29.9l3.8 22.3 22.3-3.8 57.4-80.9c.9-1.3 1.3-2.9 1-4.6-.3-1.6-1.2-3-2.5-4L83.8 7.7c-1.3-.9-2.9-1.3-4.6-1-1.6.3-3 1.2-4 2.5L17.9 90.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "toggle",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M102 52c-.8 0-1.5-.3-2.1-.9L60 11.3 20.2 51.1c-1.2 1.2-3.1 1.2-4.2 0-1.2-1.2-1.2-3.1 0-4.2L60 2.8l44.1 44.1c1.2 1.2 1.2 3.1 0 4.2-.6.6-1.4.9-2.1.9zM60 117.2L15.9 73.1c-1.2-1.2-1.2-3.1 0-4.2 1.2-1.2 3.1-1.2 4.2 0L60 108.7l39.8-39.8c1.2-1.2 3.1-1.2 4.2 0 1.2 1.2 1.2 3.1 0 4.2l-44 44.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "filter",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 120c-9.4 0-16.5-4-16.5-9.2V75.3L0 31.6V20C0 7 30.9 0 60 0s60 7.1 60 20.2v11.6L76.5 75.3v35.5c0 5.2-7.1 9.2-16.5 9.2zM3.9 30l43.5 43.7v37.1c0 2.5 5.4 5.3 12.6 5.3s12.6-2.8 12.6-5.3V73.7l43.5-43.5v-10C116.1 12.5 93 3.9 60 3.9S3.9 12.4 3.9 20v10z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M59.9 37.3c-13 0-25.3-1.6-34.6-4.4-4.5-1.3-8.3-2.9-10.9-4.5-1.8-1.1-2.8-2.1-3.3-2.6L10 24.7l.9-1.3c.6-.9 1.9-2 3.6-3 2.7-1.6 6.4-3.1 10.8-4.5 9.9-2.8 22.2-4.4 34.6-4.4 13 0 25.3 1.6 34.6 4.4 4.5 1.3 8.3 2.9 10.9 4.5 1.8 1.1 2.8 2.1 3.3 2.6l1.4 1.4-1.4 1.4c-.5.5-1.5 1.5-3.3 2.6-2.7 1.6-6.4 3.2-10.8 4.5-10 2.9-22.3 4.4-34.7 4.4zM15.4 24.4c.3.2.7.5 1.1.8 2.2 1.4 5.7 2.9 9.9 4.1 9 2.7 20.9 4.2 33.5 4.2 12.1 0 24-1.5 33.5-4.2 4.1-1.3 7.5-2.7 9.9-4.1.4-.2.7-.5 1-.7-.3-.2-.7-.5-1.1-.7-2.2-1.4-5.7-2.9-9.9-4.1-9-2.7-20.9-4.2-33.5-4.2-12.1 0-24 1.5-33.5 4.2-4.1 1.3-7.5 2.7-9.9 4.1-.4.2-.7.4-1 .6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "load",
      "viewBox": "0 0 145.3 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M143.8 37.1c-1.6-2.7-4.2-4.2-7.2-4.2h-13.1V13.2c0-7.3-5-13.2-11-13.2H11.1C5 0 .1 5.9.1 13.2v95.3c-.3 2.7.2 5.3 1.5 7.3 1.6 2.6 4.2 4.2 7.2 4.2h104c5.6 0 11.5-5.1 13.4-11.6l18.4-61.1c1.1-3.7.8-7.5-.8-10.2zM11.1 8.2h101.3c2.3 0 4.2 2.2 4.2 5v19.7H31.8c-5.6 0-11.5 5.1-13.4 11.7L6.9 84V13.2c0-2.8 1.9-5 4.2-5zm127.1 36.3l-18.4 61.1c-1 3.3-4.3 6.2-7 6.2H8.8c-.5 0-1.3-.1-1.6-.7-.4-.6-.4-1.6 0-2.8L25 47.2c.9-3.2 4.2-6.2 6.9-6.2h104.8c.5 0 1.3.1 1.6.7.2.6.2 1.7-.1 2.8z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "locked",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85.7 33.8h-6V17.4C79.7 7.8 71.9 0 62.3 0h-4.6c-9.6 0-17.4 7.8-17.4 17.4v16.3h-6c-9.6 0-17.4 7.8-17.4 17.4v51.4c0 9.6 7.8 17.4 17.4 17.4h51.4c9.6 0 17.4-7.8 17.4-17.4V51.2c0-9.6-7.8-17.4-17.4-17.4zM45.5 17.4c0-6.7 5.5-12.2 12.2-12.2h4.6c6.7 0 12.2 5.5 12.2 12.2v16.3h-29V17.4zm52.4 85.2c0 6.7-5.5 12.2-12.2 12.2H34.3c-6.7 0-12.2-5.5-12.2-12.2V51.2c0-6.7 5.5-12.2 12.2-12.2h51.4c6.7 0 12.2 5.5 12.2 12.2v51.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 64.6c-6.8 0-12.3 5.5-12.3 12.3 0 6.8 5.5 12.3 12.3 12.3 6.8 0 12.3-5.5 12.3-12.3 0-6.8-5.5-12.3-12.3-12.3zM60 84c-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1c0 3.9-3.2 7.1-7.1 7.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "minus",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M116.9 63.1H3.1C1.4 63.1 0 61.7 0 60c0-1.7 1.4-3.1 3.1-3.1h113.8c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "print",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.4 39.6H22.6V.3h74.8v39.3zm-69.8-4.9h64.9V5.3H27.6v29.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M99.2 108.3h-6.7V73H27.6v35.3h-6.7C9.3 108.3 0 99 0 87.5v-32C0 44 9.3 34.7 20.8 34.7h78.4c11.5 0 20.8 9.3 20.8 20.8v32c0 11.5-9.3 20.8-20.8 20.8zm-1.8-4.9h1.8c8.8 0 15.9-7.1 15.9-15.9v-32c0-8.8-7.1-15.9-15.9-15.9H20.8c-8.8 0-15.9 7.1-15.9 15.9v32c0 8.8 7.1 15.9 15.9 15.9h1.8V68.1h74.8v35.3z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M2.5 56h115.1v4.9H2.5zM97.4 119.7H22.6V68.1h74.8v51.6zm-69.8-5h64.9V73H27.6v41.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85 90.4H35c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h50c1.4 0 2.5 1.1 2.5 2.5s-1.2 2.5-2.5 2.5zM63.2 102.3H35c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h28.1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.4 2.5z"
    }
  }), _c('g', [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "94",
      "cy": "47.9",
      "r": "3.8"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "refresh",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M118.4 27.7c-1.3-.5-2.7.2-3.2 1.5L111 40.4c-4.5-13.1-13.7-23.8-26.1-30-12.5-6.3-26.8-7.4-40.1-3C22.9 14.6 8.1 35.8 8.7 58.9c0 1.4 1.2 2.4 2.5 2.4h.1c1.4 0 2.5-1.2 2.4-2.6-.6-20.9 12.8-40 32.6-46.5 12.1-4 24.9-3 36.3 2.7 11.3 5.7 19.8 15.5 23.7 27.6.1.2.1.3.2.5l-11.8-4.3c-1.3-.5-2.7.2-3.2 1.5s.2 2.7 1.5 3.2l17.2 6.3c.3.1.6.2.9.2.4 0 .7-.1 1.1-.2.6-.3 1.1-.8 1.3-1.4l6.3-17.2c.5-1.5-.1-2.9-1.4-3.4zM109.6 44h.1-.1zM108.7 58.7c-1.4 0-2.5 1.2-2.4 2.6.6 20.9-12.8 40-32.6 46.5-24.9 8.2-51.8-5.4-60-30.3-.1-.2-.1-.3-.2-.5l11.8 4.3c1.3.5 2.7-.2 3.2-1.5s-.2-2.7-1.5-3.2L9.7 70.4c-1.3-.5-2.7.2-3.2 1.5L.2 89.1c-.5 1.3.2 2.7 1.5 3.2.3.1.6.2.9.2 1 0 2-.6 2.4-1.6l4-11.3c7.4 21.8 27.9 35.7 49.8 35.7 5.4 0 11-.9 16.4-2.6 21.9-7.2 36.8-28.4 36.1-51.4-.1-1.5-1.2-2.6-2.6-2.6zM10.3 76c.1 0 0 0 0 0z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "search",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M119.1 113.6L89.4 85.1c8.1-9.5 12.4-21.5 12.1-34.1-.3-13.6-5.9-26.2-15.6-35.6-9.8-9.3-22.7-14.3-36.3-14-13.5.3-26.2 5.9-35.5 15.7-19.4 20.2-18.7 52.4 1.5 71.7 9.8 9.4 22.5 14.1 35.1 14.1 12.5 0 24.9-4.6 34.6-13.6l29.7 28.5c.6.5 1.3.8 2 .8.8 0 1.5-.3 2.1-.9 1.2-1.2 1.2-3 0-4.1zM19.6 84.7C1.7 67.5 1.1 39 18.3 21.1c8.3-8.7 19.5-13.6 31.5-13.9h1c11.6 0 22.6 4.4 31.1 12.5 17.9 17.1 18.5 45.7 1.4 63.6-17.2 17.9-45.7 18.5-63.7 1.4z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "summary",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M48.4 120h61.2V0H10.4v81.5m36 24.9l-22.7-23h22.7v23zm55.3 5.7H54.3V75.6h-36V7.9h83.5v104.2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M84.5 31.1h-49c-2.2 0-4-1.8-4-4s1.8-4 4-4h49.1c2.2 0 4 1.8 4 4s-1.9 4-4.1 4zM84.5 47.9h-49c-2.2 0-4-1.8-4-4s1.8-4 4-4h49.1c2.2 0 4 1.8 4 4s-1.9 4-4.1 4z"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-30 u-margin-bottom-30"
  }, [_vm._v("\n        Losses for Care\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_loss_of_care",
      "label": "Would you like to make a claim for care?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossOfCare),
      expression: "futureLossOfCare"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_loss_of_care",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossOfCare = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.futureLossOfCare) ? _c('div', [_vm._l((_vm.care), function(period, periodIndex) {
    return _c('div', [_c('futureCarePeriod', {
      attrs: {
        "index": periodIndex,
        "care": period
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addCare
    }
  }, [_vm._v("Add Care Period")])], 2) : _vm._e(), _vm._v(" "), (_vm.futureLossOfCare && _vm.futureLossOfCareValid) ? _c('div', [_c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-top-50"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.care), function(period) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(period.careStartDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.careEndDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.duration, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.multiplier, 2)))]), _vm._v(" "), _c('td', [_c('tr', [_c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0px"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(period.futureCareTotal)) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0 0 0 10px"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.toggleModal(period)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'calculation_' + _vm.uniqueId,
        "tooltip-text": "Click to view calculation",
        "side": "left",
        "text-width": "140",
        "icon-type": "formula"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.careTotal)))])])])])]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'calculation_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date from")]), _vm._v(" "), _c('th', [_vm._v("Date to")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Future Care Loss")])])])
}]}

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-executive-dashboard__chart trend-charts"
  }, [(_vm.loadingContent) ? _c('div', {
    staticClass: "a-loader--chart u-full-width"
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingContent && !_vm.hasResults) ? _c('div', {
    staticClass: "p-executive-dashboard__chart__no-results"
  }, [_c('p', [_vm._v("Your search returned no results.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "trend-charts__line"
  }, [(!_vm.loadingContent && _vm.hasResults) ? _c('line-chart', {
    attrs: {
      "chart-data": _vm.lineChartData,
      "options": _vm.lineChartOptions,
      "width": 900
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "trend-charts__legend u-full-width"
  }, [(_vm.showing !== 'total' && _vm.diseaseTypeSelected || !_vm.diseaseTypeSelected) ? _c('chart-legend', {
    attrs: {
      "columns": 3,
      "values": _vm.lineChartLabels,
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "60"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "u-margin-top-20"
  }, [_c('option-filters', [_c('li', {
    class: {
      'm-option-filters--active': _vm.period === 'month'
    },
    on: {
      "click": function($event) {
        return _vm.updateTrendsInReservesPeriod('month')
      }
    }
  }, [_vm._v("\n                        Month\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.period === 'quarter'
    },
    on: {
      "click": function($event) {
        return _vm.updateTrendsInReservesPeriod('quarter')
      }
    }
  }, [_vm._v("\n                        Quarter\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.period === 'year'
    },
    on: {
      "click": function($event) {
        return _vm.updateTrendsInReservesPeriod('year')
      }
    }
  }, [_vm._v("\n                        Year\n                    ")])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_vm._v("\n        " + _vm._s(_vm.data.formula) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "a-form-inputs--error"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])])
},staticRenderFns: []}

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Payment ' + (_vm.index + 1) + ' Date',
      "no-flex-margin": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "date",
      "required": ""
    },
    on: {
      "input": _vm.updateInterest
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidDate() || _vm.$error('date')
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY and must be after the date of injury/accident\n            " + _vm._s(_vm.dateOfInjury) + "\n        ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isBeforeInterestDate()
    }
  }, [_vm._v("\n            Date must be before interest date (" + _vm._s(_vm.interestDate) + ")\n        ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Amount",
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "name": "value",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": [function($event) {
        _vm.value = _vm.value || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = _vm._n($event.target.value)
      }, _vm.updateInterest]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            The amount must be at least £1.00.\n        ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisPayment
    }
  }, [_vm._v("Delete This Payment")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Female"
    }
  }, [_vm._v("Female")])])
},staticRenderFns: []}

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "summary-heading"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimInfoForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "name": "claim_status",
      "label": "Status:"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.active),
      expression: "active"
    }],
    attrs: {
      "name": "claimStatus",
      "id": "claim_status",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.active = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Closed")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "open_date",
      "label": "Open Date:"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:open_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "open_date",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.openDate),
      callback: function($$v) {
        _vm.openDate = $$v
      },
      expression: "openDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('open_date')
    }
  }, [_vm._v("\n                        The Open Date is required\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [(!_vm.active) ? _c('control', {
    attrs: {
      "for": "closed_date",
      "label": "Closed Date:"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:closed_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "closed_date",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.closeDate),
      callback: function($$v) {
        _vm.closeDate = $$v
      },
      expression: "closeDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('closed_date')
    }
  }, [_vm._v("\n                        The Closed Date is required\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.closedDateRules
    }
  }, [_vm._v("\n                        The Closed Date must be after the Open Date\n                    ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.active) ? _c('control', {
    attrs: {
      "for": "claim_outcome",
      "label": "Outcome:"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.outcome),
      expression: "outcome"
    }],
    attrs: {
      "name": "claimOutcome",
      "id": "claim_outcome",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.outcome = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Paid"
    }
  }, [_vm._v("Paid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Defended"
    }
  }, [_vm._v("Defended")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claim_outcome')
    }
  }, [_vm._v("\n                        The Outcome is required\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "flex-grid__g-2 flex-grid--input-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-7"
  }, [_c('button', {
    staticClass: "a-button a-button--no-margin",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.showBack) ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    on: {
      "click": function($event) {
        return _vm.close('showAllSummary')
      }
    }
  }, [_vm._v("Back")]) : _vm._e()])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "bell-chart"
  }, [_c('svg', {
    ref: "svg",
    attrs: {
      "height": _vm.height,
      "width": _vm.width
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap u-margin-bottom-40"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n                Claim Status\n            ")]), _vm._v(" "), _c('claim-status')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n                Claim Type\n            ")]), _vm._v(" "), _c('claim-type')], 1), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n                Disease or Accident\n            ")]), _vm._v(" "), _c('disease-or-accident')], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n                Disease Type\n            ")]), _vm._v(" "), _c('disease-type')], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident' || _vm.claimType === 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n                Accident Type\n            ")]), _vm._v(" "), _c('accident-type')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n                Set Date Range\n            ")]), _vm._v(" "), _c('dates')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n                Reserve Value\n            ")]), _vm._v(" "), _c('reserve-value')], 1), _vm._v(" "), (_vm.reserveValue === 'own') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n                Reserve Range\n            ")]), _vm._v(" "), _c('reserve-range')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', [_vm._v("You can search the claims below to further filter your results:")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin-slight a-form-inputs p-compare-reserve__search-buttons"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.doSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.doReset
    }
  }, [_vm._v("Reset")])])])
},staticRenderFns: []}

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_vm._m(0), _vm._v(" "), (_vm.interimPayments.length === 0) ? _c('p', [_vm._v("\n                Add details of any Interim Payments using the button below:\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.interimPayments), function(interimPayment, index) {
    return _c('div', {
      staticClass: "dependant a-form-inputs--section"
    }, [_c('payment', {
      attrs: {
        "index": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addPayment
    }
  }, [_vm._v("Add Interim Payment")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "a-form-inputs"
  }, [_vm._m(1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Calculate Interest Rates to"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestType),
      expression: "interestType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcInterestValue]
    }
  }, [_c('option', {
    attrs: {
      "value": "today"
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_settlement"
    }
  }, [_vm._v("Assumed Settlement")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Custom")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Do Not Calculate")])])]), _vm._v(" "), (_vm.interestType === 'custom') ? _c('control', {
    attrs: {
      "label": "Custom date",
      "for": "custom_interest_date"
    }
  }, [_c('date-input', {
    on: {
      "input": _vm.calcInterestValue
    },
    model: {
      value: (_vm.customInterestDate),
      callback: function($$v) {
        _vm.customInterestDate = $$v
      },
      expression: "customInterestDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidDate()
    }
  }, [_vm._v("\n                        Date is required, must be in the format DD/MM/YYYY, be after the deceased's date of death\n                        (" + _vm._s(_vm.deceasedDod) + ")\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('div', {
    staticClass: "m-div-table__holder m-div-table__holder--less-margin"
  }, [_c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastDependencyOnIncomeInterest'),
      "option": {
        name: 'pastDependencyOnIncome'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastDependencyOnIncomeWithInterest'),
      "tip-name": "past_dependency_on_income",
      "title": "Past Dependency on Income",
      "updates": "pastDependencyOnIncomeInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastDependencyOnServicesInterest'),
      "option": {
        name: 'pastDependencyOnServices'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastDependencyOnServicesWithInterest'),
      "tip-name": "past_dependency_on_services",
      "title": "Past Dependency on Services",
      "updates": "pastDependencyOnServicesInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.value('generalDamagesInterest'),
      "option": {
        name: 'generalDamages'
      },
      "payload": _vm.payload,
      "unique-id": _vm.uniqueId,
      "value": _vm.value('generalDamagesWithInterest'),
      "tip-name": "general_damages_psla",
      "title": "General damages (PSLA)",
      "updates": "generalDamages"
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('bereavementAwardInterest'),
      "option": {
        name: 'bereavementAward'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('bereavementAwardWithInterest'),
      "tip-name": "bereavement_award",
      "title": "Bereavement Award",
      "updates": "bereavementAwardInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('funeralExpensesInterest'),
      "option": {
        name: 'funeralExpenses'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('funeralExpensesWithInterest'),
      "tip-name": "funeral_expenses",
      "title": "Funeral Expenses",
      "updates": "funeralExpensesInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('lossOfSpouseInterest'),
      "option": {
        name: 'lossOfSpouse'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('lossOfSpouseWithInterest'),
      "tip-name": "loss_of_spouse",
      "title": "Loss of Spouse",
      "updates": "lossOfSpouseInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastLossOfEarningsInterest'),
      "option": {
        name: 'pastLossOfEarnings'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastLossOfEarningsWithInterest'),
      "tip-name": "past_loss_of_earnings",
      "title": "Past Loss of Earnings",
      "updates": "pastLossOfEarningsInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastCostOfCareInterest'),
      "option": {
        name: 'pastCostOfCare'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastCostOfCareWithInterest'),
      "tip-name": "past_cost_of_care",
      "title": "Past Cost of Care",
      "updates": "pastCostOfCareInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastCostOfTravelInterest'),
      "option": {
        name: 'pastCostOfTravel'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastCostOfTravelWithInterest'),
      "tip-name": "past_cost_of_travel",
      "title": "Past Cost of Travel",
      "updates": "pastCostOfTravelInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('miscInterest'),
      "option": {
        name: 'misc'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('miscWithInterest'),
      "tip-name": "miscellaneous",
      "title": "Miscellaneous",
      "updates": "miscInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _vm._l((_vm.headsOfLoss), function(headOfLoss, key) {
    return _c('interest-item', {
      attrs: {
        "payload": _vm.payload,
        "interest": headOfLoss.interest,
        "option": {
          name: headOfLoss.name,
          key: key
        },
        "title": headOfLoss.name,
        "unique-id": _vm.uniqueId,
        "updates": key,
        "value": headOfLoss.interestAccrued,
        "tip-name": headOfLoss.name
      },
      on: {
        "update": _vm.onUpdateCustom
      }
    })
  })], 2), _vm._v(" "), _c('br')])], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.$valid() && _vm.allInterimPaymentsValid
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'interest_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n                    Interim Payments\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n                        Interest\n                    ")])])
}]}

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "p-executive-dashboard__summary"
  }, [_vm._v("\n        Our Executive Dashboard provides a snapshot of key quantum and reserving data on your book of business."), _c('br'), _c('br'), _vm._v("\n        You can drill down into your live and concluded claims data.\n    ")])])
}]}

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Dependency on Income — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is determined from the deceased's date of death to the deceased's 'but for' date of\n        death.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        For earnings, the multiplicand is assessed using (i) your selected annual gross income for the deceased\n        (converted to Net equivalent by the tool), (ii) assumes the dependent has no income, and (iii) applies\n        the standard dependency formula for assessing the multiplicand dependent on the number of dependents.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Retirement is assumed at age 65. Thereafter a pension dependency multiplicand of £10,000 is applied.\n        This is broadly assessed using data within the UK Government Statistics on Pensions — \n        "), _c('a', {
    attrs: {
      "href": "https://www.gov.uk/government/statistics/pensioners-incomes-series-financial-year-201516",
      "target": "_blank"
    }
  }, [_vm._v("\n            https://www.gov.uk/government/statistics/pensioners-incomes-series-financial-year-201516\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        The period between death and assumed date of trial/settlement is \n        discounted by Table E Factor. The multiplier is applied from date of\n        trial/assumed settlement but discounted by Table F Factor.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dropdown', {
    attrs: {
      "name": "name",
      "is-a-dropdown": true,
      "button-name": "Create a new claim"
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.newFatalDependencyClaim
    }
  }, [_vm._v("Fatal Accident Dependency")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.newFatalEstateClaim
    }
  }, [_vm._v("Fatal Accident Estate")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.newLostClaim
    }
  }, [_vm._v("Lost Years")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.newPersonalClaim
    }
  }, [_vm._v("Personal Injury")])])])
},staticRenderFns: []}

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-formula__container"
  }, [(_vm.innerMultiplicand.method === 'multiplicand_percentage') ? _c('control', {
    attrs: {
      "label": "Enter percentage",
      "for": "own_total_figure",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerMultiplicand.percentage),
      expression: "innerMultiplicand.percentage"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "max": "100",
      "min": "1"
    },
    domProps: {
      "value": (_vm.innerMultiplicand.percentage)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerMultiplicand, "percentage", $event.target.value)
      }, _vm.updateMultiplicand]
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.innerMultiplicand.method === 'multiplicand_percentage' ||
    _vm.innerMultiplicand.method === 'multiplicand_default') ? _c('div', {
    staticClass: "flex-grid m-formula"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-grid m-formula__item--row"
  }, [(!_vm.hasMultipleDependants && _vm.innerMultiplicand.method === 'multiplicand_default') ? _c('p', [_vm._v("2/3 x [ ")]) : _vm._e(), _vm._v(" "), (_vm.hasMultipleDependants && _vm.innerMultiplicand.method === 'multiplicand_default') ? _c('p', [_vm._v("75% x [ ")]) : _vm._e(), _vm._v(" "), (_vm.innerMultiplicand.method === 'multiplicand_percentage') ? _c('p', [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.innerMultiplicand.percentage
    }
  }), _vm._v("% x [\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.theDeceasedNetIncome
    }
  })]), _vm._v(" "), _c('p', [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.dependantsNetIncome
    }
  })]), _vm._v(" "), _c('p', [_vm._v("] -")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.dependantsNetIncome
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid m-formula__item--row"
  }, [_c('p', [_vm._v("Total =")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    staticClass: "a-form-inputs--readonly",
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.innerMultiplicand.total
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.innerMultiplicand.method === 'multiplicand_pounds') ? _c('control', {
    attrs: {
      "label": "Enter own dependency in £",
      "for": "own_total_figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerMultiplicand.user),
      expression: "innerMultiplicand.user"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerMultiplicand.user)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerMultiplicand, "user", $event.target.value)
      }, _vm.updateMultiplicand]
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid m-formula__item--row"
  }, [_c('b', [_vm._v("Dependency Formula")])])
}]}

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Funeral Expenses — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is based on an average from claims of a similar type. Where there is insufficient\n        data within the tool to derive an average a figure of £5,000 is applied.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Loss of Earnings\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Disability Working Allowance",
      "store-key": "ploeDisabilityWorkingAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Employment and Support Allowance",
      "store-key": "ploeEmploymentSupportAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Incapacity Benefit",
      "store-key": "ploeIncapacityBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Income Support",
      "store-key": "ploeIncomeSupport"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Industrial Injuries Disablement Benefit",
      "store-key": "ploeIndustrialInjuriesDisablementBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Invalidity Pension",
      "store-key": "ploeInvalidityPension"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Invalidity Allowance",
      "store-key": "ploeInvalidityAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Jobseeker’s Allowance",
      "store-key": "ploeJobseekersAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Reduced Earnings Allowance",
      "store-key": "ploeReducedEarningsAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Severe Disablement Allowances",
      "store-key": "ploeSevereDisablementAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Sickness Benefit",
      "store-key": "ploeSicknessBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Statutory Sick Pay paid before 6 April 1994",
      "store-key": "ploeStatutorySickPay"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Unemployability Supplement",
      "store-key": "ploeUnemployabilitySupplement"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Unemployment Benefit",
      "store-key": "ploeUnemploymentBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Universal Credit",
      "store-key": "ploeUniversalCredit",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto p-interest__calc"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Interest Calculator",
      "icon": "interest"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_from",
      "label": "Date From"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_from.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_from",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateFrom",
    on: {
      "input": function($event) {
        return _vm.updateTotal()
      }
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_from')
    }
  }, [_vm._v("\n                    The date from is required and must be in the format DD/MM/YYYY\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_to",
      "label": "Date To"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_to.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_to",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateTo",
    on: {
      "input": function($event) {
        return _vm.updateTotal()
      }
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_to') || !_vm.dateRules
    }
  }, [_vm._v("\n                    The date to is required and must be in the format DD/MM/YYYY\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "interest_rate",
      "label": "Interest Rate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.interestRate),
      expression: "interestRate",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "interestRate",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "name": "interest_rate",
      "type": "number"
    },
    domProps: {
      "value": (_vm.interestRate)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.interestRate = _vm._n($event.target.value)
      }, function($event) {
        return _vm.updateTotal()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('interest_rate')
    }
  }, [_vm._v("\n                    The Interest Rate must be greater than 0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "principal_amount",
      "label": "Principal Amount",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.principalAmount),
      expression: "principalAmount",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "principalAmount",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "name": "value",
      "type": "number"
    },
    domProps: {
      "value": (_vm.principalAmount)
    },
    on: {
      "focus": function($event) {
        _vm.principalAmount = _vm.principalAmount || ''
      },
      "blur": [function($event) {
        _vm.principalAmount = _vm.principalAmount || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.principalAmount = _vm._n($event.target.value)
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('principal_amount')
    }
  }, [_vm._v("\n                    The Amount must be greater than £0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "interest_type",
      "label": "Interest Type"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.interestType),
      expression: "interestType"
    }],
    ref: "interestType",
    attrs: {
      "required": "",
      "name": "interest_type"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "simple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "compound"
    }
  }, [_vm._v("Compound")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('interest_type')
    }
  }, [_vm._v("\n                    Please select an Interest Type\n                ")])], 1), _vm._v(" "), (_vm.interestType === 'compound') ? _c('control', {
    attrs: {
      "for": "compound_frequency",
      "label": "Compound Frequency"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.compoundFrequency),
      expression: "compoundFrequency"
    }],
    ref: "compoundFrequency",
    attrs: {
      "required": "",
      "name": "compound_frequency"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.compoundFrequency = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateTotal()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "52"
    }
  }, [_vm._v("Weekly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Monthly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Quarterly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Yearly")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('compound_frequency')
    }
  }, [_vm._v("\n                    Please select a Compound Frequency\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Results\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "interest_accrued",
      "label": "Interest Accrued",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.interestAccrued),
      expression: "interestAccrued",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "name": "interest_accrued"
    },
    domProps: {
      "value": (_vm.interestAccrued)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.interestAccrued = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "theTotal",
      "label": "Total",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.theTotal),
      expression: "theTotal",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "name": "theTotal"
    },
    domProps: {
      "value": (_vm.theTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.theTotal = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The accrued interest between the period of "), _c('strong', [_vm._v(_vm._s(_vm.dateFrom))]), _vm._v(" and "), _c('strong', [_vm._v(_vm._s(_vm.dateTo))]), _vm._v("\n                on the principal of "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.principalAmount)))]), _vm._v(", with an interest rate of\n                "), _c('strong', [_vm._v(_vm._s(_vm.interestRate) + "%")]), _vm._v(",\n                using\n                "), (_vm.interestType === 'compound') ? _c('span', [_vm._v("the "), _c('strong', [_vm._v("compound")]), _vm._v(" interest calculation with\n                    compounding occurring "), _c('strong', [_vm._v(_vm._s(_vm.frequency))])]) : _c('span', [_vm._v("the "), _c('strong', [_vm._v("simple")]), _vm._v(" interest calculation")]), _vm._v("\n                is calculated using the following formula:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [(_vm.interestType === 'compound') ? _c('span', [_vm._v("\n                            [£ Total] = [£ Principal (1 + [Interest Rate %]/[Periods])[Periods] * [Duration]\n                        ")]) : _c('span', [_vm._v("\n                            [£ Total] = [£ Principal] x [1 + Interest Rate %] x [Duration]\n                        ")])])])]), _vm._v(" "), (_vm.interestType === 'compound') ? _c('p', [_vm._v("\n                Where "), _c('strong', [_vm._v("duration")]), _vm._v(" is the accrual length in years and "), _c('strong', [_vm._v("periods")]), _vm._v(" is the\n                number of\n                compounding periods that occur each year (e.g., compounding quarterly results in 4 periods per\n                year).\n            ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n                This results in "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestAccrued)))]), _vm._v(" of interest having been\n                accrued,\n                resulting in a total figure of "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.theTotal)))]), _vm._v(". This has been\n                displayed\n                on the following graph for you:\n            ")]), _vm._v(" "), (_vm.theTotal) ? _c('div', {
    staticClass: "chart chart--bar"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-interest__calc-results-group"
  }, [_c('div', [_vm._v("Aggregate Rate: "), _c('span', [_vm._v(_vm._s(_vm.roundValue(_vm.aggregateRate / 100, 2)) + "%")])]), _vm._v(" "), _c('div', [_vm._v("Number of Days: "), _c('span', [_vm._v(_vm._s(_vm.noOfDays))])]), _vm._v(" "), _c('div', [_vm._v("Interest per day: "), _c('span', [_vm._v(_vm._s(_vm.currencyFormat(_vm.dailyRate)))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tooltipText || _vm.theCurrentWidth > 1024) ? _c('div', {
    staticClass: "u-d-flex",
    class: {
      'u-r-flex-wrap': _vm.isRouteByName('mini-calculators')
    }
  }, [_c('div', {
    staticClass: "c-icon-tooltip__container",
    class: [_vm.tooltipName, _vm.iconType],
    style: ({
      width: _vm.containerWidth + _vm.pixelOrPercent
    }),
    on: {
      "mouseover": _vm.iconEnter,
      "mouseleave": _vm.iconLeave
    }
  }, [(!_vm.noIcon && _vm.tooltipText) ? _c('svg', {
    staticClass: "m-icon m-icon--small m-icon--no-hover open",
    class: _vm.iconColour,
    style: (_vm.hoverStyle),
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.iconType
    }
  })]) : _c('svg', {
    staticClass: "m-icon m-icon--small m-icon--no-hover open",
    class: _vm.iconColour,
    style: (_vm.hoverStyle),
    attrs: {
      "focusable": "false",
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.iconType
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tooltipVisible),
      expression: "tooltipVisible"
    }],
    staticClass: "c-icon-tooltip__text",
    class: 'c-icon-tooltip__' + _vm.side,
    style: ({
      width: _vm.textWidth + 'px'
    })
  }, [_vm._v("\n            " + _vm._s(_vm.tooltipText) + "\n        ")]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "c-icon-tooltip__responsive-text"
  }, [_vm._v(_vm._s(_vm.tooltipText))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "summary-heading"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "damagesReserve",
      "label": "Damages Reserve:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.damagesReserve),
      expression: "damagesReserve",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "damagesReserve",
      "id": "damagesReserve",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.damagesReserve)
    },
    on: {
      "focus": function($event) {
        _vm.damagesReserve = _vm.damagesReserve || ''
      },
      "blur": [function($event) {
        _vm.damagesReserve = _vm.damagesReserve || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.damagesReserve = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "thirdPartyReserve",
      "label": "Third Party Costs Reserve:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.thirdPartyReserve),
      expression: "thirdPartyReserve",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "thirdPartyReserve",
      "id": "thirdPartyReserve",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.thirdPartyReserve)
    },
    on: {
      "focus": function($event) {
        _vm.thirdPartyReserve = _vm.thirdPartyReserve || ''
      },
      "blur": [function($event) {
        _vm.thirdPartyReserve = _vm.thirdPartyReserve || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thirdPartyReserve = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "defenceCostsReserve",
      "label": "Defence Costs Reserve:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.defenceCostsReserve),
      expression: "defenceCostsReserve",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "defenceCostsReserve",
      "id": "defenceCostsReserve",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.defenceCostsReserve)
    },
    on: {
      "focus": function($event) {
        _vm.defenceCostsReserve = _vm.defenceCostsReserve || ''
      },
      "blur": [function($event) {
        _vm.defenceCostsReserve = _vm.defenceCostsReserve || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defenceCostsReserve = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "paidDamages",
      "label": "Paid Damages:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.paidDamages),
      expression: "paidDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "paidDamages",
      "id": "paidDamages",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.paidDamages)
    },
    on: {
      "focus": function($event) {
        _vm.paidDamages = _vm.paidDamages || ''
      },
      "blur": [function($event) {
        _vm.paidDamages = _vm.paidDamages || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paidDamages = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "paidThirdPartyCosts",
      "label": "Paid Third Party Costs:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.paidThirdPartyCosts),
      expression: "paidThirdPartyCosts",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "paidThirdPartyCosts",
      "id": "paidThirdPartyCosts",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.paidThirdPartyCosts)
    },
    on: {
      "focus": function($event) {
        _vm.paidThirdPartyCosts = _vm.paidThirdPartyCosts || ''
      },
      "blur": [function($event) {
        _vm.paidThirdPartyCosts = _vm.paidThirdPartyCosts || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paidThirdPartyCosts = _vm._n($event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "paidDefenceCosts",
      "label": "Paid Defence Costs:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.paidDefenceCosts),
      expression: "paidDefenceCosts",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "paidDefenceCosts",
      "id": "paidDefenceCosts",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.paidDefenceCosts)
    },
    on: {
      "focus": function($event) {
        _vm.paidDefenceCosts = _vm.paidDefenceCosts || ''
      },
      "blur": [function($event) {
        _vm.paidDefenceCosts = _vm.paidDefenceCosts || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paidDefenceCosts = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "recoveredCosts",
      "label": "Recovered Costs:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.recoveredCosts),
      expression: "recoveredCosts",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "recoveredCosts",
      "id": "recoveredCosts",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.recoveredCosts)
    },
    on: {
      "focus": function($event) {
        _vm.recoveredCosts = _vm.recoveredCosts || ''
      },
      "blur": [function($event) {
        _vm.recoveredCosts = _vm.recoveredCosts || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recoveredCosts = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "totalInitialReserve",
      "label": "Total Reserve:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.totalReserve || 0
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "netPaid",
      "label": "Net Paid:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.netPaid || 0
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "totalPaid",
      "label": "Total Paid:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.totalPaid || 0
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "netPaid",
      "label": "Net Paid:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.netPaid),
      expression: "netPaid",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "netPaid",
      "id": "netPaid",
      "maxlength": "100",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.netPaid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.netPaid = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "flex-grid__g-2 flex-grid--input-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-7"
  }, [_c('button', {
    staticClass: "a-button a-button--loader-button",
    class: [_vm.isSaving ? 'a-loader--white' : ''],
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_c('span', {
    class: [_vm.isSaving ? 'a-button--span-hidden' : '']
  }, [_vm._v("Save")])]), _vm._v(" "), (_vm.showBackBtn) ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    on: {
      "click": function($event) {
        return _vm.close('showAllSummary')
      }
    }
  }, [_vm._v(_vm._s(this.modal ? 'Close' : 'Back') + "\n                    ")]) : _vm._e()])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'p-animated-calc__column-one--section': _vm.showAddButton
    }
  }, [_c('div', {
    class: {
      'p-animated-calc__column-one--section-content': _vm.showAddButton
    }
  }, [_c('control', {
    attrs: {
      "name": 'dependant_income' + _vm.index,
      "label": 'Dependant ' + (_vm.index + 1) + ' Net Income',
      "no-flex-margin": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.income),
      expression: "income",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:dependant_income.required",
      value: ({
        type: 'number'
      }),
      expression: "{type:'number'}",
      arg: "dependant_income",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: _vm.reference,
    attrs: {
      "autocomplete": "off",
      "name": "dependant_income",
      "id": "dependantincome",
      "min": "0.00",
      "disabled": _vm.disabled,
      "type": "number"
    },
    domProps: {
      "value": (_vm.income)
    },
    on: {
      "focus": function($event) {
        _vm.income = _vm.income || ''
      },
      "blur": [function($event) {
        _vm.income = _vm.income || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.income = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dependant_income')
    }
  }, [_vm._v("\n                The Dependant's Net income is required and must be a valid amount\n            ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "no-flex-margin": true
    }
  }, [(_vm.columnTwo) ? _c('div', [_c('div', {
    class: {
      'a-form-inputs--half-calcs': _vm.columnTwo
    }
  }, [_c('div', {
    class: {
      'a-form-inputs__container': _vm.columnTwo
    }
  }, [(_vm.showAddButton) ? _c('button', {
    staticClass: "a-button a-button--grow u-r-margin-bottom-0",
    class: {
      'p-dependency-calc__delete': this.index < 1
    },
    on: {
      "click": function($event) {
        return _vm.deleteDependant(_vm.index)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'a-form-inputs__container': _vm.columnTwo
    }
  }, [(_vm.showAddButton) ? _c('button', {
    staticClass: "a-button a-button--grow u-r-margin-top-0",
    on: {
      "click": _vm.addDependent
    }
  }, [_vm._v("Add")]) : _vm._e()])])]) : _c('div', [(_vm.showAddButton) ? _c('button', {
    staticClass: "a-button",
    class: {
      'p-dependency-calc__delete': this.index < 1
    },
    on: {
      "click": function($event) {
        return _vm.deleteDependant(_vm.index)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.showAddButton) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addDependent
    }
  }, [_vm._v("Add")]) : _vm._e()])]), _c('br')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-full-height"
  }, [(_vm.checkHeader) ? _c('header-section', {
    attrs: {
      "title": "Mini Calculators",
      "set-position": "relative",
      "set-width": "100"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-animated-calc u-no-padding u-no-margin u-d-block",
    class: {
      'p-animated-calc--no-header': !_vm.checkHeader
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "u-full-height",
    class: {
      'p-animated-calc__logo--default': _vm.isRouteByName('mini-calculators')
    }
  }, [_c('router-view'), _vm._v(" "), _c('mini-calc-icons'), _vm._v(" "), (_vm.isRouteByName('mini-calculators')) ? _c('div', {
    staticClass: "flex-grid flex-grid--row flex-grid--reduced-bottom-margin flex-grid--wrap p-animated-calc__icon-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "age_calculator",
      "tooltip-text": "An age calculator to help you determine how old someone would be at a certain date and how old they would be today.",
      "side": "top",
      "container-width": "200",
      "text-width": "250"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/age-calculator'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Age Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#age-calculator"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "care_calculator",
      "tooltip-text": "A calculator for determining the total cost of care provided between two periods. Allows for: basic or aggregate rate; gratuitous care discount; and a configurable hours of care per day.",
      "side": "top",
      "container-width": "200",
      "text-width": "220"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/care-calculator'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Care Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#care-calculator"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "dependency_multiplicand",
      "tooltip-text": "The dependency multiplicand calculator helps determine the dependency multiplicand using a deceased and dependant(s) incomes. Uses the recommended multiplier, based on the number of dependants, but also includes the option to set your own.",
      "side": "top",
      "container-width": "200",
      "text-width": "280"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/dependency-multiplicand'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Dependency Multiplicand")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#dependency-multiplicand"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "net_gross_earnings",
      "tooltip-text": "Our Net/Gross Earnings calculator enables you to determine total Net and Gross earnings for a person, during a period, from both employment income and/or pension income.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/gross-net-earnings'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Net/Gross Earnings")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#earnings"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "net_gross_pension",
      "tooltip-text": "The Net/Gross Pension calculator is a simplified version of our Net/Gross earnings calculator, designed for calculating the pension income of retired individuals.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/gross-net-pension'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Net/Gross Pension")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#pension"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "inflation_calculator",
      "tooltip-text": "An Inflation calculator which allows you to determine the change and see a comparison in the cost of goods and services between two dates.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/inflation-calculator'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Inflation Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#inflation-calculator"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "interest",
      "tooltip-text": "The Interest calculator enables you to calculate interest accrued on principal between two dates, using either simple or compound interest calculations, with a configurable interest rate and compound frequency.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/interest'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Interest")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#interest"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "interpolated_multipliers",
      "tooltip-text": "Our Interpolated Multipliers calculator allows you to determine multipliers from Ogden Discount Tables 1–26 and 28 with a configurable discount rate.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/interpolated-multipliers'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Interpolated Multipliers")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#interpolated"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "life_expectancy",
      "tooltip-text": "The Life Expectancy calculator enables you to determine the life expectancy of a person using any of the six provided methods: Ogden Table 1/2, Years/Months, Date of Death, Age at Death, % of normal life expectancy, and % reduction in normal life expectancy.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/life-expectancy'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Life Expectancy")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#life-expectancy"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "loss_of_earnings",
      "tooltip-text": "The Loss of Earnings calculator enables you to determine total Net Loss of earnings for a person over multiple periods",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/loss-of-earnings'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Loss of Earnings")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#loss-of-earnings"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "loss_of_pension",
      "tooltip-text": "The Loss of Pension calculator",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/loss-of-pension'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Loss of Pension")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#loss-of-pension"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "mesothelioma_psla_calculator",
      "tooltip-text": "The Calculator shows estimated common law awards according to 'age' and 'duration of symptoms'- the period between onset of the disease and death (or anticipated date of death).",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/mesothelioma-psla-calculator'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Mesothelioma PSLA Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#mesothelioma-psla-calculator"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "period_between_dates",
      "tooltip-text": "The Period Between Dates calculator can provide you with the number of years, months, weeks and/or days which have elapsed between two dates, with a configurable level of precision.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/period-between-two-dates'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Period Between Dates")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#period-dates"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "pre_post_assessment_discount",
      "tooltip-text": "The Pre & Post Assessment Discount calculator helps determine the assessment discounts applicable based on the age of the deceased and the duration of time between the deceased's date of death and the date of trial/cessation of dependency.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/pre-and-post-assessment-discounts'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Pre & Post Assessment Discount")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#table-e-f-discounts"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "retirement_age_calculator",
      "tooltip-text": "The Retirement Age Calculator provides the state retirement age for a person based on their date of birth and their gender.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/retirement-age'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Retirement Age Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#retirement-calculator"
    }
  })])])], 1)], 1)]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-animated-calc__icon-container-description"
  }, [_c('h2', [_vm._v("\n                    Welcome to the mini calculators\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    These mini calculators allow you to perform discrete quantum calculations without the need to enter full claims details.\n                    "), _c('br'), _c('br'), _vm._v("\n                    You can download the results by pressing the print button.\n                ")])])
}]}

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "BC Legal - ABC Quantum",
      "set-position": "fixed",
      "load-button": true,
      "save-button": true,
      "current": this.current,
      "create-button": true,
      "set-border": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie u-position-relative",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])])
},staticRenderFns: []}

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-option-filters"
  }, [_c('ul', {
    ref: "list",
    staticClass: "js-option-filter-buttons"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Average Past & Future Losses\n    ")]), _vm._v(" "), (_vm.chosenRates.length > 1) ? _c('p', {
    staticClass: "u-text-center u-no-margin u-margin-bottom-40"
  }, [_vm._v("\n        A comparison between discount rates " + _vm._s(_vm.chosenRates[0]) + " and " + _vm._s(_vm.chosenRates[1]) + " in relation to the average\n        past, future and total losses within your book of business.\n    ")]) : _c('p', {
    staticClass: "u-text-center u-no-margin u-margin-bottom-40"
  }, [_vm._v("\n        A comparison between the average past and future losses for the " + _vm._s(_vm.chosenRates[0]) + " discount rate within\n        your book of business.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-center p-discount-rate-comparison__pie-container"
  }, _vm._l((_vm.chosenRates), function(rate) {
    return _c('pie', {
      attrs: {
        "title": "Discount Rate",
        "rate": rate,
        "total": _vm.averageTotal(rate),
        "labels": ['Past Losses', 'Future Losses'],
        "dataset": _vm.dataset(rate)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "values": [
        'Past Losses',
        'Future Losses'
      ],
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "30",
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), (_vm.chosenRates.length > 1) ? _c('pie-summary', {
    attrs: {
      "rates": _vm.chosenRates,
      "data": [_vm.dataset(_vm.chosenRates[0]), _vm.dataset(_vm.chosenRates[1])]
    }
  }) : _c('pie-summary', {
    attrs: {
      "rates": _vm.chosenRates,
      "data": [_vm.dataset(_vm.chosenRates[0]), _vm.dataset(_vm.chosenRates[0])]
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])
},staticRenderFns: []}

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('claims-dashboard-icons'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "u-margin-top-20 u-margin-bottom-10"
  }, [_c('filter-options', {
    attrs: {
      "title": "Claim Search",
      "button-title": "Search",
      "action": _vm.search,
      "reset": _vm.reset,
      "running": false,
      "filter": _vm.updateFilter
    }
  })], 1), _vm._v(" "), (_vm.claims.length === 0 && !_vm.loading) ? _c('div', {
    staticClass: "u-d-flex"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "u-d-flex"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.claims.length && !_vm.loading) ? _c('span', {
    staticClass: "c-table-filter u-cursor-pointer",
    on: {
      "click": _vm.showHideFilters
    }
  }, [_vm._v("Filter Table Columns")]) : _vm._e(), _vm._v(" "), (_vm.filters && _vm.claims.length) ? _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin-slight a-form-inputs flex-grid--wrap p-your-claims__bordered"
  }, _vm._l((_vm.availableColumns), function(columnData) {
    return _c('div', {
      staticClass: "flex-grid__g-3 p-your-claims__column-filter"
    }, [_c('div', {
      staticClass: "a-checkbox u-margin-top-20 u-margin-bottom-20"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.showColumns),
        expression: "showColumns"
      }],
      attrs: {
        "autocomplete": "off",
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": columnData.value,
        "checked": Array.isArray(_vm.showColumns) ? _vm._i(_vm.showColumns, columnData.value) > -1 : (_vm.showColumns)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.showColumns,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = columnData.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.showColumns = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.showColumns = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.showColumns = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "text"
      }
    }, [_vm._v(_vm._s(columnData.name))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-reserving__assign"
  }, [_c('div', {
    class: {
      'a-loader--table': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('table', {
    staticClass: "a-table a-table--full-width your-claims-table p-your-claims__table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeOrder('your_reference')
      }
    }
  }, [_vm._v("\n                        Your Reference\n                    ")])]), _vm._v(" "), _vm._l((_vm.showColumns), function(columnValue) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeOrder(columnValue)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.columnTitle(columnValue)) + "\n                    ")])])
  }), _vm._v(" "), _c('th', [_vm._v("\n                     \n                ")])], 2)]), _vm._v(" "), _vm._l((_vm.claims), function(claim) {
    return (_vm.claims.length) ? _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(claim.your_reference) + "\n                ")]), _vm._v(" "), _vm._l((_vm.showColumns), function(columnValue) {
      return _c('td', [_vm._v("\n                    " + _vm._s(_vm.output(claim, columnValue)) + "\n                ")])
    }), _vm._v(" "), _c('td', {
      attrs: {
        "width": "80"
      }
    }, [_c('div', {
      staticClass: "u-d-flex u-flex-space-between p-your-claims__table-icons"
    }, [_c('div', {
      staticClass: "u-float-l u-margin-right-20",
      on: {
        "click": function($event) {
          return _vm.toggleSummary(claim.id)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'expand' + claim.id,
        "tooltip-text": "more claim details",
        "side": "top",
        "text-width": "150",
        "icon-type": "toggle"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "u-float-l u-margin-right-20",
      on: {
        "click": function($event) {
          return _vm.sendLoad(claim)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'load' + claim.id,
        "tooltip-text": "load",
        "side": "top",
        "text-width": "100",
        "icon-type": "load"
      }
    })], 1), _vm._v(" "), (_vm.showDelete) ? _c('div', {
      staticClass: "u-float-l",
      on: {
        "click": function($event) {
          return _vm.sendDelete(claim)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'delete' + claim.id,
        "tooltip-text": "delete",
        "side": "left",
        "text-width": "100",
        "icon-type": "delete"
      }
    })], 1) : _vm._e()])])], 2), _vm._v(" "), _c('tr', {
      staticClass: "p-your-claims--claim-summary",
      class: _vm.showSummary(claim.id) ? 'u-d-table-row u-full-width' : 'u-d-none'
    }, [(_vm.showAllSummary) ? _c('td', {
      staticClass: "u-padding-30",
      attrs: {
        "colspan": _vm.showColumns.length + 2
      }
    }, [_c('h2', {
      staticClass: "summary-heading"
    }, [_vm._v("\n                        Summary of " + _vm._s(claim.your_reference) + "\n                        "), (_vm.showNames) ? _c('span', [_vm._v(": " + _vm._s(claim.claimant_name) + " v " + _vm._s(claim.defendant_name))]) : _vm._e()]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "flex-grid flex-grid--reduced-bottom-margin u-r-flex-direction-row u-r-flex-wrap"
    }, [_c('div', {
      staticClass: "flex-grid__g-3"
    }, [_c('h2', [_vm._v("\n                                Claim Data\n                            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Claim Type: "), _c('strong', [_vm._v(_vm._s(claim.human_claim_type))])]), _vm._v(" "), _c('li', [_vm._v("Discount Rate: "), _c('strong', [_vm._v(_vm._s(claim.discount_rate) + "%")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
      staticClass: "u-float-l"
    }, [_vm._v("\n                                Claim Info\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "p-your-claims--edit-icon u-float-l",
      on: {
        "click": function($event) {
          return _vm.updateEditing('showClaimInfo')
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_claim_info' + claim.id,
        "tooltip-text": "edit",
        "side": "right",
        "text-width": "100",
        "icon-type": "edit"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "u-clear"
    }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Handler: "), _c('strong', [_vm._v(_vm._s(_vm.userFrom(claim)))])]), _vm._v(" "), _c('li', [_vm._v("Team: "), _c('strong', [_vm._v(_vm._s(_vm.teamFrom(claim)))])]), _vm._v(" "), _c('li', [_vm._v("Open Date: "), _c('strong', [_vm._v(_vm._s(_vm.dateFormat(claim.open_date, "DD/MM/YYYY")))])]), _vm._v(" "), _c('li', [_vm._v("Status: "), _c('strong', [_vm._v(_vm._s(claim.active ? 'Open' : 'Closed'))])]), _vm._v(" "), _c('li', [_vm._v("Outcome: "), _c('strong', [_vm._v(_vm._s(claim.outcome ? claim.outcome : '-'))])])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-grid__g-3"
    }, [_c('h2', {
      staticClass: "u-float-l"
    }, [_vm._v("\n                                Reserves & Costs\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "p-your-claims--edit-icon u-float-l",
      on: {
        "click": function($event) {
          return _vm.updateEditing('showReservesCosts')
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_reserves_costs' + claim.id,
        "tooltip-text": "edit",
        "side": "right",
        "text-width": "100",
        "icon-type": "edit"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "u-clear"
    }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                                    Damages Reserve: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'current_damages_reserve')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Third Party Costs Reserve: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'current_third_party_reserve')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Defence Costs Reserve: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'current_defence_costs_reserve')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Paid Damages: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'paid_damages')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Paid Third Party Costs: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'paid_third_party_costs')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Paid Defence Costs: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'paid_defence_costs')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Recovered Costs: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'recovered_costs')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Total Reserve: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'total_current_reserve')))])]), _vm._v(" "), _c('li', [_vm._v("Total Paid: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'total_paid')))])]), _vm._v(" "), _c('li', [_vm._v("Net Paid: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'net_paid')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-grid__g-3"
    }, [_c('h2', [_vm._v("\n                                Documents\n                            ")]), _vm._v(" "), _c('ul', [_c('a', {
      attrs: {
        "href": '/api/v1/executive-summary/pdf/' + claim.id + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_vm._m(3, true)]), _vm._v(" "), (claim.recent_schedule_of_loss) ? _c('a', {
      attrs: {
        "href": '/api/v1/generated-documents/pdf/' + claim.recent_schedule_of_loss.id + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('li', [_c('strong', [_vm._v(_vm._s(claim.recent_schedule_of_loss.name))]), _c('br'), _vm._v("\n                                        —\n                                        " + _vm._s(_vm.dateFormat(claim.recent_schedule_of_loss.created_at, "DD/MM/YYYY H:m")) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (claim.recent_comparison_schedule) ? _c('a', {
      attrs: {
        "href": '/api/v1/generated-documents/pdf/' + claim.recent_comparison_schedule.id + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('li', [_c('strong', [_vm._v(_vm._s(claim.recent_comparison_schedule.name))]), _c('br'), _vm._v("\n                                        —\n                                        " + _vm._s(_vm.dateFormat(claim.recent_comparison_schedule.created_at, "DD/MM/YYYY H:m")) + "\n                                    ")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.showClaimInfo) ? _c('td', {
      staticClass: "u-padding-30",
      attrs: {
        "colspan": _vm.showColumns.length + 2
      }
    }, [_c('claim-info', {
      attrs: {
        "claim": claim
      },
      on: {
        "close": _vm.updateEditing,
        "save": _vm.saveClaimChanges
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.showReservesCosts) ? _c('td', {
      staticClass: "u-padding-30",
      attrs: {
        "colspan": _vm.showColumns.length + 2
      }
    }, [_c('initial-reserves-costs', {
      attrs: {
        "claim": claim
      },
      on: {
        "close": _vm.updateEditing,
        "save": _vm.saveReserveChanges
      }
    })], 1) : _vm._e()]), _vm._v(" "), (_vm.claims.length === 0) ? _c('tr', [_c('td', {
      staticClass: "u-text-center",
      attrs: {
        "colspan": "showColumns.length + 2"
      }
    }, [_vm._v("\n                    No claims for your current search\n                ")])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (!_vm.claims.length) ? _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.showColumns.length + 2
    }
  }, [_vm._v("\n                    You do not have any claims saved at present. Click the \"create a new claim\" button above.\n                ")])])]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? _c('ul', {
    staticClass: "m-pagination"
  }, _vm._l((_vm.pageNumbers), function(page) {
    return _c('li', {
      staticClass: "m-pagination__item",
      class: [page == _vm.isActive ? 'm-pagination__item--active' : '']
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePage(page)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page) + "\n            ")])])
  }), 0) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-d-flex"
  }, [_c('p', {
    staticClass: "u-r-margin-top-0"
  }, [_vm._v("Control all of your claims here. Perform searches, filters and quick edits.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid__g-8 u-flex-grow-none"
  }, [_c('h2', [_vm._v("No claims for your current search")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid__g-8 u-flex-grow-none"
  }, [_c('p', [_vm._v("\n                Your claims are listed here, use the plus icon on the right of each claim to expand the details for\n                that claim. You can filter the table columns as well to increase or decrease information to suited\n                to your needs.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Generate Executive Summary")])])
}]}

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")])])
},staticRenderFns: []}

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-dropdown__container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleThisDropdown.apply(null, arguments)
      }
    }
  }, [_c('button', {
    staticClass: "a-button a-button--header-button",
    class: {
      'a-button--dropdown': _vm.isADropdown, 'a-button--no-bottom-radius': _vm.isThisDropdownOpen
    }
  }, [_vm._v(_vm._s(_vm.buttonName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-dropdown",
    class: [_vm.dropdownName, {
      'm-dropdown--show': _vm.isThisDropdownOpen
    }]
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('claims-dashboard-icons'), _vm._v(" "), _c('div', {
    staticClass: "o-date-stepped-inputs__section-content u-d-flex a-form-inputs"
  }, [_c('div', {
    staticClass: "o-date-stepped-inputs__section-content-header"
  }, [_c('h2', [_vm._v("Period " + _vm._s(_vm.index + 1) + " (" + _vm._s(_vm.period.startOfPeriod) + " - " + _vm._s(_vm.period.endOfPeriod) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    on: {
      "click": _vm.toggleFirst
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "period-toggle",
      "tooltip-text": "To toggle the period between minimized and maximized just select this icon.",
      "side": "left",
      "text-width": "200",
      "icon-type": "toggle",
      "icon-colour": "m-icon--dark"
    }
  })], 1), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.removePeriod()
      }
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "period-delete",
      "tooltip-text": "To delete the period just select this icon. This will delete all data held within the period.",
      "side": "left",
      "text-width": "200",
      "icon-type": "delete",
      "icon-colour": "m-icon--dark"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-wrap a-form-inputs u-full-width"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    From\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "start_of_period",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:start_of_period.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "start_of_period",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.index === 0
    },
    model: {
      value: (_vm.period.startOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.period, "startOfPeriod", $$v)
      },
      expression: "period.startOfPeriod"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('start_of_period')
    }
  }, [_vm._v("\n                        The start of period date must be a valid date (DD/MM/YYYY).\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    To\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "end_of_period",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:end_of_period.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "end_of_period",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": function($event) {
        return _vm.updatePostInjuryIncomePeriod()
      }
    },
    model: {
      value: (_vm.period.endOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.period, "endOfPeriod", $$v)
      },
      expression: "period.endOfPeriod"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('end_of_period')
    }
  }, [_vm._v("\n                        The end of period date must be a valid date (DD/MM/YYYY).\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.afterEndOfPeriodRule
    }
  }, [_vm._v("\n                        The end of period date must be before the date of assumed settlement (" + _vm._s(_vm.getClaimInfo('dateOfAssumedSettlement')) + ").\n                    ")])], 1)], 1), _vm._v(" "), (!_vm.toggleOne) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Employment Status\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employmentType",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentType),
      expression: "period.employmentType"
    }, {
      name: "field-control",
      rawName: "v-field-control:employmentType.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "employmentType",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "employmentType",
      "id": "employmentType",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "employmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePostInjuryIncomePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "absence"
    }
  }, [_vm._v("Absent")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('employmentType') || _vm.period.employmentType === null || _vm.period.employmentType === ''
    }
  }, [_vm._v("\n                        Employment status is required\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.toggleOne && _vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('div', {
    staticClass: "flex-grid__item--third u-padding-l-0"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    New Employment Income\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employmentIncome",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.period.employmentIncome),
      expression: "period.employmentIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:employmentIncome.required",
      value: ({
        type: 'number'
      }),
      expression: "{type:'number'}",
      arg: "employmentIncome",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.period.employmentIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.period, "employmentIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePostInjuryIncomePeriod()
      }],
      "focus": function($event) {
        _vm.period.employmentIncome = _vm.period.employmentIncome || ''
      },
      "blur": [function($event) {
        _vm.period.employmentIncome = _vm.period.employmentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('employmentIncome') || _vm.period.employmentIncome < 1
    }
  }, [_vm._v("\n                        Employment Income must be greater than £0\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.toggleOne && _vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Net/Gross\n                    ")]), _vm._v(" "), (_vm.disableNetGross) ? _c('icon-tooltip', {
    attrs: {
      "tooltip-name": "net-gross",
      "tooltip-text": "ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure.",
      "side": "right",
      "text-width": "200",
      "icon-type": "info",
      "icon-colour": "m-icon--dark"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentNetGross),
      expression: "period.employmentNetGross"
    }],
    attrs: {
      "name": "",
      "disabled": _vm.disableNetGross
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePostInjuryIncomePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.toggleOne && _vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Annual Net Income\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.period.totalNetIncome
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.toggleOne) ? _c('div', {
    staticClass: "u-margin-top-20 u-full-width"
  }, [(_vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('button', {
    staticClass: "a-button a-button--small u-margin-right-10",
    on: {
      "click": function($event) {
        return _vm.selectSalary(null)
      }
    }
  }, [_vm._v("\n                    Use ASHE Average\n                ")]) : _vm._e(), _vm._v(" "), (_vm.period.employmentType !== '' && _vm.period.employmentType !== 'absence') ? _c('button', {
    staticClass: "a-button a-button--small u-margin-right-10",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n                    Refine by Occupation\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-margin-right-10 u-margin-bottom-10",
    class: {
      'disabled': _vm.postInjuryIncomePeriodPayments.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.addPayment()
      }
    }
  }, [_vm._v("Add Payment Received")])]) : _vm._e(), _vm._v(" "), (_vm.postInjuryIncomePeriodPayments.length && !_vm.toggleOne) ? _c('div', {
    staticClass: "u-d-flex u-flex-item-full u-margin-top-30"
  }, [_c('h2', [_vm._v("Payments Received for Period " + _vm._s(_vm.index + 1))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "5px 0 0 10px"
    },
    on: {
      "click": function($event) {
        return _vm.togglePayments()
      }
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "pre-accident-income",
      "tooltip-text": "To toggle the payments received between visible and hidden just select this icon.",
      "side": "right",
      "text-width": "200",
      "icon-type": "toggle",
      "icon-colour": "m-icon--dark"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.postInjuryIncomePeriodPayments), function(payment, paymentIndex) {
    return (!_vm.toggleOne && !_vm.togglePayment) ? _c('div', {
      staticClass: "u-full-width"
    }, [_c('post-accident-payments', {
      attrs: {
        "periodStart": _vm.period.startOfPeriod,
        "periodEnd": _vm.period.endOfPeriod,
        "payment": payment,
        "paymentIndex": paymentIndex,
        "periodIndex": _vm.index
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.postInjuryIncomePeriodPayments.length && !_vm.toggleOne && !_vm.togglePayment) ? _c('div', {
    staticClass: "u-full-width u-margin-top-10 u-margin-bottom-20"
  }, [_c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.addPayment()
      }
    }
  }, [_vm._v("Add Another Payment")])]) : _vm._e(), _vm._v(" "), (_vm.postInjuryIncomePeriodPayments.length && !_vm.toggleOne && !_vm.togglePayment) ? _c('div', {
    staticClass: "flex-grid__item--third",
    class: {
      'u-padding-l-0': !_vm.toggleOne && !_vm.togglePayment
    }
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Payments Received\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.totalPaymentsReceived
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third",
    class: {
      'u-padding-l-0': !_vm.postInjuryIncomePeriodPayments.length && !_vm.toggleOne || !_vm.toggleOne && _vm.togglePayment
    }
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Net Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.totalNetLoss),
      expression: "period.totalNetLoss"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.period.totalNetLoss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.period, "totalNetLoss", $event.target.value)
      }
    }
  })])], 1)], 2)]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'ons_salary_' + this.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('div', {
    staticClass: "p-day-one__refine-occupation"
  }, [_c('h2', [_vm._v("Refine by occupation")]), _vm._v(" "), (_vm.selectedNode) ? _c('div', [_c('p', [_vm._v("\n                    Your current selection - "), _c('strong', [_vm._v(_vm._s(_vm.getLastNode().description))]), _c('br'), _vm._v(" "), (_vm.getLastNode().code.length !== 3) ? _c('span', [_vm._v("Select a salary, expand down further or use the average salary for this whole group")]) : _c('span', [_vm._v("Select a salary or use the average salary for this whole group")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.unselectNode(_vm.selectedNode)
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.selectSalary(_vm.selectedNode)
      }
    }
  }, [_vm._v("Use average " + _vm._s(_vm.displaySalary(_vm.selectedNode)))])]) : _c('div', [_c('p', [_vm._v("\n                    Select a salary or expand the group\n                ")])]), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "a-table__small a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('tbody', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "a-loader--table"
  })])]) : _c('tbody', _vm._l((_vm.nodes), function(node) {
    return _c('tr', {
      staticClass: "selected--row"
    }, [_c('td', [_vm._v(_vm._s(node.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displaySalary(node)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "a-button a-button--small",
      attrs: {
        "disabled": node.code.length === 4
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectNode(node)
        }
      }
    }, [_vm._v("\n                                    Expand\n                                ")])]), _vm._v(" "), _c('td', [(node.salary !== 'x') ? _c('button', {
      staticClass: "a-button a-button--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectSalary(node, _vm.type)
        }
      }
    }, [_vm._v("\n                                    Select\n                                ")]) : _vm._e()])])
  }), 0)])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Executive Dashboard",
      "set-position": "relative",
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-executive-dashboard",
    attrs: {
      "id": "app"
    }
  }, [_c('icons'), _vm._v(" "), _c('page-header'), _vm._v(" "), _c('page-form'), _vm._v(" "), _c('div', {
    staticClass: "u-margin-bottom-40"
  }, [_c('reserve-section')], 1), _vm._v(" "), _c('div', {
    staticClass: "u-margin-bottom-40"
  }, [_c('numbers-section')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "otherFutureLosses"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Are there any other future losses?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasOtherFutureLosses),
      expression: "hasOtherFutureLosses"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasOtherFutureLosses = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.hasOtherFutureLosses) ? _c('div', [_c('future-pension', {
    staticClass: "u-margin-bottom-40"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('future-care'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('future-services'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('future-purchases')], 1) : _vm._e()]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-four-o-four"
  }, [_c('div', {
    staticClass: "p-four-o-four__container"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 72.4 72.2"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.3 0C16.2 0 0 16.2 0 36.1s16.2 36.1 36.3 36.1S72.4 56 72.4 36.1 56.1 0 36.3 0zm0 61.4c-14 0-25.3-11.3-25.3-25.3s11.3-25.3 25.3-25.3S61.6 22 61.6 36.1 50.1 61.4 36.3 61.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M68.8 70.7c-2.2 1.9-5.8 1.7-7.7-.6L55 63.2c-1.9-2.2-1.7-5.8.6-7.7 2.2-1.9 5.8-1.7 7.7.6l6.1 6.9c1.9 2.5 1.6 5.8-.6 7.7z"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("404 Error")]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Sorry we couldn't find what you are looking for. If you believe you are receiving this page in error and a resource should be available here please "), _c('a', {
    attrs: {
      "href": "mailto:abcquantum@bc-legal.co.uk"
    }
  }, [_vm._v("contact us.")])])
}]}

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_c('tr', [_c('td', {
    staticClass: "no-border-and-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.startOfPeriod),
      expression: "innerPeriod.startOfPeriod"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "startOfPeriod",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.startOfPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "startOfPeriod", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.retirementDate !== '' && _vm.innerPeriod.startOfPeriod === _vm.retirementDate) ? _c('td', {
    staticClass: "no-border-and-padding td-icon-space"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "identifier",
      "tooltip-text": "This period has been split automatically at the age at which this person retires. You can still change this manually.",
      "side": "right",
      "text-width": "300",
      "icon-type": "info"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('td', [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'date',
        name: 'endOfPeriod' + _vm.index
      }),
      expression: "{type:'date', name:'endOfPeriod' + index}",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "emit": true
    },
    on: {
      "input": function($event) {
        return _vm.updateNextPeriod()
      }
    },
    model: {
      value: (_vm.innerPeriod.endOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.innerPeriod, "endOfPeriod", $$v)
      },
      expression: "innerPeriod.endOfPeriod"
    }
  })], 1), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentType),
      expression: "innerPeriod.employmentType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "not_employed"
    }
  }, [_vm._v("Not employed")])])]) : _vm._e(), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.employmentIncome),
      expression: "innerPeriod.employmentIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'employmentIncome' + _vm.index
      }),
      expression: "{type:'number', name:'employmentIncome' + index}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.innerPeriod.employmentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.innerPeriod.employmentIncome = _vm.innerPeriod.employmentIncome || ''
      },
      "blur": [function($event) {
        _vm.innerPeriod.employmentIncome = _vm.innerPeriod.employmentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "employmentIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentNetGross),
      expression: "innerPeriod.employmentNetGross"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.pensionIncome),
      expression: "innerPeriod.pensionIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'pensionIncome' + _vm.index
      }),
      expression: "{type:'number', name:'pensionIncome' + index}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.innerPeriod.pensionIncome)
    },
    on: {
      "focus": function($event) {
        _vm.innerPeriod.pensionIncome = _vm.innerPeriod.pensionIncome || ''
      },
      "blur": [function($event) {
        _vm.innerPeriod.pensionIncome = _vm.innerPeriod.pensionIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "pensionIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  })])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.pensionNetGross),
      expression: "innerPeriod.pensionNetGross"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "pensionNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])]), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.totalGrossIncome),
      expression: "innerPeriod.totalGrossIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.totalGrossIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "totalGrossIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.totalNetIncome),
      expression: "innerPeriod.totalNetIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.totalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "totalNetIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), (this.index === 0) ? _c('td', [_c('div', {
    class: {
      'a-loader--total': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "a-button a-button--delete a-button--delete-disabled a-button--small",
    attrs: {
      "role": "button",
      "type": "button",
      "disabled": "disabled"
    }
  }) : _vm._e()]) : _c('td', [_c('div', {
    class: {
      'a-loader--total': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "a-button a-button--delete a-button--small",
    attrs: {
      "role": "button",
      "type": "button"
    },
    on: {
      "click": _vm.deletePeriod
    }
  }) : _vm._e()])]), _vm._v(" "), (!_vm.endOfPeriodRules) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": !_vm.retired ? 10 : 6
    }
  }, [_c('control-error', [_vm._v("\n                The income period end date can not be before the deceased's date of death and\n                cannot be after the deceased's 'but for' date of death\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.retired && !_vm.incomeRules && this.dependant === null) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('control-error', [_vm._v("\n                The Pension Income must be greater than £0.00\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.retired && !_vm.incomeRules && this.dependant === null) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('control-error', [_vm._v("\n                The Pension Income OR Employment Income must be greater than £0.00\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.endValid) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('control-error', [_vm._v("\n                The end date of a period must be at least one day after the start.\n            ")])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Loss of Earnings — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is calculated using (i) your selected gross annual income (converted to net\n        equivalent by the tool), and (ii) assumes loss of earnings from date of onset of symptoms to death.\n        The period between death and assumed date of trial/settlement is discounted by Table E Factor. \n        The multiplier is applied from date of trial/assumed settlement but discounted by Table F Factor.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "general_damages_psla",
      "label": "General Damages (PSLA)",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:general_damages_psla.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "general_damages_psla",
      modifiers: {
        "valid": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "general_damages_psla",
      "id": "general_damages_psla",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "focus": function($event) {
        _vm.generalDamages = _vm.generalDamages || ''
      },
      "blur": [function($event) {
        _vm.generalDamages = _vm.generalDamages || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.diseaseType === 'Mesothelioma') ? _c('span', {
    staticClass: "a-form-inputs--help"
  }, [_vm._v("\n                        Damages can be calculated using the calculator available\n                        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleGeneralDamagesPslaModal()
      }
    }
  }, [_vm._v("\n                            here\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "Bereavement Award",
      "label": "Bereavement Award",
      "before-after": "pound",
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "bereavement_award",
      "modal-name": 'headsOfLoss_' + _vm.uniqueId,
      "endpoint": 'bereavementAward',
      "payload": _vm.bereavementModalPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.findValue('bereavementAward')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "funeral_expenses",
      "label": "Funeral Expenses",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.funeralExpenses),
      expression: "funeralExpenses",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:funeral_expenses.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "funeral_expenses",
      modifiers: {
        "valid": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "number",
    attrs: {
      "autocomplete": "off",
      "min": "0",
      "name": "funeral_expenses",
      "type": "number"
    },
    domProps: {
      "value": (_vm.funeralExpenses)
    },
    on: {
      "focus": function($event) {
        _vm.funeralExpenses = _vm.funeralExpenses || ''
      },
      "blur": [function($event) {
        _vm.funeralExpenses = _vm.funeralExpenses || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.funeralExpenses = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('funeral_expenses')
    }
  }, [_vm._v("\n                        Funeral expenses should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "loss_of_spouse",
      "label": "Loss of Spouse",
      "before-after": "pound",
      "tip-icon": "info",
      "tip-text": "Click to view information",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "loss_of_spouse_award",
      "modal-name": 'lossOfSpouse'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lossOfSpouse),
      expression: "lossOfSpouse",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:loss_of_spouse.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "loss_of_spouse",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "loss_of_spouse",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lossOfSpouse)
    },
    on: {
      "focus": function($event) {
        _vm.lossOfSpouse = _vm.lossOfSpouse || ''
      },
      "blur": [function($event) {
        _vm.lossOfSpouse = _vm.lossOfSpouse || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lossOfSpouse = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('loss_of_spouse')
    }
  }, [_vm._v("\n                        Loss of spouse should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_cost_of_travel",
      "label": "Past Cost of Travel",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:past_cost_of_travel.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "past_cost_of_travel",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "past_cost_of_travel",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('past_cost_of_travel')
    }
  }, [_vm._v("\n                        Past cost of travel should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "miscellaneous_costs",
      "label": "Miscellaneous - Medication, Appliances, Additional Food & Energy Costs",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:miscellaneous_costs.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "miscellaneous_costs",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "miscellaneous_costs",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "focus": function($event) {
        _vm.misc = _vm.misc || ''
      },
      "blur": [function($event) {
        _vm.misc = _vm.misc || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('miscellaneous_costs')
    }
  }, [_vm._v("\n                        Miscellaneous should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _vm._l((_vm.headsOfLoss.length), function(index) {
    return _c('div', [_c('head-of-loss', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin u-r-margin-top-20 u-r-margin-bottom-20",
    on: {
      "click": _vm.addNewHeadOfLoss
    }
  }, [_vm._v("\n                    Add Another Head of Loss\n                ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Past Loss of Earnings",
      "tip-text": "You have two options to assess the past loss of earnings claim — click the help icon to find out more.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "200",
      "tip-name": "pastLossOfEarnings",
      "modalName": "pastLossOfEarningsModal"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastLossOfEarningsType),
      expression: "pastLossOfEarningsType"
    }],
    attrs: {
      "id": "pastLossOfEarningsType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pastLossOfEarningsType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])])]), _vm._v(" "), (_vm.pastLossOfEarningsType === 'own') ? _c('control', {
    attrs: {
      "for": "ownPastLossOfEarningsFigure",
      "label": "Enter Your Own Figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ownPastLossOfEarningsFigure),
      expression: "ownPastLossOfEarningsFigure",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:ownPastLossOfEarningsFigure.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "ownPastLossOfEarningsFigure",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "ownPastLossOfEarningsFigure",
      "min": "0.00"
    },
    domProps: {
      "value": (_vm.ownPastLossOfEarningsFigure)
    },
    on: {
      "focus": function($event) {
        _vm.ownPastLossOfEarningsFigure = _vm.ownPastLossOfEarningsFigure || ''
      },
      "blur": [function($event) {
        _vm.ownPastLossOfEarningsFigure = _vm.ownPastLossOfEarningsFigure || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ownPastLossOfEarningsFigure = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('ownPastLossOfEarningsFigure')
    }
  }, [_vm._v("\n                        Your own past loss of earnings figure should be greater than £0.00\n                    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.pastLossOfEarningsPeriods.length), function(index) {
    return (_vm.pastLossOfEarningsType === 'manual') ? _c('div', [_c('earnings-period', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.pastLossOfEarningsPeriods.length >= 0 && _vm.pastLossOfEarningsType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": _vm.addLossOfEarningsPeriod
    }
  }, [_vm._v("\n                    Add Period\n                ")]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "label": "Past Loss of Earnings Total",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.findValue('pastLossOfEarnings'), '')
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Care",
      "tip-text": "You have three options to assess the care claim — click the help icon to find out more.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "200",
      "tip-name": "care",
      "modalName": "careModal"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.careCalcType),
      expression: "careCalcType"
    }],
    attrs: {
      "id": "careCalcType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.careCalcType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto-calculate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])])]), _vm._v(" "), (_vm.careCalcType === 'own') ? _c('control', {
    attrs: {
      "for": "ownCareFigure",
      "label": "Enter Your Own Figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ownCareFigure),
      expression: "ownCareFigure",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:ownCareFigure.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "ownCareFigure",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "ownCareFigure",
      "min": "0.00"
    },
    domProps: {
      "value": (_vm.ownCareFigure)
    },
    on: {
      "focus": function($event) {
        _vm.ownCareFigure = _vm.ownCareFigure || ''
      },
      "blur": [function($event) {
        _vm.ownCareFigure = _vm.ownCareFigure || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ownCareFigure = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('ownCareFigure')
    }
  }, [_vm._v("\n                        Your own care figure should be greater than £0.00\n                    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.periods.length), function(index) {
    return (_vm.careCalcType === 'manual') ? _c('div', [_c('care-period', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.periods.length >= 0 && _vm.careCalcType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": _vm.addCarePeriod
    }
  }, [_vm._v("\n                    Add Period\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'a-loader--care': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('control', {
    attrs: {
      "for": "care_total",
      "label": "Care Total",
      "before-after": "pound",
      "tip-icon": _vm.careIcon,
      "tip-show": _vm.careCalcType === 'auto',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "care_total",
      "modal-name": 'headsOfLoss_' + _vm.uniqueId,
      "endpoint": 'autoCare'
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.findValue('pastCostOfCare'), '')
    }
  })])], 1) : _vm._e()], 2)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "pastLossOfEarningsModal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Past Loss of Earnings Claim Options\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            You have two options to assess the care claim:"), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "u-margin-lr-40"
  }, [_c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can simply enter in a £ sum for the known past loss of earnings.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can carry out a detailed calculation looking at differing periods and calculating from either Net or Gross income per annum.\n            ")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "careModal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Care Claim Options\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            You have three options to assess the care claim:"), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "u-margin-lr-40"
  }, [_c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can simply enter in a £ sum for the care.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can Auto-calculate the award. The CA in Rothwell v Chemical Insulating Co. Ltd [2006] EWCA Civ 27 recognised a sum of £12,500 as the norm for care in claims for terminal malignant mesothelioma. This award is inflated to today’s value applying the Retail Price Index since January 2006.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can carry out a detailed calculation looking at differing periods and differing hours of care and applying either a basic or aggregate care rate valued according to Local Authority Spinal Point 8. You can then discount the claim by 25% to reflect the gratuitous rather than commercial nature of the care.\n            ")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'headsOfLoss_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "generalDamagesPslaModal",
      "no-default-button": "true"
    }
  }, [(_vm.modals.generalDamagesPslaModal) ? _c('general-damages-psla-calculator') : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "lossOfSpouse",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Loss of Spouse\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Also known as ‘Regan Awards’ and awards for ‘loss of intangible benefits’, this head of loss is usually claimed for the loss of services provided by a spouse/parent which go beyond what can be commercially sourced e.g. care and attention. Originally established in Regan v Williamson, we discussed the most recent case law in "), _c('a', {
    attrs: {
      "href": "https://www.bc-legal.co.uk/images/pdf/177-BC-Disease-News-2017-03-17-Edition-177.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Edition 177 of BC Disease News")]), _vm._v(".\n        ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reserveValue),
      expression: "reserveValue"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reserveValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25000"
    }
  }, [_vm._v("<£25,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50000"
    }
  }, [_vm._v("£25,000–£49,999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10000"
    }
  }, [_vm._v("£50,000–£100,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "150000"
    }
  }, [_vm._v("£100,000–£150,000")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("£150,000+")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter Own Range")])])
},staticRenderFns: []}

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-your-claims__table-container"
  }, [_c('div', {
    staticClass: "flex-grid flex-state-buttons"
  }, [_c('h3'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showInterest),
      expression: "showInterest"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showInterest) ? _vm._i(_vm.showInterest, null) > -1 : (_vm.showInterest)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showInterest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showInterest = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showInterest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showInterest = $$c
        }
      }, _vm.updateTotals]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Show Interest")])])])]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("General Damages (PSLA)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('generalDamages'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('generalDamages') - _vm.generalDamages)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('generalDamages'), _vm.generalDamages)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("General Damages (PSLA) - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('generalDamagesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages_interest",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamagesInterest),
      expression: "generalDamagesInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamagesInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamagesInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('generalDamagesWithInterest') - _vm.generalDamagesInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('generalDamagesWithInterest'), _vm.generalDamagesInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastDependencyOnServices'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_dependency",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastDependencyOnServices),
      expression: "pastDependencyOnServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastDependencyOnServices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastDependencyOnServices = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastDependencyOnServices') - _vm.pastDependencyOnServices)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('pastDependencyOnServices'), _vm.pastDependencyOnServices)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Services - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastDependencyOnServicesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_dependency",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastDependencyOnServicesWithInterest),
      expression: "pastDependencyOnServicesWithInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastDependencyOnServicesWithInterest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastDependencyOnServicesWithInterest = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastDependencyOnServicesWithInterest') - _vm.pastDependencyOnServicesWithInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('pastDependencyOnServicesWithInterest'), _vm.pastDependencyOnServicesWithInterest)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCare),
      expression: "pastCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCare = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfCare') - _vm.pastCostOfCare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('pastCostOfCare'), _vm.pastCostOfCare)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Care - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfCareWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCareInterest),
      expression: "pastCostOfCareInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCareInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCareInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfCareWithInterest') - _vm.pastCostOfCareInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('pastCostOfCareWithInterest'), _vm.pastCostOfCareInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfTravel') - _vm.pastCostOfTravel)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('pastCostOfTravel'), _vm.pastCostOfTravel)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Travel - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfTravelWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravelInterest),
      expression: "pastCostOfTravelInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravelInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravelInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfTravelWithInterest') - _vm.pastCostOfTravelInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('pastCostOfTravelWithInterest'), _vm.pastCostOfTravelInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.pastLossTotal)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarnings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarnings = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.pastLossTotal - _vm.pastLossOfEarnings)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.pastLossTotal, _vm.pastLossOfEarnings)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings - Interest ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastLossOfEarningsWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarningsInterest),
      expression: "pastLossOfEarningsInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarningsInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarningsInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastLossOfEarningsWithInterest') - _vm.pastLossOfEarningsInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('pastLossOfEarningsWithInterest'), _vm.pastLossOfEarningsInterest)) + "%\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('misc'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('misc') - _vm.misc)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('misc'), _vm.misc)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Miscellaneous - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('miscWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.miscInterest),
      expression: "miscInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.miscInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.miscInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('miscWithInterest') - _vm.miscInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('miscWithInterest'), _vm.miscInterest)) + "%")])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.customHeadOfLoss), function(custom) {
    return _c('custom-head-of-loss', {
      attrs: {
        "headOfLoss": custom,
        "index": _vm.index,
        "showInterest": _vm.showInterest
      },
      on: {
        "update": _vm.updateTotals
      }
    })
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Future Cost of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('futureDependencyOnServices'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_dependency",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureDependencyOnServices),
      expression: "futureDependencyOnServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureDependencyOnServices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureDependencyOnServices = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('futureDependencyOnServices') - _vm.futureDependencyOnServices)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('futureDependencyOnServices'), _vm.futureDependencyOnServices)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('futureCostOfCare'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureCostOfCare),
      expression: "futureCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureCostOfCare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureCostOfCare = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('futureCostOfCare') - _vm.futureCostOfCare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getHeadsOfLossValue('futureCostOfCare'), _vm.futureCostOfCare)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureLossTotal)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossOfEarnings),
      expression: "futureLossOfEarnings",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureLossOfEarnings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossOfEarnings = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureLossTotal - _vm.futureLossOfEarnings)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.futureLossTotal, _vm.futureLossOfEarnings)) + "%")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headsOfLossTotal)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.dependantsHeadsOfLossTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.differenceTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headsOfLossTotal, _vm.dependantsHeadsOfLossTotal)) + "%")])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Defendant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Claimant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])]), _vm._v(" "), _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Percentage")])])])])
}]}

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.filterHeading.length) ? _c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n        " + _vm._s(_vm.filterHeading) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('select', {
    ref: "input",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _vm._l((_vm.optionValues), function(key, value) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromReserve),
      expression: "fromReserve"
    }],
    domProps: {
      "value": (_vm.fromReserve)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromReserve = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toReserve),
      expression: "toReserve"
    }],
    domProps: {
      "value": (_vm.toReserve)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toReserve = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('accordion', _vm._l((_vm.services), function(service, index) {
    return _c('div', {
      staticClass: "dependant"
    }, [_c('accordion-item', [_c('h2', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v("\n                    Dependency on service " + _vm._s(index + 1) + "\n                    " + _vm._s(service.descriptionOfService ? ' - ' + service.descriptionOfService : '') + "\n                ")]), _vm._v(" "), _c('service', {
      attrs: {
        "index": index
      },
      on: {
        "check": _vm.updateValid
      }
    })], 1)], 1)
  }), 0), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.stepValid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-d-inline"
  }, [_c('header-section', {
    attrs: {
      "title": "BC Legal - ABC Quantum",
      "set-position": "relative",
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "p-homepage__content flex-grid"
  }, [_c('div', {
    staticClass: "p-homepage__object flex-grid__g-3"
  }, [_c('div', {
    staticClass: "a-logo-image--homepage"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 400 53.8"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#logo"
    }
  })])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v("\n    \n                The most comprehensive quantum calculator for all types of occupational disease & personal injury claims — including fatal claims, lost years claims & those of utmost severity.\n            ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "p-homepage__policies"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "homepage_cookie_policy"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Cookie Policy")])]), _vm._v("\n\n            |\n\n            "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "homepage_disclaimer"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Disclaimer")])]), _vm._v("\n\n            |\n\n            "), _vm._m(3), _vm._v("\n\n            |\n\n            "), _vm._m(4), _vm._v("\n\n            |\n\n            "), _vm._m(5)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "homepage_disclaimer",
      "no-default-button": "true"
    }
  }, [_c('disclaimer')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "homepage_cookie_policy",
      "no-default-button": "true"
    }
  }, [_c('cookie-policy')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Welcome to the"), _c('br'), _vm._v(" "), _c('b', [_vm._v("ABC Quantum Tool")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-homepage__object flex-grid__g-7 u-no-margin v-image"
  }, [_c('img', {
    attrs: {
      "src": "static/video/mockup.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-homepage__object flex-grid__g-7 u-no-margin v-video"
  }, [_c('video', {
    attrs: {
      "id": "video",
      "src": "static/video/quantum.mp4",
      "type": "video/mp4",
      "controls": ""
    }
  }, [_vm._v("\n                Sorry, your browser doesn't support embedded videos, \n                but don't worry, you can "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("download it")]), _vm._v("\n                and watch it with your favorite video player!\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/security-policy.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Security Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/privacy-policy.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Privacy Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/license-agreement.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("License Agreement")])])
}]}

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    staticClass: "filterInput",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "emit": _vm.emit,
      "disabled": _vm.disabled,
      "placeholder": "--/--/----"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-30 u-margin-bottom-30"
  }, [_vm._v("\n        Losses for Services\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_loss_of_services",
      "label": "Is There Future Loss of Services?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossOfServices),
      expression: "futureLossOfServices"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_loss_of_services",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossOfServices = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.futureLossOfServices) ? _c('div', {
    staticClass: "u-margin-bottom-30"
  }, [_vm._l((_vm.services), function(service, serviceIndex) {
    return _c('div', [_c('futureService', {
      attrs: {
        "index": serviceIndex,
        "service": service
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addService
    }
  }, [_vm._v("Add Service")])], 2) : _vm._e(), _vm._v(" "), (_vm.futureLossOfServices && _vm.futureLossOfServicesValid) ? _c('div', [_c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-top-50 u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.services), function(service) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(service.servicesStartDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.servicesEndDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(service.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(service.duration, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(service.multiplier, 2)))]), _vm._v(" "), _c('td', [_c('tr', [_c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0px"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(service.futureServicesTotal)) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0 0 0 10px"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.toggleModal(service)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'calculation_' + _vm.uniqueId,
        "tooltip-text": "Click to view calculation",
        "side": "left",
        "text-width": "140",
        "icon-type": "formula"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.servicesTotal)))])])])])])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'calculation_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date from")]), _vm._v(" "), _c('th', [_vm._v("Date to")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Future Services Loss")])])])
}]}

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "futureLosses"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            Future Loss of Earnings\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Is there any future loss of earnings?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLosses),
      expression: "futureLosses"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses",
      "disabled": _vm.retiredBetweenInjuryAndSettlement,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLosses = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (_vm.retiredBetweenInjuryAndSettlement) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }), _vm._v(" "), _c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-10"
  }, [_vm._v("\n                        Please note the Future Loss of Earnings is disabled as the claimant is set to retire\n                        before the assumed settlement therefore there is no Future Loss of Earnings\n                    ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLosses) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Is the Future Loss Variable?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_constant",
      "tip-text": "In some cases the future losses may be variable and it may be necessary to split the future loss multipliers.",
      "tip-icon": "info",
      "tip-side": "right",
      "tip-width": "250",
      "tip-name": "future_losses_constant",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossesConstant),
      expression: "futureLossesConstant"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses_constant",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossesConstant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clearFuturePeriods]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("No")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesConstant !== null) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Claimant Level of Education\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "level_of_education"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.levelOfEducation),
      expression: "levelOfEducation"
    }],
    attrs: {
      "name": "level_of_education",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.levelOfEducation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Degree or equivalent or higher")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GE-A"
    }
  }, [_vm._v("GCSE grades A–C up to A levels or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("Below GCSE grade C or CSE grade 1 or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("No qualifications")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('level_of_education')
    }
  }, [_vm._v("\n                        Level of Education is required\n                    ")])], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.futureLossesConstant !== null) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Claimant Employed Prior to Injury?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_at_accident",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "right",
      "tip-text": "Those who at the time of the accident are employed, self-employed or on a government training scheme are classed as employed. All others (including those temporarily out of work, full-time students and unpaid family works) would be classed as not employed.",
      "tip-width": "250",
      "tip-name": "employed_at_accident"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedAtAccident),
      expression: "employedAtAccident"
    }],
    attrs: {
      "id": "employed_at_accident"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes — Employed")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No — Not Employed")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Was the Claimant Disabled?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "claimant_disabled",
      "modal-name": 'disabled-info',
      "icon-space": true,
      "tip-icon": "info",
      "tip-show": true,
      "tip-text": "Click to view information",
      "tip-side": "right",
      "tip-width": "140",
      "tip-name": "disabled-info"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledAtAccident),
      expression: "disabledAtAccident"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimant_disabled",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Not Disabled")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Disabled")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_disabled')
    }
  }, [_vm._v("\n                        Claimant Disabled is required\n                    ")])], 1)], 1), _vm._v(" "), (_vm.ageAtSettlement <= 54) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Pre-Injury Table A–D Result\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": 'table_a_d_discount_factor_' + _vm.uniqueId,
      "modal-name": 'income_' + _vm.uniqueId,
      "endpoint": "preInjuryContingencyMultiplierPayload",
      "payload": _vm.preInjuryContingencyMultiplierPayload,
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preInjuryDiscountFactor),
      expression: "preInjuryDiscountFactor"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.preInjuryDiscountFactor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preInjuryDiscountFactor = $event.target.value
      }
    }
  })])], 1) : _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }), _vm._v(" "), _c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-10"
  }, [_vm._v("\n                        Please note the discount figures only apply up to age 54\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-40",
    attrs: {
      "slot": "b"
    },
    slot: "b"
  }, [_c('p', {
    staticClass: "c-warning-box--link"
  }, [_vm._v("Read the full description here")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.futureLossesConstant !== null) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Will the Claimant Be Employed at Assessment?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_at_assessment",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "right",
      "tip-text": "If the claimant had stopped working at the onset of symptoms, regardless of whether they had reached state pension age, they would be classed as having been retired.",
      "tip-width": "200",
      "tip-name": "employed_at_assessment"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedAtAssessment),
      expression: "employedAtAssessment"
    }],
    attrs: {
      "id": "employed_at_assessment"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedAtAssessment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes — Employed")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No — Not Employed")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Is the Claimant Disabled at Assessment?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "claimant_disabled",
      "modal-name": 'disabled-info',
      "icon-space": true,
      "tip-icon": "info",
      "tip-show": true,
      "tip-text": "Click to view information",
      "tip-side": "right",
      "tip-width": "140",
      "tip-name": "disabled-info"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledAtAssessment),
      expression: "disabledAtAssessment"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimant_disabled",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledAtAssessment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Not Disabled")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Disabled")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_disabled')
    }
  }, [_vm._v("\n                        Claimant Disabled is required\n                    ")])], 1)], 1), _vm._v(" "), (_vm.ageAtSettlement <= 54) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Assessment Table A–D Result\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": 'table_a_d_discount_factor_' + _vm.uniqueId,
      "modal-name": 'income_' + _vm.uniqueId,
      "endpoint": "assessmentContingencyMultiplierPayload",
      "payload": _vm.assessmentContingencyMultiplierPayload,
      "table-control": true,
      "for": "claimant_disabled"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assessmentDiscountFactor),
      expression: "assessmentDiscountFactor"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.assessmentDiscountFactor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.assessmentDiscountFactor = $event.target.value
      }
    }
  })])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.futureLosses && _vm.futureLossOfEarningsValid &&
    (_vm.futureLossesConstant || !_vm.getIncomeValue('pastLossOfEarnings')) && _vm.futureLossesConstant !== null) ? _c('div', [_c('h2', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                Multiplicand Earnings\n            ")]), _vm._v(" "), _c('post-accident-income')], 1) : _vm._e(), _vm._v(" "), (_vm.futureLosses && _vm.futureLossesConstant === false && _vm.futureLossOfEarningsValid) ? _c('div', [_c('h2', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                Post Accident Earnings\n            ")]), _vm._v(" "), _c('strong', [_c('future-income', {
    attrs: {
      "name": "Claimant",
      "type": "future",
      "income": _vm.claimant.income,
      "retired": false
    },
    on: {
      "action": _vm.updateIncome
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Do losses continue into retirement?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_to_retirement",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossesToRetirement),
      expression: "futureLossesToRetirement"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses_to_retirement",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossesToRetirement = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateTheFutureLossOfEarnings]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (_vm.futureLossesToRetirement) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Retirement Age\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "future_losses_retirement_age",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.retirementAge),
      expression: "retirementAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "name": "retirement_age",
      "min": "50",
      "max": "80"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = _vm._n($event.target.value)
      }, _vm.updateTheFutureLossOfEarnings],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validRetirementAge
    }
  }, [_vm._v("\n                        Retirement age must be between 50 and 80.\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Retirement Date\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_end",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    on: {
      "input": _vm.updateTheFutureLossOfEarnings
    },
    model: {
      value: (_vm.retirementDate),
      callback: function($$v) {
        _vm.retirementDate = $$v
      },
      expression: "retirementDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        End date of future losses\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_end",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    on: {
      "input": _vm.updateTheFutureLossOfEarnings
    },
    model: {
      value: (_vm.futureLossesEnd),
      callback: function($$v) {
        _vm.futureLossesEnd = $$v
      },
      expression: "futureLossesEnd"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Age at End of future losses\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "future_losses_end_age",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossesEndAge),
      expression: "futureLossesEndAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "name": "retirement_age",
      "min": "18",
      "max": "100"
    },
    domProps: {
      "value": (_vm.futureLossesEndAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossesEndAge = _vm._n($event.target.value)
      }, _vm.updateTheFutureLossOfEarnings],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.futureLosses && _vm.futureLossesConstant && _vm.futureLossOfEarningsValid) ? _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_losses_start",
      "label": "Start of Loss of Earnings"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    attrs: {
      "disabled": ""
    },
    on: {
      "input": _vm.updateFutureLossOfEarnings
    },
    model: {
      value: (_vm.futureLossesStart),
      callback: function($$v) {
        _vm.futureLossesStart = $$v
      },
      expression: "futureLossesStart"
    }
  })], 1), _vm._v(" "), (_vm.futureLossesToRetirement) ? _c('control', {
    attrs: {
      "for": "retirement_age",
      "label": "Retirement Age"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.retirementAge),
      expression: "retirementAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "name": "retirement_age",
      "min": "18",
      "max": "100"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = _vm._n($event.target.value)
      }, _vm.updateTheFutureLossOfEarnings],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('control', {
    attrs: {
      "label": "Age at End of future losses",
      "for": "future_losses_end_age",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossesEndAge),
      expression: "futureLossesEndAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "name": "retirement_age",
      "min": "18",
      "max": "100"
    },
    domProps: {
      "value": (_vm.futureLossesEndAge)
    },
    on: {
      "change": _vm.updateTheFutureLossOfEarnings,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossesEndAge = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_losses_to_retirement",
      "label": "Do losses continue into retirement?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossesToRetirement),
      expression: "futureLossesToRetirement"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses_to_retirement",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossesToRetirement = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateTheFutureLossOfEarnings]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), (_vm.futureLossesToRetirement) ? _c('control', {
    attrs: {
      "for": "future_losses_end",
      "label": "Retirement Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    on: {
      "input": function($event) {
        return _vm.updateTheFutureLossOfEarnings()
      }
    },
    model: {
      value: (_vm.retirementDate),
      callback: function($$v) {
        _vm.retirementDate = $$v
      },
      expression: "retirementDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.validRangeOfLossOfEarnings()
    }
  }, [_vm._v("\n                            The end date of retirement should be after the start date.\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('control', {
    attrs: {
      "for": "future_losses_end",
      "label": "End date of future losses"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    on: {
      "input": _vm.updateTheFutureLossOfEarnings
    },
    model: {
      value: (_vm.futureLossesEnd),
      callback: function($$v) {
        _vm.futureLossesEnd = $$v
      },
      expression: "futureLossesEnd"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.validRangeOfLossOfEarnings()
    }
  }, [_vm._v("\n                            The end date of future of losses should be after the start date.\n                        ")])], 1) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Adjust Multiplier for Mortality?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_mortality_multiplier",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossesMortalityMultiplier),
      expression: "futureLossesMortalityMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses_mortality_multiplier",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossesMortalityMultiplier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateTheFutureLossOfEarningsAndIncome]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.results && _vm.futureLossesMortalityMultiplier !== null) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("\"But For\" earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesStart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesEnd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.durationOfPeriod.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.multiplier.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.preInjuryDiscountFactor, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.preAccidentNetIncome)))]), _vm._v(" "), _c('td', [_vm._v("\n                            (" + _vm._s(_vm.multiplier.toFixed(2)) + " x " + _vm._s(_vm.preInjuryDiscountFactor) + " x " + _vm._s(_vm.currencyFormat(_vm.preAccidentNetIncome)) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.preResult)))])]), _vm._v(" "), _vm._l((_vm.getIncomeValue('futurePeriods')), function(period, index) {
    return (!_vm.futureLossesConstant) ? _c('tr', [(index === 0) ? _c('th', [_vm._v("Actual earnings")]) : _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.startOfPeriod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.endOfPeriod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.duration))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.futureLossOfEarningsMultiplier || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.totalNetIncome)))]), _vm._v(" "), _c('td', [_vm._v("\n                            (" + _vm._s(parseFloat(period.futureLossOfEarningsMultiplier || "0").toFixed(2)) + " x " + _vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)) + " x " + _vm._s(_vm.currencyFormat(period.totalNetIncome)) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.periodNetEarnings(period)))])]) : _c('tr', [_c('th', [_vm._v("Actual earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesStart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesEnd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.durationOfPeriod.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(_vm.multiplier).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.postAccidentMultiplicand)))]), _vm._v(" "), _c('td', [_vm._v("\n                            (" + _vm._s(parseFloat(_vm.multiplier).toFixed(2)) + " x " + _vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)) + "\n                            x " + _vm._s(_vm.currencyFormat(_vm.postAccidentMultiplicand)) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.postResult)))])])
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("\n                            Net Loss of Earnings\n                        ")]), _vm._v(" "), (!_vm.futureLossesConstant) ? _c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.preResult)) + " - " + _vm._s(_vm.currencyFormat(_vm.postNetTotal())) + "\n                        ")]) : _c('td', [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.preResult)) + " - " + _vm._s(_vm.currencyFormat(_vm.postResult)) + "\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("\n                            Total\n                        ")]), _vm._v(" "), (!_vm.futureLossesConstant) ? _c('td', [_c('strong', [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(_vm.lossResult)) + "\n                            ")])]) : _c('td', [_c('strong', [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(_vm.futureLossesConstantResult)) + "\n                            ")])])])])])])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "disabled-info",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("Disabled")]), _vm._v("\n        A person is classified as being disabled if all three of the following conditions in relation to the\n        ill-health or disability are met:\n        "), _c('ol', {
    attrs: {
      "type": "i"
    }
  }, [_c('li', [_vm._v("the person has an illness or disability which has lasted or is expected to last for over a year or\n                is a progressive illness\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("the person satisfies the Equality Act 2010 definition that the impact of the disability\n                substantially limits the person's ability to carry out normal day to day activities, and\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("their condition affects either the kind "), _c('i', [_vm._v("or")]), _vm._v(" the amount of paid work they can do.")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'income_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'multipliers_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "warning",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("The discount figures")]), _vm._v(" "), _c('p', [_vm._v("\n            Do you wish to discount the future loss of earnings multiplier for contingencies other than mortality?\n            For example, to reflect the risks and vicissitudes of life, such as periods not earning from ill-health\n            or loss of employment or taking care for dependents. If so then Tables A-D of the Ogden Tables provide\n            framework figures for discounting the multiplier to reflect these risks. Please note the discount\n            figures only apply up to age "), _c('strong', [_vm._v("54")]), _vm._v(". Thereafter the tables state:\n        ")]), _vm._v(" "), _c('blockquote', [_c('i', [_vm._v("‘For older ages the reduction factors increase towards 1 at retirement age for those\n            who are employed and fall towards 0 for those who are not employed. However, where the claimant is older\n            than "), _c('strong', [_vm._v("54")]), _vm._v(", it is anticipated that the likely future course if employment status will be\n            particularly dependent on individual circumstances, so that the use of factors based on averages would\n            not be appropriate. Hence reduction factors are not provided for older ages’.")])]), _vm._v(" "), _c('p', [_vm._v("ABC Quantum does however provide discount factors beyond age "), _c('strong', [_vm._v("54")]), _vm._v("\n            to retirement age by simple interpolation. So for an employed male aged "), _c('strong', [_vm._v("54")]), _vm._v(", not\n            disabled with A level qualifications the discount factor in "), _c('strong', [_vm._v("Table A is 0.79")]), _vm._v(". The figure\n            at retirement age of say "), _c('strong', [_vm._v("65/67 is 1.0")]), _vm._v(". For ages between "), _c('strong', [_vm._v("54–65/67")]), _vm._v("\n            we interpolate between the figures "), _c('strong', [_vm._v("0.79-1.0")]), _vm._v(".")])]), _vm._v(" "), _c('step-button', {
    staticClass: "u-margin-top-40",
    attrs: {
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid a-form-inputs",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('h2', [_vm._v("\n                    Future Loss of Earnings\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Dates from")]), _vm._v(" "), _c('th', [_vm._v("Dates to")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), _c('th', [_vm._v("Net Annual Earnings")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Formula")]), _vm._v(" "), _c('th', [_vm._v("Total Net Earnings")])])])
}]}

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimStatus),
      expression: "claimStatus"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.claimStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Claims")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Live")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "closed"
    }
  }, [_vm._v("Concluded")])])
},staticRenderFns: []}

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n        Loss of Income to Date of Trial\n    ")]), _vm._v(" "), (_vm.pastLossTotal == 0) ? _c('div', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("\n        Claimant has no past loss of income.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_c('div', {
    class: {
      'a-loader--table': _vm.isLoading || _vm.pastLossPeriods == null
    }
  }), _vm._v(" "), (!_vm.isLoading && _vm.pastLossTotal) ? _c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.pastLossPeriods), function(period) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(period.period_from) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(period.period_to) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.duration_years, 2)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.income_multiplicand)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.discounted_multiplicand)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.multiplier, 2)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.value)) + "\n                    ")])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                        Total Loss of Income to Date of Trial:\n                    ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.pastLossTotal)) + "\n                        ")])])])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("\n        Loss of Income and Pension Post-Trial & Lost Years\n    ")]), _vm._v(" "), (_vm.futureLossTotal == 0) ? _c('div', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("\n        Claimant has no loss of income post-trial or loss of income and/or pension in lost years.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_c('div', {
    class: {
      'a-loader--table': _vm.isLoading || _vm.futureLossPeriods == null
    }
  }), _vm._v(" "), (!_vm.isLoading && _vm.futureLossTotal) ? _c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                        Dates (from–to)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Duration (years)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Deferment (years)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Income Multiplicand\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Discounted Multiplicand\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Multiplier\n                    ")]), _vm._v(" "), (_vm.claimant.income.contingencyMultiplier) ? _c('th', [_vm._v("\n                        Employment Contingency Multiplier\n                    ")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("\n                        Total Loss of Income\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.futureLossPeriods), function(period, index) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(period.period_from) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(period.period_to) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.duration_years, 2)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.deferment, 2)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.income_multiplicand)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.discounted_multiplicand)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.multiplier, 2)) + "\n                    ")]), _vm._v(" "), (_vm.claimant.income.contingencyMultiplier) ? _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.claimant.income.multiplier, 2)))]) : _vm._e(), _vm._v(" "), _c('td', [_c('tr', [_c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0px"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(period.value)) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0 0 0 10px"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.toggleModal(period)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'calculation_' + _vm.uniqueId,
        "tooltip-text": "Click to view calculation",
        "side": "left",
        "text-width": "140",
        "icon-type": "formula"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right",
    attrs: {
      "colspan": _vm.claimant.income.contingencyMultiplier ? 8 : 7
    }
  }, [_vm._v("\n                        Total Loss of Income from Date of Trial to end of 'But For' Life Expectancy:\n                    ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.futureLossTotal)) + "\n                        ")])])])])]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": true
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'calculation_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                        Dates (from–to)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Duration (years)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Income Multiplicand\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Discounted Multiplicand\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Multiplier\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Total Loss of Income\n                    ")])])])
}]}

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of Care\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "title": "Past Cost of Care",
      "subtitle": "Attendance Allowance",
      "store-key": "pcocAttendanceAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Care",
      "subtitle": "Disability Living Allowance (care component)",
      "store-key": "pcocDisabilityLivingAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Care",
      "subtitle": "Industrial Injuries Disablement Benefit increase for Constant Attendance Allowance or Exceptionally Severe Disablement Allowance",
      "store-key": "pcocIndustrialInjuriesDisablementBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Care",
      "subtitle": "Personal Independence Payment (living component)",
      "store-key": "pcocPersonalIndependencePayment",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        This head of loss is calculated using the BC Legal General Damages PSLA Calculator.\n            This assesses common law awards according to 'age' and 'duration' of symptoms-the period between onset\n            of disease and death (or anticipated date of death).\n    ")]), _vm._v(" "), _c('em', [_vm._v("The relevant excerpt from the PLSA Calculator is shown below.")]), _vm._v(" "), _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed u-margin-top-20"
  }, [_c('thead', [_vm._m(0), _vm._v(" "), _c('tr', _vm._l((_vm.durationLabels), function(label) {
    return _c('th', [_vm._v("\n                " + _vm._s(label) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableResults), function(row, ageKey) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(_vm.ageLabels[ageKey]))]), _vm._v(" "), _vm._l((row), function(cell, cellIndex) {
      return _c('td', {
        style: (_vm.calcCellStyle(ageKey, cellIndex))
      }, [_vm._v("\n                " + _vm._s(_vm.currencyFormat(cell, "£", 0)) + "\n            ")])
    })], 2)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up To)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Duration of Symptoms (months)")])])
}]}

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Discount Rate Comparison",
      "set-position": "relative",
      "create-button": true,
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-discount-rate-comparison"
  }, [(!_vm.processing) ? _c('div', [_c('page-form'), _vm._v(" "), _c('br'), _c('hr'), _c('br'), _vm._v(" "), (_vm.preview.data.length) ? _c('claims-preview') : _c('div', [_vm._v("\n                No matching claims match your search criteria. Please update your \n                search criteria and perform another preview.\n            ")])], 1) : _c('div', [_c('h2', {
    staticClass: "u-padding-b-30"
  }, [_vm._v("\n                Processing Discount Rates\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Your discount rates are currently being processed"), _c('br'), _c('br'), _vm._v("\n                " + _vm._s(_vm.progress.numberCompleted) + " claims have been updated out of " + _vm._s(_vm.progress.numberOfClaims) + " "), _c('br'), _c('br'), _vm._v("\n                Please check back soon.\n            ")]), _vm._v(" "), _c('progress-bar', {
    attrs: {
      "value": _vm.progress.numberCompleted,
      "total-value": _vm.progress.numberOfClaims
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.html)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Claims Dashboard",
      "set-position": "fixed",
      "create-button": true,
      "set-border": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-your-claims",
    attrs: {
      "id": "app"
    }
  }, [_c('claims-dashboard-icons'), _vm._v(" "), _c('claim-table', {
    ref: "claims",
    attrs: {
      "show-delete": ""
    },
    on: {
      "select": _vm.loadClaimAndView,
      "delete": _vm.deleteClaim
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "confirm_delete",
      "no-default-button": true
    }
  }, [_c('div', [_c('h1', [_vm._v("Are you sure you want to delete this claim?")]), _vm._v(" "), _c('p', [_vm._v("Once you delete this claim you can not get it back, are you sure?")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    staticStyle: {
      "background": "red"
    },
    on: {
      "click": _vm.performDelete
    }
  }, [_vm._v("\n                Delete\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.dismissClose
    }
  }, [_vm._v("\n                Close\n            ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin",
    attrs: {
      "name": "value"
    }
  }, [_c('div', {
    staticClass: "flex-grid__g-7"
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "min": "0.00",
      "name": "value"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value') && _vm.include
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.label) + " is required and must be greater than £0.00\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  })])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.include),
      expression: "include"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.include = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])])
},staticRenderFns: []}

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of DIY/Services — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is calculated applying (i) an average annual figure from claims of a similar type, and (ii) assuming loss from date of onset of symptoms to death. Where there is insufficient data within the tool to derive an average annual loss then this is assessed at £1,500.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-margin-top-30"
  }, [_c('control', {
    attrs: {
      "label": 'Period ' + (_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodStart),
      callback: function($$v) {
        _vm.periodStart = $$v
      },
      expression: "periodStart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeFirstDay),
      expression: "includeFirstDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeFirstDay) ? _vm._i(_vm.includeFirstDay, null) > -1 : (_vm.includeFirstDay)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeFirstDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeFirstDay = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeFirstDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeFirstDay = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include first day")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodStart') || !_vm.startPeriodValid()
    }
  }, [_vm._v("\n                    Care period must start after the onset of symptoms (" + _vm._s(_vm.theDeceased.onsetOfSymptoms) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.periodStartIsBeforeAttendanceRates()
    }
  }, [_vm._v("\n                    Care period data is unavailable prior to April 1st 2009\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEnd || !_vm.periodStartIsBeforeEnd()
    }
  }, [_vm._v("\n                    Start of care period must be before end of care period\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodEnd),
      callback: function($$v) {
        _vm.periodEnd = $$v
      },
      expression: "periodEnd"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeLastDay),
      expression: "includeLastDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeLastDay) ? _vm._i(_vm.includeLastDay, null) > -1 : (_vm.includeLastDay)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeLastDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeLastDay = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeLastDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeLastDay = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include last day")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodEnd') || !_vm.endPeriodValid()
    }
  }, [_vm._v("\n                    Period end date must be before " + _vm._s(_vm.theDeceased.dateOfDeath) + "\n                ")])], 1)])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Hours per Day"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hoursPerDay),
      expression: "hoursPerDay"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "hours_per_day",
      "required": "",
      "min": "0",
      "max": "24",
      "type": "number"
    },
    domProps: {
      "value": (_vm.hoursPerDay)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.hoursPerDay = $event.target.value
      }, _vm.calcRate]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("at")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }],
    attrs: {
      "id": "method",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcRate]
    }
  }, [_c('option', {
    attrs: {
      "value": "basic"
    }
  }, [_vm._v("Basic Rate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "aggregate"
    }
  }, [_vm._v("Aggregate")])])])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gratuitous Care Discount"
    }
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gratuitousCare),
      expression: "gratuitousCare"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gratuitousCare) ? _vm._i(_vm.gratuitousCare, null) > -1 : (_vm.gratuitousCare)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.gratuitousCare,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gratuitousCare = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gratuitousCare = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.gratuitousCare = $$c
        }
      }, _vm.calcRate]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Applies the 'conventional 25% discount' to reflect the gratuitous nature of care.")])])]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubtotal),
      expression: "showSubtotal"
    }],
    attrs: {
      "for": "sub_total",
      "label": "Subtotal",
      "before-after": "pound",
      "tip-icon": _vm.subTotalIcon,
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "sub_total",
      "modal-name": 'subTotal_' + _vm.uniqueId,
      "endpoint": 'detailedCare',
      "payload": {
        period: this.findPeriod(this.index)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodTotal),
      expression: "periodTotal"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.periodTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodTotal = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showDelete) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deletePeriod
    }
  }, [_vm._v("Delete This Period")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr--margin-bottom"
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'subTotal_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Resources and Tools",
      "set-position": "relative",
      "load-button": true,
      "create-button": true,
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-resources-and-tools",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "o-content__mob-main-column"
  }, [_c('router-link', {
    attrs: {
      "to": '/resources-and-tools/documents'
    }
  }, [_c('h2', [_vm._v("Documents")])])], 1), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__save"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "save_day_one_fatal"
    }
  }, [_c('button', {
    staticClass: "a-button"
  }, [_vm._v("\n            " + _vm._s(!_vm.exists ? 'Save as new claim' : 'Update Claim') + "\n        ")])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "save_day_one_fatal",
      "no-default-button": "true",
      "wide": ""
    }
  }, [(!_vm.showList) ? _c('div', {
    staticClass: "c-save-as-new-claim"
  }, [_c('h1', [_vm._v("Save your assessment")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exists),
      expression: "!exists"
    }]
  }, [_vm._v("\n                Click the button below to attach this assessment to existing claim\n                or complete the form to save as a new claim\n            ")]), _vm._v(" "), _c('h2', [_vm._v("Claim details")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "for": "claimant_name",
      "label": "Claimant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantName),
      expression: "claimantName"
    }],
    attrs: {
      "type": "text",
      "name": "claimant_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.claimantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_name')
    }
  }, [_vm._v("\n                            The claimant name is required.\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Claimant Solicitors',
      "error-message": 'The claimant solicitor is required.',
      "value": _vm.claimantSolicitors,
      "type": 'claimant_solicitors'
    },
    on: {
      "update": _vm.updateClaimantSolicitors
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimant_reference",
      "label": "Claimant Solicitors Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantReference),
      expression: "claimantReference"
    }],
    attrs: {
      "type": "text",
      "name": "claimant_reference",
      "required": ""
    },
    domProps: {
      "value": (_vm.claimantReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_reference')
    }
  }, [_vm._v("\n                            The claimant solicitors reference name is required.\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "your_reference",
      "label": "Your Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.yourReference),
      expression: "yourReference"
    }],
    attrs: {
      "type": "text",
      "name": "your_reference",
      "required": ""
    },
    domProps: {
      "value": (_vm.yourReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('your_reference')
    }
  }, [_vm._v("\n                            Your reference is required\n                        ")])], 1), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Defendant Name',
      "error-message": 'The defendant name is required.',
      "value": _vm.defendantName,
      "type": 'defendant'
    },
    on: {
      "update": _vm.updateDefendant
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorMessage),
      expression: "showErrorMessage"
    }]
  }, [_vm._v("\n                        All fields are required.\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small a-button--loader-button",
    class: [_vm.isSaving ? 'a-loader--white' : ''],
    attrs: {
      "disabled": !_vm.updateValid()
    },
    on: {
      "click": _vm.doSave
    }
  }, [_c('span', {
    class: [_vm.isSaving ? 'a-button--span-hidden' : '']
  }, [_vm._v(_vm._s(_vm.exists ? "Update" : "Save"))])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.routeToClaim
    }
  }, [_vm._v("Open as Claim\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.openSummaryDocument
    }
  }, [_vm._v("Download Day\n                        One Summary\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.toggleClaimList
    }
  }, [_vm._v("\n                        Attach to existing claim\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.exists) ? _c('p', [_c('span', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("Save your claim before you can download the summary.")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showList) ? _c('div', {
    staticClass: "c-attached-to-existing"
  }, [_c('a', {
    staticClass: "u-float-r u-cursor-pointer",
    on: {
      "click": _vm.toggleClaimList
    }
  }, [_vm._v("\n                Return to save new claim\n            ")]), _vm._v(" "), _c('claim-table', {
    on: {
      "select": _vm.attachToClaim
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-generate-schedule"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-overview-box flex-grid flex-grid--reduced-bottom-margin-slight u-position-relative"
  }, [_c('div', {
    staticClass: "box u-d-flex flex-grid--wrap u-flex-wrap"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "BC Legal - ABC Quantum",
      "set-position": "fixed",
      "load-button": true,
      "save-button": true,
      "create-button": true,
      "current": this.current,
      "set-border": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie u-position-relative",
    attrs: {
      "id": "app"
    }
  }, [(_vm.isVisible()) ? _c('div', [_c('timeline', {
    attrs: {
      "steps": this.steps,
      "current": this.current,
      "stepNo": this.stepNo,
      "timeline-steps": "eight"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content__mob-main-column"
  }, [_c('router-view')], 1)], 1) : _c('div', {
    staticClass: "a-loader--big__container"
  }, [_c('div', {
    staticClass: "a-loader--big"
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-policy"
  }, [_c('h2', [_vm._v("\n        Privacy Policy\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        TBA.\n    ")])])
}]}

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one-reserving-simple"
  }, [(_vm.calculating) ? _c('div', {
    staticClass: "a-loader--big"
  }) : (!_vm.hasResults) ? _c('div', [_c('h2', {
    staticClass: "u-margin-top-10 u-margin-bottom-10"
  }, [_vm._v("Your Results")]), _vm._v(" "), _c('p', [_vm._v("Your results will appear here once all mandatory fields have been completed.")])]) : _c('div', [_c('accordion', [_c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Facts & Figures")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('td', [_vm._v("Age at Onset")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v(_vm._s(_vm.results.calculation.ageAtOnset))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Age at Assumed Death ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.ageAtAssumedDeath, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Age at Assumed Settlement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.ageAtAssumedSettlement, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("'But for' Expected Age at End of Life")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.ageAtExpectedEndOfLife, 2)) + " ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Period Between Onset and Assumed Date of Death ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.periodBetweenOnsetAssumedDod, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                 Loss of Income Ogden Table 36 multiplier\n                                "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneTable28Multiplier",
      "type": "lost"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.table28Multiplier, 2)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "u-position-relative"
  }, [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Assumptions")]), _vm._v(" "), _c('div', {
    staticClass: "p-day-one__tooltip-modal"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "assumptions_overview"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view assumptions",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "p-day-one__tooltip-modal--assumptions-list"
  }, [_c('li', [_vm._v("\n                            Claimant had normal life expectancy as per the 0% column Ogden Table\n                            " + _vm._s(_vm.gender === 'male' ? 1 : 2) + "\n                        ")]), _vm._v(" "), (_vm.employmentType === 'employed') ? _c('li', [_vm._v("\n                            The claimant will retire at the state pension age. As the claimant was born on\n                            " + _vm._s(_vm.dateOfBirth) + " this is\n                            assumed to be on " + _vm._s(_vm.results.calculation.retirementDate) + " at age " + _vm._s(_vm.retirementAge) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Past loss of income will commence in full from the date of onset of symptoms")]), _vm._v(" "), _c('li', [_vm._v("Typical heads of loss are applied as follows:\n                            "), _c('ul', {
    staticClass: "sub"
  }, [_c('li', [_vm._v("General damages (PSLA) " + _vm._s(_vm.currencyFormat(_vm.results.damages.generalDamages)))]), _vm._v(" "), _c('li', [_vm._v("Care " + _vm._s(_vm.currencyFormat(_vm.results.damages.care)))]), _vm._v(" "), _c('li', [_vm._v("\n                                    Miscellaneous (medication, travel, appliances, additional food & energy\n                                    costs) " + _vm._s(_vm.currencyFormat(_vm.results.damages.miscellaneous)) + "\n                                ")])])]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('div', [_c('li', [_vm._v("The future loss of income multiplier is based on Ogden Table 36")]), _vm._v(" "), _c('li', [_vm._v("The dependency multiplicand on services is assesed at £1,500")]), _vm._v(" "), _c('li', [_vm._v("Loss of pension is assessed at £10,000 per annum")])]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "u-position-relative"
  }, [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Total Damages")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Heads of Loss")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Valuation")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        General Damages (PSLA)\n                                    ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Past Loss of Income to Date of Trial\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOnePastLossOfEarnings",
      "type": "lost"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.pastLossOfEarnings)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Past Cost of DIY/Services\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOnePastCostOfServices",
      "type": "lost"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.pastCostOfDiy)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Miscellaneous (treatments/increased utilities/clothing/foods/appliances &\n                                        equipment)\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneMiscellaneousCalc",
      "type": "lost"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.miscellaneous)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Care\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneCostOfCare",
      "type": "lost"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.care)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Future Cost of DIY/Services\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneFutureCostOfServices",
      "type": "lost"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.futureCostOfDiy)))])]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Future Loss of Income and Pension Post-Trial & Lost Years\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneDependencyOnIncome",
      "type": "lost"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.dependencyOnIncome)))])]) : _vm._e()]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addHeadOfLoss
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.ownHeadsOfLoss.length ?
    'Add another head of loss' : 'Click here to add your own head of loss') + "\n                                    ")])])]), _vm._v(" "), _vm._l((_vm.ownHeadsOfLoss), function(head, index) {
    return _c('own-head-of-loss', {
      attrs: {
        "head-of-loss": head,
        "index": index,
        "type": "lost"
      }
    })
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Total Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalDamages)))])])])])])])], 1), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Total Reserve")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Total Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalDamages)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Claimant Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": _vm.claimantCosts
    },
    on: {
      "input": _vm.updateClaimantCosts
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Defence Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": _vm.defenceCosts
    },
    on: {
      "input": _vm.updateDefenceCosts
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.damagesContribution
    },
    on: {
      "input": _vm.updateDamagesContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Claimant Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.claimantContribution
    },
    on: {
      "input": _vm.updateClaimantContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Defence Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.defenceContribution
    },
    on: {
      "input": _vm.updateDefenceContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Damages Reserve (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedDamagesReserve)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Claimant Costs (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedClaimantReserve)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Defence Costs (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedDefenceReserve)))])])]), _vm._v(" "), _c('tfoot', [_c('tr', {}, [_c('td', [_vm._v("Total Reserve")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalReserve)))])])])])]), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Compare Your Claim")]), _vm._v(" "), _c('div', {
    staticClass: "p-day-one-reserving-simple__compare-your-claim"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "compare_your_claim"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view compare details",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1), _vm._v(" "), _c('reserve-performance-chart', {
    attrs: {
      "slot": "if-slot"
    },
    slot: "if-slot"
  })], 1)], 1), _vm._v(" "), _c('day-one-save'), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.openSummaryDocument
    }
  }, [_vm._v("\n            Download Summary\n        ")]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "assumptions_overview",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("Assumptions")]), _vm._v(" "), _c('accordion', [_c('past-services-modal', {
    attrs: {
      "value": _vm.results.damages.pastCostOfDiy
    }
  }), _vm._v(" "), _c('past-loss-earnings-modal', {
    attrs: {
      "value": _vm.results.damages.pastLossOfEarnings
    }
  }), _vm._v(" "), _c('psla-modal', {
    attrs: {
      "age": _vm.assumedLifeExpectancy.ageAtDeath,
      "duration": _vm.durationOfSymptoms,
      "value": _vm.results.damages.generalDamages
    }
  }), _vm._v(" "), _c('care-modal', {
    attrs: {
      "value": _vm.results.damages.care,
      "person": _vm.modalPayload.person,
      "claim": _vm.modalPayload.claim,
      "type": _vm.estateOrDependency
    }
  }), _vm._v(" "), _c('misc-modal', {
    attrs: {
      "value": _vm.results.damages.miscellaneous
    }
  }), _vm._v(" "), _c('loss-of-income-modal', {
    attrs: {
      "value": _vm.results.damages.dependencyOnIncome
    }
  })], 1)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "calculation_modal",
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "psla_modal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n                General Damages\n            ")]), _vm._v(" "), _c('psla-modal-content', {
    attrs: {
      "age": _vm.assumedLifeExpectancy.ageAtDeath,
      "duration": _vm.durationOfSymptoms,
      "value": _vm.results.damages.generalDamages
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "compare_your_claim",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n                Compare your claims\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Using the information you have provided we have attempted to match claims with similar\n                characteristics from your book of claims.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                To determine a match we have looked for claims that match:\n                "), _c('ul', [_c('li', [_vm._v("Disease type: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.diseaseType))])]), _vm._v(" "), _c('li', [_vm._v("Claim type: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v("Lost Years")])]), _vm._v(" "), _c('li', [_vm._v("Deceased Gender: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.gender === 'male' ? 'Male' : 'Female'))])])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalContent.length === 0) ? _c('div', {
    staticClass: "a-loader--modal"
  }) : _c('div', _vm._l((_vm.modalContent), function(data) {
    return _c('div', _vm._l((data), function(value, key) {
      return _c(key, {
        tag: "component",
        attrs: {
          "data": value
        }
      })
    }), 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of Care\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Cost of Care",
      "subtitle": "Attendance Allowance",
      "store-key": "pcocAttendanceAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Cost of Care",
      "subtitle": "Disability Living Allowance (care component)",
      "store-key": "pcocDisabilityLivingAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Cost of Care",
      "subtitle": "Industrial Injuries Disablement Benefit increase for Constant Attendance Allowance or Exceptionally Severe Disablement Allowance",
      "store-key": "pcocIndustrialInjuriesDisablementBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Cost of Care",
      "subtitle": "Personal Independence Payment (living component)",
      "store-key": "pcocPersonalIndependencePayment",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimantForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "for": "claimantName",
      "label": "Claimant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "field-control",
      rawName: "v-field-control:claimantName.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "claimantName",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "claimantName",
      "id": "claimantName",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimantName')
    }
  }, [_vm._v("\n                        The claimant name is required and must be a valid name\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimant_gender",
      "label": "Claimant Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "required": "",
      "name": "claimant_gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_gender')
    }
  }, [_vm._v("\n                        The claimant's gender is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimant_date_of_birth",
      "label": "Claimant Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claimant_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "claimant_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "min": _vm.minDateOfBirth
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_date_of_birth')
    }
  }, [_vm._v("\n                        The claimant's date of birth is required and must be in the format DD/MM/YYYY.\n                        Claimant must be at least 16 at date of assumed settlement.\n                    ")])], 1), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Claimant Solicitors',
      "error-message": 'The claimant solicitor is required and must be a valid name',
      "value": _vm.claimantSolicitor,
      "type": 'claimant_solicitors'
    },
    on: {
      "update": _vm.updateClaimantSolicitors
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimaint_reference",
      "label": "Claimant Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantReference),
      expression: "claimantReference"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    staticClass: "input",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "maxlength": "100",
      "name": "claimaint_reference",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimantReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimaint_reference')
    }
  }, [_vm._v("\n                        The claimant reference is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "type_of_injury",
      "label": "Type of Injury"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.injuryType),
      expression: "injuryType"
    }],
    attrs: {
      "required": "",
      "name": "type_of_injury"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.injuryType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('type_of_injury')
    }
  }, [_vm._v("\n                        The claimant's injury type is required\n                    ")])], 1), _vm._v(" "), (_vm.injuryType === 'Other') ? _c('control', {
    attrs: {
      "name": "injury_type_other",
      "label": "Injury Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.injuryTypeOther),
      expression: "injuryTypeOther"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "injury_type_other",
      "id": "injury_type_other",
      "required": ""
    },
    domProps: {
      "value": (_vm.injuryTypeOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.injuryTypeOther = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('injuryTypeOther') || _vm.injuryTypeOther === null
    }
  }, [_vm._v("\n                        The claimant's injury type is required\n                    ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Defendant Name',
      "error-message": 'The defendant name is required and must be a valid name',
      "value": _vm.defendantName,
      "type": 'defendant'
    },
    on: {
      "update": _vm.updateDefendant
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "your_reference",
      "label": "Your Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yourReference),
      expression: "yourReference"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "your_reference",
      "maxlength": "30",
      "type": "text"
    },
    domProps: {
      "value": (_vm.yourReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('your_reference')
    }
  }, [_vm._v("\n                        Your reference is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_injury",
      "label": "Date of Injury / Accident"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_injury.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_injury",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfInjury),
      callback: function($$v) {
        _vm.dateOfInjury = $$v
      },
      expression: "dateOfInjury"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_injury')
    }
  }, [_vm._v("\n                        Date of Injury/Accident is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showDateInjuryInvalid
    }
  }, [_vm._v("\n                        Date of Injury/Accident cannot be in the future\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showdateOfInjuryAfterBirth
    }
  }, [_vm._v("\n                        Date of Injury/Accident must be after the date of birth\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pre_lit_or_lit",
      "label": "Procedural Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preLitOrLit),
      expression: "preLitOrLit"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "pre_lit_or_lit",
      "id": "pre_lit_or_lit",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preLitOrLit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre-lit"
    }
  }, [_vm._v("Pre-Litigation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "litigated"
    }
  }, [_vm._v("Litigated")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pre_lit_or_lit')
    }
  }, [_vm._v("\n                        Procedural status is required\n                    ")])], 1), _vm._v(" "), (_vm.preLitOrLit == 'litigated') ? _c('control', {
    attrs: {
      "for": "date_of_service_proceedings",
      "label": "Date of Service of Proceedings"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_service_proceedings.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_service_proceedings",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfServiceProceedings),
      callback: function($$v) {
        _vm.dateOfServiceProceedings = $$v
      },
      expression: "dateOfServiceProceedings"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_service_proceedings') || _vm.showServiceOfProceedingsValidationMessage_required
    }
  }, [_vm._v("\n                        Date of service of proceedings is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showServiceOfProceedingsValidationMessage_before
    }
  }, [_vm._v("\n                        Date of service of proceedings must be before the date of assumed settlement\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showServiceOfProceedingsValidationMessage_9years
    }
  }, [_vm._v("\n                        Date of service of proceeding cannot be more than 9 years before the date of assumed\n                        settlement\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement')
    }
  }, [_vm._v("\n                        Date of assumed settlement is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showDateOfAssumedSettlementValidationMessage_after
    }
  }, [_vm._v("\n                        Date of assumed settlement must be after the date of injury or accident\n                    ")]), _vm._v(" "), _c('control-warning', {
    attrs: {
      "show": _vm.dateOfAssumedSettlementInPast
    }
  }, [_c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-warning-box__orange"
  }, [_vm._v("Date of assumed settlement is in the past")])])], 1)], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_rate",
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('discount_rate')
    }
  }, [_vm._v("\n                        Discount rate is required\n                    ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs flex-grid__item--full"
  }, [_c('control', {
    attrs: {
      "for": "claim_narrative",
      "label": "Claim Narrative",
      "tip-text": "Provide a brief background to the claim and issues in dispute. This narrative will populate your counter-schedule of loss.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "claim_narrative"
    }
  }, [_c('textarea', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claim_narrative.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "claim_narrative",
      modifiers: {
        "required": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.claimNarrative),
      expression: "claimNarrative"
    }],
    staticClass: "u-full-width",
    attrs: {
      "required": "",
      "rows": "4",
      "name": "claim_narrative"
    },
    domProps: {
      "value": (_vm.claimNarrative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimNarrative = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claim_narrative')
    }
  }, [_vm._v("\n                    The claim narrative is required\n                ")])], 1)], 1)]), _vm._v(" "), _c('step-button', {
    attrs: {
      "prev-valid": false,
      "next-valid": _vm.isValid()
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "InterimPaymentsForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_vm._m(0), _vm._v(" "), (_vm.interimPayments.length === 0) ? _c('p', [_vm._v("\n                    Add details of any Interim Payments using the button below:\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.interimPayments), function(interimPayment, index) {
    return _c('div', {
      staticClass: "dependant a-form-inputs--section"
    }, [_c('payment', {
      attrs: {
        "index": index
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addPayment
    }
  }, [_vm._v("Add Interim Payment")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "a-form-inputs"
  }, [_vm._m(1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Calculate Interest Rates to"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestType),
      expression: "interestType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcInterestValue]
    }
  }, [_c('option', {
    attrs: {
      "value": "today"
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_settlement"
    }
  }, [_vm._v("Assumed Settlement")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Custom")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Do Not Calculate")])])]), _vm._v(" "), (_vm.interestType === 'custom') ? _c('control', {
    attrs: {
      "label": "Custom date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "required": _vm.interestType === 'custom'
    },
    on: {
      "input": _vm.calcInterestValue
    },
    model: {
      value: (_vm.customInterestDate),
      callback: function($$v) {
        _vm.customInterestDate = $$v
      },
      expression: "customInterestDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('div', {
    staticClass: "m-div-table__holder m-div-table__holder--less-margin"
  }, [_c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('generalDamagesInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'generalDamages'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('generalDamagesWithInterest'),
      "tip-name": "general_damages_psla",
      "title": "General damages (PSLA)",
      "updates": "generalDamages"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('pastDependencyOnServicesInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'pastDependencyOnServices'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('pastDependencyOnServicesWithInterest'),
      "tip-name": "past_dependency_on_services",
      "title": "Past Cost of Services",
      "updates": "pastDependencyOnServices"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('pastLossOfEarningsInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'pastLossOfEarnings'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('pastLossOfEarningsWithInterest'),
      "tip-name": "past_loss_of_earnings",
      "title": "Past Loss of Earnings",
      "updates": "pastLossOfEarningsInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "name": "pastCostOfCare",
      "interest": _vm.getHeadsOfLossValue('pastCostOfCareInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'pastCostOfCare'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('pastCostOfCareWithInterest'),
      "tip-name": "past_cost_of_care",
      "title": "Past Cost of Care",
      "updates": "pastCostOfCareInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('pastCostOfTravelInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'pastCostOfTravel'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('pastCostOfTravelWithInterest'),
      "tip-name": "past_cost_of_travel",
      "title": "Past Cost of Travel",
      "updates": "pastCostOfTravelInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('miscInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'misc'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('miscWithInterest'),
      "tip-name": "miscellaneous",
      "title": "Miscellaneous",
      "updates": "miscellaneous"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _vm._l((_vm.allCustomHeadOfLoss), function(headOfLoss, key) {
    return _c('interest-item', {
      attrs: {
        "interest": headOfLoss.interest,
        "payload": _vm.payload,
        "option": {
          name: headOfLoss.name,
          key: key
        },
        "title": headOfLoss.name,
        "unique-id": _vm.uniqueId,
        "updates": key,
        "value": headOfLoss.interestAccrued,
        "tip-name": headOfLoss.name
      },
      on: {
        "update": _vm.onUpdateCustom
      }
    })
  })], 2)])], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid() && _vm.allInterimPaymentsValid
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'interest_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Interim Payments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Interest")])])
}]}

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('pre-accident-earnings', {
    on: {
      "update": _vm.updatePreAccidentEarnings
    }
  }), _vm._v(" "), (_vm.preAccidentEarnings && _vm.preAccidentEarningsValid && !_vm.ownPastLosses) ? _c('div', [_c('h2', {
    staticClass: "u-margin-bottom-40"
  }, [_vm._v("Post-accident Earnings")]), _vm._v(" "), _vm._l((_vm.getPostInjuryIncomePeriods), function(period, index) {
    return _c('post-accident-earnings', {
      attrs: {
        "index": index,
        "period": period,
        "maxIndex": _vm.getPostInjuryIncomePeriods.length
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.addIncomePeriod('postInjury')
      }
    }
  }, [_vm._v("Add Period")])], 2) : _vm._e(), _vm._v(" "), (_vm.preAccidentEarnings && _vm.preAccidentEarningsValid && _vm.postInjuryIncomePeriodsValid && !_vm.ownPastLosses) ? _c('div', [_c('past-loss-of-earnings-calculator')], 1) : _vm._e(), _vm._v(" "), _c('step-button', {
    staticClass: "u-margin-top-40",
    attrs: {
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "custom-chart-container p-compare-reserves__d3 u-position-relative"
  }, [_c('div', {
    ref: "tooltip",
    staticClass: "chart-tooltip"
  }, [_c('strong', [_vm._v("TITLE")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("COUNT")]), _vm._v(" claims\n    ")]), _vm._v(" "), _c('svg', {
    ref: "svg",
    staticClass: "custom-chart",
    attrs: {
      "height": _vm.height,
      "width": _vm.width
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Dependency Multiplicand",
      "icon": "dependency-multiplicand"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_income",
      "label": "Deceased Net income",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.deceasedNetIncome),
      expression: "deceasedNetIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:deceased_income.required",
      value: ({
        type: 'number',
        min: 0
      }),
      expression: "{type:'number', min: 0}",
      arg: "deceased_income",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "deceasedNetIncome",
    attrs: {
      "autocomplete": "off",
      "name": "deceased_income",
      "id": "deceasedIncome",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.deceasedNetIncome)
    },
    on: {
      "focus": function($event) {
        _vm.deceasedNetIncome = _vm.deceasedNetIncome || ''
      },
      "blur": [function($event) {
        _vm.deceasedNetIncome = _vm.deceasedNetIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deceasedNetIncome = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_income')
    }
  }, [_vm._v("\n                    The Deceased Net income is required and must be a valid amount\n                ")])], 1), _vm._v(" "), _vm._l((_vm.getValue('dependants')), function(item, index) {
    return _c('dependant-income', {
      ref: 'dependentIncome' + index,
      refInFor: true,
      attrs: {
        "reference": 'dependentIncome' + index,
        "showAddButton": true,
        "columnTwo": true,
        "index": index
      },
      on: {
        "deleteDependant": function($event) {
          return _vm.removeDependant(index)
        },
        "addNewDependant": _vm.addDependant
      }
    })
  }), _vm._v(" "), _c('label', [_vm._v("\n                Multiplicand\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "p-dependency-calc__slider"
  }, [_c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 1,
      "max": 100,
      "real-time": true,
      "clickable": true,
      "piecewise": true,
      "process-style": {
        'backgroundColor': '#4A89E5'
      },
      "tooltip-style": {
        'backgroundColor': '#4A89E5',
        'borderColor': '#4A89E5'
      },
      "formatter": _vm.vueSliderFormatter,
      "label-style": {
        'color': '#fff'
      }
    },
    model: {
      value: (_vm.multiplicand),
      callback: function($$v) {
        _vm.multiplicand = $$v
      },
      expression: "multiplicand"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.resetMultiplicand
    }
  }, [_vm._v("\n                Reset Multiplicand\n            ")]), _vm._v(" "), _c('h2', [_vm._v("Result")]), _vm._v(" "), _c('control', {
    attrs: {
      "before-after": "pound-on-dark",
      "label": "Dependency Multiplicand"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "name": "deceased_income",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.total)
    }
  })])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The dependency multiplicand has been calculated as " + _vm._s(_vm.currencyFormat(_vm.getValue('total'))) + " based on the following:\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The deceased was earning " + _vm._s(_vm.currencyFormat(_vm.deceasedNetIncome)) + " per annum.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                There\n                " + _vm._s(_vm.getValue('dependants').length == 1 ? 'was one dependant' : 'are ') + "\n                " + _vm._s(_vm.getValue('dependants').length == 1 ? _vm.getValue('dependants').length + ' dependants' : '') + "\n                with the following income(s):\n            ")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, _vm._l((_vm.getValue('dependants')), function(item, index) {
    return _c('li', [_vm._v("\n                    Dependant " + _vm._s(index + 1) + " - " + _vm._s(_vm.currencyFormat(item.income)) + "\n                ")])
  }), 0), _vm._v(" "), _c('p', [_vm._v("\n                And the multiplicand is set at " + _vm._s(_vm.multiplicand) + "%\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The following formula was used to calculate the dependency multiplicand:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_vm._v("\n                    " + _vm._s(_vm.vueSliderFormatter(_vm.multiplicand)) + " x ([Deceased Income] + [Dependant Income]) - [Dependant Income]\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tree !== null) ? _c('h2', [_vm._v("Award - " + _vm._s(_vm.awardIndex + 1))]) : _vm._e(), _vm._v(" "), (_vm.tree !== null && _vm.awardIndex > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "-48px",
      "margin-left": "120px",
      "margin-bottom": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.removeTheAward()
      }
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "period-delete",
      "tooltip-text": "To delete this award just select this icon.",
      "side": "right",
      "text-width": "200",
      "icon-type": "delete",
      "icon-colour": "m-icon--dark"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tree !== null) ? _c('injury-select', {
    attrs: {
      "tree": _vm.tree,
      "selected": _vm.selected,
      "awardIndex": _vm.awardIndex,
      "level": 0
    },
    on: {
      "injury-selected": _vm.selectedInjury,
      "award-selected": _vm.selectedAward
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'a-loader--generalDamages': _vm.tree === null
    }
  }), _vm._v(" "), (_vm.tree !== null && _vm.award.generalDamages) ? _c('hr') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-discount-rate-update"
  }, [_c('h2', [_vm._v("\n        Claims Preview\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, [_c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('discount-rate-options')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-1"
  }, [(_vm.discountRatesOptions) ? _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "discount-rate-warning"
    }
  }, [(_vm.claimsToBeUpdatedTotal > 1) ? _c('button', {
    staticClass: "a-button a-button--small u-no-margin"
  }, [_vm._v("\n                    Apply\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.claimsToBeUpdatedTotal < 1) ? _c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                Apply\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-your-claims u-no-padding"
  }, [_c('div', {
    staticClass: "p-your-claims__table-container"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width your-claims-table p-your-claims__table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', [_c('div', {
    staticClass: "a-checkbox p-discount-rate-update__select-all-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "all",
      "checked": ""
    },
    on: {
      "change": _vm.selectAll
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Value at New Current Discount Rate (" + _vm._s(_vm.discountRates[_vm.updateDiscountRate]) + ")\n                        ")])]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.data), function(claim, index) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "a-checkbox u-margin-top-10"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": "claimId"
      },
      domProps: {
        "value": claim.id,
        "checked": claim.selected
      },
      on: {
        "click": function($event) {
          return _vm.updateSelected(claim.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ""
      }
    })])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.yourReference) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.humanClaimType) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.claimantName) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.defendantName) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.discountRate) + "%\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(claim.headsOfLossTotal)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(claim.headsOfLossPreview)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.showDifference(claim.headsOfLossTotal, claim.headsOfLossPreview))) + "\n                    ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "p-discount-rate-update__total u-margin-top-20"
  }, [_c('h3', [_vm._v("Total Difference For All Claims")]), _vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.totalDifference())) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-center flex-grid--column p-discount-rate-comparison__pie-container u-margin-top-50"
  }, [_c('h3', [_vm._v("Comparison Between Discount Rates")]), _vm._v(" "), _c('pie', {
    attrs: {
      "labels": ['Current Discount Rate', 'New Discount Rate'],
      "dataset": _vm.dataset(),
      "total": _vm.totalDifference(),
      "totalText": "Total Difference"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "values": [
        'Current Discount Rate',
        'New Discount Rate'
      ],
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "30",
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "discount-rate-warning",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("Warning")]), _vm._v("\n        You are about the change the discount rate to " + _vm._s(_vm.discountRates[_vm.updateDiscountRate]) + " on " + _vm._s(_vm.claimsToBeUpdatedTotal) + " claim(s)."), _c('br'), _c('br'), _vm._v("\n        This process can take several minutes "), _c('br'), _c('br'), _vm._v("\n        In this time you will not be able to use this feature or update the discount rate until this process has finished. "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    on: {
      "click": _vm.startUpdateDiscountRate
    }
  }, [_vm._v("Apply")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Your Reference\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Claim Type\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Claimant Name\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Defendant Name\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Current Discount Rate\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Current Value\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Difference\n                        ")])])
}]}

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Care Calculator",
      "icon": "care-calculator"
    }
  }), _vm._v(" "), _vm._l((_vm.periods), function(period, index) {
    return _c('care-period', {
      attrs: {
        "index": index,
        "period": period
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": _vm.addCarePeriod
    }
  }, [_vm._v("\n                Add Care Period\n            ")]), _vm._v(" "), _c('h2', [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "sub_total",
      "label": "Total",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.total, '')
    }
  })])], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showExplanation),
      expression: "showExplanation"
    }],
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('modal', {
    attrs: {
      "name": "care-rates",
      "noDefaultButton": true
    }
  }, [_c('h1', [_vm._v("\n                    Care and Attendance Rates\n                ")]), _vm._v(" "), (!_vm.isLoading()) ? _c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Basic")]), _vm._v(" "), _c('th', [_vm._v("Aggregate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rates), function(careRate, date) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatModalDate(date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(careRate.basic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(careRate.aggregate))])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("Explanation")]), _vm._v(" "), _vm._l((_vm.periods), function(period, index) {
    return _c('div', [_c('h2', [_vm._v("Period " + _vm._s(index + 1))]), _vm._v(" "), _c('p', [_vm._v("\n                    The total cost of care for the period between "), _c('strong', [_vm._v(_vm._s(_vm.getPeriodStart(period)))]), _vm._v(" and\n                    "), _c('strong', [_vm._v(_vm._s(_vm.getPeriodEnd(period)))]), _vm._v(", at the "), _c('strong', [_vm._v(_vm._s(period.rate))]), _vm._v(" rate, for\n                    "), _c('strong', [_vm._v(_vm._s(period.hoursPerDay) + " hour" + _vm._s(period.hoursPerDay === 1 ? '' : 's'))]), _vm._v(" per day has\n                    been calculated to be "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(period.total)))]), _vm._v(".\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    This has been calculated using the formula:\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "m-formula"
    }, [_c('div', {
      staticClass: "m-formula__item--row"
    }, [_c('strong', [_vm._v("\n                            [Total Hours] x [Care Rate] = [Total Cost of Care]\n                        ")])])]), _vm._v(" "), _vm._l((period.table[0]), function(table) {
      return (period.table[0].length == 1) ? _c('p', [_vm._v("\n                    Where the total number of hours is "), _c('strong', [_vm._v(_vm._s(table.totalHours))]), _vm._v(" and the\n                    " + _vm._s(period.rate) + " care rate is taken as\n                    "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(table.rates[period.rate])))]), _vm._v(".\n                ")]) : _vm._e()
    }), _vm._v(" "), (period.table[0].length > 1) ? _c('p', [_vm._v("\n                    As the care period spans multiple recommended rates for care and attendance, each period must be broken\n                    down and totalled up individually using the appropriate rate for each period. You can view these rates\n                    by clicking "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleCareRatesModal()
        }
      }
    }, [_vm._v("here")]), _vm._v(".\n                ")]) : _vm._e(), _vm._v(" "), (period.gratuitousCare) ? _c('p', [_vm._v("\n                    Since you have specified that the care provided was gratuitous (provided by a family member or friend\n                    without charge), a discount of 25% must be applied to the above total figure. The resulting total cost\n                    of care is therefore: "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(period.total)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "a-table a-table--short-no-style a-table--full-width"
    }, [(period.table[0].length > 0) ? _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                                Period Start\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Period End\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Total Days\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Total Hours\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                " + _vm._s(period.rate.charAt(0).toUpperCase() + period.rate.slice(1)) + " Rate\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Total\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((period.table[0]), function(table) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDate(table.start.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(table.end.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table.totalDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table.totalHours))]), _vm._v(" "), _c('td', [_vm._v("\n                                £" + _vm._s(_vm.twoDp(!period.gratuitousCare ? table.rates[period.rate] : table.rates[period.rate] * 0.75)) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(table.total)) + "\n                            ")])])
    }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "5"
      }
    }), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(period.total)) + "\n                            ")])])])]) : _vm._e()])], 2)
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Claim Status\n        ")]), _vm._v(" "), _c('claim-status')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Claim Type\n        ")]), _vm._v(" "), _c('claim-type')], 1), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Disease or Accident\n        ")]), _vm._v(" "), _c('disease-or-accident')], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Disease Type\n        ")]), _vm._v(" "), _c('disease-type')], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident' || _vm.claimType === 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Accident Type\n        ")]), _vm._v(" "), _c('accident-type')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Gender\n        ")]), _vm._v(" "), _c('gender')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "search_individual_claim",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("\n        Search an individual claim\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Please enter claimant reference or name to search claims\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__g-4 u-flex-grow-none"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-2 u-flex-grow-none"
  }, [_c('button', {
    staticClass: "a-button a-button--small u-no-margin"
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('th', [_vm._v("Your Reference")]), _vm._v(" "), _c('th', [_vm._v("Claim Type")]), _vm._v(" "), _c('th', [_vm._v("Claimant Name")]), _vm._v(" "), _c('th', [_vm._v("Defendant Name")]), _vm._v(" "), _c('th', [_vm._v("Claimant Solicitor")]), _vm._v(" "), _c('th', [_vm._v("Updated At")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('icon-tooltip', {
    attrs: {
      "tooltip-text": "load",
      "side": "left",
      "text-width": "100",
      "icon-type": "load"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of Travel\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Cost of Travel",
      "subtitle": "Disability Living Allowance (mobility component)",
      "store-key": "pcotDisabilityLivingAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Cost of Travel",
      "subtitle": "Mobility Allowance",
      "store-key": "pcotMobilityAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Cost of Travel",
      "subtitle": "Personal Independence Payment (mobility component)",
      "store-key": "pcotPersonalIndependencePayment",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-passport"
  }, [_c('passport-icons'), _vm._v(" "), _c('div', {
    staticClass: "p-passport__topbar"
  }, [_c('div', {
    staticClass: "p-passport__loggedout",
    style: (!_vm.getUserId ? 'display: flex' : 'display: none')
  }, [_c('div', {
    staticClass: "p-passport__topbar-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-passport__topbar-right"
  }, [_c('span', {
    staticClass: "p-passport__topbar--text"
  }, [_vm._v(_vm._s(_vm.passportText))]), _vm._v(" "), (!_vm.isPassportOpen) ? _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app p-passport__icon--close",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isPassportOpen) ? _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [(_vm.isPassportOpen) ? _c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app p-passport__icon--close",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#passport"
    }
  })]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__loggedin",
    style: (_vm.getUserId ? 'display: flex' : 'display: none')
  }, [_c('div', {
    staticClass: "p-passport__topbar-left"
  }, [_c('span', {
    staticClass: "p-passport__profile-name"
  }, [_vm._v("\n                    " + _vm._s(_vm.getUserFullName) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__topbar-right"
  }, [_c('div', {
    staticClass: "p-passport__topbar-right-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "https://asbestos.bc-legal.co.uk/?authenticate=" + this.getToken,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app-asbestos",
    attrs: {
      "id": "asbestos",
      "viewBox": "0 0 147.8 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#asbestos"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('a', {
    attrs: {
      "href": 'https://abcnoise.bc-legal.co.uk/?authenticate=' + this.getToken,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app-noise",
    attrs: {
      "id": "noise",
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#noise"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app-quantum",
    attrs: {
      "id": "quantum",
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#quantum"
    }
  })])])]), _vm._v(" "), (!_vm.isPassportOpen) ? _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app p-passport__icon--close",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isPassportOpen) ? _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app p-passport__icon--close",
    attrs: {
      "id": "passport",
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#passport"
    }
  })])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__content",
    style: (this.initialLoad || _vm.checkAuthStatus() ? 'display: flex' : '')
  }, [(_vm.checkAuthStatus()) ? _c('div', [_c('div', {
    staticClass: "p-passport__login"
  }, [_c('svg', {
    staticClass: "p-passport__icon--passport u-margin-top--small u-margin-bottom--small",
    attrs: {
      "height": "70",
      "width": "200",
      "id": "passport",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 305.8 108.7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M34.2 97.4c0 .6-.3 1.2-.8 1.6-.5.4-1.1.7-1.7.7-.4 0-.8-.1-1.2-.4s-.7-.6-.9-1.1l-3.3-7.5H8l-3.3 7.5c-.2.5-.5.8-.9 1.1-.4.3-.8.4-1.3.4-.7 0-1.3-.2-1.8-.7-.5-.4-.8-1-.8-1.6 0-.3.1-.6.3-1l14.1-30.8c.2-.5.6-1 1.1-1.3.5-.3 1.1-.5 1.6-.5s1.1.1 1.6.5c.5.3.9.7 1.1 1.3L34 96.4c.1.4.2.8.2 1zM9.8 86.6h14.7l-7.3-16.5-7.4 16.5zM65 84.3c1.1 1.5 1.7 3.3 1.7 5.5 0 3-1 5.4-3.1 7.1-2.1 1.7-5 2.5-8.7 2.5H42.1c-.8 0-1.4-.2-1.9-.7-.5-.5-.7-1.1-.7-1.8V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12.2c3.6 0 6.5.8 8.5 2.4 2 1.6 3.1 3.9 3.1 6.8 0 1.9-.5 3.5-1.5 4.8-1 1.4-2.4 2.4-4.1 3 2 .7 3.6 1.7 4.7 3.1zm-20.4-4.9h8.9c4.9 0 7.4-1.9 7.4-5.6 0-1.9-.6-3.3-1.8-4.2s-3.1-1.3-5.6-1.3h-8.9v11.1zm15.3 14.5c1.2-.9 1.8-2.4 1.8-4.4 0-2-.6-3.5-1.8-4.5-1.2-1-3.1-1.5-5.6-1.5h-9.7v11.7h9.7c2.6.1 4.4-.4 5.6-1.3zM80 97.7c-2.5-1.4-4.4-3.5-5.8-6.3-1.3-2.7-2-5.9-2-9.6 0-3.7.7-6.9 2-9.6 1.3-2.7 3.3-4.8 5.8-6.3s5.4-2.2 8.8-2.2c2.2 0 4.3.3 6.3 1s3.7 1.7 5.1 3c.6.5 1 1.2 1 2 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.2.6-.6 0-1.1-.2-1.6-.7-1.6-1.2-3.1-2-4.4-2.5-1.3-.5-2.8-.7-4.5-.7-3.7 0-6.5 1.2-8.4 3.6-2 2.4-3 5.8-3 10.2 0 4.5 1 7.9 3 10.3 2 2.4 4.8 3.6 8.4 3.6 1.6 0 3.1-.3 4.4-.8s2.8-1.3 4.5-2.5c.7-.4 1.2-.7 1.6-.7.5 0 .9.2 1.2.6.3.4.5.9.5 1.5 0 .8-.3 1.5-1 2-1.5 1.3-3.2 2.3-5.1 3-2 .7-4 1-6.3 1-3.4.1-6.3-.6-8.8-2zM108 99c-.5-.5-.7-1.1-.7-1.9V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12c3.7 0 6.6.9 8.7 2.8 2.1 1.8 3.1 4.4 3.1 7.8 0 3.3-1 5.9-3.1 7.8-2.1 1.9-5 2.8-8.7 2.8h-9.5v11.8c0 .8-.2 1.4-.7 1.9-.5.5-1.1.7-1.9.7-.7-.1-1.3-.3-1.8-.8zm13.3-17.8c4.9 0 7.4-2.2 7.4-6.5s-2.5-6.4-7.4-6.4h-8.9v12.8h8.9zM156.2 76.9c1.6 1.6 2.4 4.1 2.4 7.5v12.9c0 .8-.2 1.4-.6 1.8-.4.4-1 .6-1.8.6-.7 0-1.3-.2-1.8-.7-.4-.4-.7-1-.7-1.8v-1.8c-.6 1.4-1.6 2.5-2.8 3.2s-2.7 1.1-4.4 1.1c-1.6 0-3.1-.3-4.4-1-1.3-.7-2.4-1.6-3.1-2.7s-1.1-2.5-1.1-3.9c0-1.8.5-3.2 1.4-4.2.9-1 2.4-1.7 4.5-2.2 2.1-.4 5-.7 8.7-.7h1.2v-1.5c0-1.9-.4-3.2-1.2-4-.8-.8-2-1.3-3.7-1.3-1.2 0-2.3.2-3.3.5s-2.2.7-3.4 1.3c-.9.5-1.5.8-1.9.8-.5 0-.9-.2-1.2-.5-.3-.4-.5-.8-.5-1.4 0-.5.1-.9.4-1.3.3-.4.7-.8 1.4-1.1 1.2-.6 2.5-1.1 4.1-1.5 1.6-.4 3.1-.6 4.5-.6 3.3 0 5.7.9 7.3 2.5zm-4.3 17.3c1.2-1.3 1.8-2.9 1.8-4.8V88h-.9c-2.6 0-4.6.1-6 .4-1.4.2-2.4.6-3 1.2-.6.5-.9 1.3-.9 2.4 0 1.2.4 2.2 1.3 3 .9.8 2 1.1 3.3 1.1 1.7-.1 3.2-.7 4.4-1.9zM165.6 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM189.7 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM232.4 76c1.7 1.1 2.9 2.6 3.9 4.5.9 1.9 1.4 4.2 1.4 6.7s-.5 4.7-1.4 6.6c-.9 1.9-2.2 3.4-3.8 4.4-1.7 1-3.5 1.5-5.7 1.5-1.8 0-3.4-.4-4.8-1.2-1.4-.8-2.5-1.9-3.2-3.4v11.2c0 .7-.2 1.3-.7 1.7-.5.4-1 .6-1.8.6s-1.4-.2-1.9-.7-.7-1-.7-1.8V77c0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7s1.3.2 1.8.7c.5.4.7 1 .7 1.8v2c.7-1.5 1.8-2.6 3.2-3.4s3-1.2 4.8-1.2c2.1 0 4 .6 5.7 1.6zm-1.8 17.6c1.2-1.5 1.8-3.6 1.8-6.3 0-2.8-.6-4.9-1.8-6.5-1.2-1.5-2.9-2.3-5.1-2.3-2.2 0-3.9.8-5.1 2.3-1.2 1.5-1.8 3.6-1.8 6.4s.6 4.9 1.8 6.4c1.2 1.5 2.9 2.3 5.1 2.3 2.2-.1 3.9-.9 5.1-2.3zM247.5 98.2c-1.8-1-3.2-2.5-4.2-4.4-1-1.9-1.5-4.1-1.5-6.7 0-2.6.5-4.8 1.5-6.7 1-1.9 2.4-3.4 4.2-4.4 1.8-1 3.9-1.5 6.3-1.5s4.5.5 6.3 1.5c1.8 1 3.2 2.5 4.2 4.4 1 1.9 1.5 4.2 1.5 6.7s-.5 4.8-1.5 6.7c-1 1.9-2.4 3.4-4.2 4.4-1.8 1-3.9 1.5-6.3 1.5-2.4.1-4.5-.4-6.3-1.5zm11.4-4.6c1.2-1.5 1.8-3.6 1.8-6.5 0-2.8-.6-4.9-1.8-6.4s-2.9-2.2-5.1-2.2c-2.2 0-3.9.7-5.1 2.2s-1.8 3.6-1.8 6.4c0 2.8.6 5 1.8 6.5s2.9 2.2 5.1 2.2 3.9-.7 5.1-2.2zM286.6 76.6c0 .7-.2 1.3-.5 1.6-.4.4-1 .6-1.9.7l-1.5.1c-2.1.2-3.7.9-4.7 2.2-1 1.3-1.5 2.8-1.5 4.6v11.4c0 .8-.2 1.4-.7 1.8-.5.4-1.1.6-1.8.6s-1.3-.2-1.8-.6c-.5-.4-.7-1-.7-1.8V76.9c0-.8.2-1.4.7-1.8.5-.4 1.1-.6 1.8-.6s1.2.2 1.7.6c.5.4.7 1 .7 1.7v2.4c.7-1.5 1.6-2.6 2.9-3.3 1.3-.8 2.7-1.2 4.3-1.3l.7-.1c1.5-.1 2.3.6 2.3 2.1zM305.3 96.4c.3.3.5.8.5 1.3 0 .7-.3 1.2-.8 1.5-.5.3-1.3.5-2.3.4l-1.4-.1c-2.7-.2-4.7-1-6-2.5s-2-3.6-2-6.4V78.9h-3c-1.5 0-2.2-.7-2.2-2 0-.6.2-1.1.6-1.4.4-.3.9-.5 1.6-.5h3v-5.1c0-.8.2-1.4.7-1.8.5-.4 1.1-.7 1.8-.7s1.4.2 1.9.7c.5.4.7 1 .7 1.8V75h5c.7 0 1.2.2 1.6.5.4.3.6.8.6 1.4 0 .6-.2 1.1-.6 1.5-.4.3-.9.5-1.6.5h-5V91c0 1.6.3 2.7 1 3.5.6.7 1.6 1.2 3 1.3l1.4.1c.7 0 1.2.2 1.5.5z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M152.1 0c-13.5.4-24.4 11.4-24.4 25 0 13.8 11.2 25 25 25s25-11.2 25-25c0-13.5-10.8-24.6-24.2-25h-1.4zm21.8 23.1h-7.2c-.5-6.3-3.3-12.6-8.5-18.6 8.4 2.2 14.9 9.6 15.7 18.6zm-23.2 0h-8c.5-5.6 3.1-11.2 8-16.6v16.6zm0 3.8v16.5c-3-3.3-7.3-9.1-8-16.5h8zm4.2 0h8c-.7 7.3-5 13.1-8 16.4V26.9zm0-3.8V6.5c4.8 5.4 7.5 11 8 16.6h-8zm-7.4-18.7c-5.2 6-8.1 12.3-8.6 18.7h-7.3c.8-9.1 7.3-16.5 15.9-18.7zm-15.9 22.5h7.3c.6 8.4 5.2 14.9 8.7 18.7-8.6-2.2-15.2-9.6-16-18.7zM158 45.6c3.4-3.8 8-10.4 8.6-18.7h7.2c-.7 9-7.2 16.5-15.8 18.7z",
      "fill": "#5fd0b8"
    }
  })])]), _vm._v(" "), _c('span', {
    class: [_vm.checkAuthStatus() ? 'a-loader--white' : ''],
    staticStyle: {
      "margin-top": "90px"
    },
    attrs: {
      "disabled": _vm.running
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Loading...")])])]) : _vm._e(), _vm._v(" "), (_vm.getUserId === null && !_vm.checkAuthStatus()) ? _c('div', [_c('div', {
    staticClass: "p-passport__login"
  }, [_c('svg', {
    staticClass: "p-passport__icon--passport u-margin-top--small u-margin-bottom--small",
    attrs: {
      "height": "70",
      "width": "200",
      "id": "passport",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 305.8 108.7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M34.2 97.4c0 .6-.3 1.2-.8 1.6-.5.4-1.1.7-1.7.7-.4 0-.8-.1-1.2-.4s-.7-.6-.9-1.1l-3.3-7.5H8l-3.3 7.5c-.2.5-.5.8-.9 1.1-.4.3-.8.4-1.3.4-.7 0-1.3-.2-1.8-.7-.5-.4-.8-1-.8-1.6 0-.3.1-.6.3-1l14.1-30.8c.2-.5.6-1 1.1-1.3.5-.3 1.1-.5 1.6-.5s1.1.1 1.6.5c.5.3.9.7 1.1 1.3L34 96.4c.1.4.2.8.2 1zM9.8 86.6h14.7l-7.3-16.5-7.4 16.5zM65 84.3c1.1 1.5 1.7 3.3 1.7 5.5 0 3-1 5.4-3.1 7.1-2.1 1.7-5 2.5-8.7 2.5H42.1c-.8 0-1.4-.2-1.9-.7-.5-.5-.7-1.1-.7-1.8V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12.2c3.6 0 6.5.8 8.5 2.4 2 1.6 3.1 3.9 3.1 6.8 0 1.9-.5 3.5-1.5 4.8-1 1.4-2.4 2.4-4.1 3 2 .7 3.6 1.7 4.7 3.1zm-20.4-4.9h8.9c4.9 0 7.4-1.9 7.4-5.6 0-1.9-.6-3.3-1.8-4.2s-3.1-1.3-5.6-1.3h-8.9v11.1zm15.3 14.5c1.2-.9 1.8-2.4 1.8-4.4 0-2-.6-3.5-1.8-4.5-1.2-1-3.1-1.5-5.6-1.5h-9.7v11.7h9.7c2.6.1 4.4-.4 5.6-1.3zM80 97.7c-2.5-1.4-4.4-3.5-5.8-6.3-1.3-2.7-2-5.9-2-9.6 0-3.7.7-6.9 2-9.6 1.3-2.7 3.3-4.8 5.8-6.3s5.4-2.2 8.8-2.2c2.2 0 4.3.3 6.3 1s3.7 1.7 5.1 3c.6.5 1 1.2 1 2 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.2.6-.6 0-1.1-.2-1.6-.7-1.6-1.2-3.1-2-4.4-2.5-1.3-.5-2.8-.7-4.5-.7-3.7 0-6.5 1.2-8.4 3.6-2 2.4-3 5.8-3 10.2 0 4.5 1 7.9 3 10.3 2 2.4 4.8 3.6 8.4 3.6 1.6 0 3.1-.3 4.4-.8s2.8-1.3 4.5-2.5c.7-.4 1.2-.7 1.6-.7.5 0 .9.2 1.2.6.3.4.5.9.5 1.5 0 .8-.3 1.5-1 2-1.5 1.3-3.2 2.3-5.1 3-2 .7-4 1-6.3 1-3.4.1-6.3-.6-8.8-2zM108 99c-.5-.5-.7-1.1-.7-1.9V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12c3.7 0 6.6.9 8.7 2.8 2.1 1.8 3.1 4.4 3.1 7.8 0 3.3-1 5.9-3.1 7.8-2.1 1.9-5 2.8-8.7 2.8h-9.5v11.8c0 .8-.2 1.4-.7 1.9-.5.5-1.1.7-1.9.7-.7-.1-1.3-.3-1.8-.8zm13.3-17.8c4.9 0 7.4-2.2 7.4-6.5s-2.5-6.4-7.4-6.4h-8.9v12.8h8.9zM156.2 76.9c1.6 1.6 2.4 4.1 2.4 7.5v12.9c0 .8-.2 1.4-.6 1.8-.4.4-1 .6-1.8.6-.7 0-1.3-.2-1.8-.7-.4-.4-.7-1-.7-1.8v-1.8c-.6 1.4-1.6 2.5-2.8 3.2s-2.7 1.1-4.4 1.1c-1.6 0-3.1-.3-4.4-1-1.3-.7-2.4-1.6-3.1-2.7s-1.1-2.5-1.1-3.9c0-1.8.5-3.2 1.4-4.2.9-1 2.4-1.7 4.5-2.2 2.1-.4 5-.7 8.7-.7h1.2v-1.5c0-1.9-.4-3.2-1.2-4-.8-.8-2-1.3-3.7-1.3-1.2 0-2.3.2-3.3.5s-2.2.7-3.4 1.3c-.9.5-1.5.8-1.9.8-.5 0-.9-.2-1.2-.5-.3-.4-.5-.8-.5-1.4 0-.5.1-.9.4-1.3.3-.4.7-.8 1.4-1.1 1.2-.6 2.5-1.1 4.1-1.5 1.6-.4 3.1-.6 4.5-.6 3.3 0 5.7.9 7.3 2.5zm-4.3 17.3c1.2-1.3 1.8-2.9 1.8-4.8V88h-.9c-2.6 0-4.6.1-6 .4-1.4.2-2.4.6-3 1.2-.6.5-.9 1.3-.9 2.4 0 1.2.4 2.2 1.3 3 .9.8 2 1.1 3.3 1.1 1.7-.1 3.2-.7 4.4-1.9zM165.6 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM189.7 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM232.4 76c1.7 1.1 2.9 2.6 3.9 4.5.9 1.9 1.4 4.2 1.4 6.7s-.5 4.7-1.4 6.6c-.9 1.9-2.2 3.4-3.8 4.4-1.7 1-3.5 1.5-5.7 1.5-1.8 0-3.4-.4-4.8-1.2-1.4-.8-2.5-1.9-3.2-3.4v11.2c0 .7-.2 1.3-.7 1.7-.5.4-1 .6-1.8.6s-1.4-.2-1.9-.7-.7-1-.7-1.8V77c0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7s1.3.2 1.8.7c.5.4.7 1 .7 1.8v2c.7-1.5 1.8-2.6 3.2-3.4s3-1.2 4.8-1.2c2.1 0 4 .6 5.7 1.6zm-1.8 17.6c1.2-1.5 1.8-3.6 1.8-6.3 0-2.8-.6-4.9-1.8-6.5-1.2-1.5-2.9-2.3-5.1-2.3-2.2 0-3.9.8-5.1 2.3-1.2 1.5-1.8 3.6-1.8 6.4s.6 4.9 1.8 6.4c1.2 1.5 2.9 2.3 5.1 2.3 2.2-.1 3.9-.9 5.1-2.3zM247.5 98.2c-1.8-1-3.2-2.5-4.2-4.4-1-1.9-1.5-4.1-1.5-6.7 0-2.6.5-4.8 1.5-6.7 1-1.9 2.4-3.4 4.2-4.4 1.8-1 3.9-1.5 6.3-1.5s4.5.5 6.3 1.5c1.8 1 3.2 2.5 4.2 4.4 1 1.9 1.5 4.2 1.5 6.7s-.5 4.8-1.5 6.7c-1 1.9-2.4 3.4-4.2 4.4-1.8 1-3.9 1.5-6.3 1.5-2.4.1-4.5-.4-6.3-1.5zm11.4-4.6c1.2-1.5 1.8-3.6 1.8-6.5 0-2.8-.6-4.9-1.8-6.4s-2.9-2.2-5.1-2.2c-2.2 0-3.9.7-5.1 2.2s-1.8 3.6-1.8 6.4c0 2.8.6 5 1.8 6.5s2.9 2.2 5.1 2.2 3.9-.7 5.1-2.2zM286.6 76.6c0 .7-.2 1.3-.5 1.6-.4.4-1 .6-1.9.7l-1.5.1c-2.1.2-3.7.9-4.7 2.2-1 1.3-1.5 2.8-1.5 4.6v11.4c0 .8-.2 1.4-.7 1.8-.5.4-1.1.6-1.8.6s-1.3-.2-1.8-.6c-.5-.4-.7-1-.7-1.8V76.9c0-.8.2-1.4.7-1.8.5-.4 1.1-.6 1.8-.6s1.2.2 1.7.6c.5.4.7 1 .7 1.7v2.4c.7-1.5 1.6-2.6 2.9-3.3 1.3-.8 2.7-1.2 4.3-1.3l.7-.1c1.5-.1 2.3.6 2.3 2.1zM305.3 96.4c.3.3.5.8.5 1.3 0 .7-.3 1.2-.8 1.5-.5.3-1.3.5-2.3.4l-1.4-.1c-2.7-.2-4.7-1-6-2.5s-2-3.6-2-6.4V78.9h-3c-1.5 0-2.2-.7-2.2-2 0-.6.2-1.1.6-1.4.4-.3.9-.5 1.6-.5h3v-5.1c0-.8.2-1.4.7-1.8.5-.4 1.1-.7 1.8-.7s1.4.2 1.9.7c.5.4.7 1 .7 1.8V75h5c.7 0 1.2.2 1.6.5.4.3.6.8.6 1.4 0 .6-.2 1.1-.6 1.5-.4.3-.9.5-1.6.5h-5V91c0 1.6.3 2.7 1 3.5.6.7 1.6 1.2 3 1.3l1.4.1c.7 0 1.2.2 1.5.5z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M152.1 0c-13.5.4-24.4 11.4-24.4 25 0 13.8 11.2 25 25 25s25-11.2 25-25c0-13.5-10.8-24.6-24.2-25h-1.4zm21.8 23.1h-7.2c-.5-6.3-3.3-12.6-8.5-18.6 8.4 2.2 14.9 9.6 15.7 18.6zm-23.2 0h-8c.5-5.6 3.1-11.2 8-16.6v16.6zm0 3.8v16.5c-3-3.3-7.3-9.1-8-16.5h8zm4.2 0h8c-.7 7.3-5 13.1-8 16.4V26.9zm0-3.8V6.5c4.8 5.4 7.5 11 8 16.6h-8zm-7.4-18.7c-5.2 6-8.1 12.3-8.6 18.7h-7.3c.8-9.1 7.3-16.5 15.9-18.7zm-15.9 22.5h7.3c.6 8.4 5.2 14.9 8.7 18.7-8.6-2.2-15.2-9.6-16-18.7zM158 45.6c3.4-3.8 8-10.4 8.6-18.7h7.2c-.7 9-7.2 16.5-15.8 18.7z",
      "fill": "#5fd0b8"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "email",
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "p-passport__login-error"
  }, [_c('span', [_vm._v("Your credentials are incorrect, please try again.")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button",
    class: [_vm.loggingIn() ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": _vm.login
    }
  }, [_c('span', {
    class: [_vm.loggingIn() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Login")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "p-passport__content-new-account",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Don't have an account? "), _c('br'), _vm._v("Create one "), _c('a', {
    attrs: {
      "href": _vm.passportUrl
    }
  }, [_vm._v("here")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.passportUrl + '/password/reset',
      "target": "_blank"
    }
  }, [_vm._v("forgot password?")])]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getUserId !== null && !_vm.checkAuthStatus() && !_vm.isLocked) ? _c('div', [_c('div', {
    staticClass: "p-passport__login"
  }, [_c('svg', {
    staticClass: "p-passport__icon--passport u-margin-top--small u-margin-bottom--small",
    attrs: {
      "height": "70",
      "width": "200",
      "id": "passport",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 305.8 108.7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M34.2 97.4c0 .6-.3 1.2-.8 1.6-.5.4-1.1.7-1.7.7-.4 0-.8-.1-1.2-.4s-.7-.6-.9-1.1l-3.3-7.5H8l-3.3 7.5c-.2.5-.5.8-.9 1.1-.4.3-.8.4-1.3.4-.7 0-1.3-.2-1.8-.7-.5-.4-.8-1-.8-1.6 0-.3.1-.6.3-1l14.1-30.8c.2-.5.6-1 1.1-1.3.5-.3 1.1-.5 1.6-.5s1.1.1 1.6.5c.5.3.9.7 1.1 1.3L34 96.4c.1.4.2.8.2 1zM9.8 86.6h14.7l-7.3-16.5-7.4 16.5zM65 84.3c1.1 1.5 1.7 3.3 1.7 5.5 0 3-1 5.4-3.1 7.1-2.1 1.7-5 2.5-8.7 2.5H42.1c-.8 0-1.4-.2-1.9-.7-.5-.5-.7-1.1-.7-1.8V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12.2c3.6 0 6.5.8 8.5 2.4 2 1.6 3.1 3.9 3.1 6.8 0 1.9-.5 3.5-1.5 4.8-1 1.4-2.4 2.4-4.1 3 2 .7 3.6 1.7 4.7 3.1zm-20.4-4.9h8.9c4.9 0 7.4-1.9 7.4-5.6 0-1.9-.6-3.3-1.8-4.2s-3.1-1.3-5.6-1.3h-8.9v11.1zm15.3 14.5c1.2-.9 1.8-2.4 1.8-4.4 0-2-.6-3.5-1.8-4.5-1.2-1-3.1-1.5-5.6-1.5h-9.7v11.7h9.7c2.6.1 4.4-.4 5.6-1.3zM80 97.7c-2.5-1.4-4.4-3.5-5.8-6.3-1.3-2.7-2-5.9-2-9.6 0-3.7.7-6.9 2-9.6 1.3-2.7 3.3-4.8 5.8-6.3s5.4-2.2 8.8-2.2c2.2 0 4.3.3 6.3 1s3.7 1.7 5.1 3c.6.5 1 1.2 1 2 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.2.6-.6 0-1.1-.2-1.6-.7-1.6-1.2-3.1-2-4.4-2.5-1.3-.5-2.8-.7-4.5-.7-3.7 0-6.5 1.2-8.4 3.6-2 2.4-3 5.8-3 10.2 0 4.5 1 7.9 3 10.3 2 2.4 4.8 3.6 8.4 3.6 1.6 0 3.1-.3 4.4-.8s2.8-1.3 4.5-2.5c.7-.4 1.2-.7 1.6-.7.5 0 .9.2 1.2.6.3.4.5.9.5 1.5 0 .8-.3 1.5-1 2-1.5 1.3-3.2 2.3-5.1 3-2 .7-4 1-6.3 1-3.4.1-6.3-.6-8.8-2zM108 99c-.5-.5-.7-1.1-.7-1.9V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12c3.7 0 6.6.9 8.7 2.8 2.1 1.8 3.1 4.4 3.1 7.8 0 3.3-1 5.9-3.1 7.8-2.1 1.9-5 2.8-8.7 2.8h-9.5v11.8c0 .8-.2 1.4-.7 1.9-.5.5-1.1.7-1.9.7-.7-.1-1.3-.3-1.8-.8zm13.3-17.8c4.9 0 7.4-2.2 7.4-6.5s-2.5-6.4-7.4-6.4h-8.9v12.8h8.9zM156.2 76.9c1.6 1.6 2.4 4.1 2.4 7.5v12.9c0 .8-.2 1.4-.6 1.8-.4.4-1 .6-1.8.6-.7 0-1.3-.2-1.8-.7-.4-.4-.7-1-.7-1.8v-1.8c-.6 1.4-1.6 2.5-2.8 3.2s-2.7 1.1-4.4 1.1c-1.6 0-3.1-.3-4.4-1-1.3-.7-2.4-1.6-3.1-2.7s-1.1-2.5-1.1-3.9c0-1.8.5-3.2 1.4-4.2.9-1 2.4-1.7 4.5-2.2 2.1-.4 5-.7 8.7-.7h1.2v-1.5c0-1.9-.4-3.2-1.2-4-.8-.8-2-1.3-3.7-1.3-1.2 0-2.3.2-3.3.5s-2.2.7-3.4 1.3c-.9.5-1.5.8-1.9.8-.5 0-.9-.2-1.2-.5-.3-.4-.5-.8-.5-1.4 0-.5.1-.9.4-1.3.3-.4.7-.8 1.4-1.1 1.2-.6 2.5-1.1 4.1-1.5 1.6-.4 3.1-.6 4.5-.6 3.3 0 5.7.9 7.3 2.5zm-4.3 17.3c1.2-1.3 1.8-2.9 1.8-4.8V88h-.9c-2.6 0-4.6.1-6 .4-1.4.2-2.4.6-3 1.2-.6.5-.9 1.3-.9 2.4 0 1.2.4 2.2 1.3 3 .9.8 2 1.1 3.3 1.1 1.7-.1 3.2-.7 4.4-1.9zM165.6 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM189.7 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM232.4 76c1.7 1.1 2.9 2.6 3.9 4.5.9 1.9 1.4 4.2 1.4 6.7s-.5 4.7-1.4 6.6c-.9 1.9-2.2 3.4-3.8 4.4-1.7 1-3.5 1.5-5.7 1.5-1.8 0-3.4-.4-4.8-1.2-1.4-.8-2.5-1.9-3.2-3.4v11.2c0 .7-.2 1.3-.7 1.7-.5.4-1 .6-1.8.6s-1.4-.2-1.9-.7-.7-1-.7-1.8V77c0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7s1.3.2 1.8.7c.5.4.7 1 .7 1.8v2c.7-1.5 1.8-2.6 3.2-3.4s3-1.2 4.8-1.2c2.1 0 4 .6 5.7 1.6zm-1.8 17.6c1.2-1.5 1.8-3.6 1.8-6.3 0-2.8-.6-4.9-1.8-6.5-1.2-1.5-2.9-2.3-5.1-2.3-2.2 0-3.9.8-5.1 2.3-1.2 1.5-1.8 3.6-1.8 6.4s.6 4.9 1.8 6.4c1.2 1.5 2.9 2.3 5.1 2.3 2.2-.1 3.9-.9 5.1-2.3zM247.5 98.2c-1.8-1-3.2-2.5-4.2-4.4-1-1.9-1.5-4.1-1.5-6.7 0-2.6.5-4.8 1.5-6.7 1-1.9 2.4-3.4 4.2-4.4 1.8-1 3.9-1.5 6.3-1.5s4.5.5 6.3 1.5c1.8 1 3.2 2.5 4.2 4.4 1 1.9 1.5 4.2 1.5 6.7s-.5 4.8-1.5 6.7c-1 1.9-2.4 3.4-4.2 4.4-1.8 1-3.9 1.5-6.3 1.5-2.4.1-4.5-.4-6.3-1.5zm11.4-4.6c1.2-1.5 1.8-3.6 1.8-6.5 0-2.8-.6-4.9-1.8-6.4s-2.9-2.2-5.1-2.2c-2.2 0-3.9.7-5.1 2.2s-1.8 3.6-1.8 6.4c0 2.8.6 5 1.8 6.5s2.9 2.2 5.1 2.2 3.9-.7 5.1-2.2zM286.6 76.6c0 .7-.2 1.3-.5 1.6-.4.4-1 .6-1.9.7l-1.5.1c-2.1.2-3.7.9-4.7 2.2-1 1.3-1.5 2.8-1.5 4.6v11.4c0 .8-.2 1.4-.7 1.8-.5.4-1.1.6-1.8.6s-1.3-.2-1.8-.6c-.5-.4-.7-1-.7-1.8V76.9c0-.8.2-1.4.7-1.8.5-.4 1.1-.6 1.8-.6s1.2.2 1.7.6c.5.4.7 1 .7 1.7v2.4c.7-1.5 1.6-2.6 2.9-3.3 1.3-.8 2.7-1.2 4.3-1.3l.7-.1c1.5-.1 2.3.6 2.3 2.1zM305.3 96.4c.3.3.5.8.5 1.3 0 .7-.3 1.2-.8 1.5-.5.3-1.3.5-2.3.4l-1.4-.1c-2.7-.2-4.7-1-6-2.5s-2-3.6-2-6.4V78.9h-3c-1.5 0-2.2-.7-2.2-2 0-.6.2-1.1.6-1.4.4-.3.9-.5 1.6-.5h3v-5.1c0-.8.2-1.4.7-1.8.5-.4 1.1-.7 1.8-.7s1.4.2 1.9.7c.5.4.7 1 .7 1.8V75h5c.7 0 1.2.2 1.6.5.4.3.6.8.6 1.4 0 .6-.2 1.1-.6 1.5-.4.3-.9.5-1.6.5h-5V91c0 1.6.3 2.7 1 3.5.6.7 1.6 1.2 3 1.3l1.4.1c.7 0 1.2.2 1.5.5z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M152.1 0c-13.5.4-24.4 11.4-24.4 25 0 13.8 11.2 25 25 25s25-11.2 25-25c0-13.5-10.8-24.6-24.2-25h-1.4zm21.8 23.1h-7.2c-.5-6.3-3.3-12.6-8.5-18.6 8.4 2.2 14.9 9.6 15.7 18.6zm-23.2 0h-8c.5-5.6 3.1-11.2 8-16.6v16.6zm0 3.8v16.5c-3-3.3-7.3-9.1-8-16.5h8zm4.2 0h8c-.7 7.3-5 13.1-8 16.4V26.9zm0-3.8V6.5c4.8 5.4 7.5 11 8 16.6h-8zm-7.4-18.7c-5.2 6-8.1 12.3-8.6 18.7h-7.3c.8-9.1 7.3-16.5 15.9-18.7zm-15.9 22.5h7.3c.6 8.4 5.2 14.9 8.7 18.7-8.6-2.2-15.2-9.6-16-18.7zM158 45.6c3.4-3.8 8-10.4 8.6-18.7h7.2c-.7 9-7.2 16.5-15.8 18.7z",
      "fill": "#5fd0b8"
    }
  })])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button p-passport__button--close",
    class: [_vm.loggingOut() ? 'u-d-none' : ''],
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('span', {
    class: [_vm.loggingOut() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Continue")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button p-passport__logout-button",
    class: [_vm.loggingOut() ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('span', {
    class: [_vm.loggingOut() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Logout")])])])]) : _vm._e(), _vm._v(" "), (_vm.getUserId !== null && _vm.isLocked) ? _c('div', [_c('div', {
    staticClass: "p-passport__login"
  }, [_c('h2', {
    staticClass: "u-text-align-center"
  }, [_vm._v("\n                    " + _vm._s(_vm.getUserFullName) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "u-text-align-center u-margin-bottom-30"
  }, [_vm._v("\n                    Your session has timed out,\n                    please enter your password to continue\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Password\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasLockedErrors &&
    !_vm.hasLockedErrors.success &&
    _vm.hasLockedErrors.whitelisted) ? _c('span', {
    staticClass: "p-passport__login-error"
  }, [_c('span', [_vm._v("\n                        Your credentials are incorrect, please try again.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.hasLockedErrors &&
    !_vm.hasLockedErrors.success &&
    !_vm.hasLockedErrors.whitelisted) ? _c('span', {
    staticClass: "p-passport__login-error"
  }, [_c('span', [_vm._v("\n                        Your login attempt has been refused as you have attempted access from outside\n                        of your organisation's whitelisted network range.\n                    ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button p-passport__button--close u-margin-bottom-0",
    class: [_vm.loggingIn() ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": _vm.continueUser
    }
  }, [_c('span', {
    class: [_vm.loggingIn() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Continue")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button p-passport__logout-button",
    class: [_vm.loggingOut() ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('span', {
    class: [_vm.loggingOut() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Logout")])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Welcome back to "), _c('br'), _vm._v("ABC Quantum. ")])
}]}

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-wrapper",
    class: {
      'slideup': !_vm.isMobileMenuOpen, 'slidedown': _vm.isMobileMenuOpen
    }
  }, [_c('nav', {
    staticClass: "ie o-menu o-menu__icon-mob--active",
    class: {
      'o-menu--collapse': _vm.isMenuCollapsed
    },
    on: {
      "mouseleave": _vm.unforce
    }
  }, [_c('icons'), _vm._v(" "), _c('div', {
    staticClass: "o-menu__icon",
    class: {
      'o-menu__icon--animate o-menu--show-sub-menu': _vm.isMenuOpen && !this.forceMenu && this.getSubMenu.allSteps.length
    },
    on: {
      "click": function($event) {
        return _vm.updateMenu(false)
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.force
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__collapse-menu",
    class: {
      'o-menu__collapse-menu--show': _vm.isMenuOpen && !this.forceMenu && this.getSubMenu.allSteps.length
    },
    on: {
      "click": _vm.collapseMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-menu__icon-mob--close",
    on: {
      "click": _vm.updateMobileMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-top-level-nav",
    class: {
      'o-menu__m-top-level-nav--active': _vm.isMenuOpen && !this.forceMenu && this.getSubMenu.allSteps.length
    }
  }, [(_vm.getUserId !== null) ? _c('ul', {
    staticClass: "top-nav-links"
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'homepage'
      },
      "exact": "",
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                            Homepage\n                        ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'executive-dashboard'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                            Executive Dashboard\n                        ")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "has-sub",
    class: {
      'remove-border': _vm.currentSubMenu == 'reserving-sub'
    },
    attrs: {
      "id": "reserving"
    }
  }, [_c('a', [_vm._v("\n                        Reserving\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-top-level-nav--sub-menu-icon",
    class: {
      'rotate': _vm.currentSubMenu == 'reserving-sub'
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#arrow-head"
    }
  })])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSubMenu === 'reserving-sub'),
      expression: "currentSubMenu === 'reserving-sub'"
    }],
    staticClass: "sub",
    attrs: {
      "id": "reserving-sub"
    }
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'compare'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Reserve vs Paid Comparison\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reserving::day-one-assessment'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Day One Assessment\n                                ")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "has-sub",
    class: {
      'remove-border': _vm.currentSubMenu == 'discount-rate-sub'
    },
    attrs: {
      "id": "discount-rate"
    }
  }, [_c('a', [_vm._v("\n                        Discount Rate\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-top-level-nav--sub-menu-icon",
    class: {
      'rotate': _vm.currentSubMenu == 'discount-rate-sub'
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#arrow-head"
    }
  })])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSubMenu === 'discount-rate-sub'),
      expression: "currentSubMenu === 'discount-rate-sub'"
    }],
    staticClass: "sub",
    attrs: {
      "id": "discount-rate-sub'"
    }
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'discount-rate-comparison'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Discount Rate Comparison\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'update-discount-rate'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Update Discount Rates\n                                ")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "has-sub",
    class: {
      'remove-border': _vm.currentSubMenu == 'claims-sub'
    },
    attrs: {
      "id": "claims"
    }
  }, [_c('a', [_vm._v("\n                        Claims\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-top-level-nav--sub-menu-icon",
    class: {
      'rotate': _vm.currentSubMenu == 'claims-sub'
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#arrow-head"
    }
  })])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSubMenu === 'claims-sub'),
      expression: "currentSubMenu === 'claims-sub'"
    }],
    staticClass: "sub",
    attrs: {
      "id": "claims-sub"
    }
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'claims'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Claims Dashboard\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'fatal::dependency.step-1'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('fatal/dependency')
      }
    }
  }, [_vm._v("\n                                    Fatal Accident Dependency Claim\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'fatal::estate.step-1'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('fatal/estate')
      }
    }
  }, [_vm._v("\n                                    Fatal Accident Estate Claim\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lost::step-1'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('lost')
      }
    }
  }, [_vm._v("\n                                    Lost Years Claim\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'personal::step-1'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('personal')
      }
    }
  }, [_vm._v("\n                                    Personal Injury Claim\n                                ")])])], 1)])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'mini-calculators'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('mini')
      }
    }
  }, [_vm._v("\n                            Mini Calculators\n                        ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'randt::documents'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("Resources and Tools")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'support'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("Support")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logoutUser()
      }
    }
  }, [_c('p', [_vm._v("Logout\n                            "), _c('span', {
    class: [_vm.loggingOut() ? 'a-loader--white' : ''],
    staticStyle: {
      "margin-top": "-3px",
      "margin-left": "20px"
    },
    attrs: {
      "disabled": _vm.running
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.getUserId === null) ? _c('ul', {
    staticClass: "top-nav-links"
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'homepage'
      },
      "exact": "",
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("Homepage")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.updateMobileMenu();
        _vm.updatePassportMenu();
      }
    }
  }, [_c('a', {
    staticClass: "loginButton",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.openPassport()
      }
    }
  }, [_c('p', [_vm._v("Login")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-sub-nav"
  }, [_c('ul', _vm._l((this.getSubMenu.allSteps), function(item, index) {
    return (item.route.path) ? _c('li', [(item.route.path !== 'documents') ? _c('router-link', {
      class: {
        'o-menu__m-sub-nav--visited': item.valid === true
      },
      attrs: {
        "to": item.route,
        "active-class": "o-menu__m-sub-nav--active"
      }
    }, [_c('p', [_vm._v(_vm._s(item.name) + " ")])]) : _vm._e()], 1) : _vm._e()
  }), 0)]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-menu__back-button"
  }, [_c('p', [_vm._v("Main Menu")])])
}]}

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.filterHeading !== '') ? _c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            " + _vm._s(_vm.filterHeading) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "input",
    attrs: {
      "autocomplete": "off",
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-full-width flex-grid--wrap u-flex-center"
  }, [_c('div', {
    staticClass: "p-compare-reserve__average-diff-chart"
  }, [_c('h2', {
    staticClass: "u-centre chart"
  }, [_vm._v("Average Difference between " + _vm._s(_vm.fromLabel) + " and " + _vm._s(_vm.toLabel))]), _vm._v(" "), (_vm.theCurrentWidth >= 600) ? _c('bar-chart', {
    attrs: {
      "chart-data": _vm.currentChartData,
      "options": _vm.defaultOptions,
      "height": 200
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('difference-table', {
    attrs: {
      "average-from": _vm.averageFrom,
      "average-to": _vm.averageTo,
      "difference": _vm.averageDifference,
      "from-label": _vm.fromLabel,
      "to-label": _vm.toLabel,
      "colours": _vm.colours
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.load
    }
  }, [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Bereavement Award — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n            ")]), _vm._v(" "), _c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-bars",
    class: {
      'm-bars--dark': _vm.onDark
    }
  }, [(_vm.button) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.bars
    }
  }, [_vm._v("show results")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs o-filter-options"
  }, [_c('div', {
    staticClass: "o-filter-options__box o-filter-options__box-header u-d-flex flex-state-buttons",
    class: {
      'o-filter-options__box-closed': !_vm.show
    }
  }, [_c('div', {
    staticClass: "u-d-flex u-margin-bottom-10"
  }, [_c('div', [_c('h2', {
    staticClass: "u-no-margin"
  }, [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), (!_vm.justAdvanced) ? _c('div', {
    staticClass: "o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, [(!_vm.advancedSearchVisible) ? _c('div', {
    staticClass: "flex-grid__g-3 u-flex-grow-none"
  }, [_c("InputFilter", {
    tag: "component",
    attrs: {
      "name": "searchText",
      "update": _vm.filter
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.advancedSearchVisible) ? _c('div', {
    staticClass: "flex-grid__g-1"
  }, [_c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n                Search\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    on: {
      "click": _vm.advancedSearch
    }
  }, [_vm._v("\n                Advanced Search\n            ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.advancedSearchVisible || _vm.justAdvanced) ? _c('div', [_c('div', {
    staticClass: "o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, _vm._l((_vm.filters.filterTypes), function(data, index) {
    return _c('div', {
      staticClass: "flex-grid__item--third"
    }, [(data.name !== 'searchText') ? _c(data.component, {
      ref: "filterInputs",
      refInFor: true,
      tag: "component",
      attrs: {
        "filter-heading": data.filterHeading,
        "from": data.from,
        "to": data.to,
        "option-values": data.values,
        "date": data.date,
        "pound": data.pound,
        "name": data.name,
        "update": _vm.filter
      },
      on: {
        "boxToDelete": function($event) {
          _vm.deleteBox = $event
        }
      }
    }) : _vm._e()], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.advancedSearchVisible || _vm.justAdvanced) ? _c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('button', {
    staticClass: "a-button a-button--small a-button--loader-button",
    class: [_vm.running ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    class: [_vm.running ? 'a-button--span-hidden' : '']
  }, [_vm._v("\n                " + _vm._s(_vm.buttonTitle) + "\n            ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.doReset()
      }
    }
  }, [_vm._v("\n                Reset\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    on: {
      "click": _vm.advancedSearch
    }
  }, [_vm._v("\n                Simple Search\n            ")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Support",
      "set-position": "relative",
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-support",
    attrs: {
      "id": "app"
    }
  }, [_c('icons'), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "flex-grid__g-6 a-form-inputs u-margin-right-60 u-r-no-margin"
  }, [_c('h2', {
    staticClass: "u-r-margin-top-0"
  }, [_vm._v("Have a Query?")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('label', {
    staticClass: "u-margin-bottom-10 u-d-block",
    attrs: {
      "for": "Claim"
    }
  }, [_vm._v("Claim Reference (optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimText),
      expression: "claimText"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimText = $event.target.value
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "u-margin-bottom-10 u-d-block",
    attrs: {
      "for": "Your Query"
    }
  }, [_vm._v("Your Query")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    staticClass: "u-full-width",
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.sent) ? _c('p', [_vm._v("Your query has been received and we will be in touch soon.")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": function($event) {
        return _vm.sendEmail()
      }
    }
  }, [_vm._v("Send Query")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-6"
  }, [_c('h2', [_vm._v("Email Support")]), _vm._v(" "), _c('p', [_vm._v("For more detailed assistance, support and handling guidance:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("Policies")]), _vm._v(" "), _c('p', {
    staticClass: "u-r-margin-bottom-0"
  }, [_vm._v("To view our policy documents regarding the use of this application just follow the links below:")]), _vm._v(" "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "support_cookie_policy"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Cookie Policy")])]), _vm._v(" "), _c('span', {
    staticClass: "p-support--divider u-r-margin-bottom-30 u-r-d-inline-block"
  }, [_vm._v("|")]), _vm._v(" "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "support_disclaimer"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Disclaimer")])]), _vm._v(" "), _c('span', {
    staticClass: "p-support--divider u-r-margin-bottom-30 u-r-d-inline-block"
  }, [_vm._v("|")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "p-support--divider u-r-margin-bottom-30 u-r-d-inline-block"
  }, [_vm._v("|")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "p-support--divider u-r-margin-bottom-30 u-r-d-inline-block"
  }, [_vm._v("|")]), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "support_disclaimer",
      "no-default-button": "true"
    }
  }, [_c('disclaimer')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "support_cookie_policy",
      "no-default-button": "true"
    }
  }, [_c('cookie-policy')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "support_privacy_policy",
      "no-default-button": "true"
    }
  }, [_c('privacy-policy')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "mailto:abcquantum@bc-legal.co.uk"
    }
  }, [_vm._v("abcquantum@bc-legal.co.uk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/security-policy.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Security Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/privacy-policy.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Privacy Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/license-agreement.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("License Agreement")])])
}]}

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Loss of Earnings\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Disability Working Allowance",
      "store-key": "ploeDisabilityWorkingAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Employment and Support Allowance",
      "store-key": "ploeEmploymentSupportAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Incapacity Benefit",
      "store-key": "ploeIncapacityBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Income Support",
      "store-key": "ploeIncomeSupport"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Industrial Injuries Disablement Benefit",
      "store-key": "ploeIndustrialInjuriesDisablementBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Invalidity Pension",
      "store-key": "ploeInvalidityPension"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Invalidity Allowance",
      "store-key": "ploeInvalidityAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Jobseeker’s Allowance",
      "store-key": "ploeJobseekersAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Reduced Earnings Allowance",
      "store-key": "ploeReducedEarningsAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Severe Disablement Allowances",
      "store-key": "ploeSevereDisablementAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Sickness Benefit",
      "store-key": "ploeSicknessBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Statutory Sick Pay paid before 6 April 1994",
      "store-key": "ploeStatutorySickPay"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Unemployability Supplement",
      "store-key": "ploeUnemployabilitySupplement"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Unemployment Benefit",
      "store-key": "ploeUnemploymentBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "Past Loss of Earnings",
      "subtitle": "Universal Credit",
      "store-key": "ploeUniversalCredit",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        All Heads of Loss\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [(_vm.chosenRates.length === 2) ? _c('span', [_vm._v("\n            Comparison of\n        ")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.tableType === 'average' ? 'Average' : 'Total') + " Heads of Loss\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "p-discount-rate-comparison__chart-select"
  }, [_c('option-filters', {
    attrs: {
      "name": "tableType"
    }
  }, [_c('li', {
    class: {
      'm-option-filters--active': _vm.tableType === 'average'
    },
    on: {
      "click": function($event) {
        return _vm.updateTable('average')
      }
    }
  }, [_vm._v("Average")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.tableType === 'total'
    },
    on: {
      "click": function($event) {
        return _vm.updateTable('total')
      }
    }
  }, [_vm._v("Total")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid u-margin-bottom-20"
  }, [_c('div', {
    staticClass: "u-d-flex u-flex-center u-full-width p-discount-rate-comparison__pie-container"
  }, _vm._l((_vm.chosenRates), function(rate) {
    return _c('pie', {
      attrs: {
        "title": "",
        "rate": rate,
        "labels": _vm.labels,
        "dataset": _vm.dataset(rate),
        "legend": false
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "values": _vm.chartLegend(),
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "30",
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("\n                        Heads of Loss\n                    ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": _vm.numberOfRates
    }
  }, [_c('h2', [_vm._v("\n                        Amount Calculated by Discount Rate\n                    ")])]), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("\n                        Difference\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('tr', [_vm._l((_vm.chosenRates), function(rate) {
    return _c('th', [_c('h2', [_vm._v("\n                        " + _vm._s(rate) + "\n                    ")])])
  }), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('th', [_c('h2', [_vm._v("\n                        £\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('th', [_c('h2', [_vm._v("\n                        %\n                    ")])]) : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.table()), function(headOfLoss, name) {
    return (headOfLoss != undefined) ? _c('head-of-loss-row', {
      attrs: {
        "name": name,
        "row": headOfLoss
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("\n                        Total\n                    ")]), _vm._v(" "), _vm._l((_vm.chosenRates), function(rate) {
    return _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.sumOf(rate))) + "\n                    ")])
  }), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.sumOf(_vm.chosenRates[0]) - _vm.sumOf(_vm.chosenRates[1]))) + "\n                        \n                    ")]) : _vm._e(), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundAndPercent(_vm.sumOf(_vm.chosenRates[0]), _vm.sumOf(_vm.chosenRates[1]))) + "%\n                    ")]) : _vm._e()], 2)])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gd-psla-calculator"
  }, [_c('h2', [_vm._v("Mesothelioma General Damages (PSLA) Calculator")]), _vm._v(" "), _c('p', [_vm._v("\n        Welcome to our Mesothelioma General Damages (PSLA) calculator. The calculator shows estimated common law awards\n        according to 'age' and 'duration of symptoms' — the period between onset of the disease\n        and death (or anticipated date of death).\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        There are two parts to the calculator:\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n        Onset of symptoms:\n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm.onsetOfSymptoms) + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        Duration of symptoms:\n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm.calculatedDurationOfSymptoms) + " month" + _vm._s(_vm.calculatedDurationOfSymptoms === 1 ? '' : 's') + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        Age at Death: "), _c('strong', [_vm._v(_vm._s(_vm.ageAtDeath))])]), _vm._v(" "), _c('label', [_vm._v("\n        Duration of Symptoms\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-gd-psla-calculator__slider p-dependency-calc__slider"
  }, [_c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 0,
      "max": 37,
      "real-time": true,
      "clickable": true,
      "piecewise": true,
      "process-style": {
        'backgroundColor': '#4A89E5'
      },
      "tooltip-style": {
        'backgroundColor': '#4A89E5',
        'borderColor': '#4A89E5'
      },
      "formatter": _vm.calculatedDurationOfSymptoms + ' months',
      "label-style": {
        'color': '#fff'
      }
    },
    model: {
      value: (_vm.calculatedDurationOfSymptoms),
      callback: function($$v) {
        _vm.calculatedDurationOfSymptoms = $$v
      },
      expression: "calculatedDurationOfSymptoms"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('h2', [_vm._v("Tariff Table")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": function($event) {
        return _vm.applyUplift()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upliftButton ? 'Add' : 'Remove') + " 10% Uplift\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [(_vm.table[50] && !_vm.loading.table) ? _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up to)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.table[50].length
    }
  }, [_vm._v("\n                    Duration (months)\n                ")])]), _vm._v(" "), _c('tr', _vm._l((_vm.table[50].length), function(col) {
    return _c('th', [(col === 1) ? _c('span', [_vm._v("0-3")]) : (col === 13) ? _c('span', [_vm._v("37+")]) : _c('span', [_vm._v(_vm._s(col * 3 - 2) + "-" + _vm._s(col * 3))])])
  }), 0), _vm._v(" "), _vm._l((_vm.table), function(tr, age) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(age))]), _vm._v(" "), _vm._l((tr), function(td, index) {
      return _c('td', {
        style: (_vm.getTariffTableTdStyle(index, age)),
        on: {
          "click": function($event) {
            _vm.usePslaAward(_vm.uplift ? Math.round(td * 1.1) : td)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.uplift ? Math.round(td * 1.1) : td, '£', 0)) + "\n                ")])
    })], 2)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.loading.table) ? _c('div', [_vm._v("\n        Loading... one moment\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "c-gd-psla-calculator__disclaimer"
  }, [_vm._v("Data is up-to-date as of " + _vm._s(_vm.currentRpi) + " *")]), _vm._v(" "), _c('h2', [_vm._v("Awards")]), _vm._v(" "), _vm._l((_vm.filteredAwards), function(award) {
    return (!_vm.loading.awards) ? _c('psla-award', {
      attrs: {
        "award": award
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.loading.awards) ? _c('div', [_vm._v("\n        Loading... one moment\n    ")]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("\n            The first is a Tariff Table designed to give a broad brush indication of possible awards and\n            is not intended to substitute a detailed review and consideration of actual awards to\n            properly value any PSLA award. The Tariff Table is based on the 14th Edition of the JC Guidelines.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n            The second shows actual PLSA awards which most closely fit the selected age and duration\n            of symptoms.\n        ")])])
}]}

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-progress-bar"
  }, [_c('div', {
    staticClass: "m-progress-bar__bar",
    style: ('width: ' + _vm.calculateWidth() + '%;' + 'background: ' + _vm.completeColor() + ';')
  })])
},staticRenderFns: []}

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "p-day-one__own-head-of-loss--no-padding p-day-one__own-head-of-loss--no-top-border",
    attrs: {
      "colspan": "3"
    }
  }, [_c('table', {
    staticClass: "u-full-width"
  }, [_c('tr', [_c('td', {
    staticClass: "p-day-one__own-head-of-loss--no-border",
    attrs: {
      "width": "40%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "p-day-one__own-head-of-loss--no-top-bottom-border",
    attrs: {
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.amount),
      expression: "amount",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "p-day-one__own-head-of-loss--no-border",
    attrs: {
      "width": "20%"
    }
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Remove")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs c-split-screen p-day-one"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theCurrentWidth < 1024),
      expression: "theCurrentWidth < 1024"
    }]
  }, [_c('header-section', {
    attrs: {
      "set-position": "relative",
      "set-width": "100"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-split-screen__container"
  }, [_c('div', {
    staticClass: "c-split-screen__column-one"
  }, [_c('h1', [_vm._v("Day One Reserve Tool")]), _vm._v(" "), _c('p', [_vm._v("\n                Our unique reserving function allows you to perform accurate day one assessments of reserves based on your claims history.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Enter your claim type to start the reserving function")]), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "for": "",
      "label": "Enter Claim Type",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedClaimType),
      expression: "selectedClaimType"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedClaimType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.route]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal"
    }
  }, [_vm._v("Fatal Accident Claim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lost"
    }
  }, [_vm._v("Lost Years Claim")])])]), _vm._v(" "), _c('router-view', {
    staticClass: "u-margin-bottom-20",
    attrs: {
      "name": "form"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-split-screen__column-two"
  }, [_c('router-view', {
    staticClass: "u-margin-bottom-20",
    attrs: {
      "name": "results"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-policy"
  }, [_c('h2', [_vm._v("\n        Cookie Policy\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        The ABC Quantum software uses small files called cookies to help provide your experience.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        The cookies we currently use are:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://passport.bc-legal.co.uk/",
      "target": "_blank"
    }
  }, [_vm._v("\n                ABC Passport\n            ")]), _vm._v("\n            — "), _c('span', [_vm._v("required to provide secure authentication and keep you logged in whilst using the software.")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.google.com/analytics/",
      "target": "_blank"
    }
  }, [_vm._v("\n                Google Analytics\n            ")]), _vm._v(" \n            — "), _c('span', [_vm._v("for providing details about how visitors and users of the software are navigating and using the tools.")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.livechatinc.com/",
      "target": "_blank"
    }
  }, [_vm._v("\n                LiveChat\n            ")]), _vm._v(" \n            — "), _c('span', [_vm._v("for tracking what area of the software you are using when you submit feedback or request assistance from us.")])])]), _vm._v(" "), _c('p', [_vm._v("\n        Cookies are regulated by the "), _c('a', {
    attrs: {
      "href": "https://ico.org.uk/for-the-public/online/cookies/",
      "target": "_blank"
    }
  }, [_vm._v("Information Commissioner's Office (ICO)")]), _vm._v(". They have four categories of cookie which we have listed below. We've also categorised our three cookies so you know what they are:\n    ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_c('strong', [_vm._v("\n                        Cookie category\n                    ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_c('strong', [_vm._v("\n                        Cookies in use\n                    ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60%"
    }
  }, [_c('strong', [_vm._v("\n                        Notice for users\n                    ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                    Category 1\n                    "), _c('br'), _vm._v("\n                    (Strictly necessary cookies)\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    None\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    These cookies are essential in order to enable you to \n                    move around the website and use its features, such as \n                    accessing secure areas of the website. Without these \n                    cookies services you have asked for, like shopping \n                    baskets or e-billing, cannot be provided\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                    Category 2\n                    "), _c('br'), _vm._v("\n                    (Performance Cookies)\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    Google Analytics\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    These cookies collect information about how visitors use \n                    a website, for instance which pages visitors go to most \n                    often, and if they get error messages from web pages. "), _c('br'), _vm._v("\n                    These cookies don’t collect information that identifies a \n                    visitor. All information these cookies collect is aggregated \n                    and therefore anonymous. It is only used to improve how \n                    a website works.\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                    Category 3\n                    "), _c('br'), _vm._v("\n                    (Functionality cookies)\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    ABC Passport\n                    "), _c('br'), _vm._v("\n                    LiveChat\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    These cookies allow the website to remember choices \n                    you make (such as your user name, language or the \n                    region you are in) and provide enhanced, more personal \n                    features. For instance, a website may be able to provide \n                    you with local weather reports or traffic news by storing \n                    in a cookie the region in which you are currently located. \n                    These cookies can also be used to remember changes \n                    you have made to text size, fonts and other parts of web \n                    pages that you can customise. They may also be used to \n                    provide services you have asked for such as watching a \n                    video or commenting on a blog. The information these \n                    cookies collect may be anonymised and they cannot track \n                    your browsing activity on other websites.\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                    Category 4\n                    "), _c('br'), _vm._v("\n                    (Targeting or Advertising cookies)\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    None\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    These cookies are used to deliver adverts more relevant \n                    to you and your interests They are also used to limit \n                    the number of times you see an advertisement as well \n                    as help measure the effectiveness of the advertising \n                    campaigns. They are usually placed by advertising \n                    networks with the website operator’s permission. They \n                    remember that you have visited a website and this \n                    information is shared with other organisations such as \n                    advertisers. Quite often targeting or advertising cookies \n                    will be linked to site functionality provided by the other \n                    organisation.\n                ")])])])])])
}]}

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Interpolated Multipliers",
      "icon": "interpolated"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Ogden Table"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ogdenTable),
      expression: "ogdenTable"
    }],
    ref: "ogdenTable",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ogdenTable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.reCalculateMultiplier()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Please select...\n                    ")]), _vm._v(" "), _vm._l((_vm.ogdenTableInfo.tables), function(item, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(key.charAt(0).toUpperCase() + key.slice(1).replace('-', ' ')) + "\n                        -\n                        " + _vm._s(item.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }],
    ref: "discountRate",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.reCalculateMultiplier()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Please select...\n                    ")]), _vm._v(" "), _vm._l((_vm.ogdenTableInfo.columns), function(item, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "%\n                    ")])
  })], 2)]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ogdenTable !== 'table-28'),
      expression: "ogdenTable!=='table-28'"
    }],
    attrs: {
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    ref: "dateOfBirth",
    attrs: {
      "name": "date_of_birth",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.reCalculateMultiplier()
      }
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_birth')
    }
  }, [_vm._v("\n                    Date of Birth is required\n                ")])], 1), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ogdenTable !== 'table-28'),
      expression: "ogdenTable!=='table-28'"
    }],
    attrs: {
      "for": "age_of_deceased",
      "label": "Date of Trial"
    }
  }, [_c('date-input', {
    ref: "dateOfTrial",
    attrs: {
      "disabled": _vm.dateOfBirth === null || _vm.dateOfBirth === ''
    },
    on: {
      "input": function($event) {
        return _vm.reCalculateMultiplier()
      }
    },
    model: {
      value: (_vm.dateOfTrial),
      callback: function($$v) {
        _vm.dateOfTrial = $$v
      },
      expression: "dateOfTrial"
    }
  })], 1), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ogdenTable !== 'table-28'),
      expression: "ogdenTable!=='table-28'"
    }],
    attrs: {
      "label": "Age at Trial"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ageAtTrial),
      expression: "ageAtTrial"
    }],
    ref: "ageAtTrial",
    attrs: {
      "autocomplete": "off",
      "name": "age_of_deceased",
      "disabled": _vm.dateOfBirth === null || _vm.dateOfBirth === ''
    },
    domProps: {
      "value": (_vm.ageAtTrial)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtTrial = $event.target.value
      }, function($event) {
        return _vm.reCalculateMultiplier()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidAgeAtTrial()
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.ageAtTrialValidationMessage()) + "\n                ")])], 1), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ogdenTable === 'table-28'),
      expression: "ogdenTable==='table-28'"
    }],
    attrs: {
      "label": "Term"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    ref: "term",
    attrs: {
      "autocomplete": "off",
      "name": "age_of_deceased"
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }, function($event) {
        return _vm.reCalculateMultiplier()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidTerm()
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.termValidationMessage()) + "\n                ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Interpolated Multiplier"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    domProps: {
      "value": _vm.roundValue(_vm.multiplier, 2)
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiplier > 0),
      expression: "multiplier > 0"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [(_vm.multiplier) ? _c('div', [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.ogdenTableInfo.tables[_vm.ogdenTable].name) + " are calculated using Ogden " + _vm._s(_vm.ogdenTable.charAt(0).toUpperCase() + _vm.ogdenTable.slice(1).replace('-', ' ')) + ".\n                ")]), _vm._v(" "), (_vm.tableData.table.tbody.length === 1) ? _c('p', [_vm._v("\n                    Since the person's age at trial is a round figure, " + _vm._s(_vm.ageAtTrial) + " years old, an exact row can be found within the Ogden Table.\n                    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Using the discount rate of " + _vm._s(_vm.discountRate) + "% we can determine the multiplier value to be "), _c('strong', [_vm._v(_vm._s(_vm.roundValue(_vm.multiplier, 2)))])]) : _c('p', [_vm._v("\n                    Since the person's age at trial is not a round figure, " + _vm._s(_vm.ageAtTrial) + " years old, an exact row of the Ogden Table is not available. Therefore, we must\n                    use the nearest two rows and interpolate the figure from between them.\n                    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Using the discount rate of " + _vm._s(_vm.discountRate) + "% and interpolating between the two values the multiplier value can be found to be "), _c('strong', [_vm._v(_vm._s(_vm.roundValue(_vm.multiplier, 2)))])]), _vm._v(" "), (_vm.tableData !== null) ? _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width a-table--modal"
  }, [_c('thead', [_c('tr', _vm._l((_vm.tableData.table.thead), function(column) {
    return _c('th', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
    }), 0)
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.tableData.table.tbody.length > 1) ? _c('div', [_c('h2', [_vm._v("Calculation")]), _vm._v(" "), _c('p', [_vm._v("\n                        The person's age at the assumed date of trial is " + _vm._s(_vm.ageAtTrial) + " years old which, as it is not a round figure, lies between rows " + _vm._s(_vm.formulaData()[0]) + "\n                        and " + _vm._s(_vm.formulaData()[2]) + " of Ogden Table\n                        " + _vm._s(_vm.ogdenTable.charAt(0).toUpperCase() + _vm.ogdenTable.slice(1).replace('-', ' ')) + ".\n                        Therefore, interpolation between rows " + _vm._s(_vm.formulaData()[0]) + " and " + _vm._s(_vm.formulaData()[2]) + " is\n                        required on the " + _vm._s(_vm.discountRate) + "% column to receive the projected mortality value:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_vm._v("\n                            " + _vm._s(_vm.formulaData()[3]) + " + ((" + _vm._s(_vm.formulaData()[2]) + " - " + _vm._s(_vm.ageAtTrial || _vm.term) + ") x (" + _vm._s(_vm.formulaData()[1]) + " - " + _vm._s(_vm.formulaData()[3]) + ")) = " + _vm._s(_vm.roundValue(_vm.multiplier, 2)) + "\n                        ")])])]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin flex-state-buttons"
  }, [_c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "documentEditor"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('h2', {
    staticClass: "u-d-inline-block"
  }, [_vm._v("Editing - ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimantName",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentName),
      expression: "documentName"
    }],
    staticClass: "editing",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "placeholder": "Document Name",
      "name": "documentName",
      "id": "documentName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.documentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.documentName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.documentName === ''
    }
  }, [_vm._v("\n                                The document name is required\n                            ")])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-padding-t-20"
  }, [_c('router-link', {
    attrs: {
      "to": this.exitRoute
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [(_vm.claimType === 'fatal_accident_dependency') ? _c('router-link', {
    staticClass: "a-button a-button--loader-button u-no-margin",
    attrs: {
      "to": {
        name: 'fatal::dependency.documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'fatal_accident_estate') ? _c('router-link', {
    staticClass: "a-button a-button--loader-button u-no-margin",
    attrs: {
      "to": {
        name: 'fatal::estate.documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'lost_years') ? _c('router-link', {
    staticClass: "a-button a-button--loader-button u-no-margin",
    attrs: {
      "to": {
        name: 'lost::documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'personal_injury') ? _c('router-link', {
    staticClass: "a-button a-button--loader-button u-no-margin",
    attrs: {
      "to": {
        name: 'personal::documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button u-margin-trbl-0-0-0-10",
    class: [_vm.savingData() ? 'a-loader--white' : '', _vm.documentName === '' ? 'disabled' : ''],
    attrs: {
      "disabled": _vm.running || _vm.documentName === ''
    },
    on: {
      "click": function($event) {
        return _vm.saveDocument()
      }
    }
  }, [_c('span', {
    class: [_vm.savingData() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Save")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button u-margin-trbl-0-0-0-10",
    class: [_vm.savingData() ? 'a-loader--white' : '', _vm.documentName === '' ? 'disabled' : ''],
    attrs: {
      "disabled": _vm.running || _vm.documentName === ''
    },
    on: {
      "click": function($event) {
        return _vm.saveAndClose()
      }
    }
  }, [_c('span', {
    class: [_vm.savingData() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Save & Close")])]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), (_vm.theDocument.type === 'schedule_of_loss' || _vm.theDocument.type === 'offer_letter') ? _c('html-editor', {
    staticClass: "o-modal--html-editor",
    attrs: {
      "auto-height": false,
      "height": 750,
      "content": _vm.theDocument.html,
      "z-index": 10000
    },
    on: {
      "change": _vm.updateContent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDocument.type == 'comparison_schedule' && _vm.claimType === 'fatal_accident_dependency') ? _c('fatal-dependency-comparison-schedule', {
    attrs: {
      "index": this.$route.params.document_id,
      "document": _vm.theDocument
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDocument.type == 'comparison_schedule' && _vm.claimType === 'fatal_accident_estate') ? _c('fatal-estate-comparison-schedule', {
    attrs: {
      "index": this.$route.params.document_id,
      "document": _vm.theDocument
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDocument.type == 'comparison_schedule' && _vm.claimType === 'lost_years') ? _c('lost-comparison-schedule', {
    attrs: {
      "index": this.$route.params.document_id,
      "document": _vm.theDocument
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDocument.type == 'comparison_schedule' && _vm.claimType === 'personal_injury') ? _c('personal-comparison-schedule', {
    attrs: {
      "index": this.$route.params.document_id,
      "document": _vm.theDocument
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-generate-schedule__prompt u-d-none proto-6-a"
  }, [_c('div', {
    staticClass: "p-generate-schedule__prompt-align"
  }, [_vm._v("Are you sure you want to exit without saving?")])])
}]}

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid control-ie",
    class: {
      'flex-grid--reduced-bottom-margin': _vm.tableControl || _vm.noFlexMargin
    }
  }, [(!_vm.tableControl) ? _c('div', {
    staticClass: "flex-grid__g-2 flex-grid--input-label"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_c('p', {
    class: {
      'u-vertical-centre-transform-desktop no-margin-desktop': _vm.verticalCentre
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.isRequired) ? _c('span', {
    staticClass: "flex-grid--input-label-required"
  }, [_vm._v(" *")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.tableControl) ? _c('div', {
    staticClass: "flex-grid__g-7 a-form-inputs",
    class: ['a-form-inputs--' + _vm.beforeAfter, {
      'u-no-margin': !_vm.iconSpace
    }]
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "flex-grid__g-9 a-form-inputs",
    class: ['a-form-inputs--' + _vm.beforeAfter, {
      'u-no-margin': !_vm.iconSpace || _vm.theCurrentWidth < 1024
    }]
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.iconSpace || _vm.theCurrentWidth < 1024) ? _c('div', [(_vm.tipShow) ? _c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": _vm.tipName,
      "tooltip-text": _vm.tipText,
      "side": _vm.tipSide,
      "text-width": _vm.tipWidth,
      "icon-type": _vm.tipIcon
    }
  })], 1) : _c('div', {
    style: ({
      width: '26px'
    })
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Total Past & Future Losses\n    ")]), _vm._v(" "), (_vm.chosenRates.length > 1) ? _c('p', {
    staticStyle: {
      "margin-top": "0",
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n        A comparison between discount rates " + _vm._s(_vm.chosenRates[0]) + " and " + _vm._s(_vm.chosenRates[1]) + " in relation to the total of all past and future losses within your book of business.\n    ")]) : _c('p', {
    staticStyle: {
      "margin-top": "0",
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n        A comparison between the total past and future losses for the " + _vm._s(_vm.chosenRates[0]) + " discount rate within your book of business.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-center p-discount-rate-comparison__pie-container"
  }, _vm._l((_vm.chosenRates), function(rate) {
    return _c('pie', {
      attrs: {
        "title": "Discount Rate",
        "rate": rate,
        "total": _vm.totalTotal(rate),
        "labels": ['Past Losses', 'Future Losses'],
        "dataset": _vm.dataset(rate)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "values": [
        'Past Losses',
        'Future Losses'
      ],
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "30",
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), (_vm.chosenRates.length > 1) ? _c('pie-summary', {
    attrs: {
      "rates": _vm.chosenRates,
      "data": [_vm.dataset(_vm.chosenRates[0]), _vm.dataset(_vm.chosenRates[1])]
    }
  }) : _c('pie-summary', {
    attrs: {
      "rates": _vm.chosenRates,
      "data": [_vm.dataset(_vm.chosenRates[0]), _vm.dataset(_vm.chosenRates[0])]
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-margin-top-30"
  }, [_c('control', {
    attrs: {
      "label": 'Period ' + (_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodStart),
      callback: function($$v) {
        _vm.periodStart = $$v
      },
      expression: "periodStart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeFirstDay),
      expression: "includeFirstDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeFirstDay) ? _vm._i(_vm.includeFirstDay, null) > -1 : (_vm.includeFirstDay)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeFirstDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeFirstDay = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeFirstDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeFirstDay = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include first day")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodStart') || !_vm.startPeriodValid()
    }
  }, [_vm._v("\n                    Care period must start after the onset of symptoms (" + _vm._s(_vm.theDeceased.onsetOfSymptoms) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.periodStartIsBeforeAttendanceRates()
    }
  }, [_vm._v("\n                    Care period data is unavailable prior to April 1st 2009\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEnd || !_vm.periodStartIsBeforeEnd()
    }
  }, [_vm._v("\n                    Start of care period must be before end of care period\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodEnd),
      callback: function($$v) {
        _vm.periodEnd = $$v
      },
      expression: "periodEnd"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeLastDay),
      expression: "includeLastDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeLastDay) ? _vm._i(_vm.includeLastDay, null) > -1 : (_vm.includeLastDay)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeLastDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeLastDay = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeLastDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeLastDay = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include last day")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodEnd') || !_vm.endPeriodValid()
    }
  }, [_vm._v("\n                    Period end date must be before " + _vm._s(_vm.theDeceased.dateOfDeath) + "\n                ")])], 1)])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Hours per Day"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hoursPerDay),
      expression: "hoursPerDay"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "hours_per_day",
      "required": "",
      "min": "0",
      "max": "24",
      "type": "number"
    },
    domProps: {
      "value": (_vm.hoursPerDay)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.hoursPerDay = $event.target.value
      }, _vm.calcRate]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("at")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }],
    attrs: {
      "id": "method",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcRate]
    }
  }, [_c('option', {
    attrs: {
      "value": "basic"
    }
  }, [_vm._v("Basic Rate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "aggregate"
    }
  }, [_vm._v("Aggregate")])])])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gratuitous Care Discount"
    }
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gratuitousCare),
      expression: "gratuitousCare"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gratuitousCare) ? _vm._i(_vm.gratuitousCare, null) > -1 : (_vm.gratuitousCare)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.gratuitousCare,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gratuitousCare = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gratuitousCare = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.gratuitousCare = $$c
        }
      }, _vm.calcRate]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Applies the 'conventional 25% discount' to reflect the gratuitous nature of care.")])])]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubtotal),
      expression: "showSubtotal"
    }],
    attrs: {
      "for": "sub_total",
      "label": "Subtotal",
      "before-after": "pound",
      "tip-icon": _vm.subTotalIcon,
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "sub_total",
      "modal-name": 'subTotal_' + _vm.uniqueId,
      "endpoint": 'detailedCare',
      "payload": {
        period: this.findPeriod(this.index)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodTotal),
      expression: "periodTotal"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.periodTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodTotal = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showDelete) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deletePeriod
    }
  }, [_vm._v("Delete This Period")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr--margin-bottom"
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'subTotal_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-your-claims__table-container"
  }, [_c('div', {
    staticClass: "flex-grid flex-state-buttons"
  }, [_c('div', [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showInterest),
      expression: "showInterest"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showInterest) ? _vm._i(_vm.showInterest, null) > -1 : (_vm.showInterest)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showInterest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showInterest = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showInterest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showInterest = $$c
        }
      }, _vm.updateTotals]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Show Interest")])])])]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("General Damages (PSLA)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamages'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamages') - _vm.generalDamages)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('generalDamages'), _vm.generalDamages)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("General Damages (PSLA) - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamagesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages_interest",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamagesInterest),
      expression: "generalDamagesInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamagesInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamagesInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamagesWithInterest') - _vm.generalDamagesInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('generalDamagesWithInterest'), _vm.generalDamagesInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Funeral Expenses")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpenses'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_funeral_expenses",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.funeralExpenses),
      expression: "funeralExpenses",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.funeralExpenses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.funeralExpenses = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpenses') - _vm.funeralExpenses)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('funeralExpenses'), _vm.funeralExpenses)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Funeral Expenses - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpensesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_funeral_expenses",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.funeralExpensesInterest),
      expression: "funeralExpensesInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.funeralExpensesInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.funeralExpensesInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpensesWithInterest') - _vm.funeralExpensesInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('funeralExpensesWithInterest'), _vm.funeralExpensesInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loss of Spouse")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouse'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_loss_of_spouse",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lossOfSpouse),
      expression: "lossOfSpouse",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lossOfSpouse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lossOfSpouse = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouse') - _vm.lossOfSpouse)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('lossOfSpouse'), _vm.lossOfSpouse)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Loss of Spouse - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouseWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_loss_of_spouse",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lossOfSpouseInterest),
      expression: "lossOfSpouseInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lossOfSpouseInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lossOfSpouseInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouseWithInterest') - _vm.lossOfSpouseInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('lossOfSpouseWithInterest'), _vm.lossOfSpouseInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarnings'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarnings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarnings = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarnings') - _vm.pastLossOfEarnings)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastLossOfEarnings'), _vm.pastLossOfEarnings)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings - Interest ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarningsWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarningsInterest),
      expression: "pastLossOfEarningsInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarningsInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarningsInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarningsWithInterest') - _vm.pastLossOfEarningsInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastLossOfEarningsWithInterest'), _vm.pastLossOfEarningsInterest)) + "%\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravel') - _vm.pastCostOfTravel)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastCostOfTravel'), _vm.pastCostOfTravel)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Travel - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravelWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravelInterest),
      expression: "pastCostOfTravelInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravelInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravelInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravelWithInterest') - _vm.pastCostOfTravelInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastCostOfTravelWithInterest'), _vm.pastCostOfTravelInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('misc'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('misc') - _vm.misc)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('misc'), _vm.misc)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Miscellaneous - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('miscWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.miscInterest),
      expression: "miscInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.miscInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.miscInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('miscWithInterest') - _vm.miscInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('miscWithInterest'), _vm.miscInterest)) + "%")])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.customHeadsOfLoss), function(custom) {
    return _c('custom-head-of-loss', {
      attrs: {
        "headOfLoss": custom,
        "index": _vm.index,
        "showInterest": _vm.showInterest
      },
      on: {
        "update": _vm.updateTotals
      }
    })
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCare),
      expression: "pastCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCare = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCare') - _vm.pastCostOfCare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastCostOfCare'), _vm.pastCostOfCare)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Care - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCareWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCareInterest),
      expression: "pastCostOfCareInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCareInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCareInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCareWithInterest') - _vm.pastCostOfCareInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastCostOfCareWithInterest'), _vm.pastCostOfCareInterest)) + "%")])]) : _vm._e()]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headsOfLossTotal)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.dependantsHeadsOfLossTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.differenceTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headsOfLossTotal, _vm.dependantsHeadsOfLossTotal)) + "%")])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Defendant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Claimant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])]), _vm._v(" "), _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Percentage")])])])])
}]}

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageNumbers > 0) ? _c('ul', {
    staticClass: "m-pagination"
  }, _vm._l((_vm.pageNumbers), function(page) {
    return _c('li', {
      staticClass: "m-pagination__item",
      class: [page == (_vm.pageNo + 1) ? 'm-pagination__item--active' : '']
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePage(page - 1)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page) + "\n        ")])])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-margin-top-30"
  }, [_c('control', {
    attrs: {
      "label": 'Period ' + (_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodStart),
      callback: function($$v) {
        _vm.periodStart = $$v
      },
      expression: "periodStart"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodStartIsValidDate()
    }
  }, [_vm._v("\n                    The Period Start Date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodStart')
    }
  }, [_vm._v("\n                    Start of loss of earnings period must be before the deceased's date of death (" + _vm._s(_vm.theDeceased.dateOfDeath) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEnd || !_vm.periodStartIsBeforeEnd()
    }
  }, [_vm._v("\n                    Start of loss of earnings period must be before end of loss of earnings period\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodStartIsAfterOnsetOfSymptoms()
    }
  }, [_vm._v("\n                    Start of loss of earnings period must be after the onset of symptoms\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodEnd),
      callback: function($$v) {
        _vm.periodEnd = $$v
      },
      expression: "periodEnd"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEndIsValidDate()
    }
  }, [_vm._v("\n                    The Period End Date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodEnd')
    }
  }, [_vm._v("\n                    Loss of earnings period end date must be before " + _vm._s(_vm.theDeceased.dateOfDeath) + "\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEndIsAfterOnsetOfSymptoms()
    }
  }, [_vm._v("\n                    End of loss of earnings period must be after the onset of symptoms\n                ")])], 1)])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Earnings Per Annum"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodEmploymentType),
      expression: "periodEmploymentType"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    on: {
      "input": _vm.calcRate,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodEmploymentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")])]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--half u-margin-top-30"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodNetGross),
      expression: "periodNetGross"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    on: {
      "input": _vm.calcRate,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodValue),
      expression: "periodValue"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "period_value",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodValue)
    },
    on: {
      "focus": function($event) {
        _vm.periodValue = _vm.periodValue || ''
      },
      "blur": function($event) {
        _vm.periodValue = _vm.periodValue || 0
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.periodValue = $event.target.value
      }, _vm.calcRate]
    }
  })])])]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubtotal),
      expression: "showSubtotal"
    }],
    attrs: {
      "for": "sub_total",
      "label": "Subtotal",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodTotal),
      expression: "periodTotal"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.periodTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodTotal = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showDelete) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deletePeriod
    }
  }, [_vm._v("Delete This Period")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr--margin-bottom"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table a-table--modal",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [(_vm.data.table.thead[0].length) ? _c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.data.table.thead[1].length
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                        " + _vm._s(_vm.data.table.thead[0]) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.data.table.thead[1]), function(column) {
    return _c('th', [_vm._v("\n                    " + _vm._s(column) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', {
        class: {
          'a-table--highlight': column.highlight
        }
      }, [_vm._v("\n                    " + _vm._s(column.value) + "\n                ")])
    }), 0)
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.current) ? _c('div', {
    staticClass: "flex-grid flex-state-buttons c-claim-header"
  }, [_c('quantum-icons'), _vm._v(" "), _c('h2', {
    staticClass: "u-d-inline-block u-float-l u-margin-right-10"
  }, [_c('span', {
    staticClass: "claim-title"
  }, [_vm._v(_vm._s(_vm.humanClaimType) + ": ")]), _vm._v(_vm._s(_vm.pageTitle) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-position-relative c-claim-header__right"
  }, [(!_vm.isFinalStep) ? _c('button', {
    staticClass: "svg_button u-float-l c-icon-tooltip u-r-full-width u-r-d-flex",
    class: {
      'm-icon--disabled': !_vm.current.valid, 'm-icon--save': _vm.current.valid
    },
    on: {
      "click": _vm.saveForm
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small u-d-inline-block",
    class: [!_vm.current.valid ? 'm-icon--save-hover' : ''],
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#save"
    }
  })]), _vm._v(" "), (_vm.tooltipVisible && _vm.current.valid || _vm.current.valid && _vm.theCurrentWidth <= 1024) ? _c('div', {
    staticClass: "c-icon-tooltip__text c-icon-tooltip__bottom"
  }, [_vm._v("\n                    Save claim progress\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tooltipVisible && !_vm.current.valid || !_vm.current.valid && _vm.theCurrentWidth <= 1024) ? _c('div', {
    staticClass: "c-icon-tooltip__text c-icon-tooltip__bottom"
  }, [_vm._v("\n                    Cannot save until all step data is valid\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.saving()) ? _c('div', {
    staticClass: "a-loader u-float-l u-d-inline-block a-loader--save-icon"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-claim-header__timeline-text m-hide-timeline",
    class: {
      'm-hide-timeline--closed': _vm.isTimelineOpen
    },
    on: {
      "click": _vm.updateTimeline
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.timelineText))])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTimelineOpen),
      expression: "isTimelineOpen"
    }],
    staticClass: "m-timeline"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDocumentView),
      expression: "!isDocumentView"
    }],
    staticClass: "m-timeline__progress",
    class: 'm-timeline__progress--' + _vm.timelineSteps
  }, _vm._l((_vm.steps), function(step, index) {
    return (step.route.meta.step <= 9) ? _c('router-link', {
      class: {
        'm-timeline__progress--active': index <= _vm.stepNo && !_vm.progressInvalid(index, step),
          'm-timeline__progress--disabled': !_vm.progressAllowed(index, step),
          'm-timeline__progress--error': _vm.progressInvalid(index, step)
      },
      attrs: {
        "tag": "li",
        "to": _vm.route(step),
        "active-class": "m-timeline__progress--active"
      }
    }, [_c('span', [_vm._v(_vm._s(step.name))])]) : _vm._e()
  }), 1)])])
},staticRenderFns: []}

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs a-form-inputs--table"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('accordion', [_c('general-damages'), _vm._v(" "), _c('past-cost-of-care'), _vm._v(" "), _c('past-cost-of-travel'), _vm._v(" "), _c('past-loss-of-earnings')], 1), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.allValid
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Care — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('modal-content')], 1)
},staticRenderFns: []}

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Dependency on Services — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is determined (i) from the deceased's date of death to the deceased's 'but for' date\n        of death, and (ii) either applying a multiplicand based on average data within the tool for claims of a\n        similar type, or a multiplicand of £1,500. The period between death and assumed date of trial/settlement \n        is discounted by Table E Factor. The multiplier is applied from date of trial/assumed settlement but discounted by Table F Factor.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gd-psla-calculator__psla-award"
  }, [_c('h2', [_vm._v(_vm._s(_vm.award.case_name))]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('tr', [_c('td', [_vm._v("Claimant Age at Trial/Deceased Age")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.age_display))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Updated PSLA Award (May 2017)")]), _vm._v(" "), _c('td', {
    staticClass: "c-gd-psla-calculator__award-container u-position-relative"
  }, [_c('div', {
    staticClass: "c-gd-psla-calculator__award"
  }, [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.award.award)) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller u-float-r",
    on: {
      "click": function($event) {
        return _vm.usePslaAward(_vm.award.award)
      }
    }
  }, [_vm._v("\n                        Use this PSLA Award\n                    ")])])]), _vm._v(" "), (_vm.afterDate) ? _c('tr', [_c('td', [_vm._v("Updated PSLA Award (" + _vm._s(_vm.monthToString(_vm.maxMonth)) + " " + _vm._s(_vm.maxYear) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "c-gd-psla-calculator__award-container u-position-relative"
  }, [_c('div', {
    staticClass: "c-gd-psla-calculator__award"
  }, [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.equivalent)) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller u-float-r",
    on: {
      "click": function($event) {
        return _vm.usePslaAward(_vm.equivalent)
      }
    }
  }, [_vm._v("\n                        Use this PSLA Award\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Duration of Symptoms")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.duration) + " month" + _vm._s(_vm.award.duration === 1 ? '' : 's'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reduction in Life Expectancy")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.reduction_in_life))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Effects of Injury")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.effects))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_vm._m(0), _vm._v(" "), (_vm.interimPayments.length === 0) ? _c('p', [_vm._v("\n                Add details of any Interim Payments using the button below:\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.interimPayments), function(interimPayment, index) {
    return _c('div', {
      staticClass: "dependant a-form-inputs--section"
    }, [_c('payment', {
      attrs: {
        "index": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addPayment
    }
  }, [_vm._v("Add Interim Payment")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "a-form-inputs"
  }, [_vm._m(1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Calculate Interest Rates to"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestType),
      expression: "interestType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcInterestValue]
    }
  }, [_c('option', {
    attrs: {
      "value": "today"
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_settlement"
    }
  }, [_vm._v("Assumed Settlement")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Custom")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Do Not Calculate")])])]), _vm._v(" "), (_vm.interestType === 'custom') ? _c('control', {
    attrs: {
      "label": "Custom date",
      "for": "custom_interest_date"
    }
  }, [_c('date-input', {
    on: {
      "input": _vm.calcInterestValue
    },
    model: {
      value: (_vm.customInterestDate),
      callback: function($$v) {
        _vm.customInterestDate = $$v
      },
      expression: "customInterestDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidDate()
    }
  }, [_vm._v("\n                        Date is required, must be in the format DD/MM/YYYY, be after the deceased's date of death\n                        (" + _vm._s(_vm.deceasedDod) + ")\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('div', {
    staticClass: "m-div-table__holder m-div-table__holder--less-margin"
  }, [_c('interest-item', {
    attrs: {
      "interest": _vm.value('generalDamagesInterest'),
      "option": {
        name: 'generalDamages'
      },
      "payload": _vm.payload,
      "unique-id": _vm.uniqueId,
      "value": _vm.value('generalDamagesWithInterest'),
      "tip-name": "general_damages_psla",
      "title": "General damages (PSLA)",
      "updates": "generalDamages"
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('funeralExpensesInterest'),
      "option": {
        name: 'funeralExpenses'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('funeralExpensesWithInterest'),
      "tip-name": "funeral_expenses",
      "title": "Funeral Expenses",
      "updates": "funeralExpensesInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('lossOfSpouseInterest'),
      "option": {
        name: 'lossOfSpouse'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('lossOfSpouseWithInterest'),
      "tip-name": "loss_of_spouse",
      "title": "Loss of Spouse",
      "updates": "lossOfSpouseInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastLossOfEarningsInterest'),
      "option": {
        name: 'pastLossOfEarnings'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastLossOfEarningsWithInterest'),
      "tip-name": "past_loss_of_earnings",
      "title": "Past Loss of Earnings",
      "updates": "pastLossOfEarningsInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastCostOfCareInterest'),
      "option": {
        name: 'pastCostOfCare'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastCostOfCareWithInterest'),
      "tip-name": "past_cost_of_care",
      "title": "Past Cost of Care",
      "updates": "pastCostOfCareInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastCostOfTravelInterest'),
      "option": {
        name: 'pastCostOfTravel'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastCostOfTravelWithInterest'),
      "tip-name": "past_cost_of_travel",
      "title": "Past Cost of Travel",
      "updates": "pastCostOfTravelInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('miscInterest'),
      "option": {
        name: 'misc'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('miscWithInterest'),
      "tip-name": "miscellaneous",
      "title": "Miscellaneous",
      "updates": "miscInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _vm._l((_vm.headsOfLoss), function(headOfLoss, key) {
    return _c('interest-item', {
      attrs: {
        "payload": _vm.payload,
        "interest": headOfLoss.interest,
        "option": {
          name: headOfLoss.name,
          key: key
        },
        "title": headOfLoss.name,
        "unique-id": _vm.uniqueId,
        "updates": key,
        "value": headOfLoss.interestAccrued,
        "tip-name": headOfLoss.name
      },
      on: {
        "update": _vm.onUpdateCustom
      }
    })
  })], 2), _vm._v(" "), _c('br')])], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.$valid() && _vm.allInterimPaymentsValid
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'interest_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Interim Payments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Interest")])])
}]}

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Pre and Post Assessment Discounts",
      "icon": "table-e-f-discounts"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pre_or_pos",
      "label": "Discount Type"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.preOrPost),
      expression: "preOrPost"
    }],
    ref: "preOrPost",
    attrs: {
      "required": "",
      "name": "pre_or_pos"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preOrPost = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pre"
    }
  }, [_vm._v("Pre-Assessment Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "post"
    }
  }, [_vm._v("Post-Assessment Discount")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pre_or_pos')
    }
  }, [_vm._v("\n                    Please select Pre or Post\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "gender",
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    attrs: {
      "required": "",
      "name": "gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('gender')
    }
  }, [_vm._v("\n                    The gender is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_death')
    }
  }, [_vm._v("\n                    The Date of Death is required and must be in the format DD/MM/YYYY\n                    and The Age of Deceased has to be between 10 - 90\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_of_deceased",
      "label": "Age of Deceased",
      "no-flex-margin": true,
      "vertical-centre": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ageOfDeceased),
      expression: "ageOfDeceased"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    ref: "ageOfDeceased",
    attrs: {
      "autocomplete": "off",
      "name": "age_of_deceased",
      "required": "",
      "min": "10",
      "max": "90",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageOfDeceased)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageOfDeceased = $event.target.value
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_of_deceased') || !_vm.ageRules
    }
  }, [_vm._v("\n                    The Age of Deceased has to be between 10 - 90\n                ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "u-accent u-r-margin-top-20 u-d-block"
  }, [_vm._v("or")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_of_deceased",
      "label": "Date of Death",
      "vertical-centre": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:dateOfDeath.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "dateOfDeath",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfDeath",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfDeath),
      callback: function($$v) {
        _vm.dateOfDeath = $$v
      },
      expression: "dateOfDeath"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_trial_or_cessation",
      "label": "Date of Trial"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_trial_or_cessation.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_trial_or_cessation",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfTrialOrCessation",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfTrialOrCessation),
      callback: function($$v) {
        _vm.dateOfTrialOrCessation = $$v
      },
      expression: "dateOfTrialOrCessation"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_trial_or_cessation') || !_vm.dateOfTrialOrCessationRules
    }
  }, [_vm._v("\n                    The Date of Trial is required and must be in the format DD/MM/YYYY\n                    and can not be more than 9 years after the Date of Death\n                ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_result",
      "label": _vm.discountResultLabel
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.discountResult),
      expression: "discountResult"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "discount_result",
      "type": "number",
      "name": "discount_result"
    },
    domProps: {
      "value": (_vm.discountResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discountResult = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                To calculate the factor by which pre or post-trial damages should be discounted, Ogden Tables E and F\n                are used, respectively.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Using Ogden Table " + _vm._s(_vm.preOrPost == 'pre' ? "E" : "F") + " the factor by which\n                " + _vm._s(_vm.preOrPost) + "-trial damages should be discounted can be calculated using the age of the deceased at\n                the date of death and the number of years between the date of death and the\n                date of trial/assumed settlement.\n            ")]), _vm._v(" "), (_vm.tableData !== null) ? _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table a-table--modal a-table--really-wide"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                                Period from date of accident to date of trial or assumed settlement\n                            ")])])]), _vm._v(" "), _c('tr', _vm._l((_vm.tableData.table.thead), function(column) {
    return _c('th', [_vm._v("\n                            " + _vm._s(column) + "\n                        ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column, index) {
      return _c('td', [_vm._v("\n                            " + _vm._s(index === 0 || index === 5 ? column : _vm.currencyFormat(column, '')) + "\n                        ")])
    }), 0)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("\n                Calculation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The age of the deceased at the date of the accident was\n                " + _vm._s(_vm.ageOfDeceased) + " years old and the period from the date of the accident to the date of\n                trial or assumed settlement of\n                dependency was " + _vm._s(_vm.periodBetweenDodAndDot) + " years.\n            ")]), _vm._v(" "), (_vm.explanation !== null) ? _c('p', [_vm._v("\n                " + _vm._s(_vm.explanation) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n                Through interpolation it has been deduced that the\n                " + _vm._s(_vm.preOrPost) + "-assessment discount is: "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.discountResult, '')))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            General Damages\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "store-key": "gdPneumoconiosis",
      "title": "General Damages",
      "subtitle": "Pneumoconiosis etc, (Workers Compensation) Act 1979 including any extra statutory payments made following the rejection of a claim under the 1979 Act",
      "show-header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "General Damages",
      "store-key": "gdMesothelioma",
      "subtitle": "2008 Diffuse Mesothelioma Scheme",
      "is-last": "",
      "show-header": ""
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    ref: "theHeader",
    staticClass: "o-header",
    style: ({
      width: _vm.theCurrentHeaderWidth,
      position: _vm.theCurrentHeaderPosition
    })
  }, [_c('div', {
    staticClass: "o-menu__icon-mob",
    on: {
      "click": _vm.updateMobileMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin flex-state-buttons u-full-width u-flex-direction-row u-r-flex-start"
  }, [_c('div', {
    staticClass: "a-logo-image"
  }, [_c('h1', [_c('svg', {
    attrs: {
      "viewBox": "0 0 400 53.8"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#logo"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin o-header__right"
  }, [_c('div', {
    staticClass: "o-header__button-container"
  }, [(_vm.saveButton) ? _c('div', {
    class: [_vm.saving() ? 'a-loader--save-claim' : '']
  }) : _vm._e(), _vm._v(" "), (_vm.saveButton && !_vm.saving()) ? _c('button', {
    staticClass: "a-button a-button--header-button",
    attrs: {
      "disabled": _vm.current && !_vm.current.valid
    },
    on: {
      "click": _vm.saveForm
    }
  }, [_vm._v("Save Claim")]) : _vm._e(), _vm._v(" "), (_vm.loadButton) ? _c('button', {
    staticClass: "a-button a-button--header-button u-margin-left-10",
    on: {
      "click": _vm.force
    }
  }, [_vm._v("Load Claim")]) : _vm._e(), _vm._v(" "), _c('create-a-new-claim')], 1), _vm._v(" "), _c('div', {
    staticClass: "o-header__bc-logo u-r-margin-left-20"
  }, [_c('span', [_vm._v("created by:")]), _vm._v(" "), _c('svg', {
    attrs: {
      "viewBox": "0 0 185 52"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#bc-logo"
    }
  })])])])]), _vm._v(" "), _c('div', {
    class: {
      'o-header__line': _vm.setBorder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Claim Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimType),
      expression: "claimType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.claimType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident"
    }
  }, [_vm._v("All Fatal Accident")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident_dependency"
    }
  }, [_vm._v("Fatal Accident Dependency")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident_estate"
    }
  }, [_vm._v("Fatal Accident Estate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lost_years"
    }
  }, [_vm._v("Lost Years")]), _vm._v(" "), (_vm.diseaseOrAccident !== 'disease') ? _c('option', {
    attrs: {
      "value": "personal_injury"
    }
  }, [_vm._v("Personal Injury")]) : _vm._e()])]), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Disease or Accident")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])])]) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Disease Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")])])]) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident' || _vm.claimType === 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Accident Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Discount Rate")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('from-to')], 1)]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small p-compare-reserve__top-form-button",
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("Load Claims")])])
},staticRenderFns: []}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width a-table--hover",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("General Damages (PSLA)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('generalDamages'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('generalDamagesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastDependencyOnServices'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastDependencyOnServicesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfCareWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastCostOfTravelWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.pastLossTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('pastLossOfEarningsWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('misc'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('miscWithInterest'))))])]), _vm._v(" "), _vm._l((_vm.allCustomHeadOfLoss), function(headOfLoss, key) {
    return (_vm.allCustomHeadOfLoss.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(headOfLoss.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(headOfLoss.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(headOfLoss.interestAccrued)))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Cost of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('futureDependencyOnServices'))))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getHeadsOfLossValue('futureCostOfCare'))))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureLossTotal)))]), _vm._v(" "), _c('td')]), _vm._v(" "), (_vm.cruTotalDeductions > 0) ? _c('tr', [_c('td', [_vm._v("CRU Benefit Deductions")]), _vm._v(" "), _c('td', [_vm._v("- " + _vm._s(_vm.currencyFormat(_vm.cruTotalDeductions)))]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.subTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestTotal)))])]), _vm._v(" "), _c('tr', {
    staticClass: "a-table--penultimate"
  }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.total)))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalLessInterimPayments)))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "step-button flex-state-buttons flex-state-buttons--block a-table--center"
  }, [_c('div', [_c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'lost::step-7'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'lost::documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                View Documents\n            ")])], 1)]), _vm._v(" "), _c('reserves-for-claim')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Amount")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Interest")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Total "), _c('span', [_vm._v("less interim payment(s)")])])
}]}

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "for": "claimantName",
      "label": "Claimant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantName),
      expression: "claimantName"
    }, {
      name: "field-control",
      rawName: "v-field-control:claimantName.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "claimantName",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "claimantName",
      "id": "claimantName",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimantName')
    }
  }, [_vm._v("\n                        The claimant name is required and must be a valid name\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Claimant Solicitors',
      "error-message": 'The claimant solicitor is required and must be a valid name',
      "value": _vm.claimantSolicitor,
      "type": 'claimant_solicitors'
    },
    on: {
      "update": _vm.updateClaimantSolicitors
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimaint_reference",
      "label": "Claimant Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantReference),
      expression: "claimantReference"
    }, {
      name: "field-control",
      rawName: "v-field-control:claimantReference.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "claimantReference",
      modifiers: {
        "required": true
      }
    }],
    staticClass: "input",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "maxlength": "100",
      "name": "claimaint_reference",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimantReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimantReference')
    }
  }, [_vm._v("\n                        The claimant reference is required\n                    ")])], 1), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Defendant Name',
      "error-message": 'The defendant name is required and must be a valid name',
      "value": _vm.defendantName,
      "type": 'defendant'
    },
    on: {
      "update": _vm.updateDefendant
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "name": "disease_or_accident",
      "label": "Disease or Accident?"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    attrs: {
      "name": "disease_or_accident",
      "id": "disease_or_accident",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_or_accident')
    }
  }, [_vm._v("\n                        The disease type is required\n                    ")])], 1), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', [_c('control', {
    attrs: {
      "name": "disease_type",
      "label": "Disease"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    attrs: {
      "name": "disease_type",
      "id": "disease_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" - - -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer — Specify Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" - - -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_type')
    }
  }, [_vm._v("\n                            The disease type is required\n                        ")])], 1), _vm._v(" "), (_vm.diseaseType && _vm.diseaseType.substr(0, 5) === 'Other') ? _c('control', {
    attrs: {
      "name": "disease_type_other",
      "label": "Disease Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherDiseaseType),
      expression: "otherDiseaseType"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "disease_type_other",
      "id": "disease_type_other",
      "required": ""
    },
    domProps: {
      "value": (_vm.otherDiseaseType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherDiseaseType = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_type_other') || _vm.otherDiseaseType === null
    }
  }, [_vm._v("\n                            The disease type is required\n                        ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident') ? _c('div', [_c('control', {
    attrs: {
      "name": "accident_type",
      "label": "Accident"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    attrs: {
      "name": "accident_type",
      "id": "accident_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('accident_type')
    }
  }, [_vm._v("\n                            The accident type is required\n                        ")])], 1), _vm._v(" "), (_vm.accidentType && _vm.accidentType.substr(0, 5) === 'Other') ? _c('control', {
    attrs: {
      "name": "accident_type_other",
      "label": "Accident Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherAccidentType),
      expression: "otherAccidentType"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "accident_type_other",
      "id": "accident_type_other",
      "required": ""
    },
    domProps: {
      "value": (_vm.otherAccidentType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherAccidentType = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('accident_type_other') || _vm.otherAccidentType === null
    }
  }, [_vm._v("\n                            The accident type is required\n                        ")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "your_reference",
      "label": "Your Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yourReference),
      expression: "yourReference"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "your_reference",
      "maxlength": "30",
      "type": "text"
    },
    domProps: {
      "value": (_vm.yourReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('your_reference')
    }
  }, [_vm._v("\n                        Your reference is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pre_lit_or_lit",
      "label": "Procedural Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preLitOrLit),
      expression: "preLitOrLit"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "pre_lit_or_lit",
      "id": "pre_lit_or_lit",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preLitOrLit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre-lit"
    }
  }, [_vm._v("Pre-Litigation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "litigated"
    }
  }, [_vm._v("Litigated")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pre_lit_or_lit')
    }
  }, [_vm._v("\n                        Procedural status is required\n                    ")])], 1), _vm._v(" "), (_vm.preLitOrLit == 'litigated') ? _c('control', {
    attrs: {
      "for": "date_of_service_proceedings",
      "label": "Date of Service of Proceedings"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_service_proceedings.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_service_proceedings",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfServiceProceedings),
      callback: function($$v) {
        _vm.dateOfServiceProceedings = $$v
      },
      expression: "dateOfServiceProceedings"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_service_proceedings') || _vm.showServiceOfProceedingsValidationMessage_required
    }
  }, [_vm._v("\n                        Date of service of proceedings is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showServiceOfProceedingsValidationMessage_before
    }
  }, [_vm._v("\n                        Date of service of proceedings must be before the date of assumed settlement\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showServiceOfProceedingsValidationMessage_9years
    }
  }, [_vm._v("\n                        Date of service of proceeding cannot be more than 9 years before the date of assumed\n                        settlement\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement')
    }
  }, [_vm._v("\n                        Date of assumed settlement is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('control-warning', {
    attrs: {
      "show": _vm.dateOfAssumedSettlementInPast
    }
  }, [_c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-warning-box__orange"
  }, [_vm._v("Date of assumed settlement is in the past")])])], 1)], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_rate",
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('discount_rate')
    }
  }, [_vm._v("\n                        Discount rate is required\n                    ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs flex-grid__item--full"
  }, [_c('control', {
    attrs: {
      "for": "claim_narrative",
      "label": "Claim Narrative",
      "tip-text": "Provide a brief background to the claim and issues in dispute. This narrative will populate your counter-schedule of loss.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "claim_narrative"
    }
  }, [_c('textarea', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claim_narrative.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "claim_narrative",
      modifiers: {
        "required": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.narrative),
      expression: "narrative"
    }],
    staticClass: "u-full-width",
    attrs: {
      "required": "",
      "rows": "4",
      "name": "claim_narrative"
    },
    domProps: {
      "value": (_vm.narrative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.narrative = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claim_narrative')
    }
  }, [_vm._v("\n                    The claim narrative is required\n                ")])], 1)], 1)]), _vm._v(" "), _c('step-button', {
    attrs: {
      "prev-valid": false,
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width a-table--hover",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("General Damages (PSLA)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamages'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamagesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Funeral Expenses")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpenses'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpensesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loss of Spouse")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouse'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouseWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravelWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('misc'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('miscWithInterest'))))])]), _vm._v(" "), _vm._l((_vm.customHeadsOfLoss), function(customHead) {
    return (_vm.customHeadsOfLoss.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(customHead.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(customHead.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(customHead.interestAccrued)))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarnings'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarningsWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCareWithInterest'))))])]), _vm._v(" "), (_vm.cruTotalDeductions > 0) ? _c('tr', [_c('td', [_vm._v("CRU Benefit Deductions")]), _vm._v(" "), _c('td', [_vm._v("- " + _vm._s(_vm.currencyFormat(_vm.cruTotalDeductions)))]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.subTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestTotal)))])]), _vm._v(" "), (_vm.interimPayments.length > 0) ? _c('tr', {
    staticClass: "a-table--penultimate"
  }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.total)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total "), (_vm.interimPayments.length > 0) ? _c('span', [_vm._v("less interim payment(s)")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalLessInterimPayments)))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "step-button flex-state-buttons flex-state-buttons--block a-table--center"
  }, [_c('div', [_c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'fatal::estate.step-5'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'fatal::estate.documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                View Documents\n            ")])], 1)]), _vm._v(" "), _c('reserves-for-claim')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Amount")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Interest")])])])
}]}

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-position-relative"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "a-loader--typeahead"
  }) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "typeaheadField",
      "label": _vm.label
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:typeaheadField.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "typeaheadField",
      modifiers: {
        "required": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "typeaheadField",
      "maxlength": "100",
      "required": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.hit.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.reset.apply(null, arguments)
      }],
      "blur": _vm.reset,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.update]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('typeaheadField')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n        ")])], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasItems && _vm.inFocus),
      expression: "hasItems && inFocus"
    }]
  }, _vm._l((_vm.items), function(item, $item) {
    return _c('li', {
      class: _vm.activeClass($item),
      on: {
        "mousedown": _vm.hit,
        "mousemove": function($event) {
          return _vm.setActive($item)
        }
      }
    }, [_c('span', {
      staticClass: "name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "textContent": _vm._s(item.screen_name)
      }
    })])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs a-form-inputs--table"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('accordion', [_c('general-damages'), _vm._v(" "), _c('past-cost-of-care'), _vm._v(" "), _c('past-cost-of-travel'), _vm._v(" "), _c('past-loss-of-earnings')], 1), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.allValid
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "for": "claimantName",
      "label": "Claimant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantName),
      expression: "claimantName"
    }, {
      name: "field-control",
      rawName: "v-field-control:claimantName.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "claimantName",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "claimantName",
      "id": "claimantName",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimantName')
    }
  }, [_vm._v("The claimant name is required and must be a valid name")])], 1) : _vm._e(), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Claimant Solicitors',
      "error-message": 'The claimant solicitor is required and must be a valid name',
      "value": _vm.claimantSolicitor,
      "type": 'claimant_solicitors'
    },
    on: {
      "update": _vm.updateClaimantSolicitors
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimaint_reference",
      "label": "Claimant Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantReference),
      expression: "claimantReference"
    }, {
      name: "field-control",
      rawName: "v-field-control:claimantReference.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "claimantReference",
      modifiers: {
        "required": true
      }
    }],
    staticClass: "input",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "maxlength": "100",
      "name": "claimaint_reference",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimantReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimantReference')
    }
  }, [_vm._v("The claimant reference is required")])], 1), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Defendant Name',
      "error-message": 'The defendant name is required and must be a valid name',
      "value": _vm.defendantName,
      "type": 'defendant'
    },
    on: {
      "update": _vm.updateDefendant
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "name": "disease_or_accident",
      "label": "Disease or Accident?"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    attrs: {
      "name": "disease_or_accident",
      "id": "disease_or_accident",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_or_accident')
    }
  }, [_vm._v("The disease type is required")])], 1), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', [_c('control', {
    attrs: {
      "name": "disease_type",
      "label": "Disease"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    attrs: {
      "name": "disease_type",
      "id": "disease_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("- - -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer — Specify Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("- - -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_type')
    }
  }, [_vm._v("The disease type is required")])], 1), _vm._v(" "), (_vm.diseaseType && _vm.diseaseType.substr(0, 5) === 'Other') ? _c('control', {
    attrs: {
      "name": "disease_type_other",
      "label": "Disease Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherDiseaseType),
      expression: "otherDiseaseType"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "disease_type_other",
      "id": "disease_type_other",
      "required": ""
    },
    domProps: {
      "value": (_vm.otherDiseaseType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherDiseaseType = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_type_other') || _vm.otherDiseaseType === null
    }
  }, [_vm._v("The disease type is required")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident') ? _c('div', [_c('control', {
    attrs: {
      "name": "accident_type",
      "label": "Accident"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    attrs: {
      "name": "accident_type",
      "id": "accident_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('accident_type')
    }
  }, [_vm._v("The accident type is required")])], 1), _vm._v(" "), (_vm.accidentType && _vm.accidentType.substr(0, 5) === 'Other') ? _c('control', {
    attrs: {
      "name": "accident_type_other",
      "label": "Accident Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherAccidentType),
      expression: "otherAccidentType"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "accident_type_other",
      "id": "accident_type_other",
      "required": ""
    },
    domProps: {
      "value": (_vm.otherAccidentType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherAccidentType = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('accident_type_other') || _vm.otherAccidentType === null
    }
  }, [_vm._v("The accident type is required")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "your_reference",
      "label": "Your Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yourReference),
      expression: "yourReference"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "your_reference",
      "maxlength": "30",
      "type": "text"
    },
    domProps: {
      "value": (_vm.yourReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('your_reference')
    }
  }, [_vm._v("Your reference is required")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pre_lit_or_lit",
      "label": "Procedural Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preLitOrLit),
      expression: "preLitOrLit"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "pre_lit_or_lit",
      "id": "pre_lit_or_lit",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preLitOrLit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre-lit"
    }
  }, [_vm._v("Pre-Litigation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "litigated"
    }
  }, [_vm._v("Litigated")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pre_lit_or_lit')
    }
  }, [_vm._v("Procedural status is required")])], 1), _vm._v(" "), (_vm.preLitOrLit == 'litigated') ? _c('control', {
    attrs: {
      "for": "date_of_service_proceedings",
      "label": "Date of Service of Proceedings"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_service_proceedings.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_service_proceedings",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfServiceProceedings),
      callback: function($$v) {
        _vm.dateOfServiceProceedings = $$v
      },
      expression: "dateOfServiceProceedings"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_service_proceedings') || _vm.showServiceOfProceedingsValidationMessage_required
    }
  }, [_vm._v("Date of service of proceedings is required in the format DD/MM/YYYY")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showServiceOfProceedingsValidationMessage_before
    }
  }, [_vm._v("Date of service of proceedings must be before the date of assumed settlement")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showServiceOfProceedingsValidationMessage_9years
    }
  }, [_vm._v("\n            Date of service of proceeding cannot be more than 9 years before the date of assumed\n            settlement\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement')
    }
  }, [_vm._v("Date of assumed settlement is required in the format DD/MM/YYYY")]), _vm._v(" "), _c('control-warning', {
    attrs: {
      "show": _vm.dateOfAssumedSettlementInPast
    }
  }, [_c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-warning-box__orange"
  }, [_vm._v("Date of assumed settlement is in the past")])])], 1)], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_rate",
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('discount_rate')
    }
  }, [_vm._v("Discount rate is required")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs flex-grid__item--full"
  }, [_c('control', {
    attrs: {
      "for": "claim_narrative",
      "label": "Claim Narrative",
      "tip-text": "Provide a brief background to the claim and issues in dispute. This narrative will populate your counter-schedule of loss.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "claim_narrative"
    }
  }, [_c('textarea', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claim_narrative.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "claim_narrative",
      modifiers: {
        "required": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.narrative),
      expression: "narrative"
    }],
    staticClass: "u-full-width",
    attrs: {
      "required": "",
      "rows": "4",
      "name": "claim_narrative"
    },
    domProps: {
      "value": (_vm.narrative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.narrative = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claim_narrative')
    }
  }, [_vm._v("The claim narrative is required")])], 1)], 1)]), _vm._v(" "), _c('step-button', {
    attrs: {
      "prev-valid": false,
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        This head of loss is calculated using the BC Legal General Damages PSLA Calculator.\n            This assesses common law awards according to 'age' and 'duration' of symptoms-the period between onset\n            of disease and death (or anticipated date of death).\n    ")]), _vm._v(" "), _c('em', [_vm._v("The relevant excerpt from the PLSA Calculator is shown below.")]), _vm._v(" "), _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed u-margin-top-20"
  }, [_c('thead', [_vm._m(0), _vm._v(" "), _c('tr', _vm._l((_vm.durationLabels), function(label) {
    return _c('th', [_vm._v("\n                " + _vm._s(label) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableResults), function(row, ageKey) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(_vm.ageLabels[ageKey]))]), _vm._v(" "), _vm._l((row), function(cell, cellIndex) {
      return _c('td', {
        style: (_vm.calcCellStyle(ageKey, cellIndex))
      }, [_vm._v("\n                " + _vm._s(_vm.currencyFormat(cell, "£", 0)) + "\n            ")])
    })], 2)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up To)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Duration of Symptoms (months)")])])
}]}

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('div', {
    staticClass: "u-d-flex u-flex-center u-r-flex-wrap"
  }, [_c('h2', {
    staticClass: "u-centre chart u-margin-bottom-20 u-r-flex-1-0-100"
  }, [_vm._v("\n            Analyse Claims by Claims Handler\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "fee-earner",
    on: {
      "click": _vm.openModal
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to see details of the different options",
      "side": "left",
      "text-width": "200"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-compare-reserve__fee-earner-chart-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.compareType),
      expression: "compareType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.compareType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Total Difference"
    }
  }, [_vm._v("Total Difference")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Average Difference"
    }
  }, [_vm._v("Average Difference")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Maximum Difference"
    }
  }, [_vm._v("Maximum Difference")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Number of Claims"
    }
  }, [_vm._v("Number of Claims")])])]), _vm._v(" "), (_vm.show && _vm.theCurrentWidth >= 600) ? _c('bar-chart', {
    attrs: {
      "chart-data": _vm.currentChartData,
      "options": _vm.chartOptions,
      "height": 200
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theCurrentWidth < 600) ? _c('table', {
    staticClass: "a-table"
  }, [_c('th', [_vm._v("Fee Earner")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.compareType))]), _vm._v(" "), _vm._l((_vm.currentChartData.labels), function(info, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.currentChartData.labels[index]))]), _vm._v(" "), (_vm.compareType !== 'Number of Claims') ? _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.currentChartData.datasets[0].data[index])))]) : _c('td', [_vm._v(_vm._s(_vm.currentChartData.datasets[0].data[index]))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "feinfo",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("Different options for comparing Claims Handlers.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Total Difference")])]), _vm._v(" "), _c('p', [_vm._v("The total difference from '" + _vm._s(_vm.fromLabel) + "' to '" + _vm._s(_vm.toLabel) + "' grouped by Claims Handler for all the claims\n            matching your filter criteria.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Average Difference")])]), _vm._v(" "), _c('p', [_vm._v("The average difference from '" + _vm._s(_vm.fromLabel) + "' to '" + _vm._s(_vm.toLabel) + "' for each Claims Handler for all the claims\n            matching your filter criteria.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maximum Difference")])]), _vm._v(" "), _c('p', [_vm._v("For each Claims Handler the case that has the maximum difference from '" + _vm._s(_vm.fromLabel) + "' to '" + _vm._s(_vm.toLabel) + "'\n            matching your filter criteria.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Total Claims")])]), _vm._v(" "), _c('p', [_vm._v("For each Claims Handler the total number of claims that match your filter criteria for each Claims Handler.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("NOTE: Any Claims Handler that does not have a result is omitted.")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-mini-calc-icons"
  }, [_c('svg', {
    staticStyle: {
      "position": "absolute",
      "display": "none"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('svg', {
    attrs: {
      "id": "age-calculator",
      "aria-labelledby": "age-calculator",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Age Calculator")]), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "45.7",
      "cy": "68.3",
      "r": "3.2"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.2 42.9C10.4 42.9.8 33.3.8 21.5S10.4.2 22.2.2s21.4 9.6 21.4 21.4-9.7 21.3-21.4 21.3zm0-40.7c-10.6 0-19.3 8.7-19.3 19.3s8.7 19.3 19.3 19.3c10.6 0 19.3-8.7 19.3-19.3S32.8 2.2 22.2 2.2z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.2 22.5c-.6 0-1-.5-1-1V9.7c0-.6.5-1 1-1 .6 0 1 .5 1 1v11.8c0 .6-.5 1-1 1z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M34 22.5H22.2c-.6 0-1-.5-1-1 0-.6.5-1 1-1H34c.6 0 1 .5 1 1 0 .6-.5 1-1 1z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "75",
      "cy": "68.3",
      "r": "3.2"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.7 54.1c-.5 0-1-.4-1.1-.9-.1-.6.3-1.1.9-1.2l17-2.3c.6-.1 1.1.3 1.2.9.1.6-.3 1.1-.9 1.2l-17 2.3h-.1zM83.8 54.1h-.1l-17-2.3c-.6-.1-1-.6-.9-1.2.1-.6.6-1 1.2-.9L84 52c.6.1 1 .6.9 1.2-.1.5-.5.9-1.1.9z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60.3 120c-18 0-35.2-13.6-44.1-34.8-5.7-2-10.6-7.2-12.8-13.7-3.5-10.2.6-22.2 8.7-25.9l1.8-5.3 4 1.4-2.5 7.1-1 .3c-6.5 2.3-9.9 12.5-7 20.8 1.9 5.6 6.1 10 11 11.3l1 .3.4 1c8.1 20.1 24 33 40.5 33 16.4 0 32.3-12.9 40.4-32.8l.4-1 1.1-.2c5-1.1 9.6-5.7 11.6-11.5 2.8-8.1.2-14.9-6.7-17.3-1.3-.4-1.5-1.5-1.7-2.8h-.1l-.2-1.4C101.5 22.9 82.6 4.3 60.3 4.3 53 4.3 46 6.4 39.5 10.5l-2.3-3.6C44.3 2.4 52.3 0 60.3 0c24.4 0 45 20.1 49 47.8.2.4.2 1 .3 1.5 8.4 3.5 11.7 12.3 8.2 22.3-2.4 6.9-7.5 12.2-13.6 14-8.8 20.9-26 34.4-43.9 34.4zm48.2-71.2z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "care-calculator",
      "aria-labelledby": "care-calculator",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Care Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 88.3c-.5 0-1-.2-1.4-.5-1.4-1.1-34.2-26.1-43-44-.6-1.2-6.3-12.9 0-26.7C24.4-1.6 38.5-.7 44.1.6 50.8 2.1 56.8 6.3 60 11.1c3.2-4.8 9.2-9 15.9-10.6C81.5-.8 95.5-1.7 104.4 17c6.3 13.8.6 25.4-.1 26.7-8.8 17.9-41.6 42.9-43 44-.3.4-.8.6-1.3.6zM38.7 4.6c-5.8 0-13.4 2.7-19 14.5-5.3 11.8-.6 21.6 0 22.6C27.1 56.7 53.6 78 60 83.1c6.4-5 32.9-26.4 40.3-41.3.6-1.1 5.3-10.9 0-22.7C93.1 4 82.6 3.8 76.9 5.1c-8.2 1.9-14.6 8.5-14.6 13 0 1.3-1 2.3-2.3 2.3s-2.3-1-2.3-2.3c0-4.5-6.4-11.1-14.6-13-1.3-.3-2.8-.5-4.4-.5zM59.5 120c-18.7 0-38.6-4.1-38.6-11.6s19.9-11.6 38.6-11.6c18.7 0 38.6 4.1 38.6 11.6S78.2 120 59.5 120zm0-21c-21.5 0-36.4 5-36.4 9.4s14.9 9.4 36.4 9.4 36.4-5 36.4-9.4S81 99 59.5 99z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M59.5 113c-7.9 0-22.8-1.2-22.8-5.9s14.9-5.9 22.8-5.9 22.8 1.2 22.8 5.9-14.9 5.9-22.8 5.9zm0-9.6c-13.4 0-20.5 2.6-20.6 3.7.1 1.1 7.2 3.7 20.6 3.7s20.5-2.6 20.6-3.7c0-1.1-7.2-3.7-20.6-3.7z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "dependency-multiplicand",
      "aria-labelledby": "dependency-multiplicand",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Dependency Multiplicand")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M43.6 30.5H2c-1.1 0-2-.9-2-2s.9-2 2-2h41.6c1.1 0 2 .9 2 2s-.9 2-2 2z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.8 51.3c-1.1 0-2-.9-2-2V7.7c0-1.1.9-2 2-2s2 .9 2 2v41.6c0 1.1-.9 2-2 2zM111.9 114.3c-.5 0-1-.2-1.4-.6L81.1 84.3c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l29.4 29.4c.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M82.5 114.3c-.5 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8l29.4-29.4c.8-.8 2-.8 2.8 0s.8 2 0 2.8l-29.4 29.4c-.4.4-.9.6-1.4.6zM8.1 114.3c-.5 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8l29.4-29.4c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L9.5 113.7c-.4.4-.9.6-1.4.6zM118 30.5H76.4c-1.1 0-2-.9-2-2s.9-2 2-2H118c1.1 0 2 .9 2 2s-.9 2-2 2z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "earnings",
      "aria-labelledby": "earnings",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Earnings Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M43.4 81.7c-1.2 0-2.1-1-2.1-2.1V29.7c0-10.1 2.3-17.9 6.8-23C52 2.3 57.4 0 63.9 0c13.2 0 27.7 10 27.7 19 0 1.2-1 2.1-2.1 2.1s-2.1-1-2.1-2.1c0-6.1-12.1-14.8-23.4-14.8-3.6 0-8.8.9-12.6 5.3-3.8 4.3-5.7 11.1-5.7 20.2v49.8c-.2 1.2-1.1 2.2-2.3 2.2z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M89.5 82.6c-.1 0-.1 0 0 0l-58.9-.9c-1.2 0-2.1-1-2.1-2.2 0-1.2 1-2.1 2.1-2.1l58.9.9c1.2 0 2.1 1 2.1 2.2 0 1.1-1 2.1-2.1 2.1zM65.9 46.2l-35.4-.9c-1.2 0-2.1-1-2.1-2.2 0-1.2.9-2.2 2.2-2.1l35.3.9c1.2 0 2.1 1 2.1 2.2 0 1.1-.9 2.1-2.1 2.1z"
    }
  }), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 120c-19.4 0-40.1-4.2-40.1-12S40.5 96 60 96s40.1 4.2 40.1 12-20.7 12-40.1 12zm0-21.8c-22.3 0-37.9 5.2-37.9 9.8 0 4.7 15.6 9.8 37.9 9.8s37.9-5.2 37.9-9.8c0-4.6-15.6-9.8-37.9-9.8z"
    }
  })]), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 112.8c-8.2 0-23.6-1.3-23.6-6.1s15.5-6.1 23.6-6.1c8.2 0 23.6 1.3 23.6 6.1s-15.4 6.1-23.6 6.1zm0-10c-14.2 0-21.5 2.8-21.5 3.9 0 1.2 7.3 3.9 21.5 3.9s21.5-2.7 21.5-3.9c0-1.2-7.3-3.9-21.5-3.9z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "inflation-calculator",
      "aria-labelledby": "inflation-calculator",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Inflation Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M33.9 120H18.2c-3.5 0-6.4-2.9-6.4-6.4V48.8c0-3.5 2.9-6.4 6.4-6.4h15.7c3.5 0 6.4 2.9 6.4 6.4v64.8c0 3.5-2.9 6.4-6.4 6.4zM18.2 46.7c-1.2 0-2.1 1-2.1 2.1v64.8c0 1.2 1 2.1 2.1 2.1h15.7c1.2 0 2.1-1 2.1-2.1V48.8c0-1.2-1-2.1-2.1-2.1H18.2zM67.9 120H52.1c-3.5 0-6.4-2.9-6.4-6.4V30.4c0-3.5 2.9-6.4 6.4-6.4h15.7c3.5 0 6.4 2.9 6.4 6.4v83.2c0 3.5-2.8 6.4-6.3 6.4zM52.1 28.3c-1.2 0-2.1 1-2.1 2.1v83.2c0 1.2 1 2.1 2.1 2.1h15.7c1.2 0 2.1-1 2.1-2.1V30.4c0-1.2-1-2.1-2.1-2.1H52.1zM101.8 120H86.1c-3.5 0-6.4-2.9-6.4-6.4V6.4c0-3.5 2.9-6.4 6.4-6.4h15.7c3.5 0 6.4 2.9 6.4 6.4v107.3c-.1 3.4-2.9 6.3-6.4 6.3zM86.1 4.2c-1.2 0-2.1 1-2.1 2.1v107.3c0 1.2 1 2.1 2.1 2.1h15.7c1.2 0 2.1-1 2.1-2.1V6.4c0-1.2-1-2.1-2.1-2.1H86.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "interest",
      "aria-labelledby": "interest",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Interest Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M12.2 120c-.5 0-1-.2-1.4-.5-.9-.8-1-2.1-.3-3L104.3 4.6c.8-.9 2.1-1 3-.3.9.8 1 2.1.3 3L13.8 119.2c-.4.5-1 .8-1.6.8zM30.8 41.6C19.3 41.6 10 32.3 10 20.8 10.1 9.3 19.4 0 30.8 0s20.8 9.3 20.8 20.8c0 11.4-9.3 20.8-20.8 20.8zm0-37.3c-9.1 0-16.5 7.4-16.5 16.5s7.4 16.5 16.5 16.5 16.5-7.4 16.5-16.5S39.9 4.3 30.8 4.3zM89.2 120c-11.5 0-20.8-9.3-20.8-20.8s9.3-20.8 20.8-20.8S110 87.7 110 99.2 100.6 120 89.2 120zm0-37.3c-9.1 0-16.5 7.4-16.5 16.5s7.4 16.5 16.5 16.5 16.5-7.4 16.5-16.5-7.4-16.5-16.5-16.5z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "interpolated",
      "aria-labelledby": "interpolated",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Interpolated Multipliers")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M100.8 77.8V42.4c10.7-1.1 19-10.1 19-21.1C119.8 9.6 110.3.1 98.6.1c-11 0-20 8.4-21.1 19H42.4C41.4 8.5 32.4 0 21.4 0 9.7 0 .2 9.5.2 21.2c0 11 8.4 20 19 21.1v34.1C8.5 77.5.2 86.5.2 97.5c0 11.7 9.5 21.2 21.2 21.2 10.5 0 19.2-7.7 20.9-17.8h35.3c-.1-.6-.1-1.3-.1-1.9 0 11.7 9.5 21.2 21.2 21.2s21.2-9.5 21.2-21.2c-.1-11.1-8.5-20.2-19.1-21.2zM98.6 4.4c9.3 0 16.9 7.6 16.9 16.9 0 9.3-7.6 16.9-16.9 16.9-9.3 0-16.9-7.6-16.9-16.9 0-9.3 7.6-16.9 16.9-16.9zM4.4 21.2c0-9.3 7.6-16.9 16.9-16.9 9.3 0 16.9 7.6 16.9 16.9s-7.6 16.9-16.9 16.9c-9.3 0-16.9-7.6-16.9-16.9zm17 93.1c-9.3 0-16.9-7.6-16.9-16.9 0-9.3 7.6-16.9 16.9-16.9 9.3 0 16.9 7.6 16.9 16.9 0 9.3-7.6 16.9-16.9 16.9zm21.1-17.8c-.4-10.6-8.6-19.2-19-20.2V42.2c9.9-1 17.8-8.9 18.9-18.8h35.2c1 10 9 17.9 18.9 18.9v35.4c-9.9 1-17.8 8.9-18.9 18.7H42.5zm56.1 19.3c-9.3 0-16.9-7.6-16.9-16.9S89.3 82 98.6 82c9.3 0 16.9 7.6 16.9 16.9s-7.5 16.9-16.9 16.9z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.9 97.3l6.8-6.8c.4-.4.4-1.1 0-1.5-.4-.4-1.1-.4-1.5 0l-6.8 6.8-6.9-6.8c-.4-.4-1.1-.4-1.5 0s-.4 1.1 0 1.5l6.8 6.8-6.8 6.8c-.4.4-.4 1.1 0 1.5.2.2.5.3.7.3.3 0 .5-.1.7-.3l6.8-6.8 6.8 6.8c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1.1 0-1.5l-6.5-6.8z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "life-expectancy",
      "aria-labelledby": "life-expectancy",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Life Expectancy Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M27.1 119.2c-.1-.7-2.5-16.3 3-30.6 3.3-8.5 9.2-14 14-18.3 4.2-3.8 7.5-6.8 7.5-10.2s-3.3-6.4-7.5-10.2c-4.8-4.4-10.8-9.8-14-18.3C24.6 17.3 27 1.7 27.1 1l4.3.7c0 .2-2.3 15.2 2.7 28.4C37 37.4 42.3 42.3 47 46.6c4.8 4.3 8.9 8.1 8.9 13.4s-4.1 9.1-8.9 13.4c-4.7 4.3-10 9.1-12.9 16.7-5.1 13.2-2.8 28.2-2.7 28.4l-4.3.7zM92.9 119.2l-4.3-.7c0-.2 2.3-15.2-2.7-28.4C83 82.6 77.7 77.7 73 73.4c-4.8-4.3-8.9-8.1-8.9-13.4s4.1-9.1 8.9-13.4c4.7-4.3 10-9.1 12.9-16.7C91 16.7 88.7 1.6 88.7 1.5L93 .8c.1.7 2.5 16.3-3 30.6-3.3 8.5-9.2 14-14 18.3-4.2 3.8-7.5 6.8-7.5 10.2s3.3 6.4 7.5 10.2c4.8 4.4 10.8 9.8 14 18.3 5.5 14.5 3.1 30.1 2.9 30.8z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M101 4.3H19c-1.2 0-2.2-1-2.2-2.2S17.8 0 19 0h82c1.2 0 2.2 1 2.2 2.2s-1 2.1-2.2 2.1z"
    }
  }), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M101 120H19c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h82c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "pension",
      "aria-labelledby": "pension",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.6 29.2c.2.2.3.4.3.7 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3H14.6c-.4 0-.6-.1-.8-.3-.2-.2-.3-.4-.3-.8 0-.3.1-.6.3-.7s.5-.3.8-.3h2v-7.4h-2.2c-.3 0-.5-.1-.6-.2-.2-.2-.2-.4-.2-.6s.1-.5.2-.6c.2-.2.4-.2.6-.2h2.2v-4.1c0-1.7.5-3.1 1.5-4.1 1-1 2.4-1.5 4.2-1.5 1.2 0 2.3.2 3.4.6 1.1.4 2 1 2.8 1.8.3.3.5.6.5 1 0 .3-.1.5-.2.7-.2.2-.3.3-.6.3-.2 0-.5-.1-.8-.3-1-.8-1.8-1.3-2.6-1.6-.8-.3-1.6-.5-2.4-.5-1 0-1.8.3-2.4.9-.6.6-.9 1.6-.9 2.8v3.9h4.6c.3 0 .5.1.6.2.2.2.2.4.2.6s-.1.5-.2.6c-.2.2-.4.2-.6.2H19v7.4h8.8c.4.1.6.2.8.4z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "45.7",
      "cy": "68.3",
      "r": "3.2"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.2 42.9C10.4 42.9.8 33.3.8 21.5S10.4.2 22.2.2s21.4 9.6 21.4 21.4-9.7 21.3-21.4 21.3zm0-40.7c-10.6 0-19.3 8.7-19.3 19.3s8.7 19.3 19.3 19.3 19.3-8.7 19.3-19.3S32.8 2.2 22.2 2.2z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "75",
      "cy": "68.3",
      "r": "3.2"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.7 54.1c-.5 0-1-.4-1.1-.9-.1-.6.3-1.1.9-1.2l17-2.3c.6-.1 1.1.3 1.2.9.1.6-.3 1.1-.9 1.2l-17 2.3h-.1zM83.8 54.1l-17.1-2.3c-.6-.1-1-.6-.9-1.2.1-.6.6-1 1.2-.9L84 52c.6.1 1 .6.9 1.2-.1.5-.5.9-1.1.9z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60.3 120c-18 0-35.2-13.6-44.1-34.8-5.7-2-10.6-7.2-12.8-13.7-3.5-10.2.6-22.2 8.7-25.9l1.8-5.3 4 1.4-2.5 7.1-1 .3c-6.5 2.3-9.9 12.5-7 20.8 1.9 5.6 6.1 10 11 11.3l1 .3.4 1c8.1 20.1 24 33 40.5 33 16.4 0 32.3-12.9 40.4-32.8l.4-1 1.1-.2c5-1.1 9.6-5.7 11.6-11.5 2.8-8.1.2-14.9-6.7-17.3-1.3-.4-1.5-1.5-1.7-2.8h-.1l-.2-1.4C101.5 22.9 82.6 4.3 60.3 4.3 53 4.3 46 6.4 39.5 10.5l-2.3-3.6C44.3 2.4 52.3 0 60.3 0c24.4 0 45 20.1 49 47.8.2.4.2 1 .3 1.5 8.4 3.5 11.7 12.3 8.2 22.3-2.4 6.9-7.5 12.2-13.6 14-8.8 20.9-26 34.4-43.9 34.4zm48.2-71.2z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "period-dates",
      "aria-labelledby": "period-dates",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Period Between Two Dates")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M100.1 14h-6.4V4.3c0-2.4-1.9-4.3-4.3-4.3H74.1c-2.4 0-4.3 1.9-4.3 4.3V14H50.2V4.3c0-2.4-1.9-4.3-4.3-4.3H30.6c-2.4 0-4.3 1.9-4.3 4.3V14h-6.4C12.8 14 7 19.8 7 26.9V107c0 7.1 5.8 12.9 12.9 12.9H100c7.1 0 12.9-5.8 12.9-12.9V26.9c.1-7.1-5.7-12.9-12.8-12.9zm-26-9.7h15.2v25.6H74.1V4.3zm-43.5 0h15.2v25.6H30.6V4.3zm78.1 102.8c0 4.7-3.9 8.6-8.6 8.6H19.9c-4.7 0-8.6-3.9-8.6-8.6V26.9c0-4.7 3.9-8.6 8.6-8.6h6.4v11.6c0 2.4 1.9 4.3 4.3 4.3h15.2c2.4 0 4.3-1.9 4.3-4.3V18.3h19.6v11.6c0 2.4 1.9 4.3 4.3 4.3h15.2c2.4 0 4.3-1.9 4.3-4.3V18.3h6.4c4.7 0 8.6 3.9 8.6 8.6v80.2z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M41.9 71.9H20.8V50.7H42v21.2zm-19-2.2h16.9V52.9H22.9v16.8zM70.6 71.9H49.4V50.7h21.2v21.2zm-19-2.2h16.9V52.9H51.6v16.8zM99.2 71.9H78.1V50.7h21.2v21.2zm-19-2.2h16.9V52.9H80.2v16.8zM41.9 101.8H20.8V80.6H42v21.2zm-19-2.2h16.9V82.8H22.9v16.8zM70.6 101.8H49.4V80.6h21.2v21.2zm-19-2.2h16.9V82.8H51.6v16.8zM99.2 101.8H78.1V80.6h21.2v21.2zm-19-2.2h16.9V82.8H80.2v16.8z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "table-e-f-discounts",
      "aria-labelledby": "table-e-f-discounts",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Pre and Post Assessment Discounts")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M43.4 111.4L0 70.2 55.2 12l27.3-3.4 18.2 17.2-2 27.4-.4.5-54.9 57.7zM5.1 70l38.2 36.2 51.8-54.6 1.8-24.4-15.6-14.8L57 15.5 5.1 70zm71.3-24.3c-3.2 0-6.2-1.2-8.6-3.4-2.4-2.3-3.8-5.4-3.9-8.7-.1-3.3 1.1-6.5 3.4-8.9s5.4-3.8 8.7-3.9c3.4-.1 6.5 1.1 8.9 3.4 2.4 2.3 3.8 5.4 3.9 8.7.1 3.3-1.1 6.5-3.4 8.9-2.3 2.4-5.4 3.8-8.7 3.9h-.3zm0-21.3h-.2c-2.4.1-4.5 1-6.2 2.7-1.6 1.7-2.5 3.9-2.4 6.3.1 2.4 1 4.5 2.7 6.2 1.7 1.6 4 2.5 6.3 2.4 2.4-.1 4.5-1 6.2-2.7 1.6-1.7 2.5-3.9 2.4-6.3-.1-2.4-1-4.5-2.7-6.2-1.7-1.5-3.9-2.4-6.1-2.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M86.8 35.9c-6.3-.2-7.6-2.2-7.6-3.8.1-6.1 19.3-16.1 35.2-16.3 4.4-.1 5.5 1.4 5.6 2.6.6 4.5-10.7 12.6-21.6 15.4l-.2-.8c10.9-2.9 21.4-10.8 20.9-14.4-.2-1.6-2.7-1.8-4.7-1.8-15.7.2-34.2 10.3-34.3 15.4 0 1.7 2.4 2.7 6.7 2.8v.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "arrow",
      "aria-labelledby": "arrow",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M94.3 63.1H25.7c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4h68.7c1.9 0 3.4 1.5 3.4 3.4s-1.6 3.4-3.5 3.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M94.3 63.1c-.6 0-1.2-.2-1.8-.5L71.4 49c-1.6-1-2-3.1-1-4.6 1-1.6 3.1-2 4.6-1l21.1 13.5c1.6 1 2 3.1 1 4.6-.6 1-1.7 1.6-2.8 1.6z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M73.2 77.1c-1.1 0-2.1-.5-2.8-1.5-1-1.5-.6-3.6.9-4.6l21.1-14.1c1.5-1 3.6-.6 4.6.9 1 1.5.6 3.6-.9 4.6l-21 14.2c-.6.4-1.3.5-1.9.5z"
    }
  }), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 120C26.9 120 0 93.1 0 60S26.9 0 60 0s60 26.9 60 60-26.9 60-60 60zM60 6.7C30.6 6.7 6.7 30.6 6.7 60s23.9 53.3 53.3 53.3 53.3-23.9 53.3-53.3S89.4 6.7 60 6.7z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "logo",
      "aria-labelledby": "logo",
      "role": "img",
      "viewBox": "0 0 230.4 120",
      "width": "230.4",
      "height": "120"
    }
  }, [_c('title', [_vm._v("ABC Quantum logo")]), _c('path', {
    staticClass: "logo-text",
    attrs: {
      "d": "M28.1 82.8c.8.8 1.1 1.7 1.1 2.8v30.6c0 1.1-.3 2.2-1.1 2.8s-1.9 1.1-3 1.1-2.2-.3-3-1.1c-.8-.8-1.1-1.7-1.1-2.8v-10.7c-.8 1.4-1.9 2.5-3.6 3.3-1.4.8-3.3 1.1-5 1.1-2.5 0-4.4-.6-6.3-1.7-1.9-1.1-3.3-2.8-4.4-5S0 98.5 0 95.8c0-2.8.6-5.2 1.7-7.4s2.5-3.9 4.4-5.2c1.9-1.1 3.9-1.9 6.3-1.9 1.9 0 3.6.3 5.2 1.1 1.4.8 2.8 1.9 3.6 3.3V85c0-1.1.3-2.2 1.1-2.8s1.7-1.1 3-1.1c.8.6 1.9.9 2.8 1.7zm-8.8 19c1.1-1.4 1.7-3.3 1.7-5.8s-.6-4.4-1.7-5.8-2.8-2.2-4.7-2.2-3.6.8-4.7 2.2-1.7 3.3-1.7 5.8.6 4.4 1.7 5.8c1.1 1.4 2.5 1.9 4.7 1.9 1.9.1 3.6-.5 4.7-1.9zM61.1 82.8c.8.8 1.1 1.7 1.1 3v20.6c0 1.1-.3 2.2-1.1 2.8-.8.8-1.9 1.1-3 1.1s-2.2-.3-2.8-1.1-1.1-1.7-1.1-2.8v-.4c-.8 1.4-1.9 2.5-3.3 3.3-1.4.8-3 1.1-4.7 1.1-3.6 0-6.1-.8-7.7-2.8-1.7-1.9-2.5-5-2.5-8.8V85.9c0-1.1.3-2.2 1.1-3 .8-.8 1.9-1.1 3-1.1s2.2.3 3 1.1c.8.8 1.1 1.7 1.1 3v13.2c0 1.7.3 2.8 1.1 3.6.8.8 1.7 1.1 3 1.1 1.7 0 3-.6 4.1-1.7 1.1-1.1 1.7-2.5 1.7-4.4V85.9c0-1.1.3-2.2 1.1-3 .8-.8 1.7-1.1 3-1.1 1-.1 2.1.2 2.9 1zM90 84.5c1.9 1.9 3 5 3 9.1v12.7c0 1.1-.3 2.2-1.1 2.8-.8.6-1.9 1.1-3 1.1s-2.2-.3-2.8-1.1c-.6-.8-1.1-1.7-1.1-2.8v-.3c-.6 1.4-1.4 2.5-2.8 3.3s-2.8 1.1-4.7 1.1-3.6-.3-5-1.1-2.8-1.9-3.6-3-1.4-2.8-1.4-4.4c0-1.9.6-3.6 1.7-4.7s2.8-1.9 5-2.5 5.5-.8 9.4-.8H85v-1.1c0-1.7-.3-2.8-1.1-3.3-.8-.8-1.9-1.1-3.6-1.1-1.7 0-3.9.6-6.9 1.7-.8.3-1.7.6-2.2.6-.8 0-1.4-.3-1.9-.8s-.8-1.4-.8-2.2c0-.8.3-1.4.6-1.9s.8-.8 1.7-1.4c1.4-.8 3-1.4 4.7-1.7 1.9-.3 3.9-.6 5.5-.6 4-.4 7.1.5 9 2.4zm-6.6 18.4c1.1-1.1 1.4-2.5 1.4-4.4v-.8H84c-3 0-5.2.3-6.3.8-1.1.6-1.9 1.4-1.9 2.8 0 1.1.3 1.9 1.1 2.5.8.6 1.7 1.1 2.5 1.1 1.5-.3 2.9-.9 4-2zM123.9 84.5c1.7 1.9 2.5 5 2.5 8.8v12.9c0 1.1-.3 2.2-1.1 3-.8.6-1.9.8-3.3.8s-2.2-.3-3-1.1c-.8-.8-1.1-1.7-1.1-3V93.6c0-1.9-.3-3.3-1.1-4.1-.8-.8-1.7-1.4-3.3-1.4-1.7 0-3 .6-4.1 1.7-1.1 1.1-1.7 2.8-1.7 4.4V106c0 1.1-.3 2.2-1.1 3s-1.7 1.1-3 1.1c-1.4 0-2.5-.3-3-1.1-.8-.8-1.1-1.7-1.1-3V85.3c0-1.1.3-2.2 1.1-2.8.8-.6 1.9-1.1 3-1.1s2.2.3 2.8 1.1c.8.8 1.1 1.7 1.1 2.8v.8c1.1-1.4 2.2-2.8 3.9-3.3 1.7-.8 3.3-1.1 5.2-1.1 3.1 0 5.6.9 7.3 2.8zM150.3 104.9c.6.6.8 1.1.8 2.2s-.6 1.9-1.4 2.5-1.9.6-3.6.6h-1.7c-6.6-.6-9.9-3.9-9.9-10.2V89h-2.2c-1.1 0-2.2-.3-2.8-.8s-.8-1.4-.8-2.2c0-1.1.3-1.9.8-2.5.6-.6 1.7-.8 2.8-.8h2.2v-4.4c0-1.1.3-2.2 1.1-3 .8-.8 1.9-1.1 3-1.1s2.2.3 3 1.1c.8.8 1.1 1.7 1.1 3v4.4h3.9c2.5 0 3.9 1.1 3.9 3.3 0 1.1-.3 1.7-.8 2.2s-1.7.8-2.8.8H143v11.8c0 1.1.3 1.9.8 2.5s1.4.8 2.2 1.1h1.7c1.2-.4 2-.1 2.6.5zM179.4 82.8c.8.8 1.1 1.7 1.1 3v20.6c0 1.1-.3 2.2-1.1 2.8-.8.8-1.9 1.1-3 1.1s-2.2-.3-2.8-1.1c-.6-.8-1.1-1.7-1.1-2.8v-.4c-.8 1.4-1.9 2.5-3.3 3.3s-3 1.1-4.7 1.1c-3.6 0-6.1-.8-7.7-2.8-1.7-1.9-2.5-5-2.5-8.8V85.9c0-1.1.3-2.2 1.1-3 .8-.8 1.9-1.1 3-1.1s2.2.3 3 1.1c.8.8 1.1 1.7 1.1 3v13.2c0 1.7.3 2.8 1.1 3.6.8.8 1.7 1.1 3 1.1 1.7 0 3-.6 4.1-1.7 1.1-1.1 1.7-2.5 1.7-4.4V85.9c0-1.1.3-2.2 1.1-3s1.7-1.1 3-1.1c1.3-.1 2.1.2 2.9 1zM227.9 84.5c1.7 1.9 2.5 4.7 2.5 8.8v12.9c0 1.4-.3 2.2-1.1 3-.8.6-1.9 1.1-3 1.1s-2.2-.3-3-1.1c-.8-.6-1.1-1.7-1.1-3V93.3c0-1.9-.3-3-.8-3.9-.6-.8-1.7-1.1-2.8-1.1-1.7 0-2.8.6-3.9 1.7s-1.4 2.5-1.4 4.4v11.8c0 1.4-.3 2.2-1.1 3-1.1.6-2.2.8-3.3.8s-2.2-.3-3-1.1c-.8-.6-1.1-1.7-1.1-3V93c0-1.9-.3-3-.8-3.9-.6-.8-1.7-1.1-2.8-1.1-1.7 0-2.8.6-3.9 1.7-.8 1.1-1.4 2.5-1.4 4.4V106c0 1.4-.3 2.2-1.1 3-.8.8-2.2 1.1-3.6 1.1-1.1 0-2.2-.3-3-1.1-.8-.6-1.1-1.7-1.1-3V85.3c0-1.1.6-2.2 1.4-2.8.8-.6 1.9-1.1 3-1.1s1.9.3 2.8 1.1 1.1 1.7 1.1 2.8v.6c.8-1.4 1.9-2.5 3.6-3.3 1.4-.8 3-1.1 5-1.1 1.9 0 3.6.3 5 1.1s2.5 2.2 3 3.9c.8-1.7 2.2-2.8 3.6-3.9 1.7-.8 3.3-1.4 5.5-1.4 2.9.5 5.1 1.4 6.8 3.3z"
    }
  }), _c('g', [_c('path', {
    staticClass: "logo-graphic",
    staticStyle: {
      "fill": "#4a89e5"
    },
    attrs: {
      "d": "M89.7 0C69.6 0 53.4 16.2 53.4 36.1s16.2 36.1 36.3 36.1 36.1-16.2 36.1-36.1S109.5 0 89.7 0zm0 61.4c-14 0-25.3-11.3-25.3-25.3s11.3-25.3 25.3-25.3S115 22 115 36.1s-11.5 25.3-25.3 25.3z"
    }
  }), _c('path', {
    staticClass: "logo-graphic",
    staticStyle: {
      "fill": "#4a89e5"
    },
    attrs: {
      "d": "M122.2 70.7c-2.2 1.9-5.8 1.7-7.7-.6l-6.1-6.9c-1.9-2.2-1.7-5.8.6-7.7 2.2-1.9 5.8-1.7 7.7.6l6.1 6.9c1.9 2.5 1.6 5.8-.6 7.7z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "print",
      "aria-labelledby": "print",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("print results")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M101.1 35.2h-2.3V0H21.2v35.2h-2.3c-10 0-18 8.1-18 18v34.9c0 10 8.1 18 18 18h2.3V120h77.6v-13.8h2.3c10 0 18-8.1 18-18v-35c0-9.9-8.1-18-18-18zm-72.7-28h63.2v27.1H28.4V7.2zm-9.5 35.2H101c6 0 10.8 4.9 10.8 10.8V55H8.1v-1.8c0-5.9 4.9-10.8 10.8-10.8zm72.7 70.4H28.4v-37h63.2v37zm9.5-13.9h-2.3V68.6H21.2V99h-2.3c-6 0-10.8-4.9-10.8-10.8V62.3h103.8v25.9c0 5.9-4.9 10.7-10.8 10.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M84.5 83.6h-49c-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6h49c2 0 3.6-1.6 3.6-3.6s-1.6-3.6-3.6-3.6zM63.8 97.1H35.5c-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6h28.3c2 0 3.6-1.6 3.6-3.6 0-1.9-1.6-3.6-3.6-3.6z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "94.9",
      "cy": "48.8",
      "r": "3.9"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "email",
      "aria-labelledby": "email",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M111.2 39.2L73 1c-.6-.6-1.4-.9-2.2-1H22.3c-8 0-14.5 6.5-14.5 14.4v91.2c0 7.9 6.5 14.4 14.4 14.4h75.5c7.9 0 14.4-6.5 14.4-14.4v-64c.1-.9-.3-1.8-.9-2.4zm-10.7-1H79c-2.8 0-5.1-2.3-5.1-5.1V11.6l26.6 26.6zm-2.8 75H22.3c-4.2 0-7.6-3.4-7.6-7.6V14.4c0-4.2 3.4-7.6 7.6-7.6h44.8v26.3C67.1 39.6 72.4 45 79 45h26.4v60.6c0 4.2-3.5 7.6-7.7 7.6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "dashboard",
      "aria-labelledby": "dashboard",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("back to mini calculators")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M55.6 55.4H0V.1h55.6v55.3zM4.2 51.2h47.3v-47H4.2v47zM120 55.4H64.4V.1H120v55.3zm-51.4-4.2h47.3v-47H68.6v47zM55.6 119.9H0V64.6h55.6v55.3zm-51.4-4.1h47.3v-47H4.2v47zM120 119.9H64.4V64.6H120v55.3zm-51.4-4.1h47.3v-47H68.6v47z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "retirement-calculator",
      "aria-labelledby": "retirement-calculator",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Retirement Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M103.3 120c-3.6 0-7.1-1.7-9-4.9L40 26.6c-.4-.6-3.7-5.5-8.6-2.5-5 3-2 8.2-1.7 8.8l4.9 8c3.1 5 1.3 11.7-4 14.9-5.3 3.2-12 1.8-15.1-3.2L8.4 40.8c-.1-.2-11.8-22.5 10.3-36.1 22.1-13.5 37.8 6.1 38 6.3l.1.2 56.5 92.1c1.5 2.4 1.9 5.3 1.1 8.2-.8 2.8-2.6 5.2-5.1 6.7-1.9 1.2-4 1.8-6 1.8zM34.5 18.8c4.3 0 7.6 3.2 9.1 5.5l54.3 88.5c1.8 3 6 3.8 9.2 1.8 1.6-1 2.7-2.5 3.2-4.2.5-1.7.2-3.4-.6-4.8l-56.4-92c-1.2-1.4-14.1-16.5-32.4-5.2C2.4 19.7 11.4 37.5 12 38.8l7.1 11.6c1.8 3 6 3.8 9.2 1.8 3.3-2 4.4-6.1 2.6-9.1l-4.9-8c-1.9-3.2-3.8-10.4 3.1-14.6 2-1.2 3.8-1.7 5.4-1.7z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "loss-of-pension",
      "aria-labelledby": "loss-of-pension",
      "role": "img",
      "viewBox": "0 0 56.2 56.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23.5 29.6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
    }
  }), _c('path', {
    attrs: {
      "d": "M46 27.2c-.5-1.1-1.4-2-2.6-2.6 0-.1 0-.2-.1-.3C42 15.7 35.6 9.4 28 9.4c-2.6 0-5 .8-7.2 2.1-1.2-1.1-2.8-1.9-4.6-1.9-3.6 0-6.6 2.9-6.6 6.6 0 2.5 1.4 4.7 3.6 5.8-.2.7-.4 1.5-.5 2.2-2.5 1.2-3.6 4.2-2.5 7.4.7 2 2.2 3.7 4 4.3 2.8 6.5 8.1 10.8 13.7 10.8S38.8 42.5 41.6 36c1.9-.6 3.5-2.3 4.2-4.4.8-1.5.8-3.1.2-4.4zm-35.6-11c0-3.3 2.7-5.9 5.9-5.9 3.3 0 5.9 2.7 5.9 5.9s-2.7 5.9-5.9 5.9c-3.3.1-5.9-2.6-5.9-5.9zm3.8 6.2s-.1 0-.1-.1c0 .1 0 .1.1.1zm30.1 8.7c-.6 1.7-1.9 3.1-3.4 3.4l-.5.1-.1.4c-2.5 6.1-7.3 10-12.2 10-5 0-9.8-3.9-12.2-10l-.2-.4-.4-.1c-1.4-.4-2.6-1.7-3.2-3.3-.8-2.4 0-4.7 1.9-5.3l.5-.2.1-.5c.1-.8.3-1.6.5-2.4.4.1.9.1 1.3.1 3.6 0 6.6-2.9 6.6-6.6 0-1.2-.3-2.3-.9-3.3 1.9-1.1 3.9-1.8 6.1-1.8 6.8 0 12.5 5.7 13.6 13.5l.1.6c.1.4.2.7.6.9.9.3 1.6.9 2 1.8.2.8.2 1.9-.2 3.1zM21.5 12.2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M32.6 29.6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.5-1-1-1zM26 24.8l-5.2.7c-.2 0-.4.3-.4.5s.2.4.4.4h.1l5.2-.7c.2 0 .4-.3.4-.5-.1-.3-.3-.5-.5-.4zM35.4 25.5l-5.2-.7c-.2 0-.5.1-.5.4 0 .2.1.5.4.5l5.2.7h.1c.2 0 .4-.2.4-.4 0-.3-.2-.5-.4-.5zM18.2 19.2c.1-.1.1-.1.1-.2s0-.2-.1-.2c-.1-.1-.1-.1-.2-.1h-2.6v-2.2h1.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2s0-.1-.1-.2c0 0-.1-.1-.2-.1h-1.3v-1.1c0-.4.1-.6.3-.8.2-.2.4-.3.7-.3.2 0 .5 0 .7.1.2.1.5.3.8.5.1.1.2.1.2.1.1 0 .1 0 .2-.1 0-.1.1-.1.1-.2s0-.2-.1-.3c-.2-.2-.5-.4-.8-.5-.3-.1-.6-.2-1-.2-.5 0-.9.1-1.2.4-.3.3-.4.7-.4 1.2V16H14c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2s0 .1.1.2c0 0 .1.1.2.1h.6v2.2H14c-.1 0-.2 0-.2.1-.1.1-.1.1-.1.2s0 .2.1.2c.1.1.1.1.2.1h3.8c.2-.1.3-.2.4-.2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M28.1 0C12.6 0 0 12.6 0 28.1s12.6 28.1 28.1 28.1c15.5 0 28.1-12.6 28.1-28.1S43.6 0 28.1 0zM2 28.1C2 13.7 13.7 2 28.1 2c6.7 0 12.8 2.5 17.4 6.7L9.3 46.2C4.8 41.5 2 35.1 2 28.1zm26.1 26.1c-6.6 0-12.7-2.5-17.3-6.6L46.9 10c4.5 4.7 7.3 11 7.3 18 0 14.5-11.7 26.2-26.1 26.2z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "mesothelioma-psla-calculator",
      "aria-labelledby": "mesothelioma-psla-calculator",
      "role": "img",
      "viewBox": "0 0 55.3 56.2"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "20.9",
      "cy": "32",
      "r": "1.5"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M10 20.1c-5.5 0-10-4.5-10-10S4.5.1 10 .1s10 4.5 10 10-4.5 10-10 10zM10 1c-5 0-9 4.1-9 9s4.1 9 9 9c5 0 9-4.1 9-9s-4-9-9-9z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M50.8 23c0-.2-.1-.5-.1-.7C48.8 9.4 39.2 0 27.8 0 24 0 20.4 1.1 17.2 3.1c.5.5.9 1 1.2 1.6C21.3 3 24.4 2 27.8 2c10.4 0 19.3 8.7 21 20.8l.1.6h.1c.1.6.2 1.1.8 1.3 3.2 1.1 4.4 4.3 3.1 8.1-.9 2.7-3.1 4.8-5.4 5.4l-.5.1-.2.5C43 48.1 35.6 54.2 27.9 54.2c-7.7 0-15.2-6.1-18.9-15.5l-.2-.5-.5-.1c-2.3-.6-4.2-2.7-5.1-5.3-1.3-3.9 0-7.5 3.1-8.6l.4-.2.1-.6c.2-1.3.4-2.5.8-3.7-.7-.2-1.3-.4-1.9-.7-.3 1.1-.6 2.3-.8 3.5-3.8 1.7-5.4 6.2-3.7 10.9 1.1 3.1 3.3 5.5 6 6.4 4.1 9.9 12.2 16.3 20.6 16.3 8.4 0 16.4-6.3 20.6-16.2 2.8-.8 5.2-3.3 6.4-6.5 1.5-4.6 0-8.7-4-10.4z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "34.6",
      "cy": "32",
      "r": "1.5"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M16.7 25.3c-.2 0-.5-.2-.5-.4 0-.3.2-.5.4-.6l8-1.1c.3 0 .5.2.6.4 0 .3-.2.5-.4.6l-8.1 1.1zM38.8 25.3c-.1 0-.1 0 0 0l-8-1.1c-.3 0-.5-.3-.4-.6 0-.3.3-.5.6-.4l8 1.1c.3 0 .5.3.4.6-.2.2-.4.4-.6.4zM9.4 15.5c-.2-.2-.3-.4-.3-.6 0-.3.1-.5.3-.7.2-.2.4-.3.6-.3.2 0 .5.1.6.3.2.2.2.4.2.7 0 .3-.1.5-.2.6-.2.2-.4.2-.6.2-.2 0-.5 0-.6-.2zm.3-2.8c-.1-.1-.1-.2-.1-.3l-.4-7.3c0-.2 0-.4.2-.6.2-.1.3-.2.6-.2.2 0 .4.1.6.2.1.1.2.3.2.6l-.4 7.2c0 .1-.1.3-.1.3-.1.1-.2.1-.3.1-.1.1-.2.1-.3 0z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "loss-of-earnings",
      "aria-labelledby": "loss-of-earnings",
      "viewBox": "0 0 56.2 56.2"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.9 34.9c-.4 0-.7-.3-.7-.7V18.6c0-3.2.7-5.6 2.1-7.2 1.2-1.4 2.9-2.1 5-2.1 4.1 0 8.7 3.1 8.7 6 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7 0-1.9-3.8-4.6-7.3-4.6-1.1 0-2.7.3-4 1.7-1.2 1.4-1.8 3.5-1.8 6.3v15.6c.1.3-.2.6-.6.6z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M37.3 35.2l-18.5-.3c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7l18.4.3c.4 0 .7.3.7.7.1.4-.2.7-.6.7zM29.9 23.7l-11.1-.3c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7l11.1.3c.4 0 .7.3.7.7 0 .5-.3.7-.7.7z"
    }
  }), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.1 46.9c-6.1 0-12.5-1.3-12.5-3.7 0-2.4 6.5-3.7 12.5-3.7s12.5 1.3 12.5 3.7c0 2.4-6.4 3.7-12.5 3.7zm0-6.9c-7 0-11.9 1.6-11.9 3.1s4.9 3.1 11.9 3.1S40 44.6 40 43.1c0-1.4-4.9-3.1-11.9-3.1z"
    }
  })]), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.1 44.6c-2.6 0-7.4-.4-7.4-1.9s4.8-1.9 7.4-1.9c2.6 0 7.4.4 7.4 1.9s-4.9 1.9-7.4 1.9zm0-3.1c-4.4 0-6.7.9-6.7 1.2s2.3 1.2 6.7 1.2 6.7-.9 6.7-1.2-2.3-1.2-6.7-1.2z"
    }
  })]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.1 0C12.6 0 0 12.6 0 28.1s12.6 28.1 28.1 28.1c15.5 0 28.1-12.6 28.1-28.1S43.6 0 28.1 0zM2 28.1C2 13.7 13.7 2 28.1 2c6.7 0 12.8 2.5 17.4 6.7L9.3 46.2C4.8 41.5 2 35.1 2 28.1zm26.1 26.1c-6.6 0-12.7-2.5-17.3-6.6L46.9 10c4.5 4.7 7.3 11 7.3 18 0 14.5-11.7 26.2-26.1 26.2z"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.rates), function(rate) {
    return _c('th', [_vm._v("\n                " + _vm._s(rate) + "\n            ")])
  }), _vm._v(" "), _c('th', [_vm._v("Difference")])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                Past Losses\n            ")]), _vm._v(" "), _vm._l((_vm.rates.length), function(index) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.currencyFormat(_vm.data[index - 1][0].data[0])) + "\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.currencyFormat(Math.abs(_vm.data[0][0].data[0] - _vm.data[1][0].data[0]))) + "\n            ")])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                Future Losses\n            ")]), _vm._v(" "), _vm._l((_vm.rates.length), function(index) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.currencyFormat(_vm.data[index - 1][0].data[1])) + "\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.currencyFormat(Math.abs(_vm.data[0][0].data[1] - _vm.data[1][0].data[1]))) + "\n            ")])], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("\n                    Total\n                ")]), _vm._v(" "), _vm._l((_vm.rates.length), function(index) {
    return _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.data[index - 1][0].data[1] + _vm.data[index - 1][0].data[0])) + "\n                ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(Math.abs((_vm.data[0][0].data[0] - _vm.data[1][0].data[0]) - (_vm.data[0][0].data[1] - _vm.data[1][0].data[1])))) + "\n                ")])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "headsOfLossForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "general_damages_psla",
      "label": "General Damages (PSLA)",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "general_damages_psla",
      "id": "general_damages_psla",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "focus": function($event) {
        _vm.generalDamages = _vm.generalDamages || ''
      },
      "blur": [function($event) {
        _vm.generalDamages = _vm.generalDamages || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.diseaseType === 'Mesothelioma') ? _c('span', {
    staticClass: "a-form-inputs--help"
  }, [_vm._v("\n                        Damages can be calculated using the calculator available\n                        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleGeneralDamagesPslaModal()
      }
    }
  }, [_vm._v("\n                            here\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_services",
      "label": "Past Cost of Services",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastDependencyOnServices),
      expression: "pastDependencyOnServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "past_loss_of_services",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastDependencyOnServices)
    },
    on: {
      "focus": function($event) {
        _vm.pastDependencyOnServices = _vm.pastDependencyOnServices || ''
      },
      "blur": [function($event) {
        _vm.pastDependencyOnServices = _vm.pastDependencyOnServices || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastDependencyOnServices = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_loss_of_services",
      "label": "Future Cost of Services",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureDependencyOnServices),
      expression: "futureDependencyOnServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "future_loss_of_services",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureDependencyOnServices)
    },
    on: {
      "focus": function($event) {
        _vm.futureDependencyOnServices = _vm.futureDependencyOnServices || ''
      },
      "blur": [function($event) {
        _vm.futureDependencyOnServices = _vm.futureDependencyOnServices || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureDependencyOnServices = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_cost_of_travel",
      "label": "Past Cost of Travel",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "past_cost_of_travel",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "miscellaneous_costs",
      "label": "Miscellaneous - Medication, Appliances, Additional Food & Energy Costs",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "miscellaneous_costs",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "focus": function($event) {
        _vm.misc = _vm.misc || ''
      },
      "blur": [function($event) {
        _vm.misc = _vm.misc || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.customHeadsOfLoss.length), function(index) {
    return _c('div', [_c('head-of-loss', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin u-r-margin-top-20 u-r-margin-bottom-20",
    on: {
      "click": _vm.addCustomHeadOfLoss
    }
  }, [_vm._v("\n                    Add Another Head of Loss\n                ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Cost of Care",
      "tip-text": "You have multiple options to assess the care claim — click the help icon to find out more. ",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "past_care",
      "modalName": "careModal",
      "for": "cost_of_care"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costOfCareType),
      expression: "costOfCareType"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "cost_of_care",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.costOfCareType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto-calculate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter past and future cost of care")])])]), _vm._v(" "), (_vm.costOfCareType === 'auto') ? _c('control', {
    attrs: {
      "for": "care_total",
      "label": "Care Total",
      "before-after": "pound",
      "tip-icon": _vm.careIcon,
      "tip-show": _vm.costOfCareType === 'auto',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "care_total",
      "modal-name": 'headsOfLoss_' + _vm.uniqueId,
      "endpoint": 'autoCare'
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.pastTotalValue, '')
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.costOfCareType === 'own') ? _c('div', [_c('hr', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Past Care",
      "for": "past_care_type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastCareCalcType),
      expression: "pastCareCalcType"
    }],
    attrs: {
      "id": "pastCareCalcType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pastCareCalcType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('past_care_type')
    }
  }, [_vm._v("\n                            Please select a care type\n                        ")])], 1), _vm._v(" "), _vm._l((_vm.pastCarePeriods.length), function(index) {
    return (_vm.pastCareCalcType === 'manual') ? _c('div', [_c('period', {
      attrs: {
        "index": index - 1,
        "type": 'past'
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.pastCarePeriods.length >= 0 && _vm.pastCareCalcType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.addNewCarePeriod('past')
      }
    }
  }, [_vm._v("\n                        Add Period\n                    ")]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_care_total",
      "label": "Past Care Total",
      "before-after": "pound",
      "tip-icon": _vm.careIcon,
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "modal-name": 'headsOfLoss_' + _vm.uniqueId,
      "endpoint": 'autoCare'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastTotalValue),
      expression: "pastTotalValue",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": _vm.pastCareCalcType !== 'own'
    },
    domProps: {
      "value": (_vm.pastTotalValue)
    },
    on: {
      "focus": function($event) {
        _vm.pastTotalValue = _vm.pastTotalValue || ''
      },
      "blur": [function($event) {
        _vm.pastTotalValue = _vm.pastTotalValue || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastTotalValue = _vm._n($event.target.value)
      }
    }
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.costOfCareType === 'own') ? _c('div', [_c('hr', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Future Care",
      "for": "future_care_type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureCareCalcType),
      expression: "futureCareCalcType"
    }],
    attrs: {
      "id": "futureCareCalcType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureCareCalcType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('future_care_type')
    }
  }, [_vm._v("\n                            Please select a care type\n                        ")])], 1), _vm._v(" "), _vm._l((_vm.futureCarePeriods.length), function(index) {
    return (_vm.futureCareCalcType === 'manual') ? _c('div', [_c('period', {
      attrs: {
        "index": index - 1,
        "type": 'future'
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.futureCarePeriods.length >= 0 && _vm.futureCareCalcType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.addNewCarePeriod('future')
      }
    }
  }, [_vm._v("\n                        Add Period\n                    ")]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_care_total",
      "label": "Future Care Total",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureTotalValue),
      expression: "futureTotalValue",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": _vm.futureCareCalcType !== 'own'
    },
    domProps: {
      "value": (_vm.futureTotalValue)
    },
    on: {
      "focus": function($event) {
        _vm.futureTotalValue = _vm.futureTotalValue || ''
      },
      "blur": [function($event) {
        _vm.futureTotalValue = _vm.futureTotalValue || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureTotalValue = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total Cost of Care",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.pastTotalValue + _vm.futureTotalValue
    }
  })])], 2) : _vm._e()], 1)])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "careModal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Care Claim Options\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            You have 2 options to assess the care claim:"), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "u-margin-lr-40"
  }, [_c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can Auto-calculate the award. The CA in Rothwell v Chemical Insulating Co. Ltd [2006] EWCA Civ 27 recognised a sum of £12,500 as the norm for care in claims for terminal malignant mesothelioma. This award is inflated to today’s value applying the Retail Price Index since January 2006.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can carry out separate calculations for past and future care. These are:\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "u-margin-lr-40 u-margin-top-25"
  }, [_c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                    You can simply enter in a £ sum for the care.\n                ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                    You can carry out a detailed calculation looking at differing periods and differing hours of care and applying either a basic or aggregate care rate valued according to Local Authority Spinal Point 8. You can then discount the claim by 25% to reflect the gratuitous rather than commercial nature of the care.\n                ")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'headsOfLoss_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "generalDamagesPslaModal",
      "no-default-button": "true"
    }
  }, [(_vm.modals.generalDamagesPslaModal) ? _c('general-damages-psla-calculator') : _vm._e()], 1), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Rates),
      expression: "Rates"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Rates = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _vm._l((_vm.discountRates), function(discount, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(discount))])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Date Received\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "paymentDate",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:paymentDate.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "paymentDate",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateValid()
      }
    },
    model: {
      value: (_vm.payment.date),
      callback: function($$v) {
        _vm.$set(_vm.payment, "date", $$v)
      },
      expression: "payment.date"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.paymentDateInvalid
    }
  }, [_vm._v("\n                    Payment date must be on or after the date of injury (" + _vm._s(_vm.periodStart) + ") and a valid date.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Payment\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "payment_total",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.payment.total),
      expression: "payment.total",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "payment-received",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.payment.total)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "total", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updateValid()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.paymentTotalInvalid
    }
  }, [_vm._v("\n                    Payment must be greater than £0.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third u-margin-top-40"
  }, [_c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.removePayment()
      }
    }
  }, [_vm._v("Delete Payment")])])])
},staticRenderFns: []}

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Category\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9 a-form-inputs--default"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "name": "category",
      "id": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.categoryList), function(item) {
    return _c('option', {
      domProps: {
        "value": item,
        "selected": item == _vm.category ? 'true' : 'false'
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                    ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Name\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9 a-form-inputs--default"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentName),
      expression: "documentName"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "name",
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.documentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.documentName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Order By\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9 a-form-inputs--default"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderBy),
      expression: "orderBy"
    }],
    attrs: {
      "name": "orderBy",
      "id": "orderBy"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ASC"
    }
  }, [_vm._v("Ascending")]), _vm._v("Document Type\n                    "), _c('option', {
    attrs: {
      "value": "DESC"
    }
  }, [_vm._v("Descending")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3 u-align-self-flex-end u-r-align-self-flex-start"
  }, [_c('button', {
    staticClass: "a-button a-button--small a-button--no-margin",
    on: {
      "click": _vm.documentSearch
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "a-loader--documents"
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "flex-grid p-resources-and-tools__documents"
  }, [_vm._l((_vm.documents), function(document) {
    return _c('div', {
      staticClass: "p-resources-and-tools__document"
    }, [_c('div', {
      staticClass: "p-resources-and-tools__document-image"
    }, [_c('a', {
      attrs: {
        "href": document['link'] + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": document['thumbnail_src'] + '?access_token=' + _vm.getToken,
        "alt": document['name']
      }
    })])]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": document['link'] + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(document['name']))]), _vm._v(" "), (document['published_date']) ? _c('span', [_vm._v("Published at: " + _vm._s(document['published_date']))]) : _vm._e()])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.documents.length),
      expression: "!documents.length"
    }]
  }, [_vm._v("Documents will return shortly.")])], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Head of Loss ' + (_vm.index + 1),
      "for": "name"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "name",
      "placeholder": "Type of Head of Loss",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, _vm.updateValid]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('name')
    }
  }, [_vm._v("\n            Type of loss is required\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "value",
      "required": "",
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = _vm._n($event.target.value)
      }, _vm.updateValid],
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": [function($event) {
        _vm.value = _vm.value || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            Value should be greater than £0.00\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisHeadOfLoss
    }
  }, [_vm._v("Delete Head of Loss")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Dependency on Services — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is determined (i) from the deceased's date of death to the deceased's 'but for' date\n        of death, and (ii) either applying a multiplicand based on average data within the tool for claims of a\n        similar type, or a multiplicand of £1,500. The period between death and assumed date of trial/settlement \n        is discounted by Table E Factor. The multiplier is applied from date of trial/assumed settlement but discounted by Table F Factor.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid m-div-table__holder-section"
  }, [_c('div', {
    staticClass: "flex-grid__g-3 hide"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Benefit Amount")]), _vm._v(" "), _c('control', {
    attrs: {
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.amount),
      expression: "amount",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number'
      }),
      expression: "{type: 'number'}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "min": "0.00",
      "name": _vm.fieldName + '_value',
      "type": "number"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.amount = _vm.amount || ''
      },
      "blur": [function($event) {
        _vm.amount = _vm.amount || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error(_vm.fieldName + '_value')
    }
  }, [_vm._v("\n                The amount cannot be below 0 and must be a number.\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Deduction")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.include),
      expression: "include"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.include = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-five-o-three"
  }, [_c('div', {
    staticClass: "p-five-o-three__container"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 72.4 72.2"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.3 0C16.2 0 0 16.2 0 36.1s16.2 36.1 36.3 36.1S72.4 56 72.4 36.1 56.1 0 36.3 0zm0 61.4c-14 0-25.3-11.3-25.3-25.3s11.3-25.3 25.3-25.3S61.6 22 61.6 36.1 50.1 61.4 36.3 61.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M68.8 70.7c-2.2 1.9-5.8 1.7-7.7-.6L55 63.2c-1.9-2.2-1.7-5.8.6-7.7 2.2-1.9 5.8-1.7 7.7.6l6.1 6.9c1.9 2.5 1.6 5.8-.6 7.7z"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("503 Error")]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("We are currently experiencing some technical issues."), _c('br'), _c('br'), _vm._v(" Our Developers are working hard to deploy fixes as a high priority. For more information contact "), _c('strong', {
    staticClass: "strong-503"
  }, [_vm._v("Chris McCrudden")]), _vm._v(" on "), _c('strong', {
    staticClass: "strong-503"
  }, [_vm._v("0203 871 9971")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "mailto:abcquantum@bc-legal.co.uk"
    }
  }, [_c('strong', [_vm._v("contact us.")])])])
}]}

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'date',
        name: 'startOfPeriod' + _vm.index
      }),
      expression: "{type:'date', name:'startOfPeriod' + index}",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.index === 0,
      "required": "",
      "emit": true
    },
    on: {
      "input": _vm.updateNextPeriod
    },
    model: {
      value: (_vm.innerPeriod.startOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.innerPeriod, "startOfPeriod", $$v)
      },
      expression: "innerPeriod.startOfPeriod"
    }
  })], 1), _vm._v(" "), _c('td', [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'date',
        name: 'endOfPeriod' + _vm.index
      }),
      expression: "{type:'date', name:'endOfPeriod' + index}",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "required": "",
      "emit": true
    },
    on: {
      "input": _vm.updateNextPeriod
    },
    model: {
      value: (_vm.innerPeriod.endOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.innerPeriod, "endOfPeriod", $$v)
      },
      expression: "innerPeriod.endOfPeriod"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentType),
      expression: "innerPeriod.employmentType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.employmentIncome),
      expression: "innerPeriod.employmentIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'employmentIncome' + _vm.index
      }),
      expression: "{type:'number', name:'employmentIncome' + index}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.employmentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.innerPeriod.employmentIncome = _vm.innerPeriod.employmentIncome || ''
      },
      "blur": [function($event) {
        _vm.innerPeriod.employmentIncome = _vm.innerPeriod.employmentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "employmentIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  })])]), _vm._v(" "), _c('td', [_c('control', {
    attrs: {
      "tip-text": "ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "future_losses_constant",
      "tipShow": _vm.disabledNetGross,
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentNetGross),
      expression: "innerPeriod.employmentNetGross"
    }],
    attrs: {
      "disabled": _vm.disabledNetGross
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.totalNetIncome),
      expression: "innerPeriod.totalNetIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.totalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "totalNetIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "a-button u-no-margin ashe p-pi-income__ashe-average-button",
    on: {
      "click": function($event) {
        return _vm.selectSalary(null)
      }
    }
  }, [_vm._v("\n            Use ASHE average\n        ")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "a-button u-no-margin refine",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n            Refine by occupation\n        ")])]), _vm._v(" "), (this.index === 0) ? _c('td', [_c('button', {
    staticClass: "a-button a-button--delete a-button--delete-disabled a-button--small",
    attrs: {
      "role": "button",
      "type": "button",
      "disabled": "disabled"
    }
  })]) : _c('td', [_c('button', {
    staticClass: "a-button a-button--delete a-button--small",
    attrs: {
      "role": "button",
      "type": "button"
    },
    on: {
      "click": _vm.deletePeriod
    }
  })])]), _vm._v(" "), (!_vm.startOfPeriodRules || !_vm.endOfPeriodRules || !_vm.rangeOfPeriodRules || !_vm.incomeRules) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_c('control-error', {
    attrs: {
      "show": !_vm.startOfPeriodRules
    }
  }, [_vm._v("\n            The income period start date must be a valid date, can not be before the claimant's date of injury and\n            cannot be after the claimants's retirement date/end of future losses date\n        ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.endOfPeriodRules
    }
  }, [_vm._v("\n            The income period end date must be a valid date, can not be before claimant's date of injury and\n            cannot be after the claimants's retirement date/end of future losses date\n        ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.rangeOfPeriodRules
    }
  }, [_vm._v("\n            The income period start date must be before the income period end date\n        ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.incomeRules
    }
  }, [_vm._v("\n            The total income per annum is required and must be £0 or greater\n        ")])], 1)]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'ons_salary_' + this.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('div', {
    staticClass: "p-day-one__refine-occupation"
  }, [_c('h2', [_vm._v("Refine by occupation")]), _vm._v(" "), (_vm.selectedNode) ? _c('div', [_c('p', [_vm._v("\n                Your current selection - "), _c('strong', [_vm._v(_vm._s(_vm.getLastNode().description))]), _c('br'), _vm._v(" "), (_vm.getLastNode().code.length !== 3) ? _c('span', [_vm._v("Select a salary, expand down further or use the average salary for this whole group")]) : _c('span', [_vm._v("Select a salary or use the average salary for this whole group")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.unselectNode(_vm.selectedNode)
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.selectSalary(_vm.selectedNode)
      }
    }
  }, [_vm._v("Use average " + _vm._s(_vm.displaySalary(_vm.selectedNode)))])]) : _c('div', [_c('p', [_vm._v("\n                Select a salary or expand the group\n            ")])]), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "a-table__small a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('tbody', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "a-loader--table"
  })])]) : _c('tbody', _vm._l((_vm.nodes), function(node) {
    return _c('tr', {
      staticClass: "selected--row"
    }, [_c('td', [_vm._v(_vm._s(node.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displaySalary(node)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "a-button a-button--small",
      attrs: {
        "disabled": node.code.length === 4
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectNode(node)
        }
      }
    }, [_vm._v("\n                                Expand\n                            ")])]), _vm._v(" "), _c('td', [(node.salary !== 'x') ? _c('button', {
      staticClass: "a-button a-button--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectSalary(node, _vm.type)
        }
      }
    }, [_vm._v("\n                                Select\n                            ")]) : _vm._e()])])
  }), 0)])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Earnings Calculator",
      "icon": "earnings"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    on: {
      "input": _vm.reCalculateRetired
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.reCalculateRetired]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Start of Earnings"
    }
  }, [_c('date-input', {
    ref: "dateFrom",
    on: {
      "input": _vm.reCalculateEarnings
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.dateFromIsValid()
    }
  }, [_vm._v("\n                    Date is required, must be in the format DD/MM/YYYY and must be after 06/04/2008.\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "End of Earnings"
    }
  }, [_c('date-input', {
    ref: "dateTo",
    on: {
      "input": _vm.reCalculateEarnings
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.dateToIsValid()
    }
  }, [_vm._v("\n                    Date is required, must be in the format DD/MM/YYYY, and must be after both 06/04/2008 and the 'Start of Earnings'.\n                ")])], 1), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRetired),
      expression: "!isRetired"
    }],
    attrs: {
      "label": "Employment Type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    ref: "employmentType",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.reCalculateEarnings]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Income"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentIncome),
      expression: "employmentIncome"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "netOrGrossFirstText",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.employmentIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.employmentIncome = $event.target.value
      }, _vm.reCalculateEarnings],
      "focus": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || ''
      },
      "blur": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || 0
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentIncomeNetGross),
      expression: "employmentIncomeNetGross"
    }],
    ref: "netOrGrossFirst",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentIncomeNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.reCalculateEarnings]
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total Gross Earnings",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.totalGrossIncome
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total Net Earnings",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.totalNetIncome
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalNetIncome > 0),
      expression: "totalNetIncome > 0"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto p-earnings__calc"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                With annual gross earnings of " + _vm._s(_vm.currencyFormat(_vm.totalGrossIncome || 0)) + ", from " + _vm._s(_vm.dateFrom) + " to " + _vm._s(_vm.dateTo) + ",\n                " + _vm._s(_vm.currencyFormat(_vm.totalGrossIncome - _vm.totalNetIncome || 0)) + " of tax and/or NI contributions would be paid annually.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                This results in total Net earnings of " + _vm._s(_vm.currencyFormat(_vm.totalNetIncome || 0)) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "hotfix-width"
  }, [_vm._v("\n                The following chart provides a visual indication of income tax paid on employment\n                income, and any national insurance contributions applicable on employment income:\n            ")]), _vm._v(" "), (_vm.totalGrossIncome) ? _c('div', {
    staticClass: "chart"
  }, [_c('pie-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("\n                Earnings\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Between " + _vm._s(_vm.dateFrom) + " and " + _vm._s(_vm.dateTo) + " the Net of earnings would be " + _vm._s(_vm.currencyFormat(_vm.totalNetIncome * _vm.dateDiff())) + "\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimType),
      expression: "claimType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.claimType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident_estate"
    }
  }, [_vm._v("Fatal Accident Estate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident_dependency"
    }
  }, [_vm._v("Fatal Accident Dependency")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lost_years"
    }
  }, [_vm._v("Lost Years")]), _vm._v(" "), (_vm.diseaseOrAccident !== 'disease') ? _c('option', {
    attrs: {
      "value": "personal_injury"
    }
  }, [_vm._v("Personal Injury")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of Travel\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Disability Living Allowance (mobility component)",
      "store-key": "pcotDisabilityLivingAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Mobility Allowance",
      "store-key": "pcotMobilityAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Travel",
      "subtitle": "Personal Independence Payment (mobility component)",
      "store-key": "pcotPersonalIndependencePayment",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")])])
},staticRenderFns: []}

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-executive-dashboard__chart reserve-charts"
  }, [(_vm.loadingContent) ? _c('div', {
    staticClass: "a-loader--chart"
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingContent && !_vm.hasResults) ? _c('div', {
    staticClass: "p-executive-dashboard__chart__no-results"
  }, [_c('p', [_vm._v("\n            Your search returned no results.\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-full-width flex-grid--wrap u-flex-center"
  }, [(!_vm.loadingContent && _vm.hasResults) ? _c('div', {
    staticClass: "p-executive-dashboard__chart--left"
  }, [(!_vm.loadingContent && _vm.hasResults) ? _c('bar-chart', {
    attrs: {
      "chart-data": _vm.barChartData,
      "options": _vm.barChartOptions
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-executive-dashboard__chart--right a-table--short-no-style"
  }, [(!_vm.loadingContent && _vm.hasResults) ? _c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('tr', [_c('th', [_vm._v("\n                        Type\n                    ")]), _vm._v(" "), (_vm.type === 'number') ? _c('th', [_vm._v("\n                        Number of Claims\n                    ")]) : _c('th', [_vm._v("\n                        " + _vm._s(_vm.runType === 'totalReserve' ? 'Total' : 'Average') + "\n                        " + _vm._s(_vm.reserveType) + "\n                    ")]), _vm._v(" "), (_vm.diseaseType || _vm.runType === 'totalReserve' || _vm.type === 'number') ? _c('th', [_vm._v("\n                        %\n                    ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.table), function(row) {
    return (row[0]) ? _c('tr', [_c('td', {
      staticClass: "u-no-padding u-padding-l-20"
    }, [_c('table', {
      attrs: {
        "cellpadding": "0",
        "cellspacing": "0",
        "border": "0"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "u-no-padding u-no-border"
    }, [_c('div', [_c('span', {
      staticClass: "u-d-block",
      style: ('background: ' + row[2])
    })])]), _vm._v(" "), _c('td', {
      staticClass: "u-no-border"
    }, [_vm._v(_vm._s(row[0]))])])])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.type === 'number' ? row[1] : _vm.currencyFormat(row[1])) + "\n                    ")]), _vm._v(" "), (_vm.diseaseType || _vm.runType === 'totalReserve' || _vm.type === 'number') ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.percentage(row[1])) + "%\n                    ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.runType === 'totalReserve' || _vm.runType === 'averageReserve' || _vm.type === 'number') ? _c('tfoot', [_c('tr', [_c('td', [_vm._v("\n                            " + _vm._s(_vm.runType === 'totalReserve' || _vm.type === 'number' ? 'Total' : 'Average') + "\n                        ")]), _vm._v(" "), (_vm.runType === 'totalReserve' || _vm.type === 'number') ? _c('td', [_vm._v("\n                            " + _vm._s(_vm.type === 'number' ? _vm.sum : _vm.currencyFormat(_vm.sum)) + "\n                        ")]) : _c('td', [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.chartData.average)) + "\n                        ")]), _vm._v(" "), (_vm.diseaseType || _vm.runType === 'totalReserve' || _vm.type === 'number') ? _c('td', [_vm._v("\n                            100%\n                        ")]) : _vm._e()])]) : _vm._e()], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid flex-grid--wrap a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "name": 'dependent_name_' + _vm.index,
      "label": "Dependant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theDependant.name),
      expression: "theDependant.name"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "field-control",
      rawName: "v-field-control:dependent_name.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "dependent_name",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "dependent_name",
      "type": "text",
      "id": 'dependent_name_' + _vm.index,
      "maxlength": "100",
      "required": ""
    },
    domProps: {
      "value": (_vm.theDependant.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theDependant, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dependent_name')
    }
  }, [_vm._v("\n                    The dependant's name is required and must be a valid name\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "name": 'date_of_birth_' + _vm.index,
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:dependant_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "dependant_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDependant.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.theDependant, "dateOfBirth", $$v)
      },
      expression: "theDependant.dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dependant_date_of_birth')
    }
  }, [_vm._v("\n                    The dependant's date of birth is required and must be in the format DD/MM/YYYY\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "name": 'dependant_gender' + _vm.index,
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theDependant.gender),
      expression: "theDependant.gender"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "dependant_gender",
      "id": 'dependant_gender' + _vm.index,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.theDependant, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dependant_gender')
    }
  }, [_vm._v("\n                    The dependant gender is required\n                ")])], 1), _vm._v(" "), _c('life-expectancy', {
    attrs: {
      "label": "Dependant's Life Expectancy",
      "person": _vm.theDependant,
      "type": 'dependant',
      "index": this.index,
      "stepValid": _vm.stepValid,
      "assumed-settlement": _vm.claimDetails('assumedSettlement')
    },
    on: {
      "update": _vm.updateLife
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Age at Deceased’s Date of Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtDeceasedDod
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Current Age",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.age
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Age at Assumed Settlement",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtAssumedSettlement
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Age at Deceased's End of Life",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtDeceasedButForDod
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "End of Dependency",
      "for": "end_of_dependency"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.dependency.date
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--years"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endOfDependencyDuration),
      expression: "endOfDependencyDuration"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "end_of_dependency",
      "min": "0.1",
      "step": "0.01",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.endOfDependencyDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endOfDependencyDuration = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('end_of_dependency') || !_vm.endOfDependencyValid()
    }
  }, [_vm._v("\n                            There must be a period of dependency\n                        ")])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button u-margin-top-0 u-margin-bottom-0",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": _vm.deleteThisDependant
    }
  }, [_vm._v("Delete\n            Dependant\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-compare-reserve__percentage"
  }, [_c('div', {
    staticClass: "p-compare-reserve__slider"
  }, [_c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": -1,
      "max": 1,
      "interval": 0.1,
      "real-time": true,
      "clickable": true,
      "bg-style": _vm.backgroundStyle,
      "process-style": {
        'backgroundColor': '#a6a6a6'
      },
      "tooltip-style": [{
          'backgroundColor': '#85f7d9',
          'borderColor': '#85f7d9',
          'color': 'black',
          'padding': '8px 12px 5px',
        },
        {
          'backgroundColor': '#e68bb4',
          'borderColor': '#e68bb4',
          'color': 'black',
          'padding': '8px 12px 5px',
        }
      ],
      "label-style": {
        'color': '#fff'
      },
      "formatter": _vm.rangeDisplay
    },
    model: {
      value: (_vm.range),
      callback: function($$v) {
        _vm.range = $$v
      },
      expression: "range"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "u-text-center"
  }, [_vm._v("\n        Set your percentage over/under range.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "a-table a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Employment Income")]), _vm._v(" "), _c('th', [_vm._v("Net/Gross")]), _vm._v(" "), _c('th', [_vm._v("Total Net Income")]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "p-pi-income__ashe-average"
  }, [_c('p', [_vm._v("ASHE Average")]), _vm._v(" "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "ashe"
    }
  }, [_c('div', {
    staticClass: "p-pi-income__ashe-average-tooltip"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-text": "Click to view information",
      "side": "bottom",
      "text-width": "140",
      "icon-type": "info",
      "icon-colour": "m-icon--light"
    }
  })], 1)])], 1)])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                            Pre-Accident Earnings\n                        ")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.preEmploymentIncome),
      expression: "preEmploymentIncome"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "required": "",
      "disabled": _vm.getIncomeValue('pastLossOfEarnings')
    },
    domProps: {
      "value": (_vm.preEmploymentIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preEmploymentIncome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('control', {
    attrs: {
      "tip-text": "ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "future_losses_constant",
      "tipShow": !_vm.getIncomeValue('pastLossOfEarnings') && _vm.preAccidentDisableNetGross,
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preEmploymentNetGross),
      expression: "preEmploymentNetGross"
    }],
    attrs: {
      "disabled": _vm.getIncomeValue('pastLossOfEarnings') || _vm.preAccidentDisableNetGross
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preEmploymentNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.preTotalNetIncome),
      expression: "preTotalNetIncome"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.preTotalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preTotalNetIncome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "a-button u-no-margin ashe p-pi-income__ashe-average-button",
    attrs: {
      "disabled": _vm.getIncomeValue('pastLossOfEarnings')
    },
    on: {
      "click": function($event) {
        return _vm.selectSalary(null, 'pre')
      }
    }
  }, [_vm._v("\n                                Use ASHE average\n                            ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin refine",
    attrs: {
      "disabled": _vm.getIncomeValue('pastLossOfEarnings')
    },
    on: {
      "click": function($event) {
        return _vm.openDialog('pre')
      }
    }
  }, [_vm._v("\n                                Refine by occupation\n                            ")])])]), _vm._v(" "), (_vm.getIncomeValue('pastLossOfEarnings') || _vm.futureLossesConstant) ? _c('tr', [_c('td', [_vm._v("\n                            Post-Accident Earnings\n                        ")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.postEmploymentIncome),
      expression: "postEmploymentIncome",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "required": ""
    },
    domProps: {
      "value": (_vm.postEmploymentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.postEmploymentIncome = _vm.postEmploymentIncome || ''
      },
      "blur": [function($event) {
        _vm.postEmploymentIncome = _vm.postEmploymentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postEmploymentIncome = _vm._n($event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('control', {
    attrs: {
      "tip-text": "ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "future_losses_constant",
      "tipShow": _vm.postAccidentDisableNetGross,
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postEmploymentNetGross),
      expression: "postEmploymentNetGross"
    }],
    attrs: {
      "disabled": _vm.postAccidentDisableNetGross
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.postEmploymentNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.postTotalNetIncome),
      expression: "postTotalNetIncome"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.postTotalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postTotalNetIncome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "a-button u-no-margin ashe p-pi-income__ashe-average-button",
    on: {
      "click": function($event) {
        return _vm.selectSalary(null, 'post')
      }
    }
  }, [_vm._v("\n                                Use ASHE average\n                            ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin refine",
    on: {
      "click": function($event) {
        return _vm.openDialog('post')
      }
    }
  }, [_vm._v("\n                                Refine by occupation\n                            ")])])]) : _vm._e()])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'ons_salary_' + this.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('div', {
    staticClass: "p-day-one__refine-occupation"
  }, [_c('h2', [_vm._v("Refine by occupation")]), _vm._v(" "), (_vm.selectedNode) ? _c('div', [_c('p', [_vm._v("\n                    Your current selection - "), _c('strong', [_vm._v(_vm._s(_vm.getLastNode().description))]), _c('br'), _vm._v(" "), (_vm.getLastNode().code.length !== 3) ? _c('span', [_vm._v("Select a salary, expand down further or use the average salary for this whole group")]) : _c('span', [_vm._v("Select a salary or use the average salary for this whole group")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.unselectNode(_vm.selectedNode)
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.selectSalary(_vm.selectedNode)
      }
    }
  }, [_vm._v("Use average " + _vm._s(_vm.displaySalary(_vm.selectedNode)))])]) : _c('div', [_c('p', [_vm._v("\n                    Select a salary or expand the group\n                ")])]), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "a-table__small a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('tbody', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "a-loader--table"
  })])]) : _c('tbody', _vm._l((_vm.nodes), function(node) {
    return _c('tr', {
      staticClass: "selected--row"
    }, [_c('td', [_vm._v(_vm._s(node.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displaySalary(node)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "a-button a-button--small",
      attrs: {
        "disabled": node.code.length === 4
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectNode(node)
        }
      }
    }, [_vm._v("\n                                    Expand\n                                ")])]), _vm._v(" "), _c('td', [(node.salary !== 'x') ? _c('button', {
      staticClass: "a-button a-button--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectSalary(node, _vm.type)
        }
      }
    }, [_vm._v("\n                                    Select\n                                ")]) : _vm._e()])])
  }), 0)])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ashe",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("ASHE Average")]), _vm._v("\n        We have provided average gross (median) earnings by selected gender & occupational categories according to the Average Survey of Hours and Earnings (ASHE). The data are collected and published by the Office of National Statics (ONS) annually and can be found here.\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Head of Loss ' + (_vm.index + 1)
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "name",
      "placeholder": "Type of Head of Loss",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": _vm.updateValid,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('name') || !_vm.name
    }
  }, [_vm._v("\n            Name of loss is required\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "value",
      "required": "",
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "change": _vm.updateValid,
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": function($event) {
        _vm.value = _vm.value || 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            Value should be greater than £0.00\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisHeadOfLoss
    }
  }, [_vm._v("Delete Head of Loss")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('claim-info', {
    attrs: {
      "claim": _vm.claim,
      "show-back": false,
      "title": "Update Claim Status"
    },
    on: {
      "save": _vm.saveClaimData
    }
  }), _vm._v(" "), _c('initial-reserves-costs', {
    attrs: {
      "claim": _vm.claim,
      "show-back-btn": false,
      "title": "Reserves & Costs"
    },
    on: {
      "save": _vm.saveReserveChanges
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-animated-calc"
  }, [_c('div', {
    staticClass: "p-animated-calc__container all-cols"
  }, [_c('div', {
    staticClass: "p-animated-calc__column-two--large--cover"
  }), _vm._v(" "), _c('svg', {
    staticClass: "p-animated-calc__logo",
    attrs: {
      "viewBox": "0 0 230.4 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__column-one--small"
  }, [_c('div', {
    staticClass: "p-animated-calc__column-one--small--cover"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/mini-calculators/'
    }
  }, [_c('div', {
    staticClass: "p-animated-calc__top-menu"
  }, [_c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#dashboard"
    }
  })])])]), _vm._v(" "), _vm._t("summary-panel")], 2), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__column-two--large",
    attrs: {
      "id": "print-panel"
    }
  }, [_c('mini-calculator-print'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._t("results-panel")], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid--vertical p-animated-calc__summary-panel"
  }, [_c('div', [_c('h2', {
    staticClass: "prompt"
  }, [_vm._v("\n                        Your Calculation\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Your calculation will appear here once all mandatory fields have been completed.\n                    ")])])])
}]}

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs a-form-inputs--table"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('accordion', [_c('general-damages', {
    attrs: {
      "estate-type": "estate"
    }
  }), _vm._v(" "), _c('past-cost-of-care', {
    attrs: {
      "estate-type": "estate"
    }
  }), _vm._v(" "), _c('past-cost-of-travel', {
    attrs: {
      "estate-type": "estate"
    }
  }), _vm._v(" "), _c('past-loss-of-earnings', {
    attrs: {
      "estate-type": "estate"
    }
  })], 1), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.allValid
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gd-psla-calculator"
  }, [_c('h2', [_vm._v("Mesothelioma General Damages (PSLA) Calculator")]), _vm._v(" "), _c('p', [_vm._v("\n        Welcome to our Mesothelioma General Damages (PSLA) calculator. The calculator shows estimated common law awards\n        according to 'age' and 'duration of symptoms' — the period between onset of the disease\n        and death (or anticipated date of death).\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        There are two parts to the Mesothelioma calculator:\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n        Onset of symptoms:\n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm.onsetOfSymptoms) + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        Duration of symptoms:\n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm.calculatedDurationOfSymptoms) + " month" + _vm._s(_vm.calculatedDurationOfSymptoms === 1 ? '' : 's') + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        Age at Death: "), _c('strong', [_vm._v(_vm._s(_vm.ageAtDeath))])]), _vm._v(" "), _c('label', [_vm._v("\n        Duration of Symptoms\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-gd-psla-calculator__slider p-dependency-calc__slider"
  }, [_c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 0,
      "max": 37,
      "real-time": true,
      "clickable": true,
      "piecewise": true,
      "process-style": {
        'backgroundColor': '#4A89E5'
      },
      "tooltip-style": {
        'backgroundColor': '#4A89E5',
        'borderColor': '#4A89E5'
      },
      "formatter": _vm.calculatedDurationOfSymptoms + ' months',
      "label-style": {
        'color': '#fff'
      }
    },
    model: {
      value: (_vm.calculatedDurationOfSymptoms),
      callback: function($$v) {
        _vm.calculatedDurationOfSymptoms = $$v
      },
      expression: "calculatedDurationOfSymptoms"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('h2', [_vm._v("Tariff Table")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": function($event) {
        return _vm.applyUplift()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upliftButton ? 'Add' : 'Remove') + " 10% Uplift\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [(_vm.table[50] && !_vm.loading.table) ? _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up to)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.table[50].length
    }
  }, [_vm._v("\n                    Duration (months)\n                ")])]), _vm._v(" "), _c('tr', _vm._l((_vm.table[50].length), function(col) {
    return _c('th', [(col === 1) ? _c('span', [_vm._v("0-3")]) : (col === 13) ? _c('span', [_vm._v("37+")]) : _c('span', [_vm._v(_vm._s(col * 3 - 2) + "-" + _vm._s(col * 3))])])
  }), 0), _vm._v(" "), _vm._l((_vm.table), function(tr, age) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(age))]), _vm._v(" "), _vm._l((tr), function(td, index) {
      return _c('td', {
        style: (_vm.getTariffTableTdStyle(index, age)),
        on: {
          "click": function($event) {
            _vm.usePslaAward(_vm.uplift ? Math.round(td * 1.1) : td)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.uplift ? Math.round(td * 1.1) : td, '£', 0)) + "\n                ")])
    })], 2)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.loading.table) ? _c('div', [_vm._v("\n        Loading... one moment\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "c-gd-psla-calculator__disclaimer"
  }, [_vm._v("Data is up-to-date as of October 2017 *")]), _vm._v(" "), _c('h2', [_vm._v("Awards")]), _vm._v(" "), _vm._l((_vm.filteredAwards), function(award) {
    return (!_vm.loading.awards) ? _c('psla-award', {
      attrs: {
        "award": award
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.loading.awards) ? _c('div', [_vm._v("\n        Loading... one moment\n    ")]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("\n            The first is a Tariff Table designed to give a broad brush indication of possible awards and\n            is not intended to substitute a detailed review and consideration of actual awards to\n            properly value any PSLA award. The Tariff Table is based on the 14th Edition of the JC Guidelines.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n            The second shows actual PLSA awards which most closely fit the selected age and duration\n            of symptoms.\n        ")])])
}]}

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-margin-top-30"
  }, [_c('control', {
    attrs: {
      "label": 'Period ' + (_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodStart),
      callback: function($$v) {
        _vm.periodStart = $$v
      },
      expression: "periodStart"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodStart')
    }
  }, [_vm._v("\n                    Loss of earnings period must be before the deceased's date of death (" + _vm._s(_vm.theDeceased.dateOfDeath) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEnd || !_vm.periodStartIsBeforeEnd()
    }
  }, [_vm._v("\n                    Start of loss of earnings period must be before end of loss of earnings period\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodEnd),
      callback: function($$v) {
        _vm.periodEnd = $$v
      },
      expression: "periodEnd"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodEnd') || !_vm.endPeriodValid()
    }
  }, [_vm._v("\n                    Loss of earnings period end date must be before " + _vm._s(_vm.theDeceased.dateOfDeath) + "\n                ")])], 1)])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Earnings Per Annum"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodEmploymentType),
      expression: "periodEmploymentType"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    on: {
      "input": _vm.calcRate,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodEmploymentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")])]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--half u-margin-top-30"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodNetGross),
      expression: "periodNetGross"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    on: {
      "input": _vm.calcRate,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodValue),
      expression: "periodValue"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "period_value",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodValue)
    },
    on: {
      "focus": function($event) {
        _vm.periodValue = _vm.periodValue || ''
      },
      "blur": function($event) {
        _vm.periodValue = _vm.periodValue || 0
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.periodValue = $event.target.value
      }, _vm.calcRate]
    }
  })])])]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubtotal),
      expression: "showSubtotal"
    }],
    attrs: {
      "for": "sub_total",
      "label": "Subtotal",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodTotal),
      expression: "periodTotal"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.periodTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodTotal = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showDelete) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deletePeriod
    }
  }, [_vm._v("Delete This Period")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr--margin-bottom"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one-reserving-simple"
  }, [(_vm.calculating) ? _c('div', {
    staticClass: "a-loader--big"
  }) : (!_vm.hasResults || _vm.dirtyForm) ? _c('div', [_c('h2', {
    staticClass: "u-margin-top-10 u-margin-bottom-10"
  }, [_vm._v("Your Results")]), _vm._v(" "), _c('p', [_vm._v("Your results will appear here once all mandatory fields have been completed and you have calculated\n          the result.")])]) : _c('div', [_c('accordion', [_c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Facts & Figures")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('td', [_vm._v("Deceased's age at DOD")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v(_vm._s(_vm.roundValue(_vm.ageAtDeath, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Period between DOD & Assessment")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.periodBetweenDodAndAssessment, 2)) + " years")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Deceased's age at Assessment/Trial")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.deceasedAgeAtAssessment, 2)) + " years")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                            Period of Dependency from Assessment/Trial (Based on Deceased's assumed life expectancy\n                            at age of Assessment/Trial — Column 0% Ogden Table 1)\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.periodOfDependencyFromAssessment, 2)) + " years")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ogden Discount Rate")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.calculation.ogdenDiscountRate) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                Ogden Table 36 multiplier dependency\n                                "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneTable28Multiplier",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.table28Multiplier, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                Table E pre-assessment discount\n                                "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneTableEDiscount",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.preAssessmentDiscount, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                Table F post-assessment discount\n                                "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneTableFDiscount",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.postAssessmentDiscount, 2)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "u-position-relative"
  }, [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Assumptions")]), _vm._v(" "), _c('div', {
    staticClass: "p-day-one__tooltip-modal"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "assumptions_overview"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view assumptions",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "p-day-one__tooltip-modal--assumptions-list"
  }, [_c('li', [_vm._v("\n                            Deceased had normal life expectancy as per the 0% column Ogden Table\n                            " + _vm._s(_vm.gender === 'male' ? 1 : 2) + "\n                        ")]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('div', [_c('li', [_vm._v("Any dependent(s) would have outlived the deceased")]), _vm._v(" "), _c('li', [_vm._v("\n                                The deceased’s ‘but for’ life expectancy determines the end of\n                                dependency\n                            ")]), _vm._v(" "), _c('li', [_vm._v("Cost of past services is calculated from onset of symptoms to date of death")]), _vm._v(" "), _c('li', [_vm._v("Cost of past services assessed at £1,500 per annum")])]) : _vm._e(), _vm._v(" "), (_vm.employmentType === 'employed') ? _c('li', [_vm._v("\n                            The deceased will retire as the state pension age. As the deceased was born on\n                            " + _vm._s(_vm.dateOfBirth) + " this is\n                            assumed to be on " + _vm._s(_vm.results.calculation.retirementDate) + " at age " + _vm._s(_vm.retirementAge) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Past loss of earnings will commence in full from the date of onset of symptoms")]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('li', [_vm._v("\n                            Bereavement award based on date of death would apply\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Typical heads of loss are applied as follows:\n                            "), _c('ul', {
    staticClass: "sub"
  }, [_c('li', [_vm._v("General damages (PSLA) " + _vm._s(_vm.currencyFormat(_vm.results.damages.generalDamages)))]), _vm._v(" "), _c('li', [_vm._v("Care " + _vm._s(_vm.currencyFormat(_vm.results.damages.care)))]), _vm._v(" "), _c('li', [_vm._v("Funeral expenses " + _vm._s(_vm.currencyFormat(_vm.results.damages.funeralExpenses)))]), _vm._v(" "), _c('li', [_vm._v("\n                                    Miscellaneous (medication, travel, appliances, additional food & energy\n                                    costs) " + _vm._s(_vm.currencyFormat(_vm.results.damages.miscellaneous)) + "\n                                ")])])]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('div', [_c('li', [_vm._v("The dependency multiplier is based on Ogden Table 36")]), _vm._v(" "), _c('li', [_vm._v("The dependency multiplicand on services is assesed at £1,500")]), _vm._v(" "), _c('li', [_vm._v("\n                                Future dependency on services is determined from date of death to the deceased's\n                                \"but for\" life expectancy\n                            ")]), _vm._v(" "), _c('li', [_vm._v("All dependants have no earnings")]), _vm._v(" "), _c('li', [_vm._v("Dependency on pension is assessed at £10,000 per annum")])]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "u-position-relative"
  }, [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Total Damages")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Heads of Loss")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Valuation")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        General Damages (PSLA)\n                                    ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Bereavement Award\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneBereavementAward",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.bereavementAward)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Funeral Expenses\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneFuneralExpenses",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.funeralExpenses)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Past Loss of Earnings (if applicable)\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOnePastLossOfEarnings",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.pastLossOfEarnings)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Past Cost of DIY/Services\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOnePastCostOfServices",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.pastCostOfDiy)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Miscellaneous (treatments/increased utilities/clothing/foods/appliances &\n                                        equipment)\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneMiscellaneousCalc",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.miscellaneous)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Care\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneCostOfCare",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.care)))])]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Dependency on Income\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneDependencyOnIncome",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.dependencyOnIncome)))])]) : _vm._e(), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Dependency on Services\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneDependencyOnServices",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.dependencyOnServices)))])]) : _vm._e()]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addHeadOfLoss
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.ownHeadsOfLoss.length ?
    'Add another head of loss' : 'Click here to add your own head of loss') + "\n                                    ")])])]), _vm._v(" "), _vm._l((_vm.ownHeadsOfLoss), function(head, index) {
    return _c('own-head-of-loss', {
      attrs: {
        "head-of-loss": head,
        "index": index
      }
    })
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Total Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalDamages)))])])])])])])], 1), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Total Reserve")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Total Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalDamages)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Claimant Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": _vm.claimantCosts
    },
    on: {
      "input": _vm.updateClaimantCosts
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Defence Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": _vm.defenceCosts
    },
    on: {
      "input": _vm.updateDefenceCosts
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.damagesContribution
    },
    on: {
      "input": _vm.updateDamagesContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Claimant Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.claimantContribution
    },
    on: {
      "input": _vm.updateClaimantContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Defence Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.defenceContribution
    },
    on: {
      "input": _vm.updateDefenceContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Damages Reserve (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedDamagesReserve)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Claimant Costs (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedClaimantReserve)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Defence Costs (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedDefenceReserve)))])])]), _vm._v(" "), _c('tfoot', [_c('tr', {}, [_c('td', [_vm._v("Total Reserve")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalReserve)))])])])])]), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Compare Your Claim")]), _vm._v(" "), _c('div', {
    staticClass: "p-day-one-reserving-simple__compare-your-claim"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "compare_your_claim"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view compare details",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1), _vm._v(" "), _c('reserve-performance-chart', {
    attrs: {
      "slot": "if-slot"
    },
    slot: "if-slot"
  })], 1)], 1), _vm._v(" "), _c('day-one-save'), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.openSummaryDocument
    }
  }, [_vm._v("\n            Download Summary\n        ")]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "assumptions_overview",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("Assumptions")]), _vm._v(" "), _c('accordion', [_c('past-services-modal', {
    attrs: {
      "value": _vm.results.damages.pastCostOfDiy
    }
  }), _vm._v(" "), _c('past-loss-earnings-modal', {
    attrs: {
      "value": _vm.results.damages.pastLossOfEarnings
    }
  }), _vm._v(" "), (_vm.estateOrDependency !== 'estate') ? _c('bereavement-award-modal', {
    attrs: {
      "person": _vm.modalPayload.person,
      "value": _vm.results.damages.bereavementAward
    }
  }) : _vm._e(), _vm._v(" "), _c('psla-modal', {
    attrs: {
      "age": _vm.ageAtDeath,
      "duration": _vm.durationOfSymptoms,
      "value": _vm.results.damages.generalDamages
    }
  }), _vm._v(" "), _c('care-modal', {
    attrs: {
      "value": _vm.results.damages.care,
      "person": _vm.modalPayload.person,
      "claim": _vm.modalPayload.claim,
      "type": _vm.estateOrDependency
    }
  }), _vm._v(" "), _c('funeral-expenses-modal', {
    attrs: {
      "value": _vm.results.damages.funeralExpenses
    }
  }), _vm._v(" "), _c('misc-modal', {
    attrs: {
      "value": _vm.results.damages.miscellaneous
    }
  }), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('dependency-income-modal', {
    attrs: {
      "value": _vm.results.damages.dependencyOnIncome
    }
  }) : _vm._e(), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('dependency-services-modal', {
    attrs: {
      "value": _vm.results.damages.dependencyOnServices
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "calculation_modal",
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "psla_modal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n                General Damages\n            ")]), _vm._v(" "), _c('psla-modal-content', {
    attrs: {
      "age": _vm.ageAtDeath,
      "duration": _vm.durationOfSymptoms,
      "value": _vm.results.damages.generalDamages
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "compare_your_claim",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n                Compare your claims\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Using the information you have provided we have attempted to match claims with similar\n                characteristics\n                from your book of claims.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                To determine a match we have looked for claims that match:\n            "), _c('ul', [_c('li', [_vm._v("Disease type: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.diseaseType))])]), _vm._v(" "), _c('li', [_vm._v("Claim type: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v("Fatal Accident")])]), _vm._v(" "), _c('li', [_vm._v("Estate or Dependency:\n                    "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.estateOrDependency === 'dependency' ? 'Dependency' : 'Estate Only'))])]), _vm._v(" "), _c('li', [_vm._v("Deceased Gender: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.gender === 'male' ? 'Male' : 'Female'))])]), _vm._v(" "), _c('li', [_vm._v("Deceased age (in five years bracket going up):\n                    "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.ageAtDeath))]), _vm._v(" to "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(parseInt(_vm.ageAtDeath) + 4))])])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Age Calculator",
      "icon": "age-calculator"
    }
  }), _vm._v(" "), _c('div', [_c('control', {
    attrs: {
      "for": "deceased_date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "deceasedDateOfBirth",
    on: {
      "change": function($event) {
        return _vm.updateCounter(_vm.totalInputs + 1)
      },
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_birth')
    }
  }, [_vm._v("\n                        The date of birth is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_death",
      "label": "Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_death.required",
      value: ({
        type: 'date',
        rules: _vm.dateOfDeathRules
      }),
      expression: "{type:'date', rules:dateOfDeathRules}",
      arg: "deceased_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    ref: "deceasedDateOfDeath",
    on: {
      "change": function($event) {
        return _vm.updateCounter(_vm.totalInputs + 1)
      },
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfDeath),
      callback: function($$v) {
        _vm.dateOfDeath = $$v
      },
      expression: "dateOfDeath"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_death')
    }
  }, [_vm._v("\n                        The date of death is required and must be in the format DD/MM/YYYY\n                    ")])], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_death",
      "label": "Age at Death"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "age_at_death",
      "type": "number",
      "name": "age_at_death"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('p', [_vm._v("\n                The age at death calculator has determined the age for a person who was\n                born on " + _vm._s(_vm.dateOfBirth) + " and who died on " + _vm._s(_vm.dateOfDeath) + " as " + _vm._s(_vm.ageAtDeath) + " years old.\n                "), _c('br'), _c('br')]), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": _vm.barValues
    }
  }, [_c('h3', [_vm._v("Age at Date of Death — " + _vm._s(_vm.dateOfDeath))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v("Age at Today's Date — " + _vm._s(_vm.todaysDate))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])]), _vm._v(" "), _c('p', [_c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("\n                    Perhaps try our\n                    "), _c('router-link', {
    attrs: {
      "to": '/mini-calculators/life-expectancy'
    }
  }, [_vm._v("Life Expectancy Calculator")]), _vm._v("\n                    in order to see how the person's life expectancy compares to the figures provided here.\n                ")], 1)])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Head of Loss ' + (_vm.index + 1),
      "for": "name"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "name",
      "placeholder": "Type of Head of Loss",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, _vm.updateValid]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('name')
    }
  }, [_vm._v("\n            Type of loss is required\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "value",
      "required": "",
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = _vm._n($event.target.value)
      }, _vm.updateValid],
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": [function($event) {
        _vm.value = _vm.value || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            Value should be greater than £0.00\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisHeadOfLoss
    }
  }, [_vm._v("Delete Head of Loss")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid__g-4 u-flex-grow-none"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions,
      "width": 160,
      "height": 90
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-d-flex flex-state-buttons p-executive-dashboard__claim-numbers"
  }, [_c('h2', {
    staticClass: "u-margin-top-10 u-r-no-margin"
  }, [_vm._v("\n            Claim Numbers\n        ")]), _vm._v(" "), (!_vm.diseaseTypeSelected) ? _c('option-filters', [_c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'total'
    },
    on: {
      "click": function($event) {
        _vm.chartType = 'total'
      }
    }
  }, [_vm._v("\n                By Type\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'caseNumbersTrendChartData'
    },
    on: {
      "click": function($event) {
        _vm.chartType = 'trend'
      }
    }
  }, [_vm._v("\n                Trends by Numbers\n            ")])]) : _vm._e()], 1), _vm._v(" "), (_vm.chartType === 'total' && !_vm.diseaseTypeSelected) ? _c('summary-charts', {
    attrs: {
      "type": "number",
      "run-type": "averageReserve",
      "chart-data": _vm.caseNumbersChartData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chartType === 'trend' || _vm.diseaseTypeSelected) ? _c('trends-chart', {
    attrs: {
      "type": "number",
      "showing": "total",
      "chart-data": _vm.caseNumbersTrendChartData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Reserve vs Paid Comparison",
      "set-position": "relative",
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-reserving p-compare-reserve u-margin-bottom-40",
    attrs: {
      "id": "app"
    }
  }, [_c('claims-dashboard-icons'), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-30"
  }, [_vm._v("\n            Compare the accuracy of your initial or final reserves against paid\n            settlements\n        ")]), _vm._v(" "), _c('compare-form'), _vm._v(" "), (_vm.calculating) ? _c('div', {
    staticClass: "a-loader--results"
  }) : _vm._e(), _vm._v(" "), (_vm.claims.length && !_vm.calculating) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "u-full-width"
  }, [_c('range-chart-container')], 1)]) : _vm._e(), _vm._v(" "), (_vm.claims.length && !_vm.calculating) ? _c('slider') : _vm._e(), _vm._v(" "), (_vm.claims.length && !_vm.calculating) ? _c('results-table') : _vm._e(), _vm._v(" "), (_vm.claims.length && !_vm.calculating) ? _c('div', {
    staticClass: "p-compare-reserve__charts"
  }, [_c('div', {
    staticClass: "u-margin-bottom-30"
  }, [_c('difference-chart')], 1), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-center"
  }, [(_vm.claims.length && !_vm.calculating) ? _c('button', {
    staticClass: "a-button a-button--small u-margin-top-10",
    on: {
      "click": function($event) {
        _vm.showClaimTable = !_vm.showClaimTable
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.showClaimTable ? 'Hide' : 'Show') + " Table Of Claims\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.claims.length && _vm.showClaimTable) ? _c('claim-table') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-margin-bottom-40"
  }, [_c('fee-earner-chart')], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-accordion__box"
  }, [_c('div', {
    staticClass: "m-accordion__header",
    class: {
      'm-accordion__box--closed': !_vm.isOpen,
      'm-accordion__box--closed--has-error': _vm.hasError && !_vm.isOpen,
        'm-accordion__box--open': _vm.isOpen && _vm.showOpen
    },
    on: {
      "click": function($event) {
        return _vm.triggerOpenNext(_vm.index)
      }
    }
  }, [_vm._t("header"), _vm._v(" "), _c('span', {
    class: ['accordion-header-icon', {
      'accordion-header-icon-open': _vm.isOpen,
      'accordion-header-icon-closed': !_vm.isOpen
    }]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "m-accordion__item-content",
    class: {
      'm-accordion__item-content--pull': _vm.contentPull
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.isOpen) ? _vm._t("if-slot") : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimStatus),
      expression: "claimStatus"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.claimStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Claims")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Live")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "closed"
    }
  }, [_vm._v("Concluded")])])
},staticRenderFns: []}

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "prevent": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "submit", undefined, $event.key, undefined)) { return null; }
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "a-table a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [(!this.retired) ? _c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Employment Type")]), _vm._v(" "), _c('th', [_vm._v("Employment Income")]), _vm._v(" "), _c('th', [_vm._v("Net/Gross")]), _vm._v(" "), _c('th', [_vm._v("Pension Income")]), _vm._v(" "), _c('th', [_vm._v("Net/Gross")]), _vm._v(" "), _c('th', [_vm._v("Total Gross Income")]), _vm._v(" "), _c('th', [_vm._v("Total Net Income")]), _vm._v(" "), _c('th')]) : _c('tr', [(!this.retired || this.lossOfEarnings) ? _c('th', [_vm._v("From")]) : _vm._e(), _vm._v(" "), (!this.retired || this.lossOfEarnings) ? _c('th', [_vm._v("To")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Income per annum")]), _vm._v(" "), _c('th', [_vm._v("Net/Gross")]), _vm._v(" "), _c('th', [_vm._v("Net Income per annum")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _vm._l((_vm.periods), function(period, periodIndex) {
    return _c('income-period', {
      attrs: {
        "start-disabled": _vm.startDisabled,
        "period": period,
        "index": periodIndex,
        "dependant": _vm.index,
        "maxIndex": _vm.periodsLength,
        "retired": _vm.retired,
        "lossOfEarnings": _vm.lossOfEarnings,
        "type": _vm.type
      },
      on: {
        "update": _vm.updatePeriod
      }
    })
  }), _vm._v(" "), (!_vm.incomeRules) ? _c('tbody', [_c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": !_vm.retired ? 10 : 6
    }
  }, [_c('control-error', {
    attrs: {
      "show": !_vm.incomeRules
    }
  }, [_vm._v("\n                                The income must be greater than £0.00\n                            ")])], 1)])]) : _vm._e()], 2)]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.incomePeriod
    }
  }, [_vm._v("\n            Add another period\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-animated-calc__share"
  }, [_c('div', {
    staticClass: "m-mini-calc-icon--print"
  }, [_c('svg', {
    staticClass: "m-mini-calc-icon m-mini-calc-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#print"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimInfoForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "claimant_date_of_onset",
      "label": _vm.getClaimantDetail('diseaseOrAccident') === 'disease' ? 'Claimant Date of Onset Symptoms' : 'Claimant Date of Injury / Accident'
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claimant_date_of_onset.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "claimant_date_of_onset",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "claimant_date_of_onset"
    },
    model: {
      value: (_vm.onsetOfSymptoms),
      callback: function($$v) {
        _vm.onsetOfSymptoms = $$v
      },
      expression: "onsetOfSymptoms"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_date_of_onset') || !_vm.onsetRules
    }
  }, [_vm._v("\n                        The claimant's onset of symptoms is required, must be in the format DD/MM/YYYY\n                        and must be after the Claimant's date of birth " + _vm._s(_vm.dateOfBirth) + "\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimants_assumed_dod_type",
      "label": "Claimant's Assumed Date of Death"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assumedLifeExpectancyMethod),
      expression: "assumedLifeExpectancyMethod"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimants_assumed_dod_type",
      "id": "claimants_assumed_dod_type",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assumedLifeExpectancyMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_years_and_months_left"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_date"
    }
  }, [_vm._v("Enter Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_age_at_death"
    }
  }, [_vm._v("Enter Age at Death (years)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_percentage_of_life"
    }
  }, [_vm._v("% of Normal Life Expectancy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_reduction_in_life"
    }
  }, [_vm._v("% Reduction in Normal Life Expectancy")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimants_assumed_dod_type')
    }
  }, [_vm._v("\n                        The claimant's assumed Date of Death is required\n                    ")])], 1), _vm._v(" "), (_vm.assumedLifeExpectancyMethod === 'assumed_age_at_death') ? _c('control', {
    attrs: {
      "for": "claimants_age_at_assumed_death",
      "label": "Claimant's Age at Assumed Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_age_at_death',
      "name": "claimants_age_at_assumed_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod === 'assumed_years_and_months_left') ? _c('control', {
    attrs: {
      "for": "claimants_assumed_years_left",
      "label": "Enter Years/Months From Today"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.yearsLeft),
      expression: "yearsLeft",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "years"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.yearsLeft = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, _vm._l((76), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v(_vm._s(year - 1) + " year(s)")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.monthsLeft),
      expression: "monthsLeft",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "months"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.monthsLeft = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                                    " + _vm._s(month - 1) + " month(s)\n                                ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod == 'assumed_percentage_of_life') ? _c('control', {
    attrs: {
      "label": "Percentage of Normal Life Expectancy",
      "for": "percentage_of_normal_life_expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy),
      expression: "innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.assumedLifeExpectancyMethod != 'assumed_percentage_of_life',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_of_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerAssumedLifeExpectancy, "percentageOfNormalLifeExpectancy", _vm._n($event.target.value))
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_of_normal_life_expectancy')
    }
  }, [_vm._v("\n                        The percentage of normal life expectancy must be number between 1 and 100\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod == 'assumed_reduction_in_life') ? _c('control', {
    attrs: {
      "label": "Percentage Reduction in Normal Life Expectancy",
      "for": "percentage_reduction_in_normal_life_expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy),
      expression: "innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.assumedLifeExpectancyMethod != 'assumed_reduction_in_life',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_reduction_in_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerAssumedLifeExpectancy, "percentageReductionInNormalLifeExpectancy", _vm._n($event.target.value))
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_reduction_in_normal_life_expectancy')
    }
  }, [_vm._v("\n                        The percentage reduction in normal life expectancy must be number between 1 and 100\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimants_assumed_date_of_death",
      "label": "Claimant's Assumed Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claimants_assumed_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "claimants_assumed_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_date'
    },
    on: {
      "input": _vm.updateAssumedLifeExpectancy
    },
    model: {
      value: (_vm.dateOfDeath),
      callback: function($$v) {
        _vm.dateOfDeath = $$v
      },
      expression: "dateOfDeath"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimants_assumed_date_of_death')
    }
  }, [_vm._v("\n                        The claimant's assumed date of death is required\n                    ")])], 1), _vm._v(" "), _c('life-expectancy', {
    attrs: {
      "label": "Claimant's 'But For' Life Expectancy",
      "person": _vm.claimant,
      "date": _vm.theDate,
      "assumed-settlement": _vm.getClaimantInfoValue('dateOfAssumedSettlement'),
      "type": "deceased",
      "stepValid": _vm.isValid()
    },
    on: {
      "update": _vm.updateLife
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "reduction_in_claimants_life_expectancy",
      "label": "Reduction in Claimant's Life Expectancy",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.claimantReductionInLife),
      expression: "claimantReductionInLife",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "name": "reduction_in_claimants_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.claimantReductionInLife)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReductionInLife = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.claimantReductionInLifeRules
    }
  }, [_vm._v("\n                        Reduction in Claimant's Life Expectancy must be greater than 0\n                    ")])], 1), _vm._v(" "), (_vm.assumedLifeExpectancyMethod !== 'assumed_age_at_death') ? _c('control', {
    attrs: {
      "for": "claimants_age_at_assumed_death",
      "label": "Claimant's Age at Assumed Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_age_at_death',
      "name": "claimants_age_at_assumed_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "period_between_onset_of_symptoms_and_assumed_dod",
      "label": "Period Between Onset of Symptoms and Assumed DOD",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.periodBetweenOnsetAndAssumedDod),
      expression: "periodBetweenOnsetAndAssumedDod",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "name": "period_between_onset_of_symptoms_and_assumed_dod",
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodBetweenOnsetAndAssumedDod)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.periodBetweenOnsetAndAssumedDod = _vm._n($event.target.value)
      }, _vm.updateReductionInLife],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_onset_of_symptoms",
      "label": "Claimant's Age at Onset of Symptoms",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtOnsetOfSymptoms),
      expression: "ageAtOnsetOfSymptoms",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "name": "age_at_onset_of_symptoms",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtOnsetOfSymptoms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtOnsetOfSymptoms = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-your-claims__table-container"
  }, [_c('div', {
    staticClass: "flex-grid flex-state-buttons"
  }, [_c('div', [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showInterest),
      expression: "showInterest"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showInterest) ? _vm._i(_vm.showInterest, null) > -1 : (_vm.showInterest)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showInterest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showInterest = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showInterest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showInterest = $$c
        }
      }, _vm.updateTotals]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Show Interest")])])])]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("General Damages (PSLA)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamages'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamages') - _vm.generalDamages)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('generalDamages'), _vm.generalDamages)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("General Damages (PSLA) - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamagesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages_interest",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamagesInterest),
      expression: "generalDamagesInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamagesInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamagesInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamagesWithInterest') - _vm.generalDamagesInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('generalDamagesWithInterest'), _vm.generalDamagesInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bereavement Award")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('bereavementAward'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_bereavement_award",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bereavementAward),
      expression: "bereavementAward",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.bereavementAward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bereavementAward = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('bereavementAward') - _vm.bereavementAward)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('bereavementAward'), _vm.bereavementAward)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Bereavement Award - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('bereavementAwardWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_bereavement_award",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bereavementAwardInterest),
      expression: "bereavementAwardInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.bereavementAwardInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.bereavementAwardInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('bereavementAwardWithInterest') - _vm.bereavementAwardInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('bereavementAwardWithInterest'), _vm.bereavementAwardInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Funeral Expenses")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpenses'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_funeral_expenses",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.funeralExpenses),
      expression: "funeralExpenses",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.funeralExpenses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.funeralExpenses = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpenses') - _vm.funeralExpenses)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('funeralExpenses'), _vm.funeralExpenses)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Funeral Expenses - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpensesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_funeral_expenses",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.funeralExpensesInterest),
      expression: "funeralExpensesInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.funeralExpensesInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.funeralExpensesInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpensesWithInterest') - _vm.funeralExpensesInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('funeralExpensesWithInterest'), _vm.funeralExpensesInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loss of Spouse")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouse'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_loss_of_spouse",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lossOfSpouse),
      expression: "lossOfSpouse",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lossOfSpouse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lossOfSpouse = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouse') - _vm.lossOfSpouse)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('lossOfSpouse'), _vm.lossOfSpouse)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Loss of Spouse - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouseWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_loss_of_spouse",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lossOfSpouseInterest),
      expression: "lossOfSpouseInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lossOfSpouseInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lossOfSpouseInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouseWithInterest') - _vm.lossOfSpouseInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('lossOfSpouseWithInterest'), _vm.lossOfSpouseInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarnings'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarnings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarnings = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarnings') - _vm.pastLossOfEarnings)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastLossOfEarnings'), _vm.pastLossOfEarnings)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings - Interest ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarningsWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarningsInterest),
      expression: "pastLossOfEarningsInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarningsInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarningsInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarningsWithInterest') - _vm.pastLossOfEarningsInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastLossOfEarningsWithInterest'), _vm.pastLossOfEarningsInterest)) + "%\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravel') - _vm.pastCostOfTravel)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastCostOfTravel'), _vm.pastCostOfTravel)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Travel - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravelWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravelInterest),
      expression: "pastCostOfTravelInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravelInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravelInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravelWithInterest') - _vm.pastCostOfTravelInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastCostOfTravelWithInterest'), _vm.pastCostOfTravelInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('misc'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('misc') - _vm.misc)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('misc'), _vm.misc)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Miscellaneous - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('miscWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.miscInterest),
      expression: "miscInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.miscInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.miscInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('miscWithInterest') - _vm.miscInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('miscWithInterest'), _vm.miscInterest)) + "%")])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.customHeadsOfLoss), function(custom) {
    return _c('custom-head-of-loss', {
      attrs: {
        "headOfLoss": custom,
        "index": _vm.index,
        "showInterest": _vm.showInterest
      },
      on: {
        "update": _vm.updateTotals
      }
    })
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCare),
      expression: "pastCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCare = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCare') - _vm.pastCostOfCare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastCostOfCare'), _vm.pastCostOfCare)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Care - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCareWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCareInterest),
      expression: "pastCostOfCareInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCareInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCareInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCareWithInterest') - _vm.pastCostOfCareInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastCostOfCareWithInterest'), _vm.pastCostOfCareInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Dependency on Income")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnIncome'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastDependencyOnIncome),
      expression: "pastDependencyOnIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastDependencyOnIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastDependencyOnIncome = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnIncome') - _vm.pastDependencyOnIncome)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastDependencyOnIncome'), _vm.pastDependencyOnIncome)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Dependency on Income - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnIncomeWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastDependencyOnIncomeInterest),
      expression: "pastDependencyOnIncomeInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastDependencyOnIncomeInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastDependencyOnIncomeInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnIncomeWithInterest') - _vm.pastDependencyOnIncomeInterest)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastDependencyOnIncomeWithInterest'), _vm.pastDependencyOnIncomeInterest)) + "%\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Dependency on Income")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.incomePost)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureDependencyOnIncome),
      expression: "futureDependencyOnIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureDependencyOnIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureDependencyOnIncome = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.incomePost - _vm.futureDependencyOnIncome)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.incomePost, _vm.futureDependencyOnIncome)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Dependency on Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnServices'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastDependencyOnServices),
      expression: "pastDependencyOnServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastDependencyOnServices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastDependencyOnServices = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnServices') - _vm.pastDependencyOnServices)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastDependencyOnServices'), _vm.pastDependencyOnServices)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Dependency on Services - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnServicesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastDependencyOnServicesInterest),
      expression: "pastDependencyOnServicesInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastDependencyOnServicesInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastDependencyOnServicesInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnServicesWithInterest') - _vm.pastDependencyOnServicesInterest)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.roundAndPercent(_vm.headOfLoss('pastDependencyOnServicesWithInterest'), _vm.pastDependencyOnServicesInterest)) + "%\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Dependency on Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.servicePost)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureDependencyOnServices),
      expression: "futureDependencyOnServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureDependencyOnServices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureDependencyOnServices = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.servicePost - _vm.futureDependencyOnServices)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.servicePost, _vm.futureDependencyOnServices)) + "%")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headsOfLossTotal)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.dependantsHeadsOfLossTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.differenceTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headsOfLossTotal, _vm.dependantsHeadsOfLossTotal)) + "%")])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Defendant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Claimant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])]), _vm._v(" "), _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Percentage")])])])])
}]}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Care — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('modal-content')], 1)
},staticRenderFns: []}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--wrap a-form-inputs",
    on: {
      "change": _vm.updateValid
    }
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "discount_rate",
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('discount_rate')
    }
  }, [_vm._v("\n                        Discount rate is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "name": "description_of_services",
      "label": "Description of Service"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.descriptionOfService),
      expression: "service.descriptionOfService"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "description_of_services",
      "maxlength": "100",
      "id": "description_of_services",
      "type": "text"
    },
    domProps: {
      "value": (_vm.service.descriptionOfService)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "descriptionOfService", $event.target.value)
      }, _vm.update]
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "multiplicand",
      "label": "Multiplicand",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.multiplicand),
      expression: "service.multiplicand",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "required": "",
      "name": "multiplicand"
    },
    domProps: {
      "value": (_vm.service.multiplicand)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "multiplicand", _vm._n($event.target.value))
      }, _vm.update],
      "blur": [function($event) {
        _vm.service.multiplicand = _vm.service.multiplicand || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('multiplicand')
    }
  }, [_vm._v("\n                        The multiplicand is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "duration_type",
      "label": "Dependency for life"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationMask),
      expression: "durationMask"
    }],
    attrs: {
      "name": "duration_type",
      "id": "duration_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.durationMask = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), (!_vm.durationMask) ? _c('control', {
    attrs: {
      "label": "Duration of Dependency",
      "for": "method1"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.durationType),
      expression: "service.durationType"
    }],
    attrs: {
      "id": "method1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.service, "durationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "years_and_months"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "age"
    }
  }, [_vm._v("Enter Age at End of Dependency")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "date"
    }
  }, [_vm._v("Enter Date")])])]) : _vm._e(), _vm._v(" "), (_vm.service.durationType == 'years_and_months') ? _c('control', {
    attrs: {
      "label": "Enter Years/Months From the Start of Dependency"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.years),
      expression: "service.years",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "years"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.service, "years", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, _vm._l((51), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v(_vm._s(year - 1) + " year(s)")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.months),
      expression: "service.months",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "months"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.service, "months", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                                    " + _vm._s(month - 1) + " month(s)\n                                ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.service.durationType == 'age') ? _c('control', {
    attrs: {
      "label": "Age at end of Dependency",
      "for": "age_at_end",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.age),
      expression: "service.age",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "required": "",
      "min": "20",
      "name": "age_at_end",
      "type": "number"
    },
    domProps: {
      "value": (_vm.service.age)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "age", _vm._n($event.target.value))
      }, _vm.update],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "services_end_of_dependency",
      "label": "End of Dependency"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:services_end_of_dependency.required",
      value: ({
        type: 'date',
        rules: _vm.servicesEndOfDependencyRules
      }),
      expression: "{type:'date', rules:servicesEndOfDependencyRules}",
      arg: "services_end_of_dependency",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.service.durationType != 'date'
    },
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.service.toDate),
      callback: function($$v) {
        _vm.$set(_vm.service, "toDate", $$v)
      },
      expression: "service.toDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('services_end_of_dependency')
    }
  }, [_vm._v("\n                                End of Dependency is required, must be in the format DD/MM/YYYY, cannot be after the\n                                Deceased's End of Dependency (" + _vm._s(_vm.theDeceased.lifeExpectancy.dateOfDeath) + ")\n                                nor before the Deceased's Date of Death (" + _vm._s(_vm.theDeceased.dateOfDeath) + ")\n                            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("for")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--years"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.duration),
      expression: "service.duration"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "field-control",
      rawName: "v-field-control:duration.required",
      value: ({
        type: 'number'
      }),
      expression: "{type:'number'}",
      arg: "duration",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": _vm.service.durationType == 'life',
      "name": "duration",
      "min": "0"
    },
    domProps: {
      "value": (_vm.service.duration)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "duration", $event.target.value)
      }, _vm.update]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('duration')
    }
  }, [_vm._v("\n                                Length of Dependency is required and must be at least one year\n                            ")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Select Ogden Table"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountTable),
      expression: "discountTable"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountTable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Table 1 or 2")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 28
    }
  }, [_vm._v("Table 36")])])]), _vm._v(" "), (_vm.service.discountTable === 1) ? _c('control', {
    attrs: {
      "label": _vm.table1Or2Label,
      "for": "ogden_table_multiplier"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.dependencyOnIncome.table1Or2Multiplier
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.service.discountTable === 28) ? _c('control', {
    attrs: {
      "label": "Ogden Table 36 Multiplier",
      "for": "ogden_table_multiplier"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.service.ogdenTableTwentyEight
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "ogden_table_e_pre_assessment",
      "label": "Ogden Table E Pre-Assessment Discount",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_e_pre_assessment",
      "modal-name": 'services_' + _vm.uniqueId,
      "endpoint": 'pre',
      "payload": _vm.preAndPostAssessmentPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "ogden_table_e_pre_assessment",
      "name": "ogden_table_e_pre_assessment",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.service.ogdenTableE
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "ogden_table_f_pre_assessment",
      "label": "Ogden Table F Post-Assessment Discount",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_f_pre_assessment",
      "modal-name": 'services_' + _vm.uniqueId,
      "endpoint": 'post',
      "payload": _vm.preAndPostAssessmentPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "ogden_table_f_pre_assessment",
      "name": "ogden_table_f_pre_assessment",
      "disabled": ""
    },
    domProps: {
      "value": _vm.service.ogdenTableF
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      'a-loader--total': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('control', {
    attrs: {
      "for": "calculated_services",
      "label": "Calculated Services",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "min": "0.00",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.calculatedServices, '')
    }
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisService
    }
  }, [_vm._v("Delete Service")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addService
    }
  }, [_vm._v("Add Service")])])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('div', {
    class: {
      'a-loader--table': _vm.servicesTableUpdating()
    }
  }), _vm._v(" "), (_vm.table && _vm.table.pre && _vm.table.post && !_vm.servicesTableUpdating()) ? _c('table', {
    staticClass: "a-table a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Pre-Assessment period")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.pre.multiplier, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.table.pre.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.pre.multiplier, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.pre.discount, 3)))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.roundValue(_vm.table.pre.discount, 3)) + " x " + _vm._s(_vm.roundValue(_vm.table.pre.duration, 3)) + " =\n                    " + _vm._s(_vm.roundValue(_vm.table.pre.discount * _vm.table.pre.multiplier, 3)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.table.pre.dependencyValue)))])]), _vm._v(" "), (_vm.table.post.multiplier > 0) ? _c('tr', [_c('td', [_vm._v("Post-Assessment period")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.post.duration, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.table.post.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.post.multiplier, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.post.discount, 3)))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.roundValue(_vm.table.post.discount, 3)) + " x " + _vm._s(_vm.roundValue(_vm.table.post.multiplier, 3)) + " =\n                    " + _vm._s(_vm.roundValue(_vm.table.post.discount * _vm.table.post.multiplier, 3)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.table.post.dependencyValue)))])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'services_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Dependency Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), _c('th', [_vm._v("Discounted Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Dependency Value")])])])
}]}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-compare-reserve__average-diff-table"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('tr', [_c('th', [_vm._v("\n                " + _vm._s(_vm.headingLabels.from) + " vs " + _vm._s(_vm.headingLabels.to) + "\n            ")]), _vm._v(" "), _c('th', [_vm._v("\n                Amount (£)\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-align-items"
  }, [_c('span', {
    staticClass: "u-margin-right-10",
    style: ('background: ' + _vm.colours[0])
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.fromLabel))])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.currencyFormat(_vm.averageFrom)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-align-items"
  }, [_c('span', {
    staticClass: "u-margin-right-10",
    style: ('background: ' + _vm.colours[1])
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.toLabel))])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.currencyFormat(_vm.averageTo)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-align-items"
  }, [_c('span', {
    staticClass: "u-margin-right-10",
    style: ('background: ' + _vm.colours[2])
  }), _vm._v(" "), _c('div', [_vm._v("Difference")])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.currencyFormat(Math.abs(_vm.difference))))]), _vm._v(" "), _c('div', {
    staticClass: "p-compare-reserve__average-diff-table--percent"
  }, [_vm._v("\n                    ("), _c('span', [_vm._v(_vm._s(_vm.roundValue(_vm.differencePercent)) + "% average difference")]), _vm._v(")\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of Care\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "title": "Past Cost of Care",
      "subtitle": "Attendance Allowance",
      "store-key": "pcocAttendanceAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Care",
      "subtitle": "Disability Living Allowance (care component)",
      "store-key": "pcocDisabilityLivingAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Care",
      "subtitle": "Industrial Injuries Disablement Benefit increase for Constant Attendance Allowance or Exceptionally Severe Disablement Allowance",
      "store-key": "pcocIndustrialInjuriesDisablementBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Cost of Care",
      "subtitle": "Personal Independence Payment (living component)",
      "store-key": "pcocPersonalIndependencePayment",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.child) ? _c('div', [_c('control', {
    attrs: {
      "label": "Child Dependency Until",
      "for": "method"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerLifeExpectancy.method),
      expression: "innerLifeExpectancy.method"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "method",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerLifeExpectancy, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcChildDependentAge]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependent_until_16"
    }
  }, [_vm._v("Aged 16")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependent_until_18"
    }
  }, [_vm._v("Aged 18")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependent_until_21"
    }
  }, [_vm._v("Aged 21")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependent_until_custom"
    }
  }, [_vm._v("Specify custom dependency")])])]), _vm._v(" "), (_vm.innerLifeExpectancy.method === 'dependent_until_custom') ? _c('control', {
    attrs: {
      "label": "Age Dependency Ends",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerLifeExpectancy.child.youthCutOffAge),
      expression: "innerLifeExpectancy.child.youthCutOffAge"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerLifeExpectancy.child.youthCutOffAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerLifeExpectancy.child, "youthCutOffAge", $event.target.value)
      }, _vm.calcChildDependentDate]
    }
  })]) : _vm._e()], 1) : _c('div', [_c('control', {
    attrs: {
      "label": _vm.label,
      "for": "method1",
      "icon-space": !_vm.dayOne
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerLifeExpectancy.method),
      expression: "innerLifeExpectancy.method"
    }],
    attrs: {
      "id": "method1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerLifeExpectancy, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcAgeAtDeath]
    }
  }, [(this.person.gender === null) ? _c('option', {
    attrs: {
      "value": "ogden_table",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]) : _vm._e(), _vm._v(" "), (this.person.gender === 'male') ? _c('option', {
    attrs: {
      "value": "ogden_table"
    }
  }, [_vm._v("Odgen Table 1")]) : _vm._e(), _vm._v(" "), (this.person.gender === 'female') ? _c('option', {
    attrs: {
      "value": "ogden_table"
    }
  }, [_vm._v("Odgen Table 2")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "years_and_months"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "enter_date"
    }
  }, [_vm._v("Enter Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "age_at_death"
    }
  }, [_vm._v("Enter Age At Death (years)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percentage_of_normal_life_expectancy"
    }
  }, [_vm._v("% of Normal Life Expectancy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percentage_reduction_in_normal_life_expectancy"
    }
  }, [_vm._v("% Reduction in Normal Life Expectancy")])])]), _vm._v(" "), (_vm.innerLifeExpectancy.method == 'years_and_months') ? _c('control', {
    attrs: {
      "label": "Enter Years/Months From Today",
      "icon-space": !_vm.dayOne
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerLifeExpectancy.yearsAndMonths.years),
      expression: "innerLifeExpectancy.yearsAndMonths.years",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "years"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.innerLifeExpectancy.yearsAndMonths, "years", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcAgeAtDeath]
    }
  }, _vm._l((76), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v(_vm._s(year - 1) + " year(s)")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerLifeExpectancy.yearsAndMonths.months),
      expression: "innerLifeExpectancy.yearsAndMonths.months",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "months"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.innerLifeExpectancy.yearsAndMonths, "months", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcAgeAtDeath]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                            " + _vm._s(month - 1) + " month(s)\n                        ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.innerLifeExpectancy.method == 'percentage_of_normal_life_expectancy') ? _c('control', {
    attrs: {
      "label": "Percentage of Normal Life Expectancy",
      "for": "percentage_of_normal_life_expectancy",
      "before-after": "percent",
      "icon-space": !_vm.dayOne
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.percentageOfNormalLifeExpectancy),
      expression: "percentageOfNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.innerLifeExpectancy.method !== 'percentage_of_normal_life_expectancy',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_of_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentageOfNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.percentageOfNormalLifeExpectancy = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_of_normal_life_expectancy')
    }
  }, [_vm._v("\n                The percentage of normal life expectancy must be number between 1 and 100\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.innerLifeExpectancy.method == 'percentage_reduction_in_normal_life_expectancy') ? _c('control', {
    attrs: {
      "label": "Percentage Reduction in Normal Life Expectancy",
      "for": "percentage_reduction_in_normal_life_expectancy",
      "icon-space": !_vm.dayOne,
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.percentageReductionInNormalLifeExpectancy),
      expression: "percentageReductionInNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.innerLifeExpectancy.method !== 'percentage_reduction_in_normal_life_expectancy',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_reduction_in_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentageReductionInNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.percentageReductionInNormalLifeExpectancy = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_reduction_in_normal_life_expectancy')
    }
  }, [_vm._v("\n                The percentage reduction in normal life expectancy must be number between 1 and 100\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.innerLifeExpectancy.method == 'enter_date') ? _c('control', {
    attrs: {
      "label": "Expected End of Life Date",
      "for": "expected_date_of_death",
      "icon-space": !_vm.dayOne
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:expected_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "expected_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.innerLifeExpectancy.method != 'enter_date'
    },
    on: {
      "input": _vm.calcAgeAtDeath
    },
    model: {
      value: (_vm.innerLifeExpectancy.dateOfDeathIsAssumed),
      callback: function($$v) {
        _vm.$set(_vm.innerLifeExpectancy, "dateOfDeathIsAssumed", $$v)
      },
      expression: "innerLifeExpectancy.dateOfDeathIsAssumed"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('expected_date_of_death')
    }
  }, [_vm._v("\n                The deceased's expected end of life is required and must be in the format DD/MM/YYYY\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Expected Age at End of Life (Years)",
      "for": "life_age_at_death",
      "icon-space": !_vm.dayOne,
      "modal-name": 'life_age_at_death_modal_' + _vm.uniqueId,
      "endpoint": _vm.innerLifeExpectancy.method,
      "payload": _vm.lifeExpectancyModal,
      "tip-icon": _vm.lifeAgeAtDeathIcon,
      "tip-show": _vm.stepValid,
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "life_age_at_death",
      "before-after": _vm.dayOne ? 'years-old-on-dark' : 'years-old'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.innerLifeExpectancy.method !== 'age_at_death',
      "required": "",
      "min": "20",
      "name": "life_age_at_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.innerLifeExpectancy.method !== 'enter_date') ? _c('control', {
    attrs: {
      "label": "Expected End of Life Date",
      "for": "life_date_of_death",
      "icon-space": !_vm.dayOne
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "life_date_of_death",
      "disabled": "",
      "required": ""
    },
    domProps: {
      "value": _vm.dateOfDeath
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('life_date_of_death') &&
        (_vm.innerLifeExpectancy.method == 'percentage_reduction_in_normal_life_expectancy' ||
          _vm.innerLifeExpectancy.method == 'percentage_of_normal_life_expectancy')
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'life_age_at_death_modal_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('h1', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('table', {
    staticClass: "a-table",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                Age\n            ")]), _vm._v(" "), _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.selectColumn(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(header) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.ageRange), function(number, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index > index ? index + 1 : number))]), _vm._v(" "), _vm._l((_vm.eachTableAvailable), function(value) {
      return _c('td', {
        class: {
          'disabled': !value[index]
        }
      }, [_vm._v("\n                    " + _vm._s(value[index]) + "\n                ")])
    })], 2)
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid m-div-table__holder-section"
  }, [_c('div', {
    staticClass: "flex-grid__g-3 hide"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Benefit Amount")]), _vm._v(" "), _c('control', {
    attrs: {
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.amount),
      expression: "amount",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number'
      }),
      expression: "{type: 'number'}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "min": "0.00",
      "name": _vm.fieldName + '_value',
      "type": "number"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.amount = _vm.amount || ''
      },
      "blur": [function($event) {
        _vm.amount = _vm.amount || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error(_vm.fieldName + '_value')
    }
  }, [_vm._v("\n                The amount cannot be below 0 and must be a number.\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Deduction")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.include),
      expression: "include"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.include = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    class: {
      'flex-grid--vertical': !_vm.isValid
    },
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Inflation Calculator",
      "icon": "inflation-calculator"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "amount",
      "label": "Amount",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "amount",
    attrs: {
      "autocomplete": "off",
      "min": "1",
      "before-after": "pound",
      "type": "text"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.amount = _vm.amount || ''
      },
      "blur": function($event) {
        _vm.amount = _vm.amount || 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('amount')
    }
  }, [_vm._v("\n                    The amount must be at least £1.00\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date From"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minYear),
      expression: "minYear"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.minYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._l((_vm.rpiYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minMonth),
      expression: "minMonth"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.minMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.monthToString(month)) + "\n                            ")])
  })], 2)])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date To"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxYear),
      expression: "maxYear"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maxYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._l((_vm.toYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxMonth),
      expression: "maxMonth"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maxMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._l((_vm.toMonths), function(month) {
    return _c('option', {
      domProps: {
        "value": month
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.monthToString(month)) + "\n                            ")])
  })], 2)])]), _vm._v(" "), _c('control-error', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toMonths.length === 0),
      expression: "toMonths.length === 0"
    }]
  }, [_vm._v("\n                    Date To must be after Date From\n                ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isValid),
      expression: "isValid"
    }]
  }, [_c('h2', [_vm._v("\n                    Result\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": _vm.monthToString(_vm.minMonth) + ' ' + _vm.minYear,
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.amount, '')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": _vm.monthToString(_vm.maxMonth) + ' ' + _vm.maxYear,
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.equivalent, '')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Difference",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.difference, '')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Difference",
      "before-after": "percent-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.percentageDifference(_vm.amount, _vm.equivalent)
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('p', [_vm._v("\n                The inflation calculator can be used to show how the cost of goods and services\n                has changed over time.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Using the Retail Price Index (RPI) data sourced from the Office For National Statistics (ONS),\n                the calculator has determined that\n                " + _vm._s(_vm.currencyFormat(_vm.amount)) + " in " + _vm._s(_vm.monthToString(_vm.minMonth)) + " " + _vm._s(_vm.minYear) + "\n                would be the equivalent of\n                " + _vm._s(_vm.currencyFormat(_vm.equivalent)) + " in " + _vm._s(_vm.monthToString(_vm.maxMonth)) + " " + _vm._s(_vm.maxYear) + ".\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                That's a difference of " + _vm._s(_vm.currencyFormat(_vm.difference)) + "\n                (" + _vm._s(_vm.roundValue(_vm.percentageDifference(_vm.equivalent, _vm.amount), 2)) + "%)\n                during the period of " + _vm._s(_vm.startToEnd) + "."), _c('br'), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n                Visual comparison of inflation applied to " + _vm._s(_vm.currencyFormat(_vm.amount)) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": _vm.barValues
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.monthToString(_vm.minMonth)) + " " + _vm._s(_vm.minYear))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.monthToString(_vm.maxMonth)) + " " + _vm._s(_vm.maxYear))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Calculation")]), _vm._v(" "), _c('p', [_vm._v("\n                The value of inflation was calculated using the following formula:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                        ([£ Value] / [RPI @ Start]) x [RPI @ End] = [£ Value at End]\n                    ")])])]), _vm._v(" "), _c('p', [_vm._v("\n                Which was populated with the RPI data sourced from the ONS to determine the value:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula u-margin-bottom-20"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                        ( " + _vm._s(_vm.currencyFormat(_vm.amount)) + " / " + _vm._s(_vm.getRpiForDate(_vm.minYear, _vm.minMonth)) + " ) x " + _vm._s(_vm.getRpiForDate(_vm.maxYear, _vm.maxMonth)) + " = " + _vm._s(_vm.currencyFormat(_vm.equivalent)) + "\n                    ")])])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Payment ' + (_vm.index + 1) + ' Date',
      "no-flex-margin": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "date",
      "required": ""
    },
    on: {
      "input": _vm.updateInterest
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidDate() || _vm.$error('date')
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY and must be after the claimant's\n            onset of symptoms " + _vm._s(_vm.onsetOfSymptoms) + "\n        ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isBeforeInterestDate()
    }
  }, [_vm._v("\n            Date must be before interest date (" + _vm._s(_vm.interestDate) + ")\n        ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Amount",
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "max": _vm.remainingTotal,
      "min": "1",
      "name": "value",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": [function($event) {
        _vm.value = _vm.value || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = _vm._n($event.target.value)
      }, _vm.updateInterest]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            The amount must be at least £1.00 and less than the total past heads of loss\n            " + _vm._s(_vm.currencyFormat(_vm.getHeadsOfLossTotalMinusInterest)) + " - remaining total " + _vm._s(_vm.currencyFormat(_vm.remainingTotal)) + "\n        ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisPayment
    }
  }, [_vm._v("Delete This Payment")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Payment ' + (_vm.index + 1) + ' Date',
      "no-flex-margin": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "date",
      "required": ""
    },
    on: {
      "input": _vm.updateInterest
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidDate() || _vm.$error('date')
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY, be after the deceased's date of death\n            (" + _vm._s(_vm.deceasedDod) + ") and be before the interest calculation date\n        ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Amount",
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "max": _vm.remainingTotal,
      "min": "1",
      "name": "value",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = _vm._n($event.target.value)
      }, _vm.updateInterest],
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": [function($event) {
        _vm.value = _vm.value || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            The amount must be at least £1.00 and less than the total past heads of loss \n            remaining total " + _vm._s(_vm.currencyFormat(_vm.remainingTotal)) + "\n        ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisPayment
    }
  }, [_vm._v("Delete This Payment")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        General Damages — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('psla-modal-content', {
    attrs: {
      "duration": _vm.duration,
      "age": _vm.age,
      "value": _vm.value
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-discount-rate-comparison__discount-select"
  }, [_c('div', {
    staticClass: "u-margin-top-20 u-margin-bottom-10 u-bold"
  }, [_vm._v("\n        Discount Rates (please select a maximum of two)\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin flex-grid--wrap u-r-flex-direction-row"
  }, _vm._l((_vm.discountRates), function(discount, index) {
    return _c('div', {
      staticClass: "a-checkbox a-checkbox--label-above"
    }, [_c('input', {
      attrs: {
        "autocomplete": "off",
        "type": "checkbox",
        "disabled": _vm.disableRate(discount)
      },
      domProps: {
        "value": discount,
        "checked": _vm.checkedRate(discount)
      },
      on: {
        "click": _vm.toggle
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "text"
      }
    }, [_vm._v(_vm._s(discount + '%'))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [(!this.retired || this.lossOfEarnings) ? _c('td', [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'date',
        name: 'startOfPeriod' + _vm.index
      }),
      expression: "{type:'date', name:'startOfPeriod' + index}",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "required": "",
      "emit": true
    },
    on: {
      "input": function($event) {
        return _vm.updateNextPeriod()
      }
    },
    model: {
      value: (_vm.innerPeriod.startOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.innerPeriod, "startOfPeriod", $$v)
      },
      expression: "innerPeriod.startOfPeriod"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!this.retired || this.lossOfEarnings) ? _c('td', [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'date',
        name: 'endOfPeriod' + _vm.index
      }),
      expression: "{type:'date', name:'endOfPeriod' + index}",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "required": "",
      "emit": true
    },
    on: {
      "input": function($event) {
        return _vm.updateNextPeriod()
      }
    },
    model: {
      value: (_vm.innerPeriod.endOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.innerPeriod, "endOfPeriod", $$v)
      },
      expression: "innerPeriod.endOfPeriod"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentType),
      expression: "innerPeriod.employmentType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "not_employed"
    }
  }, [_vm._v("Not employed")])])]) : _vm._e(), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.employmentIncome),
      expression: "innerPeriod.employmentIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'employmentIncome' + _vm.index
      }),
      expression: "{type:'number', name:'employmentIncome' + index}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.innerPeriod.employmentIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "employmentIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePeriod()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentNetGross),
      expression: "innerPeriod.employmentNetGross"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])]) : _vm._e(), _vm._v(" "), (_vm.retired && _vm.type === 'past') ? _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.employmentIncome),
      expression: "innerPeriod.employmentIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'employmentIncome' + _vm.index
      }),
      expression: "{type:'number', name:'employmentIncome' + index}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.innerPeriod.employmentIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "employmentIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePeriod()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]) : _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.pensionIncome),
      expression: "innerPeriod.pensionIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'pensionIncome' + _vm.index
      }),
      expression: "{type:'number', name:'pensionIncome' + index}",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.innerPeriod.pensionIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "pensionIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePeriod()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), (_vm.retired && _vm.type === 'past') ? _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentNetGross),
      expression: "innerPeriod.employmentNetGross"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])]) : _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.pensionNetGross),
      expression: "innerPeriod.pensionNetGross"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "pensionNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])]), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.totalGrossIncome),
      expression: "innerPeriod.totalGrossIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.totalGrossIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "totalGrossIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.totalNetIncome),
      expression: "innerPeriod.totalNetIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.totalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "totalNetIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), (this.index === 0) ? _c('td', [_c('div', {
    class: {
      'a-loader--total': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "a-button a-button--delete a-button--delete-disabled a-button--small",
    attrs: {
      "role": "button",
      "type": "button",
      "disabled": "disabled"
    }
  }) : _vm._e()]) : _c('td', [_c('div', {
    class: {
      'a-loader--total': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "a-button a-button--delete a-button--small",
    attrs: {
      "role": "button",
      "type": "button"
    },
    on: {
      "click": _vm.deletePeriod
    }
  }) : _vm._e()])]), _vm._v(" "), (!_vm.startOfPeriodRules || !_vm.endOfPeriodRules) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": !_vm.retired ? 10 : 6
    }
  }, [_c('control-error', {
    attrs: {
      "show": !_vm.startOfPeriodRules
    }
  }, [_vm._v("\n                The income period start date must be a valid date, can not be before the claimant's onset of symptoms and\n                cannot be after the claimants's "), (this.type === 'past') ? _c('span', [_vm._v("assumed settlement")]) : _c('span', [_vm._v("'but for' date of death")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.endOfPeriodRules
    }
  }, [_vm._v("\n                The income period end date must be a valid date, can not be before the claimant's onset symptoms of and\n                cannot be after the claimants's "), (this.type === 'past') ? _c('span', [_vm._v("assumed settlement")]) : _c('span', [_vm._v("'but for' date of death")])])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "BC Legal - ABC Quantum",
      "set-position": "fixed",
      "current": this.current,
      "load-button": true,
      "save-button": true,
      "create-button": true,
      "set-border": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie u-position-relative",
    attrs: {
      "id": "app"
    }
  }, [(_vm.isVisible()) ? _c('div', [_c('timeline', {
    attrs: {
      "steps": this.steps,
      "current": this.current,
      "stepNo": this.stepNo,
      "timeline-steps": "nine"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content__mob-main-column"
  }, [_c('router-view')], 1)], 1) : _c('div', {
    staticClass: "a-loader--big__container"
  }, [_c('div', {
    staticClass: "a-loader--big"
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-compare-reserve__claim-table"
  }, [_c('p', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "label": "Include In Table"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableFilter),
      expression: "tableFilter"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tableFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inside"
    }
  }, [_vm._v("Inside Set Limit")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "outside"
    }
  }, [_vm._v("Outside Set Limit")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "under"
    }
  }, [_vm._v("Under Set Limit")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "over"
    }
  }, [_vm._v("Above Set Limit")])])])], 1), _vm._v(" "), _c('p', [_vm._v("\n        Your results have been further filtered to "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.tableClaims.length))]), _vm._v("\n        based on your percentile selection.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.fromLabel))])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.toLabel))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('tbody', _vm._l((_vm.claims), function(claim) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(claim.reference))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(claim.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(claim.to)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(claim.claimHandler))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(Math.abs(claim.difference))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayPercent(claim.percent)))])])
  }), 0)])]), _vm._v(" "), _c('paginator', {
    attrs: {
      "pageNumbers": _vm.pageNumbers,
      "pageNo": _vm.pageNo
    },
    on: {
      "change": _vm.changePage
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Claim Reference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Claim Handler")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("%")])])])
}]}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('control', {
    attrs: {
      "label": "Discount Rate Options"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DiscountRatesOptions),
      expression: "DiscountRatesOptions"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.DiscountRatesOptions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "apply"
    }
  }, [_vm._v("Apply New Discount Rate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "applyGenerate"
    }
  }, [_vm._v("Apply New Discount Rate & Generate Documents")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "generate"
    }
  }, [_vm._v("Generate Documents with New Discount Rate")])])])
},staticRenderFns: []}

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-step-buttons"
  }, [_c('div', {
    staticClass: "c-step-buttons--loader"
  }, [_c('div', {
    class: [_vm.running ? 'a-loader a-loader--step-button' : '']
  })]), _vm._v(" "), _c('div', {
    staticClass: "step-button flex-state-buttons"
  }, [_c('button', {
    staticClass: "a-button",
    class: !_vm.prevValid ? 'disabled' : '',
    attrs: {
      "disabled": !_vm.prevValid
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n            Back\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [!_vm.nextValid || _vm.running ? 'disabled' : ''],
    attrs: {
      "disabled": !_vm.nextValid || _vm.running
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("\n            Next\n        ")])]), _vm._v(" "), _c('br')])
},staticRenderFns: []}

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.dependants), function(dependant, index) {
    return _c('div', {
      staticClass: "dependant"
    }, [_c('dependant', {
      attrs: {
        "index": index,
        "stepValid": _vm.isValid()
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button u-margin-top-0 u-margin-bottom-0",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Add Dependant")])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "general_damages_psla",
      "label": "General Damages (PSLA)",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:general_damages_psla.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "general_damages_psla",
      modifiers: {
        "valid": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "general_damages_psla",
      "id": "general_damages_psla",
      "step": "0.01",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "focus": function($event) {
        _vm.generalDamages = _vm.generalDamages || ''
      },
      "blur": [function($event) {
        _vm.generalDamages = _vm.generalDamages || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), (_vm.diseaseType === 'Mesothelioma') ? _c('span', {
    staticClass: "a-form-inputs--help"
  }, [_vm._v("\n                        Damages can be calculated using the calculator available\n                        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleGeneralDamagesPslaModal()
      }
    }
  }, [_vm._v("\n                            here\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "funeral_expenses",
      "label": "Funeral Expenses",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.funeralExpenses),
      expression: "funeralExpenses",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:funeral_expenses.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "funeral_expenses",
      modifiers: {
        "valid": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "number",
    attrs: {
      "autocomplete": "off",
      "min": "0",
      "name": "funeral_expenses",
      "type": "number"
    },
    domProps: {
      "value": (_vm.funeralExpenses)
    },
    on: {
      "focus": function($event) {
        _vm.funeralExpenses = _vm.funeralExpenses || ''
      },
      "blur": [function($event) {
        _vm.funeralExpenses = _vm.funeralExpenses || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.funeralExpenses = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('funeral_expenses')
    }
  }, [_vm._v("\n                        Funeral expenses should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "loss_of_spouse",
      "label": "Loss of Spouse",
      "before-after": "pound",
      "tip-icon": "info",
      "tip-text": "Click to view information",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "loss_of_spouse_award",
      "modal-name": 'lossOfSpouse'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lossOfSpouse),
      expression: "lossOfSpouse",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:loss_of_spouse.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "loss_of_spouse",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "loss_of_spouse",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lossOfSpouse)
    },
    on: {
      "focus": function($event) {
        _vm.lossOfSpouse = _vm.lossOfSpouse || ''
      },
      "blur": [function($event) {
        _vm.lossOfSpouse = _vm.lossOfSpouse || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lossOfSpouse = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('loss_of_spouse')
    }
  }, [_vm._v("\n                        Loss of spouse should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_cost_of_travel",
      "label": "Past Cost of Travel",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:past_cost_of_travel.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "past_cost_of_travel",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "past_cost_of_travel",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "focus": function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || ''
      },
      "blur": [function($event) {
        _vm.pastCostOfTravel = _vm.pastCostOfTravel || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('past_cost_of_travel')
    }
  }, [_vm._v("\n                        Past cost of travel should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "miscellaneous_costs",
      "label": "Miscellaneous - Medication, Appliances, Additional Food & Energy Costs",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:miscellaneous_costs.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "miscellaneous_costs",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "miscellaneous_costs",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "focus": function($event) {
        _vm.misc = _vm.misc || ''
      },
      "blur": [function($event) {
        _vm.misc = _vm.misc || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      }, _vm.calcInterestValue]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('miscellaneous_costs')
    }
  }, [_vm._v("\n                        Miscellaneous should be greater than £0.00\n                    ")])], 1), _vm._v(" "), _vm._l((_vm.headsOfLoss.length), function(index) {
    return _c('div', [_c('head-of-loss', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin u-r-margin-top-20 u-r-margin-bottom-20",
    on: {
      "click": _vm.addNewHeadOfLoss
    }
  }, [_vm._v("\n                    Add Another Head of Loss\n                ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Past Loss of Earnings",
      "tip-text": "You have two options to assess the past loss of earnings claim — click the help icon to find out more.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "200",
      "tip-name": "pastLossOfEarnings",
      "modalName": "pastLossOfEarningsModal"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastLossOfEarningsType),
      expression: "pastLossOfEarningsType"
    }],
    attrs: {
      "id": "pastLossOfEarningsType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pastLossOfEarningsType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])])]), _vm._v(" "), (_vm.pastLossOfEarningsType === 'own') ? _c('control', {
    attrs: {
      "for": "ownPastLossOfEarningsFigure",
      "label": "Enter Your Own Figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ownPastLossOfEarningsFigure),
      expression: "ownPastLossOfEarningsFigure",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:ownPastLossOfEarningsFigure.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "ownPastLossOfEarningsFigure",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "ownPastLossOfEarningsFigure",
      "min": "0.00"
    },
    domProps: {
      "value": (_vm.ownPastLossOfEarningsFigure)
    },
    on: {
      "focus": function($event) {
        _vm.ownPastLossOfEarningsFigure = _vm.ownPastLossOfEarningsFigure || ''
      },
      "blur": [function($event) {
        _vm.ownPastLossOfEarningsFigure = _vm.ownPastLossOfEarningsFigure || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ownPastLossOfEarningsFigure = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('ownPastLossOfEarningsFigure')
    }
  }, [_vm._v("\n                        Your own past loss of earnings figure should be greater than £0.00\n                    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.pastLossOfEarningsPeriods.length), function(index) {
    return (_vm.pastLossOfEarningsType === 'manual') ? _c('div', [_c('earnings-period', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.pastLossOfEarningsPeriods.length >= 0 && _vm.pastLossOfEarningsType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": _vm.addLossOfEarningsPeriod
    }
  }, [_vm._v("\n                    Add Period\n                ")]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "label": "Past Loss of Earnings Total",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.findValue('pastLossOfEarnings'), '')
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "u-margin-top-40 u-r-margin-top-0"
  }, [_c('control', {
    attrs: {
      "label": "Care",
      "tip-text": "You have three options to assess the care claim — click the help icon to find out more.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "200",
      "tip-name": "care",
      "modalName": "careModal"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.careCalcType),
      expression: "careCalcType"
    }],
    attrs: {
      "id": "careCalcType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.careCalcType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "own"
    }
  }, [_vm._v("Enter your own figure")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto-calculate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Detailed calculation")])])])], 1), _vm._v(" "), (_vm.careCalcType === 'own') ? _c('control', {
    attrs: {
      "for": "ownCareFigure",
      "label": "Enter Your Own Figure",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ownCareFigure),
      expression: "ownCareFigure",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:ownCareFigure.valid",
      value: ({
        type: 'number',
        rules: 'valid'
      }),
      expression: "{type:'number', rules:'valid'}",
      arg: "ownCareFigure",
      modifiers: {
        "valid": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "ownCareFigure",
      "min": "0.00"
    },
    domProps: {
      "value": (_vm.ownCareFigure)
    },
    on: {
      "focus": function($event) {
        _vm.ownCareFigure = _vm.ownCareFigure || ''
      },
      "blur": [function($event) {
        _vm.ownCareFigure = _vm.ownCareFigure || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ownCareFigure = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('ownCareFigure')
    }
  }, [_vm._v("\n                        Your own care figure should be greater than £0.00\n                    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.periods.length), function(index) {
    return (_vm.careCalcType === 'manual') ? _c('div', [_c('care-period', {
      attrs: {
        "index": index - 1
      },
      on: {
        "update": function($event) {
          return _vm.updateValid()
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.periods.length >= 0 && _vm.careCalcType === 'manual') ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    staticStyle: {
      "margin-bottom": "40px"
    },
    on: {
      "click": _vm.addCarePeriod
    }
  }, [_vm._v("\n                    Add Period\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'a-loader--care': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('control', {
    attrs: {
      "for": "care_total",
      "label": "Care Total",
      "before-after": "pound",
      "tip-icon": _vm.careIcon,
      "tip-show": _vm.careCalcType === 'auto',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "care_total",
      "modal-name": 'headsOfLoss_' + _vm.uniqueId,
      "endpoint": 'autoCare'
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.findValue('pastCostOfCare'), '')
    }
  })])], 1) : _vm._e()], 2)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "pastLossOfEarningsModal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Past Loss of Earnings Claim Options\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            You have two options to assess the care claim:"), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "u-margin-lr-40"
  }, [_c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can simply enter in a £ sum for the known past loss of earnings.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can carry out a detailed calculation looking at differing periods and calculating from either Net or Gross income per annum.\n            ")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "careModal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Care Claim Options\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            You have three options to assess the care claim:"), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "u-margin-lr-40"
  }, [_c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can simply enter in a £ sum for the care.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can Auto-calculate the award. The CA in Rothwell v Chemical Insulating Co. Ltd [2006] EWCA Civ 27 recognised a sum of £12,500 as the norm for care in claims for terminal malignant mesothelioma. This award is inflated to today’s value applying the Retail Price Index since January 2006.\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                You can carry out a detailed calculation looking at differing periods and differing hours of care and applying either a basic or aggregate care rate valued according to Local Authority Spinal Point 8. You can then discount the claim by 25% to reflect the gratuitous rather than commercial nature of the care.\n            ")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'headsOfLoss_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "generalDamagesPslaModal",
      "no-default-button": "true"
    }
  }, [(_vm.modals.generalDamagesPslaModal) ? _c('general-damages-psla-calculator') : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "lossOfSpouse",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n            Loss of Spouse\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Also known as ‘Regan Awards’ and awards for ‘loss of intangible benefits’, this head of loss is usually claimed for the loss of services provided by a spouse/parent which go beyond what can be commercially sourced e.g. care and attention. Originally established in Regan v Williamson, we discussed the most recent case law in "), _c('a', {
    attrs: {
      "href": "https://www.bc-legal.co.uk/images/pdf/177-BC-Disease-News-2017-03-17-Edition-177.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Edition 177 of BC Disease News")]), _vm._v(".\n        ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            General Damages\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "store-key": "gdPneumoconiosis",
      "title": "General Damages",
      "subtitle": "Pneumoconiosis etc, (Workers Compensation) Act 1979 including any extra statutory payments made following the rejection of a claim under the 1979 Act",
      "show-header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "estate-type": _vm.estateType,
      "title": "General Damages",
      "store-key": "gdMesothelioma",
      "subtitle": "2008 Diffuse Mesothelioma Scheme",
      "is-last": "",
      "show-header": ""
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.load
    }
  }, [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Bereavement Award — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n            ")]), _vm._v(" "), _c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('mini-calc-icons'), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.icon
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-clear"
  }), _c('br'), _vm._v(" "), _c('h2', [_vm._v("\n        Summary\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fragment', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.getJCGuidelinesNames(_vm.awardIndex)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getJCGuidelinesInfo(_vm.awardIndex)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.award.generalDamages)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.discount),
      expression: "discount",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'discount' + _vm.awardIndex,
        min: 0,
        max: 100,
      }),
      expression: "{\n              type: 'number',\n              name: 'discount' + awardIndex,\n              min: 0,\n              max: 100,\n            }",
      modifiers: {
        "required": true
      }
    }],
    staticStyle: {
      "min-width": "5em"
    },
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "max": "100",
      "required": ""
    },
    domProps: {
      "value": (_vm.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.award.total)))])]), _vm._v(" "), (!_vm.getDiscountsValid) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('control-error', [_vm._v(" The discount must be between 0 and 100 ")])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Loss of Pension",
      "icon": "loss-of-pension"
    }
  }), _vm._v(" "), _c('div', [_c('control', {
    attrs: {
      "for": "gender",
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "gender",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('gender')
    }
  }, [_vm._v("\n                        The Gender is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_birth')
    }
  }, [_vm._v("\n                        The date of birth is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement/Trial"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfAssumedSettlement",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement')
    }
  }, [_vm._v("\n                        The date of assumed settlement/trial is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_method",
      "label": "Simple Method or Longden Method?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pensionMethod),
      expression: "pensionMethod"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "pension_method",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pensionMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "simple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "longden",
      "disabled": ""
    }
  }, [_vm._v("Longden (coming soon)")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pension_method')
    }
  }, [_vm._v("\n                        The Simple Method or Longden Method is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "lump_sum_payment",
      "label": "Is there a lump sum payment?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lumpSumLoss),
      expression: "lumpSumLoss"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "lump_sum_loss",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lumpSumLoss = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "hidden": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('lump_sum_payment')
    }
  }, [_vm._v("\n                        The lump sum payment is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "label": _vm.lumpSumLoss ? '\'But For\' Retirement Date/Date Lump Sum Would Have Been Taken' : '\'But For\' Retirement Date'
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:but_for_retirement_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "but_for_retirement_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "update": _vm.handler
    },
    model: {
      value: (_vm.butForRetirementDate),
      callback: function($$v) {
        _vm.butForRetirementDate = $$v
      },
      expression: "butForRetirementDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('but_for_retirement_date')
    }
  }, [_vm._v("\n                        The 'But for' Retirement Date is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_age",
      "label": _vm.lumpSumLoss ? '\'But For\' Retirement Age/Age Lump Sum Would Have Been Taken' : '\'But For\' Retirement Age',
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForRetirementAge),
      expression: "butForRetirementAge",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_retirement_age.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_retirement_age",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_retirement_age",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForRetirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForRetirementAge = _vm._n($event.target.value)
      }, _vm.handler],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('but_for_retirement_age')
    }
  }, [_vm._v("\n                        The 'But for' Retirement Age is required\n                    ")])], 1)], 1), _vm._v(" "), (_vm.lumpSumLoss) ? _c('div', [_c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                    Lump Sum Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_pension_lump_sum",
      "label": "'But For' Pension Lump Sum",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForPensionLumpSum),
      expression: "butForPensionLumpSum",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_lump_sum.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_lump_sum",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_pension_lump_sum",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForPensionLumpSum)
    },
    on: {
      "focus": function($event) {
        _vm.butForPensionLumpSum = _vm.butForPensionLumpSum || ''
      },
      "blur": [function($event) {
        _vm.butForPensionLumpSum = _vm.butForPensionLumpSum || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForPensionLumpSum = _vm._n($event.target.value)
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.lumpSumValid
    }
  }, [_vm._v("\n                        'But For' Pension Lump Sum must be greater than the Lump Sum Payment After the Accident\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_lump_sum",
      "label": "Actual Lump Sum Payment",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionLumpSum),
      expression: "pensionLumpSum",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_lump_sum.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_lump_sum",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_lump_sum",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionLumpSum)
    },
    on: {
      "focus": function($event) {
        _vm.pensionLumpSum = _vm.pensionLumpSum || ''
      },
      "blur": [function($event) {
        _vm.pensionLumpSum = _vm.pensionLumpSum || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionLumpSum = _vm._n($event.target.value)
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.lumpSumValid
    }
  }, [_vm._v("\n                        Lump Sum Payment After the Accident must be less than the 'But For' Pension Lump Sum\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_lump_sum_received",
      "label": "Date Lump Sum Payment Received"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_lump_sum_received.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_lump_sum_received",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "update": _vm.handler
    },
    model: {
      value: (_vm.dateLumpSumPaymentReceived),
      callback: function($$v) {
        _vm.dateLumpSumPaymentReceived = $$v
      },
      expression: "dateLumpSumPaymentReceived"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                    Pension Losses\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "label": "'But For' Pension Annual Income",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForPensionAnnual),
      expression: "butForPensionAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_pension_annual",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForPensionAnnual)
    },
    on: {
      "focus": function($event) {
        _vm.butForPensionAnnual = _vm.butForPensionAnnual || ''
      },
      "blur": [function($event) {
        _vm.butForPensionAnnual = _vm.butForPensionAnnual || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForPensionAnnual = _vm._n($event.target.value)
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.pensionAnnualIncomeValid
    }
  }, [_vm._v("\n                        'But For' Pension Annual Income must be greater than Actual Pension Annual Income\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_annual",
      "before-after": "pound",
      "label": "Actual Pension Annual Income"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionAnnual),
      expression: "pensionAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_annual",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionAnnual)
    },
    on: {
      "focus": function($event) {
        _vm.pensionAnnual = _vm.pensionAnnual || ''
      },
      "blur": [function($event) {
        _vm.pensionAnnual = _vm.pensionAnnual || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionAnnual = _vm._n($event.target.value)
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.pensionAnnualIncomeValid
    }
  }, [_vm._v("\n                        Actual Pension Annual Income must be less than 'But For' Pension Annual Income\n                    ")])], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "total_loss",
      "label": "Total Loss",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.totalLoss),
      expression: "totalLoss"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "total_loss",
      "type": "number",
      "name": "total_loss"
    },
    domProps: {
      "value": (_vm.totalLoss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalLoss = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalLoss),
      expression: "totalLoss"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('h2', [_vm._v("Pension Loss")]), _vm._v(" "), _c('p', [_vm._v("\n                Based on the 'But For' retirement date ("), _c('strong', [_vm._v(_vm._s(_vm.butForRetirementDate))]), _vm._v(") and Date of Assumed Settlement/Trial\n                ("), _c('strong', [_vm._v(_vm._s(_vm.dateOfAssumedSettlement))]), _vm._v(").\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The pension multiplier is "), _c('strong', [_vm._v(_vm._s(_vm.pensionLossMultiplier))])]), _c('div', {
    staticStyle: {
      "margin-top": "-40px",
      "margin-left": "225px"
    },
    on: {
      "click": _vm.togglePensionMultiplierModal
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "formula",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1), _vm._v(" "), _c('p'), _vm._v(" "), (_vm.lumpSumLoss) ? _c('div', [_c('h2', [_vm._v("Lump Sum Loss")]), _vm._v(" "), _c('p', [_vm._v("\n                    Based on the Date Lump Sum Payment Received ("), _c('strong', [_vm._v(_vm._s(_vm.dateLumpSumPaymentReceived))]), _vm._v(") the Period of Accelerated Receipt\n                    is "), _c('strong', [_vm._v(_vm._s(_vm.acceleratedReceipt))]), _vm._v(" years.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Table 35 Discount Factor: "), _c('strong', [_vm._v(_vm._s(_vm.discountFactor))])]), _c('div', {
    staticStyle: {
      "margin-top": "-40px",
      "margin-left": "240px"
    },
    on: {
      "click": _vm.toggleDiscountFactorModal
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "formula",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('h2', [_vm._v("Lump Sum Loss Formula")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                                Table 35 Discount Factor x ('But For' Pension Lump Sum - Actual Lump Sum Payment) = Lump Sum Loss\n                            ")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('h2', [_vm._v("Lump Sum Loss")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                                " + _vm._s(_vm.discountFactor) + " x (" + _vm._s(_vm.currencyFormat(_vm.butForPensionLumpSum)) + " - " + _vm._s(_vm.currencyFormat(_vm.pensionLumpSum)) + ") = " + _vm._s(_vm.currencyFormat(_vm.lumpSumLossPresentValue)) + "\n                            ")])])]), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('p'), _c('h2', [_vm._v("Pension Loss Formula")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                            Pension Multiplier x ('But For' Pension Annual Income - Actual Pension Annual Income)\n                            "), (_vm.lumpSumLoss) ? _c('span', [_vm._v(" + Lump Sum Loss")]) : _vm._e(), _vm._v(" = Total Annual Loss\n                        ")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('h2', [_vm._v("Pension Loss")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                        " + _vm._s(_vm.pensionLossMultiplier) + " x (" + _vm._s(_vm.currencyFormat(_vm.butForPensionAnnual)) + " - " + _vm._s(_vm.currencyFormat(_vm.pensionAnnual)) + ")\n                        "), (_vm.lumpSumLoss) ? _c('span', [_vm._v(" + " + _vm._s(_vm.currencyFormat(_vm.lumpSumLossPresentValue)))]) : _vm._e(), _vm._v(" = " + _vm._s(_vm.currencyFormat(_vm.totalLoss)) + "\n                    ")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "pension_multiplier_modal",
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "discount_factor_modal",
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.noDefaultButton) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.toggleThisModal
    }
  }, [_vm._v(_vm._s(_vm.buttonName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "o-modal",
    class: [_vm.name, {
      'o-modal--open': _vm.isThisModalOpen
    }]
  }, [_c('div', {
    staticClass: "o-modal__container",
    class: {
      'o-modal__container--wide': _vm.wide
    }
  }, [_c('div', {
    staticClass: "o-modal__close-button",
    on: {
      "click": _vm.toggleThisModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-modal__content"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-0 u-margin-bottom-30"
  }, [_vm._v("\n        Service - " + _vm._s(_vm.service.description) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "service_description",
      "label": "Service Description"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.description),
      expression: "service.description"
    }, {
      name: "field-control",
      rawName: "v-field-control:service_description.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "service_description",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "service_description",
      "name": "service_description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.service.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('service_description')
    }
  }, [_vm._v("\n                    The service description is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "services_multiplicand",
      "label": "Services Multiplicand",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.multiplicand),
      expression: "service.multiplicand",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:services_multiplicand.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "services_multiplicand",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "services_multiplicand",
      "type": "text"
    },
    domProps: {
      "value": (_vm.service.multiplicand)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "multiplicand", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updateServicePeriod()
      }],
      "focus": function($event) {
        _vm.service.multiplicand = _vm.service.multiplicand || ''
      },
      "blur": [function($event) {
        _vm.service.multiplicand = _vm.service.multiplicand || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('servicesMultiplicand')
    }
  }, [_vm._v("\n                    The services multiplicand is required and has to be greater than 0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "services_start_date",
      "label": "Services Start Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:services_start_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "services_start_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": function($event) {
        return _vm.updateServicePeriod()
      }
    },
    model: {
      value: (_vm.service.servicesStartDate),
      callback: function($$v) {
        _vm.$set(_vm.service, "servicesStartDate", $$v)
      },
      expression: "service.servicesStartDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('services_start_date')
    }
  }, [_vm._v("\n                    The services start date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.servicesStartDateValidation
    }
  }, [_vm._v("\n                    The services start date must be after the date of Injury/Accident " + _vm._s(_vm.getClaimInfo('dateOfInjury')) + "\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "mortality_multiplier",
      "label": "Adjust Multiplier for Mortality?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.mortalityMultiplier),
      expression: "service.mortalityMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "mortality_multiplier",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.service, "mortalityMultiplier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateServicePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteService
    }
  }, [_vm._v("Remove Services")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "services_losses_for_life",
      "label": "Do Services Continue for Life?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.lossesForLife),
      expression: "service.lossesForLife"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "services_losses_for_life",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.service, "lossesForLife", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getServicesLifeExpectancy]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), (_vm.service.lossesForLife) ? _c('life-expectancy', {
    attrs: {
      "label": "Claimant's 'But For' Life Expectancy",
      "person": _vm.thePerson,
      "date": _vm.theDate,
      "type": "deceased",
      "assumedSettlement": _vm.getClaimInfo('dateOfAssumedSettlement'),
      "stepValid": _vm.stepValid
    },
    on: {
      "update": _vm.updateLife
    }
  }) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "services_end_date",
      "label": "Services End Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:services_end_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "services_end_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.service.lossesForLife
    },
    on: {
      "input": function($event) {
        return _vm.updateServiceEndDate()
      }
    },
    model: {
      value: (_vm.service.servicesEndDate),
      callback: function($$v) {
        _vm.$set(_vm.service, "servicesEndDate", $$v)
      },
      expression: "service.servicesEndDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('services_end_date')
    }
  }, [_vm._v("\n                    The services end date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.servicesEndDateValidation
    }
  }, [_vm._v("\n                    The services end date must be after the services start date  " + _vm._s(_vm.service.servicesStartDate) + "\n                ")])], 1), _vm._v(" "), (_vm.service.lossesForLife === false) ? _c('control', {
    attrs: {
      "for": "services_age_at_end_date",
      "label": "Age at End Date"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.ageAtEndDate),
      expression: "service.ageAtEndDate",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:services_age_at_end_date.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "services_age_at_end_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "services_age_at_end_date",
      "type": "text"
    },
    domProps: {
      "value": (_vm.service.ageAtEndDate)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "ageAtEndDate", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updateServiceAge()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('services_age_at_end_date')
    }
  }, [_vm._v("\n                    The claimant's age at services end date is required and has to be greater than 0\n                ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(_vm.format(_vm.name)) + "\n    ")]), _vm._v(" "), _vm._l((_vm.chosenRates), function(rate) {
    return _c('td', [_vm._v("\n        " + _vm._s(_vm.row[rate] ? _vm.currencyFormat(_vm.row[rate]) : _vm.currencyFormat(0)) + "\n    ")])
  }), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('td', [_vm._v("\n        " + _vm._s(_vm.currency(_vm.row[_vm.chosenRates[0]], _vm.row[_vm.chosenRates[1]])) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('td', [_vm._v("\n        " + _vm._s(_vm.roundAndPercent(_vm.row[_vm.chosenRates[0]], _vm.row[_vm.chosenRates[1]])) + "%\n    ")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-your-claims__table-container"
  }, [_c('div', {
    staticClass: "flex-grid flex-state-buttons"
  }, [_c('h3'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showInterest),
      expression: "showInterest"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showInterest) ? _vm._i(_vm.showInterest, null) > -1 : (_vm.showInterest)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showInterest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showInterest = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showInterest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showInterest = $$c
        }
      }, _vm.updateTotals]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Show Interest")])])])]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("General Damages")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getGeneralDamages)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getGeneralDamages - _vm.generalDamages)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getGeneralDamages, _vm.generalDamages)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getIncomeValue('pastLossOfEarningsNetTotal'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarnings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarnings = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getIncomeValue('pastLossOfEarningsNetTotal') - _vm.pastLossOfEarnings)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getIncomeValue('pastLossOfEarningsNetTotal'), _vm.pastLossOfEarnings)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings - Interest ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastLossOfEarningsWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarningsInterest),
      expression: "pastLossOfEarningsInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarningsInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarningsInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastLossOfEarningsWithInterest') - _vm.pastLossOfEarningsInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastLossOfEarningsWithInterest'), _vm.pastLossOfEarningsInterest)) + "%\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfTravel') - _vm.pastCostOfTravel)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfTravel'), _vm.pastCostOfTravel)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Travel - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfTravelWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravelInterest),
      expression: "pastCostOfTravelInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravelInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravelInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfTravelWithInterest') - _vm.pastCostOfTravelInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfTravelWithInterest'), _vm.pastCostOfTravelInterest)) + "%")])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.getAllCustomHeadOfLoss), function(custom) {
    return _c('custom-head-of-loss', {
      attrs: {
        "headOfLoss": custom,
        "index": _vm.index,
        "showInterest": _vm.showInterest
      },
      on: {
        "update": _vm.updateTotals
      }
    })
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCare),
      expression: "pastCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCare = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfCare') - _vm.pastCostOfCare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfCare'), _vm.pastCostOfCare)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Care - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfCareWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCareInterest),
      expression: "pastCostOfCareInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCareInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCareInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfCareWithInterest') - _vm.pastCostOfCareInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfCareWithInterest'), _vm.pastCostOfCareInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfServices'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfServices),
      expression: "pastCostOfServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfServices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfServices = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfServices') - _vm.pastCostOfServices)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfServices'), _vm.pastCostOfServices)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Services - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfServicesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfServicesInterest),
      expression: "pastCostOfServicesInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfServicesInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfServicesInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfServicesWithInterest') - _vm.pastCostOfServicesInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfServicesWithInterest'), _vm.pastCostOfServicesInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('misc'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('misc') - _vm.misc)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('misc'), _vm.misc)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Miscellaneous - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('miscWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.miscInterest),
      expression: "miscInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.miscInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.miscInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('miscWithInterest') - _vm.miscInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('miscWithInterest'), _vm.miscInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Pension ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futurePensionTotal)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossOfPension),
      expression: "futureLossOfPension",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureLossOfPension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossOfPension = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futurePensionTotal - _vm.futureLossOfPension)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.futurePensionTotal, _vm.futureLossOfPension)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureCareTotal)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureCostOfCare),
      expression: "futureCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureCostOfCare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureCostOfCare = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureCareTotal - _vm.futureCostOfCare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.futureCareTotal, _vm.futureCostOfCare)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureServicesTotal)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureCostOfServices),
      expression: "futureCostOfServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureCostOfServices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureCostOfServices = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureServicesTotal - _vm.futureCostOfServices)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.futureServicesTotal, _vm.futureCostOfServices)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.lossResult)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossOfEarnings),
      expression: "futureLossOfEarnings",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureLossOfEarnings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossOfEarnings = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.lossResult - _vm.futureLossOfEarnings)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.lossResult, _vm.futureLossOfEarnings)) + "%")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headsOfLossTotal)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.dependantsHeadsOfLossTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.differenceTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headsOfLossTotal, _vm.dependantsHeadsOfLossTotal)) + "%")])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Defendant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Claimant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])]), _vm._v(" "), _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Percentage")])])])])
}]}

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-0 u-margin-bottom-30"
  }, [_vm._v("\n        Care - " + _vm._s(_vm.care.description) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "care_description",
      "label": "Care Description"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.care.description),
      expression: "care.description"
    }, {
      name: "field-control",
      rawName: "v-field-control:care_description.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "care_description",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "care_description",
      "name": "care_description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.care.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.care, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('care_description')
    }
  }, [_vm._v("\n                    The care description is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "care_multiplicand",
      "label": "Care Multiplicand",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.care.multiplicand),
      expression: "care.multiplicand",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:care_multiplicand.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "care_multiplicand",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "care_multiplicand",
      "type": "number"
    },
    domProps: {
      "value": (_vm.care.multiplicand)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.care, "multiplicand", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updateCarePeriod()
      }],
      "focus": function($event) {
        _vm.care.multiplicand = _vm.care.multiplicand || ''
      },
      "blur": [function($event) {
        _vm.care.multiplicand = _vm.care.multiplicand || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('careMultiplicand')
    }
  }, [_vm._v("\n                    The care multiplicand is required and has to be greater than 0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "care_start_date",
      "label": "Care Start Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:care_start_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "care_start_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": function($event) {
        return _vm.updateCarePeriod()
      }
    },
    model: {
      value: (_vm.care.careStartDate),
      callback: function($$v) {
        _vm.$set(_vm.care, "careStartDate", $$v)
      },
      expression: "care.careStartDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('care_start_date')
    }
  }, [_vm._v("\n                    The care start date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.careStartDateValidation
    }
  }, [_vm._v("\n                    The care start date must be after the date of Injury/Accident " + _vm._s(_vm.getClaimInfo('dateOfAssumedSettlement')) + "\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "mortality_multiplier",
      "label": "Adjust Multiplier for Mortality?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.care.mortalityMultiplier),
      expression: "care.mortalityMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "mortality_multiplier",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.care, "mortalityMultiplier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateCarePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteCarePeriod
    }
  }, [_vm._v("Remove Care Period")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "losses_for_life",
      "label": "Do Losses Continue for Life?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.care.lossesForLife),
      expression: "care.lossesForLife"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "losses_for_life",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.care, "lossesForLife", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.lossesForLifeChanged()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), (_vm.care.lossesForLife) ? _c('life-expectancy', {
    attrs: {
      "label": "Claimant's 'But For' Life Expectancy",
      "person": _vm.thePerson,
      "date": _vm.theDate,
      "assumedSettlement": _vm.getClaimInfo('dateOfAssumedSettlement'),
      "type": "claimant"
    },
    on: {
      "update": _vm.updateLifeForCare
    }
  }) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "care_end_date",
      "label": "Care End Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:care_end_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "care_end_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.care.lossesForLife
    },
    on: {
      "input": function($event) {
        return _vm.updateCareEndDate()
      }
    },
    model: {
      value: (_vm.care.careEndDate),
      callback: function($$v) {
        _vm.$set(_vm.care, "careEndDate", $$v)
      },
      expression: "care.careEndDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('care_end_date')
    }
  }, [_vm._v("\n                    The care end date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.careEndDateValidation
    }
  }, [_vm._v("\n                    The care end date must be after the care start date " + _vm._s(_vm.care.careStartDate) + "\n                ")])], 1), _vm._v(" "), (_vm.care.lossesForLife === false) ? _c('control', {
    attrs: {
      "for": "care_age_at_end_date",
      "label": "Age at End Date"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.care.ageAtEndDate),
      expression: "care.ageAtEndDate",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:care_age_at_end_date.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "care_age_at_end_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "care_age_at_end_date",
      "type": "text"
    },
    domProps: {
      "value": (_vm.care.ageAtEndDate)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.care, "ageAtEndDate", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updateCareAge()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('care_age_at_end_date')
    }
  }, [_vm._v("\n                    The claimant's age at care end date is required and has to be greater than 0\n                ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-modal-in-the-wild"
  }, [_c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    " + _vm._s(_vm.data.content) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_vm._m(0), _vm._v(" "), (_vm.interimPayments.length === 0) ? _c('p', [_vm._v("\n                Add details of any Interim Payments using the button below:\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.interimPayments), function(interimPayment, index) {
    return _c('div', {
      staticClass: "dependant a-form-inputs--section"
    }, [_c('payment', {
      attrs: {
        "index": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addPayment
    }
  }, [_vm._v("Add Interim Payment")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "a-form-inputs"
  }, [_vm._m(1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Calculate Interest Rates to"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestType),
      expression: "interestType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAllInterest]
    }
  }, [_c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Do not apply interest")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "today"
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_settlement"
    }
  }, [_vm._v("Assumed Settlement")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Custom")])])]), _vm._v(" "), (_vm.interestType === 'custom') ? _c('control', {
    attrs: {
      "label": "Custom date",
      "for": "custom_interest_date"
    }
  }, [_c('date-input', {
    on: {
      "input": _vm.calcAllInterest
    },
    model: {
      value: (_vm.customInterestDate),
      callback: function($$v) {
        _vm.customInterestDate = $$v
      },
      expression: "customInterestDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidDate
    }
  }, [_vm._v("\n                        Date is required, must be in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidInterestDate
    }
  }, [_vm._v("\n                        Date must be after the Date of Injury " + _vm._s(_vm.getClaimInfo('dateOfInjury')) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.interestType !== 'none') ? _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('div', {
    staticClass: "m-div-table__holder m-div-table__holder--less-margin"
  }, [(_vm.showGeneralDamages) ? _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('generalDamagesInterest'),
      "option": {
        name: 'generalDamages'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('generalDamagesWithInterest'),
      "tip-name": "general_damages",
      "title": "General Damages",
      "updates": "generalDamages"
    },
    on: {
      "update": _vm.onUpdate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pastLossOfEarnings) ? _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastLossOfEarningsInterest'),
      "option": {
        name: 'pastLossOfEarnings'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastLossOfEarningsWithInterest'),
      "tip-name": "past_loss_of_earnings",
      "title": "Past Loss of Earnings",
      "updates": "pastLossOfEarningsInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.value('pastCostOfServices') > 0) ? _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastCostOfServicesInterest'),
      "option": {
        name: 'pastCostOfServices'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastCostOfServicesWithInterest'),
      "tip-name": "past_cost_of_services",
      "title": "Past Cost of Services",
      "updates": "pastCostOfServicesInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.value('pastCostOfTravel') > 0) ? _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "name": "pastCostOfCare",
      "interest": _vm.value('pastCostOfTravelInterest'),
      "option": {
        name: 'pastCostOfTravel'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastCostOfCareWithInterest'),
      "tip-name": "past_cost_of_travel",
      "title": "Past Cost Of Travel",
      "updates": "pastCostOfTravelInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.value('misc') > 0) ? _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('miscInterest'),
      "option": {
        name: 'misc'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('miscWithInterest'),
      "tip-name": "misc",
      "title": "Miscellaneous - Medication, Appliances, Additional Food & Energy Costs",
      "updates": "miscInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.value('pastCostOfCare') > 0) ? _c('interest-item', {
    attrs: {
      "payload": _vm.payload,
      "interest": _vm.value('pastCostOfCareInterest'),
      "option": {
        name: 'pastCostOfCare'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.value('pastCostOfCareWithInterest'),
      "tip-name": "pastCostOfCare",
      "title": "Past Cost of Care",
      "updates": "pastCostOfCareInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br')]) : _vm._e()], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.$valid() && _vm.allInterimPaymentsValid
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'interest_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n                    Interim Payments\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n                        Interest\n                    ")])])
}]}

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "generalDamages"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.getAwards), function(award, awardIndex) {
    return _c('div', [_c('award', {
      attrs: {
        "awardIndex": awardIndex,
        "award": award
      },
      on: {
        "award-selected": _vm.selectedAward
      }
    })], 1)
  }), _vm._v(" "), (_vm.getTree !== null) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addAward
    }
  }, [_vm._v("Add Another Award")]) : _vm._e(), _vm._v(" "), (_vm.getTree !== null) ? _c('div', {
    staticClass: "p-pi-income"
  }, [_c('h2', [_vm._v("General Damages Totals")]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-top-20"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.getAwards), function(award, awardIndex) {
    return _c('award-value-row', {
      key: awardIndex,
      attrs: {
        "award-index": awardIndex
      }
    })
  }), 1), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                                General Damages Total (100%)\n                            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getSubTotal)))])]), _vm._v(" "), _c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                                General Damages Total (Discounted)\n                            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getSubTotalDiscounted)))])])])])])]) : _vm._e()], 2), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v("Award")]), _vm._v(" "), _c('th', [_vm._v("JC Guidelines Chapter")]), _vm._v(" "), _c('th', [_vm._v("General Damages Award")]), _vm._v(" "), _c('th', [_vm._v("Discount %")]), _vm._v(" "), _c('th', [_vm._v("Sub Total")])])])
}]}

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    This is simple mode, one input at a time and real time summary results on the right, don't\n    fancy it? Miss the look of a standard form? That's fine too, go to normal inputs at any time\n    by clicking the arrow. You can always come back to this view by clicking the\n    arrow again. We've got you covered.\n    "), _c('br'), _c('br'), _vm._v("\n    To begin just press the continue button or the enter key.\n    "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Did you know?")]), _vm._v(" "), _c('br'), _vm._v("\n    You can use the enter and tab keys to move through the form steps — which is much quicker.\n")])
}]}

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width a-table--hover",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("General Damages (PSLA)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamages'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamagesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bereavement Award")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('bereavementAward'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('bereavementAwardWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Funeral Expenses")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpenses'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpensesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loss of Spouse")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouse'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouseWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarnings'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarningsWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravelWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('misc'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('miscWithInterest'))))])]), _vm._v(" "), _vm._l((_vm.customHeadsOfLoss), function(customHead) {
    return (_vm.customHeadsOfLoss.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(customHead.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(customHead.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(customHead.interestAccrued)))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCareWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Dependency on Income")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnIncome'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnIncomeWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Dependency on Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnServices'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastDependencyOnServicesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Dependency on Income")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.incomePost)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Dependency on Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.servicePost)))]), _vm._v(" "), _c('td')]), _vm._v(" "), (_vm.cruTotalDeductions > 0) ? _c('tr', [_c('td', [_vm._v("CRU Benefit Deductions")]), _vm._v(" "), _c('td', [_vm._v("- " + _vm._s(_vm.currencyFormat(_vm.cruTotalDeductions)))]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.subTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestTotal)))])]), _vm._v(" "), (_vm.interimPayments.length > 0) ? _c('tr', {
    staticClass: "a-table--penultimate"
  }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.total)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total "), (_vm.interimPayments.length > 0) ? _c('span', [_vm._v("less interim payment(s)")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalLessInterimPayments)))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "step-button flex-state-buttons flex-state-buttons--block a-table--center"
  }, [_c('div', [_c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'fatal::dependency.step-8'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'fatal::dependency.documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                View Documents\n            ")])], 1)]), _vm._v(" "), _c('reserves-for-claim')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Amount")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Interest")])])])
}]}

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            General Damages\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "store-key": "gdPneumoconiosis",
      "title": "General Damages",
      "subtitle": "Pneumoconiosis etc, (Workers Compensation) Act 1979 including any extra statutory payments made following the rejection of a claim under the 1979 Act",
      "show-header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "General Damages",
      "store-key": "gdMesothelioma",
      "subtitle": "2008 Diffuse Mesothelioma Scheme",
      "is-last": "",
      "show-header": ""
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__save"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "save_day_one_fatal"
    }
  }, [_c('button', {
    staticClass: "a-button"
  }, [_vm._v("\n            " + _vm._s(!_vm.exists ? 'Save as new claim' : 'Update Claim') + "\n        ")])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "save_day_one_fatal",
      "no-default-button": "true",
      "wide": ""
    }
  }, [(!_vm.showList) ? _c('div', {
    staticClass: "c-save-as-new-claim"
  }, [_c('h1', [_vm._v("Save your assessment")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exists),
      expression: "!exists"
    }]
  }, [_vm._v("\n                Click the button below to attach this assessment to existing claim\n                or complete the form to save as a new claim\n            ")]), _vm._v(" "), _c('h2', [_vm._v("Claim details")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "for": "claimant_name",
      "label": "Claimant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantName),
      expression: "claimantName"
    }],
    attrs: {
      "type": "text",
      "name": "claimant_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.claimantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_name')
    }
  }, [_vm._v("\n                            The claimant name is required.\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Claimant Solicitors',
      "error-message": 'The claimant solicitor is required.',
      "value": _vm.claimantSolicitors,
      "type": 'claimant_solicitors'
    },
    on: {
      "update": _vm.updateClaimantSolicitors
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimant_reference",
      "label": "Claimant Solicitors Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantReference),
      expression: "claimantReference"
    }],
    attrs: {
      "type": "text",
      "name": "claimant_reference",
      "required": ""
    },
    domProps: {
      "value": (_vm.claimantReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_reference')
    }
  }, [_vm._v("\n                            The claimant solicitors reference name is required.\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "your_reference",
      "label": "Your Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.yourReference),
      expression: "yourReference"
    }],
    attrs: {
      "type": "text",
      "name": "your_reference",
      "required": ""
    },
    domProps: {
      "value": (_vm.yourReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('your_reference')
    }
  }, [_vm._v("\n                            Your reference is required\n                        ")])], 1), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Defendant Name',
      "error-message": 'The defendant name is required.',
      "value": _vm.defendantName,
      "type": 'defendant'
    },
    on: {
      "update": _vm.updateDefendant
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorMessage),
      expression: "showErrorMessage"
    }]
  }, [_vm._v("\n                        All fields are required.\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small a-button--loader-button",
    class: [_vm.isSaving ? 'a-loader--white' : ''],
    attrs: {
      "disabled": !_vm.updateValid()
    },
    on: {
      "click": _vm.doSave
    }
  }, [_c('span', {
    class: [_vm.isSaving ? 'a-button--span-hidden' : '']
  }, [_vm._v(_vm._s(_vm.exists ? "Update" : "Save"))])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.routeToClaim
    }
  }, [_vm._v("Open as Claim\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.openSummaryDocument
    }
  }, [_vm._v("Download Day\n                        One Summary\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.toggleClaimList
    }
  }, [_vm._v("\n                        Attach to existing claim\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.exists) ? _c('p', [_c('span', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("Save your claim before you can download the summary.")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showList) ? _c('div', {
    staticClass: "c-attached-to-existing"
  }, [_c('a', {
    staticClass: "u-float-r u-cursor-pointer",
    on: {
      "click": _vm.toggleClaimList
    }
  }, [_vm._v("\n                Return to save new claim\n            ")]), _vm._v(" "), _c('claim-table', {
    on: {
      "select": _vm.attachToClaim
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Head of Loss ' + (_vm.index + 1)
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "name",
      "placeholder": "Type of Head of Loss",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": _vm.updateValid,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('name') || !_vm.name
    }
  }, [_vm._v("\n            Name of loss is required\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "value",
      "required": "",
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "change": _vm.updateValid,
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": function($event) {
        _vm.value = _vm.value || 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            Value should be greater than £0.00\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisHeadOfLoss
    }
  }, [_vm._v("Delete Head of Loss")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Life Expectancy Calculator",
      "icon": "life-expectancy"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_gender",
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    attrs: {
      "required": "",
      "name": "deceased_gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAgeAtDeath]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_gender')
    }
  }, [_vm._v("\n                    The deceased's gender is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.calcAgeAtDeath
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_birth')
    }
  }, [_vm._v("\n                    The date of birth is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDob()
    }
  }, [_vm._v("\n                    The date of birth must be within 100 years of today\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfAssumedSettlement",
    on: {
      "input": _vm.calcAgeAtDeath
    },
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement')
    }
  }, [_vm._v("\n                    The date of assumed settlement is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDoAS()
    }
  }, [_vm._v("\n                    The date of assumed settlement must be within 100 years of today\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": 'Life Expectancy Type',
      "for": "method1"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lifeExpectancyMethod),
      expression: "lifeExpectancyMethod"
    }],
    ref: "lifeExpectancyMethod",
    attrs: {
      "id": "method1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lifeExpectancyMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAgeAtDeath]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ogden_table"
    }
  }, [_vm._v("Ogden Table 1/2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "years_and_months"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "enter_date"
    }
  }, [_vm._v("Enter Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "age_at_death"
    }
  }, [_vm._v("Enter Age At Death (years)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percentage_of_normal_life_expectancy"
    }
  }, [_vm._v("% of Normal Life Expectancy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percentage_reduction_in_normal_life_expectancy"
    }
  }, [_vm._v("\n                        % Reduction in Normal Life Expectancy\n                    ")])])]), _vm._v(" "), (_vm.lifeExpectancyMethod == 'years_and_months') ? _c('control', {
    attrs: {
      "label": "Enter Years/Months From Today"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.years),
      expression: "years",
      modifiers: {
        "number": true
      }
    }],
    ref: "years",
    attrs: {
      "id": "years1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.years = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAgeAtDeath]
    }
  }, _vm._l((76), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v("\n                                " + _vm._s(year - 1) + " year" + _vm._s(year - 1 === 1 ? '' : 's') + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.months),
      expression: "months",
      modifiers: {
        "number": true
      }
    }],
    ref: "months",
    attrs: {
      "id": "months1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.months = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAgeAtDeath]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                                " + _vm._s(month - 1) + " month" + _vm._s(month - 1 === 1 ? '' : 's') + "\n                            ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'percentage_of_normal_life_expectancy') ? _c('control', {
    attrs: {
      "label": "Percentage of Normal Life Expectancy",
      "for": "percentage_of_normal_life_expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.percentageOfNormalLifeExpectancy),
      expression: "percentageOfNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "percentageOfNormalLifeExpectancy",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "max": "100",
      "min": "1",
      "disabled": _vm.lifeExpectancyMethod !== 'percentage_of_normal_life_expectancy',
      "name": "percentage_of_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentageOfNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.percentageOfNormalLifeExpectancy = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_of_normal_life_expectancy')
    }
  }, [_vm._v("\n                    The percentage of normal life expectancy must be number between 1 and 100\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'percentage_reduction_in_normal_life_expectancy') ? _c('control', {
    attrs: {
      "label": "Percentage Reduction in Normal Life Expectancy",
      "for": "percentage_reduction_in_normal_life_expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.percentageReductionInNormalLifeExpectancy),
      expression: "percentageReductionInNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    ref: "percentageReductionInNormalLifeExpectancy",
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.lifeExpectancyMethod !== 'percentage_reduction_in_normal_life_expectancy',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_reduction_in_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentageReductionInNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.percentageReductionInNormalLifeExpectancy = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_reduction_in_normal_life_expectancy')
    }
  }, [_vm._v("\n                    The percentage reduction in normal life expectancy must be number between 1 and 100\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod === 'enter_date') ? _c('control', {
    attrs: {
      "label": "Expected End of Life Date",
      "for": "date_of_death"
    }
  }, [_c('date-input', {
    ref: "dateOfDeathIsAssumed",
    on: {
      "input": _vm.calcAgeAtDeath
    },
    model: {
      value: (_vm.dateOfDeathIsAssumed),
      callback: function($$v) {
        _vm.dateOfDeathIsAssumed = $$v
      },
      expression: "dateOfDeathIsAssumed"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod === 'age_at_death') ? _c('control', {
    attrs: {
      "label": "Expected Age at End of Life (Years)",
      "for": "date_of_death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "ageAtDeath",
    attrs: {
      "autocomplete": "off",
      "min": "20",
      "name": "life_age_at_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), (_vm.lifeExpectancyMethod !== 'age_at_death') ? _c('control', {
    attrs: {
      "label": "Expected Age at End of Life (Years)",
      "for": "life_age_at_death",
      "modal-name": 'life_age_at_death_modal',
      "before-after": "years-old-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "min": "20",
      "disabled": "",
      "name": "life_age_at_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lifeExpectancyMethod !== 'enter_date'),
      expression: "lifeExpectancyMethod!=='enter_date'"
    }],
    attrs: {
      "label": "Expected End of Life Date",
      "for": "date_of_death"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateOfDeath),
      expression: "dateOfDeath"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.dateOfDeath)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateOfDeath = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Age at today's date",
      "for": "age_today"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    domProps: {
      "value": this.ageToday()
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), (_vm.lifeExpectancyMethod == 'ogden_table' || _vm.lifeExpectancyMethod == 'percentage_of_normal_life_expectancy' || _vm.lifeExpectancyMethod == 'percentage_reduction_in_normal_life_expectancy') ? _c('div', [(_vm.lifeExpectancyMethod == 'ogden_table') ? _c('p', [_vm._v("\n                    Life expectancy has been calculated using gender and current age from the 0% discount column of Ogden Table 1 (for males) and Ogden Table 2 (for females)\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'ogden_table') ? _c('div', {
    staticClass: "a-table--really-wide"
  }, [(_vm.tableData) ? _c('table', {
    staticClass: "a-table a-table--miniCalc",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [(_vm.tableData.table.thead[0].length) ? _c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.tableData.table.thead[1].length
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                                    " + _vm._s(_vm.tableData.table.thead[0]) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.tableData.table.thead[1]), function(column) {
    return _c('th', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', {
        class: {
          'a-table--highlight': column.highlight
        }
      }, [_vm._v("\n                                " + _vm._s(column.value) + "\n                            ")])
    }), 0)
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tableData) ? _c('div', [_c('h2', [_vm._v("Calculation")]), _vm._v(" "), (Object.keys(_vm.tableData.table.tbody).length > 1) ? _c('div', [_c('p', [_vm._v("\n                                The person's age at today's date is " + _vm._s(_vm.ageToday()) + " years old (DOB " + _vm._s(_vm.dateOfBirth) + ").\n                                Therefore, interpolation between rows " + _vm._s(_vm.formulaData()[0]) + " and " + _vm._s(_vm.formulaData()[2]) + " is\n                                required on the 0% column to receive the projected mortality value:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_vm._v("\n                                    " + _vm._s(_vm.formulaData()[3]) + " + ((" + _vm._s(_vm.formulaData()[2]) + " - " + _vm._s(_vm.ageToday()) + ") x (" + _vm._s(_vm.formulaData()[1]) + " - " + _vm._s(_vm.formulaData()[3]) + ")) = " + _vm._s(_vm.result()) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n                        Life expectancy is " + _vm._s(_vm.result()) + " years giving age at end of life of " + _vm._s(_vm.roundValue(_vm.ageAtDeath, 2)) + " years old.\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'years_and_months') ? _c('div', [_c('p', [_vm._v("\n                    The person's age at todays date is " + _vm._s(this.ageToday()) + " years old (DOB " + _vm._s(_vm.dateOfBirth) + ").\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Based on the person being expected to live for another " + _vm._s(_vm.years) + " year(s) and " + _vm._s(_vm.months) + " month(s) they would be expected to live until the age of " + _vm._s(_vm.ageAtDeath) + " years old.\n                ")]), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": [_vm.ageAtDeath, this.ageToday()]
    }
  }, [_c('h3', [_vm._v("Age at Expected Date of Death — " + _vm._s(_vm.dateOfDeath))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v("Age at Today's Date — " + _vm._s(this.dateToday()))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'enter_date') ? _c('div', [_c('p', [_vm._v("\n                    The person's age at todays date is " + _vm._s(this.ageToday()) + " years old (DOB " + _vm._s(_vm.dateOfBirth) + ").\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Based on the person being expected to live until the date of " + _vm._s(_vm.dateOfDeathIsAssumed) + " they would be expected to live until the age of " + _vm._s(_vm.ageAtDeath) + " years old.\n                ")]), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": [_vm.ageAtDeath, this.ageToday()]
    }
  }, [_c('h3', [_vm._v("Age at Expected Date of Death — " + _vm._s(_vm.dateOfDeath))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v("Age at Today's Date — " + _vm._s(this.dateToday()))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'age_at_death') ? _c('div', [_c('p', [_vm._v("\n                    The person's age at todays date is " + _vm._s(this.ageToday()) + " years old (DOB " + _vm._s(_vm.dateOfBirth) + ").\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Based on the person being expected to live until the age of " + _vm._s(_vm.ageAtDeath) + " they would be expected to live until the date of " + _vm._s(_vm.dateOfDeathIsAssumed) + ".\n                ")]), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": [_vm.ageAtDeath, this.ageToday()]
    }
  }, [_c('h3', [_vm._v("Age at Expected Date of Death — " + _vm._s(_vm.dateOfDeath))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v("Age at Today's Date — " + _vm._s(this.dateToday()))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'percentage_of_normal_life_expectancy') ? _c('div', [_c('p', [_vm._v("\n                    Based on gender and current age of " + _vm._s(this.ageToday()) + ", normal life expectancy using the 0% rate of return in Tables 1/2 of the Ogden Tables is " + _vm._s(_vm.ageAtDeath) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.percentageOfNormalLifeExpectancy) + "% of normal life expectancy would result in " + _vm._s(_vm.dateOfDeathIsAssumed) + " years remaining or an end of life date of " + _vm._s(_vm.dateOfDeath) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--really-wide"
  }, [(_vm.tableData) ? _c('table', {
    staticClass: "a-table a-table--modal",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [(_vm.tableData.table.thead[0].length) ? _c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.tableData.table.thead[1].length
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                                    " + _vm._s(_vm.tableData.table.thead[0]) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.tableData.table.thead[1]), function(column) {
    return _c('th', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', {
        class: {
          'a-table--highlight': column.highlight
        }
      }, [_vm._v("\n                                " + _vm._s(column.value) + "\n                            ")])
    }), 0)
  }), 0)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'percentage_reduction_in_normal_life_expectancy') ? _c('div', [_c('p', [_vm._v("\n                    Based on gender and current age of " + _vm._s(this.ageToday()) + ", reduction in normal life expectancy using the 0% rate of return in Tables 1/2 of the Ogden Tables is " + _vm._s(_vm.ageAtDeath) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.percentageReductionInNormalLifeExpectancy) + "% reduction of normal life expectancy would result in " + _vm._s(_vm.dateOfDeathIsAssumed) + " years remaining or an end of life date of " + _vm._s(_vm.dateOfDeath) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--really-wide"
  }, [(_vm.tableData) ? _c('table', {
    staticClass: "a-table a-table--modal",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [(_vm.tableData.table.thead[0].length) ? _c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.tableData.table.thead[1].length
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                                    " + _vm._s(_vm.tableData.table.thead[0]) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.tableData.table.thead[1]), function(column) {
    return _c('th', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', {
        class: {
          'a-table--highlight': column.highlight
        }
      }, [_vm._v("\n                                " + _vm._s(column.value) + "\n                            ")])
    }), 0)
  }), 0)]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gd-psla-calculator"
  }, [_c('h2', [_vm._v("Mesothelioma General Damages (PSLA) Calculator")]), _vm._v(" "), _c('p', [_vm._v("\n        Welcome to our Mesothelioma General Damages (PSLA) calculator. The calculator shows estimated common law awards\n        according to 'age' and 'duration of symptoms' — the period between onset of the disease\n        and death (or anticipated date of death).\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        There are two parts to the calculator:\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n        Onset of symptoms:\n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm.onsetOfSymptoms) + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        Duration of symptoms:\n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm.calculatedDurationOfSymptoms) + " month" + _vm._s(_vm.calculatedDurationOfSymptoms === 1 ? '' : 's') + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        Age at Death: "), _c('strong', [_vm._v(_vm._s(_vm.ageAtDeath))])]), _vm._v(" "), _c('label', [_vm._v("\n        Duration of Symptoms\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-gd-psla-calculator__slider p-dependency-calc__slider"
  }, [_c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 0,
      "max": 37,
      "real-time": true,
      "clickable": true,
      "piecewise": true,
      "process-style": {
        'backgroundColor': '#4A89E5'
      },
      "tooltip-style": {
        'backgroundColor': '#4A89E5',
        'borderColor': '#4A89E5'
      },
      "formatter": _vm.calculatedDurationOfSymptoms + ' months',
      "label-style": {
        'color': '#fff'
      }
    },
    model: {
      value: (_vm.calculatedDurationOfSymptoms),
      callback: function($$v) {
        _vm.calculatedDurationOfSymptoms = $$v
      },
      expression: "calculatedDurationOfSymptoms"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('h2', [_vm._v("Tariff Table")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.applyUplift()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upliftButton ? 'Add' : 'Remove') + " 10% Uplift\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [(_vm.table[50] && !_vm.loading.table) ? _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up to)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.table[50].length
    }
  }, [_vm._v("\n                    Duration (months)\n                ")])]), _vm._v(" "), _c('tr', _vm._l((_vm.table[50].length), function(col) {
    return _c('th', [(col === 1) ? _c('span', [_vm._v("0-3")]) : (col === 13) ? _c('span', [_vm._v("37+")]) : _c('span', [_vm._v(_vm._s(col * 3 - 2) + "-" + _vm._s(col * 3))])])
  }), 0), _vm._v(" "), _vm._l((_vm.table), function(tr, age) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(age))]), _vm._v(" "), _vm._l((tr), function(td, index) {
      return _c('td', {
        style: (_vm.getTariffTableTdStyle(index, age)),
        on: {
          "click": function($event) {
            _vm.usePslaAward(_vm.uplift ? Math.round(td * 1.1) : td)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.uplift ? Math.round(td * 1.1) : td, '£', 0)) + "\n                ")])
    })], 2)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.loading.table) ? _c('div', [_vm._v("\n        Loading... one moment\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "c-gd-psla-calculator__disclaimer"
  }, [_vm._v("Data is up-to-date as of May 2017 *")]), _vm._v(" "), _c('h2', [_vm._v("Awards")]), _vm._v(" "), _vm._l((_vm.filteredAwards), function(award) {
    return (!_vm.loading.awards) ? _c('psla-award', {
      attrs: {
        "award": award
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.loading.awards) ? _c('div', [_vm._v("\n        Loading... one moment\n    ")]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("\n            The first is a Tariff Table designed to give a broad brush indication of possible awards and\n            is not intended to substitute a detailed review and consideration of actual awards to\n            properly value any PSLA award. The Tariff Table is based on the 11th Edition of the JC Guidelines.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n            The second shows actual PLSA awards which most closely fit the selected age and duration\n            of symptoms.\n        ")])])
}]}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-chart-legend",
    class: ( _obj = {}, _obj['c-chart-legend--' + _vm.columns] = true, _obj ),
    style: ({
      width: _vm.legendWidth + '%',
      marginTop: _vm.marginTop + 'px',
      marginBottom: _vm.marginBottom + 'px'
    })
  }, [_c('div', {
    staticClass: "u-d-flex",
    class: {
      'u-flex-wrap': _vm.theCurrentWidth <= 400
    }
  }, [_c('div', {
    staticClass: "c-chart-legend__column"
  }, [_c('div', {
    staticClass: "u-d-inline-block"
  }, _vm._l((_vm.columnOne), function(value, index) {
    return _c('div', {
      staticClass: "u-d-flex u-text-left"
    }, [_c('div', {
      staticClass: "c-chart-legend__item",
      style: ({
        background: _vm.columnOneColours[index]
      })
    }), _vm._v("\n                    " + _vm._s(_vm.columnOne[index]) + "\n                ")])
  }), 0)]), _vm._v(" "), (_vm.columns === 2 || _vm.columns === 3) ? _c('div', {
    staticClass: "c-chart-legend__column"
  }, [_c('div', {
    staticClass: "u-d-inline-block"
  }, _vm._l((_vm.columnTwo), function(value, index) {
    return _c('div', {
      staticClass: "u-d-flex u-text-left"
    }, [_c('div', {
      staticClass: "c-chart-legend__item",
      style: ({
        background: _vm.columnTwoColours[index]
      })
    }), _vm._v("\n                    " + _vm._s(_vm.columnTwo[index]) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.columns === 3) ? _c('div', {
    staticClass: "c-chart-legend__column"
  }, [_c('div', {
    staticClass: "u-d-inline-block"
  }, _vm._l((_vm.columnThree), function(value, index) {
    return _c('div', {
      staticClass: "u-d-flex u-text-left"
    }, [_c('div', {
      staticClass: "c-chart-legend__item",
      style: ({
        background: _vm.columnThreeColours[index]
      })
    }), _vm._v("\n                    " + _vm._s(_vm.columnThree[index]) + "\n                ")])
  }), 0)]) : _vm._e()])])
  var _obj;
},staticRenderFns: []}

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal-in-the-wild"
  }, [_c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_c('icons'), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "label": "Deceased Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theDeceased.name),
      expression: "theDeceased.name"
    }, {
      name: "field-control",
      rawName: "v-field-control:deceased_name.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "deceased_name",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "deceased_name",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.theDeceased.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theDeceased, "name", $event.target.value)
      }, _vm.update]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_name')
    }
  }, [_vm._v("\n                        The deceased's name is required and must be a valid name\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_gender",
      "label": "Deceased Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.theDeceased.gender),
      expression: "theDeceased.gender"
    }],
    attrs: {
      "required": "",
      "name": "deceased_gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.theDeceased, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_gender')
    }
  }, [_vm._v("\n                        The deceased's gender is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_birth",
      "label": "Deceased Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "dateOfBirth", $$v)
      },
      expression: "theDeceased.dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_birth') || !_vm.validDateOfBirth()
    }
  }, [_vm._v("\n                        The deceased's date of birth is required and must be in the format DD/MM/YYYY\n                        and be at least the age of 18\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "onset_of_deceased_symptoms",
      "label": _vm.claimDetailsValue('diseaseOrAccident') === 'disease' ? 'Onset of Symptoms' : 'Date of Injury / Accident'
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:onset_of_deceased_symptoms.required",
      value: ({
        type: 'date',
        rules: 'min:' + _vm.theDeceased.dateOfBirth + '|' + 'max:' + _vm.theDeceased.dateOfDeath
      }),
      expression: "{type:'date', rules:'min:'+theDeceased.dateOfBirth +'|'+'max:'+theDeceased.dateOfDeath}",
      arg: "onset_of_deceased_symptoms",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.onsetOfSymptoms),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "onsetOfSymptoms", $$v)
      },
      expression: "theDeceased.onsetOfSymptoms"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('onset_of_deceased_symptoms') || !_vm.validOnsetOfSymptoms()
    }
  }, [_vm._v("\n                        The onset of symptoms is required, it must be in the format DD/MM/YYYY and be before the\n                        date of death and after the date of birth\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_death",
      "label": "Deceased Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.dateOfDeath),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "dateOfDeath", $$v)
      },
      expression: "theDeceased.dateOfDeath"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_death')
    }
  }, [_vm._v("\n                        The deceased's date of death is required, must be in the format DD/MM/YYYY and must be\n                        within 9 years of the assessment date (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeath()
    }
  }, [_vm._v("\n                        The deceased's date of death must be before the assumed settlement (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathDurtaion()
    }
  }, [_vm._v("\n                        The deceased's date of death must within 9 years of the assumed settlement (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathCurrent()
    }
  }, [_vm._v("\n                        The deceased's date of death must be in the past\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfProceedings()
    }
  }, [_vm._v("\n                        The deceased's date of death must be before the issue of proceedings\n                        (" + _vm._s(_vm.dateOfServiceProceedings) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathOnsetOfSymptoms()
    }
  }, [_vm._v("\n                        The deceased's date of death must be after the onset of symptoms\n                    ")])], 1), _vm._v(" "), _c('life-expectancy', {
    attrs: {
      "label": "Deceased's 'But For' Life Expectancy",
      "person": _vm.theDeceased,
      "type": 'deceased',
      "assumed-settlement": this.assumedSettlement,
      "stepValid": _vm.$valid() && _vm.isValid(2)
    },
    on: {
      "update": _vm.updateLife
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Period Between Onset and Date of Death",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "disabled",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": _vm.periodBetweenOnsetAndDod
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_death",
      "label": "Deceased Age at Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:age_at_death",
      arg: "age_at_death"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "age_at_death",
      "type": "number",
      "name": "age_at_death",
      "min": "18"
    },
    domProps: {
      "value": _vm.theDeceased.ageAtDeath
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_at_death')
    }
  }, [_vm._v("\n                        The deceased must have been at least 18 years old at the time of death\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Period Between Deceased's DOD & Settlement",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "deceased_and_settlement",
      "type": "number",
      "min": "0",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.periodDeathToSettlement
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Deceased's Age at Assumed Settlement",
      "tip-side": "left",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtSettlement
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.periodDeathToSettlement < 0
    }
  }, [_vm._v("\n                        Date of assessment/trial must be after the date of death\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Reduction in Deceased's Life Expectancy",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "disabled",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": "",
      "min": "0"
    },
    domProps: {
      "value": _vm.reductionInLifeExpectancy
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.reductionInLifeExpectancy < 0
    }
  }, [_vm._v("\n                        The deceased must have a reduction in life expectancy\n                    ")])], 1)], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.$valid() && _vm.isValid(2)
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'educationAttainment_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-margin-top-30"
  }, [_c('control', {
    attrs: {
      "label": 'Period ' + (_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "start",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodStart),
      callback: function($$v) {
        _vm.periodStart = $$v
      },
      expression: "periodStart"
    }
  })], 1), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": (_vm.$error('periodStart') || !_vm.startPeriodValid())
    }
  }, [_vm._v("\n                    Care period must start after the date of injury/accident (" + _vm._s(_vm.validationPeriodStart) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEnd || !_vm.periodStartIsBeforeEnd()
    }
  }, [_vm._v("\n                    Start of care period must be before end of care period\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "end",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodEnd),
      callback: function($$v) {
        _vm.periodEnd = $$v
      },
      expression: "periodEnd"
    }
  })], 1), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodEnd') || !_vm.endPeriodValid()
    }
  }, [_vm._v("\n                    Period end must be before " + _vm._s(_vm.validationPeriodEnd) + "\n                ")])], 1)])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Hours per Day"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "hours",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hoursPerDay),
      expression: "hoursPerDay"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "hours_per_day",
      "required": "",
      "min": "0",
      "max": "24",
      "type": "number"
    },
    domProps: {
      "value": (_vm.hoursPerDay)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.hoursPerDay = $event.target.value
      }, _vm.calcRate]
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("at")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }],
    attrs: {
      "id": "method",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcRate]
    }
  }, [_c('option', {
    attrs: {
      "value": "basic"
    }
  }, [_vm._v("Basic Rate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "aggregate"
    }
  }, [_vm._v("Aggregate")])])])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gratuitous Care Discount"
    }
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gratuitousCare),
      expression: "gratuitousCare"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gratuitousCare) ? _vm._i(_vm.gratuitousCare, null) > -1 : (_vm.gratuitousCare)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.gratuitousCare,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gratuitousCare = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gratuitousCare = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.gratuitousCare = $$c
        }
      }, _vm.calcRate]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Applies the 'conventional 25% discount' to reflect the gratuitous nature of care.")])])]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubtotal),
      expression: "showSubtotal"
    }],
    attrs: {
      "for": "sub_total",
      "label": "Subtotal",
      "tip-icon": "formula",
      "before-after": "pound",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "sub_total",
      "modal-name": 'subTotal_' + _vm.uniqueId,
      "endpoint": "detailedCare",
      "payload": {
        period: _vm.getCarePeriod(this.index)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.periodTotal),
      expression: "periodTotal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.periodTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodTotal = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.showDelete) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deletePeriod
    }
  }, [_vm._v("Delete This Period")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr--margin-bottom"
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'subTotal_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Assessments by Age")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__g-10"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Comparison of Quantum Assessments by Age")]), _vm._v(" "), _c('div', {
    staticClass: "p-discount-rate-comparison__chart-select"
  }, [_c('option-filters', {
    attrs: {
      "name": "ageGroupChartType"
    }
  }, [_c('li', {
    class: {
      'm-option-filters--active': _vm.ageGroupChartType === 'bar'
    },
    on: {
      "click": function($event) {
        return _vm.updateAgeGroupChartType('bar')
      }
    }
  }, [_vm._v("Bar Chart\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.ageGroupChartType === 'line'
    },
    on: {
      "click": function($event) {
        return _vm.updateAgeGroupChartType('line')
      }
    }
  }, [_vm._v("Line Chart\n                    ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "flex-grid__g-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [(_vm.ageGroupChartType === 'bar') ? _c('bar', {
    attrs: {
      "dataset": _vm.ageGroupBarDataset,
      "labels": _vm.ageGroupBarLabels,
      "legend": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ageGroupChartType === 'line') ? _c('linegraph', {
    attrs: {
      "dataset": _vm.ageGroupLineDataset,
      "labels": _vm.ageGroupBarLabels,
      "legend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "columns": 2,
      "values": [
        _vm.chosenRates[0],
        _vm.chosenRates[1]
      ],
      "legendWidth": _vm.chartLegendWidthTwo,
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__g-10"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Deceased's Age at Death")]), _vm._v(" "), _c('div', {
    staticClass: "p-discount-rate-comparison__chart-select"
  }, [_c('option-filters', {
    attrs: {
      "name": "rateGroupChartType"
    }
  }, [_c('li', {
    class: {
      'm-option-filters--active': _vm.rateGroupChartType === 'bar'
    },
    on: {
      "click": function($event) {
        return _vm.updateRateGroupChartType('bar')
      }
    }
  }, [_vm._v("Bar Chart\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.rateGroupChartType === 'line'
    },
    on: {
      "click": function($event) {
        return _vm.updateRateGroupChartType('line')
      }
    }
  }, [_vm._v("Line Chart\n                    ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "flex-grid__g-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [(_vm.rateGroupChartType === 'bar') ? _c('bar', {
    attrs: {
      "dataset": _vm.rateGroupBarDataset,
      "labels": _vm.chosenRates,
      "legend": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rateGroupChartType === 'line') ? _c('linegraph', {
    attrs: {
      "dataset": _vm.rateGroupLineDataset,
      "labels": _vm.chosenRates,
      "legend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "columns": 3,
      "values": _vm.ageLabels,
      "legendWidth": _vm.chartLegendWidthThree,
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("\n                        Deceased's Age at Death\n                    ")])]), _vm._v(" "), _vm._l((_vm.chosenRates), function(rate) {
    return _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_c('h2', [_vm._v("\n                        Discount Rate " + _vm._s(rate) + "\n                    ")])])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])], 2), _vm._v(" "), _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("%")])])]), _vm._v(" "), _vm._l((_vm.rateGroupBarDataset), function(row) {
    return _c('age-group-row', {
      attrs: {
        "row": row
      }
    })
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__modal"
  }, [(_vm.noChartData) ? _c('p', [_vm._v("\n        There are no matching claims to show a comparison.\n    ")]) : _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "p-day-one__chart-select-box-label"
  }, [_vm._v("Compare Against:")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartType),
      expression: "chartType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.chartTypes), function(text, type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v("\n                            " + _vm._s(text) + "\n                        ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "p-day-one__chart-select-box-label u-r-margin-top-20"
  }, [_vm._v("Filter:")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterAttr),
      expression: "filterAttr"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterAttr = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filterTypes), function(text, type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v("\n                                " + _vm._s(text) + "\n                            ")])
  }), 0)])])]), _vm._v(" "), _c('bell-chart', {
    attrs: {
      "chart-data": _vm.forChart,
      "user-percentile": _vm.userPercentile,
      "user-label": _vm.ordinalSuffixOf(_vm.userPercentile)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("This Assessment")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('td', [_vm._v("Value of your assessment (" + _vm._s(_vm.filterTypes[_vm.filterAttr]) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.userValue, "£", 0)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Percentile for this claim:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ordinalSuffixOf(_vm.userPercentile)))])])]), _vm._v(" "), _c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("Values of Matched Claims")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('td', [_vm._v("Full Range of Matched Claims")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.scaleMin, "£", 0)) + " - " + _vm._s(_vm.currencyFormat(_vm.scaleMax, "£", 0)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0-25th Percentile")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.minPercentileLabel))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25th - 75th Percentile")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.midPercentileLabel))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("75th - 100th Percentile")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.maxPercentileLabel))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "prevent": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "submit", undefined, $event.key, undefined)) { return null; }
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label u-r-margin-top-0"
  }, [_vm._v("\n                    Was the " + _vm._s(_vm.name) + " Retired at Onset of Disease?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_but_for",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "If the deceased had stopped working at the onset of symptoms, regardless of whether they had reached state pension age, they would be classed as having been retired.",
      "tip-width": "200",
      "tip-name": 'retired_at_onset_of_disease_' + _vm.tooltipValue
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retired),
      expression: "retired"
    }],
    attrs: {
      "id": "employed_but_for"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.retired = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateEmployed]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (!_vm.retired && _vm.name == 'Deceased') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                    Apply Employment Contingency Discounts\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "contingency_multiplier",
      "tip-show": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "Contingency discount is available when the the deceased was under the age of 67 at settlement/trial.",
      "tip-width": "200",
      "tip-name": 'contingency_multiplier_' + _vm.tooltipValue,
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contingencyMultiplier),
      expression: "contingencyMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "contingency_multiplier",
      "required": "",
      "disabled": _vm.ageAtTrial > 67
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contingencyMultiplier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateContingency]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('contingency_multiplier')
    }
  }, [_vm._v("\n                    Apply employment contingency discounts is required\n                ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.retired && _vm.name == 'Deceased' && _vm.ageAtTrial > 54) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }), _vm._v(" "), _c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-10"
  }, [_vm._v("\n                        Please note the discount figures only apply up to age 54\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-40",
    attrs: {
      "slot": "b"
    },
    slot: "b"
  }, [_c('p', {
    staticClass: "c-warning-box--link"
  }, [_vm._v("Read the full description here")])])])], 1) : _vm._e()]), _vm._v(" "), (!_vm.retired && _vm.name == 'Deceased' && _vm.contingencyMultiplier) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                    " + _vm._s('Employed at ' + (_vm.name === 'Deceased' ? '' : 'Deceased\'s') + ' Date of Onset') + "\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_at_accident",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "If the deceased had stopped working at the onset of symptoms, regardless of whether they had reached state pension age, they would be classed as having been retired.",
      "tip-width": "200",
      "tip-name": 'employed_at_accident_' + _vm.tooltipValue
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedAtDateOfDeath),
      expression: "employedAtDateOfDeath"
    }],
    attrs: {
      "id": "employed_at_accident"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedAtDateOfDeath = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes — Employed")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No — Not Employed")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                    " + _vm._s(_vm.name) + " Level of Education\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "level_of_education"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.levelOfEducation),
      expression: "levelOfEducation"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "level_of_education",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.levelOfEducation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Degree or equivalent or higher")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GE-A"
    }
  }, [_vm._v("GCSE grades A–C up to A levels or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("Below GCSE grade C or CSE grade 1 or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("No qualifications")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('level_of_education')
    }
  }, [_vm._v("\n                        Level of Education is required\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                    Was the " + _vm._s(_vm.name) + " Disabled?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "claimant_disabled"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledAtAccident),
      expression: "disabledAtAccident"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimant_disabled",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Not Disabled")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Disabled")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_disabled')
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.name) + " Disabled is required\n                    ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.showResult) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                    Table A–D Discount Factor\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": 'table_a_d_discount_factor_' + _vm.tooltipValue,
      "modal-name": 'income_' + _vm.uniqueId,
      "endpoint": "contingencyMultiplier",
      "payload": _vm.contingencyMultiplierPayload,
      "assumed-settlement": "assumedSettlement",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": _vm.theMultiplier
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.retired) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                    Retirement Age\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_age_calc",
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "Use government recommended retirement age/date or manually enter own",
      "tip-width": "200",
      "tip-name": 'retirement_age_calc_' + _vm.tooltipValue
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirementAgeCalc),
      expression: "retirementAgeCalc"
    }],
    attrs: {
      "id": "retirement_age_calc"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.retirementAgeCalc = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateRetirementPeriods]
    }
  }, [_c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Manual")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                    Expected Retirement Age\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "tip-show": _vm.retirementAgeCalc == 'auto',
      "for": "retirement_age",
      "table-control": true,
      "before-after": "years-old",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": 'retirement_age_' + _vm.tooltipValue,
      "modal-name": 'income_' + _vm.uniqueId,
      "payload": {
        person: this.person
      },
      "endpoint": 'expectedRetirementAge'
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.retirementAge),
      expression: "retirementAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "disabled": _vm.retirementAgeCalc === 'auto',
      "name": "retirement_age",
      "min": "18",
      "max": "100"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = _vm._n($event.target.value)
      }, _vm.updateIncomeRelated],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('retirement_age')
    }
  }, [_vm._v("\n                        The Retirement Age must be greater than 18\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                    Expected Retirement Date\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_date",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:retirement_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "retirement_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.retirementAgeCalc === 'auto'
    },
    on: {
      "input": _vm.updateIncomeRelated
    },
    model: {
      value: (_vm.retirementDate),
      callback: function($$v) {
        _vm.retirementDate = $$v
      },
      expression: "retirementDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('retirement_date')
    }
  }, [_vm._v("\n                        The Retirement Date is required\n                    ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "a-table a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [(!_vm.retiredAtDeath) ? _c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Employment Type")]), _vm._v(" "), _c('th', [_vm._v("Employment Income")]), _vm._v(" "), _c('th', [_vm._v("Net/Gross")]), _vm._v(" "), _c('th', [_vm._v("Pension Income")]), _vm._v(" "), _c('th', [_vm._v("Net/Gross")]), _vm._v(" "), _c('th', [_vm._v("Total Gross Income")]), _vm._v(" "), _c('th', [_vm._v("Total Net Income")]), _vm._v(" "), _c('th')]) : _c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Pension Income")]), _vm._v(" "), _c('th', [_vm._v("Net/Gross")]), _vm._v(" "), _c('th', [_vm._v("Net Income")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _vm._l((this.innerIncome.periods), function(period, periodIndex) {
    return _c('income-period', {
      attrs: {
        "period": period,
        "index": periodIndex,
        "maxIndex": _vm.innerIncome.periods.length,
        "dependant": _vm.index,
        "retired": _vm.retiredAtDeath,
        "retirement-date": _vm.retirementDate
      },
      on: {
        "update": _vm.updatePeriod
      }
    })
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.addPeriod
    }
  }, [_vm._v("\n                Add another period\n            ")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'income_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "warning",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("The discount figures")]), _vm._v(" "), _c('p', [_vm._v("\n            Do you wish to discount the future loss of earnings multiplier for contingencies other than mortality? For example, to reflect the risks and vicissitudes of life, such as periods not earning from ill-health or loss of employment or taking care for dependents. If so then Tables A-D of the Ogden Tables provide framework figures for discounting the multiplier to reflect these risks. Please note the discount figures only apply up to age "), _c('strong', [_vm._v("54")]), _vm._v(". Thereafter the tables state:\n        ")]), _vm._v(" "), _c('blockquote', [_c('i', [_vm._v("‘For older ages the reduction factors increase towards 1 at retirement age for those who are employed and fall towards 0 for those who are not employed. However, where the claimant is older than "), _c('strong', [_vm._v("54")]), _vm._v(", it is anticipated that the likely future course if employment status will be particularly dependent on individual circumstances, so that the use of factors based on averages would not be appropriate. Hence reduction factors are not provided for older ages’.")])]), _vm._v(" "), _c('p', [_vm._v("ABC Quantum does however provide discount factors beyond age "), _c('strong', [_vm._v("54")]), _vm._v("\n            to retirement age by simple interpolation. So for an employed male aged "), _c('strong', [_vm._v("54")]), _vm._v(", not disabled with A level qualifications the discount factor in "), _c('strong', [_vm._v("Table A is 0.79")]), _vm._v(". The figure at retirement age of say "), _c('strong', [_vm._v("65/67 is 1.0")]), _vm._v(". For ages between "), _c('strong', [_vm._v("54–65/67")]), _vm._v("\n            we interpolate between the figures "), _c('strong', [_vm._v("0.79-1.0")]), _vm._v(".")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid m-div-table__holder-section"
  }, [_c('div', {
    staticClass: "flex-grid__g-2"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("\n            Type\n        ")]), _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-2"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Percentage")]), _vm._v(" "), (_vm.updates !== 'generalDamages') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInterest),
      expression: "userInterest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userInterest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.25
    }
  }, [_vm._v("0.25%")])]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInterest),
      expression: "userInterest"
    }],
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userInterest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("2.00%")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Value")]), _vm._v(" "), (_vm.value > 0) ? _c('control', {
    attrs: {
      "endpoint": _vm.endpoint,
      "icon-space": _vm.theCurrentWidth < 1024 ? false : true,
      "modal-name": 'interest_' + _vm.uniqueId,
      "payload": _vm.payload,
      "option": _vm.option,
      "table-control": true,
      "tip-name": _vm.tipName,
      "before-after": "pound",
      "label": "",
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (parseFloat(_vm.value) === 0) ? _c('control', {
    attrs: {
      "label": "",
      "table-control": true,
      "tip-icon": "default",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.longTextValue) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs p-general-damages"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "label": _vm.name ? 'Type of ' + _vm.name : 'Category of Injury',
      "tip-show": !!!_vm.name,
      "tip-text": "This section is based on the General Damages 14th edition of the Judicial College Guidelines.",
      "tip-icon": "info",
      "tip-side": "right",
      "tip-width": "250",
      "tip-name": "general_damages_award_narrative"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.injuryTypeId),
      expression: "injuryTypeId"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.injuryTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectInjury()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _vm._l((_vm.tree), function(category, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                        " + _vm._s(category.index ? category.index : '') + " " + _vm._s(category.name) + "\n                    ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [(_vm.hasDescription()) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.tree[_vm.injuryTypeId]['name']))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.tree[_vm.injuryTypeId]['description'])
    }
  })]) : _vm._e()])]) : _c('div', {
    staticClass: "a-form-inputs p-general-damages p-general-damages__long-text"
  }, [_c('label', [_vm._v(_vm._s(_vm.name ? 'Type of ' + _vm.name : 'Category of Injury'))]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.tree), function(category, index) {
    return _c('li', [_c('button', {
      staticClass: "a-button",
      class: [_vm.injuryTypeId === index ? 'disabled' : ''],
      on: {
        "click": function($event) {
          return _vm.updateRadioButtons(index)
        }
      }
    }, [(_vm.injuryTypeId === index) ? _c('span', [_vm._v("Selected")]) : _c('span', [_vm._v("Select Award")])]), _vm._v(" "), _c('div', {
      staticClass: "a-radio u-d-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.injuryTypeId),
        expression: "injuryTypeId"
      }],
      attrs: {
        "type": "radio",
        "name": 'injuryTypeRadio' + index
      },
      domProps: {
        "value": index,
        "checked": _vm._q(_vm.injuryTypeId, index)
      },
      on: {
        "click": function($event) {
          return _vm.selectInjury()
        },
        "change": function($event) {
          _vm.injuryTypeId = index
        }
      }
    })]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.updateRadioButtons(index)
        }
      }
    }, [_vm._v(_vm._s(category.index ? category.index : '') + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(category.name)
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasChildren()) ? _c('injury-select', {
    ref: "childSelect",
    attrs: {
      "level": (_vm.level + 1),
      "selected": _vm.selected,
      "awardIndex": _vm.awardIndex,
      "tree": _vm.tree[_vm.injuryTypeId]['children'],
      "name": _vm.tree[_vm.injuryTypeId]['name'],
      "long-text-value": _vm.longText
    },
    on: {
      "injury-selected": _vm.bubbleSelected,
      "award-selected": _vm.updateValid
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasChildren() && _vm.injuryTypeId !== null) ? _c('div', [_c('h2', [_vm._v("The Range - JC Guidelines Chapter " + _vm._s(_vm.getJCGuidelinesInfo(_vm.awardIndex)))]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-margin-top-30 a-form-inputs p-general-damages"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid--column"
  }, [_c('h3', [_vm._v("\n                        With 10% Uplift\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasValue('up_to_value_with_uplift')) ? _c('span', [_vm._v("\n                        Up to: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['up_to_value_with_uplift'])) + " ")])]) : (_vm.hasValue('in_the_region_of_with_uplift')) ? _c('span', [_vm._v("\n                        In the region of: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['in_the_region_of_with_uplift'])) + " ")])]) : (_vm.hasValue('in_excess_of_with_uplift')) ? _c('span', [_vm._v("\n                        In excess of: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['in_excess_of_with_uplift'])) + " ")])]) : (_vm.hasValue('a_few_hundred_pounds_to_with_uplift')) ? _c('span', [_vm._v("\n                        A few hundred pounds to:  "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['a_few_hundred_pounds_to_with_uplift'])) + " ")])]) : (_vm.hasValue('not_less_than_with_uplift')) ? _c('span', [_vm._v("\n                        Not less than: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['not_less_than_with_uplift'])) + " ")])]) : (_vm.hasValue('rarely_exceed_with_uplift')) ? _c('span', [_vm._v("\n                        Rarely exceed: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['rarely_exceed_with_uplift'])) + " ")])]) : (_vm.hasValue('likely_to_exceed_with_uplift')) ? _c('span', [_vm._v("\n                        Likely to exceed: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['likely_to_exceed_with_uplift'])) + " ")])]) : _c('div', [(_vm.hasValue('lower_value_with_uplift')) ? _c('span', [_vm._v("\n                            Lower Value: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['lower_value_with_uplift'])) + " ")]), _vm._v(" to\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.hasValue('upper_value_with_uplift')) ? _c('span', [_vm._v("\n                            Upper Value: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['upper_value_with_uplift'])) + " ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [_vm.uplift ? 'disabled' : ''],
    attrs: {
      "disabled": _vm.uplift
    },
    on: {
      "click": function($event) {
        return _vm.adjustUplift()
      }
    }
  }, [(_vm.uplift) ? _c('span', [_vm._v("Selected")]) : _c('span', [_vm._v("Select")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid--column"
  }, [_c('h3', [_vm._v("\n                        Without 10% Uplift\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasValue('up_to_value')) ? _c('span', [_vm._v("\n                        Up to: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['up_to_value'])) + " ")])]) : (_vm.hasValue('in_the_region_of')) ? _c('span', [_vm._v("\n                        In the region of: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['in_the_region_of'])) + " ")])]) : (_vm.hasValue('in_excess_of')) ? _c('span', [_vm._v("\n                        In excess of: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['in_excess_of'])) + " ")])]) : (_vm.hasValue('a_few_hundred_pounds_to')) ? _c('span', [_vm._v("\n                        A few hundred pounds to:  "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['a_few_hundred_pounds_to'])) + " ")])]) : (_vm.hasValue('not_less_than')) ? _c('span', [_vm._v("\n                        Not less than: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['not_less_than'])) + " ")])]) : (_vm.hasValue('rarely_exceed')) ? _c('span', [_vm._v("\n                        Rarely exceed: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['rarely_exceed'])) + " ")])]) : (_vm.hasValue('likely_to_exceed')) ? _c('span', [_vm._v("\n                        Likely to exceed: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['likely_to_exceed'])) + " ")])]) : _c('div', [(_vm.hasValue('lower_value')) ? _c('span', [_vm._v("\n                            Lower Value: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['lower_value'])) + " ")]), _vm._v(" to\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.hasValue('upper_value')) ? _c('span', [_vm._v("\n                            Upper Value: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['upper_value'])) + " ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [!_vm.uplift ? 'disabled' : ''],
    attrs: {
      "disabled": !_vm.uplift
    },
    on: {
      "click": function($event) {
        return _vm.adjustUplift()
      }
    }
  }, [(_vm.uplift) ? _c('span', [_vm._v("Select")]) : _c('span', [_vm._v("Selected")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs u-margin-top-10"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('h3', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("General Damages")]), _vm._v(" "), _c('control', {
    attrs: {
      "name": "general_damages_award",
      "tip-text": _vm.generalDamages === _vm.low || _vm.generalDamages === _vm.lowUplift ? 'This is the lower award.' : _vm.generalDamages === _vm.mid || _vm.generalDamages === _vm.midUplift ? 'This is the mid-range between the lower and upper award.' : _vm.generalDamages === _vm.upper || _vm.generalDamages === _vm.upperUplift ? 'This is the upper award.' : '',
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "general_damages_award_narrative",
      "tip-show": !!(_vm.low || _vm.lowUplift || _vm.upper || _vm.upperUplift),
      "no-flex-margin": true,
      "table-control": true
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "min": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "change": _vm.updateValid,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', [(_vm.hasValue('lower_value')) ? _c('div', [_c('button', {
    staticClass: "a-button",
    class: [_vm.generalDamages === _vm.low || _vm.generalDamages === _vm.lowUplift ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.applyAward('lower')
      }
    }
  }, [_vm._v("Apply Lower")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [_vm.generalDamages === _vm.mid || _vm.generalDamages === _vm.midUplift ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.applyAward('mid')
      }
    }
  }, [_vm._v("Apply Mid")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [_vm.generalDamages === _vm.upper || _vm.generalDamages === _vm.upperUplift ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.applyAward('upper')
      }
    }
  }, [_vm._v("Apply Upper")])]) : _vm._e()])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('icons'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n                Custom Assessment\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "p-reserving__summary"
  }, [_vm._v("\n                Our unique reserving function allows you to perform accurate day one assessments of reserves based on your concluded claims history.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                Assess and analyse reserves on your entire book of claims. Perform predictive analysis to help with IBNR assessments.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                Changes in IBNR requirements following discount rate changes can be performed in seconds — even for 1000s of claims.\n            ")])])
}]}

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-switch",
    class: {
      'a-switch--dark': _vm.onDark
    }
  }, [_c('input', {
    staticClass: "a-switch__input",
    attrs: {
      "autocomplete": "off",
      "type": "radio",
      "name": "view",
      "value": "",
      "id": _vm.id[0],
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "a-switch__label a-switch__label--off",
    class: {
      'a-switch__label--dark': _vm.onDark
    },
    attrs: {
      "for": _vm.id[0]
    }
  }, [_vm._v(_vm._s(_vm.labels[0]))]), _vm._v(" "), _c('input', {
    staticClass: "a-switch__input",
    attrs: {
      "autocomplete": "off",
      "type": "radio",
      "name": "view",
      "value": "",
      "id": _vm.id[1]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "a-switch__label a-switch__label--on",
    class: {
      'a-switch__label--dark': _vm.onDark
    },
    attrs: {
      "for": _vm.id[1]
    }
  }, [_vm._v(_vm._s(_vm.labels[1]))]), _vm._v(" "), _c('span', {
    staticClass: "a-switch__selection"
  })])
},staticRenderFns: []}

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path === '/resources-and-tools/ogden-table-viewer') ? _c('div', {
    staticClass: "flex-grid p-resources-and-tools__documents"
  }, [_c('h2', [_vm._v("Ogden Table Viewer")]), _vm._v(" "), _c('div', {
    staticClass: "p-resources-and-tools__document"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTable),
      expression: "selectedTable"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.obtainOgdenTable()
      }]
    }
  }, _vm._l((_vm.ogdenTables), function(ogdenTable) {
    return _c('option', {
      domProps: {
        "value": ogdenTable
      }
    }, [_vm._v(_vm._s(ogdenTable.name) + " -\n                    " + _vm._s(ogdenTable.description) + "\n                ")])
  }), 0)]), _vm._v(" "), (!!_vm.tableData && _vm.selectedTable) ? _c('ogden-table-viewer', {
    attrs: {
      "description": _vm.selectedTable.description,
      "name": _vm.selectedTable.name,
      "tableData": _vm.tableData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/resources-and-tools/at-a-glance-viewer') ? _c('div', {
    staticClass: "flex-grid p-resources-and-tools__documents",
    on: {
      "change": function($event) {
        return _vm.atAGlanceViewer()
      }
    }
  }, [_c('h2', [_vm._v("At a Glance Viewer")]), _vm._v(" "), _c('div', {
    staticClass: "p-resources-and-tools__document"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v("\n            Discount\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.discounts), function(discount) {
    return _c('option', {
      domProps: {
        "value": discount
      }
    }, [_vm._v(_vm._s(discount) + "%")])
  }), 0)]), _vm._v(" "), (_vm.atAGlance.data) ? _c('at-a-glance-viewer', {
    attrs: {
      "description": _vm.gender + ' - ' + _vm.discount + '%',
      "name": 'At A Glance Ogden Viewer',
      "tableData": _vm.atAGlance.data
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-30 u-margin-bottom-30"
  }, [_vm._v("\n        Purchase - " + _vm._s(_vm.purchase.description) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "purchase_description",
      "label": "Purchase Description"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.description),
      expression: "purchase.description"
    }, {
      name: "field-control",
      rawName: "v-field-control:purchase_description.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "purchase_description",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "purchase_description",
      "name": "purchase_description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('purchase_description')
    }
  }, [_vm._v("\n                    The purchase description is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "purchase_date",
      "label": "Initial Purchase Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:purchase_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "purchase_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.updateAgeAtPurchase
    },
    model: {
      value: (_vm.purchase.purchaseDate),
      callback: function($$v) {
        _vm.$set(_vm.purchase, "purchaseDate", $$v)
      },
      expression: "purchase.purchaseDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('purchase_date')
    }
  }, [_vm._v("\n                    The purchase date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.purchaseDateValidation
    }
  }, [_vm._v("\n                    The purchase date must be after the date of assumed settlement " + _vm._s(_vm.getClaimInfo('dateOfAssumedSettlement')) + "\n                ")])], 1), _vm._v(" "), (_vm.purchase.type !== 'one') ? _c('control', {
    attrs: {
      "for": "purchase_until",
      "label": "Purchase Until"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.purchaseUntil),
      expression: "purchase.purchaseUntil"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "purchase_until",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.purchase, "purchaseUntil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.purchaseUntilType]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'retirement'
    }
  }, [_vm._v("Retirement")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'life'
    }
  }, [_vm._v("'But For' Life Expectancy")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'own'
    }
  }, [_vm._v("Enter Own Date")])])]) : _vm._e(), _vm._v(" "), (_vm.purchase.purchaseUntil === 'life' && _vm.purchase.type !== 'one') ? _c('life-expectancy', {
    attrs: {
      "label": "Claimant's 'But For' Life Expectancy",
      "person": _vm.thePerson,
      "index": _vm.index,
      "date": _vm.theDate,
      "assumedSettlement": _vm.getClaimInfo('dateOfAssumedSettlement'),
      "type": "claimant"
    },
    on: {
      "update": _vm.updateLife
    }
  }) : _vm._e(), _vm._v(" "), (_vm.purchase.type !== 'one') ? _c('control', {
    attrs: {
      "for": "purchase_end",
      "label": "Purchase End Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:purchase_end.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "purchase_end",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.purchase.purchaseUntil === 'life'
    },
    on: {
      "input": function($event) {
        return _vm.setPurchase()
      }
    },
    model: {
      value: (_vm.purchase.purchaseEnd),
      callback: function($$v) {
        _vm.$set(_vm.purchase, "purchaseEnd", $$v)
      },
      expression: "purchase.purchaseEnd"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('purchase_date')
    }
  }, [_vm._v("\n                    The purchase end date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.purchaseEndDateValidation
    }
  }, [_vm._v("\n                    The purchase end date must be after the purchase date " + _vm._s(_vm.purchase.purchaseDate) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "purchase_multiplicand",
      "label": "Purchase Multiplicand",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.multiplicand),
      expression: "purchase.multiplicand",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:purchase_multiplicand.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "purchase_multiplicand",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "purchase_multiplicand",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.multiplicand)
    },
    on: {
      "focus": function($event) {
        _vm.purchase.multiplicand = _vm.purchase.multiplicand || ''
      },
      "blur": [function($event) {
        _vm.purchase.multiplicand = _vm.purchase.multiplicand || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "multiplicand", _vm._n($event.target.value))
      }, _vm.setPurchase]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('purchase_multiplicand')
    }
  }, [_vm._v("\n                    The purchase multiplicand is required and has to be greater than 0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "mortality_multiplier",
      "label": "Adjust Multiplier for Mortality?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.mortalityMultiplier),
      expression: "purchase.mortalityMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "mortality_multiplier",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.purchase, "mortalityMultiplier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setPurchase]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "purchase_type",
      "label": "Purchase Type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.type),
      expression: "purchase.type"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "purchase_type",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.purchase, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setPurchaseType]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'one'
    }
  }, [_vm._v("One Off")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'recurring'
    }
  }, [_vm._v("Recurring")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'continuous'
    }
  }, [_vm._v("Continuous")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_purchase",
      "label": "Age at Initial Purchase",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.ageAtPurchase),
      expression: "purchase.ageAtPurchase",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:age_at_purchase.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "age_at_purchase",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "age_at_purchase",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.ageAtPurchase)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "ageAtPurchase", _vm._n($event.target.value))
      }, _vm.updateDateOfPurchase],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_at_purchase')
    }
  }, [_vm._v("\n                    Age at purchase is required and has to be greater than 0\n                ")])], 1), _vm._v(" "), (_vm.purchase.type === 'recurring') ? _c('control', {
    attrs: {
      "label": "Purchase Frequency",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.frequency),
      expression: "purchase.frequency",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:purchase_frequency.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "purchase_frequency",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "purchase_frequency",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.frequency)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "frequency", _vm._n($event.target.value))
      }, _vm.setPurchase],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.purchase.type !== 'continuous') ? _c('control', {
    attrs: {
      "for": "resale_option",
      "label": "Is There a Resale Value?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase.resaleOption),
      expression: "purchase.resaleOption"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "resale_option",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.purchase, "resaleOption", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateResaleOption]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]) : _vm._e(), _vm._v(" "), (_vm.purchase.resaleOption) ? _c('control', {
    attrs: {
      "for": "resale_value",
      "label": "Resale Value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.resaleValue),
      expression: "purchase.resaleValue",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:resale_value.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "resale_value",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "resale_value",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.resaleValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "resaleValue", _vm._n($event.target.value))
      }, _vm.setPurchase],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_at_purchase')
    }
  }, [_vm._v("\n                    Resale value is required and has to be greater than 0\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.resaleValueValidation
    }
  }, [_vm._v("\n                    The resale value must be less that the initial purchase multiplicand\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "purchase_total",
      "label": "Total",
      "before-after": "pound",
      "tip-show": _vm.purchase.total > 0,
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "purchase_multiplier",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'purchase',
      "payload": _vm.purchasePayload
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.purchase.total),
      expression: "purchase.total",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:purchase_total.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "purchase_total",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "min": "1",
      "id": "purchase_total",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchase.total)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchase, "total", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deletePurchase
    }
  }, [_vm._v("Remove Purchase")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'multipliers_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-accordion",
    class: {
      'm-accordion__body-map': _vm.bodyMap
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of DIY/Services — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is calculated applying (i) an average annual figure from claims of a similar type, and (ii) assuming loss from date of onset of symptoms to death. Where there is insufficient data within the tool to derive an average annual loss then this is assessed at £1,500.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        General Damages — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('psla-modal-content', {
    attrs: {
      "duration": _vm.duration,
      "age": _vm.age,
      "value": _vm.value
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Miscellaneous (Treatments, etc) — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is based on an average from claims of a similar type. Where there is insufficient data\n        within the tool to derive an average a figure of £5,000 is applied.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ie right-col u-full-height--passport u-d-block",
    class: {
      'p-homepage': _vm.isHomePage, 'right-col--collapse-menu': _vm.isMenuCollapsed
    }
  }, [_c('icons'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid m-div-table__holder-section"
  }, [_c('div', {
    staticClass: "flex-grid__g-3 hide"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Benefit Amount")]), _vm._v(" "), _c('control', {
    attrs: {
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.amount),
      expression: "amount",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number'
      }),
      expression: "{type: 'number'}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "min": "0.00",
      "name": _vm.fieldName + '_value',
      "type": "number"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.amount = _vm.amount || ''
      },
      "blur": [function($event) {
        _vm.amount = _vm.amount || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error(_vm.fieldName + '_value')
    }
  }, [_vm._v("\n                The amount cannot be below 0 and must be a number.\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Deduction")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.include),
      expression: "include"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.include = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimType),
      expression: "claimType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.claimType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all_fatal_types"
    }
  }, [_vm._v("All Fatal Types")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident_estate"
    }
  }, [_vm._v("Fatal Accident Estate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident_dependency"
    }
  }, [_vm._v("Fatal Accident Dependency")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lost_years"
    }
  }, [_vm._v("Lost Years")]), _vm._v(" "), (_vm.diseaseOrAccident !== 'disease') ? _c('option', {
    attrs: {
      "value": "personal_injury"
    }
  }, [_vm._v("Personal Injury")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Retirement Age Calculator",
      "icon": "retirement-calculator"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "gender",
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    attrs: {
      "required": "",
      "name": "gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('gender')
    }
  }, [_vm._v("\n                    The gender is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_birth')
    }
  }, [_vm._v("\n                    The date of birth is required and must be in the format DD/MM/YYYY\n                ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_age",
      "label": "Retirement Age"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.retirementAge),
      expression: "retirementAge"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "retirement_age",
      "type": "number",
      "name": "retirement_age"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_date",
      "label": "Retirement Date"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirementDate),
      expression: "retirementDate"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "retirement_date",
      "type": "text",
      "name": "retirement_date"
    },
    domProps: {
      "value": (_vm.retirementDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementDate = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                This calculator works out when people will reach their State Pension age, under current legislation,\n                based on their gender and date of birth. The Pensions Act 2014 provides for a regular review of the\n                State Pension age, at least once every five years.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                For a " + _vm._s(_vm.gender) + " born on " + _vm._s(_vm.dateOfBirth) + ", the retirement age is "), _c('strong', [_vm._v(_vm._s(_vm.retirementAge))]), _vm._v(" which is reached on "), _c('strong', [_vm._v(_vm._s(_vm.retirementDate))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-full-height",
    on: {
      "click": function($event) {
        return _vm.closeClaimDropdown()
      }
    }
  }, [(_vm.ie) ? _c('div', {
    staticClass: "ie-detection-container"
  }, [_c('div', {
    staticClass: "ie-detection"
  }, [_c('div', {
    staticClass: "ie-detection-text"
  }, [_vm._v("It looks like you are currently using Internet Explorer " + _vm._s(_vm.ieVersion) + ". This website works best in "), _c('a', {
    attrs: {
      "href": "https://www.google.com/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Chrome")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "https://www.mozilla.org/en-GB/firefox/new/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox")]), _vm._v(". Please consider switching for an improved experience.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.hideWarningIE
    }
  }, [_vm._v("Continue in Internet Explorer " + _vm._s(_vm.ieVersion))])])]) : _vm._e(), _vm._v(" "), _c('passport'), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('right-col'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "error_modal",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("\n            Something has gone wrong!\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            We're sorry, there has been a problem with your request."), _c('br'), _c('br'), _vm._v("\n            Rest assured, the BC Legal Development Team has been notified\n            of this issue and will investigate and resolve this as soon as possible.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            If you would like to escalate the issue for immediate attention,\n            please contact "), _c('a', {
    attrs: {
      "href": "mailto:developers@bc-legal.co.uk"
    }
  }, [_vm._v("developers@bc-legal.co.uk")]), _vm._v("\n            explaining the issue"), (!_vm.errorToDisplay.exception) ? _c('span', [_vm._v(".")]) : _c('span', [_vm._v(" and including the error message below:")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errorToDisplay.exception) ? _c('div', {
    staticStyle: {
      "margin-left": "40px",
      "border-left": "5px solid #ccc",
      "padding-left": "40px",
      "padding-bottom": "20px",
      "padding-top": "20px"
    }
  }, [_c('strong', [_c('pre', [_vm._v(_vm._s(_vm.errorToDisplay.exception) + " - " + _vm._s(_vm.errorToDisplay.url))])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.errorToDisplay.message))])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    style: (_vm.heartbeatLoggedOut ? 'display: block' : ''),
    attrs: {
      "name": "loggedout_modal",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("You have been logged out")]), _vm._v(" "), _c('div', {
    staticClass: "o-modal__exception-body"
  }, [_c('pre', [_vm._v("Please log back in to continue")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Select Your Comparison")]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-bottom-30"
  }, [_c('div', {
    staticClass: "a-form-inputs a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from),
      expression: "from"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.from = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "dayOne"
    }
  }, [_vm._v("Day One")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "final"
    }
  }, [_vm._v("Final Reserve")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paid"
    }
  }, [_vm._v("Paid")])])]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("vs")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.to),
      expression: "to"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.to = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.toOptions), function(label, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(label))])
  }), 0)])])]), _vm._v(" "), (_vm.showPaidAlert) ? _c('p', [_c('strong', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("\n            You are comparing paid values but of your " + _vm._s(_vm.totalClaims) + " claims none has been marked as paid.\n            You can still compare against final reserve or make another selection.\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.hasNoClaims) ? _c('p', [_c('strong', [_vm._v("\n            No claims returned for your current search.\n        ")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Period Between Two Dates",
      "icon": "period-dates"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "First Date",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin-slight flex-grid--wrap"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:first_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "first_date",
      modifiers: {
        "required": true
      }
    }],
    ref: "firstDate",
    on: {
      "input": _vm.calculate
    },
    model: {
      value: (_vm.firstDate),
      callback: function($$v) {
        _vm.firstDate = $$v
      },
      expression: "firstDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('first_date')
    }
  }, [_vm._v("\n                        The first date is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.includeFirstDay),
      expression: "options.includeFirstDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.includeFirstDay) ? _vm._i(_vm.options.includeFirstDay, null) > -1 : (_vm.options.includeFirstDay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.includeFirstDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options, "includeFirstDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options, "includeFirstDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options, "includeFirstDay", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include first day")])])], 1)]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Second Date",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin-slight flex-grid--wrap"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:second_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "second_date",
      modifiers: {
        "required": true
      }
    }],
    ref: "secondDate",
    on: {
      "input": _vm.calculate
    },
    model: {
      value: (_vm.secondDate),
      callback: function($$v) {
        _vm.secondDate = $$v
      },
      expression: "secondDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('second_date')
    }
  }, [_vm._v("\n                        The second date is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.includeLastDay),
      expression: "options.includeLastDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.includeLastDay) ? _vm._i(_vm.options.includeLastDay, null) > -1 : (_vm.options.includeLastDay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.includeLastDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options, "includeLastDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options, "includeLastDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options, "includeLastDay", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include last day")])])], 1)]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "precision",
      "label": "Precision"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.dp),
      expression: "options.dp"
    }],
    attrs: {
      "name": "precision",
      "id": "precision"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "dp", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calculate]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Bank Holidays:",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-margin-bottom flex-grid--wrap"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.includeBankHolidays),
      expression: "options.includeBankHolidays"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.includeBankHolidays) ? _vm._i(_vm.options.includeBankHolidays, null) > -1 : (_vm.options.includeBankHolidays)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.includeBankHolidays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options, "includeBankHolidays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options, "includeBankHolidays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options, "includeBankHolidays", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include bank holidays")])])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Weekends:",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-margin-bottom flex-grid--wrap"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.includeWeekends),
      expression: "options.includeWeekends"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.includeWeekends) ? _vm._i(_vm.options.includeWeekends, null) > -1 : (_vm.options.includeWeekends)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.includeWeekends,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options, "includeWeekends", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options, "includeWeekends", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options, "includeWeekends", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include Weekends")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Display Options:",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-margin-bottom flex-grid--wrap flex-grid--row"
  }, [_c('div', {
    staticClass: "p-animated-calc--half p-animated-calc--half-non-block"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.show.years),
      expression: "options.show.years"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.show.years) ? _vm._i(_vm.options.show.years, null) > -1 : (_vm.options.show.years)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.show.years,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.show, "years", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.show, "years", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.show, "years", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Years")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc--half p-animated-calc--half-non-block"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.show.months),
      expression: "options.show.months"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.show.months) ? _vm._i(_vm.options.show.months, null) > -1 : (_vm.options.show.months)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.show.months,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.show, "months", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.show, "months", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.show, "months", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Months")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc--half p-animated-calc--half-non-block"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.show.weeks),
      expression: "options.show.weeks"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.show.weeks) ? _vm._i(_vm.options.show.weeks, null) > -1 : (_vm.options.show.weeks)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.show.weeks,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.show, "weeks", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.show, "weeks", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.show, "weeks", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Weeks")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc--half p-animated-calc--half-non-block"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.show.days),
      expression: "options.show.days"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.show.days) ? _vm._i(_vm.options.show.days, null) > -1 : (_vm.options.show.days)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.show.days,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.show, "days", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.show, "days", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.show, "days", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Days")])])])])]), _vm._v(" "), (_vm.diffBetween) ? _c('h2', [_vm._v("\n                Result\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid p-animated-calc--full-width flex-grid--row"
  }, [_c('div', {
    staticClass: "p-animated-calc--full-width"
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text ",
      "disabled": ""
    },
    domProps: {
      "value": _vm.diffBetween
    }
  })])]), _vm._v(" "), (_vm.optionsEmpty()) ? _c('div', [_vm._v("\n                Please make sure you have selected display options...\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The duration between "), _c('strong', [_vm._v(_vm._s(_vm.firstDate))]), _vm._v(" and "), _c('strong', [_vm._v(_vm._s(_vm.secondDate))]), _vm._v("\n                has been calculated.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                During the period "), _c('strong', [_vm._v(_vm._s(_vm.options.numberOfBankHolidays))]), _vm._v(" number of bank holidays would have\n                occurred. These have been "), (_vm.options.includeBankHolidays) ? _c('span', [_vm._v(" included")]) : _c('span', [_vm._v(" removed")]), _vm._v(" from the calculated total.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                During the period "), _c('strong', [_vm._v(_vm._s(_vm.options.numberOfWeekendDays))]), _vm._v(" number of weekend days would have\n                occurred. These have been "), (_vm.options.includeWeekends) ? _c('span', [_vm._v(" included")]) : _c('span', [_vm._v(" removed")]), _vm._v(" from the calculated total.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The total difference between the two dates is:\n                "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid p-animated-calc--full-width flex-grid--row p-period-between"
  }, [(_vm.options.show.years && !_vm.options.show.months && !_vm.options.show.weeks && !_vm.options.show.days) ? _c('div', [_c('span', {
    staticClass: "p-period-between__period-result"
  }, [_c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.diffYears))])])]) : _c('div', [_c('span', {
    staticClass: "p-period-between__period-result"
  }, [_c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.diffBetween))])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-policy"
  }, [_c('h2', [_vm._v("\n        Disclaimer\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        BC Legal’s ABC Quantum software is provided 'as is' without warranty of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability, suitability for a particular purpose, or non-infringement.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Without limiting the foregoing, BC Legal makes no warranty that:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("the software will meet your requirements")]), _vm._v(" "), _c('li', [_vm._v("the software will be uninterrupted, timely, secure or error-free")]), _vm._v(" "), _c('li', [_vm._v("the results that may be obtained from the use of the software will be effective, accurate or reliable")]), _vm._v(" "), _c('li', [_vm._v("the quality of the software will meet your expectations")]), _vm._v(" "), _c('li', [_vm._v("any errors in the software obtained will be corrected")])]), _vm._v(" "), _c('p', [_vm._v("\n        In no event shall BC Legal be liable to you or any third parties for any special, punitive, incidental, indirect or consequential damages of any kind, or any damages whatsoever, including, without limitation, those resulting from loss of use, data or profits, whether or not BC Legal has been advised of the possibility of such damages, and on any theory of liability, arising out of or in connection with the use of this software.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        The use of the software provided by BC Legal is done at your own discretion and risk and with the agreement that you will be solely responsible for any damage to your computer system or loss of data that results from such activities. No advice or information, whether oral or written, obtained by you from the BC Legal or from the BC Legal website or ABC Quantum software shall create any warranty for the software.\n    ")])])
}]}

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-content ie",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "flex-state-buttons"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('h1', {
    staticClass: "u-margin-top-10"
  }, [_vm._v("\n                Market Analysis\n            ")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-executive-dashboard__summary u-margin-bottom-20"
  }, [_vm._v("\n        The Market Analysis Dashboard will be ready soon..."), _c('br'), _c('br')])])
}]}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('svg', {
    attrs: {
      "id": "asbestos",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 147.8 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M15 0H0v50.6h15V14.8h90.2v90.4H14.8v-39H0V120h120V0zM132.2 104.4h15.6V120h-15.6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "close",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M69.8 60L118 11.8c2.7-2.7 2.7-7.1 0-9.8-2.7-2.7-7.1-2.7-9.8 0L60 50.2 11.8 2C9.1-.7 4.7-.7 2 2-.7 4.7-.7 9.1 2 11.8L50.2 60 2 108.2c-2.7 2.7-2.7 7.1 0 9.8 1.4 1.4 3.1 2 4.9 2s3.5-.7 4.9-2L60 69.8l48.2 48.2c1.4 1.4 3.1 2 4.9 2 1.8 0 3.5-.7 4.9-2 2.7-2.7 2.7-7.1 0-9.8L69.8 60z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "noise",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M113.2 43.3c0-15.5-4.7-30.5-13.4-43.3H86.9C97.3 12 103 27.4 103 43.3c0 36.7-29.8 66.4-66.4 66.4-10.3 0-20.5-2.4-29.7-7v5.2c0 2.2.3 4.3.8 6.4 9.2 3.8 19 5.7 28.9 5.7 42.2 0 76.6-34.4 76.6-76.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M91.7 43.3c0-16.9-7.7-32.8-21-43.3H48.4c23.9 6.6 38 31.3 31.4 55.2-6.6 23.9-31.3 38-55.2 31.4-6.6-1.8-12.7-5.1-17.9-9.7v12.8c25.6 16.4 59.8 9 76.2-16.7 5.8-8.8 8.8-19.2 8.8-29.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.5 76.3c18.3 0 33.1-14.8 33.1-33.1s-14.8-33-33.1-33c-12.6 0-24.2 7.2-29.7 18.6v29c5.5 11.3 17.1 18.5 29.7 18.5zm0-56.9c13.2 0 23.9 10.7 23.9 23.9S49.7 67.2 36.5 67.2 12.6 56.5 12.6 43.3s10.7-23.9 23.9-23.9z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "36.5",
      "cy": "43.3",
      "r": "8.9"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "open",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M99.1 55.7c-1.8 0-3.5-.7-4.9-2L60 19.5 25.8 53.7c-2.7 2.7-7 2.7-9.7 0-2.7-2.7-2.7-7.1 0-9.7L60 0l44 44c2.7 2.7 2.7 7.1 0 9.7-1.4 1.4-3.1 2-4.9 2zM60 120L16 76c-2.7-2.7-2.7-7.1 0-9.7 2.7-2.7 7-2.7 9.7 0L60 100.5l34.2-34.2c2.7-2.7 7-2.7 9.7 0 2.7 2.7 2.7 7.1 0 9.7L60 120z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "passport",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M61.9.2c-.5-.2-1.1-.2-1.7-.2-.6 0-1.2 0-1.7.2C26.1 1.1.1 27.6.1 60.1.1 93.1 27 120 60 120s59.9-26.9 59.9-59.9c0-32.4-25.8-58.9-58-59.9zm48.7 55.3H93.3c-1.1-15.2-7.9-30.2-20.4-44.6 20.4 5.4 35.8 23.1 37.7 44.6zm-55.4 0H36.1c1.2-13.4 7.5-26.8 19.1-39.8v39.8zm0 9.1v39.5C48 96.2 37.7 82.2 36.1 64.6h19.1zm9.9 0h19.1C82.6 82.1 72.3 96.1 65.1 104V64.6zm0-9.1V15.7c11.6 13 18 26.4 19.1 39.8H65.1zM47.5 10.8C35 25.2 28.1 40.2 27 55.5H9.4C11.3 33.8 26.9 16 47.5 10.8zM9.4 64.6H27c1.5 20.1 12.5 35.8 20.8 44.9-20.7-5.2-36.5-23.1-38.4-44.9zm63.2 44.8c8.2-9.1 19.2-24.8 20.7-44.8h17.3c-1.9 21.7-17.5 39.5-38 44.8z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "quantum",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60 0C26.9 0 0 26.9 0 60s26.9 60 60 60 60-26.9 60-60S93.1 0 60 0zm0 101.9c-23.2 0-41.9-18.8-41.9-41.9S36.8 18.1 60 18.1s41.9 18.8 41.9 41.9-18.7 41.9-41.9 41.9z"
    }
  }), _c('path', {
    attrs: {
      "d": "M114.3 117.8c-3.7 3.2-9.4 2.9-12.7-.9l-9.8-11.3c-3.2-3.7-2.9-9.4.9-12.7 3.7-3.2 9.4-2.9 12.7.9l9.8 11.3c3.3 3.7 2.9 9.5-.9 12.7z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("\n    " + _vm._s(_vm.data.heading) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-mini-calc-icons"
  }, [_c('svg', {
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('svg', {
    attrs: {
      "id": "back",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M90.2 42.4H8.5l17.2-19.3c1.1-1.2 1-3.2-.2-4.3-1.2-1.1-3.2-1-4.3.2L1.8 40.7c-2.4 2.6-2.4 6.6 0 9.3l19.4 21.7c.6.7 1.4 1 2.3 1 .7 0 1.4-.3 2-.8 1.2-1.1 1.4-3 .2-4.3L8.5 48.4h81.7c13.1 0 23.7 10.7 23.7 23.7s-10.7 23.7-23.7 23.7H75.8c-1.7 0-3 1.4-3 3s1.4 3 3 3h14.4c16.4 0 29.8-13.4 29.8-29.8 0-16.3-13.4-29.6-29.8-29.6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "close",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M1.3 118.7c-1.7-1.7-1.7-4.6 0-6.3L112.4 1.3c1.7-1.7 4.6-1.7 6.3 0 1.7 1.7 1.7 4.6 0 6.3L7.6 118.7c-1.7 1.7-4.6 1.7-6.3 0z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M112.4 118.7L1.3 7.6C-.4 5.9-.4 3 1.3 1.3s4.6-1.7 6.3 0l111.1 111.1c1.7 1.7 1.7 4.6 0 6.3s-4.6 1.7-6.3 0z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "delete",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M109.1 11.3H76.9V5.6c0-3.1-2.5-5.6-5.6-5.6H48.8c-3.1 0-5.6 2.5-5.6 5.6v5.7H10.9c-1.6 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8h5.2l3.6 92.9c.2 5.7 4.9 10.1 10.5 10.1h59.5c5.7 0 10.3-4.5 10.5-10.1l3.6-92.9h5.2c1.6 0 2.8-1.3 2.8-2.8.1-1.5-1.2-2.8-2.7-2.8zM48.8 5.6h22.4v5.6H48.8V5.6zm45.9 104c-.1 2.6-2.3 4.7-4.9 4.7H30.3c-2.6 0-4.8-2.1-4.9-4.7l-3.6-92.7h76.4l-3.5 92.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M42.8 42.6c0-1.5-1.3-2.8-2.8-2.8-1.6 0-2.8 1.3-2.8 2.9l.9 46.1c0 1.5 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.9l-.9-46.1zM60 39.8c-1.6 0-2.8 1.3-2.8 2.8v46.1c0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8V42.6c0-1.6-1.2-2.8-2.8-2.8zM80.1 39.8c-1.5 0-2.9 1.2-2.9 2.8l-.9 46.1c0 1.6 1.2 2.8 2.8 2.9 1.5 0 2.8-1.2 2.8-2.8l.9-46.1c.1-1.6-1.1-2.9-2.7-2.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "edit",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M16.3 120l-5.4-31.5 59-83.1c2-2.8 4.9-4.6 8.3-5.2 3.4-.6 6.7.2 9.5 2.2l16.2 11.5c2.8 2 4.6 4.9 5.2 8.3.6 3.4-.2 6.7-2.2 9.5l-59 83.1-31.6 5.2zm1.6-29.9l3.8 22.3 22.3-3.8 57.4-80.9c.9-1.3 1.3-2.9 1-4.6-.3-1.6-1.2-3-2.5-4L83.8 7.7c-1.3-.9-2.9-1.3-4.6-1-1.6.3-3 1.2-4 2.5L17.9 90.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "filter",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 120c-9.4 0-16.5-4-16.5-9.2V75.3L0 31.6V20C0 7 30.9 0 60 0s60 7.1 60 20.2v11.6L76.5 75.3v35.5c0 5.2-7.1 9.2-16.5 9.2zM3.9 30l43.5 43.7v37.1c0 2.5 5.4 5.3 12.6 5.3s12.6-2.8 12.6-5.3V73.7l43.5-43.5v-10C116.1 12.5 93 3.9 60 3.9S3.9 12.4 3.9 20v10z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M59.9 37.3c-13 0-25.3-1.6-34.6-4.4-4.5-1.3-8.3-2.9-10.9-4.5-1.8-1.1-2.8-2.1-3.3-2.6L10 24.7l.9-1.3c.6-.9 1.9-2 3.6-3 2.7-1.6 6.4-3.1 10.8-4.5 9.9-2.8 22.2-4.4 34.6-4.4 13 0 25.3 1.6 34.6 4.4 4.5 1.3 8.3 2.9 10.9 4.5 1.8 1.1 2.8 2.1 3.3 2.6l1.4 1.4-1.4 1.4c-.5.5-1.5 1.5-3.3 2.6-2.7 1.6-6.4 3.2-10.8 4.5-10 2.9-22.3 4.4-34.7 4.4zM15.4 24.4c.3.2.7.5 1.1.8 2.2 1.4 5.7 2.9 9.9 4.1 9 2.7 20.9 4.2 33.5 4.2 12.1 0 24-1.5 33.5-4.2 4.1-1.3 7.5-2.7 9.9-4.1.4-.2.7-.5 1-.7-.3-.2-.7-.5-1.1-.7-2.2-1.4-5.7-2.9-9.9-4.1-9-2.7-20.9-4.2-33.5-4.2-12.1 0-24 1.5-33.5 4.2-4.1 1.3-7.5 2.7-9.9 4.1-.4.2-.7.4-1 .6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "print",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.4 39.6H22.6V.3h74.8v39.3zm-69.8-4.9h64.9V5.3H27.6v29.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M99.2 108.3h-6.7V73H27.6v35.3h-6.7C9.3 108.3 0 99 0 87.5v-32C0 44 9.3 34.7 20.8 34.7h78.4c11.5 0 20.8 9.3 20.8 20.8v32c0 11.5-9.3 20.8-20.8 20.8zm-1.8-4.9h1.8c8.8 0 15.9-7.1 15.9-15.9v-32c0-8.8-7.1-15.9-15.9-15.9H20.8c-8.8 0-15.9 7.1-15.9 15.9v32c0 8.8 7.1 15.9 15.9 15.9h1.8V68.1h74.8v35.3z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M2.5 56h115.1v4.9H2.5zM97.4 119.7H22.6V68.1h74.8v51.6zm-69.8-5h64.9V73H27.6v41.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85 90.4H35c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h50c1.4 0 2.5 1.1 2.5 2.5s-1.2 2.5-2.5 2.5zM63.2 102.3H35c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h28.1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.4 2.5z"
    }
  }), _c('g', [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "94",
      "cy": "47.9",
      "r": "3.8"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "download",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M88.4 69.5c-1.2-1.3-3.2-1.5-4.6-.3L63.2 87.6v-84c0-1.8-1.4-3.2-3.2-3.2-1.8 0-3.2 1.4-3.2 3.2v84L36.1 69.2c-1.3-1.2-3.4-1.1-4.6.3-1.2 1.3-1.1 3.4.3 4.6L55 94.8c2.8 2.5 7.1 2.5 9.9 0L88.2 74c.7-.6 1.1-1.5 1.1-2.4 0-.7-.3-1.5-.9-2.1z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.5 119.6h-75C10.1 119.6 0 109.5 0 97.1V71.5c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v25.7c0 8.8 7.2 16 16 16h75.1c8.8 0 16-7.2 16-16V71.5c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v25.7c.1 12.3-10 22.4-22.4 22.4z"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Gross/Net Pension Calculator",
      "icon": "pension"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Fiscal Year"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fiscalYear),
      expression: "fiscalYear"
    }],
    ref: "fiscalYear",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fiscalYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("2019/20")]), _vm._v(" "), _c('option', [_vm._v("2018/19")]), _vm._v(" "), _c('option', [_vm._v("2017/18")]), _vm._v(" "), _c('option', [_vm._v("2016/17")]), _vm._v(" "), _c('option', [_vm._v("2015/16")]), _vm._v(" "), _c('option', [_vm._v("2014/15")]), _vm._v(" "), _c('option', [_vm._v("2013/14")]), _vm._v(" "), _c('option', [_vm._v("2012/13")]), _vm._v(" "), _c('option', [_vm._v("2011/12")]), _vm._v(" "), _c('option', [_vm._v("2010/11")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Net or Gross"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pensionType),
      expression: "pensionType"
    }],
    ref: "pensionType",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pensionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Gross")]), _vm._v(" "), _c('option', [_vm._v("Net")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Pension Income",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.income),
      expression: "income",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "income",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.income)
    },
    on: {
      "focus": function($event) {
        _vm.income = _vm.income || ''
      },
      "blur": [function($event) {
        _vm.income = _vm.income || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.income = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('h2', [_vm._v("\n                    Result\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gross Income",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pension.results.grossIncome),
      expression: "pension.results.grossIncome",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.pension.results.grossIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pension.results, "grossIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Net Income",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pension.results.netIncome),
      expression: "pension.results.netIncome",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.pension.results.netIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pension.results, "netIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Income Tax Paid",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pension.results.taxPaid),
      expression: "pension.results.taxPaid",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.pension.results.taxPaid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pension.results, "taxPaid", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                With a gross pension income of £" + _vm._s(_vm.twoDp(_vm.pension.results.grossIncome || 0)) + ", for the fiscal year of " + _vm._s(_vm.fiscalYear) + ",\n                £" + _vm._s(_vm.twoDp(_vm.pension.results.taxPaid || 0)) + " of income tax would be paid. The breakdown for this calculation is outlined \n                further down this page, noting the personal allowance and tax brackets for the fiscal year selected.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                This results in a Net pension income of £" + _vm._s(_vm.twoDp(_vm.pension.results.netIncome || 0)) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The following chart provides a visual indication of income tax paid on the gross pension:"), _c('br')]), _vm._v(" "), (_vm.pension.results.grossIncome) ? _c('div', {
    staticClass: "chart"
  }, [_c('pie-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Payment ' + (_vm.index + 1) + ' Date',
      "no-flex-margin": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "date",
      "required": ""
    },
    on: {
      "input": _vm.updateInterest
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidDate() || _vm.$error('date')
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY, be after the deceased's date of death\n            (" + _vm._s(_vm.deceasedDod) + ") and be before the interest calculation date\n        ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Amount",
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "max": _vm.remainingTotal,
      "min": "1",
      "name": "value",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = _vm._n($event.target.value)
      }, _vm.updateInterest],
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": [function($event) {
        _vm.value = _vm.value || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            The amount must be at least £1.00 and less than the total past heads of loss \n            remaining total " + _vm._s(_vm.currencyFormat(_vm.remainingTotal)) + "\n        ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisPayment
    }
  }, [_vm._v("Delete This Payment")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__form"
  }, [_c('control', {
    attrs: {
      "label": "Disease or Accident",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])])]), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('control', {
    attrs: {
      "label": "Disease Type",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer")])])]) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident') ? _c('control', {
    attrs: {
      "label": "Accident Type",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gender of Claimant",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Claimant's DOB",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:dob",
      value: (_vm.dobRules),
      expression: "dobRules",
      arg: "dob"
    }],
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dob')
    }
  }, [_vm._v("\n            The person must be born in the past\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Onset of Symptoms",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:osos",
      value: (_vm.oSoSRules),
      expression: "oSoSRules",
      arg: "osos"
    }],
    model: {
      value: (_vm.onsetOfSymptoms),
      callback: function($$v) {
        _vm.onsetOfSymptoms = $$v
      },
      expression: "onsetOfSymptoms"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('osos')
    }
  }, [_vm._v("\n            The symptoms must be before the date of death\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date of Assessment (or assumed)",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:assumed",
      value: (_vm.assumedRules),
      expression: "assumedRules",
      arg: "assumed"
    }],
    model: {
      value: (_vm.assumedSettlement),
      callback: function($$v) {
        _vm.assumedSettlement = $$v
      },
      expression: "assumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('assumed')
    }
  }, [_vm._v("\n            The assessment date must be after death.\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Claimant's Assumed Life Expectancy",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assumedLifeExpectancyMethod),
      expression: "assumedLifeExpectancyMethod"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimants_assumed_dod_type",
      "id": "claimants_assumed_dod_type",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assumedLifeExpectancyMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_years_and_months_left"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_date"
    }
  }, [_vm._v("Enter Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_age_at_death"
    }
  }, [_vm._v("Enter Age at Death (years)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_percentage_of_life"
    }
  }, [_vm._v("% of Normal Life Expectancy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_reduction_in_life"
    }
  }, [_vm._v("% Reduction in Normal Life Expectancy")])])]), _vm._v(" "), (_vm.assumedLifeExpectancyMethod === 'assumed_age_at_death') ? _c('control', {
    attrs: {
      "label": "Claimant's Age at Assumed Death",
      "icon-space": false,
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.assumedAgeAtDeath),
      expression: "assumedAgeAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_age_at_death',
      "name": "claimants_age_at_assumed_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.assumedAgeAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.assumedAgeAtDeath = _vm._n($event.target.value)
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.minAgeRules
    }
  }, [_vm._v("\n            The claimant's age at death is required and should be at least " + _vm._s(_vm.currentAge) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod === 'assumed_years_and_months_left') ? _c('control', {
    attrs: {
      "icon-space": false,
      "label": "Enter Years/Months From Today"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.yearsLeft),
      expression: "yearsLeft",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "years"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.yearsLeft = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, _vm._l((76), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v(_vm._s(year - 1) + " year(s)")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.monthsLeft),
      expression: "monthsLeft",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "months"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.monthsLeft = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                        " + _vm._s(month - 1) + " month(s)\n                    ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod == 'assumed_percentage_of_life') ? _c('control', {
    attrs: {
      "icon-space": false,
      "label": "Percentage of Normal Life Expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy),
      expression: "innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.assumedLifeExpectancyMethod != 'assumed_percentage_of_life',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_of_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerAssumedLifeExpectancy, "percentageOfNormalLifeExpectancy", _vm._n($event.target.value))
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_of_normal_life_expectancy')
    }
  }, [_vm._v("\n            The percentage of normal life expectancy must be number between 1 and 100\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod == 'assumed_reduction_in_life') ? _c('control', {
    attrs: {
      "label": "Percentage Reduction in Normal Life Expectancy",
      "icon-space": false,
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy),
      expression: "innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.assumedLifeExpectancyMethod != 'assumed_reduction_in_life',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_reduction_in_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerAssumedLifeExpectancy, "percentageReductionInNormalLifeExpectancy", _vm._n($event.target.value))
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_reduction_in_normal_life_expectancy')
    }
  }, [_vm._v("\n            The percentage reduction in normal life expectancy must be number between 1 and 100\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "icon-space": false,
      "label": "Claimant's Assumed Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claimants_assumed_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "claimants_assumed_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_date'
    },
    on: {
      "input": _vm.updateAssumedLifeExpectancy
    },
    model: {
      value: (_vm.assumedDateOfDeath),
      callback: function($$v) {
        _vm.assumedDateOfDeath = $$v
      },
      expression: "assumedDateOfDeath"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employed or Retired",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "retired"
    }
  }, [_vm._v("Retired")])])]), _vm._v(" "), (_vm.employmentType == 'employed') ? _c('div', [_c('control', {
    attrs: {
      "label": "Gross Annual Salary",
      "before-after": "pound",
      "icon-space": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salary),
      expression: "salary"
    }],
    attrs: {
      "type": "text",
      "min": "0"
    },
    domProps: {
      "value": (_vm.salary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salary = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.gender) ? _c('salary-finder', {
    attrs: {
      "gender": _vm.gender
    },
    on: {
      "update": _vm.updateSalary
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Procedural Status",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proceduralStatus),
      expression: "proceduralStatus"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.proceduralStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pre-lit"
    }
  }, [_vm._v("Pre-Litigation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "litigated"
    }
  }, [_vm._v("Litigated")])])]), _vm._v(" "), (_vm.showErrorMessage) ? _c('div', [_c('span', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("You must complete all fields.")])]) : _vm._e(), _vm._v("\n    Calculate the results:\n    "), _c('div', [_c('button', {
    staticClass: "a-button u-no-margin",
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "label": "Select Ogden Table Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Assumed Settlement",
      "for": "assumed_settlement"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.claimDetails('assumedSettlement')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Period Between DOD & Settlement",
      "for": "period_between_dod_and_settlement",
      "before-after": "years"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text",
      "id": "period_between_dod_and_settlement"
    },
    domProps: {
      "value": _vm.deceasedDetails('periodDeathToSettlement')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Deceased's Age at Assumed Settlement",
      "for": "deceased_age_at_settlement"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text",
      "id": "deceased_age_at_settlement"
    },
    domProps: {
      "value": _vm.deceasedDetails('ageAtSettlement')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Period from Settlement to End of Dependency",
      "before-after": "years"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text",
      "id": "period_from_settlement_to_end_of_dependency"
    },
    domProps: {
      "value": _vm.roundValue(_vm.periodSettlementToEnd, 2)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Select Ogden Table"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountTable),
      expression: "discountTable"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountTable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Table 1 or 2")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 28
    }
  }, [_vm._v("Table 36")])])]), _vm._v(" "), (_vm.discountTable === 1) ? _c('control', {
    attrs: {
      "label": _vm.table1Or2Label,
      "for": "ogden_table_multiplier",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_multiplier_1",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'table1and2',
      "payload": _vm.multiplierPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.multipliers.table1Or2Multiplier
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.discountTable === 28) ? _c('control', {
    attrs: {
      "label": "Ogden Table 36 Multiplier",
      "for": "ogden_table_multiplier",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_multiplier_28",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'table28',
      "payload": _vm.multiplierPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.multipliers.table28Multiplier
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Ogden Table E Pre-Assessment Discount",
      "for": "ogden_table_pre_assesmentment",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_pre_assesmentment",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'pre',
      "payload": _vm.preAndPostAssessmentPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.multipliers.preAssessmentDiscount
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Ogden Table F Post-Assessment Discount",
      "for": "ogden_table_post_assesmentment",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_post_assesmentment",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'post',
      "payload": _vm.preAndPostAssessmentPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.multipliers.postAssessmentDiscount
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Calculated Income Dependency",
      "for": "calculated_income_dod",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.calculatedIncomeDependency, '')
    }
  })])], 1)]), _vm._v(" "), (_vm.discountTable === 28) ? _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--really-wide"
  }, [_c('div', {
    class: {
      'a-loader--table': !_vm.multiplierTable.length
    }
  }), _vm._v(" "), (_vm.multiplierTable.length) ? _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dates (from–to)")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Number of Dependants")]), _vm._v(" "), (_vm.theMultiplicand.method != 'multiplicand_pounds') ? _c('th', [_vm._v("Dependency Formula")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Dependency Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('th', [_vm._v("Employment Contingency Multiplier")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Discounted Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Dependency Value")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multiplierTable), function(row) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(row.period == 'pre' ? 'Pre-Assessment' : 'Post-Assessment'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.end))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(row.duration, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.numberOfDependants))]), _vm._v(" "), (_vm.theMultiplicand.method == 'multiplicand_default' && row.numberOfDependants == 1) ? _c('td', [_c('svg', {
      attrs: {
        "version": "1.1",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 -3 360 30",
        "width": "360",
        "height": "38"
      }
    }, [_c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 5 10.283)"
      }
    }, [_vm._v("2")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 5 31)"
      }
    }, [_vm._v("3")]), _vm._v(" "), _c('line', {
      staticClass: "a-formula-svg__line",
      attrs: {
        "x1": "0",
        "y1": "15.8",
        "x2": "18",
        "y2": "15.8"
      }
    }), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 23.6665 18.9495)"
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 36.6665 19.283)"
      }
    }, [_vm._v("[ " + _vm._s(_vm.currencyFormat(row.formula.deceasedNet)) + " + " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)) + " ] - " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)))])])]) : _vm._e(), _vm._v(" "), (_vm.theMultiplicand.method == 'multiplicand_default' && row.numberOfDependants > 1) ? _c('td', [_c('svg', {
      attrs: {
        "version": "1.1",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 -3 360 30",
        "width": "360",
        "height": "38"
      }
    }, [_c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 5 18.9495)"
      }
    }, [_vm._v("75%")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 38.6665 18.9495)"
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 48.6665 19.283)"
      }
    }, [_vm._v("[ " + _vm._s(_vm.currencyFormat(row.formula.deceasedNet)) + " + " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)) + " ] - " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)))])])]) : _vm._e(), _vm._v(" "), (_vm.theMultiplicand.method == 'multiplicand_percentage') ? _c('td', [_c('svg', {
      attrs: {
        "version": "1.1",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 -3 360 30",
        "width": "360",
        "height": "38"
      }
    }, [_c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 5 18.9495)"
      }
    }, [_vm._v(_vm._s(_vm.theMultiplicand.percentage) + "%")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 38.6665 18.9495)"
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 48.6665 19.283)"
      }
    }, [_vm._v("[ " + _vm._s(_vm.currencyFormat(row.formula.deceasedNet)) + " + " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)) + " ] - " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)))])])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(row.dependencyMultiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(row.multiplier, 3)))]), _vm._v(" "), _c('td', [_c('em', [_vm._v("Table " + _vm._s(row.period == 'pre' ? 'E' : 'F') + " ")]), _vm._v("— " + _vm._s(_vm.roundValue(row.discountFactor, 2)) + "\n                ")]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.theDeceased.income.multiplier, 2)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.roundValue(row.multiplier, 2)) + " x " + _vm._s(_vm.roundValue(row.discountFactor, 2)) + " "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('span', [_vm._v("x " + _vm._s(_vm.roundValue(_vm.theDeceased.income.multiplier, 2)) + " ")]) : _vm._e(), _vm._v("= " + _vm._s(_vm.roundValue(row.discountedMultiplier, 2)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(row.value)))])])
  }), 0)]) : _vm._e()]) : _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--really-wide"
  }, [_c('div', {
    class: {
      'a-loader--table': !_vm.multiplierTable1and2.length
    }
  }), _vm._v(" "), (_vm.multiplierTable1and2.length) ? _c('div', [_c('h2', {
    staticClass: "a-table--non-white"
  }, [_vm._v("Pre-Assessment (" + _vm._s(_vm.dateFormat(_vm.multiplierTable1and2[0].pre.period_from.date, "DD/MM/YYYY")) + "\n                - " + _vm._s(_vm.dateFormat(_vm.multiplierTable1and2[0].pre.period_to.date, "DD/MM/YYYY")) + ")")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Period (years)")]), _vm._v(" "), _c('th', [_vm._v("Dependants")]), _vm._v(" "), _c('th', [_vm._v("Table 36")]), _vm._v(" "), _c('th', [_vm._v("Split %")]), _vm._v(" "), _c('th', [_vm._v("Table 1 and 2 ")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('th', [_vm._v("Employment Contingency Multiplier")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Discounted Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Loss")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multiplierTable1and2[0].pre.periods), function(period) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.roundValue(period.period, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.dependants)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.table28, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.split, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.table1And2, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.discountFactor, 2)))]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('td', [_vm._v(_vm._s(_vm.theDeceased.income.multiplier))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.discountMultiplier, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.loss)))])])
  }), 0)]), _vm._v(" "), _c('h2', {
    staticClass: "a-table--non-white"
  }, [_vm._v("Post-Assessment (" + _vm._s(_vm.dateFormat(_vm.multiplierTable1and2[0].post.period_from.date, "DD/MM/YYYY")) + " -\n                " + _vm._s(_vm.dateFormat(_vm.multiplierTable1and2[0].post.period_to.date, "DD/MM/YYYY")) + ")")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Period (years)")]), _vm._v(" "), _c('th', [_vm._v("Dependants")]), _vm._v(" "), _c('th', [_vm._v("Table 36")]), _vm._v(" "), _c('th', [_vm._v("Split %")]), _vm._v(" "), _c('th', [_vm._v("Table 1 and 2 ")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('th', [_vm._v("Employment Contingency Multiplier")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Discounted Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Loss")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multiplierTable1and2[0].post.periods), function(period) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.roundValue(period.period, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.dependants)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.table28, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.split, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.table1And2, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.discountFactor, 2)))]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.theDeceased.income.multiplier, 2)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.discountMultiplier, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.loss)))])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'multipliers_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid__g-4 u-flex-grow-none"
  }, [_c('bar-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions,
      "width": 160,
      "height": 90
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Future Loss of Income and Pension Post-Trial & Lost Years — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is determined from the claimant's date of assumed settlement to the claimant's 'but for' date of\n        death.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        For earnings, the multiplicand is assessed using (i) your selected annual gross income for the deceased\n        (converted to Net equivalent by the tool), (ii) assumes the dependent has no income, and (iii) applies\n        the standard dependency formula for assessing the multiplicand dependent on the number of dependents.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Retirement is assumed at age 67. Thereafter a pension dependency multiplicand of £10,000 is applied.\n        This is broadly assessed using data within the UK Government Statistics on Pensions — \n        "), _c('a', {
    attrs: {
      "href": "https://www.gov.uk/government/statistics/pensioners-incomes-series-financial-year-201516",
      "target": "_blank"
    }
  }, [_vm._v("\n            https://www.gov.uk/government/statistics/pensioners-incomes-series-financial-year-201516\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        The period between date of trial/settlement and assumed death is\n        discounted by Table 36 Factor. The multiplier is applied from claimant's\n        assumed death  to 'but for' date of death discounted by Table 35 Factor.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-compare-reserve__claim-table"
  }, [_c('div', {
    staticClass: "p-compare-reserve__claim-table"
  }, [_c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.underLimit.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.underLimit.percent * 100, 2)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.withinLimit.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.withinLimit.percent * 100, 2)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.overLimit.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.overLimit.percent * 100, 2)) + "%")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Total Claims")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Under Set Limit")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Within Set Limit")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Above Set Limit")])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("%")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("%")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("%")])])])])
}]}

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isVisible()) ? _c('div', [_c('timeline', {
    attrs: {
      "steps": this.steps,
      "current": this.current,
      "stepNo": this.stepNo,
      "timeline-steps": "six"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content__mob-main-column"
  }, [_c('router-view')], 1)], 1) : _c('div', {
    staticClass: "a-loader--big__container"
  }, [_c('div', {
    staticClass: "a-loader--big"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-padding-b-30"
  }, [_vm._v("\n        Preview and update the discount rate on a single or multiple claims\n    ")]), _vm._v(" "), _c('book-of-business-search'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    attrs: {
      "disabled": _vm.updateDiscountRate === null
    },
    on: {
      "click": function($event) {
        return _vm.loadPreview()
      }
    }
  }, [_vm._v("\n        Preview\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "a-loader--results"
  }) : _vm._e(), _vm._v(" "), (_vm.preview.data.length) ? _c('div', {
    staticStyle: {
      "margin": "20px 0 0"
    }
  }, [_vm._v("\n        Discount Rate Comparison based on " + _vm._s(_vm.preview.total) + " matching claims.\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-icons",
    staticStyle: {
      "display": "none"
    }
  }, [_c('svg', {
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('svg', {
    attrs: {
      "id": "select-arrow",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M120 30.5L76.8 82.3c-9.5 9.5-24.2 9.5-33.7 0L0 30.5h120z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "add",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M116.9 56.9H63.1V3.1C63.1 1.4 61.7 0 60 0s-3.1 1.4-3.1 3.1v53.8H3.1C1.4 56.9 0 58.3 0 60c0 1.7 1.4 3.1 3.1 3.1h53.8v53.8c0 1.7 1.4 3.1 3.1 3.1s3.1-1.4 3.1-3.1V63.1h53.8c1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.1-3.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "arrow-head",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M3.8 25.8L60 94.2l56.2-68.4"
    }
  }), _c('path', {
    attrs: {
      "d": "M60 98c-1.1 0-2.2-.5-2.9-1.4L.9 28.1c-1.3-1.6-1.1-4 .5-5.3 1.6-1.3 4-1.1 5.3.5l53.4 65 53.4-65c1.3-1.6 3.7-1.8 5.3-.5 1.6 1.3 1.8 3.7.5 5.3L62.9 96.6c-.7.9-1.8 1.4-2.9 1.4z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "calendar",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M43.8 77.7H22.4V56.3h21.4v21.4zM28.2 72h10.4V61.6H28.2V72zM70.4 77.7H49.6V56.3H71v21.4h-.6zM54.8 72h10.4V61.6H54.8V72zM97.6 77.7H76.2V56.3h21.4v21.4zM81.4 72h10.4V61.6H81.4V72zM43.8 104.3H22.4V83h21.4v21.3zm-15.6-5.2h10.4V88.7H28.2v10.4zM70.4 104.3H49.6V83H71v21.4h-.6zm-15.6-5.2h10.4V88.7H54.8v10.4zM97.6 104.3H76.2V83h21.4v21.3zm-16.2-5.2h10.4V88.7H81.4v10.4z"
    }
  }), _c('path', {
    attrs: {
      "d": "M99.1 10.4h-4.7V5.2c0-2.6-2.1-5.2-5.2-5.2H75.7c-2.6 0-5.2 2.1-5.2 5.2v5.2H49.6V5.2c0-2.6-2.1-5.2-5.2-5.2H30.8c-2.6 0-5.2 2.1-5.2 5.2v5.2h-4.2c-8.9 0-16.2 7.3-16.2 16.2v77.7c0 8.9 7.3 15.7 16.2 15.7h77.2c8.9 0 16.2-6.8 16.2-15.7V26.6c0-8.9-7.3-16.2-15.7-16.2zM76.2 5.2h13.6v21.3H76.2V5.2zm-45.4 0h13.6v21.3H30.8V5.2zm78.8 99.1c0 5.7-4.7 10.4-10.4 10.4H21.4c-5.7 0-10.4-4.7-10.4-10.4V42.8h98.6v61.5zm0-66.7H11v-11c0-5.7 4.7-10.4 10.4-10.4h4.2v10.4c0 2.6 2.1 5.2 5.2 5.2h13c3.1 0 5.7-2.1 5.7-5.2V16.2h20.9v10.4c0 2.6 2.1 5.2 5.2 5.2h13.6c3.1 0 5.7-2.1 5.2-5.2V16.2h4.7c5.7 0 10.4 4.7 10.4 10.4v11z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "delete",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M109.1 11.3H76.9V5.6c0-3.1-2.5-5.6-5.6-5.6H48.8c-3.1 0-5.6 2.5-5.6 5.6v5.7H10.9c-1.6 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8h5.2l3.6 92.9c.2 5.7 4.9 10.1 10.5 10.1h59.5c5.7 0 10.3-4.5 10.5-10.1l3.6-92.9h5.2c1.6 0 2.8-1.3 2.8-2.8.1-1.5-1.2-2.8-2.7-2.8zM48.8 5.6h22.4v5.6H48.8V5.6zm45.9 104c-.1 2.6-2.3 4.7-4.9 4.7H30.3c-2.6 0-4.8-2.1-4.9-4.7l-3.6-92.7h76.4l-3.5 92.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M42.8 42.6c0-1.5-1.3-2.8-2.8-2.8-1.6 0-2.8 1.3-2.8 2.9l.9 46.1c0 1.5 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.9l-.9-46.1zM60 39.8c-1.6 0-2.8 1.3-2.8 2.8v46.1c0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8V42.6c0-1.6-1.2-2.8-2.8-2.8zM80.1 39.8c-1.5 0-2.9 1.2-2.9 2.8l-.9 46.1c0 1.6 1.2 2.8 2.8 2.9 1.5 0 2.8-1.2 2.8-2.8l.9-46.1c.1-1.6-1.1-2.9-2.7-2.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "download",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M88.4 69.5c-1.2-1.3-3.2-1.5-4.6-.3L63.2 87.6v-84c0-1.8-1.4-3.2-3.2-3.2-1.8 0-3.2 1.4-3.2 3.2v84L36.1 69.2c-1.3-1.2-3.4-1.1-4.6.3-1.2 1.3-1.1 3.4.3 4.6L55 94.8c2.8 2.5 7.1 2.5 9.9 0L88.2 74c.7-.6 1.1-1.5 1.1-2.4 0-.7-.3-1.5-.9-2.1z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.5 119.6h-75C10.1 119.6 0 109.5 0 97.1V71.5c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v25.7c0 8.8 7.2 16 16 16h75.1c8.8 0 16-7.2 16-16V71.5c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v25.7c.1 12.3-10 22.4-22.4 22.4z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "formula",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M30.4 120L16.7 69.4H5c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3h18.2l7.7 28.4L58.4 0H115c2.4 0 4.3 1.9 4.3 4.3s-1.9 4.3-4.3 4.3H64.8L30.4 120z"
    }
  }), _c('path', {
    attrs: {
      "d": "M88.5 51.4l9.4-11.9c1.5-1.9 1.1-4.5-.7-6-1.9-1.5-4.5-1.1-6 .7l-8.1 10.3L75 34.2c-1.5-1.9-4.1-2.2-6-.7-1.9 1.5-2.2 4.1-.7 6l9.4 11.9-9.4 11.9c-1.5 1.9-1.1 4.5.7 6 .8.6 1.7.9 2.6.9 1.3 0 2.5-.6 3.4-1.6l8.1-10.3 8.1 10.3c.8 1.1 2.1 1.6 3.4 1.6.9 0 1.8-.3 2.6-.9 1.9-1.5 2.2-4.1.7-6l-9.4-11.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "info",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60 0C26.8 0 0 26.8 0 60s26.8 60 60 60 60-26.8 60-60S93.2 0 60 0zm0 109.4c-26.8 0-49.4-21.9-49.4-49.4 0-26.8 21.9-49.4 49.4-49.4s49.4 21.9 49.4 49.4c0 26.8-22.6 49.4-49.4 49.4z"
    }
  }), _c('path', {
    attrs: {
      "d": "M60 83.3c-4.2 0-7.1 3.5-7.1 7.1 0 4.2 3.5 7.1 7.1 7.1s7.1-3.5 7.1-7.1-2.9-7.1-7.1-7.1zM60 21.9c-11.3 0-19.8 9.2-19.8 19.8 0 2.8 2.1 5.6 5.6 5.6 2.8 0 5.6-2.1 5.6-5.6 0-4.9 4.2-9.2 9.2-9.2s9.2 4.2 9.2 9.2-4.2 9.2-9.2 9.2c-3.5 0-6.4 2.8-6.4 5.6v10.6c0 2.8 2.1 5.6 5.6 5.6s5.6-2.1 5.6-5.6v-5.6c8.5-2.1 14.8-9.9 14.8-19.1-.4-11.3-8.9-20.5-20.2-20.5z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "logo",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 400 53.8",
      "width": "400",
      "height": "54"
    }
  }, [_c('path', {
    attrs: {
      "d": "M26.4 0C11.8 0 0 11.8 0 26.4c0 14.5 11.8 26.4 26.4 26.4S52.8 41 52.8 26.4C52.7 11.8 40.9 0 26.4 0m0 44.8C16.2 44.8 8 36.5 8 26.4 8 16.2 16.2 8 26.4 8s18.4 8.3 18.4 18.4c0 10.1-8.2 18.4-18.4 18.4",
      "fill": "#4a89e5"
    }
  }), _c('path', {
    attrs: {
      "d": "M50.9 52.4c-1.6 1.4-4.1 1.3-5.6-.4L41 47c-1.4-1.6-1.3-4.1.4-5.6 1.6-1.4 4.1-1.3 5.6.4l4.3 5c1.4 1.6 1.2 4.2-.4 5.6",
      "fill": "#4a89e5"
    }
  }), _c('g', [_c('path', {
    attrs: {
      "d": "M108.1 41.9c0 .7-.3 1.2-.8 1.7s-1.2.7-1.8.7c-.5 0-.9-.1-1.3-.4-.4-.3-.7-.6-.9-1.1l-3.5-7.9H80.4L77 42.8c-.2.5-.5.9-.9 1.1-.4.3-.9.4-1.3.4-.7 0-1.3-.2-1.9-.7-.5-.5-.8-1-.8-1.7 0-.3.1-.6.3-1.1L87.1 8.3c.2-.6.6-1 1.2-1.3.5-.3 1.1-.5 1.7-.5s1.2.2 1.7.5.9.8 1.2 1.3l14.9 32.5c.2.5.3.8.3 1.1zM82.4 30.5h15.5L90.1 13l-7.7 17.5zM140.6 28.1c1.2 1.5 1.8 3.5 1.8 5.8 0 3.2-1.1 5.7-3.3 7.5-2.2 1.8-5.3 2.7-9.2 2.7h-13.4c-.8 0-1.5-.2-2-.7-.5-.5-.7-1.1-.7-1.9v-32c0-.8.2-1.5.7-1.9.5-.5 1.1-.7 2-.7h12.9c3.8 0 6.8.9 9 2.6 2.2 1.7 3.2 4.1 3.2 7.1 0 2-.5 3.7-1.6 5.1-1 1.4-2.5 2.5-4.4 3.2 2.1.6 3.8 1.6 5 3.2zM119 22.9h9.4c5.2 0 7.8-2 7.8-5.9 0-2-.6-3.4-1.9-4.4-1.3-.9-3.2-1.4-5.9-1.4H119v11.7zm16.2 15.3c1.3-1 1.9-2.5 1.9-4.6 0-2.1-.6-3.7-1.9-4.7-1.3-1-3.3-1.6-5.9-1.6H119v12.3h10.2c2.8 0 4.8-.4 6-1.4zM156.4 42.1c-2.6-1.5-4.7-3.7-6.1-6.6-1.4-2.9-2.1-6.3-2.1-10.2 0-3.9.7-7.2 2.1-10.1 1.4-2.9 3.4-5.1 6.1-6.6 2.6-1.5 5.7-2.3 9.3-2.3 2.3 0 4.5.4 6.6 1.1 2.1.7 3.9 1.8 5.4 3.1.7.5 1 1.2 1 2.1 0 .6-.2 1.2-.5 1.6-.4.4-.8.7-1.3.7-.6 0-1.2-.2-1.7-.7-1.7-1.3-3.2-2.2-4.6-2.7-1.4-.5-3-.8-4.7-.8-3.9 0-6.8 1.2-8.9 3.7-2.1 2.5-3.1 6.1-3.1 10.8 0 4.7 1 8.3 3.1 10.8s5 3.7 8.9 3.7c1.7 0 3.2-.3 4.6-.8 1.4-.5 3-1.4 4.7-2.6.7-.5 1.3-.7 1.7-.7.5 0 .9.2 1.3.7.4.4.5 1 .5 1.6 0 .9-.3 1.6-1 2.1-1.5 1.4-3.4 2.4-5.4 3.1-2.1.7-4.3 1.1-6.6 1.1-3.6.2-6.7-.5-9.3-2.1zM213.8 50.1c.3.5.5 1 .5 1.5 0 .6-.2 1.2-.7 1.6-.5.4-1.1.6-1.7.6-1.1 0-2-.5-2.7-1.6l-3.1-5.1c-1.1-1.8-3-2.7-5.5-2.7-3.5 0-6.6-.8-9.2-2.3-2.6-1.5-4.6-3.7-6-6.6-1.4-2.8-2.1-6.2-2.1-10.1 0-3.9.7-7.3 2.1-10.2 1.4-2.9 3.4-5.1 6-6.6s5.7-2.3 9.2-2.3c3.6 0 6.6.8 9.2 2.3 2.6 1.5 4.6 3.7 6 6.6 1.4 2.9 2.1 6.2 2.1 10.1 0 4.3-.9 8-2.6 11.1-1.8 3.1-4.2 5.3-7.4 6.6 1.5.5 2.8 1.7 4 3.5l1.9 3.6zm-21.9-13.9c2.1 2.5 4.9 3.8 8.6 3.8 3.7 0 6.6-1.3 8.7-3.8 2.1-2.5 3.1-6.1 3.1-10.8 0-4.7-1-8.3-3.1-10.8s-5-3.8-8.7-3.8c-3.7 0-6.6 1.3-8.6 3.8-2.1 2.5-3.1 6.1-3.1 10.8 0 4.7 1 8.3 3.1 10.8zM246.4 18.4c.5.5.7 1.1.7 1.9v21.5c0 .7-.2 1.3-.7 1.8-.5.5-1.1.7-2 .7-.7 0-1.3-.2-1.8-.7-.5-.4-.7-1-.7-1.8v-2c-.8 1.5-1.9 2.6-3.3 3.4-1.4.8-3 1.2-4.8 1.2-6.3 0-9.4-3.4-9.4-10.3V20.3c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 2-.7.8 0 1.5.2 1.9.7.5.5.7 1.1.7 1.9V34c0 2.1.4 3.6 1.3 4.6.8 1 2.1 1.5 3.9 1.5 2.1 0 3.7-.7 5-2 1.2-1.3 1.9-3.1 1.9-5.3V20.3c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 2-.7.8.1 1.5.3 1.9.7zM273 20.2c1.7 1.7 2.5 4.3 2.5 7.9v13.7c0 .8-.2 1.4-.7 1.9-.5.4-1.1.7-1.9.7-.8 0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.8v-2c-.7 1.5-1.7 2.6-3 3.4-1.3.8-2.9 1.2-4.6 1.2-1.7 0-3.2-.3-4.6-1-1.4-.7-2.5-1.6-3.3-2.9-.8-1.2-1.2-2.6-1.2-4.1 0-1.9.5-3.3 1.5-4.4 1-1.1 2.6-1.8 4.8-2.3 2.2-.5 5.3-.7 9.2-.7h1.2v-1.5c0-2-.4-3.4-1.2-4.3-.8-.9-2.1-1.3-3.9-1.3-1.2 0-2.4.2-3.5.5s-2.3.8-3.6 1.4c-.9.5-1.6.8-2 .8-.5 0-1-.2-1.3-.6-.3-.4-.5-.9-.5-1.5 0-.5.1-1 .4-1.4.3-.4.8-.8 1.5-1.2 1.2-.7 2.7-1.2 4.3-1.6 1.7-.4 3.3-.6 4.8-.6 3.4-.2 6 .7 7.6 2.4zm-4.5 18.3c1.2-1.3 1.8-3 1.8-5.1V32h-.9c-2.7 0-4.9.1-6.3.4-1.5.2-2.5.7-3.2 1.2-.6.6-.9 1.4-.9 2.5 0 1.3.5 2.3 1.4 3.1.9.8 2.1 1.2 3.4 1.2 1.9 0 3.5-.6 4.7-1.9zM305.9 28v13.7c0 .8-.2 1.4-.7 1.9-.5.4-1.1.7-2 .7-.8 0-1.5-.2-1.9-.7-.5-.5-.7-1.1-.7-1.8V28.3c0-2.2-.4-3.8-1.3-4.8s-2.2-1.5-4-1.5c-2.1 0-3.9.7-5.2 2-1.3 1.3-2 3.1-2 5.4v12.4c0 .8-.2 1.4-.7 1.8-.5.5-1.1.7-1.9.7-.8 0-1.5-.2-2-.7-.5-.5-.7-1.1-.7-1.8V20.3c0-.7.3-1.3.8-1.8s1.2-.7 1.9-.7c.8 0 1.4.2 1.8.7.5.5.7 1.1.7 1.8v2.2c.8-1.5 2-2.7 3.5-3.5 1.5-.8 3.2-1.2 5.1-1.2 6.2-.2 9.3 3.3 9.3 10.2zM327.5 40.8c.3.3.5.8.5 1.4 0 .7-.3 1.2-.8 1.6-.5.4-1.3.5-2.4.4l-1.4-.1c-2.8-.2-5-1.1-6.4-2.6-1.4-1.5-2.1-3.8-2.1-6.8V22.4h-3.2c-1.5 0-2.3-.7-2.3-2.1 0-.6.2-1.1.6-1.5.4-.4 1-.6 1.7-.6h3.2v-5.4c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 1.9-.7s1.5.2 2 .7c.5.5.7 1.1.7 1.9v5.4h5.2c.7 0 1.3.2 1.7.6.4.4.6.9.6 1.5 0 .7-.2 1.2-.6 1.5-.4.4-1 .5-1.7.5h-5.2v12.8c0 1.7.3 2.9 1 3.6.7.8 1.7 1.2 3.1 1.3l1.5.1c.8.2 1.3.4 1.7.7zM353.7 18.4c.5.5.7 1.1.7 1.9v21.5c0 .7-.2 1.3-.7 1.8-.5.5-1.1.7-2 .7-.7 0-1.3-.2-1.8-.7-.5-.4-.7-1-.7-1.8v-2c-.8 1.5-1.9 2.6-3.3 3.4-1.4.8-3 1.2-4.8 1.2-6.3 0-9.4-3.4-9.4-10.3V20.3c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 2-.7.8 0 1.5.2 1.9.7.5.5.7 1.1.7 1.9V34c0 2.1.4 3.6 1.3 4.6.8 1 2.1 1.5 3.9 1.5 2.1 0 3.7-.7 5-2 1.2-1.3 1.9-3.1 1.9-5.3V20.3c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 2-.7.7.1 1.4.3 1.9.7zM400 28v13.7c0 .8-.2 1.4-.7 1.9s-1.1.7-2 .7c-.8 0-1.4-.2-1.9-.7s-.7-1.1-.7-1.9V28.1c0-2.1-.4-3.7-1.2-4.7-.8-1-2-1.5-3.6-1.5-1.9 0-3.5.7-4.6 2-1.1 1.3-1.7 3.1-1.7 5.4v12.4c0 .8-.2 1.4-.7 1.9-.5.4-1.1.7-2 .7-.8 0-1.4-.2-1.9-.7s-.7-1.1-.7-1.9V28.1c0-2.1-.4-3.7-1.2-4.7-.8-1-2-1.5-3.6-1.5-1.9 0-3.5.7-4.6 2s-1.7 3.1-1.7 5.4v12.4c0 .8-.2 1.4-.7 1.9s-1.1.7-1.9.7c-.8 0-1.4-.2-1.9-.7s-.8-1.1-.8-1.9V20.3c0-.8.3-1.4.8-1.8.5-.5 1.2-.7 1.9-.7s1.3.2 1.8.7c.5.4.7 1 .7 1.8v2c.8-1.5 1.8-2.6 3.2-3.4 1.4-.8 3-1.2 4.7-1.2 2 0 3.6.4 4.9 1.2 1.3.8 2.2 2.1 2.9 3.7.8-1.5 1.9-2.7 3.4-3.6 1.5-.9 3.2-1.3 5.2-1.3 5.7-.1 8.6 3.4 8.6 10.3z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "bc-logo",
      "viewBox": "0 0 185 52",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.3 31.8h-9V.5C4.1.3 6.9.2 8.6.2c3.1 0 5.5.7 7.2 2 1.7 1.3 2.6 3.2 2.6 5.7 0 1.5-.5 2.8-1.6 4-1.1 1.2-2.3 1.9-3.6 2.2 2.5.6 4.3 1.6 5.4 3 1.1 1.4 1.7 3.3 1.7 5.6 0 2.8-1 4.9-3 6.6-2.1 1.7-4.7 2.5-8 2.5zM4.6 4v9c.9.1 2 .1 3.4.1 4.1 0 6.1-1.6 6.1-4.9 0-2.9-1.9-4.3-5.6-4.3-1.3-.1-2.6-.1-3.9.1zm0 12.3v11.9c1.5.1 2.6.2 3.4.2 2.7 0 4.7-.5 5.9-1.5 1.2-1 1.9-2.6 1.9-4.8 0-2-.6-3.5-1.8-4.5-1.2-1-3.2-1.5-5.9-1.5 0 .1-3.5.2-3.5.2zM45.4 1.7L44 5.3c-1.4-1-3.5-1.5-6.5-1.5-2.8 0-5 1.2-6.7 3.5s-2.5 5.4-2.5 9.1c0 3.6.9 6.5 2.6 8.7 1.7 2.2 3.9 3.3 6.6 3.3 3 0 5.2-1 6.8-3.1l2.4 3.3c-2.5 2.5-5.7 3.7-9.6 3.7-4.1 0-7.4-1.5-9.7-4.4-2.4-2.9-3.5-6.8-3.5-11.7 0-4.7 1.3-8.6 3.8-11.6C30.1 1.5 33.3 0 37.3 0c3.4 0 6.1.6 8.1 1.7zm19.4 30.1V.5h4.3V28h14.2v3.8H64.8zM91.4 4.4v8.7h10.4v3.6H91.4V28h14.3v3.8H87.1V.5H106v3.8H91.4zm41.1-1.7l-1.8 3.5c-2.2-1.6-4.3-2.4-6.4-2.4-3.3 0-5.9 1.2-7.8 3.5-1.9 2.3-2.9 5.4-2.9 9.2 0 3.6.9 6.5 2.8 8.7 1.9 2.2 4.4 3.3 7.6 3.3 2.3 0 4.1-.7 5.6-2.1v-7.3h-4.4v-3.6h8.7v13.6c-1.1 1-2.7 1.7-4.8 2.3-2 .6-4 .9-6 .9-4.3 0-7.8-1.5-10.3-4.4-2.5-2.9-3.8-6.8-3.8-11.7 0-4.8 1.4-8.8 4.1-11.8 2.8-3 6.5-4.5 11.2-4.5 3.5.1 6.2 1 8.2 2.8zm25.9 29.1l-2.2-6.6h-11.7l-2.3 6.6h-4.8L150.2.1h1.1l11.9 31.7h-4.8zm-7.9-23.5l-4.9 13.8h9.4l-4.5-13.8zm16 23.5V.5h4.3V28H185v3.8h-18.5z",
      "fill": "#5b6d83"
    }
  }), _c('path', {
    attrs: {
      "d": "M3 51.8H0V41.4c1.3-.1 2.2-.1 2.8-.1 1 0 1.8.2 2.4.7.5.4.8 1 .8 1.9 0 .5-.2.9-.5 1.3-.4.4-.8.6-1.2.8.8.2 1.4.5 1.8 1 .4.5.6 1.1.6 1.9 0 .9-.3 1.7-1 2.2-.7.4-1.6.7-2.7.7zm-1.6-9.3v3h1.1c1.4 0 2-.5 2-1.7 0-1-.6-1.4-1.9-1.4-.4.1-.8.1-1.2.1zm0 4.1v4c.5 0 .9.1 1.1.1.9 0 1.5-.2 2-.5.4-.3.6-.9.6-1.6 0-.7-.2-1.2-.6-1.5-.4-.3-1.1-.5-2-.5H1.4zm17.2 5.2l-2.8-4.5c-.3 0-.8 0-1.5-.1v4.6h-1.4V41.4c.1 0 .4 0 1.1-.1.5 0 1 0 1.5-.1 2.5 0 3.8 1 3.8 3 0 .7-.2 1.2-.6 1.8-.4.5-.9.9-1.5 1l3 4.8h-1.6zm-4.4-9.1V46c.3 0 .7.1 1 .1.9 0 1.5-.1 1.9-.4.4-.3.6-.8.6-1.5 0-.6-.2-1-.6-1.3-.4-.3-1.1-.4-2-.4-.3.1-.6.1-.9.2zm11.7 9.1V41.4h1.4v10.4h-1.4zM41 52l-5.4-7.6v7.5h-1.4V41.4h.6l5.3 7.2v-7.2h1.4V52H41zm14.3-9.9l-.6 1.2c-.7-.5-1.4-.8-2.1-.8-1.1 0-2 .4-2.6 1.2-.6.8-1 1.8-1 3.1 0 1.2.3 2.2.9 2.9.6.7 1.5 1.1 2.6 1.1.8 0 1.4-.2 1.9-.7v-2.4h-1.5v-1.2h2.9V51c-.4.3-.9.6-1.6.8-.6.2-1.3.3-2 .3-1.5 0-2.6-.5-3.4-1.5-.8-1-1.3-2.3-1.3-3.9s.5-2.9 1.4-3.9c.9-1 2.2-1.5 3.7-1.5 1.1-.1 2 .2 2.7.8zm7.3 9.7V41.4H64v10.4h-1.4zm15 .2l-5.4-7.6v7.5h-1.4V41.4h.6l5.3 7.2v-7.2h1.4V52h-.5zm14.3-9.9l-.6 1.2c-.7-.5-1.4-.8-2.1-.8-1.1 0-2 .4-2.6 1.2-.6.8-1 1.8-1 3.1 0 1.2.3 2.2.9 2.9.6.7 1.5 1.1 2.6 1.1.8 0 1.4-.2 1.9-.7v-2.4h-1.5v-1.2h2.9V51c-.4.3-.9.6-1.6.8-.6.2-1.3.3-2 .3-1.5 0-2.6-.5-3.4-1.5-.8-1-1.3-2.3-1.3-3.9s.5-2.9 1.4-3.9c.9-1 2.2-1.5 3.7-1.5 1.1-.1 2 .2 2.7.8zm22.6-.3L114 43c-.5-.3-1.2-.5-2.2-.5-.9 0-1.7.4-2.2 1.2-.6.8-.8 1.8-.8 3s.3 2.2.9 2.9 1.3 1.1 2.2 1.1c1 0 1.7-.3 2.3-1l.8 1.1c-.8.8-1.9 1.2-3.2 1.2-1.4 0-2.5-.5-3.2-1.5-.8-1-1.2-2.3-1.2-3.9s.4-2.8 1.3-3.9c.8-1 1.9-1.5 3.3-1.5 1 0 1.9.2 2.5.6zm6.5 10V41.4h1.4v9.1h4.7v1.3H121zm16.5 0l-.7-2.2h-3.9l-.8 2.2h-1.6l4.3-10.6h.4l4 10.6h-1.7zm-2.6-7.8l-1.6 4.6h3.1l-1.5-4.6zm14.7 7.8l-2.8-4.5c-.3 0-.8 0-1.5-.1v4.6h-1.4V41.4c.1 0 .4 0 1.1-.1.5 0 1 0 1.5-.1 2.5 0 3.8 1 3.8 3 0 .7-.2 1.2-.6 1.8-.4.5-.9.9-1.4 1l3 4.8h-1.7zm-4.3-9.1V46c.3 0 .7.1 1 .1.9 0 1.5-.1 1.9-.4.4-.3.6-.8.6-1.5 0-.6-.2-1-.6-1.3-.4-.3-1.1-.4-2-.4-.2.1-.5.1-.9.2zm11.7 9.1V41.4h1.4v10.4H157zm11.8-9.1v9.1h-1.4v-9.2H164v-1.3h8.3v1.3h-3.5v.1zm12.4 4.4v4.7h-1.4v-4.7l-3.4-5.8h1.5l2.6 4.6 2.6-4.6h1.5l-3.4 5.8z",
      "fill": "#2e3234"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "minus",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M116.9 63.1H3.1C1.4 63.1 0 61.7 0 60c0-1.7 1.4-3.1 3.1-3.1h113.8c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "minus-large",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M5.5 60h109M114.5 65.5H5.5C2.4 65.5 0 63 0 60s2.4-5.5 5.5-5.5h109.1c3 0 5.5 2.4 5.5 5.5s-2.5 5.5-5.6 5.5z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "save",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.7 0H1.3v120h117.5V21L97.7 0zM86.9 4.9v34.3H28.2V4.9h58.7zM23.3 115.1V68.6h71v46.5h-71zm90.6 0H99.2V63.7H18.4v51.4H6.1V4.9h17.1v39.2h68.6V4.9h3.9l18.2 18.2v92z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M33.1 80.8h17.1c1.4 0 2.4-1.1 2.4-2.4S51.5 76 50.2 76H33.1c-1.4 0-2.4 1.1-2.4 2.4s1 2.4 2.4 2.4zM57.6 85.7H33.1c-1.4 0-2.4 1.1-2.4 2.4 0 1.4 1.1 2.4 2.4 2.4h24.5c1.4 0 2.4-1.1 2.4-2.4 0-1.3-1.1-2.4-2.4-2.4zM63.2 86.4c-.4.5-.7 1.1-.7 1.7 0 .6.3 1.3.7 1.7.5.4 1.1.7 1.7.7.6 0 1.3-.3 1.7-.7.4-.5.7-1.1.7-1.7 0-.6-.3-1.3-.7-1.7-.9-.9-2.5-.9-3.4 0zM82 9.8H67.3v24.5H82V9.8zm-4.9 19.6h-4.9V14.7h4.9v14.7z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "triangle",
      "viewBox": "0 0 138.6 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M69.3 0l34.6 60 34.7 60H0l34.6-60z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "triangle-down",
      "viewBox": "0 0 138.6 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M69.3 120L34.7 60 0 0h138.6L104 60l-34.7 60z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "refresh",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M118.4 27.7c-1.3-.5-2.7.2-3.2 1.5L111 40.4c-4.5-13.1-13.7-23.8-26.1-30-12.5-6.3-26.8-7.4-40.1-3C22.9 14.6 8.1 35.8 8.7 58.9c0 1.4 1.2 2.4 2.5 2.4h.1c1.4 0 2.5-1.2 2.4-2.6-.6-20.9 12.8-40 32.6-46.5 12.1-4 24.9-3 36.3 2.7 11.3 5.7 19.8 15.5 23.7 27.6.1.2.1.3.2.5l-11.8-4.3c-1.3-.5-2.7.2-3.2 1.5s.2 2.7 1.5 3.2l17.2 6.3c.3.1.6.2.9.2.4 0 .7-.1 1.1-.2.6-.3 1.1-.8 1.3-1.4l6.3-17.2c.5-1.5-.1-2.9-1.4-3.4zM109.6 44h.1-.1zM108.7 58.7c-1.4 0-2.5 1.2-2.4 2.6.6 20.9-12.8 40-32.6 46.5-24.9 8.2-51.8-5.4-60-30.3-.1-.2-.1-.3-.2-.5l11.8 4.3c1.3.5 2.7-.2 3.2-1.5s-.2-2.7-1.5-3.2L9.7 70.4c-1.3-.5-2.7.2-3.2 1.5L.2 89.1c-.5 1.3.2 2.7 1.5 3.2.3.1.6.2.9.2 1 0 2-.6 2.4-1.6l4-11.3c7.4 21.8 27.9 35.7 49.8 35.7 5.4 0 11-.9 16.4-2.6 21.9-7.2 36.8-28.4 36.1-51.4-.1-1.5-1.2-2.6-2.6-2.6zM10.3 76c.1 0 0 0 0 0z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "warning",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M118.5 95.2L69.2 13.6c-1.9-3.2-5.5-5.2-9.2-5.2s-7.3 2-9.2 5.2L1.5 95.2c-2 3.3-2.1 7.5-.2 10.9 1.9 3.4 5.5 5.5 9.4 5.5h98.4c3.9 0 7.5-2.1 9.4-5.5 2-3.4 2-7.5 0-10.9zm-6.7 7.1c-.5.9-1.5 1.5-2.6 1.5H10.8c-1.1 0-2.1-.6-2.6-1.5s-.5-2.1 0-3l49.2-81.6c.5-.9 1.5-1.4 2.5-1.4s2 .6 2.5 1.4l49.2 81.6c.7.9.7 2 .2 3z"
    }
  }), _c('path', {
    attrs: {
      "d": "M60 40.5c-3 0-5.3 1.6-5.3 4.4 0 8.6 1 21 1 29.6 0 2.2 2 3.2 4.3 3.2 1.7 0 4.2-.9 4.2-3.2 0-8.6 1-21 1-29.6.1-2.8-2.3-4.4-5.2-4.4zM60 82.8c-3.2 0-5.6 2.5-5.6 5.6 0 3 2.4 5.6 5.6 5.6 3 0 5.5-2.6 5.5-5.6 0-3.1-2.5-5.6-5.5-5.6z"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "pastLossOfEarnings"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            Pre-accident Earnings\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Is there any past loss of earnings?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "past_loss_of_earnings",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pastLossOfEarnings = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (_vm.pastLossOfEarnings) ? _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Calculate past losses or enter your own\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownPastLosses),
      expression: "ownPastLosses"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "own_past_losses",
      "name": "own_past_losses",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ownPastLosses = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Calculate for me")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Enter your own figure")])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.pastLossOfEarnings && !_vm.ownPastLosses) ? _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                            Employment Income\n                        ")]), _vm._v(" "), _c('icon-tooltip', {
    attrs: {
      "tooltip-name": "pre-accident-income",
      "tooltip-text": "This is the claimant's income at the date of the accident.",
      "side": "right",
      "text-width": "200",
      "icon-type": "info",
      "icon-colour": "m-icon--dark"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employment_income",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.employmentIncome),
      expression: "employmentIncome",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "employment_income",
      "id": "employment_income",
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.employmentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || ''
      },
      "blur": [function($event) {
        _vm.employmentIncome = _vm.employmentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.employmentIncome = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('employment_income')
    }
  }, [_vm._v("\n                            This is the claimant's income at the date of the accident is required\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Net/Gross\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employment_net_gross",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentNetGross),
      expression: "employmentNetGross"
    }],
    attrs: {
      "disabled": _vm.disableNetGross
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Total Net Income\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "total_net_income",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.totalNetIncome),
      expression: "totalNetIncome"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.totalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalNetIncome = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Employment Type\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employment_type",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Update Total Net Income\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "p-pi-income__ashe-average-tooltip"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "pre-accident-income_ashe-average"
    }
  }, [_c('div', {
    staticClass: "p-pi-income__ashe-average-tooltip"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-text": "Click to view information",
      "side": "right",
      "text-width": "140",
      "icon-type": "info",
      "icon-colour": "m-icon--dark"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small ashe p-pi-income__ashe-average-button",
    on: {
      "click": function($event) {
        return _vm.selectSalary(null)
      }
    }
  }, [_vm._v("\n                    Use ASHE average\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-no-margin refine",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n                    Refine by occupation\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.pastLossOfEarnings && _vm.ownPastLosses) ? _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "employment_income",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarningsNetTotal),
      expression: "pastLossOfEarningsNetTotal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "past_loss_net",
      "id": "past_loss_net",
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.pastLossOfEarningsNetTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarningsNetTotal = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pastLossOfEarningsNetTotal')
    }
  }, [_vm._v("\n                            You must enter a value for past losses.\n                        ")])], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "pre-accident-income_ashe-average",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("ASHE Average")]), _vm._v("\n        We have provided average gross (median) earnings by selected gender & occupational categories according\n        to the Average Survey of Hours and Earnings (ASHE). The data are collected and published by the Office of\n        National Statics (ONS) annually and can be found here.\n    ")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'ons_salary_' + this.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('div', {
    staticClass: "p-day-one__refine-occupation"
  }, [_c('h2', [_vm._v("Refine by occupation")]), _vm._v(" "), (_vm.selectedNode) ? _c('div', [_c('p', [_vm._v("\n                    Your current selection - "), _c('strong', [_vm._v(_vm._s(_vm.getLastNode().description))]), _c('br'), _vm._v(" "), (_vm.getLastNode().code.length !== 3) ? _c('span', [_vm._v("Select a salary, expand down further or use the average salary for this whole group")]) : _c('span', [_vm._v("Select a salary or use the average salary for this whole group")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.unselectNode(_vm.selectedNode)
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.selectSalary(_vm.selectedNode)
      }
    }
  }, [_vm._v("Use average\n                    " + _vm._s(_vm.displaySalary(_vm.selectedNode)) + "\n                ")])]) : _c('div', [_c('p', [_vm._v("\n                    Select a salary or expand the group\n                ")])]), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "a-table__small a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('tbody', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "a-loader--table"
  })])]) : _c('tbody', _vm._l((_vm.nodes), function(node) {
    return _c('tr', {
      staticClass: "selected--row"
    }, [_c('td', [_vm._v(_vm._s(node.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displaySalary(node)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "a-button a-button--small",
      attrs: {
        "disabled": node.code.length === 4
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectNode(node)
        }
      }
    }, [_vm._v("\n                                    Expand\n                                ")])]), _vm._v(" "), _c('td', [(node.salary !== 'x') ? _c('button', {
      staticClass: "a-button a-button--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectSalary(node, _vm.type)
        }
      }
    }, [_vm._v("\n                                    Select\n                                ")]) : _vm._e()])])
  }), 0)])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-30 u-margin-bottom-30"
  }, [_vm._v("\n        Future Purchases\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_purchase",
      "label": "Are There Future Purchases?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futurePurchases),
      expression: "futurePurchases"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_purchase",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futurePurchases = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.futurePurchases) ? _c('div', {
    staticClass: "u-margin-bottom-30"
  }, [_vm._l((_vm.purchases), function(purchase, purchaseIndex) {
    return _c('div', [_c('futurePurchase', {
      attrs: {
        "index": purchaseIndex,
        "purchase": purchase
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPurchase
    }
  }, [_vm._v("Add Another Future Purchase")])], 2) : _vm._e(), _vm._v(" "), (_vm.futurePurchases && _vm.purchasesTotal) ? _c('div', [_c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-top-30"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Purchase")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Initial Purchase Date")]), _vm._v(" "), _c('th', [_vm._v("Last Purchase Date")]), _vm._v(" "), _c('th', [_vm._v("Deferment Period")]), _vm._v(" "), _c('th', [_vm._v("Age at Purchase")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), (_vm.showResaleColumn()) ? _c('th', [_vm._v("Resale Total")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Formula")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.purchases), function(purchase) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.jsUcfirst(purchase.description)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.jsUcfirst(purchase.type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(purchase.purchaseDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(purchase.purchaseEnd || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.defermentPeriod(purchase)) + " years")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(purchase.ageAtPurchase) + " years")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(purchase.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(purchase.discount))]), _vm._v(" "), (_vm.showResaleColumn()) ? _c('td', [_vm._v(_vm._s(_vm.currencyFormat(purchase.resaleTotal)))]) : _vm._e(), _vm._v(" "), (purchase.resaleTotal > 0) ? _c('td', [_vm._v("\n                        (" + _vm._s(_vm.currencyFormat(purchase.multiplicand)) + " X " + _vm._s(purchase.discount) + ") - " + _vm._s(_vm.currencyFormat(purchase.resaleTotal)) + "\n                    ")]) : _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(purchase.multiplicand)) + " X " + _vm._s(purchase.discount) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(purchase.total)))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": _vm.showResaleColumn() ? 10 : 9
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.purchasesTotal)))])])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('h1', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('table', {
    staticClass: "a-table a-table--modal",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.selectColumn(index)
        },
        "mouseover": function($event) {
          return _vm.hoverColumn(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(header) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row, key, index) {
    return _c('tr', {
      class: [_vm.highlightColumn(key, index), _vm.lightHighlightColumn(key, index)],
      on: {
        "click": function($event) {
          return _vm.selectRow(key)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "mouseover": function($event) {
          return _vm.hoverRow(key)
        }
      }
    }, [_vm._v("\n                " + _vm._s(key) + "\n            ")]), _vm._v(" "), _vm._l((row), function(column, index) {
      return _c('td', {
        class: [_vm.highlightColumn(key, index), _vm.lightHighlightColumn(key, index)]
      }, [_vm._v("\n                " + _vm._s(column) + "\n            ")])
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v("\n                " + _vm._s(key) + "\n            ")])], 2)
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Mesothelioma PSLA Calculator",
      "icon": "mesothelioma-psla-calculator"
    }
  }), _vm._v(" "), _c('div', [_c('control', {
    attrs: {
      "for": "date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_birth')
    }
  }, [_vm._v("\n                        The date of birth is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_of_person",
      "label": "Age"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageOfPerson),
      expression: "ageOfPerson",
      modifiers: {
        "number": true
      }
    }],
    ref: "ageOfPerson",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageOfPerson)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageOfPerson = _vm._n($event.target.value)
      }, _vm.handler],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age')
    }
  }, [_vm._v("\n                        The age is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "duration_of_symptoms",
      "label": "Duration Of Symptoms",
      "before-after": "months"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.durationOfSymptoms),
      expression: "durationOfSymptoms",
      modifiers: {
        "number": true
      }
    }],
    ref: "durationOfSymptoms",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.durationOfSymptoms)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.durationOfSymptoms = _vm._n($event.target.value)
      }, _vm.handler],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('duration_of_symptoms')
    }
  }, [_vm._v("\n                        The duration of symptoms is required\n                    ")])], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "result",
      "label": "PSLA Award",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pslaAward),
      expression: "pslaAward"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "age_at_death",
      "type": "number",
      "name": "age_at_death"
    },
    domProps: {
      "value": (_vm.pslaAward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pslaAward = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('p', [_vm._v("\n                Welcome to our Mesothelioma General Damages (PSLA) calculator. The calculator shows estimated common law awards\n                according to 'age' and 'duration of symptoms' — the period between onset of the disease\n                and death (or anticipated date of death).\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                There are two parts to the calculator:\n            ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("\n                    The first is a Tariff Table designed to give a broad brush indication of possible awards and\n                    is not intended to substitute a detailed review and consideration of actual awards to\n                    properly value any PSLA award. The Tariff Table is based on the 14th Edition of the JC Guidelines.\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                    The second shows actual PLSA awards which most closely fit the selected age and duration\n                    of symptoms.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('h2', [_vm._v("Tariff Table")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": function($event) {
        return _vm.applyUplift()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.upliftButton ? 'Add' : 'Remove') + " 10% Uplift\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [(_vm.table && !_vm.loading.table) ? _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up to)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.table[50].length
    }
  }, [_vm._v("\n                            Duration (months)\n                        ")])]), _vm._v(" "), _c('tr', _vm._l((_vm.table[50].length), function(col) {
    return _c('th', [(col === 1) ? _c('span', [_vm._v("0-3")]) : (col === 13) ? _c('span', [_vm._v("37+")]) : _c('span', [_vm._v(_vm._s(col * 3 - 2) + "-" + _vm._s(col * 3))])])
  }), 0), _vm._v(" "), _vm._l((_vm.table), function(tr, age) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(age))]), _vm._v(" "), _vm._l((tr), function(td, index) {
      return _c('td', {
        style: (_vm.getTariffTableTdStyle(index, age))
      }, [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.uplift ? Math.round(td * 1.1) : td, '£', 0)) + "\n                        ")])
    })], 2)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.loading.table) ? _c('div', [_c('div', {
    class: {
      'a-loader--table': _vm.loading.table
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "c-gd-psla-calculator__disclaimer"
  }, [_vm._v("Data is up-to-date as of " + _vm._s(_vm.currentRpi) + " *")]), _vm._v(" "), _c('h2', [_vm._v("Awards")]), _vm._v(" "), _vm._l((_vm.filteredAwards), function(award) {
    return (!_vm.loading.awards) ? _c('psla-award', {
      attrs: {
        "award": award,
        "showButtons": false
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.loading.awards) ? _c('div', [_c('div', {
    class: {
      'a-loader--table': _vm.loading.awards
    }
  })]) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-margin-top-30"
  }, [_c('control', {
    attrs: {
      "label": 'Period ' + (_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "start",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodStart),
      callback: function($$v) {
        _vm.periodStart = $$v
      },
      expression: "periodStart"
    }
  })], 1), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": (_vm.$error('periodStart') || !_vm.startPeriodValid()) && this.type === 'past'
    }
  }, [_vm._v("\n                    Care period must start after the onset of symptoms (" + _vm._s(_vm.validationPeriodStart) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": (_vm.$error('periodStart') || !_vm.startPeriodValid()) && this.type === 'future'
    }
  }, [_vm._v("\n                    Care period must start after the Assumed Settlement/Trial (" + _vm._s(_vm.validationPeriodStart) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.periodStartIsBeforeAttendanceRates()
    }
  }, [_vm._v("\n                    Care period data is unavailable prior to April 1st 2009\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEnd || !_vm.periodStartIsBeforeEnd()
    }
  }, [_vm._v("\n                    Start of care period must be before end of care period\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "end",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodEnd),
      callback: function($$v) {
        _vm.periodEnd = $$v
      },
      expression: "periodEnd"
    }
  })], 1), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodEnd') || !_vm.endPeriodValid()
    }
  }, [_vm._v("\n                    Period end must be before " + _vm._s(_vm.validationPeriodEnd) + "\n                ")])], 1)])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Hours per Day"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "hours",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hoursPerDay),
      expression: "hoursPerDay"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "hours_per_day",
      "required": "",
      "min": "0",
      "max": "24",
      "type": "number"
    },
    domProps: {
      "value": (_vm.hoursPerDay)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.hoursPerDay = $event.target.value
      }, _vm.calcRate]
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("at")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }],
    attrs: {
      "id": "method",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcRate]
    }
  }, [_c('option', {
    attrs: {
      "value": "basic"
    }
  }, [_vm._v("Basic Rate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "aggregate"
    }
  }, [_vm._v("Aggregate")])])])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gratuitous Care Discount"
    }
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gratuitousCare),
      expression: "gratuitousCare"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gratuitousCare) ? _vm._i(_vm.gratuitousCare, null) > -1 : (_vm.gratuitousCare)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.gratuitousCare,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gratuitousCare = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gratuitousCare = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.gratuitousCare = $$c
        }
      }, _vm.calcRate]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Applies the 'conventional 25% discount' to reflect the gratuitous nature of care.")])])]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubtotal),
      expression: "showSubtotal"
    }],
    attrs: {
      "for": "sub_total",
      "label": "Subtotal",
      "tip-icon": "formula",
      "before-after": "pound",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "sub_total",
      "modal-name": 'subTotal_' + _vm.uniqueId,
      "endpoint": 'detailedCare',
      "payload": {
        period: this.getCarePeriod(this.type, this.index)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.periodTotal),
      expression: "periodTotal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.periodTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodTotal = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.showDelete) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deletePeriod
    }
  }, [_vm._v("Delete This Period")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr--margin-bottom"
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'subTotal_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Loss of Earnings\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Disability Working Allowance",
      "store-key": "ploeDisabilityWorkingAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Employment and Support Allowance",
      "store-key": "ploeEmploymentSupportAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Incapacity Benefit",
      "store-key": "ploeIncapacityBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Income Support",
      "store-key": "ploeIncomeSupport"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Industrial Injuries Disablement Benefit",
      "store-key": "ploeIndustrialInjuriesDisablementBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Invalidity Pension",
      "store-key": "ploeInvalidityPension"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Invalidity Allowance",
      "store-key": "ploeInvalidityAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Jobseeker’s Allowance",
      "store-key": "ploeJobseekersAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Reduced Earnings Allowance",
      "store-key": "ploeReducedEarningsAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Severe Disablement Allowances",
      "store-key": "ploeSevereDisablementAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Sickness Benefit",
      "store-key": "ploeSicknessBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Statutory Sick Pay paid before 6 April 1994",
      "store-key": "ploeStatutorySickPay"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Unemployability Supplement",
      "store-key": "ploeUnemployabilitySupplement"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Unemployment Benefit",
      "store-key": "ploeUnemploymentBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Universal Credit",
      "store-key": "ploeUniversalCredit",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.value)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependantsValue),
      expression: "dependantsValue"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dependantsValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.dependantsValue = $event.target.value
      }, _vm.updateTotals]
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.value - _vm.dependantsValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.value, _vm.dependantsValue)) + "%")])]), _vm._v(" "), (this.showInterest) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.name) + " - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestAccrued)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependantsInterestValue),
      expression: "dependantsInterestValue"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dependantsInterestValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.dependantsInterestValue = $event.target.value
      }, _vm.updateTotals]
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestAccrued - _vm.dependantsInterestValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.interestAccrued, _vm.dependantsInterestValue)) + "%")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-d-flex flex-state-buttons p-executive-dashboard__reserves"
  }, [_c('h2', {
    staticClass: "u-margin-top-10 u-r-no-margin"
  }, [_vm._v("\n            Reserves \n            "), (_vm.diseaseOrAccident || _vm.claimType === 'personal_injury') ? _c('span', [_vm._v("\n                " + _vm._s(_vm.diseaseOrAccident === 'disease' ? 'by Disease' : 'by Accident') + "\n            ")]) : _c('span', [_vm._v("\n                by Claim Type\n            ")])]), _vm._v(" "), _c('option-filters', [_c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'average'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('average')
      }
    }
  }, [_vm._v("\n                Average\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'total'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('total')
      }
    }
  }, [_vm._v("\n                Total\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'trend-average'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('trend-average')
      }
    }
  }, [_vm._v("\n                Trends: Average Reserve\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'trend-total'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('trend-total')
      }
    }
  }, [_vm._v("\n                Trends: Total Reserve\n            ")])])], 1), _vm._v(" "), ((_vm.chartType === 'average' || _vm.chartType === 'total') && _vm.show) ? _c('summary-charts', {
    attrs: {
      "type": "value",
      "run-type": _vm.chartType === 'average' ? 'averageReserve' : 'totalReserve',
      "chart-data": _vm.chartType === 'average' ? _vm.averageReservesChartData : _vm.totalReservesChartData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chartType === 'trend-average' && _vm.show) ? _c('trends-chart', {
    attrs: {
      "type": "value",
      "showing": "average",
      "chart-data": _vm.trendsInAverageReservesChartData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chartType === 'trend-total' && _vm.show) ? _c('trends-chart', {
    attrs: {
      "type": "value",
      "showing": "total",
      "chart-data": _vm.trendsInTotalReservesChartData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(_vm.row.label) + "–" + _vm._s(parseInt(_vm.row.label, 10) + 5) + "\n    ")]), _vm._v(" "), _vm._l((_vm.chosenRates), function(rates, index) {
    return _c('td', [_vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.row.data[index])) + "\n    ")])
  }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.difference)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.percent)) + "%")])], 2)
},staticRenderFns: []}

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.filterHeading.length) ? _c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            " + _vm._s(_vm.filterHeading) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from),
      expression: "from"
    }],
    ref: "inputFrom",
    attrs: {
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.from)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.from = $event.target.value
      }, function($event) {
        return _vm.updateValue($event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.to),
      expression: "to"
    }],
    ref: "inputTo",
    attrs: {
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.to)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.to = $event.target.value
      }, function($event) {
        return _vm.updateValue($event)
      }]
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-bottom-30"
  }, [_vm._v("\n        Losses for Pension\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_loss_of_pension",
      "label": "Would you like to make a claim for loss of pension?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossOfPension),
      expression: "futureLossOfPension"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_loss_of_pension",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossOfPension = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [(_vm.futureLossOfPension) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Simple Method or Longden Method?\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_method",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pensionMethod),
      expression: "pensionMethod"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "pension_method",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pensionMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "simple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "longden",
      "disabled": ""
    }
  }, [_vm._v("Longden (coming soon)")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossOfPension && _vm.pensionMethod) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Is there a lump sum payment?\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "lump_sum_loss",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lumpSumLoss),
      expression: "lumpSumLoss"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "lump_sum_loss",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lumpSumLoss = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.futureLossOfPension && _vm.lumpSumLoss !== null) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                'But For' Retirement Date"), (_vm.lumpSumLoss) ? _c('span', [_vm._v("/Date Lump Sum Would Have Been Taken")]) : _vm._e()]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:but_for_retirement_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "but_for_retirement_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "update": _vm.updatePension
    },
    model: {
      value: (_vm.butForRetirementDate),
      callback: function($$v) {
        _vm.butForRetirementDate = $$v
      },
      expression: "butForRetirementDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                'But For' Retirement Age"), (_vm.lumpSumLoss) ? _c('span', [_vm._v("/Age Lump Sum Would Have Been Taken")]) : _vm._e()]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "table-control": true,
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForRetirementAge),
      expression: "butForRetirementAge",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_retirement_age.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_retirement_age",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_retirement_age",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForRetirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForRetirementAge = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.butForRetirementAge < 50
    }
  }, [_vm._v("\n                Age of anticipated retirement is earlier than 50, contact the advice of an actuary.\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.pensionMethod && _vm.lumpSumLoss) ? _c('div', [_c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("\n            Lump Sum Loss\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    'But For' Pension Lump Sum\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_pension_lump_sum",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForPensionLumpSum),
      expression: "butForPensionLumpSum",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_lump_sum.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_lump_sum",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_pension_lump_sum",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForPensionLumpSum)
    },
    on: {
      "focus": function($event) {
        _vm.butForPensionLumpSum = _vm.butForPensionLumpSum || ''
      },
      "blur": [function($event) {
        _vm.butForPensionLumpSum = _vm.butForPensionLumpSum || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForPensionLumpSum = _vm._n($event.target.value)
      }, _vm.updatePension]
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.lumpSumValid
    }
  }, [_vm._v("\n                    'But For' Pension Lump Sum must be greater than the Lump Sum Payment After the Accident\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Lump Sum Payment After the Accident\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_lump_sum",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionLumpSum),
      expression: "pensionLumpSum",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_lump_sum.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_lump_sum",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_lump_sum",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionLumpSum)
    },
    on: {
      "focus": function($event) {
        _vm.pensionLumpSum = _vm.pensionLumpSum || ''
      },
      "blur": [function($event) {
        _vm.pensionLumpSum = _vm.pensionLumpSum || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionLumpSum = _vm._n($event.target.value)
      }, _vm.updatePension]
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.lumpSumValid
    }
  }, [_vm._v("\n                    Lump Sum Payment After the Accident must be less than the 'But For' Pension Lump Sum\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Date Lump Sum Payment Received\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_lump_sum_received",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_lump_sum_received.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_lump_sum_received",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "update": _vm.updatePension
    },
    model: {
      value: (_vm.dateLumpSumPaymentReceived),
      callback: function($$v) {
        _vm.dateLumpSumPaymentReceived = $$v
      },
      expression: "dateLumpSumPaymentReceived"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.futureLossOfPension && _vm.lumpSumLossPresentValue) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [(_vm.lumpSumLossPresentValue) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Period of Accelerated Receipt\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "period_of_accelerated_receipt",
      "table-control": true,
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.periodOfAcceleratedReceipt),
      expression: "periodOfAcceleratedReceipt",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "min": "0",
      "id": "period_of_accelerated_receipt",
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodOfAcceleratedReceipt)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.periodOfAcceleratedReceipt = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Table 35 Discount Factor\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "table_27_multiplier",
      "table-control": true,
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "modal-name": 'multiplier_' + _vm.uniqueId,
      "endpoint": 'lumpSumMultiplier',
      "payload": _vm.lumpSumMultiplierModalPayload
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.discountFactor),
      expression: "discountFactor",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:table_27_multiplier.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "table_27_multiplier",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "table_27_multiplier",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.discountFactor)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.discountFactor = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Lump Sum Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "lump_sum_loss_value",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lumpSumLossPresentValue),
      expression: "lumpSumLossPresentValue",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:lump_sum_loss_value.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "lump_sum_loss_value",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "lump_sum_loss_value",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lumpSumLossPresentValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lumpSumLossPresentValue = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.futureLossOfPension && _vm.lumpSumLoss !== null) ? _c('div', [_c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("\n            Pension Losses\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    'But For' Pension Annual Income\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForPensionAnnual),
      expression: "butForPensionAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_pension_annual",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForPensionAnnual)
    },
    on: {
      "focus": function($event) {
        _vm.butForPensionAnnual = _vm.butForPensionAnnual || ''
      },
      "blur": [function($event) {
        _vm.butForPensionAnnual = _vm.butForPensionAnnual || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForPensionAnnual = _vm._n($event.target.value)
      }, _vm.updatePension]
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.pensionAnnualIncomeValid
    }
  }, [_vm._v("\n                    'But For' Pension Annual Income must be greater than Actual Pension Annual Income\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Actual Pension Annual Income\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_annual",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionAnnual),
      expression: "pensionAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_annual",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionAnnual)
    },
    on: {
      "focus": function($event) {
        _vm.pensionAnnual = _vm.pensionAnnual || ''
      },
      "blur": [function($event) {
        _vm.pensionAnnual = _vm.pensionAnnual || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionAnnual = _vm._n($event.target.value)
      }, _vm.updatePension]
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.pensionAnnualIncomeValid
    }
  }, [_vm._v("\n                    Actual Pension Annual Income must be less than 'But For' Pension Annual Income\n                ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.futureLossOfPension && _vm.totalLoss) ? _c('div', [(_vm.lumpSumLoss) ? _c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("\n            Total Losses\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Pension Multiplier\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "label": "Pension Multiplier",
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-show": !_vm.illHealthDisabilityPension,
      "modal-name": 'multiplier_' + _vm.uniqueId,
      "endpoint": 'pensionLossMultiplier',
      "payload": _vm.pensionLossMultiplierModalPayload
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionLossMultiplier),
      expression: "pensionLossMultiplier",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_loss_multiplier.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_loss_multiplier",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_loss_multiplier",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionLossMultiplier)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionLossMultiplier = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Annual Pension Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionLossAnnual),
      expression: "pensionLossAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_loss_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_loss_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_loss_annual",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionLossAnnual)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionLossAnnual = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Annual Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_annual",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.totalLossAnnual),
      expression: "totalLossAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:total_loss_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "total_loss_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "total_loss_annual",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.totalLossAnnual)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.totalLossAnnual = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), (_vm.futureLossOfPension && _vm.lumpSumLoss !== null && _vm.totalLoss) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_annual",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.totalLoss),
      expression: "totalLoss",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:total_loss.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "total_loss",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "total_loss",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.totalLoss)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.totalLoss = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'multiplier_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Loss of Earnings — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is calculated using (i) your selected gross annual income (converted to net\n        equivalent by the tool), and (ii) assumes loss of earnings from date of onset of symptoms to death.\n        The period between death and assumed date of trial/settlement is discounted by Table E Factor. \n        The multiplier is applied from date of trial/assumed settlement but discounted by Table F Factor.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Discount Rate Comparison",
      "set-position": "relative",
      "create-button": true,
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-discount-rate-comparison"
  }, [_c('page-form'), _vm._v(" "), (!_vm.results.count) ? _c('div', [_c('hr'), _vm._v(" "), (_vm.results.count == 0) ? _c('p', {
    staticClass: "a-form-inputs--error"
  }, [_c('br'), _vm._v("\n                There are no results for your criteria\n                "), _c('br')]) : _c('div', [_c('h2', [_vm._v("\n                    Your results will appear here once you click compare.\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.results !== false && _vm.results.count > 0) ? _c('accordion', [_c('average-past-future-losses'), _vm._v(" "), _c('total-past-future-losses'), _vm._v(" "), (_vm.claimType) ? _c('all-heads-of-loss') : _vm._e(), _vm._v(" "), (_vm.claimType === 'fatal_accident_estate' || _vm.claimType === 'fatal_accident_dependency') ? _c('assessments-by-age') : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    staticClass: "filterInput",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "emit": _vm.emit,
      "disabled": _vm.disabled,
      "placeholder": "--/--/----"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-discount-rate-comparison__pie"
  }, [(_vm.title) ? _c('h3', [_vm._v("\n        " + _vm._s(_vm.title) + " (" + _vm._s(_vm.rate) + ")\n    ")]) : _c('h3', [_vm._v("\n        " + _vm._s(_vm.rate) + "\n    ")]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.total !== null) ? _c('div', {
    staticClass: "u-text-center"
  }, [_c('strong', [_vm._v("\n            " + _vm._s(_vm.totalText) + "\n        ")]), _vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.total)) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.filterHeading.length) ? _c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n        " + _vm._s(_vm.filterHeading) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from),
      expression: "from"
    }],
    ref: "inputFrom",
    attrs: {
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.from)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.from = $event.target.value
      }, function($event) {
        return _vm.updateValue($event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.to),
      expression: "to"
    }],
    ref: "inputTo",
    attrs: {
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.to)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.to = $event.target.value
      }, function($event) {
        return _vm.updateValue($event)
      }]
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Miscellaneous (Treatments, etc) — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is based on an average from claims of a similar type. Where there is insufficient data\n        within the tool to derive an average a figure of £5,000 is applied.\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "label": "Deceased Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theDeceased.name),
      expression: "theDeceased.name"
    }, {
      name: "field-control",
      rawName: "v-field-control:deceased_name.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "deceased_name",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "deceased_name",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.theDeceased.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theDeceased, "name", $event.target.value)
      }, _vm.update]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_name')
    }
  }, [_vm._v("\n                        The deceased's name is required and must be a valid name\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_gender",
      "label": "Deceased Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.theDeceased.gender),
      expression: "theDeceased.gender"
    }],
    attrs: {
      "required": "",
      "name": "deceased_gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.theDeceased, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_gender')
    }
  }, [_vm._v("\n                        The deceased's gender is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_birth",
      "label": "Deceased Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "dateOfBirth", $$v)
      },
      expression: "theDeceased.dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_birth') || !_vm.validDateOfBirth()
    }
  }, [_vm._v("\n                        The deceased's date of birth is required and must be in the format DD/MM/YYYY\n                        and be at least the age of 18\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "onset_of_deceased_symptoms",
      "label": _vm.claimDetailsValue('diseaseOrAccident') === 'disease' ? 'Onset of Symptoms' : 'Date of Injury / Accident'
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:onset_of_deceased_symptoms.required",
      value: ({
        type: 'date',
        rules: 'min:' + _vm.theDeceased.dateOfBirth + '|' + 'max:' + _vm.theDeceased.dateOfDeath
      }),
      expression: "{type:'date', rules:'min:'+theDeceased.dateOfBirth +'|'+'max:'+theDeceased.dateOfDeath}",
      arg: "onset_of_deceased_symptoms",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.onsetOfSymptoms),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "onsetOfSymptoms", $$v)
      },
      expression: "theDeceased.onsetOfSymptoms"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('onset_of_deceased_symptoms') || !_vm.validOnsetOfSymptoms()
    }
  }, [_vm._v("\n                        The onset of symptoms is required, it must be in the format DD/MM/YYYY and be before the\n                        date of death and after the date of birth\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_death",
      "label": "Deceased Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.dateOfDeath),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "dateOfDeath", $$v)
      },
      expression: "theDeceased.dateOfDeath"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_death')
    }
  }, [_vm._v("\n                        The deceased's date of death is required, must be in the format DD/MM/YYYY and must be\n                        within 9 years of the assessment date\n                        (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeath()
    }
  }, [_vm._v("\n                        The deceased's date of death must be within 9 years of the assessment date\n                        (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathDurtaion()
    }
  }, [_vm._v("\n                        The deceased's date of death must within 9 years of the assumed settlement\n                        (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathCurrent()
    }
  }, [_vm._v("\n                        The deceased's date of death must be in the past\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfProceedings()
    }
  }, [_vm._v("\n                        The deceased's date of death must be before the issue of proceedings\n                        (" + _vm._s(_vm.dateOfServiceProceedings) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathOnsetOfSymptoms()
    }
  }, [_vm._v("\n                        The deceased's date of death must be after the onset of symptoms\n                    ")])], 1), _vm._v(" "), _c('life-expectancy', {
    attrs: {
      "label": "Deceased's 'But For'",
      "person": _vm.theDeceased,
      "stepValid": _vm.$valid() && _vm.validateDateOfDeath(),
      "assumed-settlement": _vm.assumedSettlement,
      "type": 'deceased'
    },
    on: {
      "update": _vm.updateLife
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Period Between Onset and Date of Death",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "disabled",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": _vm.periodBetweenOnsetAndDod
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_death",
      "label": "Deceased Age at Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:age_at_death",
      arg: "age_at_death"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "age_at_death",
      "type": "number",
      "name": "age_at_death",
      "min": "18"
    },
    domProps: {
      "value": _vm.theDeceased.ageAtDeath
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_at_death')
    }
  }, [_vm._v("\n                        The deceased must have been at least 18 years old at the time of death\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Period Between Deceased's DOD & Settlement",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "deceased_and_settlement",
      "type": "number",
      "min": "0",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.periodDeathToSettlement
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Deceased's Age at Assumed Settlement",
      "tip-side": "left",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtSettlement
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.periodDeathToSettlement < 0
    }
  }, [_vm._v("\n                        Date of assessment/trial must be after the date of death\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Reduction in Deceased's Life Expectancy",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "disabled",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": _vm.reductionInLifeExpectancy
    }
  })])], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.$valid() && _vm.validateDateOfDeath()
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'educationAttainment_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-animated-calc"
  }, [_c('div', {
    staticClass: "p-animated-calc__container all-cols"
  }, [_c('div', {
    staticClass: "p-animated-calc__column-two--cover"
  }), _vm._v(" "), _c('svg', {
    staticClass: "p-animated-calc__logo",
    attrs: {
      "viewBox": "0 0 230.4 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__column-one"
  }, [_c('div', {
    staticClass: "p-animated-calc__column-one--cover"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/mini-calculators/'
    }
  }, [_c('div', {
    staticClass: "p-animated-calc__top-menu"
  }, [_c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#dashboard"
    }
  })])])]), _vm._v(" "), _vm._t("summary-panel")], 2), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__column-two",
    attrs: {
      "id": "print-panel"
    }
  }, [_c('mini-calculator-print'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._t("results-panel")], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid--vertical p-animated-calc__summary-panel"
  }, [_c('div', [_c('h2', {
    staticClass: "prompt"
  }, [_vm._v("\n                        Your Calculation\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Your calculation will appear here once all mandatory fields have been completed.\n                    ")])])])
}]}

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Loss of Earnings Calculator",
      "icon": "earnings"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    ref: "employmentType",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Income"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentIncome),
      expression: "employmentIncome"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "employmentIncome",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.employmentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || ''
      },
      "blur": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.employmentIncome = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentNetGross),
      expression: "employmentNetGross"
    }],
    ref: "employmentNetGross",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])])])]), _vm._v(" "), _c('p', [_vm._l((_vm.getPeriods), function(period, index) {
    return _c('income-period', {
      attrs: {
        "index": index,
        "period": period
      },
      on: {
        "update": _vm.calculateLoss
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": function($event) {
        return _vm.addNewPeriod()
      }
    }
  }, [_vm._v("Add Period")])], 2), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total Net Loss",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.totalNetLoss
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto p-earnings__calc"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Based on a "), _c('strong', [_vm._v(_vm._s(_vm.gender))]), _vm._v(" with the Date of Birth ("), _c('strong', [_vm._v(_vm._s(_vm.dateOfBirth))]), _vm._v(")\n                with assumed State Retirement Date of ("), _c('strong', [_vm._v(_vm._s(_vm.retirementDate))]), _vm._v("). The Pre Loss of Earnings Net\n                is "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalNetIncome)))]), _vm._v(".\n            ")]), _vm._v(" "), _c('h2', [_vm._v("\n                Calculations\n            ")]), _vm._v(" "), _c('div', {
    class: {
      'a-loader--table': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_vm._l((_vm.getPeriods), function(period, index) {
    return _c('table', {
      staticClass: "a-table--full-width u-margin-top-20",
      attrs: {
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tbody', [_c('tr', [_c('th', {
      attrs: {
        "width": "33%"
      }
    }, [_vm._v("Period")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.startOfPeriod))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("To")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.endOfPeriod))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.periodDuration(period).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Pre-Loss"), _c('br'), _vm._v("Annual Income")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalNetIncome)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Loss of Earnings"), _c('br'), _vm._v("Annual Income")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.totalNetIncome)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Formula")]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.currencyFormat(_vm.totalNetIncome)) + " x " + _vm._s(_vm.periodDuration(period).toFixed(2)) + ") -\n                                (" + _vm._s(_vm.currencyFormat(period.totalNetIncome)) + " x " + _vm._s(_vm.periodDuration(period).toFixed(2)) + ") ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Period Net Loss")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.periodNetLoss(period, index))))])])])])
  }), _vm._v(" "), _c('table', {
    staticClass: "a-table--full-width u-margin-top-20",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "width": "33%"
    }
  }, [_vm._v("\n                                Total Net Loss\n                            ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("\n                                    " + _vm._s(_vm.currencyFormat(_vm.totalNetLoss)) + "\n                                ")])])])])])], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "a-form-inputs--warning"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs p-dependency-on-income"
  }, [_c('accordion', [_c('accordion-item', {
    attrs: {
      "has-error": !_vm.deceasedIncomeValid
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Deceased's Income\n            ")]), _vm._v(" "), _c('income', {
    attrs: {
      "name": "Deceased",
      "income": _vm.theDeceased.income,
      "person": _vm.theDeceased,
      "tooltipValue": "theDeceased"
    },
    on: {
      "action": _vm.updateTheDeceasedIncome
    }
  })], 1), _vm._v(" "), _vm._l((_vm.dependants), function(dependant, index) {
    return (_vm.determineAge(dependant) > 21) ? _c('accordion-item', {
      attrs: {
        "has-error": !_vm.dependantIncomeValid(index)
      }
    }, [_c('h2', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v("\n                Dependant " + _vm._s(index + 1) + " Income\n            ")]), _vm._v(" "), _c('income', {
      attrs: {
        "name": "Claimant",
        "income": dependant.income,
        "index": index,
        "person": dependant,
        "tooltipValue": "dependant"
      },
      on: {
        "action": _vm.updateTheDependantIncome
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (!_vm.hasSplitPeriods) ? _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                The Multiplicand\n            ")]), _vm._v(" "), _c('multiplicand')], 1) : _vm._e(), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                The Multipliers & Dependency\n            ")]), _vm._v(" "), _c('multipliers')], 1)], 2), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.updateValid()
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[832]);


// WEBPACK FOOTER //
// js/app.9f6df6f766414c12e82d.js